/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(198);
	__webpack_require__(197);
	module.exports = __webpack_require__(569);


/***/ }),

/***/ 7:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(44)
	var ieee754 = __webpack_require__(45)
	var isArray = __webpack_require__(26)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(29);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(17));
	util.inherits = __webpack_require__(18);
	/*</replacement>*/
	
	var Readable = __webpack_require__(89);
	var Writable = __webpack_require__(91);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(10).Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}


/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ }),

/***/ 26:
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),

/***/ 28:
/***/ (function(module, exports) {

	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (source.hasOwnProperty(p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);


/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (typeof process === 'undefined' ||
	    !process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(10)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),

/***/ 31:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 44:
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),

/***/ 45:
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),

/***/ 77:
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),

/***/ 85:
/***/ (function(module, exports) {

	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It doesn't worth to make additional optimizationa as in original.
	// Small size is preferable.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;


/***/ }),

/***/ 86:
/***/ (function(module, exports) {

	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;
	
	  crc ^= -1;
	
	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;


/***/ }),

/***/ 87:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};


/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(29);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(26);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(77).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(93);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(30).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(17));
	util.inherits = __webpack_require__(18);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(689);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(671);
	var destroyImpl = __webpack_require__(92);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(13);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(94).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(13);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(94).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(7)))

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(13);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(17));
	util.inherits = __webpack_require__(18);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(29);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(17));
	util.inherits = __webpack_require__(18);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(682)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(93);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(30).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(92);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(13);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(13);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(676).setImmediate, (function() { return this; }())))

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(29);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      pna.nextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      pna.nextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(77).EventEmitter;


/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(30).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var objectAssign = __webpack_require__(561);
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	// NB: The URL to the CommonJS spec is kept just for tradition.
	//     node-assert has evolved a lot since then, both in API and behavior.
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(142);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	// Expose a strict only variant of assert
	function strict(value, message) {
	  if (!value) fail(value, true, message, '==', strict);
	}
	assert.strict = objectAssign(strict, assert, {
	  equal: assert.strictEqual,
	  deepEqual: assert.deepStrictEqual,
	  notEqual: assert.notStrictEqual,
	  notDeepEqual: assert.notDeepStrictEqual
	});
	assert.strict.strict = assert.strict;
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),

/***/ 141:
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),

/***/ 142:
[691, 141, 140],

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer) {var msg = __webpack_require__(87);
	var zstream = __webpack_require__(568);
	var zlib_deflate = __webpack_require__(563);
	var zlib_inflate = __webpack_require__(565);
	var constants = __webpack_require__(562);
	
	for (var key in constants) {
	  exports[key] = constants[key];
	}
	
	// zlib modes
	exports.NONE = 0;
	exports.DEFLATE = 1;
	exports.INFLATE = 2;
	exports.GZIP = 3;
	exports.GUNZIP = 4;
	exports.DEFLATERAW = 5;
	exports.INFLATERAW = 6;
	exports.UNZIP = 7;
	
	/**
	 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
	 */
	function Zlib(mode) {
	  if (mode < exports.DEFLATE || mode > exports.UNZIP)
	    throw new TypeError("Bad argument");
	    
	  this.mode = mode;
	  this.init_done = false;
	  this.write_in_progress = false;
	  this.pending_close = false;
	  this.windowBits = 0;
	  this.level = 0;
	  this.memLevel = 0;
	  this.strategy = 0;
	  this.dictionary = null;
	}
	
	Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
	  this.windowBits = windowBits;
	  this.level = level;
	  this.memLevel = memLevel;
	  this.strategy = strategy;
	  // dictionary not supported.
	  
	  if (this.mode === exports.GZIP || this.mode === exports.GUNZIP)
	    this.windowBits += 16;
	    
	  if (this.mode === exports.UNZIP)
	    this.windowBits += 32;
	    
	  if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW)
	    this.windowBits = -this.windowBits;
	    
	  this.strm = new zstream();
	  
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.GZIP:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflateInit2(
	        this.strm,
	        this.level,
	        exports.Z_DEFLATED,
	        this.windowBits,
	        this.memLevel,
	        this.strategy
	      );
	      break;
	    case exports.INFLATE:
	    case exports.GUNZIP:
	    case exports.INFLATERAW:
	    case exports.UNZIP:
	      var status  = zlib_inflate.inflateInit2(
	        this.strm,
	        this.windowBits
	      );
	      break;
	    default:
	      throw new Error("Unknown mode " + this.mode);
	  }
	  
	  if (status !== exports.Z_OK) {
	    this._error(status);
	    return;
	  }
	  
	  this.write_in_progress = false;
	  this.init_done = true;
	};
	
	Zlib.prototype.params = function() {
	  throw new Error("deflateParams Not supported");
	};
	
	Zlib.prototype._writeCheck = function() {
	  if (!this.init_done)
	    throw new Error("write before init");
	    
	  if (this.mode === exports.NONE)
	    throw new Error("already finalized");
	    
	  if (this.write_in_progress)
	    throw new Error("write already in progress");
	    
	  if (this.pending_close)
	    throw new Error("close is pending");
	};
	
	Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {    
	  this._writeCheck();
	  this.write_in_progress = true;
	  
	  var self = this;
	  process.nextTick(function() {
	    self.write_in_progress = false;
	    var res = self._write(flush, input, in_off, in_len, out, out_off, out_len);
	    self.callback(res[0], res[1]);
	    
	    if (self.pending_close)
	      self.close();
	  });
	  
	  return this;
	};
	
	// set method for Node buffers, used by pako
	function bufferSet(data, offset) {
	  for (var i = 0; i < data.length; i++) {
	    this[offset + i] = data[i];
	  }
	}
	
	Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
	  this._writeCheck();
	  return this._write(flush, input, in_off, in_len, out, out_off, out_len);
	};
	
	Zlib.prototype._write = function(flush, input, in_off, in_len, out, out_off, out_len) {
	  this.write_in_progress = true;
	  
	  if (flush !== exports.Z_NO_FLUSH &&
	      flush !== exports.Z_PARTIAL_FLUSH &&
	      flush !== exports.Z_SYNC_FLUSH &&
	      flush !== exports.Z_FULL_FLUSH &&
	      flush !== exports.Z_FINISH &&
	      flush !== exports.Z_BLOCK) {
	    throw new Error("Invalid flush value");
	  }
	  
	  if (input == null) {
	    input = new Buffer(0);
	    in_len = 0;
	    in_off = 0;
	  }
	  
	  if (out._set)
	    out.set = out._set;
	  else
	    out.set = bufferSet;
	  
	  var strm = this.strm;
	  strm.avail_in = in_len;
	  strm.input = input;
	  strm.next_in = in_off;
	  strm.avail_out = out_len;
	  strm.output = out;
	  strm.next_out = out_off;
	  
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.GZIP:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflate(strm, flush);
	      break;
	    case exports.UNZIP:
	    case exports.INFLATE:
	    case exports.GUNZIP:
	    case exports.INFLATERAW:
	      var status = zlib_inflate.inflate(strm, flush);
	      break;
	    default:
	      throw new Error("Unknown mode " + this.mode);
	  }
	  
	  if (status !== exports.Z_STREAM_END && status !== exports.Z_OK) {
	    this._error(status);
	  }
	  
	  this.write_in_progress = false;
	  return [strm.avail_in, strm.avail_out];
	};
	
	Zlib.prototype.close = function() {
	  if (this.write_in_progress) {
	    this.pending_close = true;
	    return;
	  }
	  
	  this.pending_close = false;
	  
	  if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) {
	    zlib_deflate.deflateEnd(this.strm);
	  } else {
	    zlib_inflate.inflateEnd(this.strm);
	  }
	  
	  this.mode = exports.NONE;
	};
	
	Zlib.prototype.reset = function() {
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflateReset(this.strm);
	      break;
	    case exports.INFLATE:
	    case exports.INFLATERAW:
	      var status = zlib_inflate.inflateReset(this.strm);
	      break;
	  }
	  
	  if (status !== exports.Z_OK) {
	    this._error(status);
	  }
	};
	
	Zlib.prototype._error = function(status) {
	  this.onerror(msg[status] + ': ' + this.strm.msg, status);
	  
	  this.write_in_progress = false;
	  if (this.pending_close)
	    this.close();
	};
	
	exports.Zlib = Zlib;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(10).Buffer))

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Transform = __webpack_require__(673);
	
	var binding = __webpack_require__(144);
	var util = __webpack_require__(685);
	var assert = __webpack_require__(139).ok;
	
	// zlib doesn't provide these, so kludge them in following the same
	// const naming scheme zlib uses.
	binding.Z_MIN_WINDOWBITS = 8;
	binding.Z_MAX_WINDOWBITS = 15;
	binding.Z_DEFAULT_WINDOWBITS = 15;
	
	// fewer than 64 bytes per chunk is stupid.
	// technically it could work with as few as 8, but even 64 bytes
	// is absurdly low.  Usually a MB or more is best.
	binding.Z_MIN_CHUNK = 64;
	binding.Z_MAX_CHUNK = Infinity;
	binding.Z_DEFAULT_CHUNK = (16 * 1024);
	
	binding.Z_MIN_MEMLEVEL = 1;
	binding.Z_MAX_MEMLEVEL = 9;
	binding.Z_DEFAULT_MEMLEVEL = 8;
	
	binding.Z_MIN_LEVEL = -1;
	binding.Z_MAX_LEVEL = 9;
	binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;
	
	// expose all the zlib constants
	Object.keys(binding).forEach(function(k) {
	  if (k.match(/^Z/)) exports[k] = binding[k];
	});
	
	// translation table for return codes.
	exports.codes = {
	  Z_OK: binding.Z_OK,
	  Z_STREAM_END: binding.Z_STREAM_END,
	  Z_NEED_DICT: binding.Z_NEED_DICT,
	  Z_ERRNO: binding.Z_ERRNO,
	  Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
	  Z_DATA_ERROR: binding.Z_DATA_ERROR,
	  Z_MEM_ERROR: binding.Z_MEM_ERROR,
	  Z_BUF_ERROR: binding.Z_BUF_ERROR,
	  Z_VERSION_ERROR: binding.Z_VERSION_ERROR
	};
	
	Object.keys(exports.codes).forEach(function(k) {
	  exports.codes[exports.codes[k]] = k;
	});
	
	exports.Deflate = Deflate;
	exports.Inflate = Inflate;
	exports.Gzip = Gzip;
	exports.Gunzip = Gunzip;
	exports.DeflateRaw = DeflateRaw;
	exports.InflateRaw = InflateRaw;
	exports.Unzip = Unzip;
	
	exports.createDeflate = function(o) {
	  return new Deflate(o);
	};
	
	exports.createInflate = function(o) {
	  return new Inflate(o);
	};
	
	exports.createDeflateRaw = function(o) {
	  return new DeflateRaw(o);
	};
	
	exports.createInflateRaw = function(o) {
	  return new InflateRaw(o);
	};
	
	exports.createGzip = function(o) {
	  return new Gzip(o);
	};
	
	exports.createGunzip = function(o) {
	  return new Gunzip(o);
	};
	
	exports.createUnzip = function(o) {
	  return new Unzip(o);
	};
	
	
	// Convenience methods.
	// compress/decompress a string or buffer in one step.
	exports.deflate = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Deflate(opts), buffer, callback);
	};
	
	exports.deflateSync = function(buffer, opts) {
	  return zlibBufferSync(new Deflate(opts), buffer);
	};
	
	exports.gzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Gzip(opts), buffer, callback);
	};
	
	exports.gzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Gzip(opts), buffer);
	};
	
	exports.deflateRaw = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new DeflateRaw(opts), buffer, callback);
	};
	
	exports.deflateRawSync = function(buffer, opts) {
	  return zlibBufferSync(new DeflateRaw(opts), buffer);
	};
	
	exports.unzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Unzip(opts), buffer, callback);
	};
	
	exports.unzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Unzip(opts), buffer);
	};
	
	exports.inflate = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Inflate(opts), buffer, callback);
	};
	
	exports.inflateSync = function(buffer, opts) {
	  return zlibBufferSync(new Inflate(opts), buffer);
	};
	
	exports.gunzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Gunzip(opts), buffer, callback);
	};
	
	exports.gunzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Gunzip(opts), buffer);
	};
	
	exports.inflateRaw = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new InflateRaw(opts), buffer, callback);
	};
	
	exports.inflateRawSync = function(buffer, opts) {
	  return zlibBufferSync(new InflateRaw(opts), buffer);
	};
	
	function zlibBuffer(engine, buffer, callback) {
	  var buffers = [];
	  var nread = 0;
	
	  engine.on('error', onError);
	  engine.on('end', onEnd);
	
	  engine.end(buffer);
	  flow();
	
	  function flow() {
	    var chunk;
	    while (null !== (chunk = engine.read())) {
	      buffers.push(chunk);
	      nread += chunk.length;
	    }
	    engine.once('readable', flow);
	  }
	
	  function onError(err) {
	    engine.removeListener('end', onEnd);
	    engine.removeListener('readable', flow);
	    callback(err);
	  }
	
	  function onEnd() {
	    var buf = Buffer.concat(buffers, nread);
	    buffers = [];
	    callback(null, buf);
	    engine.close();
	  }
	}
	
	function zlibBufferSync(engine, buffer) {
	  if (typeof buffer === 'string')
	    buffer = new Buffer(buffer);
	  if (!Buffer.isBuffer(buffer))
	    throw new TypeError('Not a string or buffer');
	
	  var flushFlag = binding.Z_FINISH;
	
	  return engine._processChunk(buffer, flushFlag);
	}
	
	// generic zlib
	// minimal 2-byte header
	function Deflate(opts) {
	  if (!(this instanceof Deflate)) return new Deflate(opts);
	  Zlib.call(this, opts, binding.DEFLATE);
	}
	
	function Inflate(opts) {
	  if (!(this instanceof Inflate)) return new Inflate(opts);
	  Zlib.call(this, opts, binding.INFLATE);
	}
	
	
	
	// gzip - bigger header, same deflate compression
	function Gzip(opts) {
	  if (!(this instanceof Gzip)) return new Gzip(opts);
	  Zlib.call(this, opts, binding.GZIP);
	}
	
	function Gunzip(opts) {
	  if (!(this instanceof Gunzip)) return new Gunzip(opts);
	  Zlib.call(this, opts, binding.GUNZIP);
	}
	
	
	
	// raw - no header
	function DeflateRaw(opts) {
	  if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
	  Zlib.call(this, opts, binding.DEFLATERAW);
	}
	
	function InflateRaw(opts) {
	  if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
	  Zlib.call(this, opts, binding.INFLATERAW);
	}
	
	
	// auto-detect header.
	function Unzip(opts) {
	  if (!(this instanceof Unzip)) return new Unzip(opts);
	  Zlib.call(this, opts, binding.UNZIP);
	}
	
	
	// the Zlib class they all inherit from
	// This thing manages the queue of requests, and returns
	// true or false if there is anything in the queue when
	// you call the .write() method.
	
	function Zlib(opts, mode) {
	  this._opts = opts = opts || {};
	  this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
	
	  Transform.call(this, opts);
	
	  if (opts.flush) {
	    if (opts.flush !== binding.Z_NO_FLUSH &&
	        opts.flush !== binding.Z_PARTIAL_FLUSH &&
	        opts.flush !== binding.Z_SYNC_FLUSH &&
	        opts.flush !== binding.Z_FULL_FLUSH &&
	        opts.flush !== binding.Z_FINISH &&
	        opts.flush !== binding.Z_BLOCK) {
	      throw new Error('Invalid flush flag: ' + opts.flush);
	    }
	  }
	  this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
	
	  if (opts.chunkSize) {
	    if (opts.chunkSize < exports.Z_MIN_CHUNK ||
	        opts.chunkSize > exports.Z_MAX_CHUNK) {
	      throw new Error('Invalid chunk size: ' + opts.chunkSize);
	    }
	  }
	
	  if (opts.windowBits) {
	    if (opts.windowBits < exports.Z_MIN_WINDOWBITS ||
	        opts.windowBits > exports.Z_MAX_WINDOWBITS) {
	      throw new Error('Invalid windowBits: ' + opts.windowBits);
	    }
	  }
	
	  if (opts.level) {
	    if (opts.level < exports.Z_MIN_LEVEL ||
	        opts.level > exports.Z_MAX_LEVEL) {
	      throw new Error('Invalid compression level: ' + opts.level);
	    }
	  }
	
	  if (opts.memLevel) {
	    if (opts.memLevel < exports.Z_MIN_MEMLEVEL ||
	        opts.memLevel > exports.Z_MAX_MEMLEVEL) {
	      throw new Error('Invalid memLevel: ' + opts.memLevel);
	    }
	  }
	
	  if (opts.strategy) {
	    if (opts.strategy != exports.Z_FILTERED &&
	        opts.strategy != exports.Z_HUFFMAN_ONLY &&
	        opts.strategy != exports.Z_RLE &&
	        opts.strategy != exports.Z_FIXED &&
	        opts.strategy != exports.Z_DEFAULT_STRATEGY) {
	      throw new Error('Invalid strategy: ' + opts.strategy);
	    }
	  }
	
	  if (opts.dictionary) {
	    if (!Buffer.isBuffer(opts.dictionary)) {
	      throw new Error('Invalid dictionary: it should be a Buffer instance');
	    }
	  }
	
	  this._binding = new binding.Zlib(mode);
	
	  var self = this;
	  this._hadError = false;
	  this._binding.onerror = function(message, errno) {
	    // there is no way to cleanly recover.
	    // continuing only obscures problems.
	    self._binding = null;
	    self._hadError = true;
	
	    var error = new Error(message);
	    error.errno = errno;
	    error.code = exports.codes[errno];
	    self.emit('error', error);
	  };
	
	  var level = exports.Z_DEFAULT_COMPRESSION;
	  if (typeof opts.level === 'number') level = opts.level;
	
	  var strategy = exports.Z_DEFAULT_STRATEGY;
	  if (typeof opts.strategy === 'number') strategy = opts.strategy;
	
	  this._binding.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS,
	                     level,
	                     opts.memLevel || exports.Z_DEFAULT_MEMLEVEL,
	                     strategy,
	                     opts.dictionary);
	
	  this._buffer = new Buffer(this._chunkSize);
	  this._offset = 0;
	  this._closed = false;
	  this._level = level;
	  this._strategy = strategy;
	
	  this.once('end', this.close);
	}
	
	util.inherits(Zlib, Transform);
	
	Zlib.prototype.params = function(level, strategy, callback) {
	  if (level < exports.Z_MIN_LEVEL ||
	      level > exports.Z_MAX_LEVEL) {
	    throw new RangeError('Invalid compression level: ' + level);
	  }
	  if (strategy != exports.Z_FILTERED &&
	      strategy != exports.Z_HUFFMAN_ONLY &&
	      strategy != exports.Z_RLE &&
	      strategy != exports.Z_FIXED &&
	      strategy != exports.Z_DEFAULT_STRATEGY) {
	    throw new TypeError('Invalid strategy: ' + strategy);
	  }
	
	  if (this._level !== level || this._strategy !== strategy) {
	    var self = this;
	    this.flush(binding.Z_SYNC_FLUSH, function() {
	      self._binding.params(level, strategy);
	      if (!self._hadError) {
	        self._level = level;
	        self._strategy = strategy;
	        if (callback) callback();
	      }
	    });
	  } else {
	    process.nextTick(callback);
	  }
	};
	
	Zlib.prototype.reset = function() {
	  return this._binding.reset();
	};
	
	// This is the _flush function called by the transform class,
	// internally, when the last chunk has been written.
	Zlib.prototype._flush = function(callback) {
	  this._transform(new Buffer(0), '', callback);
	};
	
	Zlib.prototype.flush = function(kind, callback) {
	  var ws = this._writableState;
	
	  if (typeof kind === 'function' || (kind === void 0 && !callback)) {
	    callback = kind;
	    kind = binding.Z_FULL_FLUSH;
	  }
	
	  if (ws.ended) {
	    if (callback)
	      process.nextTick(callback);
	  } else if (ws.ending) {
	    if (callback)
	      this.once('end', callback);
	  } else if (ws.needDrain) {
	    var self = this;
	    this.once('drain', function() {
	      self.flush(callback);
	    });
	  } else {
	    this._flushFlag = kind;
	    this.write(new Buffer(0), '', callback);
	  }
	};
	
	Zlib.prototype.close = function(callback) {
	  if (callback)
	    process.nextTick(callback);
	
	  if (this._closed)
	    return;
	
	  this._closed = true;
	
	  this._binding.close();
	
	  var self = this;
	  process.nextTick(function() {
	    self.emit('close');
	  });
	};
	
	Zlib.prototype._transform = function(chunk, encoding, cb) {
	  var flushFlag;
	  var ws = this._writableState;
	  var ending = ws.ending || ws.ended;
	  var last = ending && (!chunk || ws.length === chunk.length);
	
	  if (!chunk === null && !Buffer.isBuffer(chunk))
	    return cb(new Error('invalid input'));
	
	  // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag.
	  // If it's explicitly flushing at some other time, then we use
	  // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
	  // goodness.
	  if (last)
	    flushFlag = binding.Z_FINISH;
	  else {
	    flushFlag = this._flushFlag;
	    // once we've flushed the last of the queue, stop flushing and
	    // go back to the normal behavior.
	    if (chunk.length >= ws.length) {
	      this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
	    }
	  }
	
	  var self = this;
	  this._processChunk(chunk, flushFlag, cb);
	};
	
	Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
	  var availInBefore = chunk && chunk.length;
	  var availOutBefore = this._chunkSize - this._offset;
	  var inOff = 0;
	
	  var self = this;
	
	  var async = typeof cb === 'function';
	
	  if (!async) {
	    var buffers = [];
	    var nread = 0;
	
	    var error;
	    this.on('error', function(er) {
	      error = er;
	    });
	
	    do {
	      var res = this._binding.writeSync(flushFlag,
	                                        chunk, // in
	                                        inOff, // in_off
	                                        availInBefore, // in_len
	                                        this._buffer, // out
	                                        this._offset, //out_off
	                                        availOutBefore); // out_len
	    } while (!this._hadError && callback(res[0], res[1]));
	
	    if (this._hadError) {
	      throw error;
	    }
	
	    var buf = Buffer.concat(buffers, nread);
	    this.close();
	
	    return buf;
	  }
	
	  var req = this._binding.write(flushFlag,
	                                chunk, // in
	                                inOff, // in_off
	                                availInBefore, // in_len
	                                this._buffer, // out
	                                this._offset, //out_off
	                                availOutBefore); // out_len
	
	  req.buffer = chunk;
	  req.callback = callback;
	
	  function callback(availInAfter, availOutAfter) {
	    if (self._hadError)
	      return;
	
	    var have = availOutBefore - availOutAfter;
	    assert(have >= 0, 'have should not go down');
	
	    if (have > 0) {
	      var out = self._buffer.slice(self._offset, self._offset + have);
	      self._offset += have;
	      // serve some output to the consumer.
	      if (async) {
	        self.push(out);
	      } else {
	        buffers.push(out);
	        nread += out.length;
	      }
	    }
	
	    // exhausted the output buffer, or used all the input create a new one.
	    if (availOutAfter === 0 || self._offset >= self._chunkSize) {
	      availOutBefore = self._chunkSize;
	      self._offset = 0;
	      self._buffer = new Buffer(self._chunkSize);
	    }
	
	    if (availOutAfter === 0) {
	      // Not actually done.  Need to reprocess.
	      // Also, update the availInBefore to the availInAfter value,
	      // so that if we have to hit it a third (fourth, etc.) time,
	      // it'll have the correct byte counts.
	      inOff += (availInBefore - availInAfter);
	      availInBefore = availInAfter;
	
	      if (!async)
	        return true;
	
	      var newReq = self._binding.write(flushFlag,
	                                       chunk,
	                                       inOff,
	                                       availInBefore,
	                                       self._buffer,
	                                       self._offset,
	                                       self._chunkSize);
	      newReq.callback = callback; // this same function
	      newReq.buffer = chunk;
	      return;
	    }
	
	    if (!async)
	      return false;
	
	    // finished with the chunk.
	    cb();
	  }
	};
	
	util.inherits(Deflate, Zlib);
	util.inherits(Inflate, Zlib);
	util.inherits(Gzip, Zlib);
	util.inherits(Gunzip, Zlib);
	util.inherits(DeflateRaw, Zlib);
	util.inherits(InflateRaw, Zlib);
	util.inherits(Unzip, Zlib);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10).Buffer, __webpack_require__(7)))

/***/ }),

/***/ 197:
/***/ (function(module, exports) {

	L.Control.Fullscreen = L.Control.extend({
	    options: {
	        position: 'topleft',
	        title: {
	            'false': 'View Fullscreen',
	            'true': 'Exit Fullscreen'
	        }
	    },
	
	    onAdd: function (map) {
	        var container = L.DomUtil.create('div', 'leaflet-control-fullscreen leaflet-bar leaflet-control');
	
	        this.link = L.DomUtil.create('a', 'leaflet-control-fullscreen-button leaflet-bar-part', container);
	        this.link.href = '#';
	
	        this._map = map;
	        this._map.on('fullscreenchange', this._toggleTitle, this);
	        this._toggleTitle();
	
	        L.DomEvent.on(this.link, 'click', this._click, this);
	
	        return container;
	    },
	
	    _click: function (e) {
	        L.DomEvent.stopPropagation(e);
	        L.DomEvent.preventDefault(e);
	        this._map.toggleFullscreen(this.options);
	    },
	
	    _toggleTitle: function() {
	        this.link.title = this.options.title[this._map.isFullscreen()];
	    }
	});
	
	L.Map.include({
	    isFullscreen: function () {
	        return this._isFullscreen || false;
	    },
	
	    toggleFullscreen: function (options) {
	        var container = this.getContainer();
	        if (this.isFullscreen()) {
	            if (options && options.pseudoFullscreen) {
	                this._disablePseudoFullscreen(container);
	            } else if (document.exitFullscreen) {
	                document.exitFullscreen();
	            } else if (document.mozCancelFullScreen) {
	                document.mozCancelFullScreen();
	            } else if (document.webkitCancelFullScreen) {
	                document.webkitCancelFullScreen();
	            } else if (document.msExitFullscreen) {
	                document.msExitFullscreen();
	            } else {
	                this._disablePseudoFullscreen(container);
	            }
	        } else {
	            if (options && options.pseudoFullscreen) {
	                this._enablePseudoFullscreen(container);
	            } else if (container.requestFullscreen) {
	                container.requestFullscreen();
	            } else if (container.mozRequestFullScreen) {
	                container.mozRequestFullScreen();
	            } else if (container.webkitRequestFullscreen) {
	                container.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
	            } else if (container.msRequestFullscreen) {
	                container.msRequestFullscreen();
	            } else {
	                this._enablePseudoFullscreen(container);
	            }
	        }
	
	    },
	
	    _enablePseudoFullscreen: function (container) {
	        L.DomUtil.addClass(container, 'leaflet-pseudo-fullscreen');
	        this._setFullscreen(true);
	        this.fire('fullscreenchange');
	    },
	
	    _disablePseudoFullscreen: function (container) {
	        L.DomUtil.removeClass(container, 'leaflet-pseudo-fullscreen');
	        this._setFullscreen(false);
	        this.fire('fullscreenchange');
	    },
	
	    _setFullscreen: function(fullscreen) {
	        this._isFullscreen = fullscreen;
	        var container = this.getContainer();
	        if (fullscreen) {
	            L.DomUtil.addClass(container, 'leaflet-fullscreen-on');
	        } else {
	            L.DomUtil.removeClass(container, 'leaflet-fullscreen-on');
	        }
	        this.invalidateSize();
	    },
	
	    _onFullscreenChange: function (e) {
	        var fullscreenElement =
	            document.fullscreenElement ||
	            document.mozFullScreenElement ||
	            document.webkitFullscreenElement ||
	            document.msFullscreenElement;
	
	        if (fullscreenElement === this.getContainer() && !this._isFullscreen) {
	            this._setFullscreen(true);
	            this.fire('fullscreenchange');
	        } else if (fullscreenElement !== this.getContainer() && this._isFullscreen) {
	            this._setFullscreen(false);
	            this.fire('fullscreenchange');
	        }
	    }
	});
	
	L.Map.mergeOptions({
	    fullscreenControl: false
	});
	
	L.Map.addInitHook(function () {
	    if (this.options.fullscreenControl) {
	        this.fullscreenControl = new L.Control.Fullscreen(this.options.fullscreenControl);
	        this.addControl(this.fullscreenControl);
	    }
	
	    var fullscreenchange;
	
	    if ('onfullscreenchange' in document) {
	        fullscreenchange = 'fullscreenchange';
	    } else if ('onmozfullscreenchange' in document) {
	        fullscreenchange = 'mozfullscreenchange';
	    } else if ('onwebkitfullscreenchange' in document) {
	        fullscreenchange = 'webkitfullscreenchange';
	    } else if ('onmsfullscreenchange' in document) {
	        fullscreenchange = 'MSFullscreenChange';
	    }
	
	    if (fullscreenchange) {
	        var onFullscreenChange = L.bind(this._onFullscreenChange, this);
	
	        this.whenReady(function () {
	            L.DomEvent.on(document, fullscreenchange, onFullscreenChange);
	        });
	
	        this.on('unload', function () {
	            L.DomEvent.off(document, fullscreenchange, onFullscreenChange);
	        });
	    }
	});
	
	L.control.fullscreen = function (options) {
	    return new L.Control.Fullscreen(options);
	};


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	/* @preserve
	 * Leaflet 1.8.0, a JS library for interactive maps. https://leafletjs.com
	 * (c) 2010-2022 Vladimir Agafonkin, (c) 2010-2011 CloudMade
	 */
	!function(t,i){ true?i(exports):"function"==typeof define&&define.amd?define(["exports"],i):i((t="undefined"!=typeof globalThis?globalThis:t||self).leaflet={})}(this,function(t){"use strict";function l(t){for(var i,e,n=1,o=arguments.length;n<o;n++)for(i in e=arguments[n])t[i]=e[i];return t}var R=Object.create||function(t){return N.prototype=t,new N};function N(){}function a(t,i){var e=Array.prototype.slice;if(t.bind)return t.bind.apply(t,e.call(arguments,1));var n=e.call(arguments,2);return function(){return t.apply(i,n.length?n.concat(e.call(arguments)):arguments)}}var D=0;function h(t){return"_leaflet_id"in t||(t._leaflet_id=++D),t._leaflet_id}function j(t,i,e){var n,o,s=function(){n=!1,o&&(r.apply(e,o),o=!1)},r=function(){n?o=arguments:(t.apply(e,arguments),setTimeout(s,i),n=!0)};return r}function H(t,i,e){var n=i[1],i=i[0],o=n-i;return t===n&&e?t:((t-i)%o+o)%o+i}function u(){return!1}function e(t,i){if(!1===i)return t;i=Math.pow(10,void 0===i?6:i);return Math.round(t*i)/i}function W(t){return t.trim?t.trim():t.replace(/^\s+|\s+$/g,"")}function F(t){return W(t).split(/\s+/)}function c(t,i){for(var e in Object.prototype.hasOwnProperty.call(t,"options")||(t.options=t.options?R(t.options):{}),i)t.options[e]=i[e];return t.options}function U(t,i,e){var n,o=[];for(n in t)o.push(encodeURIComponent(e?n.toUpperCase():n)+"="+encodeURIComponent(t[n]));return(i&&-1!==i.indexOf("?")?"&":"?")+o.join("&")}var V=/\{ *([\w_ -]+) *\}/g;function q(t,e){return t.replace(V,function(t,i){i=e[i];if(void 0===i)throw new Error("No value provided for variable "+t);return i="function"==typeof i?i(e):i})}var d=Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)};function G(t,i){for(var e=0;e<t.length;e++)if(t[e]===i)return e;return-1}var K="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";function Y(t){return window["webkit"+t]||window["moz"+t]||window["ms"+t]}var X=0;function J(t){var i=+new Date,e=Math.max(0,16-(i-X));return X=i+e,window.setTimeout(t,e)}var $=window.requestAnimationFrame||Y("RequestAnimationFrame")||J,Q=window.cancelAnimationFrame||Y("CancelAnimationFrame")||Y("CancelRequestAnimationFrame")||function(t){window.clearTimeout(t)};function x(t,i,e){if(!e||$!==J)return $.call(window,a(t,i));t.call(i)}function r(t){t&&Q.call(window,t)}var tt={__proto__:null,extend:l,create:R,bind:a,get lastId(){return D},stamp:h,throttle:j,wrapNum:H,falseFn:u,formatNum:e,trim:W,splitWords:F,setOptions:c,getParamString:U,template:q,isArray:d,indexOf:G,emptyImageUrl:K,requestFn:$,cancelFn:Q,requestAnimFrame:x,cancelAnimFrame:r};function it(){}it.extend=function(t){function i(){c(this),this.initialize&&this.initialize.apply(this,arguments),this.callInitHooks()}var e,n=i.__super__=this.prototype,o=R(n);for(e in(o.constructor=i).prototype=o,this)Object.prototype.hasOwnProperty.call(this,e)&&"prototype"!==e&&"__super__"!==e&&(i[e]=this[e]);if(t.statics&&l(i,t.statics),t.includes){var s=t.includes;if("undefined"!=typeof L&&L&&L.Mixin){s=d(s)?s:[s];for(var r=0;r<s.length;r++)s[r]===L.Mixin.Events&&console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.",(new Error).stack)}l.apply(null,[o].concat(t.includes))}return l(o,t),delete o.statics,delete o.includes,o.options&&(o.options=n.options?R(n.options):{},l(o.options,t.options)),o._initHooks=[],o.callInitHooks=function(){if(!this._initHooksCalled){n.callInitHooks&&n.callInitHooks.call(this),this._initHooksCalled=!0;for(var t=0,i=o._initHooks.length;t<i;t++)o._initHooks[t].call(this)}},i},it.include=function(t){var i=this.prototype.options;return l(this.prototype,t),t.options&&(this.prototype.options=i,this.mergeOptions(t.options)),this},it.mergeOptions=function(t){return l(this.prototype.options,t),this},it.addInitHook=function(t){var i=Array.prototype.slice.call(arguments,1),e="function"==typeof t?t:function(){this[t].apply(this,i)};return this.prototype._initHooks=this.prototype._initHooks||[],this.prototype._initHooks.push(e),this};var i={on:function(t,i,e){if("object"==typeof t)for(var n in t)this._on(n,t[n],i);else for(var o=0,s=(t=F(t)).length;o<s;o++)this._on(t[o],i,e);return this},off:function(t,i,e){if(arguments.length)if("object"==typeof t)for(var n in t)this._off(n,t[n],i);else{t=F(t);for(var o=1===arguments.length,s=0,r=t.length;s<r;s++)o?this._off(t[s]):this._off(t[s],i,e)}else delete this._events;return this},_on:function(t,i,e){if("function"!=typeof i)console.warn("wrong listener type: "+typeof i);else{this._events=this._events||{};for(var n=this._events[t],t=(n||(this._events[t]=n=[]),{fn:i,ctx:e=e===this?void 0:e}),o=n,s=0,r=o.length;s<r;s++)if(o[s].fn===i&&o[s].ctx===e)return;o.push(t)}},_off:function(t,i,e){var n,o,s;if(this._events&&(n=this._events[t]))if(1===arguments.length){if(this._firingCount)for(o=0,s=n.length;o<s;o++)n[o].fn=u;delete this._events[t]}else if(e===this&&(e=void 0),"function"!=typeof i)console.warn("wrong listener type: "+typeof i);else{for(o=0,s=n.length;o<s;o++){var r=n[o];if(r.ctx===e&&r.fn===i)return this._firingCount&&(r.fn=u,this._events[t]=n=n.slice()),void n.splice(o,1)}console.warn("listener not found")}},fire:function(t,i,e){if(!this.listens(t,e))return this;var n=l({},i,{type:t,target:this,sourceTarget:i&&i.sourceTarget||this});if(this._events){var o=this._events[t];if(o){this._firingCount=this._firingCount+1||1;for(var s=0,r=o.length;s<r;s++){var a=o[s];a.fn.call(a.ctx||this,n)}this._firingCount--}}return e&&this._propagateEvent(n),this},listens:function(t,i){"string"!=typeof t&&console.warn('"string" type argument expected');var e=this._events&&this._events[t];if(e&&e.length)return!0;if(i)for(var n in this._eventParents)if(this._eventParents[n].listens(t,i))return!0;return!1},once:function(t,i,e){if("object"==typeof t){for(var n in t)this.once(n,t[n],i);return this}var o=a(function(){this.off(t,i,e).off(t,o,e)},this);return this.on(t,i,e).on(t,o,e)},addEventParent:function(t){return this._eventParents=this._eventParents||{},this._eventParents[h(t)]=t,this},removeEventParent:function(t){return this._eventParents&&delete this._eventParents[h(t)],this},_propagateEvent:function(t){for(var i in this._eventParents)this._eventParents[i].fire(t.type,l({layer:t.target,propagatedFrom:t.target},t),!0)}},et=(i.addEventListener=i.on,i.removeEventListener=i.clearAllEventListeners=i.off,i.addOneTimeEventListener=i.once,i.fireEvent=i.fire,i.hasEventListeners=i.listens,it.extend(i));function p(t,i,e){this.x=e?Math.round(t):t,this.y=e?Math.round(i):i}var nt=Math.trunc||function(t){return 0<t?Math.floor(t):Math.ceil(t)};function _(t,i,e){return t instanceof p?t:d(t)?new p(t[0],t[1]):null==t?t:"object"==typeof t&&"x"in t&&"y"in t?new p(t.x,t.y):new p(t,i,e)}function m(t,i){if(t)for(var e=i?[t,i]:t,n=0,o=e.length;n<o;n++)this.extend(e[n])}function f(t,i){return!t||t instanceof m?t:new m(t,i)}function s(t,i){if(t)for(var e=i?[t,i]:t,n=0,o=e.length;n<o;n++)this.extend(e[n])}function g(t,i){return t instanceof s?t:new s(t,i)}function v(t,i,e){if(isNaN(t)||isNaN(i))throw new Error("Invalid LatLng object: ("+t+", "+i+")");this.lat=+t,this.lng=+i,void 0!==e&&(this.alt=+e)}function w(t,i,e){return t instanceof v?t:d(t)&&"object"!=typeof t[0]?3===t.length?new v(t[0],t[1],t[2]):2===t.length?new v(t[0],t[1]):null:null==t?t:"object"==typeof t&&"lat"in t?new v(t.lat,"lng"in t?t.lng:t.lon,t.alt):void 0===i?null:new v(t,i,e)}p.prototype={clone:function(){return new p(this.x,this.y)},add:function(t){return this.clone()._add(_(t))},_add:function(t){return this.x+=t.x,this.y+=t.y,this},subtract:function(t){return this.clone()._subtract(_(t))},_subtract:function(t){return this.x-=t.x,this.y-=t.y,this},divideBy:function(t){return this.clone()._divideBy(t)},_divideBy:function(t){return this.x/=t,this.y/=t,this},multiplyBy:function(t){return this.clone()._multiplyBy(t)},_multiplyBy:function(t){return this.x*=t,this.y*=t,this},scaleBy:function(t){return new p(this.x*t.x,this.y*t.y)},unscaleBy:function(t){return new p(this.x/t.x,this.y/t.y)},round:function(){return this.clone()._round()},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this},floor:function(){return this.clone()._floor()},_floor:function(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this},ceil:function(){return this.clone()._ceil()},_ceil:function(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this},trunc:function(){return this.clone()._trunc()},_trunc:function(){return this.x=nt(this.x),this.y=nt(this.y),this},distanceTo:function(t){var i=(t=_(t)).x-this.x,t=t.y-this.y;return Math.sqrt(i*i+t*t)},equals:function(t){return(t=_(t)).x===this.x&&t.y===this.y},contains:function(t){return t=_(t),Math.abs(t.x)<=Math.abs(this.x)&&Math.abs(t.y)<=Math.abs(this.y)},toString:function(){return"Point("+e(this.x)+", "+e(this.y)+")"}},m.prototype={extend:function(t){return t=_(t),this.min||this.max?(this.min.x=Math.min(t.x,this.min.x),this.max.x=Math.max(t.x,this.max.x),this.min.y=Math.min(t.y,this.min.y),this.max.y=Math.max(t.y,this.max.y)):(this.min=t.clone(),this.max=t.clone()),this},getCenter:function(t){return new p((this.min.x+this.max.x)/2,(this.min.y+this.max.y)/2,t)},getBottomLeft:function(){return new p(this.min.x,this.max.y)},getTopRight:function(){return new p(this.max.x,this.min.y)},getTopLeft:function(){return this.min},getBottomRight:function(){return this.max},getSize:function(){return this.max.subtract(this.min)},contains:function(t){var i,e;return(t=("number"==typeof t[0]||t instanceof p?_:f)(t))instanceof m?(i=t.min,e=t.max):i=e=t,i.x>=this.min.x&&e.x<=this.max.x&&i.y>=this.min.y&&e.y<=this.max.y},intersects:function(t){t=f(t);var i=this.min,e=this.max,n=t.min,t=t.max,o=t.x>=i.x&&n.x<=e.x,t=t.y>=i.y&&n.y<=e.y;return o&&t},overlaps:function(t){t=f(t);var i=this.min,e=this.max,n=t.min,t=t.max,o=t.x>i.x&&n.x<e.x,t=t.y>i.y&&n.y<e.y;return o&&t},isValid:function(){return!(!this.min||!this.max)}},s.prototype={extend:function(t){var i,e,n=this._southWest,o=this._northEast;if(t instanceof v)e=i=t;else{if(!(t instanceof s))return t?this.extend(w(t)||g(t)):this;if(i=t._southWest,e=t._northEast,!i||!e)return this}return n||o?(n.lat=Math.min(i.lat,n.lat),n.lng=Math.min(i.lng,n.lng),o.lat=Math.max(e.lat,o.lat),o.lng=Math.max(e.lng,o.lng)):(this._southWest=new v(i.lat,i.lng),this._northEast=new v(e.lat,e.lng)),this},pad:function(t){var i=this._southWest,e=this._northEast,n=Math.abs(i.lat-e.lat)*t,t=Math.abs(i.lng-e.lng)*t;return new s(new v(i.lat-n,i.lng-t),new v(e.lat+n,e.lng+t))},getCenter:function(){return new v((this._southWest.lat+this._northEast.lat)/2,(this._southWest.lng+this._northEast.lng)/2)},getSouthWest:function(){return this._southWest},getNorthEast:function(){return this._northEast},getNorthWest:function(){return new v(this.getNorth(),this.getWest())},getSouthEast:function(){return new v(this.getSouth(),this.getEast())},getWest:function(){return this._southWest.lng},getSouth:function(){return this._southWest.lat},getEast:function(){return this._northEast.lng},getNorth:function(){return this._northEast.lat},contains:function(t){t=("number"==typeof t[0]||t instanceof v||"lat"in t?w:g)(t);var i,e,n=this._southWest,o=this._northEast;return t instanceof s?(i=t.getSouthWest(),e=t.getNorthEast()):i=e=t,i.lat>=n.lat&&e.lat<=o.lat&&i.lng>=n.lng&&e.lng<=o.lng},intersects:function(t){t=g(t);var i=this._southWest,e=this._northEast,n=t.getSouthWest(),t=t.getNorthEast(),o=t.lat>=i.lat&&n.lat<=e.lat,t=t.lng>=i.lng&&n.lng<=e.lng;return o&&t},overlaps:function(t){t=g(t);var i=this._southWest,e=this._northEast,n=t.getSouthWest(),t=t.getNorthEast(),o=t.lat>i.lat&&n.lat<e.lat,t=t.lng>i.lng&&n.lng<e.lng;return o&&t},toBBoxString:function(){return[this.getWest(),this.getSouth(),this.getEast(),this.getNorth()].join(",")},equals:function(t,i){return!!t&&(t=g(t),this._southWest.equals(t.getSouthWest(),i)&&this._northEast.equals(t.getNorthEast(),i))},isValid:function(){return!(!this._southWest||!this._northEast)}};var ot={latLngToPoint:function(t,i){t=this.projection.project(t),i=this.scale(i);return this.transformation._transform(t,i)},pointToLatLng:function(t,i){i=this.scale(i),t=this.transformation.untransform(t,i);return this.projection.unproject(t)},project:function(t){return this.projection.project(t)},unproject:function(t){return this.projection.unproject(t)},scale:function(t){return 256*Math.pow(2,t)},zoom:function(t){return Math.log(t/256)/Math.LN2},getProjectedBounds:function(t){if(this.infinite)return null;var i=this.projection.bounds,t=this.scale(t);return new m(this.transformation.transform(i.min,t),this.transformation.transform(i.max,t))},infinite:!(v.prototype={equals:function(t,i){return!!t&&(t=w(t),Math.max(Math.abs(this.lat-t.lat),Math.abs(this.lng-t.lng))<=(void 0===i?1e-9:i))},toString:function(t){return"LatLng("+e(this.lat,t)+", "+e(this.lng,t)+")"},distanceTo:function(t){return st.distance(this,w(t))},wrap:function(){return st.wrapLatLng(this)},toBounds:function(t){var t=180*t/40075017,i=t/Math.cos(Math.PI/180*this.lat);return g([this.lat-t,this.lng-i],[this.lat+t,this.lng+i])},clone:function(){return new v(this.lat,this.lng,this.alt)}}),wrapLatLng:function(t){var i=this.wrapLng?H(t.lng,this.wrapLng,!0):t.lng;return new v(this.wrapLat?H(t.lat,this.wrapLat,!0):t.lat,i,t.alt)},wrapLatLngBounds:function(t){var i=t.getCenter(),e=this.wrapLatLng(i),n=i.lat-e.lat,i=i.lng-e.lng;if(0==n&&0==i)return t;e=t.getSouthWest(),t=t.getNorthEast();return new s(new v(e.lat-n,e.lng-i),new v(t.lat-n,t.lng-i))}},st=l({},ot,{wrapLng:[-180,180],R:6371e3,distance:function(t,i){var e=Math.PI/180,n=t.lat*e,o=i.lat*e,s=Math.sin((i.lat-t.lat)*e/2),i=Math.sin((i.lng-t.lng)*e/2),t=s*s+Math.cos(n)*Math.cos(o)*i*i,e=2*Math.atan2(Math.sqrt(t),Math.sqrt(1-t));return this.R*e}}),rt=6378137,rt={R:rt,MAX_LATITUDE:85.0511287798,project:function(t){var i=Math.PI/180,e=this.MAX_LATITUDE,e=Math.max(Math.min(e,t.lat),-e),e=Math.sin(e*i);return new p(this.R*t.lng*i,this.R*Math.log((1+e)/(1-e))/2)},unproject:function(t){var i=180/Math.PI;return new v((2*Math.atan(Math.exp(t.y/this.R))-Math.PI/2)*i,t.x*i/this.R)},bounds:new m([-(rt=rt*Math.PI),-rt],[rt,rt])};function at(t,i,e,n){if(d(t))return this._a=t[0],this._b=t[1],this._c=t[2],void(this._d=t[3]);this._a=t,this._b=i,this._c=e,this._d=n}function ht(t,i,e,n){return new at(t,i,e,n)}at.prototype={transform:function(t,i){return this._transform(t.clone(),i)},_transform:function(t,i){return t.x=(i=i||1)*(this._a*t.x+this._b),t.y=i*(this._c*t.y+this._d),t},untransform:function(t,i){return new p((t.x/(i=i||1)-this._b)/this._a,(t.y/i-this._d)/this._c)}};var lt=l({},st,{code:"EPSG:3857",projection:rt,transformation:ht(lt=.5/(Math.PI*rt.R),.5,-lt,.5)}),ut=l({},lt,{code:"EPSG:900913"});function ct(t){return document.createElementNS("http://www.w3.org/2000/svg",t)}function dt(t,i){for(var e,n,o,s,r="",a=0,h=t.length;a<h;a++){for(e=0,n=(o=t[a]).length;e<n;e++)r+=(e?"L":"M")+(s=o[e]).x+" "+s.y;r+=i?P.svg?"z":"x":""}return r||"M0 0"}var _t=document.documentElement.style,pt="ActiveXObject"in window,mt=pt&&!document.addEventListener,n="msLaunchUri"in navigator&&!("documentMode"in document),ft=y("webkit"),gt=y("android"),vt=y("android 2")||y("android 3"),yt=parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1],10),yt=gt&&y("Google")&&yt<537&&!("AudioNode"in window),xt=!!window.opera,wt=!n&&y("chrome"),Pt=y("gecko")&&!ft&&!xt&&!pt,bt=!wt&&y("safari"),Lt=y("phantom"),o="OTransition"in _t,Tt=0===navigator.platform.indexOf("Win"),zt=pt&&"transition"in _t,Mt="WebKitCSSMatrix"in window&&"m11"in new window.WebKitCSSMatrix&&!vt,_t="MozPerspective"in _t,Ct=!window.L_DISABLE_3D&&(zt||Mt||_t)&&!o&&!Lt,Zt="undefined"!=typeof orientation||y("mobile"),St=Zt&&ft,kt=Zt&&Mt,Et=!window.PointerEvent&&window.MSPointerEvent,Bt=!(!window.PointerEvent&&!Et),At="ontouchstart"in window||!!window.TouchEvent,It=!window.L_NO_TOUCH&&(At||Bt),Ot=Zt&&xt,Rt=Zt&&Pt,Nt=1<(window.devicePixelRatio||window.screen.deviceXDPI/window.screen.logicalXDPI),Dt=function(){var t=!1;try{var i=Object.defineProperty({},"passive",{get:function(){t=!0}});window.addEventListener("testPassiveEventSupport",u,i),window.removeEventListener("testPassiveEventSupport",u,i)}catch(t){}return t}(),jt=!!document.createElement("canvas").getContext,Ht=!(!document.createElementNS||!ct("svg").createSVGRect),Wt=!!Ht&&((Wt=document.createElement("div")).innerHTML="<svg/>","http://www.w3.org/2000/svg"===(Wt.firstChild&&Wt.firstChild.namespaceURI));function y(t){return 0<=navigator.userAgent.toLowerCase().indexOf(t)}var P={ie:pt,ielt9:mt,edge:n,webkit:ft,android:gt,android23:vt,androidStock:yt,opera:xt,chrome:wt,gecko:Pt,safari:bt,phantom:Lt,opera12:o,win:Tt,ie3d:zt,webkit3d:Mt,gecko3d:_t,any3d:Ct,mobile:Zt,mobileWebkit:St,mobileWebkit3d:kt,msPointer:Et,pointer:Bt,touch:It,touchNative:At,mobileOpera:Ot,mobileGecko:Rt,retina:Nt,passiveEvents:Dt,canvas:jt,svg:Ht,vml:!Ht&&function(){try{var t=document.createElement("div"),i=(t.innerHTML='<v:shape adj="1"/>',t.firstChild);return i.style.behavior="url(#default#VML)",i&&"object"==typeof i.adj}catch(t){return!1}}(),inlineSvg:Wt},Ft=P.msPointer?"MSPointerDown":"pointerdown",Ut=P.msPointer?"MSPointerMove":"pointermove",Vt=P.msPointer?"MSPointerUp":"pointerup",qt=P.msPointer?"MSPointerCancel":"pointercancel",Gt={touchstart:Ft,touchmove:Ut,touchend:Vt,touchcancel:qt},Kt={touchstart:function(t,i){i.MSPOINTER_TYPE_TOUCH&&i.pointerType===i.MSPOINTER_TYPE_TOUCH&&B(i);ii(t,i)},touchmove:ii,touchend:ii,touchcancel:ii},Yt={},Xt=!1;function Jt(t,i,e){return"touchstart"!==i||Xt||(document.addEventListener(Ft,$t,!0),document.addEventListener(Ut,Qt,!0),document.addEventListener(Vt,ti,!0),document.addEventListener(qt,ti,!0),Xt=!0),Kt[i]?(e=Kt[i].bind(this,e),t.addEventListener(Gt[i],e,!1),e):(console.warn("wrong event specified:",i),L.Util.falseFn)}function $t(t){Yt[t.pointerId]=t}function Qt(t){Yt[t.pointerId]&&(Yt[t.pointerId]=t)}function ti(t){delete Yt[t.pointerId]}function ii(t,i){if(i.pointerType!==(i.MSPOINTER_TYPE_MOUSE||"mouse")){for(var e in i.touches=[],Yt)i.touches.push(Yt[e]);i.changedTouches=[i],t(i)}}var ei=200;function ni(t,e){t.addEventListener("dblclick",e);var n,o=0;function i(t){var i;1!==t.detail?n=t.detail:"mouse"===t.pointerType||t.sourceCapabilities&&!t.sourceCapabilities.firesTouchEvents||((i=Date.now())-o<=ei?2===++n&&e(function(t){var i,e,n={};for(e in t)i=t[e],n[e]=i&&i.bind?i.bind(t):i;return(t=n).type="dblclick",n.detail=2,n.isTrusted=!1,n._simulated=!0,n}(t)):n=1,o=i)}return t.addEventListener("click",i),{dblclick:e,simDblclick:i}}var oi,si,ri,ai,hi,li,ui=wi(["transform","webkitTransform","OTransform","MozTransform","msTransform"]),ci=wi(["webkitTransition","transition","OTransition","MozTransition","msTransition"]),di="webkitTransition"===ci||"OTransition"===ci?ci+"End":"transitionend";function _i(t){return"string"==typeof t?document.getElementById(t):t}function pi(t,i){var e=t.style[i]||t.currentStyle&&t.currentStyle[i];return"auto"===(e=e&&"auto"!==e||!document.defaultView?e:(t=document.defaultView.getComputedStyle(t,null))?t[i]:null)?null:e}function b(t,i,e){t=document.createElement(t);return t.className=i||"",e&&e.appendChild(t),t}function T(t){var i=t.parentNode;i&&i.removeChild(t)}function mi(t){for(;t.firstChild;)t.removeChild(t.firstChild)}function fi(t){var i=t.parentNode;i&&i.lastChild!==t&&i.appendChild(t)}function gi(t){var i=t.parentNode;i&&i.firstChild!==t&&i.insertBefore(t,i.firstChild)}function vi(t,i){if(void 0!==t.classList)return t.classList.contains(i);t=xi(t);return 0<t.length&&new RegExp("(^|\\s)"+i+"(\\s|$)").test(t)}function z(t,i){var e;if(void 0!==t.classList)for(var n=F(i),o=0,s=n.length;o<s;o++)t.classList.add(n[o]);else vi(t,i)||yi(t,((e=xi(t))?e+" ":"")+i)}function M(t,i){void 0!==t.classList?t.classList.remove(i):yi(t,W((" "+xi(t)+" ").replace(" "+i+" "," ")))}function yi(t,i){void 0===t.className.baseVal?t.className=i:t.className.baseVal=i}function xi(t){return void 0===(t=t.correspondingElement?t.correspondingElement:t).className.baseVal?t.className:t.className.baseVal}function C(t,i){if("opacity"in t.style)t.style.opacity=i;else if("filter"in t.style){var e=!1,n="DXImageTransform.Microsoft.Alpha";try{e=t.filters.item(n)}catch(t){if(1===i)return}i=Math.round(100*i),e?(e.Enabled=100!==i,e.Opacity=i):t.style.filter+=" progid:"+n+"(opacity="+i+")"}}function wi(t){for(var i=document.documentElement.style,e=0;e<t.length;e++)if(t[e]in i)return t[e];return!1}function Pi(t,i,e){i=i||new p(0,0);t.style[ui]=(P.ie3d?"translate("+i.x+"px,"+i.y+"px)":"translate3d("+i.x+"px,"+i.y+"px,0)")+(e?" scale("+e+")":"")}function Z(t,i){t._leaflet_pos=i,P.any3d?Pi(t,i):(t.style.left=i.x+"px",t.style.top=i.y+"px")}function bi(t){return t._leaflet_pos||new p(0,0)}function Li(){S(window,"dragstart",B)}function Ti(){E(window,"dragstart",B)}function zi(t){for(;-1===t.tabIndex;)t=t.parentNode;t.style&&(Mi(),li=(hi=t).style.outline,t.style.outline="none",S(window,"keydown",Mi))}function Mi(){hi&&(hi.style.outline=li,li=hi=void 0,E(window,"keydown",Mi))}function Ci(t){for(;!((t=t.parentNode).offsetWidth&&t.offsetHeight||t===document.body););return t}function Zi(t){var i=t.getBoundingClientRect();return{x:i.width/t.offsetWidth||1,y:i.height/t.offsetHeight||1,boundingClientRect:i}}ai="onselectstart"in document?(ri=function(){S(window,"selectstart",B)},function(){E(window,"selectstart",B)}):(si=wi(["userSelect","WebkitUserSelect","OUserSelect","MozUserSelect","msUserSelect"]),ri=function(){var t;si&&(t=document.documentElement.style,oi=t[si],t[si]="none")},function(){si&&(document.documentElement.style[si]=oi,oi=void 0)});pt={__proto__:null,TRANSFORM:ui,TRANSITION:ci,TRANSITION_END:di,get:_i,getStyle:pi,create:b,remove:T,empty:mi,toFront:fi,toBack:gi,hasClass:vi,addClass:z,removeClass:M,setClass:yi,getClass:xi,setOpacity:C,testProp:wi,setTransform:Pi,setPosition:Z,getPosition:bi,get disableTextSelection(){return ri},get enableTextSelection(){return ai},disableImageDrag:Li,enableImageDrag:Ti,preventOutline:zi,restoreOutline:Mi,getSizedParentNode:Ci,getScale:Zi};function S(t,i,e,n){if(i&&"object"==typeof i)for(var o in i)Ei(t,o,i[o],e);else for(var s=0,r=(i=F(i)).length;s<r;s++)Ei(t,i[s],e,n);return this}var k="_leaflet_events";function E(t,i,e,n){if(1===arguments.length)Si(t),delete t[k];else if(i&&"object"==typeof i)for(var o in i)Bi(t,o,i[o],e);else if(i=F(i),2===arguments.length)Si(t,function(t){return-1!==G(i,t)});else for(var s=0,r=i.length;s<r;s++)Bi(t,i[s],e,n);return this}function Si(t,i){for(var e in t[k]){var n=e.split(/\d/)[0];i&&!i(n)||Bi(t,n,null,null,e)}}var ki={mouseenter:"mouseover",mouseleave:"mouseout",wheel:!("onwheel"in window)&&"mousewheel"};function Ei(i,t,e,n){var o,s,r=t+h(e)+(n?"_"+h(n):"");i[k]&&i[k][r]||(s=o=function(t){return e.call(n||i,t||window.event)},!P.touchNative&&P.pointer&&0===t.indexOf("touch")?o=Jt(i,t,o):P.touch&&"dblclick"===t?o=ni(i,o):"addEventListener"in i?"touchstart"===t||"touchmove"===t||"wheel"===t||"mousewheel"===t?i.addEventListener(ki[t]||t,o,!!P.passiveEvents&&{passive:!1}):"mouseenter"===t||"mouseleave"===t?i.addEventListener(ki[t],o=function(t){t=t||window.event,Hi(i,t)&&s(t)},!1):i.addEventListener(t,s,!1):i.attachEvent("on"+t,o),i[k]=i[k]||{},i[k][r]=o)}function Bi(t,i,e,n,o){o=o||i+h(e)+(n?"_"+h(n):"");var s,r,e=t[k]&&t[k][o];e&&(!P.touchNative&&P.pointer&&0===i.indexOf("touch")?(n=t,r=e,Gt[s=i]?n.removeEventListener(Gt[s],r,!1):console.warn("wrong event specified:",s)):P.touch&&"dblclick"===i?(n=e,(r=t).removeEventListener("dblclick",n.dblclick),r.removeEventListener("click",n.simDblclick)):"removeEventListener"in t?t.removeEventListener(ki[i]||i,e,!1):t.detachEvent("on"+i,e),t[k][o]=null)}function Ai(t){return t.stopPropagation?t.stopPropagation():t.originalEvent?t.originalEvent._stopped=!0:t.cancelBubble=!0,this}function Ii(t){return Ei(t,"wheel",Ai),this}function Oi(t){return S(t,"mousedown touchstart dblclick contextmenu",Ai),t._leaflet_disable_click=!0,this}function B(t){return t.preventDefault?t.preventDefault():t.returnValue=!1,this}function Ri(t){return B(t),Ai(t),this}function Ni(t,i){if(!i)return new p(t.clientX,t.clientY);var e=Zi(i),n=e.boundingClientRect;return new p((t.clientX-n.left)/e.x-i.clientLeft,(t.clientY-n.top)/e.y-i.clientTop)}var Di=P.win&&P.chrome?2*window.devicePixelRatio:P.gecko?window.devicePixelRatio:1;function ji(t){return P.edge?t.wheelDeltaY/2:t.deltaY&&0===t.deltaMode?-t.deltaY/Di:t.deltaY&&1===t.deltaMode?20*-t.deltaY:t.deltaY&&2===t.deltaMode?60*-t.deltaY:t.deltaX||t.deltaZ?0:t.wheelDelta?(t.wheelDeltaY||t.wheelDelta)/2:t.detail&&Math.abs(t.detail)<32765?20*-t.detail:t.detail?t.detail/-32765*60:0}function Hi(t,i){var e=i.relatedTarget;if(!e)return!0;try{for(;e&&e!==t;)e=e.parentNode}catch(t){return!1}return e!==t}var mt={__proto__:null,on:S,off:E,stopPropagation:Ai,disableScrollPropagation:Ii,disableClickPropagation:Oi,preventDefault:B,stop:Ri,getMousePosition:Ni,getWheelDelta:ji,isExternalTarget:Hi,addListener:S,removeListener:E},Wi=et.extend({run:function(t,i,e,n){this.stop(),this._el=t,this._inProgress=!0,this._duration=e||.25,this._easeOutPower=1/Math.max(n||.5,.2),this._startPos=bi(t),this._offset=i.subtract(this._startPos),this._startTime=+new Date,this.fire("start"),this._animate()},stop:function(){this._inProgress&&(this._step(!0),this._complete())},_animate:function(){this._animId=x(this._animate,this),this._step()},_step:function(t){var i=+new Date-this._startTime,e=1e3*this._duration;i<e?this._runFrame(this._easeOut(i/e),t):(this._runFrame(1),this._complete())},_runFrame:function(t,i){t=this._startPos.add(this._offset.multiplyBy(t));i&&t._round(),Z(this._el,t),this.fire("step")},_complete:function(){r(this._animId),this._inProgress=!1,this.fire("end")},_easeOut:function(t){return 1-Math.pow(1-t,this._easeOutPower)}}),A=et.extend({options:{crs:lt,center:void 0,zoom:void 0,minZoom:void 0,maxZoom:void 0,layers:[],maxBounds:void 0,renderer:void 0,zoomAnimation:!0,zoomAnimationThreshold:4,fadeAnimation:!0,markerZoomAnimation:!0,transform3DLimit:8388608,zoomSnap:1,zoomDelta:1,trackResize:!0},initialize:function(t,i){i=c(this,i),this._handlers=[],this._layers={},this._zoomBoundLayers={},this._sizeChanged=!0,this._initContainer(t),this._initLayout(),this._onResize=a(this._onResize,this),this._initEvents(),i.maxBounds&&this.setMaxBounds(i.maxBounds),void 0!==i.zoom&&(this._zoom=this._limitZoom(i.zoom)),i.center&&void 0!==i.zoom&&this.setView(w(i.center),i.zoom,{reset:!0}),this.callInitHooks(),this._zoomAnimated=ci&&P.any3d&&!P.mobileOpera&&this.options.zoomAnimation,this._zoomAnimated&&(this._createAnimProxy(),S(this._proxy,di,this._catchTransitionEnd,this)),this._addLayers(this.options.layers)},setView:function(t,i,e){if((i=void 0===i?this._zoom:this._limitZoom(i),t=this._limitCenter(w(t),i,this.options.maxBounds),e=e||{},this._stop(),this._loaded&&!e.reset&&!0!==e)&&(void 0!==e.animate&&(e.zoom=l({animate:e.animate},e.zoom),e.pan=l({animate:e.animate,duration:e.duration},e.pan)),this._zoom!==i?this._tryAnimatedZoom&&this._tryAnimatedZoom(t,i,e.zoom):this._tryAnimatedPan(t,e.pan)))return clearTimeout(this._sizeTimer),this;return this._resetView(t,i),this},setZoom:function(t,i){return this._loaded?this.setView(this.getCenter(),t,{zoom:i}):(this._zoom=t,this)},zoomIn:function(t,i){return t=t||(P.any3d?this.options.zoomDelta:1),this.setZoom(this._zoom+t,i)},zoomOut:function(t,i){return t=t||(P.any3d?this.options.zoomDelta:1),this.setZoom(this._zoom-t,i)},setZoomAround:function(t,i,e){var n=this.getZoomScale(i),o=this.getSize().divideBy(2),t=(t instanceof p?t:this.latLngToContainerPoint(t)).subtract(o).multiplyBy(1-1/n),n=this.containerPointToLatLng(o.add(t));return this.setView(n,i,{zoom:e})},_getBoundsCenterZoom:function(t,i){i=i||{},t=t.getBounds?t.getBounds():g(t);var e=_(i.paddingTopLeft||i.padding||[0,0]),n=_(i.paddingBottomRight||i.padding||[0,0]),o=this.getBoundsZoom(t,!1,e.add(n));if((o="number"==typeof i.maxZoom?Math.min(i.maxZoom,o):o)===1/0)return{center:t.getCenter(),zoom:o};i=n.subtract(e).divideBy(2),n=this.project(t.getSouthWest(),o),e=this.project(t.getNorthEast(),o);return{center:this.unproject(n.add(e).divideBy(2).add(i),o),zoom:o}},fitBounds:function(t,i){if(!(t=g(t)).isValid())throw new Error("Bounds are not valid.");t=this._getBoundsCenterZoom(t,i);return this.setView(t.center,t.zoom,i)},fitWorld:function(t){return this.fitBounds([[-90,-180],[90,180]],t)},panTo:function(t,i){return this.setView(t,this._zoom,{pan:i})},panBy:function(t,i){return i=i||{},(t=_(t).round()).x||t.y?(!0===i.animate||this.getSize().contains(t)?(this._panAnim||(this._panAnim=new Wi,this._panAnim.on({step:this._onPanTransitionStep,end:this._onPanTransitionEnd},this)),i.noMoveStart||this.fire("movestart"),!1!==i.animate?(z(this._mapPane,"leaflet-pan-anim"),e=this._getMapPanePos().subtract(t).round(),this._panAnim.run(this._mapPane,e,i.duration||.25,i.easeLinearity)):(this._rawPanBy(t),this.fire("move").fire("moveend"))):this._resetView(this.unproject(this.project(this.getCenter()).add(t)),this.getZoom()),this):this.fire("moveend");var e},flyTo:function(n,o,t){if(!1===(t=t||{}).animate||!P.any3d)return this.setView(n,o,t);this._stop();var s=this.project(this.getCenter()),r=this.project(n),i=this.getSize(),a=this._zoom,h=(n=w(n),o=void 0===o?a:o,Math.max(i.x,i.y)),e=h*this.getZoomScale(a,o),l=r.distanceTo(s)||1,u=1.42,c=u*u;function d(t){t=(e*e-h*h+(t?-1:1)*c*c*l*l)/(2*(t?e:h)*c*l),t=Math.sqrt(t*t+1)-t;return t<1e-9?-18:Math.log(t)}function _(t){return(Math.exp(t)-Math.exp(-t))/2}function p(t){return(Math.exp(t)+Math.exp(-t))/2}var m=d(0);function f(t){return h*(p(m)*(_(t=m+u*t)/p(t))-_(m))/c}var g=Date.now(),v=(d(1)-m)/u,y=t.duration?1e3*t.duration:1e3*v*.8;return this._moveStart(!0,t.noMoveStart),function t(){var i=(Date.now()-g)/y,e=(1-Math.pow(1-i,1.5))*v;i<=1?(this._flyToFrame=x(t,this),this._move(this.unproject(s.add(r.subtract(s).multiplyBy(f(e)/l)),a),this.getScaleZoom(h/(i=e,h*(p(m)/p(m+u*i))),a),{flyTo:!0})):this._move(n,o)._moveEnd(!0)}.call(this),this},flyToBounds:function(t,i){t=this._getBoundsCenterZoom(t,i);return this.flyTo(t.center,t.zoom,i)},setMaxBounds:function(t){return(t=g(t)).isValid()?(this.options.maxBounds&&this.off("moveend",this._panInsideMaxBounds),this.options.maxBounds=t,this._loaded&&this._panInsideMaxBounds(),this.on("moveend",this._panInsideMaxBounds)):(this.options.maxBounds=null,this.off("moveend",this._panInsideMaxBounds))},setMinZoom:function(t){var i=this.options.minZoom;return this.options.minZoom=t,this._loaded&&i!==t&&(this.fire("zoomlevelschange"),this.getZoom()<this.options.minZoom)?this.setZoom(t):this},setMaxZoom:function(t){var i=this.options.maxZoom;return this.options.maxZoom=t,this._loaded&&i!==t&&(this.fire("zoomlevelschange"),this.getZoom()>this.options.maxZoom)?this.setZoom(t):this},panInsideBounds:function(t,i){this._enforcingBounds=!0;var e=this.getCenter(),t=this._limitCenter(e,this._zoom,g(t));return e.equals(t)||this.panTo(t,i),this._enforcingBounds=!1,this},panInside:function(t,i){var e=_((i=i||{}).paddingTopLeft||i.padding||[0,0]),n=_(i.paddingBottomRight||i.padding||[0,0]),o=this.project(this.getCenter()),t=this.project(t),s=this.getPixelBounds(),e=f([s.min.add(e),s.max.subtract(n)]),s=e.getSize();return e.contains(t)||(this._enforcingBounds=!0,n=t.subtract(e.getCenter()),e=e.extend(t).getSize().subtract(s),o.x+=n.x<0?-e.x:e.x,o.y+=n.y<0?-e.y:e.y,this.panTo(this.unproject(o),i),this._enforcingBounds=!1),this},invalidateSize:function(t){if(!this._loaded)return this;t=l({animate:!1,pan:!0},!0===t?{animate:!0}:t);var i=this.getSize(),e=(this._sizeChanged=!0,this._lastCenter=null,this.getSize()),n=i.divideBy(2).round(),o=e.divideBy(2).round(),n=n.subtract(o);return n.x||n.y?(t.animate&&t.pan?this.panBy(n):(t.pan&&this._rawPanBy(n),this.fire("move"),t.debounceMoveend?(clearTimeout(this._sizeTimer),this._sizeTimer=setTimeout(a(this.fire,this,"moveend"),200)):this.fire("moveend")),this.fire("resize",{oldSize:i,newSize:e})):this},stop:function(){return this.setZoom(this._limitZoom(this._zoom)),this.options.zoomSnap||this.fire("viewreset"),this._stop()},locate:function(t){if(t=this._locateOptions=l({timeout:1e4,watch:!1},t),!("geolocation"in navigator))return this._handleGeolocationError({code:0,message:"Geolocation not supported."}),this;var i=a(this._handleGeolocationResponse,this),e=a(this._handleGeolocationError,this);return t.watch?this._locationWatchId=navigator.geolocation.watchPosition(i,e,t):navigator.geolocation.getCurrentPosition(i,e,t),this},stopLocate:function(){return navigator.geolocation&&navigator.geolocation.clearWatch&&navigator.geolocation.clearWatch(this._locationWatchId),this._locateOptions&&(this._locateOptions.setView=!1),this},_handleGeolocationError:function(t){var i;this._container._leaflet_id&&(i=t.code,t=t.message||(1===i?"permission denied":2===i?"position unavailable":"timeout"),this._locateOptions.setView&&!this._loaded&&this.fitWorld(),this.fire("locationerror",{code:i,message:"Geolocation error: "+t+"."}))},_handleGeolocationResponse:function(t){if(this._container._leaflet_id){var i,e,n=new v(t.coords.latitude,t.coords.longitude),o=n.toBounds(2*t.coords.accuracy),s=this._locateOptions,r=(s.setView&&(i=this.getBoundsZoom(o),this.setView(n,s.maxZoom?Math.min(i,s.maxZoom):i)),{latlng:n,bounds:o,timestamp:t.timestamp});for(e in t.coords)"number"==typeof t.coords[e]&&(r[e]=t.coords[e]);this.fire("locationfound",r)}},addHandler:function(t,i){if(!i)return this;i=this[t]=new i(this);return this._handlers.push(i),this.options[t]&&i.enable(),this},remove:function(){if(this._initEvents(!0),this.options.maxBounds&&this.off("moveend",this._panInsideMaxBounds),this._containerId!==this._container._leaflet_id)throw new Error("Map container is being reused by another instance");try{delete this._container._leaflet_id,delete this._containerId}catch(t){this._container._leaflet_id=void 0,this._containerId=void 0}for(var t in void 0!==this._locationWatchId&&this.stopLocate(),this._stop(),T(this._mapPane),this._clearControlPos&&this._clearControlPos(),this._resizeRequest&&(r(this._resizeRequest),this._resizeRequest=null),this._clearHandlers(),this._loaded&&this.fire("unload"),this._layers)this._layers[t].remove();for(t in this._panes)T(this._panes[t]);return this._layers=[],this._panes=[],delete this._mapPane,delete this._renderer,this},createPane:function(t,i){i=b("div","leaflet-pane"+(t?" leaflet-"+t.replace("Pane","")+"-pane":""),i||this._mapPane);return t&&(this._panes[t]=i),i},getCenter:function(){return this._checkIfLoaded(),this._lastCenter&&!this._moved()?this._lastCenter:this.layerPointToLatLng(this._getCenterLayerPoint())},getZoom:function(){return this._zoom},getBounds:function(){var t=this.getPixelBounds();return new s(this.unproject(t.getBottomLeft()),this.unproject(t.getTopRight()))},getMinZoom:function(){return void 0===this.options.minZoom?this._layersMinZoom||0:this.options.minZoom},getMaxZoom:function(){return void 0===this.options.maxZoom?void 0===this._layersMaxZoom?1/0:this._layersMaxZoom:this.options.maxZoom},getBoundsZoom:function(t,i,e){t=g(t),e=_(e||[0,0]);var n=this.getZoom()||0,o=this.getMinZoom(),s=this.getMaxZoom(),r=t.getNorthWest(),t=t.getSouthEast(),e=this.getSize().subtract(e),t=f(this.project(t,n),this.project(r,n)).getSize(),r=P.any3d?this.options.zoomSnap:1,a=e.x/t.x,e=e.y/t.y,t=i?Math.max(a,e):Math.min(a,e),n=this.getScaleZoom(t,n);return r&&(n=Math.round(n/(r/100))*(r/100),n=i?Math.ceil(n/r)*r:Math.floor(n/r)*r),Math.max(o,Math.min(s,n))},getSize:function(){return this._size&&!this._sizeChanged||(this._size=new p(this._container.clientWidth||0,this._container.clientHeight||0),this._sizeChanged=!1),this._size.clone()},getPixelBounds:function(t,i){t=this._getTopLeftPoint(t,i);return new m(t,t.add(this.getSize()))},getPixelOrigin:function(){return this._checkIfLoaded(),this._pixelOrigin},getPixelWorldBounds:function(t){return this.options.crs.getProjectedBounds(void 0===t?this.getZoom():t)},getPane:function(t){return"string"==typeof t?this._panes[t]:t},getPanes:function(){return this._panes},getContainer:function(){return this._container},getZoomScale:function(t,i){var e=this.options.crs;return i=void 0===i?this._zoom:i,e.scale(t)/e.scale(i)},getScaleZoom:function(t,i){var e=this.options.crs,t=(i=void 0===i?this._zoom:i,e.zoom(t*e.scale(i)));return isNaN(t)?1/0:t},project:function(t,i){return i=void 0===i?this._zoom:i,this.options.crs.latLngToPoint(w(t),i)},unproject:function(t,i){return i=void 0===i?this._zoom:i,this.options.crs.pointToLatLng(_(t),i)},layerPointToLatLng:function(t){t=_(t).add(this.getPixelOrigin());return this.unproject(t)},latLngToLayerPoint:function(t){return this.project(w(t))._round()._subtract(this.getPixelOrigin())},wrapLatLng:function(t){return this.options.crs.wrapLatLng(w(t))},wrapLatLngBounds:function(t){return this.options.crs.wrapLatLngBounds(g(t))},distance:function(t,i){return this.options.crs.distance(w(t),w(i))},containerPointToLayerPoint:function(t){return _(t).subtract(this._getMapPanePos())},layerPointToContainerPoint:function(t){return _(t).add(this._getMapPanePos())},containerPointToLatLng:function(t){t=this.containerPointToLayerPoint(_(t));return this.layerPointToLatLng(t)},latLngToContainerPoint:function(t){return this.layerPointToContainerPoint(this.latLngToLayerPoint(w(t)))},mouseEventToContainerPoint:function(t){return Ni(t,this._container)},mouseEventToLayerPoint:function(t){return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(t))},mouseEventToLatLng:function(t){return this.layerPointToLatLng(this.mouseEventToLayerPoint(t))},_initContainer:function(t){t=this._container=_i(t);if(!t)throw new Error("Map container not found.");if(t._leaflet_id)throw new Error("Map container is already initialized.");S(t,"scroll",this._onScroll,this),this._containerId=h(t)},_initLayout:function(){var t=this._container,i=(this._fadeAnimated=this.options.fadeAnimation&&P.any3d,z(t,"leaflet-container"+(P.touch?" leaflet-touch":"")+(P.retina?" leaflet-retina":"")+(P.ielt9?" leaflet-oldie":"")+(P.safari?" leaflet-safari":"")+(this._fadeAnimated?" leaflet-fade-anim":"")),pi(t,"position"));"absolute"!==i&&"relative"!==i&&"fixed"!==i&&(t.style.position="relative"),this._initPanes(),this._initControlPos&&this._initControlPos()},_initPanes:function(){var t=this._panes={};this._paneRenderers={},this._mapPane=this.createPane("mapPane",this._container),Z(this._mapPane,new p(0,0)),this.createPane("tilePane"),this.createPane("overlayPane"),this.createPane("shadowPane"),this.createPane("markerPane"),this.createPane("tooltipPane"),this.createPane("popupPane"),this.options.markerZoomAnimation||(z(t.markerPane,"leaflet-zoom-hide"),z(t.shadowPane,"leaflet-zoom-hide"))},_resetView:function(t,i){Z(this._mapPane,new p(0,0));var e=!this._loaded,n=(this._loaded=!0,i=this._limitZoom(i),this.fire("viewprereset"),this._zoom!==i);this._moveStart(n,!1)._move(t,i)._moveEnd(n),this.fire("viewreset"),e&&this.fire("load")},_moveStart:function(t,i){return t&&this.fire("zoomstart"),i||this.fire("movestart"),this},_move:function(t,i,e,n){void 0===i&&(i=this._zoom);var o=this._zoom!==i;return this._zoom=i,this._lastCenter=t,this._pixelOrigin=this._getNewPixelOrigin(t),n?e&&e.pinch&&this.fire("zoom",e):((o||e&&e.pinch)&&this.fire("zoom",e),this.fire("move",e)),this},_moveEnd:function(t){return t&&this.fire("zoomend"),this.fire("moveend")},_stop:function(){return r(this._flyToFrame),this._panAnim&&this._panAnim.stop(),this},_rawPanBy:function(t){Z(this._mapPane,this._getMapPanePos().subtract(t))},_getZoomSpan:function(){return this.getMaxZoom()-this.getMinZoom()},_panInsideMaxBounds:function(){this._enforcingBounds||this.panInsideBounds(this.options.maxBounds)},_checkIfLoaded:function(){if(!this._loaded)throw new Error("Set map center and zoom first.")},_initEvents:function(t){this._targets={};var i=t?E:S;i((this._targets[h(this._container)]=this)._container,"click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup",this._handleDOMEvent,this),this.options.trackResize&&i(window,"resize",this._onResize,this),P.any3d&&this.options.transform3DLimit&&(t?this.off:this.on).call(this,"moveend",this._onMoveEnd)},_onResize:function(){r(this._resizeRequest),this._resizeRequest=x(function(){this.invalidateSize({debounceMoveend:!0})},this)},_onScroll:function(){this._container.scrollTop=0,this._container.scrollLeft=0},_onMoveEnd:function(){var t=this._getMapPanePos();Math.max(Math.abs(t.x),Math.abs(t.y))>=this.options.transform3DLimit&&this._resetView(this.getCenter(),this.getZoom())},_findEventTargets:function(t,i){for(var e,n=[],o="mouseout"===i||"mouseover"===i,s=t.target||t.srcElement,r=!1;s;){if((e=this._targets[h(s)])&&("click"===i||"preclick"===i)&&this._draggableMoved(e)){r=!0;break}if(e&&e.listens(i,!0)){if(o&&!Hi(s,t))break;if(n.push(e),o)break}if(s===this._container)break;s=s.parentNode}return n=n.length||r||o||!this.listens(i,!0)?n:[this]},_isClickDisabled:function(t){for(;t!==this._container;){if(t._leaflet_disable_click)return!0;t=t.parentNode}},_handleDOMEvent:function(t){var i,e=t.target||t.srcElement;!this._loaded||e._leaflet_disable_events||"click"===t.type&&this._isClickDisabled(e)||("mousedown"===(i=t.type)&&zi(e),this._fireDOMEvent(t,i))},_mouseEvents:["click","dblclick","mouseover","mouseout","contextmenu"],_fireDOMEvent:function(t,i,e){"click"===t.type&&((a=l({},t)).type="preclick",this._fireDOMEvent(a,a.type,e));var n=this._findEventTargets(t,i);if(e){for(var o=[],s=0;s<e.length;s++)e[s].listens(i,!0)&&o.push(e[s]);n=o.concat(n)}if(n.length){"contextmenu"===i&&B(t);var r,a=n[0],h={originalEvent:t};for("keypress"!==t.type&&"keydown"!==t.type&&"keyup"!==t.type&&(r=a.getLatLng&&(!a._radius||a._radius<=10),h.containerPoint=r?this.latLngToContainerPoint(a.getLatLng()):this.mouseEventToContainerPoint(t),h.layerPoint=this.containerPointToLayerPoint(h.containerPoint),h.latlng=r?a.getLatLng():this.layerPointToLatLng(h.layerPoint)),s=0;s<n.length;s++)if(n[s].fire(i,h,!0),h.originalEvent._stopped||!1===n[s].options.bubblingMouseEvents&&-1!==G(this._mouseEvents,i))return}},_draggableMoved:function(t){return(t=t.dragging&&t.dragging.enabled()?t:this).dragging&&t.dragging.moved()||this.boxZoom&&this.boxZoom.moved()},_clearHandlers:function(){for(var t=0,i=this._handlers.length;t<i;t++)this._handlers[t].disable()},whenReady:function(t,i){return this._loaded?t.call(i||this,{target:this}):this.on("load",t,i),this},_getMapPanePos:function(){return bi(this._mapPane)||new p(0,0)},_moved:function(){var t=this._getMapPanePos();return t&&!t.equals([0,0])},_getTopLeftPoint:function(t,i){return(t&&void 0!==i?this._getNewPixelOrigin(t,i):this.getPixelOrigin()).subtract(this._getMapPanePos())},_getNewPixelOrigin:function(t,i){var e=this.getSize()._divideBy(2);return this.project(t,i)._subtract(e)._add(this._getMapPanePos())._round()},_latLngToNewLayerPoint:function(t,i,e){e=this._getNewPixelOrigin(e,i);return this.project(t,i)._subtract(e)},_latLngBoundsToNewLayerBounds:function(t,i,e){e=this._getNewPixelOrigin(e,i);return f([this.project(t.getSouthWest(),i)._subtract(e),this.project(t.getNorthWest(),i)._subtract(e),this.project(t.getSouthEast(),i)._subtract(e),this.project(t.getNorthEast(),i)._subtract(e)])},_getCenterLayerPoint:function(){return this.containerPointToLayerPoint(this.getSize()._divideBy(2))},_getCenterOffset:function(t){return this.latLngToLayerPoint(t).subtract(this._getCenterLayerPoint())},_limitCenter:function(t,i,e){if(!e)return t;var n=this.project(t,i),o=this.getSize().divideBy(2),o=new m(n.subtract(o),n.add(o)),o=this._getBoundsOffset(o,e,i);return o.round().equals([0,0])?t:this.unproject(n.add(o),i)},_limitOffset:function(t,i){if(!i)return t;var e=this.getPixelBounds(),e=new m(e.min.add(t),e.max.add(t));return t.add(this._getBoundsOffset(e,i))},_getBoundsOffset:function(t,i,e){i=f(this.project(i.getNorthEast(),e),this.project(i.getSouthWest(),e)),e=i.min.subtract(t.min),i=i.max.subtract(t.max);return new p(this._rebound(e.x,-i.x),this._rebound(e.y,-i.y))},_rebound:function(t,i){return 0<t+i?Math.round(t-i)/2:Math.max(0,Math.ceil(t))-Math.max(0,Math.floor(i))},_limitZoom:function(t){var i=this.getMinZoom(),e=this.getMaxZoom(),n=P.any3d?this.options.zoomSnap:1;return n&&(t=Math.round(t/n)*n),Math.max(i,Math.min(e,t))},_onPanTransitionStep:function(){this.fire("move")},_onPanTransitionEnd:function(){M(this._mapPane,"leaflet-pan-anim"),this.fire("moveend")},_tryAnimatedPan:function(t,i){t=this._getCenterOffset(t)._trunc();return!(!0!==(i&&i.animate)&&!this.getSize().contains(t))&&(this.panBy(t,i),!0)},_createAnimProxy:function(){var t=this._proxy=b("div","leaflet-proxy leaflet-zoom-animated");this._panes.mapPane.appendChild(t),this.on("zoomanim",function(t){var i=ui,e=this._proxy.style[i];Pi(this._proxy,this.project(t.center,t.zoom),this.getZoomScale(t.zoom,1)),e===this._proxy.style[i]&&this._animatingZoom&&this._onZoomTransitionEnd()},this),this.on("load moveend",this._animMoveEnd,this),this._on("unload",this._destroyAnimProxy,this)},_destroyAnimProxy:function(){T(this._proxy),this.off("load moveend",this._animMoveEnd,this),delete this._proxy},_animMoveEnd:function(){var t=this.getCenter(),i=this.getZoom();Pi(this._proxy,this.project(t,i),this.getZoomScale(i,1))},_catchTransitionEnd:function(t){this._animatingZoom&&0<=t.propertyName.indexOf("transform")&&this._onZoomTransitionEnd()},_nothingToAnimate:function(){return!this._container.getElementsByClassName("leaflet-zoom-animated").length},_tryAnimatedZoom:function(t,i,e){if(this._animatingZoom)return!0;if(e=e||{},!this._zoomAnimated||!1===e.animate||this._nothingToAnimate()||Math.abs(i-this._zoom)>this.options.zoomAnimationThreshold)return!1;var n=this.getZoomScale(i),n=this._getCenterOffset(t)._divideBy(1-1/n);return!(!0!==e.animate&&!this.getSize().contains(n))&&(x(function(){this._moveStart(!0,!1)._animateZoom(t,i,!0)},this),!0)},_animateZoom:function(t,i,e,n){this._mapPane&&(e&&(this._animatingZoom=!0,this._animateToCenter=t,this._animateToZoom=i,z(this._mapPane,"leaflet-zoom-anim")),this.fire("zoomanim",{center:t,zoom:i,noUpdate:n}),this._tempFireZoomEvent||(this._tempFireZoomEvent=this._zoom!==this._animateToZoom),this._move(this._animateToCenter,this._animateToZoom,void 0,!0),setTimeout(a(this._onZoomTransitionEnd,this),250))},_onZoomTransitionEnd:function(){this._animatingZoom&&(this._mapPane&&M(this._mapPane,"leaflet-zoom-anim"),this._animatingZoom=!1,this._move(this._animateToCenter,this._animateToZoom,void 0,!0),this._tempFireZoomEvent&&this.fire("zoom"),delete this._tempFireZoomEvent,this.fire("move"),this._moveEnd(!0))}});function Fi(t){return new I(t)}var Ui,I=it.extend({options:{position:"topright"},initialize:function(t){c(this,t)},getPosition:function(){return this.options.position},setPosition:function(t){var i=this._map;return i&&i.removeControl(this),this.options.position=t,i&&i.addControl(this),this},getContainer:function(){return this._container},addTo:function(t){this.remove(),this._map=t;var i=this._container=this.onAdd(t),e=this.getPosition(),t=t._controlCorners[e];return z(i,"leaflet-control"),-1!==e.indexOf("bottom")?t.insertBefore(i,t.firstChild):t.appendChild(i),this._map.on("unload",this.remove,this),this},remove:function(){return this._map&&(T(this._container),this.onRemove&&this.onRemove(this._map),this._map.off("unload",this.remove,this),this._map=null),this},_refocusOnMap:function(t){this._map&&t&&0<t.screenX&&0<t.screenY&&this._map.getContainer().focus()}}),Vi=(A.include({addControl:function(t){return t.addTo(this),this},removeControl:function(t){return t.remove(),this},_initControlPos:function(){var e=this._controlCorners={},n="leaflet-",o=this._controlContainer=b("div",n+"control-container",this._container);function t(t,i){e[t+i]=b("div",n+t+" "+n+i,o)}t("top","left"),t("top","right"),t("bottom","left"),t("bottom","right")},_clearControlPos:function(){for(var t in this._controlCorners)T(this._controlCorners[t]);T(this._controlContainer),delete this._controlCorners,delete this._controlContainer}}),I.extend({options:{collapsed:!0,position:"topright",autoZIndex:!0,hideSingleBase:!1,sortLayers:!1,sortFunction:function(t,i,e,n){return e<n?-1:n<e?1:0}},initialize:function(t,i,e){for(var n in c(this,e),this._layerControlInputs=[],this._layers=[],this._lastZIndex=0,this._handlingClick=!1,t)this._addLayer(t[n],n);for(n in i)this._addLayer(i[n],n,!0)},onAdd:function(t){this._initLayout(),this._update(),(this._map=t).on("zoomend",this._checkDisabledLayers,this);for(var i=0;i<this._layers.length;i++)this._layers[i].layer.on("add remove",this._onLayerChange,this);return this._container},addTo:function(t){return I.prototype.addTo.call(this,t),this._expandIfNotCollapsed()},onRemove:function(){this._map.off("zoomend",this._checkDisabledLayers,this);for(var t=0;t<this._layers.length;t++)this._layers[t].layer.off("add remove",this._onLayerChange,this)},addBaseLayer:function(t,i){return this._addLayer(t,i),this._map?this._update():this},addOverlay:function(t,i){return this._addLayer(t,i,!0),this._map?this._update():this},removeLayer:function(t){t.off("add remove",this._onLayerChange,this);t=this._getLayer(h(t));return t&&this._layers.splice(this._layers.indexOf(t),1),this._map?this._update():this},expand:function(){z(this._container,"leaflet-control-layers-expanded"),this._section.style.height=null;var t=this._map.getSize().y-(this._container.offsetTop+50);return t<this._section.clientHeight?(z(this._section,"leaflet-control-layers-scrollbar"),this._section.style.height=t+"px"):M(this._section,"leaflet-control-layers-scrollbar"),this._checkDisabledLayers(),this},collapse:function(){return M(this._container,"leaflet-control-layers-expanded"),this},_initLayout:function(){var t="leaflet-control-layers",i=this._container=b("div",t),e=this.options.collapsed,n=(i.setAttribute("aria-haspopup",!0),Oi(i),Ii(i),this._section=b("section",t+"-list")),o=(e&&(this._map.on("click",this.collapse,this),S(i,{mouseenter:function(){S(n,"click",B),this.expand(),setTimeout(function(){E(n,"click",B)})},mouseleave:this.collapse},this)),this._layersLink=b("a",t+"-toggle",i));o.href="#",o.title="Layers",o.setAttribute("role","button"),S(o,"click",B),S(o,"focus",this.expand,this),e||this.expand(),this._baseLayersList=b("div",t+"-base",n),this._separator=b("div",t+"-separator",n),this._overlaysList=b("div",t+"-overlays",n),i.appendChild(n)},_getLayer:function(t){for(var i=0;i<this._layers.length;i++)if(this._layers[i]&&h(this._layers[i].layer)===t)return this._layers[i]},_addLayer:function(t,i,e){this._map&&t.on("add remove",this._onLayerChange,this),this._layers.push({layer:t,name:i,overlay:e}),this.options.sortLayers&&this._layers.sort(a(function(t,i){return this.options.sortFunction(t.layer,i.layer,t.name,i.name)},this)),this.options.autoZIndex&&t.setZIndex&&(this._lastZIndex++,t.setZIndex(this._lastZIndex)),this._expandIfNotCollapsed()},_update:function(){if(!this._container)return this;mi(this._baseLayersList),mi(this._overlaysList),this._layerControlInputs=[];for(var t,i,e,n=0,o=0;o<this._layers.length;o++)e=this._layers[o],this._addItem(e),i=i||e.overlay,t=t||!e.overlay,n+=e.overlay?0:1;return this.options.hideSingleBase&&(this._baseLayersList.style.display=(t=t&&1<n)?"":"none"),this._separator.style.display=i&&t?"":"none",this},_onLayerChange:function(t){this._handlingClick||this._update();var i=this._getLayer(h(t.target)),t=i.overlay?"add"===t.type?"overlayadd":"overlayremove":"add"===t.type?"baselayerchange":null;t&&this._map.fire(t,i)},_createRadioElement:function(t,i){t='<input type="radio" class="leaflet-control-layers-selector" name="'+t+'"'+(i?' checked="checked"':"")+"/>",i=document.createElement("div");return i.innerHTML=t,i.firstChild},_addItem:function(t){var i,e=document.createElement("label"),n=this._map.hasLayer(t.layer),n=(t.overlay?((i=document.createElement("input")).type="checkbox",i.className="leaflet-control-layers-selector",i.defaultChecked=n):i=this._createRadioElement("leaflet-base-layers_"+h(this),n),this._layerControlInputs.push(i),i.layerId=h(t.layer),S(i,"click",this._onInputClick,this),document.createElement("span")),o=(n.innerHTML=" "+t.name,document.createElement("span"));return e.appendChild(o),o.appendChild(i),o.appendChild(n),(t.overlay?this._overlaysList:this._baseLayersList).appendChild(e),this._checkDisabledLayers(),e},_onInputClick:function(){var t,i,e=this._layerControlInputs,n=[],o=[];this._handlingClick=!0;for(var s=e.length-1;0<=s;s--)t=e[s],i=this._getLayer(t.layerId).layer,t.checked?n.push(i):t.checked||o.push(i);for(s=0;s<o.length;s++)this._map.hasLayer(o[s])&&this._map.removeLayer(o[s]);for(s=0;s<n.length;s++)this._map.hasLayer(n[s])||this._map.addLayer(n[s]);this._handlingClick=!1,this._refocusOnMap()},_checkDisabledLayers:function(){for(var t,i,e=this._layerControlInputs,n=this._map.getZoom(),o=e.length-1;0<=o;o--)t=e[o],i=this._getLayer(t.layerId).layer,t.disabled=void 0!==i.options.minZoom&&n<i.options.minZoom||void 0!==i.options.maxZoom&&n>i.options.maxZoom},_expandIfNotCollapsed:function(){return this._map&&!this.options.collapsed&&this.expand(),this}})),qi=I.extend({options:{position:"topleft",zoomInText:'<span aria-hidden="true">+</span>',zoomInTitle:"Zoom in",zoomOutText:'<span aria-hidden="true">&#x2212;</span>',zoomOutTitle:"Zoom out"},onAdd:function(t){var i="leaflet-control-zoom",e=b("div",i+" leaflet-bar"),n=this.options;return this._zoomInButton=this._createButton(n.zoomInText,n.zoomInTitle,i+"-in",e,this._zoomIn),this._zoomOutButton=this._createButton(n.zoomOutText,n.zoomOutTitle,i+"-out",e,this._zoomOut),this._updateDisabled(),t.on("zoomend zoomlevelschange",this._updateDisabled,this),e},onRemove:function(t){t.off("zoomend zoomlevelschange",this._updateDisabled,this)},disable:function(){return this._disabled=!0,this._updateDisabled(),this},enable:function(){return this._disabled=!1,this._updateDisabled(),this},_zoomIn:function(t){!this._disabled&&this._map._zoom<this._map.getMaxZoom()&&this._map.zoomIn(this._map.options.zoomDelta*(t.shiftKey?3:1))},_zoomOut:function(t){!this._disabled&&this._map._zoom>this._map.getMinZoom()&&this._map.zoomOut(this._map.options.zoomDelta*(t.shiftKey?3:1))},_createButton:function(t,i,e,n,o){e=b("a",e,n);return e.innerHTML=t,e.href="#",e.title=i,e.setAttribute("role","button"),e.setAttribute("aria-label",i),Oi(e),S(e,"click",Ri),S(e,"click",o,this),S(e,"click",this._refocusOnMap,this),e},_updateDisabled:function(){var t=this._map,i="leaflet-disabled";M(this._zoomInButton,i),M(this._zoomOutButton,i),this._zoomInButton.setAttribute("aria-disabled","false"),this._zoomOutButton.setAttribute("aria-disabled","false"),!this._disabled&&t._zoom!==t.getMinZoom()||(z(this._zoomOutButton,i),this._zoomOutButton.setAttribute("aria-disabled","true")),!this._disabled&&t._zoom!==t.getMaxZoom()||(z(this._zoomInButton,i),this._zoomInButton.setAttribute("aria-disabled","true"))}}),Gi=(A.mergeOptions({zoomControl:!0}),A.addInitHook(function(){this.options.zoomControl&&(this.zoomControl=new qi,this.addControl(this.zoomControl))}),I.extend({options:{position:"bottomleft",maxWidth:100,metric:!0,imperial:!0},onAdd:function(t){var i="leaflet-control-scale",e=b("div",i),n=this.options;return this._addScales(n,i+"-line",e),t.on(n.updateWhenIdle?"moveend":"move",this._update,this),t.whenReady(this._update,this),e},onRemove:function(t){t.off(this.options.updateWhenIdle?"moveend":"move",this._update,this)},_addScales:function(t,i,e){t.metric&&(this._mScale=b("div",i,e)),t.imperial&&(this._iScale=b("div",i,e))},_update:function(){var t=this._map,i=t.getSize().y/2,t=t.distance(t.containerPointToLatLng([0,i]),t.containerPointToLatLng([this.options.maxWidth,i]));this._updateScales(t)},_updateScales:function(t){this.options.metric&&t&&this._updateMetric(t),this.options.imperial&&t&&this._updateImperial(t)},_updateMetric:function(t){var i=this._getRoundNum(t);this._updateScale(this._mScale,i<1e3?i+" m":i/1e3+" km",i/t)},_updateImperial:function(t){var i,e,t=3.2808399*t;5280<t?(e=this._getRoundNum(i=t/5280),this._updateScale(this._iScale,e+" mi",e/i)):(e=this._getRoundNum(t),this._updateScale(this._iScale,e+" ft",e/t))},_updateScale:function(t,i,e){t.style.width=Math.round(this.options.maxWidth*e)+"px",t.innerHTML=i},_getRoundNum:function(t){var i=Math.pow(10,(Math.floor(t)+"").length-1),t=t/i;return i*(t=10<=t?10:5<=t?5:3<=t?3:2<=t?2:1)}})),Ki=I.extend({options:{position:"bottomright",prefix:'<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">'+(P.inlineSvg?'<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg> ':"")+"Leaflet</a>"},initialize:function(t){c(this,t),this._attributions={}},onAdd:function(t){for(var i in(t.attributionControl=this)._container=b("div","leaflet-control-attribution"),Oi(this._container),t._layers)t._layers[i].getAttribution&&this.addAttribution(t._layers[i].getAttribution());return this._update(),t.on("layeradd",this._addAttribution,this),this._container},onRemove:function(t){t.off("layeradd",this._addAttribution,this)},_addAttribution:function(t){t.layer.getAttribution&&(this.addAttribution(t.layer.getAttribution()),t.layer.once("remove",function(){this.removeAttribution(t.layer.getAttribution())},this))},setPrefix:function(t){return this.options.prefix=t,this._update(),this},addAttribution:function(t){return t&&(this._attributions[t]||(this._attributions[t]=0),this._attributions[t]++,this._update()),this},removeAttribution:function(t){return t&&this._attributions[t]&&(this._attributions[t]--,this._update()),this},_update:function(){if(this._map){var t,i=[];for(t in this._attributions)this._attributions[t]&&i.push(t);var e=[];this.options.prefix&&e.push(this.options.prefix),i.length&&e.push(i.join(", ")),this._container.innerHTML=e.join(' <span aria-hidden="true">|</span> ')}}}),n=(A.mergeOptions({attributionControl:!0}),A.addInitHook(function(){this.options.attributionControl&&(new Ki).addTo(this)}),I.Layers=Vi,I.Zoom=qi,I.Scale=Gi,I.Attribution=Ki,Fi.layers=function(t,i,e){return new Vi(t,i,e)},Fi.zoom=function(t){return new qi(t)},Fi.scale=function(t){return new Gi(t)},Fi.attribution=function(t){return new Ki(t)},it.extend({initialize:function(t){this._map=t},enable:function(){return this._enabled||(this._enabled=!0,this.addHooks()),this},disable:function(){return this._enabled&&(this._enabled=!1,this.removeHooks()),this},enabled:function(){return!!this._enabled}})),ft=(n.addTo=function(t,i){return t.addHandler(i,this),this},{Events:i}),Yi=P.touch?"touchstart mousedown":"mousedown",Xi=et.extend({options:{clickTolerance:3},initialize:function(t,i,e,n){c(this,n),this._element=t,this._dragStartTarget=i||t,this._preventOutline=e},enable:function(){this._enabled||(S(this._dragStartTarget,Yi,this._onDown,this),this._enabled=!0)},disable:function(){this._enabled&&(Xi._dragging===this&&this.finishDrag(!0),E(this._dragStartTarget,Yi,this._onDown,this),this._enabled=!1,this._moved=!1)},_onDown:function(t){var i,e;this._enabled&&(this._moved=!1,vi(this._element,"leaflet-zoom-anim")||(t.touches&&1!==t.touches.length?Xi._dragging===this&&this.finishDrag():Xi._dragging||t.shiftKey||1!==t.which&&1!==t.button&&!t.touches||((Xi._dragging=this)._preventOutline&&zi(this._element),Li(),ri(),this._moving||(this.fire("down"),e=t.touches?t.touches[0]:t,i=Ci(this._element),this._startPoint=new p(e.clientX,e.clientY),this._startPos=bi(this._element),this._parentScale=Zi(i),e="mousedown"===t.type,S(document,e?"mousemove":"touchmove",this._onMove,this),S(document,e?"mouseup":"touchend touchcancel",this._onUp,this)))))},_onMove:function(t){var i;this._enabled&&(t.touches&&1<t.touches.length?this._moved=!0:!(i=new p((i=t.touches&&1===t.touches.length?t.touches[0]:t).clientX,i.clientY)._subtract(this._startPoint)).x&&!i.y||Math.abs(i.x)+Math.abs(i.y)<this.options.clickTolerance||(i.x/=this._parentScale.x,i.y/=this._parentScale.y,B(t),this._moved||(this.fire("dragstart"),this._moved=!0,z(document.body,"leaflet-dragging"),this._lastTarget=t.target||t.srcElement,window.SVGElementInstance&&this._lastTarget instanceof window.SVGElementInstance&&(this._lastTarget=this._lastTarget.correspondingUseElement),z(this._lastTarget,"leaflet-drag-target")),this._newPos=this._startPos.add(i),this._moving=!0,this._lastEvent=t,this._updatePosition()))},_updatePosition:function(){var t={originalEvent:this._lastEvent};this.fire("predrag",t),Z(this._element,this._newPos),this.fire("drag",t)},_onUp:function(){this._enabled&&this.finishDrag()},finishDrag:function(t){M(document.body,"leaflet-dragging"),this._lastTarget&&(M(this._lastTarget,"leaflet-drag-target"),this._lastTarget=null),E(document,"mousemove touchmove",this._onMove,this),E(document,"mouseup touchend touchcancel",this._onUp,this),Ti(),ai(),this._moved&&this._moving&&this.fire("dragend",{noInertia:t,distance:this._newPos.distanceTo(this._startPos)}),this._moving=!1,Xi._dragging=!1}});function Ji(t,i){if(!i||!t.length)return t.slice();i*=i;return t=function(t,i){var e=t.length,n=new(typeof Uint8Array!=void 0+""?Uint8Array:Array)(e);n[0]=n[e-1]=1,function t(i,e,n,o,s){var r,a,h,l=0;for(a=o+1;a<=s-1;a++)h=ee(i[a],i[o],i[s],!0),l<h&&(r=a,l=h);n<l&&(e[r]=1,t(i,e,n,o,r),t(i,e,n,r,s))}(t,n,i,0,e-1);var o,s=[];for(o=0;o<e;o++)n[o]&&s.push(t[o]);return s}(t=function(t,i){for(var e=[t[0]],n=1,o=0,s=t.length;n<s;n++)(function(t,i){var e=i.x-t.x,i=i.y-t.y;return e*e+i*i})(t[n],t[o])>i&&(e.push(t[n]),o=n);o<s-1&&e.push(t[s-1]);return e}(t,i),i)}function $i(t,i,e){return Math.sqrt(ee(t,i,e,!0))}function Qi(t,i,e,n,o){var s,r,a,h=n?Ui:ie(t,e),l=ie(i,e);for(Ui=l;;){if(!(h|l))return[t,i];if(h&l)return!1;a=ie(r=te(t,i,s=h||l,e,o),e),s===h?(t=r,h=a):(i=r,l=a)}}function te(t,i,e,n,o){var s,r,a=i.x-t.x,i=i.y-t.y,h=n.min,n=n.max;return 8&e?(s=t.x+a*(n.y-t.y)/i,r=n.y):4&e?(s=t.x+a*(h.y-t.y)/i,r=h.y):2&e?(s=n.x,r=t.y+i*(n.x-t.x)/a):1&e&&(s=h.x,r=t.y+i*(h.x-t.x)/a),new p(s,r,o)}function ie(t,i){var e=0;return t.x<i.min.x?e|=1:t.x>i.max.x&&(e|=2),t.y<i.min.y?e|=4:t.y>i.max.y&&(e|=8),e}function ee(t,i,e,n){var o=i.x,i=i.y,s=e.x-o,r=e.y-i,a=s*s+r*r;return 0<a&&(1<(a=((t.x-o)*s+(t.y-i)*r)/a)?(o=e.x,i=e.y):0<a&&(o+=s*a,i+=r*a)),s=t.x-o,r=t.y-i,n?s*s+r*r:new p(o,i)}function ne(t){return!d(t[0])||"object"!=typeof t[0][0]&&void 0!==t[0][0]}function oe(t){return console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead."),ne(t)}gt={__proto__:null,simplify:Ji,pointToSegmentDistance:$i,closestPointOnSegment:function(t,i,e){return ee(t,i,e)},clipSegment:Qi,_getEdgeIntersection:te,_getBitCode:ie,_sqClosestPointOnSegment:ee,isFlat:ne,_flat:oe};function se(t,i,e){for(var n,o,s,r,a,h,l,u=[1,4,2,8],c=0,d=t.length;c<d;c++)t[c]._code=ie(t[c],i);for(s=0;s<4;s++){for(h=u[s],n=[],c=0,o=(d=t.length)-1;c<d;o=c++)r=t[c],a=t[o],r._code&h?a._code&h||((l=te(a,r,h,i,e))._code=ie(l,i),n.push(l)):(a._code&h&&((l=te(a,r,h,i,e))._code=ie(l,i),n.push(l)),n.push(r));t=n}return t}var vt={__proto__:null,clipPolygon:se},yt={project:function(t){return new p(t.lng,t.lat)},unproject:function(t){return new v(t.y,t.x)},bounds:new m([-180,-90],[180,90])},xt={R:6378137,R_MINOR:6356752.314245179,bounds:new m([-20037508.34279,-15496570.73972],[20037508.34279,18764656.23138]),project:function(t){var i=Math.PI/180,e=this.R,n=t.lat*i,o=this.R_MINOR/e,o=Math.sqrt(1-o*o),s=o*Math.sin(n),s=Math.tan(Math.PI/4-n/2)/Math.pow((1-s)/(1+s),o/2),n=-e*Math.log(Math.max(s,1e-10));return new p(t.lng*i*e,n)},unproject:function(t){for(var i,e=180/Math.PI,n=this.R,o=this.R_MINOR/n,s=Math.sqrt(1-o*o),r=Math.exp(-t.y/n),a=Math.PI/2-2*Math.atan(r),h=0,l=.1;h<15&&1e-7<Math.abs(l);h++)i=s*Math.sin(a),i=Math.pow((1-i)/(1+i),s/2),a+=l=Math.PI/2-2*Math.atan(r*i)-a;return new v(a*e,t.x*e/n)}},wt={__proto__:null,LonLat:yt,Mercator:xt,SphericalMercator:rt},bt=l({},st,{code:"EPSG:3395",projection:xt,transformation:ht(Pt=.5/(Math.PI*xt.R),.5,-Pt,.5)}),re=l({},st,{code:"EPSG:4326",projection:yt,transformation:ht(1/180,1,-1/180,.5)}),Lt=l({},ot,{projection:yt,transformation:ht(1,0,-1,0),scale:function(t){return Math.pow(2,t)},zoom:function(t){return Math.log(t)/Math.LN2},distance:function(t,i){var e=i.lng-t.lng,i=i.lat-t.lat;return Math.sqrt(e*e+i*i)},infinite:!0}),o=(ot.Earth=st,ot.EPSG3395=bt,ot.EPSG3857=lt,ot.EPSG900913=ut,ot.EPSG4326=re,ot.Simple=Lt,et.extend({options:{pane:"overlayPane",attribution:null,bubblingMouseEvents:!0},addTo:function(t){return t.addLayer(this),this},remove:function(){return this.removeFrom(this._map||this._mapToAdd)},removeFrom:function(t){return t&&t.removeLayer(this),this},getPane:function(t){return this._map.getPane(t?this.options[t]||t:this.options.pane)},addInteractiveTarget:function(t){return this._map._targets[h(t)]=this},removeInteractiveTarget:function(t){return delete this._map._targets[h(t)],this},getAttribution:function(){return this.options.attribution},_layerAdd:function(t){var i,e=t.target;e.hasLayer(this)&&(this._map=e,this._zoomAnimated=e._zoomAnimated,this.getEvents&&(i=this.getEvents(),e.on(i,this),this.once("remove",function(){e.off(i,this)},this)),this.onAdd(e),this.fire("add"),e.fire("layeradd",{layer:this}))}})),ae=(A.include({addLayer:function(t){if(!t._layerAdd)throw new Error("The provided object is not a Layer.");var i=h(t);return this._layers[i]||((this._layers[i]=t)._mapToAdd=this,t.beforeAdd&&t.beforeAdd(this),this.whenReady(t._layerAdd,t)),this},removeLayer:function(t){var i=h(t);return this._layers[i]&&(this._loaded&&t.onRemove(this),delete this._layers[i],this._loaded&&(this.fire("layerremove",{layer:t}),t.fire("remove")),t._map=t._mapToAdd=null),this},hasLayer:function(t){return h(t)in this._layers},eachLayer:function(t,i){for(var e in this._layers)t.call(i,this._layers[e]);return this},_addLayers:function(t){for(var i=0,e=(t=t?d(t)?t:[t]:[]).length;i<e;i++)this.addLayer(t[i])},_addZoomLimit:function(t){isNaN(t.options.maxZoom)&&isNaN(t.options.minZoom)||(this._zoomBoundLayers[h(t)]=t,this._updateZoomLevels())},_removeZoomLimit:function(t){t=h(t);this._zoomBoundLayers[t]&&(delete this._zoomBoundLayers[t],this._updateZoomLevels())},_updateZoomLevels:function(){var t,i=1/0,e=-1/0,n=this._getZoomSpan();for(t in this._zoomBoundLayers)var o=this._zoomBoundLayers[t].options,i=void 0===o.minZoom?i:Math.min(i,o.minZoom),e=void 0===o.maxZoom?e:Math.max(e,o.maxZoom);this._layersMaxZoom=e===-1/0?void 0:e,this._layersMinZoom=i===1/0?void 0:i,n!==this._getZoomSpan()&&this.fire("zoomlevelschange"),void 0===this.options.maxZoom&&this._layersMaxZoom&&this.getZoom()>this._layersMaxZoom&&this.setZoom(this._layersMaxZoom),void 0===this.options.minZoom&&this._layersMinZoom&&this.getZoom()<this._layersMinZoom&&this.setZoom(this._layersMinZoom)}}),o.extend({initialize:function(t,i){var e,n;if(c(this,i),this._layers={},t)for(e=0,n=t.length;e<n;e++)this.addLayer(t[e])},addLayer:function(t){var i=this.getLayerId(t);return this._layers[i]=t,this._map&&this._map.addLayer(t),this},removeLayer:function(t){t=t in this._layers?t:this.getLayerId(t);return this._map&&this._layers[t]&&this._map.removeLayer(this._layers[t]),delete this._layers[t],this},hasLayer:function(t){return("number"==typeof t?t:this.getLayerId(t))in this._layers},clearLayers:function(){return this.eachLayer(this.removeLayer,this)},invoke:function(t){var i,e,n=Array.prototype.slice.call(arguments,1);for(i in this._layers)(e=this._layers[i])[t]&&e[t].apply(e,n);return this},onAdd:function(t){this.eachLayer(t.addLayer,t)},onRemove:function(t){this.eachLayer(t.removeLayer,t)},eachLayer:function(t,i){for(var e in this._layers)t.call(i,this._layers[e]);return this},getLayer:function(t){return this._layers[t]},getLayers:function(){var t=[];return this.eachLayer(t.push,t),t},setZIndex:function(t){return this.invoke("setZIndex",t)},getLayerId:h})),he=ae.extend({addLayer:function(t){return this.hasLayer(t)?this:(t.addEventParent(this),ae.prototype.addLayer.call(this,t),this.fire("layeradd",{layer:t}))},removeLayer:function(t){return this.hasLayer(t)?((t=t in this._layers?this._layers[t]:t).removeEventParent(this),ae.prototype.removeLayer.call(this,t),this.fire("layerremove",{layer:t})):this},setStyle:function(t){return this.invoke("setStyle",t)},bringToFront:function(){return this.invoke("bringToFront")},bringToBack:function(){return this.invoke("bringToBack")},getBounds:function(){var t,i=new s;for(t in this._layers){var e=this._layers[t];i.extend(e.getBounds?e.getBounds():e.getLatLng())}return i}}),le=it.extend({options:{popupAnchor:[0,0],tooltipAnchor:[0,0],crossOrigin:!1},initialize:function(t){c(this,t)},createIcon:function(t){return this._createIcon("icon",t)},createShadow:function(t){return this._createIcon("shadow",t)},_createIcon:function(t,i){var e=this._getIconUrl(t);if(!e){if("icon"===t)throw new Error("iconUrl not set in Icon options (see the docs).");return null}e=this._createImg(e,i&&"IMG"===i.tagName?i:null);return this._setIconStyles(e,t),!this.options.crossOrigin&&""!==this.options.crossOrigin||(e.crossOrigin=!0===this.options.crossOrigin?"":this.options.crossOrigin),e},_setIconStyles:function(t,i){var e=this.options,n=e[i+"Size"],n=_(n="number"==typeof n?[n,n]:n),o=_("shadow"===i&&e.shadowAnchor||e.iconAnchor||n&&n.divideBy(2,!0));t.className="leaflet-marker-"+i+" "+(e.className||""),o&&(t.style.marginLeft=-o.x+"px",t.style.marginTop=-o.y+"px"),n&&(t.style.width=n.x+"px",t.style.height=n.y+"px")},_createImg:function(t,i){return(i=i||document.createElement("img")).src=t,i},_getIconUrl:function(t){return P.retina&&this.options[t+"RetinaUrl"]||this.options[t+"Url"]}});var ue=le.extend({options:{iconUrl:"marker-icon.png",iconRetinaUrl:"marker-icon-2x.png",shadowUrl:"marker-shadow.png",iconSize:[25,41],iconAnchor:[12,41],popupAnchor:[1,-34],tooltipAnchor:[16,-28],shadowSize:[41,41]},_getIconUrl:function(t){return"string"!=typeof ue.imagePath&&(ue.imagePath=this._detectIconPath()),(this.options.imagePath||ue.imagePath)+le.prototype._getIconUrl.call(this,t)},_stripUrl:function(t){function i(t,i,e){return(i=i.exec(t))&&i[e]}return(t=i(t,/^url\((['"])?(.+)\1\)$/,2))&&i(t,/^(.*)marker-icon\.png$/,1)},_detectIconPath:function(){var t=b("div","leaflet-default-icon-path",document.body),i=pi(t,"background-image")||pi(t,"backgroundImage");if(document.body.removeChild(t),i=this._stripUrl(i))return i;t=document.querySelector('link[href$="leaflet.css"]');return t?t.href.substring(0,t.href.length-"leaflet.css".length-1):""}}),ce=n.extend({initialize:function(t){this._marker=t},addHooks:function(){var t=this._marker._icon;this._draggable||(this._draggable=new Xi(t,t,!0)),this._draggable.on({dragstart:this._onDragStart,predrag:this._onPreDrag,drag:this._onDrag,dragend:this._onDragEnd},this).enable(),z(t,"leaflet-marker-draggable")},removeHooks:function(){this._draggable.off({dragstart:this._onDragStart,predrag:this._onPreDrag,drag:this._onDrag,dragend:this._onDragEnd},this).disable(),this._marker._icon&&M(this._marker._icon,"leaflet-marker-draggable")},moved:function(){return this._draggable&&this._draggable._moved},_adjustPan:function(t){var i=this._marker,e=i._map,n=this._marker.options.autoPanSpeed,o=this._marker.options.autoPanPadding,s=bi(i._icon),r=e.getPixelBounds(),a=e.getPixelOrigin(),a=f(r.min._subtract(a).add(o),r.max._subtract(a).subtract(o));a.contains(s)||(o=_((Math.max(a.max.x,s.x)-a.max.x)/(r.max.x-a.max.x)-(Math.min(a.min.x,s.x)-a.min.x)/(r.min.x-a.min.x),(Math.max(a.max.y,s.y)-a.max.y)/(r.max.y-a.max.y)-(Math.min(a.min.y,s.y)-a.min.y)/(r.min.y-a.min.y)).multiplyBy(n),e.panBy(o,{animate:!1}),this._draggable._newPos._add(o),this._draggable._startPos._add(o),Z(i._icon,this._draggable._newPos),this._onDrag(t),this._panRequest=x(this._adjustPan.bind(this,t)))},_onDragStart:function(){this._oldLatLng=this._marker.getLatLng(),this._marker.closePopup&&this._marker.closePopup(),this._marker.fire("movestart").fire("dragstart")},_onPreDrag:function(t){this._marker.options.autoPan&&(r(this._panRequest),this._panRequest=x(this._adjustPan.bind(this,t)))},_onDrag:function(t){var i=this._marker,e=i._shadow,n=bi(i._icon),o=i._map.layerPointToLatLng(n);e&&Z(e,n),i._latlng=o,t.latlng=o,t.oldLatLng=this._oldLatLng,i.fire("move",t).fire("drag",t)},_onDragEnd:function(t){r(this._panRequest),delete this._oldLatLng,this._marker.fire("moveend").fire("dragend",t)}}),de=o.extend({options:{icon:new ue,interactive:!0,keyboard:!0,title:"",alt:"Marker",zIndexOffset:0,opacity:1,riseOnHover:!1,riseOffset:250,pane:"markerPane",shadowPane:"shadowPane",bubblingMouseEvents:!1,autoPanOnFocus:!0,draggable:!1,autoPan:!1,autoPanPadding:[50,50],autoPanSpeed:10},initialize:function(t,i){c(this,i),this._latlng=w(t)},onAdd:function(t){this._zoomAnimated=this._zoomAnimated&&t.options.markerZoomAnimation,this._zoomAnimated&&t.on("zoomanim",this._animateZoom,this),this._initIcon(),this.update()},onRemove:function(t){this.dragging&&this.dragging.enabled()&&(this.options.draggable=!0,this.dragging.removeHooks()),delete this.dragging,this._zoomAnimated&&t.off("zoomanim",this._animateZoom,this),this._removeIcon(),this._removeShadow()},getEvents:function(){return{zoom:this.update,viewreset:this.update}},getLatLng:function(){return this._latlng},setLatLng:function(t){var i=this._latlng;return this._latlng=w(t),this.update(),this.fire("move",{oldLatLng:i,latlng:this._latlng})},setZIndexOffset:function(t){return this.options.zIndexOffset=t,this.update()},getIcon:function(){return this.options.icon},setIcon:function(t){return this.options.icon=t,this._map&&(this._initIcon(),this.update()),this._popup&&this.bindPopup(this._popup,this._popup.options),this},getElement:function(){return this._icon},update:function(){var t;return this._icon&&this._map&&(t=this._map.latLngToLayerPoint(this._latlng).round(),this._setPos(t)),this},_initIcon:function(){var t=this.options,i="leaflet-zoom-"+(this._zoomAnimated?"animated":"hide"),e=t.icon.createIcon(this._icon),n=!1,e=(e!==this._icon&&(this._icon&&this._removeIcon(),n=!0,t.title&&(e.title=t.title),"IMG"===e.tagName&&(e.alt=t.alt||"")),z(e,i),t.keyboard&&(e.tabIndex="0",e.setAttribute("role","button")),this._icon=e,t.riseOnHover&&this.on({mouseover:this._bringToFront,mouseout:this._resetZIndex}),this.options.autoPanOnFocus&&S(e,"focus",this._panOnFocus,this),t.icon.createShadow(this._shadow)),o=!1;e!==this._shadow&&(this._removeShadow(),o=!0),e&&(z(e,i),e.alt=""),this._shadow=e,t.opacity<1&&this._updateOpacity(),n&&this.getPane().appendChild(this._icon),this._initInteraction(),e&&o&&this.getPane(t.shadowPane).appendChild(this._shadow)},_removeIcon:function(){this.options.riseOnHover&&this.off({mouseover:this._bringToFront,mouseout:this._resetZIndex}),this.options.autoPanOnFocus&&E(this._icon,"focus",this._panOnFocus,this),T(this._icon),this.removeInteractiveTarget(this._icon),this._icon=null},_removeShadow:function(){this._shadow&&T(this._shadow),this._shadow=null},_setPos:function(t){this._icon&&Z(this._icon,t),this._shadow&&Z(this._shadow,t),this._zIndex=t.y+this.options.zIndexOffset,this._resetZIndex()},_updateZIndex:function(t){this._icon&&(this._icon.style.zIndex=this._zIndex+t)},_animateZoom:function(t){t=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center).round();this._setPos(t)},_initInteraction:function(){var t;this.options.interactive&&(z(this._icon,"leaflet-interactive"),this.addInteractiveTarget(this._icon),ce&&(t=this.options.draggable,this.dragging&&(t=this.dragging.enabled(),this.dragging.disable()),this.dragging=new ce(this),t&&this.dragging.enable()))},setOpacity:function(t){return this.options.opacity=t,this._map&&this._updateOpacity(),this},_updateOpacity:function(){var t=this.options.opacity;this._icon&&C(this._icon,t),this._shadow&&C(this._shadow,t)},_bringToFront:function(){this._updateZIndex(this.options.riseOffset)},_resetZIndex:function(){this._updateZIndex(0)},_panOnFocus:function(){var t,i,e=this._map;e&&(t=(i=this.options.icon.options).iconSize?_(i.iconSize):_(0,0),i=i.iconAnchor?_(i.iconAnchor):_(0,0),e.panInside(this._latlng,{paddingTopLeft:i,paddingBottomRight:t.subtract(i)}))},_getPopupAnchor:function(){return this.options.icon.options.popupAnchor},_getTooltipAnchor:function(){return this.options.icon.options.tooltipAnchor}});var _e=o.extend({options:{stroke:!0,color:"#3388ff",weight:3,opacity:1,lineCap:"round",lineJoin:"round",dashArray:null,dashOffset:null,fill:!1,fillColor:null,fillOpacity:.2,fillRule:"evenodd",interactive:!0,bubblingMouseEvents:!0},beforeAdd:function(t){this._renderer=t.getRenderer(this)},onAdd:function(){this._renderer._initPath(this),this._reset(),this._renderer._addPath(this)},onRemove:function(){this._renderer._removePath(this)},redraw:function(){return this._map&&this._renderer._updatePath(this),this},setStyle:function(t){return c(this,t),this._renderer&&(this._renderer._updateStyle(this),this.options.stroke&&t&&Object.prototype.hasOwnProperty.call(t,"weight")&&this._updateBounds()),this},bringToFront:function(){return this._renderer&&this._renderer._bringToFront(this),this},bringToBack:function(){return this._renderer&&this._renderer._bringToBack(this),this},getElement:function(){return this._path},_reset:function(){this._project(),this._update()},_clickTolerance:function(){return(this.options.stroke?this.options.weight/2:0)+(this._renderer.options.tolerance||0)}}),pe=_e.extend({options:{fill:!0,radius:10},initialize:function(t,i){c(this,i),this._latlng=w(t),this._radius=this.options.radius},setLatLng:function(t){var i=this._latlng;return this._latlng=w(t),this.redraw(),this.fire("move",{oldLatLng:i,latlng:this._latlng})},getLatLng:function(){return this._latlng},setRadius:function(t){return this.options.radius=this._radius=t,this.redraw()},getRadius:function(){return this._radius},setStyle:function(t){var i=t&&t.radius||this._radius;return _e.prototype.setStyle.call(this,t),this.setRadius(i),this},_project:function(){this._point=this._map.latLngToLayerPoint(this._latlng),this._updateBounds()},_updateBounds:function(){var t=this._radius,i=this._radiusY||t,e=this._clickTolerance(),t=[t+e,i+e];this._pxBounds=new m(this._point.subtract(t),this._point.add(t))},_update:function(){this._map&&this._updatePath()},_updatePath:function(){this._renderer._updateCircle(this)},_empty:function(){return this._radius&&!this._renderer._bounds.intersects(this._pxBounds)},_containsPoint:function(t){return t.distanceTo(this._point)<=this._radius+this._clickTolerance()}});var me=pe.extend({initialize:function(t,i,e){if(c(this,i="number"==typeof i?l({},e,{radius:i}):i),this._latlng=w(t),isNaN(this.options.radius))throw new Error("Circle radius cannot be NaN");this._mRadius=this.options.radius},setRadius:function(t){return this._mRadius=t,this.redraw()},getRadius:function(){return this._mRadius},getBounds:function(){var t=[this._radius,this._radiusY||this._radius];return new s(this._map.layerPointToLatLng(this._point.subtract(t)),this._map.layerPointToLatLng(this._point.add(t)))},setStyle:_e.prototype.setStyle,_project:function(){var t,i,e,n,o,s=this._latlng.lng,r=this._latlng.lat,a=this._map,h=a.options.crs;h.distance===st.distance?(n=Math.PI/180,o=this._mRadius/st.R/n,t=a.project([r+o,s]),i=a.project([r-o,s]),i=t.add(i).divideBy(2),e=a.unproject(i).lat,n=Math.acos((Math.cos(o*n)-Math.sin(r*n)*Math.sin(e*n))/(Math.cos(r*n)*Math.cos(e*n)))/n,!isNaN(n)&&0!==n||(n=o/Math.cos(Math.PI/180*r)),this._point=i.subtract(a.getPixelOrigin()),this._radius=isNaN(n)?0:i.x-a.project([e,s-n]).x,this._radiusY=i.y-t.y):(o=h.unproject(h.project(this._latlng).subtract([this._mRadius,0])),this._point=a.latLngToLayerPoint(this._latlng),this._radius=this._point.x-a.latLngToLayerPoint(o).x),this._updateBounds()}});var fe=_e.extend({options:{smoothFactor:1,noClip:!1},initialize:function(t,i){c(this,i),this._setLatLngs(t)},getLatLngs:function(){return this._latlngs},setLatLngs:function(t){return this._setLatLngs(t),this.redraw()},isEmpty:function(){return!this._latlngs.length},closestLayerPoint:function(t){for(var i=1/0,e=null,n=ee,o=0,s=this._parts.length;o<s;o++)for(var r=this._parts[o],a=1,h=r.length;a<h;a++){var l,u,c=n(t,l=r[a-1],u=r[a],!0);c<i&&(i=c,e=n(t,l,u))}return e&&(e.distance=Math.sqrt(i)),e},getCenter:function(){if(!this._map)throw new Error("Must add layer to map before using getCenter()");var t,i,e,n,o,s,r=this._rings[0],a=r.length;if(!a)return null;for(i=t=0;t<a-1;t++)i+=r[t].distanceTo(r[t+1])/2;if(0===i)return this._map.layerPointToLatLng(r[0]);for(e=t=0;t<a-1;t++)if(n=r[t],o=r[t+1],i<(e+=s=n.distanceTo(o)))return this._map.layerPointToLatLng([o.x-(s=(e-i)/s)*(o.x-n.x),o.y-s*(o.y-n.y)])},getBounds:function(){return this._bounds},addLatLng:function(t,i){return i=i||this._defaultShape(),t=w(t),i.push(t),this._bounds.extend(t),this.redraw()},_setLatLngs:function(t){this._bounds=new s,this._latlngs=this._convertLatLngs(t)},_defaultShape:function(){return ne(this._latlngs)?this._latlngs:this._latlngs[0]},_convertLatLngs:function(t){for(var i=[],e=ne(t),n=0,o=t.length;n<o;n++)e?(i[n]=w(t[n]),this._bounds.extend(i[n])):i[n]=this._convertLatLngs(t[n]);return i},_project:function(){var t=new m;this._rings=[],this._projectLatlngs(this._latlngs,this._rings,t),this._bounds.isValid()&&t.isValid()&&(this._rawPxBounds=t,this._updateBounds())},_updateBounds:function(){var t=this._clickTolerance(),t=new p(t,t);this._rawPxBounds&&(this._pxBounds=new m([this._rawPxBounds.min.subtract(t),this._rawPxBounds.max.add(t)]))},_projectLatlngs:function(t,i,e){var n,o,s=t[0]instanceof v,r=t.length;if(s){for(o=[],n=0;n<r;n++)o[n]=this._map.latLngToLayerPoint(t[n]),e.extend(o[n]);i.push(o)}else for(n=0;n<r;n++)this._projectLatlngs(t[n],i,e)},_clipPoints:function(){var t=this._renderer._bounds;if(this._parts=[],this._pxBounds&&this._pxBounds.intersects(t))if(this.options.noClip)this._parts=this._rings;else for(var i,e,n,o,s=this._parts,r=0,a=0,h=this._rings.length;r<h;r++)for(i=0,e=(o=this._rings[r]).length;i<e-1;i++)(n=Qi(o[i],o[i+1],t,i,!0))&&(s[a]=s[a]||[],s[a].push(n[0]),n[1]===o[i+1]&&i!==e-2||(s[a].push(n[1]),a++))},_simplifyPoints:function(){for(var t=this._parts,i=this.options.smoothFactor,e=0,n=t.length;e<n;e++)t[e]=Ji(t[e],i)},_update:function(){this._map&&(this._clipPoints(),this._simplifyPoints(),this._updatePath())},_updatePath:function(){this._renderer._updatePoly(this)},_containsPoint:function(t,i){var e,n,o,s,r,a,h=this._clickTolerance();if(!this._pxBounds||!this._pxBounds.contains(t))return!1;for(e=0,s=this._parts.length;e<s;e++)for(n=0,o=(r=(a=this._parts[e]).length)-1;n<r;o=n++)if((i||0!==n)&&$i(t,a[o],a[n])<=h)return!0;return!1}});fe._flat=oe;var ge=fe.extend({options:{fill:!0},isEmpty:function(){return!this._latlngs.length||!this._latlngs[0].length},getCenter:function(){if(!this._map)throw new Error("Must add layer to map before using getCenter()");var t,i,e,n,o,s,r,a,h,l=this._rings[0],u=l.length;if(!u)return null;for(t=s=r=a=0,i=u-1;t<u;i=t++)e=l[t],n=l[i],o=e.y*n.x-n.y*e.x,r+=(e.x+n.x)*o,a+=(e.y+n.y)*o,s+=3*o;return h=0===s?l[0]:[r/s,a/s],this._map.layerPointToLatLng(h)},_convertLatLngs:function(t){var t=fe.prototype._convertLatLngs.call(this,t),i=t.length;return 2<=i&&t[0]instanceof v&&t[0].equals(t[i-1])&&t.pop(),t},_setLatLngs:function(t){fe.prototype._setLatLngs.call(this,t),ne(this._latlngs)&&(this._latlngs=[this._latlngs])},_defaultShape:function(){return(ne(this._latlngs[0])?this._latlngs:this._latlngs[0])[0]},_clipPoints:function(){var t=this._renderer._bounds,i=this.options.weight,i=new p(i,i),t=new m(t.min.subtract(i),t.max.add(i));if(this._parts=[],this._pxBounds&&this._pxBounds.intersects(t))if(this.options.noClip)this._parts=this._rings;else for(var e,n=0,o=this._rings.length;n<o;n++)(e=se(this._rings[n],t,!0)).length&&this._parts.push(e)},_updatePath:function(){this._renderer._updatePoly(this,!0)},_containsPoint:function(t){var i,e,n,o,s,r,a,h,l=!1;if(!this._pxBounds||!this._pxBounds.contains(t))return!1;for(o=0,a=this._parts.length;o<a;o++)for(s=0,r=(h=(i=this._parts[o]).length)-1;s<h;r=s++)e=i[s],n=i[r],e.y>t.y!=n.y>t.y&&t.x<(n.x-e.x)*(t.y-e.y)/(n.y-e.y)+e.x&&(l=!l);return l||fe.prototype._containsPoint.call(this,t,!0)}});var ve=he.extend({initialize:function(t,i){c(this,i),this._layers={},t&&this.addData(t)},addData:function(t){var i,e,n,o=d(t)?t:t.features;if(o){for(i=0,e=o.length;i<e;i++)((n=o[i]).geometries||n.geometry||n.features||n.coordinates)&&this.addData(n);return this}var s=this.options;if(s.filter&&!s.filter(t))return this;var r=ye(t,s);return r?(r.feature=ze(t),r.defaultOptions=r.options,this.resetStyle(r),s.onEachFeature&&s.onEachFeature(t,r),this.addLayer(r)):this},resetStyle:function(t){return void 0===t?this.eachLayer(this.resetStyle,this):(t.options=l({},t.defaultOptions),this._setLayerStyle(t,this.options.style),this)},setStyle:function(i){return this.eachLayer(function(t){this._setLayerStyle(t,i)},this)},_setLayerStyle:function(t,i){t.setStyle&&("function"==typeof i&&(i=i(t.feature)),t.setStyle(i))}});function ye(t,i){var e,n,o,s,r="Feature"===t.type?t.geometry:t,a=r?r.coordinates:null,h=[],l=i&&i.pointToLayer,u=i&&i.coordsToLatLng||we;if(!a&&!r)return null;switch(r.type){case"Point":return xe(l,t,e=u(a),i);case"MultiPoint":for(o=0,s=a.length;o<s;o++)e=u(a[o]),h.push(xe(l,t,e,i));return new he(h);case"LineString":case"MultiLineString":return n=Pe(a,"LineString"===r.type?0:1,u),new fe(n,i);case"Polygon":case"MultiPolygon":return n=Pe(a,"Polygon"===r.type?1:2,u),new ge(n,i);case"GeometryCollection":for(o=0,s=r.geometries.length;o<s;o++){var c=ye({geometry:r.geometries[o],type:"Feature",properties:t.properties},i);c&&h.push(c)}return new he(h);default:throw new Error("Invalid GeoJSON object.")}}function xe(t,i,e,n){return t?t(i,e):new de(e,n&&n.markersInheritOptions&&n)}function we(t){return new v(t[1],t[0],t[2])}function Pe(t,i,e){for(var n,o=[],s=0,r=t.length;s<r;s++)n=i?Pe(t[s],i-1,e):(e||we)(t[s]),o.push(n);return o}function be(t,i){return void 0!==(t=w(t)).alt?[e(t.lng,i),e(t.lat,i),e(t.alt,i)]:[e(t.lng,i),e(t.lat,i)]}function Le(t,i,e,n){for(var o=[],s=0,r=t.length;s<r;s++)o.push(i?Le(t[s],i-1,e,n):be(t[s],n));return!i&&e&&o.push(o[0]),o}function Te(t,i){return t.feature?l({},t.feature,{geometry:i}):ze(i)}function ze(t){return"Feature"===t.type||"FeatureCollection"===t.type?t:{type:"Feature",properties:{},geometry:t}}Tt={toGeoJSON:function(t){return Te(this,{type:"Point",coordinates:be(this.getLatLng(),t)})}};function Me(t,i){return new ve(t,i)}de.include(Tt),me.include(Tt),pe.include(Tt),fe.include({toGeoJSON:function(t){var i=!ne(this._latlngs);return Te(this,{type:(i?"Multi":"")+"LineString",coordinates:Le(this._latlngs,i?1:0,!1,t)})}}),ge.include({toGeoJSON:function(t){var i=!ne(this._latlngs),e=i&&!ne(this._latlngs[0]),t=Le(this._latlngs,e?2:i?1:0,!0,t);return Te(this,{type:(e?"Multi":"")+"Polygon",coordinates:t=i?t:[t]})}}),ae.include({toMultiPoint:function(i){var e=[];return this.eachLayer(function(t){e.push(t.toGeoJSON(i).geometry.coordinates)}),Te(this,{type:"MultiPoint",coordinates:e})},toGeoJSON:function(i){var t=this.feature&&this.feature.geometry&&this.feature.geometry.type;if("MultiPoint"===t)return this.toMultiPoint(i);var e="GeometryCollection"===t,n=[];return this.eachLayer(function(t){t.toGeoJSON&&(t=t.toGeoJSON(i),e?n.push(t.geometry):"FeatureCollection"===(t=ze(t)).type?n.push.apply(n,t.features):n.push(t))}),e?Te(this,{geometries:n,type:"GeometryCollection"}):{type:"FeatureCollection",features:n}}});var zt=Me,Ce=o.extend({options:{opacity:1,alt:"",interactive:!1,crossOrigin:!1,errorOverlayUrl:"",zIndex:1,className:""},initialize:function(t,i,e){this._url=t,this._bounds=g(i),c(this,e)},onAdd:function(){this._image||(this._initImage(),this.options.opacity<1&&this._updateOpacity()),this.options.interactive&&(z(this._image,"leaflet-interactive"),this.addInteractiveTarget(this._image)),this.getPane().appendChild(this._image),this._reset()},onRemove:function(){T(this._image),this.options.interactive&&this.removeInteractiveTarget(this._image)},setOpacity:function(t){return this.options.opacity=t,this._image&&this._updateOpacity(),this},setStyle:function(t){return t.opacity&&this.setOpacity(t.opacity),this},bringToFront:function(){return this._map&&fi(this._image),this},bringToBack:function(){return this._map&&gi(this._image),this},setUrl:function(t){return this._url=t,this._image&&(this._image.src=t),this},setBounds:function(t){return this._bounds=g(t),this._map&&this._reset(),this},getEvents:function(){var t={zoom:this._reset,viewreset:this._reset};return this._zoomAnimated&&(t.zoomanim=this._animateZoom),t},setZIndex:function(t){return this.options.zIndex=t,this._updateZIndex(),this},getBounds:function(){return this._bounds},getElement:function(){return this._image},_initImage:function(){var t="IMG"===this._url.tagName,i=this._image=t?this._url:b("img");z(i,"leaflet-image-layer"),this._zoomAnimated&&z(i,"leaflet-zoom-animated"),this.options.className&&z(i,this.options.className),i.onselectstart=u,i.onmousemove=u,i.onload=a(this.fire,this,"load"),i.onerror=a(this._overlayOnError,this,"error"),!this.options.crossOrigin&&""!==this.options.crossOrigin||(i.crossOrigin=!0===this.options.crossOrigin?"":this.options.crossOrigin),this.options.zIndex&&this._updateZIndex(),t?this._url=i.src:(i.src=this._url,i.alt=this.options.alt)},_animateZoom:function(t){var i=this._map.getZoomScale(t.zoom),t=this._map._latLngBoundsToNewLayerBounds(this._bounds,t.zoom,t.center).min;Pi(this._image,t,i)},_reset:function(){var t=this._image,i=new m(this._map.latLngToLayerPoint(this._bounds.getNorthWest()),this._map.latLngToLayerPoint(this._bounds.getSouthEast())),e=i.getSize();Z(t,i.min),t.style.width=e.x+"px",t.style.height=e.y+"px"},_updateOpacity:function(){C(this._image,this.options.opacity)},_updateZIndex:function(){this._image&&void 0!==this.options.zIndex&&null!==this.options.zIndex&&(this._image.style.zIndex=this.options.zIndex)},_overlayOnError:function(){this.fire("error");var t=this.options.errorOverlayUrl;t&&this._url!==t&&(this._url=t,this._image.src=t)},getCenter:function(){return this._bounds.getCenter()}}),Ze=Ce.extend({options:{autoplay:!0,loop:!0,keepAspectRatio:!0,muted:!1,playsInline:!0},_initImage:function(){var t="VIDEO"===this._url.tagName,i=this._image=t?this._url:b("video");if(z(i,"leaflet-image-layer"),this._zoomAnimated&&z(i,"leaflet-zoom-animated"),this.options.className&&z(i,this.options.className),i.onselectstart=u,i.onmousemove=u,i.onloadeddata=a(this.fire,this,"load"),t){for(var e=i.getElementsByTagName("source"),n=[],o=0;o<e.length;o++)n.push(e[o].src);this._url=0<e.length?n:[i.src]}else{d(this._url)||(this._url=[this._url]),!this.options.keepAspectRatio&&Object.prototype.hasOwnProperty.call(i.style,"objectFit")&&(i.style.objectFit="fill"),i.autoplay=!!this.options.autoplay,i.loop=!!this.options.loop,i.muted=!!this.options.muted,i.playsInline=!!this.options.playsInline;for(var s=0;s<this._url.length;s++){var r=b("source");r.src=this._url[s],i.appendChild(r)}}}});var Se=Ce.extend({_initImage:function(){var t=this._image=this._url;z(t,"leaflet-image-layer"),this._zoomAnimated&&z(t,"leaflet-zoom-animated"),this.options.className&&z(t,this.options.className),t.onselectstart=u,t.onmousemove=u}});var O=o.extend({options:{interactive:!1,offset:[0,0],className:"",pane:void 0},initialize:function(t,i){c(this,t),this._source=i},openOn:function(t){return(t=arguments.length?t:this._source._map).hasLayer(this)||t.addLayer(this),this},close:function(){return this._map&&this._map.removeLayer(this),this},toggle:function(t){return this._map?this.close():(arguments.length?this._source=t:t=this._source,this._prepareOpen(),this.openOn(t._map)),this},onAdd:function(t){this._zoomAnimated=t._zoomAnimated,this._container||this._initLayout(),t._fadeAnimated&&C(this._container,0),clearTimeout(this._removeTimeout),this.getPane().appendChild(this._container),this.update(),t._fadeAnimated&&C(this._container,1),this.bringToFront(),this.options.interactive&&(z(this._container,"leaflet-interactive"),this.addInteractiveTarget(this._container))},onRemove:function(t){t._fadeAnimated?(C(this._container,0),this._removeTimeout=setTimeout(a(T,void 0,this._container),200)):T(this._container),this.options.interactive&&(M(this._container,"leaflet-interactive"),this.removeInteractiveTarget(this._container))},getLatLng:function(){return this._latlng},setLatLng:function(t){return this._latlng=w(t),this._map&&(this._updatePosition(),this._adjustPan()),this},getContent:function(){return this._content},setContent:function(t){return this._content=t,this.update(),this},getElement:function(){return this._container},update:function(){this._map&&(this._container.style.visibility="hidden",this._updateContent(),this._updateLayout(),this._updatePosition(),this._container.style.visibility="",this._adjustPan())},getEvents:function(){var t={zoom:this._updatePosition,viewreset:this._updatePosition};return this._zoomAnimated&&(t.zoomanim=this._animateZoom),t},isOpen:function(){return!!this._map&&this._map.hasLayer(this)},bringToFront:function(){return this._map&&fi(this._container),this},bringToBack:function(){return this._map&&gi(this._container),this},_prepareOpen:function(t){if(!(e=this._source)._map)return!1;if(e instanceof he){var i,e=null,n=this._source._layers;for(i in n)if(n[i]._map){e=n[i];break}if(!e)return!1;this._source=e}if(!t)if(e.getCenter)t=e.getCenter();else if(e.getLatLng)t=e.getLatLng();else{if(!e.getBounds)throw new Error("Unable to get source layer LatLng.");t=e.getBounds().getCenter()}return this.setLatLng(t),this._map&&this.update(),!0},_updateContent:function(){if(this._content){var t=this._contentNode,i="function"==typeof this._content?this._content(this._source||this):this._content;if("string"==typeof i)t.innerHTML=i;else{for(;t.hasChildNodes();)t.removeChild(t.firstChild);t.appendChild(i)}this.fire("contentupdate")}},_updatePosition:function(){var t,i,e;this._map&&(i=this._map.latLngToLayerPoint(this._latlng),t=_(this.options.offset),e=this._getAnchor(),this._zoomAnimated?Z(this._container,i.add(e)):t=t.add(i).add(e),i=this._containerBottom=-t.y,e=this._containerLeft=-Math.round(this._containerWidth/2)+t.x,this._container.style.bottom=i+"px",this._container.style.left=e+"px")},_getAnchor:function(){return[0,0]}}),ke=(A.include({_initOverlay:function(t,i,e,n){var o=i;return o instanceof t||(o=new t(n).setContent(i)),e&&o.setLatLng(e),o}}),o.include({_initOverlay:function(t,i,e,n){var o=e;return o instanceof t?(c(o,n),o._source=this):(o=i&&!n?i:new t(n,this)).setContent(e),o}}),O.extend({options:{pane:"popupPane",offset:[0,7],maxWidth:300,minWidth:50,maxHeight:null,autoPan:!0,autoPanPaddingTopLeft:null,autoPanPaddingBottomRight:null,autoPanPadding:[5,5],keepInView:!1,closeButton:!0,autoClose:!0,closeOnEscapeKey:!0,className:""},openOn:function(t){return!(t=arguments.length?t:this._source._map).hasLayer(this)&&t._popup&&t._popup.options.autoClose&&t.removeLayer(t._popup),t._popup=this,O.prototype.openOn.call(this,t)},onAdd:function(t){O.prototype.onAdd.call(this,t),t.fire("popupopen",{popup:this}),this._source&&(this._source.fire("popupopen",{popup:this},!0),this._source instanceof _e||this._source.on("preclick",Ai))},onRemove:function(t){O.prototype.onRemove.call(this,t),t.fire("popupclose",{popup:this}),this._source&&(this._source.fire("popupclose",{popup:this},!0),this._source instanceof _e||this._source.off("preclick",Ai))},getEvents:function(){var t=O.prototype.getEvents.call(this);return(void 0!==this.options.closeOnClick?this.options.closeOnClick:this._map.options.closePopupOnClick)&&(t.preclick=this.close),this.options.keepInView&&(t.moveend=this._adjustPan),t},_initLayout:function(){var t="leaflet-popup",i=this._container=b("div",t+" "+(this.options.className||"")+" leaflet-zoom-animated"),e=this._wrapper=b("div",t+"-content-wrapper",i);this._contentNode=b("div",t+"-content",e),Oi(i),Ii(this._contentNode),S(i,"contextmenu",Ai),this._tipContainer=b("div",t+"-tip-container",i),this._tip=b("div",t+"-tip",this._tipContainer),this.options.closeButton&&((e=this._closeButton=b("a",t+"-close-button",i)).setAttribute("role","button"),e.setAttribute("aria-label","Close popup"),e.href="#close",e.innerHTML='<span aria-hidden="true">&#215;</span>',S(e,"click",this.close,this))},_updateLayout:function(){var t=this._contentNode,i=t.style,e=(i.width="",i.whiteSpace="nowrap",t.offsetWidth),e=Math.min(e,this.options.maxWidth),e=(e=Math.max(e,this.options.minWidth),i.width=e+1+"px",i.whiteSpace="",i.height="",t.offsetHeight),n=this.options.maxHeight,o="leaflet-popup-scrolled";n&&n<e?(i.height=n+"px",z(t,o)):M(t,o),this._containerWidth=this._container.offsetWidth},_animateZoom:function(t){var t=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center),i=this._getAnchor();Z(this._container,t.add(i))},_adjustPan:function(t){var i,e,n,o,s,r,a,h;this.options.autoPan&&(this._map._panAnim&&this._map._panAnim.stop(),i=this._map,e=parseInt(pi(this._container,"marginBottom"),10)||0,e=this._container.offsetHeight+e,h=this._containerWidth,(n=new p(this._containerLeft,-e-this._containerBottom))._add(bi(this._container)),n=i.layerPointToContainerPoint(n),s=_(this.options.autoPanPadding),o=_(this.options.autoPanPaddingTopLeft||s),s=_(this.options.autoPanPaddingBottomRight||s),r=i.getSize(),a=0,n.x+h+s.x>r.x&&(a=n.x+h-r.x+s.x),n.x-a-o.x<(h=0)&&(a=n.x-o.x),n.y+e+s.y>r.y&&(h=n.y+e-r.y+s.y),n.y-h-o.y<0&&(h=n.y-o.y),(a||h)&&i.fire("autopanstart").panBy([a,h],{animate:t&&"moveend"===t.type}))},_getAnchor:function(){return _(this._source&&this._source._getPopupAnchor?this._source._getPopupAnchor():[0,0])}})),Ee=(A.mergeOptions({closePopupOnClick:!0}),A.include({openPopup:function(t,i,e){return this._initOverlay(ke,t,i,e).openOn(this),this},closePopup:function(t){return(t=arguments.length?t:this._popup)&&t.close(),this}}),o.include({bindPopup:function(t,i){return this._popup=this._initOverlay(ke,this._popup,t,i),this._popupHandlersAdded||(this.on({click:this._openPopup,keypress:this._onKeyPress,remove:this.closePopup,move:this._movePopup}),this._popupHandlersAdded=!0),this},unbindPopup:function(){return this._popup&&(this.off({click:this._openPopup,keypress:this._onKeyPress,remove:this.closePopup,move:this._movePopup}),this._popupHandlersAdded=!1,this._popup=null),this},openPopup:function(t){return this._popup&&this._popup._prepareOpen(t)&&this._popup.openOn(this._map),this},closePopup:function(){return this._popup&&this._popup.close(),this},togglePopup:function(){return this._popup&&this._popup.toggle(this),this},isPopupOpen:function(){return!!this._popup&&this._popup.isOpen()},setPopupContent:function(t){return this._popup&&this._popup.setContent(t),this},getPopup:function(){return this._popup},_openPopup:function(t){var i;this._popup&&this._map&&(Ri(t),i=t.layer||t.target,this._popup._source!==i||i instanceof _e?(this._popup._source=i,this.openPopup(t.latlng)):this._map.hasLayer(this._popup)?this.closePopup():this.openPopup(t.latlng))},_movePopup:function(t){this._popup.setLatLng(t.latlng)},_onKeyPress:function(t){13===t.originalEvent.keyCode&&this._openPopup(t)}}),O.extend({options:{pane:"tooltipPane",offset:[0,0],direction:"auto",permanent:!1,sticky:!1,opacity:.9},onAdd:function(t){O.prototype.onAdd.call(this,t),this.setOpacity(this.options.opacity),t.fire("tooltipopen",{tooltip:this}),this._source&&(this.addEventParent(this._source),this._source.fire("tooltipopen",{tooltip:this},!0))},onRemove:function(t){O.prototype.onRemove.call(this,t),t.fire("tooltipclose",{tooltip:this}),this._source&&(this.removeEventParent(this._source),this._source.fire("tooltipclose",{tooltip:this},!0))},getEvents:function(){var t=O.prototype.getEvents.call(this);return this.options.permanent||(t.preclick=this.close),t},_initLayout:function(){var t="leaflet-tooltip "+(this.options.className||"")+" leaflet-zoom-"+(this._zoomAnimated?"animated":"hide");this._contentNode=this._container=b("div",t)},_updateLayout:function(){},_adjustPan:function(){},_setPosition:function(t){var i,e=this._map,n=this._container,o=e.latLngToContainerPoint(e.getCenter()),e=e.layerPointToContainerPoint(t),s=this.options.direction,r=n.offsetWidth,a=n.offsetHeight,h=_(this.options.offset),l=this._getAnchor(),e="top"===s?(i=r/2,a):"bottom"===s?(i=r/2,0):(i="center"===s?r/2:"right"===s?0:"left"===s?r:e.x<o.x?(s="right",0):(s="left",r+2*(h.x+l.x)),a/2);t=t.subtract(_(i,e,!0)).add(h).add(l),M(n,"leaflet-tooltip-right"),M(n,"leaflet-tooltip-left"),M(n,"leaflet-tooltip-top"),M(n,"leaflet-tooltip-bottom"),z(n,"leaflet-tooltip-"+s),Z(n,t)},_updatePosition:function(){var t=this._map.latLngToLayerPoint(this._latlng);this._setPosition(t)},setOpacity:function(t){this.options.opacity=t,this._container&&C(this._container,t)},_animateZoom:function(t){t=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center);this._setPosition(t)},_getAnchor:function(){return _(this._source&&this._source._getTooltipAnchor&&!this.options.sticky?this._source._getTooltipAnchor():[0,0])}})),Be=(A.include({openTooltip:function(t,i,e){return this._initOverlay(Ee,t,i,e).openOn(this),this},closeTooltip:function(t){return t.close(),this}}),o.include({bindTooltip:function(t,i){return this._tooltip&&this.isTooltipOpen()&&this.unbindTooltip(),this._tooltip=this._initOverlay(Ee,this._tooltip,t,i),this._initTooltipInteractions(),this._tooltip.options.permanent&&this._map&&this._map.hasLayer(this)&&this.openTooltip(),this},unbindTooltip:function(){return this._tooltip&&(this._initTooltipInteractions(!0),this.closeTooltip(),this._tooltip=null),this},_initTooltipInteractions:function(t){var i,e;!t&&this._tooltipHandlersAdded||(i=t?"off":"on",e={remove:this.closeTooltip,move:this._moveTooltip},this._tooltip.options.permanent?e.add=this._openTooltip:(e.mouseover=this._openTooltip,e.mouseout=this.closeTooltip,e.click=this._openTooltip),this._tooltip.options.sticky&&(e.mousemove=this._moveTooltip),this[i](e),this._tooltipHandlersAdded=!t)},openTooltip:function(t){return this._tooltip&&this._tooltip._prepareOpen(t)&&this._tooltip.openOn(this._map),this},closeTooltip:function(){if(this._tooltip)return this._tooltip.close()},toggleTooltip:function(){return this._tooltip&&this._tooltip.toggle(this),this},isTooltipOpen:function(){return this._tooltip.isOpen()},setTooltipContent:function(t){return this._tooltip&&this._tooltip.setContent(t),this},getTooltip:function(){return this._tooltip},_openTooltip:function(t){!this._tooltip||!this._map||this._map.dragging&&this._map.dragging.moving()||(this._tooltip._source=t.layer||t.target,this.openTooltip(this._tooltip.options.sticky?t.latlng:void 0))},_moveTooltip:function(t){var i=t.latlng;this._tooltip.options.sticky&&t.originalEvent&&(t=this._map.mouseEventToContainerPoint(t.originalEvent),t=this._map.containerPointToLayerPoint(t),i=this._map.layerPointToLatLng(t)),this._tooltip.setLatLng(i)}}),le.extend({options:{iconSize:[12,12],html:!1,bgPos:null,className:"leaflet-div-icon"},createIcon:function(t){var t=t&&"DIV"===t.tagName?t:document.createElement("div"),i=this.options;return i.html instanceof Element?(mi(t),t.appendChild(i.html)):t.innerHTML=!1!==i.html?i.html:"",i.bgPos&&(i=_(i.bgPos),t.style.backgroundPosition=-i.x+"px "+-i.y+"px"),this._setIconStyles(t,"icon"),t},createShadow:function(){return null}}));le.Default=ue;var Ae=o.extend({options:{tileSize:256,opacity:1,updateWhenIdle:P.mobile,updateWhenZooming:!0,updateInterval:200,zIndex:1,bounds:null,minZoom:0,maxZoom:void 0,maxNativeZoom:void 0,minNativeZoom:void 0,noWrap:!1,pane:"tilePane",className:"",keepBuffer:2},initialize:function(t){c(this,t)},onAdd:function(){this._initContainer(),this._levels={},this._tiles={},this._resetView()},beforeAdd:function(t){t._addZoomLimit(this)},onRemove:function(t){this._removeAllTiles(),T(this._container),t._removeZoomLimit(this),this._container=null,this._tileZoom=void 0},bringToFront:function(){return this._map&&(fi(this._container),this._setAutoZIndex(Math.max)),this},bringToBack:function(){return this._map&&(gi(this._container),this._setAutoZIndex(Math.min)),this},getContainer:function(){return this._container},setOpacity:function(t){return this.options.opacity=t,this._updateOpacity(),this},setZIndex:function(t){return this.options.zIndex=t,this._updateZIndex(),this},isLoading:function(){return this._loading},redraw:function(){var t;return this._map&&(this._removeAllTiles(),(t=this._clampZoom(this._map.getZoom()))!==this._tileZoom&&(this._tileZoom=t,this._updateLevels()),this._update()),this},getEvents:function(){var t={viewprereset:this._invalidateAll,viewreset:this._resetView,zoom:this._resetView,moveend:this._onMoveEnd};return this.options.updateWhenIdle||(this._onMove||(this._onMove=j(this._onMoveEnd,this.options.updateInterval,this)),t.move=this._onMove),this._zoomAnimated&&(t.zoomanim=this._animateZoom),t},createTile:function(){return document.createElement("div")},getTileSize:function(){var t=this.options.tileSize;return t instanceof p?t:new p(t,t)},_updateZIndex:function(){this._container&&void 0!==this.options.zIndex&&null!==this.options.zIndex&&(this._container.style.zIndex=this.options.zIndex)},_setAutoZIndex:function(t){for(var i,e=this.getPane().children,n=-t(-1/0,1/0),o=0,s=e.length;o<s;o++)i=e[o].style.zIndex,e[o]!==this._container&&i&&(n=t(n,+i));isFinite(n)&&(this.options.zIndex=n+t(-1,1),this._updateZIndex())},_updateOpacity:function(){if(this._map&&!P.ielt9){C(this._container,this.options.opacity);var t,i=+new Date,e=!1,n=!1;for(t in this._tiles){var o,s=this._tiles[t];s.current&&s.loaded&&(o=Math.min(1,(i-s.loaded)/200),C(s.el,o),o<1?e=!0:(s.active?n=!0:this._onOpaqueTile(s),s.active=!0))}n&&!this._noPrune&&this._pruneTiles(),e&&(r(this._fadeFrame),this._fadeFrame=x(this._updateOpacity,this))}},_onOpaqueTile:u,_initContainer:function(){this._container||(this._container=b("div","leaflet-layer "+(this.options.className||"")),this._updateZIndex(),this.options.opacity<1&&this._updateOpacity(),this.getPane().appendChild(this._container))},_updateLevels:function(){var t=this._tileZoom,i=this.options.maxZoom;if(void 0!==t){for(var e in this._levels)e=Number(e),this._levels[e].el.children.length||e===t?(this._levels[e].el.style.zIndex=i-Math.abs(t-e),this._onUpdateLevel(e)):(T(this._levels[e].el),this._removeTilesAtZoom(e),this._onRemoveLevel(e),delete this._levels[e]);var n=this._levels[t],o=this._map;return n||((n=this._levels[t]={}).el=b("div","leaflet-tile-container leaflet-zoom-animated",this._container),n.el.style.zIndex=i,n.origin=o.project(o.unproject(o.getPixelOrigin()),t).round(),n.zoom=t,this._setZoomTransform(n,o.getCenter(),o.getZoom()),u(n.el.offsetWidth),this._onCreateLevel(n)),this._level=n}},_onUpdateLevel:u,_onRemoveLevel:u,_onCreateLevel:u,_pruneTiles:function(){if(this._map){var t,i,e,n=this._map.getZoom();if(n>this.options.maxZoom||n<this.options.minZoom)this._removeAllTiles();else{for(t in this._tiles)(e=this._tiles[t]).retain=e.current;for(t in this._tiles)(e=this._tiles[t]).current&&!e.active&&(i=e.coords,this._retainParent(i.x,i.y,i.z,i.z-5)||this._retainChildren(i.x,i.y,i.z,i.z+2));for(t in this._tiles)this._tiles[t].retain||this._removeTile(t)}}},_removeTilesAtZoom:function(t){for(var i in this._tiles)this._tiles[i].coords.z===t&&this._removeTile(i)},_removeAllTiles:function(){for(var t in this._tiles)this._removeTile(t)},_invalidateAll:function(){for(var t in this._levels)T(this._levels[t].el),this._onRemoveLevel(Number(t)),delete this._levels[t];this._removeAllTiles(),this._tileZoom=void 0},_retainParent:function(t,i,e,n){var t=Math.floor(t/2),i=Math.floor(i/2),e=e-1,o=new p(+t,+i),o=(o.z=e,this._tileCoordsToKey(o)),o=this._tiles[o];return o&&o.active?o.retain=!0:(o&&o.loaded&&(o.retain=!0),n<e&&this._retainParent(t,i,e,n))},_retainChildren:function(t,i,e,n){for(var o=2*t;o<2*t+2;o++)for(var s=2*i;s<2*i+2;s++){var r=new p(o,s),r=(r.z=e+1,this._tileCoordsToKey(r)),r=this._tiles[r];r&&r.active?r.retain=!0:(r&&r.loaded&&(r.retain=!0),e+1<n&&this._retainChildren(o,s,e+1,n))}},_resetView:function(t){t=t&&(t.pinch||t.flyTo);this._setView(this._map.getCenter(),this._map.getZoom(),t,t)},_animateZoom:function(t){this._setView(t.center,t.zoom,!0,t.noUpdate)},_clampZoom:function(t){var i=this.options;return void 0!==i.minNativeZoom&&t<i.minNativeZoom?i.minNativeZoom:void 0!==i.maxNativeZoom&&i.maxNativeZoom<t?i.maxNativeZoom:t},_setView:function(t,i,e,n){var o=Math.round(i),o=void 0!==this.options.maxZoom&&o>this.options.maxZoom||void 0!==this.options.minZoom&&o<this.options.minZoom?void 0:this._clampZoom(o),s=this.options.updateWhenZooming&&o!==this._tileZoom;n&&!s||(this._tileZoom=o,this._abortLoading&&this._abortLoading(),this._updateLevels(),this._resetGrid(),void 0!==o&&this._update(t),e||this._pruneTiles(),this._noPrune=!!e),this._setZoomTransforms(t,i)},_setZoomTransforms:function(t,i){for(var e in this._levels)this._setZoomTransform(this._levels[e],t,i)},_setZoomTransform:function(t,i,e){var n=this._map.getZoomScale(e,t.zoom),i=t.origin.multiplyBy(n).subtract(this._map._getNewPixelOrigin(i,e)).round();P.any3d?Pi(t.el,i,n):Z(t.el,i)},_resetGrid:function(){var t=this._map,i=t.options.crs,e=this._tileSize=this.getTileSize(),n=this._tileZoom,o=this._map.getPixelWorldBounds(this._tileZoom);o&&(this._globalTileRange=this._pxBoundsToTileRange(o)),this._wrapX=i.wrapLng&&!this.options.noWrap&&[Math.floor(t.project([0,i.wrapLng[0]],n).x/e.x),Math.ceil(t.project([0,i.wrapLng[1]],n).x/e.y)],this._wrapY=i.wrapLat&&!this.options.noWrap&&[Math.floor(t.project([i.wrapLat[0],0],n).y/e.x),Math.ceil(t.project([i.wrapLat[1],0],n).y/e.y)]},_onMoveEnd:function(){this._map&&!this._map._animatingZoom&&this._update()},_getTiledPixelBounds:function(t){var i=this._map,e=i._animatingZoom?Math.max(i._animateToZoom,i.getZoom()):i.getZoom(),e=i.getZoomScale(e,this._tileZoom),t=i.project(t,this._tileZoom).floor(),i=i.getSize().divideBy(2*e);return new m(t.subtract(i),t.add(i))},_update:function(t){var i=this._map;if(i){var e=this._clampZoom(i.getZoom());if(void 0===t&&(t=i.getCenter()),void 0!==this._tileZoom){var n,i=this._getTiledPixelBounds(t),o=this._pxBoundsToTileRange(i),s=o.getCenter(),r=[],i=this.options.keepBuffer,a=new m(o.getBottomLeft().subtract([i,-i]),o.getTopRight().add([i,-i]));if(!(isFinite(o.min.x)&&isFinite(o.min.y)&&isFinite(o.max.x)&&isFinite(o.max.y)))throw new Error("Attempted to load an infinite number of tiles");for(n in this._tiles){var h=this._tiles[n].coords;h.z===this._tileZoom&&a.contains(new p(h.x,h.y))||(this._tiles[n].current=!1)}if(1<Math.abs(e-this._tileZoom))this._setView(t,e);else{for(var l=o.min.y;l<=o.max.y;l++)for(var u=o.min.x;u<=o.max.x;u++){var c,d=new p(u,l);d.z=this._tileZoom,this._isValidTile(d)&&((c=this._tiles[this._tileCoordsToKey(d)])?c.current=!0:r.push(d))}if(r.sort(function(t,i){return t.distanceTo(s)-i.distanceTo(s)}),0!==r.length){this._loading||(this._loading=!0,this.fire("loading"));for(var _=document.createDocumentFragment(),u=0;u<r.length;u++)this._addTile(r[u],_);this._level.el.appendChild(_)}}}}},_isValidTile:function(t){var i=this._map.options.crs;if(!i.infinite){var e=this._globalTileRange;if(!i.wrapLng&&(t.x<e.min.x||t.x>e.max.x)||!i.wrapLat&&(t.y<e.min.y||t.y>e.max.y))return!1}if(!this.options.bounds)return!0;i=this._tileCoordsToBounds(t);return g(this.options.bounds).overlaps(i)},_keyToBounds:function(t){return this._tileCoordsToBounds(this._keyToTileCoords(t))},_tileCoordsToNwSe:function(t){var i=this._map,e=this.getTileSize(),n=t.scaleBy(e),e=n.add(e);return[i.unproject(n,t.z),i.unproject(e,t.z)]},_tileCoordsToBounds:function(t){t=this._tileCoordsToNwSe(t),t=new s(t[0],t[1]);return t=this.options.noWrap?t:this._map.wrapLatLngBounds(t)},_tileCoordsToKey:function(t){return t.x+":"+t.y+":"+t.z},_keyToTileCoords:function(t){var t=t.split(":"),i=new p(+t[0],+t[1]);return i.z=+t[2],i},_removeTile:function(t){var i=this._tiles[t];i&&(T(i.el),delete this._tiles[t],this.fire("tileunload",{tile:i.el,coords:this._keyToTileCoords(t)}))},_initTile:function(t){z(t,"leaflet-tile");var i=this.getTileSize();t.style.width=i.x+"px",t.style.height=i.y+"px",t.onselectstart=u,t.onmousemove=u,P.ielt9&&this.options.opacity<1&&C(t,this.options.opacity)},_addTile:function(t,i){var e=this._getTilePos(t),n=this._tileCoordsToKey(t),o=this.createTile(this._wrapCoords(t),a(this._tileReady,this,t));this._initTile(o),this.createTile.length<2&&x(a(this._tileReady,this,t,null,o)),Z(o,e),this._tiles[n]={el:o,coords:t,current:!0},i.appendChild(o),this.fire("tileloadstart",{tile:o,coords:t})},_tileReady:function(t,i,e){i&&this.fire("tileerror",{error:i,tile:e,coords:t});var n=this._tileCoordsToKey(t);(e=this._tiles[n])&&(e.loaded=+new Date,this._map._fadeAnimated?(C(e.el,0),r(this._fadeFrame),this._fadeFrame=x(this._updateOpacity,this)):(e.active=!0,this._pruneTiles()),i||(z(e.el,"leaflet-tile-loaded"),this.fire("tileload",{tile:e.el,coords:t})),this._noTilesToLoad()&&(this._loading=!1,this.fire("load"),P.ielt9||!this._map._fadeAnimated?x(this._pruneTiles,this):setTimeout(a(this._pruneTiles,this),250)))},_getTilePos:function(t){return t.scaleBy(this.getTileSize()).subtract(this._level.origin)},_wrapCoords:function(t){var i=new p(this._wrapX?H(t.x,this._wrapX):t.x,this._wrapY?H(t.y,this._wrapY):t.y);return i.z=t.z,i},_pxBoundsToTileRange:function(t){var i=this.getTileSize();return new m(t.min.unscaleBy(i).floor(),t.max.unscaleBy(i).ceil().subtract([1,1]))},_noTilesToLoad:function(){for(var t in this._tiles)if(!this._tiles[t].loaded)return!1;return!0}});var Ie=Ae.extend({options:{minZoom:0,maxZoom:18,subdomains:"abc",errorTileUrl:"",zoomOffset:0,tms:!1,zoomReverse:!1,detectRetina:!1,crossOrigin:!1,referrerPolicy:!1},initialize:function(t,i){this._url=t,(i=c(this,i)).detectRetina&&P.retina&&0<i.maxZoom&&(i.tileSize=Math.floor(i.tileSize/2),i.zoomReverse?(i.zoomOffset--,i.minZoom++):(i.zoomOffset++,i.maxZoom--),i.minZoom=Math.max(0,i.minZoom)),"string"==typeof i.subdomains&&(i.subdomains=i.subdomains.split("")),this.on("tileunload",this._onTileRemove)},setUrl:function(t,i){return this._url===t&&void 0===i&&(i=!0),this._url=t,i||this.redraw(),this},createTile:function(t,i){var e=document.createElement("img");return S(e,"load",a(this._tileOnLoad,this,i,e)),S(e,"error",a(this._tileOnError,this,i,e)),!this.options.crossOrigin&&""!==this.options.crossOrigin||(e.crossOrigin=!0===this.options.crossOrigin?"":this.options.crossOrigin),"string"==typeof this.options.referrerPolicy&&(e.referrerPolicy=this.options.referrerPolicy),e.alt="",e.setAttribute("role","presentation"),e.src=this.getTileUrl(t),e},getTileUrl:function(t){var i={r:P.retina?"@2x":"",s:this._getSubdomain(t),x:t.x,y:t.y,z:this._getZoomForUrl()};return this._map&&!this._map.options.crs.infinite&&(t=this._globalTileRange.max.y-t.y,this.options.tms&&(i.y=t),i["-y"]=t),q(this._url,l(i,this.options))},_tileOnLoad:function(t,i){P.ielt9?setTimeout(a(t,this,null,i),0):t(null,i)},_tileOnError:function(t,i,e){var n=this.options.errorTileUrl;n&&i.getAttribute("src")!==n&&(i.src=n),t(e,i)},_onTileRemove:function(t){t.tile.onload=null},_getZoomForUrl:function(){var t=this._tileZoom,i=this.options.maxZoom;return(t=this.options.zoomReverse?i-t:t)+this.options.zoomOffset},_getSubdomain:function(t){t=Math.abs(t.x+t.y)%this.options.subdomains.length;return this.options.subdomains[t]},_abortLoading:function(){var t,i,e;for(t in this._tiles)this._tiles[t].coords.z!==this._tileZoom&&((e=this._tiles[t].el).onload=u,e.onerror=u,e.complete||(e.src=K,i=this._tiles[t].coords,T(e),delete this._tiles[t],this.fire("tileabort",{tile:e,coords:i})))},_removeTile:function(t){var i=this._tiles[t];if(i)return i.el.setAttribute("src",K),Ae.prototype._removeTile.call(this,t)},_tileReady:function(t,i,e){if(this._map&&(!e||e.getAttribute("src")!==K))return Ae.prototype._tileReady.call(this,t,i,e)}});function Oe(t,i){return new Ie(t,i)}var Re=Ie.extend({defaultWmsParams:{service:"WMS",request:"GetMap",layers:"",styles:"",format:"image/jpeg",transparent:!1,version:"1.1.1"},options:{crs:null,uppercase:!1},initialize:function(t,i){this._url=t;var e,n=l({},this.defaultWmsParams);for(e in i)e in this.options||(n[e]=i[e]);var t=(i=c(this,i)).detectRetina&&P.retina?2:1,o=this.getTileSize();n.width=o.x*t,n.height=o.y*t,this.wmsParams=n},onAdd:function(t){this._crs=this.options.crs||t.options.crs,this._wmsVersion=parseFloat(this.wmsParams.version);var i=1.3<=this._wmsVersion?"crs":"srs";this.wmsParams[i]=this._crs.code,Ie.prototype.onAdd.call(this,t)},getTileUrl:function(t){var i=this._tileCoordsToNwSe(t),e=this._crs,e=f(e.project(i[0]),e.project(i[1])),i=e.min,e=e.max,i=(1.3<=this._wmsVersion&&this._crs===re?[i.y,i.x,e.y,e.x]:[i.x,i.y,e.x,e.y]).join(","),e=Ie.prototype.getTileUrl.call(this,t);return e+U(this.wmsParams,e,this.options.uppercase)+(this.options.uppercase?"&BBOX=":"&bbox=")+i},setParams:function(t,i){return l(this.wmsParams,t),i||this.redraw(),this}});Ie.WMS=Re,Oe.wms=function(t,i){return new Re(t,i)};var Ne=o.extend({options:{padding:.1},initialize:function(t){c(this,t),h(this),this._layers=this._layers||{}},onAdd:function(){this._container||(this._initContainer(),this._zoomAnimated&&z(this._container,"leaflet-zoom-animated")),this.getPane().appendChild(this._container),this._update(),this.on("update",this._updatePaths,this)},onRemove:function(){this.off("update",this._updatePaths,this),this._destroyContainer()},getEvents:function(){var t={viewreset:this._reset,zoom:this._onZoom,moveend:this._update,zoomend:this._onZoomEnd};return this._zoomAnimated&&(t.zoomanim=this._onAnimZoom),t},_onAnimZoom:function(t){this._updateTransform(t.center,t.zoom)},_onZoom:function(){this._updateTransform(this._map.getCenter(),this._map.getZoom())},_updateTransform:function(t,i){var e=this._map.getZoomScale(i,this._zoom),n=this._map.getSize().multiplyBy(.5+this.options.padding),o=this._map.project(this._center,i),n=n.multiplyBy(-e).add(o).subtract(this._map._getNewPixelOrigin(t,i));P.any3d?Pi(this._container,n,e):Z(this._container,n)},_reset:function(){for(var t in this._update(),this._updateTransform(this._center,this._zoom),this._layers)this._layers[t]._reset()},_onZoomEnd:function(){for(var t in this._layers)this._layers[t]._project()},_updatePaths:function(){for(var t in this._layers)this._layers[t]._update()},_update:function(){var t=this.options.padding,i=this._map.getSize(),e=this._map.containerPointToLayerPoint(i.multiplyBy(-t)).round();this._bounds=new m(e,e.add(i.multiplyBy(1+2*t)).round()),this._center=this._map.getCenter(),this._zoom=this._map.getZoom()}}),De=Ne.extend({options:{tolerance:0},getEvents:function(){var t=Ne.prototype.getEvents.call(this);return t.viewprereset=this._onViewPreReset,t},_onViewPreReset:function(){this._postponeUpdatePaths=!0},onAdd:function(){Ne.prototype.onAdd.call(this),this._draw()},_initContainer:function(){var t=this._container=document.createElement("canvas");S(t,"mousemove",this._onMouseMove,this),S(t,"click dblclick mousedown mouseup contextmenu",this._onClick,this),S(t,"mouseout",this._handleMouseOut,this),t._leaflet_disable_events=!0,this._ctx=t.getContext("2d")},_destroyContainer:function(){r(this._redrawRequest),delete this._ctx,T(this._container),E(this._container),delete this._container},_updatePaths:function(){if(!this._postponeUpdatePaths){for(var t in this._redrawBounds=null,this._layers)this._layers[t]._update();this._redraw()}},_update:function(){var t,i,e,n;this._map._animatingZoom&&this._bounds||(Ne.prototype._update.call(this),t=this._bounds,i=this._container,e=t.getSize(),n=P.retina?2:1,Z(i,t.min),i.width=n*e.x,i.height=n*e.y,i.style.width=e.x+"px",i.style.height=e.y+"px",P.retina&&this._ctx.scale(2,2),this._ctx.translate(-t.min.x,-t.min.y),this.fire("update"))},_reset:function(){Ne.prototype._reset.call(this),this._postponeUpdatePaths&&(this._postponeUpdatePaths=!1,this._updatePaths())},_initPath:function(t){this._updateDashArray(t);t=(this._layers[h(t)]=t)._order={layer:t,prev:this._drawLast,next:null};this._drawLast&&(this._drawLast.next=t),this._drawLast=t,this._drawFirst=this._drawFirst||this._drawLast},_addPath:function(t){this._requestRedraw(t)},_removePath:function(t){var i=t._order,e=i.next,i=i.prev;e?e.prev=i:this._drawLast=i,i?i.next=e:this._drawFirst=e,delete t._order,delete this._layers[h(t)],this._requestRedraw(t)},_updatePath:function(t){this._extendRedrawBounds(t),t._project(),t._update(),this._requestRedraw(t)},_updateStyle:function(t){this._updateDashArray(t),this._requestRedraw(t)},_updateDashArray:function(t){if("string"==typeof t.options.dashArray){for(var i,e=t.options.dashArray.split(/[, ]+/),n=[],o=0;o<e.length;o++){if(i=Number(e[o]),isNaN(i))return;n.push(i)}t.options._dashArray=n}else t.options._dashArray=t.options.dashArray},_requestRedraw:function(t){this._map&&(this._extendRedrawBounds(t),this._redrawRequest=this._redrawRequest||x(this._redraw,this))},_extendRedrawBounds:function(t){var i;t._pxBounds&&(i=(t.options.weight||0)+1,this._redrawBounds=this._redrawBounds||new m,this._redrawBounds.extend(t._pxBounds.min.subtract([i,i])),this._redrawBounds.extend(t._pxBounds.max.add([i,i])))},_redraw:function(){this._redrawRequest=null,this._redrawBounds&&(this._redrawBounds.min._floor(),this._redrawBounds.max._ceil()),this._clear(),this._draw(),this._redrawBounds=null},_clear:function(){var t,i=this._redrawBounds;i?(t=i.getSize(),this._ctx.clearRect(i.min.x,i.min.y,t.x,t.y)):(this._ctx.save(),this._ctx.setTransform(1,0,0,1,0,0),this._ctx.clearRect(0,0,this._container.width,this._container.height),this._ctx.restore())},_draw:function(){var t,i,e=this._redrawBounds;this._ctx.save(),e&&(i=e.getSize(),this._ctx.beginPath(),this._ctx.rect(e.min.x,e.min.y,i.x,i.y),this._ctx.clip()),this._drawing=!0;for(var n=this._drawFirst;n;n=n.next)t=n.layer,(!e||t._pxBounds&&t._pxBounds.intersects(e))&&t._updatePath();this._drawing=!1,this._ctx.restore()},_updatePoly:function(t,i){if(this._drawing){var e,n,o,s,r=t._parts,a=r.length,h=this._ctx;if(a){for(h.beginPath(),e=0;e<a;e++){for(n=0,o=r[e].length;n<o;n++)s=r[e][n],h[n?"lineTo":"moveTo"](s.x,s.y);i&&h.closePath()}this._fillStroke(h,t)}}},_updateCircle:function(t){var i,e,n,o;this._drawing&&!t._empty()&&(i=t._point,e=this._ctx,n=Math.max(Math.round(t._radius),1),1!=(o=(Math.max(Math.round(t._radiusY),1)||n)/n)&&(e.save(),e.scale(1,o)),e.beginPath(),e.arc(i.x,i.y/o,n,0,2*Math.PI,!1),1!=o&&e.restore(),this._fillStroke(e,t))},_fillStroke:function(t,i){var e=i.options;e.fill&&(t.globalAlpha=e.fillOpacity,t.fillStyle=e.fillColor||e.color,t.fill(e.fillRule||"evenodd")),e.stroke&&0!==e.weight&&(t.setLineDash&&t.setLineDash(i.options&&i.options._dashArray||[]),t.globalAlpha=e.opacity,t.lineWidth=e.weight,t.strokeStyle=e.color,t.lineCap=e.lineCap,t.lineJoin=e.lineJoin,t.stroke())},_onClick:function(t){for(var i,e,n=this._map.mouseEventToLayerPoint(t),o=this._drawFirst;o;o=o.next)(i=o.layer).options.interactive&&i._containsPoint(n)&&(("click"===t.type||"preclick"===t.type)&&this._map._draggableMoved(i)||(e=i));this._fireEvent(!!e&&[e],t)},_onMouseMove:function(t){var i;!this._map||this._map.dragging.moving()||this._map._animatingZoom||(i=this._map.mouseEventToLayerPoint(t),this._handleMouseHover(t,i))},_handleMouseOut:function(t){var i=this._hoveredLayer;i&&(M(this._container,"leaflet-interactive"),this._fireEvent([i],t,"mouseout"),this._hoveredLayer=null,this._mouseHoverThrottled=!1)},_handleMouseHover:function(t,i){if(!this._mouseHoverThrottled){for(var e,n,o=this._drawFirst;o;o=o.next)(e=o.layer).options.interactive&&e._containsPoint(i)&&(n=e);n!==this._hoveredLayer&&(this._handleMouseOut(t),n&&(z(this._container,"leaflet-interactive"),this._fireEvent([n],t,"mouseover"),this._hoveredLayer=n)),this._fireEvent(!!this._hoveredLayer&&[this._hoveredLayer],t),this._mouseHoverThrottled=!0,setTimeout(a(function(){this._mouseHoverThrottled=!1},this),32)}},_fireEvent:function(t,i,e){this._map._fireDOMEvent(i,e||i.type,t)},_bringToFront:function(t){var i,e,n=t._order;n&&(i=n.next,e=n.prev,i&&((i.prev=e)?e.next=i:i&&(this._drawFirst=i),n.prev=this._drawLast,(this._drawLast.next=n).next=null,this._drawLast=n,this._requestRedraw(t)))},_bringToBack:function(t){var i,e,n=t._order;n&&(i=n.next,(e=n.prev)&&((e.next=i)?i.prev=e:e&&(this._drawLast=e),n.prev=null,n.next=this._drawFirst,this._drawFirst.prev=n,this._drawFirst=n,this._requestRedraw(t)))}});function je(t){return P.canvas?new De(t):null}var He=function(){try{return document.namespaces.add("lvml","urn:schemas-microsoft-com:vml"),function(t){return document.createElement("<lvml:"+t+' class="lvml">')}}catch(t){}return function(t){return document.createElement("<"+t+' xmlns="urn:schemas-microsoft.com:vml" class="lvml">')}}(),Mt={_initContainer:function(){this._container=b("div","leaflet-vml-container")},_update:function(){this._map._animatingZoom||(Ne.prototype._update.call(this),this.fire("update"))},_initPath:function(t){var i=t._container=He("shape");z(i,"leaflet-vml-shape "+(this.options.className||"")),i.coordsize="1 1",t._path=He("path"),i.appendChild(t._path),this._updateStyle(t),this._layers[h(t)]=t},_addPath:function(t){var i=t._container;this._container.appendChild(i),t.options.interactive&&t.addInteractiveTarget(i)},_removePath:function(t){var i=t._container;T(i),t.removeInteractiveTarget(i),delete this._layers[h(t)]},_updateStyle:function(t){var i=t._stroke,e=t._fill,n=t.options,o=t._container;o.stroked=!!n.stroke,o.filled=!!n.fill,n.stroke?(i=i||(t._stroke=He("stroke")),o.appendChild(i),i.weight=n.weight+"px",i.color=n.color,i.opacity=n.opacity,n.dashArray?i.dashStyle=d(n.dashArray)?n.dashArray.join(" "):n.dashArray.replace(/( *, *)/g," "):i.dashStyle="",i.endcap=n.lineCap.replace("butt","flat"),i.joinstyle=n.lineJoin):i&&(o.removeChild(i),t._stroke=null),n.fill?(e=e||(t._fill=He("fill")),o.appendChild(e),e.color=n.fillColor||n.color,e.opacity=n.fillOpacity):e&&(o.removeChild(e),t._fill=null)},_updateCircle:function(t){var i=t._point.round(),e=Math.round(t._radius),n=Math.round(t._radiusY||e);this._setPath(t,t._empty()?"M0 0":"AL "+i.x+","+i.y+" "+e+","+n+" 0,23592600")},_setPath:function(t,i){t._path.v=i},_bringToFront:function(t){fi(t._container)},_bringToBack:function(t){gi(t._container)}},We=P.vml?He:ct,Fe=Ne.extend({_initContainer:function(){this._container=We("svg"),this._container.setAttribute("pointer-events","none"),this._rootGroup=We("g"),this._container.appendChild(this._rootGroup)},_destroyContainer:function(){T(this._container),E(this._container),delete this._container,delete this._rootGroup,delete this._svgSize},_update:function(){var t,i,e;this._map._animatingZoom&&this._bounds||(Ne.prototype._update.call(this),i=(t=this._bounds).getSize(),e=this._container,this._svgSize&&this._svgSize.equals(i)||(this._svgSize=i,e.setAttribute("width",i.x),e.setAttribute("height",i.y)),Z(e,t.min),e.setAttribute("viewBox",[t.min.x,t.min.y,i.x,i.y].join(" ")),this.fire("update"))},_initPath:function(t){var i=t._path=We("path");t.options.className&&z(i,t.options.className),t.options.interactive&&z(i,"leaflet-interactive"),this._updateStyle(t),this._layers[h(t)]=t},_addPath:function(t){this._rootGroup||this._initContainer(),this._rootGroup.appendChild(t._path),t.addInteractiveTarget(t._path)},_removePath:function(t){T(t._path),t.removeInteractiveTarget(t._path),delete this._layers[h(t)]},_updatePath:function(t){t._project(),t._update()},_updateStyle:function(t){var i=t._path,t=t.options;i&&(t.stroke?(i.setAttribute("stroke",t.color),i.setAttribute("stroke-opacity",t.opacity),i.setAttribute("stroke-width",t.weight),i.setAttribute("stroke-linecap",t.lineCap),i.setAttribute("stroke-linejoin",t.lineJoin),t.dashArray?i.setAttribute("stroke-dasharray",t.dashArray):i.removeAttribute("stroke-dasharray"),t.dashOffset?i.setAttribute("stroke-dashoffset",t.dashOffset):i.removeAttribute("stroke-dashoffset")):i.setAttribute("stroke","none"),t.fill?(i.setAttribute("fill",t.fillColor||t.color),i.setAttribute("fill-opacity",t.fillOpacity),i.setAttribute("fill-rule",t.fillRule||"evenodd")):i.setAttribute("fill","none"))},_updatePoly:function(t,i){this._setPath(t,dt(t._parts,i))},_updateCircle:function(t){var i=t._point,e=Math.max(Math.round(t._radius),1),n="a"+e+","+(Math.max(Math.round(t._radiusY),1)||e)+" 0 1,0 ",i=t._empty()?"M0 0":"M"+(i.x-e)+","+i.y+n+2*e+",0 "+n+2*-e+",0 ";this._setPath(t,i)},_setPath:function(t,i){t._path.setAttribute("d",i)},_bringToFront:function(t){fi(t._path)},_bringToBack:function(t){gi(t._path)}});function Ue(t){return P.svg||P.vml?new Fe(t):null}P.vml&&Fe.include(Mt),A.include({getRenderer:function(t){t=(t=t.options.renderer||this._getPaneRenderer(t.options.pane)||this.options.renderer||this._renderer)||(this._renderer=this._createRenderer());return this.hasLayer(t)||this.addLayer(t),t},_getPaneRenderer:function(t){if("overlayPane"===t||void 0===t)return!1;var i=this._paneRenderers[t];return void 0===i&&(i=this._createRenderer({pane:t}),this._paneRenderers[t]=i),i},_createRenderer:function(t){return this.options.preferCanvas&&je(t)||Ue(t)}});var Ve=ge.extend({initialize:function(t,i){ge.prototype.initialize.call(this,this._boundsToLatLngs(t),i)},setBounds:function(t){return this.setLatLngs(this._boundsToLatLngs(t))},_boundsToLatLngs:function(t){return[(t=g(t)).getSouthWest(),t.getNorthWest(),t.getNorthEast(),t.getSouthEast()]}});Fe.create=We,Fe.pointsToPath=dt,ve.geometryToLayer=ye,ve.coordsToLatLng=we,ve.coordsToLatLngs=Pe,ve.latLngToCoords=be,ve.latLngsToCoords=Le,ve.getFeature=Te,ve.asFeature=ze,A.mergeOptions({boxZoom:!0});var _t=n.extend({initialize:function(t){this._map=t,this._container=t._container,this._pane=t._panes.overlayPane,this._resetStateTimeout=0,t.on("unload",this._destroy,this)},addHooks:function(){S(this._container,"mousedown",this._onMouseDown,this)},removeHooks:function(){E(this._container,"mousedown",this._onMouseDown,this)},moved:function(){return this._moved},_destroy:function(){T(this._pane),delete this._pane},_resetState:function(){this._resetStateTimeout=0,this._moved=!1},_clearDeferredResetState:function(){0!==this._resetStateTimeout&&(clearTimeout(this._resetStateTimeout),this._resetStateTimeout=0)},_onMouseDown:function(t){if(!t.shiftKey||1!==t.which&&1!==t.button)return!1;this._clearDeferredResetState(),this._resetState(),ri(),Li(),this._startPoint=this._map.mouseEventToContainerPoint(t),S(document,{contextmenu:Ri,mousemove:this._onMouseMove,mouseup:this._onMouseUp,keydown:this._onKeyDown},this)},_onMouseMove:function(t){this._moved||(this._moved=!0,this._box=b("div","leaflet-zoom-box",this._container),z(this._container,"leaflet-crosshair"),this._map.fire("boxzoomstart")),this._point=this._map.mouseEventToContainerPoint(t);var t=new m(this._point,this._startPoint),i=t.getSize();Z(this._box,t.min),this._box.style.width=i.x+"px",this._box.style.height=i.y+"px"},_finish:function(){this._moved&&(T(this._box),M(this._container,"leaflet-crosshair")),ai(),Ti(),E(document,{contextmenu:Ri,mousemove:this._onMouseMove,mouseup:this._onMouseUp,keydown:this._onKeyDown},this)},_onMouseUp:function(t){1!==t.which&&1!==t.button||(this._finish(),this._moved&&(this._clearDeferredResetState(),this._resetStateTimeout=setTimeout(a(this._resetState,this),0),t=new s(this._map.containerPointToLatLng(this._startPoint),this._map.containerPointToLatLng(this._point)),this._map.fitBounds(t).fire("boxzoomend",{boxZoomBounds:t})))},_onKeyDown:function(t){27===t.keyCode&&(this._finish(),this._clearDeferredResetState(),this._resetState())}}),Ct=(A.addInitHook("addHandler","boxZoom",_t),A.mergeOptions({doubleClickZoom:!0}),n.extend({addHooks:function(){this._map.on("dblclick",this._onDoubleClick,this)},removeHooks:function(){this._map.off("dblclick",this._onDoubleClick,this)},_onDoubleClick:function(t){var i=this._map,e=i.getZoom(),n=i.options.zoomDelta,e=t.originalEvent.shiftKey?e-n:e+n;"center"===i.options.doubleClickZoom?i.setZoom(e):i.setZoomAround(t.containerPoint,e)}})),Zt=(A.addInitHook("addHandler","doubleClickZoom",Ct),A.mergeOptions({dragging:!0,inertia:!0,inertiaDeceleration:3400,inertiaMaxSpeed:1/0,easeLinearity:.2,worldCopyJump:!1,maxBoundsViscosity:0}),n.extend({addHooks:function(){var t;this._draggable||(t=this._map,this._draggable=new Xi(t._mapPane,t._container),this._draggable.on({dragstart:this._onDragStart,drag:this._onDrag,dragend:this._onDragEnd},this),this._draggable.on("predrag",this._onPreDragLimit,this),t.options.worldCopyJump&&(this._draggable.on("predrag",this._onPreDragWrap,this),t.on("zoomend",this._onZoomEnd,this),t.whenReady(this._onZoomEnd,this))),z(this._map._container,"leaflet-grab leaflet-touch-drag"),this._draggable.enable(),this._positions=[],this._times=[]},removeHooks:function(){M(this._map._container,"leaflet-grab"),M(this._map._container,"leaflet-touch-drag"),this._draggable.disable()},moved:function(){return this._draggable&&this._draggable._moved},moving:function(){return this._draggable&&this._draggable._moving},_onDragStart:function(){var t,i=this._map;i._stop(),this._map.options.maxBounds&&this._map.options.maxBoundsViscosity?(t=g(this._map.options.maxBounds),this._offsetLimit=f(this._map.latLngToContainerPoint(t.getNorthWest()).multiplyBy(-1),this._map.latLngToContainerPoint(t.getSouthEast()).multiplyBy(-1).add(this._map.getSize())),this._viscosity=Math.min(1,Math.max(0,this._map.options.maxBoundsViscosity))):this._offsetLimit=null,i.fire("movestart").fire("dragstart"),i.options.inertia&&(this._positions=[],this._times=[])},_onDrag:function(t){var i,e;this._map.options.inertia&&(i=this._lastTime=+new Date,e=this._lastPos=this._draggable._absPos||this._draggable._newPos,this._positions.push(e),this._times.push(i),this._prunePositions(i)),this._map.fire("move",t).fire("drag",t)},_prunePositions:function(t){for(;1<this._positions.length&&50<t-this._times[0];)this._positions.shift(),this._times.shift()},_onZoomEnd:function(){var t=this._map.getSize().divideBy(2),i=this._map.latLngToLayerPoint([0,0]);this._initialWorldOffset=i.subtract(t).x,this._worldWidth=this._map.getPixelWorldBounds().getSize().x},_viscousLimit:function(t,i){return t-(t-i)*this._viscosity},_onPreDragLimit:function(){var t,i;this._viscosity&&this._offsetLimit&&(t=this._draggable._newPos.subtract(this._draggable._startPos),i=this._offsetLimit,t.x<i.min.x&&(t.x=this._viscousLimit(t.x,i.min.x)),t.y<i.min.y&&(t.y=this._viscousLimit(t.y,i.min.y)),t.x>i.max.x&&(t.x=this._viscousLimit(t.x,i.max.x)),t.y>i.max.y&&(t.y=this._viscousLimit(t.y,i.max.y)),this._draggable._newPos=this._draggable._startPos.add(t))},_onPreDragWrap:function(){var t=this._worldWidth,i=Math.round(t/2),e=this._initialWorldOffset,n=this._draggable._newPos.x,o=(n-i+e)%t+i-e,n=(n+i+e)%t-i-e,t=Math.abs(o+e)<Math.abs(n+e)?o:n;this._draggable._absPos=this._draggable._newPos.clone(),this._draggable._newPos.x=t},_onDragEnd:function(t){var i,e,n,o,s=this._map,r=s.options,a=!r.inertia||t.noInertia||this._times.length<2;s.fire("dragend",t),a?s.fire("moveend"):(this._prunePositions(+new Date),t=this._lastPos.subtract(this._positions[0]),a=(this._lastTime-this._times[0])/1e3,i=r.easeLinearity,a=(t=t.multiplyBy(i/a)).distanceTo([0,0]),e=Math.min(r.inertiaMaxSpeed,a),t=t.multiplyBy(e/a),n=e/(r.inertiaDeceleration*i),(o=t.multiplyBy(-n/2).round()).x||o.y?(o=s._limitOffset(o,s.options.maxBounds),x(function(){s.panBy(o,{duration:n,easeLinearity:i,noMoveStart:!0,animate:!0})})):s.fire("moveend"))}})),St=(A.addInitHook("addHandler","dragging",Zt),A.mergeOptions({keyboard:!0,keyboardPanDelta:80}),n.extend({keyCodes:{left:[37],right:[39],down:[40],up:[38],zoomIn:[187,107,61,171],zoomOut:[189,109,54,173]},initialize:function(t){this._map=t,this._setPanDelta(t.options.keyboardPanDelta),this._setZoomDelta(t.options.zoomDelta)},addHooks:function(){var t=this._map._container;t.tabIndex<=0&&(t.tabIndex="0"),S(t,{focus:this._onFocus,blur:this._onBlur,mousedown:this._onMouseDown},this),this._map.on({focus:this._addHooks,blur:this._removeHooks},this)},removeHooks:function(){this._removeHooks(),E(this._map._container,{focus:this._onFocus,blur:this._onBlur,mousedown:this._onMouseDown},this),this._map.off({focus:this._addHooks,blur:this._removeHooks},this)},_onMouseDown:function(){var t,i,e;this._focused||(e=document.body,t=document.documentElement,i=e.scrollTop||t.scrollTop,e=e.scrollLeft||t.scrollLeft,this._map._container.focus(),window.scrollTo(e,i))},_onFocus:function(){this._focused=!0,this._map.fire("focus")},_onBlur:function(){this._focused=!1,this._map.fire("blur")},_setPanDelta:function(t){for(var i=this._panKeys={},e=this.keyCodes,n=0,o=e.left.length;n<o;n++)i[e.left[n]]=[-1*t,0];for(n=0,o=e.right.length;n<o;n++)i[e.right[n]]=[t,0];for(n=0,o=e.down.length;n<o;n++)i[e.down[n]]=[0,t];for(n=0,o=e.up.length;n<o;n++)i[e.up[n]]=[0,-1*t]},_setZoomDelta:function(t){for(var i=this._zoomKeys={},e=this.keyCodes,n=0,o=e.zoomIn.length;n<o;n++)i[e.zoomIn[n]]=t;for(n=0,o=e.zoomOut.length;n<o;n++)i[e.zoomOut[n]]=-t},_addHooks:function(){S(document,"keydown",this._onKeyDown,this)},_removeHooks:function(){E(document,"keydown",this._onKeyDown,this)},_onKeyDown:function(t){if(!(t.altKey||t.ctrlKey||t.metaKey)){var i,e=t.keyCode,n=this._map;if(e in this._panKeys)n._panAnim&&n._panAnim._inProgress||(i=this._panKeys[e],t.shiftKey&&(i=_(i).multiplyBy(3)),n.panBy(i),n.options.maxBounds&&n.panInsideBounds(n.options.maxBounds));else if(e in this._zoomKeys)n.setZoom(n.getZoom()+(t.shiftKey?3:1)*this._zoomKeys[e]);else{if(27!==e||!n._popup||!n._popup.options.closeOnEscapeKey)return;n.closePopup()}Ri(t)}}})),kt=(A.addInitHook("addHandler","keyboard",St),A.mergeOptions({scrollWheelZoom:!0,wheelDebounceTime:40,wheelPxPerZoomLevel:60}),n.extend({addHooks:function(){S(this._map._container,"wheel",this._onWheelScroll,this),this._delta=0},removeHooks:function(){E(this._map._container,"wheel",this._onWheelScroll,this)},_onWheelScroll:function(t){var i=ji(t),e=this._map.options.wheelDebounceTime,i=(this._delta+=i,this._lastMousePos=this._map.mouseEventToContainerPoint(t),this._startTime||(this._startTime=+new Date),Math.max(e-(+new Date-this._startTime),0));clearTimeout(this._timer),this._timer=setTimeout(a(this._performZoom,this),i),Ri(t)},_performZoom:function(){var t=this._map,i=t.getZoom(),e=this._map.options.zoomSnap||0,n=(t._stop(),this._delta/(4*this._map.options.wheelPxPerZoomLevel)),n=4*Math.log(2/(1+Math.exp(-Math.abs(n))))/Math.LN2,e=e?Math.ceil(n/e)*e:n,n=t._limitZoom(i+(0<this._delta?e:-e))-i;this._delta=0,this._startTime=null,n&&("center"===t.options.scrollWheelZoom?t.setZoom(i+n):t.setZoomAround(this._lastMousePos,i+n))}})),Et=(A.addInitHook("addHandler","scrollWheelZoom",kt),A.mergeOptions({tapHold:P.touchNative&&P.safari&&P.mobile,tapTolerance:15}),n.extend({addHooks:function(){S(this._map._container,"touchstart",this._onDown,this)},removeHooks:function(){E(this._map._container,"touchstart",this._onDown,this)},_onDown:function(t){var i;clearTimeout(this._holdTimeout),1===t.touches.length&&(i=t.touches[0],this._startPos=this._newPos=new p(i.clientX,i.clientY),this._holdTimeout=setTimeout(a(function(){this._cancel(),this._isTapValid()&&(S(document,"touchend",B),S(document,"touchend touchcancel",this._cancelClickPrevent),this._simulateEvent("contextmenu",i))},this),600),S(document,"touchend touchcancel contextmenu",this._cancel,this),S(document,"touchmove",this._onMove,this))},_cancelClickPrevent:function t(){E(document,"touchend",B),E(document,"touchend touchcancel",t)},_cancel:function(){clearTimeout(this._holdTimeout),E(document,"touchend touchcancel contextmenu",this._cancel,this),E(document,"touchmove",this._onMove,this)},_onMove:function(t){t=t.touches[0];this._newPos=new p(t.clientX,t.clientY)},_isTapValid:function(){return this._newPos.distanceTo(this._startPos)<=this._map.options.tapTolerance},_simulateEvent:function(t,i){t=new MouseEvent(t,{bubbles:!0,cancelable:!0,view:window,screenX:i.screenX,screenY:i.screenY,clientX:i.clientX,clientY:i.clientY});t._simulated=!0,i.target.dispatchEvent(t)}})),Bt=(A.addInitHook("addHandler","tapHold",Et),A.mergeOptions({touchZoom:P.touch,bounceAtZoomLimits:!0}),n.extend({addHooks:function(){z(this._map._container,"leaflet-touch-zoom"),S(this._map._container,"touchstart",this._onTouchStart,this)},removeHooks:function(){M(this._map._container,"leaflet-touch-zoom"),E(this._map._container,"touchstart",this._onTouchStart,this)},_onTouchStart:function(t){var i,e,n=this._map;!t.touches||2!==t.touches.length||n._animatingZoom||this._zooming||(i=n.mouseEventToContainerPoint(t.touches[0]),e=n.mouseEventToContainerPoint(t.touches[1]),this._centerPoint=n.getSize()._divideBy(2),this._startLatLng=n.containerPointToLatLng(this._centerPoint),"center"!==n.options.touchZoom&&(this._pinchStartLatLng=n.containerPointToLatLng(i.add(e)._divideBy(2))),this._startDist=i.distanceTo(e),this._startZoom=n.getZoom(),this._moved=!1,this._zooming=!0,n._stop(),S(document,"touchmove",this._onTouchMove,this),S(document,"touchend touchcancel",this._onTouchEnd,this),B(t))},_onTouchMove:function(t){if(t.touches&&2===t.touches.length&&this._zooming){var i=this._map,e=i.mouseEventToContainerPoint(t.touches[0]),n=i.mouseEventToContainerPoint(t.touches[1]),o=e.distanceTo(n)/this._startDist;if(this._zoom=i.getScaleZoom(o,this._startZoom),!i.options.bounceAtZoomLimits&&(this._zoom<i.getMinZoom()&&o<1||this._zoom>i.getMaxZoom()&&1<o)&&(this._zoom=i._limitZoom(this._zoom)),"center"===i.options.touchZoom){if(this._center=this._startLatLng,1==o)return}else{e=e._add(n)._divideBy(2)._subtract(this._centerPoint);if(1==o&&0===e.x&&0===e.y)return;this._center=i.unproject(i.project(this._pinchStartLatLng,this._zoom).subtract(e),this._zoom)}this._moved||(i._moveStart(!0,!1),this._moved=!0),r(this._animRequest);n=a(i._move,i,this._center,this._zoom,{pinch:!0,round:!1});this._animRequest=x(n,this,!0),B(t)}},_onTouchEnd:function(){this._moved&&this._zooming?(this._zooming=!1,r(this._animRequest),E(document,"touchmove",this._onTouchMove,this),E(document,"touchend touchcancel",this._onTouchEnd,this),this._map.options.zoomAnimation?this._map._animateZoom(this._center,this._map._limitZoom(this._zoom),!0,this._map.options.zoomSnap):this._map._resetView(this._center,this._map._limitZoom(this._zoom))):this._zooming=!1}})),qe=(A.addInitHook("addHandler","touchZoom",Bt),A.BoxZoom=_t,A.DoubleClickZoom=Ct,A.Drag=Zt,A.Keyboard=St,A.ScrollWheelZoom=kt,A.TapHold=Et,A.TouchZoom=Bt,t.Bounds=m,t.Browser=P,t.CRS=ot,t.Canvas=De,t.Circle=me,t.CircleMarker=pe,t.Class=it,t.Control=I,t.DivIcon=Be,t.DivOverlay=O,t.DomEvent=mt,t.DomUtil=pt,t.Draggable=Xi,t.Evented=et,t.FeatureGroup=he,t.GeoJSON=ve,t.GridLayer=Ae,t.Handler=n,t.Icon=le,t.ImageOverlay=Ce,t.LatLng=v,t.LatLngBounds=s,t.Layer=o,t.LayerGroup=ae,t.LineUtil=gt,t.Map=A,t.Marker=de,t.Mixin=ft,t.Path=_e,t.Point=p,t.PolyUtil=vt,t.Polygon=ge,t.Polyline=fe,t.Popup=ke,t.PosAnimation=Wi,t.Projection=wt,t.Rectangle=Ve,t.Renderer=Ne,t.SVG=Fe,t.SVGOverlay=Se,t.TileLayer=Ie,t.Tooltip=Ee,t.Transformation=at,t.Util=tt,t.VideoOverlay=Ze,t.bind=a,t.bounds=f,t.canvas=je,t.circle=function(t,i,e){return new me(t,i,e)},t.circleMarker=function(t,i){return new pe(t,i)},t.control=Fi,t.divIcon=function(t){return new Be(t)},t.extend=l,t.featureGroup=function(t,i){return new he(t,i)},t.geoJSON=Me,t.geoJson=zt,t.gridLayer=function(t){return new Ae(t)},t.icon=function(t){return new le(t)},t.imageOverlay=function(t,i,e){return new Ce(t,i,e)},t.latLng=w,t.latLngBounds=g,t.layerGroup=function(t,i){return new ae(t,i)},t.map=function(t,i){return new A(t,i)},t.marker=function(t,i){return new de(t,i)},t.point=_,t.polygon=function(t,i){return new ge(t,i)},t.polyline=function(t,i){return new fe(t,i)},t.popup=function(t,i){return new ke(t,i)},t.rectangle=function(t,i){return new Ve(t,i)},t.setOptions=c,t.stamp=h,t.svg=Ue,t.svgOverlay=function(t,i,e){return new Se(t,i,e)},t.tileLayer=Oe,t.tooltip=function(t,i){return new Ee(t,i)},t.transformation=ht,t.version="1.8.0",t.videoOverlay=function(t,i,e){return new Ze(t,i,e)},window.L);t.noConflict=function(){return window.L=qe,this},window.L=t});
	//# sourceMappingURL=leaflet.js.map

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 562:
/***/ (function(module, exports) {

	'use strict';
	
	
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};


/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils   = __webpack_require__(28);
	var trees   = __webpack_require__(567);
	var adler32 = __webpack_require__(85);
	var crc32   = __webpack_require__(86);
	var msg     = __webpack_require__(87);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	
	  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
	  //s->pending_buf = (uchf *) overlay;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
	  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
	  s.d_buf = 1 * s.lit_bufsize;
	
	  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	                );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	
	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	  wrap = s.wrap;
	
	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }
	
	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */
	
	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	      s.prev[str & s.w_mask] = s.head[s.ins_h];
	
	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}
	
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/


/***/ }),

/***/ 564:
/***/ (function(module, exports) {

	'use strict';
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};


/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils         = __webpack_require__(28);
	var adler32       = __webpack_require__(85);
	var crc32         = __webpack_require__(86);
	var inflate_fast  = __webpack_require__(564);
	var inflate_table = __webpack_require__(566);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	    case HEAD:
	      if (state.wrap === 0) {
	        state.mode = TYPEDO;
	        break;
	      }
	      //=== NEEDBITS(16);
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = FLAGS;
	        break;
	      }
	      state.flags = 0;           /* expect zlib header */
	      if (state.head) {
	        state.head.done = false;
	      }
	      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	        strm.msg = 'incorrect header check';
	        state.mode = BAD;
	        break;
	      }
	      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	      len = (hold & 0x0f)/*BITS(4)*/ + 8;
	      if (state.wbits === 0) {
	        state.wbits = len;
	      }
	      else if (len > state.wbits) {
	        strm.msg = 'invalid window size';
	        state.mode = BAD;
	        break;
	      }
	      state.dmax = 1 << len;
	      //Tracev((stderr, "inflate:   zlib header ok\n"));
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = hold & 0x200 ? DICTID : TYPE;
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      break;
	    case FLAGS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.flags = hold;
	      if ((state.flags & 0xff) !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      if (state.flags & 0xe000) {
	        strm.msg = 'unknown header flags set';
	        state.mode = BAD;
	        break;
	      }
	      if (state.head) {
	        state.head.text = ((hold >> 8) & 1);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = TIME;
	      /* falls through */
	    case TIME:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.time = hold;
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC4(state.check, hold)
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        hbuf[2] = (hold >>> 16) & 0xff;
	        hbuf[3] = (hold >>> 24) & 0xff;
	        state.check = crc32(state.check, hbuf, 4, 0);
	        //===
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = OS;
	      /* falls through */
	    case OS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.xflags = (hold & 0xff);
	        state.head.os = (hold >> 8);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = EXLEN;
	      /* falls through */
	    case EXLEN:
	      if (state.flags & 0x0400) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length = hold;
	        if (state.head) {
	          state.head.extra_len = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      else if (state.head) {
	        state.head.extra = null/*Z_NULL*/;
	      }
	      state.mode = EXTRA;
	      /* falls through */
	    case EXTRA:
	      if (state.flags & 0x0400) {
	        copy = state.length;
	        if (copy > have) { copy = have; }
	        if (copy) {
	          if (state.head) {
	            len = state.head.extra_len - state.length;
	            if (!state.head.extra) {
	              // Use untyped array for more conveniend processing later
	              state.head.extra = new Array(state.head.extra_len);
	            }
	            utils.arraySet(
	              state.head.extra,
	              input,
	              next,
	              // extra field is limited to 65536 bytes
	              // - no need for additional size check
	              copy,
	              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	              len
	            );
	            //zmemcpy(state.head.extra + len, next,
	            //        len + copy > state.head.extra_max ?
	            //        state.head.extra_max - len : copy);
	          }
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          state.length -= copy;
	        }
	        if (state.length) { break inf_leave; }
	      }
	      state.length = 0;
	      state.mode = NAME;
	      /* falls through */
	    case NAME:
	      if (state.flags & 0x0800) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          // TODO: 2 or 1 bytes?
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.name_max*/)) {
	            state.head.name += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.name = null;
	      }
	      state.length = 0;
	      state.mode = COMMENT;
	      /* falls through */
	    case COMMENT:
	      if (state.flags & 0x1000) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.comm_max*/)) {
	            state.head.comment += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.comment = null;
	      }
	      state.mode = HCRC;
	      /* falls through */
	    case HCRC:
	      if (state.flags & 0x0200) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.check & 0xffff)) {
	          strm.msg = 'header crc mismatch';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      if (state.head) {
	        state.head.hcrc = ((state.flags >> 9) & 1);
	        state.head.done = true;
	      }
	      strm.adler = state.check = 0;
	      state.mode = TYPE;
	      break;
	    case DICTID:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      strm.adler = state.check = zswap32(hold);
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = DICT;
	      /* falls through */
	    case DICT:
	      if (state.havedict === 0) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        return Z_NEED_DICT;
	      }
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      /* falls through */
	    case TYPE:
	      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case TYPEDO:
	      if (state.last) {
	        //--- BYTEBITS() ---//
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        state.mode = CHECK;
	        break;
	      }
	      //=== NEEDBITS(3); */
	      while (bits < 3) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.last = (hold & 0x01)/*BITS(1)*/;
	      //--- DROPBITS(1) ---//
	      hold >>>= 1;
	      bits -= 1;
	      //---//
	
	      switch ((hold & 0x03)/*BITS(2)*/) {
	      case 0:                             /* stored block */
	        //Tracev((stderr, "inflate:     stored block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = STORED;
	        break;
	      case 1:                             /* fixed block */
	        fixedtables(state);
	        //Tracev((stderr, "inflate:     fixed codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = LEN_;             /* decode codes */
	        if (flush === Z_TREES) {
	          //--- DROPBITS(2) ---//
	          hold >>>= 2;
	          bits -= 2;
	          //---//
	          break inf_leave;
	        }
	        break;
	      case 2:                             /* dynamic block */
	        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = TABLE;
	        break;
	      case 3:
	        strm.msg = 'invalid block type';
	        state.mode = BAD;
	      }
	      //--- DROPBITS(2) ---//
	      hold >>>= 2;
	      bits -= 2;
	      //---//
	      break;
	    case STORED:
	      //--- BYTEBITS() ---// /* go to byte boundary */
	      hold >>>= bits & 7;
	      bits -= bits & 7;
	      //---//
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	        strm.msg = 'invalid stored block lengths';
	        state.mode = BAD;
	        break;
	      }
	      state.length = hold & 0xffff;
	      //Tracev((stderr, "inflate:       stored length %u\n",
	      //        state.length));
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = COPY_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case COPY_:
	      state.mode = COPY;
	      /* falls through */
	    case COPY:
	      copy = state.length;
	      if (copy) {
	        if (copy > have) { copy = have; }
	        if (copy > left) { copy = left; }
	        if (copy === 0) { break inf_leave; }
	        //--- zmemcpy(put, next, copy); ---
	        utils.arraySet(output, input, next, copy, put);
	        //---//
	        have -= copy;
	        next += copy;
	        left -= copy;
	        put += copy;
	        state.length -= copy;
	        break;
	      }
	      //Tracev((stderr, "inflate:       stored end\n"));
	      state.mode = TYPE;
	      break;
	    case TABLE:
	      //=== NEEDBITS(14); */
	      while (bits < 14) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	      if (state.nlen > 286 || state.ndist > 30) {
	        strm.msg = 'too many length or distance symbols';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracev((stderr, "inflate:       table sizes ok\n"));
	      state.have = 0;
	      state.mode = LENLENS;
	      /* falls through */
	    case LENLENS:
	      while (state.have < state.ncode) {
	        //=== NEEDBITS(3);
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	        //--- DROPBITS(3) ---//
	        hold >>>= 3;
	        bits -= 3;
	        //---//
	      }
	      while (state.have < 19) {
	        state.lens[order[state.have++]] = 0;
	      }
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      //state.next = state.codes;
	      //state.lencode = state.next;
	      // Switch to use dynamic table
	      state.lencode = state.lendyn;
	      state.lenbits = 7;
	
	      opts = { bits: state.lenbits };
	      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	      state.lenbits = opts.bits;
	
	      if (ret) {
	        strm.msg = 'invalid code lengths set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, "inflate:       code lengths ok\n"));
	      state.have = 0;
	      state.mode = CODELENS;
	      /* falls through */
	    case CODELENS:
	      while (state.have < state.nlen + state.ndist) {
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_val < 16) {
	          //--- DROPBITS(here.bits) ---//
	          hold >>>= here_bits;
	          bits -= here_bits;
	          //---//
	          state.lens[state.have++] = here_val;
	        }
	        else {
	          if (here_val === 16) {
	            //=== NEEDBITS(here.bits + 2);
	            n = here_bits + 2;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            if (state.have === 0) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            len = state.lens[state.have - 1];
	            copy = 3 + (hold & 0x03);//BITS(2);
	            //--- DROPBITS(2) ---//
	            hold >>>= 2;
	            bits -= 2;
	            //---//
	          }
	          else if (here_val === 17) {
	            //=== NEEDBITS(here.bits + 3);
	            n = here_bits + 3;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 3 + (hold & 0x07);//BITS(3);
	            //--- DROPBITS(3) ---//
	            hold >>>= 3;
	            bits -= 3;
	            //---//
	          }
	          else {
	            //=== NEEDBITS(here.bits + 7);
	            n = here_bits + 7;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 11 + (hold & 0x7f);//BITS(7);
	            //--- DROPBITS(7) ---//
	            hold >>>= 7;
	            bits -= 7;
	            //---//
	          }
	          if (state.have + copy > state.nlen + state.ndist) {
	            strm.msg = 'invalid bit length repeat';
	            state.mode = BAD;
	            break;
	          }
	          while (copy--) {
	            state.lens[state.have++] = len;
	          }
	        }
	      }
	
	      /* handle error breaks in while */
	      if (state.mode === BAD) { break; }
	
	      /* check for end-of-block code (better have one) */
	      if (state.lens[256] === 0) {
	        strm.msg = 'invalid code -- missing end-of-block';
	        state.mode = BAD;
	        break;
	      }
	
	      /* build code tables -- note: do not change the lenbits or distbits
	         values here (9 and 6) without reading the comments in inftrees.h
	         concerning the ENOUGH constants, which depend on those values */
	      state.lenbits = 9;
	
	      opts = { bits: state.lenbits };
	      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.lenbits = opts.bits;
	      // state.lencode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid literal/lengths set';
	        state.mode = BAD;
	        break;
	      }
	
	      state.distbits = 6;
	      //state.distcode.copy(state.codes);
	      // Switch to use dynamic table
	      state.distcode = state.distdyn;
	      opts = { bits: state.distbits };
	      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.distbits = opts.bits;
	      // state.distcode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid distances set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, 'inflate:       codes ok\n'));
	      state.mode = LEN_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case LEN_:
	      state.mode = LEN;
	      /* falls through */
	    case LEN:
	      if (have >= 6 && left >= 258) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        inflate_fast(strm, _out);
	        //--- LOAD() ---
	        put = strm.next_out;
	        output = strm.output;
	        left = strm.avail_out;
	        next = strm.next_in;
	        input = strm.input;
	        have = strm.avail_in;
	        hold = state.hold;
	        bits = state.bits;
	        //---
	
	        if (state.mode === TYPE) {
	          state.back = -1;
	        }
	        break;
	      }
	      state.back = 0;
	      for (;;) {
	        here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if (here_bits <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if (here_op && (here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.lencode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      state.length = here_val;
	      if (here_op === 0) {
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        state.mode = LIT;
	        break;
	      }
	      if (here_op & 32) {
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.back = -1;
	        state.mode = TYPE;
	        break;
	      }
	      if (here_op & 64) {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break;
	      }
	      state.extra = here_op & 15;
	      state.mode = LENEXT;
	      /* falls through */
	    case LENEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	      //Tracevv((stderr, "inflate:         length %u\n", state.length));
	      state.was = state.length;
	      state.mode = DIST;
	      /* falls through */
	    case DIST:
	      for (;;) {
	        here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if ((here_bits) <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if ((here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.distcode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      if (here_op & 64) {
	        strm.msg = 'invalid distance code';
	        state.mode = BAD;
	        break;
	      }
	      state.offset = here_val;
	      state.extra = (here_op) & 15;
	      state.mode = DISTEXT;
	      /* falls through */
	    case DISTEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	//#ifdef INFLATE_STRICT
	      if (state.offset > state.dmax) {
	        strm.msg = 'invalid distance too far back';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	      state.mode = MATCH;
	      /* falls through */
	    case MATCH:
	      if (left === 0) { break inf_leave; }
	      copy = _out - left;
	      if (state.offset > copy) {         /* copy from window */
	        copy = state.offset - copy;
	        if (copy > state.whave) {
	          if (state.sane) {
	            strm.msg = 'invalid distance too far back';
	            state.mode = BAD;
	            break;
	          }
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	        }
	        if (copy > state.wnext) {
	          copy -= state.wnext;
	          from = state.wsize - copy;
	        }
	        else {
	          from = state.wnext - copy;
	        }
	        if (copy > state.length) { copy = state.length; }
	        from_source = state.window;
	      }
	      else {                              /* copy from output */
	        from_source = output;
	        from = put - state.offset;
	        copy = state.length;
	      }
	      if (copy > left) { copy = left; }
	      left -= copy;
	      state.length -= copy;
	      do {
	        output[put++] = from_source[from++];
	      } while (--copy);
	      if (state.length === 0) { state.mode = LEN; }
	      break;
	    case LIT:
	      if (left === 0) { break inf_leave; }
	      output[put++] = state.length;
	      left--;
	      state.mode = LEN;
	      break;
	    case CHECK:
	      if (state.wrap) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          // Use '|' insdead of '+' to make sure that result is signed
	          hold |= input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        _out -= left;
	        strm.total_out += _out;
	        state.total += _out;
	        if (_out) {
	          strm.adler = state.check =
	              /*UPDATE(state.check, put - _out, _out);*/
	              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	        }
	        _out = left;
	        // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	        if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	          strm.msg = 'incorrect data check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   check matches trailer\n"));
	      }
	      state.mode = LENGTH;
	      /* falls through */
	    case LENGTH:
	      if (state.wrap && state.flags) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.total & 0xffffffff)) {
	          strm.msg = 'incorrect length check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   length matches trailer\n"));
	      }
	      state.mode = DONE;
	      /* falls through */
	    case DONE:
	      ret = Z_STREAM_END;
	      break inf_leave;
	    case BAD:
	      ret = Z_DATA_ERROR;
	      break inf_leave;
	    case MEM:
	      return Z_MEM_ERROR;
	    case SYNC:
	      /* falls through */
	    default:
	      return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var state;
	  var dictid;
	  var ret;
	
	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/


/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils = __webpack_require__(28);
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;
	
	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;
	
	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  var i = 0;
	  /* process all codes and make table entries */
	  for (;;) {
	    i++;
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};


/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils = __webpack_require__(28);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */
	
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;


/***/ }),

/***/ 568:
/***/ (function(module, exports) {

	'use strict';
	
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;


/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global, Buffer) {/* Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define("pdfjs-dist/build/pdf.combined", [], factory);
		else if(typeof exports === 'object')
			exports["pdfjs-dist/build/pdf.combined"] = factory();
		else
			root["pdfjs-dist/build/pdf.combined"] = root.pdfjsDistBuildPdfCombined = factory();
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __w_pdfjs_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__w_pdfjs_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__w_pdfjs_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__w_pdfjs_require__.d = function(exports, name, getter) {
	/******/ 		if(!__w_pdfjs_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__w_pdfjs_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__w_pdfjs_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__w_pdfjs_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__w_pdfjs_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __w_pdfjs_require__(__w_pdfjs_require__.s = 91);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unreachable = exports.warn = exports.utf8StringToString = exports.stringToUTF8String = exports.stringToPDFString = exports.stringToBytes = exports.string32 = exports.shadow = exports.setVerbosityLevel = exports.ReadableStream = exports.removeNullCharacters = exports.readUint32 = exports.readUint16 = exports.readInt8 = exports.log2 = exports.loadJpegStream = exports.isEvalSupported = exports.isLittleEndian = exports.createValidAbsoluteUrl = exports.isSameOrigin = exports.isNodeJS = exports.isSpace = exports.isString = exports.isNum = exports.isEmptyObj = exports.isBool = exports.isArrayBuffer = exports.info = exports.getVerbosityLevel = exports.getLookupTableFactory = exports.deprecated = exports.createObjectURL = exports.createPromiseCapability = exports.createBlob = exports.bytesToString = exports.assert = exports.arraysToBytes = exports.arrayByteLength = exports.FormatError = exports.XRefParseException = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.StatTimer = exports.PasswordResponses = exports.PasswordException = exports.PageViewport = exports.NotImplementedException = exports.NativeImageDecoding = exports.MissingPDFException = exports.MissingDataException = exports.MessageHandler = exports.InvalidPDFException = exports.AbortException = exports.CMapCompressionType = exports.ImageKind = exports.FontType = exports.AnnotationType = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.UNSUPPORTED_FEATURES = exports.VERBOSITY_LEVELS = exports.OPS = exports.IDENTITY_MATRIX = exports.FONT_IDENTITY_MATRIX = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	__w_pdfjs_require__(92);
	
	var _streams_polyfill = __w_pdfjs_require__(132);
	
	var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
	var NativeImageDecoding = {
	  NONE: 'none',
	  DECODE: 'decode',
	  DISPLAY: 'display'
	};
	var TextRenderingMode = {
	  FILL: 0,
	  STROKE: 1,
	  FILL_STROKE: 2,
	  INVISIBLE: 3,
	  FILL_ADD_TO_PATH: 4,
	  STROKE_ADD_TO_PATH: 5,
	  FILL_STROKE_ADD_TO_PATH: 6,
	  ADD_TO_PATH: 7,
	  FILL_STROKE_MASK: 3,
	  ADD_TO_PATH_FLAG: 4
	};
	var ImageKind = {
	  GRAYSCALE_1BPP: 1,
	  RGB_24BPP: 2,
	  RGBA_32BPP: 3
	};
	var AnnotationType = {
	  TEXT: 1,
	  LINK: 2,
	  FREETEXT: 3,
	  LINE: 4,
	  SQUARE: 5,
	  CIRCLE: 6,
	  POLYGON: 7,
	  POLYLINE: 8,
	  HIGHLIGHT: 9,
	  UNDERLINE: 10,
	  SQUIGGLY: 11,
	  STRIKEOUT: 12,
	  STAMP: 13,
	  CARET: 14,
	  INK: 15,
	  POPUP: 16,
	  FILEATTACHMENT: 17,
	  SOUND: 18,
	  MOVIE: 19,
	  WIDGET: 20,
	  SCREEN: 21,
	  PRINTERMARK: 22,
	  TRAPNET: 23,
	  WATERMARK: 24,
	  THREED: 25,
	  REDACT: 26
	};
	var AnnotationFlag = {
	  INVISIBLE: 0x01,
	  HIDDEN: 0x02,
	  PRINT: 0x04,
	  NOZOOM: 0x08,
	  NOROTATE: 0x10,
	  NOVIEW: 0x20,
	  READONLY: 0x40,
	  LOCKED: 0x80,
	  TOGGLENOVIEW: 0x100,
	  LOCKEDCONTENTS: 0x200
	};
	var AnnotationFieldFlag = {
	  READONLY: 0x0000001,
	  REQUIRED: 0x0000002,
	  NOEXPORT: 0x0000004,
	  MULTILINE: 0x0001000,
	  PASSWORD: 0x0002000,
	  NOTOGGLETOOFF: 0x0004000,
	  RADIO: 0x0008000,
	  PUSHBUTTON: 0x0010000,
	  COMBO: 0x0020000,
	  EDIT: 0x0040000,
	  SORT: 0x0080000,
	  FILESELECT: 0x0100000,
	  MULTISELECT: 0x0200000,
	  DONOTSPELLCHECK: 0x0400000,
	  DONOTSCROLL: 0x0800000,
	  COMB: 0x1000000,
	  RICHTEXT: 0x2000000,
	  RADIOSINUNISON: 0x2000000,
	  COMMITONSELCHANGE: 0x4000000
	};
	var AnnotationBorderStyleType = {
	  SOLID: 1,
	  DASHED: 2,
	  BEVELED: 3,
	  INSET: 4,
	  UNDERLINE: 5
	};
	var StreamType = {
	  UNKNOWN: 0,
	  FLATE: 1,
	  LZW: 2,
	  DCT: 3,
	  JPX: 4,
	  JBIG: 5,
	  A85: 6,
	  AHX: 7,
	  CCF: 8,
	  RL: 9
	};
	var FontType = {
	  UNKNOWN: 0,
	  TYPE1: 1,
	  TYPE1C: 2,
	  CIDFONTTYPE0: 3,
	  CIDFONTTYPE0C: 4,
	  TRUETYPE: 5,
	  CIDFONTTYPE2: 6,
	  TYPE3: 7,
	  OPENTYPE: 8,
	  TYPE0: 9,
	  MMTYPE1: 10
	};
	var VERBOSITY_LEVELS = {
	  errors: 0,
	  warnings: 1,
	  infos: 5
	};
	var CMapCompressionType = {
	  NONE: 0,
	  BINARY: 1,
	  STREAM: 2
	};
	var OPS = {
	  dependency: 1,
	  setLineWidth: 2,
	  setLineCap: 3,
	  setLineJoin: 4,
	  setMiterLimit: 5,
	  setDash: 6,
	  setRenderingIntent: 7,
	  setFlatness: 8,
	  setGState: 9,
	  save: 10,
	  restore: 11,
	  transform: 12,
	  moveTo: 13,
	  lineTo: 14,
	  curveTo: 15,
	  curveTo2: 16,
	  curveTo3: 17,
	  closePath: 18,
	  rectangle: 19,
	  stroke: 20,
	  closeStroke: 21,
	  fill: 22,
	  eoFill: 23,
	  fillStroke: 24,
	  eoFillStroke: 25,
	  closeFillStroke: 26,
	  closeEOFillStroke: 27,
	  endPath: 28,
	  clip: 29,
	  eoClip: 30,
	  beginText: 31,
	  endText: 32,
	  setCharSpacing: 33,
	  setWordSpacing: 34,
	  setHScale: 35,
	  setLeading: 36,
	  setFont: 37,
	  setTextRenderingMode: 38,
	  setTextRise: 39,
	  moveText: 40,
	  setLeadingMoveText: 41,
	  setTextMatrix: 42,
	  nextLine: 43,
	  showText: 44,
	  showSpacedText: 45,
	  nextLineShowText: 46,
	  nextLineSetSpacingShowText: 47,
	  setCharWidth: 48,
	  setCharWidthAndBounds: 49,
	  setStrokeColorSpace: 50,
	  setFillColorSpace: 51,
	  setStrokeColor: 52,
	  setStrokeColorN: 53,
	  setFillColor: 54,
	  setFillColorN: 55,
	  setStrokeGray: 56,
	  setFillGray: 57,
	  setStrokeRGBColor: 58,
	  setFillRGBColor: 59,
	  setStrokeCMYKColor: 60,
	  setFillCMYKColor: 61,
	  shadingFill: 62,
	  beginInlineImage: 63,
	  beginImageData: 64,
	  endInlineImage: 65,
	  paintXObject: 66,
	  markPoint: 67,
	  markPointProps: 68,
	  beginMarkedContent: 69,
	  beginMarkedContentProps: 70,
	  endMarkedContent: 71,
	  beginCompat: 72,
	  endCompat: 73,
	  paintFormXObjectBegin: 74,
	  paintFormXObjectEnd: 75,
	  beginGroup: 76,
	  endGroup: 77,
	  beginAnnotations: 78,
	  endAnnotations: 79,
	  beginAnnotation: 80,
	  endAnnotation: 81,
	  paintJpegXObject: 82,
	  paintImageMaskXObject: 83,
	  paintImageMaskXObjectGroup: 84,
	  paintImageXObject: 85,
	  paintInlineImageXObject: 86,
	  paintInlineImageXObjectGroup: 87,
	  paintImageXObjectRepeat: 88,
	  paintImageMaskXObjectRepeat: 89,
	  paintSolidColorImageMask: 90,
	  constructPath: 91
	};
	var verbosity = VERBOSITY_LEVELS.warnings;
	function setVerbosityLevel(level) {
	  verbosity = level;
	}
	function getVerbosityLevel() {
	  return verbosity;
	}
	function info(msg) {
	  if (verbosity >= VERBOSITY_LEVELS.infos) {
	    console.log('Info: ' + msg);
	  }
	}
	function warn(msg) {
	  if (verbosity >= VERBOSITY_LEVELS.warnings) {
	    console.log('Warning: ' + msg);
	  }
	}
	function deprecated(details) {
	  console.log('Deprecated API usage: ' + details);
	}
	function unreachable(msg) {
	  throw new Error(msg);
	}
	function assert(cond, msg) {
	  if (!cond) {
	    unreachable(msg);
	  }
	}
	var UNSUPPORTED_FEATURES = {
	  unknown: 'unknown',
	  forms: 'forms',
	  javaScript: 'javaScript',
	  smask: 'smask',
	  shadingPattern: 'shadingPattern',
	  font: 'font'
	};
	function isSameOrigin(baseUrl, otherUrl) {
	  try {
	    var base = new URL(baseUrl);
	    if (!base.origin || base.origin === 'null') {
	      return false;
	    }
	  } catch (e) {
	    return false;
	  }
	  var other = new URL(otherUrl, base);
	  return base.origin === other.origin;
	}
	function isValidProtocol(url) {
	  if (!url) {
	    return false;
	  }
	  switch (url.protocol) {
	    case 'http:':
	    case 'https:':
	    case 'ftp:':
	    case 'mailto:':
	    case 'tel:':
	      return true;
	    default:
	      return false;
	  }
	}
	function createValidAbsoluteUrl(url, baseUrl) {
	  if (!url) {
	    return null;
	  }
	  try {
	    var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
	    if (isValidProtocol(absoluteUrl)) {
	      return absoluteUrl;
	    }
	  } catch (ex) {}
	  return null;
	}
	function shadow(obj, prop, value) {
	  Object.defineProperty(obj, prop, {
	    value: value,
	    enumerable: true,
	    configurable: true,
	    writable: false
	  });
	  return value;
	}
	function getLookupTableFactory(initializer) {
	  var lookup;
	  return function () {
	    if (initializer) {
	      lookup = Object.create(null);
	      initializer(lookup);
	      initializer = null;
	    }
	    return lookup;
	  };
	}
	var PasswordResponses = {
	  NEED_PASSWORD: 1,
	  INCORRECT_PASSWORD: 2
	};
	var PasswordException = function PasswordExceptionClosure() {
	  function PasswordException(msg, code) {
	    this.name = 'PasswordException';
	    this.message = msg;
	    this.code = code;
	  }
	  PasswordException.prototype = new Error();
	  PasswordException.constructor = PasswordException;
	  return PasswordException;
	}();
	var UnknownErrorException = function UnknownErrorExceptionClosure() {
	  function UnknownErrorException(msg, details) {
	    this.name = 'UnknownErrorException';
	    this.message = msg;
	    this.details = details;
	  }
	  UnknownErrorException.prototype = new Error();
	  UnknownErrorException.constructor = UnknownErrorException;
	  return UnknownErrorException;
	}();
	var InvalidPDFException = function InvalidPDFExceptionClosure() {
	  function InvalidPDFException(msg) {
	    this.name = 'InvalidPDFException';
	    this.message = msg;
	  }
	  InvalidPDFException.prototype = new Error();
	  InvalidPDFException.constructor = InvalidPDFException;
	  return InvalidPDFException;
	}();
	var MissingPDFException = function MissingPDFExceptionClosure() {
	  function MissingPDFException(msg) {
	    this.name = 'MissingPDFException';
	    this.message = msg;
	  }
	  MissingPDFException.prototype = new Error();
	  MissingPDFException.constructor = MissingPDFException;
	  return MissingPDFException;
	}();
	var UnexpectedResponseException = function UnexpectedResponseExceptionClosure() {
	  function UnexpectedResponseException(msg, status) {
	    this.name = 'UnexpectedResponseException';
	    this.message = msg;
	    this.status = status;
	  }
	  UnexpectedResponseException.prototype = new Error();
	  UnexpectedResponseException.constructor = UnexpectedResponseException;
	  return UnexpectedResponseException;
	}();
	var NotImplementedException = function NotImplementedExceptionClosure() {
	  function NotImplementedException(msg) {
	    this.message = msg;
	  }
	  NotImplementedException.prototype = new Error();
	  NotImplementedException.prototype.name = 'NotImplementedException';
	  NotImplementedException.constructor = NotImplementedException;
	  return NotImplementedException;
	}();
	var MissingDataException = function MissingDataExceptionClosure() {
	  function MissingDataException(begin, end) {
	    this.begin = begin;
	    this.end = end;
	    this.message = 'Missing data [' + begin + ', ' + end + ')';
	  }
	  MissingDataException.prototype = new Error();
	  MissingDataException.prototype.name = 'MissingDataException';
	  MissingDataException.constructor = MissingDataException;
	  return MissingDataException;
	}();
	var XRefParseException = function XRefParseExceptionClosure() {
	  function XRefParseException(msg) {
	    this.message = msg;
	  }
	  XRefParseException.prototype = new Error();
	  XRefParseException.prototype.name = 'XRefParseException';
	  XRefParseException.constructor = XRefParseException;
	  return XRefParseException;
	}();
	var FormatError = function FormatErrorClosure() {
	  function FormatError(msg) {
	    this.message = msg;
	  }
	  FormatError.prototype = new Error();
	  FormatError.prototype.name = 'FormatError';
	  FormatError.constructor = FormatError;
	  return FormatError;
	}();
	var AbortException = function AbortExceptionClosure() {
	  function AbortException(msg) {
	    this.name = 'AbortException';
	    this.message = msg;
	  }
	  AbortException.prototype = new Error();
	  AbortException.constructor = AbortException;
	  return AbortException;
	}();
	var NullCharactersRegExp = /\x00/g;
	function removeNullCharacters(str) {
	  if (typeof str !== 'string') {
	    warn('The argument for removeNullCharacters must be a string.');
	    return str;
	  }
	  return str.replace(NullCharactersRegExp, '');
	}
	function bytesToString(bytes) {
	  assert(bytes !== null && (typeof bytes === 'undefined' ? 'undefined' : _typeof(bytes)) === 'object' && bytes.length !== undefined, 'Invalid argument for bytesToString');
	  var length = bytes.length;
	  var MAX_ARGUMENT_COUNT = 8192;
	  if (length < MAX_ARGUMENT_COUNT) {
	    return String.fromCharCode.apply(null, bytes);
	  }
	  var strBuf = [];
	  for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
	    var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
	    var chunk = bytes.subarray(i, chunkEnd);
	    strBuf.push(String.fromCharCode.apply(null, chunk));
	  }
	  return strBuf.join('');
	}
	function stringToBytes(str) {
	  assert(typeof str === 'string', 'Invalid argument for stringToBytes');
	  var length = str.length;
	  var bytes = new Uint8Array(length);
	  for (var i = 0; i < length; ++i) {
	    bytes[i] = str.charCodeAt(i) & 0xFF;
	  }
	  return bytes;
	}
	function arrayByteLength(arr) {
	  if (arr.length !== undefined) {
	    return arr.length;
	  }
	  assert(arr.byteLength !== undefined);
	  return arr.byteLength;
	}
	function arraysToBytes(arr) {
	  if (arr.length === 1 && arr[0] instanceof Uint8Array) {
	    return arr[0];
	  }
	  var resultLength = 0;
	  var i,
	      ii = arr.length;
	  var item, itemLength;
	  for (i = 0; i < ii; i++) {
	    item = arr[i];
	    itemLength = arrayByteLength(item);
	    resultLength += itemLength;
	  }
	  var pos = 0;
	  var data = new Uint8Array(resultLength);
	  for (i = 0; i < ii; i++) {
	    item = arr[i];
	    if (!(item instanceof Uint8Array)) {
	      if (typeof item === 'string') {
	        item = stringToBytes(item);
	      } else {
	        item = new Uint8Array(item);
	      }
	    }
	    itemLength = item.byteLength;
	    data.set(item, pos);
	    pos += itemLength;
	  }
	  return data;
	}
	function string32(value) {
	  return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
	}
	function log2(x) {
	  var n = 1,
	      i = 0;
	  while (x > n) {
	    n <<= 1;
	    i++;
	  }
	  return i;
	}
	function readInt8(data, start) {
	  return data[start] << 24 >> 24;
	}
	function readUint16(data, offset) {
	  return data[offset] << 8 | data[offset + 1];
	}
	function readUint32(data, offset) {
	  return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
	}
	function isLittleEndian() {
	  var buffer8 = new Uint8Array(4);
	  buffer8[0] = 1;
	  var view32 = new Uint32Array(buffer8.buffer, 0, 1);
	  return view32[0] === 1;
	}
	function isEvalSupported() {
	  try {
	    new Function('');
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
	var Util = function UtilClosure() {
	  function Util() {}
	  var rgbBuf = ['rgb(', 0, ',', 0, ',', 0, ')'];
	  Util.makeCssRgb = function Util_makeCssRgb(r, g, b) {
	    rgbBuf[1] = r;
	    rgbBuf[3] = g;
	    rgbBuf[5] = b;
	    return rgbBuf.join('');
	  };
	  Util.transform = function Util_transform(m1, m2) {
	    return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
	  };
	  Util.applyTransform = function Util_applyTransform(p, m) {
	    var xt = p[0] * m[0] + p[1] * m[2] + m[4];
	    var yt = p[0] * m[1] + p[1] * m[3] + m[5];
	    return [xt, yt];
	  };
	  Util.applyInverseTransform = function Util_applyInverseTransform(p, m) {
	    var d = m[0] * m[3] - m[1] * m[2];
	    var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
	    var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
	    return [xt, yt];
	  };
	  Util.getAxialAlignedBoundingBox = function Util_getAxialAlignedBoundingBox(r, m) {
	    var p1 = Util.applyTransform(r, m);
	    var p2 = Util.applyTransform(r.slice(2, 4), m);
	    var p3 = Util.applyTransform([r[0], r[3]], m);
	    var p4 = Util.applyTransform([r[2], r[1]], m);
	    return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
	  };
	  Util.inverseTransform = function Util_inverseTransform(m) {
	    var d = m[0] * m[3] - m[1] * m[2];
	    return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
	  };
	  Util.apply3dTransform = function Util_apply3dTransform(m, v) {
	    return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
	  };
	  Util.singularValueDecompose2dScale = function Util_singularValueDecompose2dScale(m) {
	    var transpose = [m[0], m[2], m[1], m[3]];
	    var a = m[0] * transpose[0] + m[1] * transpose[2];
	    var b = m[0] * transpose[1] + m[1] * transpose[3];
	    var c = m[2] * transpose[0] + m[3] * transpose[2];
	    var d = m[2] * transpose[1] + m[3] * transpose[3];
	    var first = (a + d) / 2;
	    var second = Math.sqrt((a + d) * (a + d) - 4 * (a * d - c * b)) / 2;
	    var sx = first + second || 1;
	    var sy = first - second || 1;
	    return [Math.sqrt(sx), Math.sqrt(sy)];
	  };
	  Util.normalizeRect = function Util_normalizeRect(rect) {
	    var r = rect.slice(0);
	    if (rect[0] > rect[2]) {
	      r[0] = rect[2];
	      r[2] = rect[0];
	    }
	    if (rect[1] > rect[3]) {
	      r[1] = rect[3];
	      r[3] = rect[1];
	    }
	    return r;
	  };
	  Util.intersect = function Util_intersect(rect1, rect2) {
	    function compare(a, b) {
	      return a - b;
	    }
	    var orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare),
	        orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare),
	        result = [];
	    rect1 = Util.normalizeRect(rect1);
	    rect2 = Util.normalizeRect(rect2);
	    if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
	      result[0] = orderedX[1];
	      result[2] = orderedX[2];
	    } else {
	      return false;
	    }
	    if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
	      result[1] = orderedY[1];
	      result[3] = orderedY[2];
	    } else {
	      return false;
	    }
	    return result;
	  };
	  var ROMAN_NUMBER_MAP = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM', '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC', '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
	  Util.toRoman = function Util_toRoman(number, lowerCase) {
	    assert(Number.isInteger(number) && number > 0, 'The number should be a positive integer.');
	    var pos,
	        romanBuf = [];
	    while (number >= 1000) {
	      number -= 1000;
	      romanBuf.push('M');
	    }
	    pos = number / 100 | 0;
	    number %= 100;
	    romanBuf.push(ROMAN_NUMBER_MAP[pos]);
	    pos = number / 10 | 0;
	    number %= 10;
	    romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
	    romanBuf.push(ROMAN_NUMBER_MAP[20 + number]);
	    var romanStr = romanBuf.join('');
	    return lowerCase ? romanStr.toLowerCase() : romanStr;
	  };
	  Util.appendToArray = function Util_appendToArray(arr1, arr2) {
	    Array.prototype.push.apply(arr1, arr2);
	  };
	  Util.prependToArray = function Util_prependToArray(arr1, arr2) {
	    Array.prototype.unshift.apply(arr1, arr2);
	  };
	  Util.extendObj = function extendObj(obj1, obj2) {
	    for (var key in obj2) {
	      obj1[key] = obj2[key];
	    }
	  };
	  Util.getInheritableProperty = function Util_getInheritableProperty(dict, name, getArray) {
	    while (dict && !dict.has(name)) {
	      dict = dict.get('Parent');
	    }
	    if (!dict) {
	      return null;
	    }
	    return getArray ? dict.getArray(name) : dict.get(name);
	  };
	  Util.inherit = function Util_inherit(sub, base, prototype) {
	    sub.prototype = Object.create(base.prototype);
	    sub.prototype.constructor = sub;
	    for (var prop in prototype) {
	      sub.prototype[prop] = prototype[prop];
	    }
	  };
	  Util.loadScript = function Util_loadScript(src, callback) {
	    var script = document.createElement('script');
	    var loaded = false;
	    script.setAttribute('src', src);
	    if (callback) {
	      script.onload = function () {
	        if (!loaded) {
	          callback();
	        }
	        loaded = true;
	      };
	    }
	    document.getElementsByTagName('head')[0].appendChild(script);
	  };
	  return Util;
	}();
	var PageViewport = function PageViewportClosure() {
	  function PageViewport(viewBox, scale, rotation, offsetX, offsetY, dontFlip) {
	    this.viewBox = viewBox;
	    this.scale = scale;
	    this.rotation = rotation;
	    this.offsetX = offsetX;
	    this.offsetY = offsetY;
	    var centerX = (viewBox[2] + viewBox[0]) / 2;
	    var centerY = (viewBox[3] + viewBox[1]) / 2;
	    var rotateA, rotateB, rotateC, rotateD;
	    rotation = rotation % 360;
	    rotation = rotation < 0 ? rotation + 360 : rotation;
	    switch (rotation) {
	      case 180:
	        rotateA = -1;
	        rotateB = 0;
	        rotateC = 0;
	        rotateD = 1;
	        break;
	      case 90:
	        rotateA = 0;
	        rotateB = 1;
	        rotateC = 1;
	        rotateD = 0;
	        break;
	      case 270:
	        rotateA = 0;
	        rotateB = -1;
	        rotateC = -1;
	        rotateD = 0;
	        break;
	      default:
	        rotateA = 1;
	        rotateB = 0;
	        rotateC = 0;
	        rotateD = -1;
	        break;
	    }
	    if (dontFlip) {
	      rotateC = -rotateC;
	      rotateD = -rotateD;
	    }
	    var offsetCanvasX, offsetCanvasY;
	    var width, height;
	    if (rotateA === 0) {
	      offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
	      offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
	      width = Math.abs(viewBox[3] - viewBox[1]) * scale;
	      height = Math.abs(viewBox[2] - viewBox[0]) * scale;
	    } else {
	      offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
	      offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
	      width = Math.abs(viewBox[2] - viewBox[0]) * scale;
	      height = Math.abs(viewBox[3] - viewBox[1]) * scale;
	    }
	    this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
	    this.width = width;
	    this.height = height;
	    this.fontScale = scale;
	  }
	  PageViewport.prototype = {
	    clone: function PageViewPort_clone(args) {
	      args = args || {};
	      var scale = 'scale' in args ? args.scale : this.scale;
	      var rotation = 'rotation' in args ? args.rotation : this.rotation;
	      return new PageViewport(this.viewBox.slice(), scale, rotation, this.offsetX, this.offsetY, args.dontFlip);
	    },
	    convertToViewportPoint: function PageViewport_convertToViewportPoint(x, y) {
	      return Util.applyTransform([x, y], this.transform);
	    },
	    convertToViewportRectangle: function PageViewport_convertToViewportRectangle(rect) {
	      var tl = Util.applyTransform([rect[0], rect[1]], this.transform);
	      var br = Util.applyTransform([rect[2], rect[3]], this.transform);
	      return [tl[0], tl[1], br[0], br[1]];
	    },
	    convertToPdfPoint: function PageViewport_convertToPdfPoint(x, y) {
	      return Util.applyInverseTransform([x, y], this.transform);
	    }
	  };
	  return PageViewport;
	}();
	var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2D8, 0x2C7, 0x2C6, 0x2D9, 0x2DD, 0x2DB, 0x2DA, 0x2DC, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203A, 0x2212, 0x2030, 0x201E, 0x201C, 0x201D, 0x2018, 0x2019, 0x201A, 0x2122, 0xFB01, 0xFB02, 0x141, 0x152, 0x160, 0x178, 0x17D, 0x131, 0x142, 0x153, 0x161, 0x17E, 0, 0x20AC];
	function stringToPDFString(str) {
	  var i,
	      n = str.length,
	      strBuf = [];
	  if (str[0] === '\xFE' && str[1] === '\xFF') {
	    for (i = 2; i < n; i += 2) {
	      strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
	    }
	  } else {
	    for (i = 0; i < n; ++i) {
	      var code = PDFStringTranslateTable[str.charCodeAt(i)];
	      strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
	    }
	  }
	  return strBuf.join('');
	}
	function stringToUTF8String(str) {
	  return decodeURIComponent(escape(str));
	}
	function utf8StringToString(str) {
	  return unescape(encodeURIComponent(str));
	}
	function isEmptyObj(obj) {
	  for (var key in obj) {
	    return false;
	  }
	  return true;
	}
	function isBool(v) {
	  return typeof v === 'boolean';
	}
	function isNum(v) {
	  return typeof v === 'number';
	}
	function isString(v) {
	  return typeof v === 'string';
	}
	function isArrayBuffer(v) {
	  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v !== null && v.byteLength !== undefined;
	}
	function isSpace(ch) {
	  return ch === 0x20 || ch === 0x09 || ch === 0x0D || ch === 0x0A;
	}
	function isNodeJS() {
	  return (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && process + '' === '[object process]';
	}
	function createPromiseCapability() {
	  var capability = {};
	  capability.promise = new Promise(function (resolve, reject) {
	    capability.resolve = resolve;
	    capability.reject = reject;
	  });
	  return capability;
	}
	var StatTimer = function StatTimerClosure() {
	  function rpad(str, pad, length) {
	    while (str.length < length) {
	      str += pad;
	    }
	    return str;
	  }
	  function StatTimer() {
	    this.started = Object.create(null);
	    this.times = [];
	    this.enabled = true;
	  }
	  StatTimer.prototype = {
	    time: function StatTimer_time(name) {
	      if (!this.enabled) {
	        return;
	      }
	      if (name in this.started) {
	        warn('Timer is already running for ' + name);
	      }
	      this.started[name] = Date.now();
	    },
	    timeEnd: function StatTimer_timeEnd(name) {
	      if (!this.enabled) {
	        return;
	      }
	      if (!(name in this.started)) {
	        warn('Timer has not been started for ' + name);
	      }
	      this.times.push({
	        'name': name,
	        'start': this.started[name],
	        'end': Date.now()
	      });
	      delete this.started[name];
	    },
	    toString: function StatTimer_toString() {
	      var i, ii;
	      var times = this.times;
	      var out = '';
	      var longest = 0;
	      for (i = 0, ii = times.length; i < ii; ++i) {
	        var name = times[i]['name'];
	        if (name.length > longest) {
	          longest = name.length;
	        }
	      }
	      for (i = 0, ii = times.length; i < ii; ++i) {
	        var span = times[i];
	        var duration = span.end - span.start;
	        out += rpad(span['name'], ' ', longest) + ' ' + duration + 'ms\n';
	      }
	      return out;
	    }
	  };
	  return StatTimer;
	}();
	var createBlob = function createBlob(data, contentType) {
	  if (typeof Blob !== 'undefined') {
	    return new Blob([data], { type: contentType });
	  }
	  throw new Error('The "Blob" constructor is not supported.');
	};
	var createObjectURL = function createObjectURLClosure() {
	  var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	  return function createObjectURL(data, contentType) {
	    var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    if (!forceDataSchema && URL.createObjectURL) {
	      var blob = createBlob(data, contentType);
	      return URL.createObjectURL(blob);
	    }
	    var buffer = 'data:' + contentType + ';base64,';
	    for (var i = 0, ii = data.length; i < ii; i += 3) {
	      var b1 = data[i] & 0xFF;
	      var b2 = data[i + 1] & 0xFF;
	      var b3 = data[i + 2] & 0xFF;
	      var d1 = b1 >> 2,
	          d2 = (b1 & 3) << 4 | b2 >> 4;
	      var d3 = i + 1 < ii ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
	      var d4 = i + 2 < ii ? b3 & 0x3F : 64;
	      buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
	    }
	    return buffer;
	  };
	}();
	function resolveCall(fn, args) {
	  var thisArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  if (!fn) {
	    return Promise.resolve(undefined);
	  }
	  return new Promise(function (resolve, reject) {
	    resolve(fn.apply(thisArg, args));
	  });
	}
	function wrapReason(reason) {
	  if ((typeof reason === 'undefined' ? 'undefined' : _typeof(reason)) !== 'object') {
	    return reason;
	  }
	  switch (reason.name) {
	    case 'AbortException':
	      return new AbortException(reason.message);
	    case 'MissingPDFException':
	      return new MissingPDFException(reason.message);
	    case 'UnexpectedResponseException':
	      return new UnexpectedResponseException(reason.message, reason.status);
	    default:
	      return new UnknownErrorException(reason.message, reason.details);
	  }
	}
	function makeReasonSerializable(reason) {
	  if (!(reason instanceof Error) || reason instanceof AbortException || reason instanceof MissingPDFException || reason instanceof UnexpectedResponseException || reason instanceof UnknownErrorException) {
	    return reason;
	  }
	  return new UnknownErrorException(reason.message, reason.toString());
	}
	function resolveOrReject(capability, success, reason) {
	  if (success) {
	    capability.resolve();
	  } else {
	    capability.reject(reason);
	  }
	}
	function finalize(promise) {
	  return Promise.resolve(promise).catch(function () {});
	}
	function MessageHandler(sourceName, targetName, comObj) {
	  var _this = this;
	
	  this.sourceName = sourceName;
	  this.targetName = targetName;
	  this.comObj = comObj;
	  this.callbackId = 1;
	  this.streamId = 1;
	  this.postMessageTransfers = true;
	  this.streamSinks = Object.create(null);
	  this.streamControllers = Object.create(null);
	  var callbacksCapabilities = this.callbacksCapabilities = Object.create(null);
	  var ah = this.actionHandler = Object.create(null);
	  this._onComObjOnMessage = function (event) {
	    var data = event.data;
	    if (data.targetName !== _this.sourceName) {
	      return;
	    }
	    if (data.stream) {
	      _this._processStreamMessage(data);
	    } else if (data.isReply) {
	      var callbackId = data.callbackId;
	      if (data.callbackId in callbacksCapabilities) {
	        var callback = callbacksCapabilities[callbackId];
	        delete callbacksCapabilities[callbackId];
	        if ('error' in data) {
	          callback.reject(wrapReason(data.error));
	        } else {
	          callback.resolve(data.data);
	        }
	      } else {
	        throw new Error('Cannot resolve callback ' + callbackId);
	      }
	    } else if (data.action in ah) {
	      var action = ah[data.action];
	      if (data.callbackId) {
	        var _sourceName = _this.sourceName;
	        var _targetName = data.sourceName;
	        Promise.resolve().then(function () {
	          return action[0].call(action[1], data.data);
	        }).then(function (result) {
	          comObj.postMessage({
	            sourceName: _sourceName,
	            targetName: _targetName,
	            isReply: true,
	            callbackId: data.callbackId,
	            data: result
	          });
	        }, function (reason) {
	          comObj.postMessage({
	            sourceName: _sourceName,
	            targetName: _targetName,
	            isReply: true,
	            callbackId: data.callbackId,
	            error: makeReasonSerializable(reason)
	          });
	        });
	      } else if (data.streamId) {
	        _this._createStreamSink(data);
	      } else {
	        action[0].call(action[1], data.data);
	      }
	    } else {
	      throw new Error('Unknown action from worker: ' + data.action);
	    }
	  };
	  comObj.addEventListener('message', this._onComObjOnMessage);
	}
	MessageHandler.prototype = {
	  on: function on(actionName, handler, scope) {
	    var ah = this.actionHandler;
	    if (ah[actionName]) {
	      throw new Error('There is already an actionName called "' + actionName + '"');
	    }
	    ah[actionName] = [handler, scope];
	  },
	  send: function send(actionName, data, transfers) {
	    var message = {
	      sourceName: this.sourceName,
	      targetName: this.targetName,
	      action: actionName,
	      data: data
	    };
	    this.postMessage(message, transfers);
	  },
	  sendWithPromise: function sendWithPromise(actionName, data, transfers) {
	    var callbackId = this.callbackId++;
	    var message = {
	      sourceName: this.sourceName,
	      targetName: this.targetName,
	      action: actionName,
	      data: data,
	      callbackId: callbackId
	    };
	    var capability = createPromiseCapability();
	    this.callbacksCapabilities[callbackId] = capability;
	    try {
	      this.postMessage(message, transfers);
	    } catch (e) {
	      capability.reject(e);
	    }
	    return capability.promise;
	  },
	  sendWithStream: function sendWithStream(actionName, data, queueingStrategy, transfers) {
	    var _this2 = this;
	
	    var streamId = this.streamId++;
	    var sourceName = this.sourceName;
	    var targetName = this.targetName;
	    return new _streams_polyfill.ReadableStream({
	      start: function start(controller) {
	        var startCapability = createPromiseCapability();
	        _this2.streamControllers[streamId] = {
	          controller: controller,
	          startCall: startCapability,
	          isClosed: false
	        };
	        _this2.postMessage({
	          sourceName: sourceName,
	          targetName: targetName,
	          action: actionName,
	          streamId: streamId,
	          data: data,
	          desiredSize: controller.desiredSize
	        });
	        return startCapability.promise;
	      },
	      pull: function pull(controller) {
	        var pullCapability = createPromiseCapability();
	        _this2.streamControllers[streamId].pullCall = pullCapability;
	        _this2.postMessage({
	          sourceName: sourceName,
	          targetName: targetName,
	          stream: 'pull',
	          streamId: streamId,
	          desiredSize: controller.desiredSize
	        });
	        return pullCapability.promise;
	      },
	      cancel: function cancel(reason) {
	        var cancelCapability = createPromiseCapability();
	        _this2.streamControllers[streamId].cancelCall = cancelCapability;
	        _this2.streamControllers[streamId].isClosed = true;
	        _this2.postMessage({
	          sourceName: sourceName,
	          targetName: targetName,
	          stream: 'cancel',
	          reason: reason,
	          streamId: streamId
	        });
	        return cancelCapability.promise;
	      }
	    }, queueingStrategy);
	  },
	  _createStreamSink: function _createStreamSink(data) {
	    var _this3 = this;
	
	    var self = this;
	    var action = this.actionHandler[data.action];
	    var streamId = data.streamId;
	    var desiredSize = data.desiredSize;
	    var sourceName = this.sourceName;
	    var targetName = data.sourceName;
	    var capability = createPromiseCapability();
	    var sendStreamRequest = function sendStreamRequest(_ref) {
	      var stream = _ref.stream,
	          chunk = _ref.chunk,
	          transfers = _ref.transfers,
	          success = _ref.success,
	          reason = _ref.reason;
	
	      _this3.postMessage({
	        sourceName: sourceName,
	        targetName: targetName,
	        stream: stream,
	        streamId: streamId,
	        chunk: chunk,
	        success: success,
	        reason: reason
	      }, transfers);
	    };
	    var streamSink = {
	      enqueue: function enqueue(chunk) {
	        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	        var transfers = arguments[2];
	
	        if (this.isCancelled) {
	          return;
	        }
	        var lastDesiredSize = this.desiredSize;
	        this.desiredSize -= size;
	        if (lastDesiredSize > 0 && this.desiredSize <= 0) {
	          this.sinkCapability = createPromiseCapability();
	          this.ready = this.sinkCapability.promise;
	        }
	        sendStreamRequest({
	          stream: 'enqueue',
	          chunk: chunk,
	          transfers: transfers
	        });
	      },
	      close: function close() {
	        if (this.isCancelled) {
	          return;
	        }
	        this.isCancelled = true;
	        sendStreamRequest({ stream: 'close' });
	        delete self.streamSinks[streamId];
	      },
	      error: function error(reason) {
	        if (this.isCancelled) {
	          return;
	        }
	        this.isCancelled = true;
	        sendStreamRequest({
	          stream: 'error',
	          reason: reason
	        });
	      },
	
	      sinkCapability: capability,
	      onPull: null,
	      onCancel: null,
	      isCancelled: false,
	      desiredSize: desiredSize,
	      ready: null
	    };
	    streamSink.sinkCapability.resolve();
	    streamSink.ready = streamSink.sinkCapability.promise;
	    this.streamSinks[streamId] = streamSink;
	    resolveCall(action[0], [data.data, streamSink], action[1]).then(function () {
	      sendStreamRequest({
	        stream: 'start_complete',
	        success: true
	      });
	    }, function (reason) {
	      sendStreamRequest({
	        stream: 'start_complete',
	        success: false,
	        reason: reason
	      });
	    });
	  },
	  _processStreamMessage: function _processStreamMessage(data) {
	    var _this4 = this;
	
	    var sourceName = this.sourceName;
	    var targetName = data.sourceName;
	    var streamId = data.streamId;
	    var sendStreamResponse = function sendStreamResponse(_ref2) {
	      var stream = _ref2.stream,
	          success = _ref2.success,
	          reason = _ref2.reason;
	
	      _this4.comObj.postMessage({
	        sourceName: sourceName,
	        targetName: targetName,
	        stream: stream,
	        success: success,
	        streamId: streamId,
	        reason: reason
	      });
	    };
	    var deleteStreamController = function deleteStreamController() {
	      Promise.all([_this4.streamControllers[data.streamId].startCall, _this4.streamControllers[data.streamId].pullCall, _this4.streamControllers[data.streamId].cancelCall].map(function (capability) {
	        return capability && finalize(capability.promise);
	      })).then(function () {
	        delete _this4.streamControllers[data.streamId];
	      });
	    };
	    switch (data.stream) {
	      case 'start_complete':
	        resolveOrReject(this.streamControllers[data.streamId].startCall, data.success, wrapReason(data.reason));
	        break;
	      case 'pull_complete':
	        resolveOrReject(this.streamControllers[data.streamId].pullCall, data.success, wrapReason(data.reason));
	        break;
	      case 'pull':
	        if (!this.streamSinks[data.streamId]) {
	          sendStreamResponse({
	            stream: 'pull_complete',
	            success: true
	          });
	          break;
	        }
	        if (this.streamSinks[data.streamId].desiredSize <= 0 && data.desiredSize > 0) {
	          this.streamSinks[data.streamId].sinkCapability.resolve();
	        }
	        this.streamSinks[data.streamId].desiredSize = data.desiredSize;
	        resolveCall(this.streamSinks[data.streamId].onPull).then(function () {
	          sendStreamResponse({
	            stream: 'pull_complete',
	            success: true
	          });
	        }, function (reason) {
	          sendStreamResponse({
	            stream: 'pull_complete',
	            success: false,
	            reason: reason
	          });
	        });
	        break;
	      case 'enqueue':
	        assert(this.streamControllers[data.streamId], 'enqueue should have stream controller');
	        if (!this.streamControllers[data.streamId].isClosed) {
	          this.streamControllers[data.streamId].controller.enqueue(data.chunk);
	        }
	        break;
	      case 'close':
	        assert(this.streamControllers[data.streamId], 'close should have stream controller');
	        if (this.streamControllers[data.streamId].isClosed) {
	          break;
	        }
	        this.streamControllers[data.streamId].isClosed = true;
	        this.streamControllers[data.streamId].controller.close();
	        deleteStreamController();
	        break;
	      case 'error':
	        assert(this.streamControllers[data.streamId], 'error should have stream controller');
	        this.streamControllers[data.streamId].controller.error(wrapReason(data.reason));
	        deleteStreamController();
	        break;
	      case 'cancel_complete':
	        resolveOrReject(this.streamControllers[data.streamId].cancelCall, data.success, wrapReason(data.reason));
	        deleteStreamController();
	        break;
	      case 'cancel':
	        if (!this.streamSinks[data.streamId]) {
	          break;
	        }
	        resolveCall(this.streamSinks[data.streamId].onCancel, [wrapReason(data.reason)]).then(function () {
	          sendStreamResponse({
	            stream: 'cancel_complete',
	            success: true
	          });
	        }, function (reason) {
	          sendStreamResponse({
	            stream: 'cancel_complete',
	            success: false,
	            reason: reason
	          });
	        });
	        this.streamSinks[data.streamId].sinkCapability.reject(wrapReason(data.reason));
	        this.streamSinks[data.streamId].isCancelled = true;
	        delete this.streamSinks[data.streamId];
	        break;
	      default:
	        throw new Error('Unexpected stream case');
	    }
	  },
	  postMessage: function postMessage(message, transfers) {
	    if (transfers && this.postMessageTransfers) {
	      this.comObj.postMessage(message, transfers);
	    } else {
	      this.comObj.postMessage(message);
	    }
	  },
	  destroy: function destroy() {
	    this.comObj.removeEventListener('message', this._onComObjOnMessage);
	  }
	};
	function loadJpegStream(id, imageUrl, objs) {
	  var img = new Image();
	  img.onload = function loadJpegStream_onloadClosure() {
	    objs.resolve(id, img);
	  };
	  img.onerror = function loadJpegStream_onerrorClosure() {
	    objs.resolve(id, null);
	    warn('Error during JPEG image loading');
	  };
	  img.src = imageUrl;
	}
	exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
	exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
	exports.OPS = OPS;
	exports.VERBOSITY_LEVELS = VERBOSITY_LEVELS;
	exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
	exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
	exports.AnnotationFieldFlag = AnnotationFieldFlag;
	exports.AnnotationFlag = AnnotationFlag;
	exports.AnnotationType = AnnotationType;
	exports.FontType = FontType;
	exports.ImageKind = ImageKind;
	exports.CMapCompressionType = CMapCompressionType;
	exports.AbortException = AbortException;
	exports.InvalidPDFException = InvalidPDFException;
	exports.MessageHandler = MessageHandler;
	exports.MissingDataException = MissingDataException;
	exports.MissingPDFException = MissingPDFException;
	exports.NativeImageDecoding = NativeImageDecoding;
	exports.NotImplementedException = NotImplementedException;
	exports.PageViewport = PageViewport;
	exports.PasswordException = PasswordException;
	exports.PasswordResponses = PasswordResponses;
	exports.StatTimer = StatTimer;
	exports.StreamType = StreamType;
	exports.TextRenderingMode = TextRenderingMode;
	exports.UnexpectedResponseException = UnexpectedResponseException;
	exports.UnknownErrorException = UnknownErrorException;
	exports.Util = Util;
	exports.XRefParseException = XRefParseException;
	exports.FormatError = FormatError;
	exports.arrayByteLength = arrayByteLength;
	exports.arraysToBytes = arraysToBytes;
	exports.assert = assert;
	exports.bytesToString = bytesToString;
	exports.createBlob = createBlob;
	exports.createPromiseCapability = createPromiseCapability;
	exports.createObjectURL = createObjectURL;
	exports.deprecated = deprecated;
	exports.getLookupTableFactory = getLookupTableFactory;
	exports.getVerbosityLevel = getVerbosityLevel;
	exports.info = info;
	exports.isArrayBuffer = isArrayBuffer;
	exports.isBool = isBool;
	exports.isEmptyObj = isEmptyObj;
	exports.isNum = isNum;
	exports.isString = isString;
	exports.isSpace = isSpace;
	exports.isNodeJS = isNodeJS;
	exports.isSameOrigin = isSameOrigin;
	exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
	exports.isLittleEndian = isLittleEndian;
	exports.isEvalSupported = isEvalSupported;
	exports.loadJpegStream = loadJpegStream;
	exports.log2 = log2;
	exports.readInt8 = readInt8;
	exports.readUint16 = readUint16;
	exports.readUint32 = readUint32;
	exports.removeNullCharacters = removeNullCharacters;
	exports.ReadableStream = _streams_polyfill.ReadableStream;
	exports.setVerbosityLevel = setVerbosityLevel;
	exports.shadow = shadow;
	exports.string32 = string32;
	exports.stringToBytes = stringToBytes;
	exports.stringToPDFString = stringToPDFString;
	exports.stringToUTF8String = stringToUTF8String;
	exports.utf8StringToString = utf8StringToString;
	exports.warn = warn;
	exports.unreachable = unreachable;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if (typeof __g == 'number') __g = global;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var EOF = {};
	var Name = function NameClosure() {
	  function Name(name) {
	    this.name = name;
	  }
	  Name.prototype = {};
	  var nameCache = Object.create(null);
	  Name.get = function Name_get(name) {
	    var nameValue = nameCache[name];
	    return nameValue ? nameValue : nameCache[name] = new Name(name);
	  };
	  return Name;
	}();
	var Cmd = function CmdClosure() {
	  function Cmd(cmd) {
	    this.cmd = cmd;
	  }
	  Cmd.prototype = {};
	  var cmdCache = Object.create(null);
	  Cmd.get = function Cmd_get(cmd) {
	    var cmdValue = cmdCache[cmd];
	    return cmdValue ? cmdValue : cmdCache[cmd] = new Cmd(cmd);
	  };
	  return Cmd;
	}();
	var Dict = function DictClosure() {
	  var nonSerializable = function nonSerializableClosure() {
	    return nonSerializable;
	  };
	  function Dict(xref) {
	    this._map = Object.create(null);
	    this.xref = xref;
	    this.objId = null;
	    this.suppressEncryption = false;
	    this.__nonSerializable__ = nonSerializable;
	  }
	  Dict.prototype = {
	    assignXref: function Dict_assignXref(newXref) {
	      this.xref = newXref;
	    },
	    get: function Dict_get(key1, key2, key3) {
	      var value;
	      var xref = this.xref,
	          suppressEncryption = this.suppressEncryption;
	      if (typeof (value = this._map[key1]) !== 'undefined' || key1 in this._map || typeof key2 === 'undefined') {
	        return xref ? xref.fetchIfRef(value, suppressEncryption) : value;
	      }
	      if (typeof (value = this._map[key2]) !== 'undefined' || key2 in this._map || typeof key3 === 'undefined') {
	        return xref ? xref.fetchIfRef(value, suppressEncryption) : value;
	      }
	      value = this._map[key3] || null;
	      return xref ? xref.fetchIfRef(value, suppressEncryption) : value;
	    },
	    getAsync: function Dict_getAsync(key1, key2, key3) {
	      var value;
	      var xref = this.xref,
	          suppressEncryption = this.suppressEncryption;
	      if (typeof (value = this._map[key1]) !== 'undefined' || key1 in this._map || typeof key2 === 'undefined') {
	        if (xref) {
	          return xref.fetchIfRefAsync(value, suppressEncryption);
	        }
	        return Promise.resolve(value);
	      }
	      if (typeof (value = this._map[key2]) !== 'undefined' || key2 in this._map || typeof key3 === 'undefined') {
	        if (xref) {
	          return xref.fetchIfRefAsync(value, suppressEncryption);
	        }
	        return Promise.resolve(value);
	      }
	      value = this._map[key3] || null;
	      if (xref) {
	        return xref.fetchIfRefAsync(value, suppressEncryption);
	      }
	      return Promise.resolve(value);
	    },
	    getArray: function Dict_getArray(key1, key2, key3) {
	      var value = this.get(key1, key2, key3);
	      var xref = this.xref,
	          suppressEncryption = this.suppressEncryption;
	      if (!Array.isArray(value) || !xref) {
	        return value;
	      }
	      value = value.slice();
	      for (var i = 0, ii = value.length; i < ii; i++) {
	        if (!isRef(value[i])) {
	          continue;
	        }
	        value[i] = xref.fetch(value[i], suppressEncryption);
	      }
	      return value;
	    },
	    getRaw: function Dict_getRaw(key) {
	      return this._map[key];
	    },
	    getKeys: function Dict_getKeys() {
	      return Object.keys(this._map);
	    },
	    set: function Dict_set(key, value) {
	      this._map[key] = value;
	    },
	    has: function Dict_has(key) {
	      return key in this._map;
	    },
	    forEach: function Dict_forEach(callback) {
	      for (var key in this._map) {
	        callback(key, this.get(key));
	      }
	    }
	  };
	  Dict.empty = new Dict(null);
	  Dict.merge = function (xref, dictArray) {
	    var mergedDict = new Dict(xref);
	    for (var i = 0, ii = dictArray.length; i < ii; i++) {
	      var dict = dictArray[i];
	      if (!isDict(dict)) {
	        continue;
	      }
	      for (var keyName in dict._map) {
	        if (mergedDict._map[keyName] !== undefined) {
	          continue;
	        }
	        mergedDict._map[keyName] = dict._map[keyName];
	      }
	    }
	    return mergedDict;
	  };
	  return Dict;
	}();
	var Ref = function RefClosure() {
	  function Ref(num, gen) {
	    this.num = num;
	    this.gen = gen;
	  }
	  Ref.prototype = {
	    toString: function Ref_toString() {
	      var str = this.num + 'R';
	      if (this.gen !== 0) {
	        str += this.gen;
	      }
	      return str;
	    }
	  };
	  return Ref;
	}();
	var RefSet = function RefSetClosure() {
	  function RefSet() {
	    this.dict = Object.create(null);
	  }
	  RefSet.prototype = {
	    has: function RefSet_has(ref) {
	      return ref.toString() in this.dict;
	    },
	    put: function RefSet_put(ref) {
	      this.dict[ref.toString()] = true;
	    },
	    remove: function RefSet_remove(ref) {
	      delete this.dict[ref.toString()];
	    }
	  };
	  return RefSet;
	}();
	var RefSetCache = function RefSetCacheClosure() {
	  function RefSetCache() {
	    this.dict = Object.create(null);
	  }
	  RefSetCache.prototype = {
	    get: function RefSetCache_get(ref) {
	      return this.dict[ref.toString()];
	    },
	    has: function RefSetCache_has(ref) {
	      return ref.toString() in this.dict;
	    },
	    put: function RefSetCache_put(ref, obj) {
	      this.dict[ref.toString()] = obj;
	    },
	    putAlias: function RefSetCache_putAlias(ref, aliasRef) {
	      this.dict[ref.toString()] = this.get(aliasRef);
	    },
	    forEach: function RefSetCache_forEach(fn, thisArg) {
	      for (var i in this.dict) {
	        fn.call(thisArg, this.dict[i]);
	      }
	    },
	    clear: function RefSetCache_clear() {
	      this.dict = Object.create(null);
	    }
	  };
	  return RefSetCache;
	}();
	function isEOF(v) {
	  return v === EOF;
	}
	function isName(v, name) {
	  return v instanceof Name && (name === undefined || v.name === name);
	}
	function isCmd(v, cmd) {
	  return v instanceof Cmd && (cmd === undefined || v.cmd === cmd);
	}
	function isDict(v, type) {
	  return v instanceof Dict && (type === undefined || isName(v.get('Type'), type));
	}
	function isRef(v) {
	  return v instanceof Ref;
	}
	function isRefsEqual(v1, v2) {
	  return v1.num === v2.num && v1.gen === v2.gen;
	}
	function isStream(v) {
	  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v !== null && v.getBytes !== undefined;
	}
	exports.EOF = EOF;
	exports.Cmd = Cmd;
	exports.Dict = Dict;
	exports.Name = Name;
	exports.Ref = Ref;
	exports.RefSet = RefSet;
	exports.RefSetCache = RefSetCache;
	exports.isEOF = isEOF;
	exports.isCmd = isCmd;
	exports.isDict = isDict;
	exports.isName = isName;
	exports.isRef = isRef;
	exports.isRefsEqual = isRefsEqual;
	exports.isStream = isStream;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	module.exports = function (it) {
	  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
	};
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var store = __w_pdfjs_require__(57)('wks');
	var uid = __w_pdfjs_require__(18);
	var _Symbol = __w_pdfjs_require__(1).Symbol;
	var USE_SYMBOL = typeof _Symbol == 'function';
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
	};
	$exports.store = store;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LZWStream = exports.StringStream = exports.StreamsSequenceStream = exports.Stream = exports.RunLengthStream = exports.PredictorStream = exports.NullStream = exports.JpxStream = exports.JpegStream = exports.FlateStream = exports.DecodeStream = exports.DecryptStream = exports.AsciiHexStream = exports.Ascii85Stream = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _primitives = __w_pdfjs_require__(2);
	
	var _jpg = __w_pdfjs_require__(143);
	
	var _jpx = __w_pdfjs_require__(80);
	
	var Stream = function StreamClosure() {
	  function Stream(arrayBuffer, start, length, dict) {
	    this.bytes = arrayBuffer instanceof Uint8Array ? arrayBuffer : new Uint8Array(arrayBuffer);
	    this.start = start || 0;
	    this.pos = this.start;
	    this.end = start + length || this.bytes.length;
	    this.dict = dict;
	  }
	  Stream.prototype = {
	    get length() {
	      return this.end - this.start;
	    },
	    get isEmpty() {
	      return this.length === 0;
	    },
	    getByte: function Stream_getByte() {
	      if (this.pos >= this.end) {
	        return -1;
	      }
	      return this.bytes[this.pos++];
	    },
	    getUint16: function Stream_getUint16() {
	      var b0 = this.getByte();
	      var b1 = this.getByte();
	      if (b0 === -1 || b1 === -1) {
	        return -1;
	      }
	      return (b0 << 8) + b1;
	    },
	    getInt32: function Stream_getInt32() {
	      var b0 = this.getByte();
	      var b1 = this.getByte();
	      var b2 = this.getByte();
	      var b3 = this.getByte();
	      return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
	    },
	    getBytes: function Stream_getBytes(length) {
	      var bytes = this.bytes;
	      var pos = this.pos;
	      var strEnd = this.end;
	      if (!length) {
	        return bytes.subarray(pos, strEnd);
	      }
	      var end = pos + length;
	      if (end > strEnd) {
	        end = strEnd;
	      }
	      this.pos = end;
	      return bytes.subarray(pos, end);
	    },
	    peekByte: function Stream_peekByte() {
	      var peekedByte = this.getByte();
	      this.pos--;
	      return peekedByte;
	    },
	    peekBytes: function Stream_peekBytes(length) {
	      var bytes = this.getBytes(length);
	      this.pos -= bytes.length;
	      return bytes;
	    },
	    skip: function Stream_skip(n) {
	      if (!n) {
	        n = 1;
	      }
	      this.pos += n;
	    },
	    reset: function Stream_reset() {
	      this.pos = this.start;
	    },
	    moveStart: function Stream_moveStart() {
	      this.start = this.pos;
	    },
	    makeSubStream: function Stream_makeSubStream(start, length, dict) {
	      return new Stream(this.bytes.buffer, start, length, dict);
	    }
	  };
	  return Stream;
	}();
	var StringStream = function StringStreamClosure() {
	  function StringStream(str) {
	    var bytes = (0, _util.stringToBytes)(str);
	    Stream.call(this, bytes);
	  }
	  StringStream.prototype = Stream.prototype;
	  return StringStream;
	}();
	var DecodeStream = function DecodeStreamClosure() {
	  var emptyBuffer = new Uint8Array(0);
	  function DecodeStream(maybeMinBufferLength) {
	    this.pos = 0;
	    this.bufferLength = 0;
	    this.eof = false;
	    this.buffer = emptyBuffer;
	    this.minBufferLength = 512;
	    if (maybeMinBufferLength) {
	      while (this.minBufferLength < maybeMinBufferLength) {
	        this.minBufferLength *= 2;
	      }
	    }
	  }
	  DecodeStream.prototype = {
	    get isEmpty() {
	      while (!this.eof && this.bufferLength === 0) {
	        this.readBlock();
	      }
	      return this.bufferLength === 0;
	    },
	    ensureBuffer: function DecodeStream_ensureBuffer(requested) {
	      var buffer = this.buffer;
	      if (requested <= buffer.byteLength) {
	        return buffer;
	      }
	      var size = this.minBufferLength;
	      while (size < requested) {
	        size *= 2;
	      }
	      var buffer2 = new Uint8Array(size);
	      buffer2.set(buffer);
	      return this.buffer = buffer2;
	    },
	    getByte: function DecodeStream_getByte() {
	      var pos = this.pos;
	      while (this.bufferLength <= pos) {
	        if (this.eof) {
	          return -1;
	        }
	        this.readBlock();
	      }
	      return this.buffer[this.pos++];
	    },
	    getUint16: function DecodeStream_getUint16() {
	      var b0 = this.getByte();
	      var b1 = this.getByte();
	      if (b0 === -1 || b1 === -1) {
	        return -1;
	      }
	      return (b0 << 8) + b1;
	    },
	    getInt32: function DecodeStream_getInt32() {
	      var b0 = this.getByte();
	      var b1 = this.getByte();
	      var b2 = this.getByte();
	      var b3 = this.getByte();
	      return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
	    },
	    getBytes: function DecodeStream_getBytes(length) {
	      var end,
	          pos = this.pos;
	      if (length) {
	        this.ensureBuffer(pos + length);
	        end = pos + length;
	        while (!this.eof && this.bufferLength < end) {
	          this.readBlock();
	        }
	        var bufEnd = this.bufferLength;
	        if (end > bufEnd) {
	          end = bufEnd;
	        }
	      } else {
	        while (!this.eof) {
	          this.readBlock();
	        }
	        end = this.bufferLength;
	      }
	      this.pos = end;
	      return this.buffer.subarray(pos, end);
	    },
	    peekByte: function DecodeStream_peekByte() {
	      var peekedByte = this.getByte();
	      this.pos--;
	      return peekedByte;
	    },
	    peekBytes: function DecodeStream_peekBytes(length) {
	      var bytes = this.getBytes(length);
	      this.pos -= bytes.length;
	      return bytes;
	    },
	    makeSubStream: function DecodeStream_makeSubStream(start, length, dict) {
	      var end = start + length;
	      while (this.bufferLength <= end && !this.eof) {
	        this.readBlock();
	      }
	      return new Stream(this.buffer, start, length, dict);
	    },
	    skip: function DecodeStream_skip(n) {
	      if (!n) {
	        n = 1;
	      }
	      this.pos += n;
	    },
	    reset: function DecodeStream_reset() {
	      this.pos = 0;
	    },
	    getBaseStreams: function DecodeStream_getBaseStreams() {
	      if (this.str && this.str.getBaseStreams) {
	        return this.str.getBaseStreams();
	      }
	      return [];
	    }
	  };
	  return DecodeStream;
	}();
	var StreamsSequenceStream = function StreamsSequenceStreamClosure() {
	  function StreamsSequenceStream(streams) {
	    this.streams = streams;
	    DecodeStream.call(this, null);
	  }
	  StreamsSequenceStream.prototype = Object.create(DecodeStream.prototype);
	  StreamsSequenceStream.prototype.readBlock = function streamSequenceStreamReadBlock() {
	    var streams = this.streams;
	    if (streams.length === 0) {
	      this.eof = true;
	      return;
	    }
	    var stream = streams.shift();
	    var chunk = stream.getBytes();
	    var bufferLength = this.bufferLength;
	    var newLength = bufferLength + chunk.length;
	    var buffer = this.ensureBuffer(newLength);
	    buffer.set(chunk, bufferLength);
	    this.bufferLength = newLength;
	  };
	  StreamsSequenceStream.prototype.getBaseStreams = function StreamsSequenceStream_getBaseStreams() {
	    var baseStreams = [];
	    for (var i = 0, ii = this.streams.length; i < ii; i++) {
	      var stream = this.streams[i];
	      if (stream.getBaseStreams) {
	        _util.Util.appendToArray(baseStreams, stream.getBaseStreams());
	      }
	    }
	    return baseStreams;
	  };
	  return StreamsSequenceStream;
	}();
	var FlateStream = function FlateStreamClosure() {
	  var codeLenCodeMap = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
	  var lengthDecode = new Int32Array([0x00003, 0x00004, 0x00005, 0x00006, 0x00007, 0x00008, 0x00009, 0x0000a, 0x1000b, 0x1000d, 0x1000f, 0x10011, 0x20013, 0x20017, 0x2001b, 0x2001f, 0x30023, 0x3002b, 0x30033, 0x3003b, 0x40043, 0x40053, 0x40063, 0x40073, 0x50083, 0x500a3, 0x500c3, 0x500e3, 0x00102, 0x00102, 0x00102]);
	  var distDecode = new Int32Array([0x00001, 0x00002, 0x00003, 0x00004, 0x10005, 0x10007, 0x20009, 0x2000d, 0x30011, 0x30019, 0x40021, 0x40031, 0x50041, 0x50061, 0x60081, 0x600c1, 0x70101, 0x70181, 0x80201, 0x80301, 0x90401, 0x90601, 0xa0801, 0xa0c01, 0xb1001, 0xb1801, 0xc2001, 0xc3001, 0xd4001, 0xd6001]);
	  var fixedLitCodeTab = [new Int32Array([0x70100, 0x80050, 0x80010, 0x80118, 0x70110, 0x80070, 0x80030, 0x900c0, 0x70108, 0x80060, 0x80020, 0x900a0, 0x80000, 0x80080, 0x80040, 0x900e0, 0x70104, 0x80058, 0x80018, 0x90090, 0x70114, 0x80078, 0x80038, 0x900d0, 0x7010c, 0x80068, 0x80028, 0x900b0, 0x80008, 0x80088, 0x80048, 0x900f0, 0x70102, 0x80054, 0x80014, 0x8011c, 0x70112, 0x80074, 0x80034, 0x900c8, 0x7010a, 0x80064, 0x80024, 0x900a8, 0x80004, 0x80084, 0x80044, 0x900e8, 0x70106, 0x8005c, 0x8001c, 0x90098, 0x70116, 0x8007c, 0x8003c, 0x900d8, 0x7010e, 0x8006c, 0x8002c, 0x900b8, 0x8000c, 0x8008c, 0x8004c, 0x900f8, 0x70101, 0x80052, 0x80012, 0x8011a, 0x70111, 0x80072, 0x80032, 0x900c4, 0x70109, 0x80062, 0x80022, 0x900a4, 0x80002, 0x80082, 0x80042, 0x900e4, 0x70105, 0x8005a, 0x8001a, 0x90094, 0x70115, 0x8007a, 0x8003a, 0x900d4, 0x7010d, 0x8006a, 0x8002a, 0x900b4, 0x8000a, 0x8008a, 0x8004a, 0x900f4, 0x70103, 0x80056, 0x80016, 0x8011e, 0x70113, 0x80076, 0x80036, 0x900cc, 0x7010b, 0x80066, 0x80026, 0x900ac, 0x80006, 0x80086, 0x80046, 0x900ec, 0x70107, 0x8005e, 0x8001e, 0x9009c, 0x70117, 0x8007e, 0x8003e, 0x900dc, 0x7010f, 0x8006e, 0x8002e, 0x900bc, 0x8000e, 0x8008e, 0x8004e, 0x900fc, 0x70100, 0x80051, 0x80011, 0x80119, 0x70110, 0x80071, 0x80031, 0x900c2, 0x70108, 0x80061, 0x80021, 0x900a2, 0x80001, 0x80081, 0x80041, 0x900e2, 0x70104, 0x80059, 0x80019, 0x90092, 0x70114, 0x80079, 0x80039, 0x900d2, 0x7010c, 0x80069, 0x80029, 0x900b2, 0x80009, 0x80089, 0x80049, 0x900f2, 0x70102, 0x80055, 0x80015, 0x8011d, 0x70112, 0x80075, 0x80035, 0x900ca, 0x7010a, 0x80065, 0x80025, 0x900aa, 0x80005, 0x80085, 0x80045, 0x900ea, 0x70106, 0x8005d, 0x8001d, 0x9009a, 0x70116, 0x8007d, 0x8003d, 0x900da, 0x7010e, 0x8006d, 0x8002d, 0x900ba, 0x8000d, 0x8008d, 0x8004d, 0x900fa, 0x70101, 0x80053, 0x80013, 0x8011b, 0x70111, 0x80073, 0x80033, 0x900c6, 0x70109, 0x80063, 0x80023, 0x900a6, 0x80003, 0x80083, 0x80043, 0x900e6, 0x70105, 0x8005b, 0x8001b, 0x90096, 0x70115, 0x8007b, 0x8003b, 0x900d6, 0x7010d, 0x8006b, 0x8002b, 0x900b6, 0x8000b, 0x8008b, 0x8004b, 0x900f6, 0x70103, 0x80057, 0x80017, 0x8011f, 0x70113, 0x80077, 0x80037, 0x900ce, 0x7010b, 0x80067, 0x80027, 0x900ae, 0x80007, 0x80087, 0x80047, 0x900ee, 0x70107, 0x8005f, 0x8001f, 0x9009e, 0x70117, 0x8007f, 0x8003f, 0x900de, 0x7010f, 0x8006f, 0x8002f, 0x900be, 0x8000f, 0x8008f, 0x8004f, 0x900fe, 0x70100, 0x80050, 0x80010, 0x80118, 0x70110, 0x80070, 0x80030, 0x900c1, 0x70108, 0x80060, 0x80020, 0x900a1, 0x80000, 0x80080, 0x80040, 0x900e1, 0x70104, 0x80058, 0x80018, 0x90091, 0x70114, 0x80078, 0x80038, 0x900d1, 0x7010c, 0x80068, 0x80028, 0x900b1, 0x80008, 0x80088, 0x80048, 0x900f1, 0x70102, 0x80054, 0x80014, 0x8011c, 0x70112, 0x80074, 0x80034, 0x900c9, 0x7010a, 0x80064, 0x80024, 0x900a9, 0x80004, 0x80084, 0x80044, 0x900e9, 0x70106, 0x8005c, 0x8001c, 0x90099, 0x70116, 0x8007c, 0x8003c, 0x900d9, 0x7010e, 0x8006c, 0x8002c, 0x900b9, 0x8000c, 0x8008c, 0x8004c, 0x900f9, 0x70101, 0x80052, 0x80012, 0x8011a, 0x70111, 0x80072, 0x80032, 0x900c5, 0x70109, 0x80062, 0x80022, 0x900a5, 0x80002, 0x80082, 0x80042, 0x900e5, 0x70105, 0x8005a, 0x8001a, 0x90095, 0x70115, 0x8007a, 0x8003a, 0x900d5, 0x7010d, 0x8006a, 0x8002a, 0x900b5, 0x8000a, 0x8008a, 0x8004a, 0x900f5, 0x70103, 0x80056, 0x80016, 0x8011e, 0x70113, 0x80076, 0x80036, 0x900cd, 0x7010b, 0x80066, 0x80026, 0x900ad, 0x80006, 0x80086, 0x80046, 0x900ed, 0x70107, 0x8005e, 0x8001e, 0x9009d, 0x70117, 0x8007e, 0x8003e, 0x900dd, 0x7010f, 0x8006e, 0x8002e, 0x900bd, 0x8000e, 0x8008e, 0x8004e, 0x900fd, 0x70100, 0x80051, 0x80011, 0x80119, 0x70110, 0x80071, 0x80031, 0x900c3, 0x70108, 0x80061, 0x80021, 0x900a3, 0x80001, 0x80081, 0x80041, 0x900e3, 0x70104, 0x80059, 0x80019, 0x90093, 0x70114, 0x80079, 0x80039, 0x900d3, 0x7010c, 0x80069, 0x80029, 0x900b3, 0x80009, 0x80089, 0x80049, 0x900f3, 0x70102, 0x80055, 0x80015, 0x8011d, 0x70112, 0x80075, 0x80035, 0x900cb, 0x7010a, 0x80065, 0x80025, 0x900ab, 0x80005, 0x80085, 0x80045, 0x900eb, 0x70106, 0x8005d, 0x8001d, 0x9009b, 0x70116, 0x8007d, 0x8003d, 0x900db, 0x7010e, 0x8006d, 0x8002d, 0x900bb, 0x8000d, 0x8008d, 0x8004d, 0x900fb, 0x70101, 0x80053, 0x80013, 0x8011b, 0x70111, 0x80073, 0x80033, 0x900c7, 0x70109, 0x80063, 0x80023, 0x900a7, 0x80003, 0x80083, 0x80043, 0x900e7, 0x70105, 0x8005b, 0x8001b, 0x90097, 0x70115, 0x8007b, 0x8003b, 0x900d7, 0x7010d, 0x8006b, 0x8002b, 0x900b7, 0x8000b, 0x8008b, 0x8004b, 0x900f7, 0x70103, 0x80057, 0x80017, 0x8011f, 0x70113, 0x80077, 0x80037, 0x900cf, 0x7010b, 0x80067, 0x80027, 0x900af, 0x80007, 0x80087, 0x80047, 0x900ef, 0x70107, 0x8005f, 0x8001f, 0x9009f, 0x70117, 0x8007f, 0x8003f, 0x900df, 0x7010f, 0x8006f, 0x8002f, 0x900bf, 0x8000f, 0x8008f, 0x8004f, 0x900ff]), 9];
	  var fixedDistCodeTab = [new Int32Array([0x50000, 0x50010, 0x50008, 0x50018, 0x50004, 0x50014, 0x5000c, 0x5001c, 0x50002, 0x50012, 0x5000a, 0x5001a, 0x50006, 0x50016, 0x5000e, 0x00000, 0x50001, 0x50011, 0x50009, 0x50019, 0x50005, 0x50015, 0x5000d, 0x5001d, 0x50003, 0x50013, 0x5000b, 0x5001b, 0x50007, 0x50017, 0x5000f, 0x00000]), 5];
	  function FlateStream(str, maybeLength) {
	    this.str = str;
	    this.dict = str.dict;
	    var cmf = str.getByte();
	    var flg = str.getByte();
	    if (cmf === -1 || flg === -1) {
	      throw new _util.FormatError('Invalid header in flate stream: ' + cmf + ', ' + flg);
	    }
	    if ((cmf & 0x0f) !== 0x08) {
	      throw new _util.FormatError('Unknown compression method in flate stream: ' + cmf + ', ' + flg);
	    }
	    if (((cmf << 8) + flg) % 31 !== 0) {
	      throw new _util.FormatError('Bad FCHECK in flate stream: ' + cmf + ', ' + flg);
	    }
	    if (flg & 0x20) {
	      throw new _util.FormatError('FDICT bit set in flate stream: ' + cmf + ', ' + flg);
	    }
	    this.codeSize = 0;
	    this.codeBuf = 0;
	    DecodeStream.call(this, maybeLength);
	  }
	  FlateStream.prototype = Object.create(DecodeStream.prototype);
	  FlateStream.prototype.getBits = function FlateStream_getBits(bits) {
	    var str = this.str;
	    var codeSize = this.codeSize;
	    var codeBuf = this.codeBuf;
	    var b;
	    while (codeSize < bits) {
	      if ((b = str.getByte()) === -1) {
	        throw new _util.FormatError('Bad encoding in flate stream');
	      }
	      codeBuf |= b << codeSize;
	      codeSize += 8;
	    }
	    b = codeBuf & (1 << bits) - 1;
	    this.codeBuf = codeBuf >> bits;
	    this.codeSize = codeSize -= bits;
	    return b;
	  };
	  FlateStream.prototype.getCode = function FlateStream_getCode(table) {
	    var str = this.str;
	    var codes = table[0];
	    var maxLen = table[1];
	    var codeSize = this.codeSize;
	    var codeBuf = this.codeBuf;
	    var b;
	    while (codeSize < maxLen) {
	      if ((b = str.getByte()) === -1) {
	        break;
	      }
	      codeBuf |= b << codeSize;
	      codeSize += 8;
	    }
	    var code = codes[codeBuf & (1 << maxLen) - 1];
	    var codeLen = code >> 16;
	    var codeVal = code & 0xffff;
	    if (codeLen < 1 || codeSize < codeLen) {
	      throw new _util.FormatError('Bad encoding in flate stream');
	    }
	    this.codeBuf = codeBuf >> codeLen;
	    this.codeSize = codeSize - codeLen;
	    return codeVal;
	  };
	  FlateStream.prototype.generateHuffmanTable = function flateStreamGenerateHuffmanTable(lengths) {
	    var n = lengths.length;
	    var maxLen = 0;
	    var i;
	    for (i = 0; i < n; ++i) {
	      if (lengths[i] > maxLen) {
	        maxLen = lengths[i];
	      }
	    }
	    var size = 1 << maxLen;
	    var codes = new Int32Array(size);
	    for (var len = 1, code = 0, skip = 2; len <= maxLen; ++len, code <<= 1, skip <<= 1) {
	      for (var val = 0; val < n; ++val) {
	        if (lengths[val] === len) {
	          var code2 = 0;
	          var t = code;
	          for (i = 0; i < len; ++i) {
	            code2 = code2 << 1 | t & 1;
	            t >>= 1;
	          }
	          for (i = code2; i < size; i += skip) {
	            codes[i] = len << 16 | val;
	          }
	          ++code;
	        }
	      }
	    }
	    return [codes, maxLen];
	  };
	  FlateStream.prototype.readBlock = function FlateStream_readBlock() {
	    var buffer, len;
	    var str = this.str;
	    var hdr = this.getBits(3);
	    if (hdr & 1) {
	      this.eof = true;
	    }
	    hdr >>= 1;
	    if (hdr === 0) {
	      var b;
	      if ((b = str.getByte()) === -1) {
	        throw new _util.FormatError('Bad block header in flate stream');
	      }
	      var blockLen = b;
	      if ((b = str.getByte()) === -1) {
	        throw new _util.FormatError('Bad block header in flate stream');
	      }
	      blockLen |= b << 8;
	      if ((b = str.getByte()) === -1) {
	        throw new _util.FormatError('Bad block header in flate stream');
	      }
	      var check = b;
	      if ((b = str.getByte()) === -1) {
	        throw new _util.FormatError('Bad block header in flate stream');
	      }
	      check |= b << 8;
	      if (check !== (~blockLen & 0xffff) && (blockLen !== 0 || check !== 0)) {
	        throw new _util.FormatError('Bad uncompressed block length in flate stream');
	      }
	      this.codeBuf = 0;
	      this.codeSize = 0;
	      var bufferLength = this.bufferLength;
	      buffer = this.ensureBuffer(bufferLength + blockLen);
	      var end = bufferLength + blockLen;
	      this.bufferLength = end;
	      if (blockLen === 0) {
	        if (str.peekByte() === -1) {
	          this.eof = true;
	        }
	      } else {
	        for (var n = bufferLength; n < end; ++n) {
	          if ((b = str.getByte()) === -1) {
	            this.eof = true;
	            break;
	          }
	          buffer[n] = b;
	        }
	      }
	      return;
	    }
	    var litCodeTable;
	    var distCodeTable;
	    if (hdr === 1) {
	      litCodeTable = fixedLitCodeTab;
	      distCodeTable = fixedDistCodeTab;
	    } else if (hdr === 2) {
	      var numLitCodes = this.getBits(5) + 257;
	      var numDistCodes = this.getBits(5) + 1;
	      var numCodeLenCodes = this.getBits(4) + 4;
	      var codeLenCodeLengths = new Uint8Array(codeLenCodeMap.length);
	      var i;
	      for (i = 0; i < numCodeLenCodes; ++i) {
	        codeLenCodeLengths[codeLenCodeMap[i]] = this.getBits(3);
	      }
	      var codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);
	      len = 0;
	      i = 0;
	      var codes = numLitCodes + numDistCodes;
	      var codeLengths = new Uint8Array(codes);
	      var bitsLength, bitsOffset, what;
	      while (i < codes) {
	        var code = this.getCode(codeLenCodeTab);
	        if (code === 16) {
	          bitsLength = 2;
	          bitsOffset = 3;
	          what = len;
	        } else if (code === 17) {
	          bitsLength = 3;
	          bitsOffset = 3;
	          what = len = 0;
	        } else if (code === 18) {
	          bitsLength = 7;
	          bitsOffset = 11;
	          what = len = 0;
	        } else {
	          codeLengths[i++] = len = code;
	          continue;
	        }
	        var repeatLength = this.getBits(bitsLength) + bitsOffset;
	        while (repeatLength-- > 0) {
	          codeLengths[i++] = what;
	        }
	      }
	      litCodeTable = this.generateHuffmanTable(codeLengths.subarray(0, numLitCodes));
	      distCodeTable = this.generateHuffmanTable(codeLengths.subarray(numLitCodes, codes));
	    } else {
	      throw new _util.FormatError('Unknown block type in flate stream');
	    }
	    buffer = this.buffer;
	    var limit = buffer ? buffer.length : 0;
	    var pos = this.bufferLength;
	    while (true) {
	      var code1 = this.getCode(litCodeTable);
	      if (code1 < 256) {
	        if (pos + 1 >= limit) {
	          buffer = this.ensureBuffer(pos + 1);
	          limit = buffer.length;
	        }
	        buffer[pos++] = code1;
	        continue;
	      }
	      if (code1 === 256) {
	        this.bufferLength = pos;
	        return;
	      }
	      code1 -= 257;
	      code1 = lengthDecode[code1];
	      var code2 = code1 >> 16;
	      if (code2 > 0) {
	        code2 = this.getBits(code2);
	      }
	      len = (code1 & 0xffff) + code2;
	      code1 = this.getCode(distCodeTable);
	      code1 = distDecode[code1];
	      code2 = code1 >> 16;
	      if (code2 > 0) {
	        code2 = this.getBits(code2);
	      }
	      var dist = (code1 & 0xffff) + code2;
	      if (pos + len >= limit) {
	        buffer = this.ensureBuffer(pos + len);
	        limit = buffer.length;
	      }
	      for (var k = 0; k < len; ++k, ++pos) {
	        buffer[pos] = buffer[pos - dist];
	      }
	    }
	  };
	  return FlateStream;
	}();
	var PredictorStream = function PredictorStreamClosure() {
	  function PredictorStream(str, maybeLength, params) {
	    if (!(0, _primitives.isDict)(params)) {
	      return str;
	    }
	    var predictor = this.predictor = params.get('Predictor') || 1;
	    if (predictor <= 1) {
	      return str;
	    }
	    if (predictor !== 2 && (predictor < 10 || predictor > 15)) {
	      throw new _util.FormatError('Unsupported predictor: ' + predictor);
	    }
	    if (predictor === 2) {
	      this.readBlock = this.readBlockTiff;
	    } else {
	      this.readBlock = this.readBlockPng;
	    }
	    this.str = str;
	    this.dict = str.dict;
	    var colors = this.colors = params.get('Colors') || 1;
	    var bits = this.bits = params.get('BitsPerComponent') || 8;
	    var columns = this.columns = params.get('Columns') || 1;
	    this.pixBytes = colors * bits + 7 >> 3;
	    this.rowBytes = columns * colors * bits + 7 >> 3;
	    DecodeStream.call(this, maybeLength);
	    return this;
	  }
	  PredictorStream.prototype = Object.create(DecodeStream.prototype);
	  PredictorStream.prototype.readBlockTiff = function predictorStreamReadBlockTiff() {
	    var rowBytes = this.rowBytes;
	    var bufferLength = this.bufferLength;
	    var buffer = this.ensureBuffer(bufferLength + rowBytes);
	    var bits = this.bits;
	    var colors = this.colors;
	    var rawBytes = this.str.getBytes(rowBytes);
	    this.eof = !rawBytes.length;
	    if (this.eof) {
	      return;
	    }
	    var inbuf = 0,
	        outbuf = 0;
	    var inbits = 0,
	        outbits = 0;
	    var pos = bufferLength;
	    var i;
	    if (bits === 1 && colors === 1) {
	      for (i = 0; i < rowBytes; ++i) {
	        var c = rawBytes[i] ^ inbuf;
	        c ^= c >> 1;
	        c ^= c >> 2;
	        c ^= c >> 4;
	        inbuf = (c & 1) << 7;
	        buffer[pos++] = c;
	      }
	    } else if (bits === 8) {
	      for (i = 0; i < colors; ++i) {
	        buffer[pos++] = rawBytes[i];
	      }
	      for (; i < rowBytes; ++i) {
	        buffer[pos] = buffer[pos - colors] + rawBytes[i];
	        pos++;
	      }
	    } else if (bits === 16) {
	      var bytesPerPixel = colors * 2;
	      for (i = 0; i < bytesPerPixel; ++i) {
	        buffer[pos++] = rawBytes[i];
	      }
	      for (; i < rowBytes; i += 2) {
	        var sum = ((rawBytes[i] & 0xFF) << 8) + (rawBytes[i + 1] & 0xFF) + ((buffer[pos - bytesPerPixel] & 0xFF) << 8) + (buffer[pos - bytesPerPixel + 1] & 0xFF);
	        buffer[pos++] = sum >> 8 & 0xFF;
	        buffer[pos++] = sum & 0xFF;
	      }
	    } else {
	      var compArray = new Uint8Array(colors + 1);
	      var bitMask = (1 << bits) - 1;
	      var j = 0,
	          k = bufferLength;
	      var columns = this.columns;
	      for (i = 0; i < columns; ++i) {
	        for (var kk = 0; kk < colors; ++kk) {
	          if (inbits < bits) {
	            inbuf = inbuf << 8 | rawBytes[j++] & 0xFF;
	            inbits += 8;
	          }
	          compArray[kk] = compArray[kk] + (inbuf >> inbits - bits) & bitMask;
	          inbits -= bits;
	          outbuf = outbuf << bits | compArray[kk];
	          outbits += bits;
	          if (outbits >= 8) {
	            buffer[k++] = outbuf >> outbits - 8 & 0xFF;
	            outbits -= 8;
	          }
	        }
	      }
	      if (outbits > 0) {
	        buffer[k++] = (outbuf << 8 - outbits) + (inbuf & (1 << 8 - outbits) - 1);
	      }
	    }
	    this.bufferLength += rowBytes;
	  };
	  PredictorStream.prototype.readBlockPng = function predictorStreamReadBlockPng() {
	    var rowBytes = this.rowBytes;
	    var pixBytes = this.pixBytes;
	    var predictor = this.str.getByte();
	    var rawBytes = this.str.getBytes(rowBytes);
	    this.eof = !rawBytes.length;
	    if (this.eof) {
	      return;
	    }
	    var bufferLength = this.bufferLength;
	    var buffer = this.ensureBuffer(bufferLength + rowBytes);
	    var prevRow = buffer.subarray(bufferLength - rowBytes, bufferLength);
	    if (prevRow.length === 0) {
	      prevRow = new Uint8Array(rowBytes);
	    }
	    var i,
	        j = bufferLength,
	        up,
	        c;
	    switch (predictor) {
	      case 0:
	        for (i = 0; i < rowBytes; ++i) {
	          buffer[j++] = rawBytes[i];
	        }
	        break;
	      case 1:
	        for (i = 0; i < pixBytes; ++i) {
	          buffer[j++] = rawBytes[i];
	        }
	        for (; i < rowBytes; ++i) {
	          buffer[j] = buffer[j - pixBytes] + rawBytes[i] & 0xFF;
	          j++;
	        }
	        break;
	      case 2:
	        for (i = 0; i < rowBytes; ++i) {
	          buffer[j++] = prevRow[i] + rawBytes[i] & 0xFF;
	        }
	        break;
	      case 3:
	        for (i = 0; i < pixBytes; ++i) {
	          buffer[j++] = (prevRow[i] >> 1) + rawBytes[i];
	        }
	        for (; i < rowBytes; ++i) {
	          buffer[j] = (prevRow[i] + buffer[j - pixBytes] >> 1) + rawBytes[i] & 0xFF;
	          j++;
	        }
	        break;
	      case 4:
	        for (i = 0; i < pixBytes; ++i) {
	          up = prevRow[i];
	          c = rawBytes[i];
	          buffer[j++] = up + c;
	        }
	        for (; i < rowBytes; ++i) {
	          up = prevRow[i];
	          var upLeft = prevRow[i - pixBytes];
	          var left = buffer[j - pixBytes];
	          var p = left + up - upLeft;
	          var pa = p - left;
	          if (pa < 0) {
	            pa = -pa;
	          }
	          var pb = p - up;
	          if (pb < 0) {
	            pb = -pb;
	          }
	          var pc = p - upLeft;
	          if (pc < 0) {
	            pc = -pc;
	          }
	          c = rawBytes[i];
	          if (pa <= pb && pa <= pc) {
	            buffer[j++] = left + c;
	          } else if (pb <= pc) {
	            buffer[j++] = up + c;
	          } else {
	            buffer[j++] = upLeft + c;
	          }
	        }
	        break;
	      default:
	        throw new _util.FormatError('Unsupported predictor: ' + predictor);
	    }
	    this.bufferLength += rowBytes;
	  };
	  return PredictorStream;
	}();
	var JpegStream = function JpegStreamClosure() {
	  function JpegStream(stream, maybeLength, dict, params) {
	    var ch;
	    while ((ch = stream.getByte()) !== -1) {
	      if (ch === 0xFF) {
	        stream.skip(-1);
	        break;
	      }
	    }
	    this.stream = stream;
	    this.maybeLength = maybeLength;
	    this.dict = dict;
	    this.params = params;
	    DecodeStream.call(this, maybeLength);
	  }
	  JpegStream.prototype = Object.create(DecodeStream.prototype);
	  Object.defineProperty(JpegStream.prototype, 'bytes', {
	    get: function JpegStream_bytes() {
	      return (0, _util.shadow)(this, 'bytes', this.stream.getBytes(this.maybeLength));
	    },
	    configurable: true
	  });
	  JpegStream.prototype.ensureBuffer = function JpegStream_ensureBuffer(req) {
	    if (this.bufferLength) {
	      return;
	    }
	    var jpegImage = new _jpg.JpegImage();
	    var decodeArr = this.dict.getArray('Decode', 'D');
	    if (this.forceRGB && Array.isArray(decodeArr)) {
	      var bitsPerComponent = this.dict.get('BitsPerComponent') || 8;
	      var decodeArrLength = decodeArr.length;
	      var transform = new Int32Array(decodeArrLength);
	      var transformNeeded = false;
	      var maxValue = (1 << bitsPerComponent) - 1;
	      for (var i = 0; i < decodeArrLength; i += 2) {
	        transform[i] = (decodeArr[i + 1] - decodeArr[i]) * 256 | 0;
	        transform[i + 1] = decodeArr[i] * maxValue | 0;
	        if (transform[i] !== 256 || transform[i + 1] !== 0) {
	          transformNeeded = true;
	        }
	      }
	      if (transformNeeded) {
	        jpegImage.decodeTransform = transform;
	      }
	    }
	    if ((0, _primitives.isDict)(this.params)) {
	      var colorTransform = this.params.get('ColorTransform');
	      if (Number.isInteger(colorTransform)) {
	        jpegImage.colorTransform = colorTransform;
	      }
	    }
	    jpegImage.parse(this.bytes);
	    var data = jpegImage.getData(this.drawWidth, this.drawHeight, this.forceRGB);
	    this.buffer = data;
	    this.bufferLength = data.length;
	    this.eof = true;
	  };
	  JpegStream.prototype.getBytes = function JpegStream_getBytes(length) {
	    this.ensureBuffer();
	    return this.buffer;
	  };
	  JpegStream.prototype.getIR = function JpegStream_getIR(forceDataSchema) {
	    return (0, _util.createObjectURL)(this.bytes, 'image/jpeg', forceDataSchema);
	  };
	  return JpegStream;
	}();
	var JpxStream = function JpxStreamClosure() {
	  function JpxStream(stream, maybeLength, dict, params) {
	    this.stream = stream;
	    this.maybeLength = maybeLength;
	    this.dict = dict;
	    this.params = params;
	    DecodeStream.call(this, maybeLength);
	  }
	  JpxStream.prototype = Object.create(DecodeStream.prototype);
	  Object.defineProperty(JpxStream.prototype, 'bytes', {
	    get: function JpxStream_bytes() {
	      return (0, _util.shadow)(this, 'bytes', this.stream.getBytes(this.maybeLength));
	    },
	    configurable: true
	  });
	  JpxStream.prototype.ensureBuffer = function JpxStream_ensureBuffer(req) {
	    if (this.bufferLength) {
	      return;
	    }
	    var jpxImage = new _jpx.JpxImage();
	    jpxImage.parse(this.bytes);
	    var width = jpxImage.width;
	    var height = jpxImage.height;
	    var componentsCount = jpxImage.componentsCount;
	    var tileCount = jpxImage.tiles.length;
	    if (tileCount === 1) {
	      this.buffer = jpxImage.tiles[0].items;
	    } else {
	      var data = new Uint8ClampedArray(width * height * componentsCount);
	      for (var k = 0; k < tileCount; k++) {
	        var tileComponents = jpxImage.tiles[k];
	        var tileWidth = tileComponents.width;
	        var tileHeight = tileComponents.height;
	        var tileLeft = tileComponents.left;
	        var tileTop = tileComponents.top;
	        var src = tileComponents.items;
	        var srcPosition = 0;
	        var dataPosition = (width * tileTop + tileLeft) * componentsCount;
	        var imgRowSize = width * componentsCount;
	        var tileRowSize = tileWidth * componentsCount;
	        for (var j = 0; j < tileHeight; j++) {
	          var rowBytes = src.subarray(srcPosition, srcPosition + tileRowSize);
	          data.set(rowBytes, dataPosition);
	          srcPosition += tileRowSize;
	          dataPosition += imgRowSize;
	        }
	      }
	      this.buffer = data;
	    }
	    this.bufferLength = this.buffer.length;
	    this.eof = true;
	  };
	  return JpxStream;
	}();
	var DecryptStream = function DecryptStreamClosure() {
	  function DecryptStream(str, maybeLength, decrypt) {
	    this.str = str;
	    this.dict = str.dict;
	    this.decrypt = decrypt;
	    this.nextChunk = null;
	    this.initialized = false;
	    DecodeStream.call(this, maybeLength);
	  }
	  var chunkSize = 512;
	  DecryptStream.prototype = Object.create(DecodeStream.prototype);
	  DecryptStream.prototype.readBlock = function DecryptStream_readBlock() {
	    var chunk;
	    if (this.initialized) {
	      chunk = this.nextChunk;
	    } else {
	      chunk = this.str.getBytes(chunkSize);
	      this.initialized = true;
	    }
	    if (!chunk || chunk.length === 0) {
	      this.eof = true;
	      return;
	    }
	    this.nextChunk = this.str.getBytes(chunkSize);
	    var hasMoreData = this.nextChunk && this.nextChunk.length > 0;
	    var decrypt = this.decrypt;
	    chunk = decrypt(chunk, !hasMoreData);
	    var bufferLength = this.bufferLength;
	    var i,
	        n = chunk.length;
	    var buffer = this.ensureBuffer(bufferLength + n);
	    for (i = 0; i < n; i++) {
	      buffer[bufferLength++] = chunk[i];
	    }
	    this.bufferLength = bufferLength;
	  };
	  return DecryptStream;
	}();
	var Ascii85Stream = function Ascii85StreamClosure() {
	  function Ascii85Stream(str, maybeLength) {
	    this.str = str;
	    this.dict = str.dict;
	    this.input = new Uint8Array(5);
	    if (maybeLength) {
	      maybeLength = 0.8 * maybeLength;
	    }
	    DecodeStream.call(this, maybeLength);
	  }
	  Ascii85Stream.prototype = Object.create(DecodeStream.prototype);
	  Ascii85Stream.prototype.readBlock = function Ascii85Stream_readBlock() {
	    var TILDA_CHAR = 0x7E;
	    var Z_LOWER_CHAR = 0x7A;
	    var EOF = -1;
	    var str = this.str;
	    var c = str.getByte();
	    while ((0, _util.isSpace)(c)) {
	      c = str.getByte();
	    }
	    if (c === EOF || c === TILDA_CHAR) {
	      this.eof = true;
	      return;
	    }
	    var bufferLength = this.bufferLength,
	        buffer;
	    var i;
	    if (c === Z_LOWER_CHAR) {
	      buffer = this.ensureBuffer(bufferLength + 4);
	      for (i = 0; i < 4; ++i) {
	        buffer[bufferLength + i] = 0;
	      }
	      this.bufferLength += 4;
	    } else {
	      var input = this.input;
	      input[0] = c;
	      for (i = 1; i < 5; ++i) {
	        c = str.getByte();
	        while ((0, _util.isSpace)(c)) {
	          c = str.getByte();
	        }
	        input[i] = c;
	        if (c === EOF || c === TILDA_CHAR) {
	          break;
	        }
	      }
	      buffer = this.ensureBuffer(bufferLength + i - 1);
	      this.bufferLength += i - 1;
	      if (i < 5) {
	        for (; i < 5; ++i) {
	          input[i] = 0x21 + 84;
	        }
	        this.eof = true;
	      }
	      var t = 0;
	      for (i = 0; i < 5; ++i) {
	        t = t * 85 + (input[i] - 0x21);
	      }
	      for (i = 3; i >= 0; --i) {
	        buffer[bufferLength + i] = t & 0xFF;
	        t >>= 8;
	      }
	    }
	  };
	  return Ascii85Stream;
	}();
	var AsciiHexStream = function AsciiHexStreamClosure() {
	  function AsciiHexStream(str, maybeLength) {
	    this.str = str;
	    this.dict = str.dict;
	    this.firstDigit = -1;
	    if (maybeLength) {
	      maybeLength = 0.5 * maybeLength;
	    }
	    DecodeStream.call(this, maybeLength);
	  }
	  AsciiHexStream.prototype = Object.create(DecodeStream.prototype);
	  AsciiHexStream.prototype.readBlock = function AsciiHexStream_readBlock() {
	    var UPSTREAM_BLOCK_SIZE = 8000;
	    var bytes = this.str.getBytes(UPSTREAM_BLOCK_SIZE);
	    if (!bytes.length) {
	      this.eof = true;
	      return;
	    }
	    var maxDecodeLength = bytes.length + 1 >> 1;
	    var buffer = this.ensureBuffer(this.bufferLength + maxDecodeLength);
	    var bufferLength = this.bufferLength;
	    var firstDigit = this.firstDigit;
	    for (var i = 0, ii = bytes.length; i < ii; i++) {
	      var ch = bytes[i],
	          digit;
	      if (ch >= 0x30 && ch <= 0x39) {
	        digit = ch & 0x0F;
	      } else if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) {
	        digit = (ch & 0x0F) + 9;
	      } else if (ch === 0x3E) {
	        this.eof = true;
	        break;
	      } else {
	        continue;
	      }
	      if (firstDigit < 0) {
	        firstDigit = digit;
	      } else {
	        buffer[bufferLength++] = firstDigit << 4 | digit;
	        firstDigit = -1;
	      }
	    }
	    if (firstDigit >= 0 && this.eof) {
	      buffer[bufferLength++] = firstDigit << 4;
	      firstDigit = -1;
	    }
	    this.firstDigit = firstDigit;
	    this.bufferLength = bufferLength;
	  };
	  return AsciiHexStream;
	}();
	var RunLengthStream = function RunLengthStreamClosure() {
	  function RunLengthStream(str, maybeLength) {
	    this.str = str;
	    this.dict = str.dict;
	    DecodeStream.call(this, maybeLength);
	  }
	  RunLengthStream.prototype = Object.create(DecodeStream.prototype);
	  RunLengthStream.prototype.readBlock = function RunLengthStream_readBlock() {
	    var repeatHeader = this.str.getBytes(2);
	    if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
	      this.eof = true;
	      return;
	    }
	    var buffer;
	    var bufferLength = this.bufferLength;
	    var n = repeatHeader[0];
	    if (n < 128) {
	      buffer = this.ensureBuffer(bufferLength + n + 1);
	      buffer[bufferLength++] = repeatHeader[1];
	      if (n > 0) {
	        var source = this.str.getBytes(n);
	        buffer.set(source, bufferLength);
	        bufferLength += n;
	      }
	    } else {
	      n = 257 - n;
	      var b = repeatHeader[1];
	      buffer = this.ensureBuffer(bufferLength + n + 1);
	      for (var i = 0; i < n; i++) {
	        buffer[bufferLength++] = b;
	      }
	    }
	    this.bufferLength = bufferLength;
	  };
	  return RunLengthStream;
	}();
	var LZWStream = function LZWStreamClosure() {
	  function LZWStream(str, maybeLength, earlyChange) {
	    this.str = str;
	    this.dict = str.dict;
	    this.cachedData = 0;
	    this.bitsCached = 0;
	    var maxLzwDictionarySize = 4096;
	    var lzwState = {
	      earlyChange: earlyChange,
	      codeLength: 9,
	      nextCode: 258,
	      dictionaryValues: new Uint8Array(maxLzwDictionarySize),
	      dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
	      dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
	      currentSequence: new Uint8Array(maxLzwDictionarySize),
	      currentSequenceLength: 0
	    };
	    for (var i = 0; i < 256; ++i) {
	      lzwState.dictionaryValues[i] = i;
	      lzwState.dictionaryLengths[i] = 1;
	    }
	    this.lzwState = lzwState;
	    DecodeStream.call(this, maybeLength);
	  }
	  LZWStream.prototype = Object.create(DecodeStream.prototype);
	  LZWStream.prototype.readBits = function LZWStream_readBits(n) {
	    var bitsCached = this.bitsCached;
	    var cachedData = this.cachedData;
	    while (bitsCached < n) {
	      var c = this.str.getByte();
	      if (c === -1) {
	        this.eof = true;
	        return null;
	      }
	      cachedData = cachedData << 8 | c;
	      bitsCached += 8;
	    }
	    this.bitsCached = bitsCached -= n;
	    this.cachedData = cachedData;
	    this.lastCode = null;
	    return cachedData >>> bitsCached & (1 << n) - 1;
	  };
	  LZWStream.prototype.readBlock = function LZWStream_readBlock() {
	    var blockSize = 512;
	    var estimatedDecodedSize = blockSize * 2,
	        decodedSizeDelta = blockSize;
	    var i, j, q;
	    var lzwState = this.lzwState;
	    if (!lzwState) {
	      return;
	    }
	    var earlyChange = lzwState.earlyChange;
	    var nextCode = lzwState.nextCode;
	    var dictionaryValues = lzwState.dictionaryValues;
	    var dictionaryLengths = lzwState.dictionaryLengths;
	    var dictionaryPrevCodes = lzwState.dictionaryPrevCodes;
	    var codeLength = lzwState.codeLength;
	    var prevCode = lzwState.prevCode;
	    var currentSequence = lzwState.currentSequence;
	    var currentSequenceLength = lzwState.currentSequenceLength;
	    var decodedLength = 0;
	    var currentBufferLength = this.bufferLength;
	    var buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
	    for (i = 0; i < blockSize; i++) {
	      var code = this.readBits(codeLength);
	      var hasPrev = currentSequenceLength > 0;
	      if (code < 256) {
	        currentSequence[0] = code;
	        currentSequenceLength = 1;
	      } else if (code >= 258) {
	        if (code < nextCode) {
	          currentSequenceLength = dictionaryLengths[code];
	          for (j = currentSequenceLength - 1, q = code; j >= 0; j--) {
	            currentSequence[j] = dictionaryValues[q];
	            q = dictionaryPrevCodes[q];
	          }
	        } else {
	          currentSequence[currentSequenceLength++] = currentSequence[0];
	        }
	      } else if (code === 256) {
	        codeLength = 9;
	        nextCode = 258;
	        currentSequenceLength = 0;
	        continue;
	      } else {
	        this.eof = true;
	        delete this.lzwState;
	        break;
	      }
	      if (hasPrev) {
	        dictionaryPrevCodes[nextCode] = prevCode;
	        dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
	        dictionaryValues[nextCode] = currentSequence[0];
	        nextCode++;
	        codeLength = nextCode + earlyChange & nextCode + earlyChange - 1 ? codeLength : Math.min(Math.log(nextCode + earlyChange) / 0.6931471805599453 + 1, 12) | 0;
	      }
	      prevCode = code;
	      decodedLength += currentSequenceLength;
	      if (estimatedDecodedSize < decodedLength) {
	        do {
	          estimatedDecodedSize += decodedSizeDelta;
	        } while (estimatedDecodedSize < decodedLength);
	        buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
	      }
	      for (j = 0; j < currentSequenceLength; j++) {
	        buffer[currentBufferLength++] = currentSequence[j];
	      }
	    }
	    lzwState.nextCode = nextCode;
	    lzwState.codeLength = codeLength;
	    lzwState.prevCode = prevCode;
	    lzwState.currentSequenceLength = currentSequenceLength;
	    this.bufferLength = currentBufferLength;
	  };
	  return LZWStream;
	}();
	var NullStream = function NullStreamClosure() {
	  function NullStream() {
	    Stream.call(this, new Uint8Array(0));
	  }
	  NullStream.prototype = Stream.prototype;
	  return NullStream;
	}();
	exports.Ascii85Stream = Ascii85Stream;
	exports.AsciiHexStream = AsciiHexStream;
	exports.DecryptStream = DecryptStream;
	exports.DecodeStream = DecodeStream;
	exports.FlateStream = FlateStream;
	exports.JpegStream = JpegStream;
	exports.JpxStream = JpxStream;
	exports.NullStream = NullStream;
	exports.PredictorStream = PredictorStream;
	exports.RunLengthStream = RunLengthStream;
	exports.Stream = Stream;
	exports.StreamsSequenceStream = StreamsSequenceStream;
	exports.StringStream = StringStream;
	exports.LZWStream = LZWStream;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var core = module.exports = { version: '2.5.7' };
	if (typeof __e == 'number') __e = core;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(1);
	var core = __w_pdfjs_require__(6);
	var hide = __w_pdfjs_require__(8);
	var redefine = __w_pdfjs_require__(16);
	var ctx = __w_pdfjs_require__(13);
	var PROTOTYPE = 'prototype';
	var $export = function $export(type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    own = !IS_FORCED && target && target[key] !== undefined;
	    out = (own ? target : source)[key];
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if (target) redefine(target, key, out, type & $export.U);
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	$export.F = 1;
	$export.G = 2;
	$export.S = 4;
	$export.P = 8;
	$export.B = 16;
	$export.W = 32;
	$export.U = 64;
	$export.R = 128;
	module.exports = $export;
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var dP = __w_pdfjs_require__(15);
	var createDesc = __w_pdfjs_require__(31);
	module.exports = __w_pdfjs_require__(10) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(3);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = !__w_pdfjs_require__(11)(function () {
	  return Object.defineProperty({}, 'a', {
	    get: function get() {
	      return 7;
	    }
	  }).a != 7;
	});
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var aFunction = __w_pdfjs_require__(24);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1:
	      return function (a) {
	        return fn.call(that, a);
	      };
	    case 2:
	      return function (a, b) {
	        return fn.call(that, a, b);
	      };
	    case 3:
	      return function (a, b, c) {
	        return fn.call(that, a, b, c);
	      };
	  }
	  return function () {
	    return fn.apply(that, arguments);
	  };
	};
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toInteger = __w_pdfjs_require__(19);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0;
	};
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var anObject = __w_pdfjs_require__(9);
	var IE8_DOM_DEFINE = __w_pdfjs_require__(51);
	var toPrimitive = __w_pdfjs_require__(38);
	var dP = Object.defineProperty;
	exports.f = __w_pdfjs_require__(10) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) {}
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(1);
	var hide = __w_pdfjs_require__(8);
	var has = __w_pdfjs_require__(12);
	var SRC = __w_pdfjs_require__(18)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	__w_pdfjs_require__(6).inspectSource = function (it) {
	  return $toString.call(it);
	};
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DOMSVGFactory = exports.DOMCMapReaderFactory = exports.DOMCanvasFactory = exports.DEFAULT_LINK_REL = exports.getDefaultSetting = exports.LinkTarget = exports.getFilenameFromUrl = exports.isValidUrl = exports.isExternalLinkTargetSet = exports.addLinkAttributes = exports.RenderingCancelledException = exports.CustomStyle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __w_pdfjs_require__(0);
	
	var _global_scope = __w_pdfjs_require__(22);
	
	var _global_scope2 = _interopRequireDefault(_global_scope);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_LINK_REL = 'noopener noreferrer nofollow';
	var SVG_NS = 'http://www.w3.org/2000/svg';
	
	var DOMCanvasFactory = function () {
	  function DOMCanvasFactory() {
	    _classCallCheck(this, DOMCanvasFactory);
	  }
	
	  _createClass(DOMCanvasFactory, [{
	    key: 'create',
	    value: function create(width, height) {
	      if (width <= 0 || height <= 0) {
	        throw new Error('invalid canvas size');
	      }
	      var canvas = document.createElement('canvas');
	      var context = canvas.getContext('2d');
	      canvas.width = width;
	      canvas.height = height;
	      return {
	        canvas: canvas,
	        context: context
	      };
	    }
	  }, {
	    key: 'reset',
	    value: function reset(canvasAndContext, width, height) {
	      if (!canvasAndContext.canvas) {
	        throw new Error('canvas is not specified');
	      }
	      if (width <= 0 || height <= 0) {
	        throw new Error('invalid canvas size');
	      }
	      canvasAndContext.canvas.width = width;
	      canvasAndContext.canvas.height = height;
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy(canvasAndContext) {
	      if (!canvasAndContext.canvas) {
	        throw new Error('canvas is not specified');
	      }
	      canvasAndContext.canvas.width = 0;
	      canvasAndContext.canvas.height = 0;
	      canvasAndContext.canvas = null;
	      canvasAndContext.context = null;
	    }
	  }]);
	
	  return DOMCanvasFactory;
	}();
	
	var DOMCMapReaderFactory = function () {
	  function DOMCMapReaderFactory(_ref) {
	    var _ref$baseUrl = _ref.baseUrl,
	        baseUrl = _ref$baseUrl === undefined ? null : _ref$baseUrl,
	        _ref$isCompressed = _ref.isCompressed,
	        isCompressed = _ref$isCompressed === undefined ? false : _ref$isCompressed;
	
	    _classCallCheck(this, DOMCMapReaderFactory);
	
	    this.baseUrl = baseUrl;
	    this.isCompressed = isCompressed;
	  }
	
	  _createClass(DOMCMapReaderFactory, [{
	    key: 'fetch',
	    value: function fetch(_ref2) {
	      var _this = this;
	
	      var name = _ref2.name;
	
	      if (!this.baseUrl) {
	        return Promise.reject(new Error('CMap baseUrl must be specified, ' + 'see "PDFJS.cMapUrl" (and also "PDFJS.cMapPacked").'));
	      }
	      if (!name) {
	        return Promise.reject(new Error('CMap name must be specified.'));
	      }
	      return new Promise(function (resolve, reject) {
	        var url = _this.baseUrl + name + (_this.isCompressed ? '.bcmap' : '');
	        var request = new XMLHttpRequest();
	        request.open('GET', url, true);
	        if (_this.isCompressed) {
	          request.responseType = 'arraybuffer';
	        }
	        request.onreadystatechange = function () {
	          if (request.readyState !== XMLHttpRequest.DONE) {
	            return;
	          }
	          if (request.status === 200 || request.status === 0) {
	            var data = void 0;
	            if (_this.isCompressed && request.response) {
	              data = new Uint8Array(request.response);
	            } else if (!_this.isCompressed && request.responseText) {
	              data = (0, _util.stringToBytes)(request.responseText);
	            }
	            if (data) {
	              resolve({
	                cMapData: data,
	                compressionType: _this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE
	              });
	              return;
	            }
	          }
	          reject(new Error('Unable to load ' + (_this.isCompressed ? 'binary ' : '') + 'CMap at: ' + url));
	        };
	        request.send(null);
	      });
	    }
	  }]);
	
	  return DOMCMapReaderFactory;
	}();
	
	var DOMSVGFactory = function () {
	  function DOMSVGFactory() {
	    _classCallCheck(this, DOMSVGFactory);
	  }
	
	  _createClass(DOMSVGFactory, [{
	    key: 'create',
	    value: function create(width, height) {
	      (0, _util.assert)(width > 0 && height > 0, 'Invalid SVG dimensions');
	      var svg = document.createElementNS(SVG_NS, 'svg:svg');
	      svg.setAttribute('version', '1.1');
	      svg.setAttribute('width', width + 'px');
	      svg.setAttribute('height', height + 'px');
	      svg.setAttribute('preserveAspectRatio', 'none');
	      svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
	      return svg;
	    }
	  }, {
	    key: 'createElement',
	    value: function createElement(type) {
	      (0, _util.assert)(typeof type === 'string', 'Invalid SVG element type');
	      return document.createElementNS(SVG_NS, type);
	    }
	  }]);
	
	  return DOMSVGFactory;
	}();
	
	var CustomStyle = function CustomStyleClosure() {
	  var prefixes = ['ms', 'Moz', 'Webkit', 'O'];
	  var _cache = Object.create(null);
	  function CustomStyle() {}
	  CustomStyle.getProp = function get(propName, element) {
	    if (arguments.length === 1 && typeof _cache[propName] === 'string') {
	      return _cache[propName];
	    }
	    element = element || document.documentElement;
	    var style = element.style,
	        prefixed,
	        uPropName;
	    if (typeof style[propName] === 'string') {
	      return _cache[propName] = propName;
	    }
	    uPropName = propName.charAt(0).toUpperCase() + propName.slice(1);
	    for (var i = 0, l = prefixes.length; i < l; i++) {
	      prefixed = prefixes[i] + uPropName;
	      if (typeof style[prefixed] === 'string') {
	        return _cache[propName] = prefixed;
	      }
	    }
	    return _cache[propName] = 'undefined';
	  };
	  CustomStyle.setProp = function set(propName, element, str) {
	    var prop = this.getProp(propName);
	    if (prop !== 'undefined') {
	      element.style[prop] = str;
	    }
	  };
	  return CustomStyle;
	}();
	var RenderingCancelledException = function RenderingCancelledException() {
	  function RenderingCancelledException(msg, type) {
	    this.message = msg;
	    this.type = type;
	  }
	  RenderingCancelledException.prototype = new Error();
	  RenderingCancelledException.prototype.name = 'RenderingCancelledException';
	  RenderingCancelledException.constructor = RenderingCancelledException;
	  return RenderingCancelledException;
	}();
	var LinkTarget = {
	  NONE: 0,
	  SELF: 1,
	  BLANK: 2,
	  PARENT: 3,
	  TOP: 4
	};
	var LinkTargetStringMap = ['', '_self', '_blank', '_parent', '_top'];
	function addLinkAttributes(link, params) {
	  var url = params && params.url;
	  link.href = link.title = url ? (0, _util.removeNullCharacters)(url) : '';
	  if (url) {
	    var target = params.target;
	    if (typeof target === 'undefined') {
	      target = getDefaultSetting('externalLinkTarget');
	    }
	    link.target = LinkTargetStringMap[target];
	    var rel = params.rel;
	    if (typeof rel === 'undefined') {
	      rel = getDefaultSetting('externalLinkRel');
	    }
	    link.rel = rel;
	  }
	}
	function getFilenameFromUrl(url) {
	  var anchor = url.indexOf('#');
	  var query = url.indexOf('?');
	  var end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
	  return url.substring(url.lastIndexOf('/', end) + 1, end);
	}
	function getDefaultSetting(id) {
	  var globalSettings = _global_scope2.default.PDFJS;
	  switch (id) {
	    case 'pdfBug':
	      return globalSettings ? globalSettings.pdfBug : false;
	    case 'disableAutoFetch':
	      return globalSettings ? globalSettings.disableAutoFetch : false;
	    case 'disableStream':
	      return globalSettings ? globalSettings.disableStream : false;
	    case 'disableRange':
	      return globalSettings ? globalSettings.disableRange : false;
	    case 'disableFontFace':
	      return globalSettings ? globalSettings.disableFontFace : false;
	    case 'disableCreateObjectURL':
	      return globalSettings ? globalSettings.disableCreateObjectURL : false;
	    case 'disableWebGL':
	      return globalSettings ? globalSettings.disableWebGL : true;
	    case 'cMapUrl':
	      return globalSettings ? globalSettings.cMapUrl : null;
	    case 'cMapPacked':
	      return globalSettings ? globalSettings.cMapPacked : false;
	    case 'postMessageTransfers':
	      return globalSettings ? globalSettings.postMessageTransfers : true;
	    case 'workerPort':
	      return globalSettings ? globalSettings.workerPort : null;
	    case 'workerSrc':
	      return globalSettings ? globalSettings.workerSrc : null;
	    case 'disableWorker':
	      return globalSettings ? globalSettings.disableWorker : false;
	    case 'maxImageSize':
	      return globalSettings ? globalSettings.maxImageSize : -1;
	    case 'imageResourcesPath':
	      return globalSettings ? globalSettings.imageResourcesPath : '';
	    case 'isEvalSupported':
	      return globalSettings ? globalSettings.isEvalSupported : true;
	    case 'externalLinkTarget':
	      if (!globalSettings) {
	        return LinkTarget.NONE;
	      }
	      switch (globalSettings.externalLinkTarget) {
	        case LinkTarget.NONE:
	        case LinkTarget.SELF:
	        case LinkTarget.BLANK:
	        case LinkTarget.PARENT:
	        case LinkTarget.TOP:
	          return globalSettings.externalLinkTarget;
	      }
	      (0, _util.warn)('PDFJS.externalLinkTarget is invalid: ' + globalSettings.externalLinkTarget);
	      globalSettings.externalLinkTarget = LinkTarget.NONE;
	      return LinkTarget.NONE;
	    case 'externalLinkRel':
	      return globalSettings ? globalSettings.externalLinkRel : DEFAULT_LINK_REL;
	    case 'enableStats':
	      return !!(globalSettings && globalSettings.enableStats);
	    case 'pdfjsNext':
	      return !!(globalSettings && globalSettings.pdfjsNext);
	    default:
	      throw new Error('Unknown default setting: ' + id);
	  }
	}
	function isExternalLinkTargetSet() {
	  var externalLinkTarget = getDefaultSetting('externalLinkTarget');
	  switch (externalLinkTarget) {
	    case LinkTarget.NONE:
	      return false;
	    case LinkTarget.SELF:
	    case LinkTarget.BLANK:
	    case LinkTarget.PARENT:
	    case LinkTarget.TOP:
	      return true;
	  }
	}
	function isValidUrl(url, allowRelative) {
	  (0, _util.deprecated)('isValidUrl(), please use createValidAbsoluteUrl() instead.');
	  var baseUrl = allowRelative ? 'http://example.com' : null;
	  return (0, _util.createValidAbsoluteUrl)(url, baseUrl) !== null;
	}
	exports.CustomStyle = CustomStyle;
	exports.RenderingCancelledException = RenderingCancelledException;
	exports.addLinkAttributes = addLinkAttributes;
	exports.isExternalLinkTargetSet = isExternalLinkTargetSet;
	exports.isValidUrl = isValidUrl;
	exports.getFilenameFromUrl = getFilenameFromUrl;
	exports.LinkTarget = LinkTarget;
	exports.getDefaultSetting = getDefaultSetting;
	exports.DEFAULT_LINK_REL = DEFAULT_LINK_REL;
	exports.DOMCanvasFactory = DOMCanvasFactory;
	exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
	exports.DOMSVGFactory = DOMSVGFactory;
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var defined = __w_pdfjs_require__(40);
	module.exports = function (it) {
	  return Object(defined(it));
	};
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = {};
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = typeof window !== 'undefined' && window.Math === Math ? window : typeof global !== 'undefined' && global.Math === Math ? global : typeof self !== 'undefined' && self.Math === Math ? self : {};
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = false;
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var redefine = __w_pdfjs_require__(16);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    redefine(target, key, src[key], safe);
	  }return target;
	};
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
	    throw TypeError(name + ': incorrect invocation!');
	  }
	  return it;
	};
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toString = {}.toString;
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var def = __w_pdfjs_require__(15).f;
	var has = __w_pdfjs_require__(12);
	var TAG = __w_pdfjs_require__(4)('toStringTag');
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
	    configurable: true,
	    value: tag
	  });
	};
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorSpace = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _primitives = __w_pdfjs_require__(2);
	
	var ColorSpace = function ColorSpaceClosure() {
	  function resizeRgbImage(src, bpc, w1, h1, w2, h2, alpha01, dest) {
	    var COMPONENTS = 3;
	    alpha01 = alpha01 !== 1 ? 0 : alpha01;
	    var xRatio = w1 / w2;
	    var yRatio = h1 / h2;
	    var i,
	        j,
	        py,
	        newIndex = 0,
	        oldIndex;
	    var xScaled = new Uint16Array(w2);
	    var w1Scanline = w1 * COMPONENTS;
	    for (i = 0; i < w2; i++) {
	      xScaled[i] = Math.floor(i * xRatio) * COMPONENTS;
	    }
	    for (i = 0; i < h2; i++) {
	      py = Math.floor(i * yRatio) * w1Scanline;
	      for (j = 0; j < w2; j++) {
	        oldIndex = py + xScaled[j];
	        dest[newIndex++] = src[oldIndex++];
	        dest[newIndex++] = src[oldIndex++];
	        dest[newIndex++] = src[oldIndex++];
	        newIndex += alpha01;
	      }
	    }
	  }
	  function ColorSpace() {
	    throw new Error('should not call ColorSpace constructor');
	  }
	  ColorSpace.prototype = {
	    getRgb: function ColorSpace_getRgb(src, srcOffset) {
	      var rgb = new Uint8Array(3);
	      this.getRgbItem(src, srcOffset, rgb, 0);
	      return rgb;
	    },
	    getRgbItem: function ColorSpace_getRgbItem(src, srcOffset, dest, destOffset) {
	      throw new Error('Should not call ColorSpace.getRgbItem');
	    },
	    getRgbBuffer: function ColorSpace_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
	      throw new Error('Should not call ColorSpace.getRgbBuffer');
	    },
	    getOutputLength: function ColorSpace_getOutputLength(inputLength, alpha01) {
	      throw new Error('Should not call ColorSpace.getOutputLength');
	    },
	    isPassthrough: function ColorSpace_isPassthrough(bits) {
	      return false;
	    },
	    fillRgb: function ColorSpace_fillRgb(dest, originalWidth, originalHeight, width, height, actualHeight, bpc, comps, alpha01) {
	      var count = originalWidth * originalHeight;
	      var rgbBuf = null;
	      var numComponentColors = 1 << bpc;
	      var needsResizing = originalHeight !== height || originalWidth !== width;
	      var i, ii;
	      if (this.isPassthrough(bpc)) {
	        rgbBuf = comps;
	      } else if (this.numComps === 1 && count > numComponentColors && this.name !== 'DeviceGray' && this.name !== 'DeviceRGB') {
	        var allColors = bpc <= 8 ? new Uint8Array(numComponentColors) : new Uint16Array(numComponentColors);
	        var key;
	        for (i = 0; i < numComponentColors; i++) {
	          allColors[i] = i;
	        }
	        var colorMap = new Uint8Array(numComponentColors * 3);
	        this.getRgbBuffer(allColors, 0, numComponentColors, colorMap, 0, bpc, 0);
	        var destPos, rgbPos;
	        if (!needsResizing) {
	          destPos = 0;
	          for (i = 0; i < count; ++i) {
	            key = comps[i] * 3;
	            dest[destPos++] = colorMap[key];
	            dest[destPos++] = colorMap[key + 1];
	            dest[destPos++] = colorMap[key + 2];
	            destPos += alpha01;
	          }
	        } else {
	          rgbBuf = new Uint8Array(count * 3);
	          rgbPos = 0;
	          for (i = 0; i < count; ++i) {
	            key = comps[i] * 3;
	            rgbBuf[rgbPos++] = colorMap[key];
	            rgbBuf[rgbPos++] = colorMap[key + 1];
	            rgbBuf[rgbPos++] = colorMap[key + 2];
	          }
	        }
	      } else {
	        if (!needsResizing) {
	          this.getRgbBuffer(comps, 0, width * actualHeight, dest, 0, bpc, alpha01);
	        } else {
	          rgbBuf = new Uint8Array(count * 3);
	          this.getRgbBuffer(comps, 0, count, rgbBuf, 0, bpc, 0);
	        }
	      }
	      if (rgbBuf) {
	        if (needsResizing) {
	          resizeRgbImage(rgbBuf, bpc, originalWidth, originalHeight, width, height, alpha01, dest);
	        } else {
	          rgbPos = 0;
	          destPos = 0;
	          for (i = 0, ii = width * actualHeight; i < ii; i++) {
	            dest[destPos++] = rgbBuf[rgbPos++];
	            dest[destPos++] = rgbBuf[rgbPos++];
	            dest[destPos++] = rgbBuf[rgbPos++];
	            destPos += alpha01;
	          }
	        }
	      }
	    },
	    usesZeroToOneRange: true
	  };
	  ColorSpace.parse = function (cs, xref, res, pdfFunctionFactory) {
	    var IR = ColorSpace.parseToIR(cs, xref, res, pdfFunctionFactory);
	    return ColorSpace.fromIR(IR);
	  };
	  ColorSpace.fromIR = function (IR) {
	    var name = Array.isArray(IR) ? IR[0] : IR;
	    var whitePoint, blackPoint, gamma;
	    switch (name) {
	      case 'DeviceGrayCS':
	        return this.singletons.gray;
	      case 'DeviceRgbCS':
	        return this.singletons.rgb;
	      case 'DeviceCmykCS':
	        return this.singletons.cmyk;
	      case 'CalGrayCS':
	        whitePoint = IR[1];
	        blackPoint = IR[2];
	        gamma = IR[3];
	        return new CalGrayCS(whitePoint, blackPoint, gamma);
	      case 'CalRGBCS':
	        whitePoint = IR[1];
	        blackPoint = IR[2];
	        gamma = IR[3];
	        var matrix = IR[4];
	        return new CalRGBCS(whitePoint, blackPoint, gamma, matrix);
	      case 'PatternCS':
	        var basePatternCS = IR[1];
	        if (basePatternCS) {
	          basePatternCS = ColorSpace.fromIR(basePatternCS);
	        }
	        return new PatternCS(basePatternCS);
	      case 'IndexedCS':
	        var baseIndexedCS = IR[1];
	        var hiVal = IR[2];
	        var lookup = IR[3];
	        return new IndexedCS(ColorSpace.fromIR(baseIndexedCS), hiVal, lookup);
	      case 'AlternateCS':
	        var numComps = IR[1];
	        var alt = IR[2];
	        var tintFn = IR[3];
	        return new AlternateCS(numComps, ColorSpace.fromIR(alt), tintFn);
	      case 'LabCS':
	        whitePoint = IR[1];
	        blackPoint = IR[2];
	        var range = IR[3];
	        return new LabCS(whitePoint, blackPoint, range);
	      default:
	        throw new _util.FormatError('Unknown colorspace name: ' + name);
	    }
	  };
	  ColorSpace.parseToIR = function (cs, xref, res, pdfFunctionFactory) {
	    if ((0, _primitives.isName)(cs)) {
	      var colorSpaces = res.get('ColorSpace');
	      if ((0, _primitives.isDict)(colorSpaces)) {
	        var refcs = colorSpaces.get(cs.name);
	        if (refcs) {
	          cs = refcs;
	        }
	      }
	    }
	    cs = xref.fetchIfRef(cs);
	    if ((0, _primitives.isName)(cs)) {
	      switch (cs.name) {
	        case 'DeviceGray':
	        case 'G':
	          return 'DeviceGrayCS';
	        case 'DeviceRGB':
	        case 'RGB':
	          return 'DeviceRgbCS';
	        case 'DeviceCMYK':
	        case 'CMYK':
	          return 'DeviceCmykCS';
	        case 'Pattern':
	          return ['PatternCS', null];
	        default:
	          throw new _util.FormatError('unrecognized colorspace ' + cs.name);
	      }
	    }
	    if (Array.isArray(cs)) {
	      var mode = xref.fetchIfRef(cs[0]).name;
	      var numComps, params, alt, whitePoint, blackPoint, gamma;
	      switch (mode) {
	        case 'DeviceGray':
	        case 'G':
	          return 'DeviceGrayCS';
	        case 'DeviceRGB':
	        case 'RGB':
	          return 'DeviceRgbCS';
	        case 'DeviceCMYK':
	        case 'CMYK':
	          return 'DeviceCmykCS';
	        case 'CalGray':
	          params = xref.fetchIfRef(cs[1]);
	          whitePoint = params.getArray('WhitePoint');
	          blackPoint = params.getArray('BlackPoint');
	          gamma = params.get('Gamma');
	          return ['CalGrayCS', whitePoint, blackPoint, gamma];
	        case 'CalRGB':
	          params = xref.fetchIfRef(cs[1]);
	          whitePoint = params.getArray('WhitePoint');
	          blackPoint = params.getArray('BlackPoint');
	          gamma = params.getArray('Gamma');
	          var matrix = params.getArray('Matrix');
	          return ['CalRGBCS', whitePoint, blackPoint, gamma, matrix];
	        case 'ICCBased':
	          var stream = xref.fetchIfRef(cs[1]);
	          var dict = stream.dict;
	          numComps = dict.get('N');
	          alt = dict.get('Alternate');
	          if (alt) {
	            var altIR = ColorSpace.parseToIR(alt, xref, res, pdfFunctionFactory);
	            var altCS = ColorSpace.fromIR(altIR, pdfFunctionFactory);
	            if (altCS.numComps === numComps) {
	              return altIR;
	            }
	            (0, _util.warn)('ICCBased color space: Ignoring incorrect /Alternate entry.');
	          }
	          if (numComps === 1) {
	            return 'DeviceGrayCS';
	          } else if (numComps === 3) {
	            return 'DeviceRgbCS';
	          } else if (numComps === 4) {
	            return 'DeviceCmykCS';
	          }
	          break;
	        case 'Pattern':
	          var basePatternCS = cs[1] || null;
	          if (basePatternCS) {
	            basePatternCS = ColorSpace.parseToIR(basePatternCS, xref, res, pdfFunctionFactory);
	          }
	          return ['PatternCS', basePatternCS];
	        case 'Indexed':
	        case 'I':
	          var baseIndexedCS = ColorSpace.parseToIR(cs[1], xref, res, pdfFunctionFactory);
	          var hiVal = xref.fetchIfRef(cs[2]) + 1;
	          var lookup = xref.fetchIfRef(cs[3]);
	          if ((0, _primitives.isStream)(lookup)) {
	            lookup = lookup.getBytes();
	          }
	          return ['IndexedCS', baseIndexedCS, hiVal, lookup];
	        case 'Separation':
	        case 'DeviceN':
	          var name = xref.fetchIfRef(cs[1]);
	          numComps = Array.isArray(name) ? name.length : 1;
	          alt = ColorSpace.parseToIR(cs[2], xref, res, pdfFunctionFactory);
	          var tintFn = pdfFunctionFactory.create(xref.fetchIfRef(cs[3]));
	          return ['AlternateCS', numComps, alt, tintFn];
	        case 'Lab':
	          params = xref.fetchIfRef(cs[1]);
	          whitePoint = params.getArray('WhitePoint');
	          blackPoint = params.getArray('BlackPoint');
	          var range = params.getArray('Range');
	          return ['LabCS', whitePoint, blackPoint, range];
	        default:
	          throw new _util.FormatError('unimplemented color space object "' + mode + '"');
	      }
	    }
	    throw new _util.FormatError('unrecognized color space object: "' + cs + '"');
	  };
	  ColorSpace.isDefaultDecode = function ColorSpace_isDefaultDecode(decode, n) {
	    if (!Array.isArray(decode)) {
	      return true;
	    }
	    if (n * 2 !== decode.length) {
	      (0, _util.warn)('The decode map is not the correct length');
	      return true;
	    }
	    for (var i = 0, ii = decode.length; i < ii; i += 2) {
	      if (decode[i] !== 0 || decode[i + 1] !== 1) {
	        return false;
	      }
	    }
	    return true;
	  };
	  ColorSpace.singletons = {
	    get gray() {
	      return (0, _util.shadow)(this, 'gray', new DeviceGrayCS());
	    },
	    get rgb() {
	      return (0, _util.shadow)(this, 'rgb', new DeviceRgbCS());
	    },
	    get cmyk() {
	      return (0, _util.shadow)(this, 'cmyk', new DeviceCmykCS());
	    }
	  };
	  return ColorSpace;
	}();
	var AlternateCS = function AlternateCSClosure() {
	  function AlternateCS(numComps, base, tintFn) {
	    this.name = 'Alternate';
	    this.numComps = numComps;
	    this.defaultColor = new Float32Array(numComps);
	    for (var i = 0; i < numComps; ++i) {
	      this.defaultColor[i] = 1;
	    }
	    this.base = base;
	    this.tintFn = tintFn;
	    this.tmpBuf = new Float32Array(base.numComps);
	  }
	  AlternateCS.prototype = {
	    getRgb: ColorSpace.prototype.getRgb,
	    getRgbItem: function AlternateCS_getRgbItem(src, srcOffset, dest, destOffset) {
	      var tmpBuf = this.tmpBuf;
	      this.tintFn(src, srcOffset, tmpBuf, 0);
	      this.base.getRgbItem(tmpBuf, 0, dest, destOffset);
	    },
	    getRgbBuffer: function AlternateCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
	      var tintFn = this.tintFn;
	      var base = this.base;
	      var scale = 1 / ((1 << bits) - 1);
	      var baseNumComps = base.numComps;
	      var usesZeroToOneRange = base.usesZeroToOneRange;
	      var isPassthrough = (base.isPassthrough(8) || !usesZeroToOneRange) && alpha01 === 0;
	      var pos = isPassthrough ? destOffset : 0;
	      var baseBuf = isPassthrough ? dest : new Uint8Array(baseNumComps * count);
	      var numComps = this.numComps;
	      var scaled = new Float32Array(numComps);
	      var tinted = new Float32Array(baseNumComps);
	      var i, j;
	      for (i = 0; i < count; i++) {
	        for (j = 0; j < numComps; j++) {
	          scaled[j] = src[srcOffset++] * scale;
	        }
	        tintFn(scaled, 0, tinted, 0);
	        if (usesZeroToOneRange) {
	          for (j = 0; j < baseNumComps; j++) {
	            baseBuf[pos++] = tinted[j] * 255;
	          }
	        } else {
	          base.getRgbItem(tinted, 0, baseBuf, pos);
	          pos += baseNumComps;
	        }
	      }
	      if (!isPassthrough) {
	        base.getRgbBuffer(baseBuf, 0, count, dest, destOffset, 8, alpha01);
	      }
	    },
	    getOutputLength: function AlternateCS_getOutputLength(inputLength, alpha01) {
	      return this.base.getOutputLength(inputLength * this.base.numComps / this.numComps, alpha01);
	    },
	    isPassthrough: ColorSpace.prototype.isPassthrough,
	    fillRgb: ColorSpace.prototype.fillRgb,
	    isDefaultDecode: function AlternateCS_isDefaultDecode(decodeMap) {
	      return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
	    },
	    usesZeroToOneRange: true
	  };
	  return AlternateCS;
	}();
	var PatternCS = function PatternCSClosure() {
	  function PatternCS(baseCS) {
	    this.name = 'Pattern';
	    this.base = baseCS;
	  }
	  PatternCS.prototype = {};
	  return PatternCS;
	}();
	var IndexedCS = function IndexedCSClosure() {
	  function IndexedCS(base, highVal, lookup) {
	    this.name = 'Indexed';
	    this.numComps = 1;
	    this.defaultColor = new Uint8Array(this.numComps);
	    this.base = base;
	    this.highVal = highVal;
	    var baseNumComps = base.numComps;
	    var length = baseNumComps * highVal;
	    if ((0, _primitives.isStream)(lookup)) {
	      this.lookup = new Uint8Array(length);
	      var bytes = lookup.getBytes(length);
	      this.lookup.set(bytes);
	    } else if ((0, _util.isString)(lookup)) {
	      this.lookup = new Uint8Array(length);
	      for (var i = 0; i < length; ++i) {
	        this.lookup[i] = lookup.charCodeAt(i);
	      }
	    } else if (lookup instanceof Uint8Array || lookup instanceof Array) {
	      this.lookup = lookup;
	    } else {
	      throw new _util.FormatError('Unrecognized lookup table: ' + lookup);
	    }
	  }
	  IndexedCS.prototype = {
	    getRgb: ColorSpace.prototype.getRgb,
	    getRgbItem: function IndexedCS_getRgbItem(src, srcOffset, dest, destOffset) {
	      var numComps = this.base.numComps;
	      var start = src[srcOffset] * numComps;
	      this.base.getRgbBuffer(this.lookup, start, 1, dest, destOffset, 8, 0);
	    },
	    getRgbBuffer: function IndexedCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
	      var base = this.base;
	      var numComps = base.numComps;
	      var outputDelta = base.getOutputLength(numComps, alpha01);
	      var lookup = this.lookup;
	      for (var i = 0; i < count; ++i) {
	        var lookupPos = src[srcOffset++] * numComps;
	        base.getRgbBuffer(lookup, lookupPos, 1, dest, destOffset, 8, alpha01);
	        destOffset += outputDelta;
	      }
	    },
	    getOutputLength: function IndexedCS_getOutputLength(inputLength, alpha01) {
	      return this.base.getOutputLength(inputLength * this.base.numComps, alpha01);
	    },
	    isPassthrough: ColorSpace.prototype.isPassthrough,
	    fillRgb: ColorSpace.prototype.fillRgb,
	    isDefaultDecode: function IndexedCS_isDefaultDecode(decodeMap) {
	      return true;
	    },
	    usesZeroToOneRange: true
	  };
	  return IndexedCS;
	}();
	var DeviceGrayCS = function DeviceGrayCSClosure() {
	  function DeviceGrayCS() {
	    this.name = 'DeviceGray';
	    this.numComps = 1;
	    this.defaultColor = new Float32Array(this.numComps);
	  }
	  DeviceGrayCS.prototype = {
	    getRgb: ColorSpace.prototype.getRgb,
	    getRgbItem: function DeviceGrayCS_getRgbItem(src, srcOffset, dest, destOffset) {
	      var c = src[srcOffset] * 255 | 0;
	      c = c < 0 ? 0 : c > 255 ? 255 : c;
	      dest[destOffset] = dest[destOffset + 1] = dest[destOffset + 2] = c;
	    },
	    getRgbBuffer: function DeviceGrayCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
	      var scale = 255 / ((1 << bits) - 1);
	      var j = srcOffset,
	          q = destOffset;
	      for (var i = 0; i < count; ++i) {
	        var c = scale * src[j++] | 0;
	        dest[q++] = c;
	        dest[q++] = c;
	        dest[q++] = c;
	        q += alpha01;
	      }
	    },
	    getOutputLength: function DeviceGrayCS_getOutputLength(inputLength, alpha01) {
	      return inputLength * (3 + alpha01);
	    },
	    isPassthrough: ColorSpace.prototype.isPassthrough,
	    fillRgb: ColorSpace.prototype.fillRgb,
	    isDefaultDecode: function DeviceGrayCS_isDefaultDecode(decodeMap) {
	      return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
	    },
	    usesZeroToOneRange: true
	  };
	  return DeviceGrayCS;
	}();
	var DeviceRgbCS = function DeviceRgbCSClosure() {
	  function DeviceRgbCS() {
	    this.name = 'DeviceRGB';
	    this.numComps = 3;
	    this.defaultColor = new Float32Array(this.numComps);
	  }
	  DeviceRgbCS.prototype = {
	    getRgb: ColorSpace.prototype.getRgb,
	    getRgbItem: function DeviceRgbCS_getRgbItem(src, srcOffset, dest, destOffset) {
	      var r = src[srcOffset] * 255 | 0;
	      var g = src[srcOffset + 1] * 255 | 0;
	      var b = src[srcOffset + 2] * 255 | 0;
	      dest[destOffset] = r < 0 ? 0 : r > 255 ? 255 : r;
	      dest[destOffset + 1] = g < 0 ? 0 : g > 255 ? 255 : g;
	      dest[destOffset + 2] = b < 0 ? 0 : b > 255 ? 255 : b;
	    },
	    getRgbBuffer: function DeviceRgbCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
	      if (bits === 8 && alpha01 === 0) {
	        dest.set(src.subarray(srcOffset, srcOffset + count * 3), destOffset);
	        return;
	      }
	      var scale = 255 / ((1 << bits) - 1);
	      var j = srcOffset,
	          q = destOffset;
	      for (var i = 0; i < count; ++i) {
	        dest[q++] = scale * src[j++] | 0;
	        dest[q++] = scale * src[j++] | 0;
	        dest[q++] = scale * src[j++] | 0;
	        q += alpha01;
	      }
	    },
	    getOutputLength: function DeviceRgbCS_getOutputLength(inputLength, alpha01) {
	      return inputLength * (3 + alpha01) / 3 | 0;
	    },
	    isPassthrough: function DeviceRgbCS_isPassthrough(bits) {
	      return bits === 8;
	    },
	    fillRgb: ColorSpace.prototype.fillRgb,
	    isDefaultDecode: function DeviceRgbCS_isDefaultDecode(decodeMap) {
	      return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
	    },
	    usesZeroToOneRange: true
	  };
	  return DeviceRgbCS;
	}();
	var DeviceCmykCS = function DeviceCmykCSClosure() {
	  function convertToRgb(src, srcOffset, srcScale, dest, destOffset) {
	    var c = src[srcOffset + 0] * srcScale;
	    var m = src[srcOffset + 1] * srcScale;
	    var y = src[srcOffset + 2] * srcScale;
	    var k = src[srcOffset + 3] * srcScale;
	    var r = c * (-4.387332384609988 * c + 54.48615194189176 * m + 18.82290502165302 * y + 212.25662451639585 * k + -285.2331026137004) + m * (1.7149763477362134 * m - 5.6096736904047315 * y + -17.873870861415444 * k - 5.497006427196366) + y * (-2.5217340131683033 * y - 21.248923337353073 * k + 17.5119270841813) + k * (-21.86122147463605 * k - 189.48180835922747) + 255 | 0;
	    var g = c * (8.841041422036149 * c + 60.118027045597366 * m + 6.871425592049007 * y + 31.159100130055922 * k + -79.2970844816548) + m * (-15.310361306967817 * m + 17.575251261109482 * y + 131.35250912493976 * k - 190.9453302588951) + y * (4.444339102852739 * y + 9.8632861493405 * k - 24.86741582555878) + k * (-20.737325471181034 * k - 187.80453709719578) + 255 | 0;
	    var b = c * (0.8842522430003296 * c + 8.078677503112928 * m + 30.89978309703729 * y - 0.23883238689178934 * k + -14.183576799673286) + m * (10.49593273432072 * m + 63.02378494754052 * y + 50.606957656360734 * k - 112.23884253719248) + y * (0.03296041114873217 * y + 115.60384449646641 * k + -193.58209356861505) + k * (-22.33816807309886 * k - 180.12613974708367) + 255 | 0;
	    dest[destOffset] = r > 255 ? 255 : r < 0 ? 0 : r;
	    dest[destOffset + 1] = g > 255 ? 255 : g < 0 ? 0 : g;
	    dest[destOffset + 2] = b > 255 ? 255 : b < 0 ? 0 : b;
	  }
	  function DeviceCmykCS() {
	    this.name = 'DeviceCMYK';
	    this.numComps = 4;
	    this.defaultColor = new Float32Array(this.numComps);
	    this.defaultColor[3] = 1;
	  }
	  DeviceCmykCS.prototype = {
	    getRgb: ColorSpace.prototype.getRgb,
	    getRgbItem: function DeviceCmykCS_getRgbItem(src, srcOffset, dest, destOffset) {
	      convertToRgb(src, srcOffset, 1, dest, destOffset);
	    },
	    getRgbBuffer: function DeviceCmykCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
	      var scale = 1 / ((1 << bits) - 1);
	      for (var i = 0; i < count; i++) {
	        convertToRgb(src, srcOffset, scale, dest, destOffset);
	        srcOffset += 4;
	        destOffset += 3 + alpha01;
	      }
	    },
	    getOutputLength: function DeviceCmykCS_getOutputLength(inputLength, alpha01) {
	      return inputLength / 4 * (3 + alpha01) | 0;
	    },
	    isPassthrough: ColorSpace.prototype.isPassthrough,
	    fillRgb: ColorSpace.prototype.fillRgb,
	    isDefaultDecode: function DeviceCmykCS_isDefaultDecode(decodeMap) {
	      return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
	    },
	    usesZeroToOneRange: true
	  };
	  return DeviceCmykCS;
	}();
	var CalGrayCS = function CalGrayCSClosure() {
	  function CalGrayCS(whitePoint, blackPoint, gamma) {
	    this.name = 'CalGray';
	    this.numComps = 1;
	    this.defaultColor = new Float32Array(this.numComps);
	    if (!whitePoint) {
	      throw new _util.FormatError('WhitePoint missing - required for color space CalGray');
	    }
	    blackPoint = blackPoint || [0, 0, 0];
	    gamma = gamma || 1;
	    this.XW = whitePoint[0];
	    this.YW = whitePoint[1];
	    this.ZW = whitePoint[2];
	    this.XB = blackPoint[0];
	    this.YB = blackPoint[1];
	    this.ZB = blackPoint[2];
	    this.G = gamma;
	    if (this.XW < 0 || this.ZW < 0 || this.YW !== 1) {
	      throw new _util.FormatError('Invalid WhitePoint components for ' + this.name + ', no fallback available');
	    }
	    if (this.XB < 0 || this.YB < 0 || this.ZB < 0) {
	      (0, _util.info)('Invalid BlackPoint for ' + this.name + ', falling back to default');
	      this.XB = this.YB = this.ZB = 0;
	    }
	    if (this.XB !== 0 || this.YB !== 0 || this.ZB !== 0) {
	      (0, _util.warn)(this.name + ', BlackPoint: XB: ' + this.XB + ', YB: ' + this.YB + ', ZB: ' + this.ZB + ', only default values are supported.');
	    }
	    if (this.G < 1) {
	      (0, _util.info)('Invalid Gamma: ' + this.G + ' for ' + this.name + ', falling back to default');
	      this.G = 1;
	    }
	  }
	  function convertToRgb(cs, src, srcOffset, dest, destOffset, scale) {
	    var A = src[srcOffset] * scale;
	    var AG = Math.pow(A, cs.G);
	    var L = cs.YW * AG;
	    var val = Math.max(295.8 * Math.pow(L, 0.333333333333333333) - 40.8, 0) | 0;
	    dest[destOffset] = val;
	    dest[destOffset + 1] = val;
	    dest[destOffset + 2] = val;
	  }
	  CalGrayCS.prototype = {
	    getRgb: ColorSpace.prototype.getRgb,
	    getRgbItem: function CalGrayCS_getRgbItem(src, srcOffset, dest, destOffset) {
	      convertToRgb(this, src, srcOffset, dest, destOffset, 1);
	    },
	    getRgbBuffer: function CalGrayCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
	      var scale = 1 / ((1 << bits) - 1);
	      for (var i = 0; i < count; ++i) {
	        convertToRgb(this, src, srcOffset, dest, destOffset, scale);
	        srcOffset += 1;
	        destOffset += 3 + alpha01;
	      }
	    },
	    getOutputLength: function CalGrayCS_getOutputLength(inputLength, alpha01) {
	      return inputLength * (3 + alpha01);
	    },
	    isPassthrough: ColorSpace.prototype.isPassthrough,
	    fillRgb: ColorSpace.prototype.fillRgb,
	    isDefaultDecode: function CalGrayCS_isDefaultDecode(decodeMap) {
	      return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
	    },
	    usesZeroToOneRange: true
	  };
	  return CalGrayCS;
	}();
	var CalRGBCS = function CalRGBCSClosure() {
	  var BRADFORD_SCALE_MATRIX = new Float32Array([0.8951, 0.2664, -0.1614, -0.7502, 1.7135, 0.0367, 0.0389, -0.0685, 1.0296]);
	  var BRADFORD_SCALE_INVERSE_MATRIX = new Float32Array([0.9869929, -0.1470543, 0.1599627, 0.4323053, 0.5183603, 0.0492912, -0.0085287, 0.0400428, 0.9684867]);
	  var SRGB_D65_XYZ_TO_RGB_MATRIX = new Float32Array([3.2404542, -1.5371385, -0.4985314, -0.9692660, 1.8760108, 0.0415560, 0.0556434, -0.2040259, 1.0572252]);
	  var FLAT_WHITEPOINT_MATRIX = new Float32Array([1, 1, 1]);
	  var tempNormalizeMatrix = new Float32Array(3);
	  var tempConvertMatrix1 = new Float32Array(3);
	  var tempConvertMatrix2 = new Float32Array(3);
	  var DECODE_L_CONSTANT = Math.pow((8 + 16) / 116, 3) / 8.0;
	  function CalRGBCS(whitePoint, blackPoint, gamma, matrix) {
	    this.name = 'CalRGB';
	    this.numComps = 3;
	    this.defaultColor = new Float32Array(this.numComps);
	    if (!whitePoint) {
	      throw new _util.FormatError('WhitePoint missing - required for color space CalRGB');
	    }
	    blackPoint = blackPoint || new Float32Array(3);
	    gamma = gamma || new Float32Array([1, 1, 1]);
	    matrix = matrix || new Float32Array([1, 0, 0, 0, 1, 0, 0, 0, 1]);
	    var XW = whitePoint[0];
	    var YW = whitePoint[1];
	    var ZW = whitePoint[2];
	    this.whitePoint = whitePoint;
	    var XB = blackPoint[0];
	    var YB = blackPoint[1];
	    var ZB = blackPoint[2];
	    this.blackPoint = blackPoint;
	    this.GR = gamma[0];
	    this.GG = gamma[1];
	    this.GB = gamma[2];
	    this.MXA = matrix[0];
	    this.MYA = matrix[1];
	    this.MZA = matrix[2];
	    this.MXB = matrix[3];
	    this.MYB = matrix[4];
	    this.MZB = matrix[5];
	    this.MXC = matrix[6];
	    this.MYC = matrix[7];
	    this.MZC = matrix[8];
	    if (XW < 0 || ZW < 0 || YW !== 1) {
	      throw new _util.FormatError('Invalid WhitePoint components for ' + this.name + ', no fallback available');
	    }
	    if (XB < 0 || YB < 0 || ZB < 0) {
	      (0, _util.info)('Invalid BlackPoint for ' + this.name + ' [' + XB + ', ' + YB + ', ' + ZB + '], falling back to default');
	      this.blackPoint = new Float32Array(3);
	    }
	    if (this.GR < 0 || this.GG < 0 || this.GB < 0) {
	      (0, _util.info)('Invalid Gamma [' + this.GR + ', ' + this.GG + ', ' + this.GB + '] for ' + this.name + ', falling back to default');
	      this.GR = this.GG = this.GB = 1;
	    }
	    if (this.MXA < 0 || this.MYA < 0 || this.MZA < 0 || this.MXB < 0 || this.MYB < 0 || this.MZB < 0 || this.MXC < 0 || this.MYC < 0 || this.MZC < 0) {
	      (0, _util.info)('Invalid Matrix for ' + this.name + ' [' + this.MXA + ', ' + this.MYA + ', ' + this.MZA + this.MXB + ', ' + this.MYB + ', ' + this.MZB + this.MXC + ', ' + this.MYC + ', ' + this.MZC + '], falling back to default');
	      this.MXA = this.MYB = this.MZC = 1;
	      this.MXB = this.MYA = this.MZA = this.MXC = this.MYC = this.MZB = 0;
	    }
	  }
	  function matrixProduct(a, b, result) {
	    result[0] = a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	    result[1] = a[3] * b[0] + a[4] * b[1] + a[5] * b[2];
	    result[2] = a[6] * b[0] + a[7] * b[1] + a[8] * b[2];
	  }
	  function convertToFlat(sourceWhitePoint, LMS, result) {
	    result[0] = LMS[0] * 1 / sourceWhitePoint[0];
	    result[1] = LMS[1] * 1 / sourceWhitePoint[1];
	    result[2] = LMS[2] * 1 / sourceWhitePoint[2];
	  }
	  function convertToD65(sourceWhitePoint, LMS, result) {
	    var D65X = 0.95047;
	    var D65Y = 1;
	    var D65Z = 1.08883;
	    result[0] = LMS[0] * D65X / sourceWhitePoint[0];
	    result[1] = LMS[1] * D65Y / sourceWhitePoint[1];
	    result[2] = LMS[2] * D65Z / sourceWhitePoint[2];
	  }
	  function sRGBTransferFunction(color) {
	    if (color <= 0.0031308) {
	      return adjustToRange(0, 1, 12.92 * color);
	    }
	    return adjustToRange(0, 1, (1 + 0.055) * Math.pow(color, 1 / 2.4) - 0.055);
	  }
	  function adjustToRange(min, max, value) {
	    return Math.max(min, Math.min(max, value));
	  }
	  function decodeL(L) {
	    if (L < 0) {
	      return -decodeL(-L);
	    }
	    if (L > 8.0) {
	      return Math.pow((L + 16) / 116, 3);
	    }
	    return L * DECODE_L_CONSTANT;
	  }
	  function compensateBlackPoint(sourceBlackPoint, XYZ_Flat, result) {
	    if (sourceBlackPoint[0] === 0 && sourceBlackPoint[1] === 0 && sourceBlackPoint[2] === 0) {
	      result[0] = XYZ_Flat[0];
	      result[1] = XYZ_Flat[1];
	      result[2] = XYZ_Flat[2];
	      return;
	    }
	    var zeroDecodeL = decodeL(0);
	    var X_DST = zeroDecodeL;
	    var X_SRC = decodeL(sourceBlackPoint[0]);
	    var Y_DST = zeroDecodeL;
	    var Y_SRC = decodeL(sourceBlackPoint[1]);
	    var Z_DST = zeroDecodeL;
	    var Z_SRC = decodeL(sourceBlackPoint[2]);
	    var X_Scale = (1 - X_DST) / (1 - X_SRC);
	    var X_Offset = 1 - X_Scale;
	    var Y_Scale = (1 - Y_DST) / (1 - Y_SRC);
	    var Y_Offset = 1 - Y_Scale;
	    var Z_Scale = (1 - Z_DST) / (1 - Z_SRC);
	    var Z_Offset = 1 - Z_Scale;
	    result[0] = XYZ_Flat[0] * X_Scale + X_Offset;
	    result[1] = XYZ_Flat[1] * Y_Scale + Y_Offset;
	    result[2] = XYZ_Flat[2] * Z_Scale + Z_Offset;
	  }
	  function normalizeWhitePointToFlat(sourceWhitePoint, XYZ_In, result) {
	    if (sourceWhitePoint[0] === 1 && sourceWhitePoint[2] === 1) {
	      result[0] = XYZ_In[0];
	      result[1] = XYZ_In[1];
	      result[2] = XYZ_In[2];
	      return;
	    }
	    var LMS = result;
	    matrixProduct(BRADFORD_SCALE_MATRIX, XYZ_In, LMS);
	    var LMS_Flat = tempNormalizeMatrix;
	    convertToFlat(sourceWhitePoint, LMS, LMS_Flat);
	    matrixProduct(BRADFORD_SCALE_INVERSE_MATRIX, LMS_Flat, result);
	  }
	  function normalizeWhitePointToD65(sourceWhitePoint, XYZ_In, result) {
	    var LMS = result;
	    matrixProduct(BRADFORD_SCALE_MATRIX, XYZ_In, LMS);
	    var LMS_D65 = tempNormalizeMatrix;
	    convertToD65(sourceWhitePoint, LMS, LMS_D65);
	    matrixProduct(BRADFORD_SCALE_INVERSE_MATRIX, LMS_D65, result);
	  }
	  function convertToRgb(cs, src, srcOffset, dest, destOffset, scale) {
	    var A = adjustToRange(0, 1, src[srcOffset] * scale);
	    var B = adjustToRange(0, 1, src[srcOffset + 1] * scale);
	    var C = adjustToRange(0, 1, src[srcOffset + 2] * scale);
	    var AGR = Math.pow(A, cs.GR);
	    var BGG = Math.pow(B, cs.GG);
	    var CGB = Math.pow(C, cs.GB);
	    var X = cs.MXA * AGR + cs.MXB * BGG + cs.MXC * CGB;
	    var Y = cs.MYA * AGR + cs.MYB * BGG + cs.MYC * CGB;
	    var Z = cs.MZA * AGR + cs.MZB * BGG + cs.MZC * CGB;
	    var XYZ = tempConvertMatrix1;
	    XYZ[0] = X;
	    XYZ[1] = Y;
	    XYZ[2] = Z;
	    var XYZ_Flat = tempConvertMatrix2;
	    normalizeWhitePointToFlat(cs.whitePoint, XYZ, XYZ_Flat);
	    var XYZ_Black = tempConvertMatrix1;
	    compensateBlackPoint(cs.blackPoint, XYZ_Flat, XYZ_Black);
	    var XYZ_D65 = tempConvertMatrix2;
	    normalizeWhitePointToD65(FLAT_WHITEPOINT_MATRIX, XYZ_Black, XYZ_D65);
	    var SRGB = tempConvertMatrix1;
	    matrixProduct(SRGB_D65_XYZ_TO_RGB_MATRIX, XYZ_D65, SRGB);
	    var sR = sRGBTransferFunction(SRGB[0]);
	    var sG = sRGBTransferFunction(SRGB[1]);
	    var sB = sRGBTransferFunction(SRGB[2]);
	    dest[destOffset] = Math.round(sR * 255);
	    dest[destOffset + 1] = Math.round(sG * 255);
	    dest[destOffset + 2] = Math.round(sB * 255);
	  }
	  CalRGBCS.prototype = {
	    getRgb: ColorSpace.prototype.getRgb,
	    getRgbItem: function CalRGBCS_getRgbItem(src, srcOffset, dest, destOffset) {
	      convertToRgb(this, src, srcOffset, dest, destOffset, 1);
	    },
	    getRgbBuffer: function CalRGBCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
	      var scale = 1 / ((1 << bits) - 1);
	      for (var i = 0; i < count; ++i) {
	        convertToRgb(this, src, srcOffset, dest, destOffset, scale);
	        srcOffset += 3;
	        destOffset += 3 + alpha01;
	      }
	    },
	    getOutputLength: function CalRGBCS_getOutputLength(inputLength, alpha01) {
	      return inputLength * (3 + alpha01) / 3 | 0;
	    },
	    isPassthrough: ColorSpace.prototype.isPassthrough,
	    fillRgb: ColorSpace.prototype.fillRgb,
	    isDefaultDecode: function CalRGBCS_isDefaultDecode(decodeMap) {
	      return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
	    },
	    usesZeroToOneRange: true
	  };
	  return CalRGBCS;
	}();
	var LabCS = function LabCSClosure() {
	  function LabCS(whitePoint, blackPoint, range) {
	    this.name = 'Lab';
	    this.numComps = 3;
	    this.defaultColor = new Float32Array(this.numComps);
	    if (!whitePoint) {
	      throw new _util.FormatError('WhitePoint missing - required for color space Lab');
	    }
	    blackPoint = blackPoint || [0, 0, 0];
	    range = range || [-100, 100, -100, 100];
	    this.XW = whitePoint[0];
	    this.YW = whitePoint[1];
	    this.ZW = whitePoint[2];
	    this.amin = range[0];
	    this.amax = range[1];
	    this.bmin = range[2];
	    this.bmax = range[3];
	    this.XB = blackPoint[0];
	    this.YB = blackPoint[1];
	    this.ZB = blackPoint[2];
	    if (this.XW < 0 || this.ZW < 0 || this.YW !== 1) {
	      throw new _util.FormatError('Invalid WhitePoint components, no fallback available');
	    }
	    if (this.XB < 0 || this.YB < 0 || this.ZB < 0) {
	      (0, _util.info)('Invalid BlackPoint, falling back to default');
	      this.XB = this.YB = this.ZB = 0;
	    }
	    if (this.amin > this.amax || this.bmin > this.bmax) {
	      (0, _util.info)('Invalid Range, falling back to defaults');
	      this.amin = -100;
	      this.amax = 100;
	      this.bmin = -100;
	      this.bmax = 100;
	    }
	  }
	  function fn_g(x) {
	    var result;
	    if (x >= 6 / 29) {
	      result = x * x * x;
	    } else {
	      result = 108 / 841 * (x - 4 / 29);
	    }
	    return result;
	  }
	  function decode(value, high1, low2, high2) {
	    return low2 + value * (high2 - low2) / high1;
	  }
	  function convertToRgb(cs, src, srcOffset, maxVal, dest, destOffset) {
	    var Ls = src[srcOffset];
	    var as = src[srcOffset + 1];
	    var bs = src[srcOffset + 2];
	    if (maxVal !== false) {
	      Ls = decode(Ls, maxVal, 0, 100);
	      as = decode(as, maxVal, cs.amin, cs.amax);
	      bs = decode(bs, maxVal, cs.bmin, cs.bmax);
	    }
	    as = as > cs.amax ? cs.amax : as < cs.amin ? cs.amin : as;
	    bs = bs > cs.bmax ? cs.bmax : bs < cs.bmin ? cs.bmin : bs;
	    var M = (Ls + 16) / 116;
	    var L = M + as / 500;
	    var N = M - bs / 200;
	    var X = cs.XW * fn_g(L);
	    var Y = cs.YW * fn_g(M);
	    var Z = cs.ZW * fn_g(N);
	    var r, g, b;
	    if (cs.ZW < 1) {
	      r = X * 3.1339 + Y * -1.6170 + Z * -0.4906;
	      g = X * -0.9785 + Y * 1.9160 + Z * 0.0333;
	      b = X * 0.0720 + Y * -0.2290 + Z * 1.4057;
	    } else {
	      r = X * 3.2406 + Y * -1.5372 + Z * -0.4986;
	      g = X * -0.9689 + Y * 1.8758 + Z * 0.0415;
	      b = X * 0.0557 + Y * -0.2040 + Z * 1.0570;
	    }
	    dest[destOffset] = r <= 0 ? 0 : r >= 1 ? 255 : Math.sqrt(r) * 255 | 0;
	    dest[destOffset + 1] = g <= 0 ? 0 : g >= 1 ? 255 : Math.sqrt(g) * 255 | 0;
	    dest[destOffset + 2] = b <= 0 ? 0 : b >= 1 ? 255 : Math.sqrt(b) * 255 | 0;
	  }
	  LabCS.prototype = {
	    getRgb: ColorSpace.prototype.getRgb,
	    getRgbItem: function LabCS_getRgbItem(src, srcOffset, dest, destOffset) {
	      convertToRgb(this, src, srcOffset, false, dest, destOffset);
	    },
	    getRgbBuffer: function LabCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
	      var maxVal = (1 << bits) - 1;
	      for (var i = 0; i < count; i++) {
	        convertToRgb(this, src, srcOffset, maxVal, dest, destOffset);
	        srcOffset += 3;
	        destOffset += 3 + alpha01;
	      }
	    },
	    getOutputLength: function LabCS_getOutputLength(inputLength, alpha01) {
	      return inputLength * (3 + alpha01) / 3 | 0;
	    },
	    isPassthrough: ColorSpace.prototype.isPassthrough,
	    fillRgb: ColorSpace.prototype.fillRgb,
	    isDefaultDecode: function LabCS_isDefaultDecode(decodeMap) {
	      return true;
	    },
	    usesZeroToOneRange: false
	  };
	  return LabCS;
	}();
	exports.ColorSpace = ColorSpace;
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ExpertEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclamsmall', 'Hungarumlautsmall', '', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', '', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', '', '', '', 'isuperior', '', '', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', '', '', 'rsuperior', 'ssuperior', 'tsuperior', '', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', '', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'exclamdownsmall', 'centoldstyle', 'Lslashsmall', '', '', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall', '', 'Dotaccentsmall', '', '', 'Macronsmall', '', '', 'figuredash', 'hypheninferior', '', '', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', '', '', '', 'onequarter', 'onehalf', 'threequarters', 'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', '', '', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];
	var MacExpertEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclamsmall', 'Hungarumlautsmall', 'centoldstyle', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', '', 'threequartersemdash', '', 'questionsmall', '', '', '', '', 'Ethsmall', '', '', 'onequarter', 'onehalf', 'threequarters', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', '', '', '', '', '', '', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', '', 'parenrightinferior', 'Circumflexsmall', 'hypheninferior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', '', '', 'asuperior', 'centsuperior', '', '', '', '', 'Aacutesmall', 'Agravesmall', 'Acircumflexsmall', 'Adieresissmall', 'Atildesmall', 'Aringsmall', 'Ccedillasmall', 'Eacutesmall', 'Egravesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Iacutesmall', 'Igravesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ntildesmall', 'Oacutesmall', 'Ogravesmall', 'Ocircumflexsmall', 'Odieresissmall', 'Otildesmall', 'Uacutesmall', 'Ugravesmall', 'Ucircumflexsmall', 'Udieresissmall', '', 'eightsuperior', 'fourinferior', 'threeinferior', 'sixinferior', 'eightinferior', 'seveninferior', 'Scaronsmall', '', 'centinferior', 'twoinferior', '', 'Dieresissmall', '', 'Caronsmall', 'osuperior', 'fiveinferior', '', 'commainferior', 'periodinferior', 'Yacutesmall', '', 'dollarinferior', '', 'Thornsmall', '', 'nineinferior', 'zeroinferior', 'Zcaronsmall', 'AEsmall', 'Oslashsmall', 'questiondownsmall', 'oneinferior', 'Lslashsmall', '', '', '', '', '', '', 'Cedillasmall', '', '', '', '', '', 'OEsmall', 'figuredash', 'hyphensuperior', '', '', '', '', 'exclamdownsmall', '', 'Ydieresissmall', '', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'ninesuperior', 'zerosuperior', '', 'esuperior', 'rsuperior', 'tsuperior', '', '', 'isuperior', 'ssuperior', 'dsuperior', '', '', '', '', '', 'lsuperior', 'Ogoneksmall', 'Brevesmall', 'Macronsmall', 'bsuperior', 'nsuperior', 'msuperior', 'commasuperior', 'periodsuperior', 'Dotaccentsmall', 'Ringsmall'];
	var MacRomanEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', '', 'Adieresis', 'Aring', 'Ccedilla', 'Eacute', 'Ntilde', 'Odieresis', 'Udieresis', 'aacute', 'agrave', 'acircumflex', 'adieresis', 'atilde', 'aring', 'ccedilla', 'eacute', 'egrave', 'ecircumflex', 'edieresis', 'iacute', 'igrave', 'icircumflex', 'idieresis', 'ntilde', 'oacute', 'ograve', 'ocircumflex', 'odieresis', 'otilde', 'uacute', 'ugrave', 'ucircumflex', 'udieresis', 'dagger', 'degree', 'cent', 'sterling', 'section', 'bullet', 'paragraph', 'germandbls', 'registered', 'copyright', 'trademark', 'acute', 'dieresis', 'notequal', 'AE', 'Oslash', 'infinity', 'plusminus', 'lessequal', 'greaterequal', 'yen', 'mu', 'partialdiff', 'summation', 'product', 'pi', 'integral', 'ordfeminine', 'ordmasculine', 'Omega', 'ae', 'oslash', 'questiondown', 'exclamdown', 'logicalnot', 'radical', 'florin', 'approxequal', 'Delta', 'guillemotleft', 'guillemotright', 'ellipsis', 'space', 'Agrave', 'Atilde', 'Otilde', 'OE', 'oe', 'endash', 'emdash', 'quotedblleft', 'quotedblright', 'quoteleft', 'quoteright', 'divide', 'lozenge', 'ydieresis', 'Ydieresis', 'fraction', 'currency', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'daggerdbl', 'periodcentered', 'quotesinglbase', 'quotedblbase', 'perthousand', 'Acircumflex', 'Ecircumflex', 'Aacute', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Oacute', 'Ocircumflex', 'apple', 'Ograve', 'Uacute', 'Ucircumflex', 'Ugrave', 'dotlessi', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron'];
	var StandardEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', '', 'endash', 'dagger', 'daggerdbl', 'periodcentered', '', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand', '', 'questiondown', '', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', '', 'ring', 'cedilla', '', 'hungarumlaut', 'ogonek', 'caron', 'emdash', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'AE', '', 'ordfeminine', '', '', '', '', 'Lslash', 'Oslash', 'OE', 'ordmasculine', '', '', '', '', '', 'ae', '', '', '', 'dotlessi', '', '', 'lslash', 'oslash', 'oe', 'germandbls'];
	var WinAnsiEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'bullet', 'Euro', 'bullet', 'quotesinglbase', 'florin', 'quotedblbase', 'ellipsis', 'dagger', 'daggerdbl', 'circumflex', 'perthousand', 'Scaron', 'guilsinglleft', 'OE', 'bullet', 'Zcaron', 'bullet', 'bullet', 'quoteleft', 'quoteright', 'quotedblleft', 'quotedblright', 'bullet', 'endash', 'emdash', 'tilde', 'trademark', 'scaron', 'guilsinglright', 'oe', 'bullet', 'zcaron', 'Ydieresis', 'space', 'exclamdown', 'cent', 'sterling', 'currency', 'yen', 'brokenbar', 'section', 'dieresis', 'copyright', 'ordfeminine', 'guillemotleft', 'logicalnot', 'hyphen', 'registered', 'macron', 'degree', 'plusminus', 'twosuperior', 'threesuperior', 'acute', 'mu', 'paragraph', 'periodcentered', 'cedilla', 'onesuperior', 'ordmasculine', 'guillemotright', 'onequarter', 'onehalf', 'threequarters', 'questiondown', 'Agrave', 'Aacute', 'Acircumflex', 'Atilde', 'Adieresis', 'Aring', 'AE', 'Ccedilla', 'Egrave', 'Eacute', 'Ecircumflex', 'Edieresis', 'Igrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Eth', 'Ntilde', 'Ograve', 'Oacute', 'Ocircumflex', 'Otilde', 'Odieresis', 'multiply', 'Oslash', 'Ugrave', 'Uacute', 'Ucircumflex', 'Udieresis', 'Yacute', 'Thorn', 'germandbls', 'agrave', 'aacute', 'acircumflex', 'atilde', 'adieresis', 'aring', 'ae', 'ccedilla', 'egrave', 'eacute', 'ecircumflex', 'edieresis', 'igrave', 'iacute', 'icircumflex', 'idieresis', 'eth', 'ntilde', 'ograve', 'oacute', 'ocircumflex', 'otilde', 'odieresis', 'divide', 'oslash', 'ugrave', 'uacute', 'ucircumflex', 'udieresis', 'yacute', 'thorn', 'ydieresis'];
	var SymbolSetEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclam', 'universal', 'numbersign', 'existential', 'percent', 'ampersand', 'suchthat', 'parenleft', 'parenright', 'asteriskmath', 'plus', 'comma', 'minus', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'congruent', 'Alpha', 'Beta', 'Chi', 'Delta', 'Epsilon', 'Phi', 'Gamma', 'Eta', 'Iota', 'theta1', 'Kappa', 'Lambda', 'Mu', 'Nu', 'Omicron', 'Pi', 'Theta', 'Rho', 'Sigma', 'Tau', 'Upsilon', 'sigma1', 'Omega', 'Xi', 'Psi', 'Zeta', 'bracketleft', 'therefore', 'bracketright', 'perpendicular', 'underscore', 'radicalex', 'alpha', 'beta', 'chi', 'delta', 'epsilon', 'phi', 'gamma', 'eta', 'iota', 'phi1', 'kappa', 'lambda', 'mu', 'nu', 'omicron', 'pi', 'theta', 'rho', 'sigma', 'tau', 'upsilon', 'omega1', 'omega', 'xi', 'psi', 'zeta', 'braceleft', 'bar', 'braceright', 'similar', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'Euro', 'Upsilon1', 'minute', 'lessequal', 'fraction', 'infinity', 'florin', 'club', 'diamond', 'heart', 'spade', 'arrowboth', 'arrowleft', 'arrowup', 'arrowright', 'arrowdown', 'degree', 'plusminus', 'second', 'greaterequal', 'multiply', 'proportional', 'partialdiff', 'bullet', 'divide', 'notequal', 'equivalence', 'approxequal', 'ellipsis', 'arrowvertex', 'arrowhorizex', 'carriagereturn', 'aleph', 'Ifraktur', 'Rfraktur', 'weierstrass', 'circlemultiply', 'circleplus', 'emptyset', 'intersection', 'union', 'propersuperset', 'reflexsuperset', 'notsubset', 'propersubset', 'reflexsubset', 'element', 'notelement', 'angle', 'gradient', 'registerserif', 'copyrightserif', 'trademarkserif', 'product', 'radical', 'dotmath', 'logicalnot', 'logicaland', 'logicalor', 'arrowdblboth', 'arrowdblleft', 'arrowdblup', 'arrowdblright', 'arrowdbldown', 'lozenge', 'angleleft', 'registersans', 'copyrightsans', 'trademarksans', 'summation', 'parenlefttp', 'parenleftex', 'parenleftbt', 'bracketlefttp', 'bracketleftex', 'bracketleftbt', 'bracelefttp', 'braceleftmid', 'braceleftbt', 'braceex', '', 'angleright', 'integral', 'integraltp', 'integralex', 'integralbt', 'parenrighttp', 'parenrightex', 'parenrightbt', 'bracketrighttp', 'bracketrightex', 'bracketrightbt', 'bracerighttp', 'bracerightmid', 'bracerightbt'];
	var ZapfDingbatsEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'a1', 'a2', 'a202', 'a3', 'a4', 'a5', 'a119', 'a118', 'a117', 'a11', 'a12', 'a13', 'a14', 'a15', 'a16', 'a105', 'a17', 'a18', 'a19', 'a20', 'a21', 'a22', 'a23', 'a24', 'a25', 'a26', 'a27', 'a28', 'a6', 'a7', 'a8', 'a9', 'a10', 'a29', 'a30', 'a31', 'a32', 'a33', 'a34', 'a35', 'a36', 'a37', 'a38', 'a39', 'a40', 'a41', 'a42', 'a43', 'a44', 'a45', 'a46', 'a47', 'a48', 'a49', 'a50', 'a51', 'a52', 'a53', 'a54', 'a55', 'a56', 'a57', 'a58', 'a59', 'a60', 'a61', 'a62', 'a63', 'a64', 'a65', 'a66', 'a67', 'a68', 'a69', 'a70', 'a71', 'a72', 'a73', 'a74', 'a203', 'a75', 'a204', 'a76', 'a77', 'a78', 'a79', 'a81', 'a82', 'a83', 'a84', 'a97', 'a98', 'a99', 'a100', '', 'a89', 'a90', 'a93', 'a94', 'a91', 'a92', 'a205', 'a85', 'a206', 'a86', 'a87', 'a88', 'a95', 'a96', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'a101', 'a102', 'a103', 'a104', 'a106', 'a107', 'a108', 'a112', 'a111', 'a110', 'a109', 'a120', 'a121', 'a122', 'a123', 'a124', 'a125', 'a126', 'a127', 'a128', 'a129', 'a130', 'a131', 'a132', 'a133', 'a134', 'a135', 'a136', 'a137', 'a138', 'a139', 'a140', 'a141', 'a142', 'a143', 'a144', 'a145', 'a146', 'a147', 'a148', 'a149', 'a150', 'a151', 'a152', 'a153', 'a154', 'a155', 'a156', 'a157', 'a158', 'a159', 'a160', 'a161', 'a163', 'a164', 'a196', 'a165', 'a192', 'a166', 'a167', 'a168', 'a169', 'a170', 'a171', 'a172', 'a173', 'a162', 'a174', 'a175', 'a176', 'a177', 'a178', 'a179', 'a193', 'a180', 'a199', 'a181', 'a200', 'a182', '', 'a201', 'a183', 'a184', 'a197', 'a185', 'a194', 'a198', 'a186', 'a195', 'a187', 'a188', 'a189', 'a190', 'a191'];
	function getEncoding(encodingName) {
	  switch (encodingName) {
	    case 'WinAnsiEncoding':
	      return WinAnsiEncoding;
	    case 'StandardEncoding':
	      return StandardEncoding;
	    case 'MacRomanEncoding':
	      return MacRomanEncoding;
	    case 'SymbolSetEncoding':
	      return SymbolSetEncoding;
	    case 'ZapfDingbatsEncoding':
	      return ZapfDingbatsEncoding;
	    case 'ExpertEncoding':
	      return ExpertEncoding;
	    case 'MacExpertEncoding':
	      return MacExpertEncoding;
	    default:
	      return null;
	  }
	}
	exports.WinAnsiEncoding = WinAnsiEncoding;
	exports.StandardEncoding = StandardEncoding;
	exports.MacRomanEncoding = MacRomanEncoding;
	exports.SymbolSetEncoding = SymbolSetEncoding;
	exports.ZapfDingbatsEncoding = ZapfDingbatsEncoding;
	exports.ExpertEncoding = ExpertEncoding;
	exports.getEncoding = getEncoding;
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var IObject = __w_pdfjs_require__(39);
	var defined = __w_pdfjs_require__(40);
	module.exports = function (it) {
	  return IObject(defined(it));
	};
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toInteger = __w_pdfjs_require__(19);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var cof = __w_pdfjs_require__(27);
	var TAG = __w_pdfjs_require__(4)('toStringTag');
	var ARG = cof(function () {
	  return arguments;
	}()) == 'Arguments';
	var tryGet = function tryGet(it, key) {
	  try {
	    return it[key];
	  } catch (e) {}
	};
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T : ARG ? cof(O) : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var ctx = __w_pdfjs_require__(13);
	var call = __w_pdfjs_require__(114);
	var isArrayIter = __w_pdfjs_require__(59);
	var anObject = __w_pdfjs_require__(9);
	var toLength = __w_pdfjs_require__(14);
	var getIterFn = __w_pdfjs_require__(63);
	var BREAK = {};
	var RETURN = {};
	var _exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () {
	    return iterable;
	  } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	_exports.BREAK = BREAK;
	_exports.RETURN = RETURN;
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Parser = exports.Linearization = exports.Lexer = undefined;
	
	var _stream = __w_pdfjs_require__(5);
	
	var _util = __w_pdfjs_require__(0);
	
	var _primitives = __w_pdfjs_require__(2);
	
	var _ccitt_stream = __w_pdfjs_require__(144);
	
	var _jbig2_stream = __w_pdfjs_require__(146);
	
	var MAX_LENGTH_TO_CACHE = 1000;
	var Parser = function ParserClosure() {
	  function Parser(lexer, allowStreams, xref, recoveryMode) {
	    this.lexer = lexer;
	    this.allowStreams = allowStreams;
	    this.xref = xref;
	    this.recoveryMode = recoveryMode || false;
	    this.imageCache = Object.create(null);
	    this.refill();
	  }
	  Parser.prototype = {
	    refill: function Parser_refill() {
	      this.buf1 = this.lexer.getObj();
	      this.buf2 = this.lexer.getObj();
	    },
	    shift: function Parser_shift() {
	      if ((0, _primitives.isCmd)(this.buf2, 'ID')) {
	        this.buf1 = this.buf2;
	        this.buf2 = null;
	      } else {
	        this.buf1 = this.buf2;
	        this.buf2 = this.lexer.getObj();
	      }
	    },
	    tryShift: function Parser_tryShift() {
	      try {
	        this.shift();
	        return true;
	      } catch (e) {
	        if (e instanceof _util.MissingDataException) {
	          throw e;
	        }
	        return false;
	      }
	    },
	    getObj: function Parser_getObj(cipherTransform) {
	      var buf1 = this.buf1;
	      this.shift();
	      if (buf1 instanceof _primitives.Cmd) {
	        switch (buf1.cmd) {
	          case 'BI':
	            return this.makeInlineImage(cipherTransform);
	          case '[':
	            var array = [];
	            while (!(0, _primitives.isCmd)(this.buf1, ']') && !(0, _primitives.isEOF)(this.buf1)) {
	              array.push(this.getObj(cipherTransform));
	            }
	            if ((0, _primitives.isEOF)(this.buf1)) {
	              if (!this.recoveryMode) {
	                throw new _util.FormatError('End of file inside array');
	              }
	              return array;
	            }
	            this.shift();
	            return array;
	          case '<<':
	            var dict = new _primitives.Dict(this.xref);
	            while (!(0, _primitives.isCmd)(this.buf1, '>>') && !(0, _primitives.isEOF)(this.buf1)) {
	              if (!(0, _primitives.isName)(this.buf1)) {
	                (0, _util.info)('Malformed dictionary: key must be a name object');
	                this.shift();
	                continue;
	              }
	              var key = this.buf1.name;
	              this.shift();
	              if ((0, _primitives.isEOF)(this.buf1)) {
	                break;
	              }
	              dict.set(key, this.getObj(cipherTransform));
	            }
	            if ((0, _primitives.isEOF)(this.buf1)) {
	              if (!this.recoveryMode) {
	                throw new _util.FormatError('End of file inside dictionary');
	              }
	              return dict;
	            }
	            if ((0, _primitives.isCmd)(this.buf2, 'stream')) {
	              return this.allowStreams ? this.makeStream(dict, cipherTransform) : dict;
	            }
	            this.shift();
	            return dict;
	          default:
	            return buf1;
	        }
	      }
	      if (Number.isInteger(buf1)) {
	        var num = buf1;
	        if (Number.isInteger(this.buf1) && (0, _primitives.isCmd)(this.buf2, 'R')) {
	          var ref = new _primitives.Ref(num, this.buf1);
	          this.shift();
	          this.shift();
	          return ref;
	        }
	        return num;
	      }
	      if ((0, _util.isString)(buf1)) {
	        var str = buf1;
	        if (cipherTransform) {
	          str = cipherTransform.decryptString(str);
	        }
	        return str;
	      }
	      return buf1;
	    },
	    findDefaultInlineStreamEnd: function findDefaultInlineStreamEnd(stream) {
	      var E = 0x45,
	          I = 0x49,
	          SPACE = 0x20,
	          LF = 0xA,
	          CR = 0xD;
	      var n = 10,
	          NUL = 0x0;
	      var startPos = stream.pos,
	          state = 0,
	          ch = void 0,
	          maybeEIPos = void 0;
	      while ((ch = stream.getByte()) !== -1) {
	        if (state === 0) {
	          state = ch === E ? 1 : 0;
	        } else if (state === 1) {
	          state = ch === I ? 2 : 0;
	        } else {
	          (0, _util.assert)(state === 2);
	          if (ch === SPACE || ch === LF || ch === CR) {
	            maybeEIPos = stream.pos;
	            var followingBytes = stream.peekBytes(n);
	            for (var i = 0, ii = followingBytes.length; i < ii; i++) {
	              ch = followingBytes[i];
	              if (ch === NUL && followingBytes[i + 1] !== NUL) {
	                continue;
	              }
	              if (ch !== LF && ch !== CR && (ch < SPACE || ch > 0x7F)) {
	                state = 0;
	                break;
	              }
	            }
	            if (state === 2) {
	              break;
	            }
	          } else {
	            state = 0;
	          }
	        }
	      }
	      if (ch === -1) {
	        (0, _util.warn)('findDefaultInlineStreamEnd: ' + 'Reached the end of the stream without finding a valid EI marker');
	        if (maybeEIPos) {
	          (0, _util.warn)('... trying to recover by using the last "EI" occurrence.');
	          stream.skip(-(stream.pos - maybeEIPos));
	        }
	      }
	      return stream.pos - 4 - startPos;
	    },
	
	    findDCTDecodeInlineStreamEnd: function Parser_findDCTDecodeInlineStreamEnd(stream) {
	      var startPos = stream.pos,
	          foundEOI = false,
	          b,
	          markerLength,
	          length;
	      while ((b = stream.getByte()) !== -1) {
	        if (b !== 0xFF) {
	          continue;
	        }
	        switch (stream.getByte()) {
	          case 0x00:
	            break;
	          case 0xFF:
	            stream.skip(-1);
	            break;
	          case 0xD9:
	            foundEOI = true;
	            break;
	          case 0xC0:
	          case 0xC1:
	          case 0xC2:
	          case 0xC3:
	          case 0xC5:
	          case 0xC6:
	          case 0xC7:
	          case 0xC9:
	          case 0xCA:
	          case 0xCB:
	          case 0xCD:
	          case 0xCE:
	          case 0xCF:
	          case 0xC4:
	          case 0xCC:
	          case 0xDA:
	          case 0xDB:
	          case 0xDC:
	          case 0xDD:
	          case 0xDE:
	          case 0xDF:
	          case 0xE0:
	          case 0xE1:
	          case 0xE2:
	          case 0xE3:
	          case 0xE4:
	          case 0xE5:
	          case 0xE6:
	          case 0xE7:
	          case 0xE8:
	          case 0xE9:
	          case 0xEA:
	          case 0xEB:
	          case 0xEC:
	          case 0xED:
	          case 0xEE:
	          case 0xEF:
	          case 0xFE:
	            markerLength = stream.getUint16();
	            if (markerLength > 2) {
	              stream.skip(markerLength - 2);
	            } else {
	              stream.skip(-2);
	            }
	            break;
	        }
	        if (foundEOI) {
	          break;
	        }
	      }
	      length = stream.pos - startPos;
	      if (b === -1) {
	        (0, _util.warn)('Inline DCTDecode image stream: ' + 'EOI marker not found, searching for /EI/ instead.');
	        stream.skip(-length);
	        return this.findDefaultInlineStreamEnd(stream);
	      }
	      this.inlineStreamSkipEI(stream);
	      return length;
	    },
	    findASCII85DecodeInlineStreamEnd: function Parser_findASCII85DecodeInlineStreamEnd(stream) {
	      var TILDE = 0x7E,
	          GT = 0x3E;
	      var startPos = stream.pos,
	          ch,
	          length;
	      while ((ch = stream.getByte()) !== -1) {
	        if (ch === TILDE && stream.peekByte() === GT) {
	          stream.skip();
	          break;
	        }
	      }
	      length = stream.pos - startPos;
	      if (ch === -1) {
	        (0, _util.warn)('Inline ASCII85Decode image stream: ' + 'EOD marker not found, searching for /EI/ instead.');
	        stream.skip(-length);
	        return this.findDefaultInlineStreamEnd(stream);
	      }
	      this.inlineStreamSkipEI(stream);
	      return length;
	    },
	    findASCIIHexDecodeInlineStreamEnd: function Parser_findASCIIHexDecodeInlineStreamEnd(stream) {
	      var GT = 0x3E;
	      var startPos = stream.pos,
	          ch,
	          length;
	      while ((ch = stream.getByte()) !== -1) {
	        if (ch === GT) {
	          break;
	        }
	      }
	      length = stream.pos - startPos;
	      if (ch === -1) {
	        (0, _util.warn)('Inline ASCIIHexDecode image stream: ' + 'EOD marker not found, searching for /EI/ instead.');
	        stream.skip(-length);
	        return this.findDefaultInlineStreamEnd(stream);
	      }
	      this.inlineStreamSkipEI(stream);
	      return length;
	    },
	    inlineStreamSkipEI: function Parser_inlineStreamSkipEI(stream) {
	      var E = 0x45,
	          I = 0x49;
	      var state = 0,
	          ch;
	      while ((ch = stream.getByte()) !== -1) {
	        if (state === 0) {
	          state = ch === E ? 1 : 0;
	        } else if (state === 1) {
	          state = ch === I ? 2 : 0;
	        } else if (state === 2) {
	          break;
	        }
	      }
	    },
	    makeInlineImage: function Parser_makeInlineImage(cipherTransform) {
	      var lexer = this.lexer;
	      var stream = lexer.stream;
	      var dict = new _primitives.Dict(this.xref);
	      while (!(0, _primitives.isCmd)(this.buf1, 'ID') && !(0, _primitives.isEOF)(this.buf1)) {
	        if (!(0, _primitives.isName)(this.buf1)) {
	          throw new _util.FormatError('Dictionary key must be a name object');
	        }
	        var key = this.buf1.name;
	        this.shift();
	        if ((0, _primitives.isEOF)(this.buf1)) {
	          break;
	        }
	        dict.set(key, this.getObj(cipherTransform));
	      }
	      var filter = dict.get('Filter', 'F'),
	          filterName;
	      if ((0, _primitives.isName)(filter)) {
	        filterName = filter.name;
	      } else if (Array.isArray(filter)) {
	        var filterZero = this.xref.fetchIfRef(filter[0]);
	        if ((0, _primitives.isName)(filterZero)) {
	          filterName = filterZero.name;
	        }
	      }
	      var startPos = stream.pos,
	          length,
	          i,
	          ii;
	      if (filterName === 'DCTDecode' || filterName === 'DCT') {
	        length = this.findDCTDecodeInlineStreamEnd(stream);
	      } else if (filterName === 'ASCII85Decode' || filterName === 'A85') {
	        length = this.findASCII85DecodeInlineStreamEnd(stream);
	      } else if (filterName === 'ASCIIHexDecode' || filterName === 'AHx') {
	        length = this.findASCIIHexDecodeInlineStreamEnd(stream);
	      } else {
	        length = this.findDefaultInlineStreamEnd(stream);
	      }
	      var imageStream = stream.makeSubStream(startPos, length, dict);
	      var adler32;
	      if (length < MAX_LENGTH_TO_CACHE) {
	        var imageBytes = imageStream.getBytes();
	        imageStream.reset();
	        var a = 1;
	        var b = 0;
	        for (i = 0, ii = imageBytes.length; i < ii; ++i) {
	          a += imageBytes[i] & 0xff;
	          b += a;
	        }
	        adler32 = b % 65521 << 16 | a % 65521;
	        var cacheEntry = this.imageCache[adler32];
	        if (cacheEntry !== undefined) {
	          this.buf2 = _primitives.Cmd.get('EI');
	          this.shift();
	          cacheEntry.reset();
	          return cacheEntry;
	        }
	      }
	      if (cipherTransform) {
	        imageStream = cipherTransform.createStream(imageStream, length);
	      }
	      imageStream = this.filter(imageStream, dict, length);
	      imageStream.dict = dict;
	      if (adler32 !== undefined) {
	        imageStream.cacheKey = 'inline_' + length + '_' + adler32;
	        this.imageCache[adler32] = imageStream;
	      }
	      this.buf2 = _primitives.Cmd.get('EI');
	      this.shift();
	      return imageStream;
	    },
	    makeStream: function Parser_makeStream(dict, cipherTransform) {
	      var lexer = this.lexer;
	      var stream = lexer.stream;
	      lexer.skipToNextLine();
	      var pos = stream.pos - 1;
	      var length = dict.get('Length');
	      if (!Number.isInteger(length)) {
	        (0, _util.info)('Bad ' + length + ' attribute in stream');
	        length = 0;
	      }
	      stream.pos = pos + length;
	      lexer.nextChar();
	      if (this.tryShift() && (0, _primitives.isCmd)(this.buf2, 'endstream')) {
	        this.shift();
	      } else {
	        stream.pos = pos;
	        var SCAN_BLOCK_SIZE = 2048;
	        var ENDSTREAM_SIGNATURE_LENGTH = 9;
	        var ENDSTREAM_SIGNATURE = [0x65, 0x6E, 0x64, 0x73, 0x74, 0x72, 0x65, 0x61, 0x6D];
	        var skipped = 0,
	            found = false,
	            i,
	            j;
	        while (stream.pos < stream.end) {
	          var scanBytes = stream.peekBytes(SCAN_BLOCK_SIZE);
	          var scanLength = scanBytes.length - ENDSTREAM_SIGNATURE_LENGTH;
	          if (scanLength <= 0) {
	            break;
	          }
	          found = false;
	          i = 0;
	          while (i < scanLength) {
	            j = 0;
	            while (j < ENDSTREAM_SIGNATURE_LENGTH && scanBytes[i + j] === ENDSTREAM_SIGNATURE[j]) {
	              j++;
	            }
	            if (j >= ENDSTREAM_SIGNATURE_LENGTH) {
	              found = true;
	              break;
	            }
	            i++;
	          }
	          if (found) {
	            skipped += i;
	            stream.pos += i;
	            break;
	          }
	          skipped += scanLength;
	          stream.pos += scanLength;
	        }
	        if (!found) {
	          throw new _util.FormatError('Missing endstream');
	        }
	        length = skipped;
	        lexer.nextChar();
	        this.shift();
	        this.shift();
	      }
	      this.shift();
	      stream = stream.makeSubStream(pos, length, dict);
	      if (cipherTransform) {
	        stream = cipherTransform.createStream(stream, length);
	      }
	      stream = this.filter(stream, dict, length);
	      stream.dict = dict;
	      return stream;
	    },
	    filter: function Parser_filter(stream, dict, length) {
	      var filter = dict.get('Filter', 'F');
	      var params = dict.get('DecodeParms', 'DP');
	      if ((0, _primitives.isName)(filter)) {
	        if (Array.isArray(params)) {
	          (0, _util.warn)('/DecodeParms should not contain an Array, ' + 'when /Filter contains a Name.');
	        }
	        return this.makeFilter(stream, filter.name, length, params);
	      }
	      var maybeLength = length;
	      if (Array.isArray(filter)) {
	        var filterArray = filter;
	        var paramsArray = params;
	        for (var i = 0, ii = filterArray.length; i < ii; ++i) {
	          filter = this.xref.fetchIfRef(filterArray[i]);
	          if (!(0, _primitives.isName)(filter)) {
	            throw new _util.FormatError('Bad filter name: ' + filter);
	          }
	          params = null;
	          if (Array.isArray(paramsArray) && i in paramsArray) {
	            params = this.xref.fetchIfRef(paramsArray[i]);
	          }
	          stream = this.makeFilter(stream, filter.name, maybeLength, params);
	          maybeLength = null;
	        }
	      }
	      return stream;
	    },
	    makeFilter: function Parser_makeFilter(stream, name, maybeLength, params) {
	      if (maybeLength === 0) {
	        (0, _util.warn)('Empty "' + name + '" stream.');
	        return new _stream.NullStream(stream);
	      }
	      try {
	        var xrefStreamStats = this.xref.stats.streamTypes;
	        if (name === 'FlateDecode' || name === 'Fl') {
	          xrefStreamStats[_util.StreamType.FLATE] = true;
	          if (params) {
	            return new _stream.PredictorStream(new _stream.FlateStream(stream, maybeLength), maybeLength, params);
	          }
	          return new _stream.FlateStream(stream, maybeLength);
	        }
	        if (name === 'LZWDecode' || name === 'LZW') {
	          xrefStreamStats[_util.StreamType.LZW] = true;
	          var earlyChange = 1;
	          if (params) {
	            if (params.has('EarlyChange')) {
	              earlyChange = params.get('EarlyChange');
	            }
	            return new _stream.PredictorStream(new _stream.LZWStream(stream, maybeLength, earlyChange), maybeLength, params);
	          }
	          return new _stream.LZWStream(stream, maybeLength, earlyChange);
	        }
	        if (name === 'DCTDecode' || name === 'DCT') {
	          xrefStreamStats[_util.StreamType.DCT] = true;
	          return new _stream.JpegStream(stream, maybeLength, stream.dict, params);
	        }
	        if (name === 'JPXDecode' || name === 'JPX') {
	          xrefStreamStats[_util.StreamType.JPX] = true;
	          return new _stream.JpxStream(stream, maybeLength, stream.dict, params);
	        }
	        if (name === 'ASCII85Decode' || name === 'A85') {
	          xrefStreamStats[_util.StreamType.A85] = true;
	          return new _stream.Ascii85Stream(stream, maybeLength);
	        }
	        if (name === 'ASCIIHexDecode' || name === 'AHx') {
	          xrefStreamStats[_util.StreamType.AHX] = true;
	          return new _stream.AsciiHexStream(stream, maybeLength);
	        }
	        if (name === 'CCITTFaxDecode' || name === 'CCF') {
	          xrefStreamStats[_util.StreamType.CCF] = true;
	          return new _ccitt_stream.CCITTFaxStream(stream, maybeLength, params);
	        }
	        if (name === 'RunLengthDecode' || name === 'RL') {
	          xrefStreamStats[_util.StreamType.RL] = true;
	          return new _stream.RunLengthStream(stream, maybeLength);
	        }
	        if (name === 'JBIG2Decode') {
	          xrefStreamStats[_util.StreamType.JBIG] = true;
	          return new _jbig2_stream.Jbig2Stream(stream, maybeLength, stream.dict, params);
	        }
	        (0, _util.warn)('filter "' + name + '" not supported yet');
	        return stream;
	      } catch (ex) {
	        if (ex instanceof _util.MissingDataException) {
	          throw ex;
	        }
	        (0, _util.warn)('Invalid stream: \"' + ex + '\"');
	        return new _stream.NullStream(stream);
	      }
	    }
	  };
	  return Parser;
	}();
	var Lexer = function LexerClosure() {
	  function Lexer(stream, knownCommands) {
	    this.stream = stream;
	    this.nextChar();
	    this.strBuf = [];
	    this.knownCommands = knownCommands;
	  }
	  var specialChars = [1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 0, 0, 2, 2, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
	  function toHexDigit(ch) {
	    if (ch >= 0x30 && ch <= 0x39) {
	      return ch & 0x0F;
	    }
	    if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) {
	      return (ch & 0x0F) + 9;
	    }
	    return -1;
	  }
	  Lexer.prototype = {
	    nextChar: function Lexer_nextChar() {
	      return this.currentChar = this.stream.getByte();
	    },
	    peekChar: function Lexer_peekChar() {
	      return this.stream.peekByte();
	    },
	    getNumber: function Lexer_getNumber() {
	      var ch = this.currentChar;
	      var eNotation = false;
	      var divideBy = 0;
	      var sign = 1;
	      if (ch === 0x2D) {
	        sign = -1;
	        ch = this.nextChar();
	        if (ch === 0x2D) {
	          ch = this.nextChar();
	        }
	      } else if (ch === 0x2B) {
	        ch = this.nextChar();
	      }
	      if (ch === 0x2E) {
	        divideBy = 10;
	        ch = this.nextChar();
	      }
	      if (ch === 0x0A || ch === 0x0D) {
	        do {
	          ch = this.nextChar();
	        } while (ch === 0x0A || ch === 0x0D);
	      }
	      if (ch < 0x30 || ch > 0x39) {
	        throw new _util.FormatError('Invalid number: ' + String.fromCharCode(ch) + ' (charCode ' + ch + ')');
	      }
	      var baseValue = ch - 0x30;
	      var powerValue = 0;
	      var powerValueSign = 1;
	      while ((ch = this.nextChar()) >= 0) {
	        if (0x30 <= ch && ch <= 0x39) {
	          var currentDigit = ch - 0x30;
	          if (eNotation) {
	            powerValue = powerValue * 10 + currentDigit;
	          } else {
	            if (divideBy !== 0) {
	              divideBy *= 10;
	            }
	            baseValue = baseValue * 10 + currentDigit;
	          }
	        } else if (ch === 0x2E) {
	          if (divideBy === 0) {
	            divideBy = 1;
	          } else {
	            break;
	          }
	        } else if (ch === 0x2D) {
	          (0, _util.warn)('Badly formatted number');
	        } else if (ch === 0x45 || ch === 0x65) {
	          ch = this.peekChar();
	          if (ch === 0x2B || ch === 0x2D) {
	            powerValueSign = ch === 0x2D ? -1 : 1;
	            this.nextChar();
	          } else if (ch < 0x30 || ch > 0x39) {
	            break;
	          }
	          eNotation = true;
	        } else {
	          break;
	        }
	      }
	      if (divideBy !== 0) {
	        baseValue /= divideBy;
	      }
	      if (eNotation) {
	        baseValue *= Math.pow(10, powerValueSign * powerValue);
	      }
	      return sign * baseValue;
	    },
	    getString: function Lexer_getString() {
	      var numParen = 1;
	      var done = false;
	      var strBuf = this.strBuf;
	      strBuf.length = 0;
	      var ch = this.nextChar();
	      while (true) {
	        var charBuffered = false;
	        switch (ch | 0) {
	          case -1:
	            (0, _util.warn)('Unterminated string');
	            done = true;
	            break;
	          case 0x28:
	            ++numParen;
	            strBuf.push('(');
	            break;
	          case 0x29:
	            if (--numParen === 0) {
	              this.nextChar();
	              done = true;
	            } else {
	              strBuf.push(')');
	            }
	            break;
	          case 0x5C:
	            ch = this.nextChar();
	            switch (ch) {
	              case -1:
	                (0, _util.warn)('Unterminated string');
	                done = true;
	                break;
	              case 0x6E:
	                strBuf.push('\n');
	                break;
	              case 0x72:
	                strBuf.push('\r');
	                break;
	              case 0x74:
	                strBuf.push('\t');
	                break;
	              case 0x62:
	                strBuf.push('\b');
	                break;
	              case 0x66:
	                strBuf.push('\f');
	                break;
	              case 0x5C:
	              case 0x28:
	              case 0x29:
	                strBuf.push(String.fromCharCode(ch));
	                break;
	              case 0x30:
	              case 0x31:
	              case 0x32:
	              case 0x33:
	              case 0x34:
	              case 0x35:
	              case 0x36:
	              case 0x37:
	                var x = ch & 0x0F;
	                ch = this.nextChar();
	                charBuffered = true;
	                if (ch >= 0x30 && ch <= 0x37) {
	                  x = (x << 3) + (ch & 0x0F);
	                  ch = this.nextChar();
	                  if (ch >= 0x30 && ch <= 0x37) {
	                    charBuffered = false;
	                    x = (x << 3) + (ch & 0x0F);
	                  }
	                }
	                strBuf.push(String.fromCharCode(x));
	                break;
	              case 0x0D:
	                if (this.peekChar() === 0x0A) {
	                  this.nextChar();
	                }
	                break;
	              case 0x0A:
	                break;
	              default:
	                strBuf.push(String.fromCharCode(ch));
	                break;
	            }
	            break;
	          default:
	            strBuf.push(String.fromCharCode(ch));
	            break;
	        }
	        if (done) {
	          break;
	        }
	        if (!charBuffered) {
	          ch = this.nextChar();
	        }
	      }
	      return strBuf.join('');
	    },
	    getName: function Lexer_getName() {
	      var ch, previousCh;
	      var strBuf = this.strBuf;
	      strBuf.length = 0;
	      while ((ch = this.nextChar()) >= 0 && !specialChars[ch]) {
	        if (ch === 0x23) {
	          ch = this.nextChar();
	          if (specialChars[ch]) {
	            (0, _util.warn)('Lexer_getName: ' + 'NUMBER SIGN (#) should be followed by a hexadecimal number.');
	            strBuf.push('#');
	            break;
	          }
	          var x = toHexDigit(ch);
	          if (x !== -1) {
	            previousCh = ch;
	            ch = this.nextChar();
	            var x2 = toHexDigit(ch);
	            if (x2 === -1) {
	              (0, _util.warn)('Lexer_getName: Illegal digit (' + String.fromCharCode(ch) + ') in hexadecimal number.');
	              strBuf.push('#', String.fromCharCode(previousCh));
	              if (specialChars[ch]) {
	                break;
	              }
	              strBuf.push(String.fromCharCode(ch));
	              continue;
	            }
	            strBuf.push(String.fromCharCode(x << 4 | x2));
	          } else {
	            strBuf.push('#', String.fromCharCode(ch));
	          }
	        } else {
	          strBuf.push(String.fromCharCode(ch));
	        }
	      }
	      if (strBuf.length > 127) {
	        (0, _util.warn)('name token is longer than allowed by the spec: ' + strBuf.length);
	      }
	      return _primitives.Name.get(strBuf.join(''));
	    },
	    getHexString: function Lexer_getHexString() {
	      var strBuf = this.strBuf;
	      strBuf.length = 0;
	      var ch = this.currentChar;
	      var isFirstHex = true;
	      var firstDigit;
	      var secondDigit;
	      while (true) {
	        if (ch < 0) {
	          (0, _util.warn)('Unterminated hex string');
	          break;
	        } else if (ch === 0x3E) {
	          this.nextChar();
	          break;
	        } else if (specialChars[ch] === 1) {
	          ch = this.nextChar();
	          continue;
	        } else {
	          if (isFirstHex) {
	            firstDigit = toHexDigit(ch);
	            if (firstDigit === -1) {
	              (0, _util.warn)('Ignoring invalid character "' + ch + '" in hex string');
	              ch = this.nextChar();
	              continue;
	            }
	          } else {
	            secondDigit = toHexDigit(ch);
	            if (secondDigit === -1) {
	              (0, _util.warn)('Ignoring invalid character "' + ch + '" in hex string');
	              ch = this.nextChar();
	              continue;
	            }
	            strBuf.push(String.fromCharCode(firstDigit << 4 | secondDigit));
	          }
	          isFirstHex = !isFirstHex;
	          ch = this.nextChar();
	        }
	      }
	      return strBuf.join('');
	    },
	    getObj: function Lexer_getObj() {
	      var comment = false;
	      var ch = this.currentChar;
	      while (true) {
	        if (ch < 0) {
	          return _primitives.EOF;
	        }
	        if (comment) {
	          if (ch === 0x0A || ch === 0x0D) {
	            comment = false;
	          }
	        } else if (ch === 0x25) {
	          comment = true;
	        } else if (specialChars[ch] !== 1) {
	          break;
	        }
	        ch = this.nextChar();
	      }
	      switch (ch | 0) {
	        case 0x30:
	        case 0x31:
	        case 0x32:
	        case 0x33:
	        case 0x34:
	        case 0x35:
	        case 0x36:
	        case 0x37:
	        case 0x38:
	        case 0x39:
	        case 0x2B:
	        case 0x2D:
	        case 0x2E:
	          return this.getNumber();
	        case 0x28:
	          return this.getString();
	        case 0x2F:
	          return this.getName();
	        case 0x5B:
	          this.nextChar();
	          return _primitives.Cmd.get('[');
	        case 0x5D:
	          this.nextChar();
	          return _primitives.Cmd.get(']');
	        case 0x3C:
	          ch = this.nextChar();
	          if (ch === 0x3C) {
	            this.nextChar();
	            return _primitives.Cmd.get('<<');
	          }
	          return this.getHexString();
	        case 0x3E:
	          ch = this.nextChar();
	          if (ch === 0x3E) {
	            this.nextChar();
	            return _primitives.Cmd.get('>>');
	          }
	          return _primitives.Cmd.get('>');
	        case 0x7B:
	          this.nextChar();
	          return _primitives.Cmd.get('{');
	        case 0x7D:
	          this.nextChar();
	          return _primitives.Cmd.get('}');
	        case 0x29:
	          this.nextChar();
	          throw new _util.FormatError('Illegal character: ' + ch);
	      }
	      var str = String.fromCharCode(ch);
	      var knownCommands = this.knownCommands;
	      var knownCommandFound = knownCommands && knownCommands[str] !== undefined;
	      while ((ch = this.nextChar()) >= 0 && !specialChars[ch]) {
	        var possibleCommand = str + String.fromCharCode(ch);
	        if (knownCommandFound && knownCommands[possibleCommand] === undefined) {
	          break;
	        }
	        if (str.length === 128) {
	          throw new _util.FormatError('Command token too long: ' + str.length);
	        }
	        str = possibleCommand;
	        knownCommandFound = knownCommands && knownCommands[str] !== undefined;
	      }
	      if (str === 'true') {
	        return true;
	      }
	      if (str === 'false') {
	        return false;
	      }
	      if (str === 'null') {
	        return null;
	      }
	      return _primitives.Cmd.get(str);
	    },
	    skipToNextLine: function Lexer_skipToNextLine() {
	      var ch = this.currentChar;
	      while (ch >= 0) {
	        if (ch === 0x0D) {
	          ch = this.nextChar();
	          if (ch === 0x0A) {
	            this.nextChar();
	          }
	          break;
	        } else if (ch === 0x0A) {
	          this.nextChar();
	          break;
	        }
	        ch = this.nextChar();
	      }
	    }
	  };
	  return Lexer;
	}();
	var Linearization = {
	  create: function LinearizationCreate(stream) {
	    function getInt(name, allowZeroValue) {
	      var obj = linDict.get(name);
	      if (Number.isInteger(obj) && (allowZeroValue ? obj >= 0 : obj > 0)) {
	        return obj;
	      }
	      throw new Error('The "' + name + '" parameter in the linearization ' + 'dictionary is invalid.');
	    }
	    function getHints() {
	      var hints = linDict.get('H'),
	          hintsLength,
	          item;
	      if (Array.isArray(hints) && ((hintsLength = hints.length) === 2 || hintsLength === 4)) {
	        for (var index = 0; index < hintsLength; index++) {
	          if (!(Number.isInteger(item = hints[index]) && item > 0)) {
	            throw new Error('Hint (' + index + ') in the linearization dictionary is invalid.');
	          }
	        }
	        return hints;
	      }
	      throw new Error('Hint array in the linearization dictionary is invalid.');
	    }
	    var parser = new Parser(new Lexer(stream), false, null);
	    var obj1 = parser.getObj();
	    var obj2 = parser.getObj();
	    var obj3 = parser.getObj();
	    var linDict = parser.getObj();
	    var obj, length;
	    if (!(Number.isInteger(obj1) && Number.isInteger(obj2) && (0, _primitives.isCmd)(obj3, 'obj') && (0, _primitives.isDict)(linDict) && (0, _util.isNum)(obj = linDict.get('Linearized')) && obj > 0)) {
	      return null;
	    } else if ((length = getInt('L')) !== stream.length) {
	      throw new Error('The "L" parameter in the linearization dictionary ' + 'does not equal the stream length.');
	    }
	    return {
	      length: length,
	      hints: getHints(),
	      objectNumberFirst: getInt('O'),
	      endFirst: getInt('E'),
	      numPages: getInt('N'),
	      mainXRefEntriesOffset: getInt('T'),
	      pageFirst: linDict.has('P') ? getInt('P', true) : 0
	    };
	  }
	};
	exports.Lexer = Lexer;
	exports.Linearization = Linearization;
	exports.Parser = Parser;
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(3);
	var document = __w_pdfjs_require__(1).document;
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(3);
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var cof = __w_pdfjs_require__(27);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var shared = __w_pdfjs_require__(57)('keys');
	var uid = __w_pdfjs_require__(18);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $keys = __w_pdfjs_require__(55);
	var enumBugKeys = __w_pdfjs_require__(42);
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var ctx = __w_pdfjs_require__(13);
	var IObject = __w_pdfjs_require__(39);
	var toObject = __w_pdfjs_require__(20);
	var toLength = __w_pdfjs_require__(14);
	var asc = __w_pdfjs_require__(98);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (; length > index; index++) {
	      if (NO_HOLES || index in self) {
	        val = self[index];
	        res = f(val, index, O);
	        if (TYPE) {
	          if (IS_MAP) result[index] = res;else if (res) switch (TYPE) {
	            case 3:
	              return true;
	            case 5:
	              return val;
	            case 6:
	              return index;
	            case 2:
	              result.push(val);
	          } else if (IS_EVERY) return false;
	        }
	      }
	    }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};
	
	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var anObject = __w_pdfjs_require__(9);
	var aFunction = __w_pdfjs_require__(24);
	var SPECIES = __w_pdfjs_require__(4)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};
	
	/***/ }),
	/* 46 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var ITERATOR = __w_pdfjs_require__(4)('iterator');
	var SAFE_CLOSING = false;
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () {
	    SAFE_CLOSING = true;
	  };
	  Array.from(riter, function () {
	    throw 2;
	  });
	} catch (e) {}
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () {
	      return { done: safe = true };
	    };
	    arr[ITERATOR] = function () {
	      return iter;
	    };
	    exec(arr);
	  } catch (e) {}
	  return safe;
	};
	
	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var aFunction = __w_pdfjs_require__(24);
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};
	
	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var META = __w_pdfjs_require__(18)('meta');
	var isObject = __w_pdfjs_require__(3);
	var has = __w_pdfjs_require__(12);
	var setDesc = __w_pdfjs_require__(15).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__w_pdfjs_require__(11)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function setMeta(it) {
	  setDesc(it, META, {
	    value: {
	      i: 'O' + ++id,
	      w: {}
	    }
	  });
	};
	var fastKey = function fastKey(it, create) {
	  if (!isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    if (!isExtensible(it)) return 'F';
	    if (!create) return 'E';
	    setMeta(it);
	  }
	  return it[META].i;
	};
	var getWeak = function getWeak(it, create) {
	  if (!has(it, META)) {
	    if (!isExtensible(it)) return true;
	    if (!create) return false;
	    setMeta(it);
	  }
	  return it[META].w;
	};
	var onFreeze = function onFreeze(it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};
	
	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	var getLookupTableFactory = __w_pdfjs_require__(0).getLookupTableFactory;
	var getGlyphsUnicode = getLookupTableFactory(function (t) {
	 t['A'] = 0x0041;
	 t['AE'] = 0x00C6;
	 t['AEacute'] = 0x01FC;
	 t['AEmacron'] = 0x01E2;
	 t['AEsmall'] = 0xF7E6;
	 t['Aacute'] = 0x00C1;
	 t['Aacutesmall'] = 0xF7E1;
	 t['Abreve'] = 0x0102;
	 t['Abreveacute'] = 0x1EAE;
	 t['Abrevecyrillic'] = 0x04D0;
	 t['Abrevedotbelow'] = 0x1EB6;
	 t['Abrevegrave'] = 0x1EB0;
	 t['Abrevehookabove'] = 0x1EB2;
	 t['Abrevetilde'] = 0x1EB4;
	 t['Acaron'] = 0x01CD;
	 t['Acircle'] = 0x24B6;
	 t['Acircumflex'] = 0x00C2;
	 t['Acircumflexacute'] = 0x1EA4;
	 t['Acircumflexdotbelow'] = 0x1EAC;
	 t['Acircumflexgrave'] = 0x1EA6;
	 t['Acircumflexhookabove'] = 0x1EA8;
	 t['Acircumflexsmall'] = 0xF7E2;
	 t['Acircumflextilde'] = 0x1EAA;
	 t['Acute'] = 0xF6C9;
	 t['Acutesmall'] = 0xF7B4;
	 t['Acyrillic'] = 0x0410;
	 t['Adblgrave'] = 0x0200;
	 t['Adieresis'] = 0x00C4;
	 t['Adieresiscyrillic'] = 0x04D2;
	 t['Adieresismacron'] = 0x01DE;
	 t['Adieresissmall'] = 0xF7E4;
	 t['Adotbelow'] = 0x1EA0;
	 t['Adotmacron'] = 0x01E0;
	 t['Agrave'] = 0x00C0;
	 t['Agravesmall'] = 0xF7E0;
	 t['Ahookabove'] = 0x1EA2;
	 t['Aiecyrillic'] = 0x04D4;
	 t['Ainvertedbreve'] = 0x0202;
	 t['Alpha'] = 0x0391;
	 t['Alphatonos'] = 0x0386;
	 t['Amacron'] = 0x0100;
	 t['Amonospace'] = 0xFF21;
	 t['Aogonek'] = 0x0104;
	 t['Aring'] = 0x00C5;
	 t['Aringacute'] = 0x01FA;
	 t['Aringbelow'] = 0x1E00;
	 t['Aringsmall'] = 0xF7E5;
	 t['Asmall'] = 0xF761;
	 t['Atilde'] = 0x00C3;
	 t['Atildesmall'] = 0xF7E3;
	 t['Aybarmenian'] = 0x0531;
	 t['B'] = 0x0042;
	 t['Bcircle'] = 0x24B7;
	 t['Bdotaccent'] = 0x1E02;
	 t['Bdotbelow'] = 0x1E04;
	 t['Becyrillic'] = 0x0411;
	 t['Benarmenian'] = 0x0532;
	 t['Beta'] = 0x0392;
	 t['Bhook'] = 0x0181;
	 t['Blinebelow'] = 0x1E06;
	 t['Bmonospace'] = 0xFF22;
	 t['Brevesmall'] = 0xF6F4;
	 t['Bsmall'] = 0xF762;
	 t['Btopbar'] = 0x0182;
	 t['C'] = 0x0043;
	 t['Caarmenian'] = 0x053E;
	 t['Cacute'] = 0x0106;
	 t['Caron'] = 0xF6CA;
	 t['Caronsmall'] = 0xF6F5;
	 t['Ccaron'] = 0x010C;
	 t['Ccedilla'] = 0x00C7;
	 t['Ccedillaacute'] = 0x1E08;
	 t['Ccedillasmall'] = 0xF7E7;
	 t['Ccircle'] = 0x24B8;
	 t['Ccircumflex'] = 0x0108;
	 t['Cdot'] = 0x010A;
	 t['Cdotaccent'] = 0x010A;
	 t['Cedillasmall'] = 0xF7B8;
	 t['Chaarmenian'] = 0x0549;
	 t['Cheabkhasiancyrillic'] = 0x04BC;
	 t['Checyrillic'] = 0x0427;
	 t['Chedescenderabkhasiancyrillic'] = 0x04BE;
	 t['Chedescendercyrillic'] = 0x04B6;
	 t['Chedieresiscyrillic'] = 0x04F4;
	 t['Cheharmenian'] = 0x0543;
	 t['Chekhakassiancyrillic'] = 0x04CB;
	 t['Cheverticalstrokecyrillic'] = 0x04B8;
	 t['Chi'] = 0x03A7;
	 t['Chook'] = 0x0187;
	 t['Circumflexsmall'] = 0xF6F6;
	 t['Cmonospace'] = 0xFF23;
	 t['Coarmenian'] = 0x0551;
	 t['Csmall'] = 0xF763;
	 t['D'] = 0x0044;
	 t['DZ'] = 0x01F1;
	 t['DZcaron'] = 0x01C4;
	 t['Daarmenian'] = 0x0534;
	 t['Dafrican'] = 0x0189;
	 t['Dcaron'] = 0x010E;
	 t['Dcedilla'] = 0x1E10;
	 t['Dcircle'] = 0x24B9;
	 t['Dcircumflexbelow'] = 0x1E12;
	 t['Dcroat'] = 0x0110;
	 t['Ddotaccent'] = 0x1E0A;
	 t['Ddotbelow'] = 0x1E0C;
	 t['Decyrillic'] = 0x0414;
	 t['Deicoptic'] = 0x03EE;
	 t['Delta'] = 0x2206;
	 t['Deltagreek'] = 0x0394;
	 t['Dhook'] = 0x018A;
	 t['Dieresis'] = 0xF6CB;
	 t['DieresisAcute'] = 0xF6CC;
	 t['DieresisGrave'] = 0xF6CD;
	 t['Dieresissmall'] = 0xF7A8;
	 t['Digammagreek'] = 0x03DC;
	 t['Djecyrillic'] = 0x0402;
	 t['Dlinebelow'] = 0x1E0E;
	 t['Dmonospace'] = 0xFF24;
	 t['Dotaccentsmall'] = 0xF6F7;
	 t['Dslash'] = 0x0110;
	 t['Dsmall'] = 0xF764;
	 t['Dtopbar'] = 0x018B;
	 t['Dz'] = 0x01F2;
	 t['Dzcaron'] = 0x01C5;
	 t['Dzeabkhasiancyrillic'] = 0x04E0;
	 t['Dzecyrillic'] = 0x0405;
	 t['Dzhecyrillic'] = 0x040F;
	 t['E'] = 0x0045;
	 t['Eacute'] = 0x00C9;
	 t['Eacutesmall'] = 0xF7E9;
	 t['Ebreve'] = 0x0114;
	 t['Ecaron'] = 0x011A;
	 t['Ecedillabreve'] = 0x1E1C;
	 t['Echarmenian'] = 0x0535;
	 t['Ecircle'] = 0x24BA;
	 t['Ecircumflex'] = 0x00CA;
	 t['Ecircumflexacute'] = 0x1EBE;
	 t['Ecircumflexbelow'] = 0x1E18;
	 t['Ecircumflexdotbelow'] = 0x1EC6;
	 t['Ecircumflexgrave'] = 0x1EC0;
	 t['Ecircumflexhookabove'] = 0x1EC2;
	 t['Ecircumflexsmall'] = 0xF7EA;
	 t['Ecircumflextilde'] = 0x1EC4;
	 t['Ecyrillic'] = 0x0404;
	 t['Edblgrave'] = 0x0204;
	 t['Edieresis'] = 0x00CB;
	 t['Edieresissmall'] = 0xF7EB;
	 t['Edot'] = 0x0116;
	 t['Edotaccent'] = 0x0116;
	 t['Edotbelow'] = 0x1EB8;
	 t['Efcyrillic'] = 0x0424;
	 t['Egrave'] = 0x00C8;
	 t['Egravesmall'] = 0xF7E8;
	 t['Eharmenian'] = 0x0537;
	 t['Ehookabove'] = 0x1EBA;
	 t['Eightroman'] = 0x2167;
	 t['Einvertedbreve'] = 0x0206;
	 t['Eiotifiedcyrillic'] = 0x0464;
	 t['Elcyrillic'] = 0x041B;
	 t['Elevenroman'] = 0x216A;
	 t['Emacron'] = 0x0112;
	 t['Emacronacute'] = 0x1E16;
	 t['Emacrongrave'] = 0x1E14;
	 t['Emcyrillic'] = 0x041C;
	 t['Emonospace'] = 0xFF25;
	 t['Encyrillic'] = 0x041D;
	 t['Endescendercyrillic'] = 0x04A2;
	 t['Eng'] = 0x014A;
	 t['Enghecyrillic'] = 0x04A4;
	 t['Enhookcyrillic'] = 0x04C7;
	 t['Eogonek'] = 0x0118;
	 t['Eopen'] = 0x0190;
	 t['Epsilon'] = 0x0395;
	 t['Epsilontonos'] = 0x0388;
	 t['Ercyrillic'] = 0x0420;
	 t['Ereversed'] = 0x018E;
	 t['Ereversedcyrillic'] = 0x042D;
	 t['Escyrillic'] = 0x0421;
	 t['Esdescendercyrillic'] = 0x04AA;
	 t['Esh'] = 0x01A9;
	 t['Esmall'] = 0xF765;
	 t['Eta'] = 0x0397;
	 t['Etarmenian'] = 0x0538;
	 t['Etatonos'] = 0x0389;
	 t['Eth'] = 0x00D0;
	 t['Ethsmall'] = 0xF7F0;
	 t['Etilde'] = 0x1EBC;
	 t['Etildebelow'] = 0x1E1A;
	 t['Euro'] = 0x20AC;
	 t['Ezh'] = 0x01B7;
	 t['Ezhcaron'] = 0x01EE;
	 t['Ezhreversed'] = 0x01B8;
	 t['F'] = 0x0046;
	 t['Fcircle'] = 0x24BB;
	 t['Fdotaccent'] = 0x1E1E;
	 t['Feharmenian'] = 0x0556;
	 t['Feicoptic'] = 0x03E4;
	 t['Fhook'] = 0x0191;
	 t['Fitacyrillic'] = 0x0472;
	 t['Fiveroman'] = 0x2164;
	 t['Fmonospace'] = 0xFF26;
	 t['Fourroman'] = 0x2163;
	 t['Fsmall'] = 0xF766;
	 t['G'] = 0x0047;
	 t['GBsquare'] = 0x3387;
	 t['Gacute'] = 0x01F4;
	 t['Gamma'] = 0x0393;
	 t['Gammaafrican'] = 0x0194;
	 t['Gangiacoptic'] = 0x03EA;
	 t['Gbreve'] = 0x011E;
	 t['Gcaron'] = 0x01E6;
	 t['Gcedilla'] = 0x0122;
	 t['Gcircle'] = 0x24BC;
	 t['Gcircumflex'] = 0x011C;
	 t['Gcommaaccent'] = 0x0122;
	 t['Gdot'] = 0x0120;
	 t['Gdotaccent'] = 0x0120;
	 t['Gecyrillic'] = 0x0413;
	 t['Ghadarmenian'] = 0x0542;
	 t['Ghemiddlehookcyrillic'] = 0x0494;
	 t['Ghestrokecyrillic'] = 0x0492;
	 t['Gheupturncyrillic'] = 0x0490;
	 t['Ghook'] = 0x0193;
	 t['Gimarmenian'] = 0x0533;
	 t['Gjecyrillic'] = 0x0403;
	 t['Gmacron'] = 0x1E20;
	 t['Gmonospace'] = 0xFF27;
	 t['Grave'] = 0xF6CE;
	 t['Gravesmall'] = 0xF760;
	 t['Gsmall'] = 0xF767;
	 t['Gsmallhook'] = 0x029B;
	 t['Gstroke'] = 0x01E4;
	 t['H'] = 0x0048;
	 t['H18533'] = 0x25CF;
	 t['H18543'] = 0x25AA;
	 t['H18551'] = 0x25AB;
	 t['H22073'] = 0x25A1;
	 t['HPsquare'] = 0x33CB;
	 t['Haabkhasiancyrillic'] = 0x04A8;
	 t['Hadescendercyrillic'] = 0x04B2;
	 t['Hardsigncyrillic'] = 0x042A;
	 t['Hbar'] = 0x0126;
	 t['Hbrevebelow'] = 0x1E2A;
	 t['Hcedilla'] = 0x1E28;
	 t['Hcircle'] = 0x24BD;
	 t['Hcircumflex'] = 0x0124;
	 t['Hdieresis'] = 0x1E26;
	 t['Hdotaccent'] = 0x1E22;
	 t['Hdotbelow'] = 0x1E24;
	 t['Hmonospace'] = 0xFF28;
	 t['Hoarmenian'] = 0x0540;
	 t['Horicoptic'] = 0x03E8;
	 t['Hsmall'] = 0xF768;
	 t['Hungarumlaut'] = 0xF6CF;
	 t['Hungarumlautsmall'] = 0xF6F8;
	 t['Hzsquare'] = 0x3390;
	 t['I'] = 0x0049;
	 t['IAcyrillic'] = 0x042F;
	 t['IJ'] = 0x0132;
	 t['IUcyrillic'] = 0x042E;
	 t['Iacute'] = 0x00CD;
	 t['Iacutesmall'] = 0xF7ED;
	 t['Ibreve'] = 0x012C;
	 t['Icaron'] = 0x01CF;
	 t['Icircle'] = 0x24BE;
	 t['Icircumflex'] = 0x00CE;
	 t['Icircumflexsmall'] = 0xF7EE;
	 t['Icyrillic'] = 0x0406;
	 t['Idblgrave'] = 0x0208;
	 t['Idieresis'] = 0x00CF;
	 t['Idieresisacute'] = 0x1E2E;
	 t['Idieresiscyrillic'] = 0x04E4;
	 t['Idieresissmall'] = 0xF7EF;
	 t['Idot'] = 0x0130;
	 t['Idotaccent'] = 0x0130;
	 t['Idotbelow'] = 0x1ECA;
	 t['Iebrevecyrillic'] = 0x04D6;
	 t['Iecyrillic'] = 0x0415;
	 t['Ifraktur'] = 0x2111;
	 t['Igrave'] = 0x00CC;
	 t['Igravesmall'] = 0xF7EC;
	 t['Ihookabove'] = 0x1EC8;
	 t['Iicyrillic'] = 0x0418;
	 t['Iinvertedbreve'] = 0x020A;
	 t['Iishortcyrillic'] = 0x0419;
	 t['Imacron'] = 0x012A;
	 t['Imacroncyrillic'] = 0x04E2;
	 t['Imonospace'] = 0xFF29;
	 t['Iniarmenian'] = 0x053B;
	 t['Iocyrillic'] = 0x0401;
	 t['Iogonek'] = 0x012E;
	 t['Iota'] = 0x0399;
	 t['Iotaafrican'] = 0x0196;
	 t['Iotadieresis'] = 0x03AA;
	 t['Iotatonos'] = 0x038A;
	 t['Ismall'] = 0xF769;
	 t['Istroke'] = 0x0197;
	 t['Itilde'] = 0x0128;
	 t['Itildebelow'] = 0x1E2C;
	 t['Izhitsacyrillic'] = 0x0474;
	 t['Izhitsadblgravecyrillic'] = 0x0476;
	 t['J'] = 0x004A;
	 t['Jaarmenian'] = 0x0541;
	 t['Jcircle'] = 0x24BF;
	 t['Jcircumflex'] = 0x0134;
	 t['Jecyrillic'] = 0x0408;
	 t['Jheharmenian'] = 0x054B;
	 t['Jmonospace'] = 0xFF2A;
	 t['Jsmall'] = 0xF76A;
	 t['K'] = 0x004B;
	 t['KBsquare'] = 0x3385;
	 t['KKsquare'] = 0x33CD;
	 t['Kabashkircyrillic'] = 0x04A0;
	 t['Kacute'] = 0x1E30;
	 t['Kacyrillic'] = 0x041A;
	 t['Kadescendercyrillic'] = 0x049A;
	 t['Kahookcyrillic'] = 0x04C3;
	 t['Kappa'] = 0x039A;
	 t['Kastrokecyrillic'] = 0x049E;
	 t['Kaverticalstrokecyrillic'] = 0x049C;
	 t['Kcaron'] = 0x01E8;
	 t['Kcedilla'] = 0x0136;
	 t['Kcircle'] = 0x24C0;
	 t['Kcommaaccent'] = 0x0136;
	 t['Kdotbelow'] = 0x1E32;
	 t['Keharmenian'] = 0x0554;
	 t['Kenarmenian'] = 0x053F;
	 t['Khacyrillic'] = 0x0425;
	 t['Kheicoptic'] = 0x03E6;
	 t['Khook'] = 0x0198;
	 t['Kjecyrillic'] = 0x040C;
	 t['Klinebelow'] = 0x1E34;
	 t['Kmonospace'] = 0xFF2B;
	 t['Koppacyrillic'] = 0x0480;
	 t['Koppagreek'] = 0x03DE;
	 t['Ksicyrillic'] = 0x046E;
	 t['Ksmall'] = 0xF76B;
	 t['L'] = 0x004C;
	 t['LJ'] = 0x01C7;
	 t['LL'] = 0xF6BF;
	 t['Lacute'] = 0x0139;
	 t['Lambda'] = 0x039B;
	 t['Lcaron'] = 0x013D;
	 t['Lcedilla'] = 0x013B;
	 t['Lcircle'] = 0x24C1;
	 t['Lcircumflexbelow'] = 0x1E3C;
	 t['Lcommaaccent'] = 0x013B;
	 t['Ldot'] = 0x013F;
	 t['Ldotaccent'] = 0x013F;
	 t['Ldotbelow'] = 0x1E36;
	 t['Ldotbelowmacron'] = 0x1E38;
	 t['Liwnarmenian'] = 0x053C;
	 t['Lj'] = 0x01C8;
	 t['Ljecyrillic'] = 0x0409;
	 t['Llinebelow'] = 0x1E3A;
	 t['Lmonospace'] = 0xFF2C;
	 t['Lslash'] = 0x0141;
	 t['Lslashsmall'] = 0xF6F9;
	 t['Lsmall'] = 0xF76C;
	 t['M'] = 0x004D;
	 t['MBsquare'] = 0x3386;
	 t['Macron'] = 0xF6D0;
	 t['Macronsmall'] = 0xF7AF;
	 t['Macute'] = 0x1E3E;
	 t['Mcircle'] = 0x24C2;
	 t['Mdotaccent'] = 0x1E40;
	 t['Mdotbelow'] = 0x1E42;
	 t['Menarmenian'] = 0x0544;
	 t['Mmonospace'] = 0xFF2D;
	 t['Msmall'] = 0xF76D;
	 t['Mturned'] = 0x019C;
	 t['Mu'] = 0x039C;
	 t['N'] = 0x004E;
	 t['NJ'] = 0x01CA;
	 t['Nacute'] = 0x0143;
	 t['Ncaron'] = 0x0147;
	 t['Ncedilla'] = 0x0145;
	 t['Ncircle'] = 0x24C3;
	 t['Ncircumflexbelow'] = 0x1E4A;
	 t['Ncommaaccent'] = 0x0145;
	 t['Ndotaccent'] = 0x1E44;
	 t['Ndotbelow'] = 0x1E46;
	 t['Nhookleft'] = 0x019D;
	 t['Nineroman'] = 0x2168;
	 t['Nj'] = 0x01CB;
	 t['Njecyrillic'] = 0x040A;
	 t['Nlinebelow'] = 0x1E48;
	 t['Nmonospace'] = 0xFF2E;
	 t['Nowarmenian'] = 0x0546;
	 t['Nsmall'] = 0xF76E;
	 t['Ntilde'] = 0x00D1;
	 t['Ntildesmall'] = 0xF7F1;
	 t['Nu'] = 0x039D;
	 t['O'] = 0x004F;
	 t['OE'] = 0x0152;
	 t['OEsmall'] = 0xF6FA;
	 t['Oacute'] = 0x00D3;
	 t['Oacutesmall'] = 0xF7F3;
	 t['Obarredcyrillic'] = 0x04E8;
	 t['Obarreddieresiscyrillic'] = 0x04EA;
	 t['Obreve'] = 0x014E;
	 t['Ocaron'] = 0x01D1;
	 t['Ocenteredtilde'] = 0x019F;
	 t['Ocircle'] = 0x24C4;
	 t['Ocircumflex'] = 0x00D4;
	 t['Ocircumflexacute'] = 0x1ED0;
	 t['Ocircumflexdotbelow'] = 0x1ED8;
	 t['Ocircumflexgrave'] = 0x1ED2;
	 t['Ocircumflexhookabove'] = 0x1ED4;
	 t['Ocircumflexsmall'] = 0xF7F4;
	 t['Ocircumflextilde'] = 0x1ED6;
	 t['Ocyrillic'] = 0x041E;
	 t['Odblacute'] = 0x0150;
	 t['Odblgrave'] = 0x020C;
	 t['Odieresis'] = 0x00D6;
	 t['Odieresiscyrillic'] = 0x04E6;
	 t['Odieresissmall'] = 0xF7F6;
	 t['Odotbelow'] = 0x1ECC;
	 t['Ogoneksmall'] = 0xF6FB;
	 t['Ograve'] = 0x00D2;
	 t['Ogravesmall'] = 0xF7F2;
	 t['Oharmenian'] = 0x0555;
	 t['Ohm'] = 0x2126;
	 t['Ohookabove'] = 0x1ECE;
	 t['Ohorn'] = 0x01A0;
	 t['Ohornacute'] = 0x1EDA;
	 t['Ohorndotbelow'] = 0x1EE2;
	 t['Ohorngrave'] = 0x1EDC;
	 t['Ohornhookabove'] = 0x1EDE;
	 t['Ohorntilde'] = 0x1EE0;
	 t['Ohungarumlaut'] = 0x0150;
	 t['Oi'] = 0x01A2;
	 t['Oinvertedbreve'] = 0x020E;
	 t['Omacron'] = 0x014C;
	 t['Omacronacute'] = 0x1E52;
	 t['Omacrongrave'] = 0x1E50;
	 t['Omega'] = 0x2126;
	 t['Omegacyrillic'] = 0x0460;
	 t['Omegagreek'] = 0x03A9;
	 t['Omegaroundcyrillic'] = 0x047A;
	 t['Omegatitlocyrillic'] = 0x047C;
	 t['Omegatonos'] = 0x038F;
	 t['Omicron'] = 0x039F;
	 t['Omicrontonos'] = 0x038C;
	 t['Omonospace'] = 0xFF2F;
	 t['Oneroman'] = 0x2160;
	 t['Oogonek'] = 0x01EA;
	 t['Oogonekmacron'] = 0x01EC;
	 t['Oopen'] = 0x0186;
	 t['Oslash'] = 0x00D8;
	 t['Oslashacute'] = 0x01FE;
	 t['Oslashsmall'] = 0xF7F8;
	 t['Osmall'] = 0xF76F;
	 t['Ostrokeacute'] = 0x01FE;
	 t['Otcyrillic'] = 0x047E;
	 t['Otilde'] = 0x00D5;
	 t['Otildeacute'] = 0x1E4C;
	 t['Otildedieresis'] = 0x1E4E;
	 t['Otildesmall'] = 0xF7F5;
	 t['P'] = 0x0050;
	 t['Pacute'] = 0x1E54;
	 t['Pcircle'] = 0x24C5;
	 t['Pdotaccent'] = 0x1E56;
	 t['Pecyrillic'] = 0x041F;
	 t['Peharmenian'] = 0x054A;
	 t['Pemiddlehookcyrillic'] = 0x04A6;
	 t['Phi'] = 0x03A6;
	 t['Phook'] = 0x01A4;
	 t['Pi'] = 0x03A0;
	 t['Piwrarmenian'] = 0x0553;
	 t['Pmonospace'] = 0xFF30;
	 t['Psi'] = 0x03A8;
	 t['Psicyrillic'] = 0x0470;
	 t['Psmall'] = 0xF770;
	 t['Q'] = 0x0051;
	 t['Qcircle'] = 0x24C6;
	 t['Qmonospace'] = 0xFF31;
	 t['Qsmall'] = 0xF771;
	 t['R'] = 0x0052;
	 t['Raarmenian'] = 0x054C;
	 t['Racute'] = 0x0154;
	 t['Rcaron'] = 0x0158;
	 t['Rcedilla'] = 0x0156;
	 t['Rcircle'] = 0x24C7;
	 t['Rcommaaccent'] = 0x0156;
	 t['Rdblgrave'] = 0x0210;
	 t['Rdotaccent'] = 0x1E58;
	 t['Rdotbelow'] = 0x1E5A;
	 t['Rdotbelowmacron'] = 0x1E5C;
	 t['Reharmenian'] = 0x0550;
	 t['Rfraktur'] = 0x211C;
	 t['Rho'] = 0x03A1;
	 t['Ringsmall'] = 0xF6FC;
	 t['Rinvertedbreve'] = 0x0212;
	 t['Rlinebelow'] = 0x1E5E;
	 t['Rmonospace'] = 0xFF32;
	 t['Rsmall'] = 0xF772;
	 t['Rsmallinverted'] = 0x0281;
	 t['Rsmallinvertedsuperior'] = 0x02B6;
	 t['S'] = 0x0053;
	 t['SF010000'] = 0x250C;
	 t['SF020000'] = 0x2514;
	 t['SF030000'] = 0x2510;
	 t['SF040000'] = 0x2518;
	 t['SF050000'] = 0x253C;
	 t['SF060000'] = 0x252C;
	 t['SF070000'] = 0x2534;
	 t['SF080000'] = 0x251C;
	 t['SF090000'] = 0x2524;
	 t['SF100000'] = 0x2500;
	 t['SF110000'] = 0x2502;
	 t['SF190000'] = 0x2561;
	 t['SF200000'] = 0x2562;
	 t['SF210000'] = 0x2556;
	 t['SF220000'] = 0x2555;
	 t['SF230000'] = 0x2563;
	 t['SF240000'] = 0x2551;
	 t['SF250000'] = 0x2557;
	 t['SF260000'] = 0x255D;
	 t['SF270000'] = 0x255C;
	 t['SF280000'] = 0x255B;
	 t['SF360000'] = 0x255E;
	 t['SF370000'] = 0x255F;
	 t['SF380000'] = 0x255A;
	 t['SF390000'] = 0x2554;
	 t['SF400000'] = 0x2569;
	 t['SF410000'] = 0x2566;
	 t['SF420000'] = 0x2560;
	 t['SF430000'] = 0x2550;
	 t['SF440000'] = 0x256C;
	 t['SF450000'] = 0x2567;
	 t['SF460000'] = 0x2568;
	 t['SF470000'] = 0x2564;
	 t['SF480000'] = 0x2565;
	 t['SF490000'] = 0x2559;
	 t['SF500000'] = 0x2558;
	 t['SF510000'] = 0x2552;
	 t['SF520000'] = 0x2553;
	 t['SF530000'] = 0x256B;
	 t['SF540000'] = 0x256A;
	 t['Sacute'] = 0x015A;
	 t['Sacutedotaccent'] = 0x1E64;
	 t['Sampigreek'] = 0x03E0;
	 t['Scaron'] = 0x0160;
	 t['Scarondotaccent'] = 0x1E66;
	 t['Scaronsmall'] = 0xF6FD;
	 t['Scedilla'] = 0x015E;
	 t['Schwa'] = 0x018F;
	 t['Schwacyrillic'] = 0x04D8;
	 t['Schwadieresiscyrillic'] = 0x04DA;
	 t['Scircle'] = 0x24C8;
	 t['Scircumflex'] = 0x015C;
	 t['Scommaaccent'] = 0x0218;
	 t['Sdotaccent'] = 0x1E60;
	 t['Sdotbelow'] = 0x1E62;
	 t['Sdotbelowdotaccent'] = 0x1E68;
	 t['Seharmenian'] = 0x054D;
	 t['Sevenroman'] = 0x2166;
	 t['Shaarmenian'] = 0x0547;
	 t['Shacyrillic'] = 0x0428;
	 t['Shchacyrillic'] = 0x0429;
	 t['Sheicoptic'] = 0x03E2;
	 t['Shhacyrillic'] = 0x04BA;
	 t['Shimacoptic'] = 0x03EC;
	 t['Sigma'] = 0x03A3;
	 t['Sixroman'] = 0x2165;
	 t['Smonospace'] = 0xFF33;
	 t['Softsigncyrillic'] = 0x042C;
	 t['Ssmall'] = 0xF773;
	 t['Stigmagreek'] = 0x03DA;
	 t['T'] = 0x0054;
	 t['Tau'] = 0x03A4;
	 t['Tbar'] = 0x0166;
	 t['Tcaron'] = 0x0164;
	 t['Tcedilla'] = 0x0162;
	 t['Tcircle'] = 0x24C9;
	 t['Tcircumflexbelow'] = 0x1E70;
	 t['Tcommaaccent'] = 0x0162;
	 t['Tdotaccent'] = 0x1E6A;
	 t['Tdotbelow'] = 0x1E6C;
	 t['Tecyrillic'] = 0x0422;
	 t['Tedescendercyrillic'] = 0x04AC;
	 t['Tenroman'] = 0x2169;
	 t['Tetsecyrillic'] = 0x04B4;
	 t['Theta'] = 0x0398;
	 t['Thook'] = 0x01AC;
	 t['Thorn'] = 0x00DE;
	 t['Thornsmall'] = 0xF7FE;
	 t['Threeroman'] = 0x2162;
	 t['Tildesmall'] = 0xF6FE;
	 t['Tiwnarmenian'] = 0x054F;
	 t['Tlinebelow'] = 0x1E6E;
	 t['Tmonospace'] = 0xFF34;
	 t['Toarmenian'] = 0x0539;
	 t['Tonefive'] = 0x01BC;
	 t['Tonesix'] = 0x0184;
	 t['Tonetwo'] = 0x01A7;
	 t['Tretroflexhook'] = 0x01AE;
	 t['Tsecyrillic'] = 0x0426;
	 t['Tshecyrillic'] = 0x040B;
	 t['Tsmall'] = 0xF774;
	 t['Twelveroman'] = 0x216B;
	 t['Tworoman'] = 0x2161;
	 t['U'] = 0x0055;
	 t['Uacute'] = 0x00DA;
	 t['Uacutesmall'] = 0xF7FA;
	 t['Ubreve'] = 0x016C;
	 t['Ucaron'] = 0x01D3;
	 t['Ucircle'] = 0x24CA;
	 t['Ucircumflex'] = 0x00DB;
	 t['Ucircumflexbelow'] = 0x1E76;
	 t['Ucircumflexsmall'] = 0xF7FB;
	 t['Ucyrillic'] = 0x0423;
	 t['Udblacute'] = 0x0170;
	 t['Udblgrave'] = 0x0214;
	 t['Udieresis'] = 0x00DC;
	 t['Udieresisacute'] = 0x01D7;
	 t['Udieresisbelow'] = 0x1E72;
	 t['Udieresiscaron'] = 0x01D9;
	 t['Udieresiscyrillic'] = 0x04F0;
	 t['Udieresisgrave'] = 0x01DB;
	 t['Udieresismacron'] = 0x01D5;
	 t['Udieresissmall'] = 0xF7FC;
	 t['Udotbelow'] = 0x1EE4;
	 t['Ugrave'] = 0x00D9;
	 t['Ugravesmall'] = 0xF7F9;
	 t['Uhookabove'] = 0x1EE6;
	 t['Uhorn'] = 0x01AF;
	 t['Uhornacute'] = 0x1EE8;
	 t['Uhorndotbelow'] = 0x1EF0;
	 t['Uhorngrave'] = 0x1EEA;
	 t['Uhornhookabove'] = 0x1EEC;
	 t['Uhorntilde'] = 0x1EEE;
	 t['Uhungarumlaut'] = 0x0170;
	 t['Uhungarumlautcyrillic'] = 0x04F2;
	 t['Uinvertedbreve'] = 0x0216;
	 t['Ukcyrillic'] = 0x0478;
	 t['Umacron'] = 0x016A;
	 t['Umacroncyrillic'] = 0x04EE;
	 t['Umacrondieresis'] = 0x1E7A;
	 t['Umonospace'] = 0xFF35;
	 t['Uogonek'] = 0x0172;
	 t['Upsilon'] = 0x03A5;
	 t['Upsilon1'] = 0x03D2;
	 t['Upsilonacutehooksymbolgreek'] = 0x03D3;
	 t['Upsilonafrican'] = 0x01B1;
	 t['Upsilondieresis'] = 0x03AB;
	 t['Upsilondieresishooksymbolgreek'] = 0x03D4;
	 t['Upsilonhooksymbol'] = 0x03D2;
	 t['Upsilontonos'] = 0x038E;
	 t['Uring'] = 0x016E;
	 t['Ushortcyrillic'] = 0x040E;
	 t['Usmall'] = 0xF775;
	 t['Ustraightcyrillic'] = 0x04AE;
	 t['Ustraightstrokecyrillic'] = 0x04B0;
	 t['Utilde'] = 0x0168;
	 t['Utildeacute'] = 0x1E78;
	 t['Utildebelow'] = 0x1E74;
	 t['V'] = 0x0056;
	 t['Vcircle'] = 0x24CB;
	 t['Vdotbelow'] = 0x1E7E;
	 t['Vecyrillic'] = 0x0412;
	 t['Vewarmenian'] = 0x054E;
	 t['Vhook'] = 0x01B2;
	 t['Vmonospace'] = 0xFF36;
	 t['Voarmenian'] = 0x0548;
	 t['Vsmall'] = 0xF776;
	 t['Vtilde'] = 0x1E7C;
	 t['W'] = 0x0057;
	 t['Wacute'] = 0x1E82;
	 t['Wcircle'] = 0x24CC;
	 t['Wcircumflex'] = 0x0174;
	 t['Wdieresis'] = 0x1E84;
	 t['Wdotaccent'] = 0x1E86;
	 t['Wdotbelow'] = 0x1E88;
	 t['Wgrave'] = 0x1E80;
	 t['Wmonospace'] = 0xFF37;
	 t['Wsmall'] = 0xF777;
	 t['X'] = 0x0058;
	 t['Xcircle'] = 0x24CD;
	 t['Xdieresis'] = 0x1E8C;
	 t['Xdotaccent'] = 0x1E8A;
	 t['Xeharmenian'] = 0x053D;
	 t['Xi'] = 0x039E;
	 t['Xmonospace'] = 0xFF38;
	 t['Xsmall'] = 0xF778;
	 t['Y'] = 0x0059;
	 t['Yacute'] = 0x00DD;
	 t['Yacutesmall'] = 0xF7FD;
	 t['Yatcyrillic'] = 0x0462;
	 t['Ycircle'] = 0x24CE;
	 t['Ycircumflex'] = 0x0176;
	 t['Ydieresis'] = 0x0178;
	 t['Ydieresissmall'] = 0xF7FF;
	 t['Ydotaccent'] = 0x1E8E;
	 t['Ydotbelow'] = 0x1EF4;
	 t['Yericyrillic'] = 0x042B;
	 t['Yerudieresiscyrillic'] = 0x04F8;
	 t['Ygrave'] = 0x1EF2;
	 t['Yhook'] = 0x01B3;
	 t['Yhookabove'] = 0x1EF6;
	 t['Yiarmenian'] = 0x0545;
	 t['Yicyrillic'] = 0x0407;
	 t['Yiwnarmenian'] = 0x0552;
	 t['Ymonospace'] = 0xFF39;
	 t['Ysmall'] = 0xF779;
	 t['Ytilde'] = 0x1EF8;
	 t['Yusbigcyrillic'] = 0x046A;
	 t['Yusbigiotifiedcyrillic'] = 0x046C;
	 t['Yuslittlecyrillic'] = 0x0466;
	 t['Yuslittleiotifiedcyrillic'] = 0x0468;
	 t['Z'] = 0x005A;
	 t['Zaarmenian'] = 0x0536;
	 t['Zacute'] = 0x0179;
	 t['Zcaron'] = 0x017D;
	 t['Zcaronsmall'] = 0xF6FF;
	 t['Zcircle'] = 0x24CF;
	 t['Zcircumflex'] = 0x1E90;
	 t['Zdot'] = 0x017B;
	 t['Zdotaccent'] = 0x017B;
	 t['Zdotbelow'] = 0x1E92;
	 t['Zecyrillic'] = 0x0417;
	 t['Zedescendercyrillic'] = 0x0498;
	 t['Zedieresiscyrillic'] = 0x04DE;
	 t['Zeta'] = 0x0396;
	 t['Zhearmenian'] = 0x053A;
	 t['Zhebrevecyrillic'] = 0x04C1;
	 t['Zhecyrillic'] = 0x0416;
	 t['Zhedescendercyrillic'] = 0x0496;
	 t['Zhedieresiscyrillic'] = 0x04DC;
	 t['Zlinebelow'] = 0x1E94;
	 t['Zmonospace'] = 0xFF3A;
	 t['Zsmall'] = 0xF77A;
	 t['Zstroke'] = 0x01B5;
	 t['a'] = 0x0061;
	 t['aabengali'] = 0x0986;
	 t['aacute'] = 0x00E1;
	 t['aadeva'] = 0x0906;
	 t['aagujarati'] = 0x0A86;
	 t['aagurmukhi'] = 0x0A06;
	 t['aamatragurmukhi'] = 0x0A3E;
	 t['aarusquare'] = 0x3303;
	 t['aavowelsignbengali'] = 0x09BE;
	 t['aavowelsigndeva'] = 0x093E;
	 t['aavowelsigngujarati'] = 0x0ABE;
	 t['abbreviationmarkarmenian'] = 0x055F;
	 t['abbreviationsigndeva'] = 0x0970;
	 t['abengali'] = 0x0985;
	 t['abopomofo'] = 0x311A;
	 t['abreve'] = 0x0103;
	 t['abreveacute'] = 0x1EAF;
	 t['abrevecyrillic'] = 0x04D1;
	 t['abrevedotbelow'] = 0x1EB7;
	 t['abrevegrave'] = 0x1EB1;
	 t['abrevehookabove'] = 0x1EB3;
	 t['abrevetilde'] = 0x1EB5;
	 t['acaron'] = 0x01CE;
	 t['acircle'] = 0x24D0;
	 t['acircumflex'] = 0x00E2;
	 t['acircumflexacute'] = 0x1EA5;
	 t['acircumflexdotbelow'] = 0x1EAD;
	 t['acircumflexgrave'] = 0x1EA7;
	 t['acircumflexhookabove'] = 0x1EA9;
	 t['acircumflextilde'] = 0x1EAB;
	 t['acute'] = 0x00B4;
	 t['acutebelowcmb'] = 0x0317;
	 t['acutecmb'] = 0x0301;
	 t['acutecomb'] = 0x0301;
	 t['acutedeva'] = 0x0954;
	 t['acutelowmod'] = 0x02CF;
	 t['acutetonecmb'] = 0x0341;
	 t['acyrillic'] = 0x0430;
	 t['adblgrave'] = 0x0201;
	 t['addakgurmukhi'] = 0x0A71;
	 t['adeva'] = 0x0905;
	 t['adieresis'] = 0x00E4;
	 t['adieresiscyrillic'] = 0x04D3;
	 t['adieresismacron'] = 0x01DF;
	 t['adotbelow'] = 0x1EA1;
	 t['adotmacron'] = 0x01E1;
	 t['ae'] = 0x00E6;
	 t['aeacute'] = 0x01FD;
	 t['aekorean'] = 0x3150;
	 t['aemacron'] = 0x01E3;
	 t['afii00208'] = 0x2015;
	 t['afii08941'] = 0x20A4;
	 t['afii10017'] = 0x0410;
	 t['afii10018'] = 0x0411;
	 t['afii10019'] = 0x0412;
	 t['afii10020'] = 0x0413;
	 t['afii10021'] = 0x0414;
	 t['afii10022'] = 0x0415;
	 t['afii10023'] = 0x0401;
	 t['afii10024'] = 0x0416;
	 t['afii10025'] = 0x0417;
	 t['afii10026'] = 0x0418;
	 t['afii10027'] = 0x0419;
	 t['afii10028'] = 0x041A;
	 t['afii10029'] = 0x041B;
	 t['afii10030'] = 0x041C;
	 t['afii10031'] = 0x041D;
	 t['afii10032'] = 0x041E;
	 t['afii10033'] = 0x041F;
	 t['afii10034'] = 0x0420;
	 t['afii10035'] = 0x0421;
	 t['afii10036'] = 0x0422;
	 t['afii10037'] = 0x0423;
	 t['afii10038'] = 0x0424;
	 t['afii10039'] = 0x0425;
	 t['afii10040'] = 0x0426;
	 t['afii10041'] = 0x0427;
	 t['afii10042'] = 0x0428;
	 t['afii10043'] = 0x0429;
	 t['afii10044'] = 0x042A;
	 t['afii10045'] = 0x042B;
	 t['afii10046'] = 0x042C;
	 t['afii10047'] = 0x042D;
	 t['afii10048'] = 0x042E;
	 t['afii10049'] = 0x042F;
	 t['afii10050'] = 0x0490;
	 t['afii10051'] = 0x0402;
	 t['afii10052'] = 0x0403;
	 t['afii10053'] = 0x0404;
	 t['afii10054'] = 0x0405;
	 t['afii10055'] = 0x0406;
	 t['afii10056'] = 0x0407;
	 t['afii10057'] = 0x0408;
	 t['afii10058'] = 0x0409;
	 t['afii10059'] = 0x040A;
	 t['afii10060'] = 0x040B;
	 t['afii10061'] = 0x040C;
	 t['afii10062'] = 0x040E;
	 t['afii10063'] = 0xF6C4;
	 t['afii10064'] = 0xF6C5;
	 t['afii10065'] = 0x0430;
	 t['afii10066'] = 0x0431;
	 t['afii10067'] = 0x0432;
	 t['afii10068'] = 0x0433;
	 t['afii10069'] = 0x0434;
	 t['afii10070'] = 0x0435;
	 t['afii10071'] = 0x0451;
	 t['afii10072'] = 0x0436;
	 t['afii10073'] = 0x0437;
	 t['afii10074'] = 0x0438;
	 t['afii10075'] = 0x0439;
	 t['afii10076'] = 0x043A;
	 t['afii10077'] = 0x043B;
	 t['afii10078'] = 0x043C;
	 t['afii10079'] = 0x043D;
	 t['afii10080'] = 0x043E;
	 t['afii10081'] = 0x043F;
	 t['afii10082'] = 0x0440;
	 t['afii10083'] = 0x0441;
	 t['afii10084'] = 0x0442;
	 t['afii10085'] = 0x0443;
	 t['afii10086'] = 0x0444;
	 t['afii10087'] = 0x0445;
	 t['afii10088'] = 0x0446;
	 t['afii10089'] = 0x0447;
	 t['afii10090'] = 0x0448;
	 t['afii10091'] = 0x0449;
	 t['afii10092'] = 0x044A;
	 t['afii10093'] = 0x044B;
	 t['afii10094'] = 0x044C;
	 t['afii10095'] = 0x044D;
	 t['afii10096'] = 0x044E;
	 t['afii10097'] = 0x044F;
	 t['afii10098'] = 0x0491;
	 t['afii10099'] = 0x0452;
	 t['afii10100'] = 0x0453;
	 t['afii10101'] = 0x0454;
	 t['afii10102'] = 0x0455;
	 t['afii10103'] = 0x0456;
	 t['afii10104'] = 0x0457;
	 t['afii10105'] = 0x0458;
	 t['afii10106'] = 0x0459;
	 t['afii10107'] = 0x045A;
	 t['afii10108'] = 0x045B;
	 t['afii10109'] = 0x045C;
	 t['afii10110'] = 0x045E;
	 t['afii10145'] = 0x040F;
	 t['afii10146'] = 0x0462;
	 t['afii10147'] = 0x0472;
	 t['afii10148'] = 0x0474;
	 t['afii10192'] = 0xF6C6;
	 t['afii10193'] = 0x045F;
	 t['afii10194'] = 0x0463;
	 t['afii10195'] = 0x0473;
	 t['afii10196'] = 0x0475;
	 t['afii10831'] = 0xF6C7;
	 t['afii10832'] = 0xF6C8;
	 t['afii10846'] = 0x04D9;
	 t['afii299'] = 0x200E;
	 t['afii300'] = 0x200F;
	 t['afii301'] = 0x200D;
	 t['afii57381'] = 0x066A;
	 t['afii57388'] = 0x060C;
	 t['afii57392'] = 0x0660;
	 t['afii57393'] = 0x0661;
	 t['afii57394'] = 0x0662;
	 t['afii57395'] = 0x0663;
	 t['afii57396'] = 0x0664;
	 t['afii57397'] = 0x0665;
	 t['afii57398'] = 0x0666;
	 t['afii57399'] = 0x0667;
	 t['afii57400'] = 0x0668;
	 t['afii57401'] = 0x0669;
	 t['afii57403'] = 0x061B;
	 t['afii57407'] = 0x061F;
	 t['afii57409'] = 0x0621;
	 t['afii57410'] = 0x0622;
	 t['afii57411'] = 0x0623;
	 t['afii57412'] = 0x0624;
	 t['afii57413'] = 0x0625;
	 t['afii57414'] = 0x0626;
	 t['afii57415'] = 0x0627;
	 t['afii57416'] = 0x0628;
	 t['afii57417'] = 0x0629;
	 t['afii57418'] = 0x062A;
	 t['afii57419'] = 0x062B;
	 t['afii57420'] = 0x062C;
	 t['afii57421'] = 0x062D;
	 t['afii57422'] = 0x062E;
	 t['afii57423'] = 0x062F;
	 t['afii57424'] = 0x0630;
	 t['afii57425'] = 0x0631;
	 t['afii57426'] = 0x0632;
	 t['afii57427'] = 0x0633;
	 t['afii57428'] = 0x0634;
	 t['afii57429'] = 0x0635;
	 t['afii57430'] = 0x0636;
	 t['afii57431'] = 0x0637;
	 t['afii57432'] = 0x0638;
	 t['afii57433'] = 0x0639;
	 t['afii57434'] = 0x063A;
	 t['afii57440'] = 0x0640;
	 t['afii57441'] = 0x0641;
	 t['afii57442'] = 0x0642;
	 t['afii57443'] = 0x0643;
	 t['afii57444'] = 0x0644;
	 t['afii57445'] = 0x0645;
	 t['afii57446'] = 0x0646;
	 t['afii57448'] = 0x0648;
	 t['afii57449'] = 0x0649;
	 t['afii57450'] = 0x064A;
	 t['afii57451'] = 0x064B;
	 t['afii57452'] = 0x064C;
	 t['afii57453'] = 0x064D;
	 t['afii57454'] = 0x064E;
	 t['afii57455'] = 0x064F;
	 t['afii57456'] = 0x0650;
	 t['afii57457'] = 0x0651;
	 t['afii57458'] = 0x0652;
	 t['afii57470'] = 0x0647;
	 t['afii57505'] = 0x06A4;
	 t['afii57506'] = 0x067E;
	 t['afii57507'] = 0x0686;
	 t['afii57508'] = 0x0698;
	 t['afii57509'] = 0x06AF;
	 t['afii57511'] = 0x0679;
	 t['afii57512'] = 0x0688;
	 t['afii57513'] = 0x0691;
	 t['afii57514'] = 0x06BA;
	 t['afii57519'] = 0x06D2;
	 t['afii57534'] = 0x06D5;
	 t['afii57636'] = 0x20AA;
	 t['afii57645'] = 0x05BE;
	 t['afii57658'] = 0x05C3;
	 t['afii57664'] = 0x05D0;
	 t['afii57665'] = 0x05D1;
	 t['afii57666'] = 0x05D2;
	 t['afii57667'] = 0x05D3;
	 t['afii57668'] = 0x05D4;
	 t['afii57669'] = 0x05D5;
	 t['afii57670'] = 0x05D6;
	 t['afii57671'] = 0x05D7;
	 t['afii57672'] = 0x05D8;
	 t['afii57673'] = 0x05D9;
	 t['afii57674'] = 0x05DA;
	 t['afii57675'] = 0x05DB;
	 t['afii57676'] = 0x05DC;
	 t['afii57677'] = 0x05DD;
	 t['afii57678'] = 0x05DE;
	 t['afii57679'] = 0x05DF;
	 t['afii57680'] = 0x05E0;
	 t['afii57681'] = 0x05E1;
	 t['afii57682'] = 0x05E2;
	 t['afii57683'] = 0x05E3;
	 t['afii57684'] = 0x05E4;
	 t['afii57685'] = 0x05E5;
	 t['afii57686'] = 0x05E6;
	 t['afii57687'] = 0x05E7;
	 t['afii57688'] = 0x05E8;
	 t['afii57689'] = 0x05E9;
	 t['afii57690'] = 0x05EA;
	 t['afii57694'] = 0xFB2A;
	 t['afii57695'] = 0xFB2B;
	 t['afii57700'] = 0xFB4B;
	 t['afii57705'] = 0xFB1F;
	 t['afii57716'] = 0x05F0;
	 t['afii57717'] = 0x05F1;
	 t['afii57718'] = 0x05F2;
	 t['afii57723'] = 0xFB35;
	 t['afii57793'] = 0x05B4;
	 t['afii57794'] = 0x05B5;
	 t['afii57795'] = 0x05B6;
	 t['afii57796'] = 0x05BB;
	 t['afii57797'] = 0x05B8;
	 t['afii57798'] = 0x05B7;
	 t['afii57799'] = 0x05B0;
	 t['afii57800'] = 0x05B2;
	 t['afii57801'] = 0x05B1;
	 t['afii57802'] = 0x05B3;
	 t['afii57803'] = 0x05C2;
	 t['afii57804'] = 0x05C1;
	 t['afii57806'] = 0x05B9;
	 t['afii57807'] = 0x05BC;
	 t['afii57839'] = 0x05BD;
	 t['afii57841'] = 0x05BF;
	 t['afii57842'] = 0x05C0;
	 t['afii57929'] = 0x02BC;
	 t['afii61248'] = 0x2105;
	 t['afii61289'] = 0x2113;
	 t['afii61352'] = 0x2116;
	 t['afii61573'] = 0x202C;
	 t['afii61574'] = 0x202D;
	 t['afii61575'] = 0x202E;
	 t['afii61664'] = 0x200C;
	 t['afii63167'] = 0x066D;
	 t['afii64937'] = 0x02BD;
	 t['agrave'] = 0x00E0;
	 t['agujarati'] = 0x0A85;
	 t['agurmukhi'] = 0x0A05;
	 t['ahiragana'] = 0x3042;
	 t['ahookabove'] = 0x1EA3;
	 t['aibengali'] = 0x0990;
	 t['aibopomofo'] = 0x311E;
	 t['aideva'] = 0x0910;
	 t['aiecyrillic'] = 0x04D5;
	 t['aigujarati'] = 0x0A90;
	 t['aigurmukhi'] = 0x0A10;
	 t['aimatragurmukhi'] = 0x0A48;
	 t['ainarabic'] = 0x0639;
	 t['ainfinalarabic'] = 0xFECA;
	 t['aininitialarabic'] = 0xFECB;
	 t['ainmedialarabic'] = 0xFECC;
	 t['ainvertedbreve'] = 0x0203;
	 t['aivowelsignbengali'] = 0x09C8;
	 t['aivowelsigndeva'] = 0x0948;
	 t['aivowelsigngujarati'] = 0x0AC8;
	 t['akatakana'] = 0x30A2;
	 t['akatakanahalfwidth'] = 0xFF71;
	 t['akorean'] = 0x314F;
	 t['alef'] = 0x05D0;
	 t['alefarabic'] = 0x0627;
	 t['alefdageshhebrew'] = 0xFB30;
	 t['aleffinalarabic'] = 0xFE8E;
	 t['alefhamzaabovearabic'] = 0x0623;
	 t['alefhamzaabovefinalarabic'] = 0xFE84;
	 t['alefhamzabelowarabic'] = 0x0625;
	 t['alefhamzabelowfinalarabic'] = 0xFE88;
	 t['alefhebrew'] = 0x05D0;
	 t['aleflamedhebrew'] = 0xFB4F;
	 t['alefmaddaabovearabic'] = 0x0622;
	 t['alefmaddaabovefinalarabic'] = 0xFE82;
	 t['alefmaksuraarabic'] = 0x0649;
	 t['alefmaksurafinalarabic'] = 0xFEF0;
	 t['alefmaksurainitialarabic'] = 0xFEF3;
	 t['alefmaksuramedialarabic'] = 0xFEF4;
	 t['alefpatahhebrew'] = 0xFB2E;
	 t['alefqamatshebrew'] = 0xFB2F;
	 t['aleph'] = 0x2135;
	 t['allequal'] = 0x224C;
	 t['alpha'] = 0x03B1;
	 t['alphatonos'] = 0x03AC;
	 t['amacron'] = 0x0101;
	 t['amonospace'] = 0xFF41;
	 t['ampersand'] = 0x0026;
	 t['ampersandmonospace'] = 0xFF06;
	 t['ampersandsmall'] = 0xF726;
	 t['amsquare'] = 0x33C2;
	 t['anbopomofo'] = 0x3122;
	 t['angbopomofo'] = 0x3124;
	 t['angbracketleft'] = 0x3008;
	 t['angbracketright'] = 0x3009;
	 t['angkhankhuthai'] = 0x0E5A;
	 t['angle'] = 0x2220;
	 t['anglebracketleft'] = 0x3008;
	 t['anglebracketleftvertical'] = 0xFE3F;
	 t['anglebracketright'] = 0x3009;
	 t['anglebracketrightvertical'] = 0xFE40;
	 t['angleleft'] = 0x2329;
	 t['angleright'] = 0x232A;
	 t['angstrom'] = 0x212B;
	 t['anoteleia'] = 0x0387;
	 t['anudattadeva'] = 0x0952;
	 t['anusvarabengali'] = 0x0982;
	 t['anusvaradeva'] = 0x0902;
	 t['anusvaragujarati'] = 0x0A82;
	 t['aogonek'] = 0x0105;
	 t['apaatosquare'] = 0x3300;
	 t['aparen'] = 0x249C;
	 t['apostrophearmenian'] = 0x055A;
	 t['apostrophemod'] = 0x02BC;
	 t['apple'] = 0xF8FF;
	 t['approaches'] = 0x2250;
	 t['approxequal'] = 0x2248;
	 t['approxequalorimage'] = 0x2252;
	 t['approximatelyequal'] = 0x2245;
	 t['araeaekorean'] = 0x318E;
	 t['araeakorean'] = 0x318D;
	 t['arc'] = 0x2312;
	 t['arighthalfring'] = 0x1E9A;
	 t['aring'] = 0x00E5;
	 t['aringacute'] = 0x01FB;
	 t['aringbelow'] = 0x1E01;
	 t['arrowboth'] = 0x2194;
	 t['arrowdashdown'] = 0x21E3;
	 t['arrowdashleft'] = 0x21E0;
	 t['arrowdashright'] = 0x21E2;
	 t['arrowdashup'] = 0x21E1;
	 t['arrowdblboth'] = 0x21D4;
	 t['arrowdbldown'] = 0x21D3;
	 t['arrowdblleft'] = 0x21D0;
	 t['arrowdblright'] = 0x21D2;
	 t['arrowdblup'] = 0x21D1;
	 t['arrowdown'] = 0x2193;
	 t['arrowdownleft'] = 0x2199;
	 t['arrowdownright'] = 0x2198;
	 t['arrowdownwhite'] = 0x21E9;
	 t['arrowheaddownmod'] = 0x02C5;
	 t['arrowheadleftmod'] = 0x02C2;
	 t['arrowheadrightmod'] = 0x02C3;
	 t['arrowheadupmod'] = 0x02C4;
	 t['arrowhorizex'] = 0xF8E7;
	 t['arrowleft'] = 0x2190;
	 t['arrowleftdbl'] = 0x21D0;
	 t['arrowleftdblstroke'] = 0x21CD;
	 t['arrowleftoverright'] = 0x21C6;
	 t['arrowleftwhite'] = 0x21E6;
	 t['arrowright'] = 0x2192;
	 t['arrowrightdblstroke'] = 0x21CF;
	 t['arrowrightheavy'] = 0x279E;
	 t['arrowrightoverleft'] = 0x21C4;
	 t['arrowrightwhite'] = 0x21E8;
	 t['arrowtableft'] = 0x21E4;
	 t['arrowtabright'] = 0x21E5;
	 t['arrowup'] = 0x2191;
	 t['arrowupdn'] = 0x2195;
	 t['arrowupdnbse'] = 0x21A8;
	 t['arrowupdownbase'] = 0x21A8;
	 t['arrowupleft'] = 0x2196;
	 t['arrowupleftofdown'] = 0x21C5;
	 t['arrowupright'] = 0x2197;
	 t['arrowupwhite'] = 0x21E7;
	 t['arrowvertex'] = 0xF8E6;
	 t['asciicircum'] = 0x005E;
	 t['asciicircummonospace'] = 0xFF3E;
	 t['asciitilde'] = 0x007E;
	 t['asciitildemonospace'] = 0xFF5E;
	 t['ascript'] = 0x0251;
	 t['ascriptturned'] = 0x0252;
	 t['asmallhiragana'] = 0x3041;
	 t['asmallkatakana'] = 0x30A1;
	 t['asmallkatakanahalfwidth'] = 0xFF67;
	 t['asterisk'] = 0x002A;
	 t['asteriskaltonearabic'] = 0x066D;
	 t['asteriskarabic'] = 0x066D;
	 t['asteriskmath'] = 0x2217;
	 t['asteriskmonospace'] = 0xFF0A;
	 t['asterisksmall'] = 0xFE61;
	 t['asterism'] = 0x2042;
	 t['asuperior'] = 0xF6E9;
	 t['asymptoticallyequal'] = 0x2243;
	 t['at'] = 0x0040;
	 t['atilde'] = 0x00E3;
	 t['atmonospace'] = 0xFF20;
	 t['atsmall'] = 0xFE6B;
	 t['aturned'] = 0x0250;
	 t['aubengali'] = 0x0994;
	 t['aubopomofo'] = 0x3120;
	 t['audeva'] = 0x0914;
	 t['augujarati'] = 0x0A94;
	 t['augurmukhi'] = 0x0A14;
	 t['aulengthmarkbengali'] = 0x09D7;
	 t['aumatragurmukhi'] = 0x0A4C;
	 t['auvowelsignbengali'] = 0x09CC;
	 t['auvowelsigndeva'] = 0x094C;
	 t['auvowelsigngujarati'] = 0x0ACC;
	 t['avagrahadeva'] = 0x093D;
	 t['aybarmenian'] = 0x0561;
	 t['ayin'] = 0x05E2;
	 t['ayinaltonehebrew'] = 0xFB20;
	 t['ayinhebrew'] = 0x05E2;
	 t['b'] = 0x0062;
	 t['babengali'] = 0x09AC;
	 t['backslash'] = 0x005C;
	 t['backslashmonospace'] = 0xFF3C;
	 t['badeva'] = 0x092C;
	 t['bagujarati'] = 0x0AAC;
	 t['bagurmukhi'] = 0x0A2C;
	 t['bahiragana'] = 0x3070;
	 t['bahtthai'] = 0x0E3F;
	 t['bakatakana'] = 0x30D0;
	 t['bar'] = 0x007C;
	 t['barmonospace'] = 0xFF5C;
	 t['bbopomofo'] = 0x3105;
	 t['bcircle'] = 0x24D1;
	 t['bdotaccent'] = 0x1E03;
	 t['bdotbelow'] = 0x1E05;
	 t['beamedsixteenthnotes'] = 0x266C;
	 t['because'] = 0x2235;
	 t['becyrillic'] = 0x0431;
	 t['beharabic'] = 0x0628;
	 t['behfinalarabic'] = 0xFE90;
	 t['behinitialarabic'] = 0xFE91;
	 t['behiragana'] = 0x3079;
	 t['behmedialarabic'] = 0xFE92;
	 t['behmeeminitialarabic'] = 0xFC9F;
	 t['behmeemisolatedarabic'] = 0xFC08;
	 t['behnoonfinalarabic'] = 0xFC6D;
	 t['bekatakana'] = 0x30D9;
	 t['benarmenian'] = 0x0562;
	 t['bet'] = 0x05D1;
	 t['beta'] = 0x03B2;
	 t['betasymbolgreek'] = 0x03D0;
	 t['betdagesh'] = 0xFB31;
	 t['betdageshhebrew'] = 0xFB31;
	 t['bethebrew'] = 0x05D1;
	 t['betrafehebrew'] = 0xFB4C;
	 t['bhabengali'] = 0x09AD;
	 t['bhadeva'] = 0x092D;
	 t['bhagujarati'] = 0x0AAD;
	 t['bhagurmukhi'] = 0x0A2D;
	 t['bhook'] = 0x0253;
	 t['bihiragana'] = 0x3073;
	 t['bikatakana'] = 0x30D3;
	 t['bilabialclick'] = 0x0298;
	 t['bindigurmukhi'] = 0x0A02;
	 t['birusquare'] = 0x3331;
	 t['blackcircle'] = 0x25CF;
	 t['blackdiamond'] = 0x25C6;
	 t['blackdownpointingtriangle'] = 0x25BC;
	 t['blackleftpointingpointer'] = 0x25C4;
	 t['blackleftpointingtriangle'] = 0x25C0;
	 t['blacklenticularbracketleft'] = 0x3010;
	 t['blacklenticularbracketleftvertical'] = 0xFE3B;
	 t['blacklenticularbracketright'] = 0x3011;
	 t['blacklenticularbracketrightvertical'] = 0xFE3C;
	 t['blacklowerlefttriangle'] = 0x25E3;
	 t['blacklowerrighttriangle'] = 0x25E2;
	 t['blackrectangle'] = 0x25AC;
	 t['blackrightpointingpointer'] = 0x25BA;
	 t['blackrightpointingtriangle'] = 0x25B6;
	 t['blacksmallsquare'] = 0x25AA;
	 t['blacksmilingface'] = 0x263B;
	 t['blacksquare'] = 0x25A0;
	 t['blackstar'] = 0x2605;
	 t['blackupperlefttriangle'] = 0x25E4;
	 t['blackupperrighttriangle'] = 0x25E5;
	 t['blackuppointingsmalltriangle'] = 0x25B4;
	 t['blackuppointingtriangle'] = 0x25B2;
	 t['blank'] = 0x2423;
	 t['blinebelow'] = 0x1E07;
	 t['block'] = 0x2588;
	 t['bmonospace'] = 0xFF42;
	 t['bobaimaithai'] = 0x0E1A;
	 t['bohiragana'] = 0x307C;
	 t['bokatakana'] = 0x30DC;
	 t['bparen'] = 0x249D;
	 t['bqsquare'] = 0x33C3;
	 t['braceex'] = 0xF8F4;
	 t['braceleft'] = 0x007B;
	 t['braceleftbt'] = 0xF8F3;
	 t['braceleftmid'] = 0xF8F2;
	 t['braceleftmonospace'] = 0xFF5B;
	 t['braceleftsmall'] = 0xFE5B;
	 t['bracelefttp'] = 0xF8F1;
	 t['braceleftvertical'] = 0xFE37;
	 t['braceright'] = 0x007D;
	 t['bracerightbt'] = 0xF8FE;
	 t['bracerightmid'] = 0xF8FD;
	 t['bracerightmonospace'] = 0xFF5D;
	 t['bracerightsmall'] = 0xFE5C;
	 t['bracerighttp'] = 0xF8FC;
	 t['bracerightvertical'] = 0xFE38;
	 t['bracketleft'] = 0x005B;
	 t['bracketleftbt'] = 0xF8F0;
	 t['bracketleftex'] = 0xF8EF;
	 t['bracketleftmonospace'] = 0xFF3B;
	 t['bracketlefttp'] = 0xF8EE;
	 t['bracketright'] = 0x005D;
	 t['bracketrightbt'] = 0xF8FB;
	 t['bracketrightex'] = 0xF8FA;
	 t['bracketrightmonospace'] = 0xFF3D;
	 t['bracketrighttp'] = 0xF8F9;
	 t['breve'] = 0x02D8;
	 t['brevebelowcmb'] = 0x032E;
	 t['brevecmb'] = 0x0306;
	 t['breveinvertedbelowcmb'] = 0x032F;
	 t['breveinvertedcmb'] = 0x0311;
	 t['breveinverteddoublecmb'] = 0x0361;
	 t['bridgebelowcmb'] = 0x032A;
	 t['bridgeinvertedbelowcmb'] = 0x033A;
	 t['brokenbar'] = 0x00A6;
	 t['bstroke'] = 0x0180;
	 t['bsuperior'] = 0xF6EA;
	 t['btopbar'] = 0x0183;
	 t['buhiragana'] = 0x3076;
	 t['bukatakana'] = 0x30D6;
	 t['bullet'] = 0x2022;
	 t['bulletinverse'] = 0x25D8;
	 t['bulletoperator'] = 0x2219;
	 t['bullseye'] = 0x25CE;
	 t['c'] = 0x0063;
	 t['caarmenian'] = 0x056E;
	 t['cabengali'] = 0x099A;
	 t['cacute'] = 0x0107;
	 t['cadeva'] = 0x091A;
	 t['cagujarati'] = 0x0A9A;
	 t['cagurmukhi'] = 0x0A1A;
	 t['calsquare'] = 0x3388;
	 t['candrabindubengali'] = 0x0981;
	 t['candrabinducmb'] = 0x0310;
	 t['candrabindudeva'] = 0x0901;
	 t['candrabindugujarati'] = 0x0A81;
	 t['capslock'] = 0x21EA;
	 t['careof'] = 0x2105;
	 t['caron'] = 0x02C7;
	 t['caronbelowcmb'] = 0x032C;
	 t['caroncmb'] = 0x030C;
	 t['carriagereturn'] = 0x21B5;
	 t['cbopomofo'] = 0x3118;
	 t['ccaron'] = 0x010D;
	 t['ccedilla'] = 0x00E7;
	 t['ccedillaacute'] = 0x1E09;
	 t['ccircle'] = 0x24D2;
	 t['ccircumflex'] = 0x0109;
	 t['ccurl'] = 0x0255;
	 t['cdot'] = 0x010B;
	 t['cdotaccent'] = 0x010B;
	 t['cdsquare'] = 0x33C5;
	 t['cedilla'] = 0x00B8;
	 t['cedillacmb'] = 0x0327;
	 t['cent'] = 0x00A2;
	 t['centigrade'] = 0x2103;
	 t['centinferior'] = 0xF6DF;
	 t['centmonospace'] = 0xFFE0;
	 t['centoldstyle'] = 0xF7A2;
	 t['centsuperior'] = 0xF6E0;
	 t['chaarmenian'] = 0x0579;
	 t['chabengali'] = 0x099B;
	 t['chadeva'] = 0x091B;
	 t['chagujarati'] = 0x0A9B;
	 t['chagurmukhi'] = 0x0A1B;
	 t['chbopomofo'] = 0x3114;
	 t['cheabkhasiancyrillic'] = 0x04BD;
	 t['checkmark'] = 0x2713;
	 t['checyrillic'] = 0x0447;
	 t['chedescenderabkhasiancyrillic'] = 0x04BF;
	 t['chedescendercyrillic'] = 0x04B7;
	 t['chedieresiscyrillic'] = 0x04F5;
	 t['cheharmenian'] = 0x0573;
	 t['chekhakassiancyrillic'] = 0x04CC;
	 t['cheverticalstrokecyrillic'] = 0x04B9;
	 t['chi'] = 0x03C7;
	 t['chieuchacirclekorean'] = 0x3277;
	 t['chieuchaparenkorean'] = 0x3217;
	 t['chieuchcirclekorean'] = 0x3269;
	 t['chieuchkorean'] = 0x314A;
	 t['chieuchparenkorean'] = 0x3209;
	 t['chochangthai'] = 0x0E0A;
	 t['chochanthai'] = 0x0E08;
	 t['chochingthai'] = 0x0E09;
	 t['chochoethai'] = 0x0E0C;
	 t['chook'] = 0x0188;
	 t['cieucacirclekorean'] = 0x3276;
	 t['cieucaparenkorean'] = 0x3216;
	 t['cieuccirclekorean'] = 0x3268;
	 t['cieuckorean'] = 0x3148;
	 t['cieucparenkorean'] = 0x3208;
	 t['cieucuparenkorean'] = 0x321C;
	 t['circle'] = 0x25CB;
	 t['circlecopyrt'] = 0x00A9;
	 t['circlemultiply'] = 0x2297;
	 t['circleot'] = 0x2299;
	 t['circleplus'] = 0x2295;
	 t['circlepostalmark'] = 0x3036;
	 t['circlewithlefthalfblack'] = 0x25D0;
	 t['circlewithrighthalfblack'] = 0x25D1;
	 t['circumflex'] = 0x02C6;
	 t['circumflexbelowcmb'] = 0x032D;
	 t['circumflexcmb'] = 0x0302;
	 t['clear'] = 0x2327;
	 t['clickalveolar'] = 0x01C2;
	 t['clickdental'] = 0x01C0;
	 t['clicklateral'] = 0x01C1;
	 t['clickretroflex'] = 0x01C3;
	 t['club'] = 0x2663;
	 t['clubsuitblack'] = 0x2663;
	 t['clubsuitwhite'] = 0x2667;
	 t['cmcubedsquare'] = 0x33A4;
	 t['cmonospace'] = 0xFF43;
	 t['cmsquaredsquare'] = 0x33A0;
	 t['coarmenian'] = 0x0581;
	 t['colon'] = 0x003A;
	 t['colonmonetary'] = 0x20A1;
	 t['colonmonospace'] = 0xFF1A;
	 t['colonsign'] = 0x20A1;
	 t['colonsmall'] = 0xFE55;
	 t['colontriangularhalfmod'] = 0x02D1;
	 t['colontriangularmod'] = 0x02D0;
	 t['comma'] = 0x002C;
	 t['commaabovecmb'] = 0x0313;
	 t['commaaboverightcmb'] = 0x0315;
	 t['commaaccent'] = 0xF6C3;
	 t['commaarabic'] = 0x060C;
	 t['commaarmenian'] = 0x055D;
	 t['commainferior'] = 0xF6E1;
	 t['commamonospace'] = 0xFF0C;
	 t['commareversedabovecmb'] = 0x0314;
	 t['commareversedmod'] = 0x02BD;
	 t['commasmall'] = 0xFE50;
	 t['commasuperior'] = 0xF6E2;
	 t['commaturnedabovecmb'] = 0x0312;
	 t['commaturnedmod'] = 0x02BB;
	 t['compass'] = 0x263C;
	 t['congruent'] = 0x2245;
	 t['contourintegral'] = 0x222E;
	 t['control'] = 0x2303;
	 t['controlACK'] = 0x0006;
	 t['controlBEL'] = 0x0007;
	 t['controlBS'] = 0x0008;
	 t['controlCAN'] = 0x0018;
	 t['controlCR'] = 0x000D;
	 t['controlDC1'] = 0x0011;
	 t['controlDC2'] = 0x0012;
	 t['controlDC3'] = 0x0013;
	 t['controlDC4'] = 0x0014;
	 t['controlDEL'] = 0x007F;
	 t['controlDLE'] = 0x0010;
	 t['controlEM'] = 0x0019;
	 t['controlENQ'] = 0x0005;
	 t['controlEOT'] = 0x0004;
	 t['controlESC'] = 0x001B;
	 t['controlETB'] = 0x0017;
	 t['controlETX'] = 0x0003;
	 t['controlFF'] = 0x000C;
	 t['controlFS'] = 0x001C;
	 t['controlGS'] = 0x001D;
	 t['controlHT'] = 0x0009;
	 t['controlLF'] = 0x000A;
	 t['controlNAK'] = 0x0015;
	 t['controlNULL'] = 0x0000;
	 t['controlRS'] = 0x001E;
	 t['controlSI'] = 0x000F;
	 t['controlSO'] = 0x000E;
	 t['controlSOT'] = 0x0002;
	 t['controlSTX'] = 0x0001;
	 t['controlSUB'] = 0x001A;
	 t['controlSYN'] = 0x0016;
	 t['controlUS'] = 0x001F;
	 t['controlVT'] = 0x000B;
	 t['copyright'] = 0x00A9;
	 t['copyrightsans'] = 0xF8E9;
	 t['copyrightserif'] = 0xF6D9;
	 t['cornerbracketleft'] = 0x300C;
	 t['cornerbracketlefthalfwidth'] = 0xFF62;
	 t['cornerbracketleftvertical'] = 0xFE41;
	 t['cornerbracketright'] = 0x300D;
	 t['cornerbracketrighthalfwidth'] = 0xFF63;
	 t['cornerbracketrightvertical'] = 0xFE42;
	 t['corporationsquare'] = 0x337F;
	 t['cosquare'] = 0x33C7;
	 t['coverkgsquare'] = 0x33C6;
	 t['cparen'] = 0x249E;
	 t['cruzeiro'] = 0x20A2;
	 t['cstretched'] = 0x0297;
	 t['curlyand'] = 0x22CF;
	 t['curlyor'] = 0x22CE;
	 t['currency'] = 0x00A4;
	 t['cyrBreve'] = 0xF6D1;
	 t['cyrFlex'] = 0xF6D2;
	 t['cyrbreve'] = 0xF6D4;
	 t['cyrflex'] = 0xF6D5;
	 t['d'] = 0x0064;
	 t['daarmenian'] = 0x0564;
	 t['dabengali'] = 0x09A6;
	 t['dadarabic'] = 0x0636;
	 t['dadeva'] = 0x0926;
	 t['dadfinalarabic'] = 0xFEBE;
	 t['dadinitialarabic'] = 0xFEBF;
	 t['dadmedialarabic'] = 0xFEC0;
	 t['dagesh'] = 0x05BC;
	 t['dageshhebrew'] = 0x05BC;
	 t['dagger'] = 0x2020;
	 t['daggerdbl'] = 0x2021;
	 t['dagujarati'] = 0x0AA6;
	 t['dagurmukhi'] = 0x0A26;
	 t['dahiragana'] = 0x3060;
	 t['dakatakana'] = 0x30C0;
	 t['dalarabic'] = 0x062F;
	 t['dalet'] = 0x05D3;
	 t['daletdagesh'] = 0xFB33;
	 t['daletdageshhebrew'] = 0xFB33;
	 t['dalethebrew'] = 0x05D3;
	 t['dalfinalarabic'] = 0xFEAA;
	 t['dammaarabic'] = 0x064F;
	 t['dammalowarabic'] = 0x064F;
	 t['dammatanaltonearabic'] = 0x064C;
	 t['dammatanarabic'] = 0x064C;
	 t['danda'] = 0x0964;
	 t['dargahebrew'] = 0x05A7;
	 t['dargalefthebrew'] = 0x05A7;
	 t['dasiapneumatacyrilliccmb'] = 0x0485;
	 t['dblGrave'] = 0xF6D3;
	 t['dblanglebracketleft'] = 0x300A;
	 t['dblanglebracketleftvertical'] = 0xFE3D;
	 t['dblanglebracketright'] = 0x300B;
	 t['dblanglebracketrightvertical'] = 0xFE3E;
	 t['dblarchinvertedbelowcmb'] = 0x032B;
	 t['dblarrowleft'] = 0x21D4;
	 t['dblarrowright'] = 0x21D2;
	 t['dbldanda'] = 0x0965;
	 t['dblgrave'] = 0xF6D6;
	 t['dblgravecmb'] = 0x030F;
	 t['dblintegral'] = 0x222C;
	 t['dbllowline'] = 0x2017;
	 t['dbllowlinecmb'] = 0x0333;
	 t['dbloverlinecmb'] = 0x033F;
	 t['dblprimemod'] = 0x02BA;
	 t['dblverticalbar'] = 0x2016;
	 t['dblverticallineabovecmb'] = 0x030E;
	 t['dbopomofo'] = 0x3109;
	 t['dbsquare'] = 0x33C8;
	 t['dcaron'] = 0x010F;
	 t['dcedilla'] = 0x1E11;
	 t['dcircle'] = 0x24D3;
	 t['dcircumflexbelow'] = 0x1E13;
	 t['dcroat'] = 0x0111;
	 t['ddabengali'] = 0x09A1;
	 t['ddadeva'] = 0x0921;
	 t['ddagujarati'] = 0x0AA1;
	 t['ddagurmukhi'] = 0x0A21;
	 t['ddalarabic'] = 0x0688;
	 t['ddalfinalarabic'] = 0xFB89;
	 t['dddhadeva'] = 0x095C;
	 t['ddhabengali'] = 0x09A2;
	 t['ddhadeva'] = 0x0922;
	 t['ddhagujarati'] = 0x0AA2;
	 t['ddhagurmukhi'] = 0x0A22;
	 t['ddotaccent'] = 0x1E0B;
	 t['ddotbelow'] = 0x1E0D;
	 t['decimalseparatorarabic'] = 0x066B;
	 t['decimalseparatorpersian'] = 0x066B;
	 t['decyrillic'] = 0x0434;
	 t['degree'] = 0x00B0;
	 t['dehihebrew'] = 0x05AD;
	 t['dehiragana'] = 0x3067;
	 t['deicoptic'] = 0x03EF;
	 t['dekatakana'] = 0x30C7;
	 t['deleteleft'] = 0x232B;
	 t['deleteright'] = 0x2326;
	 t['delta'] = 0x03B4;
	 t['deltaturned'] = 0x018D;
	 t['denominatorminusonenumeratorbengali'] = 0x09F8;
	 t['dezh'] = 0x02A4;
	 t['dhabengali'] = 0x09A7;
	 t['dhadeva'] = 0x0927;
	 t['dhagujarati'] = 0x0AA7;
	 t['dhagurmukhi'] = 0x0A27;
	 t['dhook'] = 0x0257;
	 t['dialytikatonos'] = 0x0385;
	 t['dialytikatonoscmb'] = 0x0344;
	 t['diamond'] = 0x2666;
	 t['diamondsuitwhite'] = 0x2662;
	 t['dieresis'] = 0x00A8;
	 t['dieresisacute'] = 0xF6D7;
	 t['dieresisbelowcmb'] = 0x0324;
	 t['dieresiscmb'] = 0x0308;
	 t['dieresisgrave'] = 0xF6D8;
	 t['dieresistonos'] = 0x0385;
	 t['dihiragana'] = 0x3062;
	 t['dikatakana'] = 0x30C2;
	 t['dittomark'] = 0x3003;
	 t['divide'] = 0x00F7;
	 t['divides'] = 0x2223;
	 t['divisionslash'] = 0x2215;
	 t['djecyrillic'] = 0x0452;
	 t['dkshade'] = 0x2593;
	 t['dlinebelow'] = 0x1E0F;
	 t['dlsquare'] = 0x3397;
	 t['dmacron'] = 0x0111;
	 t['dmonospace'] = 0xFF44;
	 t['dnblock'] = 0x2584;
	 t['dochadathai'] = 0x0E0E;
	 t['dodekthai'] = 0x0E14;
	 t['dohiragana'] = 0x3069;
	 t['dokatakana'] = 0x30C9;
	 t['dollar'] = 0x0024;
	 t['dollarinferior'] = 0xF6E3;
	 t['dollarmonospace'] = 0xFF04;
	 t['dollaroldstyle'] = 0xF724;
	 t['dollarsmall'] = 0xFE69;
	 t['dollarsuperior'] = 0xF6E4;
	 t['dong'] = 0x20AB;
	 t['dorusquare'] = 0x3326;
	 t['dotaccent'] = 0x02D9;
	 t['dotaccentcmb'] = 0x0307;
	 t['dotbelowcmb'] = 0x0323;
	 t['dotbelowcomb'] = 0x0323;
	 t['dotkatakana'] = 0x30FB;
	 t['dotlessi'] = 0x0131;
	 t['dotlessj'] = 0xF6BE;
	 t['dotlessjstrokehook'] = 0x0284;
	 t['dotmath'] = 0x22C5;
	 t['dottedcircle'] = 0x25CC;
	 t['doubleyodpatah'] = 0xFB1F;
	 t['doubleyodpatahhebrew'] = 0xFB1F;
	 t['downtackbelowcmb'] = 0x031E;
	 t['downtackmod'] = 0x02D5;
	 t['dparen'] = 0x249F;
	 t['dsuperior'] = 0xF6EB;
	 t['dtail'] = 0x0256;
	 t['dtopbar'] = 0x018C;
	 t['duhiragana'] = 0x3065;
	 t['dukatakana'] = 0x30C5;
	 t['dz'] = 0x01F3;
	 t['dzaltone'] = 0x02A3;
	 t['dzcaron'] = 0x01C6;
	 t['dzcurl'] = 0x02A5;
	 t['dzeabkhasiancyrillic'] = 0x04E1;
	 t['dzecyrillic'] = 0x0455;
	 t['dzhecyrillic'] = 0x045F;
	 t['e'] = 0x0065;
	 t['eacute'] = 0x00E9;
	 t['earth'] = 0x2641;
	 t['ebengali'] = 0x098F;
	 t['ebopomofo'] = 0x311C;
	 t['ebreve'] = 0x0115;
	 t['ecandradeva'] = 0x090D;
	 t['ecandragujarati'] = 0x0A8D;
	 t['ecandravowelsigndeva'] = 0x0945;
	 t['ecandravowelsigngujarati'] = 0x0AC5;
	 t['ecaron'] = 0x011B;
	 t['ecedillabreve'] = 0x1E1D;
	 t['echarmenian'] = 0x0565;
	 t['echyiwnarmenian'] = 0x0587;
	 t['ecircle'] = 0x24D4;
	 t['ecircumflex'] = 0x00EA;
	 t['ecircumflexacute'] = 0x1EBF;
	 t['ecircumflexbelow'] = 0x1E19;
	 t['ecircumflexdotbelow'] = 0x1EC7;
	 t['ecircumflexgrave'] = 0x1EC1;
	 t['ecircumflexhookabove'] = 0x1EC3;
	 t['ecircumflextilde'] = 0x1EC5;
	 t['ecyrillic'] = 0x0454;
	 t['edblgrave'] = 0x0205;
	 t['edeva'] = 0x090F;
	 t['edieresis'] = 0x00EB;
	 t['edot'] = 0x0117;
	 t['edotaccent'] = 0x0117;
	 t['edotbelow'] = 0x1EB9;
	 t['eegurmukhi'] = 0x0A0F;
	 t['eematragurmukhi'] = 0x0A47;
	 t['efcyrillic'] = 0x0444;
	 t['egrave'] = 0x00E8;
	 t['egujarati'] = 0x0A8F;
	 t['eharmenian'] = 0x0567;
	 t['ehbopomofo'] = 0x311D;
	 t['ehiragana'] = 0x3048;
	 t['ehookabove'] = 0x1EBB;
	 t['eibopomofo'] = 0x311F;
	 t['eight'] = 0x0038;
	 t['eightarabic'] = 0x0668;
	 t['eightbengali'] = 0x09EE;
	 t['eightcircle'] = 0x2467;
	 t['eightcircleinversesansserif'] = 0x2791;
	 t['eightdeva'] = 0x096E;
	 t['eighteencircle'] = 0x2471;
	 t['eighteenparen'] = 0x2485;
	 t['eighteenperiod'] = 0x2499;
	 t['eightgujarati'] = 0x0AEE;
	 t['eightgurmukhi'] = 0x0A6E;
	 t['eighthackarabic'] = 0x0668;
	 t['eighthangzhou'] = 0x3028;
	 t['eighthnotebeamed'] = 0x266B;
	 t['eightideographicparen'] = 0x3227;
	 t['eightinferior'] = 0x2088;
	 t['eightmonospace'] = 0xFF18;
	 t['eightoldstyle'] = 0xF738;
	 t['eightparen'] = 0x247B;
	 t['eightperiod'] = 0x248F;
	 t['eightpersian'] = 0x06F8;
	 t['eightroman'] = 0x2177;
	 t['eightsuperior'] = 0x2078;
	 t['eightthai'] = 0x0E58;
	 t['einvertedbreve'] = 0x0207;
	 t['eiotifiedcyrillic'] = 0x0465;
	 t['ekatakana'] = 0x30A8;
	 t['ekatakanahalfwidth'] = 0xFF74;
	 t['ekonkargurmukhi'] = 0x0A74;
	 t['ekorean'] = 0x3154;
	 t['elcyrillic'] = 0x043B;
	 t['element'] = 0x2208;
	 t['elevencircle'] = 0x246A;
	 t['elevenparen'] = 0x247E;
	 t['elevenperiod'] = 0x2492;
	 t['elevenroman'] = 0x217A;
	 t['ellipsis'] = 0x2026;
	 t['ellipsisvertical'] = 0x22EE;
	 t['emacron'] = 0x0113;
	 t['emacronacute'] = 0x1E17;
	 t['emacrongrave'] = 0x1E15;
	 t['emcyrillic'] = 0x043C;
	 t['emdash'] = 0x2014;
	 t['emdashvertical'] = 0xFE31;
	 t['emonospace'] = 0xFF45;
	 t['emphasismarkarmenian'] = 0x055B;
	 t['emptyset'] = 0x2205;
	 t['enbopomofo'] = 0x3123;
	 t['encyrillic'] = 0x043D;
	 t['endash'] = 0x2013;
	 t['endashvertical'] = 0xFE32;
	 t['endescendercyrillic'] = 0x04A3;
	 t['eng'] = 0x014B;
	 t['engbopomofo'] = 0x3125;
	 t['enghecyrillic'] = 0x04A5;
	 t['enhookcyrillic'] = 0x04C8;
	 t['enspace'] = 0x2002;
	 t['eogonek'] = 0x0119;
	 t['eokorean'] = 0x3153;
	 t['eopen'] = 0x025B;
	 t['eopenclosed'] = 0x029A;
	 t['eopenreversed'] = 0x025C;
	 t['eopenreversedclosed'] = 0x025E;
	 t['eopenreversedhook'] = 0x025D;
	 t['eparen'] = 0x24A0;
	 t['epsilon'] = 0x03B5;
	 t['epsilontonos'] = 0x03AD;
	 t['equal'] = 0x003D;
	 t['equalmonospace'] = 0xFF1D;
	 t['equalsmall'] = 0xFE66;
	 t['equalsuperior'] = 0x207C;
	 t['equivalence'] = 0x2261;
	 t['erbopomofo'] = 0x3126;
	 t['ercyrillic'] = 0x0440;
	 t['ereversed'] = 0x0258;
	 t['ereversedcyrillic'] = 0x044D;
	 t['escyrillic'] = 0x0441;
	 t['esdescendercyrillic'] = 0x04AB;
	 t['esh'] = 0x0283;
	 t['eshcurl'] = 0x0286;
	 t['eshortdeva'] = 0x090E;
	 t['eshortvowelsigndeva'] = 0x0946;
	 t['eshreversedloop'] = 0x01AA;
	 t['eshsquatreversed'] = 0x0285;
	 t['esmallhiragana'] = 0x3047;
	 t['esmallkatakana'] = 0x30A7;
	 t['esmallkatakanahalfwidth'] = 0xFF6A;
	 t['estimated'] = 0x212E;
	 t['esuperior'] = 0xF6EC;
	 t['eta'] = 0x03B7;
	 t['etarmenian'] = 0x0568;
	 t['etatonos'] = 0x03AE;
	 t['eth'] = 0x00F0;
	 t['etilde'] = 0x1EBD;
	 t['etildebelow'] = 0x1E1B;
	 t['etnahtafoukhhebrew'] = 0x0591;
	 t['etnahtafoukhlefthebrew'] = 0x0591;
	 t['etnahtahebrew'] = 0x0591;
	 t['etnahtalefthebrew'] = 0x0591;
	 t['eturned'] = 0x01DD;
	 t['eukorean'] = 0x3161;
	 t['euro'] = 0x20AC;
	 t['evowelsignbengali'] = 0x09C7;
	 t['evowelsigndeva'] = 0x0947;
	 t['evowelsigngujarati'] = 0x0AC7;
	 t['exclam'] = 0x0021;
	 t['exclamarmenian'] = 0x055C;
	 t['exclamdbl'] = 0x203C;
	 t['exclamdown'] = 0x00A1;
	 t['exclamdownsmall'] = 0xF7A1;
	 t['exclammonospace'] = 0xFF01;
	 t['exclamsmall'] = 0xF721;
	 t['existential'] = 0x2203;
	 t['ezh'] = 0x0292;
	 t['ezhcaron'] = 0x01EF;
	 t['ezhcurl'] = 0x0293;
	 t['ezhreversed'] = 0x01B9;
	 t['ezhtail'] = 0x01BA;
	 t['f'] = 0x0066;
	 t['fadeva'] = 0x095E;
	 t['fagurmukhi'] = 0x0A5E;
	 t['fahrenheit'] = 0x2109;
	 t['fathaarabic'] = 0x064E;
	 t['fathalowarabic'] = 0x064E;
	 t['fathatanarabic'] = 0x064B;
	 t['fbopomofo'] = 0x3108;
	 t['fcircle'] = 0x24D5;
	 t['fdotaccent'] = 0x1E1F;
	 t['feharabic'] = 0x0641;
	 t['feharmenian'] = 0x0586;
	 t['fehfinalarabic'] = 0xFED2;
	 t['fehinitialarabic'] = 0xFED3;
	 t['fehmedialarabic'] = 0xFED4;
	 t['feicoptic'] = 0x03E5;
	 t['female'] = 0x2640;
	 t['ff'] = 0xFB00;
	 t['ffi'] = 0xFB03;
	 t['ffl'] = 0xFB04;
	 t['fi'] = 0xFB01;
	 t['fifteencircle'] = 0x246E;
	 t['fifteenparen'] = 0x2482;
	 t['fifteenperiod'] = 0x2496;
	 t['figuredash'] = 0x2012;
	 t['filledbox'] = 0x25A0;
	 t['filledrect'] = 0x25AC;
	 t['finalkaf'] = 0x05DA;
	 t['finalkafdagesh'] = 0xFB3A;
	 t['finalkafdageshhebrew'] = 0xFB3A;
	 t['finalkafhebrew'] = 0x05DA;
	 t['finalmem'] = 0x05DD;
	 t['finalmemhebrew'] = 0x05DD;
	 t['finalnun'] = 0x05DF;
	 t['finalnunhebrew'] = 0x05DF;
	 t['finalpe'] = 0x05E3;
	 t['finalpehebrew'] = 0x05E3;
	 t['finaltsadi'] = 0x05E5;
	 t['finaltsadihebrew'] = 0x05E5;
	 t['firsttonechinese'] = 0x02C9;
	 t['fisheye'] = 0x25C9;
	 t['fitacyrillic'] = 0x0473;
	 t['five'] = 0x0035;
	 t['fivearabic'] = 0x0665;
	 t['fivebengali'] = 0x09EB;
	 t['fivecircle'] = 0x2464;
	 t['fivecircleinversesansserif'] = 0x278E;
	 t['fivedeva'] = 0x096B;
	 t['fiveeighths'] = 0x215D;
	 t['fivegujarati'] = 0x0AEB;
	 t['fivegurmukhi'] = 0x0A6B;
	 t['fivehackarabic'] = 0x0665;
	 t['fivehangzhou'] = 0x3025;
	 t['fiveideographicparen'] = 0x3224;
	 t['fiveinferior'] = 0x2085;
	 t['fivemonospace'] = 0xFF15;
	 t['fiveoldstyle'] = 0xF735;
	 t['fiveparen'] = 0x2478;
	 t['fiveperiod'] = 0x248C;
	 t['fivepersian'] = 0x06F5;
	 t['fiveroman'] = 0x2174;
	 t['fivesuperior'] = 0x2075;
	 t['fivethai'] = 0x0E55;
	 t['fl'] = 0xFB02;
	 t['florin'] = 0x0192;
	 t['fmonospace'] = 0xFF46;
	 t['fmsquare'] = 0x3399;
	 t['fofanthai'] = 0x0E1F;
	 t['fofathai'] = 0x0E1D;
	 t['fongmanthai'] = 0x0E4F;
	 t['forall'] = 0x2200;
	 t['four'] = 0x0034;
	 t['fourarabic'] = 0x0664;
	 t['fourbengali'] = 0x09EA;
	 t['fourcircle'] = 0x2463;
	 t['fourcircleinversesansserif'] = 0x278D;
	 t['fourdeva'] = 0x096A;
	 t['fourgujarati'] = 0x0AEA;
	 t['fourgurmukhi'] = 0x0A6A;
	 t['fourhackarabic'] = 0x0664;
	 t['fourhangzhou'] = 0x3024;
	 t['fourideographicparen'] = 0x3223;
	 t['fourinferior'] = 0x2084;
	 t['fourmonospace'] = 0xFF14;
	 t['fournumeratorbengali'] = 0x09F7;
	 t['fouroldstyle'] = 0xF734;
	 t['fourparen'] = 0x2477;
	 t['fourperiod'] = 0x248B;
	 t['fourpersian'] = 0x06F4;
	 t['fourroman'] = 0x2173;
	 t['foursuperior'] = 0x2074;
	 t['fourteencircle'] = 0x246D;
	 t['fourteenparen'] = 0x2481;
	 t['fourteenperiod'] = 0x2495;
	 t['fourthai'] = 0x0E54;
	 t['fourthtonechinese'] = 0x02CB;
	 t['fparen'] = 0x24A1;
	 t['fraction'] = 0x2044;
	 t['franc'] = 0x20A3;
	 t['g'] = 0x0067;
	 t['gabengali'] = 0x0997;
	 t['gacute'] = 0x01F5;
	 t['gadeva'] = 0x0917;
	 t['gafarabic'] = 0x06AF;
	 t['gaffinalarabic'] = 0xFB93;
	 t['gafinitialarabic'] = 0xFB94;
	 t['gafmedialarabic'] = 0xFB95;
	 t['gagujarati'] = 0x0A97;
	 t['gagurmukhi'] = 0x0A17;
	 t['gahiragana'] = 0x304C;
	 t['gakatakana'] = 0x30AC;
	 t['gamma'] = 0x03B3;
	 t['gammalatinsmall'] = 0x0263;
	 t['gammasuperior'] = 0x02E0;
	 t['gangiacoptic'] = 0x03EB;
	 t['gbopomofo'] = 0x310D;
	 t['gbreve'] = 0x011F;
	 t['gcaron'] = 0x01E7;
	 t['gcedilla'] = 0x0123;
	 t['gcircle'] = 0x24D6;
	 t['gcircumflex'] = 0x011D;
	 t['gcommaaccent'] = 0x0123;
	 t['gdot'] = 0x0121;
	 t['gdotaccent'] = 0x0121;
	 t['gecyrillic'] = 0x0433;
	 t['gehiragana'] = 0x3052;
	 t['gekatakana'] = 0x30B2;
	 t['geometricallyequal'] = 0x2251;
	 t['gereshaccenthebrew'] = 0x059C;
	 t['gereshhebrew'] = 0x05F3;
	 t['gereshmuqdamhebrew'] = 0x059D;
	 t['germandbls'] = 0x00DF;
	 t['gershayimaccenthebrew'] = 0x059E;
	 t['gershayimhebrew'] = 0x05F4;
	 t['getamark'] = 0x3013;
	 t['ghabengali'] = 0x0998;
	 t['ghadarmenian'] = 0x0572;
	 t['ghadeva'] = 0x0918;
	 t['ghagujarati'] = 0x0A98;
	 t['ghagurmukhi'] = 0x0A18;
	 t['ghainarabic'] = 0x063A;
	 t['ghainfinalarabic'] = 0xFECE;
	 t['ghaininitialarabic'] = 0xFECF;
	 t['ghainmedialarabic'] = 0xFED0;
	 t['ghemiddlehookcyrillic'] = 0x0495;
	 t['ghestrokecyrillic'] = 0x0493;
	 t['gheupturncyrillic'] = 0x0491;
	 t['ghhadeva'] = 0x095A;
	 t['ghhagurmukhi'] = 0x0A5A;
	 t['ghook'] = 0x0260;
	 t['ghzsquare'] = 0x3393;
	 t['gihiragana'] = 0x304E;
	 t['gikatakana'] = 0x30AE;
	 t['gimarmenian'] = 0x0563;
	 t['gimel'] = 0x05D2;
	 t['gimeldagesh'] = 0xFB32;
	 t['gimeldageshhebrew'] = 0xFB32;
	 t['gimelhebrew'] = 0x05D2;
	 t['gjecyrillic'] = 0x0453;
	 t['glottalinvertedstroke'] = 0x01BE;
	 t['glottalstop'] = 0x0294;
	 t['glottalstopinverted'] = 0x0296;
	 t['glottalstopmod'] = 0x02C0;
	 t['glottalstopreversed'] = 0x0295;
	 t['glottalstopreversedmod'] = 0x02C1;
	 t['glottalstopreversedsuperior'] = 0x02E4;
	 t['glottalstopstroke'] = 0x02A1;
	 t['glottalstopstrokereversed'] = 0x02A2;
	 t['gmacron'] = 0x1E21;
	 t['gmonospace'] = 0xFF47;
	 t['gohiragana'] = 0x3054;
	 t['gokatakana'] = 0x30B4;
	 t['gparen'] = 0x24A2;
	 t['gpasquare'] = 0x33AC;
	 t['gradient'] = 0x2207;
	 t['grave'] = 0x0060;
	 t['gravebelowcmb'] = 0x0316;
	 t['gravecmb'] = 0x0300;
	 t['gravecomb'] = 0x0300;
	 t['gravedeva'] = 0x0953;
	 t['gravelowmod'] = 0x02CE;
	 t['gravemonospace'] = 0xFF40;
	 t['gravetonecmb'] = 0x0340;
	 t['greater'] = 0x003E;
	 t['greaterequal'] = 0x2265;
	 t['greaterequalorless'] = 0x22DB;
	 t['greatermonospace'] = 0xFF1E;
	 t['greaterorequivalent'] = 0x2273;
	 t['greaterorless'] = 0x2277;
	 t['greateroverequal'] = 0x2267;
	 t['greatersmall'] = 0xFE65;
	 t['gscript'] = 0x0261;
	 t['gstroke'] = 0x01E5;
	 t['guhiragana'] = 0x3050;
	 t['guillemotleft'] = 0x00AB;
	 t['guillemotright'] = 0x00BB;
	 t['guilsinglleft'] = 0x2039;
	 t['guilsinglright'] = 0x203A;
	 t['gukatakana'] = 0x30B0;
	 t['guramusquare'] = 0x3318;
	 t['gysquare'] = 0x33C9;
	 t['h'] = 0x0068;
	 t['haabkhasiancyrillic'] = 0x04A9;
	 t['haaltonearabic'] = 0x06C1;
	 t['habengali'] = 0x09B9;
	 t['hadescendercyrillic'] = 0x04B3;
	 t['hadeva'] = 0x0939;
	 t['hagujarati'] = 0x0AB9;
	 t['hagurmukhi'] = 0x0A39;
	 t['haharabic'] = 0x062D;
	 t['hahfinalarabic'] = 0xFEA2;
	 t['hahinitialarabic'] = 0xFEA3;
	 t['hahiragana'] = 0x306F;
	 t['hahmedialarabic'] = 0xFEA4;
	 t['haitusquare'] = 0x332A;
	 t['hakatakana'] = 0x30CF;
	 t['hakatakanahalfwidth'] = 0xFF8A;
	 t['halantgurmukhi'] = 0x0A4D;
	 t['hamzaarabic'] = 0x0621;
	 t['hamzalowarabic'] = 0x0621;
	 t['hangulfiller'] = 0x3164;
	 t['hardsigncyrillic'] = 0x044A;
	 t['harpoonleftbarbup'] = 0x21BC;
	 t['harpoonrightbarbup'] = 0x21C0;
	 t['hasquare'] = 0x33CA;
	 t['hatafpatah'] = 0x05B2;
	 t['hatafpatah16'] = 0x05B2;
	 t['hatafpatah23'] = 0x05B2;
	 t['hatafpatah2f'] = 0x05B2;
	 t['hatafpatahhebrew'] = 0x05B2;
	 t['hatafpatahnarrowhebrew'] = 0x05B2;
	 t['hatafpatahquarterhebrew'] = 0x05B2;
	 t['hatafpatahwidehebrew'] = 0x05B2;
	 t['hatafqamats'] = 0x05B3;
	 t['hatafqamats1b'] = 0x05B3;
	 t['hatafqamats28'] = 0x05B3;
	 t['hatafqamats34'] = 0x05B3;
	 t['hatafqamatshebrew'] = 0x05B3;
	 t['hatafqamatsnarrowhebrew'] = 0x05B3;
	 t['hatafqamatsquarterhebrew'] = 0x05B3;
	 t['hatafqamatswidehebrew'] = 0x05B3;
	 t['hatafsegol'] = 0x05B1;
	 t['hatafsegol17'] = 0x05B1;
	 t['hatafsegol24'] = 0x05B1;
	 t['hatafsegol30'] = 0x05B1;
	 t['hatafsegolhebrew'] = 0x05B1;
	 t['hatafsegolnarrowhebrew'] = 0x05B1;
	 t['hatafsegolquarterhebrew'] = 0x05B1;
	 t['hatafsegolwidehebrew'] = 0x05B1;
	 t['hbar'] = 0x0127;
	 t['hbopomofo'] = 0x310F;
	 t['hbrevebelow'] = 0x1E2B;
	 t['hcedilla'] = 0x1E29;
	 t['hcircle'] = 0x24D7;
	 t['hcircumflex'] = 0x0125;
	 t['hdieresis'] = 0x1E27;
	 t['hdotaccent'] = 0x1E23;
	 t['hdotbelow'] = 0x1E25;
	 t['he'] = 0x05D4;
	 t['heart'] = 0x2665;
	 t['heartsuitblack'] = 0x2665;
	 t['heartsuitwhite'] = 0x2661;
	 t['hedagesh'] = 0xFB34;
	 t['hedageshhebrew'] = 0xFB34;
	 t['hehaltonearabic'] = 0x06C1;
	 t['heharabic'] = 0x0647;
	 t['hehebrew'] = 0x05D4;
	 t['hehfinalaltonearabic'] = 0xFBA7;
	 t['hehfinalalttwoarabic'] = 0xFEEA;
	 t['hehfinalarabic'] = 0xFEEA;
	 t['hehhamzaabovefinalarabic'] = 0xFBA5;
	 t['hehhamzaaboveisolatedarabic'] = 0xFBA4;
	 t['hehinitialaltonearabic'] = 0xFBA8;
	 t['hehinitialarabic'] = 0xFEEB;
	 t['hehiragana'] = 0x3078;
	 t['hehmedialaltonearabic'] = 0xFBA9;
	 t['hehmedialarabic'] = 0xFEEC;
	 t['heiseierasquare'] = 0x337B;
	 t['hekatakana'] = 0x30D8;
	 t['hekatakanahalfwidth'] = 0xFF8D;
	 t['hekutaarusquare'] = 0x3336;
	 t['henghook'] = 0x0267;
	 t['herutusquare'] = 0x3339;
	 t['het'] = 0x05D7;
	 t['hethebrew'] = 0x05D7;
	 t['hhook'] = 0x0266;
	 t['hhooksuperior'] = 0x02B1;
	 t['hieuhacirclekorean'] = 0x327B;
	 t['hieuhaparenkorean'] = 0x321B;
	 t['hieuhcirclekorean'] = 0x326D;
	 t['hieuhkorean'] = 0x314E;
	 t['hieuhparenkorean'] = 0x320D;
	 t['hihiragana'] = 0x3072;
	 t['hikatakana'] = 0x30D2;
	 t['hikatakanahalfwidth'] = 0xFF8B;
	 t['hiriq'] = 0x05B4;
	 t['hiriq14'] = 0x05B4;
	 t['hiriq21'] = 0x05B4;
	 t['hiriq2d'] = 0x05B4;
	 t['hiriqhebrew'] = 0x05B4;
	 t['hiriqnarrowhebrew'] = 0x05B4;
	 t['hiriqquarterhebrew'] = 0x05B4;
	 t['hiriqwidehebrew'] = 0x05B4;
	 t['hlinebelow'] = 0x1E96;
	 t['hmonospace'] = 0xFF48;
	 t['hoarmenian'] = 0x0570;
	 t['hohipthai'] = 0x0E2B;
	 t['hohiragana'] = 0x307B;
	 t['hokatakana'] = 0x30DB;
	 t['hokatakanahalfwidth'] = 0xFF8E;
	 t['holam'] = 0x05B9;
	 t['holam19'] = 0x05B9;
	 t['holam26'] = 0x05B9;
	 t['holam32'] = 0x05B9;
	 t['holamhebrew'] = 0x05B9;
	 t['holamnarrowhebrew'] = 0x05B9;
	 t['holamquarterhebrew'] = 0x05B9;
	 t['holamwidehebrew'] = 0x05B9;
	 t['honokhukthai'] = 0x0E2E;
	 t['hookabovecomb'] = 0x0309;
	 t['hookcmb'] = 0x0309;
	 t['hookpalatalizedbelowcmb'] = 0x0321;
	 t['hookretroflexbelowcmb'] = 0x0322;
	 t['hoonsquare'] = 0x3342;
	 t['horicoptic'] = 0x03E9;
	 t['horizontalbar'] = 0x2015;
	 t['horncmb'] = 0x031B;
	 t['hotsprings'] = 0x2668;
	 t['house'] = 0x2302;
	 t['hparen'] = 0x24A3;
	 t['hsuperior'] = 0x02B0;
	 t['hturned'] = 0x0265;
	 t['huhiragana'] = 0x3075;
	 t['huiitosquare'] = 0x3333;
	 t['hukatakana'] = 0x30D5;
	 t['hukatakanahalfwidth'] = 0xFF8C;
	 t['hungarumlaut'] = 0x02DD;
	 t['hungarumlautcmb'] = 0x030B;
	 t['hv'] = 0x0195;
	 t['hyphen'] = 0x002D;
	 t['hypheninferior'] = 0xF6E5;
	 t['hyphenmonospace'] = 0xFF0D;
	 t['hyphensmall'] = 0xFE63;
	 t['hyphensuperior'] = 0xF6E6;
	 t['hyphentwo'] = 0x2010;
	 t['i'] = 0x0069;
	 t['iacute'] = 0x00ED;
	 t['iacyrillic'] = 0x044F;
	 t['ibengali'] = 0x0987;
	 t['ibopomofo'] = 0x3127;
	 t['ibreve'] = 0x012D;
	 t['icaron'] = 0x01D0;
	 t['icircle'] = 0x24D8;
	 t['icircumflex'] = 0x00EE;
	 t['icyrillic'] = 0x0456;
	 t['idblgrave'] = 0x0209;
	 t['ideographearthcircle'] = 0x328F;
	 t['ideographfirecircle'] = 0x328B;
	 t['ideographicallianceparen'] = 0x323F;
	 t['ideographiccallparen'] = 0x323A;
	 t['ideographiccentrecircle'] = 0x32A5;
	 t['ideographicclose'] = 0x3006;
	 t['ideographiccomma'] = 0x3001;
	 t['ideographiccommaleft'] = 0xFF64;
	 t['ideographiccongratulationparen'] = 0x3237;
	 t['ideographiccorrectcircle'] = 0x32A3;
	 t['ideographicearthparen'] = 0x322F;
	 t['ideographicenterpriseparen'] = 0x323D;
	 t['ideographicexcellentcircle'] = 0x329D;
	 t['ideographicfestivalparen'] = 0x3240;
	 t['ideographicfinancialcircle'] = 0x3296;
	 t['ideographicfinancialparen'] = 0x3236;
	 t['ideographicfireparen'] = 0x322B;
	 t['ideographichaveparen'] = 0x3232;
	 t['ideographichighcircle'] = 0x32A4;
	 t['ideographiciterationmark'] = 0x3005;
	 t['ideographiclaborcircle'] = 0x3298;
	 t['ideographiclaborparen'] = 0x3238;
	 t['ideographicleftcircle'] = 0x32A7;
	 t['ideographiclowcircle'] = 0x32A6;
	 t['ideographicmedicinecircle'] = 0x32A9;
	 t['ideographicmetalparen'] = 0x322E;
	 t['ideographicmoonparen'] = 0x322A;
	 t['ideographicnameparen'] = 0x3234;
	 t['ideographicperiod'] = 0x3002;
	 t['ideographicprintcircle'] = 0x329E;
	 t['ideographicreachparen'] = 0x3243;
	 t['ideographicrepresentparen'] = 0x3239;
	 t['ideographicresourceparen'] = 0x323E;
	 t['ideographicrightcircle'] = 0x32A8;
	 t['ideographicsecretcircle'] = 0x3299;
	 t['ideographicselfparen'] = 0x3242;
	 t['ideographicsocietyparen'] = 0x3233;
	 t['ideographicspace'] = 0x3000;
	 t['ideographicspecialparen'] = 0x3235;
	 t['ideographicstockparen'] = 0x3231;
	 t['ideographicstudyparen'] = 0x323B;
	 t['ideographicsunparen'] = 0x3230;
	 t['ideographicsuperviseparen'] = 0x323C;
	 t['ideographicwaterparen'] = 0x322C;
	 t['ideographicwoodparen'] = 0x322D;
	 t['ideographiczero'] = 0x3007;
	 t['ideographmetalcircle'] = 0x328E;
	 t['ideographmooncircle'] = 0x328A;
	 t['ideographnamecircle'] = 0x3294;
	 t['ideographsuncircle'] = 0x3290;
	 t['ideographwatercircle'] = 0x328C;
	 t['ideographwoodcircle'] = 0x328D;
	 t['ideva'] = 0x0907;
	 t['idieresis'] = 0x00EF;
	 t['idieresisacute'] = 0x1E2F;
	 t['idieresiscyrillic'] = 0x04E5;
	 t['idotbelow'] = 0x1ECB;
	 t['iebrevecyrillic'] = 0x04D7;
	 t['iecyrillic'] = 0x0435;
	 t['ieungacirclekorean'] = 0x3275;
	 t['ieungaparenkorean'] = 0x3215;
	 t['ieungcirclekorean'] = 0x3267;
	 t['ieungkorean'] = 0x3147;
	 t['ieungparenkorean'] = 0x3207;
	 t['igrave'] = 0x00EC;
	 t['igujarati'] = 0x0A87;
	 t['igurmukhi'] = 0x0A07;
	 t['ihiragana'] = 0x3044;
	 t['ihookabove'] = 0x1EC9;
	 t['iibengali'] = 0x0988;
	 t['iicyrillic'] = 0x0438;
	 t['iideva'] = 0x0908;
	 t['iigujarati'] = 0x0A88;
	 t['iigurmukhi'] = 0x0A08;
	 t['iimatragurmukhi'] = 0x0A40;
	 t['iinvertedbreve'] = 0x020B;
	 t['iishortcyrillic'] = 0x0439;
	 t['iivowelsignbengali'] = 0x09C0;
	 t['iivowelsigndeva'] = 0x0940;
	 t['iivowelsigngujarati'] = 0x0AC0;
	 t['ij'] = 0x0133;
	 t['ikatakana'] = 0x30A4;
	 t['ikatakanahalfwidth'] = 0xFF72;
	 t['ikorean'] = 0x3163;
	 t['ilde'] = 0x02DC;
	 t['iluyhebrew'] = 0x05AC;
	 t['imacron'] = 0x012B;
	 t['imacroncyrillic'] = 0x04E3;
	 t['imageorapproximatelyequal'] = 0x2253;
	 t['imatragurmukhi'] = 0x0A3F;
	 t['imonospace'] = 0xFF49;
	 t['increment'] = 0x2206;
	 t['infinity'] = 0x221E;
	 t['iniarmenian'] = 0x056B;
	 t['integral'] = 0x222B;
	 t['integralbottom'] = 0x2321;
	 t['integralbt'] = 0x2321;
	 t['integralex'] = 0xF8F5;
	 t['integraltop'] = 0x2320;
	 t['integraltp'] = 0x2320;
	 t['intersection'] = 0x2229;
	 t['intisquare'] = 0x3305;
	 t['invbullet'] = 0x25D8;
	 t['invcircle'] = 0x25D9;
	 t['invsmileface'] = 0x263B;
	 t['iocyrillic'] = 0x0451;
	 t['iogonek'] = 0x012F;
	 t['iota'] = 0x03B9;
	 t['iotadieresis'] = 0x03CA;
	 t['iotadieresistonos'] = 0x0390;
	 t['iotalatin'] = 0x0269;
	 t['iotatonos'] = 0x03AF;
	 t['iparen'] = 0x24A4;
	 t['irigurmukhi'] = 0x0A72;
	 t['ismallhiragana'] = 0x3043;
	 t['ismallkatakana'] = 0x30A3;
	 t['ismallkatakanahalfwidth'] = 0xFF68;
	 t['issharbengali'] = 0x09FA;
	 t['istroke'] = 0x0268;
	 t['isuperior'] = 0xF6ED;
	 t['iterationhiragana'] = 0x309D;
	 t['iterationkatakana'] = 0x30FD;
	 t['itilde'] = 0x0129;
	 t['itildebelow'] = 0x1E2D;
	 t['iubopomofo'] = 0x3129;
	 t['iucyrillic'] = 0x044E;
	 t['ivowelsignbengali'] = 0x09BF;
	 t['ivowelsigndeva'] = 0x093F;
	 t['ivowelsigngujarati'] = 0x0ABF;
	 t['izhitsacyrillic'] = 0x0475;
	 t['izhitsadblgravecyrillic'] = 0x0477;
	 t['j'] = 0x006A;
	 t['jaarmenian'] = 0x0571;
	 t['jabengali'] = 0x099C;
	 t['jadeva'] = 0x091C;
	 t['jagujarati'] = 0x0A9C;
	 t['jagurmukhi'] = 0x0A1C;
	 t['jbopomofo'] = 0x3110;
	 t['jcaron'] = 0x01F0;
	 t['jcircle'] = 0x24D9;
	 t['jcircumflex'] = 0x0135;
	 t['jcrossedtail'] = 0x029D;
	 t['jdotlessstroke'] = 0x025F;
	 t['jecyrillic'] = 0x0458;
	 t['jeemarabic'] = 0x062C;
	 t['jeemfinalarabic'] = 0xFE9E;
	 t['jeeminitialarabic'] = 0xFE9F;
	 t['jeemmedialarabic'] = 0xFEA0;
	 t['jeharabic'] = 0x0698;
	 t['jehfinalarabic'] = 0xFB8B;
	 t['jhabengali'] = 0x099D;
	 t['jhadeva'] = 0x091D;
	 t['jhagujarati'] = 0x0A9D;
	 t['jhagurmukhi'] = 0x0A1D;
	 t['jheharmenian'] = 0x057B;
	 t['jis'] = 0x3004;
	 t['jmonospace'] = 0xFF4A;
	 t['jparen'] = 0x24A5;
	 t['jsuperior'] = 0x02B2;
	 t['k'] = 0x006B;
	 t['kabashkircyrillic'] = 0x04A1;
	 t['kabengali'] = 0x0995;
	 t['kacute'] = 0x1E31;
	 t['kacyrillic'] = 0x043A;
	 t['kadescendercyrillic'] = 0x049B;
	 t['kadeva'] = 0x0915;
	 t['kaf'] = 0x05DB;
	 t['kafarabic'] = 0x0643;
	 t['kafdagesh'] = 0xFB3B;
	 t['kafdageshhebrew'] = 0xFB3B;
	 t['kaffinalarabic'] = 0xFEDA;
	 t['kafhebrew'] = 0x05DB;
	 t['kafinitialarabic'] = 0xFEDB;
	 t['kafmedialarabic'] = 0xFEDC;
	 t['kafrafehebrew'] = 0xFB4D;
	 t['kagujarati'] = 0x0A95;
	 t['kagurmukhi'] = 0x0A15;
	 t['kahiragana'] = 0x304B;
	 t['kahookcyrillic'] = 0x04C4;
	 t['kakatakana'] = 0x30AB;
	 t['kakatakanahalfwidth'] = 0xFF76;
	 t['kappa'] = 0x03BA;
	 t['kappasymbolgreek'] = 0x03F0;
	 t['kapyeounmieumkorean'] = 0x3171;
	 t['kapyeounphieuphkorean'] = 0x3184;
	 t['kapyeounpieupkorean'] = 0x3178;
	 t['kapyeounssangpieupkorean'] = 0x3179;
	 t['karoriisquare'] = 0x330D;
	 t['kashidaautoarabic'] = 0x0640;
	 t['kashidaautonosidebearingarabic'] = 0x0640;
	 t['kasmallkatakana'] = 0x30F5;
	 t['kasquare'] = 0x3384;
	 t['kasraarabic'] = 0x0650;
	 t['kasratanarabic'] = 0x064D;
	 t['kastrokecyrillic'] = 0x049F;
	 t['katahiraprolongmarkhalfwidth'] = 0xFF70;
	 t['kaverticalstrokecyrillic'] = 0x049D;
	 t['kbopomofo'] = 0x310E;
	 t['kcalsquare'] = 0x3389;
	 t['kcaron'] = 0x01E9;
	 t['kcedilla'] = 0x0137;
	 t['kcircle'] = 0x24DA;
	 t['kcommaaccent'] = 0x0137;
	 t['kdotbelow'] = 0x1E33;
	 t['keharmenian'] = 0x0584;
	 t['kehiragana'] = 0x3051;
	 t['kekatakana'] = 0x30B1;
	 t['kekatakanahalfwidth'] = 0xFF79;
	 t['kenarmenian'] = 0x056F;
	 t['kesmallkatakana'] = 0x30F6;
	 t['kgreenlandic'] = 0x0138;
	 t['khabengali'] = 0x0996;
	 t['khacyrillic'] = 0x0445;
	 t['khadeva'] = 0x0916;
	 t['khagujarati'] = 0x0A96;
	 t['khagurmukhi'] = 0x0A16;
	 t['khaharabic'] = 0x062E;
	 t['khahfinalarabic'] = 0xFEA6;
	 t['khahinitialarabic'] = 0xFEA7;
	 t['khahmedialarabic'] = 0xFEA8;
	 t['kheicoptic'] = 0x03E7;
	 t['khhadeva'] = 0x0959;
	 t['khhagurmukhi'] = 0x0A59;
	 t['khieukhacirclekorean'] = 0x3278;
	 t['khieukhaparenkorean'] = 0x3218;
	 t['khieukhcirclekorean'] = 0x326A;
	 t['khieukhkorean'] = 0x314B;
	 t['khieukhparenkorean'] = 0x320A;
	 t['khokhaithai'] = 0x0E02;
	 t['khokhonthai'] = 0x0E05;
	 t['khokhuatthai'] = 0x0E03;
	 t['khokhwaithai'] = 0x0E04;
	 t['khomutthai'] = 0x0E5B;
	 t['khook'] = 0x0199;
	 t['khorakhangthai'] = 0x0E06;
	 t['khzsquare'] = 0x3391;
	 t['kihiragana'] = 0x304D;
	 t['kikatakana'] = 0x30AD;
	 t['kikatakanahalfwidth'] = 0xFF77;
	 t['kiroguramusquare'] = 0x3315;
	 t['kiromeetorusquare'] = 0x3316;
	 t['kirosquare'] = 0x3314;
	 t['kiyeokacirclekorean'] = 0x326E;
	 t['kiyeokaparenkorean'] = 0x320E;
	 t['kiyeokcirclekorean'] = 0x3260;
	 t['kiyeokkorean'] = 0x3131;
	 t['kiyeokparenkorean'] = 0x3200;
	 t['kiyeoksioskorean'] = 0x3133;
	 t['kjecyrillic'] = 0x045C;
	 t['klinebelow'] = 0x1E35;
	 t['klsquare'] = 0x3398;
	 t['kmcubedsquare'] = 0x33A6;
	 t['kmonospace'] = 0xFF4B;
	 t['kmsquaredsquare'] = 0x33A2;
	 t['kohiragana'] = 0x3053;
	 t['kohmsquare'] = 0x33C0;
	 t['kokaithai'] = 0x0E01;
	 t['kokatakana'] = 0x30B3;
	 t['kokatakanahalfwidth'] = 0xFF7A;
	 t['kooposquare'] = 0x331E;
	 t['koppacyrillic'] = 0x0481;
	 t['koreanstandardsymbol'] = 0x327F;
	 t['koroniscmb'] = 0x0343;
	 t['kparen'] = 0x24A6;
	 t['kpasquare'] = 0x33AA;
	 t['ksicyrillic'] = 0x046F;
	 t['ktsquare'] = 0x33CF;
	 t['kturned'] = 0x029E;
	 t['kuhiragana'] = 0x304F;
	 t['kukatakana'] = 0x30AF;
	 t['kukatakanahalfwidth'] = 0xFF78;
	 t['kvsquare'] = 0x33B8;
	 t['kwsquare'] = 0x33BE;
	 t['l'] = 0x006C;
	 t['labengali'] = 0x09B2;
	 t['lacute'] = 0x013A;
	 t['ladeva'] = 0x0932;
	 t['lagujarati'] = 0x0AB2;
	 t['lagurmukhi'] = 0x0A32;
	 t['lakkhangyaothai'] = 0x0E45;
	 t['lamaleffinalarabic'] = 0xFEFC;
	 t['lamalefhamzaabovefinalarabic'] = 0xFEF8;
	 t['lamalefhamzaaboveisolatedarabic'] = 0xFEF7;
	 t['lamalefhamzabelowfinalarabic'] = 0xFEFA;
	 t['lamalefhamzabelowisolatedarabic'] = 0xFEF9;
	 t['lamalefisolatedarabic'] = 0xFEFB;
	 t['lamalefmaddaabovefinalarabic'] = 0xFEF6;
	 t['lamalefmaddaaboveisolatedarabic'] = 0xFEF5;
	 t['lamarabic'] = 0x0644;
	 t['lambda'] = 0x03BB;
	 t['lambdastroke'] = 0x019B;
	 t['lamed'] = 0x05DC;
	 t['lameddagesh'] = 0xFB3C;
	 t['lameddageshhebrew'] = 0xFB3C;
	 t['lamedhebrew'] = 0x05DC;
	 t['lamfinalarabic'] = 0xFEDE;
	 t['lamhahinitialarabic'] = 0xFCCA;
	 t['laminitialarabic'] = 0xFEDF;
	 t['lamjeeminitialarabic'] = 0xFCC9;
	 t['lamkhahinitialarabic'] = 0xFCCB;
	 t['lamlamhehisolatedarabic'] = 0xFDF2;
	 t['lammedialarabic'] = 0xFEE0;
	 t['lammeemhahinitialarabic'] = 0xFD88;
	 t['lammeeminitialarabic'] = 0xFCCC;
	 t['largecircle'] = 0x25EF;
	 t['lbar'] = 0x019A;
	 t['lbelt'] = 0x026C;
	 t['lbopomofo'] = 0x310C;
	 t['lcaron'] = 0x013E;
	 t['lcedilla'] = 0x013C;
	 t['lcircle'] = 0x24DB;
	 t['lcircumflexbelow'] = 0x1E3D;
	 t['lcommaaccent'] = 0x013C;
	 t['ldot'] = 0x0140;
	 t['ldotaccent'] = 0x0140;
	 t['ldotbelow'] = 0x1E37;
	 t['ldotbelowmacron'] = 0x1E39;
	 t['leftangleabovecmb'] = 0x031A;
	 t['lefttackbelowcmb'] = 0x0318;
	 t['less'] = 0x003C;
	 t['lessequal'] = 0x2264;
	 t['lessequalorgreater'] = 0x22DA;
	 t['lessmonospace'] = 0xFF1C;
	 t['lessorequivalent'] = 0x2272;
	 t['lessorgreater'] = 0x2276;
	 t['lessoverequal'] = 0x2266;
	 t['lesssmall'] = 0xFE64;
	 t['lezh'] = 0x026E;
	 t['lfblock'] = 0x258C;
	 t['lhookretroflex'] = 0x026D;
	 t['lira'] = 0x20A4;
	 t['liwnarmenian'] = 0x056C;
	 t['lj'] = 0x01C9;
	 t['ljecyrillic'] = 0x0459;
	 t['ll'] = 0xF6C0;
	 t['lladeva'] = 0x0933;
	 t['llagujarati'] = 0x0AB3;
	 t['llinebelow'] = 0x1E3B;
	 t['llladeva'] = 0x0934;
	 t['llvocalicbengali'] = 0x09E1;
	 t['llvocalicdeva'] = 0x0961;
	 t['llvocalicvowelsignbengali'] = 0x09E3;
	 t['llvocalicvowelsigndeva'] = 0x0963;
	 t['lmiddletilde'] = 0x026B;
	 t['lmonospace'] = 0xFF4C;
	 t['lmsquare'] = 0x33D0;
	 t['lochulathai'] = 0x0E2C;
	 t['logicaland'] = 0x2227;
	 t['logicalnot'] = 0x00AC;
	 t['logicalnotreversed'] = 0x2310;
	 t['logicalor'] = 0x2228;
	 t['lolingthai'] = 0x0E25;
	 t['longs'] = 0x017F;
	 t['lowlinecenterline'] = 0xFE4E;
	 t['lowlinecmb'] = 0x0332;
	 t['lowlinedashed'] = 0xFE4D;
	 t['lozenge'] = 0x25CA;
	 t['lparen'] = 0x24A7;
	 t['lslash'] = 0x0142;
	 t['lsquare'] = 0x2113;
	 t['lsuperior'] = 0xF6EE;
	 t['ltshade'] = 0x2591;
	 t['luthai'] = 0x0E26;
	 t['lvocalicbengali'] = 0x098C;
	 t['lvocalicdeva'] = 0x090C;
	 t['lvocalicvowelsignbengali'] = 0x09E2;
	 t['lvocalicvowelsigndeva'] = 0x0962;
	 t['lxsquare'] = 0x33D3;
	 t['m'] = 0x006D;
	 t['mabengali'] = 0x09AE;
	 t['macron'] = 0x00AF;
	 t['macronbelowcmb'] = 0x0331;
	 t['macroncmb'] = 0x0304;
	 t['macronlowmod'] = 0x02CD;
	 t['macronmonospace'] = 0xFFE3;
	 t['macute'] = 0x1E3F;
	 t['madeva'] = 0x092E;
	 t['magujarati'] = 0x0AAE;
	 t['magurmukhi'] = 0x0A2E;
	 t['mahapakhhebrew'] = 0x05A4;
	 t['mahapakhlefthebrew'] = 0x05A4;
	 t['mahiragana'] = 0x307E;
	 t['maichattawalowleftthai'] = 0xF895;
	 t['maichattawalowrightthai'] = 0xF894;
	 t['maichattawathai'] = 0x0E4B;
	 t['maichattawaupperleftthai'] = 0xF893;
	 t['maieklowleftthai'] = 0xF88C;
	 t['maieklowrightthai'] = 0xF88B;
	 t['maiekthai'] = 0x0E48;
	 t['maiekupperleftthai'] = 0xF88A;
	 t['maihanakatleftthai'] = 0xF884;
	 t['maihanakatthai'] = 0x0E31;
	 t['maitaikhuleftthai'] = 0xF889;
	 t['maitaikhuthai'] = 0x0E47;
	 t['maitholowleftthai'] = 0xF88F;
	 t['maitholowrightthai'] = 0xF88E;
	 t['maithothai'] = 0x0E49;
	 t['maithoupperleftthai'] = 0xF88D;
	 t['maitrilowleftthai'] = 0xF892;
	 t['maitrilowrightthai'] = 0xF891;
	 t['maitrithai'] = 0x0E4A;
	 t['maitriupperleftthai'] = 0xF890;
	 t['maiyamokthai'] = 0x0E46;
	 t['makatakana'] = 0x30DE;
	 t['makatakanahalfwidth'] = 0xFF8F;
	 t['male'] = 0x2642;
	 t['mansyonsquare'] = 0x3347;
	 t['maqafhebrew'] = 0x05BE;
	 t['mars'] = 0x2642;
	 t['masoracirclehebrew'] = 0x05AF;
	 t['masquare'] = 0x3383;
	 t['mbopomofo'] = 0x3107;
	 t['mbsquare'] = 0x33D4;
	 t['mcircle'] = 0x24DC;
	 t['mcubedsquare'] = 0x33A5;
	 t['mdotaccent'] = 0x1E41;
	 t['mdotbelow'] = 0x1E43;
	 t['meemarabic'] = 0x0645;
	 t['meemfinalarabic'] = 0xFEE2;
	 t['meeminitialarabic'] = 0xFEE3;
	 t['meemmedialarabic'] = 0xFEE4;
	 t['meemmeeminitialarabic'] = 0xFCD1;
	 t['meemmeemisolatedarabic'] = 0xFC48;
	 t['meetorusquare'] = 0x334D;
	 t['mehiragana'] = 0x3081;
	 t['meizierasquare'] = 0x337E;
	 t['mekatakana'] = 0x30E1;
	 t['mekatakanahalfwidth'] = 0xFF92;
	 t['mem'] = 0x05DE;
	 t['memdagesh'] = 0xFB3E;
	 t['memdageshhebrew'] = 0xFB3E;
	 t['memhebrew'] = 0x05DE;
	 t['menarmenian'] = 0x0574;
	 t['merkhahebrew'] = 0x05A5;
	 t['merkhakefulahebrew'] = 0x05A6;
	 t['merkhakefulalefthebrew'] = 0x05A6;
	 t['merkhalefthebrew'] = 0x05A5;
	 t['mhook'] = 0x0271;
	 t['mhzsquare'] = 0x3392;
	 t['middledotkatakanahalfwidth'] = 0xFF65;
	 t['middot'] = 0x00B7;
	 t['mieumacirclekorean'] = 0x3272;
	 t['mieumaparenkorean'] = 0x3212;
	 t['mieumcirclekorean'] = 0x3264;
	 t['mieumkorean'] = 0x3141;
	 t['mieumpansioskorean'] = 0x3170;
	 t['mieumparenkorean'] = 0x3204;
	 t['mieumpieupkorean'] = 0x316E;
	 t['mieumsioskorean'] = 0x316F;
	 t['mihiragana'] = 0x307F;
	 t['mikatakana'] = 0x30DF;
	 t['mikatakanahalfwidth'] = 0xFF90;
	 t['minus'] = 0x2212;
	 t['minusbelowcmb'] = 0x0320;
	 t['minuscircle'] = 0x2296;
	 t['minusmod'] = 0x02D7;
	 t['minusplus'] = 0x2213;
	 t['minute'] = 0x2032;
	 t['miribaarusquare'] = 0x334A;
	 t['mirisquare'] = 0x3349;
	 t['mlonglegturned'] = 0x0270;
	 t['mlsquare'] = 0x3396;
	 t['mmcubedsquare'] = 0x33A3;
	 t['mmonospace'] = 0xFF4D;
	 t['mmsquaredsquare'] = 0x339F;
	 t['mohiragana'] = 0x3082;
	 t['mohmsquare'] = 0x33C1;
	 t['mokatakana'] = 0x30E2;
	 t['mokatakanahalfwidth'] = 0xFF93;
	 t['molsquare'] = 0x33D6;
	 t['momathai'] = 0x0E21;
	 t['moverssquare'] = 0x33A7;
	 t['moverssquaredsquare'] = 0x33A8;
	 t['mparen'] = 0x24A8;
	 t['mpasquare'] = 0x33AB;
	 t['mssquare'] = 0x33B3;
	 t['msuperior'] = 0xF6EF;
	 t['mturned'] = 0x026F;
	 t['mu'] = 0x00B5;
	 t['mu1'] = 0x00B5;
	 t['muasquare'] = 0x3382;
	 t['muchgreater'] = 0x226B;
	 t['muchless'] = 0x226A;
	 t['mufsquare'] = 0x338C;
	 t['mugreek'] = 0x03BC;
	 t['mugsquare'] = 0x338D;
	 t['muhiragana'] = 0x3080;
	 t['mukatakana'] = 0x30E0;
	 t['mukatakanahalfwidth'] = 0xFF91;
	 t['mulsquare'] = 0x3395;
	 t['multiply'] = 0x00D7;
	 t['mumsquare'] = 0x339B;
	 t['munahhebrew'] = 0x05A3;
	 t['munahlefthebrew'] = 0x05A3;
	 t['musicalnote'] = 0x266A;
	 t['musicalnotedbl'] = 0x266B;
	 t['musicflatsign'] = 0x266D;
	 t['musicsharpsign'] = 0x266F;
	 t['mussquare'] = 0x33B2;
	 t['muvsquare'] = 0x33B6;
	 t['muwsquare'] = 0x33BC;
	 t['mvmegasquare'] = 0x33B9;
	 t['mvsquare'] = 0x33B7;
	 t['mwmegasquare'] = 0x33BF;
	 t['mwsquare'] = 0x33BD;
	 t['n'] = 0x006E;
	 t['nabengali'] = 0x09A8;
	 t['nabla'] = 0x2207;
	 t['nacute'] = 0x0144;
	 t['nadeva'] = 0x0928;
	 t['nagujarati'] = 0x0AA8;
	 t['nagurmukhi'] = 0x0A28;
	 t['nahiragana'] = 0x306A;
	 t['nakatakana'] = 0x30CA;
	 t['nakatakanahalfwidth'] = 0xFF85;
	 t['napostrophe'] = 0x0149;
	 t['nasquare'] = 0x3381;
	 t['nbopomofo'] = 0x310B;
	 t['nbspace'] = 0x00A0;
	 t['ncaron'] = 0x0148;
	 t['ncedilla'] = 0x0146;
	 t['ncircle'] = 0x24DD;
	 t['ncircumflexbelow'] = 0x1E4B;
	 t['ncommaaccent'] = 0x0146;
	 t['ndotaccent'] = 0x1E45;
	 t['ndotbelow'] = 0x1E47;
	 t['nehiragana'] = 0x306D;
	 t['nekatakana'] = 0x30CD;
	 t['nekatakanahalfwidth'] = 0xFF88;
	 t['newsheqelsign'] = 0x20AA;
	 t['nfsquare'] = 0x338B;
	 t['ngabengali'] = 0x0999;
	 t['ngadeva'] = 0x0919;
	 t['ngagujarati'] = 0x0A99;
	 t['ngagurmukhi'] = 0x0A19;
	 t['ngonguthai'] = 0x0E07;
	 t['nhiragana'] = 0x3093;
	 t['nhookleft'] = 0x0272;
	 t['nhookretroflex'] = 0x0273;
	 t['nieunacirclekorean'] = 0x326F;
	 t['nieunaparenkorean'] = 0x320F;
	 t['nieuncieuckorean'] = 0x3135;
	 t['nieuncirclekorean'] = 0x3261;
	 t['nieunhieuhkorean'] = 0x3136;
	 t['nieunkorean'] = 0x3134;
	 t['nieunpansioskorean'] = 0x3168;
	 t['nieunparenkorean'] = 0x3201;
	 t['nieunsioskorean'] = 0x3167;
	 t['nieuntikeutkorean'] = 0x3166;
	 t['nihiragana'] = 0x306B;
	 t['nikatakana'] = 0x30CB;
	 t['nikatakanahalfwidth'] = 0xFF86;
	 t['nikhahitleftthai'] = 0xF899;
	 t['nikhahitthai'] = 0x0E4D;
	 t['nine'] = 0x0039;
	 t['ninearabic'] = 0x0669;
	 t['ninebengali'] = 0x09EF;
	 t['ninecircle'] = 0x2468;
	 t['ninecircleinversesansserif'] = 0x2792;
	 t['ninedeva'] = 0x096F;
	 t['ninegujarati'] = 0x0AEF;
	 t['ninegurmukhi'] = 0x0A6F;
	 t['ninehackarabic'] = 0x0669;
	 t['ninehangzhou'] = 0x3029;
	 t['nineideographicparen'] = 0x3228;
	 t['nineinferior'] = 0x2089;
	 t['ninemonospace'] = 0xFF19;
	 t['nineoldstyle'] = 0xF739;
	 t['nineparen'] = 0x247C;
	 t['nineperiod'] = 0x2490;
	 t['ninepersian'] = 0x06F9;
	 t['nineroman'] = 0x2178;
	 t['ninesuperior'] = 0x2079;
	 t['nineteencircle'] = 0x2472;
	 t['nineteenparen'] = 0x2486;
	 t['nineteenperiod'] = 0x249A;
	 t['ninethai'] = 0x0E59;
	 t['nj'] = 0x01CC;
	 t['njecyrillic'] = 0x045A;
	 t['nkatakana'] = 0x30F3;
	 t['nkatakanahalfwidth'] = 0xFF9D;
	 t['nlegrightlong'] = 0x019E;
	 t['nlinebelow'] = 0x1E49;
	 t['nmonospace'] = 0xFF4E;
	 t['nmsquare'] = 0x339A;
	 t['nnabengali'] = 0x09A3;
	 t['nnadeva'] = 0x0923;
	 t['nnagujarati'] = 0x0AA3;
	 t['nnagurmukhi'] = 0x0A23;
	 t['nnnadeva'] = 0x0929;
	 t['nohiragana'] = 0x306E;
	 t['nokatakana'] = 0x30CE;
	 t['nokatakanahalfwidth'] = 0xFF89;
	 t['nonbreakingspace'] = 0x00A0;
	 t['nonenthai'] = 0x0E13;
	 t['nonuthai'] = 0x0E19;
	 t['noonarabic'] = 0x0646;
	 t['noonfinalarabic'] = 0xFEE6;
	 t['noonghunnaarabic'] = 0x06BA;
	 t['noonghunnafinalarabic'] = 0xFB9F;
	 t['nooninitialarabic'] = 0xFEE7;
	 t['noonjeeminitialarabic'] = 0xFCD2;
	 t['noonjeemisolatedarabic'] = 0xFC4B;
	 t['noonmedialarabic'] = 0xFEE8;
	 t['noonmeeminitialarabic'] = 0xFCD5;
	 t['noonmeemisolatedarabic'] = 0xFC4E;
	 t['noonnoonfinalarabic'] = 0xFC8D;
	 t['notcontains'] = 0x220C;
	 t['notelement'] = 0x2209;
	 t['notelementof'] = 0x2209;
	 t['notequal'] = 0x2260;
	 t['notgreater'] = 0x226F;
	 t['notgreaternorequal'] = 0x2271;
	 t['notgreaternorless'] = 0x2279;
	 t['notidentical'] = 0x2262;
	 t['notless'] = 0x226E;
	 t['notlessnorequal'] = 0x2270;
	 t['notparallel'] = 0x2226;
	 t['notprecedes'] = 0x2280;
	 t['notsubset'] = 0x2284;
	 t['notsucceeds'] = 0x2281;
	 t['notsuperset'] = 0x2285;
	 t['nowarmenian'] = 0x0576;
	 t['nparen'] = 0x24A9;
	 t['nssquare'] = 0x33B1;
	 t['nsuperior'] = 0x207F;
	 t['ntilde'] = 0x00F1;
	 t['nu'] = 0x03BD;
	 t['nuhiragana'] = 0x306C;
	 t['nukatakana'] = 0x30CC;
	 t['nukatakanahalfwidth'] = 0xFF87;
	 t['nuktabengali'] = 0x09BC;
	 t['nuktadeva'] = 0x093C;
	 t['nuktagujarati'] = 0x0ABC;
	 t['nuktagurmukhi'] = 0x0A3C;
	 t['numbersign'] = 0x0023;
	 t['numbersignmonospace'] = 0xFF03;
	 t['numbersignsmall'] = 0xFE5F;
	 t['numeralsigngreek'] = 0x0374;
	 t['numeralsignlowergreek'] = 0x0375;
	 t['numero'] = 0x2116;
	 t['nun'] = 0x05E0;
	 t['nundagesh'] = 0xFB40;
	 t['nundageshhebrew'] = 0xFB40;
	 t['nunhebrew'] = 0x05E0;
	 t['nvsquare'] = 0x33B5;
	 t['nwsquare'] = 0x33BB;
	 t['nyabengali'] = 0x099E;
	 t['nyadeva'] = 0x091E;
	 t['nyagujarati'] = 0x0A9E;
	 t['nyagurmukhi'] = 0x0A1E;
	 t['o'] = 0x006F;
	 t['oacute'] = 0x00F3;
	 t['oangthai'] = 0x0E2D;
	 t['obarred'] = 0x0275;
	 t['obarredcyrillic'] = 0x04E9;
	 t['obarreddieresiscyrillic'] = 0x04EB;
	 t['obengali'] = 0x0993;
	 t['obopomofo'] = 0x311B;
	 t['obreve'] = 0x014F;
	 t['ocandradeva'] = 0x0911;
	 t['ocandragujarati'] = 0x0A91;
	 t['ocandravowelsigndeva'] = 0x0949;
	 t['ocandravowelsigngujarati'] = 0x0AC9;
	 t['ocaron'] = 0x01D2;
	 t['ocircle'] = 0x24DE;
	 t['ocircumflex'] = 0x00F4;
	 t['ocircumflexacute'] = 0x1ED1;
	 t['ocircumflexdotbelow'] = 0x1ED9;
	 t['ocircumflexgrave'] = 0x1ED3;
	 t['ocircumflexhookabove'] = 0x1ED5;
	 t['ocircumflextilde'] = 0x1ED7;
	 t['ocyrillic'] = 0x043E;
	 t['odblacute'] = 0x0151;
	 t['odblgrave'] = 0x020D;
	 t['odeva'] = 0x0913;
	 t['odieresis'] = 0x00F6;
	 t['odieresiscyrillic'] = 0x04E7;
	 t['odotbelow'] = 0x1ECD;
	 t['oe'] = 0x0153;
	 t['oekorean'] = 0x315A;
	 t['ogonek'] = 0x02DB;
	 t['ogonekcmb'] = 0x0328;
	 t['ograve'] = 0x00F2;
	 t['ogujarati'] = 0x0A93;
	 t['oharmenian'] = 0x0585;
	 t['ohiragana'] = 0x304A;
	 t['ohookabove'] = 0x1ECF;
	 t['ohorn'] = 0x01A1;
	 t['ohornacute'] = 0x1EDB;
	 t['ohorndotbelow'] = 0x1EE3;
	 t['ohorngrave'] = 0x1EDD;
	 t['ohornhookabove'] = 0x1EDF;
	 t['ohorntilde'] = 0x1EE1;
	 t['ohungarumlaut'] = 0x0151;
	 t['oi'] = 0x01A3;
	 t['oinvertedbreve'] = 0x020F;
	 t['okatakana'] = 0x30AA;
	 t['okatakanahalfwidth'] = 0xFF75;
	 t['okorean'] = 0x3157;
	 t['olehebrew'] = 0x05AB;
	 t['omacron'] = 0x014D;
	 t['omacronacute'] = 0x1E53;
	 t['omacrongrave'] = 0x1E51;
	 t['omdeva'] = 0x0950;
	 t['omega'] = 0x03C9;
	 t['omega1'] = 0x03D6;
	 t['omegacyrillic'] = 0x0461;
	 t['omegalatinclosed'] = 0x0277;
	 t['omegaroundcyrillic'] = 0x047B;
	 t['omegatitlocyrillic'] = 0x047D;
	 t['omegatonos'] = 0x03CE;
	 t['omgujarati'] = 0x0AD0;
	 t['omicron'] = 0x03BF;
	 t['omicrontonos'] = 0x03CC;
	 t['omonospace'] = 0xFF4F;
	 t['one'] = 0x0031;
	 t['onearabic'] = 0x0661;
	 t['onebengali'] = 0x09E7;
	 t['onecircle'] = 0x2460;
	 t['onecircleinversesansserif'] = 0x278A;
	 t['onedeva'] = 0x0967;
	 t['onedotenleader'] = 0x2024;
	 t['oneeighth'] = 0x215B;
	 t['onefitted'] = 0xF6DC;
	 t['onegujarati'] = 0x0AE7;
	 t['onegurmukhi'] = 0x0A67;
	 t['onehackarabic'] = 0x0661;
	 t['onehalf'] = 0x00BD;
	 t['onehangzhou'] = 0x3021;
	 t['oneideographicparen'] = 0x3220;
	 t['oneinferior'] = 0x2081;
	 t['onemonospace'] = 0xFF11;
	 t['onenumeratorbengali'] = 0x09F4;
	 t['oneoldstyle'] = 0xF731;
	 t['oneparen'] = 0x2474;
	 t['oneperiod'] = 0x2488;
	 t['onepersian'] = 0x06F1;
	 t['onequarter'] = 0x00BC;
	 t['oneroman'] = 0x2170;
	 t['onesuperior'] = 0x00B9;
	 t['onethai'] = 0x0E51;
	 t['onethird'] = 0x2153;
	 t['oogonek'] = 0x01EB;
	 t['oogonekmacron'] = 0x01ED;
	 t['oogurmukhi'] = 0x0A13;
	 t['oomatragurmukhi'] = 0x0A4B;
	 t['oopen'] = 0x0254;
	 t['oparen'] = 0x24AA;
	 t['openbullet'] = 0x25E6;
	 t['option'] = 0x2325;
	 t['ordfeminine'] = 0x00AA;
	 t['ordmasculine'] = 0x00BA;
	 t['orthogonal'] = 0x221F;
	 t['oshortdeva'] = 0x0912;
	 t['oshortvowelsigndeva'] = 0x094A;
	 t['oslash'] = 0x00F8;
	 t['oslashacute'] = 0x01FF;
	 t['osmallhiragana'] = 0x3049;
	 t['osmallkatakana'] = 0x30A9;
	 t['osmallkatakanahalfwidth'] = 0xFF6B;
	 t['ostrokeacute'] = 0x01FF;
	 t['osuperior'] = 0xF6F0;
	 t['otcyrillic'] = 0x047F;
	 t['otilde'] = 0x00F5;
	 t['otildeacute'] = 0x1E4D;
	 t['otildedieresis'] = 0x1E4F;
	 t['oubopomofo'] = 0x3121;
	 t['overline'] = 0x203E;
	 t['overlinecenterline'] = 0xFE4A;
	 t['overlinecmb'] = 0x0305;
	 t['overlinedashed'] = 0xFE49;
	 t['overlinedblwavy'] = 0xFE4C;
	 t['overlinewavy'] = 0xFE4B;
	 t['overscore'] = 0x00AF;
	 t['ovowelsignbengali'] = 0x09CB;
	 t['ovowelsigndeva'] = 0x094B;
	 t['ovowelsigngujarati'] = 0x0ACB;
	 t['p'] = 0x0070;
	 t['paampssquare'] = 0x3380;
	 t['paasentosquare'] = 0x332B;
	 t['pabengali'] = 0x09AA;
	 t['pacute'] = 0x1E55;
	 t['padeva'] = 0x092A;
	 t['pagedown'] = 0x21DF;
	 t['pageup'] = 0x21DE;
	 t['pagujarati'] = 0x0AAA;
	 t['pagurmukhi'] = 0x0A2A;
	 t['pahiragana'] = 0x3071;
	 t['paiyannoithai'] = 0x0E2F;
	 t['pakatakana'] = 0x30D1;
	 t['palatalizationcyrilliccmb'] = 0x0484;
	 t['palochkacyrillic'] = 0x04C0;
	 t['pansioskorean'] = 0x317F;
	 t['paragraph'] = 0x00B6;
	 t['parallel'] = 0x2225;
	 t['parenleft'] = 0x0028;
	 t['parenleftaltonearabic'] = 0xFD3E;
	 t['parenleftbt'] = 0xF8ED;
	 t['parenleftex'] = 0xF8EC;
	 t['parenleftinferior'] = 0x208D;
	 t['parenleftmonospace'] = 0xFF08;
	 t['parenleftsmall'] = 0xFE59;
	 t['parenleftsuperior'] = 0x207D;
	 t['parenlefttp'] = 0xF8EB;
	 t['parenleftvertical'] = 0xFE35;
	 t['parenright'] = 0x0029;
	 t['parenrightaltonearabic'] = 0xFD3F;
	 t['parenrightbt'] = 0xF8F8;
	 t['parenrightex'] = 0xF8F7;
	 t['parenrightinferior'] = 0x208E;
	 t['parenrightmonospace'] = 0xFF09;
	 t['parenrightsmall'] = 0xFE5A;
	 t['parenrightsuperior'] = 0x207E;
	 t['parenrighttp'] = 0xF8F6;
	 t['parenrightvertical'] = 0xFE36;
	 t['partialdiff'] = 0x2202;
	 t['paseqhebrew'] = 0x05C0;
	 t['pashtahebrew'] = 0x0599;
	 t['pasquare'] = 0x33A9;
	 t['patah'] = 0x05B7;
	 t['patah11'] = 0x05B7;
	 t['patah1d'] = 0x05B7;
	 t['patah2a'] = 0x05B7;
	 t['patahhebrew'] = 0x05B7;
	 t['patahnarrowhebrew'] = 0x05B7;
	 t['patahquarterhebrew'] = 0x05B7;
	 t['patahwidehebrew'] = 0x05B7;
	 t['pazerhebrew'] = 0x05A1;
	 t['pbopomofo'] = 0x3106;
	 t['pcircle'] = 0x24DF;
	 t['pdotaccent'] = 0x1E57;
	 t['pe'] = 0x05E4;
	 t['pecyrillic'] = 0x043F;
	 t['pedagesh'] = 0xFB44;
	 t['pedageshhebrew'] = 0xFB44;
	 t['peezisquare'] = 0x333B;
	 t['pefinaldageshhebrew'] = 0xFB43;
	 t['peharabic'] = 0x067E;
	 t['peharmenian'] = 0x057A;
	 t['pehebrew'] = 0x05E4;
	 t['pehfinalarabic'] = 0xFB57;
	 t['pehinitialarabic'] = 0xFB58;
	 t['pehiragana'] = 0x307A;
	 t['pehmedialarabic'] = 0xFB59;
	 t['pekatakana'] = 0x30DA;
	 t['pemiddlehookcyrillic'] = 0x04A7;
	 t['perafehebrew'] = 0xFB4E;
	 t['percent'] = 0x0025;
	 t['percentarabic'] = 0x066A;
	 t['percentmonospace'] = 0xFF05;
	 t['percentsmall'] = 0xFE6A;
	 t['period'] = 0x002E;
	 t['periodarmenian'] = 0x0589;
	 t['periodcentered'] = 0x00B7;
	 t['periodhalfwidth'] = 0xFF61;
	 t['periodinferior'] = 0xF6E7;
	 t['periodmonospace'] = 0xFF0E;
	 t['periodsmall'] = 0xFE52;
	 t['periodsuperior'] = 0xF6E8;
	 t['perispomenigreekcmb'] = 0x0342;
	 t['perpendicular'] = 0x22A5;
	 t['perthousand'] = 0x2030;
	 t['peseta'] = 0x20A7;
	 t['pfsquare'] = 0x338A;
	 t['phabengali'] = 0x09AB;
	 t['phadeva'] = 0x092B;
	 t['phagujarati'] = 0x0AAB;
	 t['phagurmukhi'] = 0x0A2B;
	 t['phi'] = 0x03C6;
	 t['phi1'] = 0x03D5;
	 t['phieuphacirclekorean'] = 0x327A;
	 t['phieuphaparenkorean'] = 0x321A;
	 t['phieuphcirclekorean'] = 0x326C;
	 t['phieuphkorean'] = 0x314D;
	 t['phieuphparenkorean'] = 0x320C;
	 t['philatin'] = 0x0278;
	 t['phinthuthai'] = 0x0E3A;
	 t['phisymbolgreek'] = 0x03D5;
	 t['phook'] = 0x01A5;
	 t['phophanthai'] = 0x0E1E;
	 t['phophungthai'] = 0x0E1C;
	 t['phosamphaothai'] = 0x0E20;
	 t['pi'] = 0x03C0;
	 t['pieupacirclekorean'] = 0x3273;
	 t['pieupaparenkorean'] = 0x3213;
	 t['pieupcieuckorean'] = 0x3176;
	 t['pieupcirclekorean'] = 0x3265;
	 t['pieupkiyeokkorean'] = 0x3172;
	 t['pieupkorean'] = 0x3142;
	 t['pieupparenkorean'] = 0x3205;
	 t['pieupsioskiyeokkorean'] = 0x3174;
	 t['pieupsioskorean'] = 0x3144;
	 t['pieupsiostikeutkorean'] = 0x3175;
	 t['pieupthieuthkorean'] = 0x3177;
	 t['pieuptikeutkorean'] = 0x3173;
	 t['pihiragana'] = 0x3074;
	 t['pikatakana'] = 0x30D4;
	 t['pisymbolgreek'] = 0x03D6;
	 t['piwrarmenian'] = 0x0583;
	 t['plus'] = 0x002B;
	 t['plusbelowcmb'] = 0x031F;
	 t['pluscircle'] = 0x2295;
	 t['plusminus'] = 0x00B1;
	 t['plusmod'] = 0x02D6;
	 t['plusmonospace'] = 0xFF0B;
	 t['plussmall'] = 0xFE62;
	 t['plussuperior'] = 0x207A;
	 t['pmonospace'] = 0xFF50;
	 t['pmsquare'] = 0x33D8;
	 t['pohiragana'] = 0x307D;
	 t['pointingindexdownwhite'] = 0x261F;
	 t['pointingindexleftwhite'] = 0x261C;
	 t['pointingindexrightwhite'] = 0x261E;
	 t['pointingindexupwhite'] = 0x261D;
	 t['pokatakana'] = 0x30DD;
	 t['poplathai'] = 0x0E1B;
	 t['postalmark'] = 0x3012;
	 t['postalmarkface'] = 0x3020;
	 t['pparen'] = 0x24AB;
	 t['precedes'] = 0x227A;
	 t['prescription'] = 0x211E;
	 t['primemod'] = 0x02B9;
	 t['primereversed'] = 0x2035;
	 t['product'] = 0x220F;
	 t['projective'] = 0x2305;
	 t['prolongedkana'] = 0x30FC;
	 t['propellor'] = 0x2318;
	 t['propersubset'] = 0x2282;
	 t['propersuperset'] = 0x2283;
	 t['proportion'] = 0x2237;
	 t['proportional'] = 0x221D;
	 t['psi'] = 0x03C8;
	 t['psicyrillic'] = 0x0471;
	 t['psilipneumatacyrilliccmb'] = 0x0486;
	 t['pssquare'] = 0x33B0;
	 t['puhiragana'] = 0x3077;
	 t['pukatakana'] = 0x30D7;
	 t['pvsquare'] = 0x33B4;
	 t['pwsquare'] = 0x33BA;
	 t['q'] = 0x0071;
	 t['qadeva'] = 0x0958;
	 t['qadmahebrew'] = 0x05A8;
	 t['qafarabic'] = 0x0642;
	 t['qaffinalarabic'] = 0xFED6;
	 t['qafinitialarabic'] = 0xFED7;
	 t['qafmedialarabic'] = 0xFED8;
	 t['qamats'] = 0x05B8;
	 t['qamats10'] = 0x05B8;
	 t['qamats1a'] = 0x05B8;
	 t['qamats1c'] = 0x05B8;
	 t['qamats27'] = 0x05B8;
	 t['qamats29'] = 0x05B8;
	 t['qamats33'] = 0x05B8;
	 t['qamatsde'] = 0x05B8;
	 t['qamatshebrew'] = 0x05B8;
	 t['qamatsnarrowhebrew'] = 0x05B8;
	 t['qamatsqatanhebrew'] = 0x05B8;
	 t['qamatsqatannarrowhebrew'] = 0x05B8;
	 t['qamatsqatanquarterhebrew'] = 0x05B8;
	 t['qamatsqatanwidehebrew'] = 0x05B8;
	 t['qamatsquarterhebrew'] = 0x05B8;
	 t['qamatswidehebrew'] = 0x05B8;
	 t['qarneyparahebrew'] = 0x059F;
	 t['qbopomofo'] = 0x3111;
	 t['qcircle'] = 0x24E0;
	 t['qhook'] = 0x02A0;
	 t['qmonospace'] = 0xFF51;
	 t['qof'] = 0x05E7;
	 t['qofdagesh'] = 0xFB47;
	 t['qofdageshhebrew'] = 0xFB47;
	 t['qofhebrew'] = 0x05E7;
	 t['qparen'] = 0x24AC;
	 t['quarternote'] = 0x2669;
	 t['qubuts'] = 0x05BB;
	 t['qubuts18'] = 0x05BB;
	 t['qubuts25'] = 0x05BB;
	 t['qubuts31'] = 0x05BB;
	 t['qubutshebrew'] = 0x05BB;
	 t['qubutsnarrowhebrew'] = 0x05BB;
	 t['qubutsquarterhebrew'] = 0x05BB;
	 t['qubutswidehebrew'] = 0x05BB;
	 t['question'] = 0x003F;
	 t['questionarabic'] = 0x061F;
	 t['questionarmenian'] = 0x055E;
	 t['questiondown'] = 0x00BF;
	 t['questiondownsmall'] = 0xF7BF;
	 t['questiongreek'] = 0x037E;
	 t['questionmonospace'] = 0xFF1F;
	 t['questionsmall'] = 0xF73F;
	 t['quotedbl'] = 0x0022;
	 t['quotedblbase'] = 0x201E;
	 t['quotedblleft'] = 0x201C;
	 t['quotedblmonospace'] = 0xFF02;
	 t['quotedblprime'] = 0x301E;
	 t['quotedblprimereversed'] = 0x301D;
	 t['quotedblright'] = 0x201D;
	 t['quoteleft'] = 0x2018;
	 t['quoteleftreversed'] = 0x201B;
	 t['quotereversed'] = 0x201B;
	 t['quoteright'] = 0x2019;
	 t['quoterightn'] = 0x0149;
	 t['quotesinglbase'] = 0x201A;
	 t['quotesingle'] = 0x0027;
	 t['quotesinglemonospace'] = 0xFF07;
	 t['r'] = 0x0072;
	 t['raarmenian'] = 0x057C;
	 t['rabengali'] = 0x09B0;
	 t['racute'] = 0x0155;
	 t['radeva'] = 0x0930;
	 t['radical'] = 0x221A;
	 t['radicalex'] = 0xF8E5;
	 t['radoverssquare'] = 0x33AE;
	 t['radoverssquaredsquare'] = 0x33AF;
	 t['radsquare'] = 0x33AD;
	 t['rafe'] = 0x05BF;
	 t['rafehebrew'] = 0x05BF;
	 t['ragujarati'] = 0x0AB0;
	 t['ragurmukhi'] = 0x0A30;
	 t['rahiragana'] = 0x3089;
	 t['rakatakana'] = 0x30E9;
	 t['rakatakanahalfwidth'] = 0xFF97;
	 t['ralowerdiagonalbengali'] = 0x09F1;
	 t['ramiddlediagonalbengali'] = 0x09F0;
	 t['ramshorn'] = 0x0264;
	 t['ratio'] = 0x2236;
	 t['rbopomofo'] = 0x3116;
	 t['rcaron'] = 0x0159;
	 t['rcedilla'] = 0x0157;
	 t['rcircle'] = 0x24E1;
	 t['rcommaaccent'] = 0x0157;
	 t['rdblgrave'] = 0x0211;
	 t['rdotaccent'] = 0x1E59;
	 t['rdotbelow'] = 0x1E5B;
	 t['rdotbelowmacron'] = 0x1E5D;
	 t['referencemark'] = 0x203B;
	 t['reflexsubset'] = 0x2286;
	 t['reflexsuperset'] = 0x2287;
	 t['registered'] = 0x00AE;
	 t['registersans'] = 0xF8E8;
	 t['registerserif'] = 0xF6DA;
	 t['reharabic'] = 0x0631;
	 t['reharmenian'] = 0x0580;
	 t['rehfinalarabic'] = 0xFEAE;
	 t['rehiragana'] = 0x308C;
	 t['rekatakana'] = 0x30EC;
	 t['rekatakanahalfwidth'] = 0xFF9A;
	 t['resh'] = 0x05E8;
	 t['reshdageshhebrew'] = 0xFB48;
	 t['reshhebrew'] = 0x05E8;
	 t['reversedtilde'] = 0x223D;
	 t['reviahebrew'] = 0x0597;
	 t['reviamugrashhebrew'] = 0x0597;
	 t['revlogicalnot'] = 0x2310;
	 t['rfishhook'] = 0x027E;
	 t['rfishhookreversed'] = 0x027F;
	 t['rhabengali'] = 0x09DD;
	 t['rhadeva'] = 0x095D;
	 t['rho'] = 0x03C1;
	 t['rhook'] = 0x027D;
	 t['rhookturned'] = 0x027B;
	 t['rhookturnedsuperior'] = 0x02B5;
	 t['rhosymbolgreek'] = 0x03F1;
	 t['rhotichookmod'] = 0x02DE;
	 t['rieulacirclekorean'] = 0x3271;
	 t['rieulaparenkorean'] = 0x3211;
	 t['rieulcirclekorean'] = 0x3263;
	 t['rieulhieuhkorean'] = 0x3140;
	 t['rieulkiyeokkorean'] = 0x313A;
	 t['rieulkiyeoksioskorean'] = 0x3169;
	 t['rieulkorean'] = 0x3139;
	 t['rieulmieumkorean'] = 0x313B;
	 t['rieulpansioskorean'] = 0x316C;
	 t['rieulparenkorean'] = 0x3203;
	 t['rieulphieuphkorean'] = 0x313F;
	 t['rieulpieupkorean'] = 0x313C;
	 t['rieulpieupsioskorean'] = 0x316B;
	 t['rieulsioskorean'] = 0x313D;
	 t['rieulthieuthkorean'] = 0x313E;
	 t['rieultikeutkorean'] = 0x316A;
	 t['rieulyeorinhieuhkorean'] = 0x316D;
	 t['rightangle'] = 0x221F;
	 t['righttackbelowcmb'] = 0x0319;
	 t['righttriangle'] = 0x22BF;
	 t['rihiragana'] = 0x308A;
	 t['rikatakana'] = 0x30EA;
	 t['rikatakanahalfwidth'] = 0xFF98;
	 t['ring'] = 0x02DA;
	 t['ringbelowcmb'] = 0x0325;
	 t['ringcmb'] = 0x030A;
	 t['ringhalfleft'] = 0x02BF;
	 t['ringhalfleftarmenian'] = 0x0559;
	 t['ringhalfleftbelowcmb'] = 0x031C;
	 t['ringhalfleftcentered'] = 0x02D3;
	 t['ringhalfright'] = 0x02BE;
	 t['ringhalfrightbelowcmb'] = 0x0339;
	 t['ringhalfrightcentered'] = 0x02D2;
	 t['rinvertedbreve'] = 0x0213;
	 t['rittorusquare'] = 0x3351;
	 t['rlinebelow'] = 0x1E5F;
	 t['rlongleg'] = 0x027C;
	 t['rlonglegturned'] = 0x027A;
	 t['rmonospace'] = 0xFF52;
	 t['rohiragana'] = 0x308D;
	 t['rokatakana'] = 0x30ED;
	 t['rokatakanahalfwidth'] = 0xFF9B;
	 t['roruathai'] = 0x0E23;
	 t['rparen'] = 0x24AD;
	 t['rrabengali'] = 0x09DC;
	 t['rradeva'] = 0x0931;
	 t['rragurmukhi'] = 0x0A5C;
	 t['rreharabic'] = 0x0691;
	 t['rrehfinalarabic'] = 0xFB8D;
	 t['rrvocalicbengali'] = 0x09E0;
	 t['rrvocalicdeva'] = 0x0960;
	 t['rrvocalicgujarati'] = 0x0AE0;
	 t['rrvocalicvowelsignbengali'] = 0x09C4;
	 t['rrvocalicvowelsigndeva'] = 0x0944;
	 t['rrvocalicvowelsigngujarati'] = 0x0AC4;
	 t['rsuperior'] = 0xF6F1;
	 t['rtblock'] = 0x2590;
	 t['rturned'] = 0x0279;
	 t['rturnedsuperior'] = 0x02B4;
	 t['ruhiragana'] = 0x308B;
	 t['rukatakana'] = 0x30EB;
	 t['rukatakanahalfwidth'] = 0xFF99;
	 t['rupeemarkbengali'] = 0x09F2;
	 t['rupeesignbengali'] = 0x09F3;
	 t['rupiah'] = 0xF6DD;
	 t['ruthai'] = 0x0E24;
	 t['rvocalicbengali'] = 0x098B;
	 t['rvocalicdeva'] = 0x090B;
	 t['rvocalicgujarati'] = 0x0A8B;
	 t['rvocalicvowelsignbengali'] = 0x09C3;
	 t['rvocalicvowelsigndeva'] = 0x0943;
	 t['rvocalicvowelsigngujarati'] = 0x0AC3;
	 t['s'] = 0x0073;
	 t['sabengali'] = 0x09B8;
	 t['sacute'] = 0x015B;
	 t['sacutedotaccent'] = 0x1E65;
	 t['sadarabic'] = 0x0635;
	 t['sadeva'] = 0x0938;
	 t['sadfinalarabic'] = 0xFEBA;
	 t['sadinitialarabic'] = 0xFEBB;
	 t['sadmedialarabic'] = 0xFEBC;
	 t['sagujarati'] = 0x0AB8;
	 t['sagurmukhi'] = 0x0A38;
	 t['sahiragana'] = 0x3055;
	 t['sakatakana'] = 0x30B5;
	 t['sakatakanahalfwidth'] = 0xFF7B;
	 t['sallallahoualayhewasallamarabic'] = 0xFDFA;
	 t['samekh'] = 0x05E1;
	 t['samekhdagesh'] = 0xFB41;
	 t['samekhdageshhebrew'] = 0xFB41;
	 t['samekhhebrew'] = 0x05E1;
	 t['saraaathai'] = 0x0E32;
	 t['saraaethai'] = 0x0E41;
	 t['saraaimaimalaithai'] = 0x0E44;
	 t['saraaimaimuanthai'] = 0x0E43;
	 t['saraamthai'] = 0x0E33;
	 t['saraathai'] = 0x0E30;
	 t['saraethai'] = 0x0E40;
	 t['saraiileftthai'] = 0xF886;
	 t['saraiithai'] = 0x0E35;
	 t['saraileftthai'] = 0xF885;
	 t['saraithai'] = 0x0E34;
	 t['saraothai'] = 0x0E42;
	 t['saraueeleftthai'] = 0xF888;
	 t['saraueethai'] = 0x0E37;
	 t['saraueleftthai'] = 0xF887;
	 t['sarauethai'] = 0x0E36;
	 t['sarauthai'] = 0x0E38;
	 t['sarauuthai'] = 0x0E39;
	 t['sbopomofo'] = 0x3119;
	 t['scaron'] = 0x0161;
	 t['scarondotaccent'] = 0x1E67;
	 t['scedilla'] = 0x015F;
	 t['schwa'] = 0x0259;
	 t['schwacyrillic'] = 0x04D9;
	 t['schwadieresiscyrillic'] = 0x04DB;
	 t['schwahook'] = 0x025A;
	 t['scircle'] = 0x24E2;
	 t['scircumflex'] = 0x015D;
	 t['scommaaccent'] = 0x0219;
	 t['sdotaccent'] = 0x1E61;
	 t['sdotbelow'] = 0x1E63;
	 t['sdotbelowdotaccent'] = 0x1E69;
	 t['seagullbelowcmb'] = 0x033C;
	 t['second'] = 0x2033;
	 t['secondtonechinese'] = 0x02CA;
	 t['section'] = 0x00A7;
	 t['seenarabic'] = 0x0633;
	 t['seenfinalarabic'] = 0xFEB2;
	 t['seeninitialarabic'] = 0xFEB3;
	 t['seenmedialarabic'] = 0xFEB4;
	 t['segol'] = 0x05B6;
	 t['segol13'] = 0x05B6;
	 t['segol1f'] = 0x05B6;
	 t['segol2c'] = 0x05B6;
	 t['segolhebrew'] = 0x05B6;
	 t['segolnarrowhebrew'] = 0x05B6;
	 t['segolquarterhebrew'] = 0x05B6;
	 t['segoltahebrew'] = 0x0592;
	 t['segolwidehebrew'] = 0x05B6;
	 t['seharmenian'] = 0x057D;
	 t['sehiragana'] = 0x305B;
	 t['sekatakana'] = 0x30BB;
	 t['sekatakanahalfwidth'] = 0xFF7E;
	 t['semicolon'] = 0x003B;
	 t['semicolonarabic'] = 0x061B;
	 t['semicolonmonospace'] = 0xFF1B;
	 t['semicolonsmall'] = 0xFE54;
	 t['semivoicedmarkkana'] = 0x309C;
	 t['semivoicedmarkkanahalfwidth'] = 0xFF9F;
	 t['sentisquare'] = 0x3322;
	 t['sentosquare'] = 0x3323;
	 t['seven'] = 0x0037;
	 t['sevenarabic'] = 0x0667;
	 t['sevenbengali'] = 0x09ED;
	 t['sevencircle'] = 0x2466;
	 t['sevencircleinversesansserif'] = 0x2790;
	 t['sevendeva'] = 0x096D;
	 t['seveneighths'] = 0x215E;
	 t['sevengujarati'] = 0x0AED;
	 t['sevengurmukhi'] = 0x0A6D;
	 t['sevenhackarabic'] = 0x0667;
	 t['sevenhangzhou'] = 0x3027;
	 t['sevenideographicparen'] = 0x3226;
	 t['seveninferior'] = 0x2087;
	 t['sevenmonospace'] = 0xFF17;
	 t['sevenoldstyle'] = 0xF737;
	 t['sevenparen'] = 0x247A;
	 t['sevenperiod'] = 0x248E;
	 t['sevenpersian'] = 0x06F7;
	 t['sevenroman'] = 0x2176;
	 t['sevensuperior'] = 0x2077;
	 t['seventeencircle'] = 0x2470;
	 t['seventeenparen'] = 0x2484;
	 t['seventeenperiod'] = 0x2498;
	 t['seventhai'] = 0x0E57;
	 t['sfthyphen'] = 0x00AD;
	 t['shaarmenian'] = 0x0577;
	 t['shabengali'] = 0x09B6;
	 t['shacyrillic'] = 0x0448;
	 t['shaddaarabic'] = 0x0651;
	 t['shaddadammaarabic'] = 0xFC61;
	 t['shaddadammatanarabic'] = 0xFC5E;
	 t['shaddafathaarabic'] = 0xFC60;
	 t['shaddakasraarabic'] = 0xFC62;
	 t['shaddakasratanarabic'] = 0xFC5F;
	 t['shade'] = 0x2592;
	 t['shadedark'] = 0x2593;
	 t['shadelight'] = 0x2591;
	 t['shademedium'] = 0x2592;
	 t['shadeva'] = 0x0936;
	 t['shagujarati'] = 0x0AB6;
	 t['shagurmukhi'] = 0x0A36;
	 t['shalshelethebrew'] = 0x0593;
	 t['shbopomofo'] = 0x3115;
	 t['shchacyrillic'] = 0x0449;
	 t['sheenarabic'] = 0x0634;
	 t['sheenfinalarabic'] = 0xFEB6;
	 t['sheeninitialarabic'] = 0xFEB7;
	 t['sheenmedialarabic'] = 0xFEB8;
	 t['sheicoptic'] = 0x03E3;
	 t['sheqel'] = 0x20AA;
	 t['sheqelhebrew'] = 0x20AA;
	 t['sheva'] = 0x05B0;
	 t['sheva115'] = 0x05B0;
	 t['sheva15'] = 0x05B0;
	 t['sheva22'] = 0x05B0;
	 t['sheva2e'] = 0x05B0;
	 t['shevahebrew'] = 0x05B0;
	 t['shevanarrowhebrew'] = 0x05B0;
	 t['shevaquarterhebrew'] = 0x05B0;
	 t['shevawidehebrew'] = 0x05B0;
	 t['shhacyrillic'] = 0x04BB;
	 t['shimacoptic'] = 0x03ED;
	 t['shin'] = 0x05E9;
	 t['shindagesh'] = 0xFB49;
	 t['shindageshhebrew'] = 0xFB49;
	 t['shindageshshindot'] = 0xFB2C;
	 t['shindageshshindothebrew'] = 0xFB2C;
	 t['shindageshsindot'] = 0xFB2D;
	 t['shindageshsindothebrew'] = 0xFB2D;
	 t['shindothebrew'] = 0x05C1;
	 t['shinhebrew'] = 0x05E9;
	 t['shinshindot'] = 0xFB2A;
	 t['shinshindothebrew'] = 0xFB2A;
	 t['shinsindot'] = 0xFB2B;
	 t['shinsindothebrew'] = 0xFB2B;
	 t['shook'] = 0x0282;
	 t['sigma'] = 0x03C3;
	 t['sigma1'] = 0x03C2;
	 t['sigmafinal'] = 0x03C2;
	 t['sigmalunatesymbolgreek'] = 0x03F2;
	 t['sihiragana'] = 0x3057;
	 t['sikatakana'] = 0x30B7;
	 t['sikatakanahalfwidth'] = 0xFF7C;
	 t['siluqhebrew'] = 0x05BD;
	 t['siluqlefthebrew'] = 0x05BD;
	 t['similar'] = 0x223C;
	 t['sindothebrew'] = 0x05C2;
	 t['siosacirclekorean'] = 0x3274;
	 t['siosaparenkorean'] = 0x3214;
	 t['sioscieuckorean'] = 0x317E;
	 t['sioscirclekorean'] = 0x3266;
	 t['sioskiyeokkorean'] = 0x317A;
	 t['sioskorean'] = 0x3145;
	 t['siosnieunkorean'] = 0x317B;
	 t['siosparenkorean'] = 0x3206;
	 t['siospieupkorean'] = 0x317D;
	 t['siostikeutkorean'] = 0x317C;
	 t['six'] = 0x0036;
	 t['sixarabic'] = 0x0666;
	 t['sixbengali'] = 0x09EC;
	 t['sixcircle'] = 0x2465;
	 t['sixcircleinversesansserif'] = 0x278F;
	 t['sixdeva'] = 0x096C;
	 t['sixgujarati'] = 0x0AEC;
	 t['sixgurmukhi'] = 0x0A6C;
	 t['sixhackarabic'] = 0x0666;
	 t['sixhangzhou'] = 0x3026;
	 t['sixideographicparen'] = 0x3225;
	 t['sixinferior'] = 0x2086;
	 t['sixmonospace'] = 0xFF16;
	 t['sixoldstyle'] = 0xF736;
	 t['sixparen'] = 0x2479;
	 t['sixperiod'] = 0x248D;
	 t['sixpersian'] = 0x06F6;
	 t['sixroman'] = 0x2175;
	 t['sixsuperior'] = 0x2076;
	 t['sixteencircle'] = 0x246F;
	 t['sixteencurrencydenominatorbengali'] = 0x09F9;
	 t['sixteenparen'] = 0x2483;
	 t['sixteenperiod'] = 0x2497;
	 t['sixthai'] = 0x0E56;
	 t['slash'] = 0x002F;
	 t['slashmonospace'] = 0xFF0F;
	 t['slong'] = 0x017F;
	 t['slongdotaccent'] = 0x1E9B;
	 t['smileface'] = 0x263A;
	 t['smonospace'] = 0xFF53;
	 t['sofpasuqhebrew'] = 0x05C3;
	 t['softhyphen'] = 0x00AD;
	 t['softsigncyrillic'] = 0x044C;
	 t['sohiragana'] = 0x305D;
	 t['sokatakana'] = 0x30BD;
	 t['sokatakanahalfwidth'] = 0xFF7F;
	 t['soliduslongoverlaycmb'] = 0x0338;
	 t['solidusshortoverlaycmb'] = 0x0337;
	 t['sorusithai'] = 0x0E29;
	 t['sosalathai'] = 0x0E28;
	 t['sosothai'] = 0x0E0B;
	 t['sosuathai'] = 0x0E2A;
	 t['space'] = 0x0020;
	 t['spacehackarabic'] = 0x0020;
	 t['spade'] = 0x2660;
	 t['spadesuitblack'] = 0x2660;
	 t['spadesuitwhite'] = 0x2664;
	 t['sparen'] = 0x24AE;
	 t['squarebelowcmb'] = 0x033B;
	 t['squarecc'] = 0x33C4;
	 t['squarecm'] = 0x339D;
	 t['squarediagonalcrosshatchfill'] = 0x25A9;
	 t['squarehorizontalfill'] = 0x25A4;
	 t['squarekg'] = 0x338F;
	 t['squarekm'] = 0x339E;
	 t['squarekmcapital'] = 0x33CE;
	 t['squareln'] = 0x33D1;
	 t['squarelog'] = 0x33D2;
	 t['squaremg'] = 0x338E;
	 t['squaremil'] = 0x33D5;
	 t['squaremm'] = 0x339C;
	 t['squaremsquared'] = 0x33A1;
	 t['squareorthogonalcrosshatchfill'] = 0x25A6;
	 t['squareupperlefttolowerrightfill'] = 0x25A7;
	 t['squareupperrighttolowerleftfill'] = 0x25A8;
	 t['squareverticalfill'] = 0x25A5;
	 t['squarewhitewithsmallblack'] = 0x25A3;
	 t['srsquare'] = 0x33DB;
	 t['ssabengali'] = 0x09B7;
	 t['ssadeva'] = 0x0937;
	 t['ssagujarati'] = 0x0AB7;
	 t['ssangcieuckorean'] = 0x3149;
	 t['ssanghieuhkorean'] = 0x3185;
	 t['ssangieungkorean'] = 0x3180;
	 t['ssangkiyeokkorean'] = 0x3132;
	 t['ssangnieunkorean'] = 0x3165;
	 t['ssangpieupkorean'] = 0x3143;
	 t['ssangsioskorean'] = 0x3146;
	 t['ssangtikeutkorean'] = 0x3138;
	 t['ssuperior'] = 0xF6F2;
	 t['sterling'] = 0x00A3;
	 t['sterlingmonospace'] = 0xFFE1;
	 t['strokelongoverlaycmb'] = 0x0336;
	 t['strokeshortoverlaycmb'] = 0x0335;
	 t['subset'] = 0x2282;
	 t['subsetnotequal'] = 0x228A;
	 t['subsetorequal'] = 0x2286;
	 t['succeeds'] = 0x227B;
	 t['suchthat'] = 0x220B;
	 t['suhiragana'] = 0x3059;
	 t['sukatakana'] = 0x30B9;
	 t['sukatakanahalfwidth'] = 0xFF7D;
	 t['sukunarabic'] = 0x0652;
	 t['summation'] = 0x2211;
	 t['sun'] = 0x263C;
	 t['superset'] = 0x2283;
	 t['supersetnotequal'] = 0x228B;
	 t['supersetorequal'] = 0x2287;
	 t['svsquare'] = 0x33DC;
	 t['syouwaerasquare'] = 0x337C;
	 t['t'] = 0x0074;
	 t['tabengali'] = 0x09A4;
	 t['tackdown'] = 0x22A4;
	 t['tackleft'] = 0x22A3;
	 t['tadeva'] = 0x0924;
	 t['tagujarati'] = 0x0AA4;
	 t['tagurmukhi'] = 0x0A24;
	 t['taharabic'] = 0x0637;
	 t['tahfinalarabic'] = 0xFEC2;
	 t['tahinitialarabic'] = 0xFEC3;
	 t['tahiragana'] = 0x305F;
	 t['tahmedialarabic'] = 0xFEC4;
	 t['taisyouerasquare'] = 0x337D;
	 t['takatakana'] = 0x30BF;
	 t['takatakanahalfwidth'] = 0xFF80;
	 t['tatweelarabic'] = 0x0640;
	 t['tau'] = 0x03C4;
	 t['tav'] = 0x05EA;
	 t['tavdages'] = 0xFB4A;
	 t['tavdagesh'] = 0xFB4A;
	 t['tavdageshhebrew'] = 0xFB4A;
	 t['tavhebrew'] = 0x05EA;
	 t['tbar'] = 0x0167;
	 t['tbopomofo'] = 0x310A;
	 t['tcaron'] = 0x0165;
	 t['tccurl'] = 0x02A8;
	 t['tcedilla'] = 0x0163;
	 t['tcheharabic'] = 0x0686;
	 t['tchehfinalarabic'] = 0xFB7B;
	 t['tchehinitialarabic'] = 0xFB7C;
	 t['tchehmedialarabic'] = 0xFB7D;
	 t['tcircle'] = 0x24E3;
	 t['tcircumflexbelow'] = 0x1E71;
	 t['tcommaaccent'] = 0x0163;
	 t['tdieresis'] = 0x1E97;
	 t['tdotaccent'] = 0x1E6B;
	 t['tdotbelow'] = 0x1E6D;
	 t['tecyrillic'] = 0x0442;
	 t['tedescendercyrillic'] = 0x04AD;
	 t['teharabic'] = 0x062A;
	 t['tehfinalarabic'] = 0xFE96;
	 t['tehhahinitialarabic'] = 0xFCA2;
	 t['tehhahisolatedarabic'] = 0xFC0C;
	 t['tehinitialarabic'] = 0xFE97;
	 t['tehiragana'] = 0x3066;
	 t['tehjeeminitialarabic'] = 0xFCA1;
	 t['tehjeemisolatedarabic'] = 0xFC0B;
	 t['tehmarbutaarabic'] = 0x0629;
	 t['tehmarbutafinalarabic'] = 0xFE94;
	 t['tehmedialarabic'] = 0xFE98;
	 t['tehmeeminitialarabic'] = 0xFCA4;
	 t['tehmeemisolatedarabic'] = 0xFC0E;
	 t['tehnoonfinalarabic'] = 0xFC73;
	 t['tekatakana'] = 0x30C6;
	 t['tekatakanahalfwidth'] = 0xFF83;
	 t['telephone'] = 0x2121;
	 t['telephoneblack'] = 0x260E;
	 t['telishagedolahebrew'] = 0x05A0;
	 t['telishaqetanahebrew'] = 0x05A9;
	 t['tencircle'] = 0x2469;
	 t['tenideographicparen'] = 0x3229;
	 t['tenparen'] = 0x247D;
	 t['tenperiod'] = 0x2491;
	 t['tenroman'] = 0x2179;
	 t['tesh'] = 0x02A7;
	 t['tet'] = 0x05D8;
	 t['tetdagesh'] = 0xFB38;
	 t['tetdageshhebrew'] = 0xFB38;
	 t['tethebrew'] = 0x05D8;
	 t['tetsecyrillic'] = 0x04B5;
	 t['tevirhebrew'] = 0x059B;
	 t['tevirlefthebrew'] = 0x059B;
	 t['thabengali'] = 0x09A5;
	 t['thadeva'] = 0x0925;
	 t['thagujarati'] = 0x0AA5;
	 t['thagurmukhi'] = 0x0A25;
	 t['thalarabic'] = 0x0630;
	 t['thalfinalarabic'] = 0xFEAC;
	 t['thanthakhatlowleftthai'] = 0xF898;
	 t['thanthakhatlowrightthai'] = 0xF897;
	 t['thanthakhatthai'] = 0x0E4C;
	 t['thanthakhatupperleftthai'] = 0xF896;
	 t['theharabic'] = 0x062B;
	 t['thehfinalarabic'] = 0xFE9A;
	 t['thehinitialarabic'] = 0xFE9B;
	 t['thehmedialarabic'] = 0xFE9C;
	 t['thereexists'] = 0x2203;
	 t['therefore'] = 0x2234;
	 t['theta'] = 0x03B8;
	 t['theta1'] = 0x03D1;
	 t['thetasymbolgreek'] = 0x03D1;
	 t['thieuthacirclekorean'] = 0x3279;
	 t['thieuthaparenkorean'] = 0x3219;
	 t['thieuthcirclekorean'] = 0x326B;
	 t['thieuthkorean'] = 0x314C;
	 t['thieuthparenkorean'] = 0x320B;
	 t['thirteencircle'] = 0x246C;
	 t['thirteenparen'] = 0x2480;
	 t['thirteenperiod'] = 0x2494;
	 t['thonangmonthothai'] = 0x0E11;
	 t['thook'] = 0x01AD;
	 t['thophuthaothai'] = 0x0E12;
	 t['thorn'] = 0x00FE;
	 t['thothahanthai'] = 0x0E17;
	 t['thothanthai'] = 0x0E10;
	 t['thothongthai'] = 0x0E18;
	 t['thothungthai'] = 0x0E16;
	 t['thousandcyrillic'] = 0x0482;
	 t['thousandsseparatorarabic'] = 0x066C;
	 t['thousandsseparatorpersian'] = 0x066C;
	 t['three'] = 0x0033;
	 t['threearabic'] = 0x0663;
	 t['threebengali'] = 0x09E9;
	 t['threecircle'] = 0x2462;
	 t['threecircleinversesansserif'] = 0x278C;
	 t['threedeva'] = 0x0969;
	 t['threeeighths'] = 0x215C;
	 t['threegujarati'] = 0x0AE9;
	 t['threegurmukhi'] = 0x0A69;
	 t['threehackarabic'] = 0x0663;
	 t['threehangzhou'] = 0x3023;
	 t['threeideographicparen'] = 0x3222;
	 t['threeinferior'] = 0x2083;
	 t['threemonospace'] = 0xFF13;
	 t['threenumeratorbengali'] = 0x09F6;
	 t['threeoldstyle'] = 0xF733;
	 t['threeparen'] = 0x2476;
	 t['threeperiod'] = 0x248A;
	 t['threepersian'] = 0x06F3;
	 t['threequarters'] = 0x00BE;
	 t['threequartersemdash'] = 0xF6DE;
	 t['threeroman'] = 0x2172;
	 t['threesuperior'] = 0x00B3;
	 t['threethai'] = 0x0E53;
	 t['thzsquare'] = 0x3394;
	 t['tihiragana'] = 0x3061;
	 t['tikatakana'] = 0x30C1;
	 t['tikatakanahalfwidth'] = 0xFF81;
	 t['tikeutacirclekorean'] = 0x3270;
	 t['tikeutaparenkorean'] = 0x3210;
	 t['tikeutcirclekorean'] = 0x3262;
	 t['tikeutkorean'] = 0x3137;
	 t['tikeutparenkorean'] = 0x3202;
	 t['tilde'] = 0x02DC;
	 t['tildebelowcmb'] = 0x0330;
	 t['tildecmb'] = 0x0303;
	 t['tildecomb'] = 0x0303;
	 t['tildedoublecmb'] = 0x0360;
	 t['tildeoperator'] = 0x223C;
	 t['tildeoverlaycmb'] = 0x0334;
	 t['tildeverticalcmb'] = 0x033E;
	 t['timescircle'] = 0x2297;
	 t['tipehahebrew'] = 0x0596;
	 t['tipehalefthebrew'] = 0x0596;
	 t['tippigurmukhi'] = 0x0A70;
	 t['titlocyrilliccmb'] = 0x0483;
	 t['tiwnarmenian'] = 0x057F;
	 t['tlinebelow'] = 0x1E6F;
	 t['tmonospace'] = 0xFF54;
	 t['toarmenian'] = 0x0569;
	 t['tohiragana'] = 0x3068;
	 t['tokatakana'] = 0x30C8;
	 t['tokatakanahalfwidth'] = 0xFF84;
	 t['tonebarextrahighmod'] = 0x02E5;
	 t['tonebarextralowmod'] = 0x02E9;
	 t['tonebarhighmod'] = 0x02E6;
	 t['tonebarlowmod'] = 0x02E8;
	 t['tonebarmidmod'] = 0x02E7;
	 t['tonefive'] = 0x01BD;
	 t['tonesix'] = 0x0185;
	 t['tonetwo'] = 0x01A8;
	 t['tonos'] = 0x0384;
	 t['tonsquare'] = 0x3327;
	 t['topatakthai'] = 0x0E0F;
	 t['tortoiseshellbracketleft'] = 0x3014;
	 t['tortoiseshellbracketleftsmall'] = 0xFE5D;
	 t['tortoiseshellbracketleftvertical'] = 0xFE39;
	 t['tortoiseshellbracketright'] = 0x3015;
	 t['tortoiseshellbracketrightsmall'] = 0xFE5E;
	 t['tortoiseshellbracketrightvertical'] = 0xFE3A;
	 t['totaothai'] = 0x0E15;
	 t['tpalatalhook'] = 0x01AB;
	 t['tparen'] = 0x24AF;
	 t['trademark'] = 0x2122;
	 t['trademarksans'] = 0xF8EA;
	 t['trademarkserif'] = 0xF6DB;
	 t['tretroflexhook'] = 0x0288;
	 t['triagdn'] = 0x25BC;
	 t['triaglf'] = 0x25C4;
	 t['triagrt'] = 0x25BA;
	 t['triagup'] = 0x25B2;
	 t['ts'] = 0x02A6;
	 t['tsadi'] = 0x05E6;
	 t['tsadidagesh'] = 0xFB46;
	 t['tsadidageshhebrew'] = 0xFB46;
	 t['tsadihebrew'] = 0x05E6;
	 t['tsecyrillic'] = 0x0446;
	 t['tsere'] = 0x05B5;
	 t['tsere12'] = 0x05B5;
	 t['tsere1e'] = 0x05B5;
	 t['tsere2b'] = 0x05B5;
	 t['tserehebrew'] = 0x05B5;
	 t['tserenarrowhebrew'] = 0x05B5;
	 t['tserequarterhebrew'] = 0x05B5;
	 t['tserewidehebrew'] = 0x05B5;
	 t['tshecyrillic'] = 0x045B;
	 t['tsuperior'] = 0xF6F3;
	 t['ttabengali'] = 0x099F;
	 t['ttadeva'] = 0x091F;
	 t['ttagujarati'] = 0x0A9F;
	 t['ttagurmukhi'] = 0x0A1F;
	 t['tteharabic'] = 0x0679;
	 t['ttehfinalarabic'] = 0xFB67;
	 t['ttehinitialarabic'] = 0xFB68;
	 t['ttehmedialarabic'] = 0xFB69;
	 t['tthabengali'] = 0x09A0;
	 t['tthadeva'] = 0x0920;
	 t['tthagujarati'] = 0x0AA0;
	 t['tthagurmukhi'] = 0x0A20;
	 t['tturned'] = 0x0287;
	 t['tuhiragana'] = 0x3064;
	 t['tukatakana'] = 0x30C4;
	 t['tukatakanahalfwidth'] = 0xFF82;
	 t['tusmallhiragana'] = 0x3063;
	 t['tusmallkatakana'] = 0x30C3;
	 t['tusmallkatakanahalfwidth'] = 0xFF6F;
	 t['twelvecircle'] = 0x246B;
	 t['twelveparen'] = 0x247F;
	 t['twelveperiod'] = 0x2493;
	 t['twelveroman'] = 0x217B;
	 t['twentycircle'] = 0x2473;
	 t['twentyhangzhou'] = 0x5344;
	 t['twentyparen'] = 0x2487;
	 t['twentyperiod'] = 0x249B;
	 t['two'] = 0x0032;
	 t['twoarabic'] = 0x0662;
	 t['twobengali'] = 0x09E8;
	 t['twocircle'] = 0x2461;
	 t['twocircleinversesansserif'] = 0x278B;
	 t['twodeva'] = 0x0968;
	 t['twodotenleader'] = 0x2025;
	 t['twodotleader'] = 0x2025;
	 t['twodotleadervertical'] = 0xFE30;
	 t['twogujarati'] = 0x0AE8;
	 t['twogurmukhi'] = 0x0A68;
	 t['twohackarabic'] = 0x0662;
	 t['twohangzhou'] = 0x3022;
	 t['twoideographicparen'] = 0x3221;
	 t['twoinferior'] = 0x2082;
	 t['twomonospace'] = 0xFF12;
	 t['twonumeratorbengali'] = 0x09F5;
	 t['twooldstyle'] = 0xF732;
	 t['twoparen'] = 0x2475;
	 t['twoperiod'] = 0x2489;
	 t['twopersian'] = 0x06F2;
	 t['tworoman'] = 0x2171;
	 t['twostroke'] = 0x01BB;
	 t['twosuperior'] = 0x00B2;
	 t['twothai'] = 0x0E52;
	 t['twothirds'] = 0x2154;
	 t['u'] = 0x0075;
	 t['uacute'] = 0x00FA;
	 t['ubar'] = 0x0289;
	 t['ubengali'] = 0x0989;
	 t['ubopomofo'] = 0x3128;
	 t['ubreve'] = 0x016D;
	 t['ucaron'] = 0x01D4;
	 t['ucircle'] = 0x24E4;
	 t['ucircumflex'] = 0x00FB;
	 t['ucircumflexbelow'] = 0x1E77;
	 t['ucyrillic'] = 0x0443;
	 t['udattadeva'] = 0x0951;
	 t['udblacute'] = 0x0171;
	 t['udblgrave'] = 0x0215;
	 t['udeva'] = 0x0909;
	 t['udieresis'] = 0x00FC;
	 t['udieresisacute'] = 0x01D8;
	 t['udieresisbelow'] = 0x1E73;
	 t['udieresiscaron'] = 0x01DA;
	 t['udieresiscyrillic'] = 0x04F1;
	 t['udieresisgrave'] = 0x01DC;
	 t['udieresismacron'] = 0x01D6;
	 t['udotbelow'] = 0x1EE5;
	 t['ugrave'] = 0x00F9;
	 t['ugujarati'] = 0x0A89;
	 t['ugurmukhi'] = 0x0A09;
	 t['uhiragana'] = 0x3046;
	 t['uhookabove'] = 0x1EE7;
	 t['uhorn'] = 0x01B0;
	 t['uhornacute'] = 0x1EE9;
	 t['uhorndotbelow'] = 0x1EF1;
	 t['uhorngrave'] = 0x1EEB;
	 t['uhornhookabove'] = 0x1EED;
	 t['uhorntilde'] = 0x1EEF;
	 t['uhungarumlaut'] = 0x0171;
	 t['uhungarumlautcyrillic'] = 0x04F3;
	 t['uinvertedbreve'] = 0x0217;
	 t['ukatakana'] = 0x30A6;
	 t['ukatakanahalfwidth'] = 0xFF73;
	 t['ukcyrillic'] = 0x0479;
	 t['ukorean'] = 0x315C;
	 t['umacron'] = 0x016B;
	 t['umacroncyrillic'] = 0x04EF;
	 t['umacrondieresis'] = 0x1E7B;
	 t['umatragurmukhi'] = 0x0A41;
	 t['umonospace'] = 0xFF55;
	 t['underscore'] = 0x005F;
	 t['underscoredbl'] = 0x2017;
	 t['underscoremonospace'] = 0xFF3F;
	 t['underscorevertical'] = 0xFE33;
	 t['underscorewavy'] = 0xFE4F;
	 t['union'] = 0x222A;
	 t['universal'] = 0x2200;
	 t['uogonek'] = 0x0173;
	 t['uparen'] = 0x24B0;
	 t['upblock'] = 0x2580;
	 t['upperdothebrew'] = 0x05C4;
	 t['upsilon'] = 0x03C5;
	 t['upsilondieresis'] = 0x03CB;
	 t['upsilondieresistonos'] = 0x03B0;
	 t['upsilonlatin'] = 0x028A;
	 t['upsilontonos'] = 0x03CD;
	 t['uptackbelowcmb'] = 0x031D;
	 t['uptackmod'] = 0x02D4;
	 t['uragurmukhi'] = 0x0A73;
	 t['uring'] = 0x016F;
	 t['ushortcyrillic'] = 0x045E;
	 t['usmallhiragana'] = 0x3045;
	 t['usmallkatakana'] = 0x30A5;
	 t['usmallkatakanahalfwidth'] = 0xFF69;
	 t['ustraightcyrillic'] = 0x04AF;
	 t['ustraightstrokecyrillic'] = 0x04B1;
	 t['utilde'] = 0x0169;
	 t['utildeacute'] = 0x1E79;
	 t['utildebelow'] = 0x1E75;
	 t['uubengali'] = 0x098A;
	 t['uudeva'] = 0x090A;
	 t['uugujarati'] = 0x0A8A;
	 t['uugurmukhi'] = 0x0A0A;
	 t['uumatragurmukhi'] = 0x0A42;
	 t['uuvowelsignbengali'] = 0x09C2;
	 t['uuvowelsigndeva'] = 0x0942;
	 t['uuvowelsigngujarati'] = 0x0AC2;
	 t['uvowelsignbengali'] = 0x09C1;
	 t['uvowelsigndeva'] = 0x0941;
	 t['uvowelsigngujarati'] = 0x0AC1;
	 t['v'] = 0x0076;
	 t['vadeva'] = 0x0935;
	 t['vagujarati'] = 0x0AB5;
	 t['vagurmukhi'] = 0x0A35;
	 t['vakatakana'] = 0x30F7;
	 t['vav'] = 0x05D5;
	 t['vavdagesh'] = 0xFB35;
	 t['vavdagesh65'] = 0xFB35;
	 t['vavdageshhebrew'] = 0xFB35;
	 t['vavhebrew'] = 0x05D5;
	 t['vavholam'] = 0xFB4B;
	 t['vavholamhebrew'] = 0xFB4B;
	 t['vavvavhebrew'] = 0x05F0;
	 t['vavyodhebrew'] = 0x05F1;
	 t['vcircle'] = 0x24E5;
	 t['vdotbelow'] = 0x1E7F;
	 t['vecyrillic'] = 0x0432;
	 t['veharabic'] = 0x06A4;
	 t['vehfinalarabic'] = 0xFB6B;
	 t['vehinitialarabic'] = 0xFB6C;
	 t['vehmedialarabic'] = 0xFB6D;
	 t['vekatakana'] = 0x30F9;
	 t['venus'] = 0x2640;
	 t['verticalbar'] = 0x007C;
	 t['verticallineabovecmb'] = 0x030D;
	 t['verticallinebelowcmb'] = 0x0329;
	 t['verticallinelowmod'] = 0x02CC;
	 t['verticallinemod'] = 0x02C8;
	 t['vewarmenian'] = 0x057E;
	 t['vhook'] = 0x028B;
	 t['vikatakana'] = 0x30F8;
	 t['viramabengali'] = 0x09CD;
	 t['viramadeva'] = 0x094D;
	 t['viramagujarati'] = 0x0ACD;
	 t['visargabengali'] = 0x0983;
	 t['visargadeva'] = 0x0903;
	 t['visargagujarati'] = 0x0A83;
	 t['vmonospace'] = 0xFF56;
	 t['voarmenian'] = 0x0578;
	 t['voicediterationhiragana'] = 0x309E;
	 t['voicediterationkatakana'] = 0x30FE;
	 t['voicedmarkkana'] = 0x309B;
	 t['voicedmarkkanahalfwidth'] = 0xFF9E;
	 t['vokatakana'] = 0x30FA;
	 t['vparen'] = 0x24B1;
	 t['vtilde'] = 0x1E7D;
	 t['vturned'] = 0x028C;
	 t['vuhiragana'] = 0x3094;
	 t['vukatakana'] = 0x30F4;
	 t['w'] = 0x0077;
	 t['wacute'] = 0x1E83;
	 t['waekorean'] = 0x3159;
	 t['wahiragana'] = 0x308F;
	 t['wakatakana'] = 0x30EF;
	 t['wakatakanahalfwidth'] = 0xFF9C;
	 t['wakorean'] = 0x3158;
	 t['wasmallhiragana'] = 0x308E;
	 t['wasmallkatakana'] = 0x30EE;
	 t['wattosquare'] = 0x3357;
	 t['wavedash'] = 0x301C;
	 t['wavyunderscorevertical'] = 0xFE34;
	 t['wawarabic'] = 0x0648;
	 t['wawfinalarabic'] = 0xFEEE;
	 t['wawhamzaabovearabic'] = 0x0624;
	 t['wawhamzaabovefinalarabic'] = 0xFE86;
	 t['wbsquare'] = 0x33DD;
	 t['wcircle'] = 0x24E6;
	 t['wcircumflex'] = 0x0175;
	 t['wdieresis'] = 0x1E85;
	 t['wdotaccent'] = 0x1E87;
	 t['wdotbelow'] = 0x1E89;
	 t['wehiragana'] = 0x3091;
	 t['weierstrass'] = 0x2118;
	 t['wekatakana'] = 0x30F1;
	 t['wekorean'] = 0x315E;
	 t['weokorean'] = 0x315D;
	 t['wgrave'] = 0x1E81;
	 t['whitebullet'] = 0x25E6;
	 t['whitecircle'] = 0x25CB;
	 t['whitecircleinverse'] = 0x25D9;
	 t['whitecornerbracketleft'] = 0x300E;
	 t['whitecornerbracketleftvertical'] = 0xFE43;
	 t['whitecornerbracketright'] = 0x300F;
	 t['whitecornerbracketrightvertical'] = 0xFE44;
	 t['whitediamond'] = 0x25C7;
	 t['whitediamondcontainingblacksmalldiamond'] = 0x25C8;
	 t['whitedownpointingsmalltriangle'] = 0x25BF;
	 t['whitedownpointingtriangle'] = 0x25BD;
	 t['whiteleftpointingsmalltriangle'] = 0x25C3;
	 t['whiteleftpointingtriangle'] = 0x25C1;
	 t['whitelenticularbracketleft'] = 0x3016;
	 t['whitelenticularbracketright'] = 0x3017;
	 t['whiterightpointingsmalltriangle'] = 0x25B9;
	 t['whiterightpointingtriangle'] = 0x25B7;
	 t['whitesmallsquare'] = 0x25AB;
	 t['whitesmilingface'] = 0x263A;
	 t['whitesquare'] = 0x25A1;
	 t['whitestar'] = 0x2606;
	 t['whitetelephone'] = 0x260F;
	 t['whitetortoiseshellbracketleft'] = 0x3018;
	 t['whitetortoiseshellbracketright'] = 0x3019;
	 t['whiteuppointingsmalltriangle'] = 0x25B5;
	 t['whiteuppointingtriangle'] = 0x25B3;
	 t['wihiragana'] = 0x3090;
	 t['wikatakana'] = 0x30F0;
	 t['wikorean'] = 0x315F;
	 t['wmonospace'] = 0xFF57;
	 t['wohiragana'] = 0x3092;
	 t['wokatakana'] = 0x30F2;
	 t['wokatakanahalfwidth'] = 0xFF66;
	 t['won'] = 0x20A9;
	 t['wonmonospace'] = 0xFFE6;
	 t['wowaenthai'] = 0x0E27;
	 t['wparen'] = 0x24B2;
	 t['wring'] = 0x1E98;
	 t['wsuperior'] = 0x02B7;
	 t['wturned'] = 0x028D;
	 t['wynn'] = 0x01BF;
	 t['x'] = 0x0078;
	 t['xabovecmb'] = 0x033D;
	 t['xbopomofo'] = 0x3112;
	 t['xcircle'] = 0x24E7;
	 t['xdieresis'] = 0x1E8D;
	 t['xdotaccent'] = 0x1E8B;
	 t['xeharmenian'] = 0x056D;
	 t['xi'] = 0x03BE;
	 t['xmonospace'] = 0xFF58;
	 t['xparen'] = 0x24B3;
	 t['xsuperior'] = 0x02E3;
	 t['y'] = 0x0079;
	 t['yaadosquare'] = 0x334E;
	 t['yabengali'] = 0x09AF;
	 t['yacute'] = 0x00FD;
	 t['yadeva'] = 0x092F;
	 t['yaekorean'] = 0x3152;
	 t['yagujarati'] = 0x0AAF;
	 t['yagurmukhi'] = 0x0A2F;
	 t['yahiragana'] = 0x3084;
	 t['yakatakana'] = 0x30E4;
	 t['yakatakanahalfwidth'] = 0xFF94;
	 t['yakorean'] = 0x3151;
	 t['yamakkanthai'] = 0x0E4E;
	 t['yasmallhiragana'] = 0x3083;
	 t['yasmallkatakana'] = 0x30E3;
	 t['yasmallkatakanahalfwidth'] = 0xFF6C;
	 t['yatcyrillic'] = 0x0463;
	 t['ycircle'] = 0x24E8;
	 t['ycircumflex'] = 0x0177;
	 t['ydieresis'] = 0x00FF;
	 t['ydotaccent'] = 0x1E8F;
	 t['ydotbelow'] = 0x1EF5;
	 t['yeharabic'] = 0x064A;
	 t['yehbarreearabic'] = 0x06D2;
	 t['yehbarreefinalarabic'] = 0xFBAF;
	 t['yehfinalarabic'] = 0xFEF2;
	 t['yehhamzaabovearabic'] = 0x0626;
	 t['yehhamzaabovefinalarabic'] = 0xFE8A;
	 t['yehhamzaaboveinitialarabic'] = 0xFE8B;
	 t['yehhamzaabovemedialarabic'] = 0xFE8C;
	 t['yehinitialarabic'] = 0xFEF3;
	 t['yehmedialarabic'] = 0xFEF4;
	 t['yehmeeminitialarabic'] = 0xFCDD;
	 t['yehmeemisolatedarabic'] = 0xFC58;
	 t['yehnoonfinalarabic'] = 0xFC94;
	 t['yehthreedotsbelowarabic'] = 0x06D1;
	 t['yekorean'] = 0x3156;
	 t['yen'] = 0x00A5;
	 t['yenmonospace'] = 0xFFE5;
	 t['yeokorean'] = 0x3155;
	 t['yeorinhieuhkorean'] = 0x3186;
	 t['yerahbenyomohebrew'] = 0x05AA;
	 t['yerahbenyomolefthebrew'] = 0x05AA;
	 t['yericyrillic'] = 0x044B;
	 t['yerudieresiscyrillic'] = 0x04F9;
	 t['yesieungkorean'] = 0x3181;
	 t['yesieungpansioskorean'] = 0x3183;
	 t['yesieungsioskorean'] = 0x3182;
	 t['yetivhebrew'] = 0x059A;
	 t['ygrave'] = 0x1EF3;
	 t['yhook'] = 0x01B4;
	 t['yhookabove'] = 0x1EF7;
	 t['yiarmenian'] = 0x0575;
	 t['yicyrillic'] = 0x0457;
	 t['yikorean'] = 0x3162;
	 t['yinyang'] = 0x262F;
	 t['yiwnarmenian'] = 0x0582;
	 t['ymonospace'] = 0xFF59;
	 t['yod'] = 0x05D9;
	 t['yoddagesh'] = 0xFB39;
	 t['yoddageshhebrew'] = 0xFB39;
	 t['yodhebrew'] = 0x05D9;
	 t['yodyodhebrew'] = 0x05F2;
	 t['yodyodpatahhebrew'] = 0xFB1F;
	 t['yohiragana'] = 0x3088;
	 t['yoikorean'] = 0x3189;
	 t['yokatakana'] = 0x30E8;
	 t['yokatakanahalfwidth'] = 0xFF96;
	 t['yokorean'] = 0x315B;
	 t['yosmallhiragana'] = 0x3087;
	 t['yosmallkatakana'] = 0x30E7;
	 t['yosmallkatakanahalfwidth'] = 0xFF6E;
	 t['yotgreek'] = 0x03F3;
	 t['yoyaekorean'] = 0x3188;
	 t['yoyakorean'] = 0x3187;
	 t['yoyakthai'] = 0x0E22;
	 t['yoyingthai'] = 0x0E0D;
	 t['yparen'] = 0x24B4;
	 t['ypogegrammeni'] = 0x037A;
	 t['ypogegrammenigreekcmb'] = 0x0345;
	 t['yr'] = 0x01A6;
	 t['yring'] = 0x1E99;
	 t['ysuperior'] = 0x02B8;
	 t['ytilde'] = 0x1EF9;
	 t['yturned'] = 0x028E;
	 t['yuhiragana'] = 0x3086;
	 t['yuikorean'] = 0x318C;
	 t['yukatakana'] = 0x30E6;
	 t['yukatakanahalfwidth'] = 0xFF95;
	 t['yukorean'] = 0x3160;
	 t['yusbigcyrillic'] = 0x046B;
	 t['yusbigiotifiedcyrillic'] = 0x046D;
	 t['yuslittlecyrillic'] = 0x0467;
	 t['yuslittleiotifiedcyrillic'] = 0x0469;
	 t['yusmallhiragana'] = 0x3085;
	 t['yusmallkatakana'] = 0x30E5;
	 t['yusmallkatakanahalfwidth'] = 0xFF6D;
	 t['yuyekorean'] = 0x318B;
	 t['yuyeokorean'] = 0x318A;
	 t['yyabengali'] = 0x09DF;
	 t['yyadeva'] = 0x095F;
	 t['z'] = 0x007A;
	 t['zaarmenian'] = 0x0566;
	 t['zacute'] = 0x017A;
	 t['zadeva'] = 0x095B;
	 t['zagurmukhi'] = 0x0A5B;
	 t['zaharabic'] = 0x0638;
	 t['zahfinalarabic'] = 0xFEC6;
	 t['zahinitialarabic'] = 0xFEC7;
	 t['zahiragana'] = 0x3056;
	 t['zahmedialarabic'] = 0xFEC8;
	 t['zainarabic'] = 0x0632;
	 t['zainfinalarabic'] = 0xFEB0;
	 t['zakatakana'] = 0x30B6;
	 t['zaqefgadolhebrew'] = 0x0595;
	 t['zaqefqatanhebrew'] = 0x0594;
	 t['zarqahebrew'] = 0x0598;
	 t['zayin'] = 0x05D6;
	 t['zayindagesh'] = 0xFB36;
	 t['zayindageshhebrew'] = 0xFB36;
	 t['zayinhebrew'] = 0x05D6;
	 t['zbopomofo'] = 0x3117;
	 t['zcaron'] = 0x017E;
	 t['zcircle'] = 0x24E9;
	 t['zcircumflex'] = 0x1E91;
	 t['zcurl'] = 0x0291;
	 t['zdot'] = 0x017C;
	 t['zdotaccent'] = 0x017C;
	 t['zdotbelow'] = 0x1E93;
	 t['zecyrillic'] = 0x0437;
	 t['zedescendercyrillic'] = 0x0499;
	 t['zedieresiscyrillic'] = 0x04DF;
	 t['zehiragana'] = 0x305C;
	 t['zekatakana'] = 0x30BC;
	 t['zero'] = 0x0030;
	 t['zeroarabic'] = 0x0660;
	 t['zerobengali'] = 0x09E6;
	 t['zerodeva'] = 0x0966;
	 t['zerogujarati'] = 0x0AE6;
	 t['zerogurmukhi'] = 0x0A66;
	 t['zerohackarabic'] = 0x0660;
	 t['zeroinferior'] = 0x2080;
	 t['zeromonospace'] = 0xFF10;
	 t['zerooldstyle'] = 0xF730;
	 t['zeropersian'] = 0x06F0;
	 t['zerosuperior'] = 0x2070;
	 t['zerothai'] = 0x0E50;
	 t['zerowidthjoiner'] = 0xFEFF;
	 t['zerowidthnonjoiner'] = 0x200C;
	 t['zerowidthspace'] = 0x200B;
	 t['zeta'] = 0x03B6;
	 t['zhbopomofo'] = 0x3113;
	 t['zhearmenian'] = 0x056A;
	 t['zhebrevecyrillic'] = 0x04C2;
	 t['zhecyrillic'] = 0x0436;
	 t['zhedescendercyrillic'] = 0x0497;
	 t['zhedieresiscyrillic'] = 0x04DD;
	 t['zihiragana'] = 0x3058;
	 t['zikatakana'] = 0x30B8;
	 t['zinorhebrew'] = 0x05AE;
	 t['zlinebelow'] = 0x1E95;
	 t['zmonospace'] = 0xFF5A;
	 t['zohiragana'] = 0x305E;
	 t['zokatakana'] = 0x30BE;
	 t['zparen'] = 0x24B5;
	 t['zretroflexhook'] = 0x0290;
	 t['zstroke'] = 0x01B6;
	 t['zuhiragana'] = 0x305A;
	 t['zukatakana'] = 0x30BA;
	 t['.notdef'] = 0x0000;
	 t['angbracketleftbig'] = 0x2329;
	 t['angbracketleftBig'] = 0x2329;
	 t['angbracketleftbigg'] = 0x2329;
	 t['angbracketleftBigg'] = 0x2329;
	 t['angbracketrightBig'] = 0x232A;
	 t['angbracketrightbig'] = 0x232A;
	 t['angbracketrightBigg'] = 0x232A;
	 t['angbracketrightbigg'] = 0x232A;
	 t['arrowhookleft'] = 0x21AA;
	 t['arrowhookright'] = 0x21A9;
	 t['arrowlefttophalf'] = 0x21BC;
	 t['arrowleftbothalf'] = 0x21BD;
	 t['arrownortheast'] = 0x2197;
	 t['arrownorthwest'] = 0x2196;
	 t['arrowrighttophalf'] = 0x21C0;
	 t['arrowrightbothalf'] = 0x21C1;
	 t['arrowsoutheast'] = 0x2198;
	 t['arrowsouthwest'] = 0x2199;
	 t['backslashbig'] = 0x2216;
	 t['backslashBig'] = 0x2216;
	 t['backslashBigg'] = 0x2216;
	 t['backslashbigg'] = 0x2216;
	 t['bardbl'] = 0x2016;
	 t['bracehtipdownleft'] = 0xFE37;
	 t['bracehtipdownright'] = 0xFE37;
	 t['bracehtipupleft'] = 0xFE38;
	 t['bracehtipupright'] = 0xFE38;
	 t['braceleftBig'] = 0x007B;
	 t['braceleftbig'] = 0x007B;
	 t['braceleftbigg'] = 0x007B;
	 t['braceleftBigg'] = 0x007B;
	 t['bracerightBig'] = 0x007D;
	 t['bracerightbig'] = 0x007D;
	 t['bracerightbigg'] = 0x007D;
	 t['bracerightBigg'] = 0x007D;
	 t['bracketleftbig'] = 0x005B;
	 t['bracketleftBig'] = 0x005B;
	 t['bracketleftbigg'] = 0x005B;
	 t['bracketleftBigg'] = 0x005B;
	 t['bracketrightBig'] = 0x005D;
	 t['bracketrightbig'] = 0x005D;
	 t['bracketrightbigg'] = 0x005D;
	 t['bracketrightBigg'] = 0x005D;
	 t['ceilingleftbig'] = 0x2308;
	 t['ceilingleftBig'] = 0x2308;
	 t['ceilingleftBigg'] = 0x2308;
	 t['ceilingleftbigg'] = 0x2308;
	 t['ceilingrightbig'] = 0x2309;
	 t['ceilingrightBig'] = 0x2309;
	 t['ceilingrightbigg'] = 0x2309;
	 t['ceilingrightBigg'] = 0x2309;
	 t['circledotdisplay'] = 0x2299;
	 t['circledottext'] = 0x2299;
	 t['circlemultiplydisplay'] = 0x2297;
	 t['circlemultiplytext'] = 0x2297;
	 t['circleplusdisplay'] = 0x2295;
	 t['circleplustext'] = 0x2295;
	 t['contintegraldisplay'] = 0x222E;
	 t['contintegraltext'] = 0x222E;
	 t['coproductdisplay'] = 0x2210;
	 t['coproducttext'] = 0x2210;
	 t['floorleftBig'] = 0x230A;
	 t['floorleftbig'] = 0x230A;
	 t['floorleftbigg'] = 0x230A;
	 t['floorleftBigg'] = 0x230A;
	 t['floorrightbig'] = 0x230B;
	 t['floorrightBig'] = 0x230B;
	 t['floorrightBigg'] = 0x230B;
	 t['floorrightbigg'] = 0x230B;
	 t['hatwide'] = 0x0302;
	 t['hatwider'] = 0x0302;
	 t['hatwidest'] = 0x0302;
	 t['intercal'] = 0x1D40;
	 t['integraldisplay'] = 0x222B;
	 t['integraltext'] = 0x222B;
	 t['intersectiondisplay'] = 0x22C2;
	 t['intersectiontext'] = 0x22C2;
	 t['logicalanddisplay'] = 0x2227;
	 t['logicalandtext'] = 0x2227;
	 t['logicalordisplay'] = 0x2228;
	 t['logicalortext'] = 0x2228;
	 t['parenleftBig'] = 0x0028;
	 t['parenleftbig'] = 0x0028;
	 t['parenleftBigg'] = 0x0028;
	 t['parenleftbigg'] = 0x0028;
	 t['parenrightBig'] = 0x0029;
	 t['parenrightbig'] = 0x0029;
	 t['parenrightBigg'] = 0x0029;
	 t['parenrightbigg'] = 0x0029;
	 t['prime'] = 0x2032;
	 t['productdisplay'] = 0x220F;
	 t['producttext'] = 0x220F;
	 t['radicalbig'] = 0x221A;
	 t['radicalBig'] = 0x221A;
	 t['radicalBigg'] = 0x221A;
	 t['radicalbigg'] = 0x221A;
	 t['radicalbt'] = 0x221A;
	 t['radicaltp'] = 0x221A;
	 t['radicalvertex'] = 0x221A;
	 t['slashbig'] = 0x002F;
	 t['slashBig'] = 0x002F;
	 t['slashBigg'] = 0x002F;
	 t['slashbigg'] = 0x002F;
	 t['summationdisplay'] = 0x2211;
	 t['summationtext'] = 0x2211;
	 t['tildewide'] = 0x02DC;
	 t['tildewider'] = 0x02DC;
	 t['tildewidest'] = 0x02DC;
	 t['uniondisplay'] = 0x22C3;
	 t['unionmultidisplay'] = 0x228E;
	 t['unionmultitext'] = 0x228E;
	 t['unionsqdisplay'] = 0x2294;
	 t['unionsqtext'] = 0x2294;
	 t['uniontext'] = 0x22C3;
	 t['vextenddouble'] = 0x2225;
	 t['vextendsingle'] = 0x2223;
	});
	var getDingbatsGlyphsUnicode = getLookupTableFactory(function (t) {
	 t['space'] = 0x0020;
	 t['a1'] = 0x2701;
	 t['a2'] = 0x2702;
	 t['a202'] = 0x2703;
	 t['a3'] = 0x2704;
	 t['a4'] = 0x260E;
	 t['a5'] = 0x2706;
	 t['a119'] = 0x2707;
	 t['a118'] = 0x2708;
	 t['a117'] = 0x2709;
	 t['a11'] = 0x261B;
	 t['a12'] = 0x261E;
	 t['a13'] = 0x270C;
	 t['a14'] = 0x270D;
	 t['a15'] = 0x270E;
	 t['a16'] = 0x270F;
	 t['a105'] = 0x2710;
	 t['a17'] = 0x2711;
	 t['a18'] = 0x2712;
	 t['a19'] = 0x2713;
	 t['a20'] = 0x2714;
	 t['a21'] = 0x2715;
	 t['a22'] = 0x2716;
	 t['a23'] = 0x2717;
	 t['a24'] = 0x2718;
	 t['a25'] = 0x2719;
	 t['a26'] = 0x271A;
	 t['a27'] = 0x271B;
	 t['a28'] = 0x271C;
	 t['a6'] = 0x271D;
	 t['a7'] = 0x271E;
	 t['a8'] = 0x271F;
	 t['a9'] = 0x2720;
	 t['a10'] = 0x2721;
	 t['a29'] = 0x2722;
	 t['a30'] = 0x2723;
	 t['a31'] = 0x2724;
	 t['a32'] = 0x2725;
	 t['a33'] = 0x2726;
	 t['a34'] = 0x2727;
	 t['a35'] = 0x2605;
	 t['a36'] = 0x2729;
	 t['a37'] = 0x272A;
	 t['a38'] = 0x272B;
	 t['a39'] = 0x272C;
	 t['a40'] = 0x272D;
	 t['a41'] = 0x272E;
	 t['a42'] = 0x272F;
	 t['a43'] = 0x2730;
	 t['a44'] = 0x2731;
	 t['a45'] = 0x2732;
	 t['a46'] = 0x2733;
	 t['a47'] = 0x2734;
	 t['a48'] = 0x2735;
	 t['a49'] = 0x2736;
	 t['a50'] = 0x2737;
	 t['a51'] = 0x2738;
	 t['a52'] = 0x2739;
	 t['a53'] = 0x273A;
	 t['a54'] = 0x273B;
	 t['a55'] = 0x273C;
	 t['a56'] = 0x273D;
	 t['a57'] = 0x273E;
	 t['a58'] = 0x273F;
	 t['a59'] = 0x2740;
	 t['a60'] = 0x2741;
	 t['a61'] = 0x2742;
	 t['a62'] = 0x2743;
	 t['a63'] = 0x2744;
	 t['a64'] = 0x2745;
	 t['a65'] = 0x2746;
	 t['a66'] = 0x2747;
	 t['a67'] = 0x2748;
	 t['a68'] = 0x2749;
	 t['a69'] = 0x274A;
	 t['a70'] = 0x274B;
	 t['a71'] = 0x25CF;
	 t['a72'] = 0x274D;
	 t['a73'] = 0x25A0;
	 t['a74'] = 0x274F;
	 t['a203'] = 0x2750;
	 t['a75'] = 0x2751;
	 t['a204'] = 0x2752;
	 t['a76'] = 0x25B2;
	 t['a77'] = 0x25BC;
	 t['a78'] = 0x25C6;
	 t['a79'] = 0x2756;
	 t['a81'] = 0x25D7;
	 t['a82'] = 0x2758;
	 t['a83'] = 0x2759;
	 t['a84'] = 0x275A;
	 t['a97'] = 0x275B;
	 t['a98'] = 0x275C;
	 t['a99'] = 0x275D;
	 t['a100'] = 0x275E;
	 t['a101'] = 0x2761;
	 t['a102'] = 0x2762;
	 t['a103'] = 0x2763;
	 t['a104'] = 0x2764;
	 t['a106'] = 0x2765;
	 t['a107'] = 0x2766;
	 t['a108'] = 0x2767;
	 t['a112'] = 0x2663;
	 t['a111'] = 0x2666;
	 t['a110'] = 0x2665;
	 t['a109'] = 0x2660;
	 t['a120'] = 0x2460;
	 t['a121'] = 0x2461;
	 t['a122'] = 0x2462;
	 t['a123'] = 0x2463;
	 t['a124'] = 0x2464;
	 t['a125'] = 0x2465;
	 t['a126'] = 0x2466;
	 t['a127'] = 0x2467;
	 t['a128'] = 0x2468;
	 t['a129'] = 0x2469;
	 t['a130'] = 0x2776;
	 t['a131'] = 0x2777;
	 t['a132'] = 0x2778;
	 t['a133'] = 0x2779;
	 t['a134'] = 0x277A;
	 t['a135'] = 0x277B;
	 t['a136'] = 0x277C;
	 t['a137'] = 0x277D;
	 t['a138'] = 0x277E;
	 t['a139'] = 0x277F;
	 t['a140'] = 0x2780;
	 t['a141'] = 0x2781;
	 t['a142'] = 0x2782;
	 t['a143'] = 0x2783;
	 t['a144'] = 0x2784;
	 t['a145'] = 0x2785;
	 t['a146'] = 0x2786;
	 t['a147'] = 0x2787;
	 t['a148'] = 0x2788;
	 t['a149'] = 0x2789;
	 t['a150'] = 0x278A;
	 t['a151'] = 0x278B;
	 t['a152'] = 0x278C;
	 t['a153'] = 0x278D;
	 t['a154'] = 0x278E;
	 t['a155'] = 0x278F;
	 t['a156'] = 0x2790;
	 t['a157'] = 0x2791;
	 t['a158'] = 0x2792;
	 t['a159'] = 0x2793;
	 t['a160'] = 0x2794;
	 t['a161'] = 0x2192;
	 t['a163'] = 0x2194;
	 t['a164'] = 0x2195;
	 t['a196'] = 0x2798;
	 t['a165'] = 0x2799;
	 t['a192'] = 0x279A;
	 t['a166'] = 0x279B;
	 t['a167'] = 0x279C;
	 t['a168'] = 0x279D;
	 t['a169'] = 0x279E;
	 t['a170'] = 0x279F;
	 t['a171'] = 0x27A0;
	 t['a172'] = 0x27A1;
	 t['a173'] = 0x27A2;
	 t['a162'] = 0x27A3;
	 t['a174'] = 0x27A4;
	 t['a175'] = 0x27A5;
	 t['a176'] = 0x27A6;
	 t['a177'] = 0x27A7;
	 t['a178'] = 0x27A8;
	 t['a179'] = 0x27A9;
	 t['a193'] = 0x27AA;
	 t['a180'] = 0x27AB;
	 t['a199'] = 0x27AC;
	 t['a181'] = 0x27AD;
	 t['a200'] = 0x27AE;
	 t['a182'] = 0x27AF;
	 t['a201'] = 0x27B1;
	 t['a183'] = 0x27B2;
	 t['a184'] = 0x27B3;
	 t['a197'] = 0x27B4;
	 t['a185'] = 0x27B5;
	 t['a194'] = 0x27B6;
	 t['a198'] = 0x27B7;
	 t['a186'] = 0x27B8;
	 t['a195'] = 0x27B9;
	 t['a187'] = 0x27BA;
	 t['a188'] = 0x27BB;
	 t['a189'] = 0x27BC;
	 t['a190'] = 0x27BD;
	 t['a191'] = 0x27BE;
	 t['a89'] = 0x2768;
	 t['a90'] = 0x2769;
	 t['a93'] = 0x276A;
	 t['a94'] = 0x276B;
	 t['a91'] = 0x276C;
	 t['a92'] = 0x276D;
	 t['a205'] = 0x276E;
	 t['a85'] = 0x276F;
	 t['a206'] = 0x2770;
	 t['a86'] = 0x2771;
	 t['a87'] = 0x2772;
	 t['a88'] = 0x2773;
	 t['a95'] = 0x2774;
	 t['a96'] = 0x2775;
	 t['.notdef'] = 0x0000;
	});
	exports.getGlyphsUnicode = getGlyphsUnicode;
	exports.getDingbatsGlyphsUnicode = getDingbatsGlyphsUnicode;
	
	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateResponseStatus = exports.validateRangeRequestCapabilities = exports.createResponseStatusError = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	function validateRangeRequestCapabilities(_ref) {
	  var getResponseHeader = _ref.getResponseHeader,
	      isHttp = _ref.isHttp,
	      rangeChunkSize = _ref.rangeChunkSize,
	      disableRange = _ref.disableRange;
	
	  (0, _util.assert)(rangeChunkSize > 0);
	  var returnValues = {
	    allowRangeRequests: false,
	    suggestedLength: undefined
	  };
	  if (disableRange || !isHttp) {
	    return returnValues;
	  }
	  if (getResponseHeader('Accept-Ranges') !== 'bytes') {
	    return returnValues;
	  }
	  var contentEncoding = getResponseHeader('Content-Encoding') || 'identity';
	  if (contentEncoding !== 'identity') {
	    return returnValues;
	  }
	  var length = parseInt(getResponseHeader('Content-Length'), 10);
	  if (!Number.isInteger(length)) {
	    return returnValues;
	  }
	  returnValues.suggestedLength = length;
	  if (length <= 2 * rangeChunkSize) {
	    return returnValues;
	  }
	  returnValues.allowRangeRequests = true;
	  return returnValues;
	}
	function createResponseStatusError(status, url) {
	  if (status === 404 || status === 0 && /^file:/.test(url)) {
	    return new _util.MissingPDFException('Missing PDF "' + url + '".');
	  }
	  return new _util.UnexpectedResponseException('Unexpected server response (' + status + ') while retrieving PDF "' + url + '".', status);
	}
	function validateResponseStatus(status) {
	  return status === 200 || status === 206;
	}
	exports.createResponseStatusError = createResponseStatusError;
	exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
	exports.validateResponseStatus = validateResponseStatus;
	
	/***/ }),
	/* 51 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = !__w_pdfjs_require__(10) && !__w_pdfjs_require__(11)(function () {
	  return Object.defineProperty(__w_pdfjs_require__(37)('div'), 'a', {
	    get: function get() {
	      return 7;
	    }
	  }).a != 7;
	});
	
	/***/ }),
	/* 52 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(1);
	var hide = __w_pdfjs_require__(8);
	var uid = __w_pdfjs_require__(18);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	var TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};
	
	/***/ }),
	/* 53 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toInteger = __w_pdfjs_require__(19);
	var toLength = __w_pdfjs_require__(14);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};
	
	/***/ }),
	/* 54 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $keys = __w_pdfjs_require__(55);
	var hiddenKeys = __w_pdfjs_require__(42).concat('length', 'prototype');
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};
	
	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var has = __w_pdfjs_require__(12);
	var toIObject = __w_pdfjs_require__(32);
	var arrayIndexOf = __w_pdfjs_require__(56)(false);
	var IE_PROTO = __w_pdfjs_require__(41)('IE_PROTO');
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) {
	    if (key != IE_PROTO) has(O, key) && result.push(key);
	  }while (names.length > i) {
	    if (has(O, key = names[i++])) {
	      ~arrayIndexOf(result, key) || result.push(key);
	    }
	  }return result;
	};
	
	/***/ }),
	/* 56 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toIObject = __w_pdfjs_require__(32);
	var toLength = __w_pdfjs_require__(14);
	var toAbsoluteIndex = __w_pdfjs_require__(33);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      if (value != value) return true;
	    } else for (; length > index; index++) {
	      if (IS_INCLUDES || index in O) {
	        if (O[index] === el) return IS_INCLUDES || index || 0;
	      }
	    }return !IS_INCLUDES && -1;
	  };
	};
	
	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var core = __w_pdfjs_require__(6);
	var global = __w_pdfjs_require__(1);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __w_pdfjs_require__(23) ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});
	
	/***/ }),
	/* 58 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toObject = __w_pdfjs_require__(20);
	var toAbsoluteIndex = __w_pdfjs_require__(33);
	var toLength = __w_pdfjs_require__(14);
	module.exports = function fill(value) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) {
	    O[index++] = value;
	  }return O;
	};
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var Iterators = __w_pdfjs_require__(21);
	var ITERATOR = __w_pdfjs_require__(4)('iterator');
	var ArrayProto = Array.prototype;
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var anObject = __w_pdfjs_require__(9);
	var dPs = __w_pdfjs_require__(97);
	var enumBugKeys = __w_pdfjs_require__(42);
	var IE_PROTO = __w_pdfjs_require__(41)('IE_PROTO');
	var Empty = function Empty() {};
	var PROTOTYPE = 'prototype';
	var _createDict = function createDict() {
	  var iframe = __w_pdfjs_require__(37)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __w_pdfjs_require__(61).appendChild(iframe);
	  iframe.src = 'javascript:';
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  _createDict = iframeDocument.F;
	  while (i--) {
	    delete _createDict[PROTOTYPE][enumBugKeys[i]];
	  }return _createDict();
	};
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    result[IE_PROTO] = O;
	  } else result = _createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var document = __w_pdfjs_require__(1).document;
	module.exports = document && document.documentElement;
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var has = __w_pdfjs_require__(12);
	var toObject = __w_pdfjs_require__(20);
	var IE_PROTO = __w_pdfjs_require__(41)('IE_PROTO');
	var ObjectProto = Object.prototype;
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  }
	  return O instanceof Object ? ObjectProto : null;
	};
	
	/***/ }),
	/* 63 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var classof = __w_pdfjs_require__(34);
	var ITERATOR = __w_pdfjs_require__(4)('iterator');
	var Iterators = __w_pdfjs_require__(21);
	module.exports = __w_pdfjs_require__(6).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
	};
	
	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var addToUnscopables = __w_pdfjs_require__(101);
	var step = __w_pdfjs_require__(102);
	var Iterators = __w_pdfjs_require__(21);
	var toIObject = __w_pdfjs_require__(32);
	module.exports = __w_pdfjs_require__(65)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated);
	  this._i = 0;
	  this._k = kind;
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	Iterators.Arguments = Iterators.Array;
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');
	
	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var LIBRARY = __w_pdfjs_require__(23);
	var $export = __w_pdfjs_require__(7);
	var redefine = __w_pdfjs_require__(16);
	var hide = __w_pdfjs_require__(8);
	var Iterators = __w_pdfjs_require__(21);
	var $iterCreate = __w_pdfjs_require__(103);
	var setToStringTag = __w_pdfjs_require__(28);
	var getPrototypeOf = __w_pdfjs_require__(62);
	var ITERATOR = __w_pdfjs_require__(4)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys());
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	var returnThis = function returnThis() {
	  return this;
	};
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function getMethod(kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS:
	        return function keys() {
	          return new Constructor(this, kind);
	        };
	      case VALUES:
	        return function values() {
	          return new Constructor(this, kind);
	        };
	    }
	    return function entries() {
	      return new Constructor(this, kind);
	    };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      setToStringTag(IteratorPrototype, TAG, true);
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() {
	      return $native.call(this);
	    };
	  }
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(1);
	var dP = __w_pdfjs_require__(15);
	var DESCRIPTORS = __w_pdfjs_require__(10);
	var SPECIES = __w_pdfjs_require__(4)('species');
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function get() {
	      return this;
	    }
	  });
	};
	
	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var pIE = __w_pdfjs_require__(68);
	var createDesc = __w_pdfjs_require__(31);
	var toIObject = __w_pdfjs_require__(32);
	var toPrimitive = __w_pdfjs_require__(38);
	var has = __w_pdfjs_require__(12);
	var IE8_DOM_DEFINE = __w_pdfjs_require__(51);
	var gOPD = Object.getOwnPropertyDescriptor;
	exports.f = __w_pdfjs_require__(10) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) {}
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};
	
	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	exports.f = {}.propertyIsEnumerable;
	
	/***/ }),
	/* 69 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var classof = __w_pdfjs_require__(34);
	var test = {};
	test[__w_pdfjs_require__(4)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __w_pdfjs_require__(16)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}
	
	/***/ }),
	/* 70 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $iterators = __w_pdfjs_require__(64);
	var getKeys = __w_pdfjs_require__(43);
	var redefine = __w_pdfjs_require__(16);
	var global = __w_pdfjs_require__(1);
	var hide = __w_pdfjs_require__(8);
	var Iterators = __w_pdfjs_require__(21);
	var wks = __w_pdfjs_require__(4);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	var DOMIterables = {
	  CSSRuleList: true,
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true,
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true,
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) {
	      if (!proto[key]) redefine(proto, key, $iterators[key], true);
	    }
	  }
	}
	
	/***/ }),
	/* 71 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var ctx = __w_pdfjs_require__(13);
	var invoke = __w_pdfjs_require__(115);
	var html = __w_pdfjs_require__(61);
	var cel = __w_pdfjs_require__(37);
	var global = __w_pdfjs_require__(1);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function run() {
	  var id = +this;
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function listener(event) {
	  run.call(event.data);
	};
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) {
	      args.push(arguments[i++]);
	    }queue[++counter] = function () {
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  if (__w_pdfjs_require__(27)(process) == 'process') {
	    defer = function defer(id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  } else if (Dispatch && Dispatch.now) {
	    defer = function defer(id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function defer(id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function defer(id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  } else {
	    defer = function defer(id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};
	
	/***/ }),
	/* 72 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (exec) {
	  try {
	    return {
	      e: false,
	      v: exec()
	    };
	  } catch (e) {
	    return {
	      e: true,
	      v: e
	    };
	  }
	};
	
	/***/ }),
	/* 73 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var anObject = __w_pdfjs_require__(9);
	var isObject = __w_pdfjs_require__(3);
	var newPromiseCapability = __w_pdfjs_require__(47);
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};
	
	/***/ }),
	/* 74 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(3);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};
	
	/***/ }),
	/* 75 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.build = exports.version = exports._UnsupportedManager = exports.setPDFNetworkStreamClass = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFWorker = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.getDocument = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _util = __w_pdfjs_require__(0);
	
	var _dom_utils = __w_pdfjs_require__(17);
	
	var _font_loader = __w_pdfjs_require__(135);
	
	var _canvas = __w_pdfjs_require__(136);
	
	var _global_scope = __w_pdfjs_require__(22);
	
	var _global_scope2 = _interopRequireDefault(_global_scope);
	
	var _metadata = __w_pdfjs_require__(77);
	
	var _transport_stream = __w_pdfjs_require__(139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_RANGE_CHUNK_SIZE = 65536;
	var isWorkerDisabled = false;
	var workerSrc;
	var isPostMessageTransfersDisabled = false;
	var pdfjsFilePath = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : null;
	var fakeWorkerFilesLoader = null;
	var useRequireEnsure = false;
	;
	var PDFNetworkStream;
	function setPDFNetworkStreamClass(cls) {
	  PDFNetworkStream = cls;
	}
	function getDocument(src, pdfDataRangeTransport, passwordCallback, progressCallback) {
	  var task = new PDFDocumentLoadingTask();
	  if (arguments.length > 1) {
	    (0, _util.deprecated)('getDocument is called with pdfDataRangeTransport, ' + 'passwordCallback or progressCallback argument');
	  }
	  if (pdfDataRangeTransport) {
	    if (!(pdfDataRangeTransport instanceof PDFDataRangeTransport)) {
	      pdfDataRangeTransport = Object.create(pdfDataRangeTransport);
	      pdfDataRangeTransport.length = src.length;
	      pdfDataRangeTransport.initialData = src.initialData;
	      if (!pdfDataRangeTransport.abort) {
	        pdfDataRangeTransport.abort = function () {};
	      }
	    }
	    src = Object.create(src);
	    src.range = pdfDataRangeTransport;
	  }
	  task.onPassword = passwordCallback || null;
	  task.onProgress = progressCallback || null;
	  var source;
	  if (typeof src === 'string') {
	    source = { url: src };
	  } else if ((0, _util.isArrayBuffer)(src)) {
	    source = { data: src };
	  } else if (src instanceof PDFDataRangeTransport) {
	    source = { range: src };
	  } else {
	    if ((typeof src === 'undefined' ? 'undefined' : _typeof(src)) !== 'object') {
	      throw new Error('Invalid parameter in getDocument, ' + 'need either Uint8Array, string or a parameter object');
	    }
	    if (!src.url && !src.data && !src.range) {
	      throw new Error('Invalid parameter object: need either .data, .range or .url');
	    }
	    source = src;
	  }
	  var params = {};
	  var rangeTransport = null;
	  var worker = null;
	  var CMapReaderFactory = _dom_utils.DOMCMapReaderFactory;
	  for (var key in source) {
	    if (key === 'url' && typeof window !== 'undefined') {
	      params[key] = new URL(source[key], window.location).href;
	      continue;
	    } else if (key === 'range') {
	      rangeTransport = source[key];
	      continue;
	    } else if (key === 'worker') {
	      worker = source[key];
	      continue;
	    } else if (key === 'data' && !(source[key] instanceof Uint8Array)) {
	      var pdfBytes = source[key];
	      if (typeof pdfBytes === 'string') {
	        params[key] = (0, _util.stringToBytes)(pdfBytes);
	      } else if ((typeof pdfBytes === 'undefined' ? 'undefined' : _typeof(pdfBytes)) === 'object' && pdfBytes !== null && !isNaN(pdfBytes.length)) {
	        params[key] = new Uint8Array(pdfBytes);
	      } else if ((0, _util.isArrayBuffer)(pdfBytes)) {
	        params[key] = new Uint8Array(pdfBytes);
	      } else {
	        throw new Error('Invalid PDF binary data: either typed array, ' + 'string or array-like object is expected in the ' + 'data property.');
	      }
	      continue;
	    } else if (key === 'CMapReaderFactory') {
	      CMapReaderFactory = source[key];
	      continue;
	    }
	    params[key] = source[key];
	  }
	  params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
	  params.ignoreErrors = params.stopAtErrors !== true;
	  if (params.disableNativeImageDecoder !== undefined) {
	    (0, _util.deprecated)('parameter disableNativeImageDecoder, ' + 'use nativeImageDecoderSupport instead');
	  }
	  params.nativeImageDecoderSupport = params.nativeImageDecoderSupport || (params.disableNativeImageDecoder === true ? _util.NativeImageDecoding.NONE : _util.NativeImageDecoding.DECODE);
	  if (params.nativeImageDecoderSupport !== _util.NativeImageDecoding.DECODE && params.nativeImageDecoderSupport !== _util.NativeImageDecoding.NONE && params.nativeImageDecoderSupport !== _util.NativeImageDecoding.DISPLAY) {
	    (0, _util.warn)('Invalid parameter nativeImageDecoderSupport: ' + 'need a state of enum {NativeImageDecoding}');
	    params.nativeImageDecoderSupport = _util.NativeImageDecoding.DECODE;
	  }
	  if (!worker) {
	    var workerPort = (0, _dom_utils.getDefaultSetting)('workerPort');
	    worker = workerPort ? PDFWorker.fromPort(workerPort) : new PDFWorker();
	    task._worker = worker;
	  }
	  var docId = task.docId;
	  worker.promise.then(function () {
	    if (task.destroyed) {
	      throw new Error('Loading aborted');
	    }
	    return _fetchDocument(worker, params, rangeTransport, docId).then(function (workerId) {
	      if (task.destroyed) {
	        throw new Error('Loading aborted');
	      }
	      var networkStream = void 0;
	      if (rangeTransport) {
	        networkStream = new _transport_stream.PDFDataTransportStream(params, rangeTransport);
	      } else if (!params.data) {
	        networkStream = new PDFNetworkStream({
	          source: params,
	          disableRange: (0, _dom_utils.getDefaultSetting)('disableRange')
	        });
	      }
	      var messageHandler = new _util.MessageHandler(docId, workerId, worker.port);
	      messageHandler.postMessageTransfers = worker.postMessageTransfers;
	      var transport = new WorkerTransport(messageHandler, task, networkStream, CMapReaderFactory);
	      task._transport = transport;
	      messageHandler.send('Ready', null);
	    });
	  }).catch(task._capability.reject);
	  return task;
	}
	function _fetchDocument(worker, source, pdfDataRangeTransport, docId) {
	  if (worker.destroyed) {
	    return Promise.reject(new Error('Worker was destroyed'));
	  }
	  var apiVersion = '1.10.100';
	  source.disableAutoFetch = (0, _dom_utils.getDefaultSetting)('disableAutoFetch');
	  source.disableStream = (0, _dom_utils.getDefaultSetting)('disableStream');
	  source.chunkedViewerLoading = !!pdfDataRangeTransport;
	  if (pdfDataRangeTransport) {
	    source.length = pdfDataRangeTransport.length;
	    source.initialData = pdfDataRangeTransport.initialData;
	  }
	  return worker.messageHandler.sendWithPromise('GetDocRequest', {
	    docId: docId,
	    apiVersion: apiVersion,
	    source: {
	      data: source.data,
	      url: source.url,
	      password: source.password,
	      disableAutoFetch: source.disableAutoFetch,
	      rangeChunkSize: source.rangeChunkSize,
	      length: source.length
	    },
	    maxImageSize: (0, _dom_utils.getDefaultSetting)('maxImageSize'),
	    disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
	    disableCreateObjectURL: (0, _dom_utils.getDefaultSetting)('disableCreateObjectURL'),
	    postMessageTransfers: (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled,
	    docBaseUrl: source.docBaseUrl,
	    nativeImageDecoderSupport: source.nativeImageDecoderSupport,
	    ignoreErrors: source.ignoreErrors,
	    isEvalSupported: (0, _dom_utils.getDefaultSetting)('isEvalSupported')
	  }).then(function (workerId) {
	    if (worker.destroyed) {
	      throw new Error('Worker was destroyed');
	    }
	    return workerId;
	  });
	}
	var PDFDocumentLoadingTask = function PDFDocumentLoadingTaskClosure() {
	  var nextDocumentId = 0;
	  function PDFDocumentLoadingTask() {
	    this._capability = (0, _util.createPromiseCapability)();
	    this._transport = null;
	    this._worker = null;
	    this.docId = 'd' + nextDocumentId++;
	    this.destroyed = false;
	    this.onPassword = null;
	    this.onProgress = null;
	    this.onUnsupportedFeature = null;
	  }
	  PDFDocumentLoadingTask.prototype = {
	    get promise() {
	      return this._capability.promise;
	    },
	    destroy: function destroy() {
	      var _this = this;
	
	      this.destroyed = true;
	      var transportDestroyed = !this._transport ? Promise.resolve() : this._transport.destroy();
	      return transportDestroyed.then(function () {
	        _this._transport = null;
	        if (_this._worker) {
	          _this._worker.destroy();
	          _this._worker = null;
	        }
	      });
	    },
	
	    then: function PDFDocumentLoadingTask_then(onFulfilled, onRejected) {
	      return this.promise.then.apply(this.promise, arguments);
	    }
	  };
	  return PDFDocumentLoadingTask;
	}();
	var PDFDataRangeTransport = function pdfDataRangeTransportClosure() {
	  function PDFDataRangeTransport(length, initialData) {
	    this.length = length;
	    this.initialData = initialData;
	    this._rangeListeners = [];
	    this._progressListeners = [];
	    this._progressiveReadListeners = [];
	    this._readyCapability = (0, _util.createPromiseCapability)();
	  }
	  PDFDataRangeTransport.prototype = {
	    addRangeListener: function PDFDataRangeTransport_addRangeListener(listener) {
	      this._rangeListeners.push(listener);
	    },
	    addProgressListener: function PDFDataRangeTransport_addProgressListener(listener) {
	      this._progressListeners.push(listener);
	    },
	    addProgressiveReadListener: function PDFDataRangeTransport_addProgressiveReadListener(listener) {
	      this._progressiveReadListeners.push(listener);
	    },
	    onDataRange: function PDFDataRangeTransport_onDataRange(begin, chunk) {
	      var listeners = this._rangeListeners;
	      for (var i = 0, n = listeners.length; i < n; ++i) {
	        listeners[i](begin, chunk);
	      }
	    },
	    onDataProgress: function PDFDataRangeTransport_onDataProgress(loaded) {
	      var _this2 = this;
	
	      this._readyCapability.promise.then(function () {
	        var listeners = _this2._progressListeners;
	        for (var i = 0, n = listeners.length; i < n; ++i) {
	          listeners[i](loaded);
	        }
	      });
	    },
	    onDataProgressiveRead: function PDFDataRangeTransport_onDataProgress(chunk) {
	      var _this3 = this;
	
	      this._readyCapability.promise.then(function () {
	        var listeners = _this3._progressiveReadListeners;
	        for (var i = 0, n = listeners.length; i < n; ++i) {
	          listeners[i](chunk);
	        }
	      });
	    },
	    transportReady: function PDFDataRangeTransport_transportReady() {
	      this._readyCapability.resolve();
	    },
	    requestDataRange: function PDFDataRangeTransport_requestDataRange(begin, end) {
	      throw new Error('Abstract method PDFDataRangeTransport.requestDataRange');
	    },
	    abort: function PDFDataRangeTransport_abort() {}
	  };
	  return PDFDataRangeTransport;
	}();
	var PDFDocumentProxy = function PDFDocumentProxyClosure() {
	  function PDFDocumentProxy(pdfInfo, transport, loadingTask) {
	    this.pdfInfo = pdfInfo;
	    this.transport = transport;
	    this.loadingTask = loadingTask;
	  }
	  PDFDocumentProxy.prototype = {
	    get numPages() {
	      return this.pdfInfo.numPages;
	    },
	    get fingerprint() {
	      return this.pdfInfo.fingerprint;
	    },
	    getPage: function PDFDocumentProxy_getPage(pageNumber) {
	      return this.transport.getPage(pageNumber);
	    },
	    getPageIndex: function PDFDocumentProxy_getPageIndex(ref) {
	      return this.transport.getPageIndex(ref);
	    },
	    getDestinations: function PDFDocumentProxy_getDestinations() {
	      return this.transport.getDestinations();
	    },
	    getDestination: function PDFDocumentProxy_getDestination(id) {
	      return this.transport.getDestination(id);
	    },
	    getPageLabels: function PDFDocumentProxy_getPageLabels() {
	      return this.transport.getPageLabels();
	    },
	    getPageMode: function getPageMode() {
	      return this.transport.getPageMode();
	    },
	
	    getAttachments: function PDFDocumentProxy_getAttachments() {
	      return this.transport.getAttachments();
	    },
	    getJavaScript: function PDFDocumentProxy_getJavaScript() {
	      return this.transport.getJavaScript();
	    },
	    getOutline: function PDFDocumentProxy_getOutline() {
	      return this.transport.getOutline();
	    },
	    getMetadata: function PDFDocumentProxy_getMetadata() {
	      return this.transport.getMetadata();
	    },
	    getData: function PDFDocumentProxy_getData() {
	      return this.transport.getData();
	    },
	    getDownloadInfo: function PDFDocumentProxy_getDownloadInfo() {
	      return this.transport.downloadInfoCapability.promise;
	    },
	    getStats: function PDFDocumentProxy_getStats() {
	      return this.transport.getStats();
	    },
	    cleanup: function PDFDocumentProxy_cleanup() {
	      this.transport.startCleanup();
	    },
	    destroy: function PDFDocumentProxy_destroy() {
	      return this.loadingTask.destroy();
	    }
	  };
	  return PDFDocumentProxy;
	}();
	var PDFPageProxy = function PDFPageProxyClosure() {
	  function PDFPageProxy(pageIndex, pageInfo, transport) {
	    this.pageIndex = pageIndex;
	    this.pageInfo = pageInfo;
	    this.transport = transport;
	    this.stats = new _util.StatTimer();
	    this.stats.enabled = (0, _dom_utils.getDefaultSetting)('enableStats');
	    this.commonObjs = transport.commonObjs;
	    this.objs = new PDFObjects();
	    this.cleanupAfterRender = false;
	    this.pendingCleanup = false;
	    this.intentStates = Object.create(null);
	    this.destroyed = false;
	  }
	  PDFPageProxy.prototype = {
	    get pageNumber() {
	      return this.pageIndex + 1;
	    },
	    get rotate() {
	      return this.pageInfo.rotate;
	    },
	    get ref() {
	      return this.pageInfo.ref;
	    },
	    get userUnit() {
	      return this.pageInfo.userUnit;
	    },
	    get view() {
	      return this.pageInfo.view;
	    },
	    getViewport: function PDFPageProxy_getViewport(scale, rotate) {
	      if (arguments.length < 2) {
	        rotate = this.rotate;
	      }
	      return new _util.PageViewport(this.view, scale, rotate, 0, 0);
	    },
	    getAnnotations: function PDFPageProxy_getAnnotations(params) {
	      var intent = params && params.intent || null;
	      if (!this.annotationsPromise || this.annotationsIntent !== intent) {
	        this.annotationsPromise = this.transport.getAnnotations(this.pageIndex, intent);
	        this.annotationsIntent = intent;
	      }
	      return this.annotationsPromise;
	    },
	    render: function PDFPageProxy_render(params) {
	      var _this4 = this;
	
	      var stats = this.stats;
	      stats.time('Overall');
	      this.pendingCleanup = false;
	      var renderingIntent = params.intent === 'print' ? 'print' : 'display';
	      var canvasFactory = params.canvasFactory || new _dom_utils.DOMCanvasFactory();
	      if (!this.intentStates[renderingIntent]) {
	        this.intentStates[renderingIntent] = Object.create(null);
	      }
	      var intentState = this.intentStates[renderingIntent];
	      if (!intentState.displayReadyCapability) {
	        intentState.receivingOperatorList = true;
	        intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
	        intentState.operatorList = {
	          fnArray: [],
	          argsArray: [],
	          lastChunk: false
	        };
	        this.stats.time('Page Request');
	        this.transport.messageHandler.send('RenderPageRequest', {
	          pageIndex: this.pageNumber - 1,
	          intent: renderingIntent,
	          renderInteractiveForms: params.renderInteractiveForms === true
	        });
	      }
	      var complete = function complete(error) {
	        var i = intentState.renderTasks.indexOf(internalRenderTask);
	        if (i >= 0) {
	          intentState.renderTasks.splice(i, 1);
	        }
	        if (_this4.cleanupAfterRender) {
	          _this4.pendingCleanup = true;
	        }
	        _this4._tryCleanup();
	        if (error) {
	          internalRenderTask.capability.reject(error);
	        } else {
	          internalRenderTask.capability.resolve();
	        }
	        stats.timeEnd('Rendering');
	        stats.timeEnd('Overall');
	      };
	      var internalRenderTask = new InternalRenderTask(complete, params, this.objs, this.commonObjs, intentState.operatorList, this.pageNumber, canvasFactory);
	      internalRenderTask.useRequestAnimationFrame = renderingIntent !== 'print';
	      if (!intentState.renderTasks) {
	        intentState.renderTasks = [];
	      }
	      intentState.renderTasks.push(internalRenderTask);
	      var renderTask = internalRenderTask.task;
	      if (params.continueCallback) {
	        (0, _util.deprecated)('render is used with continueCallback parameter');
	        renderTask.onContinue = params.continueCallback;
	      }
	      intentState.displayReadyCapability.promise.then(function (transparency) {
	        if (_this4.pendingCleanup) {
	          complete();
	          return;
	        }
	        stats.time('Rendering');
	        internalRenderTask.initializeGraphics(transparency);
	        internalRenderTask.operatorListChanged();
	      }).catch(complete);
	      return renderTask;
	    },
	    getOperatorList: function PDFPageProxy_getOperatorList() {
	      function operatorListChanged() {
	        if (intentState.operatorList.lastChunk) {
	          intentState.opListReadCapability.resolve(intentState.operatorList);
	          var i = intentState.renderTasks.indexOf(opListTask);
	          if (i >= 0) {
	            intentState.renderTasks.splice(i, 1);
	          }
	        }
	      }
	      var renderingIntent = 'oplist';
	      if (!this.intentStates[renderingIntent]) {
	        this.intentStates[renderingIntent] = Object.create(null);
	      }
	      var intentState = this.intentStates[renderingIntent];
	      var opListTask;
	      if (!intentState.opListReadCapability) {
	        opListTask = {};
	        opListTask.operatorListChanged = operatorListChanged;
	        intentState.receivingOperatorList = true;
	        intentState.opListReadCapability = (0, _util.createPromiseCapability)();
	        intentState.renderTasks = [];
	        intentState.renderTasks.push(opListTask);
	        intentState.operatorList = {
	          fnArray: [],
	          argsArray: [],
	          lastChunk: false
	        };
	        this.transport.messageHandler.send('RenderPageRequest', {
	          pageIndex: this.pageIndex,
	          intent: renderingIntent
	        });
	      }
	      return intentState.opListReadCapability.promise;
	    },
	    streamTextContent: function streamTextContent() {
	      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var TEXT_CONTENT_CHUNK_SIZE = 100;
	      return this.transport.messageHandler.sendWithStream('GetTextContent', {
	        pageIndex: this.pageNumber - 1,
	        normalizeWhitespace: params.normalizeWhitespace === true,
	        combineTextItems: params.disableCombineTextItems !== true
	      }, {
	        highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
	        size: function size(textContent) {
	          return textContent.items.length;
	        }
	      });
	    },
	
	    getTextContent: function PDFPageProxy_getTextContent(params) {
	      params = params || {};
	      var readableStream = this.streamTextContent(params);
	      return new Promise(function (resolve, reject) {
	        function pump() {
	          reader.read().then(function (_ref) {
	            var value = _ref.value,
	                done = _ref.done;
	
	            if (done) {
	              resolve(textContent);
	              return;
	            }
	            _util.Util.extendObj(textContent.styles, value.styles);
	            _util.Util.appendToArray(textContent.items, value.items);
	            pump();
	          }, reject);
	        }
	        var reader = readableStream.getReader();
	        var textContent = {
	          items: [],
	          styles: Object.create(null)
	        };
	        pump();
	      });
	    },
	    _destroy: function PDFPageProxy_destroy() {
	      this.destroyed = true;
	      this.transport.pageCache[this.pageIndex] = null;
	      var waitOn = [];
	      Object.keys(this.intentStates).forEach(function (intent) {
	        if (intent === 'oplist') {
	          return;
	        }
	        var intentState = this.intentStates[intent];
	        intentState.renderTasks.forEach(function (renderTask) {
	          var renderCompleted = renderTask.capability.promise.catch(function () {});
	          waitOn.push(renderCompleted);
	          renderTask.cancel();
	        });
	      }, this);
	      this.objs.clear();
	      this.annotationsPromise = null;
	      this.pendingCleanup = false;
	      return Promise.all(waitOn);
	    },
	    destroy: function destroy() {
	      (0, _util.deprecated)('page destroy method, use cleanup() instead');
	      this.cleanup();
	    },
	
	    cleanup: function PDFPageProxy_cleanup() {
	      this.pendingCleanup = true;
	      this._tryCleanup();
	    },
	    _tryCleanup: function PDFPageProxy_tryCleanup() {
	      if (!this.pendingCleanup || Object.keys(this.intentStates).some(function (intent) {
	        var intentState = this.intentStates[intent];
	        return intentState.renderTasks.length !== 0 || intentState.receivingOperatorList;
	      }, this)) {
	        return;
	      }
	      Object.keys(this.intentStates).forEach(function (intent) {
	        delete this.intentStates[intent];
	      }, this);
	      this.objs.clear();
	      this.annotationsPromise = null;
	      this.pendingCleanup = false;
	    },
	    _startRenderPage: function PDFPageProxy_startRenderPage(transparency, intent) {
	      var intentState = this.intentStates[intent];
	      if (intentState.displayReadyCapability) {
	        intentState.displayReadyCapability.resolve(transparency);
	      }
	    },
	    _renderPageChunk: function PDFPageProxy_renderPageChunk(operatorListChunk, intent) {
	      var intentState = this.intentStates[intent];
	      var i, ii;
	      for (i = 0, ii = operatorListChunk.length; i < ii; i++) {
	        intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
	        intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
	      }
	      intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
	      for (i = 0; i < intentState.renderTasks.length; i++) {
	        intentState.renderTasks[i].operatorListChanged();
	      }
	      if (operatorListChunk.lastChunk) {
	        intentState.receivingOperatorList = false;
	        this._tryCleanup();
	      }
	    }
	  };
	  return PDFPageProxy;
	}();
	
	var LoopbackPort = function () {
	  function LoopbackPort(defer) {
	    _classCallCheck(this, LoopbackPort);
	
	    this._listeners = [];
	    this._defer = defer;
	    this._deferred = Promise.resolve(undefined);
	  }
	
	  _createClass(LoopbackPort, [{
	    key: 'postMessage',
	    value: function postMessage(obj, transfers) {
	      var _this5 = this;
	
	      function cloneValue(value) {
	        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null) {
	          return value;
	        }
	        if (cloned.has(value)) {
	          return cloned.get(value);
	        }
	        var result;
	        var buffer;
	        if ((buffer = value.buffer) && (0, _util.isArrayBuffer)(buffer)) {
	          var transferable = transfers && transfers.indexOf(buffer) >= 0;
	          if (value === buffer) {
	            result = value;
	          } else if (transferable) {
	            result = new value.constructor(buffer, value.byteOffset, value.byteLength);
	          } else {
	            result = new value.constructor(value);
	          }
	          cloned.set(value, result);
	          return result;
	        }
	        result = Array.isArray(value) ? [] : {};
	        cloned.set(value, result);
	        for (var i in value) {
	          var desc,
	              p = value;
	          while (!(desc = Object.getOwnPropertyDescriptor(p, i))) {
	            p = Object.getPrototypeOf(p);
	          }
	          if (typeof desc.value === 'undefined' || typeof desc.value === 'function') {
	            continue;
	          }
	          result[i] = cloneValue(desc.value);
	        }
	        return result;
	      }
	      if (!this._defer) {
	        this._listeners.forEach(function (listener) {
	          listener.call(this, { data: obj });
	        }, this);
	        return;
	      }
	      var cloned = new WeakMap();
	      var e = { data: cloneValue(obj) };
	      this._deferred.then(function () {
	        _this5._listeners.forEach(function (listener) {
	          listener.call(this, e);
	        }, _this5);
	      });
	    }
	  }, {
	    key: 'addEventListener',
	    value: function addEventListener(name, listener) {
	      this._listeners.push(listener);
	    }
	  }, {
	    key: 'removeEventListener',
	    value: function removeEventListener(name, listener) {
	      var i = this._listeners.indexOf(listener);
	      this._listeners.splice(i, 1);
	    }
	  }, {
	    key: 'terminate',
	    value: function terminate() {
	      this._listeners = [];
	    }
	  }]);
	
	  return LoopbackPort;
	}();
	
	var PDFWorker = function PDFWorkerClosure() {
	  var nextFakeWorkerId = 0;
	  function getWorkerSrc() {
	    if (typeof workerSrc !== 'undefined') {
	      return workerSrc;
	    }
	    if ((0, _dom_utils.getDefaultSetting)('workerSrc')) {
	      return (0, _dom_utils.getDefaultSetting)('workerSrc');
	    }
	    if (pdfjsFilePath) {
	      return pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, '.worker$1$2');
	    }
	    throw new Error('No PDFJS.workerSrc specified');
	  }
	  var fakeWorkerFilesLoadedCapability = void 0;
	  function setupFakeWorkerGlobal() {
	    var WorkerMessageHandler;
	    if (fakeWorkerFilesLoadedCapability) {
	      return fakeWorkerFilesLoadedCapability.promise;
	    }
	    fakeWorkerFilesLoadedCapability = (0, _util.createPromiseCapability)();
	    var pdfjsCoreWorker = __w_pdfjs_require__(140);
	    WorkerMessageHandler = pdfjsCoreWorker.WorkerMessageHandler;
	    fakeWorkerFilesLoadedCapability.resolve(WorkerMessageHandler);
	    return fakeWorkerFilesLoadedCapability.promise;
	  }
	  function createCDNWrapper(url) {
	    var wrapper = 'importScripts(\'' + url + '\');';
	    return URL.createObjectURL(new Blob([wrapper]));
	  }
	  var pdfWorkerPorts = new WeakMap();
	  function PDFWorker(name, port) {
	    if (port && pdfWorkerPorts.has(port)) {
	      throw new Error('Cannot use more than one PDFWorker per port');
	    }
	    this.name = name;
	    this.destroyed = false;
	    this.postMessageTransfers = true;
	    this._readyCapability = (0, _util.createPromiseCapability)();
	    this._port = null;
	    this._webWorker = null;
	    this._messageHandler = null;
	    if (port) {
	      pdfWorkerPorts.set(port, this);
	      this._initializeFromPort(port);
	      return;
	    }
	    this._initialize();
	  }
	  PDFWorker.prototype = {
	    get promise() {
	      return this._readyCapability.promise;
	    },
	    get port() {
	      return this._port;
	    },
	    get messageHandler() {
	      return this._messageHandler;
	    },
	    _initializeFromPort: function PDFWorker_initializeFromPort(port) {
	      this._port = port;
	      this._messageHandler = new _util.MessageHandler('main', 'worker', port);
	      this._messageHandler.on('ready', function () {});
	      this._readyCapability.resolve();
	    },
	    _initialize: function PDFWorker_initialize() {
	      this._setupFakeWorker();
	    },
	    _setupFakeWorker: function PDFWorker_setupFakeWorker() {
	      var _this6 = this;
	
	      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker')) {
	        (0, _util.warn)('Setting up fake worker.');
	        isWorkerDisabled = true;
	      }
	      setupFakeWorkerGlobal().then(function (WorkerMessageHandler) {
	        if (_this6.destroyed) {
	          _this6._readyCapability.reject(new Error('Worker was destroyed'));
	          return;
	        }
	        var isTypedArraysPresent = Uint8Array !== Float32Array;
	        var port = new LoopbackPort(isTypedArraysPresent);
	        _this6._port = port;
	        var id = 'fake' + nextFakeWorkerId++;
	        var workerHandler = new _util.MessageHandler(id + '_worker', id, port);
	        WorkerMessageHandler.setup(workerHandler, port);
	        var messageHandler = new _util.MessageHandler(id, id + '_worker', port);
	        _this6._messageHandler = messageHandler;
	        _this6._readyCapability.resolve();
	      });
	    },
	    destroy: function PDFWorker_destroy() {
	      this.destroyed = true;
	      if (this._webWorker) {
	        this._webWorker.terminate();
	        this._webWorker = null;
	      }
	      pdfWorkerPorts.delete(this._port);
	      this._port = null;
	      if (this._messageHandler) {
	        this._messageHandler.destroy();
	        this._messageHandler = null;
	      }
	    }
	  };
	  PDFWorker.fromPort = function (port) {
	    if (pdfWorkerPorts.has(port)) {
	      return pdfWorkerPorts.get(port);
	    }
	    return new PDFWorker(null, port);
	  };
	  return PDFWorker;
	}();
	var WorkerTransport = function WorkerTransportClosure() {
	  function WorkerTransport(messageHandler, loadingTask, networkStream, CMapReaderFactory) {
	    this.messageHandler = messageHandler;
	    this.loadingTask = loadingTask;
	    this.commonObjs = new PDFObjects();
	    this.fontLoader = new _font_loader.FontLoader(loadingTask.docId);
	    this.CMapReaderFactory = new CMapReaderFactory({
	      baseUrl: (0, _dom_utils.getDefaultSetting)('cMapUrl'),
	      isCompressed: (0, _dom_utils.getDefaultSetting)('cMapPacked')
	    });
	    this.destroyed = false;
	    this.destroyCapability = null;
	    this._passwordCapability = null;
	    this._networkStream = networkStream;
	    this._fullReader = null;
	    this._lastProgress = null;
	    this.pageCache = [];
	    this.pagePromises = [];
	    this.downloadInfoCapability = (0, _util.createPromiseCapability)();
	    this.setupMessageHandler();
	  }
	  WorkerTransport.prototype = {
	    destroy: function WorkerTransport_destroy() {
	      var _this7 = this;
	
	      if (this.destroyCapability) {
	        return this.destroyCapability.promise;
	      }
	      this.destroyed = true;
	      this.destroyCapability = (0, _util.createPromiseCapability)();
	      if (this._passwordCapability) {
	        this._passwordCapability.reject(new Error('Worker was destroyed during onPassword callback'));
	      }
	      var waitOn = [];
	      this.pageCache.forEach(function (page) {
	        if (page) {
	          waitOn.push(page._destroy());
	        }
	      });
	      this.pageCache = [];
	      this.pagePromises = [];
	      var terminated = this.messageHandler.sendWithPromise('Terminate', null);
	      waitOn.push(terminated);
	      Promise.all(waitOn).then(function () {
	        _this7.fontLoader.clear();
	        if (_this7._networkStream) {
	          _this7._networkStream.cancelAllRequests();
	        }
	        if (_this7.messageHandler) {
	          _this7.messageHandler.destroy();
	          _this7.messageHandler = null;
	        }
	        _this7.destroyCapability.resolve();
	      }, this.destroyCapability.reject);
	      return this.destroyCapability.promise;
	    },
	    setupMessageHandler: function WorkerTransport_setupMessageHandler() {
	      var messageHandler = this.messageHandler;
	      var loadingTask = this.loadingTask;
	      messageHandler.on('GetReader', function (data, sink) {
	        var _this8 = this;
	
	        (0, _util.assert)(this._networkStream);
	        this._fullReader = this._networkStream.getFullReader();
	        this._fullReader.onProgress = function (evt) {
	          _this8._lastProgress = {
	            loaded: evt.loaded,
	            total: evt.total
	          };
	        };
	        sink.onPull = function () {
	          _this8._fullReader.read().then(function (_ref2) {
	            var value = _ref2.value,
	                done = _ref2.done;
	
	            if (done) {
	              sink.close();
	              return;
	            }
	            (0, _util.assert)((0, _util.isArrayBuffer)(value));
	            sink.enqueue(new Uint8Array(value), 1, [value]);
	          }).catch(function (reason) {
	            sink.error(reason);
	          });
	        };
	        sink.onCancel = function (reason) {
	          _this8._fullReader.cancel(reason);
	        };
	      }, this);
	      messageHandler.on('ReaderHeadersReady', function (data) {
	        var _this9 = this;
	
	        var headersCapability = (0, _util.createPromiseCapability)();
	        var fullReader = this._fullReader;
	        fullReader.headersReady.then(function () {
	          if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
	            if (_this9._lastProgress) {
	              var _loadingTask = _this9.loadingTask;
	              if (_loadingTask.onProgress) {
	                _loadingTask.onProgress(_this9._lastProgress);
	              }
	            }
	            fullReader.onProgress = function (evt) {
	              var loadingTask = _this9.loadingTask;
	              if (loadingTask.onProgress) {
	                loadingTask.onProgress({
	                  loaded: evt.loaded,
	                  total: evt.total
	                });
	              }
	            };
	          }
	          headersCapability.resolve({
	            isStreamingSupported: fullReader.isStreamingSupported,
	            isRangeSupported: fullReader.isRangeSupported,
	            contentLength: fullReader.contentLength
	          });
	        }, headersCapability.reject);
	        return headersCapability.promise;
	      }, this);
	      messageHandler.on('GetRangeReader', function (data, sink) {
	        (0, _util.assert)(this._networkStream);
	        var _rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
	        sink.onPull = function () {
	          _rangeReader.read().then(function (_ref3) {
	            var value = _ref3.value,
	                done = _ref3.done;
	
	            if (done) {
	              sink.close();
	              return;
	            }
	            (0, _util.assert)((0, _util.isArrayBuffer)(value));
	            sink.enqueue(new Uint8Array(value), 1, [value]);
	          }).catch(function (reason) {
	            sink.error(reason);
	          });
	        };
	        sink.onCancel = function (reason) {
	          _rangeReader.cancel(reason);
	        };
	      }, this);
	      messageHandler.on('GetDoc', function transportDoc(data) {
	        var pdfInfo = data.pdfInfo;
	        this.numPages = data.pdfInfo.numPages;
	        var loadingTask = this.loadingTask;
	        var pdfDocument = new PDFDocumentProxy(pdfInfo, this, loadingTask);
	        this.pdfDocument = pdfDocument;
	        loadingTask._capability.resolve(pdfDocument);
	      }, this);
	      messageHandler.on('PasswordRequest', function transportPasswordRequest(exception) {
	        var _this10 = this;
	
	        this._passwordCapability = (0, _util.createPromiseCapability)();
	        if (loadingTask.onPassword) {
	          var updatePassword = function updatePassword(password) {
	            _this10._passwordCapability.resolve({ password: password });
	          };
	          loadingTask.onPassword(updatePassword, exception.code);
	        } else {
	          this._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
	        }
	        return this._passwordCapability.promise;
	      }, this);
	      messageHandler.on('PasswordException', function transportPasswordException(exception) {
	        loadingTask._capability.reject(new _util.PasswordException(exception.message, exception.code));
	      }, this);
	      messageHandler.on('InvalidPDF', function transportInvalidPDF(exception) {
	        this.loadingTask._capability.reject(new _util.InvalidPDFException(exception.message));
	      }, this);
	      messageHandler.on('MissingPDF', function transportMissingPDF(exception) {
	        this.loadingTask._capability.reject(new _util.MissingPDFException(exception.message));
	      }, this);
	      messageHandler.on('UnexpectedResponse', function transportUnexpectedResponse(exception) {
	        this.loadingTask._capability.reject(new _util.UnexpectedResponseException(exception.message, exception.status));
	      }, this);
	      messageHandler.on('UnknownError', function transportUnknownError(exception) {
	        this.loadingTask._capability.reject(new _util.UnknownErrorException(exception.message, exception.details));
	      }, this);
	      messageHandler.on('DataLoaded', function transportPage(data) {
	        this.downloadInfoCapability.resolve(data);
	      }, this);
	      messageHandler.on('PDFManagerReady', function transportPage(data) {}, this);
	      messageHandler.on('StartRenderPage', function transportRender(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var page = this.pageCache[data.pageIndex];
	        page.stats.timeEnd('Page Request');
	        page._startRenderPage(data.transparency, data.intent);
	      }, this);
	      messageHandler.on('RenderPageChunk', function transportRender(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var page = this.pageCache[data.pageIndex];
	        page._renderPageChunk(data.operatorList, data.intent);
	      }, this);
	      messageHandler.on('commonobj', function transportObj(data) {
	        var _this11 = this;
	
	        if (this.destroyed) {
	          return;
	        }
	        var id = data[0];
	        var type = data[1];
	        if (this.commonObjs.hasData(id)) {
	          return;
	        }
	        switch (type) {
	          case 'Font':
	            var exportedData = data[2];
	            if ('error' in exportedData) {
	              var exportedError = exportedData.error;
	              (0, _util.warn)('Error during font loading: ' + exportedError);
	              this.commonObjs.resolve(id, exportedError);
	              break;
	            }
	            var fontRegistry = null;
	            if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _global_scope2.default.FontInspector && _global_scope2.default['FontInspector'].enabled) {
	              fontRegistry = {
	                registerFont: function registerFont(font, url) {
	                  _global_scope2.default['FontInspector'].fontAdded(font, url);
	                }
	              };
	            }
	            var font = new _font_loader.FontFaceObject(exportedData, {
	              isEvalSupported: (0, _dom_utils.getDefaultSetting)('isEvalSupported'),
	              disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
	              fontRegistry: fontRegistry
	            });
	            var fontReady = function fontReady(fontObjs) {
	              _this11.commonObjs.resolve(id, font);
	            };
	            this.fontLoader.bind([font], fontReady);
	            break;
	          case 'FontPath':
	            this.commonObjs.resolve(id, data[2]);
	            break;
	          default:
	            throw new Error('Got unknown common object type ' + type);
	        }
	      }, this);
	      messageHandler.on('obj', function transportObj(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var id = data[0];
	        var pageIndex = data[1];
	        var type = data[2];
	        var pageProxy = this.pageCache[pageIndex];
	        var imageData;
	        if (pageProxy.objs.hasData(id)) {
	          return;
	        }
	        switch (type) {
	          case 'JpegStream':
	            imageData = data[3];
	            (0, _util.loadJpegStream)(id, imageData, pageProxy.objs);
	            break;
	          case 'Image':
	            imageData = data[3];
	            pageProxy.objs.resolve(id, imageData);
	            var MAX_IMAGE_SIZE_TO_STORE = 8000000;
	            if (imageData && 'data' in imageData && imageData.data.length > MAX_IMAGE_SIZE_TO_STORE) {
	              pageProxy.cleanupAfterRender = true;
	            }
	            break;
	          default:
	            throw new Error('Got unknown object type ' + type);
	        }
	      }, this);
	      messageHandler.on('DocProgress', function transportDocProgress(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var loadingTask = this.loadingTask;
	        if (loadingTask.onProgress) {
	          loadingTask.onProgress({
	            loaded: data.loaded,
	            total: data.total
	          });
	        }
	      }, this);
	      messageHandler.on('PageError', function transportError(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var page = this.pageCache[data.pageNum - 1];
	        var intentState = page.intentStates[data.intent];
	        if (intentState.displayReadyCapability) {
	          intentState.displayReadyCapability.reject(data.error);
	        } else {
	          throw new Error(data.error);
	        }
	        if (intentState.operatorList) {
	          intentState.operatorList.lastChunk = true;
	          for (var i = 0; i < intentState.renderTasks.length; i++) {
	            intentState.renderTasks[i].operatorListChanged();
	          }
	        }
	      }, this);
	      messageHandler.on('UnsupportedFeature', function transportUnsupportedFeature(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var featureId = data.featureId;
	        var loadingTask = this.loadingTask;
	        if (loadingTask.onUnsupportedFeature) {
	          loadingTask.onUnsupportedFeature(featureId);
	        }
	        _UnsupportedManager.notify(featureId);
	      }, this);
	      messageHandler.on('JpegDecode', function (data) {
	        if (this.destroyed) {
	          return Promise.reject(new Error('Worker was destroyed'));
	        }
	        if (typeof document === 'undefined') {
	          return Promise.reject(new Error('"document" is not defined.'));
	        }
	        var imageUrl = data[0];
	        var components = data[1];
	        if (components !== 3 && components !== 1) {
	          return Promise.reject(new Error('Only 3 components or 1 component can be returned'));
	        }
	        return new Promise(function (resolve, reject) {
	          var img = new Image();
	          img.onload = function () {
	            var width = img.width;
	            var height = img.height;
	            var size = width * height;
	            var rgbaLength = size * 4;
	            var buf = new Uint8Array(size * components);
	            var tmpCanvas = document.createElement('canvas');
	            tmpCanvas.width = width;
	            tmpCanvas.height = height;
	            var tmpCtx = tmpCanvas.getContext('2d');
	            tmpCtx.drawImage(img, 0, 0);
	            var data = tmpCtx.getImageData(0, 0, width, height).data;
	            var i, j;
	            if (components === 3) {
	              for (i = 0, j = 0; i < rgbaLength; i += 4, j += 3) {
	                buf[j] = data[i];
	                buf[j + 1] = data[i + 1];
	                buf[j + 2] = data[i + 2];
	              }
	            } else if (components === 1) {
	              for (i = 0, j = 0; i < rgbaLength; i += 4, j++) {
	                buf[j] = data[i];
	              }
	            }
	            resolve({
	              data: buf,
	              width: width,
	              height: height
	            });
	          };
	          img.onerror = function () {
	            reject(new Error('JpegDecode failed to load image'));
	          };
	          img.src = imageUrl;
	        });
	      }, this);
	      messageHandler.on('FetchBuiltInCMap', function (data) {
	        if (this.destroyed) {
	          return Promise.reject(new Error('Worker was destroyed'));
	        }
	        return this.CMapReaderFactory.fetch({ name: data.name });
	      }, this);
	    },
	    getData: function WorkerTransport_getData() {
	      return this.messageHandler.sendWithPromise('GetData', null);
	    },
	    getPage: function WorkerTransport_getPage(pageNumber, capability) {
	      var _this12 = this;
	
	      if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this.numPages) {
	        return Promise.reject(new Error('Invalid page request'));
	      }
	      var pageIndex = pageNumber - 1;
	      if (pageIndex in this.pagePromises) {
	        return this.pagePromises[pageIndex];
	      }
	      var promise = this.messageHandler.sendWithPromise('GetPage', { pageIndex: pageIndex }).then(function (pageInfo) {
	        if (_this12.destroyed) {
	          throw new Error('Transport destroyed');
	        }
	        var page = new PDFPageProxy(pageIndex, pageInfo, _this12);
	        _this12.pageCache[pageIndex] = page;
	        return page;
	      });
	      this.pagePromises[pageIndex] = promise;
	      return promise;
	    },
	    getPageIndex: function WorkerTransport_getPageIndexByRef(ref) {
	      return this.messageHandler.sendWithPromise('GetPageIndex', { ref: ref }).catch(function (reason) {
	        return Promise.reject(new Error(reason));
	      });
	    },
	    getAnnotations: function WorkerTransport_getAnnotations(pageIndex, intent) {
	      return this.messageHandler.sendWithPromise('GetAnnotations', {
	        pageIndex: pageIndex,
	        intent: intent
	      });
	    },
	    getDestinations: function WorkerTransport_getDestinations() {
	      return this.messageHandler.sendWithPromise('GetDestinations', null);
	    },
	    getDestination: function WorkerTransport_getDestination(id) {
	      return this.messageHandler.sendWithPromise('GetDestination', { id: id });
	    },
	    getPageLabels: function WorkerTransport_getPageLabels() {
	      return this.messageHandler.sendWithPromise('GetPageLabels', null);
	    },
	    getPageMode: function getPageMode() {
	      return this.messageHandler.sendWithPromise('GetPageMode', null);
	    },
	
	    getAttachments: function WorkerTransport_getAttachments() {
	      return this.messageHandler.sendWithPromise('GetAttachments', null);
	    },
	    getJavaScript: function WorkerTransport_getJavaScript() {
	      return this.messageHandler.sendWithPromise('GetJavaScript', null);
	    },
	    getOutline: function WorkerTransport_getOutline() {
	      return this.messageHandler.sendWithPromise('GetOutline', null);
	    },
	    getMetadata: function WorkerTransport_getMetadata() {
	      return this.messageHandler.sendWithPromise('GetMetadata', null).then(function transportMetadata(results) {
	        return {
	          info: results[0],
	          metadata: results[1] ? new _metadata.Metadata(results[1]) : null
	        };
	      });
	    },
	    getStats: function WorkerTransport_getStats() {
	      return this.messageHandler.sendWithPromise('GetStats', null);
	    },
	    startCleanup: function WorkerTransport_startCleanup() {
	      var _this13 = this;
	
	      this.messageHandler.sendWithPromise('Cleanup', null).then(function () {
	        for (var i = 0, ii = _this13.pageCache.length; i < ii; i++) {
	          var page = _this13.pageCache[i];
	          if (page) {
	            page.cleanup();
	          }
	        }
	        _this13.commonObjs.clear();
	        _this13.fontLoader.clear();
	      });
	    }
	  };
	  return WorkerTransport;
	}();
	var PDFObjects = function PDFObjectsClosure() {
	  function PDFObjects() {
	    this.objs = Object.create(null);
	  }
	  PDFObjects.prototype = {
	    ensureObj: function PDFObjects_ensureObj(objId) {
	      if (this.objs[objId]) {
	        return this.objs[objId];
	      }
	      var obj = {
	        capability: (0, _util.createPromiseCapability)(),
	        data: null,
	        resolved: false
	      };
	      this.objs[objId] = obj;
	      return obj;
	    },
	    get: function PDFObjects_get(objId, callback) {
	      if (callback) {
	        this.ensureObj(objId).capability.promise.then(callback);
	        return null;
	      }
	      var obj = this.objs[objId];
	      if (!obj || !obj.resolved) {
	        throw new Error('Requesting object that isn\'t resolved yet ' + objId);
	      }
	      return obj.data;
	    },
	    resolve: function PDFObjects_resolve(objId, data) {
	      var obj = this.ensureObj(objId);
	      obj.resolved = true;
	      obj.data = data;
	      obj.capability.resolve(data);
	    },
	    isResolved: function PDFObjects_isResolved(objId) {
	      var objs = this.objs;
	      if (!objs[objId]) {
	        return false;
	      }
	      return objs[objId].resolved;
	    },
	    hasData: function PDFObjects_hasData(objId) {
	      return this.isResolved(objId);
	    },
	    getData: function PDFObjects_getData(objId) {
	      var objs = this.objs;
	      if (!objs[objId] || !objs[objId].resolved) {
	        return null;
	      }
	      return objs[objId].data;
	    },
	    clear: function PDFObjects_clear() {
	      this.objs = Object.create(null);
	    }
	  };
	  return PDFObjects;
	}();
	var RenderTask = function RenderTaskClosure() {
	  function RenderTask(internalRenderTask) {
	    this._internalRenderTask = internalRenderTask;
	    this.onContinue = null;
	  }
	  RenderTask.prototype = {
	    get promise() {
	      return this._internalRenderTask.capability.promise;
	    },
	    cancel: function RenderTask_cancel() {
	      this._internalRenderTask.cancel();
	    },
	    then: function RenderTask_then(onFulfilled, onRejected) {
	      return this.promise.then.apply(this.promise, arguments);
	    }
	  };
	  return RenderTask;
	}();
	var InternalRenderTask = function InternalRenderTaskClosure() {
	  var canvasInRendering = new WeakMap();
	  function InternalRenderTask(callback, params, objs, commonObjs, operatorList, pageNumber, canvasFactory) {
	    this.callback = callback;
	    this.params = params;
	    this.objs = objs;
	    this.commonObjs = commonObjs;
	    this.operatorListIdx = null;
	    this.operatorList = operatorList;
	    this.pageNumber = pageNumber;
	    this.canvasFactory = canvasFactory;
	    this.running = false;
	    this.graphicsReadyCallback = null;
	    this.graphicsReady = false;
	    this.useRequestAnimationFrame = false;
	    this.cancelled = false;
	    this.capability = (0, _util.createPromiseCapability)();
	    this.task = new RenderTask(this);
	    this._continueBound = this._continue.bind(this);
	    this._scheduleNextBound = this._scheduleNext.bind(this);
	    this._nextBound = this._next.bind(this);
	    this._canvas = params.canvasContext.canvas;
	  }
	  InternalRenderTask.prototype = {
	    initializeGraphics: function InternalRenderTask_initializeGraphics(transparency) {
	      if (this._canvas) {
	        if (canvasInRendering.has(this._canvas)) {
	          throw new Error('Cannot use the same canvas during multiple render() operations. ' + 'Use different canvas or ensure previous operations were ' + 'cancelled or completed.');
	        }
	        canvasInRendering.set(this._canvas, this);
	      }
	      if (this.cancelled) {
	        return;
	      }
	      if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _global_scope2.default.StepperManager && _global_scope2.default.StepperManager.enabled) {
	        this.stepper = _global_scope2.default.StepperManager.create(this.pageNumber - 1);
	        this.stepper.init(this.operatorList);
	        this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
	      }
	      var params = this.params;
	      this.gfx = new _canvas.CanvasGraphics(params.canvasContext, this.commonObjs, this.objs, this.canvasFactory, params.imageLayer);
	      this.gfx.beginDrawing({
	        transform: params.transform,
	        viewport: params.viewport,
	        transparency: transparency,
	        background: params.background
	      });
	      this.operatorListIdx = 0;
	      this.graphicsReady = true;
	      if (this.graphicsReadyCallback) {
	        this.graphicsReadyCallback();
	      }
	    },
	    cancel: function InternalRenderTask_cancel() {
	      this.running = false;
	      this.cancelled = true;
	      if (this._canvas) {
	        canvasInRendering.delete(this._canvas);
	      }
	      if ((0, _dom_utils.getDefaultSetting)('pdfjsNext')) {
	        this.callback(new _dom_utils.RenderingCancelledException('Rendering cancelled, page ' + this.pageNumber, 'canvas'));
	      } else {
	        this.callback('cancelled');
	      }
	    },
	    operatorListChanged: function InternalRenderTask_operatorListChanged() {
	      if (!this.graphicsReady) {
	        if (!this.graphicsReadyCallback) {
	          this.graphicsReadyCallback = this._continueBound;
	        }
	        return;
	      }
	      if (this.stepper) {
	        this.stepper.updateOperatorList(this.operatorList);
	      }
	      if (this.running) {
	        return;
	      }
	      this._continue();
	    },
	    _continue: function InternalRenderTask__continue() {
	      this.running = true;
	      if (this.cancelled) {
	        return;
	      }
	      if (this.task.onContinue) {
	        this.task.onContinue(this._scheduleNextBound);
	      } else {
	        this._scheduleNext();
	      }
	    },
	    _scheduleNext: function InternalRenderTask__scheduleNext() {
	      if (this.useRequestAnimationFrame && typeof window !== 'undefined') {
	        window.requestAnimationFrame(this._nextBound);
	      } else {
	        Promise.resolve(undefined).then(this._nextBound);
	      }
	    },
	    _next: function InternalRenderTask__next() {
	      if (this.cancelled) {
	        return;
	      }
	      this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
	      if (this.operatorListIdx === this.operatorList.argsArray.length) {
	        this.running = false;
	        if (this.operatorList.lastChunk) {
	          this.gfx.endDrawing();
	          if (this._canvas) {
	            canvasInRendering.delete(this._canvas);
	          }
	          this.callback();
	        }
	      }
	    }
	  };
	  return InternalRenderTask;
	}();
	var _UnsupportedManager = function UnsupportedManagerClosure() {
	  var listeners = [];
	  return {
	    listen: function listen(cb) {
	      (0, _util.deprecated)('Global UnsupportedManager.listen is used: ' + ' use PDFDocumentLoadingTask.onUnsupportedFeature instead');
	      listeners.push(cb);
	    },
	    notify: function notify(featureId) {
	      for (var i = 0, ii = listeners.length; i < ii; i++) {
	        listeners[i](featureId);
	      }
	    }
	  };
	}();
	var version, build;
	{
	  exports.version = version = '1.10.100';
	  exports.build = build = 'ea29ec83';
	}
	exports.getDocument = getDocument;
	exports.LoopbackPort = LoopbackPort;
	exports.PDFDataRangeTransport = PDFDataRangeTransport;
	exports.PDFWorker = PDFWorker;
	exports.PDFDocumentProxy = PDFDocumentProxy;
	exports.PDFPageProxy = PDFPageProxy;
	exports.setPDFNetworkStreamClass = setPDFNetworkStreamClass;
	exports._UnsupportedManager = _UnsupportedManager;
	exports.version = version;
	exports.build = build;
	
	/***/ }),
	/* 76 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WebGLUtils = undefined;
	
	var _dom_utils = __w_pdfjs_require__(17);
	
	var _util = __w_pdfjs_require__(0);
	
	var WebGLUtils = function WebGLUtilsClosure() {
	  function loadShader(gl, code, shaderType) {
	    var shader = gl.createShader(shaderType);
	    gl.shaderSource(shader, code);
	    gl.compileShader(shader);
	    var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
	    if (!compiled) {
	      var errorMsg = gl.getShaderInfoLog(shader);
	      throw new Error('Error during shader compilation: ' + errorMsg);
	    }
	    return shader;
	  }
	  function createVertexShader(gl, code) {
	    return loadShader(gl, code, gl.VERTEX_SHADER);
	  }
	  function createFragmentShader(gl, code) {
	    return loadShader(gl, code, gl.FRAGMENT_SHADER);
	  }
	  function createProgram(gl, shaders) {
	    var program = gl.createProgram();
	    for (var i = 0, ii = shaders.length; i < ii; ++i) {
	      gl.attachShader(program, shaders[i]);
	    }
	    gl.linkProgram(program);
	    var linked = gl.getProgramParameter(program, gl.LINK_STATUS);
	    if (!linked) {
	      var errorMsg = gl.getProgramInfoLog(program);
	      throw new Error('Error during program linking: ' + errorMsg);
	    }
	    return program;
	  }
	  function createTexture(gl, image, textureId) {
	    gl.activeTexture(textureId);
	    var texture = gl.createTexture();
	    gl.bindTexture(gl.TEXTURE_2D, texture);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
	    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
	    return texture;
	  }
	  var currentGL, currentCanvas;
	  function generateGL() {
	    if (currentGL) {
	      return;
	    }
	    currentCanvas = document.createElement('canvas');
	    currentGL = currentCanvas.getContext('webgl', { premultipliedalpha: false });
	  }
	  var smaskVertexShaderCode = '\
	  attribute vec2 a_position;                                    \
	  attribute vec2 a_texCoord;                                    \
	                                                                \
	  uniform vec2 u_resolution;                                    \
	                                                                \
	  varying vec2 v_texCoord;                                      \
	                                                                \
	  void main() {                                                 \
	    vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;   \
	    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
	                                                                \
	    v_texCoord = a_texCoord;                                    \
	  }                                                             ';
	  var smaskFragmentShaderCode = '\
	  precision mediump float;                                      \
	                                                                \
	  uniform vec4 u_backdrop;                                      \
	  uniform int u_subtype;                                        \
	  uniform sampler2D u_image;                                    \
	  uniform sampler2D u_mask;                                     \
	                                                                \
	  varying vec2 v_texCoord;                                      \
	                                                                \
	  void main() {                                                 \
	    vec4 imageColor = texture2D(u_image, v_texCoord);           \
	    vec4 maskColor = texture2D(u_mask, v_texCoord);             \
	    if (u_backdrop.a > 0.0) {                                   \
	      maskColor.rgb = maskColor.rgb * maskColor.a +             \
	                      u_backdrop.rgb * (1.0 - maskColor.a);     \
	    }                                                           \
	    float lum;                                                  \
	    if (u_subtype == 0) {                                       \
	      lum = maskColor.a;                                        \
	    } else {                                                    \
	      lum = maskColor.r * 0.3 + maskColor.g * 0.59 +            \
	            maskColor.b * 0.11;                                 \
	    }                                                           \
	    imageColor.a *= lum;                                        \
	    imageColor.rgb *= imageColor.a;                             \
	    gl_FragColor = imageColor;                                  \
	  }                                                             ';
	  var smaskCache = null;
	  function initSmaskGL() {
	    var canvas, gl;
	    generateGL();
	    canvas = currentCanvas;
	    currentCanvas = null;
	    gl = currentGL;
	    currentGL = null;
	    var vertexShader = createVertexShader(gl, smaskVertexShaderCode);
	    var fragmentShader = createFragmentShader(gl, smaskFragmentShaderCode);
	    var program = createProgram(gl, [vertexShader, fragmentShader]);
	    gl.useProgram(program);
	    var cache = {};
	    cache.gl = gl;
	    cache.canvas = canvas;
	    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
	    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
	    cache.backdropLocation = gl.getUniformLocation(program, 'u_backdrop');
	    cache.subtypeLocation = gl.getUniformLocation(program, 'u_subtype');
	    var texCoordLocation = gl.getAttribLocation(program, 'a_texCoord');
	    var texLayerLocation = gl.getUniformLocation(program, 'u_image');
	    var texMaskLocation = gl.getUniformLocation(program, 'u_mask');
	    var texCoordBuffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0]), gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(texCoordLocation);
	    gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);
	    gl.uniform1i(texLayerLocation, 0);
	    gl.uniform1i(texMaskLocation, 1);
	    smaskCache = cache;
	  }
	  function composeSMask(layer, mask, properties) {
	    var width = layer.width,
	        height = layer.height;
	    if (!smaskCache) {
	      initSmaskGL();
	    }
	    var cache = smaskCache,
	        canvas = cache.canvas,
	        gl = cache.gl;
	    canvas.width = width;
	    canvas.height = height;
	    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
	    gl.uniform2f(cache.resolutionLocation, width, height);
	    if (properties.backdrop) {
	      gl.uniform4f(cache.resolutionLocation, properties.backdrop[0], properties.backdrop[1], properties.backdrop[2], 1);
	    } else {
	      gl.uniform4f(cache.resolutionLocation, 0, 0, 0, 0);
	    }
	    gl.uniform1i(cache.subtypeLocation, properties.subtype === 'Luminosity' ? 1 : 0);
	    var texture = createTexture(gl, layer, gl.TEXTURE0);
	    var maskTexture = createTexture(gl, mask, gl.TEXTURE1);
	    var buffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
	    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, width, 0, 0, height, 0, height, width, 0, width, height]), gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(cache.positionLocation);
	    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
	    gl.clearColor(0, 0, 0, 0);
	    gl.enable(gl.BLEND);
	    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
	    gl.clear(gl.COLOR_BUFFER_BIT);
	    gl.drawArrays(gl.TRIANGLES, 0, 6);
	    gl.flush();
	    gl.deleteTexture(texture);
	    gl.deleteTexture(maskTexture);
	    gl.deleteBuffer(buffer);
	    return canvas;
	  }
	  var figuresVertexShaderCode = '\
	  attribute vec2 a_position;                                    \
	  attribute vec3 a_color;                                       \
	                                                                \
	  uniform vec2 u_resolution;                                    \
	  uniform vec2 u_scale;                                         \
	  uniform vec2 u_offset;                                        \
	                                                                \
	  varying vec4 v_color;                                         \
	                                                                \
	  void main() {                                                 \
	    vec2 position = (a_position + u_offset) * u_scale;          \
	    vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;     \
	    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
	                                                                \
	    v_color = vec4(a_color / 255.0, 1.0);                       \
	  }                                                             ';
	  var figuresFragmentShaderCode = '\
	  precision mediump float;                                      \
	                                                                \
	  varying vec4 v_color;                                         \
	                                                                \
	  void main() {                                                 \
	    gl_FragColor = v_color;                                     \
	  }                                                             ';
	  var figuresCache = null;
	  function initFiguresGL() {
	    var canvas, gl;
	    generateGL();
	    canvas = currentCanvas;
	    currentCanvas = null;
	    gl = currentGL;
	    currentGL = null;
	    var vertexShader = createVertexShader(gl, figuresVertexShaderCode);
	    var fragmentShader = createFragmentShader(gl, figuresFragmentShaderCode);
	    var program = createProgram(gl, [vertexShader, fragmentShader]);
	    gl.useProgram(program);
	    var cache = {};
	    cache.gl = gl;
	    cache.canvas = canvas;
	    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
	    cache.scaleLocation = gl.getUniformLocation(program, 'u_scale');
	    cache.offsetLocation = gl.getUniformLocation(program, 'u_offset');
	    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
	    cache.colorLocation = gl.getAttribLocation(program, 'a_color');
	    figuresCache = cache;
	  }
	  function drawFigures(width, height, backgroundColor, figures, context) {
	    if (!figuresCache) {
	      initFiguresGL();
	    }
	    var cache = figuresCache,
	        canvas = cache.canvas,
	        gl = cache.gl;
	    canvas.width = width;
	    canvas.height = height;
	    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
	    gl.uniform2f(cache.resolutionLocation, width, height);
	    var count = 0;
	    var i, ii, rows;
	    for (i = 0, ii = figures.length; i < ii; i++) {
	      switch (figures[i].type) {
	        case 'lattice':
	          rows = figures[i].coords.length / figures[i].verticesPerRow | 0;
	          count += (rows - 1) * (figures[i].verticesPerRow - 1) * 6;
	          break;
	        case 'triangles':
	          count += figures[i].coords.length;
	          break;
	      }
	    }
	    var coords = new Float32Array(count * 2);
	    var colors = new Uint8Array(count * 3);
	    var coordsMap = context.coords,
	        colorsMap = context.colors;
	    var pIndex = 0,
	        cIndex = 0;
	    for (i = 0, ii = figures.length; i < ii; i++) {
	      var figure = figures[i],
	          ps = figure.coords,
	          cs = figure.colors;
	      switch (figure.type) {
	        case 'lattice':
	          var cols = figure.verticesPerRow;
	          rows = ps.length / cols | 0;
	          for (var row = 1; row < rows; row++) {
	            var offset = row * cols + 1;
	            for (var col = 1; col < cols; col++, offset++) {
	              coords[pIndex] = coordsMap[ps[offset - cols - 1]];
	              coords[pIndex + 1] = coordsMap[ps[offset - cols - 1] + 1];
	              coords[pIndex + 2] = coordsMap[ps[offset - cols]];
	              coords[pIndex + 3] = coordsMap[ps[offset - cols] + 1];
	              coords[pIndex + 4] = coordsMap[ps[offset - 1]];
	              coords[pIndex + 5] = coordsMap[ps[offset - 1] + 1];
	              colors[cIndex] = colorsMap[cs[offset - cols - 1]];
	              colors[cIndex + 1] = colorsMap[cs[offset - cols - 1] + 1];
	              colors[cIndex + 2] = colorsMap[cs[offset - cols - 1] + 2];
	              colors[cIndex + 3] = colorsMap[cs[offset - cols]];
	              colors[cIndex + 4] = colorsMap[cs[offset - cols] + 1];
	              colors[cIndex + 5] = colorsMap[cs[offset - cols] + 2];
	              colors[cIndex + 6] = colorsMap[cs[offset - 1]];
	              colors[cIndex + 7] = colorsMap[cs[offset - 1] + 1];
	              colors[cIndex + 8] = colorsMap[cs[offset - 1] + 2];
	              coords[pIndex + 6] = coords[pIndex + 2];
	              coords[pIndex + 7] = coords[pIndex + 3];
	              coords[pIndex + 8] = coords[pIndex + 4];
	              coords[pIndex + 9] = coords[pIndex + 5];
	              coords[pIndex + 10] = coordsMap[ps[offset]];
	              coords[pIndex + 11] = coordsMap[ps[offset] + 1];
	              colors[cIndex + 9] = colors[cIndex + 3];
	              colors[cIndex + 10] = colors[cIndex + 4];
	              colors[cIndex + 11] = colors[cIndex + 5];
	              colors[cIndex + 12] = colors[cIndex + 6];
	              colors[cIndex + 13] = colors[cIndex + 7];
	              colors[cIndex + 14] = colors[cIndex + 8];
	              colors[cIndex + 15] = colorsMap[cs[offset]];
	              colors[cIndex + 16] = colorsMap[cs[offset] + 1];
	              colors[cIndex + 17] = colorsMap[cs[offset] + 2];
	              pIndex += 12;
	              cIndex += 18;
	            }
	          }
	          break;
	        case 'triangles':
	          for (var j = 0, jj = ps.length; j < jj; j++) {
	            coords[pIndex] = coordsMap[ps[j]];
	            coords[pIndex + 1] = coordsMap[ps[j] + 1];
	            colors[cIndex] = colorsMap[cs[j]];
	            colors[cIndex + 1] = colorsMap[cs[j] + 1];
	            colors[cIndex + 2] = colorsMap[cs[j] + 2];
	            pIndex += 2;
	            cIndex += 3;
	          }
	          break;
	      }
	    }
	    if (backgroundColor) {
	      gl.clearColor(backgroundColor[0] / 255, backgroundColor[1] / 255, backgroundColor[2] / 255, 1.0);
	    } else {
	      gl.clearColor(0, 0, 0, 0);
	    }
	    gl.clear(gl.COLOR_BUFFER_BIT);
	    var coordsBuffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, coordsBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, coords, gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(cache.positionLocation);
	    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
	    var colorsBuffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, colorsBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, colors, gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(cache.colorLocation);
	    gl.vertexAttribPointer(cache.colorLocation, 3, gl.UNSIGNED_BYTE, false, 0, 0);
	    gl.uniform2f(cache.scaleLocation, context.scaleX, context.scaleY);
	    gl.uniform2f(cache.offsetLocation, context.offsetX, context.offsetY);
	    gl.drawArrays(gl.TRIANGLES, 0, count);
	    gl.flush();
	    gl.deleteBuffer(coordsBuffer);
	    gl.deleteBuffer(colorsBuffer);
	    return canvas;
	  }
	  function cleanup() {
	    if (smaskCache && smaskCache.canvas) {
	      smaskCache.canvas.width = 0;
	      smaskCache.canvas.height = 0;
	    }
	    if (figuresCache && figuresCache.canvas) {
	      figuresCache.canvas.width = 0;
	      figuresCache.canvas.height = 0;
	    }
	    smaskCache = null;
	    figuresCache = null;
	  }
	  return {
	    get isEnabled() {
	      if ((0, _dom_utils.getDefaultSetting)('disableWebGL')) {
	        return false;
	      }
	      var enabled = false;
	      try {
	        generateGL();
	        enabled = !!currentGL;
	      } catch (e) {}
	      return (0, _util.shadow)(this, 'isEnabled', enabled);
	    },
	    composeSMask: composeSMask,
	    drawFigures: drawFigures,
	    clear: cleanup
	  };
	}();
	exports.WebGLUtils = WebGLUtils;
	
	/***/ }),
	/* 77 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Metadata = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __w_pdfjs_require__(0);
	
	var _xml_parser = __w_pdfjs_require__(138);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Metadata = function () {
	  function Metadata(data) {
	    _classCallCheck(this, Metadata);
	
	    (0, _util.assert)(typeof data === 'string', 'Metadata: input is not a string');
	    data = this._repair(data);
	    var parser = new _xml_parser.SimpleXMLParser();
	    var xmlDocument = parser.parseFromString(data);
	    this._metadata = Object.create(null);
	    if (xmlDocument) {
	      this._parse(xmlDocument);
	    }
	  }
	
	  _createClass(Metadata, [{
	    key: '_repair',
	    value: function _repair(data) {
	      return data.replace(/>\\376\\377([^<]+)/g, function (all, codes) {
	        var bytes = codes.replace(/\\([0-3])([0-7])([0-7])/g, function (code, d1, d2, d3) {
	          return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1);
	        });
	        var chars = '';
	        for (var i = 0, ii = bytes.length; i < ii; i += 2) {
	          var code = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1);
	          if (code >= 32 && code < 127 && code !== 60 && code !== 62 && code !== 38) {
	            chars += String.fromCharCode(code);
	          } else {
	            chars += '&#x' + (0x10000 + code).toString(16).substring(1) + ';';
	          }
	        }
	        return '>' + chars;
	      });
	    }
	  }, {
	    key: '_parse',
	    value: function _parse(xmlDocument) {
	      var rdf = xmlDocument.documentElement;
	      if (rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
	        rdf = rdf.firstChild;
	        while (rdf && rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
	          rdf = rdf.nextSibling;
	        }
	      }
	      var nodeName = rdf ? rdf.nodeName.toLowerCase() : null;
	      if (!rdf || nodeName !== 'rdf:rdf' || !rdf.hasChildNodes()) {
	        return;
	      }
	      var children = rdf.childNodes;
	      for (var i = 0, ii = children.length; i < ii; i++) {
	        var desc = children[i];
	        if (desc.nodeName.toLowerCase() !== 'rdf:description') {
	          continue;
	        }
	        for (var j = 0, jj = desc.childNodes.length; j < jj; j++) {
	          if (desc.childNodes[j].nodeName.toLowerCase() !== '#text') {
	            var entry = desc.childNodes[j];
	            var name = entry.nodeName.toLowerCase();
	            this._metadata[name] = entry.textContent.trim();
	          }
	        }
	      }
	    }
	  }, {
	    key: 'get',
	    value: function get(name) {
	      return this._metadata[name] || null;
	    }
	  }, {
	    key: 'getAll',
	    value: function getAll() {
	      return this._metadata;
	    }
	  }, {
	    key: 'has',
	    value: function has(name) {
	      return typeof this._metadata[name] !== 'undefined';
	    }
	  }, {
	    key: 'metadata',
	    get: function get() {
	      (0, _util.deprecated)('`metadata` getter; use `getAll()` instead.');
	      return this.getAll();
	    }
	  }]);
	
	  return Metadata;
	}();
	
	exports.Metadata = Metadata;
	
	/***/ }),
	/* 78 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChunkedStreamManager = exports.ChunkedStream = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var ChunkedStream = function ChunkedStreamClosure() {
	  function ChunkedStream(length, chunkSize, manager) {
	    this.bytes = new Uint8Array(length);
	    this.start = 0;
	    this.pos = 0;
	    this.end = length;
	    this.chunkSize = chunkSize;
	    this.loadedChunks = [];
	    this.numChunksLoaded = 0;
	    this.numChunks = Math.ceil(length / chunkSize);
	    this.manager = manager;
	    this.progressiveDataLength = 0;
	    this.lastSuccessfulEnsureByteChunk = -1;
	  }
	  ChunkedStream.prototype = {
	    getMissingChunks: function ChunkedStream_getMissingChunks() {
	      var chunks = [];
	      for (var chunk = 0, n = this.numChunks; chunk < n; ++chunk) {
	        if (!this.loadedChunks[chunk]) {
	          chunks.push(chunk);
	        }
	      }
	      return chunks;
	    },
	    getBaseStreams: function ChunkedStream_getBaseStreams() {
	      return [this];
	    },
	    allChunksLoaded: function ChunkedStream_allChunksLoaded() {
	      return this.numChunksLoaded === this.numChunks;
	    },
	    onReceiveData: function ChunkedStream_onReceiveData(begin, chunk) {
	      var end = begin + chunk.byteLength;
	      if (begin % this.chunkSize !== 0) {
	        throw new Error('Bad begin offset: ' + begin);
	      }
	      var length = this.bytes.length;
	      if (end % this.chunkSize !== 0 && end !== length) {
	        throw new Error('Bad end offset: ' + end);
	      }
	      this.bytes.set(new Uint8Array(chunk), begin);
	      var chunkSize = this.chunkSize;
	      var beginChunk = Math.floor(begin / chunkSize);
	      var endChunk = Math.floor((end - 1) / chunkSize) + 1;
	      var curChunk;
	      for (curChunk = beginChunk; curChunk < endChunk; ++curChunk) {
	        if (!this.loadedChunks[curChunk]) {
	          this.loadedChunks[curChunk] = true;
	          ++this.numChunksLoaded;
	        }
	      }
	    },
	    onReceiveProgressiveData: function ChunkedStream_onReceiveProgressiveData(data) {
	      var position = this.progressiveDataLength;
	      var beginChunk = Math.floor(position / this.chunkSize);
	      this.bytes.set(new Uint8Array(data), position);
	      position += data.byteLength;
	      this.progressiveDataLength = position;
	      var endChunk = position >= this.end ? this.numChunks : Math.floor(position / this.chunkSize);
	      var curChunk;
	      for (curChunk = beginChunk; curChunk < endChunk; ++curChunk) {
	        if (!this.loadedChunks[curChunk]) {
	          this.loadedChunks[curChunk] = true;
	          ++this.numChunksLoaded;
	        }
	      }
	    },
	    ensureByte: function ChunkedStream_ensureByte(pos) {
	      var chunk = Math.floor(pos / this.chunkSize);
	      if (chunk === this.lastSuccessfulEnsureByteChunk) {
	        return;
	      }
	      if (!this.loadedChunks[chunk]) {
	        throw new _util.MissingDataException(pos, pos + 1);
	      }
	      this.lastSuccessfulEnsureByteChunk = chunk;
	    },
	    ensureRange: function ChunkedStream_ensureRange(begin, end) {
	      if (begin >= end) {
	        return;
	      }
	      if (end <= this.progressiveDataLength) {
	        return;
	      }
	      var chunkSize = this.chunkSize;
	      var beginChunk = Math.floor(begin / chunkSize);
	      var endChunk = Math.floor((end - 1) / chunkSize) + 1;
	      for (var chunk = beginChunk; chunk < endChunk; ++chunk) {
	        if (!this.loadedChunks[chunk]) {
	          throw new _util.MissingDataException(begin, end);
	        }
	      }
	    },
	    nextEmptyChunk: function ChunkedStream_nextEmptyChunk(beginChunk) {
	      var chunk,
	          numChunks = this.numChunks;
	      for (var i = 0; i < numChunks; ++i) {
	        chunk = (beginChunk + i) % numChunks;
	        if (!this.loadedChunks[chunk]) {
	          return chunk;
	        }
	      }
	      return null;
	    },
	    hasChunk: function ChunkedStream_hasChunk(chunk) {
	      return !!this.loadedChunks[chunk];
	    },
	    get length() {
	      return this.end - this.start;
	    },
	    get isEmpty() {
	      return this.length === 0;
	    },
	    getByte: function ChunkedStream_getByte() {
	      var pos = this.pos;
	      if (pos >= this.end) {
	        return -1;
	      }
	      this.ensureByte(pos);
	      return this.bytes[this.pos++];
	    },
	    getUint16: function ChunkedStream_getUint16() {
	      var b0 = this.getByte();
	      var b1 = this.getByte();
	      if (b0 === -1 || b1 === -1) {
	        return -1;
	      }
	      return (b0 << 8) + b1;
	    },
	    getInt32: function ChunkedStream_getInt32() {
	      var b0 = this.getByte();
	      var b1 = this.getByte();
	      var b2 = this.getByte();
	      var b3 = this.getByte();
	      return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
	    },
	    getBytes: function ChunkedStream_getBytes(length) {
	      var bytes = this.bytes;
	      var pos = this.pos;
	      var strEnd = this.end;
	      if (!length) {
	        this.ensureRange(pos, strEnd);
	        return bytes.subarray(pos, strEnd);
	      }
	      var end = pos + length;
	      if (end > strEnd) {
	        end = strEnd;
	      }
	      this.ensureRange(pos, end);
	      this.pos = end;
	      return bytes.subarray(pos, end);
	    },
	    peekByte: function ChunkedStream_peekByte() {
	      var peekedByte = this.getByte();
	      this.pos--;
	      return peekedByte;
	    },
	    peekBytes: function ChunkedStream_peekBytes(length) {
	      var bytes = this.getBytes(length);
	      this.pos -= bytes.length;
	      return bytes;
	    },
	    getByteRange: function ChunkedStream_getBytes(begin, end) {
	      this.ensureRange(begin, end);
	      return this.bytes.subarray(begin, end);
	    },
	    skip: function ChunkedStream_skip(n) {
	      if (!n) {
	        n = 1;
	      }
	      this.pos += n;
	    },
	    reset: function ChunkedStream_reset() {
	      this.pos = this.start;
	    },
	    moveStart: function ChunkedStream_moveStart() {
	      this.start = this.pos;
	    },
	    makeSubStream: function ChunkedStream_makeSubStream(start, length, dict) {
	      this.ensureRange(start, start + length);
	      function ChunkedStreamSubstream() {}
	      ChunkedStreamSubstream.prototype = Object.create(this);
	      ChunkedStreamSubstream.prototype.getMissingChunks = function () {
	        var chunkSize = this.chunkSize;
	        var beginChunk = Math.floor(this.start / chunkSize);
	        var endChunk = Math.floor((this.end - 1) / chunkSize) + 1;
	        var missingChunks = [];
	        for (var chunk = beginChunk; chunk < endChunk; ++chunk) {
	          if (!this.loadedChunks[chunk]) {
	            missingChunks.push(chunk);
	          }
	        }
	        return missingChunks;
	      };
	      var subStream = new ChunkedStreamSubstream();
	      subStream.pos = subStream.start = start;
	      subStream.end = start + length || this.end;
	      subStream.dict = dict;
	      return subStream;
	    }
	  };
	  return ChunkedStream;
	}();
	var ChunkedStreamManager = function ChunkedStreamManagerClosure() {
	  function ChunkedStreamManager(pdfNetworkStream, args) {
	    var chunkSize = args.rangeChunkSize;
	    var length = args.length;
	    this.stream = new ChunkedStream(length, chunkSize, this);
	    this.length = length;
	    this.chunkSize = chunkSize;
	    this.pdfNetworkStream = pdfNetworkStream;
	    this.url = args.url;
	    this.disableAutoFetch = args.disableAutoFetch;
	    this.msgHandler = args.msgHandler;
	    this.currRequestId = 0;
	    this.chunksNeededByRequest = Object.create(null);
	    this.requestsByChunk = Object.create(null);
	    this.promisesByRequest = Object.create(null);
	    this.progressiveDataLength = 0;
	    this.aborted = false;
	    this._loadedStreamCapability = (0, _util.createPromiseCapability)();
	  }
	  ChunkedStreamManager.prototype = {
	    onLoadedStream: function ChunkedStreamManager_getLoadedStream() {
	      return this._loadedStreamCapability.promise;
	    },
	    sendRequest: function ChunkedStreamManager_sendRequest(begin, end) {
	      var _this = this;
	
	      var rangeReader = this.pdfNetworkStream.getRangeReader(begin, end);
	      if (!rangeReader.isStreamingSupported) {
	        rangeReader.onProgress = this.onProgress.bind(this);
	      }
	      var chunks = [],
	          loaded = 0;
	      var manager = this;
	      var promise = new Promise(function (resolve, reject) {
	        var readChunk = function readChunk(chunk) {
	          try {
	            if (!chunk.done) {
	              var data = chunk.value;
	              chunks.push(data);
	              loaded += (0, _util.arrayByteLength)(data);
	              if (rangeReader.isStreamingSupported) {
	                manager.onProgress({ loaded: loaded });
	              }
	              rangeReader.read().then(readChunk, reject);
	              return;
	            }
	            var chunkData = (0, _util.arraysToBytes)(chunks);
	            chunks = null;
	            resolve(chunkData);
	          } catch (e) {
	            reject(e);
	          }
	        };
	        rangeReader.read().then(readChunk, reject);
	      });
	      promise.then(function (data) {
	        if (_this.aborted) {
	          return;
	        }
	        _this.onReceiveData({
	          chunk: data,
	          begin: begin
	        });
	      });
	    },
	    requestAllChunks: function ChunkedStreamManager_requestAllChunks() {
	      var missingChunks = this.stream.getMissingChunks();
	      this._requestChunks(missingChunks);
	      return this._loadedStreamCapability.promise;
	    },
	    _requestChunks: function ChunkedStreamManager_requestChunks(chunks) {
	      var requestId = this.currRequestId++;
	      var i, ii;
	      var chunksNeeded = Object.create(null);
	      this.chunksNeededByRequest[requestId] = chunksNeeded;
	      for (i = 0, ii = chunks.length; i < ii; i++) {
	        if (!this.stream.hasChunk(chunks[i])) {
	          chunksNeeded[chunks[i]] = true;
	        }
	      }
	      if ((0, _util.isEmptyObj)(chunksNeeded)) {
	        return Promise.resolve();
	      }
	      var capability = (0, _util.createPromiseCapability)();
	      this.promisesByRequest[requestId] = capability;
	      var chunksToRequest = [];
	      for (var chunk in chunksNeeded) {
	        chunk = chunk | 0;
	        if (!(chunk in this.requestsByChunk)) {
	          this.requestsByChunk[chunk] = [];
	          chunksToRequest.push(chunk);
	        }
	        this.requestsByChunk[chunk].push(requestId);
	      }
	      if (!chunksToRequest.length) {
	        return capability.promise;
	      }
	      var groupedChunksToRequest = this.groupChunks(chunksToRequest);
	      for (i = 0; i < groupedChunksToRequest.length; ++i) {
	        var groupedChunk = groupedChunksToRequest[i];
	        var begin = groupedChunk.beginChunk * this.chunkSize;
	        var end = Math.min(groupedChunk.endChunk * this.chunkSize, this.length);
	        this.sendRequest(begin, end);
	      }
	      return capability.promise;
	    },
	    getStream: function ChunkedStreamManager_getStream() {
	      return this.stream;
	    },
	    requestRange: function ChunkedStreamManager_requestRange(begin, end) {
	      end = Math.min(end, this.length);
	      var beginChunk = this.getBeginChunk(begin);
	      var endChunk = this.getEndChunk(end);
	      var chunks = [];
	      for (var chunk = beginChunk; chunk < endChunk; ++chunk) {
	        chunks.push(chunk);
	      }
	      return this._requestChunks(chunks);
	    },
	    requestRanges: function ChunkedStreamManager_requestRanges(ranges) {
	      ranges = ranges || [];
	      var chunksToRequest = [];
	      for (var i = 0; i < ranges.length; i++) {
	        var beginChunk = this.getBeginChunk(ranges[i].begin);
	        var endChunk = this.getEndChunk(ranges[i].end);
	        for (var chunk = beginChunk; chunk < endChunk; ++chunk) {
	          if (chunksToRequest.indexOf(chunk) < 0) {
	            chunksToRequest.push(chunk);
	          }
	        }
	      }
	      chunksToRequest.sort(function (a, b) {
	        return a - b;
	      });
	      return this._requestChunks(chunksToRequest);
	    },
	    groupChunks: function ChunkedStreamManager_groupChunks(chunks) {
	      var groupedChunks = [];
	      var beginChunk = -1;
	      var prevChunk = -1;
	      for (var i = 0; i < chunks.length; ++i) {
	        var chunk = chunks[i];
	        if (beginChunk < 0) {
	          beginChunk = chunk;
	        }
	        if (prevChunk >= 0 && prevChunk + 1 !== chunk) {
	          groupedChunks.push({
	            beginChunk: beginChunk,
	            endChunk: prevChunk + 1
	          });
	          beginChunk = chunk;
	        }
	        if (i + 1 === chunks.length) {
	          groupedChunks.push({
	            beginChunk: beginChunk,
	            endChunk: chunk + 1
	          });
	        }
	        prevChunk = chunk;
	      }
	      return groupedChunks;
	    },
	    onProgress: function ChunkedStreamManager_onProgress(args) {
	      var bytesLoaded = this.stream.numChunksLoaded * this.chunkSize + args.loaded;
	      this.msgHandler.send('DocProgress', {
	        loaded: bytesLoaded,
	        total: this.length
	      });
	    },
	    onReceiveData: function ChunkedStreamManager_onReceiveData(args) {
	      var chunk = args.chunk;
	      var isProgressive = args.begin === undefined;
	      var begin = isProgressive ? this.progressiveDataLength : args.begin;
	      var end = begin + chunk.byteLength;
	      var beginChunk = Math.floor(begin / this.chunkSize);
	      var endChunk = end < this.length ? Math.floor(end / this.chunkSize) : Math.ceil(end / this.chunkSize);
	      if (isProgressive) {
	        this.stream.onReceiveProgressiveData(chunk);
	        this.progressiveDataLength = end;
	      } else {
	        this.stream.onReceiveData(begin, chunk);
	      }
	      if (this.stream.allChunksLoaded()) {
	        this._loadedStreamCapability.resolve(this.stream);
	      }
	      var loadedRequests = [];
	      var i, requestId;
	      for (chunk = beginChunk; chunk < endChunk; ++chunk) {
	        var requestIds = this.requestsByChunk[chunk] || [];
	        delete this.requestsByChunk[chunk];
	        for (i = 0; i < requestIds.length; ++i) {
	          requestId = requestIds[i];
	          var chunksNeeded = this.chunksNeededByRequest[requestId];
	          if (chunk in chunksNeeded) {
	            delete chunksNeeded[chunk];
	          }
	          if (!(0, _util.isEmptyObj)(chunksNeeded)) {
	            continue;
	          }
	          loadedRequests.push(requestId);
	        }
	      }
	      if (!this.disableAutoFetch && (0, _util.isEmptyObj)(this.requestsByChunk)) {
	        var nextEmptyChunk;
	        if (this.stream.numChunksLoaded === 1) {
	          var lastChunk = this.stream.numChunks - 1;
	          if (!this.stream.hasChunk(lastChunk)) {
	            nextEmptyChunk = lastChunk;
	          }
	        } else {
	          nextEmptyChunk = this.stream.nextEmptyChunk(endChunk);
	        }
	        if (Number.isInteger(nextEmptyChunk)) {
	          this._requestChunks([nextEmptyChunk]);
	        }
	      }
	      for (i = 0; i < loadedRequests.length; ++i) {
	        requestId = loadedRequests[i];
	        var capability = this.promisesByRequest[requestId];
	        delete this.promisesByRequest[requestId];
	        capability.resolve();
	      }
	      this.msgHandler.send('DocProgress', {
	        loaded: this.stream.numChunksLoaded * this.chunkSize,
	        total: this.length
	      });
	    },
	    onError: function ChunkedStreamManager_onError(err) {
	      this._loadedStreamCapability.reject(err);
	    },
	    getBeginChunk: function ChunkedStreamManager_getBeginChunk(begin) {
	      var chunk = Math.floor(begin / this.chunkSize);
	      return chunk;
	    },
	    getEndChunk: function ChunkedStreamManager_getEndChunk(end) {
	      var chunk = Math.floor((end - 1) / this.chunkSize) + 1;
	      return chunk;
	    },
	    abort: function ChunkedStreamManager_abort() {
	      this.aborted = true;
	      if (this.pdfNetworkStream) {
	        this.pdfNetworkStream.cancelAllRequests('abort');
	      }
	      for (var requestId in this.promisesByRequest) {
	        var capability = this.promisesByRequest[requestId];
	        capability.reject(new Error('Request was aborted'));
	      }
	    }
	  };
	  return ChunkedStreamManager;
	}();
	exports.ChunkedStream = ChunkedStream;
	exports.ChunkedStreamManager = ChunkedStreamManager;
	
	/***/ }),
	/* 79 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FileSpec = exports.XRef = exports.ObjectLoader = exports.Catalog = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _util = __w_pdfjs_require__(0);
	
	var _primitives = __w_pdfjs_require__(2);
	
	var _parser = __w_pdfjs_require__(36);
	
	var _chunked_stream = __w_pdfjs_require__(78);
	
	var _crypto = __w_pdfjs_require__(82);
	
	var _colorspace = __w_pdfjs_require__(29);
	
	var Catalog = function CatalogClosure() {
	  function Catalog(pdfManager, xref, pageFactory) {
	    this.pdfManager = pdfManager;
	    this.xref = xref;
	    this.catDict = xref.getCatalogObj();
	    if (!(0, _primitives.isDict)(this.catDict)) {
	      throw new _util.FormatError('catalog object is not a dictionary');
	    }
	    this.fontCache = new _primitives.RefSetCache();
	    this.builtInCMapCache = Object.create(null);
	    this.pageKidsCountCache = new _primitives.RefSetCache();
	    this.pageFactory = pageFactory;
	    this.pagePromises = [];
	  }
	  Catalog.prototype = {
	    get metadata() {
	      var streamRef = this.catDict.getRaw('Metadata');
	      if (!(0, _primitives.isRef)(streamRef)) {
	        return (0, _util.shadow)(this, 'metadata', null);
	      }
	      var encryptMetadata = !this.xref.encrypt ? false : this.xref.encrypt.encryptMetadata;
	      var stream = this.xref.fetch(streamRef, !encryptMetadata);
	      var metadata;
	      if (stream && (0, _primitives.isDict)(stream.dict)) {
	        var type = stream.dict.get('Type');
	        var subtype = stream.dict.get('Subtype');
	        if ((0, _primitives.isName)(type, 'Metadata') && (0, _primitives.isName)(subtype, 'XML')) {
	          try {
	            metadata = (0, _util.stringToUTF8String)((0, _util.bytesToString)(stream.getBytes()));
	          } catch (e) {
	            if (e instanceof _util.MissingDataException) {
	              throw e;
	            }
	            (0, _util.info)('Skipping invalid metadata.');
	          }
	        }
	      }
	      return (0, _util.shadow)(this, 'metadata', metadata);
	    },
	    get toplevelPagesDict() {
	      var pagesObj = this.catDict.get('Pages');
	      if (!(0, _primitives.isDict)(pagesObj)) {
	        throw new _util.FormatError('invalid top-level pages dictionary');
	      }
	      return (0, _util.shadow)(this, 'toplevelPagesDict', pagesObj);
	    },
	    get documentOutline() {
	      var obj = null;
	      try {
	        obj = this.readDocumentOutline();
	      } catch (ex) {
	        if (ex instanceof _util.MissingDataException) {
	          throw ex;
	        }
	        (0, _util.warn)('Unable to read document outline');
	      }
	      return (0, _util.shadow)(this, 'documentOutline', obj);
	    },
	    readDocumentOutline: function Catalog_readDocumentOutline() {
	      var obj = this.catDict.get('Outlines');
	      if (!(0, _primitives.isDict)(obj)) {
	        return null;
	      }
	      obj = obj.getRaw('First');
	      if (!(0, _primitives.isRef)(obj)) {
	        return null;
	      }
	      var root = { items: [] };
	      var queue = [{
	        obj: obj,
	        parent: root
	      }];
	      var processed = new _primitives.RefSet();
	      processed.put(obj);
	      var xref = this.xref,
	          blackColor = new Uint8Array(3);
	      while (queue.length > 0) {
	        var i = queue.shift();
	        var outlineDict = xref.fetchIfRef(i.obj);
	        if (outlineDict === null) {
	          continue;
	        }
	        if (!outlineDict.has('Title')) {
	          throw new _util.FormatError('Invalid outline item');
	        }
	        var data = {
	          url: null,
	          dest: null
	        };
	        Catalog.parseDestDictionary({
	          destDict: outlineDict,
	          resultObj: data,
	          docBaseUrl: this.pdfManager.docBaseUrl
	        });
	        var title = outlineDict.get('Title');
	        var flags = outlineDict.get('F') || 0;
	        var color = outlineDict.getArray('C'),
	            rgbColor = blackColor;
	        if (Array.isArray(color) && color.length === 3 && (color[0] !== 0 || color[1] !== 0 || color[2] !== 0)) {
	          rgbColor = _colorspace.ColorSpace.singletons.rgb.getRgb(color, 0);
	        }
	        var outlineItem = {
	          dest: data.dest,
	          url: data.url,
	          unsafeUrl: data.unsafeUrl,
	          newWindow: data.newWindow,
	          title: (0, _util.stringToPDFString)(title),
	          color: rgbColor,
	          count: outlineDict.get('Count'),
	          bold: !!(flags & 2),
	          italic: !!(flags & 1),
	          items: []
	        };
	        i.parent.items.push(outlineItem);
	        obj = outlineDict.getRaw('First');
	        if ((0, _primitives.isRef)(obj) && !processed.has(obj)) {
	          queue.push({
	            obj: obj,
	            parent: outlineItem
	          });
	          processed.put(obj);
	        }
	        obj = outlineDict.getRaw('Next');
	        if ((0, _primitives.isRef)(obj) && !processed.has(obj)) {
	          queue.push({
	            obj: obj,
	            parent: i.parent
	          });
	          processed.put(obj);
	        }
	      }
	      return root.items.length > 0 ? root.items : null;
	    },
	    get numPages() {
	      var obj = this.toplevelPagesDict.get('Count');
	      if (!Number.isInteger(obj)) {
	        throw new _util.FormatError('page count in top level pages object is not an integer');
	      }
	      return (0, _util.shadow)(this, 'numPages', obj);
	    },
	    get destinations() {
	      function fetchDestination(dest) {
	        return (0, _primitives.isDict)(dest) ? dest.get('D') : dest;
	      }
	      var xref = this.xref;
	      var dests = {},
	          nameTreeRef,
	          nameDictionaryRef;
	      var obj = this.catDict.get('Names');
	      if (obj && obj.has('Dests')) {
	        nameTreeRef = obj.getRaw('Dests');
	      } else if (this.catDict.has('Dests')) {
	        nameDictionaryRef = this.catDict.get('Dests');
	      }
	      if (nameDictionaryRef) {
	        obj = nameDictionaryRef;
	        obj.forEach(function catalogForEach(key, value) {
	          if (!value) {
	            return;
	          }
	          dests[key] = fetchDestination(value);
	        });
	      }
	      if (nameTreeRef) {
	        var nameTree = new NameTree(nameTreeRef, xref);
	        var names = nameTree.getAll();
	        for (var name in names) {
	          dests[name] = fetchDestination(names[name]);
	        }
	      }
	      return (0, _util.shadow)(this, 'destinations', dests);
	    },
	    getDestination: function Catalog_getDestination(destinationId) {
	      function fetchDestination(dest) {
	        return (0, _primitives.isDict)(dest) ? dest.get('D') : dest;
	      }
	      var xref = this.xref;
	      var dest = null,
	          nameTreeRef,
	          nameDictionaryRef;
	      var obj = this.catDict.get('Names');
	      if (obj && obj.has('Dests')) {
	        nameTreeRef = obj.getRaw('Dests');
	      } else if (this.catDict.has('Dests')) {
	        nameDictionaryRef = this.catDict.get('Dests');
	      }
	      if (nameDictionaryRef) {
	        var value = nameDictionaryRef.get(destinationId);
	        if (value) {
	          dest = fetchDestination(value);
	        }
	      }
	      if (nameTreeRef) {
	        var nameTree = new NameTree(nameTreeRef, xref);
	        dest = fetchDestination(nameTree.get(destinationId));
	      }
	      return dest;
	    },
	    get pageLabels() {
	      var obj = null;
	      try {
	        obj = this.readPageLabels();
	      } catch (ex) {
	        if (ex instanceof _util.MissingDataException) {
	          throw ex;
	        }
	        (0, _util.warn)('Unable to read page labels.');
	      }
	      return (0, _util.shadow)(this, 'pageLabels', obj);
	    },
	    readPageLabels: function Catalog_readPageLabels() {
	      var obj = this.catDict.getRaw('PageLabels');
	      if (!obj) {
	        return null;
	      }
	      var pageLabels = new Array(this.numPages);
	      var style = null;
	      var prefix = '';
	      var numberTree = new NumberTree(obj, this.xref);
	      var nums = numberTree.getAll();
	      var currentLabel = '',
	          currentIndex = 1;
	      for (var i = 0, ii = this.numPages; i < ii; i++) {
	        if (i in nums) {
	          var labelDict = nums[i];
	          if (!(0, _primitives.isDict)(labelDict)) {
	            throw new _util.FormatError('The PageLabel is not a dictionary.');
	          }
	          var type = labelDict.get('Type');
	          if (type && !(0, _primitives.isName)(type, 'PageLabel')) {
	            throw new _util.FormatError('Invalid type in PageLabel dictionary.');
	          }
	          var s = labelDict.get('S');
	          if (s && !(0, _primitives.isName)(s)) {
	            throw new _util.FormatError('Invalid style in PageLabel dictionary.');
	          }
	          style = s ? s.name : null;
	          var p = labelDict.get('P');
	          if (p && !(0, _util.isString)(p)) {
	            throw new _util.FormatError('Invalid prefix in PageLabel dictionary.');
	          }
	          prefix = p ? (0, _util.stringToPDFString)(p) : '';
	          var st = labelDict.get('St');
	          if (st && !(Number.isInteger(st) && st >= 1)) {
	            throw new _util.FormatError('Invalid start in PageLabel dictionary.');
	          }
	          currentIndex = st || 1;
	        }
	        switch (style) {
	          case 'D':
	            currentLabel = currentIndex;
	            break;
	          case 'R':
	          case 'r':
	            currentLabel = _util.Util.toRoman(currentIndex, style === 'r');
	            break;
	          case 'A':
	          case 'a':
	            var LIMIT = 26;
	            var A_UPPER_CASE = 0x41,
	                A_LOWER_CASE = 0x61;
	            var baseCharCode = style === 'a' ? A_LOWER_CASE : A_UPPER_CASE;
	            var letterIndex = currentIndex - 1;
	            var character = String.fromCharCode(baseCharCode + letterIndex % LIMIT);
	            var charBuf = [];
	            for (var j = 0, jj = letterIndex / LIMIT | 0; j <= jj; j++) {
	              charBuf.push(character);
	            }
	            currentLabel = charBuf.join('');
	            break;
	          default:
	            if (style) {
	              throw new _util.FormatError('Invalid style "' + style + '" in PageLabel dictionary.');
	            }
	        }
	        pageLabels[i] = prefix + currentLabel;
	        currentLabel = '';
	        currentIndex++;
	      }
	      return pageLabels;
	    },
	    get pageMode() {
	      var obj = this.catDict.get('PageMode');
	      var pageMode = 'UseNone';
	      if ((0, _primitives.isName)(obj)) {
	        switch (obj.name) {
	          case 'UseNone':
	          case 'UseOutlines':
	          case 'UseThumbs':
	          case 'FullScreen':
	          case 'UseOC':
	          case 'UseAttachments':
	            pageMode = obj.name;
	        }
	      }
	      return (0, _util.shadow)(this, 'pageMode', pageMode);
	    },
	    get attachments() {
	      var xref = this.xref;
	      var attachments = null,
	          nameTreeRef;
	      var obj = this.catDict.get('Names');
	      if (obj) {
	        nameTreeRef = obj.getRaw('EmbeddedFiles');
	      }
	      if (nameTreeRef) {
	        var nameTree = new NameTree(nameTreeRef, xref);
	        var names = nameTree.getAll();
	        for (var name in names) {
	          var fs = new FileSpec(names[name], xref);
	          if (!attachments) {
	            attachments = Object.create(null);
	          }
	          attachments[(0, _util.stringToPDFString)(name)] = fs.serializable;
	        }
	      }
	      return (0, _util.shadow)(this, 'attachments', attachments);
	    },
	    get javaScript() {
	      var xref = this.xref;
	      var obj = this.catDict.get('Names');
	      var javaScript = [];
	      function appendIfJavaScriptDict(jsDict) {
	        var type = jsDict.get('S');
	        if (!(0, _primitives.isName)(type, 'JavaScript')) {
	          return;
	        }
	        var js = jsDict.get('JS');
	        if ((0, _primitives.isStream)(js)) {
	          js = (0, _util.bytesToString)(js.getBytes());
	        } else if (!(0, _util.isString)(js)) {
	          return;
	        }
	        javaScript.push((0, _util.stringToPDFString)(js));
	      }
	      if (obj && obj.has('JavaScript')) {
	        var nameTree = new NameTree(obj.getRaw('JavaScript'), xref);
	        var names = nameTree.getAll();
	        for (var name in names) {
	          var jsDict = names[name];
	          if ((0, _primitives.isDict)(jsDict)) {
	            appendIfJavaScriptDict(jsDict);
	          }
	        }
	      }
	      var openactionDict = this.catDict.get('OpenAction');
	      if ((0, _primitives.isDict)(openactionDict, 'Action')) {
	        var actionType = openactionDict.get('S');
	        if ((0, _primitives.isName)(actionType, 'Named')) {
	          var action = openactionDict.get('N');
	          if ((0, _primitives.isName)(action, 'Print')) {
	            javaScript.push('print({});');
	          }
	        } else {
	          appendIfJavaScriptDict(openactionDict);
	        }
	      }
	      return (0, _util.shadow)(this, 'javaScript', javaScript);
	    },
	    cleanup: function Catalog_cleanup() {
	      var _this = this;
	
	      this.pageKidsCountCache.clear();
	      var promises = [];
	      this.fontCache.forEach(function (promise) {
	        promises.push(promise);
	      });
	      return Promise.all(promises).then(function (translatedFonts) {
	        for (var i = 0, ii = translatedFonts.length; i < ii; i++) {
	          var font = translatedFonts[i].dict;
	          delete font.translated;
	        }
	        _this.fontCache.clear();
	        _this.builtInCMapCache = Object.create(null);
	      });
	    },
	    getPage: function Catalog_getPage(pageIndex) {
	      var _this2 = this;
	
	      if (!(pageIndex in this.pagePromises)) {
	        this.pagePromises[pageIndex] = this.getPageDict(pageIndex).then(function (_ref) {
	          var _ref2 = _slicedToArray(_ref, 2),
	              dict = _ref2[0],
	              ref = _ref2[1];
	
	          return _this2.pageFactory.createPage(pageIndex, dict, ref, _this2.fontCache, _this2.builtInCMapCache);
	        });
	      }
	      return this.pagePromises[pageIndex];
	    },
	    getPageDict: function Catalog_getPageDict(pageIndex) {
	      var capability = (0, _util.createPromiseCapability)();
	      var nodesToVisit = [this.catDict.getRaw('Pages')];
	      var count,
	          currentPageIndex = 0;
	      var xref = this.xref,
	          pageKidsCountCache = this.pageKidsCountCache;
	      function next() {
	        while (nodesToVisit.length) {
	          var currentNode = nodesToVisit.pop();
	          if ((0, _primitives.isRef)(currentNode)) {
	            count = pageKidsCountCache.get(currentNode);
	            if (count > 0 && currentPageIndex + count < pageIndex) {
	              currentPageIndex += count;
	              continue;
	            }
	            xref.fetchAsync(currentNode).then(function (obj) {
	              if ((0, _primitives.isDict)(obj, 'Page') || (0, _primitives.isDict)(obj) && !obj.has('Kids')) {
	                if (pageIndex === currentPageIndex) {
	                  if (currentNode && !pageKidsCountCache.has(currentNode)) {
	                    pageKidsCountCache.put(currentNode, 1);
	                  }
	                  capability.resolve([obj, currentNode]);
	                } else {
	                  currentPageIndex++;
	                  next();
	                }
	                return;
	              }
	              nodesToVisit.push(obj);
	              next();
	            }, capability.reject);
	            return;
	          }
	          if (!(0, _primitives.isDict)(currentNode)) {
	            capability.reject(new _util.FormatError('page dictionary kid reference points to wrong type of object'));
	            return;
	          }
	          count = currentNode.get('Count');
	          var objId = currentNode.objId;
	          if (objId && !pageKidsCountCache.has(objId)) {
	            pageKidsCountCache.put(objId, count);
	          }
	          if (currentPageIndex + count <= pageIndex) {
	            currentPageIndex += count;
	            continue;
	          }
	          var kids = currentNode.get('Kids');
	          if (!Array.isArray(kids)) {
	            capability.reject(new _util.FormatError('page dictionary kids object is not an array'));
	            return;
	          }
	          for (var last = kids.length - 1; last >= 0; last--) {
	            nodesToVisit.push(kids[last]);
	          }
	        }
	        capability.reject(new Error('Page index ' + pageIndex + ' not found.'));
	      }
	      next();
	      return capability.promise;
	    },
	    getPageIndex: function Catalog_getPageIndex(pageRef) {
	      var xref = this.xref;
	      function pagesBeforeRef(kidRef) {
	        var total = 0;
	        var parentRef;
	        return xref.fetchAsync(kidRef).then(function (node) {
	          if ((0, _primitives.isRefsEqual)(kidRef, pageRef) && !(0, _primitives.isDict)(node, 'Page') && !((0, _primitives.isDict)(node) && !node.has('Type') && node.has('Contents'))) {
	            throw new _util.FormatError('The reference does not point to a /Page Dict.');
	          }
	          if (!node) {
	            return null;
	          }
	          if (!(0, _primitives.isDict)(node)) {
	            throw new _util.FormatError('node must be a Dict.');
	          }
	          parentRef = node.getRaw('Parent');
	          return node.getAsync('Parent');
	        }).then(function (parent) {
	          if (!parent) {
	            return null;
	          }
	          if (!(0, _primitives.isDict)(parent)) {
	            throw new _util.FormatError('parent must be a Dict.');
	          }
	          return parent.getAsync('Kids');
	        }).then(function (kids) {
	          if (!kids) {
	            return null;
	          }
	          var kidPromises = [];
	          var found = false;
	          for (var i = 0; i < kids.length; i++) {
	            var kid = kids[i];
	            if (!(0, _primitives.isRef)(kid)) {
	              throw new _util.FormatError('kid must be a Ref.');
	            }
	            if (kid.num === kidRef.num) {
	              found = true;
	              break;
	            }
	            kidPromises.push(xref.fetchAsync(kid).then(function (kid) {
	              if (kid.has('Count')) {
	                var count = kid.get('Count');
	                total += count;
	              } else {
	                total++;
	              }
	            }));
	          }
	          if (!found) {
	            throw new _util.FormatError('kid ref not found in parents kids');
	          }
	          return Promise.all(kidPromises).then(function () {
	            return [total, parentRef];
	          });
	        });
	      }
	      var total = 0;
	      function next(ref) {
	        return pagesBeforeRef(ref).then(function (args) {
	          if (!args) {
	            return total;
	          }
	          var count = args[0];
	          var parentRef = args[1];
	          total += count;
	          return next(parentRef);
	        });
	      }
	      return next(pageRef);
	    }
	  };
	  Catalog.parseDestDictionary = function Catalog_parseDestDictionary(params) {
	    function addDefaultProtocolToUrl(url) {
	      if (url.indexOf('www.') === 0) {
	        return 'http://' + url;
	      }
	      return url;
	    }
	    function tryConvertUrlEncoding(url) {
	      try {
	        return (0, _util.stringToUTF8String)(url);
	      } catch (e) {
	        return url;
	      }
	    }
	    var destDict = params.destDict;
	    if (!(0, _primitives.isDict)(destDict)) {
	      (0, _util.warn)('parseDestDictionary: "destDict" must be a dictionary.');
	      return;
	    }
	    var resultObj = params.resultObj;
	    if ((typeof resultObj === 'undefined' ? 'undefined' : _typeof(resultObj)) !== 'object') {
	      (0, _util.warn)('parseDestDictionary: "resultObj" must be an object.');
	      return;
	    }
	    var docBaseUrl = params.docBaseUrl || null;
	    var action = destDict.get('A'),
	        url,
	        dest;
	    if (!(0, _primitives.isDict)(action) && destDict.has('Dest')) {
	      action = destDict.get('Dest');
	    }
	    if ((0, _primitives.isDict)(action)) {
	      var actionType = action.get('S');
	      if (!(0, _primitives.isName)(actionType)) {
	        (0, _util.warn)('parseDestDictionary: Invalid type in Action dictionary.');
	        return;
	      }
	      var actionName = actionType.name;
	      switch (actionName) {
	        case 'URI':
	          url = action.get('URI');
	          if ((0, _primitives.isName)(url)) {
	            url = '/' + url.name;
	          } else if ((0, _util.isString)(url)) {
	            url = addDefaultProtocolToUrl(url);
	          }
	          break;
	        case 'GoTo':
	          dest = action.get('D');
	          break;
	        case 'Launch':
	        case 'GoToR':
	          var urlDict = action.get('F');
	          if ((0, _primitives.isDict)(urlDict)) {
	            url = urlDict.get('F') || null;
	          } else if ((0, _util.isString)(urlDict)) {
	            url = urlDict;
	          }
	          var remoteDest = action.get('D');
	          if (remoteDest) {
	            if ((0, _primitives.isName)(remoteDest)) {
	              remoteDest = remoteDest.name;
	            }
	            if ((0, _util.isString)(url)) {
	              var baseUrl = url.split('#')[0];
	              if ((0, _util.isString)(remoteDest)) {
	                url = baseUrl + '#' + remoteDest;
	              } else if (Array.isArray(remoteDest)) {
	                url = baseUrl + '#' + JSON.stringify(remoteDest);
	              }
	            }
	          }
	          var newWindow = action.get('NewWindow');
	          if ((0, _util.isBool)(newWindow)) {
	            resultObj.newWindow = newWindow;
	          }
	          break;
	        case 'Named':
	          var namedAction = action.get('N');
	          if ((0, _primitives.isName)(namedAction)) {
	            resultObj.action = namedAction.name;
	          }
	          break;
	        case 'JavaScript':
	          var jsAction = action.get('JS'),
	              js;
	          if ((0, _primitives.isStream)(jsAction)) {
	            js = (0, _util.bytesToString)(jsAction.getBytes());
	          } else if ((0, _util.isString)(jsAction)) {
	            js = jsAction;
	          }
	          if (js) {
	            var URL_OPEN_METHODS = ['app.launchURL', 'window.open'];
	            var regex = new RegExp('^\\s*(' + URL_OPEN_METHODS.join('|').split('.').join('\\.') + ')\\((?:\'|\")([^\'\"]*)(?:\'|\")(?:,\\s*(\\w+)\\)|\\))', 'i');
	            var jsUrl = regex.exec((0, _util.stringToPDFString)(js));
	            if (jsUrl && jsUrl[2]) {
	              url = jsUrl[2];
	              if (jsUrl[3] === 'true' && jsUrl[1] === 'app.launchURL') {
	                resultObj.newWindow = true;
	              }
	              break;
	            }
	          }
	        default:
	          (0, _util.warn)('parseDestDictionary: Unsupported Action type "' + actionName + '".');
	          break;
	      }
	    } else if (destDict.has('Dest')) {
	      dest = destDict.get('Dest');
	    }
	    if ((0, _util.isString)(url)) {
	      url = tryConvertUrlEncoding(url);
	      var absoluteUrl = (0, _util.createValidAbsoluteUrl)(url, docBaseUrl);
	      if (absoluteUrl) {
	        resultObj.url = absoluteUrl.href;
	      }
	      resultObj.unsafeUrl = url;
	    }
	    if (dest) {
	      if ((0, _primitives.isName)(dest)) {
	        dest = dest.name;
	      }
	      if ((0, _util.isString)(dest) || Array.isArray(dest)) {
	        resultObj.dest = dest;
	      }
	    }
	  };
	  return Catalog;
	}();
	var XRef = function XRefClosure() {
	  function XRef(stream, pdfManager) {
	    this.stream = stream;
	    this.pdfManager = pdfManager;
	    this.entries = [];
	    this.xrefstms = Object.create(null);
	    this.cache = [];
	    this.stats = {
	      streamTypes: [],
	      fontTypes: []
	    };
	  }
	  XRef.prototype = {
	    setStartXRef: function XRef_setStartXRef(startXRef) {
	      this.startXRefQueue = [startXRef];
	    },
	    parse: function XRef_parse(recoveryMode) {
	      var trailerDict;
	      if (!recoveryMode) {
	        trailerDict = this.readXRef();
	      } else {
	        (0, _util.warn)('Indexing all PDF objects');
	        trailerDict = this.indexObjects();
	      }
	      trailerDict.assignXref(this);
	      this.trailer = trailerDict;
	      var encrypt = trailerDict.get('Encrypt');
	      if ((0, _primitives.isDict)(encrypt)) {
	        var ids = trailerDict.get('ID');
	        var fileId = ids && ids.length ? ids[0] : '';
	        encrypt.suppressEncryption = true;
	        this.encrypt = new _crypto.CipherTransformFactory(encrypt, fileId, this.pdfManager.password);
	      }
	      if (!(this.root = trailerDict.get('Root'))) {
	        throw new _util.FormatError('Invalid root reference');
	      }
	    },
	    processXRefTable: function XRef_processXRefTable(parser) {
	      if (!('tableState' in this)) {
	        this.tableState = {
	          entryNum: 0,
	          streamPos: parser.lexer.stream.pos,
	          parserBuf1: parser.buf1,
	          parserBuf2: parser.buf2
	        };
	      }
	      var obj = this.readXRefTable(parser);
	      if (!(0, _primitives.isCmd)(obj, 'trailer')) {
	        throw new _util.FormatError('Invalid XRef table: could not find trailer dictionary');
	      }
	      var dict = parser.getObj();
	      if (!(0, _primitives.isDict)(dict) && dict.dict) {
	        dict = dict.dict;
	      }
	      if (!(0, _primitives.isDict)(dict)) {
	        throw new _util.FormatError('Invalid XRef table: could not parse trailer dictionary');
	      }
	      delete this.tableState;
	      return dict;
	    },
	    readXRefTable: function XRef_readXRefTable(parser) {
	      var stream = parser.lexer.stream;
	      var tableState = this.tableState;
	      stream.pos = tableState.streamPos;
	      parser.buf1 = tableState.parserBuf1;
	      parser.buf2 = tableState.parserBuf2;
	      var obj;
	      while (true) {
	        if (!('firstEntryNum' in tableState) || !('entryCount' in tableState)) {
	          if ((0, _primitives.isCmd)(obj = parser.getObj(), 'trailer')) {
	            break;
	          }
	          tableState.firstEntryNum = obj;
	          tableState.entryCount = parser.getObj();
	        }
	        var first = tableState.firstEntryNum;
	        var count = tableState.entryCount;
	        if (!Number.isInteger(first) || !Number.isInteger(count)) {
	          throw new _util.FormatError('Invalid XRef table: wrong types in subsection header');
	        }
	        for (var i = tableState.entryNum; i < count; i++) {
	          tableState.streamPos = stream.pos;
	          tableState.entryNum = i;
	          tableState.parserBuf1 = parser.buf1;
	          tableState.parserBuf2 = parser.buf2;
	          var entry = {};
	          entry.offset = parser.getObj();
	          entry.gen = parser.getObj();
	          var type = parser.getObj();
	          if ((0, _primitives.isCmd)(type, 'f')) {
	            entry.free = true;
	          } else if ((0, _primitives.isCmd)(type, 'n')) {
	            entry.uncompressed = true;
	          }
	          if (!Number.isInteger(entry.offset) || !Number.isInteger(entry.gen) || !(entry.free || entry.uncompressed)) {
	            throw new _util.FormatError('Invalid entry in XRef subsection: ' + first + ', ' + count);
	          }
	          if (i === 0 && entry.free && first === 1) {
	            first = 0;
	          }
	          if (!this.entries[i + first]) {
	            this.entries[i + first] = entry;
	          }
	        }
	        tableState.entryNum = 0;
	        tableState.streamPos = stream.pos;
	        tableState.parserBuf1 = parser.buf1;
	        tableState.parserBuf2 = parser.buf2;
	        delete tableState.firstEntryNum;
	        delete tableState.entryCount;
	      }
	      if (this.entries[0] && !this.entries[0].free) {
	        throw new _util.FormatError('Invalid XRef table: unexpected first object');
	      }
	      return obj;
	    },
	    processXRefStream: function XRef_processXRefStream(stream) {
	      if (!('streamState' in this)) {
	        var streamParameters = stream.dict;
	        var byteWidths = streamParameters.get('W');
	        var range = streamParameters.get('Index');
	        if (!range) {
	          range = [0, streamParameters.get('Size')];
	        }
	        this.streamState = {
	          entryRanges: range,
	          byteWidths: byteWidths,
	          entryNum: 0,
	          streamPos: stream.pos
	        };
	      }
	      this.readXRefStream(stream);
	      delete this.streamState;
	      return stream.dict;
	    },
	    readXRefStream: function XRef_readXRefStream(stream) {
	      var i, j;
	      var streamState = this.streamState;
	      stream.pos = streamState.streamPos;
	      var byteWidths = streamState.byteWidths;
	      var typeFieldWidth = byteWidths[0];
	      var offsetFieldWidth = byteWidths[1];
	      var generationFieldWidth = byteWidths[2];
	      var entryRanges = streamState.entryRanges;
	      while (entryRanges.length > 0) {
	        var first = entryRanges[0];
	        var n = entryRanges[1];
	        if (!Number.isInteger(first) || !Number.isInteger(n)) {
	          throw new _util.FormatError('Invalid XRef range fields: ' + first + ', ' + n);
	        }
	        if (!Number.isInteger(typeFieldWidth) || !Number.isInteger(offsetFieldWidth) || !Number.isInteger(generationFieldWidth)) {
	          throw new _util.FormatError('Invalid XRef entry fields length: ' + first + ', ' + n);
	        }
	        for (i = streamState.entryNum; i < n; ++i) {
	          streamState.entryNum = i;
	          streamState.streamPos = stream.pos;
	          var type = 0,
	              offset = 0,
	              generation = 0;
	          for (j = 0; j < typeFieldWidth; ++j) {
	            type = type << 8 | stream.getByte();
	          }
	          if (typeFieldWidth === 0) {
	            type = 1;
	          }
	          for (j = 0; j < offsetFieldWidth; ++j) {
	            offset = offset << 8 | stream.getByte();
	          }
	          for (j = 0; j < generationFieldWidth; ++j) {
	            generation = generation << 8 | stream.getByte();
	          }
	          var entry = {};
	          entry.offset = offset;
	          entry.gen = generation;
	          switch (type) {
	            case 0:
	              entry.free = true;
	              break;
	            case 1:
	              entry.uncompressed = true;
	              break;
	            case 2:
	              break;
	            default:
	              throw new _util.FormatError('Invalid XRef entry type: ' + type);
	          }
	          if (!this.entries[first + i]) {
	            this.entries[first + i] = entry;
	          }
	        }
	        streamState.entryNum = 0;
	        streamState.streamPos = stream.pos;
	        entryRanges.splice(0, 2);
	      }
	    },
	    indexObjects: function XRef_indexObjects() {
	      var TAB = 0x9,
	          LF = 0xA,
	          CR = 0xD,
	          SPACE = 0x20;
	      var PERCENT = 0x25,
	          LT = 0x3C;
	      function readToken(data, offset) {
	        var token = '',
	            ch = data[offset];
	        while (ch !== LF && ch !== CR && ch !== LT) {
	          if (++offset >= data.length) {
	            break;
	          }
	          token += String.fromCharCode(ch);
	          ch = data[offset];
	        }
	        return token;
	      }
	      function skipUntil(data, offset, what) {
	        var length = what.length,
	            dataLength = data.length;
	        var skipped = 0;
	        while (offset < dataLength) {
	          var i = 0;
	          while (i < length && data[offset + i] === what[i]) {
	            ++i;
	          }
	          if (i >= length) {
	            break;
	          }
	          offset++;
	          skipped++;
	        }
	        return skipped;
	      }
	      var objRegExp = /^(\d+)\s+(\d+)\s+obj\b/;
	      var trailerBytes = new Uint8Array([116, 114, 97, 105, 108, 101, 114]);
	      var startxrefBytes = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]);
	      var endobjBytes = new Uint8Array([101, 110, 100, 111, 98, 106]);
	      var xrefBytes = new Uint8Array([47, 88, 82, 101, 102]);
	      this.entries.length = 0;
	      var stream = this.stream;
	      stream.pos = 0;
	      var buffer = stream.getBytes();
	      var position = stream.start,
	          length = buffer.length;
	      var trailers = [],
	          xrefStms = [];
	      while (position < length) {
	        var ch = buffer[position];
	        if (ch === TAB || ch === LF || ch === CR || ch === SPACE) {
	          ++position;
	          continue;
	        }
	        if (ch === PERCENT) {
	          do {
	            ++position;
	            if (position >= length) {
	              break;
	            }
	            ch = buffer[position];
	          } while (ch !== LF && ch !== CR);
	          continue;
	        }
	        var token = readToken(buffer, position);
	        var m;
	        if (token.indexOf('xref') === 0 && (token.length === 4 || /\s/.test(token[4]))) {
	          position += skipUntil(buffer, position, trailerBytes);
	          trailers.push(position);
	          position += skipUntil(buffer, position, startxrefBytes);
	        } else if (m = objRegExp.exec(token)) {
	          if (typeof this.entries[m[1]] === 'undefined') {
	            this.entries[m[1]] = {
	              offset: position - stream.start,
	              gen: m[2] | 0,
	              uncompressed: true
	            };
	          }
	          var contentLength = skipUntil(buffer, position, endobjBytes) + 7;
	          var content = buffer.subarray(position, position + contentLength);
	          var xrefTagOffset = skipUntil(content, 0, xrefBytes);
	          if (xrefTagOffset < contentLength && content[xrefTagOffset + 5] < 64) {
	            xrefStms.push(position - stream.start);
	            this.xrefstms[position - stream.start] = 1;
	          }
	          position += contentLength;
	        } else if (token.indexOf('trailer') === 0 && (token.length === 7 || /\s/.test(token[7]))) {
	          trailers.push(position);
	          position += skipUntil(buffer, position, startxrefBytes);
	        } else {
	          position += token.length + 1;
	        }
	      }
	      var i, ii;
	      for (i = 0, ii = xrefStms.length; i < ii; ++i) {
	        this.startXRefQueue.push(xrefStms[i]);
	        this.readXRef(true);
	      }
	      var dict;
	      for (i = 0, ii = trailers.length; i < ii; ++i) {
	        stream.pos = trailers[i];
	        var parser = new _parser.Parser(new _parser.Lexer(stream), true, this, true);
	        var obj = parser.getObj();
	        if (!(0, _primitives.isCmd)(obj, 'trailer')) {
	          continue;
	        }
	        dict = parser.getObj();
	        if (!(0, _primitives.isDict)(dict)) {
	          continue;
	        }
	        if (dict.has('ID')) {
	          return dict;
	        }
	      }
	      if (dict) {
	        return dict;
	      }
	      throw new _util.InvalidPDFException('Invalid PDF structure');
	    },
	    readXRef: function XRef_readXRef(recoveryMode) {
	      var stream = this.stream;
	      var startXRefParsedCache = Object.create(null);
	      try {
	        while (this.startXRefQueue.length) {
	          var startXRef = this.startXRefQueue[0];
	          if (startXRefParsedCache[startXRef]) {
	            (0, _util.warn)('readXRef - skipping XRef table since it was already parsed.');
	            this.startXRefQueue.shift();
	            continue;
	          }
	          startXRefParsedCache[startXRef] = true;
	          stream.pos = startXRef + stream.start;
	          var parser = new _parser.Parser(new _parser.Lexer(stream), true, this);
	          var obj = parser.getObj();
	          var dict;
	          if ((0, _primitives.isCmd)(obj, 'xref')) {
	            dict = this.processXRefTable(parser);
	            if (!this.topDict) {
	              this.topDict = dict;
	            }
	            obj = dict.get('XRefStm');
	            if (Number.isInteger(obj)) {
	              var pos = obj;
	              if (!(pos in this.xrefstms)) {
	                this.xrefstms[pos] = 1;
	                this.startXRefQueue.push(pos);
	              }
	            }
	          } else if (Number.isInteger(obj)) {
	            if (!Number.isInteger(parser.getObj()) || !(0, _primitives.isCmd)(parser.getObj(), 'obj') || !(0, _primitives.isStream)(obj = parser.getObj())) {
	              throw new _util.FormatError('Invalid XRef stream');
	            }
	            dict = this.processXRefStream(obj);
	            if (!this.topDict) {
	              this.topDict = dict;
	            }
	            if (!dict) {
	              throw new _util.FormatError('Failed to read XRef stream');
	            }
	          } else {
	            throw new _util.FormatError('Invalid XRef stream header');
	          }
	          obj = dict.get('Prev');
	          if (Number.isInteger(obj)) {
	            this.startXRefQueue.push(obj);
	          } else if ((0, _primitives.isRef)(obj)) {
	            this.startXRefQueue.push(obj.num);
	          }
	          this.startXRefQueue.shift();
	        }
	        return this.topDict;
	      } catch (e) {
	        if (e instanceof _util.MissingDataException) {
	          throw e;
	        }
	        (0, _util.info)('(while reading XRef): ' + e);
	      }
	      if (recoveryMode) {
	        return;
	      }
	      throw new _util.XRefParseException();
	    },
	    getEntry: function XRef_getEntry(i) {
	      var xrefEntry = this.entries[i];
	      if (xrefEntry && !xrefEntry.free && xrefEntry.offset) {
	        return xrefEntry;
	      }
	      return null;
	    },
	    fetchIfRef: function XRef_fetchIfRef(obj, suppressEncryption) {
	      if (!(0, _primitives.isRef)(obj)) {
	        return obj;
	      }
	      return this.fetch(obj, suppressEncryption);
	    },
	    fetch: function XRef_fetch(ref, suppressEncryption) {
	      if (!(0, _primitives.isRef)(ref)) {
	        throw new Error('ref object is not a reference');
	      }
	      var num = ref.num;
	      if (num in this.cache) {
	        var cacheEntry = this.cache[num];
	        if (cacheEntry instanceof _primitives.Dict && !cacheEntry.objId) {
	          cacheEntry.objId = ref.toString();
	        }
	        return cacheEntry;
	      }
	      var xrefEntry = this.getEntry(num);
	      if (xrefEntry === null) {
	        return this.cache[num] = null;
	      }
	      if (xrefEntry.uncompressed) {
	        xrefEntry = this.fetchUncompressed(ref, xrefEntry, suppressEncryption);
	      } else {
	        xrefEntry = this.fetchCompressed(xrefEntry, suppressEncryption);
	      }
	      if ((0, _primitives.isDict)(xrefEntry)) {
	        xrefEntry.objId = ref.toString();
	      } else if ((0, _primitives.isStream)(xrefEntry)) {
	        xrefEntry.dict.objId = ref.toString();
	      }
	      return xrefEntry;
	    },
	    fetchUncompressed: function XRef_fetchUncompressed(ref, xrefEntry, suppressEncryption) {
	      var gen = ref.gen;
	      var num = ref.num;
	      if (xrefEntry.gen !== gen) {
	        throw new _util.FormatError('inconsistent generation in XRef');
	      }
	      var stream = this.stream.makeSubStream(xrefEntry.offset + this.stream.start);
	      var parser = new _parser.Parser(new _parser.Lexer(stream), true, this);
	      var obj1 = parser.getObj();
	      var obj2 = parser.getObj();
	      var obj3 = parser.getObj();
	      if (!Number.isInteger(obj1)) {
	        obj1 = parseInt(obj1, 10);
	      }
	      if (!Number.isInteger(obj2)) {
	        obj2 = parseInt(obj2, 10);
	      }
	      if (obj1 !== num || obj2 !== gen || !(0, _primitives.isCmd)(obj3)) {
	        throw new _util.FormatError('bad XRef entry');
	      }
	      if (obj3.cmd !== 'obj') {
	        if (obj3.cmd.indexOf('obj') === 0) {
	          num = parseInt(obj3.cmd.substring(3), 10);
	          if (!Number.isNaN(num)) {
	            return num;
	          }
	        }
	        throw new _util.FormatError('bad XRef entry');
	      }
	      if (this.encrypt && !suppressEncryption) {
	        xrefEntry = parser.getObj(this.encrypt.createCipherTransform(num, gen));
	      } else {
	        xrefEntry = parser.getObj();
	      }
	      if (!(0, _primitives.isStream)(xrefEntry)) {
	        this.cache[num] = xrefEntry;
	      }
	      return xrefEntry;
	    },
	    fetchCompressed: function XRef_fetchCompressed(xrefEntry, suppressEncryption) {
	      var tableOffset = xrefEntry.offset;
	      var stream = this.fetch(new _primitives.Ref(tableOffset, 0));
	      if (!(0, _primitives.isStream)(stream)) {
	        throw new _util.FormatError('bad ObjStm stream');
	      }
	      var first = stream.dict.get('First');
	      var n = stream.dict.get('N');
	      if (!Number.isInteger(first) || !Number.isInteger(n)) {
	        throw new _util.FormatError('invalid first and n parameters for ObjStm stream');
	      }
	      var parser = new _parser.Parser(new _parser.Lexer(stream), false, this);
	      parser.allowStreams = true;
	      var i,
	          entries = [],
	          num,
	          nums = [];
	      for (i = 0; i < n; ++i) {
	        num = parser.getObj();
	        if (!Number.isInteger(num)) {
	          throw new _util.FormatError('invalid object number in the ObjStm stream: ' + num);
	        }
	        nums.push(num);
	        var offset = parser.getObj();
	        if (!Number.isInteger(offset)) {
	          throw new _util.FormatError('invalid object offset in the ObjStm stream: ' + offset);
	        }
	      }
	      for (i = 0; i < n; ++i) {
	        entries.push(parser.getObj());
	        if ((0, _primitives.isCmd)(parser.buf1, 'endobj')) {
	          parser.shift();
	        }
	        num = nums[i];
	        var entry = this.entries[num];
	        if (entry && entry.offset === tableOffset && entry.gen === i) {
	          this.cache[num] = entries[i];
	        }
	      }
	      xrefEntry = entries[xrefEntry.gen];
	      if (xrefEntry === undefined) {
	        throw new _util.FormatError('bad XRef entry for compressed object');
	      }
	      return xrefEntry;
	    },
	    fetchIfRefAsync: function XRef_fetchIfRefAsync(obj, suppressEncryption) {
	      if (!(0, _primitives.isRef)(obj)) {
	        return Promise.resolve(obj);
	      }
	      return this.fetchAsync(obj, suppressEncryption);
	    },
	    fetchAsync: function XRef_fetchAsync(ref, suppressEncryption) {
	      var streamManager = this.stream.manager;
	      var xref = this;
	      return new Promise(function tryFetch(resolve, reject) {
	        try {
	          resolve(xref.fetch(ref, suppressEncryption));
	        } catch (e) {
	          if (e instanceof _util.MissingDataException) {
	            streamManager.requestRange(e.begin, e.end).then(function () {
	              tryFetch(resolve, reject);
	            }, reject);
	            return;
	          }
	          reject(e);
	        }
	      });
	    },
	    getCatalogObj: function XRef_getCatalogObj() {
	      return this.root;
	    }
	  };
	  return XRef;
	}();
	var NameOrNumberTree = function NameOrNumberTreeClosure() {
	  function NameOrNumberTree(root, xref) {
	    throw new Error('Cannot initialize NameOrNumberTree.');
	  }
	  NameOrNumberTree.prototype = {
	    getAll: function NameOrNumberTree_getAll() {
	      var dict = Object.create(null);
	      if (!this.root) {
	        return dict;
	      }
	      var xref = this.xref;
	      var processed = new _primitives.RefSet();
	      processed.put(this.root);
	      var queue = [this.root];
	      while (queue.length > 0) {
	        var i, n;
	        var obj = xref.fetchIfRef(queue.shift());
	        if (!(0, _primitives.isDict)(obj)) {
	          continue;
	        }
	        if (obj.has('Kids')) {
	          var kids = obj.get('Kids');
	          for (i = 0, n = kids.length; i < n; i++) {
	            var kid = kids[i];
	            if (processed.has(kid)) {
	              throw new _util.FormatError('Duplicate entry in "' + this._type + '" tree.');
	            }
	            queue.push(kid);
	            processed.put(kid);
	          }
	          continue;
	        }
	        var entries = obj.get(this._type);
	        if (Array.isArray(entries)) {
	          for (i = 0, n = entries.length; i < n; i += 2) {
	            dict[xref.fetchIfRef(entries[i])] = xref.fetchIfRef(entries[i + 1]);
	          }
	        }
	      }
	      return dict;
	    },
	    get: function NameOrNumberTree_get(key) {
	      if (!this.root) {
	        return null;
	      }
	      var xref = this.xref;
	      var kidsOrEntries = xref.fetchIfRef(this.root);
	      var loopCount = 0;
	      var MAX_LEVELS = 10;
	      var l, r, m;
	      while (kidsOrEntries.has('Kids')) {
	        if (++loopCount > MAX_LEVELS) {
	          (0, _util.warn)('Search depth limit reached for "' + this._type + '" tree.');
	          return null;
	        }
	        var kids = kidsOrEntries.get('Kids');
	        if (!Array.isArray(kids)) {
	          return null;
	        }
	        l = 0;
	        r = kids.length - 1;
	        while (l <= r) {
	          m = l + r >> 1;
	          var kid = xref.fetchIfRef(kids[m]);
	          var limits = kid.get('Limits');
	          if (key < xref.fetchIfRef(limits[0])) {
	            r = m - 1;
	          } else if (key > xref.fetchIfRef(limits[1])) {
	            l = m + 1;
	          } else {
	            kidsOrEntries = xref.fetchIfRef(kids[m]);
	            break;
	          }
	        }
	        if (l > r) {
	          return null;
	        }
	      }
	      var entries = kidsOrEntries.get(this._type);
	      if (Array.isArray(entries)) {
	        l = 0;
	        r = entries.length - 2;
	        while (l <= r) {
	          m = l + r & ~1;
	          var currentKey = xref.fetchIfRef(entries[m]);
	          if (key < currentKey) {
	            r = m - 2;
	          } else if (key > currentKey) {
	            l = m + 2;
	          } else {
	            return xref.fetchIfRef(entries[m + 1]);
	          }
	        }
	      }
	      return null;
	    }
	  };
	  return NameOrNumberTree;
	}();
	var NameTree = function NameTreeClosure() {
	  function NameTree(root, xref) {
	    this.root = root;
	    this.xref = xref;
	    this._type = 'Names';
	  }
	  _util.Util.inherit(NameTree, NameOrNumberTree, {});
	  return NameTree;
	}();
	var NumberTree = function NumberTreeClosure() {
	  function NumberTree(root, xref) {
	    this.root = root;
	    this.xref = xref;
	    this._type = 'Nums';
	  }
	  _util.Util.inherit(NumberTree, NameOrNumberTree, {});
	  return NumberTree;
	}();
	var FileSpec = function FileSpecClosure() {
	  function FileSpec(root, xref) {
	    if (!root || !(0, _primitives.isDict)(root)) {
	      return;
	    }
	    this.xref = xref;
	    this.root = root;
	    if (root.has('FS')) {
	      this.fs = root.get('FS');
	    }
	    this.description = root.has('Desc') ? (0, _util.stringToPDFString)(root.get('Desc')) : '';
	    if (root.has('RF')) {
	      (0, _util.warn)('Related file specifications are not supported');
	    }
	    this.contentAvailable = true;
	    if (!root.has('EF')) {
	      this.contentAvailable = false;
	      (0, _util.warn)('Non-embedded file specifications are not supported');
	    }
	  }
	  function pickPlatformItem(dict) {
	    if (dict.has('UF')) {
	      return dict.get('UF');
	    } else if (dict.has('F')) {
	      return dict.get('F');
	    } else if (dict.has('Unix')) {
	      return dict.get('Unix');
	    } else if (dict.has('Mac')) {
	      return dict.get('Mac');
	    } else if (dict.has('DOS')) {
	      return dict.get('DOS');
	    }
	    return null;
	  }
	  FileSpec.prototype = {
	    get filename() {
	      if (!this._filename && this.root) {
	        var filename = pickPlatformItem(this.root) || 'unnamed';
	        this._filename = (0, _util.stringToPDFString)(filename).replace(/\\\\/g, '\\').replace(/\\\//g, '/').replace(/\\/g, '/');
	      }
	      return this._filename;
	    },
	    get content() {
	      if (!this.contentAvailable) {
	        return null;
	      }
	      if (!this.contentRef && this.root) {
	        this.contentRef = pickPlatformItem(this.root.get('EF'));
	      }
	      var content = null;
	      if (this.contentRef) {
	        var xref = this.xref;
	        var fileObj = xref.fetchIfRef(this.contentRef);
	        if (fileObj && (0, _primitives.isStream)(fileObj)) {
	          content = fileObj.getBytes();
	        } else {
	          (0, _util.warn)('Embedded file specification points to non-existing/invalid ' + 'content');
	        }
	      } else {
	        (0, _util.warn)('Embedded file specification does not have a content');
	      }
	      return content;
	    },
	    get serializable() {
	      return {
	        filename: this.filename,
	        content: this.content
	      };
	    }
	  };
	  return FileSpec;
	}();
	var ObjectLoader = function () {
	  function mayHaveChildren(value) {
	    return (0, _primitives.isRef)(value) || (0, _primitives.isDict)(value) || Array.isArray(value) || (0, _primitives.isStream)(value);
	  }
	  function addChildren(node, nodesToVisit) {
	    if ((0, _primitives.isDict)(node) || (0, _primitives.isStream)(node)) {
	      var dict = (0, _primitives.isDict)(node) ? node : node.dict;
	      var dictKeys = dict.getKeys();
	      for (var i = 0, ii = dictKeys.length; i < ii; i++) {
	        var rawValue = dict.getRaw(dictKeys[i]);
	        if (mayHaveChildren(rawValue)) {
	          nodesToVisit.push(rawValue);
	        }
	      }
	    } else if (Array.isArray(node)) {
	      for (var _i = 0, _ii = node.length; _i < _ii; _i++) {
	        var value = node[_i];
	        if (mayHaveChildren(value)) {
	          nodesToVisit.push(value);
	        }
	      }
	    }
	  }
	  function ObjectLoader(dict, keys, xref) {
	    this.dict = dict;
	    this.keys = keys;
	    this.xref = xref;
	    this.refSet = null;
	    this.capability = null;
	  }
	  ObjectLoader.prototype = {
	    load: function load() {
	      this.capability = (0, _util.createPromiseCapability)();
	      if (!(this.xref.stream instanceof _chunked_stream.ChunkedStream) || this.xref.stream.getMissingChunks().length === 0) {
	        this.capability.resolve();
	        return this.capability.promise;
	      }
	      var keys = this.keys,
	          dict = this.dict;
	
	      this.refSet = new _primitives.RefSet();
	      var nodesToVisit = [];
	      for (var i = 0, ii = keys.length; i < ii; i++) {
	        var rawValue = dict.getRaw(keys[i]);
	        if (rawValue !== undefined) {
	          nodesToVisit.push(rawValue);
	        }
	      }
	      this._walk(nodesToVisit);
	      return this.capability.promise;
	    },
	    _walk: function _walk(nodesToVisit) {
	      var _this3 = this;
	
	      var nodesToRevisit = [];
	      var pendingRequests = [];
	      while (nodesToVisit.length) {
	        var currentNode = nodesToVisit.pop();
	        if ((0, _primitives.isRef)(currentNode)) {
	          if (this.refSet.has(currentNode)) {
	            continue;
	          }
	          try {
	            this.refSet.put(currentNode);
	            currentNode = this.xref.fetch(currentNode);
	          } catch (ex) {
	            if (!(ex instanceof _util.MissingDataException)) {
	              throw ex;
	            }
	            nodesToRevisit.push(currentNode);
	            pendingRequests.push({
	              begin: ex.begin,
	              end: ex.end
	            });
	          }
	        }
	        if (currentNode && currentNode.getBaseStreams) {
	          var baseStreams = currentNode.getBaseStreams();
	          var foundMissingData = false;
	          for (var i = 0, ii = baseStreams.length; i < ii; i++) {
	            var stream = baseStreams[i];
	            if (stream.getMissingChunks && stream.getMissingChunks().length) {
	              foundMissingData = true;
	              pendingRequests.push({
	                begin: stream.start,
	                end: stream.end
	              });
	            }
	          }
	          if (foundMissingData) {
	            nodesToRevisit.push(currentNode);
	          }
	        }
	        addChildren(currentNode, nodesToVisit);
	      }
	      if (pendingRequests.length) {
	        this.xref.stream.manager.requestRanges(pendingRequests).then(function () {
	          for (var _i2 = 0, _ii2 = nodesToRevisit.length; _i2 < _ii2; _i2++) {
	            var node = nodesToRevisit[_i2];
	            if ((0, _primitives.isRef)(node)) {
	              _this3.refSet.remove(node);
	            }
	          }
	          _this3._walk(nodesToRevisit);
	        }, this.capability.reject);
	        return;
	      }
	      this.refSet = null;
	      this.capability.resolve();
	    }
	  };
	  return ObjectLoader;
	}();
	exports.Catalog = Catalog;
	exports.ObjectLoader = ObjectLoader;
	exports.XRef = XRef;
	exports.FileSpec = FileSpec;
	
	/***/ }),
	/* 80 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.JpxImage = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _arithmetic_decoder = __w_pdfjs_require__(81);
	
	var JpxError = function JpxErrorClosure() {
	  function JpxError(msg) {
	    this.message = 'JPX error: ' + msg;
	  }
	  JpxError.prototype = new Error();
	  JpxError.prototype.name = 'JpxError';
	  JpxError.constructor = JpxError;
	  return JpxError;
	}();
	var JpxImage = function JpxImageClosure() {
	  var SubbandsGainLog2 = {
	    'LL': 0,
	    'LH': 1,
	    'HL': 1,
	    'HH': 2
	  };
	  function JpxImage() {
	    this.failOnCorruptedImage = false;
	  }
	  JpxImage.prototype = {
	    parse: function JpxImage_parse(data) {
	      var head = (0, _util.readUint16)(data, 0);
	      if (head === 0xFF4F) {
	        this.parseCodestream(data, 0, data.length);
	        return;
	      }
	      var position = 0,
	          length = data.length;
	      while (position < length) {
	        var headerSize = 8;
	        var lbox = (0, _util.readUint32)(data, position);
	        var tbox = (0, _util.readUint32)(data, position + 4);
	        position += headerSize;
	        if (lbox === 1) {
	          lbox = (0, _util.readUint32)(data, position) * 4294967296 + (0, _util.readUint32)(data, position + 4);
	          position += 8;
	          headerSize += 8;
	        }
	        if (lbox === 0) {
	          lbox = length - position + headerSize;
	        }
	        if (lbox < headerSize) {
	          throw new JpxError('Invalid box field size');
	        }
	        var dataLength = lbox - headerSize;
	        var jumpDataLength = true;
	        switch (tbox) {
	          case 0x6A703268:
	            jumpDataLength = false;
	            break;
	          case 0x636F6C72:
	            var method = data[position];
	            if (method === 1) {
	              var colorspace = (0, _util.readUint32)(data, position + 3);
	              switch (colorspace) {
	                case 16:
	                case 17:
	                case 18:
	                  break;
	                default:
	                  (0, _util.warn)('Unknown colorspace ' + colorspace);
	                  break;
	              }
	            } else if (method === 2) {
	              (0, _util.info)('ICC profile not supported');
	            }
	            break;
	          case 0x6A703263:
	            this.parseCodestream(data, position, position + dataLength);
	            break;
	          case 0x6A502020:
	            if ((0, _util.readUint32)(data, position) !== 0x0d0a870a) {
	              (0, _util.warn)('Invalid JP2 signature');
	            }
	            break;
	          case 0x6A501A1A:
	          case 0x66747970:
	          case 0x72726571:
	          case 0x72657320:
	          case 0x69686472:
	            break;
	          default:
	            var headerType = String.fromCharCode(tbox >> 24 & 0xFF, tbox >> 16 & 0xFF, tbox >> 8 & 0xFF, tbox & 0xFF);
	            (0, _util.warn)('Unsupported header type ' + tbox + ' (' + headerType + ')');
	            break;
	        }
	        if (jumpDataLength) {
	          position += dataLength;
	        }
	      }
	    },
	    parseImageProperties: function JpxImage_parseImageProperties(stream) {
	      var newByte = stream.getByte();
	      while (newByte >= 0) {
	        var oldByte = newByte;
	        newByte = stream.getByte();
	        var code = oldByte << 8 | newByte;
	        if (code === 0xFF51) {
	          stream.skip(4);
	          var Xsiz = stream.getInt32() >>> 0;
	          var Ysiz = stream.getInt32() >>> 0;
	          var XOsiz = stream.getInt32() >>> 0;
	          var YOsiz = stream.getInt32() >>> 0;
	          stream.skip(16);
	          var Csiz = stream.getUint16();
	          this.width = Xsiz - XOsiz;
	          this.height = Ysiz - YOsiz;
	          this.componentsCount = Csiz;
	          this.bitsPerComponent = 8;
	          return;
	        }
	      }
	      throw new JpxError('No size marker found in JPX stream');
	    },
	    parseCodestream: function JpxImage_parseCodestream(data, start, end) {
	      var context = {};
	      var doNotRecover = false;
	      try {
	        var position = start;
	        while (position + 1 < end) {
	          var code = (0, _util.readUint16)(data, position);
	          position += 2;
	          var length = 0,
	              j,
	              sqcd,
	              spqcds,
	              spqcdSize,
	              scalarExpounded,
	              tile;
	          switch (code) {
	            case 0xFF4F:
	              context.mainHeader = true;
	              break;
	            case 0xFFD9:
	              break;
	            case 0xFF51:
	              length = (0, _util.readUint16)(data, position);
	              var siz = {};
	              siz.Xsiz = (0, _util.readUint32)(data, position + 4);
	              siz.Ysiz = (0, _util.readUint32)(data, position + 8);
	              siz.XOsiz = (0, _util.readUint32)(data, position + 12);
	              siz.YOsiz = (0, _util.readUint32)(data, position + 16);
	              siz.XTsiz = (0, _util.readUint32)(data, position + 20);
	              siz.YTsiz = (0, _util.readUint32)(data, position + 24);
	              siz.XTOsiz = (0, _util.readUint32)(data, position + 28);
	              siz.YTOsiz = (0, _util.readUint32)(data, position + 32);
	              var componentsCount = (0, _util.readUint16)(data, position + 36);
	              siz.Csiz = componentsCount;
	              var components = [];
	              j = position + 38;
	              for (var i = 0; i < componentsCount; i++) {
	                var component = {
	                  precision: (data[j] & 0x7F) + 1,
	                  isSigned: !!(data[j] & 0x80),
	                  XRsiz: data[j + 1],
	                  YRsiz: data[j + 1]
	                };
	                calculateComponentDimensions(component, siz);
	                components.push(component);
	              }
	              context.SIZ = siz;
	              context.components = components;
	              calculateTileGrids(context, components);
	              context.QCC = [];
	              context.COC = [];
	              break;
	            case 0xFF5C:
	              length = (0, _util.readUint16)(data, position);
	              var qcd = {};
	              j = position + 2;
	              sqcd = data[j++];
	              switch (sqcd & 0x1F) {
	                case 0:
	                  spqcdSize = 8;
	                  scalarExpounded = true;
	                  break;
	                case 1:
	                  spqcdSize = 16;
	                  scalarExpounded = false;
	                  break;
	                case 2:
	                  spqcdSize = 16;
	                  scalarExpounded = true;
	                  break;
	                default:
	                  throw new Error('Invalid SQcd value ' + sqcd);
	              }
	              qcd.noQuantization = spqcdSize === 8;
	              qcd.scalarExpounded = scalarExpounded;
	              qcd.guardBits = sqcd >> 5;
	              spqcds = [];
	              while (j < length + position) {
	                var spqcd = {};
	                if (spqcdSize === 8) {
	                  spqcd.epsilon = data[j++] >> 3;
	                  spqcd.mu = 0;
	                } else {
	                  spqcd.epsilon = data[j] >> 3;
	                  spqcd.mu = (data[j] & 0x7) << 8 | data[j + 1];
	                  j += 2;
	                }
	                spqcds.push(spqcd);
	              }
	              qcd.SPqcds = spqcds;
	              if (context.mainHeader) {
	                context.QCD = qcd;
	              } else {
	                context.currentTile.QCD = qcd;
	                context.currentTile.QCC = [];
	              }
	              break;
	            case 0xFF5D:
	              length = (0, _util.readUint16)(data, position);
	              var qcc = {};
	              j = position + 2;
	              var cqcc;
	              if (context.SIZ.Csiz < 257) {
	                cqcc = data[j++];
	              } else {
	                cqcc = (0, _util.readUint16)(data, j);
	                j += 2;
	              }
	              sqcd = data[j++];
	              switch (sqcd & 0x1F) {
	                case 0:
	                  spqcdSize = 8;
	                  scalarExpounded = true;
	                  break;
	                case 1:
	                  spqcdSize = 16;
	                  scalarExpounded = false;
	                  break;
	                case 2:
	                  spqcdSize = 16;
	                  scalarExpounded = true;
	                  break;
	                default:
	                  throw new Error('Invalid SQcd value ' + sqcd);
	              }
	              qcc.noQuantization = spqcdSize === 8;
	              qcc.scalarExpounded = scalarExpounded;
	              qcc.guardBits = sqcd >> 5;
	              spqcds = [];
	              while (j < length + position) {
	                spqcd = {};
	                if (spqcdSize === 8) {
	                  spqcd.epsilon = data[j++] >> 3;
	                  spqcd.mu = 0;
	                } else {
	                  spqcd.epsilon = data[j] >> 3;
	                  spqcd.mu = (data[j] & 0x7) << 8 | data[j + 1];
	                  j += 2;
	                }
	                spqcds.push(spqcd);
	              }
	              qcc.SPqcds = spqcds;
	              if (context.mainHeader) {
	                context.QCC[cqcc] = qcc;
	              } else {
	                context.currentTile.QCC[cqcc] = qcc;
	              }
	              break;
	            case 0xFF52:
	              length = (0, _util.readUint16)(data, position);
	              var cod = {};
	              j = position + 2;
	              var scod = data[j++];
	              cod.entropyCoderWithCustomPrecincts = !!(scod & 1);
	              cod.sopMarkerUsed = !!(scod & 2);
	              cod.ephMarkerUsed = !!(scod & 4);
	              cod.progressionOrder = data[j++];
	              cod.layersCount = (0, _util.readUint16)(data, j);
	              j += 2;
	              cod.multipleComponentTransform = data[j++];
	              cod.decompositionLevelsCount = data[j++];
	              cod.xcb = (data[j++] & 0xF) + 2;
	              cod.ycb = (data[j++] & 0xF) + 2;
	              var blockStyle = data[j++];
	              cod.selectiveArithmeticCodingBypass = !!(blockStyle & 1);
	              cod.resetContextProbabilities = !!(blockStyle & 2);
	              cod.terminationOnEachCodingPass = !!(blockStyle & 4);
	              cod.verticalyStripe = !!(blockStyle & 8);
	              cod.predictableTermination = !!(blockStyle & 16);
	              cod.segmentationSymbolUsed = !!(blockStyle & 32);
	              cod.reversibleTransformation = data[j++];
	              if (cod.entropyCoderWithCustomPrecincts) {
	                var precinctsSizes = [];
	                while (j < length + position) {
	                  var precinctsSize = data[j++];
	                  precinctsSizes.push({
	                    PPx: precinctsSize & 0xF,
	                    PPy: precinctsSize >> 4
	                  });
	                }
	                cod.precinctsSizes = precinctsSizes;
	              }
	              var unsupported = [];
	              if (cod.selectiveArithmeticCodingBypass) {
	                unsupported.push('selectiveArithmeticCodingBypass');
	              }
	              if (cod.resetContextProbabilities) {
	                unsupported.push('resetContextProbabilities');
	              }
	              if (cod.terminationOnEachCodingPass) {
	                unsupported.push('terminationOnEachCodingPass');
	              }
	              if (cod.verticalyStripe) {
	                unsupported.push('verticalyStripe');
	              }
	              if (cod.predictableTermination) {
	                unsupported.push('predictableTermination');
	              }
	              if (unsupported.length > 0) {
	                doNotRecover = true;
	                throw new Error('Unsupported COD options (' + unsupported.join(', ') + ')');
	              }
	              if (context.mainHeader) {
	                context.COD = cod;
	              } else {
	                context.currentTile.COD = cod;
	                context.currentTile.COC = [];
	              }
	              break;
	            case 0xFF90:
	              length = (0, _util.readUint16)(data, position);
	              tile = {};
	              tile.index = (0, _util.readUint16)(data, position + 2);
	              tile.length = (0, _util.readUint32)(data, position + 4);
	              tile.dataEnd = tile.length + position - 2;
	              tile.partIndex = data[position + 8];
	              tile.partsCount = data[position + 9];
	              context.mainHeader = false;
	              if (tile.partIndex === 0) {
	                tile.COD = context.COD;
	                tile.COC = context.COC.slice(0);
	                tile.QCD = context.QCD;
	                tile.QCC = context.QCC.slice(0);
	              }
	              context.currentTile = tile;
	              break;
	            case 0xFF93:
	              tile = context.currentTile;
	              if (tile.partIndex === 0) {
	                initializeTile(context, tile.index);
	                buildPackets(context);
	              }
	              length = tile.dataEnd - position;
	              parseTilePackets(context, data, position, length);
	              break;
	            case 0xFF55:
	            case 0xFF57:
	            case 0xFF58:
	            case 0xFF64:
	              length = (0, _util.readUint16)(data, position);
	              break;
	            case 0xFF53:
	              throw new Error('Codestream code 0xFF53 (COC) is ' + 'not implemented');
	            default:
	              throw new Error('Unknown codestream code: ' + code.toString(16));
	          }
	          position += length;
	        }
	      } catch (e) {
	        if (doNotRecover || this.failOnCorruptedImage) {
	          throw new JpxError(e.message);
	        } else {
	          (0, _util.warn)('JPX: Trying to recover from: ' + e.message);
	        }
	      }
	      this.tiles = transformComponents(context);
	      this.width = context.SIZ.Xsiz - context.SIZ.XOsiz;
	      this.height = context.SIZ.Ysiz - context.SIZ.YOsiz;
	      this.componentsCount = context.SIZ.Csiz;
	    }
	  };
	  function calculateComponentDimensions(component, siz) {
	    component.x0 = Math.ceil(siz.XOsiz / component.XRsiz);
	    component.x1 = Math.ceil(siz.Xsiz / component.XRsiz);
	    component.y0 = Math.ceil(siz.YOsiz / component.YRsiz);
	    component.y1 = Math.ceil(siz.Ysiz / component.YRsiz);
	    component.width = component.x1 - component.x0;
	    component.height = component.y1 - component.y0;
	  }
	  function calculateTileGrids(context, components) {
	    var siz = context.SIZ;
	    var tile,
	        tiles = [];
	    var numXtiles = Math.ceil((siz.Xsiz - siz.XTOsiz) / siz.XTsiz);
	    var numYtiles = Math.ceil((siz.Ysiz - siz.YTOsiz) / siz.YTsiz);
	    for (var q = 0; q < numYtiles; q++) {
	      for (var p = 0; p < numXtiles; p++) {
	        tile = {};
	        tile.tx0 = Math.max(siz.XTOsiz + p * siz.XTsiz, siz.XOsiz);
	        tile.ty0 = Math.max(siz.YTOsiz + q * siz.YTsiz, siz.YOsiz);
	        tile.tx1 = Math.min(siz.XTOsiz + (p + 1) * siz.XTsiz, siz.Xsiz);
	        tile.ty1 = Math.min(siz.YTOsiz + (q + 1) * siz.YTsiz, siz.Ysiz);
	        tile.width = tile.tx1 - tile.tx0;
	        tile.height = tile.ty1 - tile.ty0;
	        tile.components = [];
	        tiles.push(tile);
	      }
	    }
	    context.tiles = tiles;
	    var componentsCount = siz.Csiz;
	    for (var i = 0, ii = componentsCount; i < ii; i++) {
	      var component = components[i];
	      for (var j = 0, jj = tiles.length; j < jj; j++) {
	        var tileComponent = {};
	        tile = tiles[j];
	        tileComponent.tcx0 = Math.ceil(tile.tx0 / component.XRsiz);
	        tileComponent.tcy0 = Math.ceil(tile.ty0 / component.YRsiz);
	        tileComponent.tcx1 = Math.ceil(tile.tx1 / component.XRsiz);
	        tileComponent.tcy1 = Math.ceil(tile.ty1 / component.YRsiz);
	        tileComponent.width = tileComponent.tcx1 - tileComponent.tcx0;
	        tileComponent.height = tileComponent.tcy1 - tileComponent.tcy0;
	        tile.components[i] = tileComponent;
	      }
	    }
	  }
	  function getBlocksDimensions(context, component, r) {
	    var codOrCoc = component.codingStyleParameters;
	    var result = {};
	    if (!codOrCoc.entropyCoderWithCustomPrecincts) {
	      result.PPx = 15;
	      result.PPy = 15;
	    } else {
	      result.PPx = codOrCoc.precinctsSizes[r].PPx;
	      result.PPy = codOrCoc.precinctsSizes[r].PPy;
	    }
	    result.xcb_ = r > 0 ? Math.min(codOrCoc.xcb, result.PPx - 1) : Math.min(codOrCoc.xcb, result.PPx);
	    result.ycb_ = r > 0 ? Math.min(codOrCoc.ycb, result.PPy - 1) : Math.min(codOrCoc.ycb, result.PPy);
	    return result;
	  }
	  function buildPrecincts(context, resolution, dimensions) {
	    var precinctWidth = 1 << dimensions.PPx;
	    var precinctHeight = 1 << dimensions.PPy;
	    var isZeroRes = resolution.resLevel === 0;
	    var precinctWidthInSubband = 1 << dimensions.PPx + (isZeroRes ? 0 : -1);
	    var precinctHeightInSubband = 1 << dimensions.PPy + (isZeroRes ? 0 : -1);
	    var numprecinctswide = resolution.trx1 > resolution.trx0 ? Math.ceil(resolution.trx1 / precinctWidth) - Math.floor(resolution.trx0 / precinctWidth) : 0;
	    var numprecinctshigh = resolution.try1 > resolution.try0 ? Math.ceil(resolution.try1 / precinctHeight) - Math.floor(resolution.try0 / precinctHeight) : 0;
	    var numprecincts = numprecinctswide * numprecinctshigh;
	    resolution.precinctParameters = {
	      precinctWidth: precinctWidth,
	      precinctHeight: precinctHeight,
	      numprecinctswide: numprecinctswide,
	      numprecinctshigh: numprecinctshigh,
	      numprecincts: numprecincts,
	      precinctWidthInSubband: precinctWidthInSubband,
	      precinctHeightInSubband: precinctHeightInSubband
	    };
	  }
	  function buildCodeblocks(context, subband, dimensions) {
	    var xcb_ = dimensions.xcb_;
	    var ycb_ = dimensions.ycb_;
	    var codeblockWidth = 1 << xcb_;
	    var codeblockHeight = 1 << ycb_;
	    var cbx0 = subband.tbx0 >> xcb_;
	    var cby0 = subband.tby0 >> ycb_;
	    var cbx1 = subband.tbx1 + codeblockWidth - 1 >> xcb_;
	    var cby1 = subband.tby1 + codeblockHeight - 1 >> ycb_;
	    var precinctParameters = subband.resolution.precinctParameters;
	    var codeblocks = [];
	    var precincts = [];
	    var i, j, codeblock, precinctNumber;
	    for (j = cby0; j < cby1; j++) {
	      for (i = cbx0; i < cbx1; i++) {
	        codeblock = {
	          cbx: i,
	          cby: j,
	          tbx0: codeblockWidth * i,
	          tby0: codeblockHeight * j,
	          tbx1: codeblockWidth * (i + 1),
	          tby1: codeblockHeight * (j + 1)
	        };
	        codeblock.tbx0_ = Math.max(subband.tbx0, codeblock.tbx0);
	        codeblock.tby0_ = Math.max(subband.tby0, codeblock.tby0);
	        codeblock.tbx1_ = Math.min(subband.tbx1, codeblock.tbx1);
	        codeblock.tby1_ = Math.min(subband.tby1, codeblock.tby1);
	        var pi = Math.floor((codeblock.tbx0_ - subband.tbx0) / precinctParameters.precinctWidthInSubband);
	        var pj = Math.floor((codeblock.tby0_ - subband.tby0) / precinctParameters.precinctHeightInSubband);
	        precinctNumber = pi + pj * precinctParameters.numprecinctswide;
	        codeblock.precinctNumber = precinctNumber;
	        codeblock.subbandType = subband.type;
	        codeblock.Lblock = 3;
	        if (codeblock.tbx1_ <= codeblock.tbx0_ || codeblock.tby1_ <= codeblock.tby0_) {
	          continue;
	        }
	        codeblocks.push(codeblock);
	        var precinct = precincts[precinctNumber];
	        if (precinct !== undefined) {
	          if (i < precinct.cbxMin) {
	            precinct.cbxMin = i;
	          } else if (i > precinct.cbxMax) {
	            precinct.cbxMax = i;
	          }
	          if (j < precinct.cbyMin) {
	            precinct.cbxMin = j;
	          } else if (j > precinct.cbyMax) {
	            precinct.cbyMax = j;
	          }
	        } else {
	          precincts[precinctNumber] = precinct = {
	            cbxMin: i,
	            cbyMin: j,
	            cbxMax: i,
	            cbyMax: j
	          };
	        }
	        codeblock.precinct = precinct;
	      }
	    }
	    subband.codeblockParameters = {
	      codeblockWidth: xcb_,
	      codeblockHeight: ycb_,
	      numcodeblockwide: cbx1 - cbx0 + 1,
	      numcodeblockhigh: cby1 - cby0 + 1
	    };
	    subband.codeblocks = codeblocks;
	    subband.precincts = precincts;
	  }
	  function createPacket(resolution, precinctNumber, layerNumber) {
	    var precinctCodeblocks = [];
	    var subbands = resolution.subbands;
	    for (var i = 0, ii = subbands.length; i < ii; i++) {
	      var subband = subbands[i];
	      var codeblocks = subband.codeblocks;
	      for (var j = 0, jj = codeblocks.length; j < jj; j++) {
	        var codeblock = codeblocks[j];
	        if (codeblock.precinctNumber !== precinctNumber) {
	          continue;
	        }
	        precinctCodeblocks.push(codeblock);
	      }
	    }
	    return {
	      layerNumber: layerNumber,
	      codeblocks: precinctCodeblocks
	    };
	  }
	  function LayerResolutionComponentPositionIterator(context) {
	    var siz = context.SIZ;
	    var tileIndex = context.currentTile.index;
	    var tile = context.tiles[tileIndex];
	    var layersCount = tile.codingStyleDefaultParameters.layersCount;
	    var componentsCount = siz.Csiz;
	    var maxDecompositionLevelsCount = 0;
	    for (var q = 0; q < componentsCount; q++) {
	      maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, tile.components[q].codingStyleParameters.decompositionLevelsCount);
	    }
	    var l = 0,
	        r = 0,
	        i = 0,
	        k = 0;
	    this.nextPacket = function JpxImage_nextPacket() {
	      for (; l < layersCount; l++) {
	        for (; r <= maxDecompositionLevelsCount; r++) {
	          for (; i < componentsCount; i++) {
	            var component = tile.components[i];
	            if (r > component.codingStyleParameters.decompositionLevelsCount) {
	              continue;
	            }
	            var resolution = component.resolutions[r];
	            var numprecincts = resolution.precinctParameters.numprecincts;
	            for (; k < numprecincts;) {
	              var packet = createPacket(resolution, k, l);
	              k++;
	              return packet;
	            }
	            k = 0;
	          }
	          i = 0;
	        }
	        r = 0;
	      }
	      throw new JpxError('Out of packets');
	    };
	  }
	  function ResolutionLayerComponentPositionIterator(context) {
	    var siz = context.SIZ;
	    var tileIndex = context.currentTile.index;
	    var tile = context.tiles[tileIndex];
	    var layersCount = tile.codingStyleDefaultParameters.layersCount;
	    var componentsCount = siz.Csiz;
	    var maxDecompositionLevelsCount = 0;
	    for (var q = 0; q < componentsCount; q++) {
	      maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, tile.components[q].codingStyleParameters.decompositionLevelsCount);
	    }
	    var r = 0,
	        l = 0,
	        i = 0,
	        k = 0;
	    this.nextPacket = function JpxImage_nextPacket() {
	      for (; r <= maxDecompositionLevelsCount; r++) {
	        for (; l < layersCount; l++) {
	          for (; i < componentsCount; i++) {
	            var component = tile.components[i];
	            if (r > component.codingStyleParameters.decompositionLevelsCount) {
	              continue;
	            }
	            var resolution = component.resolutions[r];
	            var numprecincts = resolution.precinctParameters.numprecincts;
	            for (; k < numprecincts;) {
	              var packet = createPacket(resolution, k, l);
	              k++;
	              return packet;
	            }
	            k = 0;
	          }
	          i = 0;
	        }
	        l = 0;
	      }
	      throw new JpxError('Out of packets');
	    };
	  }
	  function ResolutionPositionComponentLayerIterator(context) {
	    var siz = context.SIZ;
	    var tileIndex = context.currentTile.index;
	    var tile = context.tiles[tileIndex];
	    var layersCount = tile.codingStyleDefaultParameters.layersCount;
	    var componentsCount = siz.Csiz;
	    var l, r, c, p;
	    var maxDecompositionLevelsCount = 0;
	    for (c = 0; c < componentsCount; c++) {
	      var component = tile.components[c];
	      maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, component.codingStyleParameters.decompositionLevelsCount);
	    }
	    var maxNumPrecinctsInLevel = new Int32Array(maxDecompositionLevelsCount + 1);
	    for (r = 0; r <= maxDecompositionLevelsCount; ++r) {
	      var maxNumPrecincts = 0;
	      for (c = 0; c < componentsCount; ++c) {
	        var resolutions = tile.components[c].resolutions;
	        if (r < resolutions.length) {
	          maxNumPrecincts = Math.max(maxNumPrecincts, resolutions[r].precinctParameters.numprecincts);
	        }
	      }
	      maxNumPrecinctsInLevel[r] = maxNumPrecincts;
	    }
	    l = 0;
	    r = 0;
	    c = 0;
	    p = 0;
	    this.nextPacket = function JpxImage_nextPacket() {
	      for (; r <= maxDecompositionLevelsCount; r++) {
	        for (; p < maxNumPrecinctsInLevel[r]; p++) {
	          for (; c < componentsCount; c++) {
	            var component = tile.components[c];
	            if (r > component.codingStyleParameters.decompositionLevelsCount) {
	              continue;
	            }
	            var resolution = component.resolutions[r];
	            var numprecincts = resolution.precinctParameters.numprecincts;
	            if (p >= numprecincts) {
	              continue;
	            }
	            for (; l < layersCount;) {
	              var packet = createPacket(resolution, p, l);
	              l++;
	              return packet;
	            }
	            l = 0;
	          }
	          c = 0;
	        }
	        p = 0;
	      }
	      throw new JpxError('Out of packets');
	    };
	  }
	  function PositionComponentResolutionLayerIterator(context) {
	    var siz = context.SIZ;
	    var tileIndex = context.currentTile.index;
	    var tile = context.tiles[tileIndex];
	    var layersCount = tile.codingStyleDefaultParameters.layersCount;
	    var componentsCount = siz.Csiz;
	    var precinctsSizes = getPrecinctSizesInImageScale(tile);
	    var precinctsIterationSizes = precinctsSizes;
	    var l = 0,
	        r = 0,
	        c = 0,
	        px = 0,
	        py = 0;
	    this.nextPacket = function JpxImage_nextPacket() {
	      for (; py < precinctsIterationSizes.maxNumHigh; py++) {
	        for (; px < precinctsIterationSizes.maxNumWide; px++) {
	          for (; c < componentsCount; c++) {
	            var component = tile.components[c];
	            var decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
	            for (; r <= decompositionLevelsCount; r++) {
	              var resolution = component.resolutions[r];
	              var sizeInImageScale = precinctsSizes.components[c].resolutions[r];
	              var k = getPrecinctIndexIfExist(px, py, sizeInImageScale, precinctsIterationSizes, resolution);
	              if (k === null) {
	                continue;
	              }
	              for (; l < layersCount;) {
	                var packet = createPacket(resolution, k, l);
	                l++;
	                return packet;
	              }
	              l = 0;
	            }
	            r = 0;
	          }
	          c = 0;
	        }
	        px = 0;
	      }
	      throw new JpxError('Out of packets');
	    };
	  }
	  function ComponentPositionResolutionLayerIterator(context) {
	    var siz = context.SIZ;
	    var tileIndex = context.currentTile.index;
	    var tile = context.tiles[tileIndex];
	    var layersCount = tile.codingStyleDefaultParameters.layersCount;
	    var componentsCount = siz.Csiz;
	    var precinctsSizes = getPrecinctSizesInImageScale(tile);
	    var l = 0,
	        r = 0,
	        c = 0,
	        px = 0,
	        py = 0;
	    this.nextPacket = function JpxImage_nextPacket() {
	      for (; c < componentsCount; ++c) {
	        var component = tile.components[c];
	        var precinctsIterationSizes = precinctsSizes.components[c];
	        var decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
	        for (; py < precinctsIterationSizes.maxNumHigh; py++) {
	          for (; px < precinctsIterationSizes.maxNumWide; px++) {
	            for (; r <= decompositionLevelsCount; r++) {
	              var resolution = component.resolutions[r];
	              var sizeInImageScale = precinctsIterationSizes.resolutions[r];
	              var k = getPrecinctIndexIfExist(px, py, sizeInImageScale, precinctsIterationSizes, resolution);
	              if (k === null) {
	                continue;
	              }
	              for (; l < layersCount;) {
	                var packet = createPacket(resolution, k, l);
	                l++;
	                return packet;
	              }
	              l = 0;
	            }
	            r = 0;
	          }
	          px = 0;
	        }
	        py = 0;
	      }
	      throw new JpxError('Out of packets');
	    };
	  }
	  function getPrecinctIndexIfExist(pxIndex, pyIndex, sizeInImageScale, precinctIterationSizes, resolution) {
	    var posX = pxIndex * precinctIterationSizes.minWidth;
	    var posY = pyIndex * precinctIterationSizes.minHeight;
	    if (posX % sizeInImageScale.width !== 0 || posY % sizeInImageScale.height !== 0) {
	      return null;
	    }
	    var startPrecinctRowIndex = posY / sizeInImageScale.width * resolution.precinctParameters.numprecinctswide;
	    return posX / sizeInImageScale.height + startPrecinctRowIndex;
	  }
	  function getPrecinctSizesInImageScale(tile) {
	    var componentsCount = tile.components.length;
	    var minWidth = Number.MAX_VALUE;
	    var minHeight = Number.MAX_VALUE;
	    var maxNumWide = 0;
	    var maxNumHigh = 0;
	    var sizePerComponent = new Array(componentsCount);
	    for (var c = 0; c < componentsCount; c++) {
	      var component = tile.components[c];
	      var decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
	      var sizePerResolution = new Array(decompositionLevelsCount + 1);
	      var minWidthCurrentComponent = Number.MAX_VALUE;
	      var minHeightCurrentComponent = Number.MAX_VALUE;
	      var maxNumWideCurrentComponent = 0;
	      var maxNumHighCurrentComponent = 0;
	      var scale = 1;
	      for (var r = decompositionLevelsCount; r >= 0; --r) {
	        var resolution = component.resolutions[r];
	        var widthCurrentResolution = scale * resolution.precinctParameters.precinctWidth;
	        var heightCurrentResolution = scale * resolution.precinctParameters.precinctHeight;
	        minWidthCurrentComponent = Math.min(minWidthCurrentComponent, widthCurrentResolution);
	        minHeightCurrentComponent = Math.min(minHeightCurrentComponent, heightCurrentResolution);
	        maxNumWideCurrentComponent = Math.max(maxNumWideCurrentComponent, resolution.precinctParameters.numprecinctswide);
	        maxNumHighCurrentComponent = Math.max(maxNumHighCurrentComponent, resolution.precinctParameters.numprecinctshigh);
	        sizePerResolution[r] = {
	          width: widthCurrentResolution,
	          height: heightCurrentResolution
	        };
	        scale <<= 1;
	      }
	      minWidth = Math.min(minWidth, minWidthCurrentComponent);
	      minHeight = Math.min(minHeight, minHeightCurrentComponent);
	      maxNumWide = Math.max(maxNumWide, maxNumWideCurrentComponent);
	      maxNumHigh = Math.max(maxNumHigh, maxNumHighCurrentComponent);
	      sizePerComponent[c] = {
	        resolutions: sizePerResolution,
	        minWidth: minWidthCurrentComponent,
	        minHeight: minHeightCurrentComponent,
	        maxNumWide: maxNumWideCurrentComponent,
	        maxNumHigh: maxNumHighCurrentComponent
	      };
	    }
	    return {
	      components: sizePerComponent,
	      minWidth: minWidth,
	      minHeight: minHeight,
	      maxNumWide: maxNumWide,
	      maxNumHigh: maxNumHigh
	    };
	  }
	  function buildPackets(context) {
	    var siz = context.SIZ;
	    var tileIndex = context.currentTile.index;
	    var tile = context.tiles[tileIndex];
	    var componentsCount = siz.Csiz;
	    for (var c = 0; c < componentsCount; c++) {
	      var component = tile.components[c];
	      var decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
	      var resolutions = [];
	      var subbands = [];
	      for (var r = 0; r <= decompositionLevelsCount; r++) {
	        var blocksDimensions = getBlocksDimensions(context, component, r);
	        var resolution = {};
	        var scale = 1 << decompositionLevelsCount - r;
	        resolution.trx0 = Math.ceil(component.tcx0 / scale);
	        resolution.try0 = Math.ceil(component.tcy0 / scale);
	        resolution.trx1 = Math.ceil(component.tcx1 / scale);
	        resolution.try1 = Math.ceil(component.tcy1 / scale);
	        resolution.resLevel = r;
	        buildPrecincts(context, resolution, blocksDimensions);
	        resolutions.push(resolution);
	        var subband;
	        if (r === 0) {
	          subband = {};
	          subband.type = 'LL';
	          subband.tbx0 = Math.ceil(component.tcx0 / scale);
	          subband.tby0 = Math.ceil(component.tcy0 / scale);
	          subband.tbx1 = Math.ceil(component.tcx1 / scale);
	          subband.tby1 = Math.ceil(component.tcy1 / scale);
	          subband.resolution = resolution;
	          buildCodeblocks(context, subband, blocksDimensions);
	          subbands.push(subband);
	          resolution.subbands = [subband];
	        } else {
	          var bscale = 1 << decompositionLevelsCount - r + 1;
	          var resolutionSubbands = [];
	          subband = {};
	          subband.type = 'HL';
	          subband.tbx0 = Math.ceil(component.tcx0 / bscale - 0.5);
	          subband.tby0 = Math.ceil(component.tcy0 / bscale);
	          subband.tbx1 = Math.ceil(component.tcx1 / bscale - 0.5);
	          subband.tby1 = Math.ceil(component.tcy1 / bscale);
	          subband.resolution = resolution;
	          buildCodeblocks(context, subband, blocksDimensions);
	          subbands.push(subband);
	          resolutionSubbands.push(subband);
	          subband = {};
	          subband.type = 'LH';
	          subband.tbx0 = Math.ceil(component.tcx0 / bscale);
	          subband.tby0 = Math.ceil(component.tcy0 / bscale - 0.5);
	          subband.tbx1 = Math.ceil(component.tcx1 / bscale);
	          subband.tby1 = Math.ceil(component.tcy1 / bscale - 0.5);
	          subband.resolution = resolution;
	          buildCodeblocks(context, subband, blocksDimensions);
	          subbands.push(subband);
	          resolutionSubbands.push(subband);
	          subband = {};
	          subband.type = 'HH';
	          subband.tbx0 = Math.ceil(component.tcx0 / bscale - 0.5);
	          subband.tby0 = Math.ceil(component.tcy0 / bscale - 0.5);
	          subband.tbx1 = Math.ceil(component.tcx1 / bscale - 0.5);
	          subband.tby1 = Math.ceil(component.tcy1 / bscale - 0.5);
	          subband.resolution = resolution;
	          buildCodeblocks(context, subband, blocksDimensions);
	          subbands.push(subband);
	          resolutionSubbands.push(subband);
	          resolution.subbands = resolutionSubbands;
	        }
	      }
	      component.resolutions = resolutions;
	      component.subbands = subbands;
	    }
	    var progressionOrder = tile.codingStyleDefaultParameters.progressionOrder;
	    switch (progressionOrder) {
	      case 0:
	        tile.packetsIterator = new LayerResolutionComponentPositionIterator(context);
	        break;
	      case 1:
	        tile.packetsIterator = new ResolutionLayerComponentPositionIterator(context);
	        break;
	      case 2:
	        tile.packetsIterator = new ResolutionPositionComponentLayerIterator(context);
	        break;
	      case 3:
	        tile.packetsIterator = new PositionComponentResolutionLayerIterator(context);
	        break;
	      case 4:
	        tile.packetsIterator = new ComponentPositionResolutionLayerIterator(context);
	        break;
	      default:
	        throw new JpxError('Unsupported progression order ' + progressionOrder);
	    }
	  }
	  function parseTilePackets(context, data, offset, dataLength) {
	    var position = 0;
	    var buffer,
	        bufferSize = 0,
	        skipNextBit = false;
	    function readBits(count) {
	      while (bufferSize < count) {
	        var b = data[offset + position];
	        position++;
	        if (skipNextBit) {
	          buffer = buffer << 7 | b;
	          bufferSize += 7;
	          skipNextBit = false;
	        } else {
	          buffer = buffer << 8 | b;
	          bufferSize += 8;
	        }
	        if (b === 0xFF) {
	          skipNextBit = true;
	        }
	      }
	      bufferSize -= count;
	      return buffer >>> bufferSize & (1 << count) - 1;
	    }
	    function skipMarkerIfEqual(value) {
	      if (data[offset + position - 1] === 0xFF && data[offset + position] === value) {
	        skipBytes(1);
	        return true;
	      } else if (data[offset + position] === 0xFF && data[offset + position + 1] === value) {
	        skipBytes(2);
	        return true;
	      }
	      return false;
	    }
	    function skipBytes(count) {
	      position += count;
	    }
	    function alignToByte() {
	      bufferSize = 0;
	      if (skipNextBit) {
	        position++;
	        skipNextBit = false;
	      }
	    }
	    function readCodingpasses() {
	      if (readBits(1) === 0) {
	        return 1;
	      }
	      if (readBits(1) === 0) {
	        return 2;
	      }
	      var value = readBits(2);
	      if (value < 3) {
	        return value + 3;
	      }
	      value = readBits(5);
	      if (value < 31) {
	        return value + 6;
	      }
	      value = readBits(7);
	      return value + 37;
	    }
	    var tileIndex = context.currentTile.index;
	    var tile = context.tiles[tileIndex];
	    var sopMarkerUsed = context.COD.sopMarkerUsed;
	    var ephMarkerUsed = context.COD.ephMarkerUsed;
	    var packetsIterator = tile.packetsIterator;
	    while (position < dataLength) {
	      alignToByte();
	      if (sopMarkerUsed && skipMarkerIfEqual(0x91)) {
	        skipBytes(4);
	      }
	      var packet = packetsIterator.nextPacket();
	      if (!readBits(1)) {
	        continue;
	      }
	      var layerNumber = packet.layerNumber;
	      var queue = [],
	          codeblock;
	      for (var i = 0, ii = packet.codeblocks.length; i < ii; i++) {
	        codeblock = packet.codeblocks[i];
	        var precinct = codeblock.precinct;
	        var codeblockColumn = codeblock.cbx - precinct.cbxMin;
	        var codeblockRow = codeblock.cby - precinct.cbyMin;
	        var codeblockIncluded = false;
	        var firstTimeInclusion = false;
	        var valueReady;
	        if (codeblock['included'] !== undefined) {
	          codeblockIncluded = !!readBits(1);
	        } else {
	          precinct = codeblock.precinct;
	          var inclusionTree, zeroBitPlanesTree;
	          if (precinct['inclusionTree'] !== undefined) {
	            inclusionTree = precinct.inclusionTree;
	          } else {
	            var width = precinct.cbxMax - precinct.cbxMin + 1;
	            var height = precinct.cbyMax - precinct.cbyMin + 1;
	            inclusionTree = new InclusionTree(width, height, layerNumber);
	            zeroBitPlanesTree = new TagTree(width, height);
	            precinct.inclusionTree = inclusionTree;
	            precinct.zeroBitPlanesTree = zeroBitPlanesTree;
	          }
	          if (inclusionTree.reset(codeblockColumn, codeblockRow, layerNumber)) {
	            while (true) {
	              if (readBits(1)) {
	                valueReady = !inclusionTree.nextLevel();
	                if (valueReady) {
	                  codeblock.included = true;
	                  codeblockIncluded = firstTimeInclusion = true;
	                  break;
	                }
	              } else {
	                inclusionTree.incrementValue(layerNumber);
	                break;
	              }
	            }
	          }
	        }
	        if (!codeblockIncluded) {
	          continue;
	        }
	        if (firstTimeInclusion) {
	          zeroBitPlanesTree = precinct.zeroBitPlanesTree;
	          zeroBitPlanesTree.reset(codeblockColumn, codeblockRow);
	          while (true) {
	            if (readBits(1)) {
	              valueReady = !zeroBitPlanesTree.nextLevel();
	              if (valueReady) {
	                break;
	              }
	            } else {
	              zeroBitPlanesTree.incrementValue();
	            }
	          }
	          codeblock.zeroBitPlanes = zeroBitPlanesTree.value;
	        }
	        var codingpasses = readCodingpasses();
	        while (readBits(1)) {
	          codeblock.Lblock++;
	        }
	        var codingpassesLog2 = (0, _util.log2)(codingpasses);
	        var bits = (codingpasses < 1 << codingpassesLog2 ? codingpassesLog2 - 1 : codingpassesLog2) + codeblock.Lblock;
	        var codedDataLength = readBits(bits);
	        queue.push({
	          codeblock: codeblock,
	          codingpasses: codingpasses,
	          dataLength: codedDataLength
	        });
	      }
	      alignToByte();
	      if (ephMarkerUsed) {
	        skipMarkerIfEqual(0x92);
	      }
	      while (queue.length > 0) {
	        var packetItem = queue.shift();
	        codeblock = packetItem.codeblock;
	        if (codeblock['data'] === undefined) {
	          codeblock.data = [];
	        }
	        codeblock.data.push({
	          data: data,
	          start: offset + position,
	          end: offset + position + packetItem.dataLength,
	          codingpasses: packetItem.codingpasses
	        });
	        position += packetItem.dataLength;
	      }
	    }
	    return position;
	  }
	  function copyCoefficients(coefficients, levelWidth, levelHeight, subband, delta, mb, reversible, segmentationSymbolUsed) {
	    var x0 = subband.tbx0;
	    var y0 = subband.tby0;
	    var width = subband.tbx1 - subband.tbx0;
	    var codeblocks = subband.codeblocks;
	    var right = subband.type.charAt(0) === 'H' ? 1 : 0;
	    var bottom = subband.type.charAt(1) === 'H' ? levelWidth : 0;
	    for (var i = 0, ii = codeblocks.length; i < ii; ++i) {
	      var codeblock = codeblocks[i];
	      var blockWidth = codeblock.tbx1_ - codeblock.tbx0_;
	      var blockHeight = codeblock.tby1_ - codeblock.tby0_;
	      if (blockWidth === 0 || blockHeight === 0) {
	        continue;
	      }
	      if (codeblock['data'] === undefined) {
	        continue;
	      }
	      var bitModel, currentCodingpassType;
	      bitModel = new BitModel(blockWidth, blockHeight, codeblock.subbandType, codeblock.zeroBitPlanes, mb);
	      currentCodingpassType = 2;
	      var data = codeblock.data,
	          totalLength = 0,
	          codingpasses = 0;
	      var j, jj, dataItem;
	      for (j = 0, jj = data.length; j < jj; j++) {
	        dataItem = data[j];
	        totalLength += dataItem.end - dataItem.start;
	        codingpasses += dataItem.codingpasses;
	      }
	      var encodedData = new Uint8Array(totalLength);
	      var position = 0;
	      for (j = 0, jj = data.length; j < jj; j++) {
	        dataItem = data[j];
	        var chunk = dataItem.data.subarray(dataItem.start, dataItem.end);
	        encodedData.set(chunk, position);
	        position += chunk.length;
	      }
	      var decoder = new _arithmetic_decoder.ArithmeticDecoder(encodedData, 0, totalLength);
	      bitModel.setDecoder(decoder);
	      for (j = 0; j < codingpasses; j++) {
	        switch (currentCodingpassType) {
	          case 0:
	            bitModel.runSignificancePropagationPass();
	            break;
	          case 1:
	            bitModel.runMagnitudeRefinementPass();
	            break;
	          case 2:
	            bitModel.runCleanupPass();
	            if (segmentationSymbolUsed) {
	              bitModel.checkSegmentationSymbol();
	            }
	            break;
	        }
	        currentCodingpassType = (currentCodingpassType + 1) % 3;
	      }
	      var offset = codeblock.tbx0_ - x0 + (codeblock.tby0_ - y0) * width;
	      var sign = bitModel.coefficentsSign;
	      var magnitude = bitModel.coefficentsMagnitude;
	      var bitsDecoded = bitModel.bitsDecoded;
	      var magnitudeCorrection = reversible ? 0 : 0.5;
	      var k, n, nb;
	      position = 0;
	      var interleave = subband.type !== 'LL';
	      for (j = 0; j < blockHeight; j++) {
	        var row = offset / width | 0;
	        var levelOffset = 2 * row * (levelWidth - width) + right + bottom;
	        for (k = 0; k < blockWidth; k++) {
	          n = magnitude[position];
	          if (n !== 0) {
	            n = (n + magnitudeCorrection) * delta;
	            if (sign[position] !== 0) {
	              n = -n;
	            }
	            nb = bitsDecoded[position];
	            var pos = interleave ? levelOffset + (offset << 1) : offset;
	            if (reversible && nb >= mb) {
	              coefficients[pos] = n;
	            } else {
	              coefficients[pos] = n * (1 << mb - nb);
	            }
	          }
	          offset++;
	          position++;
	        }
	        offset += width - blockWidth;
	      }
	    }
	  }
	  function transformTile(context, tile, c) {
	    var component = tile.components[c];
	    var codingStyleParameters = component.codingStyleParameters;
	    var quantizationParameters = component.quantizationParameters;
	    var decompositionLevelsCount = codingStyleParameters.decompositionLevelsCount;
	    var spqcds = quantizationParameters.SPqcds;
	    var scalarExpounded = quantizationParameters.scalarExpounded;
	    var guardBits = quantizationParameters.guardBits;
	    var segmentationSymbolUsed = codingStyleParameters.segmentationSymbolUsed;
	    var precision = context.components[c].precision;
	    var reversible = codingStyleParameters.reversibleTransformation;
	    var transform = reversible ? new ReversibleTransform() : new IrreversibleTransform();
	    var subbandCoefficients = [];
	    var b = 0;
	    for (var i = 0; i <= decompositionLevelsCount; i++) {
	      var resolution = component.resolutions[i];
	      var width = resolution.trx1 - resolution.trx0;
	      var height = resolution.try1 - resolution.try0;
	      var coefficients = new Float32Array(width * height);
	      for (var j = 0, jj = resolution.subbands.length; j < jj; j++) {
	        var mu, epsilon;
	        if (!scalarExpounded) {
	          mu = spqcds[0].mu;
	          epsilon = spqcds[0].epsilon + (i > 0 ? 1 - i : 0);
	        } else {
	          mu = spqcds[b].mu;
	          epsilon = spqcds[b].epsilon;
	          b++;
	        }
	        var subband = resolution.subbands[j];
	        var gainLog2 = SubbandsGainLog2[subband.type];
	        var delta = reversible ? 1 : Math.pow(2, precision + gainLog2 - epsilon) * (1 + mu / 2048);
	        var mb = guardBits + epsilon - 1;
	        copyCoefficients(coefficients, width, height, subband, delta, mb, reversible, segmentationSymbolUsed);
	      }
	      subbandCoefficients.push({
	        width: width,
	        height: height,
	        items: coefficients
	      });
	    }
	    var result = transform.calculate(subbandCoefficients, component.tcx0, component.tcy0);
	    return {
	      left: component.tcx0,
	      top: component.tcy0,
	      width: result.width,
	      height: result.height,
	      items: result.items
	    };
	  }
	  function transformComponents(context) {
	    var siz = context.SIZ;
	    var components = context.components;
	    var componentsCount = siz.Csiz;
	    var resultImages = [];
	    for (var i = 0, ii = context.tiles.length; i < ii; i++) {
	      var tile = context.tiles[i];
	      var transformedTiles = [];
	      var c;
	      for (c = 0; c < componentsCount; c++) {
	        transformedTiles[c] = transformTile(context, tile, c);
	      }
	      var tile0 = transformedTiles[0];
	      var out = new Uint8ClampedArray(tile0.items.length * componentsCount);
	      var result = {
	        left: tile0.left,
	        top: tile0.top,
	        width: tile0.width,
	        height: tile0.height,
	        items: out
	      };
	      var shift, offset;
	      var pos = 0,
	          j,
	          jj,
	          y0,
	          y1,
	          y2;
	      if (tile.codingStyleDefaultParameters.multipleComponentTransform) {
	        var fourComponents = componentsCount === 4;
	        var y0items = transformedTiles[0].items;
	        var y1items = transformedTiles[1].items;
	        var y2items = transformedTiles[2].items;
	        var y3items = fourComponents ? transformedTiles[3].items : null;
	        shift = components[0].precision - 8;
	        offset = (128 << shift) + 0.5;
	        var component0 = tile.components[0];
	        var alpha01 = componentsCount - 3;
	        jj = y0items.length;
	        if (!component0.codingStyleParameters.reversibleTransformation) {
	          for (j = 0; j < jj; j++, pos += alpha01) {
	            y0 = y0items[j] + offset;
	            y1 = y1items[j];
	            y2 = y2items[j];
	            out[pos++] = y0 + 1.402 * y2 >> shift;
	            out[pos++] = y0 - 0.34413 * y1 - 0.71414 * y2 >> shift;
	            out[pos++] = y0 + 1.772 * y1 >> shift;
	          }
	        } else {
	          for (j = 0; j < jj; j++, pos += alpha01) {
	            y0 = y0items[j] + offset;
	            y1 = y1items[j];
	            y2 = y2items[j];
	            var g = y0 - (y2 + y1 >> 2);
	            out[pos++] = g + y2 >> shift;
	            out[pos++] = g >> shift;
	            out[pos++] = g + y1 >> shift;
	          }
	        }
	        if (fourComponents) {
	          for (j = 0, pos = 3; j < jj; j++, pos += 4) {
	            out[pos] = y3items[j] + offset >> shift;
	          }
	        }
	      } else {
	        for (c = 0; c < componentsCount; c++) {
	          var items = transformedTiles[c].items;
	          shift = components[c].precision - 8;
	          offset = (128 << shift) + 0.5;
	          for (pos = c, j = 0, jj = items.length; j < jj; j++) {
	            out[pos] = items[j] + offset >> shift;
	            pos += componentsCount;
	          }
	        }
	      }
	      resultImages.push(result);
	    }
	    return resultImages;
	  }
	  function initializeTile(context, tileIndex) {
	    var siz = context.SIZ;
	    var componentsCount = siz.Csiz;
	    var tile = context.tiles[tileIndex];
	    for (var c = 0; c < componentsCount; c++) {
	      var component = tile.components[c];
	      var qcdOrQcc = context.currentTile.QCC[c] !== undefined ? context.currentTile.QCC[c] : context.currentTile.QCD;
	      component.quantizationParameters = qcdOrQcc;
	      var codOrCoc = context.currentTile.COC[c] !== undefined ? context.currentTile.COC[c] : context.currentTile.COD;
	      component.codingStyleParameters = codOrCoc;
	    }
	    tile.codingStyleDefaultParameters = context.currentTile.COD;
	  }
	  var TagTree = function TagTreeClosure() {
	    function TagTree(width, height) {
	      var levelsLength = (0, _util.log2)(Math.max(width, height)) + 1;
	      this.levels = [];
	      for (var i = 0; i < levelsLength; i++) {
	        var level = {
	          width: width,
	          height: height,
	          items: []
	        };
	        this.levels.push(level);
	        width = Math.ceil(width / 2);
	        height = Math.ceil(height / 2);
	      }
	    }
	    TagTree.prototype = {
	      reset: function TagTree_reset(i, j) {
	        var currentLevel = 0,
	            value = 0,
	            level;
	        while (currentLevel < this.levels.length) {
	          level = this.levels[currentLevel];
	          var index = i + j * level.width;
	          if (level.items[index] !== undefined) {
	            value = level.items[index];
	            break;
	          }
	          level.index = index;
	          i >>= 1;
	          j >>= 1;
	          currentLevel++;
	        }
	        currentLevel--;
	        level = this.levels[currentLevel];
	        level.items[level.index] = value;
	        this.currentLevel = currentLevel;
	        delete this.value;
	      },
	      incrementValue: function TagTree_incrementValue() {
	        var level = this.levels[this.currentLevel];
	        level.items[level.index]++;
	      },
	      nextLevel: function TagTree_nextLevel() {
	        var currentLevel = this.currentLevel;
	        var level = this.levels[currentLevel];
	        var value = level.items[level.index];
	        currentLevel--;
	        if (currentLevel < 0) {
	          this.value = value;
	          return false;
	        }
	        this.currentLevel = currentLevel;
	        level = this.levels[currentLevel];
	        level.items[level.index] = value;
	        return true;
	      }
	    };
	    return TagTree;
	  }();
	  var InclusionTree = function InclusionTreeClosure() {
	    function InclusionTree(width, height, defaultValue) {
	      var levelsLength = (0, _util.log2)(Math.max(width, height)) + 1;
	      this.levels = [];
	      for (var i = 0; i < levelsLength; i++) {
	        var items = new Uint8Array(width * height);
	        for (var j = 0, jj = items.length; j < jj; j++) {
	          items[j] = defaultValue;
	        }
	        var level = {
	          width: width,
	          height: height,
	          items: items
	        };
	        this.levels.push(level);
	        width = Math.ceil(width / 2);
	        height = Math.ceil(height / 2);
	      }
	    }
	    InclusionTree.prototype = {
	      reset: function InclusionTree_reset(i, j, stopValue) {
	        var currentLevel = 0;
	        while (currentLevel < this.levels.length) {
	          var level = this.levels[currentLevel];
	          var index = i + j * level.width;
	          level.index = index;
	          var value = level.items[index];
	          if (value === 0xFF) {
	            break;
	          }
	          if (value > stopValue) {
	            this.currentLevel = currentLevel;
	            this.propagateValues();
	            return false;
	          }
	          i >>= 1;
	          j >>= 1;
	          currentLevel++;
	        }
	        this.currentLevel = currentLevel - 1;
	        return true;
	      },
	      incrementValue: function InclusionTree_incrementValue(stopValue) {
	        var level = this.levels[this.currentLevel];
	        level.items[level.index] = stopValue + 1;
	        this.propagateValues();
	      },
	      propagateValues: function InclusionTree_propagateValues() {
	        var levelIndex = this.currentLevel;
	        var level = this.levels[levelIndex];
	        var currentValue = level.items[level.index];
	        while (--levelIndex >= 0) {
	          level = this.levels[levelIndex];
	          level.items[level.index] = currentValue;
	        }
	      },
	      nextLevel: function InclusionTree_nextLevel() {
	        var currentLevel = this.currentLevel;
	        var level = this.levels[currentLevel];
	        var value = level.items[level.index];
	        level.items[level.index] = 0xFF;
	        currentLevel--;
	        if (currentLevel < 0) {
	          return false;
	        }
	        this.currentLevel = currentLevel;
	        level = this.levels[currentLevel];
	        level.items[level.index] = value;
	        return true;
	      }
	    };
	    return InclusionTree;
	  }();
	  var BitModel = function BitModelClosure() {
	    var UNIFORM_CONTEXT = 17;
	    var RUNLENGTH_CONTEXT = 18;
	    var LLAndLHContextsLabel = new Uint8Array([0, 5, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 1, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8]);
	    var HLContextLabel = new Uint8Array([0, 3, 4, 0, 5, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 1, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8]);
	    var HHContextLabel = new Uint8Array([0, 1, 2, 0, 1, 2, 2, 0, 2, 2, 2, 0, 0, 0, 0, 0, 3, 4, 5, 0, 4, 5, 5, 0, 5, 5, 5, 0, 0, 0, 0, 0, 6, 7, 7, 0, 7, 7, 7, 0, 7, 7, 7, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8]);
	    function BitModel(width, height, subband, zeroBitPlanes, mb) {
	      this.width = width;
	      this.height = height;
	      this.contextLabelTable = subband === 'HH' ? HHContextLabel : subband === 'HL' ? HLContextLabel : LLAndLHContextsLabel;
	      var coefficientCount = width * height;
	      this.neighborsSignificance = new Uint8Array(coefficientCount);
	      this.coefficentsSign = new Uint8Array(coefficientCount);
	      this.coefficentsMagnitude = mb > 14 ? new Uint32Array(coefficientCount) : mb > 6 ? new Uint16Array(coefficientCount) : new Uint8Array(coefficientCount);
	      this.processingFlags = new Uint8Array(coefficientCount);
	      var bitsDecoded = new Uint8Array(coefficientCount);
	      if (zeroBitPlanes !== 0) {
	        for (var i = 0; i < coefficientCount; i++) {
	          bitsDecoded[i] = zeroBitPlanes;
	        }
	      }
	      this.bitsDecoded = bitsDecoded;
	      this.reset();
	    }
	    BitModel.prototype = {
	      setDecoder: function BitModel_setDecoder(decoder) {
	        this.decoder = decoder;
	      },
	      reset: function BitModel_reset() {
	        this.contexts = new Int8Array(19);
	        this.contexts[0] = 4 << 1 | 0;
	        this.contexts[UNIFORM_CONTEXT] = 46 << 1 | 0;
	        this.contexts[RUNLENGTH_CONTEXT] = 3 << 1 | 0;
	      },
	      setNeighborsSignificance: function BitModel_setNeighborsSignificance(row, column, index) {
	        var neighborsSignificance = this.neighborsSignificance;
	        var width = this.width,
	            height = this.height;
	        var left = column > 0;
	        var right = column + 1 < width;
	        var i;
	        if (row > 0) {
	          i = index - width;
	          if (left) {
	            neighborsSignificance[i - 1] += 0x10;
	          }
	          if (right) {
	            neighborsSignificance[i + 1] += 0x10;
	          }
	          neighborsSignificance[i] += 0x04;
	        }
	        if (row + 1 < height) {
	          i = index + width;
	          if (left) {
	            neighborsSignificance[i - 1] += 0x10;
	          }
	          if (right) {
	            neighborsSignificance[i + 1] += 0x10;
	          }
	          neighborsSignificance[i] += 0x04;
	        }
	        if (left) {
	          neighborsSignificance[index - 1] += 0x01;
	        }
	        if (right) {
	          neighborsSignificance[index + 1] += 0x01;
	        }
	        neighborsSignificance[index] |= 0x80;
	      },
	      runSignificancePropagationPass: function BitModel_runSignificancePropagationPass() {
	        var decoder = this.decoder;
	        var width = this.width,
	            height = this.height;
	        var coefficentsMagnitude = this.coefficentsMagnitude;
	        var coefficentsSign = this.coefficentsSign;
	        var neighborsSignificance = this.neighborsSignificance;
	        var processingFlags = this.processingFlags;
	        var contexts = this.contexts;
	        var labels = this.contextLabelTable;
	        var bitsDecoded = this.bitsDecoded;
	        var processedInverseMask = ~1;
	        var processedMask = 1;
	        var firstMagnitudeBitMask = 2;
	        for (var i0 = 0; i0 < height; i0 += 4) {
	          for (var j = 0; j < width; j++) {
	            var index = i0 * width + j;
	            for (var i1 = 0; i1 < 4; i1++, index += width) {
	              var i = i0 + i1;
	              if (i >= height) {
	                break;
	              }
	              processingFlags[index] &= processedInverseMask;
	              if (coefficentsMagnitude[index] || !neighborsSignificance[index]) {
	                continue;
	              }
	              var contextLabel = labels[neighborsSignificance[index]];
	              var decision = decoder.readBit(contexts, contextLabel);
	              if (decision) {
	                var sign = this.decodeSignBit(i, j, index);
	                coefficentsSign[index] = sign;
	                coefficentsMagnitude[index] = 1;
	                this.setNeighborsSignificance(i, j, index);
	                processingFlags[index] |= firstMagnitudeBitMask;
	              }
	              bitsDecoded[index]++;
	              processingFlags[index] |= processedMask;
	            }
	          }
	        }
	      },
	      decodeSignBit: function BitModel_decodeSignBit(row, column, index) {
	        var width = this.width,
	            height = this.height;
	        var coefficentsMagnitude = this.coefficentsMagnitude;
	        var coefficentsSign = this.coefficentsSign;
	        var contribution, sign0, sign1, significance1;
	        var contextLabel, decoded;
	        significance1 = column > 0 && coefficentsMagnitude[index - 1] !== 0;
	        if (column + 1 < width && coefficentsMagnitude[index + 1] !== 0) {
	          sign1 = coefficentsSign[index + 1];
	          if (significance1) {
	            sign0 = coefficentsSign[index - 1];
	            contribution = 1 - sign1 - sign0;
	          } else {
	            contribution = 1 - sign1 - sign1;
	          }
	        } else if (significance1) {
	          sign0 = coefficentsSign[index - 1];
	          contribution = 1 - sign0 - sign0;
	        } else {
	          contribution = 0;
	        }
	        var horizontalContribution = 3 * contribution;
	        significance1 = row > 0 && coefficentsMagnitude[index - width] !== 0;
	        if (row + 1 < height && coefficentsMagnitude[index + width] !== 0) {
	          sign1 = coefficentsSign[index + width];
	          if (significance1) {
	            sign0 = coefficentsSign[index - width];
	            contribution = 1 - sign1 - sign0 + horizontalContribution;
	          } else {
	            contribution = 1 - sign1 - sign1 + horizontalContribution;
	          }
	        } else if (significance1) {
	          sign0 = coefficentsSign[index - width];
	          contribution = 1 - sign0 - sign0 + horizontalContribution;
	        } else {
	          contribution = horizontalContribution;
	        }
	        if (contribution >= 0) {
	          contextLabel = 9 + contribution;
	          decoded = this.decoder.readBit(this.contexts, contextLabel);
	        } else {
	          contextLabel = 9 - contribution;
	          decoded = this.decoder.readBit(this.contexts, contextLabel) ^ 1;
	        }
	        return decoded;
	      },
	      runMagnitudeRefinementPass: function BitModel_runMagnitudeRefinementPass() {
	        var decoder = this.decoder;
	        var width = this.width,
	            height = this.height;
	        var coefficentsMagnitude = this.coefficentsMagnitude;
	        var neighborsSignificance = this.neighborsSignificance;
	        var contexts = this.contexts;
	        var bitsDecoded = this.bitsDecoded;
	        var processingFlags = this.processingFlags;
	        var processedMask = 1;
	        var firstMagnitudeBitMask = 2;
	        var length = width * height;
	        var width4 = width * 4;
	        for (var index0 = 0, indexNext; index0 < length; index0 = indexNext) {
	          indexNext = Math.min(length, index0 + width4);
	          for (var j = 0; j < width; j++) {
	            for (var index = index0 + j; index < indexNext; index += width) {
	              if (!coefficentsMagnitude[index] || (processingFlags[index] & processedMask) !== 0) {
	                continue;
	              }
	              var contextLabel = 16;
	              if ((processingFlags[index] & firstMagnitudeBitMask) !== 0) {
	                processingFlags[index] ^= firstMagnitudeBitMask;
	                var significance = neighborsSignificance[index] & 127;
	                contextLabel = significance === 0 ? 15 : 14;
	              }
	              var bit = decoder.readBit(contexts, contextLabel);
	              coefficentsMagnitude[index] = coefficentsMagnitude[index] << 1 | bit;
	              bitsDecoded[index]++;
	              processingFlags[index] |= processedMask;
	            }
	          }
	        }
	      },
	      runCleanupPass: function BitModel_runCleanupPass() {
	        var decoder = this.decoder;
	        var width = this.width,
	            height = this.height;
	        var neighborsSignificance = this.neighborsSignificance;
	        var coefficentsMagnitude = this.coefficentsMagnitude;
	        var coefficentsSign = this.coefficentsSign;
	        var contexts = this.contexts;
	        var labels = this.contextLabelTable;
	        var bitsDecoded = this.bitsDecoded;
	        var processingFlags = this.processingFlags;
	        var processedMask = 1;
	        var firstMagnitudeBitMask = 2;
	        var oneRowDown = width;
	        var twoRowsDown = width * 2;
	        var threeRowsDown = width * 3;
	        var iNext;
	        for (var i0 = 0; i0 < height; i0 = iNext) {
	          iNext = Math.min(i0 + 4, height);
	          var indexBase = i0 * width;
	          var checkAllEmpty = i0 + 3 < height;
	          for (var j = 0; j < width; j++) {
	            var index0 = indexBase + j;
	            var allEmpty = checkAllEmpty && processingFlags[index0] === 0 && processingFlags[index0 + oneRowDown] === 0 && processingFlags[index0 + twoRowsDown] === 0 && processingFlags[index0 + threeRowsDown] === 0 && neighborsSignificance[index0] === 0 && neighborsSignificance[index0 + oneRowDown] === 0 && neighborsSignificance[index0 + twoRowsDown] === 0 && neighborsSignificance[index0 + threeRowsDown] === 0;
	            var i1 = 0,
	                index = index0;
	            var i = i0,
	                sign;
	            if (allEmpty) {
	              var hasSignificantCoefficent = decoder.readBit(contexts, RUNLENGTH_CONTEXT);
	              if (!hasSignificantCoefficent) {
	                bitsDecoded[index0]++;
	                bitsDecoded[index0 + oneRowDown]++;
	                bitsDecoded[index0 + twoRowsDown]++;
	                bitsDecoded[index0 + threeRowsDown]++;
	                continue;
	              }
	              i1 = decoder.readBit(contexts, UNIFORM_CONTEXT) << 1 | decoder.readBit(contexts, UNIFORM_CONTEXT);
	              if (i1 !== 0) {
	                i = i0 + i1;
	                index += i1 * width;
	              }
	              sign = this.decodeSignBit(i, j, index);
	              coefficentsSign[index] = sign;
	              coefficentsMagnitude[index] = 1;
	              this.setNeighborsSignificance(i, j, index);
	              processingFlags[index] |= firstMagnitudeBitMask;
	              index = index0;
	              for (var i2 = i0; i2 <= i; i2++, index += width) {
	                bitsDecoded[index]++;
	              }
	              i1++;
	            }
	            for (i = i0 + i1; i < iNext; i++, index += width) {
	              if (coefficentsMagnitude[index] || (processingFlags[index] & processedMask) !== 0) {
	                continue;
	              }
	              var contextLabel = labels[neighborsSignificance[index]];
	              var decision = decoder.readBit(contexts, contextLabel);
	              if (decision === 1) {
	                sign = this.decodeSignBit(i, j, index);
	                coefficentsSign[index] = sign;
	                coefficentsMagnitude[index] = 1;
	                this.setNeighborsSignificance(i, j, index);
	                processingFlags[index] |= firstMagnitudeBitMask;
	              }
	              bitsDecoded[index]++;
	            }
	          }
	        }
	      },
	      checkSegmentationSymbol: function BitModel_checkSegmentationSymbol() {
	        var decoder = this.decoder;
	        var contexts = this.contexts;
	        var symbol = decoder.readBit(contexts, UNIFORM_CONTEXT) << 3 | decoder.readBit(contexts, UNIFORM_CONTEXT) << 2 | decoder.readBit(contexts, UNIFORM_CONTEXT) << 1 | decoder.readBit(contexts, UNIFORM_CONTEXT);
	        if (symbol !== 0xA) {
	          throw new JpxError('Invalid segmentation symbol');
	        }
	      }
	    };
	    return BitModel;
	  }();
	  var Transform = function TransformClosure() {
	    function Transform() {}
	    Transform.prototype.calculate = function transformCalculate(subbands, u0, v0) {
	      var ll = subbands[0];
	      for (var i = 1, ii = subbands.length; i < ii; i++) {
	        ll = this.iterate(ll, subbands[i], u0, v0);
	      }
	      return ll;
	    };
	    Transform.prototype.extend = function extend(buffer, offset, size) {
	      var i1 = offset - 1,
	          j1 = offset + 1;
	      var i2 = offset + size - 2,
	          j2 = offset + size;
	      buffer[i1--] = buffer[j1++];
	      buffer[j2++] = buffer[i2--];
	      buffer[i1--] = buffer[j1++];
	      buffer[j2++] = buffer[i2--];
	      buffer[i1--] = buffer[j1++];
	      buffer[j2++] = buffer[i2--];
	      buffer[i1] = buffer[j1];
	      buffer[j2] = buffer[i2];
	    };
	    Transform.prototype.iterate = function Transform_iterate(ll, hl_lh_hh, u0, v0) {
	      var llWidth = ll.width,
	          llHeight = ll.height,
	          llItems = ll.items;
	      var width = hl_lh_hh.width;
	      var height = hl_lh_hh.height;
	      var items = hl_lh_hh.items;
	      var i, j, k, l, u, v;
	      for (k = 0, i = 0; i < llHeight; i++) {
	        l = i * 2 * width;
	        for (j = 0; j < llWidth; j++, k++, l += 2) {
	          items[l] = llItems[k];
	        }
	      }
	      llItems = ll.items = null;
	      var bufferPadding = 4;
	      var rowBuffer = new Float32Array(width + 2 * bufferPadding);
	      if (width === 1) {
	        if ((u0 & 1) !== 0) {
	          for (v = 0, k = 0; v < height; v++, k += width) {
	            items[k] *= 0.5;
	          }
	        }
	      } else {
	        for (v = 0, k = 0; v < height; v++, k += width) {
	          rowBuffer.set(items.subarray(k, k + width), bufferPadding);
	          this.extend(rowBuffer, bufferPadding, width);
	          this.filter(rowBuffer, bufferPadding, width);
	          items.set(rowBuffer.subarray(bufferPadding, bufferPadding + width), k);
	        }
	      }
	      var numBuffers = 16;
	      var colBuffers = [];
	      for (i = 0; i < numBuffers; i++) {
	        colBuffers.push(new Float32Array(height + 2 * bufferPadding));
	      }
	      var b,
	          currentBuffer = 0;
	      ll = bufferPadding + height;
	      if (height === 1) {
	        if ((v0 & 1) !== 0) {
	          for (u = 0; u < width; u++) {
	            items[u] *= 0.5;
	          }
	        }
	      } else {
	        for (u = 0; u < width; u++) {
	          if (currentBuffer === 0) {
	            numBuffers = Math.min(width - u, numBuffers);
	            for (k = u, l = bufferPadding; l < ll; k += width, l++) {
	              for (b = 0; b < numBuffers; b++) {
	                colBuffers[b][l] = items[k + b];
	              }
	            }
	            currentBuffer = numBuffers;
	          }
	          currentBuffer--;
	          var buffer = colBuffers[currentBuffer];
	          this.extend(buffer, bufferPadding, height);
	          this.filter(buffer, bufferPadding, height);
	          if (currentBuffer === 0) {
	            k = u - numBuffers + 1;
	            for (l = bufferPadding; l < ll; k += width, l++) {
	              for (b = 0; b < numBuffers; b++) {
	                items[k + b] = colBuffers[b][l];
	              }
	            }
	          }
	        }
	      }
	      return {
	        width: width,
	        height: height,
	        items: items
	      };
	    };
	    return Transform;
	  }();
	  var IrreversibleTransform = function IrreversibleTransformClosure() {
	    function IrreversibleTransform() {
	      Transform.call(this);
	    }
	    IrreversibleTransform.prototype = Object.create(Transform.prototype);
	    IrreversibleTransform.prototype.filter = function irreversibleTransformFilter(x, offset, length) {
	      var len = length >> 1;
	      offset = offset | 0;
	      var j, n, current, next;
	      var alpha = -1.586134342059924;
	      var beta = -0.052980118572961;
	      var gamma = 0.882911075530934;
	      var delta = 0.443506852043971;
	      var K = 1.230174104914001;
	      var K_ = 1 / K;
	      j = offset - 3;
	      for (n = len + 4; n--; j += 2) {
	        x[j] *= K_;
	      }
	      j = offset - 2;
	      current = delta * x[j - 1];
	      for (n = len + 3; n--; j += 2) {
	        next = delta * x[j + 1];
	        x[j] = K * x[j] - current - next;
	        if (n--) {
	          j += 2;
	          current = delta * x[j + 1];
	          x[j] = K * x[j] - current - next;
	        } else {
	          break;
	        }
	      }
	      j = offset - 1;
	      current = gamma * x[j - 1];
	      for (n = len + 2; n--; j += 2) {
	        next = gamma * x[j + 1];
	        x[j] -= current + next;
	        if (n--) {
	          j += 2;
	          current = gamma * x[j + 1];
	          x[j] -= current + next;
	        } else {
	          break;
	        }
	      }
	      j = offset;
	      current = beta * x[j - 1];
	      for (n = len + 1; n--; j += 2) {
	        next = beta * x[j + 1];
	        x[j] -= current + next;
	        if (n--) {
	          j += 2;
	          current = beta * x[j + 1];
	          x[j] -= current + next;
	        } else {
	          break;
	        }
	      }
	      if (len !== 0) {
	        j = offset + 1;
	        current = alpha * x[j - 1];
	        for (n = len; n--; j += 2) {
	          next = alpha * x[j + 1];
	          x[j] -= current + next;
	          if (n--) {
	            j += 2;
	            current = alpha * x[j + 1];
	            x[j] -= current + next;
	          } else {
	            break;
	          }
	        }
	      }
	    };
	    return IrreversibleTransform;
	  }();
	  var ReversibleTransform = function ReversibleTransformClosure() {
	    function ReversibleTransform() {
	      Transform.call(this);
	    }
	    ReversibleTransform.prototype = Object.create(Transform.prototype);
	    ReversibleTransform.prototype.filter = function reversibleTransformFilter(x, offset, length) {
	      var len = length >> 1;
	      offset = offset | 0;
	      var j, n;
	      for (j = offset, n = len + 1; n--; j += 2) {
	        x[j] -= x[j - 1] + x[j + 1] + 2 >> 2;
	      }
	      for (j = offset + 1, n = len; n--; j += 2) {
	        x[j] += x[j - 1] + x[j + 1] >> 1;
	      }
	    };
	    return ReversibleTransform;
	  }();
	  return JpxImage;
	}();
	exports.JpxImage = JpxImage;
	
	/***/ }),
	/* 81 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ArithmeticDecoder = function ArithmeticDecoderClosure() {
	  var QeTable = [{
	    qe: 0x5601,
	    nmps: 1,
	    nlps: 1,
	    switchFlag: 1
	  }, {
	    qe: 0x3401,
	    nmps: 2,
	    nlps: 6,
	    switchFlag: 0
	  }, {
	    qe: 0x1801,
	    nmps: 3,
	    nlps: 9,
	    switchFlag: 0
	  }, {
	    qe: 0x0AC1,
	    nmps: 4,
	    nlps: 12,
	    switchFlag: 0
	  }, {
	    qe: 0x0521,
	    nmps: 5,
	    nlps: 29,
	    switchFlag: 0
	  }, {
	    qe: 0x0221,
	    nmps: 38,
	    nlps: 33,
	    switchFlag: 0
	  }, {
	    qe: 0x5601,
	    nmps: 7,
	    nlps: 6,
	    switchFlag: 1
	  }, {
	    qe: 0x5401,
	    nmps: 8,
	    nlps: 14,
	    switchFlag: 0
	  }, {
	    qe: 0x4801,
	    nmps: 9,
	    nlps: 14,
	    switchFlag: 0
	  }, {
	    qe: 0x3801,
	    nmps: 10,
	    nlps: 14,
	    switchFlag: 0
	  }, {
	    qe: 0x3001,
	    nmps: 11,
	    nlps: 17,
	    switchFlag: 0
	  }, {
	    qe: 0x2401,
	    nmps: 12,
	    nlps: 18,
	    switchFlag: 0
	  }, {
	    qe: 0x1C01,
	    nmps: 13,
	    nlps: 20,
	    switchFlag: 0
	  }, {
	    qe: 0x1601,
	    nmps: 29,
	    nlps: 21,
	    switchFlag: 0
	  }, {
	    qe: 0x5601,
	    nmps: 15,
	    nlps: 14,
	    switchFlag: 1
	  }, {
	    qe: 0x5401,
	    nmps: 16,
	    nlps: 14,
	    switchFlag: 0
	  }, {
	    qe: 0x5101,
	    nmps: 17,
	    nlps: 15,
	    switchFlag: 0
	  }, {
	    qe: 0x4801,
	    nmps: 18,
	    nlps: 16,
	    switchFlag: 0
	  }, {
	    qe: 0x3801,
	    nmps: 19,
	    nlps: 17,
	    switchFlag: 0
	  }, {
	    qe: 0x3401,
	    nmps: 20,
	    nlps: 18,
	    switchFlag: 0
	  }, {
	    qe: 0x3001,
	    nmps: 21,
	    nlps: 19,
	    switchFlag: 0
	  }, {
	    qe: 0x2801,
	    nmps: 22,
	    nlps: 19,
	    switchFlag: 0
	  }, {
	    qe: 0x2401,
	    nmps: 23,
	    nlps: 20,
	    switchFlag: 0
	  }, {
	    qe: 0x2201,
	    nmps: 24,
	    nlps: 21,
	    switchFlag: 0
	  }, {
	    qe: 0x1C01,
	    nmps: 25,
	    nlps: 22,
	    switchFlag: 0
	  }, {
	    qe: 0x1801,
	    nmps: 26,
	    nlps: 23,
	    switchFlag: 0
	  }, {
	    qe: 0x1601,
	    nmps: 27,
	    nlps: 24,
	    switchFlag: 0
	  }, {
	    qe: 0x1401,
	    nmps: 28,
	    nlps: 25,
	    switchFlag: 0
	  }, {
	    qe: 0x1201,
	    nmps: 29,
	    nlps: 26,
	    switchFlag: 0
	  }, {
	    qe: 0x1101,
	    nmps: 30,
	    nlps: 27,
	    switchFlag: 0
	  }, {
	    qe: 0x0AC1,
	    nmps: 31,
	    nlps: 28,
	    switchFlag: 0
	  }, {
	    qe: 0x09C1,
	    nmps: 32,
	    nlps: 29,
	    switchFlag: 0
	  }, {
	    qe: 0x08A1,
	    nmps: 33,
	    nlps: 30,
	    switchFlag: 0
	  }, {
	    qe: 0x0521,
	    nmps: 34,
	    nlps: 31,
	    switchFlag: 0
	  }, {
	    qe: 0x0441,
	    nmps: 35,
	    nlps: 32,
	    switchFlag: 0
	  }, {
	    qe: 0x02A1,
	    nmps: 36,
	    nlps: 33,
	    switchFlag: 0
	  }, {
	    qe: 0x0221,
	    nmps: 37,
	    nlps: 34,
	    switchFlag: 0
	  }, {
	    qe: 0x0141,
	    nmps: 38,
	    nlps: 35,
	    switchFlag: 0
	  }, {
	    qe: 0x0111,
	    nmps: 39,
	    nlps: 36,
	    switchFlag: 0
	  }, {
	    qe: 0x0085,
	    nmps: 40,
	    nlps: 37,
	    switchFlag: 0
	  }, {
	    qe: 0x0049,
	    nmps: 41,
	    nlps: 38,
	    switchFlag: 0
	  }, {
	    qe: 0x0025,
	    nmps: 42,
	    nlps: 39,
	    switchFlag: 0
	  }, {
	    qe: 0x0015,
	    nmps: 43,
	    nlps: 40,
	    switchFlag: 0
	  }, {
	    qe: 0x0009,
	    nmps: 44,
	    nlps: 41,
	    switchFlag: 0
	  }, {
	    qe: 0x0005,
	    nmps: 45,
	    nlps: 42,
	    switchFlag: 0
	  }, {
	    qe: 0x0001,
	    nmps: 45,
	    nlps: 43,
	    switchFlag: 0
	  }, {
	    qe: 0x5601,
	    nmps: 46,
	    nlps: 46,
	    switchFlag: 0
	  }];
	  function ArithmeticDecoder(data, start, end) {
	    this.data = data;
	    this.bp = start;
	    this.dataEnd = end;
	    this.chigh = data[start];
	    this.clow = 0;
	    this.byteIn();
	    this.chigh = this.chigh << 7 & 0xFFFF | this.clow >> 9 & 0x7F;
	    this.clow = this.clow << 7 & 0xFFFF;
	    this.ct -= 7;
	    this.a = 0x8000;
	  }
	  ArithmeticDecoder.prototype = {
	    byteIn: function ArithmeticDecoder_byteIn() {
	      var data = this.data;
	      var bp = this.bp;
	      if (data[bp] === 0xFF) {
	        var b1 = data[bp + 1];
	        if (b1 > 0x8F) {
	          this.clow += 0xFF00;
	          this.ct = 8;
	        } else {
	          bp++;
	          this.clow += data[bp] << 9;
	          this.ct = 7;
	          this.bp = bp;
	        }
	      } else {
	        bp++;
	        this.clow += bp < this.dataEnd ? data[bp] << 8 : 0xFF00;
	        this.ct = 8;
	        this.bp = bp;
	      }
	      if (this.clow > 0xFFFF) {
	        this.chigh += this.clow >> 16;
	        this.clow &= 0xFFFF;
	      }
	    },
	    readBit: function ArithmeticDecoder_readBit(contexts, pos) {
	      var cx_index = contexts[pos] >> 1,
	          cx_mps = contexts[pos] & 1;
	      var qeTableIcx = QeTable[cx_index];
	      var qeIcx = qeTableIcx.qe;
	      var d;
	      var a = this.a - qeIcx;
	      if (this.chigh < qeIcx) {
	        if (a < qeIcx) {
	          a = qeIcx;
	          d = cx_mps;
	          cx_index = qeTableIcx.nmps;
	        } else {
	          a = qeIcx;
	          d = 1 ^ cx_mps;
	          if (qeTableIcx.switchFlag === 1) {
	            cx_mps = d;
	          }
	          cx_index = qeTableIcx.nlps;
	        }
	      } else {
	        this.chigh -= qeIcx;
	        if ((a & 0x8000) !== 0) {
	          this.a = a;
	          return cx_mps;
	        }
	        if (a < qeIcx) {
	          d = 1 ^ cx_mps;
	          if (qeTableIcx.switchFlag === 1) {
	            cx_mps = d;
	          }
	          cx_index = qeTableIcx.nlps;
	        } else {
	          d = cx_mps;
	          cx_index = qeTableIcx.nmps;
	        }
	      }
	      do {
	        if (this.ct === 0) {
	          this.byteIn();
	        }
	        a <<= 1;
	        this.chigh = this.chigh << 1 & 0xFFFF | this.clow >> 15 & 1;
	        this.clow = this.clow << 1 & 0xFFFF;
	        this.ct--;
	      } while ((a & 0x8000) === 0);
	      this.a = a;
	      contexts[pos] = cx_index << 1 | cx_mps;
	      return d;
	    }
	  };
	  return ArithmeticDecoder;
	}();
	exports.ArithmeticDecoder = ArithmeticDecoder;
	
	/***/ }),
	/* 82 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateSHA512 = exports.calculateSHA384 = exports.calculateSHA256 = exports.calculateMD5 = exports.PDF20 = exports.PDF17 = exports.CipherTransformFactory = exports.ARCFourCipher = exports.AES256Cipher = exports.AES128Cipher = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _primitives = __w_pdfjs_require__(2);
	
	var _stream = __w_pdfjs_require__(5);
	
	var ARCFourCipher = function ARCFourCipherClosure() {
	  function ARCFourCipher(key) {
	    this.a = 0;
	    this.b = 0;
	    var s = new Uint8Array(256);
	    var i,
	        j = 0,
	        tmp,
	        keyLength = key.length;
	    for (i = 0; i < 256; ++i) {
	      s[i] = i;
	    }
	    for (i = 0; i < 256; ++i) {
	      tmp = s[i];
	      j = j + tmp + key[i % keyLength] & 0xFF;
	      s[i] = s[j];
	      s[j] = tmp;
	    }
	    this.s = s;
	  }
	  ARCFourCipher.prototype = {
	    encryptBlock: function ARCFourCipher_encryptBlock(data) {
	      var i,
	          n = data.length,
	          tmp,
	          tmp2;
	      var a = this.a,
	          b = this.b,
	          s = this.s;
	      var output = new Uint8Array(n);
	      for (i = 0; i < n; ++i) {
	        a = a + 1 & 0xFF;
	        tmp = s[a];
	        b = b + tmp & 0xFF;
	        tmp2 = s[b];
	        s[a] = tmp2;
	        s[b] = tmp;
	        output[i] = data[i] ^ s[tmp + tmp2 & 0xFF];
	      }
	      this.a = a;
	      this.b = b;
	      return output;
	    }
	  };
	  ARCFourCipher.prototype.decryptBlock = ARCFourCipher.prototype.encryptBlock;
	  return ARCFourCipher;
	}();
	var calculateMD5 = function calculateMD5Closure() {
	  var r = new Uint8Array([7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21]);
	  var k = new Int32Array([-680876936, -389564586, 606105819, -1044525330, -176418897, 1200080426, -1473231341, -45705983, 1770035416, -1958414417, -42063, -1990404162, 1804603682, -40341101, -1502002290, 1236535329, -165796510, -1069501632, 643717713, -373897302, -701558691, 38016083, -660478335, -405537848, 568446438, -1019803690, -187363961, 1163531501, -1444681467, -51403784, 1735328473, -1926607734, -378558, -2022574463, 1839030562, -35309556, -1530992060, 1272893353, -155497632, -1094730640, 681279174, -358537222, -722521979, 76029189, -640364487, -421815835, 530742520, -995338651, -198630844, 1126891415, -1416354905, -57434055, 1700485571, -1894986606, -1051523, -2054922799, 1873313359, -30611744, -1560198380, 1309151649, -145523070, -1120210379, 718787259, -343485551]);
	  function hash(data, offset, length) {
	    var h0 = 1732584193,
	        h1 = -271733879,
	        h2 = -1732584194,
	        h3 = 271733878;
	    var paddedLength = length + 72 & ~63;
	    var padded = new Uint8Array(paddedLength);
	    var i, j, n;
	    for (i = 0; i < length; ++i) {
	      padded[i] = data[offset++];
	    }
	    padded[i++] = 0x80;
	    n = paddedLength - 8;
	    while (i < n) {
	      padded[i++] = 0;
	    }
	    padded[i++] = length << 3 & 0xFF;
	    padded[i++] = length >> 5 & 0xFF;
	    padded[i++] = length >> 13 & 0xFF;
	    padded[i++] = length >> 21 & 0xFF;
	    padded[i++] = length >>> 29 & 0xFF;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    var w = new Int32Array(16);
	    for (i = 0; i < paddedLength;) {
	      for (j = 0; j < 16; ++j, i += 4) {
	        w[j] = padded[i] | padded[i + 1] << 8 | padded[i + 2] << 16 | padded[i + 3] << 24;
	      }
	      var a = h0,
	          b = h1,
	          c = h2,
	          d = h3,
	          f,
	          g;
	      for (j = 0; j < 64; ++j) {
	        if (j < 16) {
	          f = b & c | ~b & d;
	          g = j;
	        } else if (j < 32) {
	          f = d & b | ~d & c;
	          g = 5 * j + 1 & 15;
	        } else if (j < 48) {
	          f = b ^ c ^ d;
	          g = 3 * j + 5 & 15;
	        } else {
	          f = c ^ (b | ~d);
	          g = 7 * j & 15;
	        }
	        var tmp = d,
	            rotateArg = a + f + k[j] + w[g] | 0,
	            rotate = r[j];
	        d = c;
	        c = b;
	        b = b + (rotateArg << rotate | rotateArg >>> 32 - rotate) | 0;
	        a = tmp;
	      }
	      h0 = h0 + a | 0;
	      h1 = h1 + b | 0;
	      h2 = h2 + c | 0;
	      h3 = h3 + d | 0;
	    }
	    return new Uint8Array([h0 & 0xFF, h0 >> 8 & 0xFF, h0 >> 16 & 0xFF, h0 >>> 24 & 0xFF, h1 & 0xFF, h1 >> 8 & 0xFF, h1 >> 16 & 0xFF, h1 >>> 24 & 0xFF, h2 & 0xFF, h2 >> 8 & 0xFF, h2 >> 16 & 0xFF, h2 >>> 24 & 0xFF, h3 & 0xFF, h3 >> 8 & 0xFF, h3 >> 16 & 0xFF, h3 >>> 24 & 0xFF]);
	  }
	  return hash;
	}();
	var Word64 = function Word64Closure() {
	  function Word64(highInteger, lowInteger) {
	    this.high = highInteger | 0;
	    this.low = lowInteger | 0;
	  }
	  Word64.prototype = {
	    and: function Word64_and(word) {
	      this.high &= word.high;
	      this.low &= word.low;
	    },
	    xor: function Word64_xor(word) {
	      this.high ^= word.high;
	      this.low ^= word.low;
	    },
	    or: function Word64_or(word) {
	      this.high |= word.high;
	      this.low |= word.low;
	    },
	    shiftRight: function Word64_shiftRight(places) {
	      if (places >= 32) {
	        this.low = this.high >>> places - 32 | 0;
	        this.high = 0;
	      } else {
	        this.low = this.low >>> places | this.high << 32 - places;
	        this.high = this.high >>> places | 0;
	      }
	    },
	    shiftLeft: function Word64_shiftLeft(places) {
	      if (places >= 32) {
	        this.high = this.low << places - 32;
	        this.low = 0;
	      } else {
	        this.high = this.high << places | this.low >>> 32 - places;
	        this.low = this.low << places;
	      }
	    },
	    rotateRight: function Word64_rotateRight(places) {
	      var low, high;
	      if (places & 32) {
	        high = this.low;
	        low = this.high;
	      } else {
	        low = this.low;
	        high = this.high;
	      }
	      places &= 31;
	      this.low = low >>> places | high << 32 - places;
	      this.high = high >>> places | low << 32 - places;
	    },
	    not: function Word64_not() {
	      this.high = ~this.high;
	      this.low = ~this.low;
	    },
	    add: function Word64_add(word) {
	      var lowAdd = (this.low >>> 0) + (word.low >>> 0);
	      var highAdd = (this.high >>> 0) + (word.high >>> 0);
	      if (lowAdd > 0xFFFFFFFF) {
	        highAdd += 1;
	      }
	      this.low = lowAdd | 0;
	      this.high = highAdd | 0;
	    },
	    copyTo: function Word64_copyTo(bytes, offset) {
	      bytes[offset] = this.high >>> 24 & 0xFF;
	      bytes[offset + 1] = this.high >> 16 & 0xFF;
	      bytes[offset + 2] = this.high >> 8 & 0xFF;
	      bytes[offset + 3] = this.high & 0xFF;
	      bytes[offset + 4] = this.low >>> 24 & 0xFF;
	      bytes[offset + 5] = this.low >> 16 & 0xFF;
	      bytes[offset + 6] = this.low >> 8 & 0xFF;
	      bytes[offset + 7] = this.low & 0xFF;
	    },
	    assign: function Word64_assign(word) {
	      this.high = word.high;
	      this.low = word.low;
	    }
	  };
	  return Word64;
	}();
	var calculateSHA256 = function calculateSHA256Closure() {
	  function rotr(x, n) {
	    return x >>> n | x << 32 - n;
	  }
	  function ch(x, y, z) {
	    return x & y ^ ~x & z;
	  }
	  function maj(x, y, z) {
	    return x & y ^ x & z ^ y & z;
	  }
	  function sigma(x) {
	    return rotr(x, 2) ^ rotr(x, 13) ^ rotr(x, 22);
	  }
	  function sigmaPrime(x) {
	    return rotr(x, 6) ^ rotr(x, 11) ^ rotr(x, 25);
	  }
	  function littleSigma(x) {
	    return rotr(x, 7) ^ rotr(x, 18) ^ x >>> 3;
	  }
	  function littleSigmaPrime(x) {
	    return rotr(x, 17) ^ rotr(x, 19) ^ x >>> 10;
	  }
	  var k = [0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2];
	  function hash(data, offset, length) {
	    var h0 = 0x6a09e667,
	        h1 = 0xbb67ae85,
	        h2 = 0x3c6ef372,
	        h3 = 0xa54ff53a,
	        h4 = 0x510e527f,
	        h5 = 0x9b05688c,
	        h6 = 0x1f83d9ab,
	        h7 = 0x5be0cd19;
	    var paddedLength = Math.ceil((length + 9) / 64) * 64;
	    var padded = new Uint8Array(paddedLength);
	    var i, j, n;
	    for (i = 0; i < length; ++i) {
	      padded[i] = data[offset++];
	    }
	    padded[i++] = 0x80;
	    n = paddedLength - 8;
	    while (i < n) {
	      padded[i++] = 0;
	    }
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = length >>> 29 & 0xFF;
	    padded[i++] = length >> 21 & 0xFF;
	    padded[i++] = length >> 13 & 0xFF;
	    padded[i++] = length >> 5 & 0xFF;
	    padded[i++] = length << 3 & 0xFF;
	    var w = new Uint32Array(64);
	    for (i = 0; i < paddedLength;) {
	      for (j = 0; j < 16; ++j) {
	        w[j] = padded[i] << 24 | padded[i + 1] << 16 | padded[i + 2] << 8 | padded[i + 3];
	        i += 4;
	      }
	      for (j = 16; j < 64; ++j) {
	        w[j] = littleSigmaPrime(w[j - 2]) + w[j - 7] + littleSigma(w[j - 15]) + w[j - 16] | 0;
	      }
	      var a = h0,
	          b = h1,
	          c = h2,
	          d = h3,
	          e = h4,
	          f = h5,
	          g = h6,
	          h = h7,
	          t1,
	          t2;
	      for (j = 0; j < 64; ++j) {
	        t1 = h + sigmaPrime(e) + ch(e, f, g) + k[j] + w[j];
	        t2 = sigma(a) + maj(a, b, c);
	        h = g;
	        g = f;
	        f = e;
	        e = d + t1 | 0;
	        d = c;
	        c = b;
	        b = a;
	        a = t1 + t2 | 0;
	      }
	      h0 = h0 + a | 0;
	      h1 = h1 + b | 0;
	      h2 = h2 + c | 0;
	      h3 = h3 + d | 0;
	      h4 = h4 + e | 0;
	      h5 = h5 + f | 0;
	      h6 = h6 + g | 0;
	      h7 = h7 + h | 0;
	    }
	    return new Uint8Array([h0 >> 24 & 0xFF, h0 >> 16 & 0xFF, h0 >> 8 & 0xFF, h0 & 0xFF, h1 >> 24 & 0xFF, h1 >> 16 & 0xFF, h1 >> 8 & 0xFF, h1 & 0xFF, h2 >> 24 & 0xFF, h2 >> 16 & 0xFF, h2 >> 8 & 0xFF, h2 & 0xFF, h3 >> 24 & 0xFF, h3 >> 16 & 0xFF, h3 >> 8 & 0xFF, h3 & 0xFF, h4 >> 24 & 0xFF, h4 >> 16 & 0xFF, h4 >> 8 & 0xFF, h4 & 0xFF, h5 >> 24 & 0xFF, h5 >> 16 & 0xFF, h5 >> 8 & 0xFF, h5 & 0xFF, h6 >> 24 & 0xFF, h6 >> 16 & 0xFF, h6 >> 8 & 0xFF, h6 & 0xFF, h7 >> 24 & 0xFF, h7 >> 16 & 0xFF, h7 >> 8 & 0xFF, h7 & 0xFF]);
	  }
	  return hash;
	}();
	var calculateSHA512 = function calculateSHA512Closure() {
	  function ch(result, x, y, z, tmp) {
	    result.assign(x);
	    result.and(y);
	    tmp.assign(x);
	    tmp.not();
	    tmp.and(z);
	    result.xor(tmp);
	  }
	  function maj(result, x, y, z, tmp) {
	    result.assign(x);
	    result.and(y);
	    tmp.assign(x);
	    tmp.and(z);
	    result.xor(tmp);
	    tmp.assign(y);
	    tmp.and(z);
	    result.xor(tmp);
	  }
	  function sigma(result, x, tmp) {
	    result.assign(x);
	    result.rotateRight(28);
	    tmp.assign(x);
	    tmp.rotateRight(34);
	    result.xor(tmp);
	    tmp.assign(x);
	    tmp.rotateRight(39);
	    result.xor(tmp);
	  }
	  function sigmaPrime(result, x, tmp) {
	    result.assign(x);
	    result.rotateRight(14);
	    tmp.assign(x);
	    tmp.rotateRight(18);
	    result.xor(tmp);
	    tmp.assign(x);
	    tmp.rotateRight(41);
	    result.xor(tmp);
	  }
	  function littleSigma(result, x, tmp) {
	    result.assign(x);
	    result.rotateRight(1);
	    tmp.assign(x);
	    tmp.rotateRight(8);
	    result.xor(tmp);
	    tmp.assign(x);
	    tmp.shiftRight(7);
	    result.xor(tmp);
	  }
	  function littleSigmaPrime(result, x, tmp) {
	    result.assign(x);
	    result.rotateRight(19);
	    tmp.assign(x);
	    tmp.rotateRight(61);
	    result.xor(tmp);
	    tmp.assign(x);
	    tmp.shiftRight(6);
	    result.xor(tmp);
	  }
	  var k = [new Word64(0x428a2f98, 0xd728ae22), new Word64(0x71374491, 0x23ef65cd), new Word64(0xb5c0fbcf, 0xec4d3b2f), new Word64(0xe9b5dba5, 0x8189dbbc), new Word64(0x3956c25b, 0xf348b538), new Word64(0x59f111f1, 0xb605d019), new Word64(0x923f82a4, 0xaf194f9b), new Word64(0xab1c5ed5, 0xda6d8118), new Word64(0xd807aa98, 0xa3030242), new Word64(0x12835b01, 0x45706fbe), new Word64(0x243185be, 0x4ee4b28c), new Word64(0x550c7dc3, 0xd5ffb4e2), new Word64(0x72be5d74, 0xf27b896f), new Word64(0x80deb1fe, 0x3b1696b1), new Word64(0x9bdc06a7, 0x25c71235), new Word64(0xc19bf174, 0xcf692694), new Word64(0xe49b69c1, 0x9ef14ad2), new Word64(0xefbe4786, 0x384f25e3), new Word64(0x0fc19dc6, 0x8b8cd5b5), new Word64(0x240ca1cc, 0x77ac9c65), new Word64(0x2de92c6f, 0x592b0275), new Word64(0x4a7484aa, 0x6ea6e483), new Word64(0x5cb0a9dc, 0xbd41fbd4), new Word64(0x76f988da, 0x831153b5), new Word64(0x983e5152, 0xee66dfab), new Word64(0xa831c66d, 0x2db43210), new Word64(0xb00327c8, 0x98fb213f), new Word64(0xbf597fc7, 0xbeef0ee4), new Word64(0xc6e00bf3, 0x3da88fc2), new Word64(0xd5a79147, 0x930aa725), new Word64(0x06ca6351, 0xe003826f), new Word64(0x14292967, 0x0a0e6e70), new Word64(0x27b70a85, 0x46d22ffc), new Word64(0x2e1b2138, 0x5c26c926), new Word64(0x4d2c6dfc, 0x5ac42aed), new Word64(0x53380d13, 0x9d95b3df), new Word64(0x650a7354, 0x8baf63de), new Word64(0x766a0abb, 0x3c77b2a8), new Word64(0x81c2c92e, 0x47edaee6), new Word64(0x92722c85, 0x1482353b), new Word64(0xa2bfe8a1, 0x4cf10364), new Word64(0xa81a664b, 0xbc423001), new Word64(0xc24b8b70, 0xd0f89791), new Word64(0xc76c51a3, 0x0654be30), new Word64(0xd192e819, 0xd6ef5218), new Word64(0xd6990624, 0x5565a910), new Word64(0xf40e3585, 0x5771202a), new Word64(0x106aa070, 0x32bbd1b8), new Word64(0x19a4c116, 0xb8d2d0c8), new Word64(0x1e376c08, 0x5141ab53), new Word64(0x2748774c, 0xdf8eeb99), new Word64(0x34b0bcb5, 0xe19b48a8), new Word64(0x391c0cb3, 0xc5c95a63), new Word64(0x4ed8aa4a, 0xe3418acb), new Word64(0x5b9cca4f, 0x7763e373), new Word64(0x682e6ff3, 0xd6b2b8a3), new Word64(0x748f82ee, 0x5defb2fc), new Word64(0x78a5636f, 0x43172f60), new Word64(0x84c87814, 0xa1f0ab72), new Word64(0x8cc70208, 0x1a6439ec), new Word64(0x90befffa, 0x23631e28), new Word64(0xa4506ceb, 0xde82bde9), new Word64(0xbef9a3f7, 0xb2c67915), new Word64(0xc67178f2, 0xe372532b), new Word64(0xca273ece, 0xea26619c), new Word64(0xd186b8c7, 0x21c0c207), new Word64(0xeada7dd6, 0xcde0eb1e), new Word64(0xf57d4f7f, 0xee6ed178), new Word64(0x06f067aa, 0x72176fba), new Word64(0x0a637dc5, 0xa2c898a6), new Word64(0x113f9804, 0xbef90dae), new Word64(0x1b710b35, 0x131c471b), new Word64(0x28db77f5, 0x23047d84), new Word64(0x32caab7b, 0x40c72493), new Word64(0x3c9ebe0a, 0x15c9bebc), new Word64(0x431d67c4, 0x9c100d4c), new Word64(0x4cc5d4be, 0xcb3e42b6), new Word64(0x597f299c, 0xfc657e2a), new Word64(0x5fcb6fab, 0x3ad6faec), new Word64(0x6c44198c, 0x4a475817)];
	  function hash(data, offset, length, mode384) {
	    mode384 = !!mode384;
	    var h0, h1, h2, h3, h4, h5, h6, h7;
	    if (!mode384) {
	      h0 = new Word64(0x6a09e667, 0xf3bcc908);
	      h1 = new Word64(0xbb67ae85, 0x84caa73b);
	      h2 = new Word64(0x3c6ef372, 0xfe94f82b);
	      h3 = new Word64(0xa54ff53a, 0x5f1d36f1);
	      h4 = new Word64(0x510e527f, 0xade682d1);
	      h5 = new Word64(0x9b05688c, 0x2b3e6c1f);
	      h6 = new Word64(0x1f83d9ab, 0xfb41bd6b);
	      h7 = new Word64(0x5be0cd19, 0x137e2179);
	    } else {
	      h0 = new Word64(0xcbbb9d5d, 0xc1059ed8);
	      h1 = new Word64(0x629a292a, 0x367cd507);
	      h2 = new Word64(0x9159015a, 0x3070dd17);
	      h3 = new Word64(0x152fecd8, 0xf70e5939);
	      h4 = new Word64(0x67332667, 0xffc00b31);
	      h5 = new Word64(0x8eb44a87, 0x68581511);
	      h6 = new Word64(0xdb0c2e0d, 0x64f98fa7);
	      h7 = new Word64(0x47b5481d, 0xbefa4fa4);
	    }
	    var paddedLength = Math.ceil((length + 17) / 128) * 128;
	    var padded = new Uint8Array(paddedLength);
	    var i, j, n;
	    for (i = 0; i < length; ++i) {
	      padded[i] = data[offset++];
	    }
	    padded[i++] = 0x80;
	    n = paddedLength - 16;
	    while (i < n) {
	      padded[i++] = 0;
	    }
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = 0;
	    padded[i++] = length >>> 29 & 0xFF;
	    padded[i++] = length >> 21 & 0xFF;
	    padded[i++] = length >> 13 & 0xFF;
	    padded[i++] = length >> 5 & 0xFF;
	    padded[i++] = length << 3 & 0xFF;
	    var w = new Array(80);
	    for (i = 0; i < 80; i++) {
	      w[i] = new Word64(0, 0);
	    }
	    var a = new Word64(0, 0),
	        b = new Word64(0, 0),
	        c = new Word64(0, 0);
	    var d = new Word64(0, 0),
	        e = new Word64(0, 0),
	        f = new Word64(0, 0);
	    var g = new Word64(0, 0),
	        h = new Word64(0, 0);
	    var t1 = new Word64(0, 0),
	        t2 = new Word64(0, 0);
	    var tmp1 = new Word64(0, 0),
	        tmp2 = new Word64(0, 0),
	        tmp3;
	    for (i = 0; i < paddedLength;) {
	      for (j = 0; j < 16; ++j) {
	        w[j].high = padded[i] << 24 | padded[i + 1] << 16 | padded[i + 2] << 8 | padded[i + 3];
	        w[j].low = padded[i + 4] << 24 | padded[i + 5] << 16 | padded[i + 6] << 8 | padded[i + 7];
	        i += 8;
	      }
	      for (j = 16; j < 80; ++j) {
	        tmp3 = w[j];
	        littleSigmaPrime(tmp3, w[j - 2], tmp2);
	        tmp3.add(w[j - 7]);
	        littleSigma(tmp1, w[j - 15], tmp2);
	        tmp3.add(tmp1);
	        tmp3.add(w[j - 16]);
	      }
	      a.assign(h0);
	      b.assign(h1);
	      c.assign(h2);
	      d.assign(h3);
	      e.assign(h4);
	      f.assign(h5);
	      g.assign(h6);
	      h.assign(h7);
	      for (j = 0; j < 80; ++j) {
	        t1.assign(h);
	        sigmaPrime(tmp1, e, tmp2);
	        t1.add(tmp1);
	        ch(tmp1, e, f, g, tmp2);
	        t1.add(tmp1);
	        t1.add(k[j]);
	        t1.add(w[j]);
	        sigma(t2, a, tmp2);
	        maj(tmp1, a, b, c, tmp2);
	        t2.add(tmp1);
	        tmp3 = h;
	        h = g;
	        g = f;
	        f = e;
	        d.add(t1);
	        e = d;
	        d = c;
	        c = b;
	        b = a;
	        tmp3.assign(t1);
	        tmp3.add(t2);
	        a = tmp3;
	      }
	      h0.add(a);
	      h1.add(b);
	      h2.add(c);
	      h3.add(d);
	      h4.add(e);
	      h5.add(f);
	      h6.add(g);
	      h7.add(h);
	    }
	    var result;
	    if (!mode384) {
	      result = new Uint8Array(64);
	      h0.copyTo(result, 0);
	      h1.copyTo(result, 8);
	      h2.copyTo(result, 16);
	      h3.copyTo(result, 24);
	      h4.copyTo(result, 32);
	      h5.copyTo(result, 40);
	      h6.copyTo(result, 48);
	      h7.copyTo(result, 56);
	    } else {
	      result = new Uint8Array(48);
	      h0.copyTo(result, 0);
	      h1.copyTo(result, 8);
	      h2.copyTo(result, 16);
	      h3.copyTo(result, 24);
	      h4.copyTo(result, 32);
	      h5.copyTo(result, 40);
	    }
	    return result;
	  }
	  return hash;
	}();
	var calculateSHA384 = function calculateSHA384Closure() {
	  function hash(data, offset, length) {
	    return calculateSHA512(data, offset, length, true);
	  }
	  return hash;
	}();
	var NullCipher = function NullCipherClosure() {
	  function NullCipher() {}
	  NullCipher.prototype = {
	    decryptBlock: function NullCipher_decryptBlock(data) {
	      return data;
	    }
	  };
	  return NullCipher;
	}();
	var AES128Cipher = function AES128CipherClosure() {
	  var rcon = new Uint8Array([0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d]);
	  var s = new Uint8Array([0x63, 0x7c, 0x77, 0x7b, 0xf2, 0x6b, 0x6f, 0xc5, 0x30, 0x01, 0x67, 0x2b, 0xfe, 0xd7, 0xab, 0x76, 0xca, 0x82, 0xc9, 0x7d, 0xfa, 0x59, 0x47, 0xf0, 0xad, 0xd4, 0xa2, 0xaf, 0x9c, 0xa4, 0x72, 0xc0, 0xb7, 0xfd, 0x93, 0x26, 0x36, 0x3f, 0xf7, 0xcc, 0x34, 0xa5, 0xe5, 0xf1, 0x71, 0xd8, 0x31, 0x15, 0x04, 0xc7, 0x23, 0xc3, 0x18, 0x96, 0x05, 0x9a, 0x07, 0x12, 0x80, 0xe2, 0xeb, 0x27, 0xb2, 0x75, 0x09, 0x83, 0x2c, 0x1a, 0x1b, 0x6e, 0x5a, 0xa0, 0x52, 0x3b, 0xd6, 0xb3, 0x29, 0xe3, 0x2f, 0x84, 0x53, 0xd1, 0x00, 0xed, 0x20, 0xfc, 0xb1, 0x5b, 0x6a, 0xcb, 0xbe, 0x39, 0x4a, 0x4c, 0x58, 0xcf, 0xd0, 0xef, 0xaa, 0xfb, 0x43, 0x4d, 0x33, 0x85, 0x45, 0xf9, 0x02, 0x7f, 0x50, 0x3c, 0x9f, 0xa8, 0x51, 0xa3, 0x40, 0x8f, 0x92, 0x9d, 0x38, 0xf5, 0xbc, 0xb6, 0xda, 0x21, 0x10, 0xff, 0xf3, 0xd2, 0xcd, 0x0c, 0x13, 0xec, 0x5f, 0x97, 0x44, 0x17, 0xc4, 0xa7, 0x7e, 0x3d, 0x64, 0x5d, 0x19, 0x73, 0x60, 0x81, 0x4f, 0xdc, 0x22, 0x2a, 0x90, 0x88, 0x46, 0xee, 0xb8, 0x14, 0xde, 0x5e, 0x0b, 0xdb, 0xe0, 0x32, 0x3a, 0x0a, 0x49, 0x06, 0x24, 0x5c, 0xc2, 0xd3, 0xac, 0x62, 0x91, 0x95, 0xe4, 0x79, 0xe7, 0xc8, 0x37, 0x6d, 0x8d, 0xd5, 0x4e, 0xa9, 0x6c, 0x56, 0xf4, 0xea, 0x65, 0x7a, 0xae, 0x08, 0xba, 0x78, 0x25, 0x2e, 0x1c, 0xa6, 0xb4, 0xc6, 0xe8, 0xdd, 0x74, 0x1f, 0x4b, 0xbd, 0x8b, 0x8a, 0x70, 0x3e, 0xb5, 0x66, 0x48, 0x03, 0xf6, 0x0e, 0x61, 0x35, 0x57, 0xb9, 0x86, 0xc1, 0x1d, 0x9e, 0xe1, 0xf8, 0x98, 0x11, 0x69, 0xd9, 0x8e, 0x94, 0x9b, 0x1e, 0x87, 0xe9, 0xce, 0x55, 0x28, 0xdf, 0x8c, 0xa1, 0x89, 0x0d, 0xbf, 0xe6, 0x42, 0x68, 0x41, 0x99, 0x2d, 0x0f, 0xb0, 0x54, 0xbb, 0x16]);
	  var inv_s = new Uint8Array([0x52, 0x09, 0x6a, 0xd5, 0x30, 0x36, 0xa5, 0x38, 0xbf, 0x40, 0xa3, 0x9e, 0x81, 0xf3, 0xd7, 0xfb, 0x7c, 0xe3, 0x39, 0x82, 0x9b, 0x2f, 0xff, 0x87, 0x34, 0x8e, 0x43, 0x44, 0xc4, 0xde, 0xe9, 0xcb, 0x54, 0x7b, 0x94, 0x32, 0xa6, 0xc2, 0x23, 0x3d, 0xee, 0x4c, 0x95, 0x0b, 0x42, 0xfa, 0xc3, 0x4e, 0x08, 0x2e, 0xa1, 0x66, 0x28, 0xd9, 0x24, 0xb2, 0x76, 0x5b, 0xa2, 0x49, 0x6d, 0x8b, 0xd1, 0x25, 0x72, 0xf8, 0xf6, 0x64, 0x86, 0x68, 0x98, 0x16, 0xd4, 0xa4, 0x5c, 0xcc, 0x5d, 0x65, 0xb6, 0x92, 0x6c, 0x70, 0x48, 0x50, 0xfd, 0xed, 0xb9, 0xda, 0x5e, 0x15, 0x46, 0x57, 0xa7, 0x8d, 0x9d, 0x84, 0x90, 0xd8, 0xab, 0x00, 0x8c, 0xbc, 0xd3, 0x0a, 0xf7, 0xe4, 0x58, 0x05, 0xb8, 0xb3, 0x45, 0x06, 0xd0, 0x2c, 0x1e, 0x8f, 0xca, 0x3f, 0x0f, 0x02, 0xc1, 0xaf, 0xbd, 0x03, 0x01, 0x13, 0x8a, 0x6b, 0x3a, 0x91, 0x11, 0x41, 0x4f, 0x67, 0xdc, 0xea, 0x97, 0xf2, 0xcf, 0xce, 0xf0, 0xb4, 0xe6, 0x73, 0x96, 0xac, 0x74, 0x22, 0xe7, 0xad, 0x35, 0x85, 0xe2, 0xf9, 0x37, 0xe8, 0x1c, 0x75, 0xdf, 0x6e, 0x47, 0xf1, 0x1a, 0x71, 0x1d, 0x29, 0xc5, 0x89, 0x6f, 0xb7, 0x62, 0x0e, 0xaa, 0x18, 0xbe, 0x1b, 0xfc, 0x56, 0x3e, 0x4b, 0xc6, 0xd2, 0x79, 0x20, 0x9a, 0xdb, 0xc0, 0xfe, 0x78, 0xcd, 0x5a, 0xf4, 0x1f, 0xdd, 0xa8, 0x33, 0x88, 0x07, 0xc7, 0x31, 0xb1, 0x12, 0x10, 0x59, 0x27, 0x80, 0xec, 0x5f, 0x60, 0x51, 0x7f, 0xa9, 0x19, 0xb5, 0x4a, 0x0d, 0x2d, 0xe5, 0x7a, 0x9f, 0x93, 0xc9, 0x9c, 0xef, 0xa0, 0xe0, 0x3b, 0x4d, 0xae, 0x2a, 0xf5, 0xb0, 0xc8, 0xeb, 0xbb, 0x3c, 0x83, 0x53, 0x99, 0x61, 0x17, 0x2b, 0x04, 0x7e, 0xba, 0x77, 0xd6, 0x26, 0xe1, 0x69, 0x14, 0x63, 0x55, 0x21, 0x0c, 0x7d]);
	  var mixCol = new Uint8Array(256);
	  for (var i = 0; i < 256; i++) {
	    if (i < 128) {
	      mixCol[i] = i << 1;
	    } else {
	      mixCol[i] = i << 1 ^ 0x1b;
	    }
	  }
	  var mix = new Uint32Array([0x00000000, 0x0e090d0b, 0x1c121a16, 0x121b171d, 0x3824342c, 0x362d3927, 0x24362e3a, 0x2a3f2331, 0x70486858, 0x7e416553, 0x6c5a724e, 0x62537f45, 0x486c5c74, 0x4665517f, 0x547e4662, 0x5a774b69, 0xe090d0b0, 0xee99ddbb, 0xfc82caa6, 0xf28bc7ad, 0xd8b4e49c, 0xd6bde997, 0xc4a6fe8a, 0xcaaff381, 0x90d8b8e8, 0x9ed1b5e3, 0x8ccaa2fe, 0x82c3aff5, 0xa8fc8cc4, 0xa6f581cf, 0xb4ee96d2, 0xbae79bd9, 0xdb3bbb7b, 0xd532b670, 0xc729a16d, 0xc920ac66, 0xe31f8f57, 0xed16825c, 0xff0d9541, 0xf104984a, 0xab73d323, 0xa57ade28, 0xb761c935, 0xb968c43e, 0x9357e70f, 0x9d5eea04, 0x8f45fd19, 0x814cf012, 0x3bab6bcb, 0x35a266c0, 0x27b971dd, 0x29b07cd6, 0x038f5fe7, 0x0d8652ec, 0x1f9d45f1, 0x119448fa, 0x4be30393, 0x45ea0e98, 0x57f11985, 0x59f8148e, 0x73c737bf, 0x7dce3ab4, 0x6fd52da9, 0x61dc20a2, 0xad766df6, 0xa37f60fd, 0xb16477e0, 0xbf6d7aeb, 0x955259da, 0x9b5b54d1, 0x894043cc, 0x87494ec7, 0xdd3e05ae, 0xd33708a5, 0xc12c1fb8, 0xcf2512b3, 0xe51a3182, 0xeb133c89, 0xf9082b94, 0xf701269f, 0x4de6bd46, 0x43efb04d, 0x51f4a750, 0x5ffdaa5b, 0x75c2896a, 0x7bcb8461, 0x69d0937c, 0x67d99e77, 0x3daed51e, 0x33a7d815, 0x21bccf08, 0x2fb5c203, 0x058ae132, 0x0b83ec39, 0x1998fb24, 0x1791f62f, 0x764dd68d, 0x7844db86, 0x6a5fcc9b, 0x6456c190, 0x4e69e2a1, 0x4060efaa, 0x527bf8b7, 0x5c72f5bc, 0x0605bed5, 0x080cb3de, 0x1a17a4c3, 0x141ea9c8, 0x3e218af9, 0x302887f2, 0x223390ef, 0x2c3a9de4, 0x96dd063d, 0x98d40b36, 0x8acf1c2b, 0x84c61120, 0xaef93211, 0xa0f03f1a, 0xb2eb2807, 0xbce2250c, 0xe6956e65, 0xe89c636e, 0xfa877473, 0xf48e7978, 0xdeb15a49, 0xd0b85742, 0xc2a3405f, 0xccaa4d54, 0x41ecdaf7, 0x4fe5d7fc, 0x5dfec0e1, 0x53f7cdea, 0x79c8eedb, 0x77c1e3d0, 0x65daf4cd, 0x6bd3f9c6, 0x31a4b2af, 0x3fadbfa4, 0x2db6a8b9, 0x23bfa5b2, 0x09808683, 0x07898b88, 0x15929c95, 0x1b9b919e, 0xa17c0a47, 0xaf75074c, 0xbd6e1051, 0xb3671d5a, 0x99583e6b, 0x97513360, 0x854a247d, 0x8b432976, 0xd134621f, 0xdf3d6f14, 0xcd267809, 0xc32f7502, 0xe9105633, 0xe7195b38, 0xf5024c25, 0xfb0b412e, 0x9ad7618c, 0x94de6c87, 0x86c57b9a, 0x88cc7691, 0xa2f355a0, 0xacfa58ab, 0xbee14fb6, 0xb0e842bd, 0xea9f09d4, 0xe49604df, 0xf68d13c2, 0xf8841ec9, 0xd2bb3df8, 0xdcb230f3, 0xcea927ee, 0xc0a02ae5, 0x7a47b13c, 0x744ebc37, 0x6655ab2a, 0x685ca621, 0x42638510, 0x4c6a881b, 0x5e719f06, 0x5078920d, 0x0a0fd964, 0x0406d46f, 0x161dc372, 0x1814ce79, 0x322bed48, 0x3c22e043, 0x2e39f75e, 0x2030fa55, 0xec9ab701, 0xe293ba0a, 0xf088ad17, 0xfe81a01c, 0xd4be832d, 0xdab78e26, 0xc8ac993b, 0xc6a59430, 0x9cd2df59, 0x92dbd252, 0x80c0c54f, 0x8ec9c844, 0xa4f6eb75, 0xaaffe67e, 0xb8e4f163, 0xb6edfc68, 0x0c0a67b1, 0x02036aba, 0x10187da7, 0x1e1170ac, 0x342e539d, 0x3a275e96, 0x283c498b, 0x26354480, 0x7c420fe9, 0x724b02e2, 0x605015ff, 0x6e5918f4, 0x44663bc5, 0x4a6f36ce, 0x587421d3, 0x567d2cd8, 0x37a10c7a, 0x39a80171, 0x2bb3166c, 0x25ba1b67, 0x0f853856, 0x018c355d, 0x13972240, 0x1d9e2f4b, 0x47e96422, 0x49e06929, 0x5bfb7e34, 0x55f2733f, 0x7fcd500e, 0x71c45d05, 0x63df4a18, 0x6dd64713, 0xd731dcca, 0xd938d1c1, 0xcb23c6dc, 0xc52acbd7, 0xef15e8e6, 0xe11ce5ed, 0xf307f2f0, 0xfd0efffb, 0xa779b492, 0xa970b999, 0xbb6bae84, 0xb562a38f, 0x9f5d80be, 0x91548db5, 0x834f9aa8, 0x8d4697a3]);
	  function expandKey128(cipherKey) {
	    var b = 176,
	        result = new Uint8Array(b);
	    result.set(cipherKey);
	    for (var j = 16, i = 1; j < b; ++i) {
	      var t1 = result[j - 3],
	          t2 = result[j - 2],
	          t3 = result[j - 1],
	          t4 = result[j - 4];
	      t1 = s[t1];
	      t2 = s[t2];
	      t3 = s[t3];
	      t4 = s[t4];
	      t1 = t1 ^ rcon[i];
	      for (var n = 0; n < 4; ++n) {
	        result[j] = t1 ^= result[j - 16];
	        j++;
	        result[j] = t2 ^= result[j - 16];
	        j++;
	        result[j] = t3 ^= result[j - 16];
	        j++;
	        result[j] = t4 ^= result[j - 16];
	        j++;
	      }
	    }
	    return result;
	  }
	  function decrypt128(input, key) {
	    var state = new Uint8Array(16);
	    state.set(input);
	    var i, j, k;
	    var t, u, v;
	    for (j = 0, k = 160; j < 16; ++j, ++k) {
	      state[j] ^= key[k];
	    }
	    for (i = 9; i >= 1; --i) {
	      t = state[13];
	      state[13] = state[9];
	      state[9] = state[5];
	      state[5] = state[1];
	      state[1] = t;
	      t = state[14];
	      u = state[10];
	      state[14] = state[6];
	      state[10] = state[2];
	      state[6] = t;
	      state[2] = u;
	      t = state[15];
	      u = state[11];
	      v = state[7];
	      state[15] = state[3];
	      state[11] = t;
	      state[7] = u;
	      state[3] = v;
	      for (j = 0; j < 16; ++j) {
	        state[j] = inv_s[state[j]];
	      }
	      for (j = 0, k = i * 16; j < 16; ++j, ++k) {
	        state[j] ^= key[k];
	      }
	      for (j = 0; j < 16; j += 4) {
	        var s0 = mix[state[j]],
	            s1 = mix[state[j + 1]],
	            s2 = mix[state[j + 2]],
	            s3 = mix[state[j + 3]];
	        t = s0 ^ s1 >>> 8 ^ s1 << 24 ^ s2 >>> 16 ^ s2 << 16 ^ s3 >>> 24 ^ s3 << 8;
	        state[j] = t >>> 24 & 0xFF;
	        state[j + 1] = t >> 16 & 0xFF;
	        state[j + 2] = t >> 8 & 0xFF;
	        state[j + 3] = t & 0xFF;
	      }
	    }
	    t = state[13];
	    state[13] = state[9];
	    state[9] = state[5];
	    state[5] = state[1];
	    state[1] = t;
	    t = state[14];
	    u = state[10];
	    state[14] = state[6];
	    state[10] = state[2];
	    state[6] = t;
	    state[2] = u;
	    t = state[15];
	    u = state[11];
	    v = state[7];
	    state[15] = state[3];
	    state[11] = t;
	    state[7] = u;
	    state[3] = v;
	    for (j = 0; j < 16; ++j) {
	      state[j] = inv_s[state[j]];
	      state[j] ^= key[j];
	    }
	    return state;
	  }
	  function encrypt128(input, key) {
	    var t, u, v, k;
	    var state = new Uint8Array(16);
	    state.set(input);
	    for (j = 0; j < 16; ++j) {
	      state[j] ^= key[j];
	    }
	    for (i = 1; i < 10; i++) {
	      for (j = 0; j < 16; ++j) {
	        state[j] = s[state[j]];
	      }
	      v = state[1];
	      state[1] = state[5];
	      state[5] = state[9];
	      state[9] = state[13];
	      state[13] = v;
	      v = state[2];
	      u = state[6];
	      state[2] = state[10];
	      state[6] = state[14];
	      state[10] = v;
	      state[14] = u;
	      v = state[3];
	      u = state[7];
	      t = state[11];
	      state[3] = state[15];
	      state[7] = v;
	      state[11] = u;
	      state[15] = t;
	      for (var j = 0; j < 16; j += 4) {
	        var s0 = state[j + 0],
	            s1 = state[j + 1];
	        var s2 = state[j + 2],
	            s3 = state[j + 3];
	        t = s0 ^ s1 ^ s2 ^ s3;
	        state[j + 0] ^= t ^ mixCol[s0 ^ s1];
	        state[j + 1] ^= t ^ mixCol[s1 ^ s2];
	        state[j + 2] ^= t ^ mixCol[s2 ^ s3];
	        state[j + 3] ^= t ^ mixCol[s3 ^ s0];
	      }
	      for (j = 0, k = i * 16; j < 16; ++j, ++k) {
	        state[j] ^= key[k];
	      }
	    }
	    for (j = 0; j < 16; ++j) {
	      state[j] = s[state[j]];
	    }
	    v = state[1];
	    state[1] = state[5];
	    state[5] = state[9];
	    state[9] = state[13];
	    state[13] = v;
	    v = state[2];
	    u = state[6];
	    state[2] = state[10];
	    state[6] = state[14];
	    state[10] = v;
	    state[14] = u;
	    v = state[3];
	    u = state[7];
	    t = state[11];
	    state[3] = state[15];
	    state[7] = v;
	    state[11] = u;
	    state[15] = t;
	    for (j = 0, k = 160; j < 16; ++j, ++k) {
	      state[j] ^= key[k];
	    }
	    return state;
	  }
	  function AES128Cipher(key) {
	    this.key = expandKey128(key);
	    this.buffer = new Uint8Array(16);
	    this.bufferPosition = 0;
	  }
	  function decryptBlock2(data, finalize) {
	    var i,
	        j,
	        ii,
	        sourceLength = data.length,
	        buffer = this.buffer,
	        bufferLength = this.bufferPosition,
	        result = [],
	        iv = this.iv;
	    for (i = 0; i < sourceLength; ++i) {
	      buffer[bufferLength] = data[i];
	      ++bufferLength;
	      if (bufferLength < 16) {
	        continue;
	      }
	      var plain = decrypt128(buffer, this.key);
	      for (j = 0; j < 16; ++j) {
	        plain[j] ^= iv[j];
	      }
	      iv = buffer;
	      result.push(plain);
	      buffer = new Uint8Array(16);
	      bufferLength = 0;
	    }
	    this.buffer = buffer;
	    this.bufferLength = bufferLength;
	    this.iv = iv;
	    if (result.length === 0) {
	      return new Uint8Array([]);
	    }
	    var outputLength = 16 * result.length;
	    if (finalize) {
	      var lastBlock = result[result.length - 1];
	      var psLen = lastBlock[15];
	      if (psLen <= 16) {
	        for (i = 15, ii = 16 - psLen; i >= ii; --i) {
	          if (lastBlock[i] !== psLen) {
	            psLen = 0;
	            break;
	          }
	        }
	        outputLength -= psLen;
	        result[result.length - 1] = lastBlock.subarray(0, 16 - psLen);
	      }
	    }
	    var output = new Uint8Array(outputLength);
	    for (i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16) {
	      output.set(result[i], j);
	    }
	    return output;
	  }
	  AES128Cipher.prototype = {
	    decryptBlock: function AES128Cipher_decryptBlock(data, finalize) {
	      var i,
	          sourceLength = data.length;
	      var buffer = this.buffer,
	          bufferLength = this.bufferPosition;
	      for (i = 0; bufferLength < 16 && i < sourceLength; ++i, ++bufferLength) {
	        buffer[bufferLength] = data[i];
	      }
	      if (bufferLength < 16) {
	        this.bufferLength = bufferLength;
	        return new Uint8Array([]);
	      }
	      this.iv = buffer;
	      this.buffer = new Uint8Array(16);
	      this.bufferLength = 0;
	      this.decryptBlock = decryptBlock2;
	      return this.decryptBlock(data.subarray(16), finalize);
	    },
	    encrypt: function AES128Cipher_encrypt(data, iv) {
	      var i,
	          j,
	          ii,
	          sourceLength = data.length,
	          buffer = this.buffer,
	          bufferLength = this.bufferPosition,
	          result = [];
	      if (!iv) {
	        iv = new Uint8Array(16);
	      }
	      for (i = 0; i < sourceLength; ++i) {
	        buffer[bufferLength] = data[i];
	        ++bufferLength;
	        if (bufferLength < 16) {
	          continue;
	        }
	        for (j = 0; j < 16; ++j) {
	          buffer[j] ^= iv[j];
	        }
	        var cipher = encrypt128(buffer, this.key);
	        iv = cipher;
	        result.push(cipher);
	        buffer = new Uint8Array(16);
	        bufferLength = 0;
	      }
	      this.buffer = buffer;
	      this.bufferLength = bufferLength;
	      this.iv = iv;
	      if (result.length === 0) {
	        return new Uint8Array([]);
	      }
	      var outputLength = 16 * result.length;
	      var output = new Uint8Array(outputLength);
	      for (i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16) {
	        output.set(result[i], j);
	      }
	      return output;
	    }
	  };
	  return AES128Cipher;
	}();
	var AES256Cipher = function AES256CipherClosure() {
	  var s = new Uint8Array([0x63, 0x7c, 0x77, 0x7b, 0xf2, 0x6b, 0x6f, 0xc5, 0x30, 0x01, 0x67, 0x2b, 0xfe, 0xd7, 0xab, 0x76, 0xca, 0x82, 0xc9, 0x7d, 0xfa, 0x59, 0x47, 0xf0, 0xad, 0xd4, 0xa2, 0xaf, 0x9c, 0xa4, 0x72, 0xc0, 0xb7, 0xfd, 0x93, 0x26, 0x36, 0x3f, 0xf7, 0xcc, 0x34, 0xa5, 0xe5, 0xf1, 0x71, 0xd8, 0x31, 0x15, 0x04, 0xc7, 0x23, 0xc3, 0x18, 0x96, 0x05, 0x9a, 0x07, 0x12, 0x80, 0xe2, 0xeb, 0x27, 0xb2, 0x75, 0x09, 0x83, 0x2c, 0x1a, 0x1b, 0x6e, 0x5a, 0xa0, 0x52, 0x3b, 0xd6, 0xb3, 0x29, 0xe3, 0x2f, 0x84, 0x53, 0xd1, 0x00, 0xed, 0x20, 0xfc, 0xb1, 0x5b, 0x6a, 0xcb, 0xbe, 0x39, 0x4a, 0x4c, 0x58, 0xcf, 0xd0, 0xef, 0xaa, 0xfb, 0x43, 0x4d, 0x33, 0x85, 0x45, 0xf9, 0x02, 0x7f, 0x50, 0x3c, 0x9f, 0xa8, 0x51, 0xa3, 0x40, 0x8f, 0x92, 0x9d, 0x38, 0xf5, 0xbc, 0xb6, 0xda, 0x21, 0x10, 0xff, 0xf3, 0xd2, 0xcd, 0x0c, 0x13, 0xec, 0x5f, 0x97, 0x44, 0x17, 0xc4, 0xa7, 0x7e, 0x3d, 0x64, 0x5d, 0x19, 0x73, 0x60, 0x81, 0x4f, 0xdc, 0x22, 0x2a, 0x90, 0x88, 0x46, 0xee, 0xb8, 0x14, 0xde, 0x5e, 0x0b, 0xdb, 0xe0, 0x32, 0x3a, 0x0a, 0x49, 0x06, 0x24, 0x5c, 0xc2, 0xd3, 0xac, 0x62, 0x91, 0x95, 0xe4, 0x79, 0xe7, 0xc8, 0x37, 0x6d, 0x8d, 0xd5, 0x4e, 0xa9, 0x6c, 0x56, 0xf4, 0xea, 0x65, 0x7a, 0xae, 0x08, 0xba, 0x78, 0x25, 0x2e, 0x1c, 0xa6, 0xb4, 0xc6, 0xe8, 0xdd, 0x74, 0x1f, 0x4b, 0xbd, 0x8b, 0x8a, 0x70, 0x3e, 0xb5, 0x66, 0x48, 0x03, 0xf6, 0x0e, 0x61, 0x35, 0x57, 0xb9, 0x86, 0xc1, 0x1d, 0x9e, 0xe1, 0xf8, 0x98, 0x11, 0x69, 0xd9, 0x8e, 0x94, 0x9b, 0x1e, 0x87, 0xe9, 0xce, 0x55, 0x28, 0xdf, 0x8c, 0xa1, 0x89, 0x0d, 0xbf, 0xe6, 0x42, 0x68, 0x41, 0x99, 0x2d, 0x0f, 0xb0, 0x54, 0xbb, 0x16]);
	  var inv_s = new Uint8Array([0x52, 0x09, 0x6a, 0xd5, 0x30, 0x36, 0xa5, 0x38, 0xbf, 0x40, 0xa3, 0x9e, 0x81, 0xf3, 0xd7, 0xfb, 0x7c, 0xe3, 0x39, 0x82, 0x9b, 0x2f, 0xff, 0x87, 0x34, 0x8e, 0x43, 0x44, 0xc4, 0xde, 0xe9, 0xcb, 0x54, 0x7b, 0x94, 0x32, 0xa6, 0xc2, 0x23, 0x3d, 0xee, 0x4c, 0x95, 0x0b, 0x42, 0xfa, 0xc3, 0x4e, 0x08, 0x2e, 0xa1, 0x66, 0x28, 0xd9, 0x24, 0xb2, 0x76, 0x5b, 0xa2, 0x49, 0x6d, 0x8b, 0xd1, 0x25, 0x72, 0xf8, 0xf6, 0x64, 0x86, 0x68, 0x98, 0x16, 0xd4, 0xa4, 0x5c, 0xcc, 0x5d, 0x65, 0xb6, 0x92, 0x6c, 0x70, 0x48, 0x50, 0xfd, 0xed, 0xb9, 0xda, 0x5e, 0x15, 0x46, 0x57, 0xa7, 0x8d, 0x9d, 0x84, 0x90, 0xd8, 0xab, 0x00, 0x8c, 0xbc, 0xd3, 0x0a, 0xf7, 0xe4, 0x58, 0x05, 0xb8, 0xb3, 0x45, 0x06, 0xd0, 0x2c, 0x1e, 0x8f, 0xca, 0x3f, 0x0f, 0x02, 0xc1, 0xaf, 0xbd, 0x03, 0x01, 0x13, 0x8a, 0x6b, 0x3a, 0x91, 0x11, 0x41, 0x4f, 0x67, 0xdc, 0xea, 0x97, 0xf2, 0xcf, 0xce, 0xf0, 0xb4, 0xe6, 0x73, 0x96, 0xac, 0x74, 0x22, 0xe7, 0xad, 0x35, 0x85, 0xe2, 0xf9, 0x37, 0xe8, 0x1c, 0x75, 0xdf, 0x6e, 0x47, 0xf1, 0x1a, 0x71, 0x1d, 0x29, 0xc5, 0x89, 0x6f, 0xb7, 0x62, 0x0e, 0xaa, 0x18, 0xbe, 0x1b, 0xfc, 0x56, 0x3e, 0x4b, 0xc6, 0xd2, 0x79, 0x20, 0x9a, 0xdb, 0xc0, 0xfe, 0x78, 0xcd, 0x5a, 0xf4, 0x1f, 0xdd, 0xa8, 0x33, 0x88, 0x07, 0xc7, 0x31, 0xb1, 0x12, 0x10, 0x59, 0x27, 0x80, 0xec, 0x5f, 0x60, 0x51, 0x7f, 0xa9, 0x19, 0xb5, 0x4a, 0x0d, 0x2d, 0xe5, 0x7a, 0x9f, 0x93, 0xc9, 0x9c, 0xef, 0xa0, 0xe0, 0x3b, 0x4d, 0xae, 0x2a, 0xf5, 0xb0, 0xc8, 0xeb, 0xbb, 0x3c, 0x83, 0x53, 0x99, 0x61, 0x17, 0x2b, 0x04, 0x7e, 0xba, 0x77, 0xd6, 0x26, 0xe1, 0x69, 0x14, 0x63, 0x55, 0x21, 0x0c, 0x7d]);
	  var mixCol = new Uint8Array(256);
	  for (var i = 0; i < 256; i++) {
	    if (i < 128) {
	      mixCol[i] = i << 1;
	    } else {
	      mixCol[i] = i << 1 ^ 0x1b;
	    }
	  }
	  var mix = new Uint32Array([0x00000000, 0x0e090d0b, 0x1c121a16, 0x121b171d, 0x3824342c, 0x362d3927, 0x24362e3a, 0x2a3f2331, 0x70486858, 0x7e416553, 0x6c5a724e, 0x62537f45, 0x486c5c74, 0x4665517f, 0x547e4662, 0x5a774b69, 0xe090d0b0, 0xee99ddbb, 0xfc82caa6, 0xf28bc7ad, 0xd8b4e49c, 0xd6bde997, 0xc4a6fe8a, 0xcaaff381, 0x90d8b8e8, 0x9ed1b5e3, 0x8ccaa2fe, 0x82c3aff5, 0xa8fc8cc4, 0xa6f581cf, 0xb4ee96d2, 0xbae79bd9, 0xdb3bbb7b, 0xd532b670, 0xc729a16d, 0xc920ac66, 0xe31f8f57, 0xed16825c, 0xff0d9541, 0xf104984a, 0xab73d323, 0xa57ade28, 0xb761c935, 0xb968c43e, 0x9357e70f, 0x9d5eea04, 0x8f45fd19, 0x814cf012, 0x3bab6bcb, 0x35a266c0, 0x27b971dd, 0x29b07cd6, 0x038f5fe7, 0x0d8652ec, 0x1f9d45f1, 0x119448fa, 0x4be30393, 0x45ea0e98, 0x57f11985, 0x59f8148e, 0x73c737bf, 0x7dce3ab4, 0x6fd52da9, 0x61dc20a2, 0xad766df6, 0xa37f60fd, 0xb16477e0, 0xbf6d7aeb, 0x955259da, 0x9b5b54d1, 0x894043cc, 0x87494ec7, 0xdd3e05ae, 0xd33708a5, 0xc12c1fb8, 0xcf2512b3, 0xe51a3182, 0xeb133c89, 0xf9082b94, 0xf701269f, 0x4de6bd46, 0x43efb04d, 0x51f4a750, 0x5ffdaa5b, 0x75c2896a, 0x7bcb8461, 0x69d0937c, 0x67d99e77, 0x3daed51e, 0x33a7d815, 0x21bccf08, 0x2fb5c203, 0x058ae132, 0x0b83ec39, 0x1998fb24, 0x1791f62f, 0x764dd68d, 0x7844db86, 0x6a5fcc9b, 0x6456c190, 0x4e69e2a1, 0x4060efaa, 0x527bf8b7, 0x5c72f5bc, 0x0605bed5, 0x080cb3de, 0x1a17a4c3, 0x141ea9c8, 0x3e218af9, 0x302887f2, 0x223390ef, 0x2c3a9de4, 0x96dd063d, 0x98d40b36, 0x8acf1c2b, 0x84c61120, 0xaef93211, 0xa0f03f1a, 0xb2eb2807, 0xbce2250c, 0xe6956e65, 0xe89c636e, 0xfa877473, 0xf48e7978, 0xdeb15a49, 0xd0b85742, 0xc2a3405f, 0xccaa4d54, 0x41ecdaf7, 0x4fe5d7fc, 0x5dfec0e1, 0x53f7cdea, 0x79c8eedb, 0x77c1e3d0, 0x65daf4cd, 0x6bd3f9c6, 0x31a4b2af, 0x3fadbfa4, 0x2db6a8b9, 0x23bfa5b2, 0x09808683, 0x07898b88, 0x15929c95, 0x1b9b919e, 0xa17c0a47, 0xaf75074c, 0xbd6e1051, 0xb3671d5a, 0x99583e6b, 0x97513360, 0x854a247d, 0x8b432976, 0xd134621f, 0xdf3d6f14, 0xcd267809, 0xc32f7502, 0xe9105633, 0xe7195b38, 0xf5024c25, 0xfb0b412e, 0x9ad7618c, 0x94de6c87, 0x86c57b9a, 0x88cc7691, 0xa2f355a0, 0xacfa58ab, 0xbee14fb6, 0xb0e842bd, 0xea9f09d4, 0xe49604df, 0xf68d13c2, 0xf8841ec9, 0xd2bb3df8, 0xdcb230f3, 0xcea927ee, 0xc0a02ae5, 0x7a47b13c, 0x744ebc37, 0x6655ab2a, 0x685ca621, 0x42638510, 0x4c6a881b, 0x5e719f06, 0x5078920d, 0x0a0fd964, 0x0406d46f, 0x161dc372, 0x1814ce79, 0x322bed48, 0x3c22e043, 0x2e39f75e, 0x2030fa55, 0xec9ab701, 0xe293ba0a, 0xf088ad17, 0xfe81a01c, 0xd4be832d, 0xdab78e26, 0xc8ac993b, 0xc6a59430, 0x9cd2df59, 0x92dbd252, 0x80c0c54f, 0x8ec9c844, 0xa4f6eb75, 0xaaffe67e, 0xb8e4f163, 0xb6edfc68, 0x0c0a67b1, 0x02036aba, 0x10187da7, 0x1e1170ac, 0x342e539d, 0x3a275e96, 0x283c498b, 0x26354480, 0x7c420fe9, 0x724b02e2, 0x605015ff, 0x6e5918f4, 0x44663bc5, 0x4a6f36ce, 0x587421d3, 0x567d2cd8, 0x37a10c7a, 0x39a80171, 0x2bb3166c, 0x25ba1b67, 0x0f853856, 0x018c355d, 0x13972240, 0x1d9e2f4b, 0x47e96422, 0x49e06929, 0x5bfb7e34, 0x55f2733f, 0x7fcd500e, 0x71c45d05, 0x63df4a18, 0x6dd64713, 0xd731dcca, 0xd938d1c1, 0xcb23c6dc, 0xc52acbd7, 0xef15e8e6, 0xe11ce5ed, 0xf307f2f0, 0xfd0efffb, 0xa779b492, 0xa970b999, 0xbb6bae84, 0xb562a38f, 0x9f5d80be, 0x91548db5, 0x834f9aa8, 0x8d4697a3]);
	  function expandKey256(cipherKey) {
	    var b = 240,
	        result = new Uint8Array(b);
	    var r = 1;
	    result.set(cipherKey);
	    for (var j = 32, i = 1; j < b; ++i) {
	      if (j % 32 === 16) {
	        t1 = s[t1];
	        t2 = s[t2];
	        t3 = s[t3];
	        t4 = s[t4];
	      } else if (j % 32 === 0) {
	        var t1 = result[j - 3],
	            t2 = result[j - 2],
	            t3 = result[j - 1],
	            t4 = result[j - 4];
	        t1 = s[t1];
	        t2 = s[t2];
	        t3 = s[t3];
	        t4 = s[t4];
	        t1 = t1 ^ r;
	        if ((r <<= 1) >= 256) {
	          r = (r ^ 0x1b) & 0xFF;
	        }
	      }
	      for (var n = 0; n < 4; ++n) {
	        result[j] = t1 ^= result[j - 32];
	        j++;
	        result[j] = t2 ^= result[j - 32];
	        j++;
	        result[j] = t3 ^= result[j - 32];
	        j++;
	        result[j] = t4 ^= result[j - 32];
	        j++;
	      }
	    }
	    return result;
	  }
	  function decrypt256(input, key) {
	    var state = new Uint8Array(16);
	    state.set(input);
	    var i, j, k;
	    var t, u, v;
	    for (j = 0, k = 224; j < 16; ++j, ++k) {
	      state[j] ^= key[k];
	    }
	    for (i = 13; i >= 1; --i) {
	      t = state[13];
	      state[13] = state[9];
	      state[9] = state[5];
	      state[5] = state[1];
	      state[1] = t;
	      t = state[14];
	      u = state[10];
	      state[14] = state[6];
	      state[10] = state[2];
	      state[6] = t;
	      state[2] = u;
	      t = state[15];
	      u = state[11];
	      v = state[7];
	      state[15] = state[3];
	      state[11] = t;
	      state[7] = u;
	      state[3] = v;
	      for (j = 0; j < 16; ++j) {
	        state[j] = inv_s[state[j]];
	      }
	      for (j = 0, k = i * 16; j < 16; ++j, ++k) {
	        state[j] ^= key[k];
	      }
	      for (j = 0; j < 16; j += 4) {
	        var s0 = mix[state[j]],
	            s1 = mix[state[j + 1]],
	            s2 = mix[state[j + 2]],
	            s3 = mix[state[j + 3]];
	        t = s0 ^ s1 >>> 8 ^ s1 << 24 ^ s2 >>> 16 ^ s2 << 16 ^ s3 >>> 24 ^ s3 << 8;
	        state[j] = t >>> 24 & 0xFF;
	        state[j + 1] = t >> 16 & 0xFF;
	        state[j + 2] = t >> 8 & 0xFF;
	        state[j + 3] = t & 0xFF;
	      }
	    }
	    t = state[13];
	    state[13] = state[9];
	    state[9] = state[5];
	    state[5] = state[1];
	    state[1] = t;
	    t = state[14];
	    u = state[10];
	    state[14] = state[6];
	    state[10] = state[2];
	    state[6] = t;
	    state[2] = u;
	    t = state[15];
	    u = state[11];
	    v = state[7];
	    state[15] = state[3];
	    state[11] = t;
	    state[7] = u;
	    state[3] = v;
	    for (j = 0; j < 16; ++j) {
	      state[j] = inv_s[state[j]];
	      state[j] ^= key[j];
	    }
	    return state;
	  }
	  function encrypt256(input, key) {
	    var t, u, v, k;
	    var state = new Uint8Array(16);
	    state.set(input);
	    for (j = 0; j < 16; ++j) {
	      state[j] ^= key[j];
	    }
	    for (i = 1; i < 14; i++) {
	      for (j = 0; j < 16; ++j) {
	        state[j] = s[state[j]];
	      }
	      v = state[1];
	      state[1] = state[5];
	      state[5] = state[9];
	      state[9] = state[13];
	      state[13] = v;
	      v = state[2];
	      u = state[6];
	      state[2] = state[10];
	      state[6] = state[14];
	      state[10] = v;
	      state[14] = u;
	      v = state[3];
	      u = state[7];
	      t = state[11];
	      state[3] = state[15];
	      state[7] = v;
	      state[11] = u;
	      state[15] = t;
	      for (var j = 0; j < 16; j += 4) {
	        var s0 = state[j + 0],
	            s1 = state[j + 1];
	        var s2 = state[j + 2],
	            s3 = state[j + 3];
	        t = s0 ^ s1 ^ s2 ^ s3;
	        state[j + 0] ^= t ^ mixCol[s0 ^ s1];
	        state[j + 1] ^= t ^ mixCol[s1 ^ s2];
	        state[j + 2] ^= t ^ mixCol[s2 ^ s3];
	        state[j + 3] ^= t ^ mixCol[s3 ^ s0];
	      }
	      for (j = 0, k = i * 16; j < 16; ++j, ++k) {
	        state[j] ^= key[k];
	      }
	    }
	    for (j = 0; j < 16; ++j) {
	      state[j] = s[state[j]];
	    }
	    v = state[1];
	    state[1] = state[5];
	    state[5] = state[9];
	    state[9] = state[13];
	    state[13] = v;
	    v = state[2];
	    u = state[6];
	    state[2] = state[10];
	    state[6] = state[14];
	    state[10] = v;
	    state[14] = u;
	    v = state[3];
	    u = state[7];
	    t = state[11];
	    state[3] = state[15];
	    state[7] = v;
	    state[11] = u;
	    state[15] = t;
	    for (j = 0, k = 224; j < 16; ++j, ++k) {
	      state[j] ^= key[k];
	    }
	    return state;
	  }
	  function AES256Cipher(key) {
	    this.key = expandKey256(key);
	    this.buffer = new Uint8Array(16);
	    this.bufferPosition = 0;
	  }
	  function decryptBlock2(data, finalize) {
	    var i,
	        j,
	        ii,
	        sourceLength = data.length,
	        buffer = this.buffer,
	        bufferLength = this.bufferPosition,
	        result = [],
	        iv = this.iv;
	    for (i = 0; i < sourceLength; ++i) {
	      buffer[bufferLength] = data[i];
	      ++bufferLength;
	      if (bufferLength < 16) {
	        continue;
	      }
	      var plain = decrypt256(buffer, this.key);
	      for (j = 0; j < 16; ++j) {
	        plain[j] ^= iv[j];
	      }
	      iv = buffer;
	      result.push(plain);
	      buffer = new Uint8Array(16);
	      bufferLength = 0;
	    }
	    this.buffer = buffer;
	    this.bufferLength = bufferLength;
	    this.iv = iv;
	    if (result.length === 0) {
	      return new Uint8Array([]);
	    }
	    var outputLength = 16 * result.length;
	    if (finalize) {
	      var lastBlock = result[result.length - 1];
	      var psLen = lastBlock[15];
	      if (psLen <= 16) {
	        for (i = 15, ii = 16 - psLen; i >= ii; --i) {
	          if (lastBlock[i] !== psLen) {
	            psLen = 0;
	            break;
	          }
	        }
	        outputLength -= psLen;
	        result[result.length - 1] = lastBlock.subarray(0, 16 - psLen);
	      }
	    }
	    var output = new Uint8Array(outputLength);
	    for (i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16) {
	      output.set(result[i], j);
	    }
	    return output;
	  }
	  AES256Cipher.prototype = {
	    decryptBlock: function AES256Cipher_decryptBlock(data, finalize, iv) {
	      var i,
	          sourceLength = data.length;
	      var buffer = this.buffer,
	          bufferLength = this.bufferPosition;
	      if (iv) {
	        this.iv = iv;
	      } else {
	        for (i = 0; bufferLength < 16 && i < sourceLength; ++i, ++bufferLength) {
	          buffer[bufferLength] = data[i];
	        }
	        if (bufferLength < 16) {
	          this.bufferLength = bufferLength;
	          return new Uint8Array([]);
	        }
	        this.iv = buffer;
	        data = data.subarray(16);
	      }
	      this.buffer = new Uint8Array(16);
	      this.bufferLength = 0;
	      this.decryptBlock = decryptBlock2;
	      return this.decryptBlock(data, finalize);
	    },
	    encrypt: function AES256Cipher_encrypt(data, iv) {
	      var i,
	          j,
	          ii,
	          sourceLength = data.length,
	          buffer = this.buffer,
	          bufferLength = this.bufferPosition,
	          result = [];
	      if (!iv) {
	        iv = new Uint8Array(16);
	      }
	      for (i = 0; i < sourceLength; ++i) {
	        buffer[bufferLength] = data[i];
	        ++bufferLength;
	        if (bufferLength < 16) {
	          continue;
	        }
	        for (j = 0; j < 16; ++j) {
	          buffer[j] ^= iv[j];
	        }
	        var cipher = encrypt256(buffer, this.key);
	        this.iv = cipher;
	        result.push(cipher);
	        buffer = new Uint8Array(16);
	        bufferLength = 0;
	      }
	      this.buffer = buffer;
	      this.bufferLength = bufferLength;
	      this.iv = iv;
	      if (result.length === 0) {
	        return new Uint8Array([]);
	      }
	      var outputLength = 16 * result.length;
	      var output = new Uint8Array(outputLength);
	      for (i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16) {
	        output.set(result[i], j);
	      }
	      return output;
	    }
	  };
	  return AES256Cipher;
	}();
	var PDF17 = function PDF17Closure() {
	  function compareByteArrays(array1, array2) {
	    if (array1.length !== array2.length) {
	      return false;
	    }
	    for (var i = 0; i < array1.length; i++) {
	      if (array1[i] !== array2[i]) {
	        return false;
	      }
	    }
	    return true;
	  }
	  function PDF17() {}
	  PDF17.prototype = {
	    checkOwnerPassword: function PDF17_checkOwnerPassword(password, ownerValidationSalt, userBytes, ownerPassword) {
	      var hashData = new Uint8Array(password.length + 56);
	      hashData.set(password, 0);
	      hashData.set(ownerValidationSalt, password.length);
	      hashData.set(userBytes, password.length + ownerValidationSalt.length);
	      var result = calculateSHA256(hashData, 0, hashData.length);
	      return compareByteArrays(result, ownerPassword);
	    },
	    checkUserPassword: function PDF17_checkUserPassword(password, userValidationSalt, userPassword) {
	      var hashData = new Uint8Array(password.length + 8);
	      hashData.set(password, 0);
	      hashData.set(userValidationSalt, password.length);
	      var result = calculateSHA256(hashData, 0, hashData.length);
	      return compareByteArrays(result, userPassword);
	    },
	    getOwnerKey: function PDF17_getOwnerKey(password, ownerKeySalt, userBytes, ownerEncryption) {
	      var hashData = new Uint8Array(password.length + 56);
	      hashData.set(password, 0);
	      hashData.set(ownerKeySalt, password.length);
	      hashData.set(userBytes, password.length + ownerKeySalt.length);
	      var key = calculateSHA256(hashData, 0, hashData.length);
	      var cipher = new AES256Cipher(key);
	      return cipher.decryptBlock(ownerEncryption, false, new Uint8Array(16));
	    },
	    getUserKey: function PDF17_getUserKey(password, userKeySalt, userEncryption) {
	      var hashData = new Uint8Array(password.length + 8);
	      hashData.set(password, 0);
	      hashData.set(userKeySalt, password.length);
	      var key = calculateSHA256(hashData, 0, hashData.length);
	      var cipher = new AES256Cipher(key);
	      return cipher.decryptBlock(userEncryption, false, new Uint8Array(16));
	    }
	  };
	  return PDF17;
	}();
	var PDF20 = function PDF20Closure() {
	  function concatArrays(array1, array2) {
	    var t = new Uint8Array(array1.length + array2.length);
	    t.set(array1, 0);
	    t.set(array2, array1.length);
	    return t;
	  }
	  function calculatePDF20Hash(password, input, userBytes) {
	    var k = calculateSHA256(input, 0, input.length).subarray(0, 32);
	    var e = [0];
	    var i = 0;
	    while (i < 64 || e[e.length - 1] > i - 32) {
	      var arrayLength = password.length + k.length + userBytes.length;
	      var k1 = new Uint8Array(arrayLength * 64);
	      var array = concatArrays(password, k);
	      array = concatArrays(array, userBytes);
	      for (var j = 0, pos = 0; j < 64; j++, pos += arrayLength) {
	        k1.set(array, pos);
	      }
	      var cipher = new AES128Cipher(k.subarray(0, 16));
	      e = cipher.encrypt(k1, k.subarray(16, 32));
	      var remainder = 0;
	      for (var z = 0; z < 16; z++) {
	        remainder *= 256 % 3;
	        remainder %= 3;
	        remainder += (e[z] >>> 0) % 3;
	        remainder %= 3;
	      }
	      if (remainder === 0) {
	        k = calculateSHA256(e, 0, e.length);
	      } else if (remainder === 1) {
	        k = calculateSHA384(e, 0, e.length);
	      } else if (remainder === 2) {
	        k = calculateSHA512(e, 0, e.length);
	      }
	      i++;
	    }
	    return k.subarray(0, 32);
	  }
	  function PDF20() {}
	  function compareByteArrays(array1, array2) {
	    if (array1.length !== array2.length) {
	      return false;
	    }
	    for (var i = 0; i < array1.length; i++) {
	      if (array1[i] !== array2[i]) {
	        return false;
	      }
	    }
	    return true;
	  }
	  PDF20.prototype = {
	    hash: function PDF20_hash(password, concatBytes, userBytes) {
	      return calculatePDF20Hash(password, concatBytes, userBytes);
	    },
	    checkOwnerPassword: function PDF20_checkOwnerPassword(password, ownerValidationSalt, userBytes, ownerPassword) {
	      var hashData = new Uint8Array(password.length + 56);
	      hashData.set(password, 0);
	      hashData.set(ownerValidationSalt, password.length);
	      hashData.set(userBytes, password.length + ownerValidationSalt.length);
	      var result = calculatePDF20Hash(password, hashData, userBytes);
	      return compareByteArrays(result, ownerPassword);
	    },
	    checkUserPassword: function PDF20_checkUserPassword(password, userValidationSalt, userPassword) {
	      var hashData = new Uint8Array(password.length + 8);
	      hashData.set(password, 0);
	      hashData.set(userValidationSalt, password.length);
	      var result = calculatePDF20Hash(password, hashData, []);
	      return compareByteArrays(result, userPassword);
	    },
	    getOwnerKey: function PDF20_getOwnerKey(password, ownerKeySalt, userBytes, ownerEncryption) {
	      var hashData = new Uint8Array(password.length + 56);
	      hashData.set(password, 0);
	      hashData.set(ownerKeySalt, password.length);
	      hashData.set(userBytes, password.length + ownerKeySalt.length);
	      var key = calculatePDF20Hash(password, hashData, userBytes);
	      var cipher = new AES256Cipher(key);
	      return cipher.decryptBlock(ownerEncryption, false, new Uint8Array(16));
	    },
	    getUserKey: function PDF20_getUserKey(password, userKeySalt, userEncryption) {
	      var hashData = new Uint8Array(password.length + 8);
	      hashData.set(password, 0);
	      hashData.set(userKeySalt, password.length);
	      var key = calculatePDF20Hash(password, hashData, []);
	      var cipher = new AES256Cipher(key);
	      return cipher.decryptBlock(userEncryption, false, new Uint8Array(16));
	    }
	  };
	  return PDF20;
	}();
	var CipherTransform = function CipherTransformClosure() {
	  function CipherTransform(stringCipherConstructor, streamCipherConstructor) {
	    this.StringCipherConstructor = stringCipherConstructor;
	    this.StreamCipherConstructor = streamCipherConstructor;
	  }
	  CipherTransform.prototype = {
	    createStream: function CipherTransform_createStream(stream, length) {
	      var cipher = new this.StreamCipherConstructor();
	      return new _stream.DecryptStream(stream, length, function cipherTransformDecryptStream(data, finalize) {
	        return cipher.decryptBlock(data, finalize);
	      });
	    },
	    decryptString: function CipherTransform_decryptString(s) {
	      var cipher = new this.StringCipherConstructor();
	      var data = (0, _util.stringToBytes)(s);
	      data = cipher.decryptBlock(data, true);
	      return (0, _util.bytesToString)(data);
	    }
	  };
	  return CipherTransform;
	}();
	var CipherTransformFactory = function CipherTransformFactoryClosure() {
	  var defaultPasswordBytes = new Uint8Array([0x28, 0xBF, 0x4E, 0x5E, 0x4E, 0x75, 0x8A, 0x41, 0x64, 0x00, 0x4E, 0x56, 0xFF, 0xFA, 0x01, 0x08, 0x2E, 0x2E, 0x00, 0xB6, 0xD0, 0x68, 0x3E, 0x80, 0x2F, 0x0C, 0xA9, 0xFE, 0x64, 0x53, 0x69, 0x7A]);
	  function createEncryptionKey20(revision, password, ownerPassword, ownerValidationSalt, ownerKeySalt, uBytes, userPassword, userValidationSalt, userKeySalt, ownerEncryption, userEncryption, perms) {
	    if (password) {
	      var passwordLength = Math.min(127, password.length);
	      password = password.subarray(0, passwordLength);
	    } else {
	      password = [];
	    }
	    var pdfAlgorithm;
	    if (revision === 6) {
	      pdfAlgorithm = new PDF20();
	    } else {
	      pdfAlgorithm = new PDF17();
	    }
	    if (pdfAlgorithm.checkUserPassword(password, userValidationSalt, userPassword)) {
	      return pdfAlgorithm.getUserKey(password, userKeySalt, userEncryption);
	    } else if (password.length && pdfAlgorithm.checkOwnerPassword(password, ownerValidationSalt, uBytes, ownerPassword)) {
	      return pdfAlgorithm.getOwnerKey(password, ownerKeySalt, uBytes, ownerEncryption);
	    }
	    return null;
	  }
	  function prepareKeyData(fileId, password, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata) {
	    var hashDataSize = 40 + ownerPassword.length + fileId.length;
	    var hashData = new Uint8Array(hashDataSize),
	        i = 0,
	        j,
	        n;
	    if (password) {
	      n = Math.min(32, password.length);
	      for (; i < n; ++i) {
	        hashData[i] = password[i];
	      }
	    }
	    j = 0;
	    while (i < 32) {
	      hashData[i++] = defaultPasswordBytes[j++];
	    }
	    for (j = 0, n = ownerPassword.length; j < n; ++j) {
	      hashData[i++] = ownerPassword[j];
	    }
	    hashData[i++] = flags & 0xFF;
	    hashData[i++] = flags >> 8 & 0xFF;
	    hashData[i++] = flags >> 16 & 0xFF;
	    hashData[i++] = flags >>> 24 & 0xFF;
	    for (j = 0, n = fileId.length; j < n; ++j) {
	      hashData[i++] = fileId[j];
	    }
	    if (revision >= 4 && !encryptMetadata) {
	      hashData[i++] = 0xFF;
	      hashData[i++] = 0xFF;
	      hashData[i++] = 0xFF;
	      hashData[i++] = 0xFF;
	    }
	    var hash = calculateMD5(hashData, 0, i);
	    var keyLengthInBytes = keyLength >> 3;
	    if (revision >= 3) {
	      for (j = 0; j < 50; ++j) {
	        hash = calculateMD5(hash, 0, keyLengthInBytes);
	      }
	    }
	    var encryptionKey = hash.subarray(0, keyLengthInBytes);
	    var cipher, checkData;
	    if (revision >= 3) {
	      for (i = 0; i < 32; ++i) {
	        hashData[i] = defaultPasswordBytes[i];
	      }
	      for (j = 0, n = fileId.length; j < n; ++j) {
	        hashData[i++] = fileId[j];
	      }
	      cipher = new ARCFourCipher(encryptionKey);
	      checkData = cipher.encryptBlock(calculateMD5(hashData, 0, i));
	      n = encryptionKey.length;
	      var derivedKey = new Uint8Array(n),
	          k;
	      for (j = 1; j <= 19; ++j) {
	        for (k = 0; k < n; ++k) {
	          derivedKey[k] = encryptionKey[k] ^ j;
	        }
	        cipher = new ARCFourCipher(derivedKey);
	        checkData = cipher.encryptBlock(checkData);
	      }
	      for (j = 0, n = checkData.length; j < n; ++j) {
	        if (userPassword[j] !== checkData[j]) {
	          return null;
	        }
	      }
	    } else {
	      cipher = new ARCFourCipher(encryptionKey);
	      checkData = cipher.encryptBlock(defaultPasswordBytes);
	      for (j = 0, n = checkData.length; j < n; ++j) {
	        if (userPassword[j] !== checkData[j]) {
	          return null;
	        }
	      }
	    }
	    return encryptionKey;
	  }
	  function decodeUserPassword(password, ownerPassword, revision, keyLength) {
	    var hashData = new Uint8Array(32),
	        i = 0,
	        j,
	        n;
	    n = Math.min(32, password.length);
	    for (; i < n; ++i) {
	      hashData[i] = password[i];
	    }
	    j = 0;
	    while (i < 32) {
	      hashData[i++] = defaultPasswordBytes[j++];
	    }
	    var hash = calculateMD5(hashData, 0, i);
	    var keyLengthInBytes = keyLength >> 3;
	    if (revision >= 3) {
	      for (j = 0; j < 50; ++j) {
	        hash = calculateMD5(hash, 0, hash.length);
	      }
	    }
	    var cipher, userPassword;
	    if (revision >= 3) {
	      userPassword = ownerPassword;
	      var derivedKey = new Uint8Array(keyLengthInBytes),
	          k;
	      for (j = 19; j >= 0; j--) {
	        for (k = 0; k < keyLengthInBytes; ++k) {
	          derivedKey[k] = hash[k] ^ j;
	        }
	        cipher = new ARCFourCipher(derivedKey);
	        userPassword = cipher.encryptBlock(userPassword);
	      }
	    } else {
	      cipher = new ARCFourCipher(hash.subarray(0, keyLengthInBytes));
	      userPassword = cipher.encryptBlock(ownerPassword);
	    }
	    return userPassword;
	  }
	  var identityName = _primitives.Name.get('Identity');
	  function CipherTransformFactory(dict, fileId, password) {
	    var filter = dict.get('Filter');
	    if (!(0, _primitives.isName)(filter, 'Standard')) {
	      throw new _util.FormatError('unknown encryption method');
	    }
	    this.dict = dict;
	    var algorithm = dict.get('V');
	    if (!Number.isInteger(algorithm) || algorithm !== 1 && algorithm !== 2 && algorithm !== 4 && algorithm !== 5) {
	      throw new _util.FormatError('unsupported encryption algorithm');
	    }
	    this.algorithm = algorithm;
	    var keyLength = dict.get('Length');
	    if (!keyLength) {
	      if (algorithm <= 3) {
	        keyLength = 40;
	      } else {
	        var cfDict = dict.get('CF');
	        var streamCryptoName = dict.get('StmF');
	        if ((0, _primitives.isDict)(cfDict) && (0, _primitives.isName)(streamCryptoName)) {
	          cfDict.suppressEncryption = true;
	          var handlerDict = cfDict.get(streamCryptoName.name);
	          keyLength = handlerDict && handlerDict.get('Length') || 128;
	          if (keyLength < 40) {
	            keyLength <<= 3;
	          }
	        }
	      }
	    }
	    if (!Number.isInteger(keyLength) || keyLength < 40 || keyLength % 8 !== 0) {
	      throw new _util.FormatError('invalid key length');
	    }
	    var ownerPassword = (0, _util.stringToBytes)(dict.get('O')).subarray(0, 32);
	    var userPassword = (0, _util.stringToBytes)(dict.get('U')).subarray(0, 32);
	    var flags = dict.get('P');
	    var revision = dict.get('R');
	    var encryptMetadata = (algorithm === 4 || algorithm === 5) && dict.get('EncryptMetadata') !== false;
	    this.encryptMetadata = encryptMetadata;
	    var fileIdBytes = (0, _util.stringToBytes)(fileId);
	    var passwordBytes;
	    if (password) {
	      if (revision === 6) {
	        try {
	          password = (0, _util.utf8StringToString)(password);
	        } catch (ex) {
	          (0, _util.warn)('CipherTransformFactory: ' + 'Unable to convert UTF8 encoded password.');
	        }
	      }
	      passwordBytes = (0, _util.stringToBytes)(password);
	    }
	    var encryptionKey;
	    if (algorithm !== 5) {
	      encryptionKey = prepareKeyData(fileIdBytes, passwordBytes, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata);
	    } else {
	      var ownerValidationSalt = (0, _util.stringToBytes)(dict.get('O')).subarray(32, 40);
	      var ownerKeySalt = (0, _util.stringToBytes)(dict.get('O')).subarray(40, 48);
	      var uBytes = (0, _util.stringToBytes)(dict.get('U')).subarray(0, 48);
	      var userValidationSalt = (0, _util.stringToBytes)(dict.get('U')).subarray(32, 40);
	      var userKeySalt = (0, _util.stringToBytes)(dict.get('U')).subarray(40, 48);
	      var ownerEncryption = (0, _util.stringToBytes)(dict.get('OE'));
	      var userEncryption = (0, _util.stringToBytes)(dict.get('UE'));
	      var perms = (0, _util.stringToBytes)(dict.get('Perms'));
	      encryptionKey = createEncryptionKey20(revision, passwordBytes, ownerPassword, ownerValidationSalt, ownerKeySalt, uBytes, userPassword, userValidationSalt, userKeySalt, ownerEncryption, userEncryption, perms);
	    }
	    if (!encryptionKey && !password) {
	      throw new _util.PasswordException('No password given', _util.PasswordResponses.NEED_PASSWORD);
	    } else if (!encryptionKey && password) {
	      var decodedPassword = decodeUserPassword(passwordBytes, ownerPassword, revision, keyLength);
	      encryptionKey = prepareKeyData(fileIdBytes, decodedPassword, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata);
	    }
	    if (!encryptionKey) {
	      throw new _util.PasswordException('Incorrect Password', _util.PasswordResponses.INCORRECT_PASSWORD);
	    }
	    this.encryptionKey = encryptionKey;
	    if (algorithm >= 4) {
	      var cf = dict.get('CF');
	      if ((0, _primitives.isDict)(cf)) {
	        cf.suppressEncryption = true;
	      }
	      this.cf = cf;
	      this.stmf = dict.get('StmF') || identityName;
	      this.strf = dict.get('StrF') || identityName;
	      this.eff = dict.get('EFF') || this.stmf;
	    }
	  }
	  function buildObjectKey(num, gen, encryptionKey, isAes) {
	    var key = new Uint8Array(encryptionKey.length + 9),
	        i,
	        n;
	    for (i = 0, n = encryptionKey.length; i < n; ++i) {
	      key[i] = encryptionKey[i];
	    }
	    key[i++] = num & 0xFF;
	    key[i++] = num >> 8 & 0xFF;
	    key[i++] = num >> 16 & 0xFF;
	    key[i++] = gen & 0xFF;
	    key[i++] = gen >> 8 & 0xFF;
	    if (isAes) {
	      key[i++] = 0x73;
	      key[i++] = 0x41;
	      key[i++] = 0x6C;
	      key[i++] = 0x54;
	    }
	    var hash = calculateMD5(key, 0, i);
	    return hash.subarray(0, Math.min(encryptionKey.length + 5, 16));
	  }
	  function buildCipherConstructor(cf, name, num, gen, key) {
	    if (!(0, _primitives.isName)(name)) {
	      throw new _util.FormatError('Invalid crypt filter name.');
	    }
	    var cryptFilter = cf.get(name.name);
	    var cfm;
	    if (cryptFilter !== null && cryptFilter !== undefined) {
	      cfm = cryptFilter.get('CFM');
	    }
	    if (!cfm || cfm.name === 'None') {
	      return function cipherTransformFactoryBuildCipherConstructorNone() {
	        return new NullCipher();
	      };
	    }
	    if (cfm.name === 'V2') {
	      return function cipherTransformFactoryBuildCipherConstructorV2() {
	        return new ARCFourCipher(buildObjectKey(num, gen, key, false));
	      };
	    }
	    if (cfm.name === 'AESV2') {
	      return function cipherTransformFactoryBuildCipherConstructorAESV2() {
	        return new AES128Cipher(buildObjectKey(num, gen, key, true));
	      };
	    }
	    if (cfm.name === 'AESV3') {
	      return function cipherTransformFactoryBuildCipherConstructorAESV3() {
	        return new AES256Cipher(key);
	      };
	    }
	    throw new _util.FormatError('Unknown crypto method');
	  }
	  CipherTransformFactory.prototype = {
	    createCipherTransform: function CipherTransformFactory_createCipherTransform(num, gen) {
	      if (this.algorithm === 4 || this.algorithm === 5) {
	        return new CipherTransform(buildCipherConstructor(this.cf, this.stmf, num, gen, this.encryptionKey), buildCipherConstructor(this.cf, this.strf, num, gen, this.encryptionKey));
	      }
	      var key = buildObjectKey(num, gen, this.encryptionKey, false);
	      var cipherConstructor = function buildCipherCipherConstructor() {
	        return new ARCFourCipher(key);
	      };
	      return new CipherTransform(cipherConstructor, cipherConstructor);
	    }
	  };
	  return CipherTransformFactory;
	}();
	exports.AES128Cipher = AES128Cipher;
	exports.AES256Cipher = AES256Cipher;
	exports.ARCFourCipher = ARCFourCipher;
	exports.CipherTransformFactory = CipherTransformFactory;
	exports.PDF17 = PDF17;
	exports.PDF20 = PDF20;
	exports.calculateMD5 = calculateMD5;
	exports.calculateSHA256 = calculateSHA256;
	exports.calculateSHA384 = calculateSHA384;
	exports.calculateSHA512 = calculateSHA512;
	
	/***/ }),
	/* 83 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PartialEvaluator = exports.OperatorList = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _cmap = __w_pdfjs_require__(148);
	
	var _stream = __w_pdfjs_require__(5);
	
	var _primitives = __w_pdfjs_require__(2);
	
	var _fonts = __w_pdfjs_require__(149);
	
	var _encodings = __w_pdfjs_require__(30);
	
	var _unicode = __w_pdfjs_require__(86);
	
	var _standard_fonts = __w_pdfjs_require__(85);
	
	var _pattern = __w_pdfjs_require__(153);
	
	var _parser = __w_pdfjs_require__(36);
	
	var _bidi = __w_pdfjs_require__(154);
	
	var _colorspace = __w_pdfjs_require__(29);
	
	var _glyphlist = __w_pdfjs_require__(49);
	
	var _metrics = __w_pdfjs_require__(155);
	
	var _function = __w_pdfjs_require__(87);
	
	var _murmurhash = __w_pdfjs_require__(157);
	
	var _image = __w_pdfjs_require__(158);
	
	var PartialEvaluator = function PartialEvaluatorClosure() {
	  var DefaultPartialEvaluatorOptions = {
	    forceDataSchema: false,
	    maxImageSize: -1,
	    disableFontFace: false,
	    nativeImageDecoderSupport: _util.NativeImageDecoding.DECODE,
	    ignoreErrors: false,
	    isEvalSupported: true
	  };
	  function NativeImageDecoder(_ref) {
	    var xref = _ref.xref,
	        resources = _ref.resources,
	        handler = _ref.handler,
	        _ref$forceDataSchema = _ref.forceDataSchema,
	        forceDataSchema = _ref$forceDataSchema === undefined ? false : _ref$forceDataSchema,
	        pdfFunctionFactory = _ref.pdfFunctionFactory;
	
	    this.xref = xref;
	    this.resources = resources;
	    this.handler = handler;
	    this.forceDataSchema = forceDataSchema;
	    this.pdfFunctionFactory = pdfFunctionFactory;
	  }
	  NativeImageDecoder.prototype = {
	    canDecode: function canDecode(image) {
	      return image instanceof _stream.JpegStream && NativeImageDecoder.isDecodable(image, this.xref, this.resources, this.pdfFunctionFactory);
	    },
	    decode: function decode(image) {
	      var dict = image.dict;
	      var colorSpace = dict.get('ColorSpace', 'CS');
	      colorSpace = _colorspace.ColorSpace.parse(colorSpace, this.xref, this.resources, this.pdfFunctionFactory);
	      var numComps = colorSpace.numComps;
	      var decodePromise = this.handler.sendWithPromise('JpegDecode', [image.getIR(this.forceDataSchema), numComps]);
	      return decodePromise.then(function (message) {
	        var data = message.data;
	        return new _stream.Stream(data, 0, data.length, image.dict);
	      });
	    }
	  };
	  NativeImageDecoder.isSupported = function (image, xref, res, pdfFunctionFactory) {
	    var dict = image.dict;
	    if (dict.has('DecodeParms') || dict.has('DP')) {
	      return false;
	    }
	    var cs = _colorspace.ColorSpace.parse(dict.get('ColorSpace', 'CS'), xref, res, pdfFunctionFactory);
	    return (cs.name === 'DeviceGray' || cs.name === 'DeviceRGB') && cs.isDefaultDecode(dict.getArray('Decode', 'D'));
	  };
	  NativeImageDecoder.isDecodable = function (image, xref, res, pdfFunctionFactory) {
	    var dict = image.dict;
	    if (dict.has('DecodeParms') || dict.has('DP')) {
	      return false;
	    }
	    var cs = _colorspace.ColorSpace.parse(dict.get('ColorSpace', 'CS'), xref, res, pdfFunctionFactory);
	    return (cs.numComps === 1 || cs.numComps === 3) && cs.isDefaultDecode(dict.getArray('Decode', 'D'));
	  };
	  function PartialEvaluator(_ref2) {
	    var _this = this;
	
	    var pdfManager = _ref2.pdfManager,
	        xref = _ref2.xref,
	        handler = _ref2.handler,
	        pageIndex = _ref2.pageIndex,
	        idFactory = _ref2.idFactory,
	        fontCache = _ref2.fontCache,
	        builtInCMapCache = _ref2.builtInCMapCache,
	        _ref2$options = _ref2.options,
	        options = _ref2$options === undefined ? null : _ref2$options,
	        pdfFunctionFactory = _ref2.pdfFunctionFactory;
	
	    this.pdfManager = pdfManager;
	    this.xref = xref;
	    this.handler = handler;
	    this.pageIndex = pageIndex;
	    this.idFactory = idFactory;
	    this.fontCache = fontCache;
	    this.builtInCMapCache = builtInCMapCache;
	    this.options = options || DefaultPartialEvaluatorOptions;
	    this.pdfFunctionFactory = pdfFunctionFactory;
	    this.fetchBuiltInCMap = function (name) {
	      var cachedCMap = _this.builtInCMapCache[name];
	      if (cachedCMap) {
	        return Promise.resolve(cachedCMap);
	      }
	      return _this.handler.sendWithPromise('FetchBuiltInCMap', { name: name }).then(function (data) {
	        if (data.compressionType !== _util.CMapCompressionType.NONE) {
	          _this.builtInCMapCache[name] = data;
	        }
	        return data;
	      });
	    };
	  }
	  var TIME_SLOT_DURATION_MS = 20;
	  var CHECK_TIME_EVERY = 100;
	  function TimeSlotManager() {
	    this.reset();
	  }
	  TimeSlotManager.prototype = {
	    check: function TimeSlotManager_check() {
	      if (++this.checked < CHECK_TIME_EVERY) {
	        return false;
	      }
	      this.checked = 0;
	      return this.endTime <= Date.now();
	    },
	    reset: function TimeSlotManager_reset() {
	      this.endTime = Date.now() + TIME_SLOT_DURATION_MS;
	      this.checked = 0;
	    }
	  };
	  function normalizeBlendMode(value) {
	    if (!(0, _primitives.isName)(value)) {
	      return 'source-over';
	    }
	    switch (value.name) {
	      case 'Normal':
	      case 'Compatible':
	        return 'source-over';
	      case 'Multiply':
	        return 'multiply';
	      case 'Screen':
	        return 'screen';
	      case 'Overlay':
	        return 'overlay';
	      case 'Darken':
	        return 'darken';
	      case 'Lighten':
	        return 'lighten';
	      case 'ColorDodge':
	        return 'color-dodge';
	      case 'ColorBurn':
	        return 'color-burn';
	      case 'HardLight':
	        return 'hard-light';
	      case 'SoftLight':
	        return 'soft-light';
	      case 'Difference':
	        return 'difference';
	      case 'Exclusion':
	        return 'exclusion';
	      case 'Hue':
	        return 'hue';
	      case 'Saturation':
	        return 'saturation';
	      case 'Color':
	        return 'color';
	      case 'Luminosity':
	        return 'luminosity';
	    }
	    (0, _util.warn)('Unsupported blend mode: ' + value.name);
	    return 'source-over';
	  }
	  var deferred = Promise.resolve();
	  var TILING_PATTERN = 1,
	      SHADING_PATTERN = 2;
	  PartialEvaluator.prototype = {
	    clone: function clone() {
	      var newOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultPartialEvaluatorOptions;
	
	      var newEvaluator = Object.create(this);
	      newEvaluator.options = newOptions;
	      return newEvaluator;
	    },
	
	    hasBlendModes: function PartialEvaluator_hasBlendModes(resources) {
	      if (!(0, _primitives.isDict)(resources)) {
	        return false;
	      }
	      var processed = Object.create(null);
	      if (resources.objId) {
	        processed[resources.objId] = true;
	      }
	      var nodes = [resources],
	          xref = this.xref;
	      while (nodes.length) {
	        var key, i, ii;
	        var node = nodes.shift();
	        var graphicStates = node.get('ExtGState');
	        if ((0, _primitives.isDict)(graphicStates)) {
	          var graphicStatesKeys = graphicStates.getKeys();
	          for (i = 0, ii = graphicStatesKeys.length; i < ii; i++) {
	            key = graphicStatesKeys[i];
	            var graphicState = graphicStates.get(key);
	            var bm = graphicState.get('BM');
	            if ((0, _primitives.isName)(bm) && bm.name !== 'Normal') {
	              return true;
	            }
	          }
	        }
	        var xObjects = node.get('XObject');
	        if (!(0, _primitives.isDict)(xObjects)) {
	          continue;
	        }
	        var xObjectsKeys = xObjects.getKeys();
	        for (i = 0, ii = xObjectsKeys.length; i < ii; i++) {
	          key = xObjectsKeys[i];
	          var xObject = xObjects.getRaw(key);
	          if ((0, _primitives.isRef)(xObject)) {
	            if (processed[xObject.toString()]) {
	              continue;
	            }
	            xObject = xref.fetch(xObject);
	          }
	          if (!(0, _primitives.isStream)(xObject)) {
	            continue;
	          }
	          if (xObject.dict.objId) {
	            if (processed[xObject.dict.objId]) {
	              continue;
	            }
	            processed[xObject.dict.objId] = true;
	          }
	          var xResources = xObject.dict.get('Resources');
	          if ((0, _primitives.isDict)(xResources) && (!xResources.objId || !processed[xResources.objId])) {
	            nodes.push(xResources);
	            if (xResources.objId) {
	              processed[xResources.objId] = true;
	            }
	          }
	        }
	      }
	      return false;
	    },
	    buildFormXObject: function PartialEvaluator_buildFormXObject(resources, xobj, smask, operatorList, task, initialState) {
	      var dict = xobj.dict;
	      var matrix = dict.getArray('Matrix');
	      var bbox = dict.getArray('BBox');
	      var group = dict.get('Group');
	      if (group) {
	        var groupOptions = {
	          matrix: matrix,
	          bbox: bbox,
	          smask: smask,
	          isolated: false,
	          knockout: false
	        };
	        var groupSubtype = group.get('S');
	        var colorSpace = null;
	        if ((0, _primitives.isName)(groupSubtype, 'Transparency')) {
	          groupOptions.isolated = group.get('I') || false;
	          groupOptions.knockout = group.get('K') || false;
	          if (group.has('CS')) {
	            colorSpace = _colorspace.ColorSpace.parse(group.get('CS'), this.xref, resources, this.pdfFunctionFactory);
	          }
	        }
	        if (smask && smask.backdrop) {
	          colorSpace = colorSpace || _colorspace.ColorSpace.singletons.rgb;
	          smask.backdrop = colorSpace.getRgb(smask.backdrop, 0);
	        }
	        operatorList.addOp(_util.OPS.beginGroup, [groupOptions]);
	      }
	      operatorList.addOp(_util.OPS.paintFormXObjectBegin, [matrix, bbox]);
	      return this.getOperatorList({
	        stream: xobj,
	        task: task,
	        resources: dict.get('Resources') || resources,
	        operatorList: operatorList,
	        initialState: initialState
	      }).then(function () {
	        operatorList.addOp(_util.OPS.paintFormXObjectEnd, []);
	        if (group) {
	          operatorList.addOp(_util.OPS.endGroup, [groupOptions]);
	        }
	      });
	    },
	    buildPaintImageXObject: function PartialEvaluator_buildPaintImageXObject(resources, image, inline, operatorList, cacheKey, imageCache) {
	      var _this2 = this;
	
	      var dict = image.dict;
	      var w = dict.get('Width', 'W');
	      var h = dict.get('Height', 'H');
	      if (!(w && (0, _util.isNum)(w)) || !(h && (0, _util.isNum)(h))) {
	        (0, _util.warn)('Image dimensions are missing, or not numbers.');
	        return;
	      }
	      var maxImageSize = this.options.maxImageSize;
	      if (maxImageSize !== -1 && w * h > maxImageSize) {
	        (0, _util.warn)('Image exceeded maximum allowed size and was removed.');
	        return;
	      }
	      var imageMask = dict.get('ImageMask', 'IM') || false;
	      var imgData, args;
	      if (imageMask) {
	        var width = dict.get('Width', 'W');
	        var height = dict.get('Height', 'H');
	        var bitStrideLength = width + 7 >> 3;
	        var imgArray = image.getBytes(bitStrideLength * height);
	        var decode = dict.getArray('Decode', 'D');
	        imgData = _image.PDFImage.createMask({
	          imgArray: imgArray,
	          width: width,
	          height: height,
	          imageIsFromDecodeStream: image instanceof _stream.DecodeStream,
	          inverseDecode: !!decode && decode[0] > 0
	        });
	        imgData.cached = true;
	        args = [imgData];
	        operatorList.addOp(_util.OPS.paintImageMaskXObject, args);
	        if (cacheKey) {
	          imageCache[cacheKey] = {
	            fn: _util.OPS.paintImageMaskXObject,
	            args: args
	          };
	        }
	        return;
	      }
	      var softMask = dict.get('SMask', 'SM') || false;
	      var mask = dict.get('Mask') || false;
	      var SMALL_IMAGE_DIMENSIONS = 200;
	      if (inline && !softMask && !mask && !(image instanceof _stream.JpegStream) && w + h < SMALL_IMAGE_DIMENSIONS) {
	        var imageObj = new _image.PDFImage({
	          xref: this.xref,
	          res: resources,
	          image: image,
	          pdfFunctionFactory: this.pdfFunctionFactory
	        });
	        imgData = imageObj.createImageData(true);
	        operatorList.addOp(_util.OPS.paintInlineImageXObject, [imgData]);
	        return;
	      }
	      var nativeImageDecoderSupport = this.options.nativeImageDecoderSupport;
	      var objId = 'img_' + this.idFactory.createObjId();
	      operatorList.addDependency(objId);
	      args = [objId, w, h];
	      if (nativeImageDecoderSupport !== _util.NativeImageDecoding.NONE && !softMask && !mask && image instanceof _stream.JpegStream && NativeImageDecoder.isSupported(image, this.xref, resources, this.pdfFunctionFactory)) {
	        operatorList.addOp(_util.OPS.paintJpegXObject, args);
	        this.handler.send('obj', [objId, this.pageIndex, 'JpegStream', image.getIR(this.options.forceDataSchema)]);
	        if (cacheKey) {
	          imageCache[cacheKey] = {
	            fn: _util.OPS.paintJpegXObject,
	            args: args
	          };
	        }
	        return;
	      }
	      var nativeImageDecoder = null;
	      if (nativeImageDecoderSupport === _util.NativeImageDecoding.DECODE && (image instanceof _stream.JpegStream || mask instanceof _stream.JpegStream || softMask instanceof _stream.JpegStream)) {
	        nativeImageDecoder = new NativeImageDecoder({
	          xref: this.xref,
	          resources: resources,
	          handler: this.handler,
	          forceDataSchema: this.options.forceDataSchema,
	          pdfFunctionFactory: this.pdfFunctionFactory
	        });
	      }
	      _image.PDFImage.buildImage({
	        handler: this.handler,
	        xref: this.xref,
	        res: resources,
	        image: image,
	        nativeDecoder: nativeImageDecoder,
	        pdfFunctionFactory: this.pdfFunctionFactory
	      }).then(function (imageObj) {
	        var imgData = imageObj.createImageData(false);
	        _this2.handler.send('obj', [objId, _this2.pageIndex, 'Image', imgData], [imgData.data.buffer]);
	      }).catch(function (reason) {
	        (0, _util.warn)('Unable to decode image: ' + reason);
	        _this2.handler.send('obj', [objId, _this2.pageIndex, 'Image', null]);
	      });
	      operatorList.addOp(_util.OPS.paintImageXObject, args);
	      if (cacheKey) {
	        imageCache[cacheKey] = {
	          fn: _util.OPS.paintImageXObject,
	          args: args
	        };
	      }
	    },
	    handleSMask: function PartialEvaluator_handleSmask(smask, resources, operatorList, task, stateManager) {
	      var smaskContent = smask.get('G');
	      var smaskOptions = {
	        subtype: smask.get('S').name,
	        backdrop: smask.get('BC')
	      };
	      var transferObj = smask.get('TR');
	      if ((0, _function.isPDFFunction)(transferObj)) {
	        var transferFn = this.pdfFunctionFactory.create(transferObj);
	        var transferMap = new Uint8Array(256);
	        var tmp = new Float32Array(1);
	        for (var i = 0; i < 256; i++) {
	          tmp[0] = i / 255;
	          transferFn(tmp, 0, tmp, 0);
	          transferMap[i] = tmp[0] * 255 | 0;
	        }
	        smaskOptions.transferMap = transferMap;
	      }
	      return this.buildFormXObject(resources, smaskContent, smaskOptions, operatorList, task, stateManager.state.clone());
	    },
	    handleTilingType: function handleTilingType(fn, args, resources, pattern, patternDict, operatorList, task) {
	      var _this3 = this;
	
	      var tilingOpList = new OperatorList();
	      var resourcesArray = [patternDict.get('Resources'), resources];
	      var patternResources = _primitives.Dict.merge(this.xref, resourcesArray);
	      return this.getOperatorList({
	        stream: pattern,
	        task: task,
	        resources: patternResources,
	        operatorList: tilingOpList
	      }).then(function () {
	        return (0, _pattern.getTilingPatternIR)({
	          fnArray: tilingOpList.fnArray,
	          argsArray: tilingOpList.argsArray
	        }, patternDict, args);
	      }).then(function (tilingPatternIR) {
	        operatorList.addDependencies(tilingOpList.dependencies);
	        operatorList.addOp(fn, tilingPatternIR);
	      }, function (reason) {
	        if (_this3.options.ignoreErrors) {
	          _this3.handler.send('UnsupportedFeature', { featureId: _util.UNSUPPORTED_FEATURES.unknown });
	          (0, _util.warn)('handleTilingType - ignoring pattern: "' + reason + '".');
	          return;
	        }
	        throw reason;
	      });
	    },
	
	    handleSetFont: function PartialEvaluator_handleSetFont(resources, fontArgs, fontRef, operatorList, task, state) {
	      var _this4 = this;
	
	      var fontName;
	      if (fontArgs) {
	        fontArgs = fontArgs.slice();
	        fontName = fontArgs[0].name;
	      }
	      return this.loadFont(fontName, fontRef, resources).then(function (translated) {
	        if (!translated.font.isType3Font) {
	          return translated;
	        }
	        return translated.loadType3Data(_this4, resources, operatorList, task).then(function () {
	          return translated;
	        }).catch(function (reason) {
	          _this4.handler.send('UnsupportedFeature', { featureId: _util.UNSUPPORTED_FEATURES.font });
	          return new TranslatedFont('g_font_error', new _fonts.ErrorFont('Type3 font load error: ' + reason), translated.font);
	        });
	      }).then(function (translated) {
	        state.font = translated.font;
	        translated.send(_this4.handler);
	        return translated.loadedName;
	      });
	    },
	    handleText: function PartialEvaluator_handleText(chars, state) {
	      var _this5 = this;
	
	      var font = state.font;
	      var glyphs = font.charsToGlyphs(chars);
	      var isAddToPathSet = !!(state.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
	      if (font.data && (isAddToPathSet || this.options.disableFontFace)) {
	        var buildPath = function buildPath(fontChar) {
	          if (!font.renderer.hasBuiltPath(fontChar)) {
	            var path = font.renderer.getPathJs(fontChar);
	            _this5.handler.send('commonobj', [font.loadedName + '_path_' + fontChar, 'FontPath', path]);
	          }
	        };
	        for (var i = 0, ii = glyphs.length; i < ii; i++) {
	          var glyph = glyphs[i];
	          buildPath(glyph.fontChar);
	          var accent = glyph.accent;
	          if (accent && accent.fontChar) {
	            buildPath(accent.fontChar);
	          }
	        }
	      }
	      return glyphs;
	    },
	    setGState: function PartialEvaluator_setGState(resources, gState, operatorList, task, stateManager) {
	      var _this6 = this;
	
	      var gStateObj = [];
	      var gStateKeys = gState.getKeys();
	      var promise = Promise.resolve();
	
	      var _loop = function _loop() {
	        var key = gStateKeys[i];
	        var value = gState.get(key);
	        switch (key) {
	          case 'Type':
	            break;
	          case 'LW':
	          case 'LC':
	          case 'LJ':
	          case 'ML':
	          case 'D':
	          case 'RI':
	          case 'FL':
	          case 'CA':
	          case 'ca':
	            gStateObj.push([key, value]);
	            break;
	          case 'Font':
	            promise = promise.then(function () {
	              return _this6.handleSetFont(resources, null, value[0], operatorList, task, stateManager.state).then(function (loadedName) {
	                operatorList.addDependency(loadedName);
	                gStateObj.push([key, [loadedName, value[1]]]);
	              });
	            });
	            break;
	          case 'BM':
	            gStateObj.push([key, normalizeBlendMode(value)]);
	            break;
	          case 'SMask':
	            if ((0, _primitives.isName)(value, 'None')) {
	              gStateObj.push([key, false]);
	              break;
	            }
	            if ((0, _primitives.isDict)(value)) {
	              promise = promise.then(function () {
	                return _this6.handleSMask(value, resources, operatorList, task, stateManager);
	              });
	              gStateObj.push([key, true]);
	            } else {
	              (0, _util.warn)('Unsupported SMask type');
	            }
	            break;
	          case 'OP':
	          case 'op':
	          case 'OPM':
	          case 'BG':
	          case 'BG2':
	          case 'UCR':
	          case 'UCR2':
	          case 'TR':
	          case 'TR2':
	          case 'HT':
	          case 'SM':
	          case 'SA':
	          case 'AIS':
	          case 'TK':
	            (0, _util.info)('graphic state operator ' + key);
	            break;
	          default:
	            (0, _util.info)('Unknown graphic state operator ' + key);
	            break;
	        }
	      };
	
	      for (var i = 0, ii = gStateKeys.length; i < ii; i++) {
	        _loop();
	      }
	      return promise.then(function () {
	        if (gStateObj.length > 0) {
	          operatorList.addOp(_util.OPS.setGState, [gStateObj]);
	        }
	      });
	    },
	    loadFont: function PartialEvaluator_loadFont(fontName, font, resources) {
	      var _this7 = this;
	
	      function errorFont() {
	        return Promise.resolve(new TranslatedFont('g_font_error', new _fonts.ErrorFont('Font ' + fontName + ' is not available'), font));
	      }
	      var fontRef,
	          xref = this.xref;
	      if (font) {
	        if (!(0, _primitives.isRef)(font)) {
	          throw new Error('The "font" object should be a reference.');
	        }
	        fontRef = font;
	      } else {
	        var fontRes = resources.get('Font');
	        if (fontRes) {
	          fontRef = fontRes.getRaw(fontName);
	        } else {
	          (0, _util.warn)('fontRes not available');
	          return errorFont();
	        }
	      }
	      if (!fontRef) {
	        (0, _util.warn)('fontRef not available');
	        return errorFont();
	      }
	      if (this.fontCache.has(fontRef)) {
	        return this.fontCache.get(fontRef);
	      }
	      font = xref.fetchIfRef(fontRef);
	      if (!(0, _primitives.isDict)(font)) {
	        return errorFont();
	      }
	      if (font.translated) {
	        return font.translated;
	      }
	      var fontCapability = (0, _util.createPromiseCapability)();
	      var preEvaluatedFont = this.preEvaluateFont(font);
	      var descriptor = preEvaluatedFont.descriptor;
	      var fontRefIsRef = (0, _primitives.isRef)(fontRef),
	          fontID;
	      if (fontRefIsRef) {
	        fontID = fontRef.toString();
	      }
	      if ((0, _primitives.isDict)(descriptor)) {
	        if (!descriptor.fontAliases) {
	          descriptor.fontAliases = Object.create(null);
	        }
	        var fontAliases = descriptor.fontAliases;
	        var hash = preEvaluatedFont.hash;
	        if (fontAliases[hash]) {
	          var aliasFontRef = fontAliases[hash].aliasRef;
	          if (fontRefIsRef && aliasFontRef && this.fontCache.has(aliasFontRef)) {
	            this.fontCache.putAlias(fontRef, aliasFontRef);
	            return this.fontCache.get(fontRef);
	          }
	        } else {
	          fontAliases[hash] = { fontID: _fonts.Font.getFontID() };
	        }
	        if (fontRefIsRef) {
	          fontAliases[hash].aliasRef = fontRef;
	        }
	        fontID = fontAliases[hash].fontID;
	      }
	      if (fontRefIsRef) {
	        this.fontCache.put(fontRef, fontCapability.promise);
	      } else {
	        if (!fontID) {
	          fontID = this.idFactory.createObjId();
	        }
	        this.fontCache.put('id_' + fontID, fontCapability.promise);
	      }
	      (0, _util.assert)(fontID, 'The "fontID" must be defined.');
	      font.loadedName = 'g_' + this.pdfManager.docId + '_f' + fontID;
	      font.translated = fontCapability.promise;
	      var translatedPromise;
	      try {
	        translatedPromise = this.translateFont(preEvaluatedFont);
	      } catch (e) {
	        translatedPromise = Promise.reject(e);
	      }
	      translatedPromise.then(function (translatedFont) {
	        if (translatedFont.fontType !== undefined) {
	          var xrefFontStats = xref.stats.fontTypes;
	          xrefFontStats[translatedFont.fontType] = true;
	        }
	        fontCapability.resolve(new TranslatedFont(font.loadedName, translatedFont, font));
	      }).catch(function (reason) {
	        _this7.handler.send('UnsupportedFeature', { featureId: _util.UNSUPPORTED_FEATURES.font });
	        try {
	          var descriptor = preEvaluatedFont.descriptor;
	          var fontFile3 = descriptor && descriptor.get('FontFile3');
	          var subtype = fontFile3 && fontFile3.get('Subtype');
	          var fontType = (0, _fonts.getFontType)(preEvaluatedFont.type, subtype && subtype.name);
	          var xrefFontStats = xref.stats.fontTypes;
	          xrefFontStats[fontType] = true;
	        } catch (ex) {}
	        fontCapability.resolve(new TranslatedFont(font.loadedName, new _fonts.ErrorFont(reason instanceof Error ? reason.message : reason), font));
	      });
	      return fontCapability.promise;
	    },
	    buildPath: function PartialEvaluator_buildPath(operatorList, fn, args) {
	      var lastIndex = operatorList.length - 1;
	      if (!args) {
	        args = [];
	      }
	      if (lastIndex < 0 || operatorList.fnArray[lastIndex] !== _util.OPS.constructPath) {
	        operatorList.addOp(_util.OPS.constructPath, [[fn], args]);
	      } else {
	        var opArgs = operatorList.argsArray[lastIndex];
	        opArgs[0].push(fn);
	        Array.prototype.push.apply(opArgs[1], args);
	      }
	    },
	    handleColorN: function PartialEvaluator_handleColorN(operatorList, fn, args, cs, patterns, resources, task) {
	      var patternName = args[args.length - 1];
	      var pattern;
	      if ((0, _primitives.isName)(patternName) && (pattern = patterns.get(patternName.name))) {
	        var dict = (0, _primitives.isStream)(pattern) ? pattern.dict : pattern;
	        var typeNum = dict.get('PatternType');
	        if (typeNum === TILING_PATTERN) {
	          var color = cs.base ? cs.base.getRgb(args, 0) : null;
	          return this.handleTilingType(fn, color, resources, pattern, dict, operatorList, task);
	        } else if (typeNum === SHADING_PATTERN) {
	          var shading = dict.get('Shading');
	          var matrix = dict.getArray('Matrix');
	          pattern = _pattern.Pattern.parseShading(shading, matrix, this.xref, resources, this.handler, this.pdfFunctionFactory);
	          operatorList.addOp(fn, pattern.getIR());
	          return Promise.resolve();
	        }
	        return Promise.reject(new Error('Unknown PatternType: ' + typeNum));
	      }
	      operatorList.addOp(fn, args);
	      return Promise.resolve();
	    },
	    getOperatorList: function getOperatorList(_ref3) {
	      var _this8 = this;
	
	      var stream = _ref3.stream,
	          task = _ref3.task,
	          resources = _ref3.resources,
	          operatorList = _ref3.operatorList,
	          _ref3$initialState = _ref3.initialState,
	          initialState = _ref3$initialState === undefined ? null : _ref3$initialState;
	
	      resources = resources || _primitives.Dict.empty;
	      initialState = initialState || new EvalState();
	      if (!operatorList) {
	        throw new Error('getOperatorList: missing "operatorList" parameter');
	      }
	      var self = this;
	      var xref = this.xref;
	      var imageCache = Object.create(null);
	      var xobjs = resources.get('XObject') || _primitives.Dict.empty;
	      var patterns = resources.get('Pattern') || _primitives.Dict.empty;
	      var stateManager = new StateManager(initialState);
	      var preprocessor = new EvaluatorPreprocessor(stream, xref, stateManager);
	      var timeSlotManager = new TimeSlotManager();
	      function closePendingRestoreOPS(argument) {
	        for (var i = 0, ii = preprocessor.savedStatesDepth; i < ii; i++) {
	          operatorList.addOp(_util.OPS.restore, []);
	        }
	      }
	      return new Promise(function promiseBody(resolve, reject) {
	        var next = function next(promise) {
	          promise.then(function () {
	            try {
	              promiseBody(resolve, reject);
	            } catch (ex) {
	              reject(ex);
	            }
	          }, reject);
	        };
	        task.ensureNotTerminated();
	        timeSlotManager.reset();
	        var stop,
	            operation = {},
	            i,
	            ii,
	            cs;
	        while (!(stop = timeSlotManager.check())) {
	          operation.args = null;
	          if (!preprocessor.read(operation)) {
	            break;
	          }
	          var args = operation.args;
	          var fn = operation.fn;
	          switch (fn | 0) {
	            case _util.OPS.paintXObject:
	              var name = args[0].name;
	              if (name && imageCache[name] !== undefined) {
	                operatorList.addOp(imageCache[name].fn, imageCache[name].args);
	                args = null;
	                continue;
	              }
	              next(new Promise(function (resolveXObject, rejectXObject) {
	                if (!name) {
	                  throw new _util.FormatError('XObject must be referred to by name.');
	                }
	                var xobj = xobjs.get(name);
	                if (!xobj) {
	                  operatorList.addOp(fn, args);
	                  resolveXObject();
	                  return;
	                }
	                if (!(0, _primitives.isStream)(xobj)) {
	                  throw new _util.FormatError('XObject should be a stream');
	                }
	                var type = xobj.dict.get('Subtype');
	                if (!(0, _primitives.isName)(type)) {
	                  throw new _util.FormatError('XObject should have a Name subtype');
	                }
	                if (type.name === 'Form') {
	                  stateManager.save();
	                  self.buildFormXObject(resources, xobj, null, operatorList, task, stateManager.state.clone()).then(function () {
	                    stateManager.restore();
	                    resolveXObject();
	                  }, rejectXObject);
	                  return;
	                } else if (type.name === 'Image') {
	                  self.buildPaintImageXObject(resources, xobj, false, operatorList, name, imageCache);
	                } else if (type.name === 'PS') {
	                  (0, _util.info)('Ignored XObject subtype PS');
	                } else {
	                  throw new _util.FormatError('Unhandled XObject subtype ' + type.name);
	                }
	                resolveXObject();
	              }).catch(function (reason) {
	                if (self.options.ignoreErrors) {
	                  self.handler.send('UnsupportedFeature', { featureId: _util.UNSUPPORTED_FEATURES.unknown });
	                  (0, _util.warn)('getOperatorList - ignoring XObject: "' + reason + '".');
	                  return;
	                }
	                throw reason;
	              }));
	              return;
	            case _util.OPS.setFont:
	              var fontSize = args[1];
	              next(self.handleSetFont(resources, args, null, operatorList, task, stateManager.state).then(function (loadedName) {
	                operatorList.addDependency(loadedName);
	                operatorList.addOp(_util.OPS.setFont, [loadedName, fontSize]);
	              }));
	              return;
	            case _util.OPS.endInlineImage:
	              var cacheKey = args[0].cacheKey;
	              if (cacheKey) {
	                var cacheEntry = imageCache[cacheKey];
	                if (cacheEntry !== undefined) {
	                  operatorList.addOp(cacheEntry.fn, cacheEntry.args);
	                  args = null;
	                  continue;
	                }
	              }
	              self.buildPaintImageXObject(resources, args[0], true, operatorList, cacheKey, imageCache);
	              args = null;
	              continue;
	            case _util.OPS.showText:
	              args[0] = self.handleText(args[0], stateManager.state);
	              break;
	            case _util.OPS.showSpacedText:
	              var arr = args[0];
	              var combinedGlyphs = [];
	              var arrLength = arr.length;
	              var state = stateManager.state;
	              for (i = 0; i < arrLength; ++i) {
	                var arrItem = arr[i];
	                if ((0, _util.isString)(arrItem)) {
	                  Array.prototype.push.apply(combinedGlyphs, self.handleText(arrItem, state));
	                } else if ((0, _util.isNum)(arrItem)) {
	                  combinedGlyphs.push(arrItem);
	                }
	              }
	              args[0] = combinedGlyphs;
	              fn = _util.OPS.showText;
	              break;
	            case _util.OPS.nextLineShowText:
	              operatorList.addOp(_util.OPS.nextLine);
	              args[0] = self.handleText(args[0], stateManager.state);
	              fn = _util.OPS.showText;
	              break;
	            case _util.OPS.nextLineSetSpacingShowText:
	              operatorList.addOp(_util.OPS.nextLine);
	              operatorList.addOp(_util.OPS.setWordSpacing, [args.shift()]);
	              operatorList.addOp(_util.OPS.setCharSpacing, [args.shift()]);
	              args[0] = self.handleText(args[0], stateManager.state);
	              fn = _util.OPS.showText;
	              break;
	            case _util.OPS.setTextRenderingMode:
	              stateManager.state.textRenderingMode = args[0];
	              break;
	            case _util.OPS.setFillColorSpace:
	              stateManager.state.fillColorSpace = _colorspace.ColorSpace.parse(args[0], xref, resources, self.pdfFunctionFactory);
	              continue;
	            case _util.OPS.setStrokeColorSpace:
	              stateManager.state.strokeColorSpace = _colorspace.ColorSpace.parse(args[0], xref, resources, self.pdfFunctionFactory);
	              continue;
	            case _util.OPS.setFillColor:
	              cs = stateManager.state.fillColorSpace;
	              args = cs.getRgb(args, 0);
	              fn = _util.OPS.setFillRGBColor;
	              break;
	            case _util.OPS.setStrokeColor:
	              cs = stateManager.state.strokeColorSpace;
	              args = cs.getRgb(args, 0);
	              fn = _util.OPS.setStrokeRGBColor;
	              break;
	            case _util.OPS.setFillGray:
	              stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.gray;
	              args = _colorspace.ColorSpace.singletons.gray.getRgb(args, 0);
	              fn = _util.OPS.setFillRGBColor;
	              break;
	            case _util.OPS.setStrokeGray:
	              stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.gray;
	              args = _colorspace.ColorSpace.singletons.gray.getRgb(args, 0);
	              fn = _util.OPS.setStrokeRGBColor;
	              break;
	            case _util.OPS.setFillCMYKColor:
	              stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.cmyk;
	              args = _colorspace.ColorSpace.singletons.cmyk.getRgb(args, 0);
	              fn = _util.OPS.setFillRGBColor;
	              break;
	            case _util.OPS.setStrokeCMYKColor:
	              stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.cmyk;
	              args = _colorspace.ColorSpace.singletons.cmyk.getRgb(args, 0);
	              fn = _util.OPS.setStrokeRGBColor;
	              break;
	            case _util.OPS.setFillRGBColor:
	              stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.rgb;
	              args = _colorspace.ColorSpace.singletons.rgb.getRgb(args, 0);
	              break;
	            case _util.OPS.setStrokeRGBColor:
	              stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.rgb;
	              args = _colorspace.ColorSpace.singletons.rgb.getRgb(args, 0);
	              break;
	            case _util.OPS.setFillColorN:
	              cs = stateManager.state.fillColorSpace;
	              if (cs.name === 'Pattern') {
	                next(self.handleColorN(operatorList, _util.OPS.setFillColorN, args, cs, patterns, resources, task));
	                return;
	              }
	              args = cs.getRgb(args, 0);
	              fn = _util.OPS.setFillRGBColor;
	              break;
	            case _util.OPS.setStrokeColorN:
	              cs = stateManager.state.strokeColorSpace;
	              if (cs.name === 'Pattern') {
	                next(self.handleColorN(operatorList, _util.OPS.setStrokeColorN, args, cs, patterns, resources, task));
	                return;
	              }
	              args = cs.getRgb(args, 0);
	              fn = _util.OPS.setStrokeRGBColor;
	              break;
	            case _util.OPS.shadingFill:
	              var shadingRes = resources.get('Shading');
	              if (!shadingRes) {
	                throw new _util.FormatError('No shading resource found');
	              }
	              var shading = shadingRes.get(args[0].name);
	              if (!shading) {
	                throw new _util.FormatError('No shading object found');
	              }
	              var shadingFill = _pattern.Pattern.parseShading(shading, null, xref, resources, self.handler, self.pdfFunctionFactory);
	              var patternIR = shadingFill.getIR();
	              args = [patternIR];
	              fn = _util.OPS.shadingFill;
	              break;
	            case _util.OPS.setGState:
	              var dictName = args[0];
	              var extGState = resources.get('ExtGState');
	              if (!(0, _primitives.isDict)(extGState) || !extGState.has(dictName.name)) {
	                break;
	              }
	              var gState = extGState.get(dictName.name);
	              next(self.setGState(resources, gState, operatorList, task, stateManager));
	              return;
	            case _util.OPS.moveTo:
	            case _util.OPS.lineTo:
	            case _util.OPS.curveTo:
	            case _util.OPS.curveTo2:
	            case _util.OPS.curveTo3:
	            case _util.OPS.closePath:
	              self.buildPath(operatorList, fn, args);
	              continue;
	            case _util.OPS.rectangle:
	              self.buildPath(operatorList, fn, args);
	              continue;
	            case _util.OPS.markPoint:
	            case _util.OPS.markPointProps:
	            case _util.OPS.beginMarkedContent:
	            case _util.OPS.beginMarkedContentProps:
	            case _util.OPS.endMarkedContent:
	            case _util.OPS.beginCompat:
	            case _util.OPS.endCompat:
	              continue;
	            default:
	              if (args !== null) {
	                for (i = 0, ii = args.length; i < ii; i++) {
	                  if (args[i] instanceof _primitives.Dict) {
	                    break;
	                  }
	                }
	                if (i < ii) {
	                  (0, _util.warn)('getOperatorList - ignoring operator: ' + fn);
	                  continue;
	                }
	              }
	          }
	          operatorList.addOp(fn, args);
	        }
	        if (stop) {
	          next(deferred);
	          return;
	        }
	        closePendingRestoreOPS();
	        resolve();
	      }).catch(function (reason) {
	        if (_this8.options.ignoreErrors) {
	          _this8.handler.send('UnsupportedFeature', { featureId: _util.UNSUPPORTED_FEATURES.unknown });
	          (0, _util.warn)('getOperatorList - ignoring errors during task: ' + task.name);
	          closePendingRestoreOPS();
	          return;
	        }
	        throw reason;
	      });
	    },
	    getTextContent: function getTextContent(_ref4) {
	      var _this9 = this;
	
	      var stream = _ref4.stream,
	          task = _ref4.task,
	          resources = _ref4.resources,
	          _ref4$stateManager = _ref4.stateManager,
	          stateManager = _ref4$stateManager === undefined ? null : _ref4$stateManager,
	          _ref4$normalizeWhites = _ref4.normalizeWhitespace,
	          normalizeWhitespace = _ref4$normalizeWhites === undefined ? false : _ref4$normalizeWhites,
	          _ref4$combineTextItem = _ref4.combineTextItems,
	          combineTextItems = _ref4$combineTextItem === undefined ? false : _ref4$combineTextItem,
	          sink = _ref4.sink,
	          _ref4$seenStyles = _ref4.seenStyles,
	          seenStyles = _ref4$seenStyles === undefined ? Object.create(null) : _ref4$seenStyles;
	
	      resources = resources || _primitives.Dict.empty;
	      stateManager = stateManager || new StateManager(new TextState());
	      var WhitespaceRegexp = /\s/g;
	      var textContent = {
	        items: [],
	        styles: Object.create(null)
	      };
	      var textContentItem = {
	        initialized: false,
	        str: [],
	        width: 0,
	        height: 0,
	        vertical: false,
	        lastAdvanceWidth: 0,
	        lastAdvanceHeight: 0,
	        textAdvanceScale: 0,
	        spaceWidth: 0,
	        fakeSpaceMin: Infinity,
	        fakeMultiSpaceMin: Infinity,
	        fakeMultiSpaceMax: -0,
	        textRunBreakAllowed: false,
	        transform: null,
	        fontName: null
	      };
	      var SPACE_FACTOR = 0.3;
	      var MULTI_SPACE_FACTOR = 1.5;
	      var MULTI_SPACE_FACTOR_MAX = 4;
	      var self = this;
	      var xref = this.xref;
	      var xobjs = null;
	      var skipEmptyXObjs = Object.create(null);
	      var preprocessor = new EvaluatorPreprocessor(stream, xref, stateManager);
	      var textState;
	      function ensureTextContentItem() {
	        if (textContentItem.initialized) {
	          return textContentItem;
	        }
	        var font = textState.font;
	        if (!(font.loadedName in seenStyles)) {
	          seenStyles[font.loadedName] = true;
	          textContent.styles[font.loadedName] = {
	            fontFamily: font.fallbackName,
	            ascent: font.ascent,
	            descent: font.descent,
	            vertical: font.vertical
	          };
	        }
	        textContentItem.fontName = font.loadedName;
	        var tsm = [textState.fontSize * textState.textHScale, 0, 0, textState.fontSize, 0, textState.textRise];
	        if (font.isType3Font && textState.fontMatrix !== _util.FONT_IDENTITY_MATRIX && textState.fontSize === 1) {
	          var glyphHeight = font.bbox[3] - font.bbox[1];
	          if (glyphHeight > 0) {
	            glyphHeight = glyphHeight * textState.fontMatrix[3];
	            tsm[3] *= glyphHeight;
	          }
	        }
	        var trm = _util.Util.transform(textState.ctm, _util.Util.transform(textState.textMatrix, tsm));
	        textContentItem.transform = trm;
	        if (!font.vertical) {
	          textContentItem.width = 0;
	          textContentItem.height = Math.sqrt(trm[2] * trm[2] + trm[3] * trm[3]);
	          textContentItem.vertical = false;
	        } else {
	          textContentItem.width = Math.sqrt(trm[0] * trm[0] + trm[1] * trm[1]);
	          textContentItem.height = 0;
	          textContentItem.vertical = true;
	        }
	        var a = textState.textLineMatrix[0];
	        var b = textState.textLineMatrix[1];
	        var scaleLineX = Math.sqrt(a * a + b * b);
	        a = textState.ctm[0];
	        b = textState.ctm[1];
	        var scaleCtmX = Math.sqrt(a * a + b * b);
	        textContentItem.textAdvanceScale = scaleCtmX * scaleLineX;
	        textContentItem.lastAdvanceWidth = 0;
	        textContentItem.lastAdvanceHeight = 0;
	        var spaceWidth = font.spaceWidth / 1000 * textState.fontSize;
	        if (spaceWidth) {
	          textContentItem.spaceWidth = spaceWidth;
	          textContentItem.fakeSpaceMin = spaceWidth * SPACE_FACTOR;
	          textContentItem.fakeMultiSpaceMin = spaceWidth * MULTI_SPACE_FACTOR;
	          textContentItem.fakeMultiSpaceMax = spaceWidth * MULTI_SPACE_FACTOR_MAX;
	          textContentItem.textRunBreakAllowed = !font.isMonospace;
	        } else {
	          textContentItem.spaceWidth = 0;
	          textContentItem.fakeSpaceMin = Infinity;
	          textContentItem.fakeMultiSpaceMin = Infinity;
	          textContentItem.fakeMultiSpaceMax = 0;
	          textContentItem.textRunBreakAllowed = false;
	        }
	        textContentItem.initialized = true;
	        return textContentItem;
	      }
	      function replaceWhitespace(str) {
	        var i = 0,
	            ii = str.length,
	            code;
	        while (i < ii && (code = str.charCodeAt(i)) >= 0x20 && code <= 0x7F) {
	          i++;
	        }
	        return i < ii ? str.replace(WhitespaceRegexp, ' ') : str;
	      }
	      function runBidiTransform(textChunk) {
	        var str = textChunk.str.join('');
	        var bidiResult = (0, _bidi.bidi)(str, -1, textChunk.vertical);
	        return {
	          str: normalizeWhitespace ? replaceWhitespace(bidiResult.str) : bidiResult.str,
	          dir: bidiResult.dir,
	          width: textChunk.width,
	          height: textChunk.height,
	          transform: textChunk.transform,
	          fontName: textChunk.fontName
	        };
	      }
	      function handleSetFont(fontName, fontRef) {
	        return self.loadFont(fontName, fontRef, resources).then(function (translated) {
	          textState.font = translated.font;
	          textState.fontMatrix = translated.font.fontMatrix || _util.FONT_IDENTITY_MATRIX;
	        });
	      }
	      function buildTextContentItem(chars) {
	        var font = textState.font;
	        var textChunk = ensureTextContentItem();
	        var width = 0;
	        var height = 0;
	        var glyphs = font.charsToGlyphs(chars);
	        for (var i = 0; i < glyphs.length; i++) {
	          var glyph = glyphs[i];
	          var glyphWidth = null;
	          if (font.vertical && glyph.vmetric) {
	            glyphWidth = glyph.vmetric[0];
	          } else {
	            glyphWidth = glyph.width;
	          }
	          var glyphUnicode = glyph.unicode;
	          var NormalizedUnicodes = (0, _unicode.getNormalizedUnicodes)();
	          if (NormalizedUnicodes[glyphUnicode] !== undefined) {
	            glyphUnicode = NormalizedUnicodes[glyphUnicode];
	          }
	          glyphUnicode = (0, _unicode.reverseIfRtl)(glyphUnicode);
	          var charSpacing = textState.charSpacing;
	          if (glyph.isSpace) {
	            var wordSpacing = textState.wordSpacing;
	            charSpacing += wordSpacing;
	            if (wordSpacing > 0) {
	              addFakeSpaces(wordSpacing, textChunk.str);
	            }
	          }
	          var tx = 0;
	          var ty = 0;
	          if (!font.vertical) {
	            var w0 = glyphWidth * textState.fontMatrix[0];
	            tx = (w0 * textState.fontSize + charSpacing) * textState.textHScale;
	            width += tx;
	          } else {
	            var w1 = glyphWidth * textState.fontMatrix[0];
	            ty = w1 * textState.fontSize + charSpacing;
	            height += ty;
	          }
	          textState.translateTextMatrix(tx, ty);
	          textChunk.str.push(glyphUnicode);
	        }
	        if (!font.vertical) {
	          textChunk.lastAdvanceWidth = width;
	          textChunk.width += width;
	        } else {
	          textChunk.lastAdvanceHeight = height;
	          textChunk.height += Math.abs(height);
	        }
	        return textChunk;
	      }
	      function addFakeSpaces(width, strBuf) {
	        if (width < textContentItem.fakeSpaceMin) {
	          return;
	        }
	        if (width < textContentItem.fakeMultiSpaceMin) {
	          strBuf.push(' ');
	          return;
	        }
	        var fakeSpaces = Math.round(width / textContentItem.spaceWidth);
	        while (fakeSpaces-- > 0) {
	          strBuf.push(' ');
	        }
	      }
	      function flushTextContentItem() {
	        if (!textContentItem.initialized) {
	          return;
	        }
	        textContentItem.width *= textContentItem.textAdvanceScale;
	        textContentItem.height *= textContentItem.textAdvanceScale;
	        textContent.items.push(runBidiTransform(textContentItem));
	        textContentItem.initialized = false;
	        textContentItem.str.length = 0;
	      }
	      function enqueueChunk() {
	        var length = textContent.items.length;
	        if (length > 0) {
	          sink.enqueue(textContent, length);
	          textContent.items = [];
	          textContent.styles = Object.create(null);
	        }
	      }
	      var timeSlotManager = new TimeSlotManager();
	      return new Promise(function promiseBody(resolve, reject) {
	        var next = function next(promise) {
	          enqueueChunk();
	          Promise.all([promise, sink.ready]).then(function () {
	            try {
	              promiseBody(resolve, reject);
	            } catch (ex) {
	              reject(ex);
	            }
	          }, reject);
	        };
	        task.ensureNotTerminated();
	        timeSlotManager.reset();
	        var stop,
	            operation = {},
	            args = [];
	        while (!(stop = timeSlotManager.check())) {
	          args.length = 0;
	          operation.args = args;
	          if (!preprocessor.read(operation)) {
	            break;
	          }
	          textState = stateManager.state;
	          var fn = operation.fn;
	          args = operation.args;
	          var advance, diff;
	          switch (fn | 0) {
	            case _util.OPS.setFont:
	              var fontNameArg = args[0].name,
	                  fontSizeArg = args[1];
	              if (textState.font && fontNameArg === textState.fontName && fontSizeArg === textState.fontSize) {
	                break;
	              }
	              flushTextContentItem();
	              textState.fontName = fontNameArg;
	              textState.fontSize = fontSizeArg;
	              next(handleSetFont(fontNameArg, null));
	              return;
	            case _util.OPS.setTextRise:
	              flushTextContentItem();
	              textState.textRise = args[0];
	              break;
	            case _util.OPS.setHScale:
	              flushTextContentItem();
	              textState.textHScale = args[0] / 100;
	              break;
	            case _util.OPS.setLeading:
	              flushTextContentItem();
	              textState.leading = args[0];
	              break;
	            case _util.OPS.moveText:
	              var isSameTextLine = !textState.font ? false : (textState.font.vertical ? args[0] : args[1]) === 0;
	              advance = args[0] - args[1];
	              if (combineTextItems && isSameTextLine && textContentItem.initialized && advance > 0 && advance <= textContentItem.fakeMultiSpaceMax) {
	                textState.translateTextLineMatrix(args[0], args[1]);
	                textContentItem.width += args[0] - textContentItem.lastAdvanceWidth;
	                textContentItem.height += args[1] - textContentItem.lastAdvanceHeight;
	                diff = args[0] - textContentItem.lastAdvanceWidth - (args[1] - textContentItem.lastAdvanceHeight);
	                addFakeSpaces(diff, textContentItem.str);
	                break;
	              }
	              flushTextContentItem();
	              textState.translateTextLineMatrix(args[0], args[1]);
	              textState.textMatrix = textState.textLineMatrix.slice();
	              break;
	            case _util.OPS.setLeadingMoveText:
	              flushTextContentItem();
	              textState.leading = -args[1];
	              textState.translateTextLineMatrix(args[0], args[1]);
	              textState.textMatrix = textState.textLineMatrix.slice();
	              break;
	            case _util.OPS.nextLine:
	              flushTextContentItem();
	              textState.carriageReturn();
	              break;
	            case _util.OPS.setTextMatrix:
	              advance = textState.calcTextLineMatrixAdvance(args[0], args[1], args[2], args[3], args[4], args[5]);
	              if (combineTextItems && advance !== null && textContentItem.initialized && advance.value > 0 && advance.value <= textContentItem.fakeMultiSpaceMax) {
	                textState.translateTextLineMatrix(advance.width, advance.height);
	                textContentItem.width += advance.width - textContentItem.lastAdvanceWidth;
	                textContentItem.height += advance.height - textContentItem.lastAdvanceHeight;
	                diff = advance.width - textContentItem.lastAdvanceWidth - (advance.height - textContentItem.lastAdvanceHeight);
	                addFakeSpaces(diff, textContentItem.str);
	                break;
	              }
	              flushTextContentItem();
	              textState.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
	              textState.setTextLineMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
	              break;
	            case _util.OPS.setCharSpacing:
	              textState.charSpacing = args[0];
	              break;
	            case _util.OPS.setWordSpacing:
	              textState.wordSpacing = args[0];
	              break;
	            case _util.OPS.beginText:
	              flushTextContentItem();
	              textState.textMatrix = _util.IDENTITY_MATRIX.slice();
	              textState.textLineMatrix = _util.IDENTITY_MATRIX.slice();
	              break;
	            case _util.OPS.showSpacedText:
	              var items = args[0];
	              var offset;
	              for (var j = 0, jj = items.length; j < jj; j++) {
	                if (typeof items[j] === 'string') {
	                  buildTextContentItem(items[j]);
	                } else if ((0, _util.isNum)(items[j])) {
	                  ensureTextContentItem();
	                  advance = items[j] * textState.fontSize / 1000;
	                  var breakTextRun = false;
	                  if (textState.font.vertical) {
	                    offset = advance;
	                    textState.translateTextMatrix(0, offset);
	                    breakTextRun = textContentItem.textRunBreakAllowed && advance > textContentItem.fakeMultiSpaceMax;
	                    if (!breakTextRun) {
	                      textContentItem.height += offset;
	                    }
	                  } else {
	                    advance = -advance;
	                    offset = advance * textState.textHScale;
	                    textState.translateTextMatrix(offset, 0);
	                    breakTextRun = textContentItem.textRunBreakAllowed && advance > textContentItem.fakeMultiSpaceMax;
	                    if (!breakTextRun) {
	                      textContentItem.width += offset;
	                    }
	                  }
	                  if (breakTextRun) {
	                    flushTextContentItem();
	                  } else if (advance > 0) {
	                    addFakeSpaces(advance, textContentItem.str);
	                  }
	                }
	              }
	              break;
	            case _util.OPS.showText:
	              buildTextContentItem(args[0]);
	              break;
	            case _util.OPS.nextLineShowText:
	              flushTextContentItem();
	              textState.carriageReturn();
	              buildTextContentItem(args[0]);
	              break;
	            case _util.OPS.nextLineSetSpacingShowText:
	              flushTextContentItem();
	              textState.wordSpacing = args[0];
	              textState.charSpacing = args[1];
	              textState.carriageReturn();
	              buildTextContentItem(args[2]);
	              break;
	            case _util.OPS.paintXObject:
	              flushTextContentItem();
	              if (!xobjs) {
	                xobjs = resources.get('XObject') || _primitives.Dict.empty;
	              }
	              var name = args[0].name;
	              if (name && skipEmptyXObjs[name] !== undefined) {
	                break;
	              }
	              next(new Promise(function (resolveXObject, rejectXObject) {
	                if (!name) {
	                  throw new _util.FormatError('XObject must be referred to by name.');
	                }
	                var xobj = xobjs.get(name);
	                if (!xobj) {
	                  resolveXObject();
	                  return;
	                }
	                if (!(0, _primitives.isStream)(xobj)) {
	                  throw new _util.FormatError('XObject should be a stream');
	                }
	                var type = xobj.dict.get('Subtype');
	                if (!(0, _primitives.isName)(type)) {
	                  throw new _util.FormatError('XObject should have a Name subtype');
	                }
	                if (type.name !== 'Form') {
	                  skipEmptyXObjs[name] = true;
	                  resolveXObject();
	                  return;
	                }
	                var currentState = stateManager.state.clone();
	                var xObjStateManager = new StateManager(currentState);
	                var matrix = xobj.dict.getArray('Matrix');
	                if (Array.isArray(matrix) && matrix.length === 6) {
	                  xObjStateManager.transform(matrix);
	                }
	                enqueueChunk();
	                var sinkWrapper = {
	                  enqueueInvoked: false,
	                  enqueue: function enqueue(chunk, size) {
	                    this.enqueueInvoked = true;
	                    sink.enqueue(chunk, size);
	                  },
	
	                  get desiredSize() {
	                    return sink.desiredSize;
	                  },
	                  get ready() {
	                    return sink.ready;
	                  }
	                };
	                self.getTextContent({
	                  stream: xobj,
	                  task: task,
	                  resources: xobj.dict.get('Resources') || resources,
	                  stateManager: xObjStateManager,
	                  normalizeWhitespace: normalizeWhitespace,
	                  combineTextItems: combineTextItems,
	                  sink: sinkWrapper,
	                  seenStyles: seenStyles
	                }).then(function () {
	                  if (!sinkWrapper.enqueueInvoked) {
	                    skipEmptyXObjs[name] = true;
	                  }
	                  resolveXObject();
	                }, rejectXObject);
	              }).catch(function (reason) {
	                if (reason instanceof _util.AbortException) {
	                  return;
	                }
	                if (self.options.ignoreErrors) {
	                  (0, _util.warn)('getTextContent - ignoring XObject: "' + reason + '".');
	                  return;
	                }
	                throw reason;
	              }));
	              return;
	            case _util.OPS.setGState:
	              flushTextContentItem();
	              var dictName = args[0];
	              var extGState = resources.get('ExtGState');
	              if (!(0, _primitives.isDict)(extGState) || !(0, _primitives.isName)(dictName)) {
	                break;
	              }
	              var gState = extGState.get(dictName.name);
	              if (!(0, _primitives.isDict)(gState)) {
	                break;
	              }
	              var gStateFont = gState.get('Font');
	              if (gStateFont) {
	                textState.fontName = null;
	                textState.fontSize = gStateFont[1];
	                next(handleSetFont(null, gStateFont[0]));
	                return;
	              }
	              break;
	          }
	          if (textContent.items.length >= sink.desiredSize) {
	            stop = true;
	            break;
	          }
	        }
	        if (stop) {
	          next(deferred);
	          return;
	        }
	        flushTextContentItem();
	        enqueueChunk();
	        resolve();
	      }).catch(function (reason) {
	        if (reason instanceof _util.AbortException) {
	          return;
	        }
	        if (_this9.options.ignoreErrors) {
	          (0, _util.warn)('getTextContent - ignoring errors during task: ' + task.name);
	          flushTextContentItem();
	          enqueueChunk();
	          return;
	        }
	        throw reason;
	      });
	    },
	
	    extractDataStructures: function PartialEvaluator_extractDataStructures(dict, baseDict, properties) {
	      var _this10 = this;
	
	      var xref = this.xref;
	      var toUnicode = dict.get('ToUnicode') || baseDict.get('ToUnicode');
	      var toUnicodePromise = toUnicode ? this.readToUnicode(toUnicode) : Promise.resolve(undefined);
	      if (properties.composite) {
	        var cidSystemInfo = dict.get('CIDSystemInfo');
	        if ((0, _primitives.isDict)(cidSystemInfo)) {
	          properties.cidSystemInfo = {
	            registry: cidSystemInfo.get('Registry'),
	            ordering: cidSystemInfo.get('Ordering'),
	            supplement: cidSystemInfo.get('Supplement')
	          };
	        }
	        var cidToGidMap = dict.get('CIDToGIDMap');
	        if ((0, _primitives.isStream)(cidToGidMap)) {
	          properties.cidToGidMap = this.readCidToGidMap(cidToGidMap);
	        }
	      }
	      var differences = [];
	      var baseEncodingName = null;
	      var encoding;
	      if (dict.has('Encoding')) {
	        encoding = dict.get('Encoding');
	        if ((0, _primitives.isDict)(encoding)) {
	          baseEncodingName = encoding.get('BaseEncoding');
	          baseEncodingName = (0, _primitives.isName)(baseEncodingName) ? baseEncodingName.name : null;
	          if (encoding.has('Differences')) {
	            var diffEncoding = encoding.get('Differences');
	            var index = 0;
	            for (var j = 0, jj = diffEncoding.length; j < jj; j++) {
	              var data = xref.fetchIfRef(diffEncoding[j]);
	              if ((0, _util.isNum)(data)) {
	                index = data;
	              } else if ((0, _primitives.isName)(data)) {
	                differences[index++] = data.name;
	              } else {
	                throw new _util.FormatError('Invalid entry in \'Differences\' array: ' + data);
	              }
	            }
	          }
	        } else if ((0, _primitives.isName)(encoding)) {
	          baseEncodingName = encoding.name;
	        } else {
	          throw new _util.FormatError('Encoding is not a Name nor a Dict');
	        }
	        if (baseEncodingName !== 'MacRomanEncoding' && baseEncodingName !== 'MacExpertEncoding' && baseEncodingName !== 'WinAnsiEncoding') {
	          baseEncodingName = null;
	        }
	      }
	      if (baseEncodingName) {
	        properties.defaultEncoding = (0, _encodings.getEncoding)(baseEncodingName).slice();
	      } else {
	        var isSymbolicFont = !!(properties.flags & _fonts.FontFlags.Symbolic);
	        var isNonsymbolicFont = !!(properties.flags & _fonts.FontFlags.Nonsymbolic);
	        encoding = _encodings.StandardEncoding;
	        if (properties.type === 'TrueType' && !isNonsymbolicFont) {
	          encoding = _encodings.WinAnsiEncoding;
	        }
	        if (isSymbolicFont) {
	          encoding = _encodings.MacRomanEncoding;
	          if (!properties.file) {
	            if (/Symbol/i.test(properties.name)) {
	              encoding = _encodings.SymbolSetEncoding;
	            } else if (/Dingbats/i.test(properties.name)) {
	              encoding = _encodings.ZapfDingbatsEncoding;
	            }
	          }
	        }
	        properties.defaultEncoding = encoding;
	      }
	      properties.differences = differences;
	      properties.baseEncodingName = baseEncodingName;
	      properties.hasEncoding = !!baseEncodingName || differences.length > 0;
	      properties.dict = dict;
	      return toUnicodePromise.then(function (toUnicode) {
	        properties.toUnicode = toUnicode;
	        return _this10.buildToUnicode(properties);
	      }).then(function (toUnicode) {
	        properties.toUnicode = toUnicode;
	        return properties;
	      });
	    },
	    buildToUnicode: function PartialEvaluator_buildToUnicode(properties) {
	      properties.hasIncludedToUnicodeMap = !!properties.toUnicode && properties.toUnicode.length > 0;
	      if (properties.hasIncludedToUnicodeMap) {
	        return Promise.resolve(properties.toUnicode);
	      }
	      var toUnicode, charcode, glyphName;
	      if (!properties.composite) {
	        toUnicode = [];
	        var encoding = properties.defaultEncoding.slice();
	        var baseEncodingName = properties.baseEncodingName;
	        var differences = properties.differences;
	        for (charcode in differences) {
	          glyphName = differences[charcode];
	          if (glyphName === '.notdef') {
	            continue;
	          }
	          encoding[charcode] = glyphName;
	        }
	        var glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
	        for (charcode in encoding) {
	          glyphName = encoding[charcode];
	          if (glyphName === '') {
	            continue;
	          } else if (glyphsUnicodeMap[glyphName] === undefined) {
	            var code = 0;
	            switch (glyphName[0]) {
	              case 'G':
	                if (glyphName.length === 3) {
	                  code = parseInt(glyphName.substr(1), 16);
	                }
	                break;
	              case 'g':
	                if (glyphName.length === 5) {
	                  code = parseInt(glyphName.substr(1), 16);
	                }
	                break;
	              case 'C':
	              case 'c':
	                if (glyphName.length >= 3) {
	                  code = +glyphName.substr(1);
	                }
	                break;
	              default:
	                var unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
	                if (unicode !== -1) {
	                  code = unicode;
	                }
	            }
	            if (code) {
	              if (baseEncodingName && code === +charcode) {
	                var baseEncoding = (0, _encodings.getEncoding)(baseEncodingName);
	                if (baseEncoding && (glyphName = baseEncoding[charcode])) {
	                  toUnicode[charcode] = String.fromCharCode(glyphsUnicodeMap[glyphName]);
	                  continue;
	                }
	              }
	              toUnicode[charcode] = String.fromCharCode(code);
	            }
	            continue;
	          }
	          toUnicode[charcode] = String.fromCharCode(glyphsUnicodeMap[glyphName]);
	        }
	        return Promise.resolve(new _fonts.ToUnicodeMap(toUnicode));
	      }
	      if (properties.composite && (properties.cMap.builtInCMap && !(properties.cMap instanceof _cmap.IdentityCMap) || properties.cidSystemInfo.registry === 'Adobe' && (properties.cidSystemInfo.ordering === 'GB1' || properties.cidSystemInfo.ordering === 'CNS1' || properties.cidSystemInfo.ordering === 'Japan1' || properties.cidSystemInfo.ordering === 'Korea1'))) {
	        var registry = properties.cidSystemInfo.registry;
	        var ordering = properties.cidSystemInfo.ordering;
	        var ucs2CMapName = _primitives.Name.get(registry + '-' + ordering + '-UCS2');
	        return _cmap.CMapFactory.create({
	          encoding: ucs2CMapName,
	          fetchBuiltInCMap: this.fetchBuiltInCMap,
	          useCMap: null
	        }).then(function (ucs2CMap) {
	          var cMap = properties.cMap;
	          toUnicode = [];
	          cMap.forEach(function (charcode, cid) {
	            if (cid > 0xffff) {
	              throw new _util.FormatError('Max size of CID is 65,535');
	            }
	            var ucs2 = ucs2CMap.lookup(cid);
	            if (ucs2) {
	              toUnicode[charcode] = String.fromCharCode((ucs2.charCodeAt(0) << 8) + ucs2.charCodeAt(1));
	            }
	          });
	          return new _fonts.ToUnicodeMap(toUnicode);
	        });
	      }
	      return Promise.resolve(new _fonts.IdentityToUnicodeMap(properties.firstChar, properties.lastChar));
	    },
	    readToUnicode: function PartialEvaluator_readToUnicode(toUnicode) {
	      var cmapObj = toUnicode;
	      if ((0, _primitives.isName)(cmapObj)) {
	        return _cmap.CMapFactory.create({
	          encoding: cmapObj,
	          fetchBuiltInCMap: this.fetchBuiltInCMap,
	          useCMap: null
	        }).then(function (cmap) {
	          if (cmap instanceof _cmap.IdentityCMap) {
	            return new _fonts.IdentityToUnicodeMap(0, 0xFFFF);
	          }
	          return new _fonts.ToUnicodeMap(cmap.getMap());
	        });
	      } else if ((0, _primitives.isStream)(cmapObj)) {
	        return _cmap.CMapFactory.create({
	          encoding: cmapObj,
	          fetchBuiltInCMap: this.fetchBuiltInCMap,
	          useCMap: null
	        }).then(function (cmap) {
	          if (cmap instanceof _cmap.IdentityCMap) {
	            return new _fonts.IdentityToUnicodeMap(0, 0xFFFF);
	          }
	          var map = new Array(cmap.length);
	          cmap.forEach(function (charCode, token) {
	            var str = [];
	            for (var k = 0; k < token.length; k += 2) {
	              var w1 = token.charCodeAt(k) << 8 | token.charCodeAt(k + 1);
	              if ((w1 & 0xF800) !== 0xD800) {
	                str.push(w1);
	                continue;
	              }
	              k += 2;
	              var w2 = token.charCodeAt(k) << 8 | token.charCodeAt(k + 1);
	              str.push(((w1 & 0x3ff) << 10) + (w2 & 0x3ff) + 0x10000);
	            }
	            map[charCode] = String.fromCharCode.apply(String, str);
	          });
	          return new _fonts.ToUnicodeMap(map);
	        });
	      }
	      return Promise.resolve(null);
	    },
	    readCidToGidMap: function PartialEvaluator_readCidToGidMap(cidToGidStream) {
	      var glyphsData = cidToGidStream.getBytes();
	      var result = [];
	      for (var j = 0, jj = glyphsData.length; j < jj; j++) {
	        var glyphID = glyphsData[j++] << 8 | glyphsData[j];
	        if (glyphID === 0) {
	          continue;
	        }
	        var code = j >> 1;
	        result[code] = glyphID;
	      }
	      return result;
	    },
	    extractWidths: function PartialEvaluator_extractWidths(dict, descriptor, properties) {
	      var xref = this.xref;
	      var glyphsWidths = [];
	      var defaultWidth = 0;
	      var glyphsVMetrics = [];
	      var defaultVMetrics;
	      var i, ii, j, jj, start, code, widths;
	      if (properties.composite) {
	        defaultWidth = dict.has('DW') ? dict.get('DW') : 1000;
	        widths = dict.get('W');
	        if (widths) {
	          for (i = 0, ii = widths.length; i < ii; i++) {
	            start = xref.fetchIfRef(widths[i++]);
	            code = xref.fetchIfRef(widths[i]);
	            if (Array.isArray(code)) {
	              for (j = 0, jj = code.length; j < jj; j++) {
	                glyphsWidths[start++] = xref.fetchIfRef(code[j]);
	              }
	            } else {
	              var width = xref.fetchIfRef(widths[++i]);
	              for (j = start; j <= code; j++) {
	                glyphsWidths[j] = width;
	              }
	            }
	          }
	        }
	        if (properties.vertical) {
	          var vmetrics = dict.getArray('DW2') || [880, -1000];
	          defaultVMetrics = [vmetrics[1], defaultWidth * 0.5, vmetrics[0]];
	          vmetrics = dict.get('W2');
	          if (vmetrics) {
	            for (i = 0, ii = vmetrics.length; i < ii; i++) {
	              start = xref.fetchIfRef(vmetrics[i++]);
	              code = xref.fetchIfRef(vmetrics[i]);
	              if (Array.isArray(code)) {
	                for (j = 0, jj = code.length; j < jj; j++) {
	                  glyphsVMetrics[start++] = [xref.fetchIfRef(code[j++]), xref.fetchIfRef(code[j++]), xref.fetchIfRef(code[j])];
	                }
	              } else {
	                var vmetric = [xref.fetchIfRef(vmetrics[++i]), xref.fetchIfRef(vmetrics[++i]), xref.fetchIfRef(vmetrics[++i])];
	                for (j = start; j <= code; j++) {
	                  glyphsVMetrics[j] = vmetric;
	                }
	              }
	            }
	          }
	        }
	      } else {
	        var firstChar = properties.firstChar;
	        widths = dict.get('Widths');
	        if (widths) {
	          j = firstChar;
	          for (i = 0, ii = widths.length; i < ii; i++) {
	            glyphsWidths[j++] = xref.fetchIfRef(widths[i]);
	          }
	          defaultWidth = parseFloat(descriptor.get('MissingWidth')) || 0;
	        } else {
	          var baseFontName = dict.get('BaseFont');
	          if ((0, _primitives.isName)(baseFontName)) {
	            var metrics = this.getBaseFontMetrics(baseFontName.name);
	            glyphsWidths = this.buildCharCodeToWidth(metrics.widths, properties);
	            defaultWidth = metrics.defaultWidth;
	          }
	        }
	      }
	      var isMonospace = true;
	      var firstWidth = defaultWidth;
	      for (var glyph in glyphsWidths) {
	        var glyphWidth = glyphsWidths[glyph];
	        if (!glyphWidth) {
	          continue;
	        }
	        if (!firstWidth) {
	          firstWidth = glyphWidth;
	          continue;
	        }
	        if (firstWidth !== glyphWidth) {
	          isMonospace = false;
	          break;
	        }
	      }
	      if (isMonospace) {
	        properties.flags |= _fonts.FontFlags.FixedPitch;
	      }
	      properties.defaultWidth = defaultWidth;
	      properties.widths = glyphsWidths;
	      properties.defaultVMetrics = defaultVMetrics;
	      properties.vmetrics = glyphsVMetrics;
	    },
	    isSerifFont: function PartialEvaluator_isSerifFont(baseFontName) {
	      var fontNameWoStyle = baseFontName.split('-')[0];
	      return fontNameWoStyle in (0, _standard_fonts.getSerifFonts)() || fontNameWoStyle.search(/serif/gi) !== -1;
	    },
	    getBaseFontMetrics: function PartialEvaluator_getBaseFontMetrics(name) {
	      var defaultWidth = 0;
	      var widths = [];
	      var monospace = false;
	      var stdFontMap = (0, _standard_fonts.getStdFontMap)();
	      var lookupName = stdFontMap[name] || name;
	      var Metrics = (0, _metrics.getMetrics)();
	      if (!(lookupName in Metrics)) {
	        if (this.isSerifFont(name)) {
	          lookupName = 'Times-Roman';
	        } else {
	          lookupName = 'Helvetica';
	        }
	      }
	      var glyphWidths = Metrics[lookupName];
	      if ((0, _util.isNum)(glyphWidths)) {
	        defaultWidth = glyphWidths;
	        monospace = true;
	      } else {
	        widths = glyphWidths();
	      }
	      return {
	        defaultWidth: defaultWidth,
	        monospace: monospace,
	        widths: widths
	      };
	    },
	    buildCharCodeToWidth: function PartialEvaluator_bulildCharCodeToWidth(widthsByGlyphName, properties) {
	      var widths = Object.create(null);
	      var differences = properties.differences;
	      var encoding = properties.defaultEncoding;
	      for (var charCode = 0; charCode < 256; charCode++) {
	        if (charCode in differences && widthsByGlyphName[differences[charCode]]) {
	          widths[charCode] = widthsByGlyphName[differences[charCode]];
	          continue;
	        }
	        if (charCode in encoding && widthsByGlyphName[encoding[charCode]]) {
	          widths[charCode] = widthsByGlyphName[encoding[charCode]];
	          continue;
	        }
	      }
	      return widths;
	    },
	    preEvaluateFont: function PartialEvaluator_preEvaluateFont(dict) {
	      var baseDict = dict;
	      var type = dict.get('Subtype');
	      if (!(0, _primitives.isName)(type)) {
	        throw new _util.FormatError('invalid font Subtype');
	      }
	      var composite = false;
	      var uint8array;
	      if (type.name === 'Type0') {
	        var df = dict.get('DescendantFonts');
	        if (!df) {
	          throw new _util.FormatError('Descendant fonts are not specified');
	        }
	        dict = Array.isArray(df) ? this.xref.fetchIfRef(df[0]) : df;
	        type = dict.get('Subtype');
	        if (!(0, _primitives.isName)(type)) {
	          throw new _util.FormatError('invalid font Subtype');
	        }
	        composite = true;
	      }
	      var descriptor = dict.get('FontDescriptor');
	      if (descriptor) {
	        var hash = new _murmurhash.MurmurHash3_64();
	        var encoding = baseDict.getRaw('Encoding');
	        if ((0, _primitives.isName)(encoding)) {
	          hash.update(encoding.name);
	        } else if ((0, _primitives.isRef)(encoding)) {
	          hash.update(encoding.toString());
	        } else if ((0, _primitives.isDict)(encoding)) {
	          var keys = encoding.getKeys();
	          for (var i = 0, ii = keys.length; i < ii; i++) {
	            var entry = encoding.getRaw(keys[i]);
	            if ((0, _primitives.isName)(entry)) {
	              hash.update(entry.name);
	            } else if ((0, _primitives.isRef)(entry)) {
	              hash.update(entry.toString());
	            } else if (Array.isArray(entry)) {
	              var diffLength = entry.length,
	                  diffBuf = new Array(diffLength);
	              for (var j = 0; j < diffLength; j++) {
	                var diffEntry = entry[j];
	                if ((0, _primitives.isName)(diffEntry)) {
	                  diffBuf[j] = diffEntry.name;
	                } else if ((0, _util.isNum)(diffEntry) || (0, _primitives.isRef)(diffEntry)) {
	                  diffBuf[j] = diffEntry.toString();
	                }
	              }
	              hash.update(diffBuf.join());
	            }
	          }
	        }
	        var toUnicode = dict.get('ToUnicode') || baseDict.get('ToUnicode');
	        if ((0, _primitives.isStream)(toUnicode)) {
	          var stream = toUnicode.str || toUnicode;
	          uint8array = stream.buffer ? new Uint8Array(stream.buffer.buffer, 0, stream.bufferLength) : new Uint8Array(stream.bytes.buffer, stream.start, stream.end - stream.start);
	          hash.update(uint8array);
	        } else if ((0, _primitives.isName)(toUnicode)) {
	          hash.update(toUnicode.name);
	        }
	        var widths = dict.get('Widths') || baseDict.get('Widths');
	        if (widths) {
	          uint8array = new Uint8Array(new Uint32Array(widths).buffer);
	          hash.update(uint8array);
	        }
	      }
	      return {
	        descriptor: descriptor,
	        dict: dict,
	        baseDict: baseDict,
	        composite: composite,
	        type: type.name,
	        hash: hash ? hash.hexdigest() : ''
	      };
	    },
	    translateFont: function PartialEvaluator_translateFont(preEvaluatedFont) {
	      var _this11 = this;
	
	      var baseDict = preEvaluatedFont.baseDict;
	      var dict = preEvaluatedFont.dict;
	      var composite = preEvaluatedFont.composite;
	      var descriptor = preEvaluatedFont.descriptor;
	      var type = preEvaluatedFont.type;
	      var maxCharIndex = composite ? 0xFFFF : 0xFF;
	      var properties;
	      if (!descriptor) {
	        if (type === 'Type3') {
	          descriptor = new _primitives.Dict(null);
	          descriptor.set('FontName', _primitives.Name.get(type));
	          descriptor.set('FontBBox', dict.getArray('FontBBox'));
	        } else {
	          var baseFontName = dict.get('BaseFont');
	          if (!(0, _primitives.isName)(baseFontName)) {
	            throw new _util.FormatError('Base font is not specified');
	          }
	          baseFontName = baseFontName.name.replace(/[,_]/g, '-');
	          var metrics = this.getBaseFontMetrics(baseFontName);
	          var fontNameWoStyle = baseFontName.split('-')[0];
	          var flags = (this.isSerifFont(fontNameWoStyle) ? _fonts.FontFlags.Serif : 0) | (metrics.monospace ? _fonts.FontFlags.FixedPitch : 0) | ((0, _standard_fonts.getSymbolsFonts)()[fontNameWoStyle] ? _fonts.FontFlags.Symbolic : _fonts.FontFlags.Nonsymbolic);
	          properties = {
	            type: type,
	            name: baseFontName,
	            widths: metrics.widths,
	            defaultWidth: metrics.defaultWidth,
	            flags: flags,
	            firstChar: 0,
	            lastChar: maxCharIndex
	          };
	          return this.extractDataStructures(dict, dict, properties).then(function (properties) {
	            properties.widths = _this11.buildCharCodeToWidth(metrics.widths, properties);
	            return new _fonts.Font(baseFontName, null, properties);
	          });
	        }
	      }
	      var firstChar = dict.get('FirstChar') || 0;
	      var lastChar = dict.get('LastChar') || maxCharIndex;
	      var fontName = descriptor.get('FontName');
	      var baseFont = dict.get('BaseFont');
	      if ((0, _util.isString)(fontName)) {
	        fontName = _primitives.Name.get(fontName);
	      }
	      if ((0, _util.isString)(baseFont)) {
	        baseFont = _primitives.Name.get(baseFont);
	      }
	      if (type !== 'Type3') {
	        var fontNameStr = fontName && fontName.name;
	        var baseFontStr = baseFont && baseFont.name;
	        if (fontNameStr !== baseFontStr) {
	          (0, _util.info)('The FontDescriptor\'s FontName is "' + fontNameStr + '" but should be the same as the Font\'s BaseFont "' + baseFontStr + '"');
	          if (fontNameStr && baseFontStr && baseFontStr.indexOf(fontNameStr) === 0) {
	            fontName = baseFont;
	          }
	        }
	      }
	      fontName = fontName || baseFont;
	      if (!(0, _primitives.isName)(fontName)) {
	        throw new _util.FormatError('invalid font name');
	      }
	      var fontFile = descriptor.get('FontFile', 'FontFile2', 'FontFile3');
	      if (fontFile) {
	        if (fontFile.dict) {
	          var subtype = fontFile.dict.get('Subtype');
	          if (subtype) {
	            subtype = subtype.name;
	          }
	          var length1 = fontFile.dict.get('Length1');
	          var length2 = fontFile.dict.get('Length2');
	          var length3 = fontFile.dict.get('Length3');
	        }
	      }
	      properties = {
	        type: type,
	        name: fontName.name,
	        subtype: subtype,
	        file: fontFile,
	        length1: length1,
	        length2: length2,
	        length3: length3,
	        loadedName: baseDict.loadedName,
	        composite: composite,
	        wideChars: composite,
	        fixedPitch: false,
	        fontMatrix: dict.getArray('FontMatrix') || _util.FONT_IDENTITY_MATRIX,
	        firstChar: firstChar || 0,
	        lastChar: lastChar || maxCharIndex,
	        bbox: descriptor.getArray('FontBBox'),
	        ascent: descriptor.get('Ascent'),
	        descent: descriptor.get('Descent'),
	        xHeight: descriptor.get('XHeight'),
	        capHeight: descriptor.get('CapHeight'),
	        flags: descriptor.get('Flags'),
	        italicAngle: descriptor.get('ItalicAngle'),
	        isType3Font: false
	      };
	      var cMapPromise;
	      if (composite) {
	        var cidEncoding = baseDict.get('Encoding');
	        if ((0, _primitives.isName)(cidEncoding)) {
	          properties.cidEncoding = cidEncoding.name;
	        }
	        cMapPromise = _cmap.CMapFactory.create({
	          encoding: cidEncoding,
	          fetchBuiltInCMap: this.fetchBuiltInCMap,
	          useCMap: null
	        }).then(function (cMap) {
	          properties.cMap = cMap;
	          properties.vertical = properties.cMap.vertical;
	        });
	      } else {
	        cMapPromise = Promise.resolve(undefined);
	      }
	      return cMapPromise.then(function () {
	        return _this11.extractDataStructures(dict, baseDict, properties);
	      }).then(function (properties) {
	        _this11.extractWidths(dict, descriptor, properties);
	        if (type === 'Type3') {
	          properties.isType3Font = true;
	        }
	        return new _fonts.Font(fontName.name, fontFile, properties);
	      });
	    }
	  };
	  return PartialEvaluator;
	}();
	var TranslatedFont = function TranslatedFontClosure() {
	  function TranslatedFont(loadedName, font, dict) {
	    this.loadedName = loadedName;
	    this.font = font;
	    this.dict = dict;
	    this.type3Loaded = null;
	    this.sent = false;
	  }
	  TranslatedFont.prototype = {
	    send: function send(handler) {
	      if (this.sent) {
	        return;
	      }
	      var fontData = this.font.exportData();
	      handler.send('commonobj', [this.loadedName, 'Font', fontData]);
	      this.sent = true;
	    },
	    loadType3Data: function loadType3Data(evaluator, resources, parentOperatorList, task) {
	      if (!this.font.isType3Font) {
	        throw new Error('Must be a Type3 font.');
	      }
	      if (this.type3Loaded) {
	        return this.type3Loaded;
	      }
	      var type3Options = Object.create(evaluator.options);
	      type3Options.ignoreErrors = false;
	      var type3Evaluator = evaluator.clone(type3Options);
	      var translatedFont = this.font;
	      var loadCharProcsPromise = Promise.resolve();
	      var charProcs = this.dict.get('CharProcs');
	      var fontResources = this.dict.get('Resources') || resources;
	      var charProcKeys = charProcs.getKeys();
	      var charProcOperatorList = Object.create(null);
	
	      var _loop2 = function _loop2() {
	        var key = charProcKeys[i];
	        loadCharProcsPromise = loadCharProcsPromise.then(function () {
	          var glyphStream = charProcs.get(key);
	          var operatorList = new OperatorList();
	          return type3Evaluator.getOperatorList({
	            stream: glyphStream,
	            task: task,
	            resources: fontResources,
	            operatorList: operatorList
	          }).then(function () {
	            charProcOperatorList[key] = operatorList.getIR();
	            parentOperatorList.addDependencies(operatorList.dependencies);
	          }).catch(function (reason) {
	            (0, _util.warn)('Type3 font resource "' + key + '" is not available.');
	            var operatorList = new OperatorList();
	            charProcOperatorList[key] = operatorList.getIR();
	          });
	        });
	      };
	
	      for (var i = 0, n = charProcKeys.length; i < n; ++i) {
	        _loop2();
	      }
	      this.type3Loaded = loadCharProcsPromise.then(function () {
	        translatedFont.charProcOperatorList = charProcOperatorList;
	      });
	      return this.type3Loaded;
	    }
	  };
	  return TranslatedFont;
	}();
	var OperatorList = function OperatorListClosure() {
	  var CHUNK_SIZE = 1000;
	  var CHUNK_SIZE_ABOUT = CHUNK_SIZE - 5;
	  function getTransfers(queue) {
	    var transfers = [];
	    var fnArray = queue.fnArray,
	        argsArray = queue.argsArray;
	    for (var i = 0, ii = queue.length; i < ii; i++) {
	      switch (fnArray[i]) {
	        case _util.OPS.paintInlineImageXObject:
	        case _util.OPS.paintInlineImageXObjectGroup:
	        case _util.OPS.paintImageMaskXObject:
	          var arg = argsArray[i][0];
	          if (!arg.cached) {
	            transfers.push(arg.data.buffer);
	          }
	          break;
	      }
	    }
	    return transfers;
	  }
	  function OperatorList(intent, messageHandler, pageIndex) {
	    this.messageHandler = messageHandler;
	    this.fnArray = [];
	    this.argsArray = [];
	    this.dependencies = Object.create(null);
	    this._totalLength = 0;
	    this.pageIndex = pageIndex;
	    this.intent = intent;
	  }
	  OperatorList.prototype = {
	    get length() {
	      return this.argsArray.length;
	    },
	    get totalLength() {
	      return this._totalLength + this.length;
	    },
	    addOp: function addOp(fn, args) {
	      this.fnArray.push(fn);
	      this.argsArray.push(args);
	      if (this.messageHandler) {
	        if (this.fnArray.length >= CHUNK_SIZE) {
	          this.flush();
	        } else if (this.fnArray.length >= CHUNK_SIZE_ABOUT && (fn === _util.OPS.restore || fn === _util.OPS.endText)) {
	          this.flush();
	        }
	      }
	    },
	    addDependency: function addDependency(dependency) {
	      if (dependency in this.dependencies) {
	        return;
	      }
	      this.dependencies[dependency] = true;
	      this.addOp(_util.OPS.dependency, [dependency]);
	    },
	    addDependencies: function addDependencies(dependencies) {
	      for (var key in dependencies) {
	        this.addDependency(key);
	      }
	    },
	    addOpList: function addOpList(opList) {
	      _util.Util.extendObj(this.dependencies, opList.dependencies);
	      for (var i = 0, ii = opList.length; i < ii; i++) {
	        this.addOp(opList.fnArray[i], opList.argsArray[i]);
	      }
	    },
	    getIR: function getIR() {
	      return {
	        fnArray: this.fnArray,
	        argsArray: this.argsArray,
	        length: this.length
	      };
	    },
	    flush: function flush(lastChunk) {
	      if (this.intent !== 'oplist') {
	        new QueueOptimizer().optimize(this);
	      }
	      var transfers = getTransfers(this);
	      var length = this.length;
	      this._totalLength += length;
	      this.messageHandler.send('RenderPageChunk', {
	        operatorList: {
	          fnArray: this.fnArray,
	          argsArray: this.argsArray,
	          lastChunk: lastChunk,
	          length: length
	        },
	        pageIndex: this.pageIndex,
	        intent: this.intent
	      }, transfers);
	      this.dependencies = Object.create(null);
	      this.fnArray.length = 0;
	      this.argsArray.length = 0;
	    }
	  };
	  return OperatorList;
	}();
	var StateManager = function StateManagerClosure() {
	  function StateManager(initialState) {
	    this.state = initialState;
	    this.stateStack = [];
	  }
	  StateManager.prototype = {
	    save: function save() {
	      var old = this.state;
	      this.stateStack.push(this.state);
	      this.state = old.clone();
	    },
	    restore: function restore() {
	      var prev = this.stateStack.pop();
	      if (prev) {
	        this.state = prev;
	      }
	    },
	    transform: function transform(args) {
	      this.state.ctm = _util.Util.transform(this.state.ctm, args);
	    }
	  };
	  return StateManager;
	}();
	var TextState = function TextStateClosure() {
	  function TextState() {
	    this.ctm = new Float32Array(_util.IDENTITY_MATRIX);
	    this.fontName = null;
	    this.fontSize = 0;
	    this.font = null;
	    this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
	    this.textMatrix = _util.IDENTITY_MATRIX.slice();
	    this.textLineMatrix = _util.IDENTITY_MATRIX.slice();
	    this.charSpacing = 0;
	    this.wordSpacing = 0;
	    this.leading = 0;
	    this.textHScale = 1;
	    this.textRise = 0;
	  }
	  TextState.prototype = {
	    setTextMatrix: function TextState_setTextMatrix(a, b, c, d, e, f) {
	      var m = this.textMatrix;
	      m[0] = a;
	      m[1] = b;
	      m[2] = c;
	      m[3] = d;
	      m[4] = e;
	      m[5] = f;
	    },
	    setTextLineMatrix: function TextState_setTextMatrix(a, b, c, d, e, f) {
	      var m = this.textLineMatrix;
	      m[0] = a;
	      m[1] = b;
	      m[2] = c;
	      m[3] = d;
	      m[4] = e;
	      m[5] = f;
	    },
	    translateTextMatrix: function TextState_translateTextMatrix(x, y) {
	      var m = this.textMatrix;
	      m[4] = m[0] * x + m[2] * y + m[4];
	      m[5] = m[1] * x + m[3] * y + m[5];
	    },
	    translateTextLineMatrix: function TextState_translateTextMatrix(x, y) {
	      var m = this.textLineMatrix;
	      m[4] = m[0] * x + m[2] * y + m[4];
	      m[5] = m[1] * x + m[3] * y + m[5];
	    },
	    calcTextLineMatrixAdvance: function TextState_calcTextLineMatrixAdvance(a, b, c, d, e, f) {
	      var font = this.font;
	      if (!font) {
	        return null;
	      }
	      var m = this.textLineMatrix;
	      if (!(a === m[0] && b === m[1] && c === m[2] && d === m[3])) {
	        return null;
	      }
	      var txDiff = e - m[4],
	          tyDiff = f - m[5];
	      if (font.vertical && txDiff !== 0 || !font.vertical && tyDiff !== 0) {
	        return null;
	      }
	      var tx,
	          ty,
	          denominator = a * d - b * c;
	      if (font.vertical) {
	        tx = -tyDiff * c / denominator;
	        ty = tyDiff * a / denominator;
	      } else {
	        tx = txDiff * d / denominator;
	        ty = -txDiff * b / denominator;
	      }
	      return {
	        width: tx,
	        height: ty,
	        value: font.vertical ? ty : tx
	      };
	    },
	    calcRenderMatrix: function TextState_calcRendeMatrix(ctm) {
	      var tsm = [this.fontSize * this.textHScale, 0, 0, this.fontSize, 0, this.textRise];
	      return _util.Util.transform(ctm, _util.Util.transform(this.textMatrix, tsm));
	    },
	    carriageReturn: function TextState_carriageReturn() {
	      this.translateTextLineMatrix(0, -this.leading);
	      this.textMatrix = this.textLineMatrix.slice();
	    },
	    clone: function TextState_clone() {
	      var clone = Object.create(this);
	      clone.textMatrix = this.textMatrix.slice();
	      clone.textLineMatrix = this.textLineMatrix.slice();
	      clone.fontMatrix = this.fontMatrix.slice();
	      return clone;
	    }
	  };
	  return TextState;
	}();
	var EvalState = function EvalStateClosure() {
	  function EvalState() {
	    this.ctm = new Float32Array(_util.IDENTITY_MATRIX);
	    this.font = null;
	    this.textRenderingMode = _util.TextRenderingMode.FILL;
	    this.fillColorSpace = _colorspace.ColorSpace.singletons.gray;
	    this.strokeColorSpace = _colorspace.ColorSpace.singletons.gray;
	  }
	  EvalState.prototype = {
	    clone: function CanvasExtraState_clone() {
	      return Object.create(this);
	    }
	  };
	  return EvalState;
	}();
	var EvaluatorPreprocessor = function EvaluatorPreprocessorClosure() {
	  var getOPMap = (0, _util.getLookupTableFactory)(function (t) {
	    t['w'] = {
	      id: _util.OPS.setLineWidth,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['J'] = {
	      id: _util.OPS.setLineCap,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['j'] = {
	      id: _util.OPS.setLineJoin,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['M'] = {
	      id: _util.OPS.setMiterLimit,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['d'] = {
	      id: _util.OPS.setDash,
	      numArgs: 2,
	      variableArgs: false
	    };
	    t['ri'] = {
	      id: _util.OPS.setRenderingIntent,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['i'] = {
	      id: _util.OPS.setFlatness,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['gs'] = {
	      id: _util.OPS.setGState,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['q'] = {
	      id: _util.OPS.save,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['Q'] = {
	      id: _util.OPS.restore,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['cm'] = {
	      id: _util.OPS.transform,
	      numArgs: 6,
	      variableArgs: false
	    };
	    t['m'] = {
	      id: _util.OPS.moveTo,
	      numArgs: 2,
	      variableArgs: false
	    };
	    t['l'] = {
	      id: _util.OPS.lineTo,
	      numArgs: 2,
	      variableArgs: false
	    };
	    t['c'] = {
	      id: _util.OPS.curveTo,
	      numArgs: 6,
	      variableArgs: false
	    };
	    t['v'] = {
	      id: _util.OPS.curveTo2,
	      numArgs: 4,
	      variableArgs: false
	    };
	    t['y'] = {
	      id: _util.OPS.curveTo3,
	      numArgs: 4,
	      variableArgs: false
	    };
	    t['h'] = {
	      id: _util.OPS.closePath,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['re'] = {
	      id: _util.OPS.rectangle,
	      numArgs: 4,
	      variableArgs: false
	    };
	    t['S'] = {
	      id: _util.OPS.stroke,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['s'] = {
	      id: _util.OPS.closeStroke,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['f'] = {
	      id: _util.OPS.fill,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['F'] = {
	      id: _util.OPS.fill,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['f*'] = {
	      id: _util.OPS.eoFill,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['B'] = {
	      id: _util.OPS.fillStroke,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['B*'] = {
	      id: _util.OPS.eoFillStroke,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['b'] = {
	      id: _util.OPS.closeFillStroke,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['b*'] = {
	      id: _util.OPS.closeEOFillStroke,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['n'] = {
	      id: _util.OPS.endPath,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['W'] = {
	      id: _util.OPS.clip,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['W*'] = {
	      id: _util.OPS.eoClip,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['BT'] = {
	      id: _util.OPS.beginText,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['ET'] = {
	      id: _util.OPS.endText,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['Tc'] = {
	      id: _util.OPS.setCharSpacing,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['Tw'] = {
	      id: _util.OPS.setWordSpacing,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['Tz'] = {
	      id: _util.OPS.setHScale,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['TL'] = {
	      id: _util.OPS.setLeading,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['Tf'] = {
	      id: _util.OPS.setFont,
	      numArgs: 2,
	      variableArgs: false
	    };
	    t['Tr'] = {
	      id: _util.OPS.setTextRenderingMode,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['Ts'] = {
	      id: _util.OPS.setTextRise,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['Td'] = {
	      id: _util.OPS.moveText,
	      numArgs: 2,
	      variableArgs: false
	    };
	    t['TD'] = {
	      id: _util.OPS.setLeadingMoveText,
	      numArgs: 2,
	      variableArgs: false
	    };
	    t['Tm'] = {
	      id: _util.OPS.setTextMatrix,
	      numArgs: 6,
	      variableArgs: false
	    };
	    t['T*'] = {
	      id: _util.OPS.nextLine,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['Tj'] = {
	      id: _util.OPS.showText,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['TJ'] = {
	      id: _util.OPS.showSpacedText,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['\''] = {
	      id: _util.OPS.nextLineShowText,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['"'] = {
	      id: _util.OPS.nextLineSetSpacingShowText,
	      numArgs: 3,
	      variableArgs: false
	    };
	    t['d0'] = {
	      id: _util.OPS.setCharWidth,
	      numArgs: 2,
	      variableArgs: false
	    };
	    t['d1'] = {
	      id: _util.OPS.setCharWidthAndBounds,
	      numArgs: 6,
	      variableArgs: false
	    };
	    t['CS'] = {
	      id: _util.OPS.setStrokeColorSpace,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['cs'] = {
	      id: _util.OPS.setFillColorSpace,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['SC'] = {
	      id: _util.OPS.setStrokeColor,
	      numArgs: 4,
	      variableArgs: true
	    };
	    t['SCN'] = {
	      id: _util.OPS.setStrokeColorN,
	      numArgs: 33,
	      variableArgs: true
	    };
	    t['sc'] = {
	      id: _util.OPS.setFillColor,
	      numArgs: 4,
	      variableArgs: true
	    };
	    t['scn'] = {
	      id: _util.OPS.setFillColorN,
	      numArgs: 33,
	      variableArgs: true
	    };
	    t['G'] = {
	      id: _util.OPS.setStrokeGray,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['g'] = {
	      id: _util.OPS.setFillGray,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['RG'] = {
	      id: _util.OPS.setStrokeRGBColor,
	      numArgs: 3,
	      variableArgs: false
	    };
	    t['rg'] = {
	      id: _util.OPS.setFillRGBColor,
	      numArgs: 3,
	      variableArgs: false
	    };
	    t['K'] = {
	      id: _util.OPS.setStrokeCMYKColor,
	      numArgs: 4,
	      variableArgs: false
	    };
	    t['k'] = {
	      id: _util.OPS.setFillCMYKColor,
	      numArgs: 4,
	      variableArgs: false
	    };
	    t['sh'] = {
	      id: _util.OPS.shadingFill,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['BI'] = {
	      id: _util.OPS.beginInlineImage,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['ID'] = {
	      id: _util.OPS.beginImageData,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['EI'] = {
	      id: _util.OPS.endInlineImage,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['Do'] = {
	      id: _util.OPS.paintXObject,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['MP'] = {
	      id: _util.OPS.markPoint,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['DP'] = {
	      id: _util.OPS.markPointProps,
	      numArgs: 2,
	      variableArgs: false
	    };
	    t['BMC'] = {
	      id: _util.OPS.beginMarkedContent,
	      numArgs: 1,
	      variableArgs: false
	    };
	    t['BDC'] = {
	      id: _util.OPS.beginMarkedContentProps,
	      numArgs: 2,
	      variableArgs: false
	    };
	    t['EMC'] = {
	      id: _util.OPS.endMarkedContent,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['BX'] = {
	      id: _util.OPS.beginCompat,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['EX'] = {
	      id: _util.OPS.endCompat,
	      numArgs: 0,
	      variableArgs: false
	    };
	    t['BM'] = null;
	    t['BD'] = null;
	    t['true'] = null;
	    t['fa'] = null;
	    t['fal'] = null;
	    t['fals'] = null;
	    t['false'] = null;
	    t['nu'] = null;
	    t['nul'] = null;
	    t['null'] = null;
	  });
	  function EvaluatorPreprocessor(stream, xref, stateManager) {
	    this.opMap = getOPMap();
	    this.parser = new _parser.Parser(new _parser.Lexer(stream, this.opMap), false, xref);
	    this.stateManager = stateManager;
	    this.nonProcessedArgs = [];
	  }
	  EvaluatorPreprocessor.prototype = {
	    get savedStatesDepth() {
	      return this.stateManager.stateStack.length;
	    },
	    read: function EvaluatorPreprocessor_read(operation) {
	      var args = operation.args;
	      while (true) {
	        var obj = this.parser.getObj();
	        if ((0, _primitives.isCmd)(obj)) {
	          var cmd = obj.cmd;
	          var opSpec = this.opMap[cmd];
	          if (!opSpec) {
	            (0, _util.warn)('Unknown command "' + cmd + '"');
	            continue;
	          }
	          var fn = opSpec.id;
	          var numArgs = opSpec.numArgs;
	          var argsLength = args !== null ? args.length : 0;
	          if (!opSpec.variableArgs) {
	            if (argsLength !== numArgs) {
	              var nonProcessedArgs = this.nonProcessedArgs;
	              while (argsLength > numArgs) {
	                nonProcessedArgs.push(args.shift());
	                argsLength--;
	              }
	              while (argsLength < numArgs && nonProcessedArgs.length !== 0) {
	                if (args === null) {
	                  args = [];
	                }
	                args.unshift(nonProcessedArgs.pop());
	                argsLength++;
	              }
	            }
	            if (argsLength < numArgs) {
	              (0, _util.warn)('Skipping command ' + fn + ': expected ' + numArgs + ' args, but received ' + argsLength + ' args.');
	              if (args !== null) {
	                args.length = 0;
	              }
	              continue;
	            }
	          } else if (argsLength > numArgs) {
	            (0, _util.info)('Command ' + fn + ': expected [0,' + numArgs + '] args, but received ' + argsLength + ' args.');
	          }
	          this.preprocessCommand(fn, args);
	          operation.fn = fn;
	          operation.args = args;
	          return true;
	        }
	        if ((0, _primitives.isEOF)(obj)) {
	          return false;
	        }
	        if (obj !== null) {
	          if (args === null) {
	            args = [];
	          }
	          args.push(obj);
	          if (args.length > 33) {
	            throw new _util.FormatError('Too many arguments');
	          }
	        }
	      }
	    },
	    preprocessCommand: function EvaluatorPreprocessor_preprocessCommand(fn, args) {
	      switch (fn | 0) {
	        case _util.OPS.save:
	          this.stateManager.save();
	          break;
	        case _util.OPS.restore:
	          this.stateManager.restore();
	          break;
	        case _util.OPS.transform:
	          this.stateManager.transform(args);
	          break;
	      }
	    }
	  };
	  return EvaluatorPreprocessor;
	}();
	var QueueOptimizer = function QueueOptimizerClosure() {
	  function addState(parentState, pattern, fn) {
	    var state = parentState;
	    for (var i = 0, ii = pattern.length - 1; i < ii; i++) {
	      var item = pattern[i];
	      state = state[item] || (state[item] = []);
	    }
	    state[pattern[pattern.length - 1]] = fn;
	  }
	  function handlePaintSolidColorImageMask(iFirstSave, count, fnArray, argsArray) {
	    var iFirstPIMXO = iFirstSave + 2;
	    for (var i = 0; i < count; i++) {
	      var arg = argsArray[iFirstPIMXO + 4 * i];
	      var imageMask = arg.length === 1 && arg[0];
	      if (imageMask && imageMask.width === 1 && imageMask.height === 1 && (!imageMask.data.length || imageMask.data.length === 1 && imageMask.data[0] === 0)) {
	        fnArray[iFirstPIMXO + 4 * i] = _util.OPS.paintSolidColorImageMask;
	        continue;
	      }
	      break;
	    }
	    return count - i;
	  }
	  var InitialState = [];
	  addState(InitialState, [_util.OPS.save, _util.OPS.transform, _util.OPS.paintInlineImageXObject, _util.OPS.restore], function foundInlineImageGroup(context) {
	    var MIN_IMAGES_IN_INLINE_IMAGES_BLOCK = 10;
	    var MAX_IMAGES_IN_INLINE_IMAGES_BLOCK = 200;
	    var MAX_WIDTH = 1000;
	    var IMAGE_PADDING = 1;
	    var fnArray = context.fnArray,
	        argsArray = context.argsArray;
	    var curr = context.iCurr;
	    var iFirstSave = curr - 3;
	    var iFirstTransform = curr - 2;
	    var iFirstPIIXO = curr - 1;
	    var i = iFirstSave + 4;
	    var ii = fnArray.length;
	    while (i + 3 < ii) {
	      if (fnArray[i] !== _util.OPS.save || fnArray[i + 1] !== _util.OPS.transform || fnArray[i + 2] !== _util.OPS.paintInlineImageXObject || fnArray[i + 3] !== _util.OPS.restore) {
	        break;
	      }
	      i += 4;
	    }
	    var count = Math.min((i - iFirstSave) / 4, MAX_IMAGES_IN_INLINE_IMAGES_BLOCK);
	    if (count < MIN_IMAGES_IN_INLINE_IMAGES_BLOCK) {
	      return i;
	    }
	    var maxX = 0;
	    var map = [],
	        maxLineHeight = 0;
	    var currentX = IMAGE_PADDING,
	        currentY = IMAGE_PADDING;
	    var q;
	    for (q = 0; q < count; q++) {
	      var transform = argsArray[iFirstTransform + (q << 2)];
	      var img = argsArray[iFirstPIIXO + (q << 2)][0];
	      if (currentX + img.width > MAX_WIDTH) {
	        maxX = Math.max(maxX, currentX);
	        currentY += maxLineHeight + 2 * IMAGE_PADDING;
	        currentX = 0;
	        maxLineHeight = 0;
	      }
	      map.push({
	        transform: transform,
	        x: currentX,
	        y: currentY,
	        w: img.width,
	        h: img.height
	      });
	      currentX += img.width + 2 * IMAGE_PADDING;
	      maxLineHeight = Math.max(maxLineHeight, img.height);
	    }
	    var imgWidth = Math.max(maxX, currentX) + IMAGE_PADDING;
	    var imgHeight = currentY + maxLineHeight + IMAGE_PADDING;
	    var imgData = new Uint8Array(imgWidth * imgHeight * 4);
	    var imgRowSize = imgWidth << 2;
	    for (q = 0; q < count; q++) {
	      var data = argsArray[iFirstPIIXO + (q << 2)][0].data;
	      var rowSize = map[q].w << 2;
	      var dataOffset = 0;
	      var offset = map[q].x + map[q].y * imgWidth << 2;
	      imgData.set(data.subarray(0, rowSize), offset - imgRowSize);
	      for (var k = 0, kk = map[q].h; k < kk; k++) {
	        imgData.set(data.subarray(dataOffset, dataOffset + rowSize), offset);
	        dataOffset += rowSize;
	        offset += imgRowSize;
	      }
	      imgData.set(data.subarray(dataOffset - rowSize, dataOffset), offset);
	      while (offset >= 0) {
	        data[offset - 4] = data[offset];
	        data[offset - 3] = data[offset + 1];
	        data[offset - 2] = data[offset + 2];
	        data[offset - 1] = data[offset + 3];
	        data[offset + rowSize] = data[offset + rowSize - 4];
	        data[offset + rowSize + 1] = data[offset + rowSize - 3];
	        data[offset + rowSize + 2] = data[offset + rowSize - 2];
	        data[offset + rowSize + 3] = data[offset + rowSize - 1];
	        offset -= imgRowSize;
	      }
	    }
	    fnArray.splice(iFirstSave, count * 4, _util.OPS.paintInlineImageXObjectGroup);
	    argsArray.splice(iFirstSave, count * 4, [{
	      width: imgWidth,
	      height: imgHeight,
	      kind: _util.ImageKind.RGBA_32BPP,
	      data: imgData
	    }, map]);
	    return iFirstSave + 1;
	  });
	  addState(InitialState, [_util.OPS.save, _util.OPS.transform, _util.OPS.paintImageMaskXObject, _util.OPS.restore], function foundImageMaskGroup(context) {
	    var MIN_IMAGES_IN_MASKS_BLOCK = 10;
	    var MAX_IMAGES_IN_MASKS_BLOCK = 100;
	    var MAX_SAME_IMAGES_IN_MASKS_BLOCK = 1000;
	    var fnArray = context.fnArray,
	        argsArray = context.argsArray;
	    var curr = context.iCurr;
	    var iFirstSave = curr - 3;
	    var iFirstTransform = curr - 2;
	    var iFirstPIMXO = curr - 1;
	    var i = iFirstSave + 4;
	    var ii = fnArray.length;
	    while (i + 3 < ii) {
	      if (fnArray[i] !== _util.OPS.save || fnArray[i + 1] !== _util.OPS.transform || fnArray[i + 2] !== _util.OPS.paintImageMaskXObject || fnArray[i + 3] !== _util.OPS.restore) {
	        break;
	      }
	      i += 4;
	    }
	    var count = (i - iFirstSave) / 4;
	    count = handlePaintSolidColorImageMask(iFirstSave, count, fnArray, argsArray);
	    if (count < MIN_IMAGES_IN_MASKS_BLOCK) {
	      return i;
	    }
	    var q;
	    var isSameImage = false;
	    var iTransform, transformArgs;
	    var firstPIMXOArg0 = argsArray[iFirstPIMXO][0];
	    if (argsArray[iFirstTransform][1] === 0 && argsArray[iFirstTransform][2] === 0) {
	      isSameImage = true;
	      var firstTransformArg0 = argsArray[iFirstTransform][0];
	      var firstTransformArg3 = argsArray[iFirstTransform][3];
	      iTransform = iFirstTransform + 4;
	      var iPIMXO = iFirstPIMXO + 4;
	      for (q = 1; q < count; q++, iTransform += 4, iPIMXO += 4) {
	        transformArgs = argsArray[iTransform];
	        if (argsArray[iPIMXO][0] !== firstPIMXOArg0 || transformArgs[0] !== firstTransformArg0 || transformArgs[1] !== 0 || transformArgs[2] !== 0 || transformArgs[3] !== firstTransformArg3) {
	          if (q < MIN_IMAGES_IN_MASKS_BLOCK) {
	            isSameImage = false;
	          } else {
	            count = q;
	          }
	          break;
	        }
	      }
	    }
	    if (isSameImage) {
	      count = Math.min(count, MAX_SAME_IMAGES_IN_MASKS_BLOCK);
	      var positions = new Float32Array(count * 2);
	      iTransform = iFirstTransform;
	      for (q = 0; q < count; q++, iTransform += 4) {
	        transformArgs = argsArray[iTransform];
	        positions[q << 1] = transformArgs[4];
	        positions[(q << 1) + 1] = transformArgs[5];
	      }
	      fnArray.splice(iFirstSave, count * 4, _util.OPS.paintImageMaskXObjectRepeat);
	      argsArray.splice(iFirstSave, count * 4, [firstPIMXOArg0, firstTransformArg0, firstTransformArg3, positions]);
	    } else {
	      count = Math.min(count, MAX_IMAGES_IN_MASKS_BLOCK);
	      var images = [];
	      for (q = 0; q < count; q++) {
	        transformArgs = argsArray[iFirstTransform + (q << 2)];
	        var maskParams = argsArray[iFirstPIMXO + (q << 2)][0];
	        images.push({
	          data: maskParams.data,
	          width: maskParams.width,
	          height: maskParams.height,
	          transform: transformArgs
	        });
	      }
	      fnArray.splice(iFirstSave, count * 4, _util.OPS.paintImageMaskXObjectGroup);
	      argsArray.splice(iFirstSave, count * 4, [images]);
	    }
	    return iFirstSave + 1;
	  });
	  addState(InitialState, [_util.OPS.save, _util.OPS.transform, _util.OPS.paintImageXObject, _util.OPS.restore], function (context) {
	    var MIN_IMAGES_IN_BLOCK = 3;
	    var MAX_IMAGES_IN_BLOCK = 1000;
	    var fnArray = context.fnArray,
	        argsArray = context.argsArray;
	    var curr = context.iCurr;
	    var iFirstSave = curr - 3;
	    var iFirstTransform = curr - 2;
	    var iFirstPIXO = curr - 1;
	    var iFirstRestore = curr;
	    if (argsArray[iFirstTransform][1] !== 0 || argsArray[iFirstTransform][2] !== 0) {
	      return iFirstRestore + 1;
	    }
	    var firstPIXOArg0 = argsArray[iFirstPIXO][0];
	    var firstTransformArg0 = argsArray[iFirstTransform][0];
	    var firstTransformArg3 = argsArray[iFirstTransform][3];
	    var i = iFirstSave + 4;
	    var ii = fnArray.length;
	    while (i + 3 < ii) {
	      if (fnArray[i] !== _util.OPS.save || fnArray[i + 1] !== _util.OPS.transform || fnArray[i + 2] !== _util.OPS.paintImageXObject || fnArray[i + 3] !== _util.OPS.restore) {
	        break;
	      }
	      if (argsArray[i + 1][0] !== firstTransformArg0 || argsArray[i + 1][1] !== 0 || argsArray[i + 1][2] !== 0 || argsArray[i + 1][3] !== firstTransformArg3) {
	        break;
	      }
	      if (argsArray[i + 2][0] !== firstPIXOArg0) {
	        break;
	      }
	      i += 4;
	    }
	    var count = Math.min((i - iFirstSave) / 4, MAX_IMAGES_IN_BLOCK);
	    if (count < MIN_IMAGES_IN_BLOCK) {
	      return i;
	    }
	    var positions = new Float32Array(count * 2);
	    var iTransform = iFirstTransform;
	    for (var q = 0; q < count; q++, iTransform += 4) {
	      var transformArgs = argsArray[iTransform];
	      positions[q << 1] = transformArgs[4];
	      positions[(q << 1) + 1] = transformArgs[5];
	    }
	    var args = [firstPIXOArg0, firstTransformArg0, firstTransformArg3, positions];
	    fnArray.splice(iFirstSave, count * 4, _util.OPS.paintImageXObjectRepeat);
	    argsArray.splice(iFirstSave, count * 4, args);
	    return iFirstSave + 1;
	  });
	  addState(InitialState, [_util.OPS.beginText, _util.OPS.setFont, _util.OPS.setTextMatrix, _util.OPS.showText, _util.OPS.endText], function (context) {
	    var MIN_CHARS_IN_BLOCK = 3;
	    var MAX_CHARS_IN_BLOCK = 1000;
	    var fnArray = context.fnArray,
	        argsArray = context.argsArray;
	    var curr = context.iCurr;
	    var iFirstBeginText = curr - 4;
	    var iFirstSetFont = curr - 3;
	    var iFirstSetTextMatrix = curr - 2;
	    var iFirstShowText = curr - 1;
	    var iFirstEndText = curr;
	    var firstSetFontArg0 = argsArray[iFirstSetFont][0];
	    var firstSetFontArg1 = argsArray[iFirstSetFont][1];
	    var i = iFirstBeginText + 5;
	    var ii = fnArray.length;
	    while (i + 4 < ii) {
	      if (fnArray[i] !== _util.OPS.beginText || fnArray[i + 1] !== _util.OPS.setFont || fnArray[i + 2] !== _util.OPS.setTextMatrix || fnArray[i + 3] !== _util.OPS.showText || fnArray[i + 4] !== _util.OPS.endText) {
	        break;
	      }
	      if (argsArray[i + 1][0] !== firstSetFontArg0 || argsArray[i + 1][1] !== firstSetFontArg1) {
	        break;
	      }
	      i += 5;
	    }
	    var count = Math.min((i - iFirstBeginText) / 5, MAX_CHARS_IN_BLOCK);
	    if (count < MIN_CHARS_IN_BLOCK) {
	      return i;
	    }
	    var iFirst = iFirstBeginText;
	    if (iFirstBeginText >= 4 && fnArray[iFirstBeginText - 4] === fnArray[iFirstSetFont] && fnArray[iFirstBeginText - 3] === fnArray[iFirstSetTextMatrix] && fnArray[iFirstBeginText - 2] === fnArray[iFirstShowText] && fnArray[iFirstBeginText - 1] === fnArray[iFirstEndText] && argsArray[iFirstBeginText - 4][0] === firstSetFontArg0 && argsArray[iFirstBeginText - 4][1] === firstSetFontArg1) {
	      count++;
	      iFirst -= 5;
	    }
	    var iEndText = iFirst + 4;
	    for (var q = 1; q < count; q++) {
	      fnArray.splice(iEndText, 3);
	      argsArray.splice(iEndText, 3);
	      iEndText += 2;
	    }
	    return iEndText + 1;
	  });
	  function QueueOptimizer() {}
	  QueueOptimizer.prototype = {
	    optimize: function QueueOptimizer_optimize(queue) {
	      var fnArray = queue.fnArray,
	          argsArray = queue.argsArray;
	      var context = {
	        iCurr: 0,
	        fnArray: fnArray,
	        argsArray: argsArray
	      };
	      var state;
	      var i = 0,
	          ii = fnArray.length;
	      while (i < ii) {
	        state = (state || InitialState)[fnArray[i]];
	        if (typeof state === 'function') {
	          context.iCurr = i;
	          i = state(context);
	          state = undefined;
	          ii = context.fnArray.length;
	        } else {
	          i++;
	        }
	      }
	    }
	  };
	  return QueueOptimizer;
	}();
	exports.OperatorList = OperatorList;
	exports.PartialEvaluator = PartialEvaluator;
	
	/***/ }),
	/* 84 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CFFCompiler = exports.CFFPrivateDict = exports.CFFTopDict = exports.CFFCharset = exports.CFFIndex = exports.CFFStrings = exports.CFFHeader = exports.CFF = exports.CFFParser = exports.CFFStandardStrings = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _charsets = __w_pdfjs_require__(150);
	
	var _encodings = __w_pdfjs_require__(30);
	
	var MAX_SUBR_NESTING = 10;
	var CFFStandardStrings = ['.notdef', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'endash', 'dagger', 'daggerdbl', 'periodcentered', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand', 'questiondown', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'emdash', 'AE', 'ordfeminine', 'Lslash', 'Oslash', 'OE', 'ordmasculine', 'ae', 'dotlessi', 'lslash', 'oslash', 'oe', 'germandbls', 'onesuperior', 'logicalnot', 'mu', 'trademark', 'Eth', 'onehalf', 'plusminus', 'Thorn', 'onequarter', 'divide', 'brokenbar', 'degree', 'thorn', 'threequarters', 'twosuperior', 'registered', 'minus', 'eth', 'multiply', 'threesuperior', 'copyright', 'Aacute', 'Acircumflex', 'Adieresis', 'Agrave', 'Aring', 'Atilde', 'Ccedilla', 'Eacute', 'Ecircumflex', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Ntilde', 'Oacute', 'Ocircumflex', 'Odieresis', 'Ograve', 'Otilde', 'Scaron', 'Uacute', 'Ucircumflex', 'Udieresis', 'Ugrave', 'Yacute', 'Ydieresis', 'Zcaron', 'aacute', 'acircumflex', 'adieresis', 'agrave', 'aring', 'atilde', 'ccedilla', 'eacute', 'ecircumflex', 'edieresis', 'egrave', 'iacute', 'icircumflex', 'idieresis', 'igrave', 'ntilde', 'oacute', 'ocircumflex', 'odieresis', 'ograve', 'otilde', 'scaron', 'uacute', 'ucircumflex', 'udieresis', 'ugrave', 'yacute', 'ydieresis', 'zcaron', 'exclamsmall', 'Hungarumlautsmall', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'ffi', 'ffl', 'parenleftinferior', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', 'exclamdownsmall', 'centoldstyle', 'Lslashsmall', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall', 'Dotaccentsmall', 'Macronsmall', 'figuredash', 'hypheninferior', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', 'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', 'zerosuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall', '001.000', '001.001', '001.002', '001.003', 'Black', 'Bold', 'Book', 'Light', 'Medium', 'Regular', 'Roman', 'Semibold'];
	var CFFParser = function CFFParserClosure() {
	  var CharstringValidationData = [null, {
	    id: 'hstem',
	    min: 2,
	    stackClearing: true,
	    stem: true
	  }, null, {
	    id: 'vstem',
	    min: 2,
	    stackClearing: true,
	    stem: true
	  }, {
	    id: 'vmoveto',
	    min: 1,
	    stackClearing: true
	  }, {
	    id: 'rlineto',
	    min: 2,
	    resetStack: true
	  }, {
	    id: 'hlineto',
	    min: 1,
	    resetStack: true
	  }, {
	    id: 'vlineto',
	    min: 1,
	    resetStack: true
	  }, {
	    id: 'rrcurveto',
	    min: 6,
	    resetStack: true
	  }, null, {
	    id: 'callsubr',
	    min: 1,
	    undefStack: true
	  }, {
	    id: 'return',
	    min: 0,
	    undefStack: true
	  }, null, null, {
	    id: 'endchar',
	    min: 0,
	    stackClearing: true
	  }, null, null, null, {
	    id: 'hstemhm',
	    min: 2,
	    stackClearing: true,
	    stem: true
	  }, {
	    id: 'hintmask',
	    min: 0,
	    stackClearing: true
	  }, {
	    id: 'cntrmask',
	    min: 0,
	    stackClearing: true
	  }, {
	    id: 'rmoveto',
	    min: 2,
	    stackClearing: true
	  }, {
	    id: 'hmoveto',
	    min: 1,
	    stackClearing: true
	  }, {
	    id: 'vstemhm',
	    min: 2,
	    stackClearing: true,
	    stem: true
	  }, {
	    id: 'rcurveline',
	    min: 8,
	    resetStack: true
	  }, {
	    id: 'rlinecurve',
	    min: 8,
	    resetStack: true
	  }, {
	    id: 'vvcurveto',
	    min: 4,
	    resetStack: true
	  }, {
	    id: 'hhcurveto',
	    min: 4,
	    resetStack: true
	  }, null, {
	    id: 'callgsubr',
	    min: 1,
	    undefStack: true
	  }, {
	    id: 'vhcurveto',
	    min: 4,
	    resetStack: true
	  }, {
	    id: 'hvcurveto',
	    min: 4,
	    resetStack: true
	  }];
	  var CharstringValidationData12 = [null, null, null, {
	    id: 'and',
	    min: 2,
	    stackDelta: -1
	  }, {
	    id: 'or',
	    min: 2,
	    stackDelta: -1
	  }, {
	    id: 'not',
	    min: 1,
	    stackDelta: 0
	  }, null, null, null, {
	    id: 'abs',
	    min: 1,
	    stackDelta: 0
	  }, {
	    id: 'add',
	    min: 2,
	    stackDelta: -1,
	    stackFn: function stack_div(stack, index) {
	      stack[index - 2] = stack[index - 2] + stack[index - 1];
	    }
	  }, {
	    id: 'sub',
	    min: 2,
	    stackDelta: -1,
	    stackFn: function stack_div(stack, index) {
	      stack[index - 2] = stack[index - 2] - stack[index - 1];
	    }
	  }, {
	    id: 'div',
	    min: 2,
	    stackDelta: -1,
	    stackFn: function stack_div(stack, index) {
	      stack[index - 2] = stack[index - 2] / stack[index - 1];
	    }
	  }, null, {
	    id: 'neg',
	    min: 1,
	    stackDelta: 0,
	    stackFn: function stack_div(stack, index) {
	      stack[index - 1] = -stack[index - 1];
	    }
	  }, {
	    id: 'eq',
	    min: 2,
	    stackDelta: -1
	  }, null, null, {
	    id: 'drop',
	    min: 1,
	    stackDelta: -1
	  }, null, {
	    id: 'put',
	    min: 2,
	    stackDelta: -2
	  }, {
	    id: 'get',
	    min: 1,
	    stackDelta: 0
	  }, {
	    id: 'ifelse',
	    min: 4,
	    stackDelta: -3
	  }, {
	    id: 'random',
	    min: 0,
	    stackDelta: 1
	  }, {
	    id: 'mul',
	    min: 2,
	    stackDelta: -1,
	    stackFn: function stack_div(stack, index) {
	      stack[index - 2] = stack[index - 2] * stack[index - 1];
	    }
	  }, null, {
	    id: 'sqrt',
	    min: 1,
	    stackDelta: 0
	  }, {
	    id: 'dup',
	    min: 1,
	    stackDelta: 1
	  }, {
	    id: 'exch',
	    min: 2,
	    stackDelta: 0
	  }, {
	    id: 'index',
	    min: 2,
	    stackDelta: 0
	  }, {
	    id: 'roll',
	    min: 3,
	    stackDelta: -2
	  }, null, null, null, {
	    id: 'hflex',
	    min: 7,
	    resetStack: true
	  }, {
	    id: 'flex',
	    min: 13,
	    resetStack: true
	  }, {
	    id: 'hflex1',
	    min: 9,
	    resetStack: true
	  }, {
	    id: 'flex1',
	    min: 11,
	    resetStack: true
	  }];
	  function CFFParser(file, properties, seacAnalysisEnabled) {
	    this.bytes = file.getBytes();
	    this.properties = properties;
	    this.seacAnalysisEnabled = !!seacAnalysisEnabled;
	  }
	  CFFParser.prototype = {
	    parse: function CFFParser_parse() {
	      var properties = this.properties;
	      var cff = new CFF();
	      this.cff = cff;
	      var header = this.parseHeader();
	      var nameIndex = this.parseIndex(header.endPos);
	      var topDictIndex = this.parseIndex(nameIndex.endPos);
	      var stringIndex = this.parseIndex(topDictIndex.endPos);
	      var globalSubrIndex = this.parseIndex(stringIndex.endPos);
	      var topDictParsed = this.parseDict(topDictIndex.obj.get(0));
	      var topDict = this.createDict(CFFTopDict, topDictParsed, cff.strings);
	      cff.header = header.obj;
	      cff.names = this.parseNameIndex(nameIndex.obj);
	      cff.strings = this.parseStringIndex(stringIndex.obj);
	      cff.topDict = topDict;
	      cff.globalSubrIndex = globalSubrIndex.obj;
	      this.parsePrivateDict(cff.topDict);
	      cff.isCIDFont = topDict.hasName('ROS');
	      var charStringOffset = topDict.getByName('CharStrings');
	      var charStringIndex = this.parseIndex(charStringOffset).obj;
	      var fontMatrix = topDict.getByName('FontMatrix');
	      if (fontMatrix) {
	        properties.fontMatrix = fontMatrix;
	      }
	      var fontBBox = topDict.getByName('FontBBox');
	      if (fontBBox) {
	        properties.ascent = Math.max(fontBBox[3], fontBBox[1]);
	        properties.descent = Math.min(fontBBox[1], fontBBox[3]);
	        properties.ascentScaled = true;
	      }
	      var charset, encoding;
	      if (cff.isCIDFont) {
	        var fdArrayIndex = this.parseIndex(topDict.getByName('FDArray')).obj;
	        for (var i = 0, ii = fdArrayIndex.count; i < ii; ++i) {
	          var dictRaw = fdArrayIndex.get(i);
	          var fontDict = this.createDict(CFFTopDict, this.parseDict(dictRaw), cff.strings);
	          this.parsePrivateDict(fontDict);
	          cff.fdArray.push(fontDict);
	        }
	        encoding = null;
	        charset = this.parseCharsets(topDict.getByName('charset'), charStringIndex.count, cff.strings, true);
	        cff.fdSelect = this.parseFDSelect(topDict.getByName('FDSelect'), charStringIndex.count);
	      } else {
	        charset = this.parseCharsets(topDict.getByName('charset'), charStringIndex.count, cff.strings, false);
	        encoding = this.parseEncoding(topDict.getByName('Encoding'), properties, cff.strings, charset.charset);
	      }
	      cff.charset = charset;
	      cff.encoding = encoding;
	      var charStringsAndSeacs = this.parseCharStrings({
	        charStrings: charStringIndex,
	        localSubrIndex: topDict.privateDict.subrsIndex,
	        globalSubrIndex: globalSubrIndex.obj,
	        fdSelect: cff.fdSelect,
	        fdArray: cff.fdArray,
	        privateDict: topDict.privateDict
	      });
	      cff.charStrings = charStringsAndSeacs.charStrings;
	      cff.seacs = charStringsAndSeacs.seacs;
	      cff.widths = charStringsAndSeacs.widths;
	      return cff;
	    },
	    parseHeader: function CFFParser_parseHeader() {
	      var bytes = this.bytes;
	      var bytesLength = bytes.length;
	      var offset = 0;
	      while (offset < bytesLength && bytes[offset] !== 1) {
	        ++offset;
	      }
	      if (offset >= bytesLength) {
	        throw new _util.FormatError('Invalid CFF header');
	      }
	      if (offset !== 0) {
	        (0, _util.info)('cff data is shifted');
	        bytes = bytes.subarray(offset);
	        this.bytes = bytes;
	      }
	      var major = bytes[0];
	      var minor = bytes[1];
	      var hdrSize = bytes[2];
	      var offSize = bytes[3];
	      var header = new CFFHeader(major, minor, hdrSize, offSize);
	      return {
	        obj: header,
	        endPos: hdrSize
	      };
	    },
	    parseDict: function CFFParser_parseDict(dict) {
	      var pos = 0;
	      function parseOperand() {
	        var value = dict[pos++];
	        if (value === 30) {
	          return parseFloatOperand();
	        } else if (value === 28) {
	          value = dict[pos++];
	          value = (value << 24 | dict[pos++] << 16) >> 16;
	          return value;
	        } else if (value === 29) {
	          value = dict[pos++];
	          value = value << 8 | dict[pos++];
	          value = value << 8 | dict[pos++];
	          value = value << 8 | dict[pos++];
	          return value;
	        } else if (value >= 32 && value <= 246) {
	          return value - 139;
	        } else if (value >= 247 && value <= 250) {
	          return (value - 247) * 256 + dict[pos++] + 108;
	        } else if (value >= 251 && value <= 254) {
	          return -((value - 251) * 256) - dict[pos++] - 108;
	        }
	        (0, _util.warn)('CFFParser_parseDict: "' + value + '" is a reserved command.');
	        return NaN;
	      }
	      function parseFloatOperand() {
	        var str = '';
	        var eof = 15;
	        var lookup = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', 'E', 'E-', null, '-'];
	        var length = dict.length;
	        while (pos < length) {
	          var b = dict[pos++];
	          var b1 = b >> 4;
	          var b2 = b & 15;
	          if (b1 === eof) {
	            break;
	          }
	          str += lookup[b1];
	          if (b2 === eof) {
	            break;
	          }
	          str += lookup[b2];
	        }
	        return parseFloat(str);
	      }
	      var operands = [];
	      var entries = [];
	      pos = 0;
	      var end = dict.length;
	      while (pos < end) {
	        var b = dict[pos];
	        if (b <= 21) {
	          if (b === 12) {
	            b = b << 8 | dict[++pos];
	          }
	          entries.push([b, operands]);
	          operands = [];
	          ++pos;
	        } else {
	          operands.push(parseOperand());
	        }
	      }
	      return entries;
	    },
	    parseIndex: function CFFParser_parseIndex(pos) {
	      var cffIndex = new CFFIndex();
	      var bytes = this.bytes;
	      var count = bytes[pos++] << 8 | bytes[pos++];
	      var offsets = [];
	      var end = pos;
	      var i, ii;
	      if (count !== 0) {
	        var offsetSize = bytes[pos++];
	        var startPos = pos + (count + 1) * offsetSize - 1;
	        for (i = 0, ii = count + 1; i < ii; ++i) {
	          var offset = 0;
	          for (var j = 0; j < offsetSize; ++j) {
	            offset <<= 8;
	            offset += bytes[pos++];
	          }
	          offsets.push(startPos + offset);
	        }
	        end = offsets[count];
	      }
	      for (i = 0, ii = offsets.length - 1; i < ii; ++i) {
	        var offsetStart = offsets[i];
	        var offsetEnd = offsets[i + 1];
	        cffIndex.add(bytes.subarray(offsetStart, offsetEnd));
	      }
	      return {
	        obj: cffIndex,
	        endPos: end
	      };
	    },
	    parseNameIndex: function CFFParser_parseNameIndex(index) {
	      var names = [];
	      for (var i = 0, ii = index.count; i < ii; ++i) {
	        var name = index.get(i);
	        names.push((0, _util.bytesToString)(name));
	      }
	      return names;
	    },
	    parseStringIndex: function CFFParser_parseStringIndex(index) {
	      var strings = new CFFStrings();
	      for (var i = 0, ii = index.count; i < ii; ++i) {
	        var data = index.get(i);
	        strings.add((0, _util.bytesToString)(data));
	      }
	      return strings;
	    },
	    createDict: function CFFParser_createDict(Type, dict, strings) {
	      var cffDict = new Type(strings);
	      for (var i = 0, ii = dict.length; i < ii; ++i) {
	        var pair = dict[i];
	        var key = pair[0];
	        var value = pair[1];
	        cffDict.setByKey(key, value);
	      }
	      return cffDict;
	    },
	    parseCharString: function CFFParser_parseCharString(state, data, localSubrIndex, globalSubrIndex) {
	      if (!data || state.callDepth > MAX_SUBR_NESTING) {
	        return false;
	      }
	      var stackSize = state.stackSize;
	      var stack = state.stack;
	      var length = data.length;
	      for (var j = 0; j < length;) {
	        var value = data[j++];
	        var validationCommand = null;
	        if (value === 12) {
	          var q = data[j++];
	          if (q === 0) {
	            data[j - 2] = 139;
	            data[j - 1] = 22;
	            stackSize = 0;
	          } else {
	            validationCommand = CharstringValidationData12[q];
	          }
	        } else if (value === 28) {
	          stack[stackSize] = (data[j] << 24 | data[j + 1] << 16) >> 16;
	          j += 2;
	          stackSize++;
	        } else if (value === 14) {
	          if (stackSize >= 4) {
	            stackSize -= 4;
	            if (this.seacAnalysisEnabled) {
	              state.seac = stack.slice(stackSize, stackSize + 4);
	              return false;
	            }
	          }
	          validationCommand = CharstringValidationData[value];
	        } else if (value >= 32 && value <= 246) {
	          stack[stackSize] = value - 139;
	          stackSize++;
	        } else if (value >= 247 && value <= 254) {
	          stack[stackSize] = value < 251 ? (value - 247 << 8) + data[j] + 108 : -(value - 251 << 8) - data[j] - 108;
	          j++;
	          stackSize++;
	        } else if (value === 255) {
	          stack[stackSize] = (data[j] << 24 | data[j + 1] << 16 | data[j + 2] << 8 | data[j + 3]) / 65536;
	          j += 4;
	          stackSize++;
	        } else if (value === 19 || value === 20) {
	          state.hints += stackSize >> 1;
	          j += state.hints + 7 >> 3;
	          stackSize %= 2;
	          validationCommand = CharstringValidationData[value];
	        } else if (value === 10 || value === 29) {
	          var subrsIndex;
	          if (value === 10) {
	            subrsIndex = localSubrIndex;
	          } else {
	            subrsIndex = globalSubrIndex;
	          }
	          if (!subrsIndex) {
	            validationCommand = CharstringValidationData[value];
	            (0, _util.warn)('Missing subrsIndex for ' + validationCommand.id);
	            return false;
	          }
	          var bias = 32768;
	          if (subrsIndex.count < 1240) {
	            bias = 107;
	          } else if (subrsIndex.count < 33900) {
	            bias = 1131;
	          }
	          var subrNumber = stack[--stackSize] + bias;
	          if (subrNumber < 0 || subrNumber >= subrsIndex.count || isNaN(subrNumber)) {
	            validationCommand = CharstringValidationData[value];
	            (0, _util.warn)('Out of bounds subrIndex for ' + validationCommand.id);
	            return false;
	          }
	          state.stackSize = stackSize;
	          state.callDepth++;
	          var valid = this.parseCharString(state, subrsIndex.get(subrNumber), localSubrIndex, globalSubrIndex);
	          if (!valid) {
	            return false;
	          }
	          state.callDepth--;
	          stackSize = state.stackSize;
	          continue;
	        } else if (value === 11) {
	          state.stackSize = stackSize;
	          return true;
	        } else {
	          validationCommand = CharstringValidationData[value];
	        }
	        if (validationCommand) {
	          if (validationCommand.stem) {
	            state.hints += stackSize >> 1;
	          }
	          if ('min' in validationCommand) {
	            if (!state.undefStack && stackSize < validationCommand.min) {
	              (0, _util.warn)('Not enough parameters for ' + validationCommand.id + '; actual: ' + stackSize + ', expected: ' + validationCommand.min);
	              return false;
	            }
	          }
	          if (state.firstStackClearing && validationCommand.stackClearing) {
	            state.firstStackClearing = false;
	            stackSize -= validationCommand.min;
	            if (stackSize >= 2 && validationCommand.stem) {
	              stackSize %= 2;
	            } else if (stackSize > 1) {
	              (0, _util.warn)('Found too many parameters for stack-clearing command');
	            }
	            if (stackSize > 0 && stack[stackSize - 1] >= 0) {
	              state.width = stack[stackSize - 1];
	            }
	          }
	          if ('stackDelta' in validationCommand) {
	            if ('stackFn' in validationCommand) {
	              validationCommand.stackFn(stack, stackSize);
	            }
	            stackSize += validationCommand.stackDelta;
	          } else if (validationCommand.stackClearing) {
	            stackSize = 0;
	          } else if (validationCommand.resetStack) {
	            stackSize = 0;
	            state.undefStack = false;
	          } else if (validationCommand.undefStack) {
	            stackSize = 0;
	            state.undefStack = true;
	            state.firstStackClearing = false;
	          }
	        }
	      }
	      state.stackSize = stackSize;
	      return true;
	    },
	    parseCharStrings: function parseCharStrings(_ref) {
	      var charStrings = _ref.charStrings,
	          localSubrIndex = _ref.localSubrIndex,
	          globalSubrIndex = _ref.globalSubrIndex,
	          fdSelect = _ref.fdSelect,
	          fdArray = _ref.fdArray,
	          privateDict = _ref.privateDict;
	
	      var seacs = [];
	      var widths = [];
	      var count = charStrings.count;
	      for (var i = 0; i < count; i++) {
	        var charstring = charStrings.get(i);
	        var state = {
	          callDepth: 0,
	          stackSize: 0,
	          stack: [],
	          undefStack: true,
	          hints: 0,
	          firstStackClearing: true,
	          seac: null,
	          width: null
	        };
	        var valid = true;
	        var localSubrToUse = null;
	        var privateDictToUse = privateDict;
	        if (fdSelect && fdArray.length) {
	          var fdIndex = fdSelect.getFDIndex(i);
	          if (fdIndex === -1) {
	            (0, _util.warn)('Glyph index is not in fd select.');
	            valid = false;
	          }
	          if (fdIndex >= fdArray.length) {
	            (0, _util.warn)('Invalid fd index for glyph index.');
	            valid = false;
	          }
	          if (valid) {
	            privateDictToUse = fdArray[fdIndex].privateDict;
	            localSubrToUse = privateDictToUse.subrsIndex;
	          }
	        } else if (localSubrIndex) {
	          localSubrToUse = localSubrIndex;
	        }
	        if (valid) {
	          valid = this.parseCharString(state, charstring, localSubrToUse, globalSubrIndex);
	        }
	        if (state.width !== null) {
	          var nominalWidth = privateDictToUse.getByName('nominalWidthX');
	          widths[i] = nominalWidth + state.width;
	        } else {
	          var defaultWidth = privateDictToUse.getByName('defaultWidthX');
	          widths[i] = defaultWidth;
	        }
	        if (state.seac !== null) {
	          seacs[i] = state.seac;
	        }
	        if (!valid) {
	          charStrings.set(i, new Uint8Array([14]));
	        }
	      }
	      return {
	        charStrings: charStrings,
	        seacs: seacs,
	        widths: widths
	      };
	    },
	
	    emptyPrivateDictionary: function CFFParser_emptyPrivateDictionary(parentDict) {
	      var privateDict = this.createDict(CFFPrivateDict, [], parentDict.strings);
	      parentDict.setByKey(18, [0, 0]);
	      parentDict.privateDict = privateDict;
	    },
	    parsePrivateDict: function CFFParser_parsePrivateDict(parentDict) {
	      if (!parentDict.hasName('Private')) {
	        this.emptyPrivateDictionary(parentDict);
	        return;
	      }
	      var privateOffset = parentDict.getByName('Private');
	      if (!Array.isArray(privateOffset) || privateOffset.length !== 2) {
	        parentDict.removeByName('Private');
	        return;
	      }
	      var size = privateOffset[0];
	      var offset = privateOffset[1];
	      if (size === 0 || offset >= this.bytes.length) {
	        this.emptyPrivateDictionary(parentDict);
	        return;
	      }
	      var privateDictEnd = offset + size;
	      var dictData = this.bytes.subarray(offset, privateDictEnd);
	      var dict = this.parseDict(dictData);
	      var privateDict = this.createDict(CFFPrivateDict, dict, parentDict.strings);
	      parentDict.privateDict = privateDict;
	      if (!privateDict.getByName('Subrs')) {
	        return;
	      }
	      var subrsOffset = privateDict.getByName('Subrs');
	      var relativeOffset = offset + subrsOffset;
	      if (subrsOffset === 0 || relativeOffset >= this.bytes.length) {
	        this.emptyPrivateDictionary(parentDict);
	        return;
	      }
	      var subrsIndex = this.parseIndex(relativeOffset);
	      privateDict.subrsIndex = subrsIndex.obj;
	    },
	    parseCharsets: function CFFParser_parseCharsets(pos, length, strings, cid) {
	      if (pos === 0) {
	        return new CFFCharset(true, CFFCharsetPredefinedTypes.ISO_ADOBE, _charsets.ISOAdobeCharset);
	      } else if (pos === 1) {
	        return new CFFCharset(true, CFFCharsetPredefinedTypes.EXPERT, _charsets.ExpertCharset);
	      } else if (pos === 2) {
	        return new CFFCharset(true, CFFCharsetPredefinedTypes.EXPERT_SUBSET, _charsets.ExpertSubsetCharset);
	      }
	      var bytes = this.bytes;
	      var start = pos;
	      var format = bytes[pos++];
	      var charset = ['.notdef'];
	      var id, count, i;
	      length -= 1;
	      switch (format) {
	        case 0:
	          for (i = 0; i < length; i++) {
	            id = bytes[pos++] << 8 | bytes[pos++];
	            charset.push(cid ? id : strings.get(id));
	          }
	          break;
	        case 1:
	          while (charset.length <= length) {
	            id = bytes[pos++] << 8 | bytes[pos++];
	            count = bytes[pos++];
	            for (i = 0; i <= count; i++) {
	              charset.push(cid ? id++ : strings.get(id++));
	            }
	          }
	          break;
	        case 2:
	          while (charset.length <= length) {
	            id = bytes[pos++] << 8 | bytes[pos++];
	            count = bytes[pos++] << 8 | bytes[pos++];
	            for (i = 0; i <= count; i++) {
	              charset.push(cid ? id++ : strings.get(id++));
	            }
	          }
	          break;
	        default:
	          throw new _util.FormatError('Unknown charset format');
	      }
	      var end = pos;
	      var raw = bytes.subarray(start, end);
	      return new CFFCharset(false, format, charset, raw);
	    },
	    parseEncoding: function CFFParser_parseEncoding(pos, properties, strings, charset) {
	      var encoding = Object.create(null);
	      var bytes = this.bytes;
	      var predefined = false;
	      var format, i, ii;
	      var raw = null;
	      function readSupplement() {
	        var supplementsCount = bytes[pos++];
	        for (i = 0; i < supplementsCount; i++) {
	          var code = bytes[pos++];
	          var sid = (bytes[pos++] << 8) + (bytes[pos++] & 0xff);
	          encoding[code] = charset.indexOf(strings.get(sid));
	        }
	      }
	      if (pos === 0 || pos === 1) {
	        predefined = true;
	        format = pos;
	        var baseEncoding = pos ? _encodings.ExpertEncoding : _encodings.StandardEncoding;
	        for (i = 0, ii = charset.length; i < ii; i++) {
	          var index = baseEncoding.indexOf(charset[i]);
	          if (index !== -1) {
	            encoding[index] = i;
	          }
	        }
	      } else {
	        var dataStart = pos;
	        format = bytes[pos++];
	        switch (format & 0x7f) {
	          case 0:
	            var glyphsCount = bytes[pos++];
	            for (i = 1; i <= glyphsCount; i++) {
	              encoding[bytes[pos++]] = i;
	            }
	            break;
	          case 1:
	            var rangesCount = bytes[pos++];
	            var gid = 1;
	            for (i = 0; i < rangesCount; i++) {
	              var start = bytes[pos++];
	              var left = bytes[pos++];
	              for (var j = start; j <= start + left; j++) {
	                encoding[j] = gid++;
	              }
	            }
	            break;
	          default:
	            throw new _util.FormatError('Unknown encoding format: ' + format + ' in CFF');
	        }
	        var dataEnd = pos;
	        if (format & 0x80) {
	          bytes[dataStart] &= 0x7f;
	          readSupplement();
	        }
	        raw = bytes.subarray(dataStart, dataEnd);
	      }
	      format = format & 0x7f;
	      return new CFFEncoding(predefined, format, encoding, raw);
	    },
	    parseFDSelect: function CFFParser_parseFDSelect(pos, length) {
	      var start = pos;
	      var bytes = this.bytes;
	      var format = bytes[pos++];
	      var fdSelect = [],
	          rawBytes;
	      var i,
	          invalidFirstGID = false;
	      switch (format) {
	        case 0:
	          for (i = 0; i < length; ++i) {
	            var id = bytes[pos++];
	            fdSelect.push(id);
	          }
	          rawBytes = bytes.subarray(start, pos);
	          break;
	        case 3:
	          var rangesCount = bytes[pos++] << 8 | bytes[pos++];
	          for (i = 0; i < rangesCount; ++i) {
	            var first = bytes[pos++] << 8 | bytes[pos++];
	            if (i === 0 && first !== 0) {
	              (0, _util.warn)('parseFDSelect: The first range must have a first GID of 0' + ' -- trying to recover.');
	              invalidFirstGID = true;
	              first = 0;
	            }
	            var fdIndex = bytes[pos++];
	            var next = bytes[pos] << 8 | bytes[pos + 1];
	            for (var j = first; j < next; ++j) {
	              fdSelect.push(fdIndex);
	            }
	          }
	          pos += 2;
	          rawBytes = bytes.subarray(start, pos);
	          if (invalidFirstGID) {
	            rawBytes[3] = rawBytes[4] = 0;
	          }
	          break;
	        default:
	          throw new _util.FormatError('parseFDSelect: Unknown format "' + format + '".');
	      }
	      if (fdSelect.length !== length) {
	        throw new _util.FormatError('parseFDSelect: Invalid font data.');
	      }
	      return new CFFFDSelect(fdSelect, rawBytes);
	    }
	  };
	  return CFFParser;
	}();
	var CFF = function CFFClosure() {
	  function CFF() {
	    this.header = null;
	    this.names = [];
	    this.topDict = null;
	    this.strings = new CFFStrings();
	    this.globalSubrIndex = null;
	    this.encoding = null;
	    this.charset = null;
	    this.charStrings = null;
	    this.fdArray = [];
	    this.fdSelect = null;
	    this.isCIDFont = false;
	  }
	  return CFF;
	}();
	var CFFHeader = function CFFHeaderClosure() {
	  function CFFHeader(major, minor, hdrSize, offSize) {
	    this.major = major;
	    this.minor = minor;
	    this.hdrSize = hdrSize;
	    this.offSize = offSize;
	  }
	  return CFFHeader;
	}();
	var CFFStrings = function CFFStringsClosure() {
	  function CFFStrings() {
	    this.strings = [];
	  }
	  CFFStrings.prototype = {
	    get: function CFFStrings_get(index) {
	      if (index >= 0 && index <= 390) {
	        return CFFStandardStrings[index];
	      }
	      if (index - 391 <= this.strings.length) {
	        return this.strings[index - 391];
	      }
	      return CFFStandardStrings[0];
	    },
	    add: function CFFStrings_add(value) {
	      this.strings.push(value);
	    },
	    get count() {
	      return this.strings.length;
	    }
	  };
	  return CFFStrings;
	}();
	var CFFIndex = function CFFIndexClosure() {
	  function CFFIndex() {
	    this.objects = [];
	    this.length = 0;
	  }
	  CFFIndex.prototype = {
	    add: function CFFIndex_add(data) {
	      this.length += data.length;
	      this.objects.push(data);
	    },
	    set: function CFFIndex_set(index, data) {
	      this.length += data.length - this.objects[index].length;
	      this.objects[index] = data;
	    },
	    get: function CFFIndex_get(index) {
	      return this.objects[index];
	    },
	    get count() {
	      return this.objects.length;
	    }
	  };
	  return CFFIndex;
	}();
	var CFFDict = function CFFDictClosure() {
	  function CFFDict(tables, strings) {
	    this.keyToNameMap = tables.keyToNameMap;
	    this.nameToKeyMap = tables.nameToKeyMap;
	    this.defaults = tables.defaults;
	    this.types = tables.types;
	    this.opcodes = tables.opcodes;
	    this.order = tables.order;
	    this.strings = strings;
	    this.values = Object.create(null);
	  }
	  CFFDict.prototype = {
	    setByKey: function CFFDict_setByKey(key, value) {
	      if (!(key in this.keyToNameMap)) {
	        return false;
	      }
	      var valueLength = value.length;
	      if (valueLength === 0) {
	        return true;
	      }
	      for (var i = 0; i < valueLength; i++) {
	        if (isNaN(value[i])) {
	          (0, _util.warn)('Invalid CFFDict value: "' + value + '" for key "' + key + '".');
	          return true;
	        }
	      }
	      var type = this.types[key];
	      if (type === 'num' || type === 'sid' || type === 'offset') {
	        value = value[0];
	      }
	      this.values[key] = value;
	      return true;
	    },
	    setByName: function CFFDict_setByName(name, value) {
	      if (!(name in this.nameToKeyMap)) {
	        throw new _util.FormatError('Invalid dictionary name "' + name + '"');
	      }
	      this.values[this.nameToKeyMap[name]] = value;
	    },
	    hasName: function CFFDict_hasName(name) {
	      return this.nameToKeyMap[name] in this.values;
	    },
	    getByName: function CFFDict_getByName(name) {
	      if (!(name in this.nameToKeyMap)) {
	        throw new _util.FormatError('Invalid dictionary name ' + name + '"');
	      }
	      var key = this.nameToKeyMap[name];
	      if (!(key in this.values)) {
	        return this.defaults[key];
	      }
	      return this.values[key];
	    },
	    removeByName: function CFFDict_removeByName(name) {
	      delete this.values[this.nameToKeyMap[name]];
	    }
	  };
	  CFFDict.createTables = function CFFDict_createTables(layout) {
	    var tables = {
	      keyToNameMap: {},
	      nameToKeyMap: {},
	      defaults: {},
	      types: {},
	      opcodes: {},
	      order: []
	    };
	    for (var i = 0, ii = layout.length; i < ii; ++i) {
	      var entry = layout[i];
	      var key = Array.isArray(entry[0]) ? (entry[0][0] << 8) + entry[0][1] : entry[0];
	      tables.keyToNameMap[key] = entry[1];
	      tables.nameToKeyMap[entry[1]] = key;
	      tables.types[key] = entry[2];
	      tables.defaults[key] = entry[3];
	      tables.opcodes[key] = Array.isArray(entry[0]) ? entry[0] : [entry[0]];
	      tables.order.push(key);
	    }
	    return tables;
	  };
	  return CFFDict;
	}();
	var CFFTopDict = function CFFTopDictClosure() {
	  var layout = [[[12, 30], 'ROS', ['sid', 'sid', 'num'], null], [[12, 20], 'SyntheticBase', 'num', null], [0, 'version', 'sid', null], [1, 'Notice', 'sid', null], [[12, 0], 'Copyright', 'sid', null], [2, 'FullName', 'sid', null], [3, 'FamilyName', 'sid', null], [4, 'Weight', 'sid', null], [[12, 1], 'isFixedPitch', 'num', 0], [[12, 2], 'ItalicAngle', 'num', 0], [[12, 3], 'UnderlinePosition', 'num', -100], [[12, 4], 'UnderlineThickness', 'num', 50], [[12, 5], 'PaintType', 'num', 0], [[12, 6], 'CharstringType', 'num', 2], [[12, 7], 'FontMatrix', ['num', 'num', 'num', 'num', 'num', 'num'], [0.001, 0, 0, 0.001, 0, 0]], [13, 'UniqueID', 'num', null], [5, 'FontBBox', ['num', 'num', 'num', 'num'], [0, 0, 0, 0]], [[12, 8], 'StrokeWidth', 'num', 0], [14, 'XUID', 'array', null], [15, 'charset', 'offset', 0], [16, 'Encoding', 'offset', 0], [17, 'CharStrings', 'offset', 0], [18, 'Private', ['offset', 'offset'], null], [[12, 21], 'PostScript', 'sid', null], [[12, 22], 'BaseFontName', 'sid', null], [[12, 23], 'BaseFontBlend', 'delta', null], [[12, 31], 'CIDFontVersion', 'num', 0], [[12, 32], 'CIDFontRevision', 'num', 0], [[12, 33], 'CIDFontType', 'num', 0], [[12, 34], 'CIDCount', 'num', 8720], [[12, 35], 'UIDBase', 'num', null], [[12, 37], 'FDSelect', 'offset', null], [[12, 36], 'FDArray', 'offset', null], [[12, 38], 'FontName', 'sid', null]];
	  var tables = null;
	  function CFFTopDict(strings) {
	    if (tables === null) {
	      tables = CFFDict.createTables(layout);
	    }
	    CFFDict.call(this, tables, strings);
	    this.privateDict = null;
	  }
	  CFFTopDict.prototype = Object.create(CFFDict.prototype);
	  return CFFTopDict;
	}();
	var CFFPrivateDict = function CFFPrivateDictClosure() {
	  var layout = [[6, 'BlueValues', 'delta', null], [7, 'OtherBlues', 'delta', null], [8, 'FamilyBlues', 'delta', null], [9, 'FamilyOtherBlues', 'delta', null], [[12, 9], 'BlueScale', 'num', 0.039625], [[12, 10], 'BlueShift', 'num', 7], [[12, 11], 'BlueFuzz', 'num', 1], [10, 'StdHW', 'num', null], [11, 'StdVW', 'num', null], [[12, 12], 'StemSnapH', 'delta', null], [[12, 13], 'StemSnapV', 'delta', null], [[12, 14], 'ForceBold', 'num', 0], [[12, 17], 'LanguageGroup', 'num', 0], [[12, 18], 'ExpansionFactor', 'num', 0.06], [[12, 19], 'initialRandomSeed', 'num', 0], [20, 'defaultWidthX', 'num', 0], [21, 'nominalWidthX', 'num', 0], [19, 'Subrs', 'offset', null]];
	  var tables = null;
	  function CFFPrivateDict(strings) {
	    if (tables === null) {
	      tables = CFFDict.createTables(layout);
	    }
	    CFFDict.call(this, tables, strings);
	    this.subrsIndex = null;
	  }
	  CFFPrivateDict.prototype = Object.create(CFFDict.prototype);
	  return CFFPrivateDict;
	}();
	var CFFCharsetPredefinedTypes = {
	  ISO_ADOBE: 0,
	  EXPERT: 1,
	  EXPERT_SUBSET: 2
	};
	var CFFCharset = function CFFCharsetClosure() {
	  function CFFCharset(predefined, format, charset, raw) {
	    this.predefined = predefined;
	    this.format = format;
	    this.charset = charset;
	    this.raw = raw;
	  }
	  return CFFCharset;
	}();
	var CFFEncoding = function CFFEncodingClosure() {
	  function CFFEncoding(predefined, format, encoding, raw) {
	    this.predefined = predefined;
	    this.format = format;
	    this.encoding = encoding;
	    this.raw = raw;
	  }
	  return CFFEncoding;
	}();
	var CFFFDSelect = function CFFFDSelectClosure() {
	  function CFFFDSelect(fdSelect, raw) {
	    this.fdSelect = fdSelect;
	    this.raw = raw;
	  }
	  CFFFDSelect.prototype = {
	    getFDIndex: function CFFFDSelect_get(glyphIndex) {
	      if (glyphIndex < 0 || glyphIndex >= this.fdSelect.length) {
	        return -1;
	      }
	      return this.fdSelect[glyphIndex];
	    }
	  };
	  return CFFFDSelect;
	}();
	var CFFOffsetTracker = function CFFOffsetTrackerClosure() {
	  function CFFOffsetTracker() {
	    this.offsets = Object.create(null);
	  }
	  CFFOffsetTracker.prototype = {
	    isTracking: function CFFOffsetTracker_isTracking(key) {
	      return key in this.offsets;
	    },
	    track: function CFFOffsetTracker_track(key, location) {
	      if (key in this.offsets) {
	        throw new _util.FormatError('Already tracking location of ' + key);
	      }
	      this.offsets[key] = location;
	    },
	    offset: function CFFOffsetTracker_offset(value) {
	      for (var key in this.offsets) {
	        this.offsets[key] += value;
	      }
	    },
	    setEntryLocation: function CFFOffsetTracker_setEntryLocation(key, values, output) {
	      if (!(key in this.offsets)) {
	        throw new _util.FormatError('Not tracking location of ' + key);
	      }
	      var data = output.data;
	      var dataOffset = this.offsets[key];
	      var size = 5;
	      for (var i = 0, ii = values.length; i < ii; ++i) {
	        var offset0 = i * size + dataOffset;
	        var offset1 = offset0 + 1;
	        var offset2 = offset0 + 2;
	        var offset3 = offset0 + 3;
	        var offset4 = offset0 + 4;
	        if (data[offset0] !== 0x1d || data[offset1] !== 0 || data[offset2] !== 0 || data[offset3] !== 0 || data[offset4] !== 0) {
	          throw new _util.FormatError('writing to an offset that is not empty');
	        }
	        var value = values[i];
	        data[offset0] = 0x1d;
	        data[offset1] = value >> 24 & 0xFF;
	        data[offset2] = value >> 16 & 0xFF;
	        data[offset3] = value >> 8 & 0xFF;
	        data[offset4] = value & 0xFF;
	      }
	    }
	  };
	  return CFFOffsetTracker;
	}();
	var CFFCompiler = function CFFCompilerClosure() {
	  function CFFCompiler(cff) {
	    this.cff = cff;
	  }
	  CFFCompiler.prototype = {
	    compile: function CFFCompiler_compile() {
	      var cff = this.cff;
	      var output = {
	        data: [],
	        length: 0,
	        add: function CFFCompiler_add(data) {
	          this.data = this.data.concat(data);
	          this.length = this.data.length;
	        }
	      };
	      var header = this.compileHeader(cff.header);
	      output.add(header);
	      var nameIndex = this.compileNameIndex(cff.names);
	      output.add(nameIndex);
	      if (cff.isCIDFont) {
	        if (cff.topDict.hasName('FontMatrix')) {
	          var base = cff.topDict.getByName('FontMatrix');
	          cff.topDict.removeByName('FontMatrix');
	          for (var i = 0, ii = cff.fdArray.length; i < ii; i++) {
	            var subDict = cff.fdArray[i];
	            var matrix = base.slice(0);
	            if (subDict.hasName('FontMatrix')) {
	              matrix = _util.Util.transform(matrix, subDict.getByName('FontMatrix'));
	            }
	            subDict.setByName('FontMatrix', matrix);
	          }
	        }
	      }
	      var compiled = this.compileTopDicts([cff.topDict], output.length, cff.isCIDFont);
	      output.add(compiled.output);
	      var topDictTracker = compiled.trackers[0];
	      var stringIndex = this.compileStringIndex(cff.strings.strings);
	      output.add(stringIndex);
	      var globalSubrIndex = this.compileIndex(cff.globalSubrIndex);
	      output.add(globalSubrIndex);
	      if (cff.encoding && cff.topDict.hasName('Encoding')) {
	        if (cff.encoding.predefined) {
	          topDictTracker.setEntryLocation('Encoding', [cff.encoding.format], output);
	        } else {
	          var encoding = this.compileEncoding(cff.encoding);
	          topDictTracker.setEntryLocation('Encoding', [output.length], output);
	          output.add(encoding);
	        }
	      }
	      if (cff.charset && cff.topDict.hasName('charset')) {
	        if (cff.charset.predefined) {
	          topDictTracker.setEntryLocation('charset', [cff.charset.format], output);
	        } else {
	          var charset = this.compileCharset(cff.charset);
	          topDictTracker.setEntryLocation('charset', [output.length], output);
	          output.add(charset);
	        }
	      }
	      var charStrings = this.compileCharStrings(cff.charStrings);
	      topDictTracker.setEntryLocation('CharStrings', [output.length], output);
	      output.add(charStrings);
	      if (cff.isCIDFont) {
	        topDictTracker.setEntryLocation('FDSelect', [output.length], output);
	        var fdSelect = this.compileFDSelect(cff.fdSelect.raw);
	        output.add(fdSelect);
	        compiled = this.compileTopDicts(cff.fdArray, output.length, true);
	        topDictTracker.setEntryLocation('FDArray', [output.length], output);
	        output.add(compiled.output);
	        var fontDictTrackers = compiled.trackers;
	        this.compilePrivateDicts(cff.fdArray, fontDictTrackers, output);
	      }
	      this.compilePrivateDicts([cff.topDict], [topDictTracker], output);
	      output.add([0]);
	      return output.data;
	    },
	    encodeNumber: function CFFCompiler_encodeNumber(value) {
	      if (parseFloat(value) === parseInt(value, 10) && !isNaN(value)) {
	        return this.encodeInteger(value);
	      }
	      return this.encodeFloat(value);
	    },
	    encodeFloat: function CFFCompiler_encodeFloat(num) {
	      var value = num.toString();
	      var m = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(value);
	      if (m) {
	        var epsilon = parseFloat('1e' + ((m[2] ? +m[2] : 0) + m[1].length));
	        value = (Math.round(num * epsilon) / epsilon).toString();
	      }
	      var nibbles = '';
	      var i, ii;
	      for (i = 0, ii = value.length; i < ii; ++i) {
	        var a = value[i];
	        if (a === 'e') {
	          nibbles += value[++i] === '-' ? 'c' : 'b';
	        } else if (a === '.') {
	          nibbles += 'a';
	        } else if (a === '-') {
	          nibbles += 'e';
	        } else {
	          nibbles += a;
	        }
	      }
	      nibbles += nibbles.length & 1 ? 'f' : 'ff';
	      var out = [30];
	      for (i = 0, ii = nibbles.length; i < ii; i += 2) {
	        out.push(parseInt(nibbles.substr(i, 2), 16));
	      }
	      return out;
	    },
	    encodeInteger: function CFFCompiler_encodeInteger(value) {
	      var code;
	      if (value >= -107 && value <= 107) {
	        code = [value + 139];
	      } else if (value >= 108 && value <= 1131) {
	        value = value - 108;
	        code = [(value >> 8) + 247, value & 0xFF];
	      } else if (value >= -1131 && value <= -108) {
	        value = -value - 108;
	        code = [(value >> 8) + 251, value & 0xFF];
	      } else if (value >= -32768 && value <= 32767) {
	        code = [0x1c, value >> 8 & 0xFF, value & 0xFF];
	      } else {
	        code = [0x1d, value >> 24 & 0xFF, value >> 16 & 0xFF, value >> 8 & 0xFF, value & 0xFF];
	      }
	      return code;
	    },
	    compileHeader: function CFFCompiler_compileHeader(header) {
	      return [header.major, header.minor, header.hdrSize, header.offSize];
	    },
	    compileNameIndex: function CFFCompiler_compileNameIndex(names) {
	      var nameIndex = new CFFIndex();
	      for (var i = 0, ii = names.length; i < ii; ++i) {
	        var name = names[i];
	        var length = Math.min(name.length, 127);
	        var sanitizedName = new Array(length);
	        for (var j = 0; j < length; j++) {
	          var char = name[j];
	          if (char < '!' || char > '~' || char === '[' || char === ']' || char === '(' || char === ')' || char === '{' || char === '}' || char === '<' || char === '>' || char === '/' || char === '%') {
	            char = '_';
	          }
	          sanitizedName[j] = char;
	        }
	        sanitizedName = sanitizedName.join('');
	        if (sanitizedName === '') {
	          sanitizedName = 'Bad_Font_Name';
	        }
	        nameIndex.add((0, _util.stringToBytes)(sanitizedName));
	      }
	      return this.compileIndex(nameIndex);
	    },
	    compileTopDicts: function CFFCompiler_compileTopDicts(dicts, length, removeCidKeys) {
	      var fontDictTrackers = [];
	      var fdArrayIndex = new CFFIndex();
	      for (var i = 0, ii = dicts.length; i < ii; ++i) {
	        var fontDict = dicts[i];
	        if (removeCidKeys) {
	          fontDict.removeByName('CIDFontVersion');
	          fontDict.removeByName('CIDFontRevision');
	          fontDict.removeByName('CIDFontType');
	          fontDict.removeByName('CIDCount');
	          fontDict.removeByName('UIDBase');
	        }
	        var fontDictTracker = new CFFOffsetTracker();
	        var fontDictData = this.compileDict(fontDict, fontDictTracker);
	        fontDictTrackers.push(fontDictTracker);
	        fdArrayIndex.add(fontDictData);
	        fontDictTracker.offset(length);
	      }
	      fdArrayIndex = this.compileIndex(fdArrayIndex, fontDictTrackers);
	      return {
	        trackers: fontDictTrackers,
	        output: fdArrayIndex
	      };
	    },
	    compilePrivateDicts: function CFFCompiler_compilePrivateDicts(dicts, trackers, output) {
	      for (var i = 0, ii = dicts.length; i < ii; ++i) {
	        var fontDict = dicts[i];
	        var privateDict = fontDict.privateDict;
	        if (!privateDict || !fontDict.hasName('Private')) {
	          throw new _util.FormatError('There must be a private dictionary.');
	        }
	        var privateDictTracker = new CFFOffsetTracker();
	        var privateDictData = this.compileDict(privateDict, privateDictTracker);
	        var outputLength = output.length;
	        privateDictTracker.offset(outputLength);
	        if (!privateDictData.length) {
	          outputLength = 0;
	        }
	        trackers[i].setEntryLocation('Private', [privateDictData.length, outputLength], output);
	        output.add(privateDictData);
	        if (privateDict.subrsIndex && privateDict.hasName('Subrs')) {
	          var subrs = this.compileIndex(privateDict.subrsIndex);
	          privateDictTracker.setEntryLocation('Subrs', [privateDictData.length], output);
	          output.add(subrs);
	        }
	      }
	    },
	    compileDict: function CFFCompiler_compileDict(dict, offsetTracker) {
	      var out = [];
	      var order = dict.order;
	      for (var i = 0; i < order.length; ++i) {
	        var key = order[i];
	        if (!(key in dict.values)) {
	          continue;
	        }
	        var values = dict.values[key];
	        var types = dict.types[key];
	        if (!Array.isArray(types)) {
	          types = [types];
	        }
	        if (!Array.isArray(values)) {
	          values = [values];
	        }
	        if (values.length === 0) {
	          continue;
	        }
	        for (var j = 0, jj = types.length; j < jj; ++j) {
	          var type = types[j];
	          var value = values[j];
	          switch (type) {
	            case 'num':
	            case 'sid':
	              out = out.concat(this.encodeNumber(value));
	              break;
	            case 'offset':
	              var name = dict.keyToNameMap[key];
	              if (!offsetTracker.isTracking(name)) {
	                offsetTracker.track(name, out.length);
	              }
	              out = out.concat([0x1d, 0, 0, 0, 0]);
	              break;
	            case 'array':
	            case 'delta':
	              out = out.concat(this.encodeNumber(value));
	              for (var k = 1, kk = values.length; k < kk; ++k) {
	                out = out.concat(this.encodeNumber(values[k]));
	              }
	              break;
	            default:
	              throw new _util.FormatError('Unknown data type of ' + type);
	          }
	        }
	        out = out.concat(dict.opcodes[key]);
	      }
	      return out;
	    },
	    compileStringIndex: function CFFCompiler_compileStringIndex(strings) {
	      var stringIndex = new CFFIndex();
	      for (var i = 0, ii = strings.length; i < ii; ++i) {
	        stringIndex.add((0, _util.stringToBytes)(strings[i]));
	      }
	      return this.compileIndex(stringIndex);
	    },
	    compileGlobalSubrIndex: function CFFCompiler_compileGlobalSubrIndex() {
	      var globalSubrIndex = this.cff.globalSubrIndex;
	      this.out.writeByteArray(this.compileIndex(globalSubrIndex));
	    },
	    compileCharStrings: function CFFCompiler_compileCharStrings(charStrings) {
	      return this.compileIndex(charStrings);
	    },
	    compileCharset: function CFFCompiler_compileCharset(charset) {
	      return this.compileTypedArray(charset.raw);
	    },
	    compileEncoding: function CFFCompiler_compileEncoding(encoding) {
	      return this.compileTypedArray(encoding.raw);
	    },
	    compileFDSelect: function CFFCompiler_compileFDSelect(fdSelect) {
	      return this.compileTypedArray(fdSelect);
	    },
	    compileTypedArray: function CFFCompiler_compileTypedArray(data) {
	      var out = [];
	      for (var i = 0, ii = data.length; i < ii; ++i) {
	        out[i] = data[i];
	      }
	      return out;
	    },
	    compileIndex: function CFFCompiler_compileIndex(index, trackers) {
	      trackers = trackers || [];
	      var objects = index.objects;
	      var count = objects.length;
	      if (count === 0) {
	        return [0, 0, 0];
	      }
	      var data = [count >> 8 & 0xFF, count & 0xff];
	      var lastOffset = 1,
	          i;
	      for (i = 0; i < count; ++i) {
	        lastOffset += objects[i].length;
	      }
	      var offsetSize;
	      if (lastOffset < 0x100) {
	        offsetSize = 1;
	      } else if (lastOffset < 0x10000) {
	        offsetSize = 2;
	      } else if (lastOffset < 0x1000000) {
	        offsetSize = 3;
	      } else {
	        offsetSize = 4;
	      }
	      data.push(offsetSize);
	      var relativeOffset = 1;
	      for (i = 0; i < count + 1; i++) {
	        if (offsetSize === 1) {
	          data.push(relativeOffset & 0xFF);
	        } else if (offsetSize === 2) {
	          data.push(relativeOffset >> 8 & 0xFF, relativeOffset & 0xFF);
	        } else if (offsetSize === 3) {
	          data.push(relativeOffset >> 16 & 0xFF, relativeOffset >> 8 & 0xFF, relativeOffset & 0xFF);
	        } else {
	          data.push(relativeOffset >>> 24 & 0xFF, relativeOffset >> 16 & 0xFF, relativeOffset >> 8 & 0xFF, relativeOffset & 0xFF);
	        }
	        if (objects[i]) {
	          relativeOffset += objects[i].length;
	        }
	      }
	      for (i = 0; i < count; i++) {
	        if (trackers[i]) {
	          trackers[i].offset(data.length);
	        }
	        for (var j = 0, jj = objects[i].length; j < jj; j++) {
	          data.push(objects[i][j]);
	        }
	      }
	      return data;
	    }
	  };
	  return CFFCompiler;
	}();
	exports.CFFStandardStrings = CFFStandardStrings;
	exports.CFFParser = CFFParser;
	exports.CFF = CFF;
	exports.CFFHeader = CFFHeader;
	exports.CFFStrings = CFFStrings;
	exports.CFFIndex = CFFIndex;
	exports.CFFCharset = CFFCharset;
	exports.CFFTopDict = CFFTopDict;
	exports.CFFPrivateDict = CFFPrivateDict;
	exports.CFFCompiler = CFFCompiler;
	
	/***/ }),
	/* 85 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSupplementalGlyphMapForArialBlack = exports.getGlyphMapForStandardFonts = exports.getSymbolsFonts = exports.getSerifFonts = exports.getNonStdFontMap = exports.getStdFontMap = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var getStdFontMap = (0, _util.getLookupTableFactory)(function (t) {
	  t['ArialNarrow'] = 'Helvetica';
	  t['ArialNarrow-Bold'] = 'Helvetica-Bold';
	  t['ArialNarrow-BoldItalic'] = 'Helvetica-BoldOblique';
	  t['ArialNarrow-Italic'] = 'Helvetica-Oblique';
	  t['ArialBlack'] = 'Helvetica';
	  t['ArialBlack-Bold'] = 'Helvetica-Bold';
	  t['ArialBlack-BoldItalic'] = 'Helvetica-BoldOblique';
	  t['ArialBlack-Italic'] = 'Helvetica-Oblique';
	  t['Arial-Black'] = 'Helvetica';
	  t['Arial-Black-Bold'] = 'Helvetica-Bold';
	  t['Arial-Black-BoldItalic'] = 'Helvetica-BoldOblique';
	  t['Arial-Black-Italic'] = 'Helvetica-Oblique';
	  t['Arial'] = 'Helvetica';
	  t['Arial-Bold'] = 'Helvetica-Bold';
	  t['Arial-BoldItalic'] = 'Helvetica-BoldOblique';
	  t['Arial-Italic'] = 'Helvetica-Oblique';
	  t['Arial-BoldItalicMT'] = 'Helvetica-BoldOblique';
	  t['Arial-BoldMT'] = 'Helvetica-Bold';
	  t['Arial-ItalicMT'] = 'Helvetica-Oblique';
	  t['ArialMT'] = 'Helvetica';
	  t['Courier-Bold'] = 'Courier-Bold';
	  t['Courier-BoldItalic'] = 'Courier-BoldOblique';
	  t['Courier-Italic'] = 'Courier-Oblique';
	  t['CourierNew'] = 'Courier';
	  t['CourierNew-Bold'] = 'Courier-Bold';
	  t['CourierNew-BoldItalic'] = 'Courier-BoldOblique';
	  t['CourierNew-Italic'] = 'Courier-Oblique';
	  t['CourierNewPS-BoldItalicMT'] = 'Courier-BoldOblique';
	  t['CourierNewPS-BoldMT'] = 'Courier-Bold';
	  t['CourierNewPS-ItalicMT'] = 'Courier-Oblique';
	  t['CourierNewPSMT'] = 'Courier';
	  t['Helvetica'] = 'Helvetica';
	  t['Helvetica-Bold'] = 'Helvetica-Bold';
	  t['Helvetica-BoldItalic'] = 'Helvetica-BoldOblique';
	  t['Helvetica-BoldOblique'] = 'Helvetica-BoldOblique';
	  t['Helvetica-Italic'] = 'Helvetica-Oblique';
	  t['Helvetica-Oblique'] = 'Helvetica-Oblique';
	  t['SegoeUISymbol'] = 'Helvetica';
	  t['Symbol-Bold'] = 'Symbol';
	  t['Symbol-BoldItalic'] = 'Symbol';
	  t['Symbol-Italic'] = 'Symbol';
	  t['TimesNewRoman'] = 'Times-Roman';
	  t['TimesNewRoman-Bold'] = 'Times-Bold';
	  t['TimesNewRoman-BoldItalic'] = 'Times-BoldItalic';
	  t['TimesNewRoman-Italic'] = 'Times-Italic';
	  t['TimesNewRomanPS'] = 'Times-Roman';
	  t['TimesNewRomanPS-Bold'] = 'Times-Bold';
	  t['TimesNewRomanPS-BoldItalic'] = 'Times-BoldItalic';
	  t['TimesNewRomanPS-BoldItalicMT'] = 'Times-BoldItalic';
	  t['TimesNewRomanPS-BoldMT'] = 'Times-Bold';
	  t['TimesNewRomanPS-Italic'] = 'Times-Italic';
	  t['TimesNewRomanPS-ItalicMT'] = 'Times-Italic';
	  t['TimesNewRomanPSMT'] = 'Times-Roman';
	  t['TimesNewRomanPSMT-Bold'] = 'Times-Bold';
	  t['TimesNewRomanPSMT-BoldItalic'] = 'Times-BoldItalic';
	  t['TimesNewRomanPSMT-Italic'] = 'Times-Italic';
	});
	var getNonStdFontMap = (0, _util.getLookupTableFactory)(function (t) {
	  t['CenturyGothic'] = 'Helvetica';
	  t['CenturyGothic-Bold'] = 'Helvetica-Bold';
	  t['CenturyGothic-BoldItalic'] = 'Helvetica-BoldOblique';
	  t['CenturyGothic-Italic'] = 'Helvetica-Oblique';
	  t['ComicSansMS'] = 'Comic Sans MS';
	  t['ComicSansMS-Bold'] = 'Comic Sans MS-Bold';
	  t['ComicSansMS-BoldItalic'] = 'Comic Sans MS-BoldItalic';
	  t['ComicSansMS-Italic'] = 'Comic Sans MS-Italic';
	  t['LucidaConsole'] = 'Courier';
	  t['LucidaConsole-Bold'] = 'Courier-Bold';
	  t['LucidaConsole-BoldItalic'] = 'Courier-BoldOblique';
	  t['LucidaConsole-Italic'] = 'Courier-Oblique';
	  t['MS-Gothic'] = 'MS Gothic';
	  t['MS-Gothic-Bold'] = 'MS Gothic-Bold';
	  t['MS-Gothic-BoldItalic'] = 'MS Gothic-BoldItalic';
	  t['MS-Gothic-Italic'] = 'MS Gothic-Italic';
	  t['MS-Mincho'] = 'MS Mincho';
	  t['MS-Mincho-Bold'] = 'MS Mincho-Bold';
	  t['MS-Mincho-BoldItalic'] = 'MS Mincho-BoldItalic';
	  t['MS-Mincho-Italic'] = 'MS Mincho-Italic';
	  t['MS-PGothic'] = 'MS PGothic';
	  t['MS-PGothic-Bold'] = 'MS PGothic-Bold';
	  t['MS-PGothic-BoldItalic'] = 'MS PGothic-BoldItalic';
	  t['MS-PGothic-Italic'] = 'MS PGothic-Italic';
	  t['MS-PMincho'] = 'MS PMincho';
	  t['MS-PMincho-Bold'] = 'MS PMincho-Bold';
	  t['MS-PMincho-BoldItalic'] = 'MS PMincho-BoldItalic';
	  t['MS-PMincho-Italic'] = 'MS PMincho-Italic';
	  t['NuptialScript'] = 'Times-Italic';
	  t['Wingdings'] = 'ZapfDingbats';
	});
	var getSerifFonts = (0, _util.getLookupTableFactory)(function (t) {
	  t['Adobe Jenson'] = true;
	  t['Adobe Text'] = true;
	  t['Albertus'] = true;
	  t['Aldus'] = true;
	  t['Alexandria'] = true;
	  t['Algerian'] = true;
	  t['American Typewriter'] = true;
	  t['Antiqua'] = true;
	  t['Apex'] = true;
	  t['Arno'] = true;
	  t['Aster'] = true;
	  t['Aurora'] = true;
	  t['Baskerville'] = true;
	  t['Bell'] = true;
	  t['Bembo'] = true;
	  t['Bembo Schoolbook'] = true;
	  t['Benguiat'] = true;
	  t['Berkeley Old Style'] = true;
	  t['Bernhard Modern'] = true;
	  t['Berthold City'] = true;
	  t['Bodoni'] = true;
	  t['Bauer Bodoni'] = true;
	  t['Book Antiqua'] = true;
	  t['Bookman'] = true;
	  t['Bordeaux Roman'] = true;
	  t['Californian FB'] = true;
	  t['Calisto'] = true;
	  t['Calvert'] = true;
	  t['Capitals'] = true;
	  t['Cambria'] = true;
	  t['Cartier'] = true;
	  t['Caslon'] = true;
	  t['Catull'] = true;
	  t['Centaur'] = true;
	  t['Century Old Style'] = true;
	  t['Century Schoolbook'] = true;
	  t['Chaparral'] = true;
	  t['Charis SIL'] = true;
	  t['Cheltenham'] = true;
	  t['Cholla Slab'] = true;
	  t['Clarendon'] = true;
	  t['Clearface'] = true;
	  t['Cochin'] = true;
	  t['Colonna'] = true;
	  t['Computer Modern'] = true;
	  t['Concrete Roman'] = true;
	  t['Constantia'] = true;
	  t['Cooper Black'] = true;
	  t['Corona'] = true;
	  t['Ecotype'] = true;
	  t['Egyptienne'] = true;
	  t['Elephant'] = true;
	  t['Excelsior'] = true;
	  t['Fairfield'] = true;
	  t['FF Scala'] = true;
	  t['Folkard'] = true;
	  t['Footlight'] = true;
	  t['FreeSerif'] = true;
	  t['Friz Quadrata'] = true;
	  t['Garamond'] = true;
	  t['Gentium'] = true;
	  t['Georgia'] = true;
	  t['Gloucester'] = true;
	  t['Goudy Old Style'] = true;
	  t['Goudy Schoolbook'] = true;
	  t['Goudy Pro Font'] = true;
	  t['Granjon'] = true;
	  t['Guardian Egyptian'] = true;
	  t['Heather'] = true;
	  t['Hercules'] = true;
	  t['High Tower Text'] = true;
	  t['Hiroshige'] = true;
	  t['Hoefler Text'] = true;
	  t['Humana Serif'] = true;
	  t['Imprint'] = true;
	  t['Ionic No. 5'] = true;
	  t['Janson'] = true;
	  t['Joanna'] = true;
	  t['Korinna'] = true;
	  t['Lexicon'] = true;
	  t['Liberation Serif'] = true;
	  t['Linux Libertine'] = true;
	  t['Literaturnaya'] = true;
	  t['Lucida'] = true;
	  t['Lucida Bright'] = true;
	  t['Melior'] = true;
	  t['Memphis'] = true;
	  t['Miller'] = true;
	  t['Minion'] = true;
	  t['Modern'] = true;
	  t['Mona Lisa'] = true;
	  t['Mrs Eaves'] = true;
	  t['MS Serif'] = true;
	  t['Museo Slab'] = true;
	  t['New York'] = true;
	  t['Nimbus Roman'] = true;
	  t['NPS Rawlinson Roadway'] = true;
	  t['NuptialScript'] = true;
	  t['Palatino'] = true;
	  t['Perpetua'] = true;
	  t['Plantin'] = true;
	  t['Plantin Schoolbook'] = true;
	  t['Playbill'] = true;
	  t['Poor Richard'] = true;
	  t['Rawlinson Roadway'] = true;
	  t['Renault'] = true;
	  t['Requiem'] = true;
	  t['Rockwell'] = true;
	  t['Roman'] = true;
	  t['Rotis Serif'] = true;
	  t['Sabon'] = true;
	  t['Scala'] = true;
	  t['Seagull'] = true;
	  t['Sistina'] = true;
	  t['Souvenir'] = true;
	  t['STIX'] = true;
	  t['Stone Informal'] = true;
	  t['Stone Serif'] = true;
	  t['Sylfaen'] = true;
	  t['Times'] = true;
	  t['Trajan'] = true;
	  t['Trinité'] = true;
	  t['Trump Mediaeval'] = true;
	  t['Utopia'] = true;
	  t['Vale Type'] = true;
	  t['Bitstream Vera'] = true;
	  t['Vera Serif'] = true;
	  t['Versailles'] = true;
	  t['Wanted'] = true;
	  t['Weiss'] = true;
	  t['Wide Latin'] = true;
	  t['Windsor'] = true;
	  t['XITS'] = true;
	});
	var getSymbolsFonts = (0, _util.getLookupTableFactory)(function (t) {
	  t['Dingbats'] = true;
	  t['Symbol'] = true;
	  t['ZapfDingbats'] = true;
	});
	var getGlyphMapForStandardFonts = (0, _util.getLookupTableFactory)(function (t) {
	  t[2] = 10;
	  t[3] = 32;
	  t[4] = 33;
	  t[5] = 34;
	  t[6] = 35;
	  t[7] = 36;
	  t[8] = 37;
	  t[9] = 38;
	  t[10] = 39;
	  t[11] = 40;
	  t[12] = 41;
	  t[13] = 42;
	  t[14] = 43;
	  t[15] = 44;
	  t[16] = 45;
	  t[17] = 46;
	  t[18] = 47;
	  t[19] = 48;
	  t[20] = 49;
	  t[21] = 50;
	  t[22] = 51;
	  t[23] = 52;
	  t[24] = 53;
	  t[25] = 54;
	  t[26] = 55;
	  t[27] = 56;
	  t[28] = 57;
	  t[29] = 58;
	  t[30] = 894;
	  t[31] = 60;
	  t[32] = 61;
	  t[33] = 62;
	  t[34] = 63;
	  t[35] = 64;
	  t[36] = 65;
	  t[37] = 66;
	  t[38] = 67;
	  t[39] = 68;
	  t[40] = 69;
	  t[41] = 70;
	  t[42] = 71;
	  t[43] = 72;
	  t[44] = 73;
	  t[45] = 74;
	  t[46] = 75;
	  t[47] = 76;
	  t[48] = 77;
	  t[49] = 78;
	  t[50] = 79;
	  t[51] = 80;
	  t[52] = 81;
	  t[53] = 82;
	  t[54] = 83;
	  t[55] = 84;
	  t[56] = 85;
	  t[57] = 86;
	  t[58] = 87;
	  t[59] = 88;
	  t[60] = 89;
	  t[61] = 90;
	  t[62] = 91;
	  t[63] = 92;
	  t[64] = 93;
	  t[65] = 94;
	  t[66] = 95;
	  t[67] = 96;
	  t[68] = 97;
	  t[69] = 98;
	  t[70] = 99;
	  t[71] = 100;
	  t[72] = 101;
	  t[73] = 102;
	  t[74] = 103;
	  t[75] = 104;
	  t[76] = 105;
	  t[77] = 106;
	  t[78] = 107;
	  t[79] = 108;
	  t[80] = 109;
	  t[81] = 110;
	  t[82] = 111;
	  t[83] = 112;
	  t[84] = 113;
	  t[85] = 114;
	  t[86] = 115;
	  t[87] = 116;
	  t[88] = 117;
	  t[89] = 118;
	  t[90] = 119;
	  t[91] = 120;
	  t[92] = 121;
	  t[93] = 122;
	  t[94] = 123;
	  t[95] = 124;
	  t[96] = 125;
	  t[97] = 126;
	  t[98] = 196;
	  t[99] = 197;
	  t[100] = 199;
	  t[101] = 201;
	  t[102] = 209;
	  t[103] = 214;
	  t[104] = 220;
	  t[105] = 225;
	  t[106] = 224;
	  t[107] = 226;
	  t[108] = 228;
	  t[109] = 227;
	  t[110] = 229;
	  t[111] = 231;
	  t[112] = 233;
	  t[113] = 232;
	  t[114] = 234;
	  t[115] = 235;
	  t[116] = 237;
	  t[117] = 236;
	  t[118] = 238;
	  t[119] = 239;
	  t[120] = 241;
	  t[121] = 243;
	  t[122] = 242;
	  t[123] = 244;
	  t[124] = 246;
	  t[125] = 245;
	  t[126] = 250;
	  t[127] = 249;
	  t[128] = 251;
	  t[129] = 252;
	  t[130] = 8224;
	  t[131] = 176;
	  t[132] = 162;
	  t[133] = 163;
	  t[134] = 167;
	  t[135] = 8226;
	  t[136] = 182;
	  t[137] = 223;
	  t[138] = 174;
	  t[139] = 169;
	  t[140] = 8482;
	  t[141] = 180;
	  t[142] = 168;
	  t[143] = 8800;
	  t[144] = 198;
	  t[145] = 216;
	  t[146] = 8734;
	  t[147] = 177;
	  t[148] = 8804;
	  t[149] = 8805;
	  t[150] = 165;
	  t[151] = 181;
	  t[152] = 8706;
	  t[153] = 8721;
	  t[154] = 8719;
	  t[156] = 8747;
	  t[157] = 170;
	  t[158] = 186;
	  t[159] = 8486;
	  t[160] = 230;
	  t[161] = 248;
	  t[162] = 191;
	  t[163] = 161;
	  t[164] = 172;
	  t[165] = 8730;
	  t[166] = 402;
	  t[167] = 8776;
	  t[168] = 8710;
	  t[169] = 171;
	  t[170] = 187;
	  t[171] = 8230;
	  t[210] = 218;
	  t[223] = 711;
	  t[224] = 321;
	  t[225] = 322;
	  t[227] = 353;
	  t[229] = 382;
	  t[234] = 253;
	  t[252] = 263;
	  t[253] = 268;
	  t[254] = 269;
	  t[258] = 258;
	  t[260] = 260;
	  t[261] = 261;
	  t[265] = 280;
	  t[266] = 281;
	  t[268] = 283;
	  t[269] = 313;
	  t[275] = 323;
	  t[276] = 324;
	  t[278] = 328;
	  t[284] = 345;
	  t[285] = 346;
	  t[286] = 347;
	  t[292] = 367;
	  t[295] = 377;
	  t[296] = 378;
	  t[298] = 380;
	  t[305] = 963;
	  t[306] = 964;
	  t[307] = 966;
	  t[308] = 8215;
	  t[309] = 8252;
	  t[310] = 8319;
	  t[311] = 8359;
	  t[312] = 8592;
	  t[313] = 8593;
	  t[337] = 9552;
	  t[493] = 1039;
	  t[494] = 1040;
	  t[705] = 1524;
	  t[706] = 8362;
	  t[710] = 64288;
	  t[711] = 64298;
	  t[759] = 1617;
	  t[761] = 1776;
	  t[763] = 1778;
	  t[775] = 1652;
	  t[777] = 1764;
	  t[778] = 1780;
	  t[779] = 1781;
	  t[780] = 1782;
	  t[782] = 771;
	  t[783] = 64726;
	  t[786] = 8363;
	  t[788] = 8532;
	  t[790] = 768;
	  t[791] = 769;
	  t[792] = 768;
	  t[795] = 803;
	  t[797] = 64336;
	  t[798] = 64337;
	  t[799] = 64342;
	  t[800] = 64343;
	  t[801] = 64344;
	  t[802] = 64345;
	  t[803] = 64362;
	  t[804] = 64363;
	  t[805] = 64364;
	  t[2424] = 7821;
	  t[2425] = 7822;
	  t[2426] = 7823;
	  t[2427] = 7824;
	  t[2428] = 7825;
	  t[2429] = 7826;
	  t[2430] = 7827;
	  t[2433] = 7682;
	  t[2678] = 8045;
	  t[2679] = 8046;
	  t[2830] = 1552;
	  t[2838] = 686;
	  t[2840] = 751;
	  t[2842] = 753;
	  t[2843] = 754;
	  t[2844] = 755;
	  t[2846] = 757;
	  t[2856] = 767;
	  t[2857] = 848;
	  t[2858] = 849;
	  t[2862] = 853;
	  t[2863] = 854;
	  t[2864] = 855;
	  t[2865] = 861;
	  t[2866] = 862;
	  t[2906] = 7460;
	  t[2908] = 7462;
	  t[2909] = 7463;
	  t[2910] = 7464;
	  t[2912] = 7466;
	  t[2913] = 7467;
	  t[2914] = 7468;
	  t[2916] = 7470;
	  t[2917] = 7471;
	  t[2918] = 7472;
	  t[2920] = 7474;
	  t[2921] = 7475;
	  t[2922] = 7476;
	  t[2924] = 7478;
	  t[2925] = 7479;
	  t[2926] = 7480;
	  t[2928] = 7482;
	  t[2929] = 7483;
	  t[2930] = 7484;
	  t[2932] = 7486;
	  t[2933] = 7487;
	  t[2934] = 7488;
	  t[2936] = 7490;
	  t[2937] = 7491;
	  t[2938] = 7492;
	  t[2940] = 7494;
	  t[2941] = 7495;
	  t[2942] = 7496;
	  t[2944] = 7498;
	  t[2946] = 7500;
	  t[2948] = 7502;
	  t[2950] = 7504;
	  t[2951] = 7505;
	  t[2952] = 7506;
	  t[2954] = 7508;
	  t[2955] = 7509;
	  t[2956] = 7510;
	  t[2958] = 7512;
	  t[2959] = 7513;
	  t[2960] = 7514;
	  t[2962] = 7516;
	  t[2963] = 7517;
	  t[2964] = 7518;
	  t[2966] = 7520;
	  t[2967] = 7521;
	  t[2968] = 7522;
	  t[2970] = 7524;
	  t[2971] = 7525;
	  t[2972] = 7526;
	  t[2974] = 7528;
	  t[2975] = 7529;
	  t[2976] = 7530;
	  t[2978] = 1537;
	  t[2979] = 1538;
	  t[2980] = 1539;
	  t[2982] = 1549;
	  t[2983] = 1551;
	  t[2984] = 1552;
	  t[2986] = 1554;
	  t[2987] = 1555;
	  t[2988] = 1556;
	  t[2990] = 1623;
	  t[2991] = 1624;
	  t[2995] = 1775;
	  t[2999] = 1791;
	  t[3002] = 64290;
	  t[3003] = 64291;
	  t[3004] = 64292;
	  t[3006] = 64294;
	  t[3007] = 64295;
	  t[3008] = 64296;
	  t[3011] = 1900;
	  t[3014] = 8223;
	  t[3015] = 8244;
	  t[3017] = 7532;
	  t[3018] = 7533;
	  t[3019] = 7534;
	  t[3075] = 7590;
	  t[3076] = 7591;
	  t[3079] = 7594;
	  t[3080] = 7595;
	  t[3083] = 7598;
	  t[3084] = 7599;
	  t[3087] = 7602;
	  t[3088] = 7603;
	  t[3091] = 7606;
	  t[3092] = 7607;
	  t[3095] = 7610;
	  t[3096] = 7611;
	  t[3099] = 7614;
	  t[3100] = 7615;
	  t[3103] = 7618;
	  t[3104] = 7619;
	  t[3107] = 8337;
	  t[3108] = 8338;
	  t[3116] = 1884;
	  t[3119] = 1885;
	  t[3120] = 1885;
	  t[3123] = 1886;
	  t[3124] = 1886;
	  t[3127] = 1887;
	  t[3128] = 1887;
	  t[3131] = 1888;
	  t[3132] = 1888;
	  t[3135] = 1889;
	  t[3136] = 1889;
	  t[3139] = 1890;
	  t[3140] = 1890;
	  t[3143] = 1891;
	  t[3144] = 1891;
	  t[3147] = 1892;
	  t[3148] = 1892;
	  t[3153] = 580;
	  t[3154] = 581;
	  t[3157] = 584;
	  t[3158] = 585;
	  t[3161] = 588;
	  t[3162] = 589;
	  t[3165] = 891;
	  t[3166] = 892;
	  t[3169] = 1274;
	  t[3170] = 1275;
	  t[3173] = 1278;
	  t[3174] = 1279;
	  t[3181] = 7622;
	  t[3182] = 7623;
	  t[3282] = 11799;
	  t[3316] = 578;
	  t[3379] = 42785;
	  t[3393] = 1159;
	  t[3416] = 8377;
	});
	var getSupplementalGlyphMapForArialBlack = (0, _util.getLookupTableFactory)(function (t) {
	  t[227] = 322;
	  t[264] = 261;
	  t[291] = 346;
	});
	exports.getStdFontMap = getStdFontMap;
	exports.getNonStdFontMap = getNonStdFontMap;
	exports.getSerifFonts = getSerifFonts;
	exports.getSymbolsFonts = getSymbolsFonts;
	exports.getGlyphMapForStandardFonts = getGlyphMapForStandardFonts;
	exports.getSupplementalGlyphMapForArialBlack = getSupplementalGlyphMapForArialBlack;
	
	/***/ }),
	/* 86 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	var getLookupTableFactory = __w_pdfjs_require__(0).getLookupTableFactory;
	var getSpecialPUASymbols = getLookupTableFactory(function (t) {
	 t[63721] = 0x00A9;
	 t[63193] = 0x00A9;
	 t[63720] = 0x00AE;
	 t[63194] = 0x00AE;
	 t[63722] = 0x2122;
	 t[63195] = 0x2122;
	 t[63729] = 0x23A7;
	 t[63730] = 0x23A8;
	 t[63731] = 0x23A9;
	 t[63740] = 0x23AB;
	 t[63741] = 0x23AC;
	 t[63742] = 0x23AD;
	 t[63726] = 0x23A1;
	 t[63727] = 0x23A2;
	 t[63728] = 0x23A3;
	 t[63737] = 0x23A4;
	 t[63738] = 0x23A5;
	 t[63739] = 0x23A6;
	 t[63723] = 0x239B;
	 t[63724] = 0x239C;
	 t[63725] = 0x239D;
	 t[63734] = 0x239E;
	 t[63735] = 0x239F;
	 t[63736] = 0x23A0;
	});
	function mapSpecialUnicodeValues(code) {
	 if (code >= 0xFFF0 && code <= 0xFFFF) {
	  return 0;
	 } else if (code >= 0xF600 && code <= 0xF8FF) {
	  return getSpecialPUASymbols()[code] || code;
	 } else if (code === 0x00AD) {
	  return 0x002D;
	 }
	 return code;
	}
	function getUnicodeForGlyph(name, glyphsUnicodeMap) {
	 var unicode = glyphsUnicodeMap[name];
	 if (unicode !== undefined) {
	  return unicode;
	 }
	 if (!name) {
	  return -1;
	 }
	 if (name[0] === 'u') {
	  var nameLen = name.length, hexStr;
	  if (nameLen === 7 && name[1] === 'n' && name[2] === 'i') {
	   hexStr = name.substr(3);
	  } else if (nameLen >= 5 && nameLen <= 7) {
	   hexStr = name.substr(1);
	  } else {
	   return -1;
	  }
	  if (hexStr === hexStr.toUpperCase()) {
	   unicode = parseInt(hexStr, 16);
	   if (unicode >= 0) {
	    return unicode;
	   }
	  }
	 }
	 return -1;
	}
	var UnicodeRanges = [
	 {
	  'begin': 0x0000,
	  'end': 0x007F
	 },
	 {
	  'begin': 0x0080,
	  'end': 0x00FF
	 },
	 {
	  'begin': 0x0100,
	  'end': 0x017F
	 },
	 {
	  'begin': 0x0180,
	  'end': 0x024F
	 },
	 {
	  'begin': 0x0250,
	  'end': 0x02AF
	 },
	 {
	  'begin': 0x02B0,
	  'end': 0x02FF
	 },
	 {
	  'begin': 0x0300,
	  'end': 0x036F
	 },
	 {
	  'begin': 0x0370,
	  'end': 0x03FF
	 },
	 {
	  'begin': 0x2C80,
	  'end': 0x2CFF
	 },
	 {
	  'begin': 0x0400,
	  'end': 0x04FF
	 },
	 {
	  'begin': 0x0530,
	  'end': 0x058F
	 },
	 {
	  'begin': 0x0590,
	  'end': 0x05FF
	 },
	 {
	  'begin': 0xA500,
	  'end': 0xA63F
	 },
	 {
	  'begin': 0x0600,
	  'end': 0x06FF
	 },
	 {
	  'begin': 0x07C0,
	  'end': 0x07FF
	 },
	 {
	  'begin': 0x0900,
	  'end': 0x097F
	 },
	 {
	  'begin': 0x0980,
	  'end': 0x09FF
	 },
	 {
	  'begin': 0x0A00,
	  'end': 0x0A7F
	 },
	 {
	  'begin': 0x0A80,
	  'end': 0x0AFF
	 },
	 {
	  'begin': 0x0B00,
	  'end': 0x0B7F
	 },
	 {
	  'begin': 0x0B80,
	  'end': 0x0BFF
	 },
	 {
	  'begin': 0x0C00,
	  'end': 0x0C7F
	 },
	 {
	  'begin': 0x0C80,
	  'end': 0x0CFF
	 },
	 {
	  'begin': 0x0D00,
	  'end': 0x0D7F
	 },
	 {
	  'begin': 0x0E00,
	  'end': 0x0E7F
	 },
	 {
	  'begin': 0x0E80,
	  'end': 0x0EFF
	 },
	 {
	  'begin': 0x10A0,
	  'end': 0x10FF
	 },
	 {
	  'begin': 0x1B00,
	  'end': 0x1B7F
	 },
	 {
	  'begin': 0x1100,
	  'end': 0x11FF
	 },
	 {
	  'begin': 0x1E00,
	  'end': 0x1EFF
	 },
	 {
	  'begin': 0x1F00,
	  'end': 0x1FFF
	 },
	 {
	  'begin': 0x2000,
	  'end': 0x206F
	 },
	 {
	  'begin': 0x2070,
	  'end': 0x209F
	 },
	 {
	  'begin': 0x20A0,
	  'end': 0x20CF
	 },
	 {
	  'begin': 0x20D0,
	  'end': 0x20FF
	 },
	 {
	  'begin': 0x2100,
	  'end': 0x214F
	 },
	 {
	  'begin': 0x2150,
	  'end': 0x218F
	 },
	 {
	  'begin': 0x2190,
	  'end': 0x21FF
	 },
	 {
	  'begin': 0x2200,
	  'end': 0x22FF
	 },
	 {
	  'begin': 0x2300,
	  'end': 0x23FF
	 },
	 {
	  'begin': 0x2400,
	  'end': 0x243F
	 },
	 {
	  'begin': 0x2440,
	  'end': 0x245F
	 },
	 {
	  'begin': 0x2460,
	  'end': 0x24FF
	 },
	 {
	  'begin': 0x2500,
	  'end': 0x257F
	 },
	 {
	  'begin': 0x2580,
	  'end': 0x259F
	 },
	 {
	  'begin': 0x25A0,
	  'end': 0x25FF
	 },
	 {
	  'begin': 0x2600,
	  'end': 0x26FF
	 },
	 {
	  'begin': 0x2700,
	  'end': 0x27BF
	 },
	 {
	  'begin': 0x3000,
	  'end': 0x303F
	 },
	 {
	  'begin': 0x3040,
	  'end': 0x309F
	 },
	 {
	  'begin': 0x30A0,
	  'end': 0x30FF
	 },
	 {
	  'begin': 0x3100,
	  'end': 0x312F
	 },
	 {
	  'begin': 0x3130,
	  'end': 0x318F
	 },
	 {
	  'begin': 0xA840,
	  'end': 0xA87F
	 },
	 {
	  'begin': 0x3200,
	  'end': 0x32FF
	 },
	 {
	  'begin': 0x3300,
	  'end': 0x33FF
	 },
	 {
	  'begin': 0xAC00,
	  'end': 0xD7AF
	 },
	 {
	  'begin': 0xD800,
	  'end': 0xDFFF
	 },
	 {
	  'begin': 0x10900,
	  'end': 0x1091F
	 },
	 {
	  'begin': 0x4E00,
	  'end': 0x9FFF
	 },
	 {
	  'begin': 0xE000,
	  'end': 0xF8FF
	 },
	 {
	  'begin': 0x31C0,
	  'end': 0x31EF
	 },
	 {
	  'begin': 0xFB00,
	  'end': 0xFB4F
	 },
	 {
	  'begin': 0xFB50,
	  'end': 0xFDFF
	 },
	 {
	  'begin': 0xFE20,
	  'end': 0xFE2F
	 },
	 {
	  'begin': 0xFE10,
	  'end': 0xFE1F
	 },
	 {
	  'begin': 0xFE50,
	  'end': 0xFE6F
	 },
	 {
	  'begin': 0xFE70,
	  'end': 0xFEFF
	 },
	 {
	  'begin': 0xFF00,
	  'end': 0xFFEF
	 },
	 {
	  'begin': 0xFFF0,
	  'end': 0xFFFF
	 },
	 {
	  'begin': 0x0F00,
	  'end': 0x0FFF
	 },
	 {
	  'begin': 0x0700,
	  'end': 0x074F
	 },
	 {
	  'begin': 0x0780,
	  'end': 0x07BF
	 },
	 {
	  'begin': 0x0D80,
	  'end': 0x0DFF
	 },
	 {
	  'begin': 0x1000,
	  'end': 0x109F
	 },
	 {
	  'begin': 0x1200,
	  'end': 0x137F
	 },
	 {
	  'begin': 0x13A0,
	  'end': 0x13FF
	 },
	 {
	  'begin': 0x1400,
	  'end': 0x167F
	 },
	 {
	  'begin': 0x1680,
	  'end': 0x169F
	 },
	 {
	  'begin': 0x16A0,
	  'end': 0x16FF
	 },
	 {
	  'begin': 0x1780,
	  'end': 0x17FF
	 },
	 {
	  'begin': 0x1800,
	  'end': 0x18AF
	 },
	 {
	  'begin': 0x2800,
	  'end': 0x28FF
	 },
	 {
	  'begin': 0xA000,
	  'end': 0xA48F
	 },
	 {
	  'begin': 0x1700,
	  'end': 0x171F
	 },
	 {
	  'begin': 0x10300,
	  'end': 0x1032F
	 },
	 {
	  'begin': 0x10330,
	  'end': 0x1034F
	 },
	 {
	  'begin': 0x10400,
	  'end': 0x1044F
	 },
	 {
	  'begin': 0x1D000,
	  'end': 0x1D0FF
	 },
	 {
	  'begin': 0x1D400,
	  'end': 0x1D7FF
	 },
	 {
	  'begin': 0xFF000,
	  'end': 0xFFFFD
	 },
	 {
	  'begin': 0xFE00,
	  'end': 0xFE0F
	 },
	 {
	  'begin': 0xE0000,
	  'end': 0xE007F
	 },
	 {
	  'begin': 0x1900,
	  'end': 0x194F
	 },
	 {
	  'begin': 0x1950,
	  'end': 0x197F
	 },
	 {
	  'begin': 0x1980,
	  'end': 0x19DF
	 },
	 {
	  'begin': 0x1A00,
	  'end': 0x1A1F
	 },
	 {
	  'begin': 0x2C00,
	  'end': 0x2C5F
	 },
	 {
	  'begin': 0x2D30,
	  'end': 0x2D7F
	 },
	 {
	  'begin': 0x4DC0,
	  'end': 0x4DFF
	 },
	 {
	  'begin': 0xA800,
	  'end': 0xA82F
	 },
	 {
	  'begin': 0x10000,
	  'end': 0x1007F
	 },
	 {
	  'begin': 0x10140,
	  'end': 0x1018F
	 },
	 {
	  'begin': 0x10380,
	  'end': 0x1039F
	 },
	 {
	  'begin': 0x103A0,
	  'end': 0x103DF
	 },
	 {
	  'begin': 0x10450,
	  'end': 0x1047F
	 },
	 {
	  'begin': 0x10480,
	  'end': 0x104AF
	 },
	 {
	  'begin': 0x10800,
	  'end': 0x1083F
	 },
	 {
	  'begin': 0x10A00,
	  'end': 0x10A5F
	 },
	 {
	  'begin': 0x1D300,
	  'end': 0x1D35F
	 },
	 {
	  'begin': 0x12000,
	  'end': 0x123FF
	 },
	 {
	  'begin': 0x1D360,
	  'end': 0x1D37F
	 },
	 {
	  'begin': 0x1B80,
	  'end': 0x1BBF
	 },
	 {
	  'begin': 0x1C00,
	  'end': 0x1C4F
	 },
	 {
	  'begin': 0x1C50,
	  'end': 0x1C7F
	 },
	 {
	  'begin': 0xA880,
	  'end': 0xA8DF
	 },
	 {
	  'begin': 0xA900,
	  'end': 0xA92F
	 },
	 {
	  'begin': 0xA930,
	  'end': 0xA95F
	 },
	 {
	  'begin': 0xAA00,
	  'end': 0xAA5F
	 },
	 {
	  'begin': 0x10190,
	  'end': 0x101CF
	 },
	 {
	  'begin': 0x101D0,
	  'end': 0x101FF
	 },
	 {
	  'begin': 0x102A0,
	  'end': 0x102DF
	 },
	 {
	  'begin': 0x1F030,
	  'end': 0x1F09F
	 }
	];
	function getUnicodeRangeFor(value) {
	 for (var i = 0, ii = UnicodeRanges.length; i < ii; i++) {
	  var range = UnicodeRanges[i];
	  if (value >= range.begin && value < range.end) {
	   return i;
	  }
	 }
	 return -1;
	}
	function isRTLRangeFor(value) {
	 var range = UnicodeRanges[13];
	 if (value >= range.begin && value < range.end) {
	  return true;
	 }
	 range = UnicodeRanges[11];
	 if (value >= range.begin && value < range.end) {
	  return true;
	 }
	 return false;
	}
	var getNormalizedUnicodes = getLookupTableFactory(function (t) {
	 t['\u00A8'] = '\u0020\u0308';
	 t['\u00AF'] = '\u0020\u0304';
	 t['\u00B4'] = '\u0020\u0301';
	 t['\u00B5'] = '\u03BC';
	 t['\u00B8'] = '\u0020\u0327';
	 t['\u0132'] = '\u0049\u004A';
	 t['\u0133'] = '\u0069\u006A';
	 t['\u013F'] = '\u004C\u00B7';
	 t['\u0140'] = '\u006C\u00B7';
	 t['\u0149'] = '\u02BC\u006E';
	 t['\u017F'] = '\u0073';
	 t['\u01C4'] = '\u0044\u017D';
	 t['\u01C5'] = '\u0044\u017E';
	 t['\u01C6'] = '\u0064\u017E';
	 t['\u01C7'] = '\u004C\u004A';
	 t['\u01C8'] = '\u004C\u006A';
	 t['\u01C9'] = '\u006C\u006A';
	 t['\u01CA'] = '\u004E\u004A';
	 t['\u01CB'] = '\u004E\u006A';
	 t['\u01CC'] = '\u006E\u006A';
	 t['\u01F1'] = '\u0044\u005A';
	 t['\u01F2'] = '\u0044\u007A';
	 t['\u01F3'] = '\u0064\u007A';
	 t['\u02D8'] = '\u0020\u0306';
	 t['\u02D9'] = '\u0020\u0307';
	 t['\u02DA'] = '\u0020\u030A';
	 t['\u02DB'] = '\u0020\u0328';
	 t['\u02DC'] = '\u0020\u0303';
	 t['\u02DD'] = '\u0020\u030B';
	 t['\u037A'] = '\u0020\u0345';
	 t['\u0384'] = '\u0020\u0301';
	 t['\u03D0'] = '\u03B2';
	 t['\u03D1'] = '\u03B8';
	 t['\u03D2'] = '\u03A5';
	 t['\u03D5'] = '\u03C6';
	 t['\u03D6'] = '\u03C0';
	 t['\u03F0'] = '\u03BA';
	 t['\u03F1'] = '\u03C1';
	 t['\u03F2'] = '\u03C2';
	 t['\u03F4'] = '\u0398';
	 t['\u03F5'] = '\u03B5';
	 t['\u03F9'] = '\u03A3';
	 t['\u0587'] = '\u0565\u0582';
	 t['\u0675'] = '\u0627\u0674';
	 t['\u0676'] = '\u0648\u0674';
	 t['\u0677'] = '\u06C7\u0674';
	 t['\u0678'] = '\u064A\u0674';
	 t['\u0E33'] = '\u0E4D\u0E32';
	 t['\u0EB3'] = '\u0ECD\u0EB2';
	 t['\u0EDC'] = '\u0EAB\u0E99';
	 t['\u0EDD'] = '\u0EAB\u0EA1';
	 t['\u0F77'] = '\u0FB2\u0F81';
	 t['\u0F79'] = '\u0FB3\u0F81';
	 t['\u1E9A'] = '\u0061\u02BE';
	 t['\u1FBD'] = '\u0020\u0313';
	 t['\u1FBF'] = '\u0020\u0313';
	 t['\u1FC0'] = '\u0020\u0342';
	 t['\u1FFE'] = '\u0020\u0314';
	 t['\u2002'] = '\u0020';
	 t['\u2003'] = '\u0020';
	 t['\u2004'] = '\u0020';
	 t['\u2005'] = '\u0020';
	 t['\u2006'] = '\u0020';
	 t['\u2008'] = '\u0020';
	 t['\u2009'] = '\u0020';
	 t['\u200A'] = '\u0020';
	 t['\u2017'] = '\u0020\u0333';
	 t['\u2024'] = '\u002E';
	 t['\u2025'] = '\u002E\u002E';
	 t['\u2026'] = '\u002E\u002E\u002E';
	 t['\u2033'] = '\u2032\u2032';
	 t['\u2034'] = '\u2032\u2032\u2032';
	 t['\u2036'] = '\u2035\u2035';
	 t['\u2037'] = '\u2035\u2035\u2035';
	 t['\u203C'] = '\u0021\u0021';
	 t['\u203E'] = '\u0020\u0305';
	 t['\u2047'] = '\u003F\u003F';
	 t['\u2048'] = '\u003F\u0021';
	 t['\u2049'] = '\u0021\u003F';
	 t['\u2057'] = '\u2032\u2032\u2032\u2032';
	 t['\u205F'] = '\u0020';
	 t['\u20A8'] = '\u0052\u0073';
	 t['\u2100'] = '\u0061\u002F\u0063';
	 t['\u2101'] = '\u0061\u002F\u0073';
	 t['\u2103'] = '\u00B0\u0043';
	 t['\u2105'] = '\u0063\u002F\u006F';
	 t['\u2106'] = '\u0063\u002F\u0075';
	 t['\u2107'] = '\u0190';
	 t['\u2109'] = '\u00B0\u0046';
	 t['\u2116'] = '\u004E\u006F';
	 t['\u2121'] = '\u0054\u0045\u004C';
	 t['\u2135'] = '\u05D0';
	 t['\u2136'] = '\u05D1';
	 t['\u2137'] = '\u05D2';
	 t['\u2138'] = '\u05D3';
	 t['\u213B'] = '\u0046\u0041\u0058';
	 t['\u2160'] = '\u0049';
	 t['\u2161'] = '\u0049\u0049';
	 t['\u2162'] = '\u0049\u0049\u0049';
	 t['\u2163'] = '\u0049\u0056';
	 t['\u2164'] = '\u0056';
	 t['\u2165'] = '\u0056\u0049';
	 t['\u2166'] = '\u0056\u0049\u0049';
	 t['\u2167'] = '\u0056\u0049\u0049\u0049';
	 t['\u2168'] = '\u0049\u0058';
	 t['\u2169'] = '\u0058';
	 t['\u216A'] = '\u0058\u0049';
	 t['\u216B'] = '\u0058\u0049\u0049';
	 t['\u216C'] = '\u004C';
	 t['\u216D'] = '\u0043';
	 t['\u216E'] = '\u0044';
	 t['\u216F'] = '\u004D';
	 t['\u2170'] = '\u0069';
	 t['\u2171'] = '\u0069\u0069';
	 t['\u2172'] = '\u0069\u0069\u0069';
	 t['\u2173'] = '\u0069\u0076';
	 t['\u2174'] = '\u0076';
	 t['\u2175'] = '\u0076\u0069';
	 t['\u2176'] = '\u0076\u0069\u0069';
	 t['\u2177'] = '\u0076\u0069\u0069\u0069';
	 t['\u2178'] = '\u0069\u0078';
	 t['\u2179'] = '\u0078';
	 t['\u217A'] = '\u0078\u0069';
	 t['\u217B'] = '\u0078\u0069\u0069';
	 t['\u217C'] = '\u006C';
	 t['\u217D'] = '\u0063';
	 t['\u217E'] = '\u0064';
	 t['\u217F'] = '\u006D';
	 t['\u222C'] = '\u222B\u222B';
	 t['\u222D'] = '\u222B\u222B\u222B';
	 t['\u222F'] = '\u222E\u222E';
	 t['\u2230'] = '\u222E\u222E\u222E';
	 t['\u2474'] = '\u0028\u0031\u0029';
	 t['\u2475'] = '\u0028\u0032\u0029';
	 t['\u2476'] = '\u0028\u0033\u0029';
	 t['\u2477'] = '\u0028\u0034\u0029';
	 t['\u2478'] = '\u0028\u0035\u0029';
	 t['\u2479'] = '\u0028\u0036\u0029';
	 t['\u247A'] = '\u0028\u0037\u0029';
	 t['\u247B'] = '\u0028\u0038\u0029';
	 t['\u247C'] = '\u0028\u0039\u0029';
	 t['\u247D'] = '\u0028\u0031\u0030\u0029';
	 t['\u247E'] = '\u0028\u0031\u0031\u0029';
	 t['\u247F'] = '\u0028\u0031\u0032\u0029';
	 t['\u2480'] = '\u0028\u0031\u0033\u0029';
	 t['\u2481'] = '\u0028\u0031\u0034\u0029';
	 t['\u2482'] = '\u0028\u0031\u0035\u0029';
	 t['\u2483'] = '\u0028\u0031\u0036\u0029';
	 t['\u2484'] = '\u0028\u0031\u0037\u0029';
	 t['\u2485'] = '\u0028\u0031\u0038\u0029';
	 t['\u2486'] = '\u0028\u0031\u0039\u0029';
	 t['\u2487'] = '\u0028\u0032\u0030\u0029';
	 t['\u2488'] = '\u0031\u002E';
	 t['\u2489'] = '\u0032\u002E';
	 t['\u248A'] = '\u0033\u002E';
	 t['\u248B'] = '\u0034\u002E';
	 t['\u248C'] = '\u0035\u002E';
	 t['\u248D'] = '\u0036\u002E';
	 t['\u248E'] = '\u0037\u002E';
	 t['\u248F'] = '\u0038\u002E';
	 t['\u2490'] = '\u0039\u002E';
	 t['\u2491'] = '\u0031\u0030\u002E';
	 t['\u2492'] = '\u0031\u0031\u002E';
	 t['\u2493'] = '\u0031\u0032\u002E';
	 t['\u2494'] = '\u0031\u0033\u002E';
	 t['\u2495'] = '\u0031\u0034\u002E';
	 t['\u2496'] = '\u0031\u0035\u002E';
	 t['\u2497'] = '\u0031\u0036\u002E';
	 t['\u2498'] = '\u0031\u0037\u002E';
	 t['\u2499'] = '\u0031\u0038\u002E';
	 t['\u249A'] = '\u0031\u0039\u002E';
	 t['\u249B'] = '\u0032\u0030\u002E';
	 t['\u249C'] = '\u0028\u0061\u0029';
	 t['\u249D'] = '\u0028\u0062\u0029';
	 t['\u249E'] = '\u0028\u0063\u0029';
	 t['\u249F'] = '\u0028\u0064\u0029';
	 t['\u24A0'] = '\u0028\u0065\u0029';
	 t['\u24A1'] = '\u0028\u0066\u0029';
	 t['\u24A2'] = '\u0028\u0067\u0029';
	 t['\u24A3'] = '\u0028\u0068\u0029';
	 t['\u24A4'] = '\u0028\u0069\u0029';
	 t['\u24A5'] = '\u0028\u006A\u0029';
	 t['\u24A6'] = '\u0028\u006B\u0029';
	 t['\u24A7'] = '\u0028\u006C\u0029';
	 t['\u24A8'] = '\u0028\u006D\u0029';
	 t['\u24A9'] = '\u0028\u006E\u0029';
	 t['\u24AA'] = '\u0028\u006F\u0029';
	 t['\u24AB'] = '\u0028\u0070\u0029';
	 t['\u24AC'] = '\u0028\u0071\u0029';
	 t['\u24AD'] = '\u0028\u0072\u0029';
	 t['\u24AE'] = '\u0028\u0073\u0029';
	 t['\u24AF'] = '\u0028\u0074\u0029';
	 t['\u24B0'] = '\u0028\u0075\u0029';
	 t['\u24B1'] = '\u0028\u0076\u0029';
	 t['\u24B2'] = '\u0028\u0077\u0029';
	 t['\u24B3'] = '\u0028\u0078\u0029';
	 t['\u24B4'] = '\u0028\u0079\u0029';
	 t['\u24B5'] = '\u0028\u007A\u0029';
	 t['\u2A0C'] = '\u222B\u222B\u222B\u222B';
	 t['\u2A74'] = '\u003A\u003A\u003D';
	 t['\u2A75'] = '\u003D\u003D';
	 t['\u2A76'] = '\u003D\u003D\u003D';
	 t['\u2E9F'] = '\u6BCD';
	 t['\u2EF3'] = '\u9F9F';
	 t['\u2F00'] = '\u4E00';
	 t['\u2F01'] = '\u4E28';
	 t['\u2F02'] = '\u4E36';
	 t['\u2F03'] = '\u4E3F';
	 t['\u2F04'] = '\u4E59';
	 t['\u2F05'] = '\u4E85';
	 t['\u2F06'] = '\u4E8C';
	 t['\u2F07'] = '\u4EA0';
	 t['\u2F08'] = '\u4EBA';
	 t['\u2F09'] = '\u513F';
	 t['\u2F0A'] = '\u5165';
	 t['\u2F0B'] = '\u516B';
	 t['\u2F0C'] = '\u5182';
	 t['\u2F0D'] = '\u5196';
	 t['\u2F0E'] = '\u51AB';
	 t['\u2F0F'] = '\u51E0';
	 t['\u2F10'] = '\u51F5';
	 t['\u2F11'] = '\u5200';
	 t['\u2F12'] = '\u529B';
	 t['\u2F13'] = '\u52F9';
	 t['\u2F14'] = '\u5315';
	 t['\u2F15'] = '\u531A';
	 t['\u2F16'] = '\u5338';
	 t['\u2F17'] = '\u5341';
	 t['\u2F18'] = '\u535C';
	 t['\u2F19'] = '\u5369';
	 t['\u2F1A'] = '\u5382';
	 t['\u2F1B'] = '\u53B6';
	 t['\u2F1C'] = '\u53C8';
	 t['\u2F1D'] = '\u53E3';
	 t['\u2F1E'] = '\u56D7';
	 t['\u2F1F'] = '\u571F';
	 t['\u2F20'] = '\u58EB';
	 t['\u2F21'] = '\u5902';
	 t['\u2F22'] = '\u590A';
	 t['\u2F23'] = '\u5915';
	 t['\u2F24'] = '\u5927';
	 t['\u2F25'] = '\u5973';
	 t['\u2F26'] = '\u5B50';
	 t['\u2F27'] = '\u5B80';
	 t['\u2F28'] = '\u5BF8';
	 t['\u2F29'] = '\u5C0F';
	 t['\u2F2A'] = '\u5C22';
	 t['\u2F2B'] = '\u5C38';
	 t['\u2F2C'] = '\u5C6E';
	 t['\u2F2D'] = '\u5C71';
	 t['\u2F2E'] = '\u5DDB';
	 t['\u2F2F'] = '\u5DE5';
	 t['\u2F30'] = '\u5DF1';
	 t['\u2F31'] = '\u5DFE';
	 t['\u2F32'] = '\u5E72';
	 t['\u2F33'] = '\u5E7A';
	 t['\u2F34'] = '\u5E7F';
	 t['\u2F35'] = '\u5EF4';
	 t['\u2F36'] = '\u5EFE';
	 t['\u2F37'] = '\u5F0B';
	 t['\u2F38'] = '\u5F13';
	 t['\u2F39'] = '\u5F50';
	 t['\u2F3A'] = '\u5F61';
	 t['\u2F3B'] = '\u5F73';
	 t['\u2F3C'] = '\u5FC3';
	 t['\u2F3D'] = '\u6208';
	 t['\u2F3E'] = '\u6236';
	 t['\u2F3F'] = '\u624B';
	 t['\u2F40'] = '\u652F';
	 t['\u2F41'] = '\u6534';
	 t['\u2F42'] = '\u6587';
	 t['\u2F43'] = '\u6597';
	 t['\u2F44'] = '\u65A4';
	 t['\u2F45'] = '\u65B9';
	 t['\u2F46'] = '\u65E0';
	 t['\u2F47'] = '\u65E5';
	 t['\u2F48'] = '\u66F0';
	 t['\u2F49'] = '\u6708';
	 t['\u2F4A'] = '\u6728';
	 t['\u2F4B'] = '\u6B20';
	 t['\u2F4C'] = '\u6B62';
	 t['\u2F4D'] = '\u6B79';
	 t['\u2F4E'] = '\u6BB3';
	 t['\u2F4F'] = '\u6BCB';
	 t['\u2F50'] = '\u6BD4';
	 t['\u2F51'] = '\u6BDB';
	 t['\u2F52'] = '\u6C0F';
	 t['\u2F53'] = '\u6C14';
	 t['\u2F54'] = '\u6C34';
	 t['\u2F55'] = '\u706B';
	 t['\u2F56'] = '\u722A';
	 t['\u2F57'] = '\u7236';
	 t['\u2F58'] = '\u723B';
	 t['\u2F59'] = '\u723F';
	 t['\u2F5A'] = '\u7247';
	 t['\u2F5B'] = '\u7259';
	 t['\u2F5C'] = '\u725B';
	 t['\u2F5D'] = '\u72AC';
	 t['\u2F5E'] = '\u7384';
	 t['\u2F5F'] = '\u7389';
	 t['\u2F60'] = '\u74DC';
	 t['\u2F61'] = '\u74E6';
	 t['\u2F62'] = '\u7518';
	 t['\u2F63'] = '\u751F';
	 t['\u2F64'] = '\u7528';
	 t['\u2F65'] = '\u7530';
	 t['\u2F66'] = '\u758B';
	 t['\u2F67'] = '\u7592';
	 t['\u2F68'] = '\u7676';
	 t['\u2F69'] = '\u767D';
	 t['\u2F6A'] = '\u76AE';
	 t['\u2F6B'] = '\u76BF';
	 t['\u2F6C'] = '\u76EE';
	 t['\u2F6D'] = '\u77DB';
	 t['\u2F6E'] = '\u77E2';
	 t['\u2F6F'] = '\u77F3';
	 t['\u2F70'] = '\u793A';
	 t['\u2F71'] = '\u79B8';
	 t['\u2F72'] = '\u79BE';
	 t['\u2F73'] = '\u7A74';
	 t['\u2F74'] = '\u7ACB';
	 t['\u2F75'] = '\u7AF9';
	 t['\u2F76'] = '\u7C73';
	 t['\u2F77'] = '\u7CF8';
	 t['\u2F78'] = '\u7F36';
	 t['\u2F79'] = '\u7F51';
	 t['\u2F7A'] = '\u7F8A';
	 t['\u2F7B'] = '\u7FBD';
	 t['\u2F7C'] = '\u8001';
	 t['\u2F7D'] = '\u800C';
	 t['\u2F7E'] = '\u8012';
	 t['\u2F7F'] = '\u8033';
	 t['\u2F80'] = '\u807F';
	 t['\u2F81'] = '\u8089';
	 t['\u2F82'] = '\u81E3';
	 t['\u2F83'] = '\u81EA';
	 t['\u2F84'] = '\u81F3';
	 t['\u2F85'] = '\u81FC';
	 t['\u2F86'] = '\u820C';
	 t['\u2F87'] = '\u821B';
	 t['\u2F88'] = '\u821F';
	 t['\u2F89'] = '\u826E';
	 t['\u2F8A'] = '\u8272';
	 t['\u2F8B'] = '\u8278';
	 t['\u2F8C'] = '\u864D';
	 t['\u2F8D'] = '\u866B';
	 t['\u2F8E'] = '\u8840';
	 t['\u2F8F'] = '\u884C';
	 t['\u2F90'] = '\u8863';
	 t['\u2F91'] = '\u897E';
	 t['\u2F92'] = '\u898B';
	 t['\u2F93'] = '\u89D2';
	 t['\u2F94'] = '\u8A00';
	 t['\u2F95'] = '\u8C37';
	 t['\u2F96'] = '\u8C46';
	 t['\u2F97'] = '\u8C55';
	 t['\u2F98'] = '\u8C78';
	 t['\u2F99'] = '\u8C9D';
	 t['\u2F9A'] = '\u8D64';
	 t['\u2F9B'] = '\u8D70';
	 t['\u2F9C'] = '\u8DB3';
	 t['\u2F9D'] = '\u8EAB';
	 t['\u2F9E'] = '\u8ECA';
	 t['\u2F9F'] = '\u8F9B';
	 t['\u2FA0'] = '\u8FB0';
	 t['\u2FA1'] = '\u8FB5';
	 t['\u2FA2'] = '\u9091';
	 t['\u2FA3'] = '\u9149';
	 t['\u2FA4'] = '\u91C6';
	 t['\u2FA5'] = '\u91CC';
	 t['\u2FA6'] = '\u91D1';
	 t['\u2FA7'] = '\u9577';
	 t['\u2FA8'] = '\u9580';
	 t['\u2FA9'] = '\u961C';
	 t['\u2FAA'] = '\u96B6';
	 t['\u2FAB'] = '\u96B9';
	 t['\u2FAC'] = '\u96E8';
	 t['\u2FAD'] = '\u9751';
	 t['\u2FAE'] = '\u975E';
	 t['\u2FAF'] = '\u9762';
	 t['\u2FB0'] = '\u9769';
	 t['\u2FB1'] = '\u97CB';
	 t['\u2FB2'] = '\u97ED';
	 t['\u2FB3'] = '\u97F3';
	 t['\u2FB4'] = '\u9801';
	 t['\u2FB5'] = '\u98A8';
	 t['\u2FB6'] = '\u98DB';
	 t['\u2FB7'] = '\u98DF';
	 t['\u2FB8'] = '\u9996';
	 t['\u2FB9'] = '\u9999';
	 t['\u2FBA'] = '\u99AC';
	 t['\u2FBB'] = '\u9AA8';
	 t['\u2FBC'] = '\u9AD8';
	 t['\u2FBD'] = '\u9ADF';
	 t['\u2FBE'] = '\u9B25';
	 t['\u2FBF'] = '\u9B2F';
	 t['\u2FC0'] = '\u9B32';
	 t['\u2FC1'] = '\u9B3C';
	 t['\u2FC2'] = '\u9B5A';
	 t['\u2FC3'] = '\u9CE5';
	 t['\u2FC4'] = '\u9E75';
	 t['\u2FC5'] = '\u9E7F';
	 t['\u2FC6'] = '\u9EA5';
	 t['\u2FC7'] = '\u9EBB';
	 t['\u2FC8'] = '\u9EC3';
	 t['\u2FC9'] = '\u9ECD';
	 t['\u2FCA'] = '\u9ED1';
	 t['\u2FCB'] = '\u9EF9';
	 t['\u2FCC'] = '\u9EFD';
	 t['\u2FCD'] = '\u9F0E';
	 t['\u2FCE'] = '\u9F13';
	 t['\u2FCF'] = '\u9F20';
	 t['\u2FD0'] = '\u9F3B';
	 t['\u2FD1'] = '\u9F4A';
	 t['\u2FD2'] = '\u9F52';
	 t['\u2FD3'] = '\u9F8D';
	 t['\u2FD4'] = '\u9F9C';
	 t['\u2FD5'] = '\u9FA0';
	 t['\u3036'] = '\u3012';
	 t['\u3038'] = '\u5341';
	 t['\u3039'] = '\u5344';
	 t['\u303A'] = '\u5345';
	 t['\u309B'] = '\u0020\u3099';
	 t['\u309C'] = '\u0020\u309A';
	 t['\u3131'] = '\u1100';
	 t['\u3132'] = '\u1101';
	 t['\u3133'] = '\u11AA';
	 t['\u3134'] = '\u1102';
	 t['\u3135'] = '\u11AC';
	 t['\u3136'] = '\u11AD';
	 t['\u3137'] = '\u1103';
	 t['\u3138'] = '\u1104';
	 t['\u3139'] = '\u1105';
	 t['\u313A'] = '\u11B0';
	 t['\u313B'] = '\u11B1';
	 t['\u313C'] = '\u11B2';
	 t['\u313D'] = '\u11B3';
	 t['\u313E'] = '\u11B4';
	 t['\u313F'] = '\u11B5';
	 t['\u3140'] = '\u111A';
	 t['\u3141'] = '\u1106';
	 t['\u3142'] = '\u1107';
	 t['\u3143'] = '\u1108';
	 t['\u3144'] = '\u1121';
	 t['\u3145'] = '\u1109';
	 t['\u3146'] = '\u110A';
	 t['\u3147'] = '\u110B';
	 t['\u3148'] = '\u110C';
	 t['\u3149'] = '\u110D';
	 t['\u314A'] = '\u110E';
	 t['\u314B'] = '\u110F';
	 t['\u314C'] = '\u1110';
	 t['\u314D'] = '\u1111';
	 t['\u314E'] = '\u1112';
	 t['\u314F'] = '\u1161';
	 t['\u3150'] = '\u1162';
	 t['\u3151'] = '\u1163';
	 t['\u3152'] = '\u1164';
	 t['\u3153'] = '\u1165';
	 t['\u3154'] = '\u1166';
	 t['\u3155'] = '\u1167';
	 t['\u3156'] = '\u1168';
	 t['\u3157'] = '\u1169';
	 t['\u3158'] = '\u116A';
	 t['\u3159'] = '\u116B';
	 t['\u315A'] = '\u116C';
	 t['\u315B'] = '\u116D';
	 t['\u315C'] = '\u116E';
	 t['\u315D'] = '\u116F';
	 t['\u315E'] = '\u1170';
	 t['\u315F'] = '\u1171';
	 t['\u3160'] = '\u1172';
	 t['\u3161'] = '\u1173';
	 t['\u3162'] = '\u1174';
	 t['\u3163'] = '\u1175';
	 t['\u3164'] = '\u1160';
	 t['\u3165'] = '\u1114';
	 t['\u3166'] = '\u1115';
	 t['\u3167'] = '\u11C7';
	 t['\u3168'] = '\u11C8';
	 t['\u3169'] = '\u11CC';
	 t['\u316A'] = '\u11CE';
	 t['\u316B'] = '\u11D3';
	 t['\u316C'] = '\u11D7';
	 t['\u316D'] = '\u11D9';
	 t['\u316E'] = '\u111C';
	 t['\u316F'] = '\u11DD';
	 t['\u3170'] = '\u11DF';
	 t['\u3171'] = '\u111D';
	 t['\u3172'] = '\u111E';
	 t['\u3173'] = '\u1120';
	 t['\u3174'] = '\u1122';
	 t['\u3175'] = '\u1123';
	 t['\u3176'] = '\u1127';
	 t['\u3177'] = '\u1129';
	 t['\u3178'] = '\u112B';
	 t['\u3179'] = '\u112C';
	 t['\u317A'] = '\u112D';
	 t['\u317B'] = '\u112E';
	 t['\u317C'] = '\u112F';
	 t['\u317D'] = '\u1132';
	 t['\u317E'] = '\u1136';
	 t['\u317F'] = '\u1140';
	 t['\u3180'] = '\u1147';
	 t['\u3181'] = '\u114C';
	 t['\u3182'] = '\u11F1';
	 t['\u3183'] = '\u11F2';
	 t['\u3184'] = '\u1157';
	 t['\u3185'] = '\u1158';
	 t['\u3186'] = '\u1159';
	 t['\u3187'] = '\u1184';
	 t['\u3188'] = '\u1185';
	 t['\u3189'] = '\u1188';
	 t['\u318A'] = '\u1191';
	 t['\u318B'] = '\u1192';
	 t['\u318C'] = '\u1194';
	 t['\u318D'] = '\u119E';
	 t['\u318E'] = '\u11A1';
	 t['\u3200'] = '\u0028\u1100\u0029';
	 t['\u3201'] = '\u0028\u1102\u0029';
	 t['\u3202'] = '\u0028\u1103\u0029';
	 t['\u3203'] = '\u0028\u1105\u0029';
	 t['\u3204'] = '\u0028\u1106\u0029';
	 t['\u3205'] = '\u0028\u1107\u0029';
	 t['\u3206'] = '\u0028\u1109\u0029';
	 t['\u3207'] = '\u0028\u110B\u0029';
	 t['\u3208'] = '\u0028\u110C\u0029';
	 t['\u3209'] = '\u0028\u110E\u0029';
	 t['\u320A'] = '\u0028\u110F\u0029';
	 t['\u320B'] = '\u0028\u1110\u0029';
	 t['\u320C'] = '\u0028\u1111\u0029';
	 t['\u320D'] = '\u0028\u1112\u0029';
	 t['\u320E'] = '\u0028\u1100\u1161\u0029';
	 t['\u320F'] = '\u0028\u1102\u1161\u0029';
	 t['\u3210'] = '\u0028\u1103\u1161\u0029';
	 t['\u3211'] = '\u0028\u1105\u1161\u0029';
	 t['\u3212'] = '\u0028\u1106\u1161\u0029';
	 t['\u3213'] = '\u0028\u1107\u1161\u0029';
	 t['\u3214'] = '\u0028\u1109\u1161\u0029';
	 t['\u3215'] = '\u0028\u110B\u1161\u0029';
	 t['\u3216'] = '\u0028\u110C\u1161\u0029';
	 t['\u3217'] = '\u0028\u110E\u1161\u0029';
	 t['\u3218'] = '\u0028\u110F\u1161\u0029';
	 t['\u3219'] = '\u0028\u1110\u1161\u0029';
	 t['\u321A'] = '\u0028\u1111\u1161\u0029';
	 t['\u321B'] = '\u0028\u1112\u1161\u0029';
	 t['\u321C'] = '\u0028\u110C\u116E\u0029';
	 t['\u321D'] = '\u0028\u110B\u1169\u110C\u1165\u11AB\u0029';
	 t['\u321E'] = '\u0028\u110B\u1169\u1112\u116E\u0029';
	 t['\u3220'] = '\u0028\u4E00\u0029';
	 t['\u3221'] = '\u0028\u4E8C\u0029';
	 t['\u3222'] = '\u0028\u4E09\u0029';
	 t['\u3223'] = '\u0028\u56DB\u0029';
	 t['\u3224'] = '\u0028\u4E94\u0029';
	 t['\u3225'] = '\u0028\u516D\u0029';
	 t['\u3226'] = '\u0028\u4E03\u0029';
	 t['\u3227'] = '\u0028\u516B\u0029';
	 t['\u3228'] = '\u0028\u4E5D\u0029';
	 t['\u3229'] = '\u0028\u5341\u0029';
	 t['\u322A'] = '\u0028\u6708\u0029';
	 t['\u322B'] = '\u0028\u706B\u0029';
	 t['\u322C'] = '\u0028\u6C34\u0029';
	 t['\u322D'] = '\u0028\u6728\u0029';
	 t['\u322E'] = '\u0028\u91D1\u0029';
	 t['\u322F'] = '\u0028\u571F\u0029';
	 t['\u3230'] = '\u0028\u65E5\u0029';
	 t['\u3231'] = '\u0028\u682A\u0029';
	 t['\u3232'] = '\u0028\u6709\u0029';
	 t['\u3233'] = '\u0028\u793E\u0029';
	 t['\u3234'] = '\u0028\u540D\u0029';
	 t['\u3235'] = '\u0028\u7279\u0029';
	 t['\u3236'] = '\u0028\u8CA1\u0029';
	 t['\u3237'] = '\u0028\u795D\u0029';
	 t['\u3238'] = '\u0028\u52B4\u0029';
	 t['\u3239'] = '\u0028\u4EE3\u0029';
	 t['\u323A'] = '\u0028\u547C\u0029';
	 t['\u323B'] = '\u0028\u5B66\u0029';
	 t['\u323C'] = '\u0028\u76E3\u0029';
	 t['\u323D'] = '\u0028\u4F01\u0029';
	 t['\u323E'] = '\u0028\u8CC7\u0029';
	 t['\u323F'] = '\u0028\u5354\u0029';
	 t['\u3240'] = '\u0028\u796D\u0029';
	 t['\u3241'] = '\u0028\u4F11\u0029';
	 t['\u3242'] = '\u0028\u81EA\u0029';
	 t['\u3243'] = '\u0028\u81F3\u0029';
	 t['\u32C0'] = '\u0031\u6708';
	 t['\u32C1'] = '\u0032\u6708';
	 t['\u32C2'] = '\u0033\u6708';
	 t['\u32C3'] = '\u0034\u6708';
	 t['\u32C4'] = '\u0035\u6708';
	 t['\u32C5'] = '\u0036\u6708';
	 t['\u32C6'] = '\u0037\u6708';
	 t['\u32C7'] = '\u0038\u6708';
	 t['\u32C8'] = '\u0039\u6708';
	 t['\u32C9'] = '\u0031\u0030\u6708';
	 t['\u32CA'] = '\u0031\u0031\u6708';
	 t['\u32CB'] = '\u0031\u0032\u6708';
	 t['\u3358'] = '\u0030\u70B9';
	 t['\u3359'] = '\u0031\u70B9';
	 t['\u335A'] = '\u0032\u70B9';
	 t['\u335B'] = '\u0033\u70B9';
	 t['\u335C'] = '\u0034\u70B9';
	 t['\u335D'] = '\u0035\u70B9';
	 t['\u335E'] = '\u0036\u70B9';
	 t['\u335F'] = '\u0037\u70B9';
	 t['\u3360'] = '\u0038\u70B9';
	 t['\u3361'] = '\u0039\u70B9';
	 t['\u3362'] = '\u0031\u0030\u70B9';
	 t['\u3363'] = '\u0031\u0031\u70B9';
	 t['\u3364'] = '\u0031\u0032\u70B9';
	 t['\u3365'] = '\u0031\u0033\u70B9';
	 t['\u3366'] = '\u0031\u0034\u70B9';
	 t['\u3367'] = '\u0031\u0035\u70B9';
	 t['\u3368'] = '\u0031\u0036\u70B9';
	 t['\u3369'] = '\u0031\u0037\u70B9';
	 t['\u336A'] = '\u0031\u0038\u70B9';
	 t['\u336B'] = '\u0031\u0039\u70B9';
	 t['\u336C'] = '\u0032\u0030\u70B9';
	 t['\u336D'] = '\u0032\u0031\u70B9';
	 t['\u336E'] = '\u0032\u0032\u70B9';
	 t['\u336F'] = '\u0032\u0033\u70B9';
	 t['\u3370'] = '\u0032\u0034\u70B9';
	 t['\u33E0'] = '\u0031\u65E5';
	 t['\u33E1'] = '\u0032\u65E5';
	 t['\u33E2'] = '\u0033\u65E5';
	 t['\u33E3'] = '\u0034\u65E5';
	 t['\u33E4'] = '\u0035\u65E5';
	 t['\u33E5'] = '\u0036\u65E5';
	 t['\u33E6'] = '\u0037\u65E5';
	 t['\u33E7'] = '\u0038\u65E5';
	 t['\u33E8'] = '\u0039\u65E5';
	 t['\u33E9'] = '\u0031\u0030\u65E5';
	 t['\u33EA'] = '\u0031\u0031\u65E5';
	 t['\u33EB'] = '\u0031\u0032\u65E5';
	 t['\u33EC'] = '\u0031\u0033\u65E5';
	 t['\u33ED'] = '\u0031\u0034\u65E5';
	 t['\u33EE'] = '\u0031\u0035\u65E5';
	 t['\u33EF'] = '\u0031\u0036\u65E5';
	 t['\u33F0'] = '\u0031\u0037\u65E5';
	 t['\u33F1'] = '\u0031\u0038\u65E5';
	 t['\u33F2'] = '\u0031\u0039\u65E5';
	 t['\u33F3'] = '\u0032\u0030\u65E5';
	 t['\u33F4'] = '\u0032\u0031\u65E5';
	 t['\u33F5'] = '\u0032\u0032\u65E5';
	 t['\u33F6'] = '\u0032\u0033\u65E5';
	 t['\u33F7'] = '\u0032\u0034\u65E5';
	 t['\u33F8'] = '\u0032\u0035\u65E5';
	 t['\u33F9'] = '\u0032\u0036\u65E5';
	 t['\u33FA'] = '\u0032\u0037\u65E5';
	 t['\u33FB'] = '\u0032\u0038\u65E5';
	 t['\u33FC'] = '\u0032\u0039\u65E5';
	 t['\u33FD'] = '\u0033\u0030\u65E5';
	 t['\u33FE'] = '\u0033\u0031\u65E5';
	 t['\uFB00'] = '\u0066\u0066';
	 t['\uFB01'] = '\u0066\u0069';
	 t['\uFB02'] = '\u0066\u006C';
	 t['\uFB03'] = '\u0066\u0066\u0069';
	 t['\uFB04'] = '\u0066\u0066\u006C';
	 t['\uFB05'] = '\u017F\u0074';
	 t['\uFB06'] = '\u0073\u0074';
	 t['\uFB13'] = '\u0574\u0576';
	 t['\uFB14'] = '\u0574\u0565';
	 t['\uFB15'] = '\u0574\u056B';
	 t['\uFB16'] = '\u057E\u0576';
	 t['\uFB17'] = '\u0574\u056D';
	 t['\uFB4F'] = '\u05D0\u05DC';
	 t['\uFB50'] = '\u0671';
	 t['\uFB51'] = '\u0671';
	 t['\uFB52'] = '\u067B';
	 t['\uFB53'] = '\u067B';
	 t['\uFB54'] = '\u067B';
	 t['\uFB55'] = '\u067B';
	 t['\uFB56'] = '\u067E';
	 t['\uFB57'] = '\u067E';
	 t['\uFB58'] = '\u067E';
	 t['\uFB59'] = '\u067E';
	 t['\uFB5A'] = '\u0680';
	 t['\uFB5B'] = '\u0680';
	 t['\uFB5C'] = '\u0680';
	 t['\uFB5D'] = '\u0680';
	 t['\uFB5E'] = '\u067A';
	 t['\uFB5F'] = '\u067A';
	 t['\uFB60'] = '\u067A';
	 t['\uFB61'] = '\u067A';
	 t['\uFB62'] = '\u067F';
	 t['\uFB63'] = '\u067F';
	 t['\uFB64'] = '\u067F';
	 t['\uFB65'] = '\u067F';
	 t['\uFB66'] = '\u0679';
	 t['\uFB67'] = '\u0679';
	 t['\uFB68'] = '\u0679';
	 t['\uFB69'] = '\u0679';
	 t['\uFB6A'] = '\u06A4';
	 t['\uFB6B'] = '\u06A4';
	 t['\uFB6C'] = '\u06A4';
	 t['\uFB6D'] = '\u06A4';
	 t['\uFB6E'] = '\u06A6';
	 t['\uFB6F'] = '\u06A6';
	 t['\uFB70'] = '\u06A6';
	 t['\uFB71'] = '\u06A6';
	 t['\uFB72'] = '\u0684';
	 t['\uFB73'] = '\u0684';
	 t['\uFB74'] = '\u0684';
	 t['\uFB75'] = '\u0684';
	 t['\uFB76'] = '\u0683';
	 t['\uFB77'] = '\u0683';
	 t['\uFB78'] = '\u0683';
	 t['\uFB79'] = '\u0683';
	 t['\uFB7A'] = '\u0686';
	 t['\uFB7B'] = '\u0686';
	 t['\uFB7C'] = '\u0686';
	 t['\uFB7D'] = '\u0686';
	 t['\uFB7E'] = '\u0687';
	 t['\uFB7F'] = '\u0687';
	 t['\uFB80'] = '\u0687';
	 t['\uFB81'] = '\u0687';
	 t['\uFB82'] = '\u068D';
	 t['\uFB83'] = '\u068D';
	 t['\uFB84'] = '\u068C';
	 t['\uFB85'] = '\u068C';
	 t['\uFB86'] = '\u068E';
	 t['\uFB87'] = '\u068E';
	 t['\uFB88'] = '\u0688';
	 t['\uFB89'] = '\u0688';
	 t['\uFB8A'] = '\u0698';
	 t['\uFB8B'] = '\u0698';
	 t['\uFB8C'] = '\u0691';
	 t['\uFB8D'] = '\u0691';
	 t['\uFB8E'] = '\u06A9';
	 t['\uFB8F'] = '\u06A9';
	 t['\uFB90'] = '\u06A9';
	 t['\uFB91'] = '\u06A9';
	 t['\uFB92'] = '\u06AF';
	 t['\uFB93'] = '\u06AF';
	 t['\uFB94'] = '\u06AF';
	 t['\uFB95'] = '\u06AF';
	 t['\uFB96'] = '\u06B3';
	 t['\uFB97'] = '\u06B3';
	 t['\uFB98'] = '\u06B3';
	 t['\uFB99'] = '\u06B3';
	 t['\uFB9A'] = '\u06B1';
	 t['\uFB9B'] = '\u06B1';
	 t['\uFB9C'] = '\u06B1';
	 t['\uFB9D'] = '\u06B1';
	 t['\uFB9E'] = '\u06BA';
	 t['\uFB9F'] = '\u06BA';
	 t['\uFBA0'] = '\u06BB';
	 t['\uFBA1'] = '\u06BB';
	 t['\uFBA2'] = '\u06BB';
	 t['\uFBA3'] = '\u06BB';
	 t['\uFBA4'] = '\u06C0';
	 t['\uFBA5'] = '\u06C0';
	 t['\uFBA6'] = '\u06C1';
	 t['\uFBA7'] = '\u06C1';
	 t['\uFBA8'] = '\u06C1';
	 t['\uFBA9'] = '\u06C1';
	 t['\uFBAA'] = '\u06BE';
	 t['\uFBAB'] = '\u06BE';
	 t['\uFBAC'] = '\u06BE';
	 t['\uFBAD'] = '\u06BE';
	 t['\uFBAE'] = '\u06D2';
	 t['\uFBAF'] = '\u06D2';
	 t['\uFBB0'] = '\u06D3';
	 t['\uFBB1'] = '\u06D3';
	 t['\uFBD3'] = '\u06AD';
	 t['\uFBD4'] = '\u06AD';
	 t['\uFBD5'] = '\u06AD';
	 t['\uFBD6'] = '\u06AD';
	 t['\uFBD7'] = '\u06C7';
	 t['\uFBD8'] = '\u06C7';
	 t['\uFBD9'] = '\u06C6';
	 t['\uFBDA'] = '\u06C6';
	 t['\uFBDB'] = '\u06C8';
	 t['\uFBDC'] = '\u06C8';
	 t['\uFBDD'] = '\u0677';
	 t['\uFBDE'] = '\u06CB';
	 t['\uFBDF'] = '\u06CB';
	 t['\uFBE0'] = '\u06C5';
	 t['\uFBE1'] = '\u06C5';
	 t['\uFBE2'] = '\u06C9';
	 t['\uFBE3'] = '\u06C9';
	 t['\uFBE4'] = '\u06D0';
	 t['\uFBE5'] = '\u06D0';
	 t['\uFBE6'] = '\u06D0';
	 t['\uFBE7'] = '\u06D0';
	 t['\uFBE8'] = '\u0649';
	 t['\uFBE9'] = '\u0649';
	 t['\uFBEA'] = '\u0626\u0627';
	 t['\uFBEB'] = '\u0626\u0627';
	 t['\uFBEC'] = '\u0626\u06D5';
	 t['\uFBED'] = '\u0626\u06D5';
	 t['\uFBEE'] = '\u0626\u0648';
	 t['\uFBEF'] = '\u0626\u0648';
	 t['\uFBF0'] = '\u0626\u06C7';
	 t['\uFBF1'] = '\u0626\u06C7';
	 t['\uFBF2'] = '\u0626\u06C6';
	 t['\uFBF3'] = '\u0626\u06C6';
	 t['\uFBF4'] = '\u0626\u06C8';
	 t['\uFBF5'] = '\u0626\u06C8';
	 t['\uFBF6'] = '\u0626\u06D0';
	 t['\uFBF7'] = '\u0626\u06D0';
	 t['\uFBF8'] = '\u0626\u06D0';
	 t['\uFBF9'] = '\u0626\u0649';
	 t['\uFBFA'] = '\u0626\u0649';
	 t['\uFBFB'] = '\u0626\u0649';
	 t['\uFBFC'] = '\u06CC';
	 t['\uFBFD'] = '\u06CC';
	 t['\uFBFE'] = '\u06CC';
	 t['\uFBFF'] = '\u06CC';
	 t['\uFC00'] = '\u0626\u062C';
	 t['\uFC01'] = '\u0626\u062D';
	 t['\uFC02'] = '\u0626\u0645';
	 t['\uFC03'] = '\u0626\u0649';
	 t['\uFC04'] = '\u0626\u064A';
	 t['\uFC05'] = '\u0628\u062C';
	 t['\uFC06'] = '\u0628\u062D';
	 t['\uFC07'] = '\u0628\u062E';
	 t['\uFC08'] = '\u0628\u0645';
	 t['\uFC09'] = '\u0628\u0649';
	 t['\uFC0A'] = '\u0628\u064A';
	 t['\uFC0B'] = '\u062A\u062C';
	 t['\uFC0C'] = '\u062A\u062D';
	 t['\uFC0D'] = '\u062A\u062E';
	 t['\uFC0E'] = '\u062A\u0645';
	 t['\uFC0F'] = '\u062A\u0649';
	 t['\uFC10'] = '\u062A\u064A';
	 t['\uFC11'] = '\u062B\u062C';
	 t['\uFC12'] = '\u062B\u0645';
	 t['\uFC13'] = '\u062B\u0649';
	 t['\uFC14'] = '\u062B\u064A';
	 t['\uFC15'] = '\u062C\u062D';
	 t['\uFC16'] = '\u062C\u0645';
	 t['\uFC17'] = '\u062D\u062C';
	 t['\uFC18'] = '\u062D\u0645';
	 t['\uFC19'] = '\u062E\u062C';
	 t['\uFC1A'] = '\u062E\u062D';
	 t['\uFC1B'] = '\u062E\u0645';
	 t['\uFC1C'] = '\u0633\u062C';
	 t['\uFC1D'] = '\u0633\u062D';
	 t['\uFC1E'] = '\u0633\u062E';
	 t['\uFC1F'] = '\u0633\u0645';
	 t['\uFC20'] = '\u0635\u062D';
	 t['\uFC21'] = '\u0635\u0645';
	 t['\uFC22'] = '\u0636\u062C';
	 t['\uFC23'] = '\u0636\u062D';
	 t['\uFC24'] = '\u0636\u062E';
	 t['\uFC25'] = '\u0636\u0645';
	 t['\uFC26'] = '\u0637\u062D';
	 t['\uFC27'] = '\u0637\u0645';
	 t['\uFC28'] = '\u0638\u0645';
	 t['\uFC29'] = '\u0639\u062C';
	 t['\uFC2A'] = '\u0639\u0645';
	 t['\uFC2B'] = '\u063A\u062C';
	 t['\uFC2C'] = '\u063A\u0645';
	 t['\uFC2D'] = '\u0641\u062C';
	 t['\uFC2E'] = '\u0641\u062D';
	 t['\uFC2F'] = '\u0641\u062E';
	 t['\uFC30'] = '\u0641\u0645';
	 t['\uFC31'] = '\u0641\u0649';
	 t['\uFC32'] = '\u0641\u064A';
	 t['\uFC33'] = '\u0642\u062D';
	 t['\uFC34'] = '\u0642\u0645';
	 t['\uFC35'] = '\u0642\u0649';
	 t['\uFC36'] = '\u0642\u064A';
	 t['\uFC37'] = '\u0643\u0627';
	 t['\uFC38'] = '\u0643\u062C';
	 t['\uFC39'] = '\u0643\u062D';
	 t['\uFC3A'] = '\u0643\u062E';
	 t['\uFC3B'] = '\u0643\u0644';
	 t['\uFC3C'] = '\u0643\u0645';
	 t['\uFC3D'] = '\u0643\u0649';
	 t['\uFC3E'] = '\u0643\u064A';
	 t['\uFC3F'] = '\u0644\u062C';
	 t['\uFC40'] = '\u0644\u062D';
	 t['\uFC41'] = '\u0644\u062E';
	 t['\uFC42'] = '\u0644\u0645';
	 t['\uFC43'] = '\u0644\u0649';
	 t['\uFC44'] = '\u0644\u064A';
	 t['\uFC45'] = '\u0645\u062C';
	 t['\uFC46'] = '\u0645\u062D';
	 t['\uFC47'] = '\u0645\u062E';
	 t['\uFC48'] = '\u0645\u0645';
	 t['\uFC49'] = '\u0645\u0649';
	 t['\uFC4A'] = '\u0645\u064A';
	 t['\uFC4B'] = '\u0646\u062C';
	 t['\uFC4C'] = '\u0646\u062D';
	 t['\uFC4D'] = '\u0646\u062E';
	 t['\uFC4E'] = '\u0646\u0645';
	 t['\uFC4F'] = '\u0646\u0649';
	 t['\uFC50'] = '\u0646\u064A';
	 t['\uFC51'] = '\u0647\u062C';
	 t['\uFC52'] = '\u0647\u0645';
	 t['\uFC53'] = '\u0647\u0649';
	 t['\uFC54'] = '\u0647\u064A';
	 t['\uFC55'] = '\u064A\u062C';
	 t['\uFC56'] = '\u064A\u062D';
	 t['\uFC57'] = '\u064A\u062E';
	 t['\uFC58'] = '\u064A\u0645';
	 t['\uFC59'] = '\u064A\u0649';
	 t['\uFC5A'] = '\u064A\u064A';
	 t['\uFC5B'] = '\u0630\u0670';
	 t['\uFC5C'] = '\u0631\u0670';
	 t['\uFC5D'] = '\u0649\u0670';
	 t['\uFC5E'] = '\u0020\u064C\u0651';
	 t['\uFC5F'] = '\u0020\u064D\u0651';
	 t['\uFC60'] = '\u0020\u064E\u0651';
	 t['\uFC61'] = '\u0020\u064F\u0651';
	 t['\uFC62'] = '\u0020\u0650\u0651';
	 t['\uFC63'] = '\u0020\u0651\u0670';
	 t['\uFC64'] = '\u0626\u0631';
	 t['\uFC65'] = '\u0626\u0632';
	 t['\uFC66'] = '\u0626\u0645';
	 t['\uFC67'] = '\u0626\u0646';
	 t['\uFC68'] = '\u0626\u0649';
	 t['\uFC69'] = '\u0626\u064A';
	 t['\uFC6A'] = '\u0628\u0631';
	 t['\uFC6B'] = '\u0628\u0632';
	 t['\uFC6C'] = '\u0628\u0645';
	 t['\uFC6D'] = '\u0628\u0646';
	 t['\uFC6E'] = '\u0628\u0649';
	 t['\uFC6F'] = '\u0628\u064A';
	 t['\uFC70'] = '\u062A\u0631';
	 t['\uFC71'] = '\u062A\u0632';
	 t['\uFC72'] = '\u062A\u0645';
	 t['\uFC73'] = '\u062A\u0646';
	 t['\uFC74'] = '\u062A\u0649';
	 t['\uFC75'] = '\u062A\u064A';
	 t['\uFC76'] = '\u062B\u0631';
	 t['\uFC77'] = '\u062B\u0632';
	 t['\uFC78'] = '\u062B\u0645';
	 t['\uFC79'] = '\u062B\u0646';
	 t['\uFC7A'] = '\u062B\u0649';
	 t['\uFC7B'] = '\u062B\u064A';
	 t['\uFC7C'] = '\u0641\u0649';
	 t['\uFC7D'] = '\u0641\u064A';
	 t['\uFC7E'] = '\u0642\u0649';
	 t['\uFC7F'] = '\u0642\u064A';
	 t['\uFC80'] = '\u0643\u0627';
	 t['\uFC81'] = '\u0643\u0644';
	 t['\uFC82'] = '\u0643\u0645';
	 t['\uFC83'] = '\u0643\u0649';
	 t['\uFC84'] = '\u0643\u064A';
	 t['\uFC85'] = '\u0644\u0645';
	 t['\uFC86'] = '\u0644\u0649';
	 t['\uFC87'] = '\u0644\u064A';
	 t['\uFC88'] = '\u0645\u0627';
	 t['\uFC89'] = '\u0645\u0645';
	 t['\uFC8A'] = '\u0646\u0631';
	 t['\uFC8B'] = '\u0646\u0632';
	 t['\uFC8C'] = '\u0646\u0645';
	 t['\uFC8D'] = '\u0646\u0646';
	 t['\uFC8E'] = '\u0646\u0649';
	 t['\uFC8F'] = '\u0646\u064A';
	 t['\uFC90'] = '\u0649\u0670';
	 t['\uFC91'] = '\u064A\u0631';
	 t['\uFC92'] = '\u064A\u0632';
	 t['\uFC93'] = '\u064A\u0645';
	 t['\uFC94'] = '\u064A\u0646';
	 t['\uFC95'] = '\u064A\u0649';
	 t['\uFC96'] = '\u064A\u064A';
	 t['\uFC97'] = '\u0626\u062C';
	 t['\uFC98'] = '\u0626\u062D';
	 t['\uFC99'] = '\u0626\u062E';
	 t['\uFC9A'] = '\u0626\u0645';
	 t['\uFC9B'] = '\u0626\u0647';
	 t['\uFC9C'] = '\u0628\u062C';
	 t['\uFC9D'] = '\u0628\u062D';
	 t['\uFC9E'] = '\u0628\u062E';
	 t['\uFC9F'] = '\u0628\u0645';
	 t['\uFCA0'] = '\u0628\u0647';
	 t['\uFCA1'] = '\u062A\u062C';
	 t['\uFCA2'] = '\u062A\u062D';
	 t['\uFCA3'] = '\u062A\u062E';
	 t['\uFCA4'] = '\u062A\u0645';
	 t['\uFCA5'] = '\u062A\u0647';
	 t['\uFCA6'] = '\u062B\u0645';
	 t['\uFCA7'] = '\u062C\u062D';
	 t['\uFCA8'] = '\u062C\u0645';
	 t['\uFCA9'] = '\u062D\u062C';
	 t['\uFCAA'] = '\u062D\u0645';
	 t['\uFCAB'] = '\u062E\u062C';
	 t['\uFCAC'] = '\u062E\u0645';
	 t['\uFCAD'] = '\u0633\u062C';
	 t['\uFCAE'] = '\u0633\u062D';
	 t['\uFCAF'] = '\u0633\u062E';
	 t['\uFCB0'] = '\u0633\u0645';
	 t['\uFCB1'] = '\u0635\u062D';
	 t['\uFCB2'] = '\u0635\u062E';
	 t['\uFCB3'] = '\u0635\u0645';
	 t['\uFCB4'] = '\u0636\u062C';
	 t['\uFCB5'] = '\u0636\u062D';
	 t['\uFCB6'] = '\u0636\u062E';
	 t['\uFCB7'] = '\u0636\u0645';
	 t['\uFCB8'] = '\u0637\u062D';
	 t['\uFCB9'] = '\u0638\u0645';
	 t['\uFCBA'] = '\u0639\u062C';
	 t['\uFCBB'] = '\u0639\u0645';
	 t['\uFCBC'] = '\u063A\u062C';
	 t['\uFCBD'] = '\u063A\u0645';
	 t['\uFCBE'] = '\u0641\u062C';
	 t['\uFCBF'] = '\u0641\u062D';
	 t['\uFCC0'] = '\u0641\u062E';
	 t['\uFCC1'] = '\u0641\u0645';
	 t['\uFCC2'] = '\u0642\u062D';
	 t['\uFCC3'] = '\u0642\u0645';
	 t['\uFCC4'] = '\u0643\u062C';
	 t['\uFCC5'] = '\u0643\u062D';
	 t['\uFCC6'] = '\u0643\u062E';
	 t['\uFCC7'] = '\u0643\u0644';
	 t['\uFCC8'] = '\u0643\u0645';
	 t['\uFCC9'] = '\u0644\u062C';
	 t['\uFCCA'] = '\u0644\u062D';
	 t['\uFCCB'] = '\u0644\u062E';
	 t['\uFCCC'] = '\u0644\u0645';
	 t['\uFCCD'] = '\u0644\u0647';
	 t['\uFCCE'] = '\u0645\u062C';
	 t['\uFCCF'] = '\u0645\u062D';
	 t['\uFCD0'] = '\u0645\u062E';
	 t['\uFCD1'] = '\u0645\u0645';
	 t['\uFCD2'] = '\u0646\u062C';
	 t['\uFCD3'] = '\u0646\u062D';
	 t['\uFCD4'] = '\u0646\u062E';
	 t['\uFCD5'] = '\u0646\u0645';
	 t['\uFCD6'] = '\u0646\u0647';
	 t['\uFCD7'] = '\u0647\u062C';
	 t['\uFCD8'] = '\u0647\u0645';
	 t['\uFCD9'] = '\u0647\u0670';
	 t['\uFCDA'] = '\u064A\u062C';
	 t['\uFCDB'] = '\u064A\u062D';
	 t['\uFCDC'] = '\u064A\u062E';
	 t['\uFCDD'] = '\u064A\u0645';
	 t['\uFCDE'] = '\u064A\u0647';
	 t['\uFCDF'] = '\u0626\u0645';
	 t['\uFCE0'] = '\u0626\u0647';
	 t['\uFCE1'] = '\u0628\u0645';
	 t['\uFCE2'] = '\u0628\u0647';
	 t['\uFCE3'] = '\u062A\u0645';
	 t['\uFCE4'] = '\u062A\u0647';
	 t['\uFCE5'] = '\u062B\u0645';
	 t['\uFCE6'] = '\u062B\u0647';
	 t['\uFCE7'] = '\u0633\u0645';
	 t['\uFCE8'] = '\u0633\u0647';
	 t['\uFCE9'] = '\u0634\u0645';
	 t['\uFCEA'] = '\u0634\u0647';
	 t['\uFCEB'] = '\u0643\u0644';
	 t['\uFCEC'] = '\u0643\u0645';
	 t['\uFCED'] = '\u0644\u0645';
	 t['\uFCEE'] = '\u0646\u0645';
	 t['\uFCEF'] = '\u0646\u0647';
	 t['\uFCF0'] = '\u064A\u0645';
	 t['\uFCF1'] = '\u064A\u0647';
	 t['\uFCF2'] = '\u0640\u064E\u0651';
	 t['\uFCF3'] = '\u0640\u064F\u0651';
	 t['\uFCF4'] = '\u0640\u0650\u0651';
	 t['\uFCF5'] = '\u0637\u0649';
	 t['\uFCF6'] = '\u0637\u064A';
	 t['\uFCF7'] = '\u0639\u0649';
	 t['\uFCF8'] = '\u0639\u064A';
	 t['\uFCF9'] = '\u063A\u0649';
	 t['\uFCFA'] = '\u063A\u064A';
	 t['\uFCFB'] = '\u0633\u0649';
	 t['\uFCFC'] = '\u0633\u064A';
	 t['\uFCFD'] = '\u0634\u0649';
	 t['\uFCFE'] = '\u0634\u064A';
	 t['\uFCFF'] = '\u062D\u0649';
	 t['\uFD00'] = '\u062D\u064A';
	 t['\uFD01'] = '\u062C\u0649';
	 t['\uFD02'] = '\u062C\u064A';
	 t['\uFD03'] = '\u062E\u0649';
	 t['\uFD04'] = '\u062E\u064A';
	 t['\uFD05'] = '\u0635\u0649';
	 t['\uFD06'] = '\u0635\u064A';
	 t['\uFD07'] = '\u0636\u0649';
	 t['\uFD08'] = '\u0636\u064A';
	 t['\uFD09'] = '\u0634\u062C';
	 t['\uFD0A'] = '\u0634\u062D';
	 t['\uFD0B'] = '\u0634\u062E';
	 t['\uFD0C'] = '\u0634\u0645';
	 t['\uFD0D'] = '\u0634\u0631';
	 t['\uFD0E'] = '\u0633\u0631';
	 t['\uFD0F'] = '\u0635\u0631';
	 t['\uFD10'] = '\u0636\u0631';
	 t['\uFD11'] = '\u0637\u0649';
	 t['\uFD12'] = '\u0637\u064A';
	 t['\uFD13'] = '\u0639\u0649';
	 t['\uFD14'] = '\u0639\u064A';
	 t['\uFD15'] = '\u063A\u0649';
	 t['\uFD16'] = '\u063A\u064A';
	 t['\uFD17'] = '\u0633\u0649';
	 t['\uFD18'] = '\u0633\u064A';
	 t['\uFD19'] = '\u0634\u0649';
	 t['\uFD1A'] = '\u0634\u064A';
	 t['\uFD1B'] = '\u062D\u0649';
	 t['\uFD1C'] = '\u062D\u064A';
	 t['\uFD1D'] = '\u062C\u0649';
	 t['\uFD1E'] = '\u062C\u064A';
	 t['\uFD1F'] = '\u062E\u0649';
	 t['\uFD20'] = '\u062E\u064A';
	 t['\uFD21'] = '\u0635\u0649';
	 t['\uFD22'] = '\u0635\u064A';
	 t['\uFD23'] = '\u0636\u0649';
	 t['\uFD24'] = '\u0636\u064A';
	 t['\uFD25'] = '\u0634\u062C';
	 t['\uFD26'] = '\u0634\u062D';
	 t['\uFD27'] = '\u0634\u062E';
	 t['\uFD28'] = '\u0634\u0645';
	 t['\uFD29'] = '\u0634\u0631';
	 t['\uFD2A'] = '\u0633\u0631';
	 t['\uFD2B'] = '\u0635\u0631';
	 t['\uFD2C'] = '\u0636\u0631';
	 t['\uFD2D'] = '\u0634\u062C';
	 t['\uFD2E'] = '\u0634\u062D';
	 t['\uFD2F'] = '\u0634\u062E';
	 t['\uFD30'] = '\u0634\u0645';
	 t['\uFD31'] = '\u0633\u0647';
	 t['\uFD32'] = '\u0634\u0647';
	 t['\uFD33'] = '\u0637\u0645';
	 t['\uFD34'] = '\u0633\u062C';
	 t['\uFD35'] = '\u0633\u062D';
	 t['\uFD36'] = '\u0633\u062E';
	 t['\uFD37'] = '\u0634\u062C';
	 t['\uFD38'] = '\u0634\u062D';
	 t['\uFD39'] = '\u0634\u062E';
	 t['\uFD3A'] = '\u0637\u0645';
	 t['\uFD3B'] = '\u0638\u0645';
	 t['\uFD3C'] = '\u0627\u064B';
	 t['\uFD3D'] = '\u0627\u064B';
	 t['\uFD50'] = '\u062A\u062C\u0645';
	 t['\uFD51'] = '\u062A\u062D\u062C';
	 t['\uFD52'] = '\u062A\u062D\u062C';
	 t['\uFD53'] = '\u062A\u062D\u0645';
	 t['\uFD54'] = '\u062A\u062E\u0645';
	 t['\uFD55'] = '\u062A\u0645\u062C';
	 t['\uFD56'] = '\u062A\u0645\u062D';
	 t['\uFD57'] = '\u062A\u0645\u062E';
	 t['\uFD58'] = '\u062C\u0645\u062D';
	 t['\uFD59'] = '\u062C\u0645\u062D';
	 t['\uFD5A'] = '\u062D\u0645\u064A';
	 t['\uFD5B'] = '\u062D\u0645\u0649';
	 t['\uFD5C'] = '\u0633\u062D\u062C';
	 t['\uFD5D'] = '\u0633\u062C\u062D';
	 t['\uFD5E'] = '\u0633\u062C\u0649';
	 t['\uFD5F'] = '\u0633\u0645\u062D';
	 t['\uFD60'] = '\u0633\u0645\u062D';
	 t['\uFD61'] = '\u0633\u0645\u062C';
	 t['\uFD62'] = '\u0633\u0645\u0645';
	 t['\uFD63'] = '\u0633\u0645\u0645';
	 t['\uFD64'] = '\u0635\u062D\u062D';
	 t['\uFD65'] = '\u0635\u062D\u062D';
	 t['\uFD66'] = '\u0635\u0645\u0645';
	 t['\uFD67'] = '\u0634\u062D\u0645';
	 t['\uFD68'] = '\u0634\u062D\u0645';
	 t['\uFD69'] = '\u0634\u062C\u064A';
	 t['\uFD6A'] = '\u0634\u0645\u062E';
	 t['\uFD6B'] = '\u0634\u0645\u062E';
	 t['\uFD6C'] = '\u0634\u0645\u0645';
	 t['\uFD6D'] = '\u0634\u0645\u0645';
	 t['\uFD6E'] = '\u0636\u062D\u0649';
	 t['\uFD6F'] = '\u0636\u062E\u0645';
	 t['\uFD70'] = '\u0636\u062E\u0645';
	 t['\uFD71'] = '\u0637\u0645\u062D';
	 t['\uFD72'] = '\u0637\u0645\u062D';
	 t['\uFD73'] = '\u0637\u0645\u0645';
	 t['\uFD74'] = '\u0637\u0645\u064A';
	 t['\uFD75'] = '\u0639\u062C\u0645';
	 t['\uFD76'] = '\u0639\u0645\u0645';
	 t['\uFD77'] = '\u0639\u0645\u0645';
	 t['\uFD78'] = '\u0639\u0645\u0649';
	 t['\uFD79'] = '\u063A\u0645\u0645';
	 t['\uFD7A'] = '\u063A\u0645\u064A';
	 t['\uFD7B'] = '\u063A\u0645\u0649';
	 t['\uFD7C'] = '\u0641\u062E\u0645';
	 t['\uFD7D'] = '\u0641\u062E\u0645';
	 t['\uFD7E'] = '\u0642\u0645\u062D';
	 t['\uFD7F'] = '\u0642\u0645\u0645';
	 t['\uFD80'] = '\u0644\u062D\u0645';
	 t['\uFD81'] = '\u0644\u062D\u064A';
	 t['\uFD82'] = '\u0644\u062D\u0649';
	 t['\uFD83'] = '\u0644\u062C\u062C';
	 t['\uFD84'] = '\u0644\u062C\u062C';
	 t['\uFD85'] = '\u0644\u062E\u0645';
	 t['\uFD86'] = '\u0644\u062E\u0645';
	 t['\uFD87'] = '\u0644\u0645\u062D';
	 t['\uFD88'] = '\u0644\u0645\u062D';
	 t['\uFD89'] = '\u0645\u062D\u062C';
	 t['\uFD8A'] = '\u0645\u062D\u0645';
	 t['\uFD8B'] = '\u0645\u062D\u064A';
	 t['\uFD8C'] = '\u0645\u062C\u062D';
	 t['\uFD8D'] = '\u0645\u062C\u0645';
	 t['\uFD8E'] = '\u0645\u062E\u062C';
	 t['\uFD8F'] = '\u0645\u062E\u0645';
	 t['\uFD92'] = '\u0645\u062C\u062E';
	 t['\uFD93'] = '\u0647\u0645\u062C';
	 t['\uFD94'] = '\u0647\u0645\u0645';
	 t['\uFD95'] = '\u0646\u062D\u0645';
	 t['\uFD96'] = '\u0646\u062D\u0649';
	 t['\uFD97'] = '\u0646\u062C\u0645';
	 t['\uFD98'] = '\u0646\u062C\u0645';
	 t['\uFD99'] = '\u0646\u062C\u0649';
	 t['\uFD9A'] = '\u0646\u0645\u064A';
	 t['\uFD9B'] = '\u0646\u0645\u0649';
	 t['\uFD9C'] = '\u064A\u0645\u0645';
	 t['\uFD9D'] = '\u064A\u0645\u0645';
	 t['\uFD9E'] = '\u0628\u062E\u064A';
	 t['\uFD9F'] = '\u062A\u062C\u064A';
	 t['\uFDA0'] = '\u062A\u062C\u0649';
	 t['\uFDA1'] = '\u062A\u062E\u064A';
	 t['\uFDA2'] = '\u062A\u062E\u0649';
	 t['\uFDA3'] = '\u062A\u0645\u064A';
	 t['\uFDA4'] = '\u062A\u0645\u0649';
	 t['\uFDA5'] = '\u062C\u0645\u064A';
	 t['\uFDA6'] = '\u062C\u062D\u0649';
	 t['\uFDA7'] = '\u062C\u0645\u0649';
	 t['\uFDA8'] = '\u0633\u062E\u0649';
	 t['\uFDA9'] = '\u0635\u062D\u064A';
	 t['\uFDAA'] = '\u0634\u062D\u064A';
	 t['\uFDAB'] = '\u0636\u062D\u064A';
	 t['\uFDAC'] = '\u0644\u062C\u064A';
	 t['\uFDAD'] = '\u0644\u0645\u064A';
	 t['\uFDAE'] = '\u064A\u062D\u064A';
	 t['\uFDAF'] = '\u064A\u062C\u064A';
	 t['\uFDB0'] = '\u064A\u0645\u064A';
	 t['\uFDB1'] = '\u0645\u0645\u064A';
	 t['\uFDB2'] = '\u0642\u0645\u064A';
	 t['\uFDB3'] = '\u0646\u062D\u064A';
	 t['\uFDB4'] = '\u0642\u0645\u062D';
	 t['\uFDB5'] = '\u0644\u062D\u0645';
	 t['\uFDB6'] = '\u0639\u0645\u064A';
	 t['\uFDB7'] = '\u0643\u0645\u064A';
	 t['\uFDB8'] = '\u0646\u062C\u062D';
	 t['\uFDB9'] = '\u0645\u062E\u064A';
	 t['\uFDBA'] = '\u0644\u062C\u0645';
	 t['\uFDBB'] = '\u0643\u0645\u0645';
	 t['\uFDBC'] = '\u0644\u062C\u0645';
	 t['\uFDBD'] = '\u0646\u062C\u062D';
	 t['\uFDBE'] = '\u062C\u062D\u064A';
	 t['\uFDBF'] = '\u062D\u062C\u064A';
	 t['\uFDC0'] = '\u0645\u062C\u064A';
	 t['\uFDC1'] = '\u0641\u0645\u064A';
	 t['\uFDC2'] = '\u0628\u062D\u064A';
	 t['\uFDC3'] = '\u0643\u0645\u0645';
	 t['\uFDC4'] = '\u0639\u062C\u0645';
	 t['\uFDC5'] = '\u0635\u0645\u0645';
	 t['\uFDC6'] = '\u0633\u062E\u064A';
	 t['\uFDC7'] = '\u0646\u062C\u064A';
	 t['\uFE49'] = '\u203E';
	 t['\uFE4A'] = '\u203E';
	 t['\uFE4B'] = '\u203E';
	 t['\uFE4C'] = '\u203E';
	 t['\uFE4D'] = '\u005F';
	 t['\uFE4E'] = '\u005F';
	 t['\uFE4F'] = '\u005F';
	 t['\uFE80'] = '\u0621';
	 t['\uFE81'] = '\u0622';
	 t['\uFE82'] = '\u0622';
	 t['\uFE83'] = '\u0623';
	 t['\uFE84'] = '\u0623';
	 t['\uFE85'] = '\u0624';
	 t['\uFE86'] = '\u0624';
	 t['\uFE87'] = '\u0625';
	 t['\uFE88'] = '\u0625';
	 t['\uFE89'] = '\u0626';
	 t['\uFE8A'] = '\u0626';
	 t['\uFE8B'] = '\u0626';
	 t['\uFE8C'] = '\u0626';
	 t['\uFE8D'] = '\u0627';
	 t['\uFE8E'] = '\u0627';
	 t['\uFE8F'] = '\u0628';
	 t['\uFE90'] = '\u0628';
	 t['\uFE91'] = '\u0628';
	 t['\uFE92'] = '\u0628';
	 t['\uFE93'] = '\u0629';
	 t['\uFE94'] = '\u0629';
	 t['\uFE95'] = '\u062A';
	 t['\uFE96'] = '\u062A';
	 t['\uFE97'] = '\u062A';
	 t['\uFE98'] = '\u062A';
	 t['\uFE99'] = '\u062B';
	 t['\uFE9A'] = '\u062B';
	 t['\uFE9B'] = '\u062B';
	 t['\uFE9C'] = '\u062B';
	 t['\uFE9D'] = '\u062C';
	 t['\uFE9E'] = '\u062C';
	 t['\uFE9F'] = '\u062C';
	 t['\uFEA0'] = '\u062C';
	 t['\uFEA1'] = '\u062D';
	 t['\uFEA2'] = '\u062D';
	 t['\uFEA3'] = '\u062D';
	 t['\uFEA4'] = '\u062D';
	 t['\uFEA5'] = '\u062E';
	 t['\uFEA6'] = '\u062E';
	 t['\uFEA7'] = '\u062E';
	 t['\uFEA8'] = '\u062E';
	 t['\uFEA9'] = '\u062F';
	 t['\uFEAA'] = '\u062F';
	 t['\uFEAB'] = '\u0630';
	 t['\uFEAC'] = '\u0630';
	 t['\uFEAD'] = '\u0631';
	 t['\uFEAE'] = '\u0631';
	 t['\uFEAF'] = '\u0632';
	 t['\uFEB0'] = '\u0632';
	 t['\uFEB1'] = '\u0633';
	 t['\uFEB2'] = '\u0633';
	 t['\uFEB3'] = '\u0633';
	 t['\uFEB4'] = '\u0633';
	 t['\uFEB5'] = '\u0634';
	 t['\uFEB6'] = '\u0634';
	 t['\uFEB7'] = '\u0634';
	 t['\uFEB8'] = '\u0634';
	 t['\uFEB9'] = '\u0635';
	 t['\uFEBA'] = '\u0635';
	 t['\uFEBB'] = '\u0635';
	 t['\uFEBC'] = '\u0635';
	 t['\uFEBD'] = '\u0636';
	 t['\uFEBE'] = '\u0636';
	 t['\uFEBF'] = '\u0636';
	 t['\uFEC0'] = '\u0636';
	 t['\uFEC1'] = '\u0637';
	 t['\uFEC2'] = '\u0637';
	 t['\uFEC3'] = '\u0637';
	 t['\uFEC4'] = '\u0637';
	 t['\uFEC5'] = '\u0638';
	 t['\uFEC6'] = '\u0638';
	 t['\uFEC7'] = '\u0638';
	 t['\uFEC8'] = '\u0638';
	 t['\uFEC9'] = '\u0639';
	 t['\uFECA'] = '\u0639';
	 t['\uFECB'] = '\u0639';
	 t['\uFECC'] = '\u0639';
	 t['\uFECD'] = '\u063A';
	 t['\uFECE'] = '\u063A';
	 t['\uFECF'] = '\u063A';
	 t['\uFED0'] = '\u063A';
	 t['\uFED1'] = '\u0641';
	 t['\uFED2'] = '\u0641';
	 t['\uFED3'] = '\u0641';
	 t['\uFED4'] = '\u0641';
	 t['\uFED5'] = '\u0642';
	 t['\uFED6'] = '\u0642';
	 t['\uFED7'] = '\u0642';
	 t['\uFED8'] = '\u0642';
	 t['\uFED9'] = '\u0643';
	 t['\uFEDA'] = '\u0643';
	 t['\uFEDB'] = '\u0643';
	 t['\uFEDC'] = '\u0643';
	 t['\uFEDD'] = '\u0644';
	 t['\uFEDE'] = '\u0644';
	 t['\uFEDF'] = '\u0644';
	 t['\uFEE0'] = '\u0644';
	 t['\uFEE1'] = '\u0645';
	 t['\uFEE2'] = '\u0645';
	 t['\uFEE3'] = '\u0645';
	 t['\uFEE4'] = '\u0645';
	 t['\uFEE5'] = '\u0646';
	 t['\uFEE6'] = '\u0646';
	 t['\uFEE7'] = '\u0646';
	 t['\uFEE8'] = '\u0646';
	 t['\uFEE9'] = '\u0647';
	 t['\uFEEA'] = '\u0647';
	 t['\uFEEB'] = '\u0647';
	 t['\uFEEC'] = '\u0647';
	 t['\uFEED'] = '\u0648';
	 t['\uFEEE'] = '\u0648';
	 t['\uFEEF'] = '\u0649';
	 t['\uFEF0'] = '\u0649';
	 t['\uFEF1'] = '\u064A';
	 t['\uFEF2'] = '\u064A';
	 t['\uFEF3'] = '\u064A';
	 t['\uFEF4'] = '\u064A';
	 t['\uFEF5'] = '\u0644\u0622';
	 t['\uFEF6'] = '\u0644\u0622';
	 t['\uFEF7'] = '\u0644\u0623';
	 t['\uFEF8'] = '\u0644\u0623';
	 t['\uFEF9'] = '\u0644\u0625';
	 t['\uFEFA'] = '\u0644\u0625';
	 t['\uFEFB'] = '\u0644\u0627';
	 t['\uFEFC'] = '\u0644\u0627';
	});
	function reverseIfRtl(chars) {
	 var charsLength = chars.length;
	 if (charsLength <= 1 || !isRTLRangeFor(chars.charCodeAt(0))) {
	  return chars;
	 }
	 var s = '';
	 for (var ii = charsLength - 1; ii >= 0; ii--) {
	  s += chars[ii];
	 }
	 return s;
	}
	exports.mapSpecialUnicodeValues = mapSpecialUnicodeValues;
	exports.reverseIfRtl = reverseIfRtl;
	exports.getUnicodeRangeFor = getUnicodeRangeFor;
	exports.getNormalizedUnicodes = getNormalizedUnicodes;
	exports.getUnicodeForGlyph = getUnicodeForGlyph;
	
	/***/ }),
	/* 87 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PostScriptCompiler = exports.PostScriptEvaluator = exports.PDFFunctionFactory = exports.isPDFFunction = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __w_pdfjs_require__(0);
	
	var _primitives = __w_pdfjs_require__(2);
	
	var _ps_parser = __w_pdfjs_require__(156);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var IsEvalSupportedCached = {
	  get value() {
	    return (0, _util.shadow)(this, 'value', (0, _util.isEvalSupported)());
	  }
	};
	
	var PDFFunctionFactory = function () {
	  function PDFFunctionFactory(_ref) {
	    var xref = _ref.xref,
	        _ref$isEvalSupported = _ref.isEvalSupported,
	        isEvalSupported = _ref$isEvalSupported === undefined ? true : _ref$isEvalSupported;
	
	    _classCallCheck(this, PDFFunctionFactory);
	
	    this.xref = xref;
	    this.isEvalSupported = isEvalSupported !== false;
	  }
	
	  _createClass(PDFFunctionFactory, [{
	    key: 'create',
	    value: function create(fn) {
	      return PDFFunction.parse({
	        xref: this.xref,
	        isEvalSupported: this.isEvalSupported,
	        fn: fn
	      });
	    }
	  }, {
	    key: 'createFromArray',
	    value: function createFromArray(fnObj) {
	      return PDFFunction.parseArray({
	        xref: this.xref,
	        isEvalSupported: this.isEvalSupported,
	        fnObj: fnObj
	      });
	    }
	  }]);
	
	  return PDFFunctionFactory;
	}();
	
	function toNumberArray(arr) {
	  if (!Array.isArray(arr)) {
	    return null;
	  }
	  var length = arr.length;
	  for (var i = 0; i < length; i++) {
	    if (typeof arr[i] !== 'number') {
	      var result = new Array(length);
	      for (var _i = 0; _i < length; _i++) {
	        result[_i] = +arr[_i];
	      }
	      return result;
	    }
	  }
	  return arr;
	}
	var PDFFunction = function PDFFunctionClosure() {
	  var CONSTRUCT_SAMPLED = 0;
	  var CONSTRUCT_INTERPOLATED = 2;
	  var CONSTRUCT_STICHED = 3;
	  var CONSTRUCT_POSTSCRIPT = 4;
	  return {
	    getSampleArray: function getSampleArray(size, outputSize, bps, stream) {
	      var i, ii;
	      var length = 1;
	      for (i = 0, ii = size.length; i < ii; i++) {
	        length *= size[i];
	      }
	      length *= outputSize;
	      var array = new Array(length);
	      var codeSize = 0;
	      var codeBuf = 0;
	      var sampleMul = 1.0 / (Math.pow(2.0, bps) - 1);
	      var strBytes = stream.getBytes((length * bps + 7) / 8);
	      var strIdx = 0;
	      for (i = 0; i < length; i++) {
	        while (codeSize < bps) {
	          codeBuf <<= 8;
	          codeBuf |= strBytes[strIdx++];
	          codeSize += 8;
	        }
	        codeSize -= bps;
	        array[i] = (codeBuf >> codeSize) * sampleMul;
	        codeBuf &= (1 << codeSize) - 1;
	      }
	      return array;
	    },
	    getIR: function getIR(_ref2) {
	      var xref = _ref2.xref,
	          isEvalSupported = _ref2.isEvalSupported,
	          fn = _ref2.fn;
	
	      var dict = fn.dict;
	      if (!dict) {
	        dict = fn;
	      }
	      var types = [this.constructSampled, null, this.constructInterpolated, this.constructStiched, this.constructPostScript];
	      var typeNum = dict.get('FunctionType');
	      var typeFn = types[typeNum];
	      if (!typeFn) {
	        throw new _util.FormatError('Unknown type of function');
	      }
	      return typeFn.call(this, {
	        xref: xref,
	        isEvalSupported: isEvalSupported,
	        fn: fn,
	        dict: dict
	      });
	    },
	    fromIR: function fromIR(_ref3) {
	      var xref = _ref3.xref,
	          isEvalSupported = _ref3.isEvalSupported,
	          IR = _ref3.IR;
	
	      var type = IR[0];
	      switch (type) {
	        case CONSTRUCT_SAMPLED:
	          return this.constructSampledFromIR({
	            xref: xref,
	            isEvalSupported: isEvalSupported,
	            IR: IR
	          });
	        case CONSTRUCT_INTERPOLATED:
	          return this.constructInterpolatedFromIR({
	            xref: xref,
	            isEvalSupported: isEvalSupported,
	            IR: IR
	          });
	        case CONSTRUCT_STICHED:
	          return this.constructStichedFromIR({
	            xref: xref,
	            isEvalSupported: isEvalSupported,
	            IR: IR
	          });
	        default:
	          return this.constructPostScriptFromIR({
	            xref: xref,
	            isEvalSupported: isEvalSupported,
	            IR: IR
	          });
	      }
	    },
	    parse: function parse(_ref4) {
	      var xref = _ref4.xref,
	          isEvalSupported = _ref4.isEvalSupported,
	          fn = _ref4.fn;
	
	      var IR = this.getIR({
	        xref: xref,
	        isEvalSupported: isEvalSupported,
	        fn: fn
	      });
	      return this.fromIR({
	        xref: xref,
	        isEvalSupported: isEvalSupported,
	        IR: IR
	      });
	    },
	    parseArray: function parseArray(_ref5) {
	      var xref = _ref5.xref,
	          isEvalSupported = _ref5.isEvalSupported,
	          fnObj = _ref5.fnObj;
	
	      if (!Array.isArray(fnObj)) {
	        return this.parse({
	          xref: xref,
	          isEvalSupported: isEvalSupported,
	          fn: fnObj
	        });
	      }
	      var fnArray = [];
	      for (var j = 0, jj = fnObj.length; j < jj; j++) {
	        fnArray.push(this.parse({
	          xref: xref,
	          isEvalSupported: isEvalSupported,
	          fn: xref.fetchIfRef(fnObj[j])
	        }));
	      }
	      return function (src, srcOffset, dest, destOffset) {
	        for (var i = 0, ii = fnArray.length; i < ii; i++) {
	          fnArray[i](src, srcOffset, dest, destOffset + i);
	        }
	      };
	    },
	    constructSampled: function constructSampled(_ref6) {
	      var xref = _ref6.xref,
	          isEvalSupported = _ref6.isEvalSupported,
	          fn = _ref6.fn,
	          dict = _ref6.dict;
	
	      function toMultiArray(arr) {
	        var inputLength = arr.length;
	        var out = [];
	        var index = 0;
	        for (var i = 0; i < inputLength; i += 2) {
	          out[index] = [arr[i], arr[i + 1]];
	          ++index;
	        }
	        return out;
	      }
	      var domain = toNumberArray(dict.getArray('Domain'));
	      var range = toNumberArray(dict.getArray('Range'));
	      if (!domain || !range) {
	        throw new _util.FormatError('No domain or range');
	      }
	      var inputSize = domain.length / 2;
	      var outputSize = range.length / 2;
	      domain = toMultiArray(domain);
	      range = toMultiArray(range);
	      var size = toNumberArray(dict.get('Size'));
	      var bps = dict.get('BitsPerSample');
	      var order = dict.get('Order') || 1;
	      if (order !== 1) {
	        (0, _util.info)('No support for cubic spline interpolation: ' + order);
	      }
	      var encode = toNumberArray(dict.getArray('Encode'));
	      if (!encode) {
	        encode = [];
	        for (var i = 0; i < inputSize; ++i) {
	          encode.push([0, size[i] - 1]);
	        }
	      } else {
	        encode = toMultiArray(encode);
	      }
	      var decode = toNumberArray(dict.getArray('Decode'));
	      if (!decode) {
	        decode = range;
	      } else {
	        decode = toMultiArray(decode);
	      }
	      var samples = this.getSampleArray(size, outputSize, bps, fn);
	      return [CONSTRUCT_SAMPLED, inputSize, domain, encode, decode, samples, size, outputSize, Math.pow(2, bps) - 1, range];
	    },
	    constructSampledFromIR: function constructSampledFromIR(_ref7) {
	      var xref = _ref7.xref,
	          isEvalSupported = _ref7.isEvalSupported,
	          IR = _ref7.IR;
	
	      function interpolate(x, xmin, xmax, ymin, ymax) {
	        return ymin + (x - xmin) * ((ymax - ymin) / (xmax - xmin));
	      }
	      return function constructSampledFromIRResult(src, srcOffset, dest, destOffset) {
	        var m = IR[1];
	        var domain = IR[2];
	        var encode = IR[3];
	        var decode = IR[4];
	        var samples = IR[5];
	        var size = IR[6];
	        var n = IR[7];
	        var range = IR[9];
	        var cubeVertices = 1 << m;
	        var cubeN = new Float64Array(cubeVertices);
	        var cubeVertex = new Uint32Array(cubeVertices);
	        var i, j;
	        for (j = 0; j < cubeVertices; j++) {
	          cubeN[j] = 1;
	        }
	        var k = n,
	            pos = 1;
	        for (i = 0; i < m; ++i) {
	          var domain_2i = domain[i][0];
	          var domain_2i_1 = domain[i][1];
	          var xi = Math.min(Math.max(src[srcOffset + i], domain_2i), domain_2i_1);
	          var e = interpolate(xi, domain_2i, domain_2i_1, encode[i][0], encode[i][1]);
	          var size_i = size[i];
	          e = Math.min(Math.max(e, 0), size_i - 1);
	          var e0 = e < size_i - 1 ? Math.floor(e) : e - 1;
	          var n0 = e0 + 1 - e;
	          var n1 = e - e0;
	          var offset0 = e0 * k;
	          var offset1 = offset0 + k;
	          for (j = 0; j < cubeVertices; j++) {
	            if (j & pos) {
	              cubeN[j] *= n1;
	              cubeVertex[j] += offset1;
	            } else {
	              cubeN[j] *= n0;
	              cubeVertex[j] += offset0;
	            }
	          }
	          k *= size_i;
	          pos <<= 1;
	        }
	        for (j = 0; j < n; ++j) {
	          var rj = 0;
	          for (i = 0; i < cubeVertices; i++) {
	            rj += samples[cubeVertex[i] + j] * cubeN[i];
	          }
	          rj = interpolate(rj, 0, 1, decode[j][0], decode[j][1]);
	          dest[destOffset + j] = Math.min(Math.max(rj, range[j][0]), range[j][1]);
	        }
	      };
	    },
	    constructInterpolated: function constructInterpolated(_ref8) {
	      var xref = _ref8.xref,
	          isEvalSupported = _ref8.isEvalSupported,
	          fn = _ref8.fn,
	          dict = _ref8.dict;
	
	      var c0 = toNumberArray(dict.getArray('C0')) || [0];
	      var c1 = toNumberArray(dict.getArray('C1')) || [1];
	      var n = dict.get('N');
	      var length = c0.length;
	      var diff = [];
	      for (var i = 0; i < length; ++i) {
	        diff.push(c1[i] - c0[i]);
	      }
	      return [CONSTRUCT_INTERPOLATED, c0, diff, n];
	    },
	    constructInterpolatedFromIR: function constructInterpolatedFromIR(_ref9) {
	      var xref = _ref9.xref,
	          isEvalSupported = _ref9.isEvalSupported,
	          IR = _ref9.IR;
	
	      var c0 = IR[1];
	      var diff = IR[2];
	      var n = IR[3];
	      var length = diff.length;
	      return function constructInterpolatedFromIRResult(src, srcOffset, dest, destOffset) {
	        var x = n === 1 ? src[srcOffset] : Math.pow(src[srcOffset], n);
	        for (var j = 0; j < length; ++j) {
	          dest[destOffset + j] = c0[j] + x * diff[j];
	        }
	      };
	    },
	    constructStiched: function constructStiched(_ref10) {
	      var xref = _ref10.xref,
	          isEvalSupported = _ref10.isEvalSupported,
	          fn = _ref10.fn,
	          dict = _ref10.dict;
	
	      var domain = toNumberArray(dict.getArray('Domain'));
	      if (!domain) {
	        throw new _util.FormatError('No domain');
	      }
	      var inputSize = domain.length / 2;
	      if (inputSize !== 1) {
	        throw new _util.FormatError('Bad domain for stiched function');
	      }
	      var fnRefs = dict.get('Functions');
	      var fns = [];
	      for (var i = 0, ii = fnRefs.length; i < ii; ++i) {
	        fns.push(this.parse({
	          xref: xref,
	          isEvalSupported: isEvalSupported,
	          fn: xref.fetchIfRef(fnRefs[i])
	        }));
	      }
	      var bounds = toNumberArray(dict.getArray('Bounds'));
	      var encode = toNumberArray(dict.getArray('Encode'));
	      return [CONSTRUCT_STICHED, domain, bounds, encode, fns];
	    },
	    constructStichedFromIR: function constructStichedFromIR(_ref11) {
	      var xref = _ref11.xref,
	          isEvalSupported = _ref11.isEvalSupported,
	          IR = _ref11.IR;
	
	      var domain = IR[1];
	      var bounds = IR[2];
	      var encode = IR[3];
	      var fns = IR[4];
	      var tmpBuf = new Float32Array(1);
	      return function constructStichedFromIRResult(src, srcOffset, dest, destOffset) {
	        var clip = function constructStichedFromIRClip(v, min, max) {
	          if (v > max) {
	            v = max;
	          } else if (v < min) {
	            v = min;
	          }
	          return v;
	        };
	        var v = clip(src[srcOffset], domain[0], domain[1]);
	        for (var i = 0, ii = bounds.length; i < ii; ++i) {
	          if (v < bounds[i]) {
	            break;
	          }
	        }
	        var dmin = domain[0];
	        if (i > 0) {
	          dmin = bounds[i - 1];
	        }
	        var dmax = domain[1];
	        if (i < bounds.length) {
	          dmax = bounds[i];
	        }
	        var rmin = encode[2 * i];
	        var rmax = encode[2 * i + 1];
	        tmpBuf[0] = dmin === dmax ? rmin : rmin + (v - dmin) * (rmax - rmin) / (dmax - dmin);
	        fns[i](tmpBuf, 0, dest, destOffset);
	      };
	    },
	    constructPostScript: function constructPostScript(_ref12) {
	      var xref = _ref12.xref,
	          isEvalSupported = _ref12.isEvalSupported,
	          fn = _ref12.fn,
	          dict = _ref12.dict;
	
	      var domain = toNumberArray(dict.getArray('Domain'));
	      var range = toNumberArray(dict.getArray('Range'));
	      if (!domain) {
	        throw new _util.FormatError('No domain.');
	      }
	      if (!range) {
	        throw new _util.FormatError('No range.');
	      }
	      var lexer = new _ps_parser.PostScriptLexer(fn);
	      var parser = new _ps_parser.PostScriptParser(lexer);
	      var code = parser.parse();
	      return [CONSTRUCT_POSTSCRIPT, domain, range, code];
	    },
	    constructPostScriptFromIR: function constructPostScriptFromIR(_ref13) {
	      var xref = _ref13.xref,
	          isEvalSupported = _ref13.isEvalSupported,
	          IR = _ref13.IR;
	
	      var domain = IR[1];
	      var range = IR[2];
	      var code = IR[3];
	      if (isEvalSupported && IsEvalSupportedCached.value) {
	        var compiled = new PostScriptCompiler().compile(code, domain, range);
	        if (compiled) {
	          return new Function('src', 'srcOffset', 'dest', 'destOffset', compiled);
	        }
	      }
	      (0, _util.info)('Unable to compile PS function');
	      var numOutputs = range.length >> 1;
	      var numInputs = domain.length >> 1;
	      var evaluator = new PostScriptEvaluator(code);
	      var cache = Object.create(null);
	      var MAX_CACHE_SIZE = 2048 * 4;
	      var cache_available = MAX_CACHE_SIZE;
	      var tmpBuf = new Float32Array(numInputs);
	      return function constructPostScriptFromIRResult(src, srcOffset, dest, destOffset) {
	        var i, value;
	        var key = '';
	        var input = tmpBuf;
	        for (i = 0; i < numInputs; i++) {
	          value = src[srcOffset + i];
	          input[i] = value;
	          key += value + '_';
	        }
	        var cachedValue = cache[key];
	        if (cachedValue !== undefined) {
	          dest.set(cachedValue, destOffset);
	          return;
	        }
	        var output = new Float32Array(numOutputs);
	        var stack = evaluator.execute(input);
	        var stackIndex = stack.length - numOutputs;
	        for (i = 0; i < numOutputs; i++) {
	          value = stack[stackIndex + i];
	          var bound = range[i * 2];
	          if (value < bound) {
	            value = bound;
	          } else {
	            bound = range[i * 2 + 1];
	            if (value > bound) {
	              value = bound;
	            }
	          }
	          output[i] = value;
	        }
	        if (cache_available > 0) {
	          cache_available--;
	          cache[key] = output;
	        }
	        dest.set(output, destOffset);
	      };
	    }
	  };
	}();
	function isPDFFunction(v) {
	  var fnDict;
	  if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) !== 'object') {
	    return false;
	  } else if ((0, _primitives.isDict)(v)) {
	    fnDict = v;
	  } else if ((0, _primitives.isStream)(v)) {
	    fnDict = v.dict;
	  } else {
	    return false;
	  }
	  return fnDict.has('FunctionType');
	}
	var PostScriptStack = function PostScriptStackClosure() {
	  var MAX_STACK_SIZE = 100;
	  function PostScriptStack(initialStack) {
	    this.stack = !initialStack ? [] : Array.prototype.slice.call(initialStack, 0);
	  }
	  PostScriptStack.prototype = {
	    push: function PostScriptStack_push(value) {
	      if (this.stack.length >= MAX_STACK_SIZE) {
	        throw new Error('PostScript function stack overflow.');
	      }
	      this.stack.push(value);
	    },
	    pop: function PostScriptStack_pop() {
	      if (this.stack.length <= 0) {
	        throw new Error('PostScript function stack underflow.');
	      }
	      return this.stack.pop();
	    },
	    copy: function PostScriptStack_copy(n) {
	      if (this.stack.length + n >= MAX_STACK_SIZE) {
	        throw new Error('PostScript function stack overflow.');
	      }
	      var stack = this.stack;
	      for (var i = stack.length - n, j = n - 1; j >= 0; j--, i++) {
	        stack.push(stack[i]);
	      }
	    },
	    index: function PostScriptStack_index(n) {
	      this.push(this.stack[this.stack.length - n - 1]);
	    },
	    roll: function PostScriptStack_roll(n, p) {
	      var stack = this.stack;
	      var l = stack.length - n;
	      var r = stack.length - 1,
	          c = l + (p - Math.floor(p / n) * n),
	          i,
	          j,
	          t;
	      for (i = l, j = r; i < j; i++, j--) {
	        t = stack[i];
	        stack[i] = stack[j];
	        stack[j] = t;
	      }
	      for (i = l, j = c - 1; i < j; i++, j--) {
	        t = stack[i];
	        stack[i] = stack[j];
	        stack[j] = t;
	      }
	      for (i = c, j = r; i < j; i++, j--) {
	        t = stack[i];
	        stack[i] = stack[j];
	        stack[j] = t;
	      }
	    }
	  };
	  return PostScriptStack;
	}();
	var PostScriptEvaluator = function PostScriptEvaluatorClosure() {
	  function PostScriptEvaluator(operators) {
	    this.operators = operators;
	  }
	  PostScriptEvaluator.prototype = {
	    execute: function PostScriptEvaluator_execute(initialStack) {
	      var stack = new PostScriptStack(initialStack);
	      var counter = 0;
	      var operators = this.operators;
	      var length = operators.length;
	      var operator, a, b;
	      while (counter < length) {
	        operator = operators[counter++];
	        if (typeof operator === 'number') {
	          stack.push(operator);
	          continue;
	        }
	        switch (operator) {
	          case 'jz':
	            b = stack.pop();
	            a = stack.pop();
	            if (!a) {
	              counter = b;
	            }
	            break;
	          case 'j':
	            a = stack.pop();
	            counter = a;
	            break;
	          case 'abs':
	            a = stack.pop();
	            stack.push(Math.abs(a));
	            break;
	          case 'add':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a + b);
	            break;
	          case 'and':
	            b = stack.pop();
	            a = stack.pop();
	            if ((0, _util.isBool)(a) && (0, _util.isBool)(b)) {
	              stack.push(a && b);
	            } else {
	              stack.push(a & b);
	            }
	            break;
	          case 'atan':
	            a = stack.pop();
	            stack.push(Math.atan(a));
	            break;
	          case 'bitshift':
	            b = stack.pop();
	            a = stack.pop();
	            if (a > 0) {
	              stack.push(a << b);
	            } else {
	              stack.push(a >> b);
	            }
	            break;
	          case 'ceiling':
	            a = stack.pop();
	            stack.push(Math.ceil(a));
	            break;
	          case 'copy':
	            a = stack.pop();
	            stack.copy(a);
	            break;
	          case 'cos':
	            a = stack.pop();
	            stack.push(Math.cos(a));
	            break;
	          case 'cvi':
	            a = stack.pop() | 0;
	            stack.push(a);
	            break;
	          case 'cvr':
	            break;
	          case 'div':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a / b);
	            break;
	          case 'dup':
	            stack.copy(1);
	            break;
	          case 'eq':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a === b);
	            break;
	          case 'exch':
	            stack.roll(2, 1);
	            break;
	          case 'exp':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(Math.pow(a, b));
	            break;
	          case 'false':
	            stack.push(false);
	            break;
	          case 'floor':
	            a = stack.pop();
	            stack.push(Math.floor(a));
	            break;
	          case 'ge':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a >= b);
	            break;
	          case 'gt':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a > b);
	            break;
	          case 'idiv':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a / b | 0);
	            break;
	          case 'index':
	            a = stack.pop();
	            stack.index(a);
	            break;
	          case 'le':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a <= b);
	            break;
	          case 'ln':
	            a = stack.pop();
	            stack.push(Math.log(a));
	            break;
	          case 'log':
	            a = stack.pop();
	            stack.push(Math.log(a) / Math.LN10);
	            break;
	          case 'lt':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a < b);
	            break;
	          case 'mod':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a % b);
	            break;
	          case 'mul':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a * b);
	            break;
	          case 'ne':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a !== b);
	            break;
	          case 'neg':
	            a = stack.pop();
	            stack.push(-a);
	            break;
	          case 'not':
	            a = stack.pop();
	            if ((0, _util.isBool)(a)) {
	              stack.push(!a);
	            } else {
	              stack.push(~a);
	            }
	            break;
	          case 'or':
	            b = stack.pop();
	            a = stack.pop();
	            if ((0, _util.isBool)(a) && (0, _util.isBool)(b)) {
	              stack.push(a || b);
	            } else {
	              stack.push(a | b);
	            }
	            break;
	          case 'pop':
	            stack.pop();
	            break;
	          case 'roll':
	            b = stack.pop();
	            a = stack.pop();
	            stack.roll(a, b);
	            break;
	          case 'round':
	            a = stack.pop();
	            stack.push(Math.round(a));
	            break;
	          case 'sin':
	            a = stack.pop();
	            stack.push(Math.sin(a));
	            break;
	          case 'sqrt':
	            a = stack.pop();
	            stack.push(Math.sqrt(a));
	            break;
	          case 'sub':
	            b = stack.pop();
	            a = stack.pop();
	            stack.push(a - b);
	            break;
	          case 'true':
	            stack.push(true);
	            break;
	          case 'truncate':
	            a = stack.pop();
	            a = a < 0 ? Math.ceil(a) : Math.floor(a);
	            stack.push(a);
	            break;
	          case 'xor':
	            b = stack.pop();
	            a = stack.pop();
	            if ((0, _util.isBool)(a) && (0, _util.isBool)(b)) {
	              stack.push(a !== b);
	            } else {
	              stack.push(a ^ b);
	            }
	            break;
	          default:
	            throw new _util.FormatError('Unknown operator ' + operator);
	        }
	      }
	      return stack.stack;
	    }
	  };
	  return PostScriptEvaluator;
	}();
	var PostScriptCompiler = function PostScriptCompilerClosure() {
	  function AstNode(type) {
	    this.type = type;
	  }
	  AstNode.prototype.visit = function (visitor) {
	    throw new Error('abstract method');
	  };
	  function AstArgument(index, min, max) {
	    AstNode.call(this, 'args');
	    this.index = index;
	    this.min = min;
	    this.max = max;
	  }
	  AstArgument.prototype = Object.create(AstNode.prototype);
	  AstArgument.prototype.visit = function (visitor) {
	    visitor.visitArgument(this);
	  };
	  function AstLiteral(number) {
	    AstNode.call(this, 'literal');
	    this.number = number;
	    this.min = number;
	    this.max = number;
	  }
	  AstLiteral.prototype = Object.create(AstNode.prototype);
	  AstLiteral.prototype.visit = function (visitor) {
	    visitor.visitLiteral(this);
	  };
	  function AstBinaryOperation(op, arg1, arg2, min, max) {
	    AstNode.call(this, 'binary');
	    this.op = op;
	    this.arg1 = arg1;
	    this.arg2 = arg2;
	    this.min = min;
	    this.max = max;
	  }
	  AstBinaryOperation.prototype = Object.create(AstNode.prototype);
	  AstBinaryOperation.prototype.visit = function (visitor) {
	    visitor.visitBinaryOperation(this);
	  };
	  function AstMin(arg, max) {
	    AstNode.call(this, 'max');
	    this.arg = arg;
	    this.min = arg.min;
	    this.max = max;
	  }
	  AstMin.prototype = Object.create(AstNode.prototype);
	  AstMin.prototype.visit = function (visitor) {
	    visitor.visitMin(this);
	  };
	  function AstVariable(index, min, max) {
	    AstNode.call(this, 'var');
	    this.index = index;
	    this.min = min;
	    this.max = max;
	  }
	  AstVariable.prototype = Object.create(AstNode.prototype);
	  AstVariable.prototype.visit = function (visitor) {
	    visitor.visitVariable(this);
	  };
	  function AstVariableDefinition(variable, arg) {
	    AstNode.call(this, 'definition');
	    this.variable = variable;
	    this.arg = arg;
	  }
	  AstVariableDefinition.prototype = Object.create(AstNode.prototype);
	  AstVariableDefinition.prototype.visit = function (visitor) {
	    visitor.visitVariableDefinition(this);
	  };
	  function ExpressionBuilderVisitor() {
	    this.parts = [];
	  }
	  ExpressionBuilderVisitor.prototype = {
	    visitArgument: function visitArgument(arg) {
	      this.parts.push('Math.max(', arg.min, ', Math.min(', arg.max, ', src[srcOffset + ', arg.index, ']))');
	    },
	    visitVariable: function visitVariable(variable) {
	      this.parts.push('v', variable.index);
	    },
	    visitLiteral: function visitLiteral(literal) {
	      this.parts.push(literal.number);
	    },
	    visitBinaryOperation: function visitBinaryOperation(operation) {
	      this.parts.push('(');
	      operation.arg1.visit(this);
	      this.parts.push(' ', operation.op, ' ');
	      operation.arg2.visit(this);
	      this.parts.push(')');
	    },
	    visitVariableDefinition: function visitVariableDefinition(definition) {
	      this.parts.push('var ');
	      definition.variable.visit(this);
	      this.parts.push(' = ');
	      definition.arg.visit(this);
	      this.parts.push(';');
	    },
	    visitMin: function visitMin(max) {
	      this.parts.push('Math.min(');
	      max.arg.visit(this);
	      this.parts.push(', ', max.max, ')');
	    },
	    toString: function toString() {
	      return this.parts.join('');
	    }
	  };
	  function buildAddOperation(num1, num2) {
	    if (num2.type === 'literal' && num2.number === 0) {
	      return num1;
	    }
	    if (num1.type === 'literal' && num1.number === 0) {
	      return num2;
	    }
	    if (num2.type === 'literal' && num1.type === 'literal') {
	      return new AstLiteral(num1.number + num2.number);
	    }
	    return new AstBinaryOperation('+', num1, num2, num1.min + num2.min, num1.max + num2.max);
	  }
	  function buildMulOperation(num1, num2) {
	    if (num2.type === 'literal') {
	      if (num2.number === 0) {
	        return new AstLiteral(0);
	      } else if (num2.number === 1) {
	        return num1;
	      } else if (num1.type === 'literal') {
	        return new AstLiteral(num1.number * num2.number);
	      }
	    }
	    if (num1.type === 'literal') {
	      if (num1.number === 0) {
	        return new AstLiteral(0);
	      } else if (num1.number === 1) {
	        return num2;
	      }
	    }
	    var min = Math.min(num1.min * num2.min, num1.min * num2.max, num1.max * num2.min, num1.max * num2.max);
	    var max = Math.max(num1.min * num2.min, num1.min * num2.max, num1.max * num2.min, num1.max * num2.max);
	    return new AstBinaryOperation('*', num1, num2, min, max);
	  }
	  function buildSubOperation(num1, num2) {
	    if (num2.type === 'literal') {
	      if (num2.number === 0) {
	        return num1;
	      } else if (num1.type === 'literal') {
	        return new AstLiteral(num1.number - num2.number);
	      }
	    }
	    if (num2.type === 'binary' && num2.op === '-' && num1.type === 'literal' && num1.number === 1 && num2.arg1.type === 'literal' && num2.arg1.number === 1) {
	      return num2.arg2;
	    }
	    return new AstBinaryOperation('-', num1, num2, num1.min - num2.max, num1.max - num2.min);
	  }
	  function buildMinOperation(num1, max) {
	    if (num1.min >= max) {
	      return new AstLiteral(max);
	    } else if (num1.max <= max) {
	      return num1;
	    }
	    return new AstMin(num1, max);
	  }
	  function PostScriptCompiler() {}
	  PostScriptCompiler.prototype = {
	    compile: function PostScriptCompiler_compile(code, domain, range) {
	      var stack = [];
	      var i, ii;
	      var instructions = [];
	      var inputSize = domain.length >> 1,
	          outputSize = range.length >> 1;
	      var lastRegister = 0;
	      var n, j;
	      var num1, num2, ast1, ast2, tmpVar, item;
	      for (i = 0; i < inputSize; i++) {
	        stack.push(new AstArgument(i, domain[i * 2], domain[i * 2 + 1]));
	      }
	      for (i = 0, ii = code.length; i < ii; i++) {
	        item = code[i];
	        if (typeof item === 'number') {
	          stack.push(new AstLiteral(item));
	          continue;
	        }
	        switch (item) {
	          case 'add':
	            if (stack.length < 2) {
	              return null;
	            }
	            num2 = stack.pop();
	            num1 = stack.pop();
	            stack.push(buildAddOperation(num1, num2));
	            break;
	          case 'cvr':
	            if (stack.length < 1) {
	              return null;
	            }
	            break;
	          case 'mul':
	            if (stack.length < 2) {
	              return null;
	            }
	            num2 = stack.pop();
	            num1 = stack.pop();
	            stack.push(buildMulOperation(num1, num2));
	            break;
	          case 'sub':
	            if (stack.length < 2) {
	              return null;
	            }
	            num2 = stack.pop();
	            num1 = stack.pop();
	            stack.push(buildSubOperation(num1, num2));
	            break;
	          case 'exch':
	            if (stack.length < 2) {
	              return null;
	            }
	            ast1 = stack.pop();
	            ast2 = stack.pop();
	            stack.push(ast1, ast2);
	            break;
	          case 'pop':
	            if (stack.length < 1) {
	              return null;
	            }
	            stack.pop();
	            break;
	          case 'index':
	            if (stack.length < 1) {
	              return null;
	            }
	            num1 = stack.pop();
	            if (num1.type !== 'literal') {
	              return null;
	            }
	            n = num1.number;
	            if (n < 0 || !Number.isInteger(n) || stack.length < n) {
	              return null;
	            }
	            ast1 = stack[stack.length - n - 1];
	            if (ast1.type === 'literal' || ast1.type === 'var') {
	              stack.push(ast1);
	              break;
	            }
	            tmpVar = new AstVariable(lastRegister++, ast1.min, ast1.max);
	            stack[stack.length - n - 1] = tmpVar;
	            stack.push(tmpVar);
	            instructions.push(new AstVariableDefinition(tmpVar, ast1));
	            break;
	          case 'dup':
	            if (stack.length < 1) {
	              return null;
	            }
	            if (typeof code[i + 1] === 'number' && code[i + 2] === 'gt' && code[i + 3] === i + 7 && code[i + 4] === 'jz' && code[i + 5] === 'pop' && code[i + 6] === code[i + 1]) {
	              num1 = stack.pop();
	              stack.push(buildMinOperation(num1, code[i + 1]));
	              i += 6;
	              break;
	            }
	            ast1 = stack[stack.length - 1];
	            if (ast1.type === 'literal' || ast1.type === 'var') {
	              stack.push(ast1);
	              break;
	            }
	            tmpVar = new AstVariable(lastRegister++, ast1.min, ast1.max);
	            stack[stack.length - 1] = tmpVar;
	            stack.push(tmpVar);
	            instructions.push(new AstVariableDefinition(tmpVar, ast1));
	            break;
	          case 'roll':
	            if (stack.length < 2) {
	              return null;
	            }
	            num2 = stack.pop();
	            num1 = stack.pop();
	            if (num2.type !== 'literal' || num1.type !== 'literal') {
	              return null;
	            }
	            j = num2.number;
	            n = num1.number;
	            if (n <= 0 || !Number.isInteger(n) || !Number.isInteger(j) || stack.length < n) {
	              return null;
	            }
	            j = (j % n + n) % n;
	            if (j === 0) {
	              break;
	            }
	            Array.prototype.push.apply(stack, stack.splice(stack.length - n, n - j));
	            break;
	          default:
	            return null;
	        }
	      }
	      if (stack.length !== outputSize) {
	        return null;
	      }
	      var result = [];
	      instructions.forEach(function (instruction) {
	        var statementBuilder = new ExpressionBuilderVisitor();
	        instruction.visit(statementBuilder);
	        result.push(statementBuilder.toString());
	      });
	      stack.forEach(function (expr, i) {
	        var statementBuilder = new ExpressionBuilderVisitor();
	        expr.visit(statementBuilder);
	        var min = range[i * 2],
	            max = range[i * 2 + 1];
	        var out = [statementBuilder.toString()];
	        if (min > expr.min) {
	          out.unshift('Math.max(', min, ', ');
	          out.push(')');
	        }
	        if (max < expr.max) {
	          out.unshift('Math.min(', max, ', ');
	          out.push(')');
	        }
	        out.unshift('dest[destOffset + ', i, '] = ');
	        out.push(';');
	        result.push(out.join(''));
	      });
	      return result.join('\n');
	    }
	  };
	  return PostScriptCompiler;
	}();
	exports.isPDFFunction = isPDFFunction;
	exports.PDFFunctionFactory = PDFFunctionFactory;
	exports.PostScriptEvaluator = PostScriptEvaluator;
	exports.PostScriptCompiler = PostScriptCompiler;
	
	/***/ }),
	/* 88 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AnnotationLayer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dom_utils = __w_pdfjs_require__(17);
	
	var _util = __w_pdfjs_require__(0);
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AnnotationElementFactory = function () {
	  function AnnotationElementFactory() {
	    _classCallCheck(this, AnnotationElementFactory);
	  }
	
	  _createClass(AnnotationElementFactory, null, [{
	    key: 'create',
	    value: function create(parameters) {
	      var subtype = parameters.data.annotationType;
	      switch (subtype) {
	        case _util.AnnotationType.LINK:
	          return new LinkAnnotationElement(parameters);
	        case _util.AnnotationType.TEXT:
	          return new TextAnnotationElement(parameters);
	        case _util.AnnotationType.WIDGET:
	          var fieldType = parameters.data.fieldType;
	          switch (fieldType) {
	            case 'Tx':
	              return new TextWidgetAnnotationElement(parameters);
	            case 'Btn':
	              if (parameters.data.radioButton) {
	                return new RadioButtonWidgetAnnotationElement(parameters);
	              } else if (parameters.data.checkBox) {
	                return new CheckboxWidgetAnnotationElement(parameters);
	              }
	              (0, _util.warn)('Unimplemented button widget annotation: pushbutton');
	              break;
	            case 'Ch':
	              return new ChoiceWidgetAnnotationElement(parameters);
	          }
	          return new WidgetAnnotationElement(parameters);
	        case _util.AnnotationType.POPUP:
	          return new PopupAnnotationElement(parameters);
	        case _util.AnnotationType.LINE:
	          return new LineAnnotationElement(parameters);
	        case _util.AnnotationType.SQUARE:
	          return new SquareAnnotationElement(parameters);
	        case _util.AnnotationType.CIRCLE:
	          return new CircleAnnotationElement(parameters);
	        case _util.AnnotationType.POLYLINE:
	          return new PolylineAnnotationElement(parameters);
	        case _util.AnnotationType.POLYGON:
	          return new PolygonAnnotationElement(parameters);
	        case _util.AnnotationType.HIGHLIGHT:
	          return new HighlightAnnotationElement(parameters);
	        case _util.AnnotationType.UNDERLINE:
	          return new UnderlineAnnotationElement(parameters);
	        case _util.AnnotationType.SQUIGGLY:
	          return new SquigglyAnnotationElement(parameters);
	        case _util.AnnotationType.STRIKEOUT:
	          return new StrikeOutAnnotationElement(parameters);
	        case _util.AnnotationType.STAMP:
	          return new StampAnnotationElement(parameters);
	        case _util.AnnotationType.FILEATTACHMENT:
	          return new FileAttachmentAnnotationElement(parameters);
	        default:
	          return new AnnotationElement(parameters);
	      }
	    }
	  }]);
	
	  return AnnotationElementFactory;
	}();
	
	var AnnotationElement = function () {
	  function AnnotationElement(parameters) {
	    var isRenderable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var ignoreBorder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    _classCallCheck(this, AnnotationElement);
	
	    this.isRenderable = isRenderable;
	    this.data = parameters.data;
	    this.layer = parameters.layer;
	    this.page = parameters.page;
	    this.viewport = parameters.viewport;
	    this.linkService = parameters.linkService;
	    this.downloadManager = parameters.downloadManager;
	    this.imageResourcesPath = parameters.imageResourcesPath;
	    this.renderInteractiveForms = parameters.renderInteractiveForms;
	    this.svgFactory = parameters.svgFactory;
	    if (isRenderable) {
	      this.container = this._createContainer(ignoreBorder);
	    }
	  }
	
	  _createClass(AnnotationElement, [{
	    key: '_createContainer',
	    value: function _createContainer() {
	      var ignoreBorder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var data = this.data,
	          page = this.page,
	          viewport = this.viewport;
	      var container = document.createElement('section');
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      container.setAttribute('data-annotation-id', data.id);
	      var rect = _util.Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]]);
	      _dom_utils.CustomStyle.setProp('transform', container, 'matrix(' + viewport.transform.join(',') + ')');
	      _dom_utils.CustomStyle.setProp('transformOrigin', container, -rect[0] + 'px ' + -rect[1] + 'px');
	      if (!ignoreBorder && data.borderStyle.width > 0) {
	        container.style.borderWidth = data.borderStyle.width + 'px';
	        if (data.borderStyle.style !== _util.AnnotationBorderStyleType.UNDERLINE) {
	          width = width - 2 * data.borderStyle.width;
	          height = height - 2 * data.borderStyle.width;
	        }
	        var horizontalRadius = data.borderStyle.horizontalCornerRadius;
	        var verticalRadius = data.borderStyle.verticalCornerRadius;
	        if (horizontalRadius > 0 || verticalRadius > 0) {
	          var radius = horizontalRadius + 'px / ' + verticalRadius + 'px';
	          _dom_utils.CustomStyle.setProp('borderRadius', container, radius);
	        }
	        switch (data.borderStyle.style) {
	          case _util.AnnotationBorderStyleType.SOLID:
	            container.style.borderStyle = 'solid';
	            break;
	          case _util.AnnotationBorderStyleType.DASHED:
	            container.style.borderStyle = 'dashed';
	            break;
	          case _util.AnnotationBorderStyleType.BEVELED:
	            (0, _util.warn)('Unimplemented border style: beveled');
	            break;
	          case _util.AnnotationBorderStyleType.INSET:
	            (0, _util.warn)('Unimplemented border style: inset');
	            break;
	          case _util.AnnotationBorderStyleType.UNDERLINE:
	            container.style.borderBottomStyle = 'solid';
	            break;
	          default:
	            break;
	        }
	        if (data.color) {
	          container.style.borderColor = _util.Util.makeCssRgb(data.color[0] | 0, data.color[1] | 0, data.color[2] | 0);
	        } else {
	          container.style.borderWidth = 0;
	        }
	      }
	      container.style.left = rect[0] + 'px';
	      container.style.top = rect[1] + 'px';
	      container.style.width = width + 'px';
	      container.style.height = height + 'px';
	      return container;
	    }
	  }, {
	    key: '_createPopup',
	    value: function _createPopup(container, trigger, data) {
	      if (!trigger) {
	        trigger = document.createElement('div');
	        trigger.style.height = container.style.height;
	        trigger.style.width = container.style.width;
	        container.appendChild(trigger);
	      }
	      var popupElement = new PopupElement({
	        container: container,
	        trigger: trigger,
	        color: data.color,
	        title: data.title,
	        contents: data.contents,
	        hideWrapper: true
	      });
	      var popup = popupElement.render();
	      popup.style.left = container.style.width;
	      container.appendChild(popup);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      throw new Error('Abstract method `AnnotationElement.render` called');
	    }
	  }]);
	
	  return AnnotationElement;
	}();
	
	var LinkAnnotationElement = function (_AnnotationElement) {
	  _inherits(LinkAnnotationElement, _AnnotationElement);
	
	  function LinkAnnotationElement(parameters) {
	    _classCallCheck(this, LinkAnnotationElement);
	
	    var isRenderable = !!(parameters.data.url || parameters.data.dest || parameters.data.action);
	    return _possibleConstructorReturn(this, (LinkAnnotationElement.__proto__ || Object.getPrototypeOf(LinkAnnotationElement)).call(this, parameters, isRenderable));
	  }
	
	  _createClass(LinkAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'linkAnnotation';
	      var link = document.createElement('a');
	      (0, _dom_utils.addLinkAttributes)(link, {
	        url: this.data.url,
	        target: this.data.newWindow ? _dom_utils.LinkTarget.BLANK : undefined
	      });
	      if (!this.data.url) {
	        if (this.data.action) {
	          this._bindNamedAction(link, this.data.action);
	        } else {
	          this._bindLink(link, this.data.dest);
	        }
	      }
	      this.container.appendChild(link);
	      return this.container;
	    }
	  }, {
	    key: '_bindLink',
	    value: function _bindLink(link, destination) {
	      var _this2 = this;
	
	      link.href = this.linkService.getDestinationHash(destination);
	      link.onclick = function () {
	        if (destination) {
	          _this2.linkService.navigateTo(destination);
	        }
	        return false;
	      };
	      if (destination) {
	        link.className = 'internalLink';
	      }
	    }
	  }, {
	    key: '_bindNamedAction',
	    value: function _bindNamedAction(link, action) {
	      var _this3 = this;
	
	      link.href = this.linkService.getAnchorUrl('');
	      link.onclick = function () {
	        _this3.linkService.executeNamedAction(action);
	        return false;
	      };
	      link.className = 'internalLink';
	    }
	  }]);
	
	  return LinkAnnotationElement;
	}(AnnotationElement);
	
	var TextAnnotationElement = function (_AnnotationElement2) {
	  _inherits(TextAnnotationElement, _AnnotationElement2);
	
	  function TextAnnotationElement(parameters) {
	    _classCallCheck(this, TextAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (TextAnnotationElement.__proto__ || Object.getPrototypeOf(TextAnnotationElement)).call(this, parameters, isRenderable));
	  }
	
	  _createClass(TextAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'textAnnotation';
	      var image = document.createElement('img');
	      image.style.height = this.container.style.height;
	      image.style.width = this.container.style.width;
	      image.src = this.imageResourcesPath + 'annotation-' + this.data.name.toLowerCase() + '.svg';
	      image.alt = '[{{type}} Annotation]';
	      image.dataset.l10nId = 'text_annotation_type';
	      image.dataset.l10nArgs = JSON.stringify({ type: this.data.name });
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, image, this.data);
	      }
	      this.container.appendChild(image);
	      return this.container;
	    }
	  }]);
	
	  return TextAnnotationElement;
	}(AnnotationElement);
	
	var WidgetAnnotationElement = function (_AnnotationElement3) {
	  _inherits(WidgetAnnotationElement, _AnnotationElement3);
	
	  function WidgetAnnotationElement() {
	    _classCallCheck(this, WidgetAnnotationElement);
	
	    return _possibleConstructorReturn(this, (WidgetAnnotationElement.__proto__ || Object.getPrototypeOf(WidgetAnnotationElement)).apply(this, arguments));
	  }
	
	  _createClass(WidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      return this.container;
	    }
	  }]);
	
	  return WidgetAnnotationElement;
	}(AnnotationElement);
	
	var TextWidgetAnnotationElement = function (_WidgetAnnotationElem) {
	  _inherits(TextWidgetAnnotationElement, _WidgetAnnotationElem);
	
	  function TextWidgetAnnotationElement(parameters) {
	    _classCallCheck(this, TextWidgetAnnotationElement);
	
	    var isRenderable = parameters.renderInteractiveForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
	    return _possibleConstructorReturn(this, (TextWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(TextWidgetAnnotationElement)).call(this, parameters, isRenderable));
	  }
	
	  _createClass(TextWidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      var TEXT_ALIGNMENT = ['left', 'center', 'right'];
	      this.container.className = 'textWidgetAnnotation';
	      var element = null;
	      if (this.renderInteractiveForms) {
	        if (this.data.multiLine) {
	          element = document.createElement('textarea');
	          element.textContent = this.data.fieldValue;
	        } else {
	          element = document.createElement('input');
	          element.type = 'text';
	          element.setAttribute('value', this.data.fieldValue);
	        }
	        element.disabled = this.data.readOnly;
	        if (this.data.maxLen !== null) {
	          element.maxLength = this.data.maxLen;
	        }
	        if (this.data.comb) {
	          var fieldWidth = this.data.rect[2] - this.data.rect[0];
	          var combWidth = fieldWidth / this.data.maxLen;
	          element.classList.add('comb');
	          element.style.letterSpacing = 'calc(' + combWidth + 'px - 1ch)';
	        }
	      } else {
	        element = document.createElement('div');
	        element.textContent = this.data.fieldValue;
	        element.style.verticalAlign = 'middle';
	        element.style.display = 'table-cell';
	        var font = null;
	        if (this.data.fontRefName) {
	          font = this.page.commonObjs.getData(this.data.fontRefName);
	        }
	        this._setTextStyle(element, font);
	      }
	      if (this.data.textAlignment !== null) {
	        element.style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
	      }
	      this.container.appendChild(element);
	      return this.container;
	    }
	  }, {
	    key: '_setTextStyle',
	    value: function _setTextStyle(element, font) {
	      var style = element.style;
	      style.fontSize = this.data.fontSize + 'px';
	      style.direction = this.data.fontDirection < 0 ? 'rtl' : 'ltr';
	      if (!font) {
	        return;
	      }
	      style.fontWeight = font.black ? font.bold ? '900' : 'bold' : font.bold ? 'bold' : 'normal';
	      style.fontStyle = font.italic ? 'italic' : 'normal';
	      var fontFamily = font.loadedName ? '"' + font.loadedName + '", ' : '';
	      var fallbackName = font.fallbackName || 'Helvetica, sans-serif';
	      style.fontFamily = fontFamily + fallbackName;
	    }
	  }]);
	
	  return TextWidgetAnnotationElement;
	}(WidgetAnnotationElement);
	
	var CheckboxWidgetAnnotationElement = function (_WidgetAnnotationElem2) {
	  _inherits(CheckboxWidgetAnnotationElement, _WidgetAnnotationElem2);
	
	  function CheckboxWidgetAnnotationElement(parameters) {
	    _classCallCheck(this, CheckboxWidgetAnnotationElement);
	
	    return _possibleConstructorReturn(this, (CheckboxWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(CheckboxWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
	  }
	
	  _createClass(CheckboxWidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'buttonWidgetAnnotation checkBox';
	      var element = document.createElement('input');
	      element.disabled = this.data.readOnly;
	      element.type = 'checkbox';
	      if (this.data.fieldValue && this.data.fieldValue !== 'Off') {
	        element.setAttribute('checked', true);
	      }
	      this.container.appendChild(element);
	      return this.container;
	    }
	  }]);
	
	  return CheckboxWidgetAnnotationElement;
	}(WidgetAnnotationElement);
	
	var RadioButtonWidgetAnnotationElement = function (_WidgetAnnotationElem3) {
	  _inherits(RadioButtonWidgetAnnotationElement, _WidgetAnnotationElem3);
	
	  function RadioButtonWidgetAnnotationElement(parameters) {
	    _classCallCheck(this, RadioButtonWidgetAnnotationElement);
	
	    return _possibleConstructorReturn(this, (RadioButtonWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(RadioButtonWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
	  }
	
	  _createClass(RadioButtonWidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'buttonWidgetAnnotation radioButton';
	      var element = document.createElement('input');
	      element.disabled = this.data.readOnly;
	      element.type = 'radio';
	      element.name = this.data.fieldName;
	      if (this.data.fieldValue === this.data.buttonValue) {
	        element.setAttribute('checked', true);
	      }
	      this.container.appendChild(element);
	      return this.container;
	    }
	  }]);
	
	  return RadioButtonWidgetAnnotationElement;
	}(WidgetAnnotationElement);
	
	var ChoiceWidgetAnnotationElement = function (_WidgetAnnotationElem4) {
	  _inherits(ChoiceWidgetAnnotationElement, _WidgetAnnotationElem4);
	
	  function ChoiceWidgetAnnotationElement(parameters) {
	    _classCallCheck(this, ChoiceWidgetAnnotationElement);
	
	    return _possibleConstructorReturn(this, (ChoiceWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(ChoiceWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
	  }
	
	  _createClass(ChoiceWidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'choiceWidgetAnnotation';
	      var selectElement = document.createElement('select');
	      selectElement.disabled = this.data.readOnly;
	      if (!this.data.combo) {
	        selectElement.size = this.data.options.length;
	        if (this.data.multiSelect) {
	          selectElement.multiple = true;
	        }
	      }
	      for (var i = 0, ii = this.data.options.length; i < ii; i++) {
	        var option = this.data.options[i];
	        var optionElement = document.createElement('option');
	        optionElement.textContent = option.displayValue;
	        optionElement.value = option.exportValue;
	        if (this.data.fieldValue.indexOf(option.displayValue) >= 0) {
	          optionElement.setAttribute('selected', true);
	        }
	        selectElement.appendChild(optionElement);
	      }
	      this.container.appendChild(selectElement);
	      return this.container;
	    }
	  }]);
	
	  return ChoiceWidgetAnnotationElement;
	}(WidgetAnnotationElement);
	
	var PopupAnnotationElement = function (_AnnotationElement4) {
	  _inherits(PopupAnnotationElement, _AnnotationElement4);
	
	  function PopupAnnotationElement(parameters) {
	    _classCallCheck(this, PopupAnnotationElement);
	
	    var isRenderable = !!(parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (PopupAnnotationElement.__proto__ || Object.getPrototypeOf(PopupAnnotationElement)).call(this, parameters, isRenderable));
	  }
	
	  _createClass(PopupAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      var IGNORE_TYPES = ['Line', 'Square', 'Circle', 'PolyLine', 'Polygon'];
	      this.container.className = 'popupAnnotation';
	      if (IGNORE_TYPES.indexOf(this.data.parentType) >= 0) {
	        return this.container;
	      }
	      var selector = '[data-annotation-id="' + this.data.parentId + '"]';
	      var parentElement = this.layer.querySelector(selector);
	      if (!parentElement) {
	        return this.container;
	      }
	      var popup = new PopupElement({
	        container: this.container,
	        trigger: parentElement,
	        color: this.data.color,
	        title: this.data.title,
	        contents: this.data.contents
	      });
	      var parentLeft = parseFloat(parentElement.style.left);
	      var parentWidth = parseFloat(parentElement.style.width);
	      _dom_utils.CustomStyle.setProp('transformOrigin', this.container, -(parentLeft + parentWidth) + 'px -' + parentElement.style.top);
	      this.container.style.left = parentLeft + parentWidth + 'px';
	      this.container.appendChild(popup.render());
	      return this.container;
	    }
	  }]);
	
	  return PopupAnnotationElement;
	}(AnnotationElement);
	
	var PopupElement = function () {
	  function PopupElement(parameters) {
	    _classCallCheck(this, PopupElement);
	
	    this.container = parameters.container;
	    this.trigger = parameters.trigger;
	    this.color = parameters.color;
	    this.title = parameters.title;
	    this.contents = parameters.contents;
	    this.hideWrapper = parameters.hideWrapper || false;
	    this.pinned = false;
	  }
	
	  _createClass(PopupElement, [{
	    key: 'render',
	    value: function render() {
	      var BACKGROUND_ENLIGHT = 0.7;
	      var wrapper = document.createElement('div');
	      wrapper.className = 'popupWrapper';
	      this.hideElement = this.hideWrapper ? wrapper : this.container;
	      this.hideElement.setAttribute('hidden', true);
	      var popup = document.createElement('div');
	      popup.className = 'popup';
	      var color = this.color;
	      if (color) {
	        var r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0];
	        var g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1];
	        var b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2];
	        popup.style.backgroundColor = _util.Util.makeCssRgb(r | 0, g | 0, b | 0);
	      }
	      var contents = this._formatContents(this.contents);
	      var title = document.createElement('h1');
	      title.textContent = this.title;
	      this.trigger.addEventListener('click', this._toggle.bind(this));
	      this.trigger.addEventListener('mouseover', this._show.bind(this, false));
	      this.trigger.addEventListener('mouseout', this._hide.bind(this, false));
	      popup.addEventListener('click', this._hide.bind(this, true));
	      popup.appendChild(title);
	      popup.appendChild(contents);
	      wrapper.appendChild(popup);
	      return wrapper;
	    }
	  }, {
	    key: '_formatContents',
	    value: function _formatContents(contents) {
	      var p = document.createElement('p');
	      var lines = contents.split(/(?:\r\n?|\n)/);
	      for (var i = 0, ii = lines.length; i < ii; ++i) {
	        var line = lines[i];
	        p.appendChild(document.createTextNode(line));
	        if (i < ii - 1) {
	          p.appendChild(document.createElement('br'));
	        }
	      }
	      return p;
	    }
	  }, {
	    key: '_toggle',
	    value: function _toggle() {
	      if (this.pinned) {
	        this._hide(true);
	      } else {
	        this._show(true);
	      }
	    }
	  }, {
	    key: '_show',
	    value: function _show() {
	      var pin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (pin) {
	        this.pinned = true;
	      }
	      if (this.hideElement.hasAttribute('hidden')) {
	        this.hideElement.removeAttribute('hidden');
	        this.container.style.zIndex += 1;
	      }
	    }
	  }, {
	    key: '_hide',
	    value: function _hide() {
	      var unpin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (unpin) {
	        this.pinned = false;
	      }
	      if (!this.hideElement.hasAttribute('hidden') && !this.pinned) {
	        this.hideElement.setAttribute('hidden', true);
	        this.container.style.zIndex -= 1;
	      }
	    }
	  }]);
	
	  return PopupElement;
	}();
	
	var LineAnnotationElement = function (_AnnotationElement5) {
	  _inherits(LineAnnotationElement, _AnnotationElement5);
	
	  function LineAnnotationElement(parameters) {
	    _classCallCheck(this, LineAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (LineAnnotationElement.__proto__ || Object.getPrototypeOf(LineAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(LineAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'lineAnnotation';
	      var data = this.data;
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      var svg = this.svgFactory.create(width, height);
	      var line = this.svgFactory.createElement('svg:line');
	      line.setAttribute('x1', data.rect[2] - data.lineCoordinates[0]);
	      line.setAttribute('y1', data.rect[3] - data.lineCoordinates[1]);
	      line.setAttribute('x2', data.rect[2] - data.lineCoordinates[2]);
	      line.setAttribute('y2', data.rect[3] - data.lineCoordinates[3]);
	      line.setAttribute('stroke-width', data.borderStyle.width);
	      line.setAttribute('stroke', 'transparent');
	      svg.appendChild(line);
	      this.container.append(svg);
	      this._createPopup(this.container, line, data);
	      return this.container;
	    }
	  }]);
	
	  return LineAnnotationElement;
	}(AnnotationElement);
	
	var SquareAnnotationElement = function (_AnnotationElement6) {
	  _inherits(SquareAnnotationElement, _AnnotationElement6);
	
	  function SquareAnnotationElement(parameters) {
	    _classCallCheck(this, SquareAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (SquareAnnotationElement.__proto__ || Object.getPrototypeOf(SquareAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(SquareAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'squareAnnotation';
	      var data = this.data;
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      var svg = this.svgFactory.create(width, height);
	      var borderWidth = data.borderStyle.width;
	      var square = this.svgFactory.createElement('svg:rect');
	      square.setAttribute('x', borderWidth / 2);
	      square.setAttribute('y', borderWidth / 2);
	      square.setAttribute('width', width - borderWidth);
	      square.setAttribute('height', height - borderWidth);
	      square.setAttribute('stroke-width', borderWidth);
	      square.setAttribute('stroke', 'transparent');
	      square.setAttribute('fill', 'none');
	      svg.appendChild(square);
	      this.container.append(svg);
	      this._createPopup(this.container, square, data);
	      return this.container;
	    }
	  }]);
	
	  return SquareAnnotationElement;
	}(AnnotationElement);
	
	var CircleAnnotationElement = function (_AnnotationElement7) {
	  _inherits(CircleAnnotationElement, _AnnotationElement7);
	
	  function CircleAnnotationElement(parameters) {
	    _classCallCheck(this, CircleAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (CircleAnnotationElement.__proto__ || Object.getPrototypeOf(CircleAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(CircleAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'circleAnnotation';
	      var data = this.data;
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      var svg = this.svgFactory.create(width, height);
	      var borderWidth = data.borderStyle.width;
	      var circle = this.svgFactory.createElement('svg:ellipse');
	      circle.setAttribute('cx', width / 2);
	      circle.setAttribute('cy', height / 2);
	      circle.setAttribute('rx', width / 2 - borderWidth / 2);
	      circle.setAttribute('ry', height / 2 - borderWidth / 2);
	      circle.setAttribute('stroke-width', borderWidth);
	      circle.setAttribute('stroke', 'transparent');
	      circle.setAttribute('fill', 'none');
	      svg.appendChild(circle);
	      this.container.append(svg);
	      this._createPopup(this.container, circle, data);
	      return this.container;
	    }
	  }]);
	
	  return CircleAnnotationElement;
	}(AnnotationElement);
	
	var PolylineAnnotationElement = function (_AnnotationElement8) {
	  _inherits(PolylineAnnotationElement, _AnnotationElement8);
	
	  function PolylineAnnotationElement(parameters) {
	    _classCallCheck(this, PolylineAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	
	    var _this14 = _possibleConstructorReturn(this, (PolylineAnnotationElement.__proto__ || Object.getPrototypeOf(PolylineAnnotationElement)).call(this, parameters, isRenderable, true));
	
	    _this14.containerClassName = 'polylineAnnotation';
	    _this14.svgElementName = 'svg:polyline';
	    return _this14;
	  }
	
	  _createClass(PolylineAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = this.containerClassName;
	      var data = this.data;
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      var svg = this.svgFactory.create(width, height);
	      var vertices = data.vertices;
	      var points = [];
	      for (var i = 0, ii = vertices.length; i < ii; i++) {
	        var x = vertices[i].x - data.rect[0];
	        var y = data.rect[3] - vertices[i].y;
	        points.push(x + ',' + y);
	      }
	      points = points.join(' ');
	      var borderWidth = data.borderStyle.width;
	      var polyline = this.svgFactory.createElement(this.svgElementName);
	      polyline.setAttribute('points', points);
	      polyline.setAttribute('stroke-width', borderWidth);
	      polyline.setAttribute('stroke', 'transparent');
	      polyline.setAttribute('fill', 'none');
	      svg.appendChild(polyline);
	      this.container.append(svg);
	      this._createPopup(this.container, polyline, data);
	      return this.container;
	    }
	  }]);
	
	  return PolylineAnnotationElement;
	}(AnnotationElement);
	
	var PolygonAnnotationElement = function (_PolylineAnnotationEl) {
	  _inherits(PolygonAnnotationElement, _PolylineAnnotationEl);
	
	  function PolygonAnnotationElement(parameters) {
	    _classCallCheck(this, PolygonAnnotationElement);
	
	    var _this15 = _possibleConstructorReturn(this, (PolygonAnnotationElement.__proto__ || Object.getPrototypeOf(PolygonAnnotationElement)).call(this, parameters));
	
	    _this15.containerClassName = 'polygonAnnotation';
	    _this15.svgElementName = 'svg:polygon';
	    return _this15;
	  }
	
	  return PolygonAnnotationElement;
	}(PolylineAnnotationElement);
	
	var HighlightAnnotationElement = function (_AnnotationElement9) {
	  _inherits(HighlightAnnotationElement, _AnnotationElement9);
	
	  function HighlightAnnotationElement(parameters) {
	    _classCallCheck(this, HighlightAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (HighlightAnnotationElement.__proto__ || Object.getPrototypeOf(HighlightAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(HighlightAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'highlightAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return HighlightAnnotationElement;
	}(AnnotationElement);
	
	var UnderlineAnnotationElement = function (_AnnotationElement10) {
	  _inherits(UnderlineAnnotationElement, _AnnotationElement10);
	
	  function UnderlineAnnotationElement(parameters) {
	    _classCallCheck(this, UnderlineAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (UnderlineAnnotationElement.__proto__ || Object.getPrototypeOf(UnderlineAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(UnderlineAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'underlineAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return UnderlineAnnotationElement;
	}(AnnotationElement);
	
	var SquigglyAnnotationElement = function (_AnnotationElement11) {
	  _inherits(SquigglyAnnotationElement, _AnnotationElement11);
	
	  function SquigglyAnnotationElement(parameters) {
	    _classCallCheck(this, SquigglyAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (SquigglyAnnotationElement.__proto__ || Object.getPrototypeOf(SquigglyAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(SquigglyAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'squigglyAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return SquigglyAnnotationElement;
	}(AnnotationElement);
	
	var StrikeOutAnnotationElement = function (_AnnotationElement12) {
	  _inherits(StrikeOutAnnotationElement, _AnnotationElement12);
	
	  function StrikeOutAnnotationElement(parameters) {
	    _classCallCheck(this, StrikeOutAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (StrikeOutAnnotationElement.__proto__ || Object.getPrototypeOf(StrikeOutAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(StrikeOutAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'strikeoutAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return StrikeOutAnnotationElement;
	}(AnnotationElement);
	
	var StampAnnotationElement = function (_AnnotationElement13) {
	  _inherits(StampAnnotationElement, _AnnotationElement13);
	
	  function StampAnnotationElement(parameters) {
	    _classCallCheck(this, StampAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (StampAnnotationElement.__proto__ || Object.getPrototypeOf(StampAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(StampAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'stampAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return StampAnnotationElement;
	}(AnnotationElement);
	
	var FileAttachmentAnnotationElement = function (_AnnotationElement14) {
	  _inherits(FileAttachmentAnnotationElement, _AnnotationElement14);
	
	  function FileAttachmentAnnotationElement(parameters) {
	    _classCallCheck(this, FileAttachmentAnnotationElement);
	
	    var _this21 = _possibleConstructorReturn(this, (FileAttachmentAnnotationElement.__proto__ || Object.getPrototypeOf(FileAttachmentAnnotationElement)).call(this, parameters, true));
	
	    var file = _this21.data.file;
	    _this21.filename = (0, _dom_utils.getFilenameFromUrl)(file.filename);
	    _this21.content = file.content;
	    _this21.linkService.onFileAttachmentAnnotation({
	      id: (0, _util.stringToPDFString)(file.filename),
	      filename: file.filename,
	      content: file.content
	    });
	    return _this21;
	  }
	
	  _createClass(FileAttachmentAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'fileAttachmentAnnotation';
	      var trigger = document.createElement('div');
	      trigger.style.height = this.container.style.height;
	      trigger.style.width = this.container.style.width;
	      trigger.addEventListener('dblclick', this._download.bind(this));
	      if (!this.data.hasPopup && (this.data.title || this.data.contents)) {
	        this._createPopup(this.container, trigger, this.data);
	      }
	      this.container.appendChild(trigger);
	      return this.container;
	    }
	  }, {
	    key: '_download',
	    value: function _download() {
	      if (!this.downloadManager) {
	        (0, _util.warn)('Download cannot be started due to unavailable download manager');
	        return;
	      }
	      this.downloadManager.downloadData(this.content, this.filename, '');
	    }
	  }]);
	
	  return FileAttachmentAnnotationElement;
	}(AnnotationElement);
	
	var AnnotationLayer = function () {
	  function AnnotationLayer() {
	    _classCallCheck(this, AnnotationLayer);
	  }
	
	  _createClass(AnnotationLayer, null, [{
	    key: 'render',
	    value: function render(parameters) {
	      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
	        var data = parameters.annotations[i];
	        if (!data) {
	          continue;
	        }
	        var element = AnnotationElementFactory.create({
	          data: data,
	          layer: parameters.div,
	          page: parameters.page,
	          viewport: parameters.viewport,
	          linkService: parameters.linkService,
	          downloadManager: parameters.downloadManager,
	          imageResourcesPath: parameters.imageResourcesPath || (0, _dom_utils.getDefaultSetting)('imageResourcesPath'),
	          renderInteractiveForms: parameters.renderInteractiveForms || false,
	          svgFactory: new _dom_utils.DOMSVGFactory()
	        });
	        if (element.isRenderable) {
	          parameters.div.appendChild(element.render());
	        }
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(parameters) {
	      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
	        var data = parameters.annotations[i];
	        var element = parameters.div.querySelector('[data-annotation-id="' + data.id + '"]');
	        if (element) {
	          _dom_utils.CustomStyle.setProp('transform', element, 'matrix(' + parameters.viewport.transform.join(',') + ')');
	        }
	      }
	      parameters.div.removeAttribute('hidden');
	    }
	  }]);
	
	  return AnnotationLayer;
	}();
	
	exports.AnnotationLayer = AnnotationLayer;
	
	/***/ }),
	/* 89 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderTextLayer = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _dom_utils = __w_pdfjs_require__(17);
	
	var renderTextLayer = function renderTextLayerClosure() {
	  var MAX_TEXT_DIVS_TO_RENDER = 100000;
	  var NonWhitespaceRegexp = /\S/;
	  function isAllWhitespace(str) {
	    return !NonWhitespaceRegexp.test(str);
	  }
	  var styleBuf = ['left: ', 0, 'px; top: ', 0, 'px; font-size: ', 0, 'px; font-family: ', '', ';'];
	  function appendText(task, geom, styles) {
	    var textDiv = document.createElement('div');
	    var textDivProperties = {
	      style: null,
	      angle: 0,
	      canvasWidth: 0,
	      isWhitespace: false,
	      originalTransform: null,
	      paddingBottom: 0,
	      paddingLeft: 0,
	      paddingRight: 0,
	      paddingTop: 0,
	      scale: 1
	    };
	    task._textDivs.push(textDiv);
	    if (isAllWhitespace(geom.str)) {
	      textDivProperties.isWhitespace = true;
	      task._textDivProperties.set(textDiv, textDivProperties);
	      return;
	    }
	    var tx = _util.Util.transform(task._viewport.transform, geom.transform);
	    var angle = Math.atan2(tx[1], tx[0]);
	    var style = styles[geom.fontName];
	    if (style.vertical) {
	      angle += Math.PI / 2;
	    }
	    var fontHeight = Math.sqrt(tx[2] * tx[2] + tx[3] * tx[3]);
	    var fontAscent = fontHeight;
	    if (style.ascent) {
	      fontAscent = style.ascent * fontAscent;
	    } else if (style.descent) {
	      fontAscent = (1 + style.descent) * fontAscent;
	    }
	    var left;
	    var top;
	    if (angle === 0) {
	      left = tx[4];
	      top = tx[5] - fontAscent;
	    } else {
	      left = tx[4] + fontAscent * Math.sin(angle);
	      top = tx[5] - fontAscent * Math.cos(angle);
	    }
	    styleBuf[1] = left;
	    styleBuf[3] = top;
	    styleBuf[5] = fontHeight;
	    styleBuf[7] = style.fontFamily;
	    textDivProperties.style = styleBuf.join('');
	    textDiv.setAttribute('style', textDivProperties.style);
	    textDiv.textContent = geom.str;
	    if ((0, _dom_utils.getDefaultSetting)('pdfBug')) {
	      textDiv.dataset.fontName = geom.fontName;
	    }
	    if (angle !== 0) {
	      textDivProperties.angle = angle * (180 / Math.PI);
	    }
	    if (geom.str.length > 1) {
	      if (style.vertical) {
	        textDivProperties.canvasWidth = geom.height * task._viewport.scale;
	      } else {
	        textDivProperties.canvasWidth = geom.width * task._viewport.scale;
	      }
	    }
	    task._textDivProperties.set(textDiv, textDivProperties);
	    if (task._textContentStream) {
	      task._layoutText(textDiv);
	    }
	    if (task._enhanceTextSelection) {
	      var angleCos = 1,
	          angleSin = 0;
	      if (angle !== 0) {
	        angleCos = Math.cos(angle);
	        angleSin = Math.sin(angle);
	      }
	      var divWidth = (style.vertical ? geom.height : geom.width) * task._viewport.scale;
	      var divHeight = fontHeight;
	      var m, b;
	      if (angle !== 0) {
	        m = [angleCos, angleSin, -angleSin, angleCos, left, top];
	        b = _util.Util.getAxialAlignedBoundingBox([0, 0, divWidth, divHeight], m);
	      } else {
	        b = [left, top, left + divWidth, top + divHeight];
	      }
	      task._bounds.push({
	        left: b[0],
	        top: b[1],
	        right: b[2],
	        bottom: b[3],
	        div: textDiv,
	        size: [divWidth, divHeight],
	        m: m
	      });
	    }
	  }
	  function render(task) {
	    if (task._canceled) {
	      return;
	    }
	    var textDivs = task._textDivs;
	    var capability = task._capability;
	    var textDivsLength = textDivs.length;
	    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
	      task._renderingDone = true;
	      capability.resolve();
	      return;
	    }
	    if (!task._textContentStream) {
	      for (var i = 0; i < textDivsLength; i++) {
	        task._layoutText(textDivs[i]);
	      }
	    }
	    task._renderingDone = true;
	    capability.resolve();
	  }
	  function expand(task) {
	    var bounds = task._bounds;
	    var viewport = task._viewport;
	    var expanded = expandBounds(viewport.width, viewport.height, bounds);
	    for (var i = 0; i < expanded.length; i++) {
	      var div = bounds[i].div;
	      var divProperties = task._textDivProperties.get(div);
	      if (divProperties.angle === 0) {
	        divProperties.paddingLeft = bounds[i].left - expanded[i].left;
	        divProperties.paddingTop = bounds[i].top - expanded[i].top;
	        divProperties.paddingRight = expanded[i].right - bounds[i].right;
	        divProperties.paddingBottom = expanded[i].bottom - bounds[i].bottom;
	        task._textDivProperties.set(div, divProperties);
	        continue;
	      }
	      var e = expanded[i],
	          b = bounds[i];
	      var m = b.m,
	          c = m[0],
	          s = m[1];
	      var points = [[0, 0], [0, b.size[1]], [b.size[0], 0], b.size];
	      var ts = new Float64Array(64);
	      points.forEach(function (p, i) {
	        var t = _util.Util.applyTransform(p, m);
	        ts[i + 0] = c && (e.left - t[0]) / c;
	        ts[i + 4] = s && (e.top - t[1]) / s;
	        ts[i + 8] = c && (e.right - t[0]) / c;
	        ts[i + 12] = s && (e.bottom - t[1]) / s;
	        ts[i + 16] = s && (e.left - t[0]) / -s;
	        ts[i + 20] = c && (e.top - t[1]) / c;
	        ts[i + 24] = s && (e.right - t[0]) / -s;
	        ts[i + 28] = c && (e.bottom - t[1]) / c;
	        ts[i + 32] = c && (e.left - t[0]) / -c;
	        ts[i + 36] = s && (e.top - t[1]) / -s;
	        ts[i + 40] = c && (e.right - t[0]) / -c;
	        ts[i + 44] = s && (e.bottom - t[1]) / -s;
	        ts[i + 48] = s && (e.left - t[0]) / s;
	        ts[i + 52] = c && (e.top - t[1]) / -c;
	        ts[i + 56] = s && (e.right - t[0]) / s;
	        ts[i + 60] = c && (e.bottom - t[1]) / -c;
	      });
	      var findPositiveMin = function findPositiveMin(ts, offset, count) {
	        var result = 0;
	        for (var i = 0; i < count; i++) {
	          var t = ts[offset++];
	          if (t > 0) {
	            result = result ? Math.min(t, result) : t;
	          }
	        }
	        return result;
	      };
	      var boxScale = 1 + Math.min(Math.abs(c), Math.abs(s));
	      divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale;
	      divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale;
	      divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale;
	      divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale;
	      task._textDivProperties.set(div, divProperties);
	    }
	  }
	  function expandBounds(width, height, boxes) {
	    var bounds = boxes.map(function (box, i) {
	      return {
	        x1: box.left,
	        y1: box.top,
	        x2: box.right,
	        y2: box.bottom,
	        index: i,
	        x1New: undefined,
	        x2New: undefined
	      };
	    });
	    expandBoundsLTR(width, bounds);
	    var expanded = new Array(boxes.length);
	    bounds.forEach(function (b) {
	      var i = b.index;
	      expanded[i] = {
	        left: b.x1New,
	        top: 0,
	        right: b.x2New,
	        bottom: 0
	      };
	    });
	    boxes.map(function (box, i) {
	      var e = expanded[i],
	          b = bounds[i];
	      b.x1 = box.top;
	      b.y1 = width - e.right;
	      b.x2 = box.bottom;
	      b.y2 = width - e.left;
	      b.index = i;
	      b.x1New = undefined;
	      b.x2New = undefined;
	    });
	    expandBoundsLTR(height, bounds);
	    bounds.forEach(function (b) {
	      var i = b.index;
	      expanded[i].top = b.x1New;
	      expanded[i].bottom = b.x2New;
	    });
	    return expanded;
	  }
	  function expandBoundsLTR(width, bounds) {
	    bounds.sort(function (a, b) {
	      return a.x1 - b.x1 || a.index - b.index;
	    });
	    var fakeBoundary = {
	      x1: -Infinity,
	      y1: -Infinity,
	      x2: 0,
	      y2: Infinity,
	      index: -1,
	      x1New: 0,
	      x2New: 0
	    };
	    var horizon = [{
	      start: -Infinity,
	      end: Infinity,
	      boundary: fakeBoundary
	    }];
	    bounds.forEach(function (boundary) {
	      var i = 0;
	      while (i < horizon.length && horizon[i].end <= boundary.y1) {
	        i++;
	      }
	      var j = horizon.length - 1;
	      while (j >= 0 && horizon[j].start >= boundary.y2) {
	        j--;
	      }
	      var horizonPart, affectedBoundary;
	      var q,
	          k,
	          maxXNew = -Infinity;
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        var xNew;
	        if (affectedBoundary.x2 > boundary.x1) {
	          xNew = affectedBoundary.index > boundary.index ? affectedBoundary.x1New : boundary.x1;
	        } else if (affectedBoundary.x2New === undefined) {
	          xNew = (affectedBoundary.x2 + boundary.x1) / 2;
	        } else {
	          xNew = affectedBoundary.x2New;
	        }
	        if (xNew > maxXNew) {
	          maxXNew = xNew;
	        }
	      }
	      boundary.x1New = maxXNew;
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        if (affectedBoundary.x2New === undefined) {
	          if (affectedBoundary.x2 > boundary.x1) {
	            if (affectedBoundary.index > boundary.index) {
	              affectedBoundary.x2New = affectedBoundary.x2;
	            }
	          } else {
	            affectedBoundary.x2New = maxXNew;
	          }
	        } else if (affectedBoundary.x2New > maxXNew) {
	          affectedBoundary.x2New = Math.max(maxXNew, affectedBoundary.x2);
	        }
	      }
	      var changedHorizon = [],
	          lastBoundary = null;
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        var useBoundary = affectedBoundary.x2 > boundary.x2 ? affectedBoundary : boundary;
	        if (lastBoundary === useBoundary) {
	          changedHorizon[changedHorizon.length - 1].end = horizonPart.end;
	        } else {
	          changedHorizon.push({
	            start: horizonPart.start,
	            end: horizonPart.end,
	            boundary: useBoundary
	          });
	          lastBoundary = useBoundary;
	        }
	      }
	      if (horizon[i].start < boundary.y1) {
	        changedHorizon[0].start = boundary.y1;
	        changedHorizon.unshift({
	          start: horizon[i].start,
	          end: boundary.y1,
	          boundary: horizon[i].boundary
	        });
	      }
	      if (boundary.y2 < horizon[j].end) {
	        changedHorizon[changedHorizon.length - 1].end = boundary.y2;
	        changedHorizon.push({
	          start: boundary.y2,
	          end: horizon[j].end,
	          boundary: horizon[j].boundary
	        });
	      }
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        if (affectedBoundary.x2New !== undefined) {
	          continue;
	        }
	        var used = false;
	        for (k = i - 1; !used && k >= 0 && horizon[k].start >= affectedBoundary.y1; k--) {
	          used = horizon[k].boundary === affectedBoundary;
	        }
	        for (k = j + 1; !used && k < horizon.length && horizon[k].end <= affectedBoundary.y2; k++) {
	          used = horizon[k].boundary === affectedBoundary;
	        }
	        for (k = 0; !used && k < changedHorizon.length; k++) {
	          used = changedHorizon[k].boundary === affectedBoundary;
	        }
	        if (!used) {
	          affectedBoundary.x2New = maxXNew;
	        }
	      }
	      Array.prototype.splice.apply(horizon, [i, j - i + 1].concat(changedHorizon));
	    });
	    horizon.forEach(function (horizonPart) {
	      var affectedBoundary = horizonPart.boundary;
	      if (affectedBoundary.x2New === undefined) {
	        affectedBoundary.x2New = Math.max(width, affectedBoundary.x2);
	      }
	    });
	  }
	  function TextLayerRenderTask(_ref) {
	    var textContent = _ref.textContent,
	        textContentStream = _ref.textContentStream,
	        container = _ref.container,
	        viewport = _ref.viewport,
	        textDivs = _ref.textDivs,
	        textContentItemsStr = _ref.textContentItemsStr,
	        enhanceTextSelection = _ref.enhanceTextSelection;
	
	    this._textContent = textContent;
	    this._textContentStream = textContentStream;
	    this._container = container;
	    this._viewport = viewport;
	    this._textDivs = textDivs || [];
	    this._textContentItemsStr = textContentItemsStr || [];
	    this._enhanceTextSelection = !!enhanceTextSelection;
	    this._reader = null;
	    this._layoutTextLastFontSize = null;
	    this._layoutTextLastFontFamily = null;
	    this._layoutTextCtx = null;
	    this._textDivProperties = new WeakMap();
	    this._renderingDone = false;
	    this._canceled = false;
	    this._capability = (0, _util.createPromiseCapability)();
	    this._renderTimer = null;
	    this._bounds = [];
	  }
	  TextLayerRenderTask.prototype = {
	    get promise() {
	      return this._capability.promise;
	    },
	    cancel: function TextLayer_cancel() {
	      if (this._reader) {
	        this._reader.cancel(new _util.AbortException('text layer task cancelled'));
	        this._reader = null;
	      }
	      this._canceled = true;
	      if (this._renderTimer !== null) {
	        clearTimeout(this._renderTimer);
	        this._renderTimer = null;
	      }
	      this._capability.reject('canceled');
	    },
	    _processItems: function _processItems(items, styleCache) {
	      for (var i = 0, len = items.length; i < len; i++) {
	        this._textContentItemsStr.push(items[i].str);
	        appendText(this, items[i], styleCache);
	      }
	    },
	    _layoutText: function _layoutText(textDiv) {
	      var textLayerFrag = this._container;
	      var textDivProperties = this._textDivProperties.get(textDiv);
	      if (textDivProperties.isWhitespace) {
	        return;
	      }
	      var fontSize = textDiv.style.fontSize;
	      var fontFamily = textDiv.style.fontFamily;
	      if (fontSize !== this._layoutTextLastFontSize || fontFamily !== this._layoutTextLastFontFamily) {
	        this._layoutTextCtx.font = fontSize + ' ' + fontFamily;
	        this._lastFontSize = fontSize;
	        this._lastFontFamily = fontFamily;
	      }
	      var width = this._layoutTextCtx.measureText(textDiv.textContent).width;
	      var transform = '';
	      if (textDivProperties.canvasWidth !== 0 && width > 0) {
	        textDivProperties.scale = textDivProperties.canvasWidth / width;
	        transform = 'scaleX(' + textDivProperties.scale + ')';
	      }
	      if (textDivProperties.angle !== 0) {
	        transform = 'rotate(' + textDivProperties.angle + 'deg) ' + transform;
	      }
	      if (transform !== '') {
	        textDivProperties.originalTransform = transform;
	        _dom_utils.CustomStyle.setProp('transform', textDiv, transform);
	      }
	      this._textDivProperties.set(textDiv, textDivProperties);
	      textLayerFrag.appendChild(textDiv);
	    },
	
	    _render: function TextLayer_render(timeout) {
	      var _this = this;
	
	      var capability = (0, _util.createPromiseCapability)();
	      var styleCache = Object.create(null);
	      var canvas = document.createElement('canvas');
	      this._layoutTextCtx = canvas.getContext('2d', { alpha: false });
	      if (this._textContent) {
	        var textItems = this._textContent.items;
	        var textStyles = this._textContent.styles;
	        this._processItems(textItems, textStyles);
	        capability.resolve();
	      } else if (this._textContentStream) {
	        var pump = function pump() {
	          _this._reader.read().then(function (_ref2) {
	            var value = _ref2.value,
	                done = _ref2.done;
	
	            if (done) {
	              capability.resolve();
	              return;
	            }
	            _util.Util.extendObj(styleCache, value.styles);
	            _this._processItems(value.items, styleCache);
	            pump();
	          }, capability.reject);
	        };
	        this._reader = this._textContentStream.getReader();
	        pump();
	      } else {
	        throw new Error('Neither "textContent" nor "textContentStream"' + ' parameters specified.');
	      }
	      capability.promise.then(function () {
	        styleCache = null;
	        if (!timeout) {
	          render(_this);
	        } else {
	          _this._renderTimer = setTimeout(function () {
	            render(_this);
	            _this._renderTimer = null;
	          }, timeout);
	        }
	      }, this._capability.reject);
	    },
	    expandTextDivs: function TextLayer_expandTextDivs(expandDivs) {
	      if (!this._enhanceTextSelection || !this._renderingDone) {
	        return;
	      }
	      if (this._bounds !== null) {
	        expand(this);
	        this._bounds = null;
	      }
	      for (var i = 0, ii = this._textDivs.length; i < ii; i++) {
	        var div = this._textDivs[i];
	        var divProperties = this._textDivProperties.get(div);
	        if (divProperties.isWhitespace) {
	          continue;
	        }
	        if (expandDivs) {
	          var transform = '',
	              padding = '';
	          if (divProperties.scale !== 1) {
	            transform = 'scaleX(' + divProperties.scale + ')';
	          }
	          if (divProperties.angle !== 0) {
	            transform = 'rotate(' + divProperties.angle + 'deg) ' + transform;
	          }
	          if (divProperties.paddingLeft !== 0) {
	            padding += ' padding-left: ' + divProperties.paddingLeft / divProperties.scale + 'px;';
	            transform += ' translateX(' + -divProperties.paddingLeft / divProperties.scale + 'px)';
	          }
	          if (divProperties.paddingTop !== 0) {
	            padding += ' padding-top: ' + divProperties.paddingTop + 'px;';
	            transform += ' translateY(' + -divProperties.paddingTop + 'px)';
	          }
	          if (divProperties.paddingRight !== 0) {
	            padding += ' padding-right: ' + divProperties.paddingRight / divProperties.scale + 'px;';
	          }
	          if (divProperties.paddingBottom !== 0) {
	            padding += ' padding-bottom: ' + divProperties.paddingBottom + 'px;';
	          }
	          if (padding !== '') {
	            div.setAttribute('style', divProperties.style + padding);
	          }
	          if (transform !== '') {
	            _dom_utils.CustomStyle.setProp('transform', div, transform);
	          }
	        } else {
	          div.style.padding = 0;
	          _dom_utils.CustomStyle.setProp('transform', div, divProperties.originalTransform || '');
	        }
	      }
	    }
	  };
	  function renderTextLayer(renderParameters) {
	    var task = new TextLayerRenderTask({
	      textContent: renderParameters.textContent,
	      textContentStream: renderParameters.textContentStream,
	      container: renderParameters.container,
	      viewport: renderParameters.viewport,
	      textDivs: renderParameters.textDivs,
	      textContentItemsStr: renderParameters.textContentItemsStr,
	      enhanceTextSelection: renderParameters.enhanceTextSelection
	    });
	    task._render(renderParameters.timeout);
	    return task;
	  }
	  return renderTextLayer;
	}();
	exports.renderTextLayer = renderTextLayer;
	
	/***/ }),
	/* 90 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SVGGraphics = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _dom_utils = __w_pdfjs_require__(17);
	
	var SVGGraphics = function SVGGraphics() {
	  throw new Error('Not implemented: SVGGraphics');
	};
	{
	  var SVG_DEFAULTS = {
	    fontStyle: 'normal',
	    fontWeight: 'normal',
	    fillColor: '#000000'
	  };
	  var convertImgDataToPng = function convertImgDataToPngClosure() {
	    var PNG_HEADER = new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]);
	    var CHUNK_WRAPPER_SIZE = 12;
	    var crcTable = new Int32Array(256);
	    for (var i = 0; i < 256; i++) {
	      var c = i;
	      for (var h = 0; h < 8; h++) {
	        if (c & 1) {
	          c = 0xedB88320 ^ c >> 1 & 0x7fffffff;
	        } else {
	          c = c >> 1 & 0x7fffffff;
	        }
	      }
	      crcTable[i] = c;
	    }
	    function crc32(data, start, end) {
	      var crc = -1;
	      for (var i = start; i < end; i++) {
	        var a = (crc ^ data[i]) & 0xff;
	        var b = crcTable[a];
	        crc = crc >>> 8 ^ b;
	      }
	      return crc ^ -1;
	    }
	    function writePngChunk(type, body, data, offset) {
	      var p = offset;
	      var len = body.length;
	      data[p] = len >> 24 & 0xff;
	      data[p + 1] = len >> 16 & 0xff;
	      data[p + 2] = len >> 8 & 0xff;
	      data[p + 3] = len & 0xff;
	      p += 4;
	      data[p] = type.charCodeAt(0) & 0xff;
	      data[p + 1] = type.charCodeAt(1) & 0xff;
	      data[p + 2] = type.charCodeAt(2) & 0xff;
	      data[p + 3] = type.charCodeAt(3) & 0xff;
	      p += 4;
	      data.set(body, p);
	      p += body.length;
	      var crc = crc32(data, offset + 4, p);
	      data[p] = crc >> 24 & 0xff;
	      data[p + 1] = crc >> 16 & 0xff;
	      data[p + 2] = crc >> 8 & 0xff;
	      data[p + 3] = crc & 0xff;
	    }
	    function adler32(data, start, end) {
	      var a = 1;
	      var b = 0;
	      for (var i = start; i < end; ++i) {
	        a = (a + (data[i] & 0xff)) % 65521;
	        b = (b + a) % 65521;
	      }
	      return b << 16 | a;
	    }
	    function deflateSync(literals) {
	      if (!(0, _util.isNodeJS)()) {
	        return deflateSyncUncompressed(literals);
	      }
	      try {
	        var input;
	        if (parseInt(process.versions.node) >= 8) {
	          input = literals;
	        } else {
	          input = new Buffer(literals);
	        }
	        var output = __webpack_require__(145).deflateSync(input, { level: 9 });
	        return output instanceof Uint8Array ? output : new Uint8Array(output);
	      } catch (e) {
	        (0, _util.warn)('Not compressing PNG because zlib.deflateSync is unavailable: ' + e);
	      }
	      return deflateSyncUncompressed(literals);
	    }
	    function deflateSyncUncompressed(literals) {
	      var len = literals.length;
	      var maxBlockLength = 0xFFFF;
	      var deflateBlocks = Math.ceil(len / maxBlockLength);
	      var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
	      var pi = 0;
	      idat[pi++] = 0x78;
	      idat[pi++] = 0x9c;
	      var pos = 0;
	      while (len > maxBlockLength) {
	        idat[pi++] = 0x00;
	        idat[pi++] = 0xff;
	        idat[pi++] = 0xff;
	        idat[pi++] = 0x00;
	        idat[pi++] = 0x00;
	        idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
	        pi += maxBlockLength;
	        pos += maxBlockLength;
	        len -= maxBlockLength;
	      }
	      idat[pi++] = 0x01;
	      idat[pi++] = len & 0xff;
	      idat[pi++] = len >> 8 & 0xff;
	      idat[pi++] = ~len & 0xffff & 0xff;
	      idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
	      idat.set(literals.subarray(pos), pi);
	      pi += literals.length - pos;
	      var adler = adler32(literals, 0, literals.length);
	      idat[pi++] = adler >> 24 & 0xff;
	      idat[pi++] = adler >> 16 & 0xff;
	      idat[pi++] = adler >> 8 & 0xff;
	      idat[pi++] = adler & 0xff;
	      return idat;
	    }
	    function encode(imgData, kind, forceDataSchema) {
	      var width = imgData.width;
	      var height = imgData.height;
	      var bitDepth, colorType, lineSize;
	      var bytes = imgData.data;
	      switch (kind) {
	        case _util.ImageKind.GRAYSCALE_1BPP:
	          colorType = 0;
	          bitDepth = 1;
	          lineSize = width + 7 >> 3;
	          break;
	        case _util.ImageKind.RGB_24BPP:
	          colorType = 2;
	          bitDepth = 8;
	          lineSize = width * 3;
	          break;
	        case _util.ImageKind.RGBA_32BPP:
	          colorType = 6;
	          bitDepth = 8;
	          lineSize = width * 4;
	          break;
	        default:
	          throw new Error('invalid format');
	      }
	      var literals = new Uint8Array((1 + lineSize) * height);
	      var offsetLiterals = 0,
	          offsetBytes = 0;
	      var y, i;
	      for (y = 0; y < height; ++y) {
	        literals[offsetLiterals++] = 0;
	        literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
	        offsetBytes += lineSize;
	        offsetLiterals += lineSize;
	      }
	      if (kind === _util.ImageKind.GRAYSCALE_1BPP) {
	        offsetLiterals = 0;
	        for (y = 0; y < height; y++) {
	          offsetLiterals++;
	          for (i = 0; i < lineSize; i++) {
	            literals[offsetLiterals++] ^= 0xFF;
	          }
	        }
	      }
	      var ihdr = new Uint8Array([width >> 24 & 0xff, width >> 16 & 0xff, width >> 8 & 0xff, width & 0xff, height >> 24 & 0xff, height >> 16 & 0xff, height >> 8 & 0xff, height & 0xff, bitDepth, colorType, 0x00, 0x00, 0x00]);
	      var idat = deflateSync(literals);
	      var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
	      var data = new Uint8Array(pngLength);
	      var offset = 0;
	      data.set(PNG_HEADER, offset);
	      offset += PNG_HEADER.length;
	      writePngChunk('IHDR', ihdr, data, offset);
	      offset += CHUNK_WRAPPER_SIZE + ihdr.length;
	      writePngChunk('IDATA', idat, data, offset);
	      offset += CHUNK_WRAPPER_SIZE + idat.length;
	      writePngChunk('IEND', new Uint8Array(0), data, offset);
	      return (0, _util.createObjectURL)(data, 'image/png', forceDataSchema);
	    }
	    return function convertImgDataToPng(imgData, forceDataSchema) {
	      var kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
	      return encode(imgData, kind, forceDataSchema);
	    };
	  }();
	  var SVGExtraState = function SVGExtraStateClosure() {
	    function SVGExtraState() {
	      this.fontSizeScale = 1;
	      this.fontWeight = SVG_DEFAULTS.fontWeight;
	      this.fontSize = 0;
	      this.textMatrix = _util.IDENTITY_MATRIX;
	      this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
	      this.leading = 0;
	      this.x = 0;
	      this.y = 0;
	      this.lineX = 0;
	      this.lineY = 0;
	      this.charSpacing = 0;
	      this.wordSpacing = 0;
	      this.textHScale = 1;
	      this.textRise = 0;
	      this.fillColor = SVG_DEFAULTS.fillColor;
	      this.strokeColor = '#000000';
	      this.fillAlpha = 1;
	      this.strokeAlpha = 1;
	      this.lineWidth = 1;
	      this.lineJoin = '';
	      this.lineCap = '';
	      this.miterLimit = 0;
	      this.dashArray = [];
	      this.dashPhase = 0;
	      this.dependencies = [];
	      this.activeClipUrl = null;
	      this.clipGroup = null;
	      this.maskId = '';
	    }
	    SVGExtraState.prototype = {
	      clone: function SVGExtraState_clone() {
	        return Object.create(this);
	      },
	      setCurrentPoint: function SVGExtraState_setCurrentPoint(x, y) {
	        this.x = x;
	        this.y = y;
	      }
	    };
	    return SVGExtraState;
	  }();
	  exports.SVGGraphics = SVGGraphics = function SVGGraphicsClosure() {
	    function opListToTree(opList) {
	      var opTree = [];
	      var tmp = [];
	      var opListLen = opList.length;
	      for (var x = 0; x < opListLen; x++) {
	        if (opList[x].fn === 'save') {
	          opTree.push({
	            'fnId': 92,
	            'fn': 'group',
	            'items': []
	          });
	          tmp.push(opTree);
	          opTree = opTree[opTree.length - 1].items;
	          continue;
	        }
	        if (opList[x].fn === 'restore') {
	          opTree = tmp.pop();
	        } else {
	          opTree.push(opList[x]);
	        }
	      }
	      return opTree;
	    }
	    function pf(value) {
	      if (Number.isInteger(value)) {
	        return value.toString();
	      }
	      var s = value.toFixed(10);
	      var i = s.length - 1;
	      if (s[i] !== '0') {
	        return s;
	      }
	      do {
	        i--;
	      } while (s[i] === '0');
	      return s.substr(0, s[i] === '.' ? i : i + 1);
	    }
	    function pm(m) {
	      if (m[4] === 0 && m[5] === 0) {
	        if (m[1] === 0 && m[2] === 0) {
	          if (m[0] === 1 && m[3] === 1) {
	            return '';
	          }
	          return 'scale(' + pf(m[0]) + ' ' + pf(m[3]) + ')';
	        }
	        if (m[0] === m[3] && m[1] === -m[2]) {
	          var a = Math.acos(m[0]) * 180 / Math.PI;
	          return 'rotate(' + pf(a) + ')';
	        }
	      } else {
	        if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
	          return 'translate(' + pf(m[4]) + ' ' + pf(m[5]) + ')';
	        }
	      }
	      return 'matrix(' + pf(m[0]) + ' ' + pf(m[1]) + ' ' + pf(m[2]) + ' ' + pf(m[3]) + ' ' + pf(m[4]) + ' ' + pf(m[5]) + ')';
	    }
	    function SVGGraphics(commonObjs, objs, forceDataSchema) {
	      this.svgFactory = new _dom_utils.DOMSVGFactory();
	      this.current = new SVGExtraState();
	      this.transformMatrix = _util.IDENTITY_MATRIX;
	      this.transformStack = [];
	      this.extraStack = [];
	      this.commonObjs = commonObjs;
	      this.objs = objs;
	      this.pendingClip = null;
	      this.pendingEOFill = false;
	      this.embedFonts = false;
	      this.embeddedFonts = Object.create(null);
	      this.cssStyle = null;
	      this.forceDataSchema = !!forceDataSchema;
	    }
	    var XML_NS = 'http://www.w3.org/XML/1998/namespace';
	    var XLINK_NS = 'http://www.w3.org/1999/xlink';
	    var LINE_CAP_STYLES = ['butt', 'round', 'square'];
	    var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
	    var clipCount = 0;
	    var maskCount = 0;
	    SVGGraphics.prototype = {
	      save: function SVGGraphics_save() {
	        this.transformStack.push(this.transformMatrix);
	        var old = this.current;
	        this.extraStack.push(old);
	        this.current = old.clone();
	      },
	      restore: function SVGGraphics_restore() {
	        this.transformMatrix = this.transformStack.pop();
	        this.current = this.extraStack.pop();
	        this.pendingClip = null;
	        this.tgrp = null;
	      },
	      group: function SVGGraphics_group(items) {
	        this.save();
	        this.executeOpTree(items);
	        this.restore();
	      },
	      loadDependencies: function SVGGraphics_loadDependencies(operatorList) {
	        var _this = this;
	
	        var fnArray = operatorList.fnArray;
	        var fnArrayLen = fnArray.length;
	        var argsArray = operatorList.argsArray;
	        for (var i = 0; i < fnArrayLen; i++) {
	          if (_util.OPS.dependency === fnArray[i]) {
	            var deps = argsArray[i];
	            for (var n = 0, nn = deps.length; n < nn; n++) {
	              var obj = deps[n];
	              var common = obj.substring(0, 2) === 'g_';
	              var promise;
	              if (common) {
	                promise = new Promise(function (resolve) {
	                  _this.commonObjs.get(obj, resolve);
	                });
	              } else {
	                promise = new Promise(function (resolve) {
	                  _this.objs.get(obj, resolve);
	                });
	              }
	              this.current.dependencies.push(promise);
	            }
	          }
	        }
	        return Promise.all(this.current.dependencies);
	      },
	      transform: function SVGGraphics_transform(a, b, c, d, e, f) {
	        var transformMatrix = [a, b, c, d, e, f];
	        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
	        this.tgrp = null;
	      },
	      getSVG: function SVGGraphics_getSVG(operatorList, viewport) {
	        var _this2 = this;
	
	        this.viewport = viewport;
	        var svgElement = this._initialize(viewport);
	        return this.loadDependencies(operatorList).then(function () {
	          _this2.transformMatrix = _util.IDENTITY_MATRIX;
	          var opTree = _this2.convertOpList(operatorList);
	          _this2.executeOpTree(opTree);
	          return svgElement;
	        });
	      },
	      convertOpList: function SVGGraphics_convertOpList(operatorList) {
	        var argsArray = operatorList.argsArray;
	        var fnArray = operatorList.fnArray;
	        var fnArrayLen = fnArray.length;
	        var REVOPS = [];
	        var opList = [];
	        for (var op in _util.OPS) {
	          REVOPS[_util.OPS[op]] = op;
	        }
	        for (var x = 0; x < fnArrayLen; x++) {
	          var fnId = fnArray[x];
	          opList.push({
	            'fnId': fnId,
	            'fn': REVOPS[fnId],
	            'args': argsArray[x]
	          });
	        }
	        return opListToTree(opList);
	      },
	      executeOpTree: function SVGGraphics_executeOpTree(opTree) {
	        var opTreeLen = opTree.length;
	        for (var x = 0; x < opTreeLen; x++) {
	          var fn = opTree[x].fn;
	          var fnId = opTree[x].fnId;
	          var args = opTree[x].args;
	          switch (fnId | 0) {
	            case _util.OPS.beginText:
	              this.beginText();
	              break;
	            case _util.OPS.setLeading:
	              this.setLeading(args);
	              break;
	            case _util.OPS.setLeadingMoveText:
	              this.setLeadingMoveText(args[0], args[1]);
	              break;
	            case _util.OPS.setFont:
	              this.setFont(args);
	              break;
	            case _util.OPS.showText:
	              this.showText(args[0]);
	              break;
	            case _util.OPS.showSpacedText:
	              this.showText(args[0]);
	              break;
	            case _util.OPS.endText:
	              this.endText();
	              break;
	            case _util.OPS.moveText:
	              this.moveText(args[0], args[1]);
	              break;
	            case _util.OPS.setCharSpacing:
	              this.setCharSpacing(args[0]);
	              break;
	            case _util.OPS.setWordSpacing:
	              this.setWordSpacing(args[0]);
	              break;
	            case _util.OPS.setHScale:
	              this.setHScale(args[0]);
	              break;
	            case _util.OPS.setTextMatrix:
	              this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
	              break;
	            case _util.OPS.setTextRise:
	              this.setTextRise(args[0]);
	              break;
	            case _util.OPS.setLineWidth:
	              this.setLineWidth(args[0]);
	              break;
	            case _util.OPS.setLineJoin:
	              this.setLineJoin(args[0]);
	              break;
	            case _util.OPS.setLineCap:
	              this.setLineCap(args[0]);
	              break;
	            case _util.OPS.setMiterLimit:
	              this.setMiterLimit(args[0]);
	              break;
	            case _util.OPS.setFillRGBColor:
	              this.setFillRGBColor(args[0], args[1], args[2]);
	              break;
	            case _util.OPS.setStrokeRGBColor:
	              this.setStrokeRGBColor(args[0], args[1], args[2]);
	              break;
	            case _util.OPS.setDash:
	              this.setDash(args[0], args[1]);
	              break;
	            case _util.OPS.setGState:
	              this.setGState(args[0]);
	              break;
	            case _util.OPS.fill:
	              this.fill();
	              break;
	            case _util.OPS.eoFill:
	              this.eoFill();
	              break;
	            case _util.OPS.stroke:
	              this.stroke();
	              break;
	            case _util.OPS.fillStroke:
	              this.fillStroke();
	              break;
	            case _util.OPS.eoFillStroke:
	              this.eoFillStroke();
	              break;
	            case _util.OPS.clip:
	              this.clip('nonzero');
	              break;
	            case _util.OPS.eoClip:
	              this.clip('evenodd');
	              break;
	            case _util.OPS.paintSolidColorImageMask:
	              this.paintSolidColorImageMask();
	              break;
	            case _util.OPS.paintJpegXObject:
	              this.paintJpegXObject(args[0], args[1], args[2]);
	              break;
	            case _util.OPS.paintImageXObject:
	              this.paintImageXObject(args[0]);
	              break;
	            case _util.OPS.paintInlineImageXObject:
	              this.paintInlineImageXObject(args[0]);
	              break;
	            case _util.OPS.paintImageMaskXObject:
	              this.paintImageMaskXObject(args[0]);
	              break;
	            case _util.OPS.paintFormXObjectBegin:
	              this.paintFormXObjectBegin(args[0], args[1]);
	              break;
	            case _util.OPS.paintFormXObjectEnd:
	              this.paintFormXObjectEnd();
	              break;
	            case _util.OPS.closePath:
	              this.closePath();
	              break;
	            case _util.OPS.closeStroke:
	              this.closeStroke();
	              break;
	            case _util.OPS.closeFillStroke:
	              this.closeFillStroke();
	              break;
	            case _util.OPS.nextLine:
	              this.nextLine();
	              break;
	            case _util.OPS.transform:
	              this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
	              break;
	            case _util.OPS.constructPath:
	              this.constructPath(args[0], args[1]);
	              break;
	            case _util.OPS.endPath:
	              this.endPath();
	              break;
	            case 92:
	              this.group(opTree[x].items);
	              break;
	            default:
	              (0, _util.warn)('Unimplemented operator ' + fn);
	              break;
	          }
	        }
	      },
	      setWordSpacing: function SVGGraphics_setWordSpacing(wordSpacing) {
	        this.current.wordSpacing = wordSpacing;
	      },
	      setCharSpacing: function SVGGraphics_setCharSpacing(charSpacing) {
	        this.current.charSpacing = charSpacing;
	      },
	      nextLine: function SVGGraphics_nextLine() {
	        this.moveText(0, this.current.leading);
	      },
	      setTextMatrix: function SVGGraphics_setTextMatrix(a, b, c, d, e, f) {
	        var current = this.current;
	        this.current.textMatrix = this.current.lineMatrix = [a, b, c, d, e, f];
	        this.current.x = this.current.lineX = 0;
	        this.current.y = this.current.lineY = 0;
	        current.xcoords = [];
	        current.tspan = this.svgFactory.createElement('svg:tspan');
	        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
	        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	        current.txtElement = this.svgFactory.createElement('svg:text');
	        current.txtElement.appendChild(current.tspan);
	      },
	      beginText: function SVGGraphics_beginText() {
	        this.current.x = this.current.lineX = 0;
	        this.current.y = this.current.lineY = 0;
	        this.current.textMatrix = _util.IDENTITY_MATRIX;
	        this.current.lineMatrix = _util.IDENTITY_MATRIX;
	        this.current.tspan = this.svgFactory.createElement('svg:tspan');
	        this.current.txtElement = this.svgFactory.createElement('svg:text');
	        this.current.txtgrp = this.svgFactory.createElement('svg:g');
	        this.current.xcoords = [];
	      },
	      moveText: function SVGGraphics_moveText(x, y) {
	        var current = this.current;
	        this.current.x = this.current.lineX += x;
	        this.current.y = this.current.lineY += y;
	        current.xcoords = [];
	        current.tspan = this.svgFactory.createElement('svg:tspan');
	        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
	        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	      },
	      showText: function SVGGraphics_showText(glyphs) {
	        var current = this.current;
	        var font = current.font;
	        var fontSize = current.fontSize;
	        if (fontSize === 0) {
	          return;
	        }
	        var charSpacing = current.charSpacing;
	        var wordSpacing = current.wordSpacing;
	        var fontDirection = current.fontDirection;
	        var textHScale = current.textHScale * fontDirection;
	        var glyphsLength = glyphs.length;
	        var vertical = font.vertical;
	        var widthAdvanceScale = fontSize * current.fontMatrix[0];
	        var x = 0,
	            i;
	        for (i = 0; i < glyphsLength; ++i) {
	          var glyph = glyphs[i];
	          if (glyph === null) {
	            x += fontDirection * wordSpacing;
	            continue;
	          } else if ((0, _util.isNum)(glyph)) {
	            x += -glyph * fontSize * 0.001;
	            continue;
	          }
	          var width = glyph.width;
	          var character = glyph.fontChar;
	          var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
	          var charWidth = width * widthAdvanceScale + spacing * fontDirection;
	          if (!glyph.isInFont && !font.missingFile) {
	            x += charWidth;
	            continue;
	          }
	          current.xcoords.push(current.x + x * textHScale);
	          current.tspan.textContent += character;
	          x += charWidth;
	        }
	        if (vertical) {
	          current.y -= x * textHScale;
	        } else {
	          current.x += x * textHScale;
	        }
	        current.tspan.setAttributeNS(null, 'x', current.xcoords.map(pf).join(' '));
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
	        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
	        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
	          current.tspan.setAttributeNS(null, 'font-style', current.fontStyle);
	        }
	        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
	          current.tspan.setAttributeNS(null, 'font-weight', current.fontWeight);
	        }
	        if (current.fillColor !== SVG_DEFAULTS.fillColor) {
	          current.tspan.setAttributeNS(null, 'fill', current.fillColor);
	        }
	        var textMatrix = current.textMatrix;
	        if (current.textRise !== 0) {
	          textMatrix = textMatrix.slice();
	          textMatrix[5] += current.textRise;
	        }
	        current.txtElement.setAttributeNS(null, 'transform', pm(textMatrix) + ' scale(1, -1)');
	        current.txtElement.setAttributeNS(XML_NS, 'xml:space', 'preserve');
	        current.txtElement.appendChild(current.tspan);
	        current.txtgrp.appendChild(current.txtElement);
	        this._ensureTransformGroup().appendChild(current.txtElement);
	      },
	      setLeadingMoveText: function SVGGraphics_setLeadingMoveText(x, y) {
	        this.setLeading(-y);
	        this.moveText(x, y);
	      },
	      addFontStyle: function SVGGraphics_addFontStyle(fontObj) {
	        if (!this.cssStyle) {
	          this.cssStyle = this.svgFactory.createElement('svg:style');
	          this.cssStyle.setAttributeNS(null, 'type', 'text/css');
	          this.defs.appendChild(this.cssStyle);
	        }
	        var url = (0, _util.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema);
	        this.cssStyle.textContent += '@font-face { font-family: "' + fontObj.loadedName + '";' + ' src: url(' + url + '); }\n';
	      },
	      setFont: function SVGGraphics_setFont(details) {
	        var current = this.current;
	        var fontObj = this.commonObjs.get(details[0]);
	        var size = details[1];
	        this.current.font = fontObj;
	        if (this.embedFonts && fontObj.data && !this.embeddedFonts[fontObj.loadedName]) {
	          this.addFontStyle(fontObj);
	          this.embeddedFonts[fontObj.loadedName] = fontObj;
	        }
	        current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
	        var bold = fontObj.black ? fontObj.bold ? 'bolder' : 'bold' : fontObj.bold ? 'bold' : 'normal';
	        var italic = fontObj.italic ? 'italic' : 'normal';
	        if (size < 0) {
	          size = -size;
	          current.fontDirection = -1;
	        } else {
	          current.fontDirection = 1;
	        }
	        current.fontSize = size;
	        current.fontFamily = fontObj.loadedName;
	        current.fontWeight = bold;
	        current.fontStyle = italic;
	        current.tspan = this.svgFactory.createElement('svg:tspan');
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	        current.xcoords = [];
	      },
	      endText: function SVGGraphics_endText() {},
	      setLineWidth: function SVGGraphics_setLineWidth(width) {
	        this.current.lineWidth = width;
	      },
	      setLineCap: function SVGGraphics_setLineCap(style) {
	        this.current.lineCap = LINE_CAP_STYLES[style];
	      },
	      setLineJoin: function SVGGraphics_setLineJoin(style) {
	        this.current.lineJoin = LINE_JOIN_STYLES[style];
	      },
	      setMiterLimit: function SVGGraphics_setMiterLimit(limit) {
	        this.current.miterLimit = limit;
	      },
	      setStrokeAlpha: function SVGGraphics_setStrokeAlpha(strokeAlpha) {
	        this.current.strokeAlpha = strokeAlpha;
	      },
	      setStrokeRGBColor: function SVGGraphics_setStrokeRGBColor(r, g, b) {
	        var color = _util.Util.makeCssRgb(r, g, b);
	        this.current.strokeColor = color;
	      },
	      setFillAlpha: function SVGGraphics_setFillAlpha(fillAlpha) {
	        this.current.fillAlpha = fillAlpha;
	      },
	      setFillRGBColor: function SVGGraphics_setFillRGBColor(r, g, b) {
	        var color = _util.Util.makeCssRgb(r, g, b);
	        this.current.fillColor = color;
	        this.current.tspan = this.svgFactory.createElement('svg:tspan');
	        this.current.xcoords = [];
	      },
	      setDash: function SVGGraphics_setDash(dashArray, dashPhase) {
	        this.current.dashArray = dashArray;
	        this.current.dashPhase = dashPhase;
	      },
	      constructPath: function SVGGraphics_constructPath(ops, args) {
	        var current = this.current;
	        var x = current.x,
	            y = current.y;
	        current.path = this.svgFactory.createElement('svg:path');
	        var d = [];
	        var opLength = ops.length;
	        for (var i = 0, j = 0; i < opLength; i++) {
	          switch (ops[i] | 0) {
	            case _util.OPS.rectangle:
	              x = args[j++];
	              y = args[j++];
	              var width = args[j++];
	              var height = args[j++];
	              var xw = x + width;
	              var yh = y + height;
	              d.push('M', pf(x), pf(y), 'L', pf(xw), pf(y), 'L', pf(xw), pf(yh), 'L', pf(x), pf(yh), 'Z');
	              break;
	            case _util.OPS.moveTo:
	              x = args[j++];
	              y = args[j++];
	              d.push('M', pf(x), pf(y));
	              break;
	            case _util.OPS.lineTo:
	              x = args[j++];
	              y = args[j++];
	              d.push('L', pf(x), pf(y));
	              break;
	            case _util.OPS.curveTo:
	              x = args[j + 4];
	              y = args[j + 5];
	              d.push('C', pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
	              j += 6;
	              break;
	            case _util.OPS.curveTo2:
	              x = args[j + 2];
	              y = args[j + 3];
	              d.push('C', pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
	              j += 4;
	              break;
	            case _util.OPS.curveTo3:
	              x = args[j + 2];
	              y = args[j + 3];
	              d.push('C', pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
	              j += 4;
	              break;
	            case _util.OPS.closePath:
	              d.push('Z');
	              break;
	          }
	        }
	        current.path.setAttributeNS(null, 'd', d.join(' '));
	        current.path.setAttributeNS(null, 'fill', 'none');
	        this._ensureTransformGroup().appendChild(current.path);
	        current.element = current.path;
	        current.setCurrentPoint(x, y);
	      },
	      endPath: function SVGGraphics_endPath() {
	        if (!this.pendingClip) {
	          return;
	        }
	        var current = this.current;
	        var clipId = 'clippath' + clipCount;
	        clipCount++;
	        var clipPath = this.svgFactory.createElement('svg:clipPath');
	        clipPath.setAttributeNS(null, 'id', clipId);
	        clipPath.setAttributeNS(null, 'transform', pm(this.transformMatrix));
	        var clipElement = current.element.cloneNode();
	        if (this.pendingClip === 'evenodd') {
	          clipElement.setAttributeNS(null, 'clip-rule', 'evenodd');
	        } else {
	          clipElement.setAttributeNS(null, 'clip-rule', 'nonzero');
	        }
	        this.pendingClip = null;
	        clipPath.appendChild(clipElement);
	        this.defs.appendChild(clipPath);
	        if (current.activeClipUrl) {
	          current.clipGroup = null;
	          this.extraStack.forEach(function (prev) {
	            prev.clipGroup = null;
	          });
	        }
	        current.activeClipUrl = 'url(#' + clipId + ')';
	        this.tgrp = null;
	      },
	      clip: function SVGGraphics_clip(type) {
	        this.pendingClip = type;
	      },
	      closePath: function SVGGraphics_closePath() {
	        var current = this.current;
	        var d = current.path.getAttributeNS(null, 'd');
	        d += 'Z';
	        current.path.setAttributeNS(null, 'd', d);
	      },
	      setLeading: function SVGGraphics_setLeading(leading) {
	        this.current.leading = -leading;
	      },
	      setTextRise: function SVGGraphics_setTextRise(textRise) {
	        this.current.textRise = textRise;
	      },
	      setHScale: function SVGGraphics_setHScale(scale) {
	        this.current.textHScale = scale / 100;
	      },
	      setGState: function SVGGraphics_setGState(states) {
	        for (var i = 0, ii = states.length; i < ii; i++) {
	          var state = states[i];
	          var key = state[0];
	          var value = state[1];
	          switch (key) {
	            case 'LW':
	              this.setLineWidth(value);
	              break;
	            case 'LC':
	              this.setLineCap(value);
	              break;
	            case 'LJ':
	              this.setLineJoin(value);
	              break;
	            case 'ML':
	              this.setMiterLimit(value);
	              break;
	            case 'D':
	              this.setDash(value[0], value[1]);
	              break;
	            case 'Font':
	              this.setFont(value);
	              break;
	            case 'CA':
	              this.setStrokeAlpha(value);
	              break;
	            case 'ca':
	              this.setFillAlpha(value);
	              break;
	            default:
	              (0, _util.warn)('Unimplemented graphic state ' + key);
	              break;
	          }
	        }
	      },
	      fill: function SVGGraphics_fill() {
	        var current = this.current;
	        current.element.setAttributeNS(null, 'fill', current.fillColor);
	        current.element.setAttributeNS(null, 'fill-opacity', current.fillAlpha);
	      },
	      stroke: function SVGGraphics_stroke() {
	        var current = this.current;
	        current.element.setAttributeNS(null, 'stroke', current.strokeColor);
	        current.element.setAttributeNS(null, 'stroke-opacity', current.strokeAlpha);
	        current.element.setAttributeNS(null, 'stroke-miterlimit', pf(current.miterLimit));
	        current.element.setAttributeNS(null, 'stroke-linecap', current.lineCap);
	        current.element.setAttributeNS(null, 'stroke-linejoin', current.lineJoin);
	        current.element.setAttributeNS(null, 'stroke-width', pf(current.lineWidth) + 'px');
	        current.element.setAttributeNS(null, 'stroke-dasharray', current.dashArray.map(pf).join(' '));
	        current.element.setAttributeNS(null, 'stroke-dashoffset', pf(current.dashPhase) + 'px');
	        current.element.setAttributeNS(null, 'fill', 'none');
	      },
	      eoFill: function SVGGraphics_eoFill() {
	        this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
	        this.fill();
	      },
	      fillStroke: function SVGGraphics_fillStroke() {
	        this.stroke();
	        this.fill();
	      },
	      eoFillStroke: function SVGGraphics_eoFillStroke() {
	        this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
	        this.fillStroke();
	      },
	      closeStroke: function SVGGraphics_closeStroke() {
	        this.closePath();
	        this.stroke();
	      },
	      closeFillStroke: function SVGGraphics_closeFillStroke() {
	        this.closePath();
	        this.fillStroke();
	      },
	      paintSolidColorImageMask: function SVGGraphics_paintSolidColorImageMask() {
	        var current = this.current;
	        var rect = this.svgFactory.createElement('svg:rect');
	        rect.setAttributeNS(null, 'x', '0');
	        rect.setAttributeNS(null, 'y', '0');
	        rect.setAttributeNS(null, 'width', '1px');
	        rect.setAttributeNS(null, 'height', '1px');
	        rect.setAttributeNS(null, 'fill', current.fillColor);
	        this._ensureTransformGroup().appendChild(rect);
	      },
	      paintJpegXObject: function SVGGraphics_paintJpegXObject(objId, w, h) {
	        var imgObj = this.objs.get(objId);
	        var imgEl = this.svgFactory.createElement('svg:image');
	        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgObj.src);
	        imgEl.setAttributeNS(null, 'width', pf(w));
	        imgEl.setAttributeNS(null, 'height', pf(h));
	        imgEl.setAttributeNS(null, 'x', '0');
	        imgEl.setAttributeNS(null, 'y', pf(-h));
	        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / w) + ' ' + pf(-1 / h) + ')');
	        this._ensureTransformGroup().appendChild(imgEl);
	      },
	      paintImageXObject: function SVGGraphics_paintImageXObject(objId) {
	        var imgData = this.objs.get(objId);
	        if (!imgData) {
	          (0, _util.warn)('Dependent image isn\'t ready yet');
	          return;
	        }
	        this.paintInlineImageXObject(imgData);
	      },
	      paintInlineImageXObject: function SVGGraphics_paintInlineImageXObject(imgData, mask) {
	        var width = imgData.width;
	        var height = imgData.height;
	        var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema);
	        var cliprect = this.svgFactory.createElement('svg:rect');
	        cliprect.setAttributeNS(null, 'x', '0');
	        cliprect.setAttributeNS(null, 'y', '0');
	        cliprect.setAttributeNS(null, 'width', pf(width));
	        cliprect.setAttributeNS(null, 'height', pf(height));
	        this.current.element = cliprect;
	        this.clip('nonzero');
	        var imgEl = this.svgFactory.createElement('svg:image');
	        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgSrc);
	        imgEl.setAttributeNS(null, 'x', '0');
	        imgEl.setAttributeNS(null, 'y', pf(-height));
	        imgEl.setAttributeNS(null, 'width', pf(width) + 'px');
	        imgEl.setAttributeNS(null, 'height', pf(height) + 'px');
	        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / width) + ' ' + pf(-1 / height) + ')');
	        if (mask) {
	          mask.appendChild(imgEl);
	        } else {
	          this._ensureTransformGroup().appendChild(imgEl);
	        }
	      },
	      paintImageMaskXObject: function SVGGraphics_paintImageMaskXObject(imgData) {
	        var current = this.current;
	        var width = imgData.width;
	        var height = imgData.height;
	        var fillColor = current.fillColor;
	        current.maskId = 'mask' + maskCount++;
	        var mask = this.svgFactory.createElement('svg:mask');
	        mask.setAttributeNS(null, 'id', current.maskId);
	        var rect = this.svgFactory.createElement('svg:rect');
	        rect.setAttributeNS(null, 'x', '0');
	        rect.setAttributeNS(null, 'y', '0');
	        rect.setAttributeNS(null, 'width', pf(width));
	        rect.setAttributeNS(null, 'height', pf(height));
	        rect.setAttributeNS(null, 'fill', fillColor);
	        rect.setAttributeNS(null, 'mask', 'url(#' + current.maskId + ')');
	        this.defs.appendChild(mask);
	        this._ensureTransformGroup().appendChild(rect);
	        this.paintInlineImageXObject(imgData, mask);
	      },
	      paintFormXObjectBegin: function SVGGraphics_paintFormXObjectBegin(matrix, bbox) {
	        if (Array.isArray(matrix) && matrix.length === 6) {
	          this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	        }
	        if (Array.isArray(bbox) && bbox.length === 4) {
	          var width = bbox[2] - bbox[0];
	          var height = bbox[3] - bbox[1];
	          var cliprect = this.svgFactory.createElement('svg:rect');
	          cliprect.setAttributeNS(null, 'x', bbox[0]);
	          cliprect.setAttributeNS(null, 'y', bbox[1]);
	          cliprect.setAttributeNS(null, 'width', pf(width));
	          cliprect.setAttributeNS(null, 'height', pf(height));
	          this.current.element = cliprect;
	          this.clip('nonzero');
	          this.endPath();
	        }
	      },
	      paintFormXObjectEnd: function SVGGraphics_paintFormXObjectEnd() {},
	      _initialize: function _initialize(viewport) {
	        var svg = this.svgFactory.create(viewport.width, viewport.height);
	        var definitions = this.svgFactory.createElement('svg:defs');
	        svg.appendChild(definitions);
	        this.defs = definitions;
	        var rootGroup = this.svgFactory.createElement('svg:g');
	        rootGroup.setAttributeNS(null, 'transform', pm(viewport.transform));
	        svg.appendChild(rootGroup);
	        this.svg = rootGroup;
	        return svg;
	      },
	
	      _ensureClipGroup: function SVGGraphics_ensureClipGroup() {
	        if (!this.current.clipGroup) {
	          var clipGroup = this.svgFactory.createElement('svg:g');
	          clipGroup.setAttributeNS(null, 'clip-path', this.current.activeClipUrl);
	          this.svg.appendChild(clipGroup);
	          this.current.clipGroup = clipGroup;
	        }
	        return this.current.clipGroup;
	      },
	      _ensureTransformGroup: function SVGGraphics_ensureTransformGroup() {
	        if (!this.tgrp) {
	          this.tgrp = this.svgFactory.createElement('svg:g');
	          this.tgrp.setAttributeNS(null, 'transform', pm(this.transformMatrix));
	          if (this.current.activeClipUrl) {
	            this._ensureClipGroup().appendChild(this.tgrp);
	          } else {
	            this.svg.appendChild(this.tgrp);
	          }
	        }
	        return this.tgrp;
	      }
	    };
	    return SVGGraphics;
	  }();
	}
	exports.SVGGraphics = SVGGraphics;
	
	/***/ }),
	/* 91 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var pdfjsVersion = '1.10.100';
	var pdfjsBuild = 'ea29ec83';
	var pdfjsSharedUtil = __w_pdfjs_require__(0);
	var pdfjsDisplayGlobal = __w_pdfjs_require__(134);
	var pdfjsDisplayAPI = __w_pdfjs_require__(75);
	var pdfjsDisplayTextLayer = __w_pdfjs_require__(89);
	var pdfjsDisplayAnnotationLayer = __w_pdfjs_require__(88);
	var pdfjsDisplayDOMUtils = __w_pdfjs_require__(17);
	var pdfjsDisplaySVG = __w_pdfjs_require__(90);
	{
	  if (pdfjsSharedUtil.isNodeJS()) {
	    var PDFNodeStream = __w_pdfjs_require__(160).PDFNodeStream;
	    pdfjsDisplayAPI.setPDFNetworkStreamClass(PDFNodeStream);
	  } else if (typeof Response !== 'undefined' && 'body' in Response.prototype && typeof ReadableStream !== 'undefined') {
	    var PDFFetchStream = __w_pdfjs_require__(161).PDFFetchStream;
	    pdfjsDisplayAPI.setPDFNetworkStreamClass(PDFFetchStream);
	  } else {
	    var PDFNetworkStream = __w_pdfjs_require__(162).PDFNetworkStream;
	    pdfjsDisplayAPI.setPDFNetworkStreamClass(PDFNetworkStream);
	  }
	}
	exports.PDFJS = pdfjsDisplayGlobal.PDFJS;
	exports.build = pdfjsDisplayAPI.build;
	exports.version = pdfjsDisplayAPI.version;
	exports.getDocument = pdfjsDisplayAPI.getDocument;
	exports.LoopbackPort = pdfjsDisplayAPI.LoopbackPort;
	exports.PDFDataRangeTransport = pdfjsDisplayAPI.PDFDataRangeTransport;
	exports.PDFWorker = pdfjsDisplayAPI.PDFWorker;
	exports.renderTextLayer = pdfjsDisplayTextLayer.renderTextLayer;
	exports.AnnotationLayer = pdfjsDisplayAnnotationLayer.AnnotationLayer;
	exports.CustomStyle = pdfjsDisplayDOMUtils.CustomStyle;
	exports.createPromiseCapability = pdfjsSharedUtil.createPromiseCapability;
	exports.PasswordResponses = pdfjsSharedUtil.PasswordResponses;
	exports.InvalidPDFException = pdfjsSharedUtil.InvalidPDFException;
	exports.MissingPDFException = pdfjsSharedUtil.MissingPDFException;
	exports.SVGGraphics = pdfjsDisplaySVG.SVGGraphics;
	exports.NativeImageDecoding = pdfjsSharedUtil.NativeImageDecoding;
	exports.UnexpectedResponseException = pdfjsSharedUtil.UnexpectedResponseException;
	exports.OPS = pdfjsSharedUtil.OPS;
	exports.UNSUPPORTED_FEATURES = pdfjsSharedUtil.UNSUPPORTED_FEATURES;
	exports.isValidUrl = pdfjsDisplayDOMUtils.isValidUrl;
	exports.createValidAbsoluteUrl = pdfjsSharedUtil.createValidAbsoluteUrl;
	exports.createObjectURL = pdfjsSharedUtil.createObjectURL;
	exports.removeNullCharacters = pdfjsSharedUtil.removeNullCharacters;
	exports.shadow = pdfjsSharedUtil.shadow;
	exports.createBlob = pdfjsSharedUtil.createBlob;
	exports.RenderingCancelledException = pdfjsDisplayDOMUtils.RenderingCancelledException;
	exports.getFilenameFromUrl = pdfjsDisplayDOMUtils.getFilenameFromUrl;
	exports.addLinkAttributes = pdfjsDisplayDOMUtils.addLinkAttributes;
	exports.StatTimer = pdfjsSharedUtil.StatTimer;
	
	/***/ }),
	/* 92 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	if (typeof PDFJS === 'undefined' || !PDFJS.compatibilityChecked) {
	  var globalScope = __w_pdfjs_require__(22);
	  var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
	  var isAndroid = /Android/.test(userAgent);
	  var isAndroidPre3 = /Android\s[0-2][^\d]/.test(userAgent);
	  var isAndroidPre5 = /Android\s[0-4][^\d]/.test(userAgent);
	  var isChrome = userAgent.indexOf('Chrom') >= 0;
	  var isChromeWithRangeBug = /Chrome\/(39|40)\./.test(userAgent);
	  var isIOSChrome = userAgent.indexOf('CriOS') >= 0;
	  var isIE = userAgent.indexOf('Trident') >= 0;
	  var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
	  var isOpera = userAgent.indexOf('Opera') >= 0;
	  var isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
	  var hasDOM = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object';
	  if (typeof PDFJS === 'undefined') {
	    globalScope.PDFJS = {};
	  }
	  PDFJS.compatibilityChecked = true;
	  (function checkTypedArrayCompatibility() {
	    if (typeof Uint8ClampedArray === 'undefined') {
	      globalScope.Uint8ClampedArray = __w_pdfjs_require__(93);
	    }
	    if (typeof Uint8Array !== 'undefined') {
	      if (typeof Uint8Array.prototype.subarray === 'undefined') {
	        Uint8Array.prototype.subarray = function subarray(start, end) {
	          return new Uint8Array(this.slice(start, end));
	        };
	        Float32Array.prototype.subarray = function subarray(start, end) {
	          return new Float32Array(this.slice(start, end));
	        };
	      }
	      if (typeof Float64Array === 'undefined') {
	        globalScope.Float64Array = Float32Array;
	      }
	      return;
	    }
	    function subarray(start, end) {
	      return new TypedArray(this.slice(start, end));
	    }
	    function setArrayOffset(array, offset) {
	      if (arguments.length < 2) {
	        offset = 0;
	      }
	      for (var i = 0, n = array.length; i < n; ++i, ++offset) {
	        this[offset] = array[i] & 0xFF;
	      }
	    }
	    function Uint32ArrayView(buffer, length) {
	      this.buffer = buffer;
	      this.byteLength = buffer.length;
	      this.length = length;
	      ensureUint32ArrayViewProps(this.length);
	    }
	    Uint32ArrayView.prototype = Object.create(null);
	    var uint32ArrayViewSetters = 0;
	    function createUint32ArrayProp(index) {
	      return {
	        get: function get() {
	          var buffer = this.buffer,
	              offset = index << 2;
	          return (buffer[offset] | buffer[offset + 1] << 8 | buffer[offset + 2] << 16 | buffer[offset + 3] << 24) >>> 0;
	        },
	        set: function set(value) {
	          var buffer = this.buffer,
	              offset = index << 2;
	          buffer[offset] = value & 255;
	          buffer[offset + 1] = value >> 8 & 255;
	          buffer[offset + 2] = value >> 16 & 255;
	          buffer[offset + 3] = value >>> 24 & 255;
	        }
	      };
	    }
	    function ensureUint32ArrayViewProps(length) {
	      while (uint32ArrayViewSetters < length) {
	        Object.defineProperty(Uint32ArrayView.prototype, uint32ArrayViewSetters, createUint32ArrayProp(uint32ArrayViewSetters));
	        uint32ArrayViewSetters++;
	      }
	    }
	    function TypedArray(arg1) {
	      var result, i, n;
	      if (typeof arg1 === 'number') {
	        result = [];
	        for (i = 0; i < arg1; ++i) {
	          result[i] = 0;
	        }
	      } else if ('slice' in arg1) {
	        result = arg1.slice(0);
	      } else {
	        result = [];
	        for (i = 0, n = arg1.length; i < n; ++i) {
	          result[i] = arg1[i];
	        }
	      }
	      result.subarray = subarray;
	      result.buffer = result;
	      result.byteLength = result.length;
	      result.set = setArrayOffset;
	      if ((typeof arg1 === 'undefined' ? 'undefined' : _typeof(arg1)) === 'object' && arg1.buffer) {
	        result.buffer = arg1.buffer;
	      }
	      return result;
	    }
	    globalScope.Uint8Array = TypedArray;
	    globalScope.Int8Array = TypedArray;
	    globalScope.Int32Array = TypedArray;
	    globalScope.Uint16Array = TypedArray;
	    globalScope.Float32Array = TypedArray;
	    globalScope.Float64Array = TypedArray;
	    globalScope.Uint32Array = function () {
	      if (arguments.length === 3) {
	        if (arguments[1] !== 0) {
	          throw new Error('offset !== 0 is not supported');
	        }
	        return new Uint32ArrayView(arguments[0], arguments[2]);
	      }
	      return TypedArray.apply(this, arguments);
	    };
	  })();
	  (function canvasPixelArrayBuffer() {
	    if (!hasDOM || !window.CanvasPixelArray) {
	      return;
	    }
	    var cpaProto = window.CanvasPixelArray.prototype;
	    if ('buffer' in cpaProto) {
	      return;
	    }
	    Object.defineProperty(cpaProto, 'buffer', {
	      get: function get() {
	        return this;
	      },
	
	      enumerable: false,
	      configurable: true
	    });
	    Object.defineProperty(cpaProto, 'byteLength', {
	      get: function get() {
	        return this.length;
	      },
	
	      enumerable: false,
	      configurable: true
	    });
	  })();
	  (function normalizeURLObject() {
	    if (!globalScope.URL) {
	      globalScope.URL = globalScope.webkitURL;
	    }
	  })();
	  (function checkObjectDefinePropertyCompatibility() {
	    if (typeof Object.defineProperty !== 'undefined') {
	      var definePropertyPossible = true;
	      try {
	        if (hasDOM) {
	          Object.defineProperty(new Image(), 'id', { value: 'test' });
	        }
	        var Test = function Test() {};
	        Test.prototype = {
	          get id() {}
	        };
	        Object.defineProperty(new Test(), 'id', {
	          value: '',
	          configurable: true,
	          enumerable: true,
	          writable: false
	        });
	      } catch (e) {
	        definePropertyPossible = false;
	      }
	      if (definePropertyPossible) {
	        return;
	      }
	    }
	    Object.defineProperty = function objectDefineProperty(obj, name, def) {
	      delete obj[name];
	      if ('get' in def) {
	        obj.__defineGetter__(name, def['get']);
	      }
	      if ('set' in def) {
	        obj.__defineSetter__(name, def['set']);
	      }
	      if ('value' in def) {
	        obj.__defineSetter__(name, function objectDefinePropertySetter(value) {
	          this.__defineGetter__(name, function objectDefinePropertyGetter() {
	            return value;
	          });
	          return value;
	        });
	        obj[name] = def.value;
	      }
	    };
	  })();
	  (function checkXMLHttpRequestResponseCompatibility() {
	    if (typeof XMLHttpRequest === 'undefined') {
	      return;
	    }
	    var xhrPrototype = XMLHttpRequest.prototype;
	    var xhr = new XMLHttpRequest();
	    if (!('overrideMimeType' in xhr)) {
	      Object.defineProperty(xhrPrototype, 'overrideMimeType', {
	        value: function xmlHttpRequestOverrideMimeType(mimeType) {}
	      });
	    }
	    if ('responseType' in xhr) {
	      return;
	    }
	    Object.defineProperty(xhrPrototype, 'responseType', {
	      get: function xmlHttpRequestGetResponseType() {
	        return this._responseType || 'text';
	      },
	      set: function xmlHttpRequestSetResponseType(value) {
	        if (value === 'text' || value === 'arraybuffer') {
	          this._responseType = value;
	          if (value === 'arraybuffer' && typeof this.overrideMimeType === 'function') {
	            this.overrideMimeType('text/plain; charset=x-user-defined');
	          }
	        }
	      }
	    });
	    if (typeof VBArray !== 'undefined') {
	      Object.defineProperty(xhrPrototype, 'response', {
	        get: function xmlHttpRequestResponseGet() {
	          if (this.responseType === 'arraybuffer') {
	            return new Uint8Array(new VBArray(this.responseBody).toArray());
	          }
	          return this.responseText;
	        }
	      });
	      return;
	    }
	    Object.defineProperty(xhrPrototype, 'response', {
	      get: function xmlHttpRequestResponseGet() {
	        if (this.responseType !== 'arraybuffer') {
	          return this.responseText;
	        }
	        var text = this.responseText;
	        var i,
	            n = text.length;
	        var result = new Uint8Array(n);
	        for (i = 0; i < n; ++i) {
	          result[i] = text.charCodeAt(i) & 0xFF;
	        }
	        return result.buffer;
	      }
	    });
	  })();
	  (function checkWindowBtoaCompatibility() {
	    if ('btoa' in globalScope) {
	      return;
	    }
	    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    globalScope.btoa = function (chars) {
	      var buffer = '';
	      var i, n;
	      for (i = 0, n = chars.length; i < n; i += 3) {
	        var b1 = chars.charCodeAt(i) & 0xFF;
	        var b2 = chars.charCodeAt(i + 1) & 0xFF;
	        var b3 = chars.charCodeAt(i + 2) & 0xFF;
	        var d1 = b1 >> 2,
	            d2 = (b1 & 3) << 4 | b2 >> 4;
	        var d3 = i + 1 < n ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
	        var d4 = i + 2 < n ? b3 & 0x3F : 64;
	        buffer += digits.charAt(d1) + digits.charAt(d2) + digits.charAt(d3) + digits.charAt(d4);
	      }
	      return buffer;
	    };
	  })();
	  (function checkWindowAtobCompatibility() {
	    if ('atob' in globalScope) {
	      return;
	    }
	    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    globalScope.atob = function (input) {
	      input = input.replace(/=+$/, '');
	      if (input.length % 4 === 1) {
	        throw new Error('bad atob input');
	      }
	      for (var bc = 0, bs, buffer, idx = 0, output = ''; buffer = input.charAt(idx++); ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) {
	        buffer = digits.indexOf(buffer);
	      }
	      return output;
	    };
	  })();
	  (function checkFunctionPrototypeBindCompatibility() {
	    if (typeof Function.prototype.bind !== 'undefined') {
	      return;
	    }
	    Function.prototype.bind = function functionPrototypeBind(obj) {
	      var fn = this,
	          headArgs = Array.prototype.slice.call(arguments, 1);
	      var bound = function functionPrototypeBindBound() {
	        var args = headArgs.concat(Array.prototype.slice.call(arguments));
	        return fn.apply(obj, args);
	      };
	      return bound;
	    };
	  })();
	  (function checkDatasetProperty() {
	    if (!hasDOM) {
	      return;
	    }
	    var div = document.createElement('div');
	    if ('dataset' in div) {
	      return;
	    }
	    Object.defineProperty(HTMLElement.prototype, 'dataset', {
	      get: function get() {
	        if (this._dataset) {
	          return this._dataset;
	        }
	        var dataset = {};
	        for (var j = 0, jj = this.attributes.length; j < jj; j++) {
	          var attribute = this.attributes[j];
	          if (attribute.name.substring(0, 5) !== 'data-') {
	            continue;
	          }
	          var key = attribute.name.substring(5).replace(/\-([a-z])/g, function (all, ch) {
	            return ch.toUpperCase();
	          });
	          dataset[key] = attribute.value;
	        }
	        Object.defineProperty(this, '_dataset', {
	          value: dataset,
	          writable: false,
	          enumerable: false
	        });
	        return dataset;
	      },
	
	      enumerable: true
	    });
	  })();
	  (function checkClassListProperty() {
	    function changeList(element, itemName, add, remove) {
	      var s = element.className || '';
	      var list = s.split(/\s+/g);
	      if (list[0] === '') {
	        list.shift();
	      }
	      var index = list.indexOf(itemName);
	      if (index < 0 && add) {
	        list.push(itemName);
	      }
	      if (index >= 0 && remove) {
	        list.splice(index, 1);
	      }
	      element.className = list.join(' ');
	      return index >= 0;
	    }
	    if (!hasDOM) {
	      return;
	    }
	    var div = document.createElement('div');
	    if ('classList' in div) {
	      return;
	    }
	    var classListPrototype = {
	      add: function add(name) {
	        changeList(this.element, name, true, false);
	      },
	      contains: function contains(name) {
	        return changeList(this.element, name, false, false);
	      },
	      remove: function remove(name) {
	        changeList(this.element, name, false, true);
	      },
	      toggle: function toggle(name) {
	        changeList(this.element, name, true, true);
	      }
	    };
	    Object.defineProperty(HTMLElement.prototype, 'classList', {
	      get: function get() {
	        if (this._classList) {
	          return this._classList;
	        }
	        var classList = Object.create(classListPrototype, {
	          element: {
	            value: this,
	            writable: false,
	            enumerable: true
	          }
	        });
	        Object.defineProperty(this, '_classList', {
	          value: classList,
	          writable: false,
	          enumerable: false
	        });
	        return classList;
	      },
	
	      enumerable: true
	    });
	  })();
	  (function checkWorkerConsoleCompatibility() {
	    if (typeof importScripts === 'undefined' || 'console' in globalScope) {
	      return;
	    }
	    var consoleTimer = {};
	    var workerConsole = {
	      log: function log() {
	        var args = Array.prototype.slice.call(arguments);
	        globalScope.postMessage({
	          targetName: 'main',
	          action: 'console_log',
	          data: args
	        });
	      },
	      error: function error() {
	        var args = Array.prototype.slice.call(arguments);
	        globalScope.postMessage({
	          targetName: 'main',
	          action: 'console_error',
	          data: args
	        });
	      },
	      time: function time(name) {
	        consoleTimer[name] = Date.now();
	      },
	      timeEnd: function timeEnd(name) {
	        var time = consoleTimer[name];
	        if (!time) {
	          throw new Error('Unknown timer name ' + name);
	        }
	        this.log('Timer:', name, Date.now() - time);
	      }
	    };
	    globalScope.console = workerConsole;
	  })();
	  (function checkConsoleCompatibility() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!('console' in window)) {
	      window.console = {
	        log: function log() {},
	        error: function error() {},
	        warn: function warn() {}
	      };
	      return;
	    }
	    if (!('bind' in console.log)) {
	      console.log = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.log);
	      console.error = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.error);
	      console.warn = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.warn);
	      return;
	    }
	  })();
	  (function checkOnClickCompatibility() {
	    function ignoreIfTargetDisabled(event) {
	      if (isDisabled(event.target)) {
	        event.stopPropagation();
	      }
	    }
	    function isDisabled(node) {
	      return node.disabled || node.parentNode && isDisabled(node.parentNode);
	    }
	    if (isOpera) {
	      document.addEventListener('click', ignoreIfTargetDisabled, true);
	    }
	  })();
	  (function checkOnBlobSupport() {
	    if (isIE || isIOSChrome) {
	      PDFJS.disableCreateObjectURL = true;
	    }
	  })();
	  (function checkNavigatorLanguage() {
	    if (typeof navigator === 'undefined') {
	      return;
	    }
	    if ('language' in navigator) {
	      return;
	    }
	    PDFJS.locale = navigator.userLanguage || 'en-US';
	  })();
	  (function checkRangeRequests() {
	    if (isSafari || isAndroidPre3 || isChromeWithRangeBug || isIOS) {
	      PDFJS.disableRange = true;
	      PDFJS.disableStream = true;
	    }
	  })();
	  (function checkHistoryManipulation() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!history.pushState || isAndroidPre3) {
	      PDFJS.disableHistory = true;
	    }
	  })();
	  (function checkSetPresenceInImageData() {
	    if (!hasDOM) {
	      return;
	    }
	    if (window.CanvasPixelArray) {
	      if (typeof window.CanvasPixelArray.prototype.set !== 'function') {
	        window.CanvasPixelArray.prototype.set = function (arr) {
	          for (var i = 0, ii = this.length; i < ii; i++) {
	            this[i] = arr[i];
	          }
	        };
	      }
	    } else {
	      var polyfill = false,
	          versionMatch;
	      if (isChrome) {
	        versionMatch = userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
	        polyfill = versionMatch && parseInt(versionMatch[2]) < 21;
	      } else if (isAndroid) {
	        polyfill = isAndroidPre5;
	      } else if (isSafari) {
	        versionMatch = userAgent.match(/Version\/([0-9]+)\.([0-9]+)\.([0-9]+) Safari\//);
	        polyfill = versionMatch && parseInt(versionMatch[1]) < 6;
	      }
	      if (polyfill) {
	        var contextPrototype = window.CanvasRenderingContext2D.prototype;
	        var createImageData = contextPrototype.createImageData;
	        contextPrototype.createImageData = function (w, h) {
	          var imageData = createImageData.call(this, w, h);
	          imageData.data.set = function (arr) {
	            for (var i = 0, ii = this.length; i < ii; i++) {
	              this[i] = arr[i];
	            }
	          };
	          return imageData;
	        };
	        contextPrototype = null;
	      }
	    }
	  })();
	  (function checkRequestAnimationFrame() {
	    function installFakeAnimationFrameFunctions() {
	      window.requestAnimationFrame = function (callback) {
	        return window.setTimeout(callback, 20);
	      };
	      window.cancelAnimationFrame = function (timeoutID) {
	        window.clearTimeout(timeoutID);
	      };
	    }
	    if (!hasDOM) {
	      return;
	    }
	    if (isIOS) {
	      installFakeAnimationFrameFunctions();
	      return;
	    }
	    if ('requestAnimationFrame' in window) {
	      return;
	    }
	    window.requestAnimationFrame = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame;
	    if (window.requestAnimationFrame) {
	      return;
	    }
	    installFakeAnimationFrameFunctions();
	  })();
	  (function checkCanvasSizeLimitation() {
	    if (isIOS || isAndroid) {
	      PDFJS.maxCanvasPixels = 5242880;
	    }
	  })();
	  (function checkFullscreenSupport() {
	    if (!hasDOM) {
	      return;
	    }
	    if (isIE && window.parent !== window) {
	      PDFJS.disableFullscreen = true;
	    }
	  })();
	  (function checkCurrentScript() {
	    if (!hasDOM) {
	      return;
	    }
	    if ('currentScript' in document) {
	      return;
	    }
	    Object.defineProperty(document, 'currentScript', {
	      get: function get() {
	        var scripts = document.getElementsByTagName('script');
	        return scripts[scripts.length - 1];
	      },
	
	      enumerable: true,
	      configurable: true
	    });
	  })();
	  (function checkInputTypeNumberAssign() {
	    if (!hasDOM) {
	      return;
	    }
	    var el = document.createElement('input');
	    try {
	      el.type = 'number';
	    } catch (ex) {
	      var inputProto = el.constructor.prototype;
	      var typeProperty = Object.getOwnPropertyDescriptor(inputProto, 'type');
	      Object.defineProperty(inputProto, 'type', {
	        get: function get() {
	          return typeProperty.get.call(this);
	        },
	        set: function set(value) {
	          typeProperty.set.call(this, value === 'number' ? 'text' : value);
	        },
	
	        enumerable: true,
	        configurable: true
	      });
	    }
	  })();
	  (function checkDocumentReadyState() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!document.attachEvent) {
	      return;
	    }
	    var documentProto = document.constructor.prototype;
	    var readyStateProto = Object.getOwnPropertyDescriptor(documentProto, 'readyState');
	    Object.defineProperty(documentProto, 'readyState', {
	      get: function get() {
	        var value = readyStateProto.get.call(this);
	        return value === 'interactive' ? 'loading' : value;
	      },
	      set: function set(value) {
	        readyStateProto.set.call(this, value);
	      },
	
	      enumerable: true,
	      configurable: true
	    });
	  })();
	  (function checkChildNodeRemove() {
	    if (!hasDOM) {
	      return;
	    }
	    if (typeof Element.prototype.remove !== 'undefined') {
	      return;
	    }
	    Element.prototype.remove = function () {
	      if (this.parentNode) {
	        this.parentNode.removeChild(this);
	      }
	    };
	  })();
	  (function checkNumberIsNaN() {
	    if (Number.isNaN) {
	      return;
	    }
	    Number.isNaN = __w_pdfjs_require__(105);
	  })();
	  (function checkNumberIsInteger() {
	    if (Number.isInteger) {
	      return;
	    }
	    Number.isInteger = __w_pdfjs_require__(107);
	  })();
	  (function checkPromise() {
	    if (globalScope.Promise) {
	      return;
	    }
	    globalScope.Promise = __w_pdfjs_require__(110);
	  })();
	  (function checkWeakMap() {
	    if (globalScope.WeakMap) {
	      return;
	    }
	    globalScope.WeakMap = __w_pdfjs_require__(120);
	  })();
	  (function checkURLConstructor() {
	    var hasWorkingUrl = false;
	    try {
	      if (typeof URL === 'function' && _typeof(URL.prototype) === 'object' && 'origin' in URL.prototype) {
	        var u = new URL('b', 'http://a');
	        u.pathname = 'c%20d';
	        hasWorkingUrl = u.href === 'http://a/c%20d';
	      }
	    } catch (e) {}
	    if (hasWorkingUrl) {
	      return;
	    }
	    var relative = Object.create(null);
	    relative['ftp'] = 21;
	    relative['file'] = 0;
	    relative['gopher'] = 70;
	    relative['http'] = 80;
	    relative['https'] = 443;
	    relative['ws'] = 80;
	    relative['wss'] = 443;
	    var relativePathDotMapping = Object.create(null);
	    relativePathDotMapping['%2e'] = '.';
	    relativePathDotMapping['.%2e'] = '..';
	    relativePathDotMapping['%2e.'] = '..';
	    relativePathDotMapping['%2e%2e'] = '..';
	    function isRelativeScheme(scheme) {
	      return relative[scheme] !== undefined;
	    }
	    function invalid() {
	      clear.call(this);
	      this._isInvalid = true;
	    }
	    function IDNAToASCII(h) {
	      if (h === '') {
	        invalid.call(this);
	      }
	      return h.toLowerCase();
	    }
	    function percentEscape(c) {
	      var unicode = c.charCodeAt(0);
	      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
	        return c;
	      }
	      return encodeURIComponent(c);
	    }
	    function percentEscapeQuery(c) {
	      var unicode = c.charCodeAt(0);
	      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
	        return c;
	      }
	      return encodeURIComponent(c);
	    }
	    var EOF,
	        ALPHA = /[a-zA-Z]/,
	        ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;
	    function parse(input, stateOverride, base) {
	      function err(message) {
	        errors.push(message);
	      }
	      var state = stateOverride || 'scheme start',
	          cursor = 0,
	          buffer = '',
	          seenAt = false,
	          seenBracket = false,
	          errors = [];
	      loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
	        var c = input[cursor];
	        switch (state) {
	          case 'scheme start':
	            if (c && ALPHA.test(c)) {
	              buffer += c.toLowerCase();
	              state = 'scheme';
	            } else if (!stateOverride) {
	              buffer = '';
	              state = 'no scheme';
	              continue;
	            } else {
	              err('Invalid scheme.');
	              break loop;
	            }
	            break;
	          case 'scheme':
	            if (c && ALPHANUMERIC.test(c)) {
	              buffer += c.toLowerCase();
	            } else if (c === ':') {
	              this._scheme = buffer;
	              buffer = '';
	              if (stateOverride) {
	                break loop;
	              }
	              if (isRelativeScheme(this._scheme)) {
	                this._isRelative = true;
	              }
	              if (this._scheme === 'file') {
	                state = 'relative';
	              } else if (this._isRelative && base && base._scheme === this._scheme) {
	                state = 'relative or authority';
	              } else if (this._isRelative) {
	                state = 'authority first slash';
	              } else {
	                state = 'scheme data';
	              }
	            } else if (!stateOverride) {
	              buffer = '';
	              cursor = 0;
	              state = 'no scheme';
	              continue;
	            } else if (c === EOF) {
	              break loop;
	            } else {
	              err('Code point not allowed in scheme: ' + c);
	              break loop;
	            }
	            break;
	          case 'scheme data':
	            if (c === '?') {
	              this._query = '?';
	              state = 'query';
	            } else if (c === '#') {
	              this._fragment = '#';
	              state = 'fragment';
	            } else {
	              if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	                this._schemeData += percentEscape(c);
	              }
	            }
	            break;
	          case 'no scheme':
	            if (!base || !isRelativeScheme(base._scheme)) {
	              err('Missing scheme.');
	              invalid.call(this);
	            } else {
	              state = 'relative';
	              continue;
	            }
	            break;
	          case 'relative or authority':
	            if (c === '/' && input[cursor + 1] === '/') {
	              state = 'authority ignore slashes';
	            } else {
	              err('Expected /, got: ' + c);
	              state = 'relative';
	              continue;
	            }
	            break;
	          case 'relative':
	            this._isRelative = true;
	            if (this._scheme !== 'file') {
	              this._scheme = base._scheme;
	            }
	            if (c === EOF) {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = base._query;
	              this._username = base._username;
	              this._password = base._password;
	              break loop;
	            } else if (c === '/' || c === '\\') {
	              if (c === '\\') {
	                err('\\ is an invalid code point.');
	              }
	              state = 'relative slash';
	            } else if (c === '?') {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = '?';
	              this._username = base._username;
	              this._password = base._password;
	              state = 'query';
	            } else if (c === '#') {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = base._query;
	              this._fragment = '#';
	              this._username = base._username;
	              this._password = base._password;
	              state = 'fragment';
	            } else {
	              var nextC = input[cursor + 1];
	              var nextNextC = input[cursor + 2];
	              if (this._scheme !== 'file' || !ALPHA.test(c) || nextC !== ':' && nextC !== '|' || nextNextC !== EOF && nextNextC !== '/' && nextNextC !== '\\' && nextNextC !== '?' && nextNextC !== '#') {
	                this._host = base._host;
	                this._port = base._port;
	                this._username = base._username;
	                this._password = base._password;
	                this._path = base._path.slice();
	                this._path.pop();
	              }
	              state = 'relative path';
	              continue;
	            }
	            break;
	          case 'relative slash':
	            if (c === '/' || c === '\\') {
	              if (c === '\\') {
	                err('\\ is an invalid code point.');
	              }
	              if (this._scheme === 'file') {
	                state = 'file host';
	              } else {
	                state = 'authority ignore slashes';
	              }
	            } else {
	              if (this._scheme !== 'file') {
	                this._host = base._host;
	                this._port = base._port;
	                this._username = base._username;
	                this._password = base._password;
	              }
	              state = 'relative path';
	              continue;
	            }
	            break;
	          case 'authority first slash':
	            if (c === '/') {
	              state = 'authority second slash';
	            } else {
	              err('Expected \'/\', got: ' + c);
	              state = 'authority ignore slashes';
	              continue;
	            }
	            break;
	          case 'authority second slash':
	            state = 'authority ignore slashes';
	            if (c !== '/') {
	              err('Expected \'/\', got: ' + c);
	              continue;
	            }
	            break;
	          case 'authority ignore slashes':
	            if (c !== '/' && c !== '\\') {
	              state = 'authority';
	              continue;
	            } else {
	              err('Expected authority, got: ' + c);
	            }
	            break;
	          case 'authority':
	            if (c === '@') {
	              if (seenAt) {
	                err('@ already seen.');
	                buffer += '%40';
	              }
	              seenAt = true;
	              for (var i = 0; i < buffer.length; i++) {
	                var cp = buffer[i];
	                if (cp === '\t' || cp === '\n' || cp === '\r') {
	                  err('Invalid whitespace in authority.');
	                  continue;
	                }
	                if (cp === ':' && this._password === null) {
	                  this._password = '';
	                  continue;
	                }
	                var tempC = percentEscape(cp);
	                if (this._password !== null) {
	                  this._password += tempC;
	                } else {
	                  this._username += tempC;
	                }
	              }
	              buffer = '';
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              cursor -= buffer.length;
	              buffer = '';
	              state = 'host';
	              continue;
	            } else {
	              buffer += c;
	            }
	            break;
	          case 'file host':
	            if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ':' || buffer[1] === '|')) {
	                state = 'relative path';
	              } else if (buffer.length === 0) {
	                state = 'relative path start';
	              } else {
	                this._host = IDNAToASCII.call(this, buffer);
	                buffer = '';
	                state = 'relative path start';
	              }
	              continue;
	            } else if (c === '\t' || c === '\n' || c === '\r') {
	              err('Invalid whitespace in file host.');
	            } else {
	              buffer += c;
	            }
	            break;
	          case 'host':
	          case 'hostname':
	            if (c === ':' && !seenBracket) {
	              this._host = IDNAToASCII.call(this, buffer);
	              buffer = '';
	              state = 'port';
	              if (stateOverride === 'hostname') {
	                break loop;
	              }
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              this._host = IDNAToASCII.call(this, buffer);
	              buffer = '';
	              state = 'relative path start';
	              if (stateOverride) {
	                break loop;
	              }
	              continue;
	            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
	              if (c === '[') {
	                seenBracket = true;
	              } else if (c === ']') {
	                seenBracket = false;
	              }
	              buffer += c;
	            } else {
	              err('Invalid code point in host/hostname: ' + c);
	            }
	            break;
	          case 'port':
	            if (/[0-9]/.test(c)) {
	              buffer += c;
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#' || stateOverride) {
	              if (buffer !== '') {
	                var temp = parseInt(buffer, 10);
	                if (temp !== relative[this._scheme]) {
	                  this._port = temp + '';
	                }
	                buffer = '';
	              }
	              if (stateOverride) {
	                break loop;
	              }
	              state = 'relative path start';
	              continue;
	            } else if (c === '\t' || c === '\n' || c === '\r') {
	              err('Invalid code point in port: ' + c);
	            } else {
	              invalid.call(this);
	            }
	            break;
	          case 'relative path start':
	            if (c === '\\') {
	              err('\'\\\' not allowed in path.');
	            }
	            state = 'relative path';
	            if (c !== '/' && c !== '\\') {
	              continue;
	            }
	            break;
	          case 'relative path':
	            if (c === EOF || c === '/' || c === '\\' || !stateOverride && (c === '?' || c === '#')) {
	              if (c === '\\') {
	                err('\\ not allowed in relative path.');
	              }
	              var tmp;
	              if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
	                buffer = tmp;
	              }
	              if (buffer === '..') {
	                this._path.pop();
	                if (c !== '/' && c !== '\\') {
	                  this._path.push('');
	                }
	              } else if (buffer === '.' && c !== '/' && c !== '\\') {
	                this._path.push('');
	              } else if (buffer !== '.') {
	                if (this._scheme === 'file' && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === '|') {
	                  buffer = buffer[0] + ':';
	                }
	                this._path.push(buffer);
	              }
	              buffer = '';
	              if (c === '?') {
	                this._query = '?';
	                state = 'query';
	              } else if (c === '#') {
	                this._fragment = '#';
	                state = 'fragment';
	              }
	            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
	              buffer += percentEscape(c);
	            }
	            break;
	          case 'query':
	            if (!stateOverride && c === '#') {
	              this._fragment = '#';
	              state = 'fragment';
	            } else if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	              this._query += percentEscapeQuery(c);
	            }
	            break;
	          case 'fragment':
	            if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	              this._fragment += c;
	            }
	            break;
	        }
	        cursor++;
	      }
	    }
	    function clear() {
	      this._scheme = '';
	      this._schemeData = '';
	      this._username = '';
	      this._password = null;
	      this._host = '';
	      this._port = '';
	      this._path = [];
	      this._query = '';
	      this._fragment = '';
	      this._isInvalid = false;
	      this._isRelative = false;
	    }
	    function JURL(url, base) {
	      if (base !== undefined && !(base instanceof JURL)) {
	        base = new JURL(String(base));
	      }
	      this._url = url;
	      clear.call(this);
	      var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
	      parse.call(this, input, null, base);
	    }
	    JURL.prototype = {
	      toString: function toString() {
	        return this.href;
	      },
	
	      get href() {
	        if (this._isInvalid) {
	          return this._url;
	        }
	        var authority = '';
	        if (this._username !== '' || this._password !== null) {
	          authority = this._username + (this._password !== null ? ':' + this._password : '') + '@';
	        }
	        return this.protocol + (this._isRelative ? '//' + authority + this.host : '') + this.pathname + this._query + this._fragment;
	      },
	      set href(value) {
	        clear.call(this);
	        parse.call(this, value);
	      },
	      get protocol() {
	        return this._scheme + ':';
	      },
	      set protocol(value) {
	        if (this._isInvalid) {
	          return;
	        }
	        parse.call(this, value + ':', 'scheme start');
	      },
	      get host() {
	        return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
	      },
	      set host(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, value, 'host');
	      },
	      get hostname() {
	        return this._host;
	      },
	      set hostname(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, value, 'hostname');
	      },
	      get port() {
	        return this._port;
	      },
	      set port(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, value, 'port');
	      },
	      get pathname() {
	        return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
	      },
	      set pathname(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        this._path = [];
	        parse.call(this, value, 'relative path start');
	      },
	      get search() {
	        return this._isInvalid || !this._query || this._query === '?' ? '' : this._query;
	      },
	      set search(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        this._query = '?';
	        if (value[0] === '?') {
	          value = value.slice(1);
	        }
	        parse.call(this, value, 'query');
	      },
	      get hash() {
	        return this._isInvalid || !this._fragment || this._fragment === '#' ? '' : this._fragment;
	      },
	      set hash(value) {
	        if (this._isInvalid) {
	          return;
	        }
	        this._fragment = '#';
	        if (value[0] === '#') {
	          value = value.slice(1);
	        }
	        parse.call(this, value, 'fragment');
	      },
	      get origin() {
	        var host;
	        if (this._isInvalid || !this._scheme) {
	          return '';
	        }
	        switch (this._scheme) {
	          case 'data':
	          case 'file':
	          case 'javascript':
	          case 'mailto':
	            return 'null';
	          case 'blob':
	            try {
	              return new JURL(this._schemeData).origin || 'null';
	            } catch (_) {}
	            return 'null';
	        }
	        host = this.host;
	        if (!host) {
	          return '';
	        }
	        return this._scheme + '://' + host;
	      }
	    };
	    var OriginalURL = globalScope.URL;
	    if (OriginalURL) {
	      JURL.createObjectURL = function (blob) {
	        return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
	      };
	      JURL.revokeObjectURL = function (url) {
	        OriginalURL.revokeObjectURL(url);
	      };
	    }
	    globalScope.URL = JURL;
	  })();
	}
	
	/***/ }),
	/* 93 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(94);
	module.exports = __w_pdfjs_require__(6).Uint8ClampedArray;
	
	/***/ }),
	/* 94 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(95)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);
	
	/***/ }),
	/* 95 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	if (__w_pdfjs_require__(10)) {
	  var LIBRARY = __w_pdfjs_require__(23);
	  var global = __w_pdfjs_require__(1);
	  var fails = __w_pdfjs_require__(11);
	  var $export = __w_pdfjs_require__(7);
	  var $typed = __w_pdfjs_require__(52);
	  var $buffer = __w_pdfjs_require__(96);
	  var ctx = __w_pdfjs_require__(13);
	  var anInstance = __w_pdfjs_require__(26);
	  var propertyDesc = __w_pdfjs_require__(31);
	  var hide = __w_pdfjs_require__(8);
	  var redefineAll = __w_pdfjs_require__(25);
	  var toInteger = __w_pdfjs_require__(19);
	  var toLength = __w_pdfjs_require__(14);
	  var toIndex = __w_pdfjs_require__(53);
	  var toAbsoluteIndex = __w_pdfjs_require__(33);
	  var toPrimitive = __w_pdfjs_require__(38);
	  var has = __w_pdfjs_require__(12);
	  var classof = __w_pdfjs_require__(34);
	  var isObject = __w_pdfjs_require__(3);
	  var toObject = __w_pdfjs_require__(20);
	  var isArrayIter = __w_pdfjs_require__(59);
	  var create = __w_pdfjs_require__(60);
	  var getPrototypeOf = __w_pdfjs_require__(62);
	  var gOPN = __w_pdfjs_require__(54).f;
	  var getIterFn = __w_pdfjs_require__(63);
	  var uid = __w_pdfjs_require__(18);
	  var wks = __w_pdfjs_require__(4);
	  var createArrayMethod = __w_pdfjs_require__(44);
	  var createArrayIncludes = __w_pdfjs_require__(56);
	  var speciesConstructor = __w_pdfjs_require__(45);
	  var ArrayIterators = __w_pdfjs_require__(64);
	  var Iterators = __w_pdfjs_require__(21);
	  var $iterDetect = __w_pdfjs_require__(46);
	  var setSpecies = __w_pdfjs_require__(66);
	  var arrayFill = __w_pdfjs_require__(58);
	  var arrayCopyWithin = __w_pdfjs_require__(104);
	  var $DP = __w_pdfjs_require__(15);
	  var $GOPD = __w_pdfjs_require__(67);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	  var LITTLE_ENDIAN = fails(function () {
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	  var toOffset = function toOffset(it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	  var validate = function validate(it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	  var allocate = function allocate(C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    }
	    return new C(length);
	  };
	  var speciesFromList = function speciesFromList(O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	  var fromList = function fromList(C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) {
	      result[index] = list[index++];
	    }return result;
	  };
	  var addGetter = function addGetter(it, key, internal) {
	    dP(it, key, {
	      get: function get() {
	        return this._d[internal];
	      }
	    });
	  };
	  var $from = function from(source) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      }
	      O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	  var $of = function of() {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) {
	      result[index] = arguments[index++];
	    }return result;
	  };
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () {
	    arrayToLocaleString.call(new Uint8Array(1));
	  });
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	  var proto = {
	    copyWithin: function copyWithin(target, start) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value) {
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) {
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement) {
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn) {
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn) {
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      }
	      return that;
	    },
	    some: function some(callbackfn) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin));
	    }
	  };
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	  var $set = function set(arrayLike) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) {
	      this[offset + index] = src[index++];
	    }
	  };
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	  var isTAIndex = function isTAIndex(target, key) {
	    return isObject(target) && target[TYPED_ARRAY] && (typeof key === 'undefined' ? 'undefined' : _typeof(key)) != 'symbol' && key in target && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true)) ? propertyDesc(2, target[key]) : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true)) && isObject(desc) && has(desc, 'value') && !has(desc, 'get') && !has(desc, 'set') && !desc.configurable && (!has(desc, 'writable') || desc.writable) && (!has(desc, 'enumerable') || desc.enumerable)) {
	      target[key] = desc.value;
	      return target;
	    }
	    return dP(target, key, desc);
	  };
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	  if (fails(function () {
	    arrayToString.call({});
	  })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function constructor() {},
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function get() {
	      return this[TYPED_ARRAY];
	    }
	  });
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function getter(that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function setter(that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function addElement(that, index) {
	      dP(that, index, {
	        get: function get() {
	          return getter(this, index);
	        },
	        set: function set(value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) {
	          addElement(that, index++);
	        }
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1);
	    }) || !$iterDetect(function (iter) {
	      new TypedArray();
	      new TypedArray(null);
	      new TypedArray(1.5);
	      new TypedArray(iter);
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined ? new Base(data, toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, toOffset($offset, BYTES)) : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function get() {
	          return NAME;
	        }
	      });
	    }
	    O[NAME] = TypedArray;
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	    $export($export.S, NAME, { BYTES_PER_ELEMENT: BYTES });
	    $export($export.S + $export.F * fails(function () {
	      Base.of.call(TypedArray, 1);
	    }), NAME, {
	      from: $from,
	      of: $of
	    });
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	    $export($export.P, NAME, proto);
	    setSpecies(NAME);
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () {};
	
	/***/ }),
	/* 96 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(1);
	var DESCRIPTORS = __w_pdfjs_require__(10);
	var LIBRARY = __w_pdfjs_require__(23);
	var $typed = __w_pdfjs_require__(52);
	var hide = __w_pdfjs_require__(8);
	var redefineAll = __w_pdfjs_require__(25);
	var fails = __w_pdfjs_require__(11);
	var anInstance = __w_pdfjs_require__(26);
	var toInteger = __w_pdfjs_require__(19);
	var toLength = __w_pdfjs_require__(14);
	var toIndex = __w_pdfjs_require__(53);
	var gOPN = __w_pdfjs_require__(54).f;
	var dP = __w_pdfjs_require__(15).f;
	var arrayFill = __w_pdfjs_require__(58);
	var setToStringTag = __w_pdfjs_require__(28);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  if (value != value || value === Infinity) {
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8) {}
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8) {}
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8) {}
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8) {}
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  }
	  return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, {
	    get: function get() {
	      return this[internal];
	    }
	  });
	}
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) {
	    store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	  }
	}
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1);
	  }) || fails(function () {
	    new $ArrayBuffer();
	    new $ArrayBuffer(1.5);
	    new $ArrayBuffer(NaN);
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;
	
	/***/ }),
	/* 97 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var dP = __w_pdfjs_require__(15);
	var anObject = __w_pdfjs_require__(9);
	var getKeys = __w_pdfjs_require__(43);
	module.exports = __w_pdfjs_require__(10) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) {
	    dP.f(O, P = keys[i++], Properties[P]);
	  }return O;
	};
	
	/***/ }),
	/* 98 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var speciesConstructor = __w_pdfjs_require__(99);
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};
	
	/***/ }),
	/* 99 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(3);
	var isArray = __w_pdfjs_require__(100);
	var SPECIES = __w_pdfjs_require__(4)('species');
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  }
	  return C === undefined ? Array : C;
	};
	
	/***/ }),
	/* 100 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var cof = __w_pdfjs_require__(27);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};
	
	/***/ }),
	/* 101 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var UNSCOPABLES = __w_pdfjs_require__(4)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __w_pdfjs_require__(8)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};
	
	/***/ }),
	/* 102 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (done, value) {
	  return {
	    value: value,
	    done: !!done
	  };
	};
	
	/***/ }),
	/* 103 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var create = __w_pdfjs_require__(60);
	var descriptor = __w_pdfjs_require__(31);
	var setToStringTag = __w_pdfjs_require__(28);
	var IteratorPrototype = {};
	__w_pdfjs_require__(8)(IteratorPrototype, __w_pdfjs_require__(4)('iterator'), function () {
	  return this;
	});
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};
	
	/***/ }),
	/* 104 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toObject = __w_pdfjs_require__(20);
	var toAbsoluteIndex = __w_pdfjs_require__(33);
	var toLength = __w_pdfjs_require__(14);
	module.exports = [].copyWithin || function copyWithin(target, start) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];else delete O[to];
	    to += inc;
	    from += inc;
	  }
	  return O;
	};
	
	/***/ }),
	/* 105 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(106);
	module.exports = __w_pdfjs_require__(6).Number.isNaN;
	
	/***/ }),
	/* 106 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(7);
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    return number != number;
	  }
	});
	
	/***/ }),
	/* 107 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(108);
	module.exports = __w_pdfjs_require__(6).Number.isInteger;
	
	/***/ }),
	/* 108 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(7);
	$export($export.S, 'Number', { isInteger: __w_pdfjs_require__(109) });
	
	/***/ }),
	/* 109 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(3);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};
	
	/***/ }),
	/* 110 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(69);
	__w_pdfjs_require__(111);
	__w_pdfjs_require__(70);
	__w_pdfjs_require__(113);
	__w_pdfjs_require__(118);
	__w_pdfjs_require__(119);
	module.exports = __w_pdfjs_require__(6).Promise;
	
	/***/ }),
	/* 111 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $at = __w_pdfjs_require__(112)(true);
	__w_pdfjs_require__(65)(String, 'String', function (iterated) {
	  this._t = String(iterated);
	  this._i = 0;
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return {
	    value: undefined,
	    done: true
	  };
	  point = $at(O, index);
	  this._i += point.length;
	  return {
	    value: point,
	    done: false
	  };
	});
	
	/***/ }),
	/* 112 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toInteger = __w_pdfjs_require__(19);
	var defined = __w_pdfjs_require__(40);
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};
	
	/***/ }),
	/* 113 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var LIBRARY = __w_pdfjs_require__(23);
	var global = __w_pdfjs_require__(1);
	var ctx = __w_pdfjs_require__(13);
	var classof = __w_pdfjs_require__(34);
	var $export = __w_pdfjs_require__(7);
	var isObject = __w_pdfjs_require__(3);
	var aFunction = __w_pdfjs_require__(24);
	var anInstance = __w_pdfjs_require__(26);
	var forOf = __w_pdfjs_require__(35);
	var speciesConstructor = __w_pdfjs_require__(45);
	var task = __w_pdfjs_require__(71).set;
	var microtask = __w_pdfjs_require__(116)();
	var newPromiseCapabilityModule = __w_pdfjs_require__(47);
	var perform = __w_pdfjs_require__(72);
	var userAgent = __w_pdfjs_require__(117);
	var promiseResolve = __w_pdfjs_require__(73);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function empty() {};
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	var USE_NATIVE = !!function () {
	  try {
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__w_pdfjs_require__(4)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise && v8.indexOf('6.6') !== 0 && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) {}
	}();
	var isThenable = function isThenable(it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function notify(promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function run(reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) {
	      run(chain[i++]);
	    }promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function onUnhandled(promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({
	            promise: promise,
	            reason: value
	          });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    }
	    promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function isUnhandled(promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function onHandleUnhandled(promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({
	        promise: promise,
	        reason: promise._v
	      });
	    }
	  });
	};
	var $reject = function $reject(value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise;
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function $resolve(value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise;
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = {
	          _w: promise,
	          _d: false
	        };
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({
	      _w: promise,
	      _d: false
	    }, e);
	  }
	};
	if (!USE_NATIVE) {
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor) {
	    this._c = [];
	    this._a = undefined;
	    this._s = 0;
	    this._d = false;
	    this._v = undefined;
	    this._h = 0;
	    this._n = false;
	  };
	  Internal.prototype = __w_pdfjs_require__(25)($Promise.prototype, {
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    'catch': function _catch(onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function OwnPromiseCapability() {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
	    return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
	  };
	}
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__w_pdfjs_require__(28)($Promise, PROMISE);
	__w_pdfjs_require__(66)(PROMISE);
	Wrapper = __w_pdfjs_require__(6)[PROMISE];
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __w_pdfjs_require__(46)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});
	
	/***/ }),
	/* 114 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var anObject = __w_pdfjs_require__(9);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};
	
	/***/ }),
	/* 115 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0:
	      return un ? fn() : fn.call(that);
	    case 1:
	      return un ? fn(args[0]) : fn.call(that, args[0]);
	    case 2:
	      return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
	    case 3:
	      return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
	    case 4:
	      return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
	  }
	  return fn.apply(that, args);
	};
	
	/***/ }),
	/* 116 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(1);
	var macrotask = __w_pdfjs_require__(71).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __w_pdfjs_require__(27)(process) == 'process';
	module.exports = function () {
	  var head, last, notify;
	  var flush = function flush() {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();else last = undefined;
	        throw e;
	      }
	    }
	    last = undefined;
	    if (parent) parent.enter();
	  };
	  if (isNode) {
	    notify = function notify() {
	      process.nextTick(flush);
	    };
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true });
	    notify = function notify() {
	      node.data = toggle = !toggle;
	    };
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve(undefined);
	    notify = function notify() {
	      promise.then(flush);
	    };
	  } else {
	    notify = function notify() {
	      macrotask.call(global, flush);
	    };
	  }
	  return function (fn) {
	    var task = {
	      fn: fn,
	      next: undefined
	    };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    }
	    last = task;
	  };
	};
	
	/***/ }),
	/* 117 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(1);
	var navigator = global.navigator;
	module.exports = navigator && navigator.userAgent || '';
	
	/***/ }),
	/* 118 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(7);
	var core = __w_pdfjs_require__(6);
	var global = __w_pdfjs_require__(1);
	var speciesConstructor = __w_pdfjs_require__(45);
	var promiseResolve = __w_pdfjs_require__(73);
	$export($export.P + $export.R, 'Promise', {
	  'finally': function _finally(onFinally) {
	    var C = speciesConstructor(this, core.Promise || global.Promise);
	    var isFunction = typeof onFinally == 'function';
	    return this.then(isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () {
	        return x;
	      });
	    } : onFinally, isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () {
	        throw e;
	      });
	    } : onFinally);
	  }
	});
	
	/***/ }),
	/* 119 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(7);
	var newPromiseCapability = __w_pdfjs_require__(47);
	var perform = __w_pdfjs_require__(72);
	$export($export.S, 'Promise', {
	  'try': function _try(callbackfn) {
	    var promiseCapability = newPromiseCapability.f(this);
	    var result = perform(callbackfn);
	    (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	    return promiseCapability.promise;
	  }
	});
	
	/***/ }),
	/* 120 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(69);
	__w_pdfjs_require__(70);
	__w_pdfjs_require__(121);
	__w_pdfjs_require__(128);
	__w_pdfjs_require__(130);
	module.exports = __w_pdfjs_require__(6).WeakMap;
	
	/***/ }),
	/* 121 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var each = __w_pdfjs_require__(44)(0);
	var redefine = __w_pdfjs_require__(16);
	var meta = __w_pdfjs_require__(48);
	var assign = __w_pdfjs_require__(122);
	var weak = __w_pdfjs_require__(124);
	var isObject = __w_pdfjs_require__(3);
	var fails = __w_pdfjs_require__(11);
	var validate = __w_pdfjs_require__(74);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	var wrapper = function wrapper(get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	var methods = {
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	var $WeakMap = module.exports = __w_pdfjs_require__(125)(WEAK_MAP, wrapper, methods, weak, true, true);
	if (fails(function () {
	  return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7;
	})) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      }
	      return method.call(this, a, b);
	    });
	  });
	}
	
	/***/ }),
	/* 122 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var getKeys = __w_pdfjs_require__(43);
	var gOPS = __w_pdfjs_require__(123);
	var pIE = __w_pdfjs_require__(68);
	var toObject = __w_pdfjs_require__(20);
	var IObject = __w_pdfjs_require__(39);
	var $assign = Object.assign;
	module.exports = !$assign || __w_pdfjs_require__(11)(function () {
	  var A = {};
	  var B = {};
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) {
	    B[k] = k;
	  });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) {
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	    }
	  }
	  return T;
	} : $assign;
	
	/***/ }),
	/* 123 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	exports.f = Object.getOwnPropertySymbols;
	
	/***/ }),
	/* 124 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var redefineAll = __w_pdfjs_require__(25);
	var getWeak = __w_pdfjs_require__(48).getWeak;
	var anObject = __w_pdfjs_require__(9);
	var isObject = __w_pdfjs_require__(3);
	var anInstance = __w_pdfjs_require__(26);
	var forOf = __w_pdfjs_require__(35);
	var createArrayMethod = __w_pdfjs_require__(44);
	var $has = __w_pdfjs_require__(12);
	var validate = __w_pdfjs_require__(74);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function UncaughtFrozenStore() {
	  this.a = [];
	};
	var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function get(key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function has(key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function set(key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;else this.a.push([key, value]);
	  },
	  'delete': function _delete(key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	module.exports = {
	  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;
	      that._i = id++;
	      that._l = undefined;
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      'delete': function _delete(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function def(that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};
	
	/***/ }),
	/* 125 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(1);
	var $export = __w_pdfjs_require__(7);
	var redefine = __w_pdfjs_require__(16);
	var redefineAll = __w_pdfjs_require__(25);
	var meta = __w_pdfjs_require__(48);
	var forOf = __w_pdfjs_require__(35);
	var anInstance = __w_pdfjs_require__(26);
	var isObject = __w_pdfjs_require__(3);
	var fails = __w_pdfjs_require__(11);
	var $iterDetect = __w_pdfjs_require__(46);
	var setToStringTag = __w_pdfjs_require__(28);
	var inheritIfRequired = __w_pdfjs_require__(126);
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function fixMethod(KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY, KEY == 'delete' ? function (a) {
	      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	    } : KEY == 'has' ? function has(a) {
	      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	    } : KEY == 'get' ? function get(a) {
	      return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	    } : KEY == 'add' ? function add(a) {
	      fn.call(this, a === 0 ? 0 : a);
	      return this;
	    } : function set(a, b) {
	      fn.call(this, a === 0 ? 0 : a, b);
	      return this;
	    });
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    var THROWS_ON_PRIMITIVES = fails(function () {
	      instance.has(1);
	    });
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) {
	      new C(iter);
	    });
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      var $instance = new C();
	      var index = 5;
	      while (index--) {
	        $instance[ADDER](index, index);
	      }return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	  setToStringTag(C, NAME);
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	  return C;
	};
	
	/***/ }),
	/* 126 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(3);
	var setPrototypeOf = __w_pdfjs_require__(127).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  }
	  return that;
	};
	
	/***/ }),
	/* 127 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(3);
	var anObject = __w_pdfjs_require__(9);
	var check = function check(O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? function (test, buggy, set) {
	    try {
	      set = __w_pdfjs_require__(13)(Function.call, __w_pdfjs_require__(67).f(Object.prototype, '__proto__').set, 2);
	      set(test, []);
	      buggy = !(test instanceof Array);
	    } catch (e) {
	      buggy = true;
	    }
	    return function setPrototypeOf(O, proto) {
	      check(O, proto);
	      if (buggy) O.__proto__ = proto;else set(O, proto);
	      return O;
	    };
	  }({}, false) : undefined),
	  check: check
	};
	
	/***/ }),
	/* 128 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(129)('WeakMap');
	
	/***/ }),
	/* 129 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(7);
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, {
	    of: function of() {
	      var length = arguments.length;
	      var A = new Array(length);
	      while (length--) {
	        A[length] = arguments[length];
	      }return new this(A);
	    }
	  });
	};
	
	/***/ }),
	/* 130 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(131)('WeakMap');
	
	/***/ }),
	/* 131 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(7);
	var aFunction = __w_pdfjs_require__(24);
	var ctx = __w_pdfjs_require__(13);
	var forOf = __w_pdfjs_require__(35);
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, {
	    from: function from(source) {
	      var mapFn = arguments[1];
	      var mapping, A, n, cb;
	      aFunction(this);
	      mapping = mapFn !== undefined;
	      if (mapping) aFunction(mapFn);
	      if (source == undefined) return new this();
	      A = [];
	      if (mapping) {
	        n = 0;
	        cb = ctx(mapFn, arguments[2], 2);
	        forOf(source, false, function (nextItem) {
	          A.push(cb(nextItem, n++));
	        });
	      } else {
	        forOf(source, false, A.push, A);
	      }
	      return new this(A);
	    }
	  });
	};
	
	/***/ }),
	/* 132 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isReadableStreamSupported = false;
	if (typeof ReadableStream !== 'undefined') {
	  try {
	    new ReadableStream({
	      start: function start(controller) {
	        controller.close();
	      }
	    });
	    isReadableStreamSupported = true;
	  } catch (e) {}
	}
	if (isReadableStreamSupported) {
	  exports.ReadableStream = ReadableStream;
	} else {
	  exports.ReadableStream = __w_pdfjs_require__(133).ReadableStream;
	}
	
	/***/ }),
	/* 133 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (e, a) {
	  for (var i in a) {
	    e[i] = a[i];
	  }
	})(exports, function (modules) {
	  var installedModules = {};
	  function __w_pdfjs_require__(moduleId) {
	    if (installedModules[moduleId]) return installedModules[moduleId].exports;
	    var module = installedModules[moduleId] = {
	      i: moduleId,
	      l: false,
	      exports: {}
	    };
	    modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
	    module.l = true;
	    return module.exports;
	  }
	  __w_pdfjs_require__.m = modules;
	  __w_pdfjs_require__.c = installedModules;
	  __w_pdfjs_require__.i = function (value) {
	    return value;
	  };
	  __w_pdfjs_require__.d = function (exports, name, getter) {
	    if (!__w_pdfjs_require__.o(exports, name)) {
	      Object.defineProperty(exports, name, {
	        configurable: false,
	        enumerable: true,
	        get: getter
	      });
	    }
	  };
	  __w_pdfjs_require__.n = function (module) {
	    var getter = module && module.__esModule ? function getDefault() {
	      return module['default'];
	    } : function getModuleExports() {
	      return module;
	    };
	    __w_pdfjs_require__.d(getter, 'a', getter);
	    return getter;
	  };
	  __w_pdfjs_require__.o = function (object, property) {
	    return Object.prototype.hasOwnProperty.call(object, property);
	  };
	  __w_pdfjs_require__.p = "";
	  return __w_pdfjs_require__(__w_pdfjs_require__.s = 7);
	}([function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	    return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	  } : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	  };
	  var _require = __w_pdfjs_require__(1),
	      assert = _require.assert;
	  function IsPropertyKey(argument) {
	    return typeof argument === 'string' || (typeof argument === 'undefined' ? 'undefined' : _typeof(argument)) === 'symbol';
	  }
	  exports.typeIsObject = function (x) {
	    return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null || typeof x === 'function';
	  };
	  exports.createDataProperty = function (o, p, v) {
	    assert(exports.typeIsObject(o));
	    Object.defineProperty(o, p, {
	      value: v,
	      writable: true,
	      enumerable: true,
	      configurable: true
	    });
	  };
	  exports.createArrayFromList = function (elements) {
	    return elements.slice();
	  };
	  exports.ArrayBufferCopy = function (dest, destOffset, src, srcOffset, n) {
	    new Uint8Array(dest).set(new Uint8Array(src, srcOffset, n), destOffset);
	  };
	  exports.CreateIterResultObject = function (value, done) {
	    assert(typeof done === 'boolean');
	    var obj = {};
	    Object.defineProperty(obj, 'value', {
	      value: value,
	      enumerable: true,
	      writable: true,
	      configurable: true
	    });
	    Object.defineProperty(obj, 'done', {
	      value: done,
	      enumerable: true,
	      writable: true,
	      configurable: true
	    });
	    return obj;
	  };
	  exports.IsFiniteNonNegativeNumber = function (v) {
	    if (Number.isNaN(v)) {
	      return false;
	    }
	    if (v === Infinity) {
	      return false;
	    }
	    if (v < 0) {
	      return false;
	    }
	    return true;
	  };
	  function Call(F, V, args) {
	    if (typeof F !== 'function') {
	      throw new TypeError('Argument is not a function');
	    }
	    return Function.prototype.apply.call(F, V, args);
	  }
	  exports.InvokeOrNoop = function (O, P, args) {
	    assert(O !== undefined);
	    assert(IsPropertyKey(P));
	    assert(Array.isArray(args));
	    var method = O[P];
	    if (method === undefined) {
	      return undefined;
	    }
	    return Call(method, O, args);
	  };
	  exports.PromiseInvokeOrNoop = function (O, P, args) {
	    assert(O !== undefined);
	    assert(IsPropertyKey(P));
	    assert(Array.isArray(args));
	    try {
	      return Promise.resolve(exports.InvokeOrNoop(O, P, args));
	    } catch (returnValueE) {
	      return Promise.reject(returnValueE);
	    }
	  };
	  exports.PromiseInvokeOrPerformFallback = function (O, P, args, F, argsF) {
	    assert(O !== undefined);
	    assert(IsPropertyKey(P));
	    assert(Array.isArray(args));
	    assert(Array.isArray(argsF));
	    var method = void 0;
	    try {
	      method = O[P];
	    } catch (methodE) {
	      return Promise.reject(methodE);
	    }
	    if (method === undefined) {
	      return F.apply(null, argsF);
	    }
	    try {
	      return Promise.resolve(Call(method, O, args));
	    } catch (e) {
	      return Promise.reject(e);
	    }
	  };
	  exports.TransferArrayBuffer = function (O) {
	    return O.slice();
	  };
	  exports.ValidateAndNormalizeHighWaterMark = function (highWaterMark) {
	    highWaterMark = Number(highWaterMark);
	    if (Number.isNaN(highWaterMark) || highWaterMark < 0) {
	      throw new RangeError('highWaterMark property of a queuing strategy must be non-negative and non-NaN');
	    }
	    return highWaterMark;
	  };
	  exports.ValidateAndNormalizeQueuingStrategy = function (size, highWaterMark) {
	    if (size !== undefined && typeof size !== 'function') {
	      throw new TypeError('size property of a queuing strategy must be a function');
	    }
	    highWaterMark = exports.ValidateAndNormalizeHighWaterMark(highWaterMark);
	    return {
	      size: size,
	      highWaterMark: highWaterMark
	    };
	  };
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  function rethrowAssertionErrorRejection(e) {
	    if (e && e.constructor === AssertionError) {
	      setTimeout(function () {
	        throw e;
	      }, 0);
	    }
	  }
	  function AssertionError(message) {
	    this.name = 'AssertionError';
	    this.message = message || '';
	    this.stack = new Error().stack;
	  }
	  AssertionError.prototype = Object.create(Error.prototype);
	  AssertionError.prototype.constructor = AssertionError;
	  function assert(value, message) {
	    if (!value) {
	      throw new AssertionError(message);
	    }
	  }
	  module.exports = {
	    rethrowAssertionErrorRejection: rethrowAssertionErrorRejection,
	    AssertionError: AssertionError,
	    assert: assert
	  };
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	  var _require = __w_pdfjs_require__(0),
	      InvokeOrNoop = _require.InvokeOrNoop,
	      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
	      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
	      typeIsObject = _require.typeIsObject;
	  var _require2 = __w_pdfjs_require__(1),
	      assert = _require2.assert,
	      rethrowAssertionErrorRejection = _require2.rethrowAssertionErrorRejection;
	  var _require3 = __w_pdfjs_require__(3),
	      DequeueValue = _require3.DequeueValue,
	      EnqueueValueWithSize = _require3.EnqueueValueWithSize,
	      PeekQueueValue = _require3.PeekQueueValue,
	      ResetQueue = _require3.ResetQueue;
	  var WritableStream = function () {
	    function WritableStream() {
	      var underlyingSink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          size = _ref.size,
	          _ref$highWaterMark = _ref.highWaterMark,
	          highWaterMark = _ref$highWaterMark === undefined ? 1 : _ref$highWaterMark;
	      _classCallCheck(this, WritableStream);
	      this._state = 'writable';
	      this._storedError = undefined;
	      this._writer = undefined;
	      this._writableStreamController = undefined;
	      this._writeRequests = [];
	      this._inFlightWriteRequest = undefined;
	      this._closeRequest = undefined;
	      this._inFlightCloseRequest = undefined;
	      this._pendingAbortRequest = undefined;
	      this._backpressure = false;
	      var type = underlyingSink.type;
	      if (type !== undefined) {
	        throw new RangeError('Invalid type is specified');
	      }
	      this._writableStreamController = new WritableStreamDefaultController(this, underlyingSink, size, highWaterMark);
	      this._writableStreamController.__startSteps();
	    }
	    _createClass(WritableStream, [{
	      key: 'abort',
	      value: function abort(reason) {
	        if (IsWritableStream(this) === false) {
	          return Promise.reject(streamBrandCheckException('abort'));
	        }
	        if (IsWritableStreamLocked(this) === true) {
	          return Promise.reject(new TypeError('Cannot abort a stream that already has a writer'));
	        }
	        return WritableStreamAbort(this, reason);
	      }
	    }, {
	      key: 'getWriter',
	      value: function getWriter() {
	        if (IsWritableStream(this) === false) {
	          throw streamBrandCheckException('getWriter');
	        }
	        return AcquireWritableStreamDefaultWriter(this);
	      }
	    }, {
	      key: 'locked',
	      get: function get() {
	        if (IsWritableStream(this) === false) {
	          throw streamBrandCheckException('locked');
	        }
	        return IsWritableStreamLocked(this);
	      }
	    }]);
	    return WritableStream;
	  }();
	  module.exports = {
	    AcquireWritableStreamDefaultWriter: AcquireWritableStreamDefaultWriter,
	    IsWritableStream: IsWritableStream,
	    IsWritableStreamLocked: IsWritableStreamLocked,
	    WritableStream: WritableStream,
	    WritableStreamAbort: WritableStreamAbort,
	    WritableStreamDefaultControllerError: WritableStreamDefaultControllerError,
	    WritableStreamDefaultWriterCloseWithErrorPropagation: WritableStreamDefaultWriterCloseWithErrorPropagation,
	    WritableStreamDefaultWriterRelease: WritableStreamDefaultWriterRelease,
	    WritableStreamDefaultWriterWrite: WritableStreamDefaultWriterWrite,
	    WritableStreamCloseQueuedOrInFlight: WritableStreamCloseQueuedOrInFlight
	  };
	  function AcquireWritableStreamDefaultWriter(stream) {
	    return new WritableStreamDefaultWriter(stream);
	  }
	  function IsWritableStream(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_writableStreamController')) {
	      return false;
	    }
	    return true;
	  }
	  function IsWritableStreamLocked(stream) {
	    assert(IsWritableStream(stream) === true, 'IsWritableStreamLocked should only be used on known writable streams');
	    if (stream._writer === undefined) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamAbort(stream, reason) {
	    var state = stream._state;
	    if (state === 'closed') {
	      return Promise.resolve(undefined);
	    }
	    if (state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    var error = new TypeError('Requested to abort');
	    if (stream._pendingAbortRequest !== undefined) {
	      return Promise.reject(error);
	    }
	    assert(state === 'writable' || state === 'erroring', 'state must be writable or erroring');
	    var wasAlreadyErroring = false;
	    if (state === 'erroring') {
	      wasAlreadyErroring = true;
	      reason = undefined;
	    }
	    var promise = new Promise(function (resolve, reject) {
	      stream._pendingAbortRequest = {
	        _resolve: resolve,
	        _reject: reject,
	        _reason: reason,
	        _wasAlreadyErroring: wasAlreadyErroring
	      };
	    });
	    if (wasAlreadyErroring === false) {
	      WritableStreamStartErroring(stream, error);
	    }
	    return promise;
	  }
	  function WritableStreamAddWriteRequest(stream) {
	    assert(IsWritableStreamLocked(stream) === true);
	    assert(stream._state === 'writable');
	    var promise = new Promise(function (resolve, reject) {
	      var writeRequest = {
	        _resolve: resolve,
	        _reject: reject
	      };
	      stream._writeRequests.push(writeRequest);
	    });
	    return promise;
	  }
	  function WritableStreamDealWithRejection(stream, error) {
	    var state = stream._state;
	    if (state === 'writable') {
	      WritableStreamStartErroring(stream, error);
	      return;
	    }
	    assert(state === 'erroring');
	    WritableStreamFinishErroring(stream);
	  }
	  function WritableStreamStartErroring(stream, reason) {
	    assert(stream._storedError === undefined, 'stream._storedError === undefined');
	    assert(stream._state === 'writable', 'state must be writable');
	    var controller = stream._writableStreamController;
	    assert(controller !== undefined, 'controller must not be undefined');
	    stream._state = 'erroring';
	    stream._storedError = reason;
	    var writer = stream._writer;
	    if (writer !== undefined) {
	      WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason);
	    }
	    if (WritableStreamHasOperationMarkedInFlight(stream) === false && controller._started === true) {
	      WritableStreamFinishErroring(stream);
	    }
	  }
	  function WritableStreamFinishErroring(stream) {
	    assert(stream._state === 'erroring', 'stream._state === erroring');
	    assert(WritableStreamHasOperationMarkedInFlight(stream) === false, 'WritableStreamHasOperationMarkedInFlight(stream) === false');
	    stream._state = 'errored';
	    stream._writableStreamController.__errorSteps();
	    var storedError = stream._storedError;
	    for (var i = 0; i < stream._writeRequests.length; i++) {
	      var writeRequest = stream._writeRequests[i];
	      writeRequest._reject(storedError);
	    }
	    stream._writeRequests = [];
	    if (stream._pendingAbortRequest === undefined) {
	      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	      return;
	    }
	    var abortRequest = stream._pendingAbortRequest;
	    stream._pendingAbortRequest = undefined;
	    if (abortRequest._wasAlreadyErroring === true) {
	      abortRequest._reject(storedError);
	      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	      return;
	    }
	    var promise = stream._writableStreamController.__abortSteps(abortRequest._reason);
	    promise.then(function () {
	      abortRequest._resolve();
	      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	    }, function (reason) {
	      abortRequest._reject(reason);
	      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	    });
	  }
	  function WritableStreamFinishInFlightWrite(stream) {
	    assert(stream._inFlightWriteRequest !== undefined);
	    stream._inFlightWriteRequest._resolve(undefined);
	    stream._inFlightWriteRequest = undefined;
	  }
	  function WritableStreamFinishInFlightWriteWithError(stream, error) {
	    assert(stream._inFlightWriteRequest !== undefined);
	    stream._inFlightWriteRequest._reject(error);
	    stream._inFlightWriteRequest = undefined;
	    assert(stream._state === 'writable' || stream._state === 'erroring');
	    WritableStreamDealWithRejection(stream, error);
	  }
	  function WritableStreamFinishInFlightClose(stream) {
	    assert(stream._inFlightCloseRequest !== undefined);
	    stream._inFlightCloseRequest._resolve(undefined);
	    stream._inFlightCloseRequest = undefined;
	    var state = stream._state;
	    assert(state === 'writable' || state === 'erroring');
	    if (state === 'erroring') {
	      stream._storedError = undefined;
	      if (stream._pendingAbortRequest !== undefined) {
	        stream._pendingAbortRequest._resolve();
	        stream._pendingAbortRequest = undefined;
	      }
	    }
	    stream._state = 'closed';
	    var writer = stream._writer;
	    if (writer !== undefined) {
	      defaultWriterClosedPromiseResolve(writer);
	    }
	    assert(stream._pendingAbortRequest === undefined, 'stream._pendingAbortRequest === undefined');
	    assert(stream._storedError === undefined, 'stream._storedError === undefined');
	  }
	  function WritableStreamFinishInFlightCloseWithError(stream, error) {
	    assert(stream._inFlightCloseRequest !== undefined);
	    stream._inFlightCloseRequest._reject(error);
	    stream._inFlightCloseRequest = undefined;
	    assert(stream._state === 'writable' || stream._state === 'erroring');
	    if (stream._pendingAbortRequest !== undefined) {
	      stream._pendingAbortRequest._reject(error);
	      stream._pendingAbortRequest = undefined;
	    }
	    WritableStreamDealWithRejection(stream, error);
	  }
	  function WritableStreamCloseQueuedOrInFlight(stream) {
	    if (stream._closeRequest === undefined && stream._inFlightCloseRequest === undefined) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamHasOperationMarkedInFlight(stream) {
	    if (stream._inFlightWriteRequest === undefined && stream._inFlightCloseRequest === undefined) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamMarkCloseRequestInFlight(stream) {
	    assert(stream._inFlightCloseRequest === undefined);
	    assert(stream._closeRequest !== undefined);
	    stream._inFlightCloseRequest = stream._closeRequest;
	    stream._closeRequest = undefined;
	  }
	  function WritableStreamMarkFirstWriteRequestInFlight(stream) {
	    assert(stream._inFlightWriteRequest === undefined, 'there must be no pending write request');
	    assert(stream._writeRequests.length !== 0, 'writeRequests must not be empty');
	    stream._inFlightWriteRequest = stream._writeRequests.shift();
	  }
	  function WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream) {
	    assert(stream._state === 'errored', '_stream_.[[state]] is `"errored"`');
	    if (stream._closeRequest !== undefined) {
	      assert(stream._inFlightCloseRequest === undefined);
	      stream._closeRequest._reject(stream._storedError);
	      stream._closeRequest = undefined;
	    }
	    var writer = stream._writer;
	    if (writer !== undefined) {
	      defaultWriterClosedPromiseReject(writer, stream._storedError);
	      writer._closedPromise.catch(function () {});
	    }
	  }
	  function WritableStreamUpdateBackpressure(stream, backpressure) {
	    assert(stream._state === 'writable');
	    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
	    var writer = stream._writer;
	    if (writer !== undefined && backpressure !== stream._backpressure) {
	      if (backpressure === true) {
	        defaultWriterReadyPromiseReset(writer);
	      } else {
	        assert(backpressure === false);
	        defaultWriterReadyPromiseResolve(writer);
	      }
	    }
	    stream._backpressure = backpressure;
	  }
	  var WritableStreamDefaultWriter = function () {
	    function WritableStreamDefaultWriter(stream) {
	      _classCallCheck(this, WritableStreamDefaultWriter);
	      if (IsWritableStream(stream) === false) {
	        throw new TypeError('WritableStreamDefaultWriter can only be constructed with a WritableStream instance');
	      }
	      if (IsWritableStreamLocked(stream) === true) {
	        throw new TypeError('This stream has already been locked for exclusive writing by another writer');
	      }
	      this._ownerWritableStream = stream;
	      stream._writer = this;
	      var state = stream._state;
	      if (state === 'writable') {
	        if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._backpressure === true) {
	          defaultWriterReadyPromiseInitialize(this);
	        } else {
	          defaultWriterReadyPromiseInitializeAsResolved(this);
	        }
	        defaultWriterClosedPromiseInitialize(this);
	      } else if (state === 'erroring') {
	        defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError);
	        this._readyPromise.catch(function () {});
	        defaultWriterClosedPromiseInitialize(this);
	      } else if (state === 'closed') {
	        defaultWriterReadyPromiseInitializeAsResolved(this);
	        defaultWriterClosedPromiseInitializeAsResolved(this);
	      } else {
	        assert(state === 'errored', 'state must be errored');
	        var storedError = stream._storedError;
	        defaultWriterReadyPromiseInitializeAsRejected(this, storedError);
	        this._readyPromise.catch(function () {});
	        defaultWriterClosedPromiseInitializeAsRejected(this, storedError);
	        this._closedPromise.catch(function () {});
	      }
	    }
	    _createClass(WritableStreamDefaultWriter, [{
	      key: 'abort',
	      value: function abort(reason) {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('abort'));
	        }
	        if (this._ownerWritableStream === undefined) {
	          return Promise.reject(defaultWriterLockException('abort'));
	        }
	        return WritableStreamDefaultWriterAbort(this, reason);
	      }
	    }, {
	      key: 'close',
	      value: function close() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('close'));
	        }
	        var stream = this._ownerWritableStream;
	        if (stream === undefined) {
	          return Promise.reject(defaultWriterLockException('close'));
	        }
	        if (WritableStreamCloseQueuedOrInFlight(stream) === true) {
	          return Promise.reject(new TypeError('cannot close an already-closing stream'));
	        }
	        return WritableStreamDefaultWriterClose(this);
	      }
	    }, {
	      key: 'releaseLock',
	      value: function releaseLock() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          throw defaultWriterBrandCheckException('releaseLock');
	        }
	        var stream = this._ownerWritableStream;
	        if (stream === undefined) {
	          return;
	        }
	        assert(stream._writer !== undefined);
	        WritableStreamDefaultWriterRelease(this);
	      }
	    }, {
	      key: 'write',
	      value: function write(chunk) {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('write'));
	        }
	        if (this._ownerWritableStream === undefined) {
	          return Promise.reject(defaultWriterLockException('write to'));
	        }
	        return WritableStreamDefaultWriterWrite(this, chunk);
	      }
	    }, {
	      key: 'closed',
	      get: function get() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('closed'));
	        }
	        return this._closedPromise;
	      }
	    }, {
	      key: 'desiredSize',
	      get: function get() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          throw defaultWriterBrandCheckException('desiredSize');
	        }
	        if (this._ownerWritableStream === undefined) {
	          throw defaultWriterLockException('desiredSize');
	        }
	        return WritableStreamDefaultWriterGetDesiredSize(this);
	      }
	    }, {
	      key: 'ready',
	      get: function get() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('ready'));
	        }
	        return this._readyPromise;
	      }
	    }]);
	    return WritableStreamDefaultWriter;
	  }();
	  function IsWritableStreamDefaultWriter(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_ownerWritableStream')) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamDefaultWriterAbort(writer, reason) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    return WritableStreamAbort(stream, reason);
	  }
	  function WritableStreamDefaultWriterClose(writer) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    var state = stream._state;
	    if (state === 'closed' || state === 'errored') {
	      return Promise.reject(new TypeError('The stream (in ' + state + ' state) is not in the writable state and cannot be closed'));
	    }
	    assert(state === 'writable' || state === 'erroring');
	    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
	    var promise = new Promise(function (resolve, reject) {
	      var closeRequest = {
	        _resolve: resolve,
	        _reject: reject
	      };
	      stream._closeRequest = closeRequest;
	    });
	    if (stream._backpressure === true && state === 'writable') {
	      defaultWriterReadyPromiseResolve(writer);
	    }
	    WritableStreamDefaultControllerClose(stream._writableStreamController);
	    return promise;
	  }
	  function WritableStreamDefaultWriterCloseWithErrorPropagation(writer) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    var state = stream._state;
	    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
	      return Promise.resolve();
	    }
	    if (state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    assert(state === 'writable' || state === 'erroring');
	    return WritableStreamDefaultWriterClose(writer);
	  }
	  function WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, error) {
	    if (writer._closedPromiseState === 'pending') {
	      defaultWriterClosedPromiseReject(writer, error);
	    } else {
	      defaultWriterClosedPromiseResetToRejected(writer, error);
	    }
	    writer._closedPromise.catch(function () {});
	  }
	  function WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, error) {
	    if (writer._readyPromiseState === 'pending') {
	      defaultWriterReadyPromiseReject(writer, error);
	    } else {
	      defaultWriterReadyPromiseResetToRejected(writer, error);
	    }
	    writer._readyPromise.catch(function () {});
	  }
	  function WritableStreamDefaultWriterGetDesiredSize(writer) {
	    var stream = writer._ownerWritableStream;
	    var state = stream._state;
	    if (state === 'errored' || state === 'erroring') {
	      return null;
	    }
	    if (state === 'closed') {
	      return 0;
	    }
	    return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController);
	  }
	  function WritableStreamDefaultWriterRelease(writer) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    assert(stream._writer === writer);
	    var releasedError = new TypeError('Writer was released and can no longer be used to monitor the stream\'s closedness');
	    WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError);
	    WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError);
	    stream._writer = undefined;
	    writer._ownerWritableStream = undefined;
	  }
	  function WritableStreamDefaultWriterWrite(writer, chunk) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    var controller = stream._writableStreamController;
	    var chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk);
	    if (stream !== writer._ownerWritableStream) {
	      return Promise.reject(defaultWriterLockException('write to'));
	    }
	    var state = stream._state;
	    if (state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
	      return Promise.reject(new TypeError('The stream is closing or closed and cannot be written to'));
	    }
	    if (state === 'erroring') {
	      return Promise.reject(stream._storedError);
	    }
	    assert(state === 'writable');
	    var promise = WritableStreamAddWriteRequest(stream);
	    WritableStreamDefaultControllerWrite(controller, chunk, chunkSize);
	    return promise;
	  }
	  var WritableStreamDefaultController = function () {
	    function WritableStreamDefaultController(stream, underlyingSink, size, highWaterMark) {
	      _classCallCheck(this, WritableStreamDefaultController);
	      if (IsWritableStream(stream) === false) {
	        throw new TypeError('WritableStreamDefaultController can only be constructed with a WritableStream instance');
	      }
	      if (stream._writableStreamController !== undefined) {
	        throw new TypeError('WritableStreamDefaultController instances can only be created by the WritableStream constructor');
	      }
	      this._controlledWritableStream = stream;
	      this._underlyingSink = underlyingSink;
	      this._queue = undefined;
	      this._queueTotalSize = undefined;
	      ResetQueue(this);
	      this._started = false;
	      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
	      this._strategySize = normalizedStrategy.size;
	      this._strategyHWM = normalizedStrategy.highWaterMark;
	      var backpressure = WritableStreamDefaultControllerGetBackpressure(this);
	      WritableStreamUpdateBackpressure(stream, backpressure);
	    }
	    _createClass(WritableStreamDefaultController, [{
	      key: 'error',
	      value: function error(e) {
	        if (IsWritableStreamDefaultController(this) === false) {
	          throw new TypeError('WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController');
	        }
	        var state = this._controlledWritableStream._state;
	        if (state !== 'writable') {
	          return;
	        }
	        WritableStreamDefaultControllerError(this, e);
	      }
	    }, {
	      key: '__abortSteps',
	      value: function __abortSteps(reason) {
	        return PromiseInvokeOrNoop(this._underlyingSink, 'abort', [reason]);
	      }
	    }, {
	      key: '__errorSteps',
	      value: function __errorSteps() {
	        ResetQueue(this);
	      }
	    }, {
	      key: '__startSteps',
	      value: function __startSteps() {
	        var _this = this;
	        var startResult = InvokeOrNoop(this._underlyingSink, 'start', [this]);
	        var stream = this._controlledWritableStream;
	        Promise.resolve(startResult).then(function () {
	          assert(stream._state === 'writable' || stream._state === 'erroring');
	          _this._started = true;
	          WritableStreamDefaultControllerAdvanceQueueIfNeeded(_this);
	        }, function (r) {
	          assert(stream._state === 'writable' || stream._state === 'erroring');
	          _this._started = true;
	          WritableStreamDealWithRejection(stream, r);
	        }).catch(rethrowAssertionErrorRejection);
	      }
	    }]);
	    return WritableStreamDefaultController;
	  }();
	  function WritableStreamDefaultControllerClose(controller) {
	    EnqueueValueWithSize(controller, 'close', 0);
	    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
	  }
	  function WritableStreamDefaultControllerGetChunkSize(controller, chunk) {
	    var strategySize = controller._strategySize;
	    if (strategySize === undefined) {
	      return 1;
	    }
	    try {
	      return strategySize(chunk);
	    } catch (chunkSizeE) {
	      WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
	      return 1;
	    }
	  }
	  function WritableStreamDefaultControllerGetDesiredSize(controller) {
	    return controller._strategyHWM - controller._queueTotalSize;
	  }
	  function WritableStreamDefaultControllerWrite(controller, chunk, chunkSize) {
	    var writeRecord = { chunk: chunk };
	    try {
	      EnqueueValueWithSize(controller, writeRecord, chunkSize);
	    } catch (enqueueE) {
	      WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
	      return;
	    }
	    var stream = controller._controlledWritableStream;
	    if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._state === 'writable') {
	      var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
	      WritableStreamUpdateBackpressure(stream, backpressure);
	    }
	    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
	  }
	  function IsWritableStreamDefaultController(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSink')) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller) {
	    var stream = controller._controlledWritableStream;
	    if (controller._started === false) {
	      return;
	    }
	    if (stream._inFlightWriteRequest !== undefined) {
	      return;
	    }
	    var state = stream._state;
	    if (state === 'closed' || state === 'errored') {
	      return;
	    }
	    if (state === 'erroring') {
	      WritableStreamFinishErroring(stream);
	      return;
	    }
	    if (controller._queue.length === 0) {
	      return;
	    }
	    var writeRecord = PeekQueueValue(controller);
	    if (writeRecord === 'close') {
	      WritableStreamDefaultControllerProcessClose(controller);
	    } else {
	      WritableStreamDefaultControllerProcessWrite(controller, writeRecord.chunk);
	    }
	  }
	  function WritableStreamDefaultControllerErrorIfNeeded(controller, error) {
	    if (controller._controlledWritableStream._state === 'writable') {
	      WritableStreamDefaultControllerError(controller, error);
	    }
	  }
	  function WritableStreamDefaultControllerProcessClose(controller) {
	    var stream = controller._controlledWritableStream;
	    WritableStreamMarkCloseRequestInFlight(stream);
	    DequeueValue(controller);
	    assert(controller._queue.length === 0, 'queue must be empty once the final write record is dequeued');
	    var sinkClosePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'close', []);
	    sinkClosePromise.then(function () {
	      WritableStreamFinishInFlightClose(stream);
	    }, function (reason) {
	      WritableStreamFinishInFlightCloseWithError(stream, reason);
	    }).catch(rethrowAssertionErrorRejection);
	  }
	  function WritableStreamDefaultControllerProcessWrite(controller, chunk) {
	    var stream = controller._controlledWritableStream;
	    WritableStreamMarkFirstWriteRequestInFlight(stream);
	    var sinkWritePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'write', [chunk, controller]);
	    sinkWritePromise.then(function () {
	      WritableStreamFinishInFlightWrite(stream);
	      var state = stream._state;
	      assert(state === 'writable' || state === 'erroring');
	      DequeueValue(controller);
	      if (WritableStreamCloseQueuedOrInFlight(stream) === false && state === 'writable') {
	        var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
	        WritableStreamUpdateBackpressure(stream, backpressure);
	      }
	      WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
	    }, function (reason) {
	      WritableStreamFinishInFlightWriteWithError(stream, reason);
	    }).catch(rethrowAssertionErrorRejection);
	  }
	  function WritableStreamDefaultControllerGetBackpressure(controller) {
	    var desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller);
	    return desiredSize <= 0;
	  }
	  function WritableStreamDefaultControllerError(controller, error) {
	    var stream = controller._controlledWritableStream;
	    assert(stream._state === 'writable');
	    WritableStreamStartErroring(stream, error);
	  }
	  function streamBrandCheckException(name) {
	    return new TypeError('WritableStream.prototype.' + name + ' can only be used on a WritableStream');
	  }
	  function defaultWriterBrandCheckException(name) {
	    return new TypeError('WritableStreamDefaultWriter.prototype.' + name + ' can only be used on a WritableStreamDefaultWriter');
	  }
	  function defaultWriterLockException(name) {
	    return new TypeError('Cannot ' + name + ' a stream using a released writer');
	  }
	  function defaultWriterClosedPromiseInitialize(writer) {
	    writer._closedPromise = new Promise(function (resolve, reject) {
	      writer._closedPromise_resolve = resolve;
	      writer._closedPromise_reject = reject;
	      writer._closedPromiseState = 'pending';
	    });
	  }
	  function defaultWriterClosedPromiseInitializeAsRejected(writer, reason) {
	    writer._closedPromise = Promise.reject(reason);
	    writer._closedPromise_resolve = undefined;
	    writer._closedPromise_reject = undefined;
	    writer._closedPromiseState = 'rejected';
	  }
	  function defaultWriterClosedPromiseInitializeAsResolved(writer) {
	    writer._closedPromise = Promise.resolve(undefined);
	    writer._closedPromise_resolve = undefined;
	    writer._closedPromise_reject = undefined;
	    writer._closedPromiseState = 'resolved';
	  }
	  function defaultWriterClosedPromiseReject(writer, reason) {
	    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
	    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
	    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
	    writer._closedPromise_reject(reason);
	    writer._closedPromise_resolve = undefined;
	    writer._closedPromise_reject = undefined;
	    writer._closedPromiseState = 'rejected';
	  }
	  function defaultWriterClosedPromiseResetToRejected(writer, reason) {
	    assert(writer._closedPromise_resolve === undefined, 'writer._closedPromise_resolve === undefined');
	    assert(writer._closedPromise_reject === undefined, 'writer._closedPromise_reject === undefined');
	    assert(writer._closedPromiseState !== 'pending', 'writer._closedPromiseState is not pending');
	    writer._closedPromise = Promise.reject(reason);
	    writer._closedPromiseState = 'rejected';
	  }
	  function defaultWriterClosedPromiseResolve(writer) {
	    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
	    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
	    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
	    writer._closedPromise_resolve(undefined);
	    writer._closedPromise_resolve = undefined;
	    writer._closedPromise_reject = undefined;
	    writer._closedPromiseState = 'resolved';
	  }
	  function defaultWriterReadyPromiseInitialize(writer) {
	    writer._readyPromise = new Promise(function (resolve, reject) {
	      writer._readyPromise_resolve = resolve;
	      writer._readyPromise_reject = reject;
	    });
	    writer._readyPromiseState = 'pending';
	  }
	  function defaultWriterReadyPromiseInitializeAsRejected(writer, reason) {
	    writer._readyPromise = Promise.reject(reason);
	    writer._readyPromise_resolve = undefined;
	    writer._readyPromise_reject = undefined;
	    writer._readyPromiseState = 'rejected';
	  }
	  function defaultWriterReadyPromiseInitializeAsResolved(writer) {
	    writer._readyPromise = Promise.resolve(undefined);
	    writer._readyPromise_resolve = undefined;
	    writer._readyPromise_reject = undefined;
	    writer._readyPromiseState = 'fulfilled';
	  }
	  function defaultWriterReadyPromiseReject(writer, reason) {
	    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
	    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
	    writer._readyPromise_reject(reason);
	    writer._readyPromise_resolve = undefined;
	    writer._readyPromise_reject = undefined;
	    writer._readyPromiseState = 'rejected';
	  }
	  function defaultWriterReadyPromiseReset(writer) {
	    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
	    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
	    writer._readyPromise = new Promise(function (resolve, reject) {
	      writer._readyPromise_resolve = resolve;
	      writer._readyPromise_reject = reject;
	    });
	    writer._readyPromiseState = 'pending';
	  }
	  function defaultWriterReadyPromiseResetToRejected(writer, reason) {
	    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
	    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
	    writer._readyPromise = Promise.reject(reason);
	    writer._readyPromiseState = 'rejected';
	  }
	  function defaultWriterReadyPromiseResolve(writer) {
	    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
	    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
	    writer._readyPromise_resolve(undefined);
	    writer._readyPromise_resolve = undefined;
	    writer._readyPromise_reject = undefined;
	    writer._readyPromiseState = 'fulfilled';
	  }
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _require = __w_pdfjs_require__(0),
	      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber;
	  var _require2 = __w_pdfjs_require__(1),
	      assert = _require2.assert;
	  exports.DequeueValue = function (container) {
	    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: DequeueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
	    assert(container._queue.length > 0, 'Spec-level failure: should never dequeue from an empty queue.');
	    var pair = container._queue.shift();
	    container._queueTotalSize -= pair.size;
	    if (container._queueTotalSize < 0) {
	      container._queueTotalSize = 0;
	    }
	    return pair.value;
	  };
	  exports.EnqueueValueWithSize = function (container, value, size) {
	    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: EnqueueValueWithSize should only be used on containers with [[queue]] and ' + '[[queueTotalSize]].');
	    size = Number(size);
	    if (!IsFiniteNonNegativeNumber(size)) {
	      throw new RangeError('Size must be a finite, non-NaN, non-negative number.');
	    }
	    container._queue.push({
	      value: value,
	      size: size
	    });
	    container._queueTotalSize += size;
	  };
	  exports.PeekQueueValue = function (container) {
	    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: PeekQueueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
	    assert(container._queue.length > 0, 'Spec-level failure: should never peek at an empty queue.');
	    var pair = container._queue[0];
	    return pair.value;
	  };
	  exports.ResetQueue = function (container) {
	    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: ResetQueue should only be used on containers with [[queue]] and [[queueTotalSize]].');
	    container._queue = [];
	    container._queueTotalSize = 0;
	  };
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	  var _require = __w_pdfjs_require__(0),
	      ArrayBufferCopy = _require.ArrayBufferCopy,
	      CreateIterResultObject = _require.CreateIterResultObject,
	      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber,
	      InvokeOrNoop = _require.InvokeOrNoop,
	      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
	      TransferArrayBuffer = _require.TransferArrayBuffer,
	      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
	      ValidateAndNormalizeHighWaterMark = _require.ValidateAndNormalizeHighWaterMark;
	  var _require2 = __w_pdfjs_require__(0),
	      createArrayFromList = _require2.createArrayFromList,
	      createDataProperty = _require2.createDataProperty,
	      typeIsObject = _require2.typeIsObject;
	  var _require3 = __w_pdfjs_require__(1),
	      assert = _require3.assert,
	      rethrowAssertionErrorRejection = _require3.rethrowAssertionErrorRejection;
	  var _require4 = __w_pdfjs_require__(3),
	      DequeueValue = _require4.DequeueValue,
	      EnqueueValueWithSize = _require4.EnqueueValueWithSize,
	      ResetQueue = _require4.ResetQueue;
	  var _require5 = __w_pdfjs_require__(2),
	      AcquireWritableStreamDefaultWriter = _require5.AcquireWritableStreamDefaultWriter,
	      IsWritableStream = _require5.IsWritableStream,
	      IsWritableStreamLocked = _require5.IsWritableStreamLocked,
	      WritableStreamAbort = _require5.WritableStreamAbort,
	      WritableStreamDefaultWriterCloseWithErrorPropagation = _require5.WritableStreamDefaultWriterCloseWithErrorPropagation,
	      WritableStreamDefaultWriterRelease = _require5.WritableStreamDefaultWriterRelease,
	      WritableStreamDefaultWriterWrite = _require5.WritableStreamDefaultWriterWrite,
	      WritableStreamCloseQueuedOrInFlight = _require5.WritableStreamCloseQueuedOrInFlight;
	  var ReadableStream = function () {
	    function ReadableStream() {
	      var underlyingSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          size = _ref.size,
	          highWaterMark = _ref.highWaterMark;
	      _classCallCheck(this, ReadableStream);
	      this._state = 'readable';
	      this._reader = undefined;
	      this._storedError = undefined;
	      this._disturbed = false;
	      this._readableStreamController = undefined;
	      var type = underlyingSource.type;
	      var typeString = String(type);
	      if (typeString === 'bytes') {
	        if (highWaterMark === undefined) {
	          highWaterMark = 0;
	        }
	        this._readableStreamController = new ReadableByteStreamController(this, underlyingSource, highWaterMark);
	      } else if (type === undefined) {
	        if (highWaterMark === undefined) {
	          highWaterMark = 1;
	        }
	        this._readableStreamController = new ReadableStreamDefaultController(this, underlyingSource, size, highWaterMark);
	      } else {
	        throw new RangeError('Invalid type is specified');
	      }
	    }
	    _createClass(ReadableStream, [{
	      key: 'cancel',
	      value: function cancel(reason) {
	        if (IsReadableStream(this) === false) {
	          return Promise.reject(streamBrandCheckException('cancel'));
	        }
	        if (IsReadableStreamLocked(this) === true) {
	          return Promise.reject(new TypeError('Cannot cancel a stream that already has a reader'));
	        }
	        return ReadableStreamCancel(this, reason);
	      }
	    }, {
	      key: 'getReader',
	      value: function getReader() {
	        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	            mode = _ref2.mode;
	        if (IsReadableStream(this) === false) {
	          throw streamBrandCheckException('getReader');
	        }
	        if (mode === undefined) {
	          return AcquireReadableStreamDefaultReader(this);
	        }
	        mode = String(mode);
	        if (mode === 'byob') {
	          return AcquireReadableStreamBYOBReader(this);
	        }
	        throw new RangeError('Invalid mode is specified');
	      }
	    }, {
	      key: 'pipeThrough',
	      value: function pipeThrough(_ref3, options) {
	        var writable = _ref3.writable,
	            readable = _ref3.readable;
	        var promise = this.pipeTo(writable, options);
	        ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise);
	        return readable;
	      }
	    }, {
	      key: 'pipeTo',
	      value: function pipeTo(dest) {
	        var _this = this;
	        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	            preventClose = _ref4.preventClose,
	            preventAbort = _ref4.preventAbort,
	            preventCancel = _ref4.preventCancel;
	        if (IsReadableStream(this) === false) {
	          return Promise.reject(streamBrandCheckException('pipeTo'));
	        }
	        if (IsWritableStream(dest) === false) {
	          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo\'s first argument must be a WritableStream'));
	        }
	        preventClose = Boolean(preventClose);
	        preventAbort = Boolean(preventAbort);
	        preventCancel = Boolean(preventCancel);
	        if (IsReadableStreamLocked(this) === true) {
	          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream'));
	        }
	        if (IsWritableStreamLocked(dest) === true) {
	          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream'));
	        }
	        var reader = AcquireReadableStreamDefaultReader(this);
	        var writer = AcquireWritableStreamDefaultWriter(dest);
	        var shuttingDown = false;
	        var currentWrite = Promise.resolve();
	        return new Promise(function (resolve, reject) {
	          function pipeLoop() {
	            currentWrite = Promise.resolve();
	            if (shuttingDown === true) {
	              return Promise.resolve();
	            }
	            return writer._readyPromise.then(function () {
	              return ReadableStreamDefaultReaderRead(reader).then(function (_ref5) {
	                var value = _ref5.value,
	                    done = _ref5.done;
	                if (done === true) {
	                  return;
	                }
	                currentWrite = WritableStreamDefaultWriterWrite(writer, value).catch(function () {});
	              });
	            }).then(pipeLoop);
	          }
	          isOrBecomesErrored(_this, reader._closedPromise, function (storedError) {
	            if (preventAbort === false) {
	              shutdownWithAction(function () {
	                return WritableStreamAbort(dest, storedError);
	              }, true, storedError);
	            } else {
	              shutdown(true, storedError);
	            }
	          });
	          isOrBecomesErrored(dest, writer._closedPromise, function (storedError) {
	            if (preventCancel === false) {
	              shutdownWithAction(function () {
	                return ReadableStreamCancel(_this, storedError);
	              }, true, storedError);
	            } else {
	              shutdown(true, storedError);
	            }
	          });
	          isOrBecomesClosed(_this, reader._closedPromise, function () {
	            if (preventClose === false) {
	              shutdownWithAction(function () {
	                return WritableStreamDefaultWriterCloseWithErrorPropagation(writer);
	              });
	            } else {
	              shutdown();
	            }
	          });
	          if (WritableStreamCloseQueuedOrInFlight(dest) === true || dest._state === 'closed') {
	            var destClosed = new TypeError('the destination writable stream closed before all data could be piped to it');
	            if (preventCancel === false) {
	              shutdownWithAction(function () {
	                return ReadableStreamCancel(_this, destClosed);
	              }, true, destClosed);
	            } else {
	              shutdown(true, destClosed);
	            }
	          }
	          pipeLoop().catch(function (err) {
	            currentWrite = Promise.resolve();
	            rethrowAssertionErrorRejection(err);
	          });
	          function waitForWritesToFinish() {
	            var oldCurrentWrite = currentWrite;
	            return currentWrite.then(function () {
	              return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : undefined;
	            });
	          }
	          function isOrBecomesErrored(stream, promise, action) {
	            if (stream._state === 'errored') {
	              action(stream._storedError);
	            } else {
	              promise.catch(action).catch(rethrowAssertionErrorRejection);
	            }
	          }
	          function isOrBecomesClosed(stream, promise, action) {
	            if (stream._state === 'closed') {
	              action();
	            } else {
	              promise.then(action).catch(rethrowAssertionErrorRejection);
	            }
	          }
	          function shutdownWithAction(action, originalIsError, originalError) {
	            if (shuttingDown === true) {
	              return;
	            }
	            shuttingDown = true;
	            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
	              waitForWritesToFinish().then(doTheRest);
	            } else {
	              doTheRest();
	            }
	            function doTheRest() {
	              action().then(function () {
	                return finalize(originalIsError, originalError);
	              }, function (newError) {
	                return finalize(true, newError);
	              }).catch(rethrowAssertionErrorRejection);
	            }
	          }
	          function shutdown(isError, error) {
	            if (shuttingDown === true) {
	              return;
	            }
	            shuttingDown = true;
	            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
	              waitForWritesToFinish().then(function () {
	                return finalize(isError, error);
	              }).catch(rethrowAssertionErrorRejection);
	            } else {
	              finalize(isError, error);
	            }
	          }
	          function finalize(isError, error) {
	            WritableStreamDefaultWriterRelease(writer);
	            ReadableStreamReaderGenericRelease(reader);
	            if (isError) {
	              reject(error);
	            } else {
	              resolve(undefined);
	            }
	          }
	        });
	      }
	    }, {
	      key: 'tee',
	      value: function tee() {
	        if (IsReadableStream(this) === false) {
	          throw streamBrandCheckException('tee');
	        }
	        var branches = ReadableStreamTee(this, false);
	        return createArrayFromList(branches);
	      }
	    }, {
	      key: 'locked',
	      get: function get() {
	        if (IsReadableStream(this) === false) {
	          throw streamBrandCheckException('locked');
	        }
	        return IsReadableStreamLocked(this);
	      }
	    }]);
	    return ReadableStream;
	  }();
	  module.exports = {
	    ReadableStream: ReadableStream,
	    IsReadableStreamDisturbed: IsReadableStreamDisturbed,
	    ReadableStreamDefaultControllerClose: ReadableStreamDefaultControllerClose,
	    ReadableStreamDefaultControllerEnqueue: ReadableStreamDefaultControllerEnqueue,
	    ReadableStreamDefaultControllerError: ReadableStreamDefaultControllerError,
	    ReadableStreamDefaultControllerGetDesiredSize: ReadableStreamDefaultControllerGetDesiredSize
	  };
	  function AcquireReadableStreamBYOBReader(stream) {
	    return new ReadableStreamBYOBReader(stream);
	  }
	  function AcquireReadableStreamDefaultReader(stream) {
	    return new ReadableStreamDefaultReader(stream);
	  }
	  function IsReadableStream(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_readableStreamController')) {
	      return false;
	    }
	    return true;
	  }
	  function IsReadableStreamDisturbed(stream) {
	    assert(IsReadableStream(stream) === true, 'IsReadableStreamDisturbed should only be used on known readable streams');
	    return stream._disturbed;
	  }
	  function IsReadableStreamLocked(stream) {
	    assert(IsReadableStream(stream) === true, 'IsReadableStreamLocked should only be used on known readable streams');
	    if (stream._reader === undefined) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableStreamTee(stream, cloneForBranch2) {
	    assert(IsReadableStream(stream) === true);
	    assert(typeof cloneForBranch2 === 'boolean');
	    var reader = AcquireReadableStreamDefaultReader(stream);
	    var teeState = {
	      closedOrErrored: false,
	      canceled1: false,
	      canceled2: false,
	      reason1: undefined,
	      reason2: undefined
	    };
	    teeState.promise = new Promise(function (resolve) {
	      teeState._resolve = resolve;
	    });
	    var pull = create_ReadableStreamTeePullFunction();
	    pull._reader = reader;
	    pull._teeState = teeState;
	    pull._cloneForBranch2 = cloneForBranch2;
	    var cancel1 = create_ReadableStreamTeeBranch1CancelFunction();
	    cancel1._stream = stream;
	    cancel1._teeState = teeState;
	    var cancel2 = create_ReadableStreamTeeBranch2CancelFunction();
	    cancel2._stream = stream;
	    cancel2._teeState = teeState;
	    var underlyingSource1 = Object.create(Object.prototype);
	    createDataProperty(underlyingSource1, 'pull', pull);
	    createDataProperty(underlyingSource1, 'cancel', cancel1);
	    var branch1Stream = new ReadableStream(underlyingSource1);
	    var underlyingSource2 = Object.create(Object.prototype);
	    createDataProperty(underlyingSource2, 'pull', pull);
	    createDataProperty(underlyingSource2, 'cancel', cancel2);
	    var branch2Stream = new ReadableStream(underlyingSource2);
	    pull._branch1 = branch1Stream._readableStreamController;
	    pull._branch2 = branch2Stream._readableStreamController;
	    reader._closedPromise.catch(function (r) {
	      if (teeState.closedOrErrored === true) {
	        return;
	      }
	      ReadableStreamDefaultControllerError(pull._branch1, r);
	      ReadableStreamDefaultControllerError(pull._branch2, r);
	      teeState.closedOrErrored = true;
	    });
	    return [branch1Stream, branch2Stream];
	  }
	  function create_ReadableStreamTeePullFunction() {
	    function f() {
	      var reader = f._reader,
	          branch1 = f._branch1,
	          branch2 = f._branch2,
	          teeState = f._teeState;
	      return ReadableStreamDefaultReaderRead(reader).then(function (result) {
	        assert(typeIsObject(result));
	        var value = result.value;
	        var done = result.done;
	        assert(typeof done === 'boolean');
	        if (done === true && teeState.closedOrErrored === false) {
	          if (teeState.canceled1 === false) {
	            ReadableStreamDefaultControllerClose(branch1);
	          }
	          if (teeState.canceled2 === false) {
	            ReadableStreamDefaultControllerClose(branch2);
	          }
	          teeState.closedOrErrored = true;
	        }
	        if (teeState.closedOrErrored === true) {
	          return;
	        }
	        var value1 = value;
	        var value2 = value;
	        if (teeState.canceled1 === false) {
	          ReadableStreamDefaultControllerEnqueue(branch1, value1);
	        }
	        if (teeState.canceled2 === false) {
	          ReadableStreamDefaultControllerEnqueue(branch2, value2);
	        }
	      });
	    }
	    return f;
	  }
	  function create_ReadableStreamTeeBranch1CancelFunction() {
	    function f(reason) {
	      var stream = f._stream,
	          teeState = f._teeState;
	      teeState.canceled1 = true;
	      teeState.reason1 = reason;
	      if (teeState.canceled2 === true) {
	        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
	        var cancelResult = ReadableStreamCancel(stream, compositeReason);
	        teeState._resolve(cancelResult);
	      }
	      return teeState.promise;
	    }
	    return f;
	  }
	  function create_ReadableStreamTeeBranch2CancelFunction() {
	    function f(reason) {
	      var stream = f._stream,
	          teeState = f._teeState;
	      teeState.canceled2 = true;
	      teeState.reason2 = reason;
	      if (teeState.canceled1 === true) {
	        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
	        var cancelResult = ReadableStreamCancel(stream, compositeReason);
	        teeState._resolve(cancelResult);
	      }
	      return teeState.promise;
	    }
	    return f;
	  }
	  function ReadableStreamAddReadIntoRequest(stream) {
	    assert(IsReadableStreamBYOBReader(stream._reader) === true);
	    assert(stream._state === 'readable' || stream._state === 'closed');
	    var promise = new Promise(function (resolve, reject) {
	      var readIntoRequest = {
	        _resolve: resolve,
	        _reject: reject
	      };
	      stream._reader._readIntoRequests.push(readIntoRequest);
	    });
	    return promise;
	  }
	  function ReadableStreamAddReadRequest(stream) {
	    assert(IsReadableStreamDefaultReader(stream._reader) === true);
	    assert(stream._state === 'readable');
	    var promise = new Promise(function (resolve, reject) {
	      var readRequest = {
	        _resolve: resolve,
	        _reject: reject
	      };
	      stream._reader._readRequests.push(readRequest);
	    });
	    return promise;
	  }
	  function ReadableStreamCancel(stream, reason) {
	    stream._disturbed = true;
	    if (stream._state === 'closed') {
	      return Promise.resolve(undefined);
	    }
	    if (stream._state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    ReadableStreamClose(stream);
	    var sourceCancelPromise = stream._readableStreamController.__cancelSteps(reason);
	    return sourceCancelPromise.then(function () {
	      return undefined;
	    });
	  }
	  function ReadableStreamClose(stream) {
	    assert(stream._state === 'readable');
	    stream._state = 'closed';
	    var reader = stream._reader;
	    if (reader === undefined) {
	      return undefined;
	    }
	    if (IsReadableStreamDefaultReader(reader) === true) {
	      for (var i = 0; i < reader._readRequests.length; i++) {
	        var _resolve = reader._readRequests[i]._resolve;
	        _resolve(CreateIterResultObject(undefined, true));
	      }
	      reader._readRequests = [];
	    }
	    defaultReaderClosedPromiseResolve(reader);
	    return undefined;
	  }
	  function ReadableStreamError(stream, e) {
	    assert(IsReadableStream(stream) === true, 'stream must be ReadableStream');
	    assert(stream._state === 'readable', 'state must be readable');
	    stream._state = 'errored';
	    stream._storedError = e;
	    var reader = stream._reader;
	    if (reader === undefined) {
	      return undefined;
	    }
	    if (IsReadableStreamDefaultReader(reader) === true) {
	      for (var i = 0; i < reader._readRequests.length; i++) {
	        var readRequest = reader._readRequests[i];
	        readRequest._reject(e);
	      }
	      reader._readRequests = [];
	    } else {
	      assert(IsReadableStreamBYOBReader(reader), 'reader must be ReadableStreamBYOBReader');
	      for (var _i = 0; _i < reader._readIntoRequests.length; _i++) {
	        var readIntoRequest = reader._readIntoRequests[_i];
	        readIntoRequest._reject(e);
	      }
	      reader._readIntoRequests = [];
	    }
	    defaultReaderClosedPromiseReject(reader, e);
	    reader._closedPromise.catch(function () {});
	  }
	  function ReadableStreamFulfillReadIntoRequest(stream, chunk, done) {
	    var reader = stream._reader;
	    assert(reader._readIntoRequests.length > 0);
	    var readIntoRequest = reader._readIntoRequests.shift();
	    readIntoRequest._resolve(CreateIterResultObject(chunk, done));
	  }
	  function ReadableStreamFulfillReadRequest(stream, chunk, done) {
	    var reader = stream._reader;
	    assert(reader._readRequests.length > 0);
	    var readRequest = reader._readRequests.shift();
	    readRequest._resolve(CreateIterResultObject(chunk, done));
	  }
	  function ReadableStreamGetNumReadIntoRequests(stream) {
	    return stream._reader._readIntoRequests.length;
	  }
	  function ReadableStreamGetNumReadRequests(stream) {
	    return stream._reader._readRequests.length;
	  }
	  function ReadableStreamHasBYOBReader(stream) {
	    var reader = stream._reader;
	    if (reader === undefined) {
	      return false;
	    }
	    if (IsReadableStreamBYOBReader(reader) === false) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableStreamHasDefaultReader(stream) {
	    var reader = stream._reader;
	    if (reader === undefined) {
	      return false;
	    }
	    if (IsReadableStreamDefaultReader(reader) === false) {
	      return false;
	    }
	    return true;
	  }
	  var ReadableStreamDefaultReader = function () {
	    function ReadableStreamDefaultReader(stream) {
	      _classCallCheck(this, ReadableStreamDefaultReader);
	      if (IsReadableStream(stream) === false) {
	        throw new TypeError('ReadableStreamDefaultReader can only be constructed with a ReadableStream instance');
	      }
	      if (IsReadableStreamLocked(stream) === true) {
	        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
	      }
	      ReadableStreamReaderGenericInitialize(this, stream);
	      this._readRequests = [];
	    }
	    _createClass(ReadableStreamDefaultReader, [{
	      key: 'cancel',
	      value: function cancel(reason) {
	        if (IsReadableStreamDefaultReader(this) === false) {
	          return Promise.reject(defaultReaderBrandCheckException('cancel'));
	        }
	        if (this._ownerReadableStream === undefined) {
	          return Promise.reject(readerLockException('cancel'));
	        }
	        return ReadableStreamReaderGenericCancel(this, reason);
	      }
	    }, {
	      key: 'read',
	      value: function read() {
	        if (IsReadableStreamDefaultReader(this) === false) {
	          return Promise.reject(defaultReaderBrandCheckException('read'));
	        }
	        if (this._ownerReadableStream === undefined) {
	          return Promise.reject(readerLockException('read from'));
	        }
	        return ReadableStreamDefaultReaderRead(this);
	      }
	    }, {
	      key: 'releaseLock',
	      value: function releaseLock() {
	        if (IsReadableStreamDefaultReader(this) === false) {
	          throw defaultReaderBrandCheckException('releaseLock');
	        }
	        if (this._ownerReadableStream === undefined) {
	          return;
	        }
	        if (this._readRequests.length > 0) {
	          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
	        }
	        ReadableStreamReaderGenericRelease(this);
	      }
	    }, {
	      key: 'closed',
	      get: function get() {
	        if (IsReadableStreamDefaultReader(this) === false) {
	          return Promise.reject(defaultReaderBrandCheckException('closed'));
	        }
	        return this._closedPromise;
	      }
	    }]);
	    return ReadableStreamDefaultReader;
	  }();
	  var ReadableStreamBYOBReader = function () {
	    function ReadableStreamBYOBReader(stream) {
	      _classCallCheck(this, ReadableStreamBYOBReader);
	      if (!IsReadableStream(stream)) {
	        throw new TypeError('ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a ' + 'byte source');
	      }
	      if (IsReadableByteStreamController(stream._readableStreamController) === false) {
	        throw new TypeError('Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte ' + 'source');
	      }
	      if (IsReadableStreamLocked(stream)) {
	        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
	      }
	      ReadableStreamReaderGenericInitialize(this, stream);
	      this._readIntoRequests = [];
	    }
	    _createClass(ReadableStreamBYOBReader, [{
	      key: 'cancel',
	      value: function cancel(reason) {
	        if (!IsReadableStreamBYOBReader(this)) {
	          return Promise.reject(byobReaderBrandCheckException('cancel'));
	        }
	        if (this._ownerReadableStream === undefined) {
	          return Promise.reject(readerLockException('cancel'));
	        }
	        return ReadableStreamReaderGenericCancel(this, reason);
	      }
	    }, {
	      key: 'read',
	      value: function read(view) {
	        if (!IsReadableStreamBYOBReader(this)) {
	          return Promise.reject(byobReaderBrandCheckException('read'));
	        }
	        if (this._ownerReadableStream === undefined) {
	          return Promise.reject(readerLockException('read from'));
	        }
	        if (!ArrayBuffer.isView(view)) {
	          return Promise.reject(new TypeError('view must be an array buffer view'));
	        }
	        if (view.byteLength === 0) {
	          return Promise.reject(new TypeError('view must have non-zero byteLength'));
	        }
	        return ReadableStreamBYOBReaderRead(this, view);
	      }
	    }, {
	      key: 'releaseLock',
	      value: function releaseLock() {
	        if (!IsReadableStreamBYOBReader(this)) {
	          throw byobReaderBrandCheckException('releaseLock');
	        }
	        if (this._ownerReadableStream === undefined) {
	          return;
	        }
	        if (this._readIntoRequests.length > 0) {
	          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
	        }
	        ReadableStreamReaderGenericRelease(this);
	      }
	    }, {
	      key: 'closed',
	      get: function get() {
	        if (!IsReadableStreamBYOBReader(this)) {
	          return Promise.reject(byobReaderBrandCheckException('closed'));
	        }
	        return this._closedPromise;
	      }
	    }]);
	    return ReadableStreamBYOBReader;
	  }();
	  function IsReadableStreamBYOBReader(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_readIntoRequests')) {
	      return false;
	    }
	    return true;
	  }
	  function IsReadableStreamDefaultReader(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_readRequests')) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableStreamReaderGenericInitialize(reader, stream) {
	    reader._ownerReadableStream = stream;
	    stream._reader = reader;
	    if (stream._state === 'readable') {
	      defaultReaderClosedPromiseInitialize(reader);
	    } else if (stream._state === 'closed') {
	      defaultReaderClosedPromiseInitializeAsResolved(reader);
	    } else {
	      assert(stream._state === 'errored', 'state must be errored');
	      defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError);
	      reader._closedPromise.catch(function () {});
	    }
	  }
	  function ReadableStreamReaderGenericCancel(reader, reason) {
	    var stream = reader._ownerReadableStream;
	    assert(stream !== undefined);
	    return ReadableStreamCancel(stream, reason);
	  }
	  function ReadableStreamReaderGenericRelease(reader) {
	    assert(reader._ownerReadableStream !== undefined);
	    assert(reader._ownerReadableStream._reader === reader);
	    if (reader._ownerReadableStream._state === 'readable') {
	      defaultReaderClosedPromiseReject(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
	    } else {
	      defaultReaderClosedPromiseResetToRejected(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
	    }
	    reader._closedPromise.catch(function () {});
	    reader._ownerReadableStream._reader = undefined;
	    reader._ownerReadableStream = undefined;
	  }
	  function ReadableStreamBYOBReaderRead(reader, view) {
	    var stream = reader._ownerReadableStream;
	    assert(stream !== undefined);
	    stream._disturbed = true;
	    if (stream._state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    return ReadableByteStreamControllerPullInto(stream._readableStreamController, view);
	  }
	  function ReadableStreamDefaultReaderRead(reader) {
	    var stream = reader._ownerReadableStream;
	    assert(stream !== undefined);
	    stream._disturbed = true;
	    if (stream._state === 'closed') {
	      return Promise.resolve(CreateIterResultObject(undefined, true));
	    }
	    if (stream._state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    assert(stream._state === 'readable');
	    return stream._readableStreamController.__pullSteps();
	  }
	  var ReadableStreamDefaultController = function () {
	    function ReadableStreamDefaultController(stream, underlyingSource, size, highWaterMark) {
	      _classCallCheck(this, ReadableStreamDefaultController);
	      if (IsReadableStream(stream) === false) {
	        throw new TypeError('ReadableStreamDefaultController can only be constructed with a ReadableStream instance');
	      }
	      if (stream._readableStreamController !== undefined) {
	        throw new TypeError('ReadableStreamDefaultController instances can only be created by the ReadableStream constructor');
	      }
	      this._controlledReadableStream = stream;
	      this._underlyingSource = underlyingSource;
	      this._queue = undefined;
	      this._queueTotalSize = undefined;
	      ResetQueue(this);
	      this._started = false;
	      this._closeRequested = false;
	      this._pullAgain = false;
	      this._pulling = false;
	      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
	      this._strategySize = normalizedStrategy.size;
	      this._strategyHWM = normalizedStrategy.highWaterMark;
	      var controller = this;
	      var startResult = InvokeOrNoop(underlyingSource, 'start', [this]);
	      Promise.resolve(startResult).then(function () {
	        controller._started = true;
	        assert(controller._pulling === false);
	        assert(controller._pullAgain === false);
	        ReadableStreamDefaultControllerCallPullIfNeeded(controller);
	      }, function (r) {
	        ReadableStreamDefaultControllerErrorIfNeeded(controller, r);
	      }).catch(rethrowAssertionErrorRejection);
	    }
	    _createClass(ReadableStreamDefaultController, [{
	      key: 'close',
	      value: function close() {
	        if (IsReadableStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('close');
	        }
	        if (this._closeRequested === true) {
	          throw new TypeError('The stream has already been closed; do not close it again!');
	        }
	        var state = this._controlledReadableStream._state;
	        if (state !== 'readable') {
	          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
	        }
	        ReadableStreamDefaultControllerClose(this);
	      }
	    }, {
	      key: 'enqueue',
	      value: function enqueue(chunk) {
	        if (IsReadableStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('enqueue');
	        }
	        if (this._closeRequested === true) {
	          throw new TypeError('stream is closed or draining');
	        }
	        var state = this._controlledReadableStream._state;
	        if (state !== 'readable') {
	          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
	        }
	        return ReadableStreamDefaultControllerEnqueue(this, chunk);
	      }
	    }, {
	      key: 'error',
	      value: function error(e) {
	        if (IsReadableStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('error');
	        }
	        var stream = this._controlledReadableStream;
	        if (stream._state !== 'readable') {
	          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
	        }
	        ReadableStreamDefaultControllerError(this, e);
	      }
	    }, {
	      key: '__cancelSteps',
	      value: function __cancelSteps(reason) {
	        ResetQueue(this);
	        return PromiseInvokeOrNoop(this._underlyingSource, 'cancel', [reason]);
	      }
	    }, {
	      key: '__pullSteps',
	      value: function __pullSteps() {
	        var stream = this._controlledReadableStream;
	        if (this._queue.length > 0) {
	          var chunk = DequeueValue(this);
	          if (this._closeRequested === true && this._queue.length === 0) {
	            ReadableStreamClose(stream);
	          } else {
	            ReadableStreamDefaultControllerCallPullIfNeeded(this);
	          }
	          return Promise.resolve(CreateIterResultObject(chunk, false));
	        }
	        var pendingPromise = ReadableStreamAddReadRequest(stream);
	        ReadableStreamDefaultControllerCallPullIfNeeded(this);
	        return pendingPromise;
	      }
	    }, {
	      key: 'desiredSize',
	      get: function get() {
	        if (IsReadableStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('desiredSize');
	        }
	        return ReadableStreamDefaultControllerGetDesiredSize(this);
	      }
	    }]);
	    return ReadableStreamDefaultController;
	  }();
	  function IsReadableStreamDefaultController(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSource')) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableStreamDefaultControllerCallPullIfNeeded(controller) {
	    var shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller);
	    if (shouldPull === false) {
	      return undefined;
	    }
	    if (controller._pulling === true) {
	      controller._pullAgain = true;
	      return undefined;
	    }
	    assert(controller._pullAgain === false);
	    controller._pulling = true;
	    var pullPromise = PromiseInvokeOrNoop(controller._underlyingSource, 'pull', [controller]);
	    pullPromise.then(function () {
	      controller._pulling = false;
	      if (controller._pullAgain === true) {
	        controller._pullAgain = false;
	        return ReadableStreamDefaultControllerCallPullIfNeeded(controller);
	      }
	      return undefined;
	    }, function (e) {
	      ReadableStreamDefaultControllerErrorIfNeeded(controller, e);
	    }).catch(rethrowAssertionErrorRejection);
	    return undefined;
	  }
	  function ReadableStreamDefaultControllerShouldCallPull(controller) {
	    var stream = controller._controlledReadableStream;
	    if (stream._state === 'closed' || stream._state === 'errored') {
	      return false;
	    }
	    if (controller._closeRequested === true) {
	      return false;
	    }
	    if (controller._started === false) {
	      return false;
	    }
	    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
	      return true;
	    }
	    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
	    if (desiredSize > 0) {
	      return true;
	    }
	    return false;
	  }
	  function ReadableStreamDefaultControllerClose(controller) {
	    var stream = controller._controlledReadableStream;
	    assert(controller._closeRequested === false);
	    assert(stream._state === 'readable');
	    controller._closeRequested = true;
	    if (controller._queue.length === 0) {
	      ReadableStreamClose(stream);
	    }
	  }
	  function ReadableStreamDefaultControllerEnqueue(controller, chunk) {
	    var stream = controller._controlledReadableStream;
	    assert(controller._closeRequested === false);
	    assert(stream._state === 'readable');
	    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
	      ReadableStreamFulfillReadRequest(stream, chunk, false);
	    } else {
	      var chunkSize = 1;
	      if (controller._strategySize !== undefined) {
	        var strategySize = controller._strategySize;
	        try {
	          chunkSize = strategySize(chunk);
	        } catch (chunkSizeE) {
	          ReadableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
	          throw chunkSizeE;
	        }
	      }
	      try {
	        EnqueueValueWithSize(controller, chunk, chunkSize);
	      } catch (enqueueE) {
	        ReadableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
	        throw enqueueE;
	      }
	    }
	    ReadableStreamDefaultControllerCallPullIfNeeded(controller);
	    return undefined;
	  }
	  function ReadableStreamDefaultControllerError(controller, e) {
	    var stream = controller._controlledReadableStream;
	    assert(stream._state === 'readable');
	    ResetQueue(controller);
	    ReadableStreamError(stream, e);
	  }
	  function ReadableStreamDefaultControllerErrorIfNeeded(controller, e) {
	    if (controller._controlledReadableStream._state === 'readable') {
	      ReadableStreamDefaultControllerError(controller, e);
	    }
	  }
	  function ReadableStreamDefaultControllerGetDesiredSize(controller) {
	    var stream = controller._controlledReadableStream;
	    var state = stream._state;
	    if (state === 'errored') {
	      return null;
	    }
	    if (state === 'closed') {
	      return 0;
	    }
	    return controller._strategyHWM - controller._queueTotalSize;
	  }
	  var ReadableStreamBYOBRequest = function () {
	    function ReadableStreamBYOBRequest(controller, view) {
	      _classCallCheck(this, ReadableStreamBYOBRequest);
	      this._associatedReadableByteStreamController = controller;
	      this._view = view;
	    }
	    _createClass(ReadableStreamBYOBRequest, [{
	      key: 'respond',
	      value: function respond(bytesWritten) {
	        if (IsReadableStreamBYOBRequest(this) === false) {
	          throw byobRequestBrandCheckException('respond');
	        }
	        if (this._associatedReadableByteStreamController === undefined) {
	          throw new TypeError('This BYOB request has been invalidated');
	        }
	        ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten);
	      }
	    }, {
	      key: 'respondWithNewView',
	      value: function respondWithNewView(view) {
	        if (IsReadableStreamBYOBRequest(this) === false) {
	          throw byobRequestBrandCheckException('respond');
	        }
	        if (this._associatedReadableByteStreamController === undefined) {
	          throw new TypeError('This BYOB request has been invalidated');
	        }
	        if (!ArrayBuffer.isView(view)) {
	          throw new TypeError('You can only respond with array buffer views');
	        }
	        ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view);
	      }
	    }, {
	      key: 'view',
	      get: function get() {
	        return this._view;
	      }
	    }]);
	    return ReadableStreamBYOBRequest;
	  }();
	  var ReadableByteStreamController = function () {
	    function ReadableByteStreamController(stream, underlyingByteSource, highWaterMark) {
	      _classCallCheck(this, ReadableByteStreamController);
	      if (IsReadableStream(stream) === false) {
	        throw new TypeError('ReadableByteStreamController can only be constructed with a ReadableStream instance given ' + 'a byte source');
	      }
	      if (stream._readableStreamController !== undefined) {
	        throw new TypeError('ReadableByteStreamController instances can only be created by the ReadableStream constructor given a byte ' + 'source');
	      }
	      this._controlledReadableStream = stream;
	      this._underlyingByteSource = underlyingByteSource;
	      this._pullAgain = false;
	      this._pulling = false;
	      ReadableByteStreamControllerClearPendingPullIntos(this);
	      this._queue = this._queueTotalSize = undefined;
	      ResetQueue(this);
	      this._closeRequested = false;
	      this._started = false;
	      this._strategyHWM = ValidateAndNormalizeHighWaterMark(highWaterMark);
	      var autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize;
	      if (autoAllocateChunkSize !== undefined) {
	        if (Number.isInteger(autoAllocateChunkSize) === false || autoAllocateChunkSize <= 0) {
	          throw new RangeError('autoAllocateChunkSize must be a positive integer');
	        }
	      }
	      this._autoAllocateChunkSize = autoAllocateChunkSize;
	      this._pendingPullIntos = [];
	      var controller = this;
	      var startResult = InvokeOrNoop(underlyingByteSource, 'start', [this]);
	      Promise.resolve(startResult).then(function () {
	        controller._started = true;
	        assert(controller._pulling === false);
	        assert(controller._pullAgain === false);
	        ReadableByteStreamControllerCallPullIfNeeded(controller);
	      }, function (r) {
	        if (stream._state === 'readable') {
	          ReadableByteStreamControllerError(controller, r);
	        }
	      }).catch(rethrowAssertionErrorRejection);
	    }
	    _createClass(ReadableByteStreamController, [{
	      key: 'close',
	      value: function close() {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('close');
	        }
	        if (this._closeRequested === true) {
	          throw new TypeError('The stream has already been closed; do not close it again!');
	        }
	        var state = this._controlledReadableStream._state;
	        if (state !== 'readable') {
	          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
	        }
	        ReadableByteStreamControllerClose(this);
	      }
	    }, {
	      key: 'enqueue',
	      value: function enqueue(chunk) {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('enqueue');
	        }
	        if (this._closeRequested === true) {
	          throw new TypeError('stream is closed or draining');
	        }
	        var state = this._controlledReadableStream._state;
	        if (state !== 'readable') {
	          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
	        }
	        if (!ArrayBuffer.isView(chunk)) {
	          throw new TypeError('You can only enqueue array buffer views when using a ReadableByteStreamController');
	        }
	        ReadableByteStreamControllerEnqueue(this, chunk);
	      }
	    }, {
	      key: 'error',
	      value: function error(e) {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('error');
	        }
	        var stream = this._controlledReadableStream;
	        if (stream._state !== 'readable') {
	          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
	        }
	        ReadableByteStreamControllerError(this, e);
	      }
	    }, {
	      key: '__cancelSteps',
	      value: function __cancelSteps(reason) {
	        if (this._pendingPullIntos.length > 0) {
	          var firstDescriptor = this._pendingPullIntos[0];
	          firstDescriptor.bytesFilled = 0;
	        }
	        ResetQueue(this);
	        return PromiseInvokeOrNoop(this._underlyingByteSource, 'cancel', [reason]);
	      }
	    }, {
	      key: '__pullSteps',
	      value: function __pullSteps() {
	        var stream = this._controlledReadableStream;
	        assert(ReadableStreamHasDefaultReader(stream) === true);
	        if (this._queueTotalSize > 0) {
	          assert(ReadableStreamGetNumReadRequests(stream) === 0);
	          var entry = this._queue.shift();
	          this._queueTotalSize -= entry.byteLength;
	          ReadableByteStreamControllerHandleQueueDrain(this);
	          var view = void 0;
	          try {
	            view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength);
	          } catch (viewE) {
	            return Promise.reject(viewE);
	          }
	          return Promise.resolve(CreateIterResultObject(view, false));
	        }
	        var autoAllocateChunkSize = this._autoAllocateChunkSize;
	        if (autoAllocateChunkSize !== undefined) {
	          var buffer = void 0;
	          try {
	            buffer = new ArrayBuffer(autoAllocateChunkSize);
	          } catch (bufferE) {
	            return Promise.reject(bufferE);
	          }
	          var pullIntoDescriptor = {
	            buffer: buffer,
	            byteOffset: 0,
	            byteLength: autoAllocateChunkSize,
	            bytesFilled: 0,
	            elementSize: 1,
	            ctor: Uint8Array,
	            readerType: 'default'
	          };
	          this._pendingPullIntos.push(pullIntoDescriptor);
	        }
	        var promise = ReadableStreamAddReadRequest(stream);
	        ReadableByteStreamControllerCallPullIfNeeded(this);
	        return promise;
	      }
	    }, {
	      key: 'byobRequest',
	      get: function get() {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('byobRequest');
	        }
	        if (this._byobRequest === undefined && this._pendingPullIntos.length > 0) {
	          var firstDescriptor = this._pendingPullIntos[0];
	          var view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled);
	          this._byobRequest = new ReadableStreamBYOBRequest(this, view);
	        }
	        return this._byobRequest;
	      }
	    }, {
	      key: 'desiredSize',
	      get: function get() {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('desiredSize');
	        }
	        return ReadableByteStreamControllerGetDesiredSize(this);
	      }
	    }]);
	    return ReadableByteStreamController;
	  }();
	  function IsReadableByteStreamController(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingByteSource')) {
	      return false;
	    }
	    return true;
	  }
	  function IsReadableStreamBYOBRequest(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_associatedReadableByteStreamController')) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableByteStreamControllerCallPullIfNeeded(controller) {
	    var shouldPull = ReadableByteStreamControllerShouldCallPull(controller);
	    if (shouldPull === false) {
	      return undefined;
	    }
	    if (controller._pulling === true) {
	      controller._pullAgain = true;
	      return undefined;
	    }
	    assert(controller._pullAgain === false);
	    controller._pulling = true;
	    var pullPromise = PromiseInvokeOrNoop(controller._underlyingByteSource, 'pull', [controller]);
	    pullPromise.then(function () {
	      controller._pulling = false;
	      if (controller._pullAgain === true) {
	        controller._pullAgain = false;
	        ReadableByteStreamControllerCallPullIfNeeded(controller);
	      }
	    }, function (e) {
	      if (controller._controlledReadableStream._state === 'readable') {
	        ReadableByteStreamControllerError(controller, e);
	      }
	    }).catch(rethrowAssertionErrorRejection);
	    return undefined;
	  }
	  function ReadableByteStreamControllerClearPendingPullIntos(controller) {
	    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
	    controller._pendingPullIntos = [];
	  }
	  function ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor) {
	    assert(stream._state !== 'errored', 'state must not be errored');
	    var done = false;
	    if (stream._state === 'closed') {
	      assert(pullIntoDescriptor.bytesFilled === 0);
	      done = true;
	    }
	    var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
	    if (pullIntoDescriptor.readerType === 'default') {
	      ReadableStreamFulfillReadRequest(stream, filledView, done);
	    } else {
	      assert(pullIntoDescriptor.readerType === 'byob');
	      ReadableStreamFulfillReadIntoRequest(stream, filledView, done);
	    }
	  }
	  function ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor) {
	    var bytesFilled = pullIntoDescriptor.bytesFilled;
	    var elementSize = pullIntoDescriptor.elementSize;
	    assert(bytesFilled <= pullIntoDescriptor.byteLength);
	    assert(bytesFilled % elementSize === 0);
	    return new pullIntoDescriptor.ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize);
	  }
	  function ReadableByteStreamControllerEnqueueChunkToQueue(controller, buffer, byteOffset, byteLength) {
	    controller._queue.push({
	      buffer: buffer,
	      byteOffset: byteOffset,
	      byteLength: byteLength
	    });
	    controller._queueTotalSize += byteLength;
	  }
	  function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) {
	    var elementSize = pullIntoDescriptor.elementSize;
	    var currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize;
	    var maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled);
	    var maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy;
	    var maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize;
	    var totalBytesToCopyRemaining = maxBytesToCopy;
	    var ready = false;
	    if (maxAlignedBytes > currentAlignedBytes) {
	      totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled;
	      ready = true;
	    }
	    var queue = controller._queue;
	    while (totalBytesToCopyRemaining > 0) {
	      var headOfQueue = queue[0];
	      var bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength);
	      var destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
	      ArrayBufferCopy(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy);
	      if (headOfQueue.byteLength === bytesToCopy) {
	        queue.shift();
	      } else {
	        headOfQueue.byteOffset += bytesToCopy;
	        headOfQueue.byteLength -= bytesToCopy;
	      }
	      controller._queueTotalSize -= bytesToCopy;
	      ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor);
	      totalBytesToCopyRemaining -= bytesToCopy;
	    }
	    if (ready === false) {
	      assert(controller._queueTotalSize === 0, 'queue must be empty');
	      assert(pullIntoDescriptor.bytesFilled > 0);
	      assert(pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize);
	    }
	    return ready;
	  }
	  function ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, size, pullIntoDescriptor) {
	    assert(controller._pendingPullIntos.length === 0 || controller._pendingPullIntos[0] === pullIntoDescriptor);
	    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
	    pullIntoDescriptor.bytesFilled += size;
	  }
	  function ReadableByteStreamControllerHandleQueueDrain(controller) {
	    assert(controller._controlledReadableStream._state === 'readable');
	    if (controller._queueTotalSize === 0 && controller._closeRequested === true) {
	      ReadableStreamClose(controller._controlledReadableStream);
	    } else {
	      ReadableByteStreamControllerCallPullIfNeeded(controller);
	    }
	  }
	  function ReadableByteStreamControllerInvalidateBYOBRequest(controller) {
	    if (controller._byobRequest === undefined) {
	      return;
	    }
	    controller._byobRequest._associatedReadableByteStreamController = undefined;
	    controller._byobRequest._view = undefined;
	    controller._byobRequest = undefined;
	  }
	  function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller) {
	    assert(controller._closeRequested === false);
	    while (controller._pendingPullIntos.length > 0) {
	      if (controller._queueTotalSize === 0) {
	        return;
	      }
	      var pullIntoDescriptor = controller._pendingPullIntos[0];
	      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
	        ReadableByteStreamControllerShiftPendingPullInto(controller);
	        ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
	      }
	    }
	  }
	  function ReadableByteStreamControllerPullInto(controller, view) {
	    var stream = controller._controlledReadableStream;
	    var elementSize = 1;
	    if (view.constructor !== DataView) {
	      elementSize = view.constructor.BYTES_PER_ELEMENT;
	    }
	    var ctor = view.constructor;
	    var pullIntoDescriptor = {
	      buffer: view.buffer,
	      byteOffset: view.byteOffset,
	      byteLength: view.byteLength,
	      bytesFilled: 0,
	      elementSize: elementSize,
	      ctor: ctor,
	      readerType: 'byob'
	    };
	    if (controller._pendingPullIntos.length > 0) {
	      pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
	      controller._pendingPullIntos.push(pullIntoDescriptor);
	      return ReadableStreamAddReadIntoRequest(stream);
	    }
	    if (stream._state === 'closed') {
	      var emptyView = new view.constructor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0);
	      return Promise.resolve(CreateIterResultObject(emptyView, true));
	    }
	    if (controller._queueTotalSize > 0) {
	      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
	        var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
	        ReadableByteStreamControllerHandleQueueDrain(controller);
	        return Promise.resolve(CreateIterResultObject(filledView, false));
	      }
	      if (controller._closeRequested === true) {
	        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
	        ReadableByteStreamControllerError(controller, e);
	        return Promise.reject(e);
	      }
	    }
	    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
	    controller._pendingPullIntos.push(pullIntoDescriptor);
	    var promise = ReadableStreamAddReadIntoRequest(stream);
	    ReadableByteStreamControllerCallPullIfNeeded(controller);
	    return promise;
	  }
	  function ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor) {
	    firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer);
	    assert(firstDescriptor.bytesFilled === 0, 'bytesFilled must be 0');
	    var stream = controller._controlledReadableStream;
	    if (ReadableStreamHasBYOBReader(stream) === true) {
	      while (ReadableStreamGetNumReadIntoRequests(stream) > 0) {
	        var pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller);
	        ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor);
	      }
	    }
	  }
	  function ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, pullIntoDescriptor) {
	    if (pullIntoDescriptor.bytesFilled + bytesWritten > pullIntoDescriptor.byteLength) {
	      throw new RangeError('bytesWritten out of range');
	    }
	    ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor);
	    if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) {
	      return;
	    }
	    ReadableByteStreamControllerShiftPendingPullInto(controller);
	    var remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize;
	    if (remainderSize > 0) {
	      var end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
	      var remainder = pullIntoDescriptor.buffer.slice(end - remainderSize, end);
	      ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength);
	    }
	    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
	    pullIntoDescriptor.bytesFilled -= remainderSize;
	    ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
	    ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
	  }
	  function ReadableByteStreamControllerRespondInternal(controller, bytesWritten) {
	    var firstDescriptor = controller._pendingPullIntos[0];
	    var stream = controller._controlledReadableStream;
	    if (stream._state === 'closed') {
	      if (bytesWritten !== 0) {
	        throw new TypeError('bytesWritten must be 0 when calling respond() on a closed stream');
	      }
	      ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor);
	    } else {
	      assert(stream._state === 'readable');
	      ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor);
	    }
	  }
	  function ReadableByteStreamControllerShiftPendingPullInto(controller) {
	    var descriptor = controller._pendingPullIntos.shift();
	    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
	    return descriptor;
	  }
	  function ReadableByteStreamControllerShouldCallPull(controller) {
	    var stream = controller._controlledReadableStream;
	    if (stream._state !== 'readable') {
	      return false;
	    }
	    if (controller._closeRequested === true) {
	      return false;
	    }
	    if (controller._started === false) {
	      return false;
	    }
	    if (ReadableStreamHasDefaultReader(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
	      return true;
	    }
	    if (ReadableStreamHasBYOBReader(stream) === true && ReadableStreamGetNumReadIntoRequests(stream) > 0) {
	      return true;
	    }
	    if (ReadableByteStreamControllerGetDesiredSize(controller) > 0) {
	      return true;
	    }
	    return false;
	  }
	  function ReadableByteStreamControllerClose(controller) {
	    var stream = controller._controlledReadableStream;
	    assert(controller._closeRequested === false);
	    assert(stream._state === 'readable');
	    if (controller._queueTotalSize > 0) {
	      controller._closeRequested = true;
	      return;
	    }
	    if (controller._pendingPullIntos.length > 0) {
	      var firstPendingPullInto = controller._pendingPullIntos[0];
	      if (firstPendingPullInto.bytesFilled > 0) {
	        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
	        ReadableByteStreamControllerError(controller, e);
	        throw e;
	      }
	    }
	    ReadableStreamClose(stream);
	  }
	  function ReadableByteStreamControllerEnqueue(controller, chunk) {
	    var stream = controller._controlledReadableStream;
	    assert(controller._closeRequested === false);
	    assert(stream._state === 'readable');
	    var buffer = chunk.buffer;
	    var byteOffset = chunk.byteOffset;
	    var byteLength = chunk.byteLength;
	    var transferredBuffer = TransferArrayBuffer(buffer);
	    if (ReadableStreamHasDefaultReader(stream) === true) {
	      if (ReadableStreamGetNumReadRequests(stream) === 0) {
	        ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
	      } else {
	        assert(controller._queue.length === 0);
	        var transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength);
	        ReadableStreamFulfillReadRequest(stream, transferredView, false);
	      }
	    } else if (ReadableStreamHasBYOBReader(stream) === true) {
	      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
	      ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
	    } else {
	      assert(IsReadableStreamLocked(stream) === false, 'stream must not be locked');
	      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
	    }
	  }
	  function ReadableByteStreamControllerError(controller, e) {
	    var stream = controller._controlledReadableStream;
	    assert(stream._state === 'readable');
	    ReadableByteStreamControllerClearPendingPullIntos(controller);
	    ResetQueue(controller);
	    ReadableStreamError(stream, e);
	  }
	  function ReadableByteStreamControllerGetDesiredSize(controller) {
	    var stream = controller._controlledReadableStream;
	    var state = stream._state;
	    if (state === 'errored') {
	      return null;
	    }
	    if (state === 'closed') {
	      return 0;
	    }
	    return controller._strategyHWM - controller._queueTotalSize;
	  }
	  function ReadableByteStreamControllerRespond(controller, bytesWritten) {
	    bytesWritten = Number(bytesWritten);
	    if (IsFiniteNonNegativeNumber(bytesWritten) === false) {
	      throw new RangeError('bytesWritten must be a finite');
	    }
	    assert(controller._pendingPullIntos.length > 0);
	    ReadableByteStreamControllerRespondInternal(controller, bytesWritten);
	  }
	  function ReadableByteStreamControllerRespondWithNewView(controller, view) {
	    assert(controller._pendingPullIntos.length > 0);
	    var firstDescriptor = controller._pendingPullIntos[0];
	    if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) {
	      throw new RangeError('The region specified by view does not match byobRequest');
	    }
	    if (firstDescriptor.byteLength !== view.byteLength) {
	      throw new RangeError('The buffer of view has different capacity than byobRequest');
	    }
	    firstDescriptor.buffer = view.buffer;
	    ReadableByteStreamControllerRespondInternal(controller, view.byteLength);
	  }
	  function streamBrandCheckException(name) {
	    return new TypeError('ReadableStream.prototype.' + name + ' can only be used on a ReadableStream');
	  }
	  function readerLockException(name) {
	    return new TypeError('Cannot ' + name + ' a stream using a released reader');
	  }
	  function defaultReaderBrandCheckException(name) {
	    return new TypeError('ReadableStreamDefaultReader.prototype.' + name + ' can only be used on a ReadableStreamDefaultReader');
	  }
	  function defaultReaderClosedPromiseInitialize(reader) {
	    reader._closedPromise = new Promise(function (resolve, reject) {
	      reader._closedPromise_resolve = resolve;
	      reader._closedPromise_reject = reject;
	    });
	  }
	  function defaultReaderClosedPromiseInitializeAsRejected(reader, reason) {
	    reader._closedPromise = Promise.reject(reason);
	    reader._closedPromise_resolve = undefined;
	    reader._closedPromise_reject = undefined;
	  }
	  function defaultReaderClosedPromiseInitializeAsResolved(reader) {
	    reader._closedPromise = Promise.resolve(undefined);
	    reader._closedPromise_resolve = undefined;
	    reader._closedPromise_reject = undefined;
	  }
	  function defaultReaderClosedPromiseReject(reader, reason) {
	    assert(reader._closedPromise_resolve !== undefined);
	    assert(reader._closedPromise_reject !== undefined);
	    reader._closedPromise_reject(reason);
	    reader._closedPromise_resolve = undefined;
	    reader._closedPromise_reject = undefined;
	  }
	  function defaultReaderClosedPromiseResetToRejected(reader, reason) {
	    assert(reader._closedPromise_resolve === undefined);
	    assert(reader._closedPromise_reject === undefined);
	    reader._closedPromise = Promise.reject(reason);
	  }
	  function defaultReaderClosedPromiseResolve(reader) {
	    assert(reader._closedPromise_resolve !== undefined);
	    assert(reader._closedPromise_reject !== undefined);
	    reader._closedPromise_resolve(undefined);
	    reader._closedPromise_resolve = undefined;
	    reader._closedPromise_reject = undefined;
	  }
	  function byobReaderBrandCheckException(name) {
	    return new TypeError('ReadableStreamBYOBReader.prototype.' + name + ' can only be used on a ReadableStreamBYOBReader');
	  }
	  function defaultControllerBrandCheckException(name) {
	    return new TypeError('ReadableStreamDefaultController.prototype.' + name + ' can only be used on a ReadableStreamDefaultController');
	  }
	  function byobRequestBrandCheckException(name) {
	    return new TypeError('ReadableStreamBYOBRequest.prototype.' + name + ' can only be used on a ReadableStreamBYOBRequest');
	  }
	  function byteStreamControllerBrandCheckException(name) {
	    return new TypeError('ReadableByteStreamController.prototype.' + name + ' can only be used on a ReadableByteStreamController');
	  }
	  function ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise) {
	    try {
	      Promise.prototype.then.call(promise, undefined, function () {});
	    } catch (e) {}
	  }
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var transformStream = __w_pdfjs_require__(6);
	  var readableStream = __w_pdfjs_require__(4);
	  var writableStream = __w_pdfjs_require__(2);
	  exports.TransformStream = transformStream.TransformStream;
	  exports.ReadableStream = readableStream.ReadableStream;
	  exports.IsReadableStreamDisturbed = readableStream.IsReadableStreamDisturbed;
	  exports.ReadableStreamDefaultControllerClose = readableStream.ReadableStreamDefaultControllerClose;
	  exports.ReadableStreamDefaultControllerEnqueue = readableStream.ReadableStreamDefaultControllerEnqueue;
	  exports.ReadableStreamDefaultControllerError = readableStream.ReadableStreamDefaultControllerError;
	  exports.ReadableStreamDefaultControllerGetDesiredSize = readableStream.ReadableStreamDefaultControllerGetDesiredSize;
	  exports.AcquireWritableStreamDefaultWriter = writableStream.AcquireWritableStreamDefaultWriter;
	  exports.IsWritableStream = writableStream.IsWritableStream;
	  exports.IsWritableStreamLocked = writableStream.IsWritableStreamLocked;
	  exports.WritableStream = writableStream.WritableStream;
	  exports.WritableStreamAbort = writableStream.WritableStreamAbort;
	  exports.WritableStreamDefaultControllerError = writableStream.WritableStreamDefaultControllerError;
	  exports.WritableStreamDefaultWriterCloseWithErrorPropagation = writableStream.WritableStreamDefaultWriterCloseWithErrorPropagation;
	  exports.WritableStreamDefaultWriterRelease = writableStream.WritableStreamDefaultWriterRelease;
	  exports.WritableStreamDefaultWriterWrite = writableStream.WritableStreamDefaultWriterWrite;
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	  var _require = __w_pdfjs_require__(1),
	      assert = _require.assert;
	  var _require2 = __w_pdfjs_require__(0),
	      InvokeOrNoop = _require2.InvokeOrNoop,
	      PromiseInvokeOrPerformFallback = _require2.PromiseInvokeOrPerformFallback,
	      PromiseInvokeOrNoop = _require2.PromiseInvokeOrNoop,
	      typeIsObject = _require2.typeIsObject;
	  var _require3 = __w_pdfjs_require__(4),
	      ReadableStream = _require3.ReadableStream,
	      ReadableStreamDefaultControllerClose = _require3.ReadableStreamDefaultControllerClose,
	      ReadableStreamDefaultControllerEnqueue = _require3.ReadableStreamDefaultControllerEnqueue,
	      ReadableStreamDefaultControllerError = _require3.ReadableStreamDefaultControllerError,
	      ReadableStreamDefaultControllerGetDesiredSize = _require3.ReadableStreamDefaultControllerGetDesiredSize;
	  var _require4 = __w_pdfjs_require__(2),
	      WritableStream = _require4.WritableStream,
	      WritableStreamDefaultControllerError = _require4.WritableStreamDefaultControllerError;
	  function TransformStreamCloseReadable(transformStream) {
	    if (transformStream._errored === true) {
	      throw new TypeError('TransformStream is already errored');
	    }
	    if (transformStream._readableClosed === true) {
	      throw new TypeError('Readable side is already closed');
	    }
	    TransformStreamCloseReadableInternal(transformStream);
	  }
	  function TransformStreamEnqueueToReadable(transformStream, chunk) {
	    if (transformStream._errored === true) {
	      throw new TypeError('TransformStream is already errored');
	    }
	    if (transformStream._readableClosed === true) {
	      throw new TypeError('Readable side is already closed');
	    }
	    var controller = transformStream._readableController;
	    try {
	      ReadableStreamDefaultControllerEnqueue(controller, chunk);
	    } catch (e) {
	      transformStream._readableClosed = true;
	      TransformStreamErrorIfNeeded(transformStream, e);
	      throw transformStream._storedError;
	    }
	    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
	    var maybeBackpressure = desiredSize <= 0;
	    if (maybeBackpressure === true && transformStream._backpressure === false) {
	      TransformStreamSetBackpressure(transformStream, true);
	    }
	  }
	  function TransformStreamError(transformStream, e) {
	    if (transformStream._errored === true) {
	      throw new TypeError('TransformStream is already errored');
	    }
	    TransformStreamErrorInternal(transformStream, e);
	  }
	  function TransformStreamCloseReadableInternal(transformStream) {
	    assert(transformStream._errored === false);
	    assert(transformStream._readableClosed === false);
	    try {
	      ReadableStreamDefaultControllerClose(transformStream._readableController);
	    } catch (e) {
	      assert(false);
	    }
	    transformStream._readableClosed = true;
	  }
	  function TransformStreamErrorIfNeeded(transformStream, e) {
	    if (transformStream._errored === false) {
	      TransformStreamErrorInternal(transformStream, e);
	    }
	  }
	  function TransformStreamErrorInternal(transformStream, e) {
	    assert(transformStream._errored === false);
	    transformStream._errored = true;
	    transformStream._storedError = e;
	    if (transformStream._writableDone === false) {
	      WritableStreamDefaultControllerError(transformStream._writableController, e);
	    }
	    if (transformStream._readableClosed === false) {
	      ReadableStreamDefaultControllerError(transformStream._readableController, e);
	    }
	  }
	  function TransformStreamReadableReadyPromise(transformStream) {
	    assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
	    if (transformStream._backpressure === false) {
	      return Promise.resolve();
	    }
	    assert(transformStream._backpressure === true, '_backpressure should have been initialized');
	    return transformStream._backpressureChangePromise;
	  }
	  function TransformStreamSetBackpressure(transformStream, backpressure) {
	    assert(transformStream._backpressure !== backpressure, 'TransformStreamSetBackpressure() should be called only when backpressure is changed');
	    if (transformStream._backpressureChangePromise !== undefined) {
	      transformStream._backpressureChangePromise_resolve(backpressure);
	    }
	    transformStream._backpressureChangePromise = new Promise(function (resolve) {
	      transformStream._backpressureChangePromise_resolve = resolve;
	    });
	    transformStream._backpressureChangePromise.then(function (resolution) {
	      assert(resolution !== backpressure, '_backpressureChangePromise should be fulfilled only when backpressure is changed');
	    });
	    transformStream._backpressure = backpressure;
	  }
	  function TransformStreamDefaultTransform(chunk, transformStreamController) {
	    var transformStream = transformStreamController._controlledTransformStream;
	    TransformStreamEnqueueToReadable(transformStream, chunk);
	    return Promise.resolve();
	  }
	  function TransformStreamTransform(transformStream, chunk) {
	    assert(transformStream._errored === false);
	    assert(transformStream._transforming === false);
	    assert(transformStream._backpressure === false);
	    transformStream._transforming = true;
	    var transformer = transformStream._transformer;
	    var controller = transformStream._transformStreamController;
	    var transformPromise = PromiseInvokeOrPerformFallback(transformer, 'transform', [chunk, controller], TransformStreamDefaultTransform, [chunk, controller]);
	    return transformPromise.then(function () {
	      transformStream._transforming = false;
	      return TransformStreamReadableReadyPromise(transformStream);
	    }, function (e) {
	      TransformStreamErrorIfNeeded(transformStream, e);
	      return Promise.reject(e);
	    });
	  }
	  function IsTransformStreamDefaultController(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_controlledTransformStream')) {
	      return false;
	    }
	    return true;
	  }
	  function IsTransformStream(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_transformStreamController')) {
	      return false;
	    }
	    return true;
	  }
	  var TransformStreamSink = function () {
	    function TransformStreamSink(transformStream, startPromise) {
	      _classCallCheck(this, TransformStreamSink);
	      this._transformStream = transformStream;
	      this._startPromise = startPromise;
	    }
	    _createClass(TransformStreamSink, [{
	      key: 'start',
	      value: function start(c) {
	        var transformStream = this._transformStream;
	        transformStream._writableController = c;
	        return this._startPromise.then(function () {
	          return TransformStreamReadableReadyPromise(transformStream);
	        });
	      }
	    }, {
	      key: 'write',
	      value: function write(chunk) {
	        var transformStream = this._transformStream;
	        return TransformStreamTransform(transformStream, chunk);
	      }
	    }, {
	      key: 'abort',
	      value: function abort() {
	        var transformStream = this._transformStream;
	        transformStream._writableDone = true;
	        TransformStreamErrorInternal(transformStream, new TypeError('Writable side aborted'));
	      }
	    }, {
	      key: 'close',
	      value: function close() {
	        var transformStream = this._transformStream;
	        assert(transformStream._transforming === false);
	        transformStream._writableDone = true;
	        var flushPromise = PromiseInvokeOrNoop(transformStream._transformer, 'flush', [transformStream._transformStreamController]);
	        return flushPromise.then(function () {
	          if (transformStream._errored === true) {
	            return Promise.reject(transformStream._storedError);
	          }
	          if (transformStream._readableClosed === false) {
	            TransformStreamCloseReadableInternal(transformStream);
	          }
	          return Promise.resolve();
	        }).catch(function (r) {
	          TransformStreamErrorIfNeeded(transformStream, r);
	          return Promise.reject(transformStream._storedError);
	        });
	      }
	    }]);
	    return TransformStreamSink;
	  }();
	  var TransformStreamSource = function () {
	    function TransformStreamSource(transformStream, startPromise) {
	      _classCallCheck(this, TransformStreamSource);
	      this._transformStream = transformStream;
	      this._startPromise = startPromise;
	    }
	    _createClass(TransformStreamSource, [{
	      key: 'start',
	      value: function start(c) {
	        var transformStream = this._transformStream;
	        transformStream._readableController = c;
	        return this._startPromise.then(function () {
	          assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
	          if (transformStream._backpressure === true) {
	            return Promise.resolve();
	          }
	          assert(transformStream._backpressure === false, '_backpressure should have been initialized');
	          return transformStream._backpressureChangePromise;
	        });
	      }
	    }, {
	      key: 'pull',
	      value: function pull() {
	        var transformStream = this._transformStream;
	        assert(transformStream._backpressure === true, 'pull() should be never called while _backpressure is false');
	        assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
	        TransformStreamSetBackpressure(transformStream, false);
	        return transformStream._backpressureChangePromise;
	      }
	    }, {
	      key: 'cancel',
	      value: function cancel() {
	        var transformStream = this._transformStream;
	        transformStream._readableClosed = true;
	        TransformStreamErrorInternal(transformStream, new TypeError('Readable side canceled'));
	      }
	    }]);
	    return TransformStreamSource;
	  }();
	  var TransformStreamDefaultController = function () {
	    function TransformStreamDefaultController(transformStream) {
	      _classCallCheck(this, TransformStreamDefaultController);
	      if (IsTransformStream(transformStream) === false) {
	        throw new TypeError('TransformStreamDefaultController can only be ' + 'constructed with a TransformStream instance');
	      }
	      if (transformStream._transformStreamController !== undefined) {
	        throw new TypeError('TransformStreamDefaultController instances can ' + 'only be created by the TransformStream constructor');
	      }
	      this._controlledTransformStream = transformStream;
	    }
	    _createClass(TransformStreamDefaultController, [{
	      key: 'enqueue',
	      value: function enqueue(chunk) {
	        if (IsTransformStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('enqueue');
	        }
	        TransformStreamEnqueueToReadable(this._controlledTransformStream, chunk);
	      }
	    }, {
	      key: 'close',
	      value: function close() {
	        if (IsTransformStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('close');
	        }
	        TransformStreamCloseReadable(this._controlledTransformStream);
	      }
	    }, {
	      key: 'error',
	      value: function error(reason) {
	        if (IsTransformStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('error');
	        }
	        TransformStreamError(this._controlledTransformStream, reason);
	      }
	    }, {
	      key: 'desiredSize',
	      get: function get() {
	        if (IsTransformStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('desiredSize');
	        }
	        var transformStream = this._controlledTransformStream;
	        var readableController = transformStream._readableController;
	        return ReadableStreamDefaultControllerGetDesiredSize(readableController);
	      }
	    }]);
	    return TransformStreamDefaultController;
	  }();
	  var TransformStream = function () {
	    function TransformStream() {
	      var transformer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      _classCallCheck(this, TransformStream);
	      this._transformer = transformer;
	      var readableStrategy = transformer.readableStrategy,
	          writableStrategy = transformer.writableStrategy;
	      this._transforming = false;
	      this._errored = false;
	      this._storedError = undefined;
	      this._writableController = undefined;
	      this._readableController = undefined;
	      this._transformStreamController = undefined;
	      this._writableDone = false;
	      this._readableClosed = false;
	      this._backpressure = undefined;
	      this._backpressureChangePromise = undefined;
	      this._backpressureChangePromise_resolve = undefined;
	      this._transformStreamController = new TransformStreamDefaultController(this);
	      var startPromise_resolve = void 0;
	      var startPromise = new Promise(function (resolve) {
	        startPromise_resolve = resolve;
	      });
	      var source = new TransformStreamSource(this, startPromise);
	      this._readable = new ReadableStream(source, readableStrategy);
	      var sink = new TransformStreamSink(this, startPromise);
	      this._writable = new WritableStream(sink, writableStrategy);
	      assert(this._writableController !== undefined);
	      assert(this._readableController !== undefined);
	      var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(this._readableController);
	      TransformStreamSetBackpressure(this, desiredSize <= 0);
	      var transformStream = this;
	      var startResult = InvokeOrNoop(transformer, 'start', [transformStream._transformStreamController]);
	      startPromise_resolve(startResult);
	      startPromise.catch(function (e) {
	        if (transformStream._errored === false) {
	          transformStream._errored = true;
	          transformStream._storedError = e;
	        }
	      });
	    }
	    _createClass(TransformStream, [{
	      key: 'readable',
	      get: function get() {
	        if (IsTransformStream(this) === false) {
	          throw streamBrandCheckException('readable');
	        }
	        return this._readable;
	      }
	    }, {
	      key: 'writable',
	      get: function get() {
	        if (IsTransformStream(this) === false) {
	          throw streamBrandCheckException('writable');
	        }
	        return this._writable;
	      }
	    }]);
	    return TransformStream;
	  }();
	  module.exports = { TransformStream: TransformStream };
	  function defaultControllerBrandCheckException(name) {
	    return new TypeError('TransformStreamDefaultController.prototype.' + name + ' can only be used on a TransformStreamDefaultController');
	  }
	  function streamBrandCheckException(name) {
	    return new TypeError('TransformStream.prototype.' + name + ' can only be used on a TransformStream');
	  }
	}, function (module, exports, __w_pdfjs_require__) {
	  module.exports = __w_pdfjs_require__(5);
	}]));
	
	/***/ }),
	/* 134 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFJS = exports.globalScope = undefined;
	
	var _api = __w_pdfjs_require__(75);
	
	var _dom_utils = __w_pdfjs_require__(17);
	
	var _util = __w_pdfjs_require__(0);
	
	var _annotation_layer = __w_pdfjs_require__(88);
	
	var _global_scope = __w_pdfjs_require__(22);
	
	var _global_scope2 = _interopRequireDefault(_global_scope);
	
	var _metadata = __w_pdfjs_require__(77);
	
	var _text_layer = __w_pdfjs_require__(89);
	
	var _svg = __w_pdfjs_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (!_global_scope2.default.PDFJS) {
	  _global_scope2.default.PDFJS = {};
	}
	var PDFJS = _global_scope2.default.PDFJS;
	{
	  PDFJS.version = '1.10.100';
	  PDFJS.build = 'ea29ec83';
	}
	PDFJS.pdfBug = false;
	if (PDFJS.verbosity !== undefined) {
	  (0, _util.setVerbosityLevel)(PDFJS.verbosity);
	}
	delete PDFJS.verbosity;
	Object.defineProperty(PDFJS, 'verbosity', {
	  get: function get() {
	    return (0, _util.getVerbosityLevel)();
	  },
	  set: function set(level) {
	    (0, _util.setVerbosityLevel)(level);
	  },
	
	  enumerable: true,
	  configurable: true
	});
	PDFJS.VERBOSITY_LEVELS = _util.VERBOSITY_LEVELS;
	PDFJS.OPS = _util.OPS;
	PDFJS.UNSUPPORTED_FEATURES = _util.UNSUPPORTED_FEATURES;
	PDFJS.isValidUrl = _dom_utils.isValidUrl;
	PDFJS.shadow = _util.shadow;
	PDFJS.createBlob = _util.createBlob;
	PDFJS.createObjectURL = function PDFJS_createObjectURL(data, contentType) {
	  return (0, _util.createObjectURL)(data, contentType, PDFJS.disableCreateObjectURL);
	};
	Object.defineProperty(PDFJS, 'isLittleEndian', {
	  configurable: true,
	  get: function PDFJS_isLittleEndian() {
	    return (0, _util.shadow)(PDFJS, 'isLittleEndian', (0, _util.isLittleEndian)());
	  }
	});
	PDFJS.removeNullCharacters = _util.removeNullCharacters;
	PDFJS.PasswordResponses = _util.PasswordResponses;
	PDFJS.PasswordException = _util.PasswordException;
	PDFJS.UnknownErrorException = _util.UnknownErrorException;
	PDFJS.InvalidPDFException = _util.InvalidPDFException;
	PDFJS.MissingPDFException = _util.MissingPDFException;
	PDFJS.UnexpectedResponseException = _util.UnexpectedResponseException;
	PDFJS.Util = _util.Util;
	PDFJS.PageViewport = _util.PageViewport;
	PDFJS.createPromiseCapability = _util.createPromiseCapability;
	PDFJS.maxImageSize = PDFJS.maxImageSize === undefined ? -1 : PDFJS.maxImageSize;
	PDFJS.cMapUrl = PDFJS.cMapUrl === undefined ? null : PDFJS.cMapUrl;
	PDFJS.cMapPacked = PDFJS.cMapPacked === undefined ? false : PDFJS.cMapPacked;
	PDFJS.disableFontFace = PDFJS.disableFontFace === undefined ? false : PDFJS.disableFontFace;
	PDFJS.imageResourcesPath = PDFJS.imageResourcesPath === undefined ? '' : PDFJS.imageResourcesPath;
	PDFJS.disableWorker = PDFJS.disableWorker === undefined ? false : PDFJS.disableWorker;
	PDFJS.workerSrc = PDFJS.workerSrc === undefined ? null : PDFJS.workerSrc;
	PDFJS.workerPort = PDFJS.workerPort === undefined ? null : PDFJS.workerPort;
	PDFJS.disableRange = PDFJS.disableRange === undefined ? false : PDFJS.disableRange;
	PDFJS.disableStream = PDFJS.disableStream === undefined ? false : PDFJS.disableStream;
	PDFJS.disableAutoFetch = PDFJS.disableAutoFetch === undefined ? false : PDFJS.disableAutoFetch;
	PDFJS.pdfBug = PDFJS.pdfBug === undefined ? false : PDFJS.pdfBug;
	PDFJS.postMessageTransfers = PDFJS.postMessageTransfers === undefined ? true : PDFJS.postMessageTransfers;
	PDFJS.disableCreateObjectURL = PDFJS.disableCreateObjectURL === undefined ? false : PDFJS.disableCreateObjectURL;
	PDFJS.disableWebGL = PDFJS.disableWebGL === undefined ? true : PDFJS.disableWebGL;
	PDFJS.externalLinkTarget = PDFJS.externalLinkTarget === undefined ? _dom_utils.LinkTarget.NONE : PDFJS.externalLinkTarget;
	PDFJS.externalLinkRel = PDFJS.externalLinkRel === undefined ? _dom_utils.DEFAULT_LINK_REL : PDFJS.externalLinkRel;
	PDFJS.isEvalSupported = PDFJS.isEvalSupported === undefined ? true : PDFJS.isEvalSupported;
	PDFJS.pdfjsNext = PDFJS.pdfjsNext === undefined ? false : PDFJS.pdfjsNext;
	{
	  var savedOpenExternalLinksInNewWindow = PDFJS.openExternalLinksInNewWindow;
	  delete PDFJS.openExternalLinksInNewWindow;
	  Object.defineProperty(PDFJS, 'openExternalLinksInNewWindow', {
	    get: function get() {
	      return PDFJS.externalLinkTarget === _dom_utils.LinkTarget.BLANK;
	    },
	    set: function set(value) {
	      if (value) {
	        (0, _util.deprecated)('PDFJS.openExternalLinksInNewWindow, please use ' + '"PDFJS.externalLinkTarget = PDFJS.LinkTarget.BLANK" instead.');
	      }
	      if (PDFJS.externalLinkTarget !== _dom_utils.LinkTarget.NONE) {
	        (0, _util.warn)('PDFJS.externalLinkTarget is already initialized');
	        return;
	      }
	      PDFJS.externalLinkTarget = value ? _dom_utils.LinkTarget.BLANK : _dom_utils.LinkTarget.NONE;
	    },
	
	    enumerable: true,
	    configurable: true
	  });
	  if (savedOpenExternalLinksInNewWindow) {
	    PDFJS.openExternalLinksInNewWindow = savedOpenExternalLinksInNewWindow;
	  }
	}
	PDFJS.getDocument = _api.getDocument;
	PDFJS.LoopbackPort = _api.LoopbackPort;
	PDFJS.PDFDataRangeTransport = _api.PDFDataRangeTransport;
	PDFJS.PDFWorker = _api.PDFWorker;
	PDFJS.hasCanvasTypedArrays = true;
	PDFJS.CustomStyle = _dom_utils.CustomStyle;
	PDFJS.LinkTarget = _dom_utils.LinkTarget;
	PDFJS.addLinkAttributes = _dom_utils.addLinkAttributes;
	PDFJS.getFilenameFromUrl = _dom_utils.getFilenameFromUrl;
	PDFJS.isExternalLinkTargetSet = _dom_utils.isExternalLinkTargetSet;
	PDFJS.AnnotationLayer = _annotation_layer.AnnotationLayer;
	PDFJS.renderTextLayer = _text_layer.renderTextLayer;
	PDFJS.Metadata = _metadata.Metadata;
	PDFJS.SVGGraphics = _svg.SVGGraphics;
	PDFJS.UnsupportedManager = _api._UnsupportedManager;
	exports.globalScope = _global_scope2.default;
	exports.PDFJS = PDFJS;
	
	/***/ }),
	/* 135 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontLoader = exports.FontFaceObject = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	function FontLoader(docId) {
	  this.docId = docId;
	  this.styleElement = null;
	  this.nativeFontFaces = [];
	  this.loadTestFontId = 0;
	  this.loadingContext = {
	    requests: [],
	    nextRequestId: 0
	  };
	}
	FontLoader.prototype = {
	  insertRule: function fontLoaderInsertRule(rule) {
	    var styleElement = this.styleElement;
	    if (!styleElement) {
	      styleElement = this.styleElement = document.createElement('style');
	      styleElement.id = 'PDFJS_FONT_STYLE_TAG_' + this.docId;
	      document.documentElement.getElementsByTagName('head')[0].appendChild(styleElement);
	    }
	    var styleSheet = styleElement.sheet;
	    styleSheet.insertRule(rule, styleSheet.cssRules.length);
	  },
	  clear: function fontLoaderClear() {
	    if (this.styleElement) {
	      this.styleElement.remove();
	      this.styleElement = null;
	    }
	    this.nativeFontFaces.forEach(function (nativeFontFace) {
	      document.fonts.delete(nativeFontFace);
	    });
	    this.nativeFontFaces.length = 0;
	  }
	};
	{
	  var getLoadTestFont = function getLoadTestFont() {
	    return atob('T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQ' + 'AABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwA' + 'AAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbm' + 'FtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAA' + 'AADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6A' + 'ABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAA' + 'MQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAA' + 'AAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAA' + 'AAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQ' + 'AAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMA' + 'AQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAA' + 'EAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAA' + 'AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAA' + 'AAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgc' + 'A/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWF' + 'hYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQA' + 'AAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAg' + 'ABAAAAAAAAAAAD6AAAAAAAAA==');
	  };
	  Object.defineProperty(FontLoader.prototype, 'loadTestFont', {
	    get: function get() {
	      return (0, _util.shadow)(this, 'loadTestFont', getLoadTestFont());
	    },
	
	    configurable: true
	  });
	  FontLoader.prototype.addNativeFontFace = function fontLoader_addNativeFontFace(nativeFontFace) {
	    this.nativeFontFaces.push(nativeFontFace);
	    document.fonts.add(nativeFontFace);
	  };
	  FontLoader.prototype.bind = function fontLoaderBind(fonts, callback) {
	    var rules = [];
	    var fontsToLoad = [];
	    var fontLoadPromises = [];
	    var getNativeFontPromise = function getNativeFontPromise(nativeFontFace) {
	      return nativeFontFace.loaded.catch(function (e) {
	        (0, _util.warn)('Failed to load font "' + nativeFontFace.family + '": ' + e);
	      });
	    };
	    var isFontLoadingAPISupported = FontLoader.isFontLoadingAPISupported && !FontLoader.isSyncFontLoadingSupported;
	    for (var i = 0, ii = fonts.length; i < ii; i++) {
	      var font = fonts[i];
	      if (font.attached || font.loading === false) {
	        continue;
	      }
	      font.attached = true;
	      if (isFontLoadingAPISupported) {
	        var nativeFontFace = font.createNativeFontFace();
	        if (nativeFontFace) {
	          this.addNativeFontFace(nativeFontFace);
	          fontLoadPromises.push(getNativeFontPromise(nativeFontFace));
	        }
	      } else {
	        var rule = font.createFontFaceRule();
	        if (rule) {
	          this.insertRule(rule);
	          rules.push(rule);
	          fontsToLoad.push(font);
	        }
	      }
	    }
	    var request = this.queueLoadingCallback(callback);
	    if (isFontLoadingAPISupported) {
	      Promise.all(fontLoadPromises).then(function () {
	        request.complete();
	      });
	    } else if (rules.length > 0 && !FontLoader.isSyncFontLoadingSupported) {
	      this.prepareFontLoadEvent(rules, fontsToLoad, request);
	    } else {
	      request.complete();
	    }
	  };
	  FontLoader.prototype.queueLoadingCallback = function FontLoader_queueLoadingCallback(callback) {
	    function LoadLoader_completeRequest() {
	      (0, _util.assert)(!request.end, 'completeRequest() cannot be called twice');
	      request.end = Date.now();
	      while (context.requests.length > 0 && context.requests[0].end) {
	        var otherRequest = context.requests.shift();
	        setTimeout(otherRequest.callback, 0);
	      }
	    }
	    var context = this.loadingContext;
	    var requestId = 'pdfjs-font-loading-' + context.nextRequestId++;
	    var request = {
	      id: requestId,
	      complete: LoadLoader_completeRequest,
	      callback: callback,
	      started: Date.now()
	    };
	    context.requests.push(request);
	    return request;
	  };
	  FontLoader.prototype.prepareFontLoadEvent = function fontLoaderPrepareFontLoadEvent(rules, fonts, request) {
	    function int32(data, offset) {
	      return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
	    }
	    function spliceString(s, offset, remove, insert) {
	      var chunk1 = s.substr(0, offset);
	      var chunk2 = s.substr(offset + remove);
	      return chunk1 + insert + chunk2;
	    }
	    var i, ii;
	    var canvas = document.createElement('canvas');
	    canvas.width = 1;
	    canvas.height = 1;
	    var ctx = canvas.getContext('2d');
	    var called = 0;
	    function isFontReady(name, callback) {
	      called++;
	      if (called > 30) {
	        (0, _util.warn)('Load test font never loaded.');
	        callback();
	        return;
	      }
	      ctx.font = '30px ' + name;
	      ctx.fillText('.', 0, 20);
	      var imageData = ctx.getImageData(0, 0, 1, 1);
	      if (imageData.data[3] > 0) {
	        callback();
	        return;
	      }
	      setTimeout(isFontReady.bind(null, name, callback));
	    }
	    var loadTestFontId = 'lt' + Date.now() + this.loadTestFontId++;
	    var data = this.loadTestFont;
	    var COMMENT_OFFSET = 976;
	    data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
	    var CFF_CHECKSUM_OFFSET = 16;
	    var XXXX_VALUE = 0x58585858;
	    var checksum = int32(data, CFF_CHECKSUM_OFFSET);
	    for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
	      checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
	    }
	    if (i < loadTestFontId.length) {
	      checksum = checksum - XXXX_VALUE + int32(loadTestFontId + 'XXX', i) | 0;
	    }
	    data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
	    var url = 'url(data:font/opentype;base64,' + btoa(data) + ');';
	    var rule = '@font-face { font-family:"' + loadTestFontId + '";src:' + url + '}';
	    this.insertRule(rule);
	    var names = [];
	    for (i = 0, ii = fonts.length; i < ii; i++) {
	      names.push(fonts[i].loadedName);
	    }
	    names.push(loadTestFontId);
	    var div = document.createElement('div');
	    div.setAttribute('style', 'visibility: hidden;' + 'width: 10px; height: 10px;' + 'position: absolute; top: 0px; left: 0px;');
	    for (i = 0, ii = names.length; i < ii; ++i) {
	      var span = document.createElement('span');
	      span.textContent = 'Hi';
	      span.style.fontFamily = names[i];
	      div.appendChild(span);
	    }
	    document.body.appendChild(div);
	    isFontReady(loadTestFontId, function () {
	      document.body.removeChild(div);
	      request.complete();
	    });
	  };
	}
	{
	  FontLoader.isFontLoadingAPISupported = typeof document !== 'undefined' && !!document.fonts;
	}
	{
	  var isSyncFontLoadingSupported = function isSyncFontLoadingSupported() {
	    if (typeof navigator === 'undefined') {
	      return true;
	    }
	    var supported = false;
	    var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
	    if (m && m[1] >= 14) {
	      supported = true;
	    }
	    return supported;
	  };
	  Object.defineProperty(FontLoader, 'isSyncFontLoadingSupported', {
	    get: function get() {
	      return (0, _util.shadow)(FontLoader, 'isSyncFontLoadingSupported', isSyncFontLoadingSupported());
	    },
	
	    enumerable: true,
	    configurable: true
	  });
	}
	var IsEvalSupportedCached = {
	  get value() {
	    return (0, _util.shadow)(this, 'value', (0, _util.isEvalSupported)());
	  }
	};
	var FontFaceObject = function FontFaceObjectClosure() {
	  function FontFaceObject(translatedData, options) {
	    this.compiledGlyphs = Object.create(null);
	    for (var i in translatedData) {
	      this[i] = translatedData[i];
	    }
	    this.options = options;
	  }
	  FontFaceObject.prototype = {
	    createNativeFontFace: function FontFaceObject_createNativeFontFace() {
	      if (!this.data) {
	        return null;
	      }
	      if (this.options.disableFontFace) {
	        this.disableFontFace = true;
	        return null;
	      }
	      var nativeFontFace = new FontFace(this.loadedName, this.data, {});
	      if (this.options.fontRegistry) {
	        this.options.fontRegistry.registerFont(this);
	      }
	      return nativeFontFace;
	    },
	    createFontFaceRule: function FontFaceObject_createFontFaceRule() {
	      if (!this.data) {
	        return null;
	      }
	      if (this.options.disableFontFace) {
	        this.disableFontFace = true;
	        return null;
	      }
	      var data = (0, _util.bytesToString)(new Uint8Array(this.data));
	      var fontName = this.loadedName;
	      var url = 'url(data:' + this.mimetype + ';base64,' + btoa(data) + ');';
	      var rule = '@font-face { font-family:"' + fontName + '";src:' + url + '}';
	      if (this.options.fontRegistry) {
	        this.options.fontRegistry.registerFont(this, url);
	      }
	      return rule;
	    },
	    getPathGenerator: function FontFaceObject_getPathGenerator(objs, character) {
	      if (!(character in this.compiledGlyphs)) {
	        var cmds = objs.get(this.loadedName + '_path_' + character);
	        var current, i, len;
	        if (this.options.isEvalSupported && IsEvalSupportedCached.value) {
	          var args,
	              js = '';
	          for (i = 0, len = cmds.length; i < len; i++) {
	            current = cmds[i];
	            if (current.args !== undefined) {
	              args = current.args.join(',');
	            } else {
	              args = '';
	            }
	            js += 'c.' + current.cmd + '(' + args + ');\n';
	          }
	          this.compiledGlyphs[character] = new Function('c', 'size', js);
	        } else {
	          this.compiledGlyphs[character] = function (c, size) {
	            for (i = 0, len = cmds.length; i < len; i++) {
	              current = cmds[i];
	              if (current.cmd === 'scale') {
	                current.args = [size, -size];
	              }
	              c[current.cmd].apply(c, current.args);
	            }
	          };
	        }
	      }
	      return this.compiledGlyphs[character];
	    }
	  };
	  return FontFaceObject;
	}();
	exports.FontFaceObject = FontFaceObject;
	exports.FontLoader = FontLoader;
	
	/***/ }),
	/* 136 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CanvasGraphics = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _pattern_helper = __w_pdfjs_require__(137);
	
	var _webgl = __w_pdfjs_require__(76);
	
	var MIN_FONT_SIZE = 16;
	var MAX_FONT_SIZE = 100;
	var MAX_GROUP_SIZE = 4096;
	var MIN_WIDTH_FACTOR = 0.65;
	var COMPILE_TYPE3_GLYPHS = true;
	var MAX_SIZE_TO_COMPILE = 1000;
	var FULL_CHUNK_HEIGHT = 16;
	var IsLittleEndianCached = {
	  get value() {
	    return (0, _util.shadow)(IsLittleEndianCached, 'value', (0, _util.isLittleEndian)());
	  }
	};
	function addContextCurrentTransform(ctx) {
	  if (!ctx.mozCurrentTransform) {
	    ctx._originalSave = ctx.save;
	    ctx._originalRestore = ctx.restore;
	    ctx._originalRotate = ctx.rotate;
	    ctx._originalScale = ctx.scale;
	    ctx._originalTranslate = ctx.translate;
	    ctx._originalTransform = ctx.transform;
	    ctx._originalSetTransform = ctx.setTransform;
	    ctx._transformMatrix = ctx._transformMatrix || [1, 0, 0, 1, 0, 0];
	    ctx._transformStack = [];
	    Object.defineProperty(ctx, 'mozCurrentTransform', {
	      get: function getCurrentTransform() {
	        return this._transformMatrix;
	      }
	    });
	    Object.defineProperty(ctx, 'mozCurrentTransformInverse', {
	      get: function getCurrentTransformInverse() {
	        var m = this._transformMatrix;
	        var a = m[0],
	            b = m[1],
	            c = m[2],
	            d = m[3],
	            e = m[4],
	            f = m[5];
	        var ad_bc = a * d - b * c;
	        var bc_ad = b * c - a * d;
	        return [d / ad_bc, b / bc_ad, c / bc_ad, a / ad_bc, (d * e - c * f) / bc_ad, (b * e - a * f) / ad_bc];
	      }
	    });
	    ctx.save = function ctxSave() {
	      var old = this._transformMatrix;
	      this._transformStack.push(old);
	      this._transformMatrix = old.slice(0, 6);
	      this._originalSave();
	    };
	    ctx.restore = function ctxRestore() {
	      var prev = this._transformStack.pop();
	      if (prev) {
	        this._transformMatrix = prev;
	        this._originalRestore();
	      }
	    };
	    ctx.translate = function ctxTranslate(x, y) {
	      var m = this._transformMatrix;
	      m[4] = m[0] * x + m[2] * y + m[4];
	      m[5] = m[1] * x + m[3] * y + m[5];
	      this._originalTranslate(x, y);
	    };
	    ctx.scale = function ctxScale(x, y) {
	      var m = this._transformMatrix;
	      m[0] = m[0] * x;
	      m[1] = m[1] * x;
	      m[2] = m[2] * y;
	      m[3] = m[3] * y;
	      this._originalScale(x, y);
	    };
	    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
	      var m = this._transformMatrix;
	      this._transformMatrix = [m[0] * a + m[2] * b, m[1] * a + m[3] * b, m[0] * c + m[2] * d, m[1] * c + m[3] * d, m[0] * e + m[2] * f + m[4], m[1] * e + m[3] * f + m[5]];
	      ctx._originalTransform(a, b, c, d, e, f);
	    };
	    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
	      this._transformMatrix = [a, b, c, d, e, f];
	      ctx._originalSetTransform(a, b, c, d, e, f);
	    };
	    ctx.rotate = function ctxRotate(angle) {
	      var cosValue = Math.cos(angle);
	      var sinValue = Math.sin(angle);
	      var m = this._transformMatrix;
	      this._transformMatrix = [m[0] * cosValue + m[2] * sinValue, m[1] * cosValue + m[3] * sinValue, m[0] * -sinValue + m[2] * cosValue, m[1] * -sinValue + m[3] * cosValue, m[4], m[5]];
	      this._originalRotate(angle);
	    };
	  }
	}
	var CachedCanvases = function CachedCanvasesClosure() {
	  function CachedCanvases(canvasFactory) {
	    this.canvasFactory = canvasFactory;
	    this.cache = Object.create(null);
	  }
	  CachedCanvases.prototype = {
	    getCanvas: function CachedCanvases_getCanvas(id, width, height, trackTransform) {
	      var canvasEntry;
	      if (this.cache[id] !== undefined) {
	        canvasEntry = this.cache[id];
	        this.canvasFactory.reset(canvasEntry, width, height);
	        canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0);
	      } else {
	        canvasEntry = this.canvasFactory.create(width, height);
	        this.cache[id] = canvasEntry;
	      }
	      if (trackTransform) {
	        addContextCurrentTransform(canvasEntry.context);
	      }
	      return canvasEntry;
	    },
	    clear: function clear() {
	      for (var id in this.cache) {
	        var canvasEntry = this.cache[id];
	        this.canvasFactory.destroy(canvasEntry);
	        delete this.cache[id];
	      }
	    }
	  };
	  return CachedCanvases;
	}();
	function compileType3Glyph(imgData) {
	  var POINT_TO_PROCESS_LIMIT = 1000;
	  var width = imgData.width,
	      height = imgData.height;
	  var i,
	      j,
	      j0,
	      width1 = width + 1;
	  var points = new Uint8Array(width1 * (height + 1));
	  var POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
	  var lineSize = width + 7 & ~7,
	      data0 = imgData.data;
	  var data = new Uint8Array(lineSize * height),
	      pos = 0,
	      ii;
	  for (i = 0, ii = data0.length; i < ii; i++) {
	    var mask = 128,
	        elem = data0[i];
	    while (mask > 0) {
	      data[pos++] = elem & mask ? 0 : 255;
	      mask >>= 1;
	    }
	  }
	  var count = 0;
	  pos = 0;
	  if (data[pos] !== 0) {
	    points[0] = 1;
	    ++count;
	  }
	  for (j = 1; j < width; j++) {
	    if (data[pos] !== data[pos + 1]) {
	      points[j] = data[pos] ? 2 : 1;
	      ++count;
	    }
	    pos++;
	  }
	  if (data[pos] !== 0) {
	    points[j] = 2;
	    ++count;
	  }
	  for (i = 1; i < height; i++) {
	    pos = i * lineSize;
	    j0 = i * width1;
	    if (data[pos - lineSize] !== data[pos]) {
	      points[j0] = data[pos] ? 1 : 8;
	      ++count;
	    }
	    var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
	    for (j = 1; j < width; j++) {
	      sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
	      if (POINT_TYPES[sum]) {
	        points[j0 + j] = POINT_TYPES[sum];
	        ++count;
	      }
	      pos++;
	    }
	    if (data[pos - lineSize] !== data[pos]) {
	      points[j0 + j] = data[pos] ? 2 : 4;
	      ++count;
	    }
	    if (count > POINT_TO_PROCESS_LIMIT) {
	      return null;
	    }
	  }
	  pos = lineSize * (height - 1);
	  j0 = i * width1;
	  if (data[pos] !== 0) {
	    points[j0] = 8;
	    ++count;
	  }
	  for (j = 1; j < width; j++) {
	    if (data[pos] !== data[pos + 1]) {
	      points[j0 + j] = data[pos] ? 4 : 8;
	      ++count;
	    }
	    pos++;
	  }
	  if (data[pos] !== 0) {
	    points[j0 + j] = 4;
	    ++count;
	  }
	  if (count > POINT_TO_PROCESS_LIMIT) {
	    return null;
	  }
	  var steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
	  var outlines = [];
	  for (i = 0; count && i <= height; i++) {
	    var p = i * width1;
	    var end = p + width;
	    while (p < end && !points[p]) {
	      p++;
	    }
	    if (p === end) {
	      continue;
	    }
	    var coords = [p % width1, i];
	    var type = points[p],
	        p0 = p,
	        pp;
	    do {
	      var step = steps[type];
	      do {
	        p += step;
	      } while (!points[p]);
	      pp = points[p];
	      if (pp !== 5 && pp !== 10) {
	        type = pp;
	        points[p] = 0;
	      } else {
	        type = pp & 0x33 * type >> 4;
	        points[p] &= type >> 2 | type << 2;
	      }
	      coords.push(p % width1);
	      coords.push(p / width1 | 0);
	      --count;
	    } while (p0 !== p);
	    outlines.push(coords);
	    --i;
	  }
	  var drawOutline = function drawOutline(c) {
	    c.save();
	    c.scale(1 / width, -1 / height);
	    c.translate(0, -height);
	    c.beginPath();
	    for (var i = 0, ii = outlines.length; i < ii; i++) {
	      var o = outlines[i];
	      c.moveTo(o[0], o[1]);
	      for (var j = 2, jj = o.length; j < jj; j += 2) {
	        c.lineTo(o[j], o[j + 1]);
	      }
	    }
	    c.fill();
	    c.beginPath();
	    c.restore();
	  };
	  return drawOutline;
	}
	var CanvasExtraState = function CanvasExtraStateClosure() {
	  function CanvasExtraState() {
	    this.alphaIsShape = false;
	    this.fontSize = 0;
	    this.fontSizeScale = 1;
	    this.textMatrix = _util.IDENTITY_MATRIX;
	    this.textMatrixScale = 1;
	    this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
	    this.leading = 0;
	    this.x = 0;
	    this.y = 0;
	    this.lineX = 0;
	    this.lineY = 0;
	    this.charSpacing = 0;
	    this.wordSpacing = 0;
	    this.textHScale = 1;
	    this.textRenderingMode = _util.TextRenderingMode.FILL;
	    this.textRise = 0;
	    this.fillColor = '#000000';
	    this.strokeColor = '#000000';
	    this.patternFill = false;
	    this.fillAlpha = 1;
	    this.strokeAlpha = 1;
	    this.lineWidth = 1;
	    this.activeSMask = null;
	    this.resumeSMaskCtx = null;
	  }
	  CanvasExtraState.prototype = {
	    clone: function CanvasExtraState_clone() {
	      return Object.create(this);
	    },
	    setCurrentPoint: function CanvasExtraState_setCurrentPoint(x, y) {
	      this.x = x;
	      this.y = y;
	    }
	  };
	  return CanvasExtraState;
	}();
	var CanvasGraphics = function CanvasGraphicsClosure() {
	  var EXECUTION_TIME = 15;
	  var EXECUTION_STEPS = 10;
	  function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, imageLayer) {
	    this.ctx = canvasCtx;
	    this.current = new CanvasExtraState();
	    this.stateStack = [];
	    this.pendingClip = null;
	    this.pendingEOFill = false;
	    this.res = null;
	    this.xobjs = null;
	    this.commonObjs = commonObjs;
	    this.objs = objs;
	    this.canvasFactory = canvasFactory;
	    this.imageLayer = imageLayer;
	    this.groupStack = [];
	    this.processingType3 = null;
	    this.baseTransform = null;
	    this.baseTransformStack = [];
	    this.groupLevel = 0;
	    this.smaskStack = [];
	    this.smaskCounter = 0;
	    this.tempSMask = null;
	    this.cachedCanvases = new CachedCanvases(this.canvasFactory);
	    if (canvasCtx) {
	      addContextCurrentTransform(canvasCtx);
	    }
	    this.cachedGetSinglePixelWidth = null;
	  }
	  function putBinaryImageData(ctx, imgData) {
	    if (typeof ImageData !== 'undefined' && imgData instanceof ImageData) {
	      ctx.putImageData(imgData, 0, 0);
	      return;
	    }
	    var height = imgData.height,
	        width = imgData.width;
	    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
	    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
	    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
	    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
	    var srcPos = 0,
	        destPos;
	    var src = imgData.data;
	    var dest = chunkImgData.data;
	    var i, j, thisChunkHeight, elemsInThisChunk;
	    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
	      var srcLength = src.byteLength;
	      var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
	      var dest32DataLength = dest32.length;
	      var fullSrcDiff = width + 7 >> 3;
	      var white = 0xFFFFFFFF;
	      var black = IsLittleEndianCached.value ? 0xFF000000 : 0x000000FF;
	      for (i = 0; i < totalChunks; i++) {
	        thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
	        destPos = 0;
	        for (j = 0; j < thisChunkHeight; j++) {
	          var srcDiff = srcLength - srcPos;
	          var k = 0;
	          var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
	          var kEndUnrolled = kEnd & ~7;
	          var mask = 0;
	          var srcByte = 0;
	          for (; k < kEndUnrolled; k += 8) {
	            srcByte = src[srcPos++];
	            dest32[destPos++] = srcByte & 128 ? white : black;
	            dest32[destPos++] = srcByte & 64 ? white : black;
	            dest32[destPos++] = srcByte & 32 ? white : black;
	            dest32[destPos++] = srcByte & 16 ? white : black;
	            dest32[destPos++] = srcByte & 8 ? white : black;
	            dest32[destPos++] = srcByte & 4 ? white : black;
	            dest32[destPos++] = srcByte & 2 ? white : black;
	            dest32[destPos++] = srcByte & 1 ? white : black;
	          }
	          for (; k < kEnd; k++) {
	            if (mask === 0) {
	              srcByte = src[srcPos++];
	              mask = 128;
	            }
	            dest32[destPos++] = srcByte & mask ? white : black;
	            mask >>= 1;
	          }
	        }
	        while (destPos < dest32DataLength) {
	          dest32[destPos++] = 0;
	        }
	        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
	      }
	    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
	      j = 0;
	      elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
	      for (i = 0; i < fullChunks; i++) {
	        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
	        srcPos += elemsInThisChunk;
	        ctx.putImageData(chunkImgData, 0, j);
	        j += FULL_CHUNK_HEIGHT;
	      }
	      if (i < totalChunks) {
	        elemsInThisChunk = width * partialChunkHeight * 4;
	        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
	        ctx.putImageData(chunkImgData, 0, j);
	      }
	    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
	      thisChunkHeight = FULL_CHUNK_HEIGHT;
	      elemsInThisChunk = width * thisChunkHeight;
	      for (i = 0; i < totalChunks; i++) {
	        if (i >= fullChunks) {
	          thisChunkHeight = partialChunkHeight;
	          elemsInThisChunk = width * thisChunkHeight;
	        }
	        destPos = 0;
	        for (j = elemsInThisChunk; j--;) {
	          dest[destPos++] = src[srcPos++];
	          dest[destPos++] = src[srcPos++];
	          dest[destPos++] = src[srcPos++];
	          dest[destPos++] = 255;
	        }
	        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
	      }
	    } else {
	      throw new Error('bad image kind: ' + imgData.kind);
	    }
	  }
	  function putBinaryImageMask(ctx, imgData) {
	    var height = imgData.height,
	        width = imgData.width;
	    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
	    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
	    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
	    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
	    var srcPos = 0;
	    var src = imgData.data;
	    var dest = chunkImgData.data;
	    for (var i = 0; i < totalChunks; i++) {
	      var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
	      var destPos = 3;
	      for (var j = 0; j < thisChunkHeight; j++) {
	        var mask = 0;
	        for (var k = 0; k < width; k++) {
	          if (!mask) {
	            var elem = src[srcPos++];
	            mask = 128;
	          }
	          dest[destPos] = elem & mask ? 0 : 255;
	          destPos += 4;
	          mask >>= 1;
	        }
	      }
	      ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
	    }
	  }
	  function copyCtxState(sourceCtx, destCtx) {
	    var properties = ['strokeStyle', 'fillStyle', 'fillRule', 'globalAlpha', 'lineWidth', 'lineCap', 'lineJoin', 'miterLimit', 'globalCompositeOperation', 'font'];
	    for (var i = 0, ii = properties.length; i < ii; i++) {
	      var property = properties[i];
	      if (sourceCtx[property] !== undefined) {
	        destCtx[property] = sourceCtx[property];
	      }
	    }
	    if (sourceCtx.setLineDash !== undefined) {
	      destCtx.setLineDash(sourceCtx.getLineDash());
	      destCtx.lineDashOffset = sourceCtx.lineDashOffset;
	    }
	  }
	  function resetCtxToDefault(ctx) {
	    ctx.strokeStyle = '#000000';
	    ctx.fillStyle = '#000000';
	    ctx.fillRule = 'nonzero';
	    ctx.globalAlpha = 1;
	    ctx.lineWidth = 1;
	    ctx.lineCap = 'butt';
	    ctx.lineJoin = 'miter';
	    ctx.miterLimit = 10;
	    ctx.globalCompositeOperation = 'source-over';
	    ctx.font = '10px sans-serif';
	    if (ctx.setLineDash !== undefined) {
	      ctx.setLineDash([]);
	      ctx.lineDashOffset = 0;
	    }
	  }
	  function composeSMaskBackdrop(bytes, r0, g0, b0) {
	    var length = bytes.length;
	    for (var i = 3; i < length; i += 4) {
	      var alpha = bytes[i];
	      if (alpha === 0) {
	        bytes[i - 3] = r0;
	        bytes[i - 2] = g0;
	        bytes[i - 1] = b0;
	      } else if (alpha < 255) {
	        var alpha_ = 255 - alpha;
	        bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
	        bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
	        bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
	      }
	    }
	  }
	  function composeSMaskAlpha(maskData, layerData, transferMap) {
	    var length = maskData.length;
	    var scale = 1 / 255;
	    for (var i = 3; i < length; i += 4) {
	      var alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
	      layerData[i] = layerData[i] * alpha * scale | 0;
	    }
	  }
	  function composeSMaskLuminosity(maskData, layerData, transferMap) {
	    var length = maskData.length;
	    for (var i = 3; i < length; i += 4) {
	      var y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
	      layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
	    }
	  }
	  function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap) {
	    var hasBackdrop = !!backdrop;
	    var r0 = hasBackdrop ? backdrop[0] : 0;
	    var g0 = hasBackdrop ? backdrop[1] : 0;
	    var b0 = hasBackdrop ? backdrop[2] : 0;
	    var composeFn;
	    if (subtype === 'Luminosity') {
	      composeFn = composeSMaskLuminosity;
	    } else {
	      composeFn = composeSMaskAlpha;
	    }
	    var PIXELS_TO_PROCESS = 1048576;
	    var chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
	    for (var row = 0; row < height; row += chunkSize) {
	      var chunkHeight = Math.min(chunkSize, height - row);
	      var maskData = maskCtx.getImageData(0, row, width, chunkHeight);
	      var layerData = layerCtx.getImageData(0, row, width, chunkHeight);
	      if (hasBackdrop) {
	        composeSMaskBackdrop(maskData.data, r0, g0, b0);
	      }
	      composeFn(maskData.data, layerData.data, transferMap);
	      maskCtx.putImageData(layerData, 0, row);
	    }
	  }
	  function composeSMask(ctx, smask, layerCtx) {
	    var mask = smask.canvas;
	    var maskCtx = smask.context;
	    ctx.setTransform(smask.scaleX, 0, 0, smask.scaleY, smask.offsetX, smask.offsetY);
	    var backdrop = smask.backdrop || null;
	    if (!smask.transferMap && _webgl.WebGLUtils.isEnabled) {
	      var composed = _webgl.WebGLUtils.composeSMask(layerCtx.canvas, mask, {
	        subtype: smask.subtype,
	        backdrop: backdrop
	      });
	      ctx.setTransform(1, 0, 0, 1, 0, 0);
	      ctx.drawImage(composed, smask.offsetX, smask.offsetY);
	      return;
	    }
	    genericComposeSMask(maskCtx, layerCtx, mask.width, mask.height, smask.subtype, backdrop, smask.transferMap);
	    ctx.drawImage(mask, 0, 0);
	  }
	  var LINE_CAP_STYLES = ['butt', 'round', 'square'];
	  var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
	  var NORMAL_CLIP = {};
	  var EO_CLIP = {};
	  CanvasGraphics.prototype = {
	    beginDrawing: function beginDrawing(_ref) {
	      var transform = _ref.transform,
	          viewport = _ref.viewport,
	          transparency = _ref.transparency,
	          _ref$background = _ref.background,
	          background = _ref$background === undefined ? null : _ref$background;
	
	      var width = this.ctx.canvas.width;
	      var height = this.ctx.canvas.height;
	      this.ctx.save();
	      this.ctx.fillStyle = background || 'rgb(255, 255, 255)';
	      this.ctx.fillRect(0, 0, width, height);
	      this.ctx.restore();
	      if (transparency) {
	        var transparentCanvas = this.cachedCanvases.getCanvas('transparent', width, height, true);
	        this.compositeCtx = this.ctx;
	        this.transparentCanvas = transparentCanvas.canvas;
	        this.ctx = transparentCanvas.context;
	        this.ctx.save();
	        this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
	      }
	      this.ctx.save();
	      resetCtxToDefault(this.ctx);
	      if (transform) {
	        this.ctx.transform.apply(this.ctx, transform);
	      }
	      this.ctx.transform.apply(this.ctx, viewport.transform);
	      this.baseTransform = this.ctx.mozCurrentTransform.slice();
	      if (this.imageLayer) {
	        this.imageLayer.beginLayout();
	      }
	    },
	
	    executeOperatorList: function CanvasGraphics_executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
	      var argsArray = operatorList.argsArray;
	      var fnArray = operatorList.fnArray;
	      var i = executionStartIdx || 0;
	      var argsArrayLen = argsArray.length;
	      if (argsArrayLen === i) {
	        return i;
	      }
	      var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === 'function';
	      var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
	      var steps = 0;
	      var commonObjs = this.commonObjs;
	      var objs = this.objs;
	      var fnId;
	      while (true) {
	        if (stepper !== undefined && i === stepper.nextBreakPoint) {
	          stepper.breakIt(i, continueCallback);
	          return i;
	        }
	        fnId = fnArray[i];
	        if (fnId !== _util.OPS.dependency) {
	          this[fnId].apply(this, argsArray[i]);
	        } else {
	          var deps = argsArray[i];
	          for (var n = 0, nn = deps.length; n < nn; n++) {
	            var depObjId = deps[n];
	            var common = depObjId[0] === 'g' && depObjId[1] === '_';
	            var objsPool = common ? commonObjs : objs;
	            if (!objsPool.isResolved(depObjId)) {
	              objsPool.get(depObjId, continueCallback);
	              return i;
	            }
	          }
	        }
	        i++;
	        if (i === argsArrayLen) {
	          return i;
	        }
	        if (chunkOperations && ++steps > EXECUTION_STEPS) {
	          if (Date.now() > endTime) {
	            continueCallback();
	            return i;
	          }
	          steps = 0;
	        }
	      }
	    },
	    endDrawing: function CanvasGraphics_endDrawing() {
	      if (this.current.activeSMask !== null) {
	        this.endSMaskGroup();
	      }
	      this.ctx.restore();
	      if (this.transparentCanvas) {
	        this.ctx = this.compositeCtx;
	        this.ctx.save();
	        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
	        this.ctx.drawImage(this.transparentCanvas, 0, 0);
	        this.ctx.restore();
	        this.transparentCanvas = null;
	      }
	      this.cachedCanvases.clear();
	      _webgl.WebGLUtils.clear();
	      if (this.imageLayer) {
	        this.imageLayer.endLayout();
	      }
	    },
	    setLineWidth: function CanvasGraphics_setLineWidth(width) {
	      this.current.lineWidth = width;
	      this.ctx.lineWidth = width;
	    },
	    setLineCap: function CanvasGraphics_setLineCap(style) {
	      this.ctx.lineCap = LINE_CAP_STYLES[style];
	    },
	    setLineJoin: function CanvasGraphics_setLineJoin(style) {
	      this.ctx.lineJoin = LINE_JOIN_STYLES[style];
	    },
	    setMiterLimit: function CanvasGraphics_setMiterLimit(limit) {
	      this.ctx.miterLimit = limit;
	    },
	    setDash: function CanvasGraphics_setDash(dashArray, dashPhase) {
	      var ctx = this.ctx;
	      if (ctx.setLineDash !== undefined) {
	        ctx.setLineDash(dashArray);
	        ctx.lineDashOffset = dashPhase;
	      }
	    },
	    setRenderingIntent: function CanvasGraphics_setRenderingIntent(intent) {},
	    setFlatness: function CanvasGraphics_setFlatness(flatness) {},
	    setGState: function CanvasGraphics_setGState(states) {
	      for (var i = 0, ii = states.length; i < ii; i++) {
	        var state = states[i];
	        var key = state[0];
	        var value = state[1];
	        switch (key) {
	          case 'LW':
	            this.setLineWidth(value);
	            break;
	          case 'LC':
	            this.setLineCap(value);
	            break;
	          case 'LJ':
	            this.setLineJoin(value);
	            break;
	          case 'ML':
	            this.setMiterLimit(value);
	            break;
	          case 'D':
	            this.setDash(value[0], value[1]);
	            break;
	          case 'RI':
	            this.setRenderingIntent(value);
	            break;
	          case 'FL':
	            this.setFlatness(value);
	            break;
	          case 'Font':
	            this.setFont(value[0], value[1]);
	            break;
	          case 'CA':
	            this.current.strokeAlpha = state[1];
	            break;
	          case 'ca':
	            this.current.fillAlpha = state[1];
	            this.ctx.globalAlpha = state[1];
	            break;
	          case 'BM':
	            this.ctx.globalCompositeOperation = value;
	            break;
	          case 'SMask':
	            if (this.current.activeSMask) {
	              if (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask) {
	                this.suspendSMaskGroup();
	              } else {
	                this.endSMaskGroup();
	              }
	            }
	            this.current.activeSMask = value ? this.tempSMask : null;
	            if (this.current.activeSMask) {
	              this.beginSMaskGroup();
	            }
	            this.tempSMask = null;
	            break;
	        }
	      }
	    },
	    beginSMaskGroup: function CanvasGraphics_beginSMaskGroup() {
	      var activeSMask = this.current.activeSMask;
	      var drawnWidth = activeSMask.canvas.width;
	      var drawnHeight = activeSMask.canvas.height;
	      var cacheId = 'smaskGroupAt' + this.groupLevel;
	      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
	      var currentCtx = this.ctx;
	      var currentTransform = currentCtx.mozCurrentTransform;
	      this.ctx.save();
	      var groupCtx = scratchCanvas.context;
	      groupCtx.scale(1 / activeSMask.scaleX, 1 / activeSMask.scaleY);
	      groupCtx.translate(-activeSMask.offsetX, -activeSMask.offsetY);
	      groupCtx.transform.apply(groupCtx, currentTransform);
	      activeSMask.startTransformInverse = groupCtx.mozCurrentTransformInverse;
	      copyCtxState(currentCtx, groupCtx);
	      this.ctx = groupCtx;
	      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
	      this.groupStack.push(currentCtx);
	      this.groupLevel++;
	    },
	    suspendSMaskGroup: function CanvasGraphics_endSMaskGroup() {
	      var groupCtx = this.ctx;
	      this.groupLevel--;
	      this.ctx = this.groupStack.pop();
	      composeSMask(this.ctx, this.current.activeSMask, groupCtx);
	      this.ctx.restore();
	      this.ctx.save();
	      copyCtxState(groupCtx, this.ctx);
	      this.current.resumeSMaskCtx = groupCtx;
	      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
	      this.ctx.transform.apply(this.ctx, deltaTransform);
	      groupCtx.save();
	      groupCtx.setTransform(1, 0, 0, 1, 0, 0);
	      groupCtx.clearRect(0, 0, groupCtx.canvas.width, groupCtx.canvas.height);
	      groupCtx.restore();
	    },
	    resumeSMaskGroup: function CanvasGraphics_endSMaskGroup() {
	      var groupCtx = this.current.resumeSMaskCtx;
	      var currentCtx = this.ctx;
	      this.ctx = groupCtx;
	      this.groupStack.push(currentCtx);
	      this.groupLevel++;
	    },
	    endSMaskGroup: function CanvasGraphics_endSMaskGroup() {
	      var groupCtx = this.ctx;
	      this.groupLevel--;
	      this.ctx = this.groupStack.pop();
	      composeSMask(this.ctx, this.current.activeSMask, groupCtx);
	      this.ctx.restore();
	      copyCtxState(groupCtx, this.ctx);
	      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
	      this.ctx.transform.apply(this.ctx, deltaTransform);
	    },
	    save: function CanvasGraphics_save() {
	      this.ctx.save();
	      var old = this.current;
	      this.stateStack.push(old);
	      this.current = old.clone();
	      this.current.resumeSMaskCtx = null;
	    },
	    restore: function CanvasGraphics_restore() {
	      if (this.current.resumeSMaskCtx) {
	        this.resumeSMaskGroup();
	      }
	      if (this.current.activeSMask !== null && (this.stateStack.length === 0 || this.stateStack[this.stateStack.length - 1].activeSMask !== this.current.activeSMask)) {
	        this.endSMaskGroup();
	      }
	      if (this.stateStack.length !== 0) {
	        this.current = this.stateStack.pop();
	        this.ctx.restore();
	        this.pendingClip = null;
	        this.cachedGetSinglePixelWidth = null;
	      }
	    },
	    transform: function CanvasGraphics_transform(a, b, c, d, e, f) {
	      this.ctx.transform(a, b, c, d, e, f);
	      this.cachedGetSinglePixelWidth = null;
	    },
	    constructPath: function CanvasGraphics_constructPath(ops, args) {
	      var ctx = this.ctx;
	      var current = this.current;
	      var x = current.x,
	          y = current.y;
	      for (var i = 0, j = 0, ii = ops.length; i < ii; i++) {
	        switch (ops[i] | 0) {
	          case _util.OPS.rectangle:
	            x = args[j++];
	            y = args[j++];
	            var width = args[j++];
	            var height = args[j++];
	            if (width === 0) {
	              width = this.getSinglePixelWidth();
	            }
	            if (height === 0) {
	              height = this.getSinglePixelWidth();
	            }
	            var xw = x + width;
	            var yh = y + height;
	            this.ctx.moveTo(x, y);
	            this.ctx.lineTo(xw, y);
	            this.ctx.lineTo(xw, yh);
	            this.ctx.lineTo(x, yh);
	            this.ctx.lineTo(x, y);
	            this.ctx.closePath();
	            break;
	          case _util.OPS.moveTo:
	            x = args[j++];
	            y = args[j++];
	            ctx.moveTo(x, y);
	            break;
	          case _util.OPS.lineTo:
	            x = args[j++];
	            y = args[j++];
	            ctx.lineTo(x, y);
	            break;
	          case _util.OPS.curveTo:
	            x = args[j + 4];
	            y = args[j + 5];
	            ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
	            j += 6;
	            break;
	          case _util.OPS.curveTo2:
	            ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
	            x = args[j + 2];
	            y = args[j + 3];
	            j += 4;
	            break;
	          case _util.OPS.curveTo3:
	            x = args[j + 2];
	            y = args[j + 3];
	            ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
	            j += 4;
	            break;
	          case _util.OPS.closePath:
	            ctx.closePath();
	            break;
	        }
	      }
	      current.setCurrentPoint(x, y);
	    },
	    closePath: function CanvasGraphics_closePath() {
	      this.ctx.closePath();
	    },
	    stroke: function CanvasGraphics_stroke(consumePath) {
	      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
	      var ctx = this.ctx;
	      var strokeColor = this.current.strokeColor;
	      ctx.lineWidth = Math.max(this.getSinglePixelWidth() * MIN_WIDTH_FACTOR, this.current.lineWidth);
	      ctx.globalAlpha = this.current.strokeAlpha;
	      if (strokeColor && strokeColor.hasOwnProperty('type') && strokeColor.type === 'Pattern') {
	        ctx.save();
	        ctx.strokeStyle = strokeColor.getPattern(ctx, this);
	        ctx.stroke();
	        ctx.restore();
	      } else {
	        ctx.stroke();
	      }
	      if (consumePath) {
	        this.consumePath();
	      }
	      ctx.globalAlpha = this.current.fillAlpha;
	    },
	    closeStroke: function CanvasGraphics_closeStroke() {
	      this.closePath();
	      this.stroke();
	    },
	    fill: function CanvasGraphics_fill(consumePath) {
	      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
	      var ctx = this.ctx;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      var needRestore = false;
	      if (isPatternFill) {
	        ctx.save();
	        if (this.baseTransform) {
	          ctx.setTransform.apply(ctx, this.baseTransform);
	        }
	        ctx.fillStyle = fillColor.getPattern(ctx, this);
	        needRestore = true;
	      }
	      if (this.pendingEOFill) {
	        ctx.fill('evenodd');
	        this.pendingEOFill = false;
	      } else {
	        ctx.fill();
	      }
	      if (needRestore) {
	        ctx.restore();
	      }
	      if (consumePath) {
	        this.consumePath();
	      }
	    },
	    eoFill: function CanvasGraphics_eoFill() {
	      this.pendingEOFill = true;
	      this.fill();
	    },
	    fillStroke: function CanvasGraphics_fillStroke() {
	      this.fill(false);
	      this.stroke(false);
	      this.consumePath();
	    },
	    eoFillStroke: function CanvasGraphics_eoFillStroke() {
	      this.pendingEOFill = true;
	      this.fillStroke();
	    },
	    closeFillStroke: function CanvasGraphics_closeFillStroke() {
	      this.closePath();
	      this.fillStroke();
	    },
	    closeEOFillStroke: function CanvasGraphics_closeEOFillStroke() {
	      this.pendingEOFill = true;
	      this.closePath();
	      this.fillStroke();
	    },
	    endPath: function CanvasGraphics_endPath() {
	      this.consumePath();
	    },
	    clip: function CanvasGraphics_clip() {
	      this.pendingClip = NORMAL_CLIP;
	    },
	    eoClip: function CanvasGraphics_eoClip() {
	      this.pendingClip = EO_CLIP;
	    },
	    beginText: function CanvasGraphics_beginText() {
	      this.current.textMatrix = _util.IDENTITY_MATRIX;
	      this.current.textMatrixScale = 1;
	      this.current.x = this.current.lineX = 0;
	      this.current.y = this.current.lineY = 0;
	    },
	    endText: function CanvasGraphics_endText() {
	      var paths = this.pendingTextPaths;
	      var ctx = this.ctx;
	      if (paths === undefined) {
	        ctx.beginPath();
	        return;
	      }
	      ctx.save();
	      ctx.beginPath();
	      for (var i = 0; i < paths.length; i++) {
	        var path = paths[i];
	        ctx.setTransform.apply(ctx, path.transform);
	        ctx.translate(path.x, path.y);
	        path.addToPath(ctx, path.fontSize);
	      }
	      ctx.restore();
	      ctx.clip();
	      ctx.beginPath();
	      delete this.pendingTextPaths;
	    },
	    setCharSpacing: function CanvasGraphics_setCharSpacing(spacing) {
	      this.current.charSpacing = spacing;
	    },
	    setWordSpacing: function CanvasGraphics_setWordSpacing(spacing) {
	      this.current.wordSpacing = spacing;
	    },
	    setHScale: function CanvasGraphics_setHScale(scale) {
	      this.current.textHScale = scale / 100;
	    },
	    setLeading: function CanvasGraphics_setLeading(leading) {
	      this.current.leading = -leading;
	    },
	    setFont: function CanvasGraphics_setFont(fontRefName, size) {
	      var fontObj = this.commonObjs.get(fontRefName);
	      var current = this.current;
	      if (!fontObj) {
	        throw new Error('Can\'t find font for ' + fontRefName);
	      }
	      current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
	      if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
	        (0, _util.warn)('Invalid font matrix for font ' + fontRefName);
	      }
	      if (size < 0) {
	        size = -size;
	        current.fontDirection = -1;
	      } else {
	        current.fontDirection = 1;
	      }
	      this.current.font = fontObj;
	      this.current.fontSize = size;
	      if (fontObj.isType3Font) {
	        return;
	      }
	      var name = fontObj.loadedName || 'sans-serif';
	      var bold = fontObj.black ? '900' : fontObj.bold ? 'bold' : 'normal';
	      var italic = fontObj.italic ? 'italic' : 'normal';
	      var typeface = '"' + name + '", ' + fontObj.fallbackName;
	      var browserFontSize = size < MIN_FONT_SIZE ? MIN_FONT_SIZE : size > MAX_FONT_SIZE ? MAX_FONT_SIZE : size;
	      this.current.fontSizeScale = size / browserFontSize;
	      var rule = italic + ' ' + bold + ' ' + browserFontSize + 'px ' + typeface;
	      this.ctx.font = rule;
	    },
	    setTextRenderingMode: function CanvasGraphics_setTextRenderingMode(mode) {
	      this.current.textRenderingMode = mode;
	    },
	    setTextRise: function CanvasGraphics_setTextRise(rise) {
	      this.current.textRise = rise;
	    },
	    moveText: function CanvasGraphics_moveText(x, y) {
	      this.current.x = this.current.lineX += x;
	      this.current.y = this.current.lineY += y;
	    },
	    setLeadingMoveText: function CanvasGraphics_setLeadingMoveText(x, y) {
	      this.setLeading(-y);
	      this.moveText(x, y);
	    },
	    setTextMatrix: function CanvasGraphics_setTextMatrix(a, b, c, d, e, f) {
	      this.current.textMatrix = [a, b, c, d, e, f];
	      this.current.textMatrixScale = Math.sqrt(a * a + b * b);
	      this.current.x = this.current.lineX = 0;
	      this.current.y = this.current.lineY = 0;
	    },
	    nextLine: function CanvasGraphics_nextLine() {
	      this.moveText(0, this.current.leading);
	    },
	    paintChar: function CanvasGraphics_paintChar(character, x, y) {
	      var ctx = this.ctx;
	      var current = this.current;
	      var font = current.font;
	      var textRenderingMode = current.textRenderingMode;
	      var fontSize = current.fontSize / current.fontSizeScale;
	      var fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
	      var isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
	      var addToPath;
	      if (font.disableFontFace || isAddToPathSet) {
	        addToPath = font.getPathGenerator(this.commonObjs, character);
	      }
	      if (font.disableFontFace) {
	        ctx.save();
	        ctx.translate(x, y);
	        ctx.beginPath();
	        addToPath(ctx, fontSize);
	        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.fill();
	        }
	        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.stroke();
	        }
	        ctx.restore();
	      } else {
	        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.fillText(character, x, y);
	        }
	        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.strokeText(character, x, y);
	        }
	      }
	      if (isAddToPathSet) {
	        var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
	        paths.push({
	          transform: ctx.mozCurrentTransform,
	          x: x,
	          y: y,
	          fontSize: fontSize,
	          addToPath: addToPath
	        });
	      }
	    },
	    get isFontSubpixelAAEnabled() {
	      var ctx = this.canvasFactory.create(10, 10).context;
	      ctx.scale(1.5, 1);
	      ctx.fillText('I', 0, 10);
	      var data = ctx.getImageData(0, 0, 10, 10).data;
	      var enabled = false;
	      for (var i = 3; i < data.length; i += 4) {
	        if (data[i] > 0 && data[i] < 255) {
	          enabled = true;
	          break;
	        }
	      }
	      return (0, _util.shadow)(this, 'isFontSubpixelAAEnabled', enabled);
	    },
	    showText: function CanvasGraphics_showText(glyphs) {
	      var current = this.current;
	      var font = current.font;
	      if (font.isType3Font) {
	        return this.showType3Text(glyphs);
	      }
	      var fontSize = current.fontSize;
	      if (fontSize === 0) {
	        return;
	      }
	      var ctx = this.ctx;
	      var fontSizeScale = current.fontSizeScale;
	      var charSpacing = current.charSpacing;
	      var wordSpacing = current.wordSpacing;
	      var fontDirection = current.fontDirection;
	      var textHScale = current.textHScale * fontDirection;
	      var glyphsLength = glyphs.length;
	      var vertical = font.vertical;
	      var spacingDir = vertical ? 1 : -1;
	      var defaultVMetrics = font.defaultVMetrics;
	      var widthAdvanceScale = fontSize * current.fontMatrix[0];
	      var simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace;
	      ctx.save();
	      ctx.transform.apply(ctx, current.textMatrix);
	      ctx.translate(current.x, current.y + current.textRise);
	      if (current.patternFill) {
	        ctx.fillStyle = current.fillColor.getPattern(ctx, this);
	      }
	      if (fontDirection > 0) {
	        ctx.scale(textHScale, -1);
	      } else {
	        ctx.scale(textHScale, 1);
	      }
	      var lineWidth = current.lineWidth;
	      var scale = current.textMatrixScale;
	      if (scale === 0 || lineWidth === 0) {
	        var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
	        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          this.cachedGetSinglePixelWidth = null;
	          lineWidth = this.getSinglePixelWidth() * MIN_WIDTH_FACTOR;
	        }
	      } else {
	        lineWidth /= scale;
	      }
	      if (fontSizeScale !== 1.0) {
	        ctx.scale(fontSizeScale, fontSizeScale);
	        lineWidth /= fontSizeScale;
	      }
	      ctx.lineWidth = lineWidth;
	      var x = 0,
	          i;
	      for (i = 0; i < glyphsLength; ++i) {
	        var glyph = glyphs[i];
	        if ((0, _util.isNum)(glyph)) {
	          x += spacingDir * glyph * fontSize / 1000;
	          continue;
	        }
	        var restoreNeeded = false;
	        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
	        var character = glyph.fontChar;
	        var accent = glyph.accent;
	        var scaledX, scaledY, scaledAccentX, scaledAccentY;
	        var width = glyph.width;
	        if (vertical) {
	          var vmetric, vx, vy;
	          vmetric = glyph.vmetric || defaultVMetrics;
	          vx = glyph.vmetric ? vmetric[1] : width * 0.5;
	          vx = -vx * widthAdvanceScale;
	          vy = vmetric[2] * widthAdvanceScale;
	          width = vmetric ? -vmetric[0] : width;
	          scaledX = vx / fontSizeScale;
	          scaledY = (x + vy) / fontSizeScale;
	        } else {
	          scaledX = x / fontSizeScale;
	          scaledY = 0;
	        }
	        if (font.remeasure && width > 0) {
	          var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
	          if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
	            var characterScaleX = width / measuredWidth;
	            restoreNeeded = true;
	            ctx.save();
	            ctx.scale(characterScaleX, 1);
	            scaledX /= characterScaleX;
	          } else if (width !== measuredWidth) {
	            scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
	          }
	        }
	        if (glyph.isInFont || font.missingFile) {
	          if (simpleFillText && !accent) {
	            ctx.fillText(character, scaledX, scaledY);
	          } else {
	            this.paintChar(character, scaledX, scaledY);
	            if (accent) {
	              scaledAccentX = scaledX + accent.offset.x / fontSizeScale;
	              scaledAccentY = scaledY - accent.offset.y / fontSizeScale;
	              this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY);
	            }
	          }
	        }
	        var charWidth = width * widthAdvanceScale + spacing * fontDirection;
	        x += charWidth;
	        if (restoreNeeded) {
	          ctx.restore();
	        }
	      }
	      if (vertical) {
	        current.y -= x * textHScale;
	      } else {
	        current.x += x * textHScale;
	      }
	      ctx.restore();
	    },
	    showType3Text: function CanvasGraphics_showType3Text(glyphs) {
	      var ctx = this.ctx;
	      var current = this.current;
	      var font = current.font;
	      var fontSize = current.fontSize;
	      var fontDirection = current.fontDirection;
	      var spacingDir = font.vertical ? 1 : -1;
	      var charSpacing = current.charSpacing;
	      var wordSpacing = current.wordSpacing;
	      var textHScale = current.textHScale * fontDirection;
	      var fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
	      var glyphsLength = glyphs.length;
	      var isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
	      var i, glyph, width, spacingLength;
	      if (isTextInvisible || fontSize === 0) {
	        return;
	      }
	      this.cachedGetSinglePixelWidth = null;
	      ctx.save();
	      ctx.transform.apply(ctx, current.textMatrix);
	      ctx.translate(current.x, current.y);
	      ctx.scale(textHScale, fontDirection);
	      for (i = 0; i < glyphsLength; ++i) {
	        glyph = glyphs[i];
	        if ((0, _util.isNum)(glyph)) {
	          spacingLength = spacingDir * glyph * fontSize / 1000;
	          this.ctx.translate(spacingLength, 0);
	          current.x += spacingLength * textHScale;
	          continue;
	        }
	        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
	        var operatorList = font.charProcOperatorList[glyph.operatorListId];
	        if (!operatorList) {
	          (0, _util.warn)('Type3 character "' + glyph.operatorListId + '" is not available.');
	          continue;
	        }
	        this.processingType3 = glyph;
	        this.save();
	        ctx.scale(fontSize, fontSize);
	        ctx.transform.apply(ctx, fontMatrix);
	        this.executeOperatorList(operatorList);
	        this.restore();
	        var transformed = _util.Util.applyTransform([glyph.width, 0], fontMatrix);
	        width = transformed[0] * fontSize + spacing;
	        ctx.translate(width, 0);
	        current.x += width * textHScale;
	      }
	      ctx.restore();
	      this.processingType3 = null;
	    },
	    setCharWidth: function CanvasGraphics_setCharWidth(xWidth, yWidth) {},
	    setCharWidthAndBounds: function CanvasGraphics_setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
	      this.ctx.rect(llx, lly, urx - llx, ury - lly);
	      this.clip();
	      this.endPath();
	    },
	    getColorN_Pattern: function CanvasGraphics_getColorN_Pattern(IR) {
	      var _this = this;
	
	      var pattern;
	      if (IR[0] === 'TilingPattern') {
	        var color = IR[1];
	        var baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice();
	        var canvasGraphicsFactory = {
	          createCanvasGraphics: function createCanvasGraphics(ctx) {
	            return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory);
	          }
	        };
	        pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
	      } else {
	        pattern = (0, _pattern_helper.getShadingPatternFromIR)(IR);
	      }
	      return pattern;
	    },
	    setStrokeColorN: function CanvasGraphics_setStrokeColorN() {
	      this.current.strokeColor = this.getColorN_Pattern(arguments);
	    },
	    setFillColorN: function CanvasGraphics_setFillColorN() {
	      this.current.fillColor = this.getColorN_Pattern(arguments);
	      this.current.patternFill = true;
	    },
	    setStrokeRGBColor: function CanvasGraphics_setStrokeRGBColor(r, g, b) {
	      var color = _util.Util.makeCssRgb(r, g, b);
	      this.ctx.strokeStyle = color;
	      this.current.strokeColor = color;
	    },
	    setFillRGBColor: function CanvasGraphics_setFillRGBColor(r, g, b) {
	      var color = _util.Util.makeCssRgb(r, g, b);
	      this.ctx.fillStyle = color;
	      this.current.fillColor = color;
	      this.current.patternFill = false;
	    },
	    shadingFill: function CanvasGraphics_shadingFill(patternIR) {
	      var ctx = this.ctx;
	      this.save();
	      var pattern = (0, _pattern_helper.getShadingPatternFromIR)(patternIR);
	      ctx.fillStyle = pattern.getPattern(ctx, this, true);
	      var inv = ctx.mozCurrentTransformInverse;
	      if (inv) {
	        var canvas = ctx.canvas;
	        var width = canvas.width;
	        var height = canvas.height;
	        var bl = _util.Util.applyTransform([0, 0], inv);
	        var br = _util.Util.applyTransform([0, height], inv);
	        var ul = _util.Util.applyTransform([width, 0], inv);
	        var ur = _util.Util.applyTransform([width, height], inv);
	        var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
	        var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
	        var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
	        var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
	        this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
	      } else {
	        this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
	      }
	      this.restore();
	    },
	    beginInlineImage: function CanvasGraphics_beginInlineImage() {
	      throw new Error('Should not call beginInlineImage');
	    },
	    beginImageData: function CanvasGraphics_beginImageData() {
	      throw new Error('Should not call beginImageData');
	    },
	    paintFormXObjectBegin: function CanvasGraphics_paintFormXObjectBegin(matrix, bbox) {
	      this.save();
	      this.baseTransformStack.push(this.baseTransform);
	      if (Array.isArray(matrix) && matrix.length === 6) {
	        this.transform.apply(this, matrix);
	      }
	      this.baseTransform = this.ctx.mozCurrentTransform;
	      if (Array.isArray(bbox) && bbox.length === 4) {
	        var width = bbox[2] - bbox[0];
	        var height = bbox[3] - bbox[1];
	        this.ctx.rect(bbox[0], bbox[1], width, height);
	        this.clip();
	        this.endPath();
	      }
	    },
	    paintFormXObjectEnd: function CanvasGraphics_paintFormXObjectEnd() {
	      this.restore();
	      this.baseTransform = this.baseTransformStack.pop();
	    },
	    beginGroup: function CanvasGraphics_beginGroup(group) {
	      this.save();
	      var currentCtx = this.ctx;
	      if (!group.isolated) {
	        (0, _util.info)('TODO: Support non-isolated groups.');
	      }
	      if (group.knockout) {
	        (0, _util.warn)('Knockout groups not supported.');
	      }
	      var currentTransform = currentCtx.mozCurrentTransform;
	      if (group.matrix) {
	        currentCtx.transform.apply(currentCtx, group.matrix);
	      }
	      if (!group.bbox) {
	        throw new Error('Bounding box is required.');
	      }
	      var bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform);
	      var canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
	      bounds = _util.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
	      var offsetX = Math.floor(bounds[0]);
	      var offsetY = Math.floor(bounds[1]);
	      var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
	      var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
	      var scaleX = 1,
	          scaleY = 1;
	      if (drawnWidth > MAX_GROUP_SIZE) {
	        scaleX = drawnWidth / MAX_GROUP_SIZE;
	        drawnWidth = MAX_GROUP_SIZE;
	      }
	      if (drawnHeight > MAX_GROUP_SIZE) {
	        scaleY = drawnHeight / MAX_GROUP_SIZE;
	        drawnHeight = MAX_GROUP_SIZE;
	      }
	      var cacheId = 'groupAt' + this.groupLevel;
	      if (group.smask) {
	        cacheId += '_smask_' + this.smaskCounter++ % 2;
	      }
	      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
	      var groupCtx = scratchCanvas.context;
	      groupCtx.scale(1 / scaleX, 1 / scaleY);
	      groupCtx.translate(-offsetX, -offsetY);
	      groupCtx.transform.apply(groupCtx, currentTransform);
	      if (group.smask) {
	        this.smaskStack.push({
	          canvas: scratchCanvas.canvas,
	          context: groupCtx,
	          offsetX: offsetX,
	          offsetY: offsetY,
	          scaleX: scaleX,
	          scaleY: scaleY,
	          subtype: group.smask.subtype,
	          backdrop: group.smask.backdrop,
	          transferMap: group.smask.transferMap || null,
	          startTransformInverse: null
	        });
	      } else {
	        currentCtx.setTransform(1, 0, 0, 1, 0, 0);
	        currentCtx.translate(offsetX, offsetY);
	        currentCtx.scale(scaleX, scaleY);
	      }
	      copyCtxState(currentCtx, groupCtx);
	      this.ctx = groupCtx;
	      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
	      this.groupStack.push(currentCtx);
	      this.groupLevel++;
	      this.current.activeSMask = null;
	    },
	    endGroup: function CanvasGraphics_endGroup(group) {
	      this.groupLevel--;
	      var groupCtx = this.ctx;
	      this.ctx = this.groupStack.pop();
	      if (this.ctx.imageSmoothingEnabled !== undefined) {
	        this.ctx.imageSmoothingEnabled = false;
	      } else {
	        this.ctx.mozImageSmoothingEnabled = false;
	      }
	      if (group.smask) {
	        this.tempSMask = this.smaskStack.pop();
	      } else {
	        this.ctx.drawImage(groupCtx.canvas, 0, 0);
	      }
	      this.restore();
	    },
	    beginAnnotations: function CanvasGraphics_beginAnnotations() {
	      this.save();
	      if (this.baseTransform) {
	        this.ctx.setTransform.apply(this.ctx, this.baseTransform);
	      }
	    },
	    endAnnotations: function CanvasGraphics_endAnnotations() {
	      this.restore();
	    },
	    beginAnnotation: function CanvasGraphics_beginAnnotation(rect, transform, matrix) {
	      this.save();
	      resetCtxToDefault(this.ctx);
	      this.current = new CanvasExtraState();
	      if (Array.isArray(rect) && rect.length === 4) {
	        var width = rect[2] - rect[0];
	        var height = rect[3] - rect[1];
	        this.ctx.rect(rect[0], rect[1], width, height);
	        this.clip();
	        this.endPath();
	      }
	      this.transform.apply(this, transform);
	      this.transform.apply(this, matrix);
	    },
	    endAnnotation: function CanvasGraphics_endAnnotation() {
	      this.restore();
	    },
	    paintJpegXObject: function CanvasGraphics_paintJpegXObject(objId, w, h) {
	      var domImage = this.objs.get(objId);
	      if (!domImage) {
	        (0, _util.warn)('Dependent image isn\'t ready yet');
	        return;
	      }
	      this.save();
	      var ctx = this.ctx;
	      ctx.scale(1 / w, -1 / h);
	      ctx.drawImage(domImage, 0, 0, domImage.width, domImage.height, 0, -h, w, h);
	      if (this.imageLayer) {
	        var currentTransform = ctx.mozCurrentTransformInverse;
	        var position = this.getCanvasPosition(0, 0);
	        this.imageLayer.appendImage({
	          objId: objId,
	          left: position[0],
	          top: position[1],
	          width: w / currentTransform[0],
	          height: h / currentTransform[3]
	        });
	      }
	      this.restore();
	    },
	    paintImageMaskXObject: function CanvasGraphics_paintImageMaskXObject(img) {
	      var ctx = this.ctx;
	      var width = img.width,
	          height = img.height;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      var glyph = this.processingType3;
	      if (COMPILE_TYPE3_GLYPHS && glyph && glyph.compiled === undefined) {
	        if (width <= MAX_SIZE_TO_COMPILE && height <= MAX_SIZE_TO_COMPILE) {
	          glyph.compiled = compileType3Glyph({
	            data: img.data,
	            width: width,
	            height: height
	          });
	        } else {
	          glyph.compiled = null;
	        }
	      }
	      if (glyph && glyph.compiled) {
	        glyph.compiled(ctx);
	        return;
	      }
	      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
	      var maskCtx = maskCanvas.context;
	      maskCtx.save();
	      putBinaryImageMask(maskCtx, img);
	      maskCtx.globalCompositeOperation = 'source-in';
	      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
	      maskCtx.fillRect(0, 0, width, height);
	      maskCtx.restore();
	      this.paintInlineImageXObject(maskCanvas.canvas);
	    },
	    paintImageMaskXObjectRepeat: function CanvasGraphics_paintImageMaskXObjectRepeat(imgData, scaleX, scaleY, positions) {
	      var width = imgData.width;
	      var height = imgData.height;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
	      var maskCtx = maskCanvas.context;
	      maskCtx.save();
	      putBinaryImageMask(maskCtx, imgData);
	      maskCtx.globalCompositeOperation = 'source-in';
	      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
	      maskCtx.fillRect(0, 0, width, height);
	      maskCtx.restore();
	      var ctx = this.ctx;
	      for (var i = 0, ii = positions.length; i < ii; i += 2) {
	        ctx.save();
	        ctx.transform(scaleX, 0, 0, scaleY, positions[i], positions[i + 1]);
	        ctx.scale(1, -1);
	        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
	        ctx.restore();
	      }
	    },
	    paintImageMaskXObjectGroup: function CanvasGraphics_paintImageMaskXObjectGroup(images) {
	      var ctx = this.ctx;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      for (var i = 0, ii = images.length; i < ii; i++) {
	        var image = images[i];
	        var width = image.width,
	            height = image.height;
	        var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
	        var maskCtx = maskCanvas.context;
	        maskCtx.save();
	        putBinaryImageMask(maskCtx, image);
	        maskCtx.globalCompositeOperation = 'source-in';
	        maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
	        maskCtx.fillRect(0, 0, width, height);
	        maskCtx.restore();
	        ctx.save();
	        ctx.transform.apply(ctx, image.transform);
	        ctx.scale(1, -1);
	        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
	        ctx.restore();
	      }
	    },
	    paintImageXObject: function CanvasGraphics_paintImageXObject(objId) {
	      var imgData = this.objs.get(objId);
	      if (!imgData) {
	        (0, _util.warn)('Dependent image isn\'t ready yet');
	        return;
	      }
	      this.paintInlineImageXObject(imgData);
	    },
	    paintImageXObjectRepeat: function CanvasGraphics_paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
	      var imgData = this.objs.get(objId);
	      if (!imgData) {
	        (0, _util.warn)('Dependent image isn\'t ready yet');
	        return;
	      }
	      var width = imgData.width;
	      var height = imgData.height;
	      var map = [];
	      for (var i = 0, ii = positions.length; i < ii; i += 2) {
	        map.push({
	          transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
	          x: 0,
	          y: 0,
	          w: width,
	          h: height
	        });
	      }
	      this.paintInlineImageXObjectGroup(imgData, map);
	    },
	    paintInlineImageXObject: function CanvasGraphics_paintInlineImageXObject(imgData) {
	      var width = imgData.width;
	      var height = imgData.height;
	      var ctx = this.ctx;
	      this.save();
	      ctx.scale(1 / width, -1 / height);
	      var currentTransform = ctx.mozCurrentTransformInverse;
	      var a = currentTransform[0],
	          b = currentTransform[1];
	      var widthScale = Math.max(Math.sqrt(a * a + b * b), 1);
	      var c = currentTransform[2],
	          d = currentTransform[3];
	      var heightScale = Math.max(Math.sqrt(c * c + d * d), 1);
	      var imgToPaint, tmpCanvas;
	      if (imgData instanceof HTMLElement || !imgData.data) {
	        imgToPaint = imgData;
	      } else {
	        tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', width, height);
	        var tmpCtx = tmpCanvas.context;
	        putBinaryImageData(tmpCtx, imgData);
	        imgToPaint = tmpCanvas.canvas;
	      }
	      var paintWidth = width,
	          paintHeight = height;
	      var tmpCanvasId = 'prescale1';
	      while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
	        var newWidth = paintWidth,
	            newHeight = paintHeight;
	        if (widthScale > 2 && paintWidth > 1) {
	          newWidth = Math.ceil(paintWidth / 2);
	          widthScale /= paintWidth / newWidth;
	        }
	        if (heightScale > 2 && paintHeight > 1) {
	          newHeight = Math.ceil(paintHeight / 2);
	          heightScale /= paintHeight / newHeight;
	        }
	        tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
	        tmpCtx = tmpCanvas.context;
	        tmpCtx.clearRect(0, 0, newWidth, newHeight);
	        tmpCtx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
	        imgToPaint = tmpCanvas.canvas;
	        paintWidth = newWidth;
	        paintHeight = newHeight;
	        tmpCanvasId = tmpCanvasId === 'prescale1' ? 'prescale2' : 'prescale1';
	      }
	      ctx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, -height, width, height);
	      if (this.imageLayer) {
	        var position = this.getCanvasPosition(0, -height);
	        this.imageLayer.appendImage({
	          imgData: imgData,
	          left: position[0],
	          top: position[1],
	          width: width / currentTransform[0],
	          height: height / currentTransform[3]
	        });
	      }
	      this.restore();
	    },
	    paintInlineImageXObjectGroup: function CanvasGraphics_paintInlineImageXObjectGroup(imgData, map) {
	      var ctx = this.ctx;
	      var w = imgData.width;
	      var h = imgData.height;
	      var tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', w, h);
	      var tmpCtx = tmpCanvas.context;
	      putBinaryImageData(tmpCtx, imgData);
	      for (var i = 0, ii = map.length; i < ii; i++) {
	        var entry = map[i];
	        ctx.save();
	        ctx.transform.apply(ctx, entry.transform);
	        ctx.scale(1, -1);
	        ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
	        if (this.imageLayer) {
	          var position = this.getCanvasPosition(entry.x, entry.y);
	          this.imageLayer.appendImage({
	            imgData: imgData,
	            left: position[0],
	            top: position[1],
	            width: w,
	            height: h
	          });
	        }
	        ctx.restore();
	      }
	    },
	    paintSolidColorImageMask: function CanvasGraphics_paintSolidColorImageMask() {
	      this.ctx.fillRect(0, 0, 1, 1);
	    },
	    paintXObject: function CanvasGraphics_paintXObject() {
	      (0, _util.warn)('Unsupported \'paintXObject\' command.');
	    },
	    markPoint: function CanvasGraphics_markPoint(tag) {},
	    markPointProps: function CanvasGraphics_markPointProps(tag, properties) {},
	    beginMarkedContent: function CanvasGraphics_beginMarkedContent(tag) {},
	    beginMarkedContentProps: function CanvasGraphics_beginMarkedContentProps(tag, properties) {},
	    endMarkedContent: function CanvasGraphics_endMarkedContent() {},
	    beginCompat: function CanvasGraphics_beginCompat() {},
	    endCompat: function CanvasGraphics_endCompat() {},
	    consumePath: function CanvasGraphics_consumePath() {
	      var ctx = this.ctx;
	      if (this.pendingClip) {
	        if (this.pendingClip === EO_CLIP) {
	          ctx.clip('evenodd');
	        } else {
	          ctx.clip();
	        }
	        this.pendingClip = null;
	      }
	      ctx.beginPath();
	    },
	    getSinglePixelWidth: function CanvasGraphics_getSinglePixelWidth(scale) {
	      if (this.cachedGetSinglePixelWidth === null) {
	        this.ctx.save();
	        var inverse = this.ctx.mozCurrentTransformInverse;
	        this.ctx.restore();
	        this.cachedGetSinglePixelWidth = Math.sqrt(Math.max(inverse[0] * inverse[0] + inverse[1] * inverse[1], inverse[2] * inverse[2] + inverse[3] * inverse[3]));
	      }
	      return this.cachedGetSinglePixelWidth;
	    },
	    getCanvasPosition: function CanvasGraphics_getCanvasPosition(x, y) {
	      var transform = this.ctx.mozCurrentTransform;
	      return [transform[0] * x + transform[2] * y + transform[4], transform[1] * x + transform[3] * y + transform[5]];
	    }
	  };
	  for (var op in _util.OPS) {
	    CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
	  }
	  return CanvasGraphics;
	}();
	exports.CanvasGraphics = CanvasGraphics;
	
	/***/ }),
	/* 137 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TilingPattern = exports.getShadingPatternFromIR = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _webgl = __w_pdfjs_require__(76);
	
	var ShadingIRs = {};
	ShadingIRs.RadialAxial = {
	  fromIR: function RadialAxial_fromIR(raw) {
	    var type = raw[1];
	    var colorStops = raw[2];
	    var p0 = raw[3];
	    var p1 = raw[4];
	    var r0 = raw[5];
	    var r1 = raw[6];
	    return {
	      type: 'Pattern',
	      getPattern: function RadialAxial_getPattern(ctx) {
	        var grad;
	        if (type === 'axial') {
	          grad = ctx.createLinearGradient(p0[0], p0[1], p1[0], p1[1]);
	        } else if (type === 'radial') {
	          grad = ctx.createRadialGradient(p0[0], p0[1], r0, p1[0], p1[1], r1);
	        }
	        for (var i = 0, ii = colorStops.length; i < ii; ++i) {
	          var c = colorStops[i];
	          grad.addColorStop(c[0], c[1]);
	        }
	        return grad;
	      }
	    };
	  }
	};
	var createMeshCanvas = function createMeshCanvasClosure() {
	  function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
	    var coords = context.coords,
	        colors = context.colors;
	    var bytes = data.data,
	        rowSize = data.width * 4;
	    var tmp;
	    if (coords[p1 + 1] > coords[p2 + 1]) {
	      tmp = p1;
	      p1 = p2;
	      p2 = tmp;
	      tmp = c1;
	      c1 = c2;
	      c2 = tmp;
	    }
	    if (coords[p2 + 1] > coords[p3 + 1]) {
	      tmp = p2;
	      p2 = p3;
	      p3 = tmp;
	      tmp = c2;
	      c2 = c3;
	      c3 = tmp;
	    }
	    if (coords[p1 + 1] > coords[p2 + 1]) {
	      tmp = p1;
	      p1 = p2;
	      p2 = tmp;
	      tmp = c1;
	      c1 = c2;
	      c2 = tmp;
	    }
	    var x1 = (coords[p1] + context.offsetX) * context.scaleX;
	    var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
	    var x2 = (coords[p2] + context.offsetX) * context.scaleX;
	    var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
	    var x3 = (coords[p3] + context.offsetX) * context.scaleX;
	    var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
	    if (y1 >= y3) {
	      return;
	    }
	    var c1r = colors[c1],
	        c1g = colors[c1 + 1],
	        c1b = colors[c1 + 2];
	    var c2r = colors[c2],
	        c2g = colors[c2 + 1],
	        c2b = colors[c2 + 2];
	    var c3r = colors[c3],
	        c3g = colors[c3 + 1],
	        c3b = colors[c3 + 2];
	    var minY = Math.round(y1),
	        maxY = Math.round(y3);
	    var xa, car, cag, cab;
	    var xb, cbr, cbg, cbb;
	    var k;
	    for (var y = minY; y <= maxY; y++) {
	      if (y < y2) {
	        k = y < y1 ? 0 : y1 === y2 ? 1 : (y1 - y) / (y1 - y2);
	        xa = x1 - (x1 - x2) * k;
	        car = c1r - (c1r - c2r) * k;
	        cag = c1g - (c1g - c2g) * k;
	        cab = c1b - (c1b - c2b) * k;
	      } else {
	        k = y > y3 ? 1 : y2 === y3 ? 0 : (y2 - y) / (y2 - y3);
	        xa = x2 - (x2 - x3) * k;
	        car = c2r - (c2r - c3r) * k;
	        cag = c2g - (c2g - c3g) * k;
	        cab = c2b - (c2b - c3b) * k;
	      }
	      k = y < y1 ? 0 : y > y3 ? 1 : (y1 - y) / (y1 - y3);
	      xb = x1 - (x1 - x3) * k;
	      cbr = c1r - (c1r - c3r) * k;
	      cbg = c1g - (c1g - c3g) * k;
	      cbb = c1b - (c1b - c3b) * k;
	      var x1_ = Math.round(Math.min(xa, xb));
	      var x2_ = Math.round(Math.max(xa, xb));
	      var j = rowSize * y + x1_ * 4;
	      for (var x = x1_; x <= x2_; x++) {
	        k = (xa - x) / (xa - xb);
	        k = k < 0 ? 0 : k > 1 ? 1 : k;
	        bytes[j++] = car - (car - cbr) * k | 0;
	        bytes[j++] = cag - (cag - cbg) * k | 0;
	        bytes[j++] = cab - (cab - cbb) * k | 0;
	        bytes[j++] = 255;
	      }
	    }
	  }
	  function drawFigure(data, figure, context) {
	    var ps = figure.coords;
	    var cs = figure.colors;
	    var i, ii;
	    switch (figure.type) {
	      case 'lattice':
	        var verticesPerRow = figure.verticesPerRow;
	        var rows = Math.floor(ps.length / verticesPerRow) - 1;
	        var cols = verticesPerRow - 1;
	        for (i = 0; i < rows; i++) {
	          var q = i * verticesPerRow;
	          for (var j = 0; j < cols; j++, q++) {
	            drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
	            drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
	          }
	        }
	        break;
	      case 'triangles':
	        for (i = 0, ii = ps.length; i < ii; i += 3) {
	          drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
	        }
	        break;
	      default:
	        throw new Error('illegal figure');
	    }
	  }
	  function createMeshCanvas(bounds, combinesScale, coords, colors, figures, backgroundColor, cachedCanvases) {
	    var EXPECTED_SCALE = 1.1;
	    var MAX_PATTERN_SIZE = 3000;
	    var BORDER_SIZE = 2;
	    var offsetX = Math.floor(bounds[0]);
	    var offsetY = Math.floor(bounds[1]);
	    var boundsWidth = Math.ceil(bounds[2]) - offsetX;
	    var boundsHeight = Math.ceil(bounds[3]) - offsetY;
	    var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinesScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
	    var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinesScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
	    var scaleX = boundsWidth / width;
	    var scaleY = boundsHeight / height;
	    var context = {
	      coords: coords,
	      colors: colors,
	      offsetX: -offsetX,
	      offsetY: -offsetY,
	      scaleX: 1 / scaleX,
	      scaleY: 1 / scaleY
	    };
	    var paddedWidth = width + BORDER_SIZE * 2;
	    var paddedHeight = height + BORDER_SIZE * 2;
	    var canvas, tmpCanvas, i, ii;
	    if (_webgl.WebGLUtils.isEnabled) {
	      canvas = _webgl.WebGLUtils.drawFigures(width, height, backgroundColor, figures, context);
	      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
	      tmpCanvas.context.drawImage(canvas, BORDER_SIZE, BORDER_SIZE);
	      canvas = tmpCanvas.canvas;
	    } else {
	      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
	      var tmpCtx = tmpCanvas.context;
	      var data = tmpCtx.createImageData(width, height);
	      if (backgroundColor) {
	        var bytes = data.data;
	        for (i = 0, ii = bytes.length; i < ii; i += 4) {
	          bytes[i] = backgroundColor[0];
	          bytes[i + 1] = backgroundColor[1];
	          bytes[i + 2] = backgroundColor[2];
	          bytes[i + 3] = 255;
	        }
	      }
	      for (i = 0; i < figures.length; i++) {
	        drawFigure(data, figures[i], context);
	      }
	      tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
	      canvas = tmpCanvas.canvas;
	    }
	    return {
	      canvas: canvas,
	      offsetX: offsetX - BORDER_SIZE * scaleX,
	      offsetY: offsetY - BORDER_SIZE * scaleY,
	      scaleX: scaleX,
	      scaleY: scaleY
	    };
	  }
	  return createMeshCanvas;
	}();
	ShadingIRs.Mesh = {
	  fromIR: function Mesh_fromIR(raw) {
	    var coords = raw[2];
	    var colors = raw[3];
	    var figures = raw[4];
	    var bounds = raw[5];
	    var matrix = raw[6];
	    var background = raw[8];
	    return {
	      type: 'Pattern',
	      getPattern: function Mesh_getPattern(ctx, owner, shadingFill) {
	        var scale;
	        if (shadingFill) {
	          scale = _util.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform);
	        } else {
	          scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
	          if (matrix) {
	            var matrixScale = _util.Util.singularValueDecompose2dScale(matrix);
	            scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
	          }
	        }
	        var temporaryPatternCanvas = createMeshCanvas(bounds, scale, coords, colors, figures, shadingFill ? null : background, owner.cachedCanvases);
	        if (!shadingFill) {
	          ctx.setTransform.apply(ctx, owner.baseTransform);
	          if (matrix) {
	            ctx.transform.apply(ctx, matrix);
	          }
	        }
	        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
	        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
	        return ctx.createPattern(temporaryPatternCanvas.canvas, 'no-repeat');
	      }
	    };
	  }
	};
	ShadingIRs.Dummy = {
	  fromIR: function Dummy_fromIR() {
	    return {
	      type: 'Pattern',
	      getPattern: function Dummy_fromIR_getPattern() {
	        return 'hotpink';
	      }
	    };
	  }
	};
	function getShadingPatternFromIR(raw) {
	  var shadingIR = ShadingIRs[raw[0]];
	  if (!shadingIR) {
	    throw new Error('Unknown IR type: ' + raw[0]);
	  }
	  return shadingIR.fromIR(raw);
	}
	var TilingPattern = function TilingPatternClosure() {
	  var PaintType = {
	    COLORED: 1,
	    UNCOLORED: 2
	  };
	  var MAX_PATTERN_SIZE = 3000;
	  function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
	    this.operatorList = IR[2];
	    this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
	    this.bbox = IR[4];
	    this.xstep = IR[5];
	    this.ystep = IR[6];
	    this.paintType = IR[7];
	    this.tilingType = IR[8];
	    this.color = color;
	    this.canvasGraphicsFactory = canvasGraphicsFactory;
	    this.baseTransform = baseTransform;
	    this.type = 'Pattern';
	    this.ctx = ctx;
	  }
	  TilingPattern.prototype = {
	    createPatternCanvas: function TilinPattern_createPatternCanvas(owner) {
	      var operatorList = this.operatorList;
	      var bbox = this.bbox;
	      var xstep = this.xstep;
	      var ystep = this.ystep;
	      var paintType = this.paintType;
	      var tilingType = this.tilingType;
	      var color = this.color;
	      var canvasGraphicsFactory = this.canvasGraphicsFactory;
	      (0, _util.info)('TilingType: ' + tilingType);
	      var x0 = bbox[0],
	          y0 = bbox[1],
	          x1 = bbox[2],
	          y1 = bbox[3];
	      var topLeft = [x0, y0];
	      var botRight = [x0 + xstep, y0 + ystep];
	      var width = botRight[0] - topLeft[0];
	      var height = botRight[1] - topLeft[1];
	      var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
	      var curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
	      var combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
	      width = Math.min(Math.ceil(Math.abs(width * combinedScale[0])), MAX_PATTERN_SIZE);
	      height = Math.min(Math.ceil(Math.abs(height * combinedScale[1])), MAX_PATTERN_SIZE);
	      var tmpCanvas = owner.cachedCanvases.getCanvas('pattern', width, height, true);
	      var tmpCtx = tmpCanvas.context;
	      var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
	      graphics.groupLevel = owner.groupLevel;
	      this.setFillAndStrokeStyleToContext(graphics, paintType, color);
	      this.setScale(width, height, xstep, ystep);
	      this.transformToScale(graphics);
	      var tmpTranslate = [1, 0, 0, 1, -topLeft[0], -topLeft[1]];
	      graphics.transform.apply(graphics, tmpTranslate);
	      this.clipBbox(graphics, bbox, x0, y0, x1, y1);
	      graphics.executeOperatorList(operatorList);
	      return tmpCanvas.canvas;
	    },
	    setScale: function TilingPattern_setScale(width, height, xstep, ystep) {
	      this.scale = [width / xstep, height / ystep];
	    },
	    transformToScale: function TilingPattern_transformToScale(graphics) {
	      var scale = this.scale;
	      var tmpScale = [scale[0], 0, 0, scale[1], 0, 0];
	      graphics.transform.apply(graphics, tmpScale);
	    },
	    scaleToContext: function TilingPattern_scaleToContext() {
	      var scale = this.scale;
	      this.ctx.scale(1 / scale[0], 1 / scale[1]);
	    },
	    clipBbox: function clipBbox(graphics, bbox, x0, y0, x1, y1) {
	      if (Array.isArray(bbox) && bbox.length === 4) {
	        var bboxWidth = x1 - x0;
	        var bboxHeight = y1 - y0;
	        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
	        graphics.clip();
	        graphics.endPath();
	      }
	    },
	    setFillAndStrokeStyleToContext: function setFillAndStrokeStyleToContext(graphics, paintType, color) {
	      var context = graphics.ctx,
	          current = graphics.current;
	      switch (paintType) {
	        case PaintType.COLORED:
	          var ctx = this.ctx;
	          context.fillStyle = ctx.fillStyle;
	          context.strokeStyle = ctx.strokeStyle;
	          current.fillColor = ctx.fillStyle;
	          current.strokeColor = ctx.strokeStyle;
	          break;
	        case PaintType.UNCOLORED:
	          var cssColor = _util.Util.makeCssRgb(color[0], color[1], color[2]);
	          context.fillStyle = cssColor;
	          context.strokeStyle = cssColor;
	          current.fillColor = cssColor;
	          current.strokeColor = cssColor;
	          break;
	        default:
	          throw new _util.FormatError('Unsupported paint type: ' + paintType);
	      }
	    },
	    getPattern: function TilingPattern_getPattern(ctx, owner) {
	      var temporaryPatternCanvas = this.createPatternCanvas(owner);
	      ctx = this.ctx;
	      ctx.setTransform.apply(ctx, this.baseTransform);
	      ctx.transform.apply(ctx, this.matrix);
	      this.scaleToContext();
	      return ctx.createPattern(temporaryPatternCanvas, 'repeat');
	    }
	  };
	  return TilingPattern;
	}();
	exports.getShadingPatternFromIR = getShadingPatternFromIR;
	exports.TilingPattern = TilingPattern;
	
	/***/ }),
	/* 138 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var XMLParserErrorCode = {
	  NoError: 0,
	  EndOfDocument: -1,
	  UnterminatedCdat: -2,
	  UnterminatedXmlDeclaration: -3,
	  UnterminatedDoctypeDeclaration: -4,
	  UnterminatedComment: -5,
	  MalformedElement: -6,
	  OutOfMemory: -7,
	  UnterminatedAttributeValue: -8,
	  UnterminatedElement: -9,
	  ElementNeverBegun: -10
	};
	function isWhitespace(s, index) {
	  var ch = s[index];
	  return ch === ' ' || ch === '\n' || ch === '\r' || ch === '\t';
	}
	function isWhitespaceString(s) {
	  for (var i = 0, ii = s.length; i < ii; i++) {
	    if (!isWhitespace(s, i)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var XMLParserBase = function () {
	  function XMLParserBase() {
	    _classCallCheck(this, XMLParserBase);
	  }
	
	  _createClass(XMLParserBase, [{
	    key: '_resolveEntities',
	    value: function _resolveEntities(s) {
	      return s.replace(/&([^;]+);/g, function (all, entity) {
	        if (entity.substring(0, 2) === '#x') {
	          return String.fromCharCode(parseInt(entity.substring(2), 16));
	        } else if (entity.substring(0, 1) === '#') {
	          return String.fromCharCode(parseInt(entity.substring(1), 10));
	        }
	        switch (entity) {
	          case 'lt':
	            return '<';
	          case 'gt':
	            return '>';
	          case 'amp':
	            return '&';
	          case 'quot':
	            return '\"';
	        }
	        return this.onResolveEntity(entity);
	      });
	    }
	  }, {
	    key: '_parseContent',
	    value: function _parseContent(s, start) {
	      var pos = start,
	          name = void 0,
	          attributes = [];
	      function skipWs() {
	        while (pos < s.length && isWhitespace(s, pos)) {
	          ++pos;
	        }
	      }
	      while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== '>' && s[pos] !== '/') {
	        ++pos;
	      }
	      name = s.substring(start, pos);
	      skipWs();
	      while (pos < s.length && s[pos] !== '>' && s[pos] !== '/' && s[pos] !== '?') {
	        skipWs();
	        var attrName = '',
	            attrValue = '';
	        while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== '=') {
	          attrName += s[pos];
	          ++pos;
	        }
	        skipWs();
	        if (s[pos] !== '=') {
	          return null;
	        }
	        ++pos;
	        skipWs();
	        var attrEndChar = s[pos];
	        if (attrEndChar !== '\"' && attrEndChar !== '\'') {
	          return null;
	        }
	        var attrEndIndex = s.indexOf(attrEndChar, ++pos);
	        if (attrEndIndex < 0) {
	          return null;
	        }
	        attrValue = s.substring(pos, attrEndIndex);
	        attributes.push({
	          name: attrName,
	          value: this._resolveEntities(attrValue)
	        });
	        pos = attrEndIndex + 1;
	        skipWs();
	      }
	      return {
	        name: name,
	        attributes: attributes,
	        parsed: pos - start
	      };
	    }
	  }, {
	    key: '_parseProcessingInstruction',
	    value: function _parseProcessingInstruction(s, start) {
	      var pos = start,
	          name = void 0,
	          value = void 0;
	      function skipWs() {
	        while (pos < s.length && isWhitespace(s, pos)) {
	          ++pos;
	        }
	      }
	      while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== '>' && s[pos] !== '/') {
	        ++pos;
	      }
	      name = s.substring(start, pos);
	      skipWs();
	      var attrStart = pos;
	      while (pos < s.length && (s[pos] !== '?' || s[pos + 1] !== '>')) {
	        ++pos;
	      }
	      value = s.substring(attrStart, pos);
	      return {
	        name: name,
	        value: value,
	        parsed: pos - start
	      };
	    }
	  }, {
	    key: 'parseXml',
	    value: function parseXml(s) {
	      var i = 0;
	      while (i < s.length) {
	        var ch = s[i];
	        var j = i;
	        if (ch === '<') {
	          ++j;
	          var ch2 = s[j];
	          var q = void 0;
	          switch (ch2) {
	            case '/':
	              ++j;
	              q = s.indexOf('>', j);
	              if (q < 0) {
	                this.onError(XMLParserErrorCode.UnterminatedElement);
	                return;
	              }
	              this.onEndElement(s.substring(j, q));
	              j = q + 1;
	              break;
	            case '?':
	              ++j;
	              var pi = this._parseProcessingInstruction(s, j);
	              if (s.substring(j + pi.parsed, j + pi.parsed + 2) !== '?>') {
	                this.onError(XMLParserErrorCode.UnterminatedXmlDeclaration);
	                return;
	              }
	              this.onPi(pi.name, pi.value);
	              j += pi.parsed + 2;
	              break;
	            case '!':
	              if (s.substring(j + 1, j + 3) === '--') {
	                q = s.indexOf('-->', j + 3);
	                if (q < 0) {
	                  this.onError(XMLParserErrorCode.UnterminatedComment);
	                  return;
	                }
	                this.onComment(s.substring(j + 3, q));
	                j = q + 3;
	              } else if (s.substring(j + 1, j + 8) === '[CDATA[') {
	                q = s.indexOf(']]>', j + 8);
	                if (q < 0) {
	                  this.onError(XMLParserErrorCode.UnterminatedCdat);
	                  return;
	                }
	                this.onCdata(s.substring(j + 8, q));
	                j = q + 3;
	              } else if (s.substring(j + 1, j + 8) === 'DOCTYPE') {
	                var q2 = s.indexOf('[', j + 8);
	                var complexDoctype = false;
	                q = s.indexOf('>', j + 8);
	                if (q < 0) {
	                  this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration);
	                  return;
	                }
	                if (q2 > 0 && q > q2) {
	                  q = s.indexOf(']>', j + 8);
	                  if (q < 0) {
	                    this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration);
	                    return;
	                  }
	                  complexDoctype = true;
	                }
	                var doctypeContent = s.substring(j + 8, q + (complexDoctype ? 1 : 0));
	                this.onDoctype(doctypeContent);
	                j = q + (complexDoctype ? 2 : 1);
	              } else {
	                this.onError(XMLParserErrorCode.MalformedElement);
	                return;
	              }
	              break;
	            default:
	              var content = this._parseContent(s, j);
	              if (content === null) {
	                this.onError(XMLParserErrorCode.MalformedElement);
	                return;
	              }
	              var isClosed = false;
	              if (s.substring(j + content.parsed, j + content.parsed + 2) === '/>') {
	                isClosed = true;
	              } else if (s.substring(j + content.parsed, j + content.parsed + 1) !== '>') {
	                this.onError(XMLParserErrorCode.UnterminatedElement);
	                return;
	              }
	              this.onBeginElement(content.name, content.attributes, isClosed);
	              j += content.parsed + (isClosed ? 2 : 1);
	              break;
	          }
	        } else {
	          while (j < s.length && s[j] !== '<') {
	            j++;
	          }
	          var text = s.substring(i, j);
	          this.onText(this._resolveEntities(text));
	        }
	        i = j;
	      }
	    }
	  }, {
	    key: 'onResolveEntity',
	    value: function onResolveEntity(name) {
	      return '&' + name + ';';
	    }
	  }, {
	    key: 'onPi',
	    value: function onPi(name, value) {}
	  }, {
	    key: 'onComment',
	    value: function onComment(text) {}
	  }, {
	    key: 'onCdata',
	    value: function onCdata(text) {}
	  }, {
	    key: 'onDoctype',
	    value: function onDoctype(doctypeContent) {}
	  }, {
	    key: 'onText',
	    value: function onText(text) {}
	  }, {
	    key: 'onBeginElement',
	    value: function onBeginElement(name, attributes, isEmpty) {}
	  }, {
	    key: 'onEndElement',
	    value: function onEndElement(name) {}
	  }, {
	    key: 'onError',
	    value: function onError(code) {}
	  }]);
	
	  return XMLParserBase;
	}();
	
	var SimpleDOMNode = function () {
	  function SimpleDOMNode(nodeName, nodeValue) {
	    _classCallCheck(this, SimpleDOMNode);
	
	    this.nodeName = nodeName;
	    this.nodeValue = nodeValue;
	    Object.defineProperty(this, 'parentNode', {
	      value: null,
	      writable: true
	    });
	  }
	
	  _createClass(SimpleDOMNode, [{
	    key: 'hasChildNodes',
	    value: function hasChildNodes() {
	      return this.childNodes && this.childNodes.length > 0;
	    }
	  }, {
	    key: 'firstChild',
	    get: function get() {
	      return this.childNodes[0];
	    }
	  }, {
	    key: 'nextSibling',
	    get: function get() {
	      var index = this.parentNode.childNodes.indexOf(this);
	      return this.parentNode.childNodes[index + 1];
	    }
	  }, {
	    key: 'textContent',
	    get: function get() {
	      if (!this.childNodes) {
	        return this.nodeValue || '';
	      }
	      return this.childNodes.map(function (child) {
	        return child.textContent;
	      }).join('');
	    }
	  }]);
	
	  return SimpleDOMNode;
	}();
	
	var SimpleXMLParser = function (_XMLParserBase) {
	  _inherits(SimpleXMLParser, _XMLParserBase);
	
	  function SimpleXMLParser() {
	    _classCallCheck(this, SimpleXMLParser);
	
	    var _this = _possibleConstructorReturn(this, (SimpleXMLParser.__proto__ || Object.getPrototypeOf(SimpleXMLParser)).call(this));
	
	    _this._currentFragment = null;
	    _this._stack = null;
	    _this._errorCode = XMLParserErrorCode.NoError;
	    return _this;
	  }
	
	  _createClass(SimpleXMLParser, [{
	    key: 'parseFromString',
	    value: function parseFromString(data) {
	      this._currentFragment = [];
	      this._stack = [];
	      this._errorCode = XMLParserErrorCode.NoError;
	      this.parseXml(data);
	      if (this._errorCode !== XMLParserErrorCode.NoError) {
	        return undefined;
	      }
	
	      var _currentFragment = _slicedToArray(this._currentFragment, 1),
	          documentElement = _currentFragment[0];
	
	      return { documentElement: documentElement };
	    }
	  }, {
	    key: 'onResolveEntity',
	    value: function onResolveEntity(name) {
	      switch (name) {
	        case 'apos':
	          return '\'';
	      }
	      return _get(SimpleXMLParser.prototype.__proto__ || Object.getPrototypeOf(SimpleXMLParser.prototype), 'onResolveEntity', this).call(this, name);
	    }
	  }, {
	    key: 'onText',
	    value: function onText(text) {
	      if (isWhitespaceString(text)) {
	        return;
	      }
	      var node = new SimpleDOMNode('#text', text);
	      this._currentFragment.push(node);
	    }
	  }, {
	    key: 'onCdata',
	    value: function onCdata(text) {
	      var node = new SimpleDOMNode('#text', text);
	      this._currentFragment.push(node);
	    }
	  }, {
	    key: 'onBeginElement',
	    value: function onBeginElement(name, attributes, isEmpty) {
	      var node = new SimpleDOMNode(name);
	      node.childNodes = [];
	      this._currentFragment.push(node);
	      if (isEmpty) {
	        return;
	      }
	      this._stack.push(this._currentFragment);
	      this._currentFragment = node.childNodes;
	    }
	  }, {
	    key: 'onEndElement',
	    value: function onEndElement(name) {
	      this._currentFragment = this._stack.pop();
	      var lastElement = this._currentFragment[this._currentFragment.length - 1];
	      for (var i = 0, ii = lastElement.childNodes.length; i < ii; i++) {
	        lastElement.childNodes[i].parentNode = lastElement;
	      }
	    }
	  }, {
	    key: 'onError',
	    value: function onError(code) {
	      this._errorCode = code;
	    }
	  }]);
	
	  return SimpleXMLParser;
	}(XMLParserBase);
	
	exports.SimpleXMLParser = SimpleXMLParser;
	
	/***/ }),
	/* 139 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFDataTransportStream = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var PDFDataTransportStream = function PDFDataTransportStreamClosure() {
	  function PDFDataTransportStream(params, pdfDataRangeTransport) {
	    var _this = this;
	
	    (0, _util.assert)(pdfDataRangeTransport);
	    this._queuedChunks = [];
	    var initialData = params.initialData;
	    if (initialData && initialData.length > 0) {
	      var buffer = new Uint8Array(initialData).buffer;
	      this._queuedChunks.push(buffer);
	    }
	    this._pdfDataRangeTransport = pdfDataRangeTransport;
	    this._isRangeSupported = !params.disableRange;
	    this._isStreamingSupported = !params.disableStream;
	    this._contentLength = params.length;
	    this._fullRequestReader = null;
	    this._rangeReaders = [];
	    this._pdfDataRangeTransport.addRangeListener(function (begin, chunk) {
	      _this._onReceiveData({
	        begin: begin,
	        chunk: chunk
	      });
	    });
	    this._pdfDataRangeTransport.addProgressListener(function (loaded) {
	      _this._onProgress({ loaded: loaded });
	    });
	    this._pdfDataRangeTransport.addProgressiveReadListener(function (chunk) {
	      _this._onReceiveData({ chunk: chunk });
	    });
	    this._pdfDataRangeTransport.transportReady();
	  }
	  PDFDataTransportStream.prototype = {
	    _onReceiveData: function PDFDataTransportStream_onReceiveData(args) {
	      var buffer = new Uint8Array(args.chunk).buffer;
	      if (args.begin === undefined) {
	        if (this._fullRequestReader) {
	          this._fullRequestReader._enqueue(buffer);
	        } else {
	          this._queuedChunks.push(buffer);
	        }
	      } else {
	        var found = this._rangeReaders.some(function (rangeReader) {
	          if (rangeReader._begin !== args.begin) {
	            return false;
	          }
	          rangeReader._enqueue(buffer);
	          return true;
	        });
	        (0, _util.assert)(found);
	      }
	    },
	    _onProgress: function PDFDataTransportStream_onDataProgress(evt) {
	      if (this._rangeReaders.length > 0) {
	        var firstReader = this._rangeReaders[0];
	        if (firstReader.onProgress) {
	          firstReader.onProgress({ loaded: evt.loaded });
	        }
	      }
	    },
	    _removeRangeReader: function PDFDataTransportStream_removeRangeReader(reader) {
	      var i = this._rangeReaders.indexOf(reader);
	      if (i >= 0) {
	        this._rangeReaders.splice(i, 1);
	      }
	    },
	    getFullReader: function PDFDataTransportStream_getFullReader() {
	      (0, _util.assert)(!this._fullRequestReader);
	      var queuedChunks = this._queuedChunks;
	      this._queuedChunks = null;
	      return new PDFDataTransportStreamReader(this, queuedChunks);
	    },
	    getRangeReader: function PDFDataTransportStream_getRangeReader(begin, end) {
	      var reader = new PDFDataTransportStreamRangeReader(this, begin, end);
	      this._pdfDataRangeTransport.requestDataRange(begin, end);
	      this._rangeReaders.push(reader);
	      return reader;
	    },
	    cancelAllRequests: function PDFDataTransportStream_cancelAllRequests(reason) {
	      if (this._fullRequestReader) {
	        this._fullRequestReader.cancel(reason);
	      }
	      var readers = this._rangeReaders.slice(0);
	      readers.forEach(function (rangeReader) {
	        rangeReader.cancel(reason);
	      });
	      this._pdfDataRangeTransport.abort();
	    }
	  };
	  function PDFDataTransportStreamReader(stream, queuedChunks) {
	    this._stream = stream;
	    this._done = false;
	    this._queuedChunks = queuedChunks || [];
	    this._requests = [];
	    this._headersReady = Promise.resolve();
	    stream._fullRequestReader = this;
	    this.onProgress = null;
	  }
	  PDFDataTransportStreamReader.prototype = {
	    _enqueue: function PDFDataTransportStreamReader_enqueue(chunk) {
	      if (this._done) {
	        return;
	      }
	      if (this._requests.length > 0) {
	        var requestCapability = this._requests.shift();
	        requestCapability.resolve({
	          value: chunk,
	          done: false
	        });
	        return;
	      }
	      this._queuedChunks.push(chunk);
	    },
	    get headersReady() {
	      return this._headersReady;
	    },
	    get isRangeSupported() {
	      return this._stream._isRangeSupported;
	    },
	    get isStreamingSupported() {
	      return this._stream._isStreamingSupported;
	    },
	    get contentLength() {
	      return this._stream._contentLength;
	    },
	    read: function PDFDataTransportStreamReader_read() {
	      if (this._queuedChunks.length > 0) {
	        var chunk = this._queuedChunks.shift();
	        return Promise.resolve({
	          value: chunk,
	          done: false
	        });
	      }
	      if (this._done) {
	        return Promise.resolve({
	          value: undefined,
	          done: true
	        });
	      }
	      var requestCapability = (0, _util.createPromiseCapability)();
	      this._requests.push(requestCapability);
	      return requestCapability.promise;
	    },
	    cancel: function PDFDataTransportStreamReader_cancel(reason) {
	      this._done = true;
	      this._requests.forEach(function (requestCapability) {
	        requestCapability.resolve({
	          value: undefined,
	          done: true
	        });
	      });
	      this._requests = [];
	    }
	  };
	  function PDFDataTransportStreamRangeReader(stream, begin, end) {
	    this._stream = stream;
	    this._begin = begin;
	    this._end = end;
	    this._queuedChunk = null;
	    this._requests = [];
	    this._done = false;
	    this.onProgress = null;
	  }
	  PDFDataTransportStreamRangeReader.prototype = {
	    _enqueue: function PDFDataTransportStreamRangeReader_enqueue(chunk) {
	      if (this._done) {
	        return;
	      }
	      if (this._requests.length === 0) {
	        this._queuedChunk = chunk;
	      } else {
	        var requestsCapability = this._requests.shift();
	        requestsCapability.resolve({
	          value: chunk,
	          done: false
	        });
	        this._requests.forEach(function (requestCapability) {
	          requestCapability.resolve({
	            value: undefined,
	            done: true
	          });
	        });
	        this._requests = [];
	      }
	      this._done = true;
	      this._stream._removeRangeReader(this);
	    },
	    get isStreamingSupported() {
	      return false;
	    },
	    read: function PDFDataTransportStreamRangeReader_read() {
	      if (this._queuedChunk) {
	        var chunk = this._queuedChunk;
	        this._queuedChunk = null;
	        return Promise.resolve({
	          value: chunk,
	          done: false
	        });
	      }
	      if (this._done) {
	        return Promise.resolve({
	          value: undefined,
	          done: true
	        });
	      }
	      var requestCapability = (0, _util.createPromiseCapability)();
	      this._requests.push(requestCapability);
	      return requestCapability.promise;
	    },
	    cancel: function PDFDataTransportStreamRangeReader_cancel(reason) {
	      this._done = true;
	      this._requests.forEach(function (requestCapability) {
	        requestCapability.resolve({
	          value: undefined,
	          done: true
	        });
	      });
	      this._requests = [];
	      this._stream._removeRangeReader(this);
	    }
	  };
	  return PDFDataTransportStream;
	}();
	exports.PDFDataTransportStream = PDFDataTransportStream;
	
	/***/ }),
	/* 140 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WorkerMessageHandler = exports.WorkerTask = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _util = __w_pdfjs_require__(0);
	
	var _pdf_manager = __w_pdfjs_require__(141);
	
	var _primitives = __w_pdfjs_require__(2);
	
	var WorkerTask = function WorkerTaskClosure() {
	  function WorkerTask(name) {
	    this.name = name;
	    this.terminated = false;
	    this._capability = (0, _util.createPromiseCapability)();
	  }
	  WorkerTask.prototype = {
	    get finished() {
	      return this._capability.promise;
	    },
	    finish: function finish() {
	      this._capability.resolve();
	    },
	    terminate: function terminate() {
	      this.terminated = true;
	    },
	    ensureNotTerminated: function ensureNotTerminated() {
	      if (this.terminated) {
	        throw new Error('Worker task was terminated');
	      }
	    }
	  };
	  return WorkerTask;
	}();
	;
	var PDFWorkerStream = function PDFWorkerStreamClosure() {
	  function PDFWorkerStream(msgHandler) {
	    this._msgHandler = msgHandler;
	    this._contentLength = null;
	    this._fullRequestReader = null;
	    this._rangeRequestReaders = [];
	  }
	  PDFWorkerStream.prototype = {
	    getFullReader: function getFullReader() {
	      (0, _util.assert)(!this._fullRequestReader);
	      this._fullRequestReader = new PDFWorkerStreamReader(this._msgHandler);
	      return this._fullRequestReader;
	    },
	    getRangeReader: function getRangeReader(begin, end) {
	      var reader = new PDFWorkerStreamRangeReader(begin, end, this._msgHandler);
	      this._rangeRequestReaders.push(reader);
	      return reader;
	    },
	    cancelAllRequests: function cancelAllRequests(reason) {
	      if (this._fullRequestReader) {
	        this._fullRequestReader.cancel(reason);
	      }
	      var readers = this._rangeRequestReaders.slice(0);
	      readers.forEach(function (reader) {
	        reader.cancel(reason);
	      });
	    }
	  };
	  function PDFWorkerStreamReader(msgHandler) {
	    var _this = this;
	
	    this._msgHandler = msgHandler;
	    this._contentLength = null;
	    this._isRangeSupported = false;
	    this._isStreamingSupported = false;
	    var readableStream = this._msgHandler.sendWithStream('GetReader');
	    this._reader = readableStream.getReader();
	    this._headersReady = this._msgHandler.sendWithPromise('ReaderHeadersReady').then(function (data) {
	      _this._isStreamingSupported = data.isStreamingSupported;
	      _this._isRangeSupported = data.isRangeSupported;
	      _this._contentLength = data.contentLength;
	    });
	  }
	  PDFWorkerStreamReader.prototype = {
	    get headersReady() {
	      return this._headersReady;
	    },
	    get contentLength() {
	      return this._contentLength;
	    },
	    get isStreamingSupported() {
	      return this._isStreamingSupported;
	    },
	    get isRangeSupported() {
	      return this._isRangeSupported;
	    },
	    read: function read() {
	      return this._reader.read().then(function (_ref) {
	        var value = _ref.value,
	            done = _ref.done;
	
	        if (done) {
	          return {
	            value: undefined,
	            done: true
	          };
	        }
	        return {
	          value: value.buffer,
	          done: false
	        };
	      });
	    },
	    cancel: function cancel(reason) {
	      this._reader.cancel(reason);
	    }
	  };
	  function PDFWorkerStreamRangeReader(begin, end, msgHandler) {
	    this._msgHandler = msgHandler;
	    this.onProgress = null;
	    var readableStream = this._msgHandler.sendWithStream('GetRangeReader', {
	      begin: begin,
	      end: end
	    });
	    this._reader = readableStream.getReader();
	  }
	  PDFWorkerStreamRangeReader.prototype = {
	    get isStreamingSupported() {
	      return false;
	    },
	    read: function read() {
	      return this._reader.read().then(function (_ref2) {
	        var value = _ref2.value,
	            done = _ref2.done;
	
	        if (done) {
	          return {
	            value: undefined,
	            done: true
	          };
	        }
	        return {
	          value: value.buffer,
	          done: false
	        };
	      });
	    },
	    cancel: function cancel(reason) {
	      this._reader.cancel(reason);
	    }
	  };
	  return PDFWorkerStream;
	}();
	var WorkerMessageHandler = {
	  setup: function setup(handler, port) {
	    var testMessageProcessed = false;
	    handler.on('test', function wphSetupTest(data) {
	      if (testMessageProcessed) {
	        return;
	      }
	      testMessageProcessed = true;
	      if (!(data instanceof Uint8Array)) {
	        handler.send('test', 'main', false);
	        return;
	      }
	      var supportTransfers = data[0] === 255;
	      handler.postMessageTransfers = supportTransfers;
	      var xhr = new XMLHttpRequest();
	      var responseExists = 'response' in xhr;
	      try {
	        xhr.responseType;
	      } catch (e) {
	        responseExists = false;
	      }
	      if (!responseExists) {
	        handler.send('test', false);
	        return;
	      }
	      handler.send('test', {
	        supportTypedArray: true,
	        supportTransfers: supportTransfers
	      });
	    });
	    handler.on('configure', function wphConfigure(data) {
	      (0, _util.setVerbosityLevel)(data.verbosity);
	    });
	    handler.on('GetDocRequest', function wphSetupDoc(data) {
	      return WorkerMessageHandler.createDocumentHandler(data, port);
	    });
	  },
	  createDocumentHandler: function createDocumentHandler(docParams, port) {
	    var pdfManager;
	    var terminated = false;
	    var cancelXHRs = null;
	    var WorkerTasks = [];
	    var apiVersion = docParams.apiVersion;
	    var workerVersion = '1.10.100';
	    if (apiVersion !== null && apiVersion !== workerVersion) {
	      throw new Error('The API version "' + apiVersion + '" does not match ' + ('the Worker version "' + workerVersion + '".'));
	    }
	    var docId = docParams.docId;
	    var docBaseUrl = docParams.docBaseUrl;
	    var workerHandlerName = docParams.docId + '_worker';
	    var handler = new _util.MessageHandler(workerHandlerName, docId, port);
	    handler.postMessageTransfers = docParams.postMessageTransfers;
	    function ensureNotTerminated() {
	      if (terminated) {
	        throw new Error('Worker was terminated');
	      }
	    }
	    function startWorkerTask(task) {
	      WorkerTasks.push(task);
	    }
	    function finishWorkerTask(task) {
	      task.finish();
	      var i = WorkerTasks.indexOf(task);
	      WorkerTasks.splice(i, 1);
	    }
	    function loadDocument(recoveryMode) {
	      var loadDocumentCapability = (0, _util.createPromiseCapability)();
	      var parseSuccess = function parseSuccess() {
	        var numPagesPromise = pdfManager.ensureDoc('numPages');
	        var fingerprintPromise = pdfManager.ensureDoc('fingerprint');
	        var encryptedPromise = pdfManager.ensureXRef('encrypt');
	        Promise.all([numPagesPromise, fingerprintPromise, encryptedPromise]).then(function onDocReady(results) {
	          var doc = {
	            numPages: results[0],
	            fingerprint: results[1],
	            encrypted: !!results[2]
	          };
	          loadDocumentCapability.resolve(doc);
	        }, parseFailure);
	      };
	      var parseFailure = function parseFailure(e) {
	        loadDocumentCapability.reject(e);
	      };
	      pdfManager.ensureDoc('checkHeader', []).then(function () {
	        pdfManager.ensureDoc('parseStartXRef', []).then(function () {
	          pdfManager.ensureDoc('parse', [recoveryMode]).then(parseSuccess, parseFailure);
	        }, parseFailure);
	      }, parseFailure);
	      return loadDocumentCapability.promise;
	    }
	    function getPdfManager(data, evaluatorOptions) {
	      var pdfManagerCapability = (0, _util.createPromiseCapability)();
	      var pdfManager;
	      var source = data.source;
	      if (source.data) {
	        try {
	          pdfManager = new _pdf_manager.LocalPdfManager(docId, source.data, source.password, evaluatorOptions, docBaseUrl);
	          pdfManagerCapability.resolve(pdfManager);
	        } catch (ex) {
	          pdfManagerCapability.reject(ex);
	        }
	        return pdfManagerCapability.promise;
	      }
	      var pdfStream,
	          cachedChunks = [];
	      try {
	        pdfStream = new PDFWorkerStream(handler);
	      } catch (ex) {
	        pdfManagerCapability.reject(ex);
	        return pdfManagerCapability.promise;
	      }
	      var fullRequest = pdfStream.getFullReader();
	      fullRequest.headersReady.then(function () {
	        if (!fullRequest.isRangeSupported) {
	          return;
	        }
	        var disableAutoFetch = source.disableAutoFetch || fullRequest.isStreamingSupported;
	        pdfManager = new _pdf_manager.NetworkPdfManager(docId, pdfStream, {
	          msgHandler: handler,
	          url: source.url,
	          password: source.password,
	          length: fullRequest.contentLength,
	          disableAutoFetch: disableAutoFetch,
	          rangeChunkSize: source.rangeChunkSize
	        }, evaluatorOptions, docBaseUrl);
	        for (var i = 0; i < cachedChunks.length; i++) {
	          pdfManager.sendProgressiveData(cachedChunks[i]);
	        }
	        cachedChunks = [];
	        pdfManagerCapability.resolve(pdfManager);
	        cancelXHRs = null;
	      }).catch(function (reason) {
	        pdfManagerCapability.reject(reason);
	        cancelXHRs = null;
	      });
	      var loaded = 0;
	      var flushChunks = function flushChunks() {
	        var pdfFile = (0, _util.arraysToBytes)(cachedChunks);
	        if (source.length && pdfFile.length !== source.length) {
	          (0, _util.warn)('reported HTTP length is different from actual');
	        }
	        try {
	          pdfManager = new _pdf_manager.LocalPdfManager(docId, pdfFile, source.password, evaluatorOptions, docBaseUrl);
	          pdfManagerCapability.resolve(pdfManager);
	        } catch (ex) {
	          pdfManagerCapability.reject(ex);
	        }
	        cachedChunks = [];
	      };
	      var readPromise = new Promise(function (resolve, reject) {
	        var readChunk = function readChunk(chunk) {
	          try {
	            ensureNotTerminated();
	            if (chunk.done) {
	              if (!pdfManager) {
	                flushChunks();
	              }
	              cancelXHRs = null;
	              return;
	            }
	            var data = chunk.value;
	            loaded += (0, _util.arrayByteLength)(data);
	            if (!fullRequest.isStreamingSupported) {
	              handler.send('DocProgress', {
	                loaded: loaded,
	                total: Math.max(loaded, fullRequest.contentLength || 0)
	              });
	            }
	            if (pdfManager) {
	              pdfManager.sendProgressiveData(data);
	            } else {
	              cachedChunks.push(data);
	            }
	            fullRequest.read().then(readChunk, reject);
	          } catch (e) {
	            reject(e);
	          }
	        };
	        fullRequest.read().then(readChunk, reject);
	      });
	      readPromise.catch(function (e) {
	        pdfManagerCapability.reject(e);
	        cancelXHRs = null;
	      });
	      cancelXHRs = function cancelXHRs() {
	        pdfStream.cancelAllRequests('abort');
	      };
	      return pdfManagerCapability.promise;
	    }
	    function setupDoc(data) {
	      function onSuccess(doc) {
	        ensureNotTerminated();
	        handler.send('GetDoc', { pdfInfo: doc });
	      }
	      function onFailure(e) {
	        ensureNotTerminated();
	        if (e instanceof _util.PasswordException) {
	          var task = new WorkerTask('PasswordException: response ' + e.code);
	          startWorkerTask(task);
	          handler.sendWithPromise('PasswordRequest', e).then(function (data) {
	            finishWorkerTask(task);
	            pdfManager.updatePassword(data.password);
	            pdfManagerReady();
	          }).catch(function (ex) {
	            finishWorkerTask(task);
	            handler.send('PasswordException', ex);
	          }.bind(null, e));
	        } else if (e instanceof _util.InvalidPDFException) {
	          handler.send('InvalidPDF', e);
	        } else if (e instanceof _util.MissingPDFException) {
	          handler.send('MissingPDF', e);
	        } else if (e instanceof _util.UnexpectedResponseException) {
	          handler.send('UnexpectedResponse', e);
	        } else {
	          handler.send('UnknownError', new _util.UnknownErrorException(e.message, e.toString()));
	        }
	      }
	      function pdfManagerReady() {
	        ensureNotTerminated();
	        loadDocument(false).then(onSuccess, function loadFailure(ex) {
	          ensureNotTerminated();
	          if (!(ex instanceof _util.XRefParseException)) {
	            onFailure(ex);
	            return;
	          }
	          pdfManager.requestLoadedStream();
	          pdfManager.onLoadedStream().then(function () {
	            ensureNotTerminated();
	            loadDocument(true).then(onSuccess, onFailure);
	          });
	        }, onFailure);
	      }
	      ensureNotTerminated();
	      var evaluatorOptions = {
	        forceDataSchema: data.disableCreateObjectURL,
	        maxImageSize: data.maxImageSize === undefined ? -1 : data.maxImageSize,
	        disableFontFace: data.disableFontFace,
	        nativeImageDecoderSupport: data.nativeImageDecoderSupport,
	        ignoreErrors: data.ignoreErrors,
	        isEvalSupported: data.isEvalSupported
	      };
	      getPdfManager(data, evaluatorOptions).then(function (newPdfManager) {
	        if (terminated) {
	          newPdfManager.terminate();
	          throw new Error('Worker was terminated');
	        }
	        pdfManager = newPdfManager;
	        handler.send('PDFManagerReady', null);
	        pdfManager.onLoadedStream().then(function (stream) {
	          handler.send('DataLoaded', { length: stream.bytes.byteLength });
	        });
	      }).then(pdfManagerReady, onFailure);
	    }
	    handler.on('GetPage', function wphSetupGetPage(data) {
	      return pdfManager.getPage(data.pageIndex).then(function (page) {
	        var rotatePromise = pdfManager.ensure(page, 'rotate');
	        var refPromise = pdfManager.ensure(page, 'ref');
	        var userUnitPromise = pdfManager.ensure(page, 'userUnit');
	        var viewPromise = pdfManager.ensure(page, 'view');
	        return Promise.all([rotatePromise, refPromise, userUnitPromise, viewPromise]).then(function (results) {
	          return {
	            rotate: results[0],
	            ref: results[1],
	            userUnit: results[2],
	            view: results[3]
	          };
	        });
	      });
	    });
	    handler.on('GetPageIndex', function wphSetupGetPageIndex(data) {
	      var ref = new _primitives.Ref(data.ref.num, data.ref.gen);
	      var catalog = pdfManager.pdfDocument.catalog;
	      return catalog.getPageIndex(ref);
	    });
	    handler.on('GetDestinations', function wphSetupGetDestinations(data) {
	      return pdfManager.ensureCatalog('destinations');
	    });
	    handler.on('GetDestination', function wphSetupGetDestination(data) {
	      return pdfManager.ensureCatalog('getDestination', [data.id]);
	    });
	    handler.on('GetPageLabels', function wphSetupGetPageLabels(data) {
	      return pdfManager.ensureCatalog('pageLabels');
	    });
	    handler.on('GetPageMode', function wphSetupGetPageMode(data) {
	      return pdfManager.ensureCatalog('pageMode');
	    });
	    handler.on('GetAttachments', function wphSetupGetAttachments(data) {
	      return pdfManager.ensureCatalog('attachments');
	    });
	    handler.on('GetJavaScript', function wphSetupGetJavaScript(data) {
	      return pdfManager.ensureCatalog('javaScript');
	    });
	    handler.on('GetOutline', function wphSetupGetOutline(data) {
	      return pdfManager.ensureCatalog('documentOutline');
	    });
	    handler.on('GetMetadata', function wphSetupGetMetadata(data) {
	      return Promise.all([pdfManager.ensureDoc('documentInfo'), pdfManager.ensureCatalog('metadata')]);
	    });
	    handler.on('GetData', function wphSetupGetData(data) {
	      pdfManager.requestLoadedStream();
	      return pdfManager.onLoadedStream().then(function (stream) {
	        return stream.bytes;
	      });
	    });
	    handler.on('GetStats', function wphSetupGetStats(data) {
	      return pdfManager.pdfDocument.xref.stats;
	    });
	    handler.on('GetAnnotations', function wphSetupGetAnnotations(data) {
	      return pdfManager.getPage(data.pageIndex).then(function (page) {
	        return pdfManager.ensure(page, 'getAnnotationsData', [data.intent]);
	      });
	    });
	    handler.on('RenderPageRequest', function wphSetupRenderPage(data) {
	      var pageIndex = data.pageIndex;
	      pdfManager.getPage(pageIndex).then(function (page) {
	        var task = new WorkerTask('RenderPageRequest: page ' + pageIndex);
	        startWorkerTask(task);
	        var pageNum = pageIndex + 1;
	        var start = Date.now();
	        page.getOperatorList({
	          handler: handler,
	          task: task,
	          intent: data.intent,
	          renderInteractiveForms: data.renderInteractiveForms
	        }).then(function (operatorList) {
	          finishWorkerTask(task);
	          (0, _util.info)('page=' + pageNum + ' - getOperatorList: time=' + (Date.now() - start) + 'ms, len=' + operatorList.totalLength);
	        }, function (e) {
	          finishWorkerTask(task);
	          if (task.terminated) {
	            return;
	          }
	          handler.send('UnsupportedFeature', { featureId: _util.UNSUPPORTED_FEATURES.unknown });
	          var minimumStackMessage = 'worker.js: while trying to getPage() and getOperatorList()';
	          var wrappedException;
	          if (typeof e === 'string') {
	            wrappedException = {
	              message: e,
	              stack: minimumStackMessage
	            };
	          } else if ((typeof e === 'undefined' ? 'undefined' : _typeof(e)) === 'object') {
	            wrappedException = {
	              message: e.message || e.toString(),
	              stack: e.stack || minimumStackMessage
	            };
	          } else {
	            wrappedException = {
	              message: 'Unknown exception type: ' + (typeof e === 'undefined' ? 'undefined' : _typeof(e)),
	              stack: minimumStackMessage
	            };
	          }
	          handler.send('PageError', {
	            pageNum: pageNum,
	            error: wrappedException,
	            intent: data.intent
	          });
	        });
	      });
	    }, this);
	    handler.on('GetTextContent', function wphExtractText(data, sink) {
	      var pageIndex = data.pageIndex;
	      sink.onPull = function (desiredSize) {};
	      sink.onCancel = function (reason) {};
	      pdfManager.getPage(pageIndex).then(function (page) {
	        var task = new WorkerTask('GetTextContent: page ' + pageIndex);
	        startWorkerTask(task);
	        var pageNum = pageIndex + 1;
	        var start = Date.now();
	        page.extractTextContent({
	          handler: handler,
	          task: task,
	          sink: sink,
	          normalizeWhitespace: data.normalizeWhitespace,
	          combineTextItems: data.combineTextItems
	        }).then(function () {
	          finishWorkerTask(task);
	          (0, _util.info)('text indexing: page=' + pageNum + ' - time=' + (Date.now() - start) + 'ms');
	          sink.close();
	        }, function (reason) {
	          finishWorkerTask(task);
	          if (task.terminated) {
	            return;
	          }
	          sink.error(reason);
	          throw reason;
	        });
	      });
	    });
	    handler.on('Cleanup', function wphCleanup(data) {
	      return pdfManager.cleanup();
	    });
	    handler.on('Terminate', function wphTerminate(data) {
	      terminated = true;
	      if (pdfManager) {
	        pdfManager.terminate();
	        pdfManager = null;
	      }
	      if (cancelXHRs) {
	        cancelXHRs();
	      }
	      var waitOn = [];
	      WorkerTasks.forEach(function (task) {
	        waitOn.push(task.finished);
	        task.terminate();
	      });
	      return Promise.all(waitOn).then(function () {
	        handler.destroy();
	        handler = null;
	      });
	    });
	    handler.on('Ready', function wphReady(data) {
	      setupDoc(docParams);
	      docParams = null;
	    });
	    return workerHandlerName;
	  },
	  initializeFromPort: function initializeFromPort(port) {
	    var handler = new _util.MessageHandler('worker', 'main', port);
	    WorkerMessageHandler.setup(handler, port);
	    handler.send('ready', null);
	  }
	};
	function isMessagePort(maybePort) {
	  return typeof maybePort.postMessage === 'function' && 'onmessage' in maybePort;
	}
	if (typeof window === 'undefined' && !(0, _util.isNodeJS)() && typeof self !== 'undefined' && isMessagePort(self)) {
	  WorkerMessageHandler.initializeFromPort(self);
	}
	exports.WorkerTask = WorkerTask;
	exports.WorkerMessageHandler = WorkerMessageHandler;
	
	/***/ }),
	/* 141 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NetworkPdfManager = exports.LocalPdfManager = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _chunked_stream = __w_pdfjs_require__(78);
	
	var _document = __w_pdfjs_require__(142);
	
	var _stream = __w_pdfjs_require__(5);
	
	var BasePdfManager = function BasePdfManagerClosure() {
	  function BasePdfManager() {
	    throw new Error('Cannot initialize BaseManagerManager');
	  }
	  BasePdfManager.prototype = {
	    get docId() {
	      return this._docId;
	    },
	    get password() {
	      return this._password;
	    },
	    get docBaseUrl() {
	      var docBaseUrl = null;
	      if (this._docBaseUrl) {
	        var absoluteUrl = (0, _util.createValidAbsoluteUrl)(this._docBaseUrl);
	        if (absoluteUrl) {
	          docBaseUrl = absoluteUrl.href;
	        } else {
	          (0, _util.warn)('Invalid absolute docBaseUrl: "' + this._docBaseUrl + '".');
	        }
	      }
	      return (0, _util.shadow)(this, 'docBaseUrl', docBaseUrl);
	    },
	    onLoadedStream: function BasePdfManager_onLoadedStream() {
	      throw new _util.NotImplementedException();
	    },
	    ensureDoc: function BasePdfManager_ensureDoc(prop, args) {
	      return this.ensure(this.pdfDocument, prop, args);
	    },
	    ensureXRef: function BasePdfManager_ensureXRef(prop, args) {
	      return this.ensure(this.pdfDocument.xref, prop, args);
	    },
	    ensureCatalog: function BasePdfManager_ensureCatalog(prop, args) {
	      return this.ensure(this.pdfDocument.catalog, prop, args);
	    },
	    getPage: function BasePdfManager_getPage(pageIndex) {
	      return this.pdfDocument.getPage(pageIndex);
	    },
	    cleanup: function BasePdfManager_cleanup() {
	      return this.pdfDocument.cleanup();
	    },
	    ensure: function BasePdfManager_ensure(obj, prop, args) {
	      return new _util.NotImplementedException();
	    },
	    requestRange: function BasePdfManager_requestRange(begin, end) {
	      return new _util.NotImplementedException();
	    },
	    requestLoadedStream: function BasePdfManager_requestLoadedStream() {
	      return new _util.NotImplementedException();
	    },
	    sendProgressiveData: function BasePdfManager_sendProgressiveData(chunk) {
	      return new _util.NotImplementedException();
	    },
	    updatePassword: function BasePdfManager_updatePassword(password) {
	      this._password = password;
	    },
	    terminate: function BasePdfManager_terminate() {
	      return new _util.NotImplementedException();
	    }
	  };
	  return BasePdfManager;
	}();
	var LocalPdfManager = function LocalPdfManagerClosure() {
	  function LocalPdfManager(docId, data, password, evaluatorOptions, docBaseUrl) {
	    this._docId = docId;
	    this._password = password;
	    this._docBaseUrl = docBaseUrl;
	    this.evaluatorOptions = evaluatorOptions;
	    var stream = new _stream.Stream(data);
	    this.pdfDocument = new _document.PDFDocument(this, stream);
	    this._loadedStreamCapability = (0, _util.createPromiseCapability)();
	    this._loadedStreamCapability.resolve(stream);
	  }
	  _util.Util.inherit(LocalPdfManager, BasePdfManager, {
	    ensure: function LocalPdfManager_ensure(obj, prop, args) {
	      return new Promise(function (resolve, reject) {
	        try {
	          var value = obj[prop];
	          var result;
	          if (typeof value === 'function') {
	            result = value.apply(obj, args);
	          } else {
	            result = value;
	          }
	          resolve(result);
	        } catch (e) {
	          reject(e);
	        }
	      });
	    },
	    requestRange: function LocalPdfManager_requestRange(begin, end) {
	      return Promise.resolve();
	    },
	    requestLoadedStream: function LocalPdfManager_requestLoadedStream() {},
	    onLoadedStream: function LocalPdfManager_onLoadedStream() {
	      return this._loadedStreamCapability.promise;
	    },
	    terminate: function LocalPdfManager_terminate() {}
	  });
	  return LocalPdfManager;
	}();
	var NetworkPdfManager = function NetworkPdfManagerClosure() {
	  function NetworkPdfManager(docId, pdfNetworkStream, args, evaluatorOptions, docBaseUrl) {
	    this._docId = docId;
	    this._password = args.password;
	    this._docBaseUrl = docBaseUrl;
	    this.msgHandler = args.msgHandler;
	    this.evaluatorOptions = evaluatorOptions;
	    var params = {
	      msgHandler: args.msgHandler,
	      url: args.url,
	      length: args.length,
	      disableAutoFetch: args.disableAutoFetch,
	      rangeChunkSize: args.rangeChunkSize
	    };
	    this.streamManager = new _chunked_stream.ChunkedStreamManager(pdfNetworkStream, params);
	    this.pdfDocument = new _document.PDFDocument(this, this.streamManager.getStream());
	  }
	  _util.Util.inherit(NetworkPdfManager, BasePdfManager, {
	    ensure: function NetworkPdfManager_ensure(obj, prop, args) {
	      var pdfManager = this;
	      return new Promise(function (resolve, reject) {
	        function ensureHelper() {
	          try {
	            var result;
	            var value = obj[prop];
	            if (typeof value === 'function') {
	              result = value.apply(obj, args);
	            } else {
	              result = value;
	            }
	            resolve(result);
	          } catch (e) {
	            if (!(e instanceof _util.MissingDataException)) {
	              reject(e);
	              return;
	            }
	            pdfManager.streamManager.requestRange(e.begin, e.end).then(ensureHelper, reject);
	          }
	        }
	        ensureHelper();
	      });
	    },
	    requestRange: function NetworkPdfManager_requestRange(begin, end) {
	      return this.streamManager.requestRange(begin, end);
	    },
	    requestLoadedStream: function NetworkPdfManager_requestLoadedStream() {
	      this.streamManager.requestAllChunks();
	    },
	    sendProgressiveData: function NetworkPdfManager_sendProgressiveData(chunk) {
	      this.streamManager.onReceiveData({ chunk: chunk });
	    },
	    onLoadedStream: function NetworkPdfManager_onLoadedStream() {
	      return this.streamManager.onLoadedStream();
	    },
	    terminate: function NetworkPdfManager_terminate() {
	      this.streamManager.abort();
	    }
	  });
	  return NetworkPdfManager;
	}();
	exports.LocalPdfManager = LocalPdfManager;
	exports.NetworkPdfManager = NetworkPdfManager;
	
	/***/ }),
	/* 142 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFDocument = exports.Page = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _obj = __w_pdfjs_require__(79);
	
	var _primitives = __w_pdfjs_require__(2);
	
	var _util = __w_pdfjs_require__(0);
	
	var _stream = __w_pdfjs_require__(5);
	
	var _evaluator = __w_pdfjs_require__(83);
	
	var _annotation = __w_pdfjs_require__(159);
	
	var _crypto = __w_pdfjs_require__(82);
	
	var _parser = __w_pdfjs_require__(36);
	
	var _function = __w_pdfjs_require__(87);
	
	var Page = function PageClosure() {
	  var DEFAULT_USER_UNIT = 1.0;
	  var LETTER_SIZE_MEDIABOX = [0, 0, 612, 792];
	  function isAnnotationRenderable(annotation, intent) {
	    return intent === 'display' && annotation.viewable || intent === 'print' && annotation.printable;
	  }
	  function Page(_ref) {
	    var pdfManager = _ref.pdfManager,
	        xref = _ref.xref,
	        pageIndex = _ref.pageIndex,
	        pageDict = _ref.pageDict,
	        ref = _ref.ref,
	        fontCache = _ref.fontCache,
	        builtInCMapCache = _ref.builtInCMapCache,
	        pdfFunctionFactory = _ref.pdfFunctionFactory;
	
	    this.pdfManager = pdfManager;
	    this.pageIndex = pageIndex;
	    this.pageDict = pageDict;
	    this.xref = xref;
	    this.ref = ref;
	    this.fontCache = fontCache;
	    this.builtInCMapCache = builtInCMapCache;
	    this.pdfFunctionFactory = pdfFunctionFactory;
	    this.evaluatorOptions = pdfManager.evaluatorOptions;
	    this.resourcesPromise = null;
	    var uniquePrefix = 'p' + this.pageIndex + '_';
	    var idCounters = { obj: 0 };
	    this.idFactory = {
	      createObjId: function createObjId() {
	        return uniquePrefix + ++idCounters.obj;
	      }
	    };
	  }
	  Page.prototype = {
	    getPageProp: function Page_getPageProp(key) {
	      return this.pageDict.get(key);
	    },
	    getInheritedPageProp: function Page_getInheritedPageProp(key, getArray) {
	      var dict = this.pageDict,
	          valueArray = null,
	          loopCount = 0;
	      var MAX_LOOP_COUNT = 100;
	      getArray = getArray || false;
	      while (dict) {
	        var value = getArray ? dict.getArray(key) : dict.get(key);
	        if (value !== undefined) {
	          if (!valueArray) {
	            valueArray = [];
	          }
	          valueArray.push(value);
	        }
	        if (++loopCount > MAX_LOOP_COUNT) {
	          (0, _util.warn)('getInheritedPageProp: maximum loop count exceeded for ' + key);
	          return valueArray ? valueArray[0] : undefined;
	        }
	        dict = dict.get('Parent');
	      }
	      if (!valueArray) {
	        return undefined;
	      }
	      if (valueArray.length === 1 || !(0, _primitives.isDict)(valueArray[0])) {
	        return valueArray[0];
	      }
	      return _primitives.Dict.merge(this.xref, valueArray);
	    },
	    get content() {
	      return this.getPageProp('Contents');
	    },
	    get resources() {
	      return (0, _util.shadow)(this, 'resources', this.getInheritedPageProp('Resources') || _primitives.Dict.empty);
	    },
	    get mediaBox() {
	      var mediaBox = this.getInheritedPageProp('MediaBox', true);
	      if (!Array.isArray(mediaBox) || mediaBox.length !== 4) {
	        return (0, _util.shadow)(this, 'mediaBox', LETTER_SIZE_MEDIABOX);
	      }
	      return (0, _util.shadow)(this, 'mediaBox', mediaBox);
	    },
	    get cropBox() {
	      var cropBox = this.getInheritedPageProp('CropBox', true);
	      if (!Array.isArray(cropBox) || cropBox.length !== 4) {
	        return (0, _util.shadow)(this, 'cropBox', this.mediaBox);
	      }
	      return (0, _util.shadow)(this, 'cropBox', cropBox);
	    },
	    get userUnit() {
	      var obj = this.getPageProp('UserUnit');
	      if (!(0, _util.isNum)(obj) || obj <= 0) {
	        obj = DEFAULT_USER_UNIT;
	      }
	      return (0, _util.shadow)(this, 'userUnit', obj);
	    },
	    get view() {
	      var mediaBox = this.mediaBox,
	          cropBox = this.cropBox;
	      if (mediaBox === cropBox) {
	        return (0, _util.shadow)(this, 'view', mediaBox);
	      }
	      var intersection = _util.Util.intersect(cropBox, mediaBox);
	      return (0, _util.shadow)(this, 'view', intersection || mediaBox);
	    },
	    get rotate() {
	      var rotate = this.getInheritedPageProp('Rotate') || 0;
	      if (rotate % 90 !== 0) {
	        rotate = 0;
	      } else if (rotate >= 360) {
	        rotate = rotate % 360;
	      } else if (rotate < 0) {
	        rotate = (rotate % 360 + 360) % 360;
	      }
	      return (0, _util.shadow)(this, 'rotate', rotate);
	    },
	    getContentStream: function Page_getContentStream() {
	      var content = this.content;
	      var stream;
	      if (Array.isArray(content)) {
	        var xref = this.xref;
	        var i,
	            n = content.length;
	        var streams = [];
	        for (i = 0; i < n; ++i) {
	          streams.push(xref.fetchIfRef(content[i]));
	        }
	        stream = new _stream.StreamsSequenceStream(streams);
	      } else if ((0, _primitives.isStream)(content)) {
	        stream = content;
	      } else {
	        stream = new _stream.NullStream();
	      }
	      return stream;
	    },
	    loadResources: function Page_loadResources(keys) {
	      var _this = this;
	
	      if (!this.resourcesPromise) {
	        this.resourcesPromise = this.pdfManager.ensure(this, 'resources');
	      }
	      return this.resourcesPromise.then(function () {
	        var objectLoader = new _obj.ObjectLoader(_this.resources, keys, _this.xref);
	        return objectLoader.load();
	      });
	    },
	    getOperatorList: function getOperatorList(_ref2) {
	      var _this2 = this;
	
	      var handler = _ref2.handler,
	          task = _ref2.task,
	          intent = _ref2.intent,
	          renderInteractiveForms = _ref2.renderInteractiveForms;
	
	      var contentStreamPromise = this.pdfManager.ensure(this, 'getContentStream');
	      var resourcesPromise = this.loadResources(['ExtGState', 'ColorSpace', 'Pattern', 'Shading', 'XObject', 'Font']);
	      var partialEvaluator = new _evaluator.PartialEvaluator({
	        pdfManager: this.pdfManager,
	        xref: this.xref,
	        handler: handler,
	        pageIndex: this.pageIndex,
	        idFactory: this.idFactory,
	        fontCache: this.fontCache,
	        builtInCMapCache: this.builtInCMapCache,
	        options: this.evaluatorOptions,
	        pdfFunctionFactory: this.pdfFunctionFactory
	      });
	      var dataPromises = Promise.all([contentStreamPromise, resourcesPromise]);
	      var pageListPromise = dataPromises.then(function (_ref3) {
	        var _ref4 = _slicedToArray(_ref3, 1),
	            contentStream = _ref4[0];
	
	        var opList = new _evaluator.OperatorList(intent, handler, _this2.pageIndex);
	        handler.send('StartRenderPage', {
	          transparency: partialEvaluator.hasBlendModes(_this2.resources),
	          pageIndex: _this2.pageIndex,
	          intent: intent
	        });
	        return partialEvaluator.getOperatorList({
	          stream: contentStream,
	          task: task,
	          resources: _this2.resources,
	          operatorList: opList
	        }).then(function () {
	          return opList;
	        });
	      });
	      var annotationsPromise = this.pdfManager.ensure(this, 'annotations');
	      return Promise.all([pageListPromise, annotationsPromise]).then(function (_ref5) {
	        var _ref6 = _slicedToArray(_ref5, 2),
	            pageOpList = _ref6[0],
	            annotations = _ref6[1];
	
	        if (annotations.length === 0) {
	          pageOpList.flush(true);
	          return pageOpList;
	        }
	        var i,
	            ii,
	            opListPromises = [];
	        for (i = 0, ii = annotations.length; i < ii; i++) {
	          if (isAnnotationRenderable(annotations[i], intent)) {
	            opListPromises.push(annotations[i].getOperatorList(partialEvaluator, task, renderInteractiveForms));
	          }
	        }
	        return Promise.all(opListPromises).then(function (opLists) {
	          pageOpList.addOp(_util.OPS.beginAnnotations, []);
	          for (i = 0, ii = opLists.length; i < ii; i++) {
	            pageOpList.addOpList(opLists[i]);
	          }
	          pageOpList.addOp(_util.OPS.endAnnotations, []);
	          pageOpList.flush(true);
	          return pageOpList;
	        });
	      });
	    },
	    extractTextContent: function extractTextContent(_ref7) {
	      var _this3 = this;
	
	      var handler = _ref7.handler,
	          task = _ref7.task,
	          normalizeWhitespace = _ref7.normalizeWhitespace,
	          sink = _ref7.sink,
	          combineTextItems = _ref7.combineTextItems;
	
	      var contentStreamPromise = this.pdfManager.ensure(this, 'getContentStream');
	      var resourcesPromise = this.loadResources(['ExtGState', 'XObject', 'Font']);
	      var dataPromises = Promise.all([contentStreamPromise, resourcesPromise]);
	      return dataPromises.then(function (_ref8) {
	        var _ref9 = _slicedToArray(_ref8, 1),
	            contentStream = _ref9[0];
	
	        var partialEvaluator = new _evaluator.PartialEvaluator({
	          pdfManager: _this3.pdfManager,
	          xref: _this3.xref,
	          handler: handler,
	          pageIndex: _this3.pageIndex,
	          idFactory: _this3.idFactory,
	          fontCache: _this3.fontCache,
	          builtInCMapCache: _this3.builtInCMapCache,
	          options: _this3.evaluatorOptions,
	          pdfFunctionFactory: _this3.pdfFunctionFactory
	        });
	        return partialEvaluator.getTextContent({
	          stream: contentStream,
	          task: task,
	          resources: _this3.resources,
	          normalizeWhitespace: normalizeWhitespace,
	          combineTextItems: combineTextItems,
	          sink: sink
	        });
	      });
	    },
	
	    getAnnotationsData: function Page_getAnnotationsData(intent) {
	      var annotations = this.annotations;
	      var annotationsData = [];
	      for (var i = 0, n = annotations.length; i < n; ++i) {
	        if (!intent || isAnnotationRenderable(annotations[i], intent)) {
	          annotationsData.push(annotations[i].data);
	        }
	      }
	      return annotationsData;
	    },
	    get annotations() {
	      var annotations = [];
	      var annotationRefs = this.getInheritedPageProp('Annots') || [];
	      for (var i = 0, n = annotationRefs.length; i < n; ++i) {
	        var annotationRef = annotationRefs[i];
	        var annotation = _annotation.AnnotationFactory.create(this.xref, annotationRef, this.pdfManager, this.idFactory);
	        if (annotation) {
	          annotations.push(annotation);
	        }
	      }
	      return (0, _util.shadow)(this, 'annotations', annotations);
	    }
	  };
	  return Page;
	}();
	var PDFDocument = function PDFDocumentClosure() {
	  var FINGERPRINT_FIRST_BYTES = 1024;
	  var EMPTY_FINGERPRINT = '\x00\x00\x00\x00\x00\x00\x00' + '\x00\x00\x00\x00\x00\x00\x00\x00\x00';
	  function PDFDocument(pdfManager, arg) {
	    var stream;
	    if ((0, _primitives.isStream)(arg)) {
	      stream = arg;
	    } else if ((0, _util.isArrayBuffer)(arg)) {
	      stream = new _stream.Stream(arg);
	    } else {
	      throw new Error('PDFDocument: Unknown argument type');
	    }
	    if (stream.length <= 0) {
	      throw new Error('PDFDocument: stream must have data');
	    }
	    this.pdfManager = pdfManager;
	    this.stream = stream;
	    this.xref = new _obj.XRef(stream, pdfManager);
	    var evaluatorOptions = pdfManager.evaluatorOptions;
	    this.pdfFunctionFactory = new _function.PDFFunctionFactory({
	      xref: this.xref,
	      isEvalSupported: evaluatorOptions.isEvalSupported
	    });
	  }
	  function find(stream, needle, limit, backwards) {
	    var pos = stream.pos;
	    var end = stream.end;
	    var strBuf = [];
	    if (pos + limit > end) {
	      limit = end - pos;
	    }
	    for (var n = 0; n < limit; ++n) {
	      strBuf.push(String.fromCharCode(stream.getByte()));
	    }
	    var str = strBuf.join('');
	    stream.pos = pos;
	    var index = backwards ? str.lastIndexOf(needle) : str.indexOf(needle);
	    if (index === -1) {
	      return false;
	    }
	    stream.pos += index;
	    return true;
	  }
	  var DocumentInfoValidators = {
	    get entries() {
	      return (0, _util.shadow)(this, 'entries', {
	        Title: _util.isString,
	        Author: _util.isString,
	        Subject: _util.isString,
	        Keywords: _util.isString,
	        Creator: _util.isString,
	        Producer: _util.isString,
	        CreationDate: _util.isString,
	        ModDate: _util.isString,
	        Trapped: _primitives.isName
	      });
	    }
	  };
	  PDFDocument.prototype = {
	    parse: function PDFDocument_parse(recoveryMode) {
	      this.setup(recoveryMode);
	      var version = this.catalog.catDict.get('Version');
	      if ((0, _primitives.isName)(version)) {
	        this.pdfFormatVersion = version.name;
	      }
	      try {
	        this.acroForm = this.catalog.catDict.get('AcroForm');
	        if (this.acroForm) {
	          this.xfa = this.acroForm.get('XFA');
	          var fields = this.acroForm.get('Fields');
	          if ((!fields || !Array.isArray(fields) || fields.length === 0) && !this.xfa) {
	            this.acroForm = null;
	          }
	        }
	      } catch (ex) {
	        if (ex instanceof _util.MissingDataException) {
	          throw ex;
	        }
	        (0, _util.info)('Something wrong with AcroForm entry');
	        this.acroForm = null;
	      }
	    },
	    get linearization() {
	      var linearization = null;
	      if (this.stream.length) {
	        try {
	          linearization = _parser.Linearization.create(this.stream);
	        } catch (err) {
	          if (err instanceof _util.MissingDataException) {
	            throw err;
	          }
	          (0, _util.info)(err);
	        }
	      }
	      return (0, _util.shadow)(this, 'linearization', linearization);
	    },
	    get startXRef() {
	      var stream = this.stream;
	      var startXRef = 0;
	      var linearization = this.linearization;
	      if (linearization) {
	        stream.reset();
	        if (find(stream, 'endobj', 1024)) {
	          startXRef = stream.pos + 6;
	        }
	      } else {
	        var step = 1024;
	        var found = false,
	            pos = stream.end;
	        while (!found && pos > 0) {
	          pos -= step - 'startxref'.length;
	          if (pos < 0) {
	            pos = 0;
	          }
	          stream.pos = pos;
	          found = find(stream, 'startxref', step, true);
	        }
	        if (found) {
	          stream.skip(9);
	          var ch;
	          do {
	            ch = stream.getByte();
	          } while ((0, _util.isSpace)(ch));
	          var str = '';
	          while (ch >= 0x20 && ch <= 0x39) {
	            str += String.fromCharCode(ch);
	            ch = stream.getByte();
	          }
	          startXRef = parseInt(str, 10);
	          if (isNaN(startXRef)) {
	            startXRef = 0;
	          }
	        }
	      }
	      return (0, _util.shadow)(this, 'startXRef', startXRef);
	    },
	    get mainXRefEntriesOffset() {
	      var mainXRefEntriesOffset = 0;
	      var linearization = this.linearization;
	      if (linearization) {
	        mainXRefEntriesOffset = linearization.mainXRefEntriesOffset;
	      }
	      return (0, _util.shadow)(this, 'mainXRefEntriesOffset', mainXRefEntriesOffset);
	    },
	    checkHeader: function PDFDocument_checkHeader() {
	      var stream = this.stream;
	      stream.reset();
	      if (find(stream, '%PDF-', 1024)) {
	        stream.moveStart();
	        var MAX_VERSION_LENGTH = 12;
	        var version = '',
	            ch;
	        while ((ch = stream.getByte()) > 0x20) {
	          if (version.length >= MAX_VERSION_LENGTH) {
	            break;
	          }
	          version += String.fromCharCode(ch);
	        }
	        if (!this.pdfFormatVersion) {
	          this.pdfFormatVersion = version.substring(5);
	        }
	        return;
	      }
	    },
	    parseStartXRef: function PDFDocument_parseStartXRef() {
	      var startXRef = this.startXRef;
	      this.xref.setStartXRef(startXRef);
	    },
	    setup: function PDFDocument_setup(recoveryMode) {
	      var _this4 = this;
	
	      this.xref.parse(recoveryMode);
	      var pageFactory = {
	        createPage: function createPage(pageIndex, dict, ref, fontCache, builtInCMapCache) {
	          return new Page({
	            pdfManager: _this4.pdfManager,
	            xref: _this4.xref,
	            pageIndex: pageIndex,
	            pageDict: dict,
	            ref: ref,
	            fontCache: fontCache,
	            builtInCMapCache: builtInCMapCache,
	            pdfFunctionFactory: _this4.pdfFunctionFactory
	          });
	        }
	      };
	      this.catalog = new _obj.Catalog(this.pdfManager, this.xref, pageFactory);
	    },
	    get numPages() {
	      var linearization = this.linearization;
	      var num = linearization ? linearization.numPages : this.catalog.numPages;
	      return (0, _util.shadow)(this, 'numPages', num);
	    },
	    get documentInfo() {
	      var docInfo = {
	        PDFFormatVersion: this.pdfFormatVersion,
	        IsAcroFormPresent: !!this.acroForm,
	        IsXFAPresent: !!this.xfa
	      };
	      var infoDict;
	      try {
	        infoDict = this.xref.trailer.get('Info');
	      } catch (err) {
	        if (err instanceof _util.MissingDataException) {
	          throw err;
	        }
	        (0, _util.info)('The document information dictionary is invalid.');
	      }
	      if (infoDict) {
	        var validEntries = DocumentInfoValidators.entries;
	        for (var key in validEntries) {
	          if (infoDict.has(key)) {
	            var value = infoDict.get(key);
	            if (validEntries[key](value)) {
	              docInfo[key] = typeof value !== 'string' ? value : (0, _util.stringToPDFString)(value);
	            } else {
	              (0, _util.info)('Bad value in document info for "' + key + '"');
	            }
	          }
	        }
	      }
	      return (0, _util.shadow)(this, 'documentInfo', docInfo);
	    },
	    get fingerprint() {
	      var xref = this.xref,
	          hash,
	          fileID = '';
	      var idArray = xref.trailer.get('ID');
	      if (Array.isArray(idArray) && idArray[0] && (0, _util.isString)(idArray[0]) && idArray[0] !== EMPTY_FINGERPRINT) {
	        hash = (0, _util.stringToBytes)(idArray[0]);
	      } else {
	        if (this.stream.ensureRange) {
	          this.stream.ensureRange(0, Math.min(FINGERPRINT_FIRST_BYTES, this.stream.end));
	        }
	        hash = (0, _crypto.calculateMD5)(this.stream.bytes.subarray(0, FINGERPRINT_FIRST_BYTES), 0, FINGERPRINT_FIRST_BYTES);
	      }
	      for (var i = 0, n = hash.length; i < n; i++) {
	        var hex = hash[i].toString(16);
	        fileID += hex.length === 1 ? '0' + hex : hex;
	      }
	      return (0, _util.shadow)(this, 'fingerprint', fileID);
	    },
	    getPage: function PDFDocument_getPage(pageIndex) {
	      return this.catalog.getPage(pageIndex);
	    },
	    cleanup: function PDFDocument_cleanup() {
	      return this.catalog.cleanup();
	    }
	  };
	  return PDFDocument;
	}();
	exports.Page = Page;
	exports.PDFDocument = PDFDocument;
	
	/***/ }),
	/* 143 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.JpegImage = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _util = __w_pdfjs_require__(0);
	
	var JpegError = function JpegErrorClosure() {
	  function JpegError(msg) {
	    this.message = 'JPEG error: ' + msg;
	  }
	  JpegError.prototype = new Error();
	  JpegError.prototype.name = 'JpegError';
	  JpegError.constructor = JpegError;
	  return JpegError;
	}();
	var JpegImage = function JpegImageClosure() {
	  var dctZigZag = new Uint8Array([0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19, 26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49, 56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52, 45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63]);
	  var dctCos1 = 4017;
	  var dctSin1 = 799;
	  var dctCos3 = 3406;
	  var dctSin3 = 2276;
	  var dctCos6 = 1567;
	  var dctSin6 = 3784;
	  var dctSqrt2 = 5793;
	  var dctSqrt1d2 = 2896;
	  function JpegImage() {
	    this.decodeTransform = null;
	    this.colorTransform = -1;
	  }
	  function buildHuffmanTable(codeLengths, values) {
	    var k = 0,
	        code = [],
	        i,
	        j,
	        length = 16;
	    while (length > 0 && !codeLengths[length - 1]) {
	      length--;
	    }
	    code.push({
	      children: [],
	      index: 0
	    });
	    var p = code[0],
	        q;
	    for (i = 0; i < length; i++) {
	      for (j = 0; j < codeLengths[i]; j++) {
	        p = code.pop();
	        p.children[p.index] = values[k];
	        while (p.index > 0) {
	          p = code.pop();
	        }
	        p.index++;
	        code.push(p);
	        while (code.length <= i) {
	          code.push(q = {
	            children: [],
	            index: 0
	          });
	          p.children[p.index] = q.children;
	          p = q;
	        }
	        k++;
	      }
	      if (i + 1 < length) {
	        code.push(q = {
	          children: [],
	          index: 0
	        });
	        p.children[p.index] = q.children;
	        p = q;
	      }
	    }
	    return code[0].children;
	  }
	  function getBlockBufferOffset(component, row, col) {
	    return 64 * ((component.blocksPerLine + 1) * row + col);
	  }
	  function decodeScan(data, offset, frame, components, resetInterval, spectralStart, spectralEnd, successivePrev, successive) {
	    var mcusPerLine = frame.mcusPerLine;
	    var progressive = frame.progressive;
	    var startOffset = offset,
	        bitsData = 0,
	        bitsCount = 0;
	    function readBit() {
	      if (bitsCount > 0) {
	        bitsCount--;
	        return bitsData >> bitsCount & 1;
	      }
	      bitsData = data[offset++];
	      if (bitsData === 0xFF) {
	        var nextByte = data[offset++];
	        if (nextByte) {
	          throw new JpegError('unexpected marker ' + (bitsData << 8 | nextByte).toString(16));
	        }
	      }
	      bitsCount = 7;
	      return bitsData >>> 7;
	    }
	    function decodeHuffman(tree) {
	      var node = tree;
	      while (true) {
	        node = node[readBit()];
	        if (typeof node === 'number') {
	          return node;
	        }
	        if ((typeof node === 'undefined' ? 'undefined' : _typeof(node)) !== 'object') {
	          throw new JpegError('invalid huffman sequence');
	        }
	      }
	    }
	    function receive(length) {
	      var n = 0;
	      while (length > 0) {
	        n = n << 1 | readBit();
	        length--;
	      }
	      return n;
	    }
	    function receiveAndExtend(length) {
	      if (length === 1) {
	        return readBit() === 1 ? 1 : -1;
	      }
	      var n = receive(length);
	      if (n >= 1 << length - 1) {
	        return n;
	      }
	      return n + (-1 << length) + 1;
	    }
	    function decodeBaseline(component, offset) {
	      var t = decodeHuffman(component.huffmanTableDC);
	      var diff = t === 0 ? 0 : receiveAndExtend(t);
	      component.blockData[offset] = component.pred += diff;
	      var k = 1;
	      while (k < 64) {
	        var rs = decodeHuffman(component.huffmanTableAC);
	        var s = rs & 15,
	            r = rs >> 4;
	        if (s === 0) {
	          if (r < 15) {
	            break;
	          }
	          k += 16;
	          continue;
	        }
	        k += r;
	        var z = dctZigZag[k];
	        component.blockData[offset + z] = receiveAndExtend(s);
	        k++;
	      }
	    }
	    function decodeDCFirst(component, offset) {
	      var t = decodeHuffman(component.huffmanTableDC);
	      var diff = t === 0 ? 0 : receiveAndExtend(t) << successive;
	      component.blockData[offset] = component.pred += diff;
	    }
	    function decodeDCSuccessive(component, offset) {
	      component.blockData[offset] |= readBit() << successive;
	    }
	    var eobrun = 0;
	    function decodeACFirst(component, offset) {
	      if (eobrun > 0) {
	        eobrun--;
	        return;
	      }
	      var k = spectralStart,
	          e = spectralEnd;
	      while (k <= e) {
	        var rs = decodeHuffman(component.huffmanTableAC);
	        var s = rs & 15,
	            r = rs >> 4;
	        if (s === 0) {
	          if (r < 15) {
	            eobrun = receive(r) + (1 << r) - 1;
	            break;
	          }
	          k += 16;
	          continue;
	        }
	        k += r;
	        var z = dctZigZag[k];
	        component.blockData[offset + z] = receiveAndExtend(s) * (1 << successive);
	        k++;
	      }
	    }
	    var successiveACState = 0,
	        successiveACNextValue;
	    function decodeACSuccessive(component, offset) {
	      var k = spectralStart;
	      var e = spectralEnd;
	      var r = 0;
	      var s;
	      var rs;
	      while (k <= e) {
	        var z = dctZigZag[k];
	        switch (successiveACState) {
	          case 0:
	            rs = decodeHuffman(component.huffmanTableAC);
	            s = rs & 15;
	            r = rs >> 4;
	            if (s === 0) {
	              if (r < 15) {
	                eobrun = receive(r) + (1 << r);
	                successiveACState = 4;
	              } else {
	                r = 16;
	                successiveACState = 1;
	              }
	            } else {
	              if (s !== 1) {
	                throw new JpegError('invalid ACn encoding');
	              }
	              successiveACNextValue = receiveAndExtend(s);
	              successiveACState = r ? 2 : 3;
	            }
	            continue;
	          case 1:
	          case 2:
	            if (component.blockData[offset + z]) {
	              component.blockData[offset + z] += readBit() << successive;
	            } else {
	              r--;
	              if (r === 0) {
	                successiveACState = successiveACState === 2 ? 3 : 0;
	              }
	            }
	            break;
	          case 3:
	            if (component.blockData[offset + z]) {
	              component.blockData[offset + z] += readBit() << successive;
	            } else {
	              component.blockData[offset + z] = successiveACNextValue << successive;
	              successiveACState = 0;
	            }
	            break;
	          case 4:
	            if (component.blockData[offset + z]) {
	              component.blockData[offset + z] += readBit() << successive;
	            }
	            break;
	        }
	        k++;
	      }
	      if (successiveACState === 4) {
	        eobrun--;
	        if (eobrun === 0) {
	          successiveACState = 0;
	        }
	      }
	    }
	    function decodeMcu(component, decode, mcu, row, col) {
	      var mcuRow = mcu / mcusPerLine | 0;
	      var mcuCol = mcu % mcusPerLine;
	      var blockRow = mcuRow * component.v + row;
	      var blockCol = mcuCol * component.h + col;
	      var offset = getBlockBufferOffset(component, blockRow, blockCol);
	      decode(component, offset);
	    }
	    function decodeBlock(component, decode, mcu) {
	      var blockRow = mcu / component.blocksPerLine | 0;
	      var blockCol = mcu % component.blocksPerLine;
	      var offset = getBlockBufferOffset(component, blockRow, blockCol);
	      decode(component, offset);
	    }
	    var componentsLength = components.length;
	    var component, i, j, k, n;
	    var decodeFn;
	    if (progressive) {
	      if (spectralStart === 0) {
	        decodeFn = successivePrev === 0 ? decodeDCFirst : decodeDCSuccessive;
	      } else {
	        decodeFn = successivePrev === 0 ? decodeACFirst : decodeACSuccessive;
	      }
	    } else {
	      decodeFn = decodeBaseline;
	    }
	    var mcu = 0,
	        fileMarker;
	    var mcuExpected;
	    if (componentsLength === 1) {
	      mcuExpected = components[0].blocksPerLine * components[0].blocksPerColumn;
	    } else {
	      mcuExpected = mcusPerLine * frame.mcusPerColumn;
	    }
	    var h, v;
	    while (mcu < mcuExpected) {
	      var mcuToRead = resetInterval ? Math.min(mcuExpected - mcu, resetInterval) : mcuExpected;
	      for (i = 0; i < componentsLength; i++) {
	        components[i].pred = 0;
	      }
	      eobrun = 0;
	      if (componentsLength === 1) {
	        component = components[0];
	        for (n = 0; n < mcuToRead; n++) {
	          decodeBlock(component, decodeFn, mcu);
	          mcu++;
	        }
	      } else {
	        for (n = 0; n < mcuToRead; n++) {
	          for (i = 0; i < componentsLength; i++) {
	            component = components[i];
	            h = component.h;
	            v = component.v;
	            for (j = 0; j < v; j++) {
	              for (k = 0; k < h; k++) {
	                decodeMcu(component, decodeFn, mcu, j, k);
	              }
	            }
	          }
	          mcu++;
	        }
	      }
	      bitsCount = 0;
	      fileMarker = findNextFileMarker(data, offset);
	      if (fileMarker && fileMarker.invalid) {
	        (0, _util.warn)('decodeScan - unexpected MCU data, next marker is: ' + fileMarker.invalid);
	        offset = fileMarker.offset;
	      }
	      var marker = fileMarker && fileMarker.marker;
	      if (!marker || marker <= 0xFF00) {
	        throw new JpegError('marker was not found');
	      }
	      if (marker >= 0xFFD0 && marker <= 0xFFD7) {
	        offset += 2;
	      } else {
	        break;
	      }
	    }
	    fileMarker = findNextFileMarker(data, offset);
	    if (fileMarker && fileMarker.invalid) {
	      (0, _util.warn)('decodeScan - unexpected Scan data, next marker is: ' + fileMarker.invalid);
	      offset = fileMarker.offset;
	    }
	    return offset - startOffset;
	  }
	  function quantizeAndInverse(component, blockBufferOffset, p) {
	    var qt = component.quantizationTable,
	        blockData = component.blockData;
	    var v0, v1, v2, v3, v4, v5, v6, v7;
	    var p0, p1, p2, p3, p4, p5, p6, p7;
	    var t;
	    if (!qt) {
	      throw new JpegError('missing required Quantization Table.');
	    }
	    for (var row = 0; row < 64; row += 8) {
	      p0 = blockData[blockBufferOffset + row];
	      p1 = blockData[blockBufferOffset + row + 1];
	      p2 = blockData[blockBufferOffset + row + 2];
	      p3 = blockData[blockBufferOffset + row + 3];
	      p4 = blockData[blockBufferOffset + row + 4];
	      p5 = blockData[blockBufferOffset + row + 5];
	      p6 = blockData[blockBufferOffset + row + 6];
	      p7 = blockData[blockBufferOffset + row + 7];
	      p0 *= qt[row];
	      if ((p1 | p2 | p3 | p4 | p5 | p6 | p7) === 0) {
	        t = dctSqrt2 * p0 + 512 >> 10;
	        p[row] = t;
	        p[row + 1] = t;
	        p[row + 2] = t;
	        p[row + 3] = t;
	        p[row + 4] = t;
	        p[row + 5] = t;
	        p[row + 6] = t;
	        p[row + 7] = t;
	        continue;
	      }
	      p1 *= qt[row + 1];
	      p2 *= qt[row + 2];
	      p3 *= qt[row + 3];
	      p4 *= qt[row + 4];
	      p5 *= qt[row + 5];
	      p6 *= qt[row + 6];
	      p7 *= qt[row + 7];
	      v0 = dctSqrt2 * p0 + 128 >> 8;
	      v1 = dctSqrt2 * p4 + 128 >> 8;
	      v2 = p2;
	      v3 = p6;
	      v4 = dctSqrt1d2 * (p1 - p7) + 128 >> 8;
	      v7 = dctSqrt1d2 * (p1 + p7) + 128 >> 8;
	      v5 = p3 << 4;
	      v6 = p5 << 4;
	      v0 = v0 + v1 + 1 >> 1;
	      v1 = v0 - v1;
	      t = v2 * dctSin6 + v3 * dctCos6 + 128 >> 8;
	      v2 = v2 * dctCos6 - v3 * dctSin6 + 128 >> 8;
	      v3 = t;
	      v4 = v4 + v6 + 1 >> 1;
	      v6 = v4 - v6;
	      v7 = v7 + v5 + 1 >> 1;
	      v5 = v7 - v5;
	      v0 = v0 + v3 + 1 >> 1;
	      v3 = v0 - v3;
	      v1 = v1 + v2 + 1 >> 1;
	      v2 = v1 - v2;
	      t = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
	      v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
	      v7 = t;
	      t = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
	      v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
	      v6 = t;
	      p[row] = v0 + v7;
	      p[row + 7] = v0 - v7;
	      p[row + 1] = v1 + v6;
	      p[row + 6] = v1 - v6;
	      p[row + 2] = v2 + v5;
	      p[row + 5] = v2 - v5;
	      p[row + 3] = v3 + v4;
	      p[row + 4] = v3 - v4;
	    }
	    for (var col = 0; col < 8; ++col) {
	      p0 = p[col];
	      p1 = p[col + 8];
	      p2 = p[col + 16];
	      p3 = p[col + 24];
	      p4 = p[col + 32];
	      p5 = p[col + 40];
	      p6 = p[col + 48];
	      p7 = p[col + 56];
	      if ((p1 | p2 | p3 | p4 | p5 | p6 | p7) === 0) {
	        t = dctSqrt2 * p0 + 8192 >> 14;
	        t = t < -2040 ? 0 : t >= 2024 ? 255 : t + 2056 >> 4;
	        blockData[blockBufferOffset + col] = t;
	        blockData[blockBufferOffset + col + 8] = t;
	        blockData[blockBufferOffset + col + 16] = t;
	        blockData[blockBufferOffset + col + 24] = t;
	        blockData[blockBufferOffset + col + 32] = t;
	        blockData[blockBufferOffset + col + 40] = t;
	        blockData[blockBufferOffset + col + 48] = t;
	        blockData[blockBufferOffset + col + 56] = t;
	        continue;
	      }
	      v0 = dctSqrt2 * p0 + 2048 >> 12;
	      v1 = dctSqrt2 * p4 + 2048 >> 12;
	      v2 = p2;
	      v3 = p6;
	      v4 = dctSqrt1d2 * (p1 - p7) + 2048 >> 12;
	      v7 = dctSqrt1d2 * (p1 + p7) + 2048 >> 12;
	      v5 = p3;
	      v6 = p5;
	      v0 = (v0 + v1 + 1 >> 1) + 4112;
	      v1 = v0 - v1;
	      t = v2 * dctSin6 + v3 * dctCos6 + 2048 >> 12;
	      v2 = v2 * dctCos6 - v3 * dctSin6 + 2048 >> 12;
	      v3 = t;
	      v4 = v4 + v6 + 1 >> 1;
	      v6 = v4 - v6;
	      v7 = v7 + v5 + 1 >> 1;
	      v5 = v7 - v5;
	      v0 = v0 + v3 + 1 >> 1;
	      v3 = v0 - v3;
	      v1 = v1 + v2 + 1 >> 1;
	      v2 = v1 - v2;
	      t = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
	      v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
	      v7 = t;
	      t = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
	      v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
	      v6 = t;
	      p0 = v0 + v7;
	      p7 = v0 - v7;
	      p1 = v1 + v6;
	      p6 = v1 - v6;
	      p2 = v2 + v5;
	      p5 = v2 - v5;
	      p3 = v3 + v4;
	      p4 = v3 - v4;
	      p0 = p0 < 16 ? 0 : p0 >= 4080 ? 255 : p0 >> 4;
	      p1 = p1 < 16 ? 0 : p1 >= 4080 ? 255 : p1 >> 4;
	      p2 = p2 < 16 ? 0 : p2 >= 4080 ? 255 : p2 >> 4;
	      p3 = p3 < 16 ? 0 : p3 >= 4080 ? 255 : p3 >> 4;
	      p4 = p4 < 16 ? 0 : p4 >= 4080 ? 255 : p4 >> 4;
	      p5 = p5 < 16 ? 0 : p5 >= 4080 ? 255 : p5 >> 4;
	      p6 = p6 < 16 ? 0 : p6 >= 4080 ? 255 : p6 >> 4;
	      p7 = p7 < 16 ? 0 : p7 >= 4080 ? 255 : p7 >> 4;
	      blockData[blockBufferOffset + col] = p0;
	      blockData[blockBufferOffset + col + 8] = p1;
	      blockData[blockBufferOffset + col + 16] = p2;
	      blockData[blockBufferOffset + col + 24] = p3;
	      blockData[blockBufferOffset + col + 32] = p4;
	      blockData[blockBufferOffset + col + 40] = p5;
	      blockData[blockBufferOffset + col + 48] = p6;
	      blockData[blockBufferOffset + col + 56] = p7;
	    }
	  }
	  function buildComponentData(frame, component) {
	    var blocksPerLine = component.blocksPerLine;
	    var blocksPerColumn = component.blocksPerColumn;
	    var computationBuffer = new Int16Array(64);
	    for (var blockRow = 0; blockRow < blocksPerColumn; blockRow++) {
	      for (var blockCol = 0; blockCol < blocksPerLine; blockCol++) {
	        var offset = getBlockBufferOffset(component, blockRow, blockCol);
	        quantizeAndInverse(component, offset, computationBuffer);
	      }
	    }
	    return component.blockData;
	  }
	  function findNextFileMarker(data, currentPos, startPos) {
	    function peekUint16(pos) {
	      return data[pos] << 8 | data[pos + 1];
	    }
	    var maxPos = data.length - 1;
	    var newPos = startPos < currentPos ? startPos : currentPos;
	    if (currentPos >= maxPos) {
	      return null;
	    }
	    var currentMarker = peekUint16(currentPos);
	    if (currentMarker >= 0xFFC0 && currentMarker <= 0xFFFE) {
	      return {
	        invalid: null,
	        marker: currentMarker,
	        offset: currentPos
	      };
	    }
	    var newMarker = peekUint16(newPos);
	    while (!(newMarker >= 0xFFC0 && newMarker <= 0xFFFE)) {
	      if (++newPos >= maxPos) {
	        return null;
	      }
	      newMarker = peekUint16(newPos);
	    }
	    return {
	      invalid: currentMarker.toString(16),
	      marker: newMarker,
	      offset: newPos
	    };
	  }
	  JpegImage.prototype = {
	    parse: function parse(data) {
	      function readUint16() {
	        var value = data[offset] << 8 | data[offset + 1];
	        offset += 2;
	        return value;
	      }
	      function readDataBlock() {
	        var length = readUint16();
	        var endOffset = offset + length - 2;
	        var fileMarker = findNextFileMarker(data, endOffset, offset);
	        if (fileMarker && fileMarker.invalid) {
	          (0, _util.warn)('readDataBlock - incorrect length, next marker is: ' + fileMarker.invalid);
	          endOffset = fileMarker.offset;
	        }
	        var array = data.subarray(offset, endOffset);
	        offset += array.length;
	        return array;
	      }
	      function prepareComponents(frame) {
	        var mcusPerLine = Math.ceil(frame.samplesPerLine / 8 / frame.maxH);
	        var mcusPerColumn = Math.ceil(frame.scanLines / 8 / frame.maxV);
	        for (var i = 0; i < frame.components.length; i++) {
	          component = frame.components[i];
	          var blocksPerLine = Math.ceil(Math.ceil(frame.samplesPerLine / 8) * component.h / frame.maxH);
	          var blocksPerColumn = Math.ceil(Math.ceil(frame.scanLines / 8) * component.v / frame.maxV);
	          var blocksPerLineForMcu = mcusPerLine * component.h;
	          var blocksPerColumnForMcu = mcusPerColumn * component.v;
	          var blocksBufferSize = 64 * blocksPerColumnForMcu * (blocksPerLineForMcu + 1);
	          component.blockData = new Int16Array(blocksBufferSize);
	          component.blocksPerLine = blocksPerLine;
	          component.blocksPerColumn = blocksPerColumn;
	        }
	        frame.mcusPerLine = mcusPerLine;
	        frame.mcusPerColumn = mcusPerColumn;
	      }
	      var offset = 0;
	      var jfif = null;
	      var adobe = null;
	      var frame, resetInterval;
	      var quantizationTables = [];
	      var huffmanTablesAC = [],
	          huffmanTablesDC = [];
	      var fileMarker = readUint16();
	      if (fileMarker !== 0xFFD8) {
	        throw new JpegError('SOI not found');
	      }
	      fileMarker = readUint16();
	      while (fileMarker !== 0xFFD9) {
	        var i, j, l;
	        switch (fileMarker) {
	          case 0xFFE0:
	          case 0xFFE1:
	          case 0xFFE2:
	          case 0xFFE3:
	          case 0xFFE4:
	          case 0xFFE5:
	          case 0xFFE6:
	          case 0xFFE7:
	          case 0xFFE8:
	          case 0xFFE9:
	          case 0xFFEA:
	          case 0xFFEB:
	          case 0xFFEC:
	          case 0xFFED:
	          case 0xFFEE:
	          case 0xFFEF:
	          case 0xFFFE:
	            var appData = readDataBlock();
	            if (fileMarker === 0xFFE0) {
	              if (appData[0] === 0x4A && appData[1] === 0x46 && appData[2] === 0x49 && appData[3] === 0x46 && appData[4] === 0) {
	                jfif = {
	                  version: {
	                    major: appData[5],
	                    minor: appData[6]
	                  },
	                  densityUnits: appData[7],
	                  xDensity: appData[8] << 8 | appData[9],
	                  yDensity: appData[10] << 8 | appData[11],
	                  thumbWidth: appData[12],
	                  thumbHeight: appData[13],
	                  thumbData: appData.subarray(14, 14 + 3 * appData[12] * appData[13])
	                };
	              }
	            }
	            if (fileMarker === 0xFFEE) {
	              if (appData[0] === 0x41 && appData[1] === 0x64 && appData[2] === 0x6F && appData[3] === 0x62 && appData[4] === 0x65) {
	                adobe = {
	                  version: appData[5] << 8 | appData[6],
	                  flags0: appData[7] << 8 | appData[8],
	                  flags1: appData[9] << 8 | appData[10],
	                  transformCode: appData[11]
	                };
	              }
	            }
	            break;
	          case 0xFFDB:
	            var quantizationTablesLength = readUint16();
	            var quantizationTablesEnd = quantizationTablesLength + offset - 2;
	            var z;
	            while (offset < quantizationTablesEnd) {
	              var quantizationTableSpec = data[offset++];
	              var tableData = new Uint16Array(64);
	              if (quantizationTableSpec >> 4 === 0) {
	                for (j = 0; j < 64; j++) {
	                  z = dctZigZag[j];
	                  tableData[z] = data[offset++];
	                }
	              } else if (quantizationTableSpec >> 4 === 1) {
	                for (j = 0; j < 64; j++) {
	                  z = dctZigZag[j];
	                  tableData[z] = readUint16();
	                }
	              } else {
	                throw new JpegError('DQT - invalid table spec');
	              }
	              quantizationTables[quantizationTableSpec & 15] = tableData;
	            }
	            break;
	          case 0xFFC0:
	          case 0xFFC1:
	          case 0xFFC2:
	            if (frame) {
	              throw new JpegError('Only single frame JPEGs supported');
	            }
	            readUint16();
	            frame = {};
	            frame.extended = fileMarker === 0xFFC1;
	            frame.progressive = fileMarker === 0xFFC2;
	            frame.precision = data[offset++];
	            frame.scanLines = readUint16();
	            frame.samplesPerLine = readUint16();
	            frame.components = [];
	            frame.componentIds = {};
	            var componentsCount = data[offset++],
	                componentId;
	            var maxH = 0,
	                maxV = 0;
	            for (i = 0; i < componentsCount; i++) {
	              componentId = data[offset];
	              var h = data[offset + 1] >> 4;
	              var v = data[offset + 1] & 15;
	              if (maxH < h) {
	                maxH = h;
	              }
	              if (maxV < v) {
	                maxV = v;
	              }
	              var qId = data[offset + 2];
	              l = frame.components.push({
	                h: h,
	                v: v,
	                quantizationId: qId,
	                quantizationTable: null
	              });
	              frame.componentIds[componentId] = l - 1;
	              offset += 3;
	            }
	            frame.maxH = maxH;
	            frame.maxV = maxV;
	            prepareComponents(frame);
	            break;
	          case 0xFFC4:
	            var huffmanLength = readUint16();
	            for (i = 2; i < huffmanLength;) {
	              var huffmanTableSpec = data[offset++];
	              var codeLengths = new Uint8Array(16);
	              var codeLengthSum = 0;
	              for (j = 0; j < 16; j++, offset++) {
	                codeLengthSum += codeLengths[j] = data[offset];
	              }
	              var huffmanValues = new Uint8Array(codeLengthSum);
	              for (j = 0; j < codeLengthSum; j++, offset++) {
	                huffmanValues[j] = data[offset];
	              }
	              i += 17 + codeLengthSum;
	              (huffmanTableSpec >> 4 === 0 ? huffmanTablesDC : huffmanTablesAC)[huffmanTableSpec & 15] = buildHuffmanTable(codeLengths, huffmanValues);
	            }
	            break;
	          case 0xFFDD:
	            readUint16();
	            resetInterval = readUint16();
	            break;
	          case 0xFFDA:
	            readUint16();
	            var selectorsCount = data[offset++];
	            var components = [],
	                component;
	            for (i = 0; i < selectorsCount; i++) {
	              var componentIndex = frame.componentIds[data[offset++]];
	              component = frame.components[componentIndex];
	              var tableSpec = data[offset++];
	              component.huffmanTableDC = huffmanTablesDC[tableSpec >> 4];
	              component.huffmanTableAC = huffmanTablesAC[tableSpec & 15];
	              components.push(component);
	            }
	            var spectralStart = data[offset++];
	            var spectralEnd = data[offset++];
	            var successiveApproximation = data[offset++];
	            var processed = decodeScan(data, offset, frame, components, resetInterval, spectralStart, spectralEnd, successiveApproximation >> 4, successiveApproximation & 15);
	            offset += processed;
	            break;
	          case 0xFFFF:
	            if (data[offset] !== 0xFF) {
	              offset--;
	            }
	            break;
	          default:
	            if (data[offset - 3] === 0xFF && data[offset - 2] >= 0xC0 && data[offset - 2] <= 0xFE) {
	              offset -= 3;
	              break;
	            }
	            throw new JpegError('unknown marker ' + fileMarker.toString(16));
	        }
	        fileMarker = readUint16();
	      }
	      this.width = frame.samplesPerLine;
	      this.height = frame.scanLines;
	      this.jfif = jfif;
	      this.adobe = adobe;
	      this.components = [];
	      for (i = 0; i < frame.components.length; i++) {
	        component = frame.components[i];
	        var quantizationTable = quantizationTables[component.quantizationId];
	        if (quantizationTable) {
	          component.quantizationTable = quantizationTable;
	        }
	        this.components.push({
	          output: buildComponentData(frame, component),
	          scaleX: component.h / frame.maxH,
	          scaleY: component.v / frame.maxV,
	          blocksPerLine: component.blocksPerLine,
	          blocksPerColumn: component.blocksPerColumn
	        });
	      }
	      this.numComponents = this.components.length;
	    },
	    _getLinearizedBlockData: function getLinearizedBlockData(width, height) {
	      var scaleX = this.width / width,
	          scaleY = this.height / height;
	      var component, componentScaleX, componentScaleY, blocksPerScanline;
	      var x, y, i, j, k;
	      var index;
	      var offset = 0;
	      var output;
	      var numComponents = this.components.length;
	      var dataLength = width * height * numComponents;
	      var data = new Uint8ClampedArray(dataLength);
	      var xScaleBlockOffset = new Uint32Array(width);
	      var mask3LSB = 0xfffffff8;
	      for (i = 0; i < numComponents; i++) {
	        component = this.components[i];
	        componentScaleX = component.scaleX * scaleX;
	        componentScaleY = component.scaleY * scaleY;
	        offset = i;
	        output = component.output;
	        blocksPerScanline = component.blocksPerLine + 1 << 3;
	        for (x = 0; x < width; x++) {
	          j = 0 | x * componentScaleX;
	          xScaleBlockOffset[x] = (j & mask3LSB) << 3 | j & 7;
	        }
	        for (y = 0; y < height; y++) {
	          j = 0 | y * componentScaleY;
	          index = blocksPerScanline * (j & mask3LSB) | (j & 7) << 3;
	          for (x = 0; x < width; x++) {
	            data[offset] = output[index + xScaleBlockOffset[x]];
	            offset += numComponents;
	          }
	        }
	      }
	      var transform = this.decodeTransform;
	      if (transform) {
	        for (i = 0; i < dataLength;) {
	          for (j = 0, k = 0; j < numComponents; j++, i++, k += 2) {
	            data[i] = (data[i] * transform[k] >> 8) + transform[k + 1];
	          }
	        }
	      }
	      return data;
	    },
	    _isColorConversionNeeded: function _isColorConversionNeeded() {
	      if (this.adobe) {
	        return !!this.adobe.transformCode;
	      }
	      if (this.numComponents === 3) {
	        if (this.colorTransform === 0) {
	          return false;
	        }
	        return true;
	      }
	      if (this.colorTransform === 1) {
	        return true;
	      }
	      return false;
	    },
	
	    _convertYccToRgb: function convertYccToRgb(data) {
	      var Y, Cb, Cr;
	      for (var i = 0, length = data.length; i < length; i += 3) {
	        Y = data[i];
	        Cb = data[i + 1];
	        Cr = data[i + 2];
	        data[i] = Y - 179.456 + 1.402 * Cr;
	        data[i + 1] = Y + 135.459 - 0.344 * Cb - 0.714 * Cr;
	        data[i + 2] = Y - 226.816 + 1.772 * Cb;
	      }
	      return data;
	    },
	    _convertYcckToRgb: function convertYcckToRgb(data) {
	      var Y, Cb, Cr, k;
	      var offset = 0;
	      for (var i = 0, length = data.length; i < length; i += 4) {
	        Y = data[i];
	        Cb = data[i + 1];
	        Cr = data[i + 2];
	        k = data[i + 3];
	        data[offset++] = -122.67195406894 + Cb * (-6.60635669420364e-5 * Cb + 0.000437130475926232 * Cr - 5.4080610064599e-5 * Y + 0.00048449797120281 * k - 0.154362151871126) + Cr * (-0.000957964378445773 * Cr + 0.000817076911346625 * Y - 0.00477271405408747 * k + 1.53380253221734) + Y * (0.000961250184130688 * Y - 0.00266257332283933 * k + 0.48357088451265) + k * (-0.000336197177618394 * k + 0.484791561490776);
	        data[offset++] = 107.268039397724 + Cb * (2.19927104525741e-5 * Cb - 0.000640992018297945 * Cr + 0.000659397001245577 * Y + 0.000426105652938837 * k - 0.176491792462875) + Cr * (-0.000778269941513683 * Cr + 0.00130872261408275 * Y + 0.000770482631801132 * k - 0.151051492775562) + Y * (0.00126935368114843 * Y - 0.00265090189010898 * k + 0.25802910206845) + k * (-0.000318913117588328 * k - 0.213742400323665);
	        data[offset++] = -20.810012546947 + Cb * (-0.000570115196973677 * Cb - 2.63409051004589e-5 * Cr + 0.0020741088115012 * Y - 0.00288260236853442 * k + 0.814272968359295) + Cr * (-1.53496057440975e-5 * Cr - 0.000132689043961446 * Y + 0.000560833691242812 * k - 0.195152027534049) + Y * (0.00174418132927582 * Y - 0.00255243321439347 * k + 0.116935020465145) + k * (-0.000343531996510555 * k + 0.24165260232407);
	      }
	      return data;
	    },
	    _convertYcckToCmyk: function convertYcckToCmyk(data) {
	      var Y, Cb, Cr;
	      for (var i = 0, length = data.length; i < length; i += 4) {
	        Y = data[i];
	        Cb = data[i + 1];
	        Cr = data[i + 2];
	        data[i] = 434.456 - Y - 1.402 * Cr;
	        data[i + 1] = 119.541 - Y + 0.344 * Cb + 0.714 * Cr;
	        data[i + 2] = 481.816 - Y - 1.772 * Cb;
	      }
	      return data;
	    },
	    _convertCmykToRgb: function convertCmykToRgb(data) {
	      var c, m, y, k;
	      var offset = 0;
	      var scale = 1 / 255;
	      for (var i = 0, length = data.length; i < length; i += 4) {
	        c = data[i] * scale;
	        m = data[i + 1] * scale;
	        y = data[i + 2] * scale;
	        k = data[i + 3] * scale;
	        data[offset++] = 255 + c * (-4.387332384609988 * c + 54.48615194189176 * m + 18.82290502165302 * y + 212.25662451639585 * k - 285.2331026137004) + m * (1.7149763477362134 * m - 5.6096736904047315 * y - 17.873870861415444 * k - 5.497006427196366) + y * (-2.5217340131683033 * y - 21.248923337353073 * k + 17.5119270841813) - k * (21.86122147463605 * k + 189.48180835922747);
	        data[offset++] = 255 + c * (8.841041422036149 * c + 60.118027045597366 * m + 6.871425592049007 * y + 31.159100130055922 * k - 79.2970844816548) + m * (-15.310361306967817 * m + 17.575251261109482 * y + 131.35250912493976 * k - 190.9453302588951) + y * (4.444339102852739 * y + 9.8632861493405 * k - 24.86741582555878) - k * (20.737325471181034 * k + 187.80453709719578);
	        data[offset++] = 255 + c * (0.8842522430003296 * c + 8.078677503112928 * m + 30.89978309703729 * y - 0.23883238689178934 * k - 14.183576799673286) + m * (10.49593273432072 * m + 63.02378494754052 * y + 50.606957656360734 * k - 112.23884253719248) + y * (0.03296041114873217 * y + 115.60384449646641 * k - 193.58209356861505) - k * (22.33816807309886 * k + 180.12613974708367);
	      }
	      return data;
	    },
	    getData: function getData(width, height, forceRGBoutput) {
	      if (this.numComponents > 4) {
	        throw new JpegError('Unsupported color mode');
	      }
	      var data = this._getLinearizedBlockData(width, height);
	      if (this.numComponents === 1 && forceRGBoutput) {
	        var dataLength = data.length;
	        var rgbData = new Uint8ClampedArray(dataLength * 3);
	        var offset = 0;
	        for (var i = 0; i < dataLength; i++) {
	          var grayColor = data[i];
	          rgbData[offset++] = grayColor;
	          rgbData[offset++] = grayColor;
	          rgbData[offset++] = grayColor;
	        }
	        return rgbData;
	      } else if (this.numComponents === 3 && this._isColorConversionNeeded()) {
	        return this._convertYccToRgb(data);
	      } else if (this.numComponents === 4) {
	        if (this._isColorConversionNeeded()) {
	          if (forceRGBoutput) {
	            return this._convertYcckToRgb(data);
	          }
	          return this._convertYcckToCmyk(data);
	        } else if (forceRGBoutput) {
	          return this._convertCmykToRgb(data);
	        }
	      }
	      return data;
	    }
	  };
	  return JpegImage;
	}();
	exports.JpegImage = JpegImage;
	
	/***/ }),
	/* 144 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCITTFaxStream = undefined;
	
	var _primitives = __w_pdfjs_require__(2);
	
	var _ccitt = __w_pdfjs_require__(145);
	
	var _stream = __w_pdfjs_require__(5);
	
	var CCITTFaxStream = function CCITTFaxStreamClosure() {
	  function CCITTFaxStream(str, maybeLength, params) {
	    this.str = str;
	    this.dict = str.dict;
	    if (!(0, _primitives.isDict)(params)) {
	      params = _primitives.Dict.empty;
	    }
	    var source = {
	      next: function next() {
	        return str.getByte();
	      }
	    };
	    this.ccittFaxDecoder = new _ccitt.CCITTFaxDecoder(source, {
	      K: params.get('K'),
	      EndOfLine: params.get('EndOfLine'),
	      EncodedByteAlign: params.get('EncodedByteAlign'),
	      Columns: params.get('Columns'),
	      Rows: params.get('Rows'),
	      EndOfBlock: params.get('EndOfBlock'),
	      BlackIs1: params.get('BlackIs1')
	    });
	    _stream.DecodeStream.call(this, maybeLength);
	  }
	  CCITTFaxStream.prototype = Object.create(_stream.DecodeStream.prototype);
	  CCITTFaxStream.prototype.readBlock = function () {
	    while (!this.eof) {
	      var c = this.ccittFaxDecoder.readNextChar();
	      if (c === -1) {
	        this.eof = true;
	        return;
	      }
	      this.ensureBuffer(this.bufferLength + 1);
	      this.buffer[this.bufferLength++] = c;
	    }
	  };
	  return CCITTFaxStream;
	}();
	exports.CCITTFaxStream = CCITTFaxStream;
	
	/***/ }),
	/* 145 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CCITTFaxDecoder = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var CCITTFaxDecoder = function CCITTFaxDecoder() {
	  var ccittEOL = -2;
	  var ccittEOF = -1;
	  var twoDimPass = 0;
	  var twoDimHoriz = 1;
	  var twoDimVert0 = 2;
	  var twoDimVertR1 = 3;
	  var twoDimVertL1 = 4;
	  var twoDimVertR2 = 5;
	  var twoDimVertL2 = 6;
	  var twoDimVertR3 = 7;
	  var twoDimVertL3 = 8;
	  var twoDimTable = [[-1, -1], [-1, -1], [7, twoDimVertL3], [7, twoDimVertR3], [6, twoDimVertL2], [6, twoDimVertL2], [6, twoDimVertR2], [6, twoDimVertR2], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0]];
	  var whiteTable1 = [[-1, -1], [12, ccittEOL], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [12, 1984], [12, 2048], [12, 2112], [12, 2176], [12, 2240], [12, 2304], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [12, 2368], [12, 2432], [12, 2496], [12, 2560]];
	  var whiteTable2 = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [8, 29], [8, 29], [8, 30], [8, 30], [8, 45], [8, 45], [8, 46], [8, 46], [7, 22], [7, 22], [7, 22], [7, 22], [7, 23], [7, 23], [7, 23], [7, 23], [8, 47], [8, 47], [8, 48], [8, 48], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [7, 20], [7, 20], [7, 20], [7, 20], [8, 33], [8, 33], [8, 34], [8, 34], [8, 35], [8, 35], [8, 36], [8, 36], [8, 37], [8, 37], [8, 38], [8, 38], [7, 19], [7, 19], [7, 19], [7, 19], [8, 31], [8, 31], [8, 32], [8, 32], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [8, 53], [8, 53], [8, 54], [8, 54], [7, 26], [7, 26], [7, 26], [7, 26], [8, 39], [8, 39], [8, 40], [8, 40], [8, 41], [8, 41], [8, 42], [8, 42], [8, 43], [8, 43], [8, 44], [8, 44], [7, 21], [7, 21], [7, 21], [7, 21], [7, 28], [7, 28], [7, 28], [7, 28], [8, 61], [8, 61], [8, 62], [8, 62], [8, 63], [8, 63], [8, 0], [8, 0], [8, 320], [8, 320], [8, 384], [8, 384], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [7, 27], [7, 27], [7, 27], [7, 27], [8, 59], [8, 59], [8, 60], [8, 60], [9, 1472], [9, 1536], [9, 1600], [9, 1728], [7, 18], [7, 18], [7, 18], [7, 18], [7, 24], [7, 24], [7, 24], [7, 24], [8, 49], [8, 49], [8, 50], [8, 50], [8, 51], [8, 51], [8, 52], [8, 52], [7, 25], [7, 25], [7, 25], [7, 25], [8, 55], [8, 55], [8, 56], [8, 56], [8, 57], [8, 57], [8, 58], [8, 58], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [8, 448], [8, 448], [8, 512], [8, 512], [9, 704], [9, 768], [8, 640], [8, 640], [8, 576], [8, 576], [9, 832], [9, 896], [9, 960], [9, 1024], [9, 1088], [9, 1152], [9, 1216], [9, 1280], [9, 1344], [9, 1408], [7, 256], [7, 256], [7, 256], [7, 256], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7]];
	  var blackTable1 = [[-1, -1], [-1, -1], [12, ccittEOL], [12, ccittEOL], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [11, 1792], [11, 1792], [12, 1984], [12, 1984], [12, 2048], [12, 2048], [12, 2112], [12, 2112], [12, 2176], [12, 2176], [12, 2240], [12, 2240], [12, 2304], [12, 2304], [11, 1856], [11, 1856], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [11, 1920], [11, 1920], [12, 2368], [12, 2368], [12, 2432], [12, 2432], [12, 2496], [12, 2496], [12, 2560], [12, 2560], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [12, 52], [12, 52], [13, 640], [13, 704], [13, 768], [13, 832], [12, 55], [12, 55], [12, 56], [12, 56], [13, 1280], [13, 1344], [13, 1408], [13, 1472], [12, 59], [12, 59], [12, 60], [12, 60], [13, 1536], [13, 1600], [11, 24], [11, 24], [11, 24], [11, 24], [11, 25], [11, 25], [11, 25], [11, 25], [13, 1664], [13, 1728], [12, 320], [12, 320], [12, 384], [12, 384], [12, 448], [12, 448], [13, 512], [13, 576], [12, 53], [12, 53], [12, 54], [12, 54], [13, 896], [13, 960], [13, 1024], [13, 1088], [13, 1152], [13, 1216], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64]];
	  var blackTable2 = [[8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [11, 23], [11, 23], [12, 50], [12, 51], [12, 44], [12, 45], [12, 46], [12, 47], [12, 57], [12, 58], [12, 61], [12, 256], [10, 16], [10, 16], [10, 16], [10, 16], [10, 17], [10, 17], [10, 17], [10, 17], [12, 48], [12, 49], [12, 62], [12, 63], [12, 30], [12, 31], [12, 32], [12, 33], [12, 40], [12, 41], [11, 22], [11, 22], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [12, 128], [12, 192], [12, 26], [12, 27], [12, 28], [12, 29], [11, 19], [11, 19], [11, 20], [11, 20], [12, 34], [12, 35], [12, 36], [12, 37], [12, 38], [12, 39], [11, 21], [11, 21], [12, 42], [12, 43], [10, 0], [10, 0], [10, 0], [10, 0], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12]];
	  var blackTable3 = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [6, 9], [6, 8], [5, 7], [5, 7], [4, 6], [4, 6], [4, 6], [4, 6], [4, 5], [4, 5], [4, 5], [4, 5], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2]];
	  function CCITTFaxDecoder(source) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (!source || typeof source.next !== 'function') {
	      throw new Error('CCITTFaxDecoder - invalid "source" parameter.');
	    }
	    this.source = source;
	    this.eof = false;
	    this.encoding = options['K'] || 0;
	    this.eoline = options['EndOfLine'] || false;
	    this.byteAlign = options['EncodedByteAlign'] || false;
	    this.columns = options['Columns'] || 1728;
	    this.rows = options['Rows'] || 0;
	    var eoblock = options['EndOfBlock'];
	    if (eoblock === null || eoblock === undefined) {
	      eoblock = true;
	    }
	    this.eoblock = eoblock;
	    this.black = options['BlackIs1'] || false;
	    this.codingLine = new Uint32Array(this.columns + 1);
	    this.refLine = new Uint32Array(this.columns + 2);
	    this.codingLine[0] = this.columns;
	    this.codingPos = 0;
	    this.row = 0;
	    this.nextLine2D = this.encoding < 0;
	    this.inputBits = 0;
	    this.inputBuf = 0;
	    this.outputBits = 0;
	    this.rowsDone = false;
	    var code1 = void 0;
	    while ((code1 = this._lookBits(12)) === 0) {
	      this._eatBits(1);
	    }
	    if (code1 === 1) {
	      this._eatBits(12);
	    }
	    if (this.encoding > 0) {
	      this.nextLine2D = !this._lookBits(1);
	      this._eatBits(1);
	    }
	  }
	  CCITTFaxDecoder.prototype = {
	    readNextChar: function readNextChar() {
	      if (this.eof) {
	        return -1;
	      }
	      var refLine = this.refLine;
	      var codingLine = this.codingLine;
	      var columns = this.columns;
	      var refPos = void 0,
	          blackPixels = void 0,
	          bits = void 0,
	          i = void 0;
	      if (this.outputBits === 0) {
	        if (this.rowsDone) {
	          this.eof = true;
	        }
	        if (this.eof) {
	          return -1;
	        }
	        this.err = false;
	        var code1 = void 0,
	            code2 = void 0,
	            code3 = void 0;
	        if (this.nextLine2D) {
	          for (i = 0; codingLine[i] < columns; ++i) {
	            refLine[i] = codingLine[i];
	          }
	          refLine[i++] = columns;
	          refLine[i] = columns;
	          codingLine[0] = 0;
	          this.codingPos = 0;
	          refPos = 0;
	          blackPixels = 0;
	          while (codingLine[this.codingPos] < columns) {
	            code1 = this._getTwoDimCode();
	            switch (code1) {
	              case twoDimPass:
	                this._addPixels(refLine[refPos + 1], blackPixels);
	                if (refLine[refPos + 1] < columns) {
	                  refPos += 2;
	                }
	                break;
	              case twoDimHoriz:
	                code1 = code2 = 0;
	                if (blackPixels) {
	                  do {
	                    code1 += code3 = this._getBlackCode();
	                  } while (code3 >= 64);
	                  do {
	                    code2 += code3 = this._getWhiteCode();
	                  } while (code3 >= 64);
	                } else {
	                  do {
	                    code1 += code3 = this._getWhiteCode();
	                  } while (code3 >= 64);
	                  do {
	                    code2 += code3 = this._getBlackCode();
	                  } while (code3 >= 64);
	                }
	                this._addPixels(codingLine[this.codingPos] + code1, blackPixels);
	                if (codingLine[this.codingPos] < columns) {
	                  this._addPixels(codingLine[this.codingPos] + code2, blackPixels ^ 1);
	                }
	                while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
	                  refPos += 2;
	                }
	                break;
	              case twoDimVertR3:
	                this._addPixels(refLine[refPos] + 3, blackPixels);
	                blackPixels ^= 1;
	                if (codingLine[this.codingPos] < columns) {
	                  ++refPos;
	                  while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
	                    refPos += 2;
	                  }
	                }
	                break;
	              case twoDimVertR2:
	                this._addPixels(refLine[refPos] + 2, blackPixels);
	                blackPixels ^= 1;
	                if (codingLine[this.codingPos] < columns) {
	                  ++refPos;
	                  while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
	                    refPos += 2;
	                  }
	                }
	                break;
	              case twoDimVertR1:
	                this._addPixels(refLine[refPos] + 1, blackPixels);
	                blackPixels ^= 1;
	                if (codingLine[this.codingPos] < columns) {
	                  ++refPos;
	                  while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
	                    refPos += 2;
	                  }
	                }
	                break;
	              case twoDimVert0:
	                this._addPixels(refLine[refPos], blackPixels);
	                blackPixels ^= 1;
	                if (codingLine[this.codingPos] < columns) {
	                  ++refPos;
	                  while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
	                    refPos += 2;
	                  }
	                }
	                break;
	              case twoDimVertL3:
	                this._addPixelsNeg(refLine[refPos] - 3, blackPixels);
	                blackPixels ^= 1;
	                if (codingLine[this.codingPos] < columns) {
	                  if (refPos > 0) {
	                    --refPos;
	                  } else {
	                    ++refPos;
	                  }
	                  while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
	                    refPos += 2;
	                  }
	                }
	                break;
	              case twoDimVertL2:
	                this._addPixelsNeg(refLine[refPos] - 2, blackPixels);
	                blackPixels ^= 1;
	                if (codingLine[this.codingPos] < columns) {
	                  if (refPos > 0) {
	                    --refPos;
	                  } else {
	                    ++refPos;
	                  }
	                  while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
	                    refPos += 2;
	                  }
	                }
	                break;
	              case twoDimVertL1:
	                this._addPixelsNeg(refLine[refPos] - 1, blackPixels);
	                blackPixels ^= 1;
	                if (codingLine[this.codingPos] < columns) {
	                  if (refPos > 0) {
	                    --refPos;
	                  } else {
	                    ++refPos;
	                  }
	                  while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
	                    refPos += 2;
	                  }
	                }
	                break;
	              case ccittEOF:
	                this._addPixels(columns, 0);
	                this.eof = true;
	                break;
	              default:
	                (0, _util.info)('bad 2d code');
	                this._addPixels(columns, 0);
	                this.err = true;
	            }
	          }
	        } else {
	          codingLine[0] = 0;
	          this.codingPos = 0;
	          blackPixels = 0;
	          while (codingLine[this.codingPos] < columns) {
	            code1 = 0;
	            if (blackPixels) {
	              do {
	                code1 += code3 = this._getBlackCode();
	              } while (code3 >= 64);
	            } else {
	              do {
	                code1 += code3 = this._getWhiteCode();
	              } while (code3 >= 64);
	            }
	            this._addPixels(codingLine[this.codingPos] + code1, blackPixels);
	            blackPixels ^= 1;
	          }
	        }
	        var gotEOL = false;
	        if (this.byteAlign) {
	          this.inputBits &= ~7;
	        }
	        if (!this.eoblock && this.row === this.rows - 1) {
	          this.rowsDone = true;
	        } else {
	          code1 = this._lookBits(12);
	          if (this.eoline) {
	            while (code1 !== ccittEOF && code1 !== 1) {
	              this._eatBits(1);
	              code1 = this._lookBits(12);
	            }
	          } else {
	            while (code1 === 0) {
	              this._eatBits(1);
	              code1 = this._lookBits(12);
	            }
	          }
	          if (code1 === 1) {
	            this._eatBits(12);
	            gotEOL = true;
	          } else if (code1 === ccittEOF) {
	            this.eof = true;
	          }
	        }
	        if (!this.eof && this.encoding > 0 && !this.rowsDone) {
	          this.nextLine2D = !this._lookBits(1);
	          this._eatBits(1);
	        }
	        if (this.eoblock && gotEOL && this.byteAlign) {
	          code1 = this._lookBits(12);
	          if (code1 === 1) {
	            this._eatBits(12);
	            if (this.encoding > 0) {
	              this._lookBits(1);
	              this._eatBits(1);
	            }
	            if (this.encoding >= 0) {
	              for (i = 0; i < 4; ++i) {
	                code1 = this._lookBits(12);
	                if (code1 !== 1) {
	                  (0, _util.info)('bad rtc code: ' + code1);
	                }
	                this._eatBits(12);
	                if (this.encoding > 0) {
	                  this._lookBits(1);
	                  this._eatBits(1);
	                }
	              }
	            }
	            this.eof = true;
	          }
	        } else if (this.err && this.eoline) {
	          while (true) {
	            code1 = this._lookBits(13);
	            if (code1 === ccittEOF) {
	              this.eof = true;
	              return -1;
	            }
	            if (code1 >> 1 === 1) {
	              break;
	            }
	            this._eatBits(1);
	          }
	          this._eatBits(12);
	          if (this.encoding > 0) {
	            this._eatBits(1);
	            this.nextLine2D = !(code1 & 1);
	          }
	        }
	        if (codingLine[0] > 0) {
	          this.outputBits = codingLine[this.codingPos = 0];
	        } else {
	          this.outputBits = codingLine[this.codingPos = 1];
	        }
	        this.row++;
	      }
	      var c = void 0;
	      if (this.outputBits >= 8) {
	        c = this.codingPos & 1 ? 0 : 0xFF;
	        this.outputBits -= 8;
	        if (this.outputBits === 0 && codingLine[this.codingPos] < columns) {
	          this.codingPos++;
	          this.outputBits = codingLine[this.codingPos] - codingLine[this.codingPos - 1];
	        }
	      } else {
	        bits = 8;
	        c = 0;
	        do {
	          if (this.outputBits > bits) {
	            c <<= bits;
	            if (!(this.codingPos & 1)) {
	              c |= 0xFF >> 8 - bits;
	            }
	            this.outputBits -= bits;
	            bits = 0;
	          } else {
	            c <<= this.outputBits;
	            if (!(this.codingPos & 1)) {
	              c |= 0xFF >> 8 - this.outputBits;
	            }
	            bits -= this.outputBits;
	            this.outputBits = 0;
	            if (codingLine[this.codingPos] < columns) {
	              this.codingPos++;
	              this.outputBits = codingLine[this.codingPos] - codingLine[this.codingPos - 1];
	            } else if (bits > 0) {
	              c <<= bits;
	              bits = 0;
	            }
	          }
	        } while (bits);
	      }
	      if (this.black) {
	        c ^= 0xFF;
	      }
	      return c;
	    },
	    _addPixels: function _addPixels(a1, blackPixels) {
	      var codingLine = this.codingLine;
	      var codingPos = this.codingPos;
	      if (a1 > codingLine[codingPos]) {
	        if (a1 > this.columns) {
	          (0, _util.info)('row is wrong length');
	          this.err = true;
	          a1 = this.columns;
	        }
	        if (codingPos & 1 ^ blackPixels) {
	          ++codingPos;
	        }
	        codingLine[codingPos] = a1;
	      }
	      this.codingPos = codingPos;
	    },
	    _addPixelsNeg: function _addPixelsNeg(a1, blackPixels) {
	      var codingLine = this.codingLine;
	      var codingPos = this.codingPos;
	      if (a1 > codingLine[codingPos]) {
	        if (a1 > this.columns) {
	          (0, _util.info)('row is wrong length');
	          this.err = true;
	          a1 = this.columns;
	        }
	        if (codingPos & 1 ^ blackPixels) {
	          ++codingPos;
	        }
	        codingLine[codingPos] = a1;
	      } else if (a1 < codingLine[codingPos]) {
	        if (a1 < 0) {
	          (0, _util.info)('invalid code');
	          this.err = true;
	          a1 = 0;
	        }
	        while (codingPos > 0 && a1 < codingLine[codingPos - 1]) {
	          --codingPos;
	        }
	        codingLine[codingPos] = a1;
	      }
	      this.codingPos = codingPos;
	    },
	    _findTableCode: function _findTableCode(start, end, table, limit) {
	      var limitValue = limit || 0;
	      for (var i = start; i <= end; ++i) {
	        var code = this._lookBits(i);
	        if (code === ccittEOF) {
	          return [true, 1, false];
	        }
	        if (i < end) {
	          code <<= end - i;
	        }
	        if (!limitValue || code >= limitValue) {
	          var p = table[code - limitValue];
	          if (p[0] === i) {
	            this._eatBits(i);
	            return [true, p[1], true];
	          }
	        }
	      }
	      return [false, 0, false];
	    },
	    _getTwoDimCode: function _getTwoDimCode() {
	      var code = 0;
	      var p = void 0;
	      if (this.eoblock) {
	        code = this._lookBits(7);
	        p = twoDimTable[code];
	        if (p && p[0] > 0) {
	          this._eatBits(p[0]);
	          return p[1];
	        }
	      } else {
	        var result = this._findTableCode(1, 7, twoDimTable);
	        if (result[0] && result[2]) {
	          return result[1];
	        }
	      }
	      (0, _util.info)('Bad two dim code');
	      return ccittEOF;
	    },
	    _getWhiteCode: function _getWhiteCode() {
	      var code = 0;
	      var p = void 0;
	      if (this.eoblock) {
	        code = this._lookBits(12);
	        if (code === ccittEOF) {
	          return 1;
	        }
	        if (code >> 5 === 0) {
	          p = whiteTable1[code];
	        } else {
	          p = whiteTable2[code >> 3];
	        }
	        if (p[0] > 0) {
	          this._eatBits(p[0]);
	          return p[1];
	        }
	      } else {
	        var result = this._findTableCode(1, 9, whiteTable2);
	        if (result[0]) {
	          return result[1];
	        }
	        result = this._findTableCode(11, 12, whiteTable1);
	        if (result[0]) {
	          return result[1];
	        }
	      }
	      (0, _util.info)('bad white code');
	      this._eatBits(1);
	      return 1;
	    },
	    _getBlackCode: function _getBlackCode() {
	      var code = void 0,
	          p = void 0;
	      if (this.eoblock) {
	        code = this._lookBits(13);
	        if (code === ccittEOF) {
	          return 1;
	        }
	        if (code >> 7 === 0) {
	          p = blackTable1[code];
	        } else if (code >> 9 === 0 && code >> 7 !== 0) {
	          p = blackTable2[(code >> 1) - 64];
	        } else {
	          p = blackTable3[code >> 7];
	        }
	        if (p[0] > 0) {
	          this._eatBits(p[0]);
	          return p[1];
	        }
	      } else {
	        var result = this._findTableCode(2, 6, blackTable3);
	        if (result[0]) {
	          return result[1];
	        }
	        result = this._findTableCode(7, 12, blackTable2, 64);
	        if (result[0]) {
	          return result[1];
	        }
	        result = this._findTableCode(10, 13, blackTable1);
	        if (result[0]) {
	          return result[1];
	        }
	      }
	      (0, _util.info)('bad black code');
	      this._eatBits(1);
	      return 1;
	    },
	    _lookBits: function _lookBits(n) {
	      var c = void 0;
	      while (this.inputBits < n) {
	        if ((c = this.source.next()) === -1) {
	          if (this.inputBits === 0) {
	            return ccittEOF;
	          }
	          return this.inputBuf << n - this.inputBits & 0xFFFF >> 16 - n;
	        }
	        this.inputBuf = this.inputBuf << 8 | c;
	        this.inputBits += 8;
	      }
	      return this.inputBuf >> this.inputBits - n & 0xFFFF >> 16 - n;
	    },
	    _eatBits: function _eatBits(n) {
	      if ((this.inputBits -= n) < 0) {
	        this.inputBits = 0;
	      }
	    }
	  };
	  return CCITTFaxDecoder;
	}();
	exports.CCITTFaxDecoder = CCITTFaxDecoder;
	
	/***/ }),
	/* 146 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Jbig2Stream = undefined;
	
	var _primitives = __w_pdfjs_require__(2);
	
	var _stream = __w_pdfjs_require__(5);
	
	var _jbig = __w_pdfjs_require__(147);
	
	var _util = __w_pdfjs_require__(0);
	
	var Jbig2Stream = function Jbig2StreamClosure() {
	  function Jbig2Stream(stream, maybeLength, dict, params) {
	    this.stream = stream;
	    this.maybeLength = maybeLength;
	    this.dict = dict;
	    this.params = params;
	    _stream.DecodeStream.call(this, maybeLength);
	  }
	  Jbig2Stream.prototype = Object.create(_stream.DecodeStream.prototype);
	  Object.defineProperty(Jbig2Stream.prototype, 'bytes', {
	    get: function get() {
	      return (0, _util.shadow)(this, 'bytes', this.stream.getBytes(this.maybeLength));
	    },
	
	    configurable: true
	  });
	  Jbig2Stream.prototype.ensureBuffer = function (req) {
	    if (this.bufferLength) {
	      return;
	    }
	    var jbig2Image = new _jbig.Jbig2Image();
	    var chunks = [];
	    if ((0, _primitives.isDict)(this.params)) {
	      var globalsStream = this.params.get('JBIG2Globals');
	      if ((0, _primitives.isStream)(globalsStream)) {
	        var globals = globalsStream.getBytes();
	        chunks.push({
	          data: globals,
	          start: 0,
	          end: globals.length
	        });
	      }
	    }
	    chunks.push({
	      data: this.bytes,
	      start: 0,
	      end: this.bytes.length
	    });
	    var data = jbig2Image.parseChunks(chunks);
	    var dataLength = data.length;
	    for (var i = 0; i < dataLength; i++) {
	      data[i] ^= 0xFF;
	    }
	    this.buffer = data;
	    this.bufferLength = dataLength;
	    this.eof = true;
	  };
	  return Jbig2Stream;
	}();
	exports.Jbig2Stream = Jbig2Stream;
	
	/***/ }),
	/* 147 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Jbig2Image = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _arithmetic_decoder = __w_pdfjs_require__(81);
	
	var Jbig2Error = function Jbig2ErrorClosure() {
	  function Jbig2Error(msg) {
	    this.message = 'JBIG2 error: ' + msg;
	  }
	  Jbig2Error.prototype = new Error();
	  Jbig2Error.prototype.name = 'Jbig2Error';
	  Jbig2Error.constructor = Jbig2Error;
	  return Jbig2Error;
	}();
	var Jbig2Image = function Jbig2ImageClosure() {
	  function ContextCache() {}
	  ContextCache.prototype = {
	    getContexts: function getContexts(id) {
	      if (id in this) {
	        return this[id];
	      }
	      return this[id] = new Int8Array(1 << 16);
	    }
	  };
	  function DecodingContext(data, start, end) {
	    this.data = data;
	    this.start = start;
	    this.end = end;
	  }
	  DecodingContext.prototype = {
	    get decoder() {
	      var decoder = new _arithmetic_decoder.ArithmeticDecoder(this.data, this.start, this.end);
	      return (0, _util.shadow)(this, 'decoder', decoder);
	    },
	    get contextCache() {
	      var cache = new ContextCache();
	      return (0, _util.shadow)(this, 'contextCache', cache);
	    }
	  };
	  function decodeInteger(contextCache, procedure, decoder) {
	    var contexts = contextCache.getContexts(procedure);
	    var prev = 1;
	    function readBits(length) {
	      var v = 0;
	      for (var i = 0; i < length; i++) {
	        var bit = decoder.readBit(contexts, prev);
	        prev = prev < 256 ? prev << 1 | bit : (prev << 1 | bit) & 511 | 256;
	        v = v << 1 | bit;
	      }
	      return v >>> 0;
	    }
	    var sign = readBits(1);
	    var value = readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(32) + 4436 : readBits(12) + 340 : readBits(8) + 84 : readBits(6) + 20 : readBits(4) + 4 : readBits(2);
	    return sign === 0 ? value : value > 0 ? -value : null;
	  }
	  function decodeIAID(contextCache, decoder, codeLength) {
	    var contexts = contextCache.getContexts('IAID');
	    var prev = 1;
	    for (var i = 0; i < codeLength; i++) {
	      var bit = decoder.readBit(contexts, prev);
	      prev = prev << 1 | bit;
	    }
	    if (codeLength < 31) {
	      return prev & (1 << codeLength) - 1;
	    }
	    return prev & 0x7FFFFFFF;
	  }
	  var SegmentTypes = ['SymbolDictionary', null, null, null, 'IntermediateTextRegion', null, 'ImmediateTextRegion', 'ImmediateLosslessTextRegion', null, null, null, null, null, null, null, null, 'PatternDictionary', null, null, null, 'IntermediateHalftoneRegion', null, 'ImmediateHalftoneRegion', 'ImmediateLosslessHalftoneRegion', null, null, null, null, null, null, null, null, null, null, null, null, 'IntermediateGenericRegion', null, 'ImmediateGenericRegion', 'ImmediateLosslessGenericRegion', 'IntermediateGenericRefinementRegion', null, 'ImmediateGenericRefinementRegion', 'ImmediateLosslessGenericRefinementRegion', null, null, null, null, 'PageInformation', 'EndOfPage', 'EndOfStripe', 'EndOfFile', 'Profiles', 'Tables', null, null, null, null, null, null, null, null, 'Extension'];
	  var CodingTemplates = [[{
	    x: -1,
	    y: -2
	  }, {
	    x: 0,
	    y: -2
	  }, {
	    x: 1,
	    y: -2
	  }, {
	    x: -2,
	    y: -1
	  }, {
	    x: -1,
	    y: -1
	  }, {
	    x: 0,
	    y: -1
	  }, {
	    x: 1,
	    y: -1
	  }, {
	    x: 2,
	    y: -1
	  }, {
	    x: -4,
	    y: 0
	  }, {
	    x: -3,
	    y: 0
	  }, {
	    x: -2,
	    y: 0
	  }, {
	    x: -1,
	    y: 0
	  }], [{
	    x: -1,
	    y: -2
	  }, {
	    x: 0,
	    y: -2
	  }, {
	    x: 1,
	    y: -2
	  }, {
	    x: 2,
	    y: -2
	  }, {
	    x: -2,
	    y: -1
	  }, {
	    x: -1,
	    y: -1
	  }, {
	    x: 0,
	    y: -1
	  }, {
	    x: 1,
	    y: -1
	  }, {
	    x: 2,
	    y: -1
	  }, {
	    x: -3,
	    y: 0
	  }, {
	    x: -2,
	    y: 0
	  }, {
	    x: -1,
	    y: 0
	  }], [{
	    x: -1,
	    y: -2
	  }, {
	    x: 0,
	    y: -2
	  }, {
	    x: 1,
	    y: -2
	  }, {
	    x: -2,
	    y: -1
	  }, {
	    x: -1,
	    y: -1
	  }, {
	    x: 0,
	    y: -1
	  }, {
	    x: 1,
	    y: -1
	  }, {
	    x: -2,
	    y: 0
	  }, {
	    x: -1,
	    y: 0
	  }], [{
	    x: -3,
	    y: -1
	  }, {
	    x: -2,
	    y: -1
	  }, {
	    x: -1,
	    y: -1
	  }, {
	    x: 0,
	    y: -1
	  }, {
	    x: 1,
	    y: -1
	  }, {
	    x: -4,
	    y: 0
	  }, {
	    x: -3,
	    y: 0
	  }, {
	    x: -2,
	    y: 0
	  }, {
	    x: -1,
	    y: 0
	  }]];
	  var RefinementTemplates = [{
	    coding: [{
	      x: 0,
	      y: -1
	    }, {
	      x: 1,
	      y: -1
	    }, {
	      x: -1,
	      y: 0
	    }],
	    reference: [{
	      x: 0,
	      y: -1
	    }, {
	      x: 1,
	      y: -1
	    }, {
	      x: -1,
	      y: 0
	    }, {
	      x: 0,
	      y: 0
	    }, {
	      x: 1,
	      y: 0
	    }, {
	      x: -1,
	      y: 1
	    }, {
	      x: 0,
	      y: 1
	    }, {
	      x: 1,
	      y: 1
	    }]
	  }, {
	    coding: [{
	      x: -1,
	      y: -1
	    }, {
	      x: 0,
	      y: -1
	    }, {
	      x: 1,
	      y: -1
	    }, {
	      x: -1,
	      y: 0
	    }],
	    reference: [{
	      x: 0,
	      y: -1
	    }, {
	      x: -1,
	      y: 0
	    }, {
	      x: 0,
	      y: 0
	    }, {
	      x: 1,
	      y: 0
	    }, {
	      x: 0,
	      y: 1
	    }, {
	      x: 1,
	      y: 1
	    }]
	  }];
	  var ReusedContexts = [0x9B25, 0x0795, 0x00E5, 0x0195];
	  var RefinementReusedContexts = [0x0020, 0x0008];
	  function decodeBitmapTemplate0(width, height, decodingContext) {
	    var decoder = decodingContext.decoder;
	    var contexts = decodingContext.contextCache.getContexts('GB');
	    var contextLabel,
	        i,
	        j,
	        pixel,
	        row,
	        row1,
	        row2,
	        bitmap = [];
	    var OLD_PIXEL_MASK = 0x7BF7;
	    for (i = 0; i < height; i++) {
	      row = bitmap[i] = new Uint8Array(width);
	      row1 = i < 1 ? row : bitmap[i - 1];
	      row2 = i < 2 ? row : bitmap[i - 2];
	      contextLabel = row2[0] << 13 | row2[1] << 12 | row2[2] << 11 | row1[0] << 7 | row1[1] << 6 | row1[2] << 5 | row1[3] << 4;
	      for (j = 0; j < width; j++) {
	        row[j] = pixel = decoder.readBit(contexts, contextLabel);
	        contextLabel = (contextLabel & OLD_PIXEL_MASK) << 1 | (j + 3 < width ? row2[j + 3] << 11 : 0) | (j + 4 < width ? row1[j + 4] << 4 : 0) | pixel;
	      }
	    }
	    return bitmap;
	  }
	  function decodeBitmap(mmr, width, height, templateIndex, prediction, skip, at, decodingContext) {
	    if (mmr) {
	      throw new Jbig2Error('MMR encoding is not supported');
	    }
	    if (templateIndex === 0 && !skip && !prediction && at.length === 4 && at[0].x === 3 && at[0].y === -1 && at[1].x === -3 && at[1].y === -1 && at[2].x === 2 && at[2].y === -2 && at[3].x === -2 && at[3].y === -2) {
	      return decodeBitmapTemplate0(width, height, decodingContext);
	    }
	    var useskip = !!skip;
	    var template = CodingTemplates[templateIndex].concat(at);
	    template.sort(function (a, b) {
	      return a.y - b.y || a.x - b.x;
	    });
	    var templateLength = template.length;
	    var templateX = new Int8Array(templateLength);
	    var templateY = new Int8Array(templateLength);
	    var changingTemplateEntries = [];
	    var reuseMask = 0,
	        minX = 0,
	        maxX = 0,
	        minY = 0;
	    var c, k;
	    for (k = 0; k < templateLength; k++) {
	      templateX[k] = template[k].x;
	      templateY[k] = template[k].y;
	      minX = Math.min(minX, template[k].x);
	      maxX = Math.max(maxX, template[k].x);
	      minY = Math.min(minY, template[k].y);
	      if (k < templateLength - 1 && template[k].y === template[k + 1].y && template[k].x === template[k + 1].x - 1) {
	        reuseMask |= 1 << templateLength - 1 - k;
	      } else {
	        changingTemplateEntries.push(k);
	      }
	    }
	    var changingEntriesLength = changingTemplateEntries.length;
	    var changingTemplateX = new Int8Array(changingEntriesLength);
	    var changingTemplateY = new Int8Array(changingEntriesLength);
	    var changingTemplateBit = new Uint16Array(changingEntriesLength);
	    for (c = 0; c < changingEntriesLength; c++) {
	      k = changingTemplateEntries[c];
	      changingTemplateX[c] = template[k].x;
	      changingTemplateY[c] = template[k].y;
	      changingTemplateBit[c] = 1 << templateLength - 1 - k;
	    }
	    var sbb_left = -minX;
	    var sbb_top = -minY;
	    var sbb_right = width - maxX;
	    var pseudoPixelContext = ReusedContexts[templateIndex];
	    var row = new Uint8Array(width);
	    var bitmap = [];
	    var decoder = decodingContext.decoder;
	    var contexts = decodingContext.contextCache.getContexts('GB');
	    var ltp = 0,
	        j,
	        i0,
	        j0,
	        contextLabel = 0,
	        bit,
	        shift;
	    for (var i = 0; i < height; i++) {
	      if (prediction) {
	        var sltp = decoder.readBit(contexts, pseudoPixelContext);
	        ltp ^= sltp;
	        if (ltp) {
	          bitmap.push(row);
	          continue;
	        }
	      }
	      row = new Uint8Array(row);
	      bitmap.push(row);
	      for (j = 0; j < width; j++) {
	        if (useskip && skip[i][j]) {
	          row[j] = 0;
	          continue;
	        }
	        if (j >= sbb_left && j < sbb_right && i >= sbb_top) {
	          contextLabel = contextLabel << 1 & reuseMask;
	          for (k = 0; k < changingEntriesLength; k++) {
	            i0 = i + changingTemplateY[k];
	            j0 = j + changingTemplateX[k];
	            bit = bitmap[i0][j0];
	            if (bit) {
	              bit = changingTemplateBit[k];
	              contextLabel |= bit;
	            }
	          }
	        } else {
	          contextLabel = 0;
	          shift = templateLength - 1;
	          for (k = 0; k < templateLength; k++, shift--) {
	            j0 = j + templateX[k];
	            if (j0 >= 0 && j0 < width) {
	              i0 = i + templateY[k];
	              if (i0 >= 0) {
	                bit = bitmap[i0][j0];
	                if (bit) {
	                  contextLabel |= bit << shift;
	                }
	              }
	            }
	          }
	        }
	        var pixel = decoder.readBit(contexts, contextLabel);
	        row[j] = pixel;
	      }
	    }
	    return bitmap;
	  }
	  function decodeRefinement(width, height, templateIndex, referenceBitmap, offsetX, offsetY, prediction, at, decodingContext) {
	    var codingTemplate = RefinementTemplates[templateIndex].coding;
	    if (templateIndex === 0) {
	      codingTemplate = codingTemplate.concat([at[0]]);
	    }
	    var codingTemplateLength = codingTemplate.length;
	    var codingTemplateX = new Int32Array(codingTemplateLength);
	    var codingTemplateY = new Int32Array(codingTemplateLength);
	    var k;
	    for (k = 0; k < codingTemplateLength; k++) {
	      codingTemplateX[k] = codingTemplate[k].x;
	      codingTemplateY[k] = codingTemplate[k].y;
	    }
	    var referenceTemplate = RefinementTemplates[templateIndex].reference;
	    if (templateIndex === 0) {
	      referenceTemplate = referenceTemplate.concat([at[1]]);
	    }
	    var referenceTemplateLength = referenceTemplate.length;
	    var referenceTemplateX = new Int32Array(referenceTemplateLength);
	    var referenceTemplateY = new Int32Array(referenceTemplateLength);
	    for (k = 0; k < referenceTemplateLength; k++) {
	      referenceTemplateX[k] = referenceTemplate[k].x;
	      referenceTemplateY[k] = referenceTemplate[k].y;
	    }
	    var referenceWidth = referenceBitmap[0].length;
	    var referenceHeight = referenceBitmap.length;
	    var pseudoPixelContext = RefinementReusedContexts[templateIndex];
	    var bitmap = [];
	    var decoder = decodingContext.decoder;
	    var contexts = decodingContext.contextCache.getContexts('GR');
	    var ltp = 0;
	    for (var i = 0; i < height; i++) {
	      if (prediction) {
	        var sltp = decoder.readBit(contexts, pseudoPixelContext);
	        ltp ^= sltp;
	        if (ltp) {
	          throw new Jbig2Error('prediction is not supported');
	        }
	      }
	      var row = new Uint8Array(width);
	      bitmap.push(row);
	      for (var j = 0; j < width; j++) {
	        var i0, j0;
	        var contextLabel = 0;
	        for (k = 0; k < codingTemplateLength; k++) {
	          i0 = i + codingTemplateY[k];
	          j0 = j + codingTemplateX[k];
	          if (i0 < 0 || j0 < 0 || j0 >= width) {
	            contextLabel <<= 1;
	          } else {
	            contextLabel = contextLabel << 1 | bitmap[i0][j0];
	          }
	        }
	        for (k = 0; k < referenceTemplateLength; k++) {
	          i0 = i + referenceTemplateY[k] - offsetY;
	          j0 = j + referenceTemplateX[k] - offsetX;
	          if (i0 < 0 || i0 >= referenceHeight || j0 < 0 || j0 >= referenceWidth) {
	            contextLabel <<= 1;
	          } else {
	            contextLabel = contextLabel << 1 | referenceBitmap[i0][j0];
	          }
	        }
	        var pixel = decoder.readBit(contexts, contextLabel);
	        row[j] = pixel;
	      }
	    }
	    return bitmap;
	  }
	  function decodeSymbolDictionary(huffman, refinement, symbols, numberOfNewSymbols, numberOfExportedSymbols, huffmanTables, templateIndex, at, refinementTemplateIndex, refinementAt, decodingContext) {
	    if (huffman) {
	      throw new Jbig2Error('huffman is not supported');
	    }
	    var newSymbols = [];
	    var currentHeight = 0;
	    var symbolCodeLength = (0, _util.log2)(symbols.length + numberOfNewSymbols);
	    var decoder = decodingContext.decoder;
	    var contextCache = decodingContext.contextCache;
	    while (newSymbols.length < numberOfNewSymbols) {
	      var deltaHeight = decodeInteger(contextCache, 'IADH', decoder);
	      currentHeight += deltaHeight;
	      var currentWidth = 0;
	      while (true) {
	        var deltaWidth = decodeInteger(contextCache, 'IADW', decoder);
	        if (deltaWidth === null) {
	          break;
	        }
	        currentWidth += deltaWidth;
	        var bitmap;
	        if (refinement) {
	          var numberOfInstances = decodeInteger(contextCache, 'IAAI', decoder);
	          if (numberOfInstances > 1) {
	            bitmap = decodeTextRegion(huffman, refinement, currentWidth, currentHeight, 0, numberOfInstances, 1, symbols.concat(newSymbols), symbolCodeLength, 0, 0, 1, 0, huffmanTables, refinementTemplateIndex, refinementAt, decodingContext);
	          } else {
	            var symbolId = decodeIAID(contextCache, decoder, symbolCodeLength);
	            var rdx = decodeInteger(contextCache, 'IARDX', decoder);
	            var rdy = decodeInteger(contextCache, 'IARDY', decoder);
	            var symbol = symbolId < symbols.length ? symbols[symbolId] : newSymbols[symbolId - symbols.length];
	            bitmap = decodeRefinement(currentWidth, currentHeight, refinementTemplateIndex, symbol, rdx, rdy, false, refinementAt, decodingContext);
	          }
	        } else {
	          bitmap = decodeBitmap(false, currentWidth, currentHeight, templateIndex, false, null, at, decodingContext);
	        }
	        newSymbols.push(bitmap);
	      }
	    }
	    var exportedSymbols = [];
	    var flags = [],
	        currentFlag = false;
	    var totalSymbolsLength = symbols.length + numberOfNewSymbols;
	    while (flags.length < totalSymbolsLength) {
	      var runLength = decodeInteger(contextCache, 'IAEX', decoder);
	      while (runLength--) {
	        flags.push(currentFlag);
	      }
	      currentFlag = !currentFlag;
	    }
	    for (var i = 0, ii = symbols.length; i < ii; i++) {
	      if (flags[i]) {
	        exportedSymbols.push(symbols[i]);
	      }
	    }
	    for (var j = 0; j < numberOfNewSymbols; i++, j++) {
	      if (flags[i]) {
	        exportedSymbols.push(newSymbols[j]);
	      }
	    }
	    return exportedSymbols;
	  }
	  function decodeTextRegion(huffman, refinement, width, height, defaultPixelValue, numberOfSymbolInstances, stripSize, inputSymbols, symbolCodeLength, transposed, dsOffset, referenceCorner, combinationOperator, huffmanTables, refinementTemplateIndex, refinementAt, decodingContext) {
	    if (huffman) {
	      throw new Jbig2Error('huffman is not supported');
	    }
	    var bitmap = [];
	    var i, row;
	    for (i = 0; i < height; i++) {
	      row = new Uint8Array(width);
	      if (defaultPixelValue) {
	        for (var j = 0; j < width; j++) {
	          row[j] = defaultPixelValue;
	        }
	      }
	      bitmap.push(row);
	    }
	    var decoder = decodingContext.decoder;
	    var contextCache = decodingContext.contextCache;
	    var stripT = -decodeInteger(contextCache, 'IADT', decoder);
	    var firstS = 0;
	    i = 0;
	    while (i < numberOfSymbolInstances) {
	      var deltaT = decodeInteger(contextCache, 'IADT', decoder);
	      stripT += deltaT;
	      var deltaFirstS = decodeInteger(contextCache, 'IAFS', decoder);
	      firstS += deltaFirstS;
	      var currentS = firstS;
	      do {
	        var currentT = stripSize === 1 ? 0 : decodeInteger(contextCache, 'IAIT', decoder);
	        var t = stripSize * stripT + currentT;
	        var symbolId = decodeIAID(contextCache, decoder, symbolCodeLength);
	        var applyRefinement = refinement && decodeInteger(contextCache, 'IARI', decoder);
	        var symbolBitmap = inputSymbols[symbolId];
	        var symbolWidth = symbolBitmap[0].length;
	        var symbolHeight = symbolBitmap.length;
	        if (applyRefinement) {
	          var rdw = decodeInteger(contextCache, 'IARDW', decoder);
	          var rdh = decodeInteger(contextCache, 'IARDH', decoder);
	          var rdx = decodeInteger(contextCache, 'IARDX', decoder);
	          var rdy = decodeInteger(contextCache, 'IARDY', decoder);
	          symbolWidth += rdw;
	          symbolHeight += rdh;
	          symbolBitmap = decodeRefinement(symbolWidth, symbolHeight, refinementTemplateIndex, symbolBitmap, (rdw >> 1) + rdx, (rdh >> 1) + rdy, false, refinementAt, decodingContext);
	        }
	        var offsetT = t - (referenceCorner & 1 ? 0 : symbolHeight - 1);
	        var offsetS = currentS - (referenceCorner & 2 ? symbolWidth - 1 : 0);
	        var s2, t2, symbolRow;
	        if (transposed) {
	          for (s2 = 0; s2 < symbolHeight; s2++) {
	            row = bitmap[offsetS + s2];
	            if (!row) {
	              continue;
	            }
	            symbolRow = symbolBitmap[s2];
	            var maxWidth = Math.min(width - offsetT, symbolWidth);
	            switch (combinationOperator) {
	              case 0:
	                for (t2 = 0; t2 < maxWidth; t2++) {
	                  row[offsetT + t2] |= symbolRow[t2];
	                }
	                break;
	              case 2:
	                for (t2 = 0; t2 < maxWidth; t2++) {
	                  row[offsetT + t2] ^= symbolRow[t2];
	                }
	                break;
	              default:
	                throw new Jbig2Error('operator ' + combinationOperator + ' is not supported');
	            }
	          }
	          currentS += symbolHeight - 1;
	        } else {
	          for (t2 = 0; t2 < symbolHeight; t2++) {
	            row = bitmap[offsetT + t2];
	            if (!row) {
	              continue;
	            }
	            symbolRow = symbolBitmap[t2];
	            switch (combinationOperator) {
	              case 0:
	                for (s2 = 0; s2 < symbolWidth; s2++) {
	                  row[offsetS + s2] |= symbolRow[s2];
	                }
	                break;
	              case 2:
	                for (s2 = 0; s2 < symbolWidth; s2++) {
	                  row[offsetS + s2] ^= symbolRow[s2];
	                }
	                break;
	              default:
	                throw new Jbig2Error('operator ' + combinationOperator + ' is not supported');
	            }
	          }
	          currentS += symbolWidth - 1;
	        }
	        i++;
	        var deltaS = decodeInteger(contextCache, 'IADS', decoder);
	        if (deltaS === null) {
	          break;
	        }
	        currentS += deltaS + dsOffset;
	      } while (true);
	    }
	    return bitmap;
	  }
	  function decodePatternDictionary(mmr, patternWidth, patternHeight, maxPatternIndex, template, decodingContext) {
	    var at = [];
	    at.push({
	      x: -patternWidth,
	      y: 0
	    });
	    if (template === 0) {
	      at.push({
	        x: -3,
	        y: -1
	      });
	      at.push({
	        x: 2,
	        y: -2
	      });
	      at.push({
	        x: -2,
	        y: -2
	      });
	    }
	    var collectiveWidth = (maxPatternIndex + 1) * patternWidth;
	    var collectiveBitmap = decodeBitmap(mmr, collectiveWidth, patternHeight, template, false, null, at, decodingContext);
	    var patterns = [],
	        i = 0,
	        patternBitmap = void 0,
	        xMin = void 0,
	        xMax = void 0,
	        y = void 0;
	    while (i <= maxPatternIndex) {
	      patternBitmap = [];
	      xMin = patternWidth * i;
	      xMax = xMin + patternWidth;
	      for (y = 0; y < patternHeight; y++) {
	        patternBitmap.push(collectiveBitmap[y].subarray(xMin, xMax));
	      }
	      patterns.push(patternBitmap);
	      i++;
	    }
	    return patterns;
	  }
	  function decodeHalftoneRegion(mmr, patterns, template, regionWidth, regionHeight, defaultPixelValue, enableSkip, combinationOperator, gridWidth, gridHeight, gridOffsetX, gridOffsetY, gridVectorX, gridVectorY, decodingContext) {
	    var skip = null;
	    if (enableSkip) {
	      throw new Jbig2Error('skip is not supported');
	    }
	    if (combinationOperator !== 0) {
	      throw new Jbig2Error('operator ' + combinationOperator + ' is not supported in halftone region');
	    }
	    var regionBitmap = [];
	    var i = void 0,
	        j = void 0,
	        row = void 0;
	    for (i = 0; i < regionHeight; i++) {
	      row = new Uint8Array(regionWidth);
	      if (defaultPixelValue) {
	        for (j = 0; j < regionWidth; j++) {
	          row[j] = defaultPixelValue;
	        }
	      }
	      regionBitmap.push(row);
	    }
	    var numberOfPatterns = patterns.length;
	    var pattern0 = patterns[0];
	    var patternWidth = pattern0[0].length,
	        patternHeight = pattern0.length;
	    var bitsPerValue = (0, _util.log2)(numberOfPatterns);
	    var at = [];
	    at.push({
	      x: template <= 1 ? 3 : 2,
	      y: -1
	    });
	    if (template === 0) {
	      at.push({
	        x: -3,
	        y: -1
	      });
	      at.push({
	        x: 2,
	        y: -2
	      });
	      at.push({
	        x: -2,
	        y: -2
	      });
	    }
	    var grayScaleBitPlanes = [];
	    for (i = bitsPerValue - 1; i >= 0; i--) {
	      grayScaleBitPlanes[i] = decodeBitmap(mmr, gridWidth, gridHeight, template, false, skip, at, decodingContext);
	    }
	    var mg = void 0,
	        ng = void 0,
	        bit = void 0,
	        patternIndex = void 0,
	        patternBitmap = void 0,
	        x = void 0,
	        y = void 0,
	        patternRow = void 0,
	        regionRow = void 0;
	    for (mg = 0; mg < gridHeight; mg++) {
	      for (ng = 0; ng < gridWidth; ng++) {
	        bit = 0;
	        patternIndex = 0;
	        for (j = bitsPerValue - 1; j >= 0; j--) {
	          bit = grayScaleBitPlanes[j][mg][ng] ^ bit;
	          patternIndex |= bit << j;
	        }
	        patternBitmap = patterns[patternIndex];
	        x = gridOffsetX + mg * gridVectorY + ng * gridVectorX >> 8;
	        y = gridOffsetY + mg * gridVectorX - ng * gridVectorY >> 8;
	        if (x >= 0 && x + patternWidth <= regionWidth && y >= 0 && y + patternHeight <= regionHeight) {
	          for (i = 0; i < patternHeight; i++) {
	            regionRow = regionBitmap[y + i];
	            patternRow = patternBitmap[i];
	            for (j = 0; j < patternWidth; j++) {
	              regionRow[x + j] |= patternRow[j];
	            }
	          }
	        } else {
	          var regionX = void 0,
	              regionY = void 0;
	          for (i = 0; i < patternHeight; i++) {
	            regionY = y + i;
	            if (regionY < 0 || regionY >= regionHeight) {
	              continue;
	            }
	            regionRow = regionBitmap[regionY];
	            patternRow = patternBitmap[i];
	            for (j = 0; j < patternWidth; j++) {
	              regionX = x + j;
	              if (regionX >= 0 && regionX < regionWidth) {
	                regionRow[regionX] |= patternRow[j];
	              }
	            }
	          }
	        }
	      }
	    }
	    return regionBitmap;
	  }
	  function readSegmentHeader(data, start) {
	    var segmentHeader = {};
	    segmentHeader.number = (0, _util.readUint32)(data, start);
	    var flags = data[start + 4];
	    var segmentType = flags & 0x3F;
	    if (!SegmentTypes[segmentType]) {
	      throw new Jbig2Error('invalid segment type: ' + segmentType);
	    }
	    segmentHeader.type = segmentType;
	    segmentHeader.typeName = SegmentTypes[segmentType];
	    segmentHeader.deferredNonRetain = !!(flags & 0x80);
	    var pageAssociationFieldSize = !!(flags & 0x40);
	    var referredFlags = data[start + 5];
	    var referredToCount = referredFlags >> 5 & 7;
	    var retainBits = [referredFlags & 31];
	    var position = start + 6;
	    if (referredFlags === 7) {
	      referredToCount = (0, _util.readUint32)(data, position - 1) & 0x1FFFFFFF;
	      position += 3;
	      var bytes = referredToCount + 7 >> 3;
	      retainBits[0] = data[position++];
	      while (--bytes > 0) {
	        retainBits.push(data[position++]);
	      }
	    } else if (referredFlags === 5 || referredFlags === 6) {
	      throw new Jbig2Error('invalid referred-to flags');
	    }
	    segmentHeader.retainBits = retainBits;
	    var referredToSegmentNumberSize = segmentHeader.number <= 256 ? 1 : segmentHeader.number <= 65536 ? 2 : 4;
	    var referredTo = [];
	    var i, ii;
	    for (i = 0; i < referredToCount; i++) {
	      var number = referredToSegmentNumberSize === 1 ? data[position] : referredToSegmentNumberSize === 2 ? (0, _util.readUint16)(data, position) : (0, _util.readUint32)(data, position);
	      referredTo.push(number);
	      position += referredToSegmentNumberSize;
	    }
	    segmentHeader.referredTo = referredTo;
	    if (!pageAssociationFieldSize) {
	      segmentHeader.pageAssociation = data[position++];
	    } else {
	      segmentHeader.pageAssociation = (0, _util.readUint32)(data, position);
	      position += 4;
	    }
	    segmentHeader.length = (0, _util.readUint32)(data, position);
	    position += 4;
	    if (segmentHeader.length === 0xFFFFFFFF) {
	      if (segmentType === 38) {
	        var genericRegionInfo = readRegionSegmentInformation(data, position);
	        var genericRegionSegmentFlags = data[position + RegionSegmentInformationFieldLength];
	        var genericRegionMmr = !!(genericRegionSegmentFlags & 1);
	        var searchPatternLength = 6;
	        var searchPattern = new Uint8Array(searchPatternLength);
	        if (!genericRegionMmr) {
	          searchPattern[0] = 0xFF;
	          searchPattern[1] = 0xAC;
	        }
	        searchPattern[2] = genericRegionInfo.height >>> 24 & 0xFF;
	        searchPattern[3] = genericRegionInfo.height >> 16 & 0xFF;
	        searchPattern[4] = genericRegionInfo.height >> 8 & 0xFF;
	        searchPattern[5] = genericRegionInfo.height & 0xFF;
	        for (i = position, ii = data.length; i < ii; i++) {
	          var j = 0;
	          while (j < searchPatternLength && searchPattern[j] === data[i + j]) {
	            j++;
	          }
	          if (j === searchPatternLength) {
	            segmentHeader.length = i + searchPatternLength;
	            break;
	          }
	        }
	        if (segmentHeader.length === 0xFFFFFFFF) {
	          throw new Jbig2Error('segment end was not found');
	        }
	      } else {
	        throw new Jbig2Error('invalid unknown segment length');
	      }
	    }
	    segmentHeader.headerEnd = position;
	    return segmentHeader;
	  }
	  function readSegments(header, data, start, end) {
	    var segments = [];
	    var position = start;
	    while (position < end) {
	      var segmentHeader = readSegmentHeader(data, position);
	      position = segmentHeader.headerEnd;
	      var segment = {
	        header: segmentHeader,
	        data: data
	      };
	      if (!header.randomAccess) {
	        segment.start = position;
	        position += segmentHeader.length;
	        segment.end = position;
	      }
	      segments.push(segment);
	      if (segmentHeader.type === 51) {
	        break;
	      }
	    }
	    if (header.randomAccess) {
	      for (var i = 0, ii = segments.length; i < ii; i++) {
	        segments[i].start = position;
	        position += segments[i].header.length;
	        segments[i].end = position;
	      }
	    }
	    return segments;
	  }
	  function readRegionSegmentInformation(data, start) {
	    return {
	      width: (0, _util.readUint32)(data, start),
	      height: (0, _util.readUint32)(data, start + 4),
	      x: (0, _util.readUint32)(data, start + 8),
	      y: (0, _util.readUint32)(data, start + 12),
	      combinationOperator: data[start + 16] & 7
	    };
	  }
	  var RegionSegmentInformationFieldLength = 17;
	  function processSegment(segment, visitor) {
	    var header = segment.header;
	    var data = segment.data,
	        position = segment.start,
	        end = segment.end;
	    var args, at, i, atLength;
	    switch (header.type) {
	      case 0:
	        var dictionary = {};
	        var dictionaryFlags = (0, _util.readUint16)(data, position);
	        dictionary.huffman = !!(dictionaryFlags & 1);
	        dictionary.refinement = !!(dictionaryFlags & 2);
	        dictionary.huffmanDHSelector = dictionaryFlags >> 2 & 3;
	        dictionary.huffmanDWSelector = dictionaryFlags >> 4 & 3;
	        dictionary.bitmapSizeSelector = dictionaryFlags >> 6 & 1;
	        dictionary.aggregationInstancesSelector = dictionaryFlags >> 7 & 1;
	        dictionary.bitmapCodingContextUsed = !!(dictionaryFlags & 256);
	        dictionary.bitmapCodingContextRetained = !!(dictionaryFlags & 512);
	        dictionary.template = dictionaryFlags >> 10 & 3;
	        dictionary.refinementTemplate = dictionaryFlags >> 12 & 1;
	        position += 2;
	        if (!dictionary.huffman) {
	          atLength = dictionary.template === 0 ? 4 : 1;
	          at = [];
	          for (i = 0; i < atLength; i++) {
	            at.push({
	              x: (0, _util.readInt8)(data, position),
	              y: (0, _util.readInt8)(data, position + 1)
	            });
	            position += 2;
	          }
	          dictionary.at = at;
	        }
	        if (dictionary.refinement && !dictionary.refinementTemplate) {
	          at = [];
	          for (i = 0; i < 2; i++) {
	            at.push({
	              x: (0, _util.readInt8)(data, position),
	              y: (0, _util.readInt8)(data, position + 1)
	            });
	            position += 2;
	          }
	          dictionary.refinementAt = at;
	        }
	        dictionary.numberOfExportedSymbols = (0, _util.readUint32)(data, position);
	        position += 4;
	        dictionary.numberOfNewSymbols = (0, _util.readUint32)(data, position);
	        position += 4;
	        args = [dictionary, header.number, header.referredTo, data, position, end];
	        break;
	      case 6:
	      case 7:
	        var textRegion = {};
	        textRegion.info = readRegionSegmentInformation(data, position);
	        position += RegionSegmentInformationFieldLength;
	        var textRegionSegmentFlags = (0, _util.readUint16)(data, position);
	        position += 2;
	        textRegion.huffman = !!(textRegionSegmentFlags & 1);
	        textRegion.refinement = !!(textRegionSegmentFlags & 2);
	        textRegion.stripSize = 1 << (textRegionSegmentFlags >> 2 & 3);
	        textRegion.referenceCorner = textRegionSegmentFlags >> 4 & 3;
	        textRegion.transposed = !!(textRegionSegmentFlags & 64);
	        textRegion.combinationOperator = textRegionSegmentFlags >> 7 & 3;
	        textRegion.defaultPixelValue = textRegionSegmentFlags >> 9 & 1;
	        textRegion.dsOffset = textRegionSegmentFlags << 17 >> 27;
	        textRegion.refinementTemplate = textRegionSegmentFlags >> 15 & 1;
	        if (textRegion.huffman) {
	          var textRegionHuffmanFlags = (0, _util.readUint16)(data, position);
	          position += 2;
	          textRegion.huffmanFS = textRegionHuffmanFlags & 3;
	          textRegion.huffmanDS = textRegionHuffmanFlags >> 2 & 3;
	          textRegion.huffmanDT = textRegionHuffmanFlags >> 4 & 3;
	          textRegion.huffmanRefinementDW = textRegionHuffmanFlags >> 6 & 3;
	          textRegion.huffmanRefinementDH = textRegionHuffmanFlags >> 8 & 3;
	          textRegion.huffmanRefinementDX = textRegionHuffmanFlags >> 10 & 3;
	          textRegion.huffmanRefinementDY = textRegionHuffmanFlags >> 12 & 3;
	          textRegion.huffmanRefinementSizeSelector = !!(textRegionHuffmanFlags & 14);
	        }
	        if (textRegion.refinement && !textRegion.refinementTemplate) {
	          at = [];
	          for (i = 0; i < 2; i++) {
	            at.push({
	              x: (0, _util.readInt8)(data, position),
	              y: (0, _util.readInt8)(data, position + 1)
	            });
	            position += 2;
	          }
	          textRegion.refinementAt = at;
	        }
	        textRegion.numberOfSymbolInstances = (0, _util.readUint32)(data, position);
	        position += 4;
	        if (textRegion.huffman) {
	          throw new Jbig2Error('huffman is not supported');
	        }
	        args = [textRegion, header.referredTo, data, position, end];
	        break;
	      case 16:
	        var patternDictionary = {};
	        var patternDictionaryFlags = data[position++];
	        patternDictionary.mmr = !!(patternDictionaryFlags & 1);
	        patternDictionary.template = patternDictionaryFlags >> 1 & 3;
	        patternDictionary.patternWidth = data[position++];
	        patternDictionary.patternHeight = data[position++];
	        patternDictionary.maxPatternIndex = (0, _util.readUint32)(data, position);
	        position += 4;
	        args = [patternDictionary, header.number, data, position, end];
	        break;
	      case 22:
	      case 23:
	        var halftoneRegion = {};
	        halftoneRegion.info = readRegionSegmentInformation(data, position);
	        position += RegionSegmentInformationFieldLength;
	        var halftoneRegionFlags = data[position++];
	        halftoneRegion.mmr = !!(halftoneRegionFlags & 1);
	        halftoneRegion.template = halftoneRegionFlags >> 1 & 3;
	        halftoneRegion.enableSkip = !!(halftoneRegionFlags & 8);
	        halftoneRegion.combinationOperator = halftoneRegionFlags >> 4 & 7;
	        halftoneRegion.defaultPixelValue = halftoneRegionFlags >> 7 & 1;
	        halftoneRegion.gridWidth = (0, _util.readUint32)(data, position);
	        position += 4;
	        halftoneRegion.gridHeight = (0, _util.readUint32)(data, position);
	        position += 4;
	        halftoneRegion.gridOffsetX = (0, _util.readUint32)(data, position) & 0xFFFFFFFF;
	        position += 4;
	        halftoneRegion.gridOffsetY = (0, _util.readUint32)(data, position) & 0xFFFFFFFF;
	        position += 4;
	        halftoneRegion.gridVectorX = (0, _util.readUint16)(data, position);
	        position += 2;
	        halftoneRegion.gridVectorY = (0, _util.readUint16)(data, position);
	        position += 2;
	        args = [halftoneRegion, header.referredTo, data, position, end];
	        break;
	      case 38:
	      case 39:
	        var genericRegion = {};
	        genericRegion.info = readRegionSegmentInformation(data, position);
	        position += RegionSegmentInformationFieldLength;
	        var genericRegionSegmentFlags = data[position++];
	        genericRegion.mmr = !!(genericRegionSegmentFlags & 1);
	        genericRegion.template = genericRegionSegmentFlags >> 1 & 3;
	        genericRegion.prediction = !!(genericRegionSegmentFlags & 8);
	        if (!genericRegion.mmr) {
	          atLength = genericRegion.template === 0 ? 4 : 1;
	          at = [];
	          for (i = 0; i < atLength; i++) {
	            at.push({
	              x: (0, _util.readInt8)(data, position),
	              y: (0, _util.readInt8)(data, position + 1)
	            });
	            position += 2;
	          }
	          genericRegion.at = at;
	        }
	        args = [genericRegion, data, position, end];
	        break;
	      case 48:
	        var pageInfo = {
	          width: (0, _util.readUint32)(data, position),
	          height: (0, _util.readUint32)(data, position + 4),
	          resolutionX: (0, _util.readUint32)(data, position + 8),
	          resolutionY: (0, _util.readUint32)(data, position + 12)
	        };
	        if (pageInfo.height === 0xFFFFFFFF) {
	          delete pageInfo.height;
	        }
	        var pageSegmentFlags = data[position + 16];
	        (0, _util.readUint16)(data, position + 17);
	        pageInfo.lossless = !!(pageSegmentFlags & 1);
	        pageInfo.refinement = !!(pageSegmentFlags & 2);
	        pageInfo.defaultPixelValue = pageSegmentFlags >> 2 & 1;
	        pageInfo.combinationOperator = pageSegmentFlags >> 3 & 3;
	        pageInfo.requiresBuffer = !!(pageSegmentFlags & 32);
	        pageInfo.combinationOperatorOverride = !!(pageSegmentFlags & 64);
	        args = [pageInfo];
	        break;
	      case 49:
	        break;
	      case 50:
	        break;
	      case 51:
	        break;
	      case 62:
	        break;
	      default:
	        throw new Jbig2Error('segment type ' + header.typeName + '(' + header.type + ')' + ' is not implemented');
	    }
	    var callbackName = 'on' + header.typeName;
	    if (callbackName in visitor) {
	      visitor[callbackName].apply(visitor, args);
	    }
	  }
	  function processSegments(segments, visitor) {
	    for (var i = 0, ii = segments.length; i < ii; i++) {
	      processSegment(segments[i], visitor);
	    }
	  }
	  function parseJbig2(data, start, end) {
	    var position = start;
	    if (data[position] !== 0x97 || data[position + 1] !== 0x4A || data[position + 2] !== 0x42 || data[position + 3] !== 0x32 || data[position + 4] !== 0x0D || data[position + 5] !== 0x0A || data[position + 6] !== 0x1A || data[position + 7] !== 0x0A) {
	      throw new Jbig2Error('invalid header');
	    }
	    var header = {};
	    position += 8;
	    var flags = data[position++];
	    header.randomAccess = !(flags & 1);
	    if (!(flags & 2)) {
	      header.numberOfPages = (0, _util.readUint32)(data, position);
	      position += 4;
	    }
	    readSegments(header, data, position, end);
	    throw new Error('Not implemented');
	  }
	  function parseJbig2Chunks(chunks) {
	    var visitor = new SimpleSegmentVisitor();
	    for (var i = 0, ii = chunks.length; i < ii; i++) {
	      var chunk = chunks[i];
	      var segments = readSegments({}, chunk.data, chunk.start, chunk.end);
	      processSegments(segments, visitor);
	    }
	    return visitor.buffer;
	  }
	  function SimpleSegmentVisitor() {}
	  SimpleSegmentVisitor.prototype = {
	    onPageInformation: function SimpleSegmentVisitor_onPageInformation(info) {
	      this.currentPageInfo = info;
	      var rowSize = info.width + 7 >> 3;
	      var buffer = new Uint8ClampedArray(rowSize * info.height);
	      if (info.defaultPixelValue) {
	        for (var i = 0, ii = buffer.length; i < ii; i++) {
	          buffer[i] = 0xFF;
	        }
	      }
	      this.buffer = buffer;
	    },
	    drawBitmap: function SimpleSegmentVisitor_drawBitmap(regionInfo, bitmap) {
	      var pageInfo = this.currentPageInfo;
	      var width = regionInfo.width,
	          height = regionInfo.height;
	      var rowSize = pageInfo.width + 7 >> 3;
	      var combinationOperator = pageInfo.combinationOperatorOverride ? regionInfo.combinationOperator : pageInfo.combinationOperator;
	      var buffer = this.buffer;
	      var mask0 = 128 >> (regionInfo.x & 7);
	      var offset0 = regionInfo.y * rowSize + (regionInfo.x >> 3);
	      var i, j, mask, offset;
	      switch (combinationOperator) {
	        case 0:
	          for (i = 0; i < height; i++) {
	            mask = mask0;
	            offset = offset0;
	            for (j = 0; j < width; j++) {
	              if (bitmap[i][j]) {
	                buffer[offset] |= mask;
	              }
	              mask >>= 1;
	              if (!mask) {
	                mask = 128;
	                offset++;
	              }
	            }
	            offset0 += rowSize;
	          }
	          break;
	        case 2:
	          for (i = 0; i < height; i++) {
	            mask = mask0;
	            offset = offset0;
	            for (j = 0; j < width; j++) {
	              if (bitmap[i][j]) {
	                buffer[offset] ^= mask;
	              }
	              mask >>= 1;
	              if (!mask) {
	                mask = 128;
	                offset++;
	              }
	            }
	            offset0 += rowSize;
	          }
	          break;
	        default:
	          throw new Jbig2Error('operator ' + combinationOperator + ' is not supported');
	      }
	    },
	    onImmediateGenericRegion: function SimpleSegmentVisitor_onImmediateGenericRegion(region, data, start, end) {
	      var regionInfo = region.info;
	      var decodingContext = new DecodingContext(data, start, end);
	      var bitmap = decodeBitmap(region.mmr, regionInfo.width, regionInfo.height, region.template, region.prediction, null, region.at, decodingContext);
	      this.drawBitmap(regionInfo, bitmap);
	    },
	    onImmediateLosslessGenericRegion: function SimpleSegmentVisitor_onImmediateLosslessGenericRegion() {
	      this.onImmediateGenericRegion.apply(this, arguments);
	    },
	    onSymbolDictionary: function SimpleSegmentVisitor_onSymbolDictionary(dictionary, currentSegment, referredSegments, data, start, end) {
	      var huffmanTables;
	      if (dictionary.huffman) {
	        throw new Jbig2Error('huffman is not supported');
	      }
	      var symbols = this.symbols;
	      if (!symbols) {
	        this.symbols = symbols = {};
	      }
	      var inputSymbols = [];
	      for (var i = 0, ii = referredSegments.length; i < ii; i++) {
	        inputSymbols = inputSymbols.concat(symbols[referredSegments[i]]);
	      }
	      var decodingContext = new DecodingContext(data, start, end);
	      symbols[currentSegment] = decodeSymbolDictionary(dictionary.huffman, dictionary.refinement, inputSymbols, dictionary.numberOfNewSymbols, dictionary.numberOfExportedSymbols, huffmanTables, dictionary.template, dictionary.at, dictionary.refinementTemplate, dictionary.refinementAt, decodingContext);
	    },
	    onImmediateTextRegion: function SimpleSegmentVisitor_onImmediateTextRegion(region, referredSegments, data, start, end) {
	      var regionInfo = region.info;
	      var huffmanTables;
	      var symbols = this.symbols;
	      var inputSymbols = [];
	      for (var i = 0, ii = referredSegments.length; i < ii; i++) {
	        inputSymbols = inputSymbols.concat(symbols[referredSegments[i]]);
	      }
	      var symbolCodeLength = (0, _util.log2)(inputSymbols.length);
	      var decodingContext = new DecodingContext(data, start, end);
	      var bitmap = decodeTextRegion(region.huffman, region.refinement, regionInfo.width, regionInfo.height, region.defaultPixelValue, region.numberOfSymbolInstances, region.stripSize, inputSymbols, symbolCodeLength, region.transposed, region.dsOffset, region.referenceCorner, region.combinationOperator, huffmanTables, region.refinementTemplate, region.refinementAt, decodingContext);
	      this.drawBitmap(regionInfo, bitmap);
	    },
	    onImmediateLosslessTextRegion: function SimpleSegmentVisitor_onImmediateLosslessTextRegion() {
	      this.onImmediateTextRegion.apply(this, arguments);
	    },
	    onPatternDictionary: function onPatternDictionary(dictionary, currentSegment, data, start, end) {
	      var patterns = this.patterns;
	      if (!patterns) {
	        this.patterns = patterns = {};
	      }
	      var decodingContext = new DecodingContext(data, start, end);
	      patterns[currentSegment] = decodePatternDictionary(dictionary.mmr, dictionary.patternWidth, dictionary.patternHeight, dictionary.maxPatternIndex, dictionary.template, decodingContext);
	    },
	    onImmediateHalftoneRegion: function onImmediateHalftoneRegion(region, referredSegments, data, start, end) {
	      var patterns = this.patterns[referredSegments[0]];
	      var regionInfo = region.info;
	      var decodingContext = new DecodingContext(data, start, end);
	      var bitmap = decodeHalftoneRegion(region.mmr, patterns, region.template, regionInfo.width, regionInfo.height, region.defaultPixelValue, region.enableSkip, region.combinationOperator, region.gridWidth, region.gridHeight, region.gridOffsetX, region.gridOffsetY, region.gridVectorX, region.gridVectorY, decodingContext);
	      this.drawBitmap(regionInfo, bitmap);
	    },
	    onImmediateLosslessHalftoneRegion: function onImmediateLosslessHalftoneRegion() {
	      this.onImmediateHalftoneRegion.apply(this, arguments);
	    }
	  };
	  function Jbig2Image() {}
	  Jbig2Image.prototype = {
	    parseChunks: function Jbig2Image_parseChunks(chunks) {
	      return parseJbig2Chunks(chunks);
	    }
	  };
	  return Jbig2Image;
	}();
	exports.Jbig2Image = Jbig2Image;
	
	/***/ }),
	/* 148 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CMapFactory = exports.IdentityCMap = exports.CMap = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _primitives = __w_pdfjs_require__(2);
	
	var _parser = __w_pdfjs_require__(36);
	
	var _stream = __w_pdfjs_require__(5);
	
	var BUILT_IN_CMAPS = ['Adobe-GB1-UCS2', 'Adobe-CNS1-UCS2', 'Adobe-Japan1-UCS2', 'Adobe-Korea1-UCS2', '78-EUC-H', '78-EUC-V', '78-H', '78-RKSJ-H', '78-RKSJ-V', '78-V', '78ms-RKSJ-H', '78ms-RKSJ-V', '83pv-RKSJ-H', '90ms-RKSJ-H', '90ms-RKSJ-V', '90msp-RKSJ-H', '90msp-RKSJ-V', '90pv-RKSJ-H', '90pv-RKSJ-V', 'Add-H', 'Add-RKSJ-H', 'Add-RKSJ-V', 'Add-V', 'Adobe-CNS1-0', 'Adobe-CNS1-1', 'Adobe-CNS1-2', 'Adobe-CNS1-3', 'Adobe-CNS1-4', 'Adobe-CNS1-5', 'Adobe-CNS1-6', 'Adobe-GB1-0', 'Adobe-GB1-1', 'Adobe-GB1-2', 'Adobe-GB1-3', 'Adobe-GB1-4', 'Adobe-GB1-5', 'Adobe-Japan1-0', 'Adobe-Japan1-1', 'Adobe-Japan1-2', 'Adobe-Japan1-3', 'Adobe-Japan1-4', 'Adobe-Japan1-5', 'Adobe-Japan1-6', 'Adobe-Korea1-0', 'Adobe-Korea1-1', 'Adobe-Korea1-2', 'B5-H', 'B5-V', 'B5pc-H', 'B5pc-V', 'CNS-EUC-H', 'CNS-EUC-V', 'CNS1-H', 'CNS1-V', 'CNS2-H', 'CNS2-V', 'ETHK-B5-H', 'ETHK-B5-V', 'ETen-B5-H', 'ETen-B5-V', 'ETenms-B5-H', 'ETenms-B5-V', 'EUC-H', 'EUC-V', 'Ext-H', 'Ext-RKSJ-H', 'Ext-RKSJ-V', 'Ext-V', 'GB-EUC-H', 'GB-EUC-V', 'GB-H', 'GB-V', 'GBK-EUC-H', 'GBK-EUC-V', 'GBK2K-H', 'GBK2K-V', 'GBKp-EUC-H', 'GBKp-EUC-V', 'GBT-EUC-H', 'GBT-EUC-V', 'GBT-H', 'GBT-V', 'GBTpc-EUC-H', 'GBTpc-EUC-V', 'GBpc-EUC-H', 'GBpc-EUC-V', 'H', 'HKdla-B5-H', 'HKdla-B5-V', 'HKdlb-B5-H', 'HKdlb-B5-V', 'HKgccs-B5-H', 'HKgccs-B5-V', 'HKm314-B5-H', 'HKm314-B5-V', 'HKm471-B5-H', 'HKm471-B5-V', 'HKscs-B5-H', 'HKscs-B5-V', 'Hankaku', 'Hiragana', 'KSC-EUC-H', 'KSC-EUC-V', 'KSC-H', 'KSC-Johab-H', 'KSC-Johab-V', 'KSC-V', 'KSCms-UHC-H', 'KSCms-UHC-HW-H', 'KSCms-UHC-HW-V', 'KSCms-UHC-V', 'KSCpc-EUC-H', 'KSCpc-EUC-V', 'Katakana', 'NWP-H', 'NWP-V', 'RKSJ-H', 'RKSJ-V', 'Roman', 'UniCNS-UCS2-H', 'UniCNS-UCS2-V', 'UniCNS-UTF16-H', 'UniCNS-UTF16-V', 'UniCNS-UTF32-H', 'UniCNS-UTF32-V', 'UniCNS-UTF8-H', 'UniCNS-UTF8-V', 'UniGB-UCS2-H', 'UniGB-UCS2-V', 'UniGB-UTF16-H', 'UniGB-UTF16-V', 'UniGB-UTF32-H', 'UniGB-UTF32-V', 'UniGB-UTF8-H', 'UniGB-UTF8-V', 'UniJIS-UCS2-H', 'UniJIS-UCS2-HW-H', 'UniJIS-UCS2-HW-V', 'UniJIS-UCS2-V', 'UniJIS-UTF16-H', 'UniJIS-UTF16-V', 'UniJIS-UTF32-H', 'UniJIS-UTF32-V', 'UniJIS-UTF8-H', 'UniJIS-UTF8-V', 'UniJIS2004-UTF16-H', 'UniJIS2004-UTF16-V', 'UniJIS2004-UTF32-H', 'UniJIS2004-UTF32-V', 'UniJIS2004-UTF8-H', 'UniJIS2004-UTF8-V', 'UniJISPro-UCS2-HW-V', 'UniJISPro-UCS2-V', 'UniJISPro-UTF8-V', 'UniJISX0213-UTF32-H', 'UniJISX0213-UTF32-V', 'UniJISX02132004-UTF32-H', 'UniJISX02132004-UTF32-V', 'UniKS-UCS2-H', 'UniKS-UCS2-V', 'UniKS-UTF16-H', 'UniKS-UTF16-V', 'UniKS-UTF32-H', 'UniKS-UTF32-V', 'UniKS-UTF8-H', 'UniKS-UTF8-V', 'V', 'WP-Symbol'];
	var CMap = function CMapClosure() {
	  function CMap(builtInCMap) {
	    this.codespaceRanges = [[], [], [], []];
	    this.numCodespaceRanges = 0;
	    this._map = [];
	    this.name = '';
	    this.vertical = false;
	    this.useCMap = null;
	    this.builtInCMap = builtInCMap;
	  }
	  CMap.prototype = {
	    addCodespaceRange: function addCodespaceRange(n, low, high) {
	      this.codespaceRanges[n - 1].push(low, high);
	      this.numCodespaceRanges++;
	    },
	    mapCidRange: function mapCidRange(low, high, dstLow) {
	      while (low <= high) {
	        this._map[low++] = dstLow++;
	      }
	    },
	    mapBfRange: function mapBfRange(low, high, dstLow) {
	      var lastByte = dstLow.length - 1;
	      while (low <= high) {
	        this._map[low++] = dstLow;
	        dstLow = dstLow.substr(0, lastByte) + String.fromCharCode(dstLow.charCodeAt(lastByte) + 1);
	      }
	    },
	    mapBfRangeToArray: function mapBfRangeToArray(low, high, array) {
	      var i = 0,
	          ii = array.length;
	      while (low <= high && i < ii) {
	        this._map[low] = array[i++];
	        ++low;
	      }
	    },
	    mapOne: function mapOne(src, dst) {
	      this._map[src] = dst;
	    },
	    lookup: function lookup(code) {
	      return this._map[code];
	    },
	    contains: function contains(code) {
	      return this._map[code] !== undefined;
	    },
	    forEach: function forEach(callback) {
	      var map = this._map;
	      var length = map.length;
	      if (length <= 0x10000) {
	        for (var i = 0; i < length; i++) {
	          if (map[i] !== undefined) {
	            callback(i, map[i]);
	          }
	        }
	      } else {
	        for (var _i in map) {
	          callback(_i, map[_i]);
	        }
	      }
	    },
	    charCodeOf: function charCodeOf(value) {
	      var map = this._map;
	      if (map.length <= 0x10000) {
	        return map.indexOf(value);
	      }
	      for (var charCode in map) {
	        if (map[charCode] === value) {
	          return charCode | 0;
	        }
	      }
	      return -1;
	    },
	    getMap: function getMap() {
	      return this._map;
	    },
	    readCharCode: function readCharCode(str, offset, out) {
	      var c = 0;
	      var codespaceRanges = this.codespaceRanges;
	      var codespaceRangesLen = this.codespaceRanges.length;
	      for (var n = 0; n < codespaceRangesLen; n++) {
	        c = (c << 8 | str.charCodeAt(offset + n)) >>> 0;
	        var codespaceRange = codespaceRanges[n];
	        for (var k = 0, kk = codespaceRange.length; k < kk;) {
	          var low = codespaceRange[k++];
	          var high = codespaceRange[k++];
	          if (c >= low && c <= high) {
	            out.charcode = c;
	            out.length = n + 1;
	            return;
	          }
	        }
	      }
	      out.charcode = 0;
	      out.length = 1;
	    },
	
	    get length() {
	      return this._map.length;
	    },
	    get isIdentityCMap() {
	      if (!(this.name === 'Identity-H' || this.name === 'Identity-V')) {
	        return false;
	      }
	      if (this._map.length !== 0x10000) {
	        return false;
	      }
	      for (var i = 0; i < 0x10000; i++) {
	        if (this._map[i] !== i) {
	          return false;
	        }
	      }
	      return true;
	    }
	  };
	  return CMap;
	}();
	var IdentityCMap = function IdentityCMapClosure() {
	  function IdentityCMap(vertical, n) {
	    CMap.call(this);
	    this.vertical = vertical;
	    this.addCodespaceRange(n, 0, 0xffff);
	  }
	  _util.Util.inherit(IdentityCMap, CMap, {});
	  IdentityCMap.prototype = {
	    addCodespaceRange: CMap.prototype.addCodespaceRange,
	    mapCidRange: function mapCidRange(low, high, dstLow) {
	      throw new Error('should not call mapCidRange');
	    },
	    mapBfRange: function mapBfRange(low, high, dstLow) {
	      throw new Error('should not call mapBfRange');
	    },
	    mapBfRangeToArray: function mapBfRangeToArray(low, high, array) {
	      throw new Error('should not call mapBfRangeToArray');
	    },
	    mapOne: function mapOne(src, dst) {
	      throw new Error('should not call mapCidOne');
	    },
	    lookup: function lookup(code) {
	      return Number.isInteger(code) && code <= 0xffff ? code : undefined;
	    },
	    contains: function contains(code) {
	      return Number.isInteger(code) && code <= 0xffff;
	    },
	    forEach: function forEach(callback) {
	      for (var i = 0; i <= 0xffff; i++) {
	        callback(i, i);
	      }
	    },
	    charCodeOf: function charCodeOf(value) {
	      return Number.isInteger(value) && value <= 0xffff ? value : -1;
	    },
	    getMap: function getMap() {
	      var map = new Array(0x10000);
	      for (var i = 0; i <= 0xffff; i++) {
	        map[i] = i;
	      }
	      return map;
	    },
	
	    readCharCode: CMap.prototype.readCharCode,
	    get length() {
	      return 0x10000;
	    },
	    get isIdentityCMap() {
	      throw new Error('should not access .isIdentityCMap');
	    }
	  };
	  return IdentityCMap;
	}();
	var BinaryCMapReader = function BinaryCMapReaderClosure() {
	  function hexToInt(a, size) {
	    var n = 0;
	    for (var i = 0; i <= size; i++) {
	      n = n << 8 | a[i];
	    }
	    return n >>> 0;
	  }
	  function hexToStr(a, size) {
	    if (size === 1) {
	      return String.fromCharCode(a[0], a[1]);
	    }
	    if (size === 3) {
	      return String.fromCharCode(a[0], a[1], a[2], a[3]);
	    }
	    return String.fromCharCode.apply(null, a.subarray(0, size + 1));
	  }
	  function addHex(a, b, size) {
	    var c = 0;
	    for (var i = size; i >= 0; i--) {
	      c += a[i] + b[i];
	      a[i] = c & 255;
	      c >>= 8;
	    }
	  }
	  function incHex(a, size) {
	    var c = 1;
	    for (var i = size; i >= 0 && c > 0; i--) {
	      c += a[i];
	      a[i] = c & 255;
	      c >>= 8;
	    }
	  }
	  var MAX_NUM_SIZE = 16;
	  var MAX_ENCODED_NUM_SIZE = 19;
	  function BinaryCMapStream(data) {
	    this.buffer = data;
	    this.pos = 0;
	    this.end = data.length;
	    this.tmpBuf = new Uint8Array(MAX_ENCODED_NUM_SIZE);
	  }
	  BinaryCMapStream.prototype = {
	    readByte: function readByte() {
	      if (this.pos >= this.end) {
	        return -1;
	      }
	      return this.buffer[this.pos++];
	    },
	    readNumber: function readNumber() {
	      var n = 0;
	      var last;
	      do {
	        var b = this.readByte();
	        if (b < 0) {
	          throw new _util.FormatError('unexpected EOF in bcmap');
	        }
	        last = !(b & 0x80);
	        n = n << 7 | b & 0x7F;
	      } while (!last);
	      return n;
	    },
	    readSigned: function readSigned() {
	      var n = this.readNumber();
	      return n & 1 ? ~(n >>> 1) : n >>> 1;
	    },
	    readHex: function readHex(num, size) {
	      num.set(this.buffer.subarray(this.pos, this.pos + size + 1));
	      this.pos += size + 1;
	    },
	    readHexNumber: function readHexNumber(num, size) {
	      var last;
	      var stack = this.tmpBuf,
	          sp = 0;
	      do {
	        var b = this.readByte();
	        if (b < 0) {
	          throw new _util.FormatError('unexpected EOF in bcmap');
	        }
	        last = !(b & 0x80);
	        stack[sp++] = b & 0x7F;
	      } while (!last);
	      var i = size,
	          buffer = 0,
	          bufferSize = 0;
	      while (i >= 0) {
	        while (bufferSize < 8 && stack.length > 0) {
	          buffer = stack[--sp] << bufferSize | buffer;
	          bufferSize += 7;
	        }
	        num[i] = buffer & 255;
	        i--;
	        buffer >>= 8;
	        bufferSize -= 8;
	      }
	    },
	    readHexSigned: function readHexSigned(num, size) {
	      this.readHexNumber(num, size);
	      var sign = num[size] & 1 ? 255 : 0;
	      var c = 0;
	      for (var i = 0; i <= size; i++) {
	        c = (c & 1) << 8 | num[i];
	        num[i] = c >> 1 ^ sign;
	      }
	    },
	    readString: function readString() {
	      var len = this.readNumber();
	      var s = '';
	      for (var i = 0; i < len; i++) {
	        s += String.fromCharCode(this.readNumber());
	      }
	      return s;
	    }
	  };
	  function processBinaryCMap(data, cMap, extend) {
	    return new Promise(function (resolve, reject) {
	      var stream = new BinaryCMapStream(data);
	      var header = stream.readByte();
	      cMap.vertical = !!(header & 1);
	      var useCMap = null;
	      var start = new Uint8Array(MAX_NUM_SIZE);
	      var end = new Uint8Array(MAX_NUM_SIZE);
	      var char = new Uint8Array(MAX_NUM_SIZE);
	      var charCode = new Uint8Array(MAX_NUM_SIZE);
	      var tmp = new Uint8Array(MAX_NUM_SIZE);
	      var code;
	      var b;
	      while ((b = stream.readByte()) >= 0) {
	        var type = b >> 5;
	        if (type === 7) {
	          switch (b & 0x1F) {
	            case 0:
	              stream.readString();
	              break;
	            case 1:
	              useCMap = stream.readString();
	              break;
	          }
	          continue;
	        }
	        var sequence = !!(b & 0x10);
	        var dataSize = b & 15;
	        if (dataSize + 1 > MAX_NUM_SIZE) {
	          throw new Error('processBinaryCMap: Invalid dataSize.');
	        }
	        var ucs2DataSize = 1;
	        var subitemsCount = stream.readNumber();
	        var i;
	        switch (type) {
	          case 0:
	            stream.readHex(start, dataSize);
	            stream.readHexNumber(end, dataSize);
	            addHex(end, start, dataSize);
	            cMap.addCodespaceRange(dataSize + 1, hexToInt(start, dataSize), hexToInt(end, dataSize));
	            for (i = 1; i < subitemsCount; i++) {
	              incHex(end, dataSize);
	              stream.readHexNumber(start, dataSize);
	              addHex(start, end, dataSize);
	              stream.readHexNumber(end, dataSize);
	              addHex(end, start, dataSize);
	              cMap.addCodespaceRange(dataSize + 1, hexToInt(start, dataSize), hexToInt(end, dataSize));
	            }
	            break;
	          case 1:
	            stream.readHex(start, dataSize);
	            stream.readHexNumber(end, dataSize);
	            addHex(end, start, dataSize);
	            code = stream.readNumber();
	            for (i = 1; i < subitemsCount; i++) {
	              incHex(end, dataSize);
	              stream.readHexNumber(start, dataSize);
	              addHex(start, end, dataSize);
	              stream.readHexNumber(end, dataSize);
	              addHex(end, start, dataSize);
	              code = stream.readNumber();
	            }
	            break;
	          case 2:
	            stream.readHex(char, dataSize);
	            code = stream.readNumber();
	            cMap.mapOne(hexToInt(char, dataSize), code);
	            for (i = 1; i < subitemsCount; i++) {
	              incHex(char, dataSize);
	              if (!sequence) {
	                stream.readHexNumber(tmp, dataSize);
	                addHex(char, tmp, dataSize);
	              }
	              code = stream.readSigned() + (code + 1);
	              cMap.mapOne(hexToInt(char, dataSize), code);
	            }
	            break;
	          case 3:
	            stream.readHex(start, dataSize);
	            stream.readHexNumber(end, dataSize);
	            addHex(end, start, dataSize);
	            code = stream.readNumber();
	            cMap.mapCidRange(hexToInt(start, dataSize), hexToInt(end, dataSize), code);
	            for (i = 1; i < subitemsCount; i++) {
	              incHex(end, dataSize);
	              if (!sequence) {
	                stream.readHexNumber(start, dataSize);
	                addHex(start, end, dataSize);
	              } else {
	                start.set(end);
	              }
	              stream.readHexNumber(end, dataSize);
	              addHex(end, start, dataSize);
	              code = stream.readNumber();
	              cMap.mapCidRange(hexToInt(start, dataSize), hexToInt(end, dataSize), code);
	            }
	            break;
	          case 4:
	            stream.readHex(char, ucs2DataSize);
	            stream.readHex(charCode, dataSize);
	            cMap.mapOne(hexToInt(char, ucs2DataSize), hexToStr(charCode, dataSize));
	            for (i = 1; i < subitemsCount; i++) {
	              incHex(char, ucs2DataSize);
	              if (!sequence) {
	                stream.readHexNumber(tmp, ucs2DataSize);
	                addHex(char, tmp, ucs2DataSize);
	              }
	              incHex(charCode, dataSize);
	              stream.readHexSigned(tmp, dataSize);
	              addHex(charCode, tmp, dataSize);
	              cMap.mapOne(hexToInt(char, ucs2DataSize), hexToStr(charCode, dataSize));
	            }
	            break;
	          case 5:
	            stream.readHex(start, ucs2DataSize);
	            stream.readHexNumber(end, ucs2DataSize);
	            addHex(end, start, ucs2DataSize);
	            stream.readHex(charCode, dataSize);
	            cMap.mapBfRange(hexToInt(start, ucs2DataSize), hexToInt(end, ucs2DataSize), hexToStr(charCode, dataSize));
	            for (i = 1; i < subitemsCount; i++) {
	              incHex(end, ucs2DataSize);
	              if (!sequence) {
	                stream.readHexNumber(start, ucs2DataSize);
	                addHex(start, end, ucs2DataSize);
	              } else {
	                start.set(end);
	              }
	              stream.readHexNumber(end, ucs2DataSize);
	              addHex(end, start, ucs2DataSize);
	              stream.readHex(charCode, dataSize);
	              cMap.mapBfRange(hexToInt(start, ucs2DataSize), hexToInt(end, ucs2DataSize), hexToStr(charCode, dataSize));
	            }
	            break;
	          default:
	            reject(new Error('processBinaryCMap: Unknown type: ' + type));
	            return;
	        }
	      }
	      if (useCMap) {
	        resolve(extend(useCMap));
	        return;
	      }
	      resolve(cMap);
	    });
	  }
	  function BinaryCMapReader() {}
	  BinaryCMapReader.prototype = { process: processBinaryCMap };
	  return BinaryCMapReader;
	}();
	var CMapFactory = function CMapFactoryClosure() {
	  function strToInt(str) {
	    var a = 0;
	    for (var i = 0; i < str.length; i++) {
	      a = a << 8 | str.charCodeAt(i);
	    }
	    return a >>> 0;
	  }
	  function expectString(obj) {
	    if (!(0, _util.isString)(obj)) {
	      throw new _util.FormatError('Malformed CMap: expected string.');
	    }
	  }
	  function expectInt(obj) {
	    if (!Number.isInteger(obj)) {
	      throw new _util.FormatError('Malformed CMap: expected int.');
	    }
	  }
	  function parseBfChar(cMap, lexer) {
	    while (true) {
	      var obj = lexer.getObj();
	      if ((0, _primitives.isEOF)(obj)) {
	        break;
	      }
	      if ((0, _primitives.isCmd)(obj, 'endbfchar')) {
	        return;
	      }
	      expectString(obj);
	      var src = strToInt(obj);
	      obj = lexer.getObj();
	      expectString(obj);
	      var dst = obj;
	      cMap.mapOne(src, dst);
	    }
	  }
	  function parseBfRange(cMap, lexer) {
	    while (true) {
	      var obj = lexer.getObj();
	      if ((0, _primitives.isEOF)(obj)) {
	        break;
	      }
	      if ((0, _primitives.isCmd)(obj, 'endbfrange')) {
	        return;
	      }
	      expectString(obj);
	      var low = strToInt(obj);
	      obj = lexer.getObj();
	      expectString(obj);
	      var high = strToInt(obj);
	      obj = lexer.getObj();
	      if (Number.isInteger(obj) || (0, _util.isString)(obj)) {
	        var dstLow = Number.isInteger(obj) ? String.fromCharCode(obj) : obj;
	        cMap.mapBfRange(low, high, dstLow);
	      } else if ((0, _primitives.isCmd)(obj, '[')) {
	        obj = lexer.getObj();
	        var array = [];
	        while (!(0, _primitives.isCmd)(obj, ']') && !(0, _primitives.isEOF)(obj)) {
	          array.push(obj);
	          obj = lexer.getObj();
	        }
	        cMap.mapBfRangeToArray(low, high, array);
	      } else {
	        break;
	      }
	    }
	    throw new _util.FormatError('Invalid bf range.');
	  }
	  function parseCidChar(cMap, lexer) {
	    while (true) {
	      var obj = lexer.getObj();
	      if ((0, _primitives.isEOF)(obj)) {
	        break;
	      }
	      if ((0, _primitives.isCmd)(obj, 'endcidchar')) {
	        return;
	      }
	      expectString(obj);
	      var src = strToInt(obj);
	      obj = lexer.getObj();
	      expectInt(obj);
	      var dst = obj;
	      cMap.mapOne(src, dst);
	    }
	  }
	  function parseCidRange(cMap, lexer) {
	    while (true) {
	      var obj = lexer.getObj();
	      if ((0, _primitives.isEOF)(obj)) {
	        break;
	      }
	      if ((0, _primitives.isCmd)(obj, 'endcidrange')) {
	        return;
	      }
	      expectString(obj);
	      var low = strToInt(obj);
	      obj = lexer.getObj();
	      expectString(obj);
	      var high = strToInt(obj);
	      obj = lexer.getObj();
	      expectInt(obj);
	      var dstLow = obj;
	      cMap.mapCidRange(low, high, dstLow);
	    }
	  }
	  function parseCodespaceRange(cMap, lexer) {
	    while (true) {
	      var obj = lexer.getObj();
	      if ((0, _primitives.isEOF)(obj)) {
	        break;
	      }
	      if ((0, _primitives.isCmd)(obj, 'endcodespacerange')) {
	        return;
	      }
	      if (!(0, _util.isString)(obj)) {
	        break;
	      }
	      var low = strToInt(obj);
	      obj = lexer.getObj();
	      if (!(0, _util.isString)(obj)) {
	        break;
	      }
	      var high = strToInt(obj);
	      cMap.addCodespaceRange(obj.length, low, high);
	    }
	    throw new _util.FormatError('Invalid codespace range.');
	  }
	  function parseWMode(cMap, lexer) {
	    var obj = lexer.getObj();
	    if (Number.isInteger(obj)) {
	      cMap.vertical = !!obj;
	    }
	  }
	  function parseCMapName(cMap, lexer) {
	    var obj = lexer.getObj();
	    if ((0, _primitives.isName)(obj) && (0, _util.isString)(obj.name)) {
	      cMap.name = obj.name;
	    }
	  }
	  function parseCMap(cMap, lexer, fetchBuiltInCMap, useCMap) {
	    var previous;
	    var embededUseCMap;
	    objLoop: while (true) {
	      try {
	        var obj = lexer.getObj();
	        if ((0, _primitives.isEOF)(obj)) {
	          break;
	        } else if ((0, _primitives.isName)(obj)) {
	          if (obj.name === 'WMode') {
	            parseWMode(cMap, lexer);
	          } else if (obj.name === 'CMapName') {
	            parseCMapName(cMap, lexer);
	          }
	          previous = obj;
	        } else if ((0, _primitives.isCmd)(obj)) {
	          switch (obj.cmd) {
	            case 'endcmap':
	              break objLoop;
	            case 'usecmap':
	              if ((0, _primitives.isName)(previous)) {
	                embededUseCMap = previous.name;
	              }
	              break;
	            case 'begincodespacerange':
	              parseCodespaceRange(cMap, lexer);
	              break;
	            case 'beginbfchar':
	              parseBfChar(cMap, lexer);
	              break;
	            case 'begincidchar':
	              parseCidChar(cMap, lexer);
	              break;
	            case 'beginbfrange':
	              parseBfRange(cMap, lexer);
	              break;
	            case 'begincidrange':
	              parseCidRange(cMap, lexer);
	              break;
	          }
	        }
	      } catch (ex) {
	        if (ex instanceof _util.MissingDataException) {
	          throw ex;
	        }
	        (0, _util.warn)('Invalid cMap data: ' + ex);
	        continue;
	      }
	    }
	    if (!useCMap && embededUseCMap) {
	      useCMap = embededUseCMap;
	    }
	    if (useCMap) {
	      return extendCMap(cMap, fetchBuiltInCMap, useCMap);
	    }
	    return Promise.resolve(cMap);
	  }
	  function extendCMap(cMap, fetchBuiltInCMap, useCMap) {
	    return createBuiltInCMap(useCMap, fetchBuiltInCMap).then(function (newCMap) {
	      cMap.useCMap = newCMap;
	      if (cMap.numCodespaceRanges === 0) {
	        var useCodespaceRanges = cMap.useCMap.codespaceRanges;
	        for (var i = 0; i < useCodespaceRanges.length; i++) {
	          cMap.codespaceRanges[i] = useCodespaceRanges[i].slice();
	        }
	        cMap.numCodespaceRanges = cMap.useCMap.numCodespaceRanges;
	      }
	      cMap.useCMap.forEach(function (key, value) {
	        if (!cMap.contains(key)) {
	          cMap.mapOne(key, cMap.useCMap.lookup(key));
	        }
	      });
	      return cMap;
	    });
	  }
	  function createBuiltInCMap(name, fetchBuiltInCMap) {
	    if (name === 'Identity-H') {
	      return Promise.resolve(new IdentityCMap(false, 2));
	    } else if (name === 'Identity-V') {
	      return Promise.resolve(new IdentityCMap(true, 2));
	    }
	    if (BUILT_IN_CMAPS.indexOf(name) === -1) {
	      return Promise.reject(new Error('Unknown CMap name: ' + name));
	    }
	    if (!fetchBuiltInCMap) {
	      return Promise.reject(new Error('Built-in CMap parameters are not provided.'));
	    }
	    return fetchBuiltInCMap(name).then(function (data) {
	      var cMapData = data.cMapData,
	          compressionType = data.compressionType;
	      var cMap = new CMap(true);
	      if (compressionType === _util.CMapCompressionType.BINARY) {
	        return new BinaryCMapReader().process(cMapData, cMap, function (useCMap) {
	          return extendCMap(cMap, fetchBuiltInCMap, useCMap);
	        });
	      }
	      if (compressionType === _util.CMapCompressionType.NONE) {
	        var lexer = new _parser.Lexer(new _stream.Stream(cMapData));
	        return parseCMap(cMap, lexer, fetchBuiltInCMap, null);
	      }
	      return Promise.reject(new Error('TODO: Only BINARY/NONE CMap compression is currently supported.'));
	    });
	  }
	  return {
	    create: function create(params) {
	      var encoding = params.encoding;
	      var fetchBuiltInCMap = params.fetchBuiltInCMap;
	      var useCMap = params.useCMap;
	      if ((0, _primitives.isName)(encoding)) {
	        return createBuiltInCMap(encoding.name, fetchBuiltInCMap);
	      } else if ((0, _primitives.isStream)(encoding)) {
	        var cMap = new CMap();
	        var lexer = new _parser.Lexer(encoding);
	        return parseCMap(cMap, lexer, fetchBuiltInCMap, useCMap).then(function (parsedCMap) {
	          if (parsedCMap.isIdentityCMap) {
	            return createBuiltInCMap(parsedCMap.name, fetchBuiltInCMap);
	          }
	          return parsedCMap;
	        });
	      }
	      return Promise.reject(new Error('Encoding required.'));
	    }
	  };
	}();
	exports.CMap = CMap;
	exports.IdentityCMap = IdentityCMap;
	exports.CMapFactory = CMapFactory;
	
	/***/ }),
	/* 149 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFontType = exports.ProblematicCharRanges = exports.IdentityToUnicodeMap = exports.ToUnicodeMap = exports.FontFlags = exports.Font = exports.ErrorFont = exports.PRIVATE_USE_OFFSET_END = exports.PRIVATE_USE_OFFSET_START = exports.SEAC_ANALYSIS_ENABLED = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _cff_parser = __w_pdfjs_require__(84);
	
	var _glyphlist = __w_pdfjs_require__(49);
	
	var _encodings = __w_pdfjs_require__(30);
	
	var _standard_fonts = __w_pdfjs_require__(85);
	
	var _unicode = __w_pdfjs_require__(86);
	
	var _font_renderer = __w_pdfjs_require__(151);
	
	var _stream = __w_pdfjs_require__(5);
	
	var _type1_parser = __w_pdfjs_require__(152);
	
	var PRIVATE_USE_OFFSET_START = 0xE000;
	var PRIVATE_USE_OFFSET_END = 0xF8FF;
	var SKIP_PRIVATE_USE_RANGE_F000_TO_F01F = false;
	var PDF_GLYPH_SPACE_UNITS = 1000;
	var SEAC_ANALYSIS_ENABLED = false;
	var FontFlags = {
	  FixedPitch: 1,
	  Serif: 2,
	  Symbolic: 4,
	  Script: 8,
	  Nonsymbolic: 32,
	  Italic: 64,
	  AllCap: 65536,
	  SmallCap: 131072,
	  ForceBold: 262144
	};
	var MacStandardGlyphOrdering = ['.notdef', '.null', 'nonmarkingreturn', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'Adieresis', 'Aring', 'Ccedilla', 'Eacute', 'Ntilde', 'Odieresis', 'Udieresis', 'aacute', 'agrave', 'acircumflex', 'adieresis', 'atilde', 'aring', 'ccedilla', 'eacute', 'egrave', 'ecircumflex', 'edieresis', 'iacute', 'igrave', 'icircumflex', 'idieresis', 'ntilde', 'oacute', 'ograve', 'ocircumflex', 'odieresis', 'otilde', 'uacute', 'ugrave', 'ucircumflex', 'udieresis', 'dagger', 'degree', 'cent', 'sterling', 'section', 'bullet', 'paragraph', 'germandbls', 'registered', 'copyright', 'trademark', 'acute', 'dieresis', 'notequal', 'AE', 'Oslash', 'infinity', 'plusminus', 'lessequal', 'greaterequal', 'yen', 'mu', 'partialdiff', 'summation', 'product', 'pi', 'integral', 'ordfeminine', 'ordmasculine', 'Omega', 'ae', 'oslash', 'questiondown', 'exclamdown', 'logicalnot', 'radical', 'florin', 'approxequal', 'Delta', 'guillemotleft', 'guillemotright', 'ellipsis', 'nonbreakingspace', 'Agrave', 'Atilde', 'Otilde', 'OE', 'oe', 'endash', 'emdash', 'quotedblleft', 'quotedblright', 'quoteleft', 'quoteright', 'divide', 'lozenge', 'ydieresis', 'Ydieresis', 'fraction', 'currency', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'daggerdbl', 'periodcentered', 'quotesinglbase', 'quotedblbase', 'perthousand', 'Acircumflex', 'Ecircumflex', 'Aacute', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Oacute', 'Ocircumflex', 'apple', 'Ograve', 'Uacute', 'Ucircumflex', 'Ugrave', 'dotlessi', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'Lslash', 'lslash', 'Scaron', 'scaron', 'Zcaron', 'zcaron', 'brokenbar', 'Eth', 'eth', 'Yacute', 'yacute', 'Thorn', 'thorn', 'minus', 'multiply', 'onesuperior', 'twosuperior', 'threesuperior', 'onehalf', 'onequarter', 'threequarters', 'franc', 'Gbreve', 'gbreve', 'Idotaccent', 'Scedilla', 'scedilla', 'Cacute', 'cacute', 'Ccaron', 'ccaron', 'dcroat'];
	function adjustWidths(properties) {
	  if (!properties.fontMatrix) {
	    return;
	  }
	  if (properties.fontMatrix[0] === _util.FONT_IDENTITY_MATRIX[0]) {
	    return;
	  }
	  var scale = 0.001 / properties.fontMatrix[0];
	  var glyphsWidths = properties.widths;
	  for (var glyph in glyphsWidths) {
	    glyphsWidths[glyph] *= scale;
	  }
	  properties.defaultWidth *= scale;
	}
	function adjustToUnicode(properties, builtInEncoding) {
	  if (properties.hasIncludedToUnicodeMap) {
	    return;
	  }
	  if (properties.hasEncoding) {
	    return;
	  }
	  if (builtInEncoding === properties.defaultEncoding) {
	    return;
	  }
	  if (properties.toUnicode instanceof IdentityToUnicodeMap) {
	    return;
	  }
	  var toUnicode = [],
	      glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
	  for (var charCode in builtInEncoding) {
	    var glyphName = builtInEncoding[charCode];
	    var unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
	    if (unicode !== -1) {
	      toUnicode[charCode] = String.fromCharCode(unicode);
	    }
	  }
	  properties.toUnicode.amend(toUnicode);
	}
	function getFontType(type, subtype) {
	  switch (type) {
	    case 'Type1':
	      return subtype === 'Type1C' ? _util.FontType.TYPE1C : _util.FontType.TYPE1;
	    case 'CIDFontType0':
	      return subtype === 'CIDFontType0C' ? _util.FontType.CIDFONTTYPE0C : _util.FontType.CIDFONTTYPE0;
	    case 'OpenType':
	      return _util.FontType.OPENTYPE;
	    case 'TrueType':
	      return _util.FontType.TRUETYPE;
	    case 'CIDFontType2':
	      return _util.FontType.CIDFONTTYPE2;
	    case 'MMType1':
	      return _util.FontType.MMTYPE1;
	    case 'Type0':
	      return _util.FontType.TYPE0;
	    default:
	      return _util.FontType.UNKNOWN;
	  }
	}
	function recoverGlyphName(name, glyphsUnicodeMap) {
	  if (glyphsUnicodeMap[name] !== undefined) {
	    return name;
	  }
	  var unicode = (0, _unicode.getUnicodeForGlyph)(name, glyphsUnicodeMap);
	  if (unicode !== -1) {
	    for (var key in glyphsUnicodeMap) {
	      if (glyphsUnicodeMap[key] === unicode) {
	        return key;
	      }
	    }
	  }
	  (0, _util.info)('Unable to recover a standard glyph name for: ' + name);
	  return name;
	}
	var Glyph = function GlyphClosure() {
	  function Glyph(fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont) {
	    this.fontChar = fontChar;
	    this.unicode = unicode;
	    this.accent = accent;
	    this.width = width;
	    this.vmetric = vmetric;
	    this.operatorListId = operatorListId;
	    this.isSpace = isSpace;
	    this.isInFont = isInFont;
	  }
	  Glyph.prototype.matchesForCache = function (fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont) {
	    return this.fontChar === fontChar && this.unicode === unicode && this.accent === accent && this.width === width && this.vmetric === vmetric && this.operatorListId === operatorListId && this.isSpace === isSpace && this.isInFont === isInFont;
	  };
	  return Glyph;
	}();
	var ToUnicodeMap = function ToUnicodeMapClosure() {
	  function ToUnicodeMap(cmap) {
	    this._map = cmap;
	  }
	  ToUnicodeMap.prototype = {
	    get length() {
	      return this._map.length;
	    },
	    forEach: function forEach(callback) {
	      for (var charCode in this._map) {
	        callback(charCode, this._map[charCode].charCodeAt(0));
	      }
	    },
	    has: function has(i) {
	      return this._map[i] !== undefined;
	    },
	    get: function get(i) {
	      return this._map[i];
	    },
	    charCodeOf: function charCodeOf(value) {
	      var map = this._map;
	      if (map.length <= 0x10000) {
	        return map.indexOf(value);
	      }
	      for (var charCode in map) {
	        if (map[charCode] === value) {
	          return charCode | 0;
	        }
	      }
	      return -1;
	    },
	    amend: function amend(map) {
	      for (var charCode in map) {
	        this._map[charCode] = map[charCode];
	      }
	    }
	  };
	  return ToUnicodeMap;
	}();
	var IdentityToUnicodeMap = function IdentityToUnicodeMapClosure() {
	  function IdentityToUnicodeMap(firstChar, lastChar) {
	    this.firstChar = firstChar;
	    this.lastChar = lastChar;
	  }
	  IdentityToUnicodeMap.prototype = {
	    get length() {
	      return this.lastChar + 1 - this.firstChar;
	    },
	    forEach: function forEach(callback) {
	      for (var i = this.firstChar, ii = this.lastChar; i <= ii; i++) {
	        callback(i, i);
	      }
	    },
	    has: function has(i) {
	      return this.firstChar <= i && i <= this.lastChar;
	    },
	    get: function get(i) {
	      if (this.firstChar <= i && i <= this.lastChar) {
	        return String.fromCharCode(i);
	      }
	      return undefined;
	    },
	    charCodeOf: function charCodeOf(v) {
	      return Number.isInteger(v) && v >= this.firstChar && v <= this.lastChar ? v : -1;
	    },
	    amend: function amend(map) {
	      throw new Error('Should not call amend()');
	    }
	  };
	  return IdentityToUnicodeMap;
	}();
	var OpenTypeFileBuilder = function OpenTypeFileBuilderClosure() {
	  function writeInt16(dest, offset, num) {
	    dest[offset] = num >> 8 & 0xFF;
	    dest[offset + 1] = num & 0xFF;
	  }
	  function writeInt32(dest, offset, num) {
	    dest[offset] = num >> 24 & 0xFF;
	    dest[offset + 1] = num >> 16 & 0xFF;
	    dest[offset + 2] = num >> 8 & 0xFF;
	    dest[offset + 3] = num & 0xFF;
	  }
	  function writeData(dest, offset, data) {
	    var i, ii;
	    if (data instanceof Uint8Array) {
	      dest.set(data, offset);
	    } else if (typeof data === 'string') {
	      for (i = 0, ii = data.length; i < ii; i++) {
	        dest[offset++] = data.charCodeAt(i) & 0xFF;
	      }
	    } else {
	      for (i = 0, ii = data.length; i < ii; i++) {
	        dest[offset++] = data[i] & 0xFF;
	      }
	    }
	  }
	  function OpenTypeFileBuilder(sfnt) {
	    this.sfnt = sfnt;
	    this.tables = Object.create(null);
	  }
	  OpenTypeFileBuilder.getSearchParams = function OpenTypeFileBuilder_getSearchParams(entriesCount, entrySize) {
	    var maxPower2 = 1,
	        log2 = 0;
	    while ((maxPower2 ^ entriesCount) > maxPower2) {
	      maxPower2 <<= 1;
	      log2++;
	    }
	    var searchRange = maxPower2 * entrySize;
	    return {
	      range: searchRange,
	      entry: log2,
	      rangeShift: entrySize * entriesCount - searchRange
	    };
	  };
	  var OTF_HEADER_SIZE = 12;
	  var OTF_TABLE_ENTRY_SIZE = 16;
	  OpenTypeFileBuilder.prototype = {
	    toArray: function OpenTypeFileBuilder_toArray() {
	      var sfnt = this.sfnt;
	      var tables = this.tables;
	      var tablesNames = Object.keys(tables);
	      tablesNames.sort();
	      var numTables = tablesNames.length;
	      var i, j, jj, table, tableName;
	      var offset = OTF_HEADER_SIZE + numTables * OTF_TABLE_ENTRY_SIZE;
	      var tableOffsets = [offset];
	      for (i = 0; i < numTables; i++) {
	        table = tables[tablesNames[i]];
	        var paddedLength = (table.length + 3 & ~3) >>> 0;
	        offset += paddedLength;
	        tableOffsets.push(offset);
	      }
	      var file = new Uint8Array(offset);
	      for (i = 0; i < numTables; i++) {
	        table = tables[tablesNames[i]];
	        writeData(file, tableOffsets[i], table);
	      }
	      if (sfnt === 'true') {
	        sfnt = (0, _util.string32)(0x00010000);
	      }
	      file[0] = sfnt.charCodeAt(0) & 0xFF;
	      file[1] = sfnt.charCodeAt(1) & 0xFF;
	      file[2] = sfnt.charCodeAt(2) & 0xFF;
	      file[3] = sfnt.charCodeAt(3) & 0xFF;
	      writeInt16(file, 4, numTables);
	      var searchParams = OpenTypeFileBuilder.getSearchParams(numTables, 16);
	      writeInt16(file, 6, searchParams.range);
	      writeInt16(file, 8, searchParams.entry);
	      writeInt16(file, 10, searchParams.rangeShift);
	      offset = OTF_HEADER_SIZE;
	      for (i = 0; i < numTables; i++) {
	        tableName = tablesNames[i];
	        file[offset] = tableName.charCodeAt(0) & 0xFF;
	        file[offset + 1] = tableName.charCodeAt(1) & 0xFF;
	        file[offset + 2] = tableName.charCodeAt(2) & 0xFF;
	        file[offset + 3] = tableName.charCodeAt(3) & 0xFF;
	        var checksum = 0;
	        for (j = tableOffsets[i], jj = tableOffsets[i + 1]; j < jj; j += 4) {
	          var quad = (0, _util.readUint32)(file, j);
	          checksum = checksum + quad >>> 0;
	        }
	        writeInt32(file, offset + 4, checksum);
	        writeInt32(file, offset + 8, tableOffsets[i]);
	        writeInt32(file, offset + 12, tables[tableName].length);
	        offset += OTF_TABLE_ENTRY_SIZE;
	      }
	      return file;
	    },
	    addTable: function OpenTypeFileBuilder_addTable(tag, data) {
	      if (tag in this.tables) {
	        throw new Error('Table ' + tag + ' already exists');
	      }
	      this.tables[tag] = data;
	    }
	  };
	  return OpenTypeFileBuilder;
	}();
	var ProblematicCharRanges = new Int32Array([0x0000, 0x0020, 0x007F, 0x00A1, 0x00AD, 0x00AE, 0x0600, 0x0780, 0x08A0, 0x10A0, 0x1780, 0x1800, 0x1C00, 0x1C50, 0x2000, 0x2010, 0x2011, 0x2012, 0x2028, 0x2030, 0x205F, 0x2070, 0x25CC, 0x25CD, 0x3000, 0x3001, 0x3164, 0x3165, 0xAA60, 0xAA80, 0xFFF0, 0x10000]);
	var Font = function FontClosure() {
	  function Font(name, file, properties) {
	    var charCode;
	    this.name = name;
	    this.loadedName = properties.loadedName;
	    this.isType3Font = properties.isType3Font;
	    this.sizes = [];
	    this.missingFile = false;
	    this.glyphCache = Object.create(null);
	    this.isSerifFont = !!(properties.flags & FontFlags.Serif);
	    this.isSymbolicFont = !!(properties.flags & FontFlags.Symbolic);
	    this.isMonospace = !!(properties.flags & FontFlags.FixedPitch);
	    var type = properties.type;
	    var subtype = properties.subtype;
	    this.type = type;
	    this.subtype = subtype;
	    this.fallbackName = this.isMonospace ? 'monospace' : this.isSerifFont ? 'serif' : 'sans-serif';
	    this.differences = properties.differences;
	    this.widths = properties.widths;
	    this.defaultWidth = properties.defaultWidth;
	    this.composite = properties.composite;
	    this.wideChars = properties.wideChars;
	    this.cMap = properties.cMap;
	    this.ascent = properties.ascent / PDF_GLYPH_SPACE_UNITS;
	    this.descent = properties.descent / PDF_GLYPH_SPACE_UNITS;
	    this.fontMatrix = properties.fontMatrix;
	    this.bbox = properties.bbox;
	    this.defaultEncoding = properties.defaultEncoding;
	    this.toUnicode = properties.toUnicode;
	    this.toFontChar = [];
	    if (properties.type === 'Type3') {
	      for (charCode = 0; charCode < 256; charCode++) {
	        this.toFontChar[charCode] = this.differences[charCode] || properties.defaultEncoding[charCode];
	      }
	      this.fontType = _util.FontType.TYPE3;
	      return;
	    }
	    this.cidEncoding = properties.cidEncoding;
	    this.vertical = properties.vertical;
	    if (this.vertical) {
	      this.vmetrics = properties.vmetrics;
	      this.defaultVMetrics = properties.defaultVMetrics;
	    }
	    if (!file || file.isEmpty) {
	      if (file) {
	        (0, _util.warn)('Font file is empty in "' + name + '" (' + this.loadedName + ')');
	      }
	      this.fallbackToSystemFont();
	      return;
	    }
	    if (subtype === 'Type1C') {
	      if (type !== 'Type1' && type !== 'MMType1') {
	        if (isTrueTypeFile(file)) {
	          subtype = 'TrueType';
	        } else {
	          type = 'Type1';
	        }
	      } else if (isOpenTypeFile(file)) {
	        subtype = 'OpenType';
	      }
	    }
	    if (subtype === 'CIDFontType0C' && type !== 'CIDFontType0') {
	      type = 'CIDFontType0';
	    }
	    if (type === 'CIDFontType0') {
	      if (isType1File(file)) {
	        subtype = 'CIDFontType0';
	      } else if (isOpenTypeFile(file)) {
	        subtype = 'OpenType';
	      } else {
	        subtype = 'CIDFontType0C';
	      }
	    }
	    if (subtype === 'OpenType' && type !== 'OpenType') {
	      type = 'OpenType';
	    }
	    try {
	      var data;
	      switch (type) {
	        case 'MMType1':
	          (0, _util.info)('MMType1 font (' + name + '), falling back to Type1.');
	        case 'Type1':
	        case 'CIDFontType0':
	          this.mimetype = 'font/opentype';
	          var cff = subtype === 'Type1C' || subtype === 'CIDFontType0C' ? new CFFFont(file, properties) : new Type1Font(name, file, properties);
	          adjustWidths(properties);
	          data = this.convert(name, cff, properties);
	          break;
	        case 'OpenType':
	        case 'TrueType':
	        case 'CIDFontType2':
	          this.mimetype = 'font/opentype';
	          data = this.checkAndRepair(name, file, properties);
	          if (this.isOpenType) {
	            adjustWidths(properties);
	            type = 'OpenType';
	          }
	          break;
	        default:
	          throw new _util.FormatError('Font ' + type + ' is not supported');
	      }
	    } catch (e) {
	      if (!(e instanceof _util.FormatError)) {
	        throw e;
	      }
	      (0, _util.warn)(e);
	      this.fallbackToSystemFont();
	      return;
	    }
	    this.data = data;
	    this.fontType = getFontType(type, subtype);
	    this.fontMatrix = properties.fontMatrix;
	    this.widths = properties.widths;
	    this.defaultWidth = properties.defaultWidth;
	    this.toUnicode = properties.toUnicode;
	    this.encoding = properties.baseEncoding;
	    this.seacMap = properties.seacMap;
	    this.loading = true;
	  }
	  Font.getFontID = function () {
	    var ID = 1;
	    return function Font_getFontID() {
	      return String(ID++);
	    };
	  }();
	  function int16(b0, b1) {
	    return (b0 << 8) + b1;
	  }
	  function writeSignedInt16(bytes, index, value) {
	    bytes[index + 1] = value;
	    bytes[index] = value >>> 8;
	  }
	  function signedInt16(b0, b1) {
	    var value = (b0 << 8) + b1;
	    return value & 1 << 15 ? value - 0x10000 : value;
	  }
	  function int32(b0, b1, b2, b3) {
	    return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
	  }
	  function string16(value) {
	    return String.fromCharCode(value >> 8 & 0xff, value & 0xff);
	  }
	  function safeString16(value) {
	    value = value > 0x7FFF ? 0x7FFF : value < -0x8000 ? -0x8000 : value;
	    return String.fromCharCode(value >> 8 & 0xff, value & 0xff);
	  }
	  function isTrueTypeFile(file) {
	    var header = file.peekBytes(4);
	    return (0, _util.readUint32)(header, 0) === 0x00010000;
	  }
	  function isOpenTypeFile(file) {
	    var header = file.peekBytes(4);
	    return (0, _util.bytesToString)(header) === 'OTTO';
	  }
	  function isType1File(file) {
	    var header = file.peekBytes(2);
	    if (header[0] === 0x25 && header[1] === 0x21) {
	      return true;
	    }
	    if (header[0] === 0x80 && header[1] === 0x01) {
	      return true;
	    }
	    return false;
	  }
	  function buildToFontChar(encoding, glyphsUnicodeMap, differences) {
	    var toFontChar = [],
	        unicode;
	    for (var i = 0, ii = encoding.length; i < ii; i++) {
	      unicode = (0, _unicode.getUnicodeForGlyph)(encoding[i], glyphsUnicodeMap);
	      if (unicode !== -1) {
	        toFontChar[i] = unicode;
	      }
	    }
	    for (var charCode in differences) {
	      unicode = (0, _unicode.getUnicodeForGlyph)(differences[charCode], glyphsUnicodeMap);
	      if (unicode !== -1) {
	        toFontChar[+charCode] = unicode;
	      }
	    }
	    return toFontChar;
	  }
	  function isProblematicUnicodeLocation(code) {
	    var i = 0,
	        j = ProblematicCharRanges.length - 1;
	    while (i < j) {
	      var c = i + j + 1 >> 1;
	      if (code < ProblematicCharRanges[c]) {
	        j = c - 1;
	      } else {
	        i = c;
	      }
	    }
	    return !(i & 1);
	  }
	  function adjustMapping(charCodeToGlyphId, properties, missingGlyphs) {
	    var toUnicode = properties.toUnicode;
	    var isSymbolic = !!(properties.flags & FontFlags.Symbolic);
	    var isIdentityUnicode = properties.toUnicode instanceof IdentityToUnicodeMap;
	    var newMap = Object.create(null);
	    var toFontChar = [];
	    var usedFontCharCodes = [];
	    var nextAvailableFontCharCode = PRIVATE_USE_OFFSET_START;
	    for (var originalCharCode in charCodeToGlyphId) {
	      originalCharCode |= 0;
	      var glyphId = charCodeToGlyphId[originalCharCode];
	      if (missingGlyphs[glyphId]) {
	        continue;
	      }
	      var fontCharCode = originalCharCode;
	      var hasUnicodeValue = false;
	      if (!isIdentityUnicode && toUnicode.has(originalCharCode)) {
	        hasUnicodeValue = true;
	        var unicode = toUnicode.get(fontCharCode);
	        if (unicode.length === 1) {
	          fontCharCode = unicode.charCodeAt(0);
	        }
	      }
	      if (usedFontCharCodes[fontCharCode] !== undefined || isProblematicUnicodeLocation(fontCharCode) || isSymbolic && !hasUnicodeValue) {
	        do {
	          if (nextAvailableFontCharCode > PRIVATE_USE_OFFSET_END) {
	            (0, _util.warn)('Ran out of space in font private use area.');
	            break;
	          }
	          fontCharCode = nextAvailableFontCharCode++;
	          if (SKIP_PRIVATE_USE_RANGE_F000_TO_F01F && fontCharCode === 0xF000) {
	            fontCharCode = 0xF020;
	            nextAvailableFontCharCode = fontCharCode + 1;
	          }
	        } while (usedFontCharCodes[fontCharCode] !== undefined);
	      }
	      newMap[fontCharCode] = glyphId;
	      toFontChar[originalCharCode] = fontCharCode;
	      usedFontCharCodes[fontCharCode] = true;
	    }
	    return {
	      toFontChar: toFontChar,
	      charCodeToGlyphId: newMap,
	      nextAvailableFontCharCode: nextAvailableFontCharCode
	    };
	  }
	  function getRanges(glyphs, numGlyphs) {
	    var codes = [];
	    for (var charCode in glyphs) {
	      if (glyphs[charCode] >= numGlyphs) {
	        continue;
	      }
	      codes.push({
	        fontCharCode: charCode | 0,
	        glyphId: glyphs[charCode]
	      });
	    }
	    if (codes.length === 0) {
	      codes.push({
	        fontCharCode: 0,
	        glyphId: 0
	      });
	    }
	    codes.sort(function fontGetRangesSort(a, b) {
	      return a.fontCharCode - b.fontCharCode;
	    });
	    var ranges = [];
	    var length = codes.length;
	    for (var n = 0; n < length;) {
	      var start = codes[n].fontCharCode;
	      var codeIndices = [codes[n].glyphId];
	      ++n;
	      var end = start;
	      while (n < length && end + 1 === codes[n].fontCharCode) {
	        codeIndices.push(codes[n].glyphId);
	        ++end;
	        ++n;
	        if (end === 0xFFFF) {
	          break;
	        }
	      }
	      ranges.push([start, end, codeIndices]);
	    }
	    return ranges;
	  }
	  function createCmapTable(glyphs, numGlyphs) {
	    var ranges = getRanges(glyphs, numGlyphs);
	    var numTables = ranges[ranges.length - 1][1] > 0xFFFF ? 2 : 1;
	    var cmap = '\x00\x00' + string16(numTables) + '\x00\x03' + '\x00\x01' + (0, _util.string32)(4 + numTables * 8);
	    var i, ii, j, jj;
	    for (i = ranges.length - 1; i >= 0; --i) {
	      if (ranges[i][0] <= 0xFFFF) {
	        break;
	      }
	    }
	    var bmpLength = i + 1;
	    if (ranges[i][0] < 0xFFFF && ranges[i][1] === 0xFFFF) {
	      ranges[i][1] = 0xFFFE;
	    }
	    var trailingRangesCount = ranges[i][1] < 0xFFFF ? 1 : 0;
	    var segCount = bmpLength + trailingRangesCount;
	    var searchParams = OpenTypeFileBuilder.getSearchParams(segCount, 2);
	    var startCount = '';
	    var endCount = '';
	    var idDeltas = '';
	    var idRangeOffsets = '';
	    var glyphsIds = '';
	    var bias = 0;
	    var range, start, end, codes;
	    for (i = 0, ii = bmpLength; i < ii; i++) {
	      range = ranges[i];
	      start = range[0];
	      end = range[1];
	      startCount += string16(start);
	      endCount += string16(end);
	      codes = range[2];
	      var contiguous = true;
	      for (j = 1, jj = codes.length; j < jj; ++j) {
	        if (codes[j] !== codes[j - 1] + 1) {
	          contiguous = false;
	          break;
	        }
	      }
	      if (!contiguous) {
	        var offset = (segCount - i) * 2 + bias * 2;
	        bias += end - start + 1;
	        idDeltas += string16(0);
	        idRangeOffsets += string16(offset);
	        for (j = 0, jj = codes.length; j < jj; ++j) {
	          glyphsIds += string16(codes[j]);
	        }
	      } else {
	        var startCode = codes[0];
	        idDeltas += string16(startCode - start & 0xFFFF);
	        idRangeOffsets += string16(0);
	      }
	    }
	    if (trailingRangesCount > 0) {
	      endCount += '\xFF\xFF';
	      startCount += '\xFF\xFF';
	      idDeltas += '\x00\x01';
	      idRangeOffsets += '\x00\x00';
	    }
	    var format314 = '\x00\x00' + string16(2 * segCount) + string16(searchParams.range) + string16(searchParams.entry) + string16(searchParams.rangeShift) + endCount + '\x00\x00' + startCount + idDeltas + idRangeOffsets + glyphsIds;
	    var format31012 = '';
	    var header31012 = '';
	    if (numTables > 1) {
	      cmap += '\x00\x03' + '\x00\x0A' + (0, _util.string32)(4 + numTables * 8 + 4 + format314.length);
	      format31012 = '';
	      for (i = 0, ii = ranges.length; i < ii; i++) {
	        range = ranges[i];
	        start = range[0];
	        codes = range[2];
	        var code = codes[0];
	        for (j = 1, jj = codes.length; j < jj; ++j) {
	          if (codes[j] !== codes[j - 1] + 1) {
	            end = range[0] + j - 1;
	            format31012 += (0, _util.string32)(start) + (0, _util.string32)(end) + (0, _util.string32)(code);
	            start = end + 1;
	            code = codes[j];
	          }
	        }
	        format31012 += (0, _util.string32)(start) + (0, _util.string32)(range[1]) + (0, _util.string32)(code);
	      }
	      header31012 = '\x00\x0C' + '\x00\x00' + (0, _util.string32)(format31012.length + 16) + '\x00\x00\x00\x00' + (0, _util.string32)(format31012.length / 12);
	    }
	    return cmap + '\x00\x04' + string16(format314.length + 4) + format314 + header31012 + format31012;
	  }
	  function validateOS2Table(os2) {
	    var stream = new _stream.Stream(os2.data);
	    var version = stream.getUint16();
	    stream.getBytes(60);
	    var selection = stream.getUint16();
	    if (version < 4 && selection & 0x0300) {
	      return false;
	    }
	    var firstChar = stream.getUint16();
	    var lastChar = stream.getUint16();
	    if (firstChar > lastChar) {
	      return false;
	    }
	    stream.getBytes(6);
	    var usWinAscent = stream.getUint16();
	    if (usWinAscent === 0) {
	      return false;
	    }
	    os2.data[8] = os2.data[9] = 0;
	    return true;
	  }
	  function createOS2Table(properties, charstrings, override) {
	    override = override || {
	      unitsPerEm: 0,
	      yMax: 0,
	      yMin: 0,
	      ascent: 0,
	      descent: 0
	    };
	    var ulUnicodeRange1 = 0;
	    var ulUnicodeRange2 = 0;
	    var ulUnicodeRange3 = 0;
	    var ulUnicodeRange4 = 0;
	    var firstCharIndex = null;
	    var lastCharIndex = 0;
	    if (charstrings) {
	      for (var code in charstrings) {
	        code |= 0;
	        if (firstCharIndex > code || !firstCharIndex) {
	          firstCharIndex = code;
	        }
	        if (lastCharIndex < code) {
	          lastCharIndex = code;
	        }
	        var position = (0, _unicode.getUnicodeRangeFor)(code);
	        if (position < 32) {
	          ulUnicodeRange1 |= 1 << position;
	        } else if (position < 64) {
	          ulUnicodeRange2 |= 1 << position - 32;
	        } else if (position < 96) {
	          ulUnicodeRange3 |= 1 << position - 64;
	        } else if (position < 123) {
	          ulUnicodeRange4 |= 1 << position - 96;
	        } else {
	          throw new _util.FormatError('Unicode ranges Bits > 123 are reserved for internal usage');
	        }
	      }
	    } else {
	      firstCharIndex = 0;
	      lastCharIndex = 255;
	    }
	    var bbox = properties.bbox || [0, 0, 0, 0];
	    var unitsPerEm = override.unitsPerEm || 1 / (properties.fontMatrix || _util.FONT_IDENTITY_MATRIX)[0];
	    var scale = properties.ascentScaled ? 1.0 : unitsPerEm / PDF_GLYPH_SPACE_UNITS;
	    var typoAscent = override.ascent || Math.round(scale * (properties.ascent || bbox[3]));
	    var typoDescent = override.descent || Math.round(scale * (properties.descent || bbox[1]));
	    if (typoDescent > 0 && properties.descent > 0 && bbox[1] < 0) {
	      typoDescent = -typoDescent;
	    }
	    var winAscent = override.yMax || typoAscent;
	    var winDescent = -override.yMin || -typoDescent;
	    return '\x00\x03' + '\x02\x24' + '\x01\xF4' + '\x00\x05' + '\x00\x00' + '\x02\x8A' + '\x02\xBB' + '\x00\x00' + '\x00\x8C' + '\x02\x8A' + '\x02\xBB' + '\x00\x00' + '\x01\xDF' + '\x00\x31' + '\x01\x02' + '\x00\x00' + '\x00\x00\x06' + String.fromCharCode(properties.fixedPitch ? 0x09 : 0x00) + '\x00\x00\x00\x00\x00\x00' + (0, _util.string32)(ulUnicodeRange1) + (0, _util.string32)(ulUnicodeRange2) + (0, _util.string32)(ulUnicodeRange3) + (0, _util.string32)(ulUnicodeRange4) + '\x2A\x32\x31\x2A' + string16(properties.italicAngle ? 1 : 0) + string16(firstCharIndex || properties.firstChar) + string16(lastCharIndex || properties.lastChar) + string16(typoAscent) + string16(typoDescent) + '\x00\x64' + string16(winAscent) + string16(winDescent) + '\x00\x00\x00\x00' + '\x00\x00\x00\x00' + string16(properties.xHeight) + string16(properties.capHeight) + string16(0) + string16(firstCharIndex || properties.firstChar) + '\x00\x03';
	  }
	  function createPostTable(properties) {
	    var angle = Math.floor(properties.italicAngle * Math.pow(2, 16));
	    return '\x00\x03\x00\x00' + (0, _util.string32)(angle) + '\x00\x00' + '\x00\x00' + (0, _util.string32)(properties.fixedPitch) + '\x00\x00\x00\x00' + '\x00\x00\x00\x00' + '\x00\x00\x00\x00' + '\x00\x00\x00\x00';
	  }
	  function createNameTable(name, proto) {
	    if (!proto) {
	      proto = [[], []];
	    }
	    var strings = [proto[0][0] || 'Original licence', proto[0][1] || name, proto[0][2] || 'Unknown', proto[0][3] || 'uniqueID', proto[0][4] || name, proto[0][5] || 'Version 0.11', proto[0][6] || '', proto[0][7] || 'Unknown', proto[0][8] || 'Unknown', proto[0][9] || 'Unknown'];
	    var stringsUnicode = [];
	    var i, ii, j, jj, str;
	    for (i = 0, ii = strings.length; i < ii; i++) {
	      str = proto[1][i] || strings[i];
	      var strBufUnicode = [];
	      for (j = 0, jj = str.length; j < jj; j++) {
	        strBufUnicode.push(string16(str.charCodeAt(j)));
	      }
	      stringsUnicode.push(strBufUnicode.join(''));
	    }
	    var names = [strings, stringsUnicode];
	    var platforms = ['\x00\x01', '\x00\x03'];
	    var encodings = ['\x00\x00', '\x00\x01'];
	    var languages = ['\x00\x00', '\x04\x09'];
	    var namesRecordCount = strings.length * platforms.length;
	    var nameTable = '\x00\x00' + string16(namesRecordCount) + string16(namesRecordCount * 12 + 6);
	    var strOffset = 0;
	    for (i = 0, ii = platforms.length; i < ii; i++) {
	      var strs = names[i];
	      for (j = 0, jj = strs.length; j < jj; j++) {
	        str = strs[j];
	        var nameRecord = platforms[i] + encodings[i] + languages[i] + string16(j) + string16(str.length) + string16(strOffset);
	        nameTable += nameRecord;
	        strOffset += str.length;
	      }
	    }
	    nameTable += strings.join('') + stringsUnicode.join('');
	    return nameTable;
	  }
	  Font.prototype = {
	    name: null,
	    font: null,
	    mimetype: null,
	    encoding: null,
	    get renderer() {
	      var renderer = _font_renderer.FontRendererFactory.create(this, SEAC_ANALYSIS_ENABLED);
	      return (0, _util.shadow)(this, 'renderer', renderer);
	    },
	    exportData: function Font_exportData() {
	      var data = {};
	      for (var i in this) {
	        if (this.hasOwnProperty(i)) {
	          data[i] = this[i];
	        }
	      }
	      return data;
	    },
	    fallbackToSystemFont: function Font_fallbackToSystemFont() {
	      var _this = this;
	
	      this.missingFile = true;
	      var charCode, unicode;
	      var name = this.name;
	      var type = this.type;
	      var subtype = this.subtype;
	      var fontName = name.replace(/[,_]/g, '-');
	      var stdFontMap = (0, _standard_fonts.getStdFontMap)(),
	          nonStdFontMap = (0, _standard_fonts.getNonStdFontMap)();
	      var isStandardFont = !!stdFontMap[fontName] || !!(nonStdFontMap[fontName] && stdFontMap[nonStdFontMap[fontName]]);
	      fontName = stdFontMap[fontName] || nonStdFontMap[fontName] || fontName;
	      this.bold = fontName.search(/bold/gi) !== -1;
	      this.italic = fontName.search(/oblique/gi) !== -1 || fontName.search(/italic/gi) !== -1;
	      this.black = name.search(/Black/g) !== -1;
	      this.remeasure = Object.keys(this.widths).length > 0;
	      if (isStandardFont && type === 'CIDFontType2' && this.cidEncoding.indexOf('Identity-') === 0) {
	        var GlyphMapForStandardFonts = (0, _standard_fonts.getGlyphMapForStandardFonts)();
	        var map = [];
	        for (charCode in GlyphMapForStandardFonts) {
	          map[+charCode] = GlyphMapForStandardFonts[charCode];
	        }
	        if (/Arial-?Black/i.test(name)) {
	          var SupplementalGlyphMapForArialBlack = (0, _standard_fonts.getSupplementalGlyphMapForArialBlack)();
	          for (charCode in SupplementalGlyphMapForArialBlack) {
	            map[+charCode] = SupplementalGlyphMapForArialBlack[charCode];
	          }
	        }
	        var isIdentityUnicode = this.toUnicode instanceof IdentityToUnicodeMap;
	        if (!isIdentityUnicode) {
	          this.toUnicode.forEach(function (charCode, unicodeCharCode) {
	            map[+charCode] = unicodeCharCode;
	          });
	        }
	        this.toFontChar = map;
	        this.toUnicode = new ToUnicodeMap(map);
	      } else if (/Symbol/i.test(fontName)) {
	        this.toFontChar = buildToFontChar(_encodings.SymbolSetEncoding, (0, _glyphlist.getGlyphsUnicode)(), this.differences);
	      } else if (/Dingbats/i.test(fontName)) {
	        if (/Wingdings/i.test(name)) {
	          (0, _util.warn)('Non-embedded Wingdings font, falling back to ZapfDingbats.');
	        }
	        this.toFontChar = buildToFontChar(_encodings.ZapfDingbatsEncoding, (0, _glyphlist.getDingbatsGlyphsUnicode)(), this.differences);
	      } else if (isStandardFont) {
	        this.toFontChar = buildToFontChar(this.defaultEncoding, (0, _glyphlist.getGlyphsUnicode)(), this.differences);
	      } else {
	        var glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
	        this.toUnicode.forEach(function (charCode, unicodeCharCode) {
	          if (!_this.composite) {
	            var glyphName = _this.differences[charCode] || _this.defaultEncoding[charCode];
	            unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
	            if (unicode !== -1) {
	              unicodeCharCode = unicode;
	            }
	          }
	          _this.toFontChar[charCode] = unicodeCharCode;
	        });
	      }
	      this.loadedName = fontName.split('-')[0];
	      this.loading = false;
	      this.fontType = getFontType(type, subtype);
	    },
	    checkAndRepair: function Font_checkAndRepair(name, font, properties) {
	      function readTableEntry(file) {
	        var tag = (0, _util.bytesToString)(file.getBytes(4));
	        var checksum = file.getInt32() >>> 0;
	        var offset = file.getInt32() >>> 0;
	        var length = file.getInt32() >>> 0;
	        var previousPosition = file.pos;
	        file.pos = file.start ? file.start : 0;
	        file.skip(offset);
	        var data = file.getBytes(length);
	        file.pos = previousPosition;
	        if (tag === 'head') {
	          data[8] = data[9] = data[10] = data[11] = 0;
	          data[17] |= 0x20;
	        }
	        return {
	          tag: tag,
	          checksum: checksum,
	          length: length,
	          offset: offset,
	          data: data
	        };
	      }
	      function readOpenTypeHeader(ttf) {
	        return {
	          version: (0, _util.bytesToString)(ttf.getBytes(4)),
	          numTables: ttf.getUint16(),
	          searchRange: ttf.getUint16(),
	          entrySelector: ttf.getUint16(),
	          rangeShift: ttf.getUint16()
	        };
	      }
	      function readCmapTable(cmap, font, isSymbolicFont, hasEncoding) {
	        if (!cmap) {
	          (0, _util.warn)('No cmap table available.');
	          return {
	            platformId: -1,
	            encodingId: -1,
	            mappings: [],
	            hasShortCmap: false
	          };
	        }
	        var segment;
	        var start = (font.start ? font.start : 0) + cmap.offset;
	        font.pos = start;
	        font.getUint16();
	        var numTables = font.getUint16();
	        var potentialTable;
	        var canBreak = false;
	        for (var i = 0; i < numTables; i++) {
	          var platformId = font.getUint16();
	          var encodingId = font.getUint16();
	          var offset = font.getInt32() >>> 0;
	          var useTable = false;
	          if (potentialTable && potentialTable.platformId === platformId && potentialTable.encodingId === encodingId) {
	            continue;
	          }
	          if (platformId === 0 && encodingId === 0) {
	            useTable = true;
	          } else if (platformId === 1 && encodingId === 0) {
	            useTable = true;
	          } else if (platformId === 3 && encodingId === 1 && (hasEncoding || !potentialTable)) {
	            useTable = true;
	            if (!isSymbolicFont) {
	              canBreak = true;
	            }
	          } else if (isSymbolicFont && platformId === 3 && encodingId === 0) {
	            useTable = true;
	            canBreak = true;
	          }
	          if (useTable) {
	            potentialTable = {
	              platformId: platformId,
	              encodingId: encodingId,
	              offset: offset
	            };
	          }
	          if (canBreak) {
	            break;
	          }
	        }
	        if (potentialTable) {
	          font.pos = start + potentialTable.offset;
	        }
	        if (!potentialTable || font.peekByte() === -1) {
	          (0, _util.warn)('Could not find a preferred cmap table.');
	          return {
	            platformId: -1,
	            encodingId: -1,
	            mappings: [],
	            hasShortCmap: false
	          };
	        }
	        var format = font.getUint16();
	        font.getUint16();
	        font.getUint16();
	        var hasShortCmap = false;
	        var mappings = [];
	        var j, glyphId;
	        if (format === 0) {
	          for (j = 0; j < 256; j++) {
	            var index = font.getByte();
	            if (!index) {
	              continue;
	            }
	            mappings.push({
	              charCode: j,
	              glyphId: index
	            });
	          }
	          hasShortCmap = true;
	        } else if (format === 4) {
	          var segCount = font.getUint16() >> 1;
	          font.getBytes(6);
	          var segIndex,
	              segments = [];
	          for (segIndex = 0; segIndex < segCount; segIndex++) {
	            segments.push({ end: font.getUint16() });
	          }
	          font.getUint16();
	          for (segIndex = 0; segIndex < segCount; segIndex++) {
	            segments[segIndex].start = font.getUint16();
	          }
	          for (segIndex = 0; segIndex < segCount; segIndex++) {
	            segments[segIndex].delta = font.getUint16();
	          }
	          var offsetsCount = 0;
	          for (segIndex = 0; segIndex < segCount; segIndex++) {
	            segment = segments[segIndex];
	            var rangeOffset = font.getUint16();
	            if (!rangeOffset) {
	              segment.offsetIndex = -1;
	              continue;
	            }
	            var offsetIndex = (rangeOffset >> 1) - (segCount - segIndex);
	            segment.offsetIndex = offsetIndex;
	            offsetsCount = Math.max(offsetsCount, offsetIndex + segment.end - segment.start + 1);
	          }
	          var offsets = [];
	          for (j = 0; j < offsetsCount; j++) {
	            offsets.push(font.getUint16());
	          }
	          for (segIndex = 0; segIndex < segCount; segIndex++) {
	            segment = segments[segIndex];
	            start = segment.start;
	            var end = segment.end;
	            var delta = segment.delta;
	            offsetIndex = segment.offsetIndex;
	            for (j = start; j <= end; j++) {
	              if (j === 0xFFFF) {
	                continue;
	              }
	              glyphId = offsetIndex < 0 ? j : offsets[offsetIndex + j - start];
	              glyphId = glyphId + delta & 0xFFFF;
	              mappings.push({
	                charCode: j,
	                glyphId: glyphId
	              });
	            }
	          }
	        } else if (format === 6) {
	          var firstCode = font.getUint16();
	          var entryCount = font.getUint16();
	          for (j = 0; j < entryCount; j++) {
	            glyphId = font.getUint16();
	            var charCode = firstCode + j;
	            mappings.push({
	              charCode: charCode,
	              glyphId: glyphId
	            });
	          }
	        } else {
	          (0, _util.warn)('cmap table has unsupported format: ' + format);
	          return {
	            platformId: -1,
	            encodingId: -1,
	            mappings: [],
	            hasShortCmap: false
	          };
	        }
	        mappings.sort(function (a, b) {
	          return a.charCode - b.charCode;
	        });
	        for (i = 1; i < mappings.length; i++) {
	          if (mappings[i - 1].charCode === mappings[i].charCode) {
	            mappings.splice(i, 1);
	            i--;
	          }
	        }
	        return {
	          platformId: potentialTable.platformId,
	          encodingId: potentialTable.encodingId,
	          mappings: mappings,
	          hasShortCmap: hasShortCmap
	        };
	      }
	      function sanitizeMetrics(font, header, metrics, numGlyphs) {
	        if (!header) {
	          if (metrics) {
	            metrics.data = null;
	          }
	          return;
	        }
	        font.pos = (font.start ? font.start : 0) + header.offset;
	        font.pos += header.length - 2;
	        var numOfMetrics = font.getUint16();
	        if (numOfMetrics > numGlyphs) {
	          (0, _util.info)('The numOfMetrics (' + numOfMetrics + ') should not be ' + 'greater than the numGlyphs (' + numGlyphs + ')');
	          numOfMetrics = numGlyphs;
	          header.data[34] = (numOfMetrics & 0xff00) >> 8;
	          header.data[35] = numOfMetrics & 0x00ff;
	        }
	        var numOfSidebearings = numGlyphs - numOfMetrics;
	        var numMissing = numOfSidebearings - (metrics.length - numOfMetrics * 4 >> 1);
	        if (numMissing > 0) {
	          var entries = new Uint8Array(metrics.length + numMissing * 2);
	          entries.set(metrics.data);
	          metrics.data = entries;
	        }
	      }
	      function sanitizeGlyph(source, sourceStart, sourceEnd, dest, destStart, hintsValid) {
	        var glyphProfile = {
	          length: 0,
	          sizeOfInstructions: 0
	        };
	        if (sourceEnd - sourceStart <= 12) {
	          return glyphProfile;
	        }
	        var glyf = source.subarray(sourceStart, sourceEnd);
	        var contoursCount = signedInt16(glyf[0], glyf[1]);
	        if (contoursCount < 0) {
	          contoursCount = -1;
	          writeSignedInt16(glyf, 0, contoursCount);
	          dest.set(glyf, destStart);
	          glyphProfile.length = glyf.length;
	          return glyphProfile;
	        }
	        var i,
	            j = 10,
	            flagsCount = 0;
	        for (i = 0; i < contoursCount; i++) {
	          var endPoint = glyf[j] << 8 | glyf[j + 1];
	          flagsCount = endPoint + 1;
	          j += 2;
	        }
	        var instructionsStart = j;
	        var instructionsLength = glyf[j] << 8 | glyf[j + 1];
	        glyphProfile.sizeOfInstructions = instructionsLength;
	        j += 2 + instructionsLength;
	        var instructionsEnd = j;
	        var coordinatesLength = 0;
	        for (i = 0; i < flagsCount; i++) {
	          var flag = glyf[j++];
	          if (flag & 0xC0) {
	            glyf[j - 1] = flag & 0x3F;
	          }
	          var xyLength = (flag & 2 ? 1 : flag & 16 ? 0 : 2) + (flag & 4 ? 1 : flag & 32 ? 0 : 2);
	          coordinatesLength += xyLength;
	          if (flag & 8) {
	            var repeat = glyf[j++];
	            i += repeat;
	            coordinatesLength += repeat * xyLength;
	          }
	        }
	        if (coordinatesLength === 0) {
	          return glyphProfile;
	        }
	        var glyphDataLength = j + coordinatesLength;
	        if (glyphDataLength > glyf.length) {
	          return glyphProfile;
	        }
	        if (!hintsValid && instructionsLength > 0) {
	          dest.set(glyf.subarray(0, instructionsStart), destStart);
	          dest.set([0, 0], destStart + instructionsStart);
	          dest.set(glyf.subarray(instructionsEnd, glyphDataLength), destStart + instructionsStart + 2);
	          glyphDataLength -= instructionsLength;
	          if (glyf.length - glyphDataLength > 3) {
	            glyphDataLength = glyphDataLength + 3 & ~3;
	          }
	          glyphProfile.length = glyphDataLength;
	          return glyphProfile;
	        }
	        if (glyf.length - glyphDataLength > 3) {
	          glyphDataLength = glyphDataLength + 3 & ~3;
	          dest.set(glyf.subarray(0, glyphDataLength), destStart);
	          glyphProfile.length = glyphDataLength;
	          return glyphProfile;
	        }
	        dest.set(glyf, destStart);
	        glyphProfile.length = glyf.length;
	        return glyphProfile;
	      }
	      function sanitizeHead(head, numGlyphs, locaLength) {
	        var data = head.data;
	        var version = int32(data[0], data[1], data[2], data[3]);
	        if (version >> 16 !== 1) {
	          (0, _util.info)('Attempting to fix invalid version in head table: ' + version);
	          data[0] = 0;
	          data[1] = 1;
	          data[2] = 0;
	          data[3] = 0;
	        }
	        var indexToLocFormat = int16(data[50], data[51]);
	        if (indexToLocFormat < 0 || indexToLocFormat > 1) {
	          (0, _util.info)('Attempting to fix invalid indexToLocFormat in head table: ' + indexToLocFormat);
	          var numGlyphsPlusOne = numGlyphs + 1;
	          if (locaLength === numGlyphsPlusOne << 1) {
	            data[50] = 0;
	            data[51] = 0;
	          } else if (locaLength === numGlyphsPlusOne << 2) {
	            data[50] = 0;
	            data[51] = 1;
	          } else {
	            throw new _util.FormatError('Could not fix indexToLocFormat: ' + indexToLocFormat);
	          }
	        }
	      }
	      function sanitizeGlyphLocations(loca, glyf, numGlyphs, isGlyphLocationsLong, hintsValid, dupFirstEntry, maxSizeOfInstructions) {
	        var itemSize, itemDecode, itemEncode;
	        if (isGlyphLocationsLong) {
	          itemSize = 4;
	          itemDecode = function fontItemDecodeLong(data, offset) {
	            return data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3];
	          };
	          itemEncode = function fontItemEncodeLong(data, offset, value) {
	            data[offset] = value >>> 24 & 0xFF;
	            data[offset + 1] = value >> 16 & 0xFF;
	            data[offset + 2] = value >> 8 & 0xFF;
	            data[offset + 3] = value & 0xFF;
	          };
	        } else {
	          itemSize = 2;
	          itemDecode = function fontItemDecode(data, offset) {
	            return data[offset] << 9 | data[offset + 1] << 1;
	          };
	          itemEncode = function fontItemEncode(data, offset, value) {
	            data[offset] = value >> 9 & 0xFF;
	            data[offset + 1] = value >> 1 & 0xFF;
	          };
	        }
	        var locaData = loca.data;
	        var locaDataSize = itemSize * (1 + numGlyphs);
	        if (locaData.length !== locaDataSize) {
	          locaData = new Uint8Array(locaDataSize);
	          locaData.set(loca.data.subarray(0, locaDataSize));
	          loca.data = locaData;
	        }
	        var oldGlyfData = glyf.data;
	        var oldGlyfDataLength = oldGlyfData.length;
	        var newGlyfData = new Uint8Array(oldGlyfDataLength);
	        var startOffset = itemDecode(locaData, 0);
	        var writeOffset = 0;
	        var missingGlyphs = Object.create(null);
	        itemEncode(locaData, 0, writeOffset);
	        var i, j;
	        var locaCount = dupFirstEntry ? numGlyphs - 1 : numGlyphs;
	        for (i = 0, j = itemSize; i < locaCount; i++, j += itemSize) {
	          var endOffset = itemDecode(locaData, j);
	          if (endOffset > oldGlyfDataLength && (oldGlyfDataLength + 3 & ~3) === endOffset) {
	            endOffset = oldGlyfDataLength;
	          }
	          if (endOffset > oldGlyfDataLength) {
	            startOffset = endOffset;
	          }
	          var glyphProfile = sanitizeGlyph(oldGlyfData, startOffset, endOffset, newGlyfData, writeOffset, hintsValid);
	          var newLength = glyphProfile.length;
	          if (newLength === 0) {
	            missingGlyphs[i] = true;
	          }
	          if (glyphProfile.sizeOfInstructions > maxSizeOfInstructions) {
	            maxSizeOfInstructions = glyphProfile.sizeOfInstructions;
	          }
	          writeOffset += newLength;
	          itemEncode(locaData, j, writeOffset);
	          startOffset = endOffset;
	        }
	        if (writeOffset === 0) {
	          var simpleGlyph = new Uint8Array([0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 49, 0]);
	          for (i = 0, j = itemSize; i < numGlyphs; i++, j += itemSize) {
	            itemEncode(locaData, j, simpleGlyph.length);
	          }
	          glyf.data = simpleGlyph;
	        } else if (dupFirstEntry) {
	          var firstEntryLength = itemDecode(locaData, itemSize);
	          if (newGlyfData.length > firstEntryLength + writeOffset) {
	            glyf.data = newGlyfData.subarray(0, firstEntryLength + writeOffset);
	          } else {
	            glyf.data = new Uint8Array(firstEntryLength + writeOffset);
	            glyf.data.set(newGlyfData.subarray(0, writeOffset));
	          }
	          glyf.data.set(newGlyfData.subarray(0, firstEntryLength), writeOffset);
	          itemEncode(loca.data, locaData.length - itemSize, writeOffset + firstEntryLength);
	        } else {
	          glyf.data = newGlyfData.subarray(0, writeOffset);
	        }
	        return {
	          missingGlyphs: missingGlyphs,
	          maxSizeOfInstructions: maxSizeOfInstructions
	        };
	      }
	      function readPostScriptTable(post, properties, maxpNumGlyphs) {
	        var start = (font.start ? font.start : 0) + post.offset;
	        font.pos = start;
	        var length = post.length,
	            end = start + length;
	        var version = font.getInt32();
	        font.getBytes(28);
	        var glyphNames;
	        var valid = true;
	        var i;
	        switch (version) {
	          case 0x00010000:
	            glyphNames = MacStandardGlyphOrdering;
	            break;
	          case 0x00020000:
	            var numGlyphs = font.getUint16();
	            if (numGlyphs !== maxpNumGlyphs) {
	              valid = false;
	              break;
	            }
	            var glyphNameIndexes = [];
	            for (i = 0; i < numGlyphs; ++i) {
	              var index = font.getUint16();
	              if (index >= 32768) {
	                valid = false;
	                break;
	              }
	              glyphNameIndexes.push(index);
	            }
	            if (!valid) {
	              break;
	            }
	            var customNames = [];
	            var strBuf = [];
	            while (font.pos < end) {
	              var stringLength = font.getByte();
	              strBuf.length = stringLength;
	              for (i = 0; i < stringLength; ++i) {
	                strBuf[i] = String.fromCharCode(font.getByte());
	              }
	              customNames.push(strBuf.join(''));
	            }
	            glyphNames = [];
	            for (i = 0; i < numGlyphs; ++i) {
	              var j = glyphNameIndexes[i];
	              if (j < 258) {
	                glyphNames.push(MacStandardGlyphOrdering[j]);
	                continue;
	              }
	              glyphNames.push(customNames[j - 258]);
	            }
	            break;
	          case 0x00030000:
	            break;
	          default:
	            (0, _util.warn)('Unknown/unsupported post table version ' + version);
	            valid = false;
	            if (properties.defaultEncoding) {
	              glyphNames = properties.defaultEncoding;
	            }
	            break;
	        }
	        properties.glyphNames = glyphNames;
	        return valid;
	      }
	      function readNameTable(nameTable) {
	        var start = (font.start ? font.start : 0) + nameTable.offset;
	        font.pos = start;
	        var names = [[], []];
	        var length = nameTable.length,
	            end = start + length;
	        var format = font.getUint16();
	        var FORMAT_0_HEADER_LENGTH = 6;
	        if (format !== 0 || length < FORMAT_0_HEADER_LENGTH) {
	          return names;
	        }
	        var numRecords = font.getUint16();
	        var stringsStart = font.getUint16();
	        var records = [];
	        var NAME_RECORD_LENGTH = 12;
	        var i, ii;
	        for (i = 0; i < numRecords && font.pos + NAME_RECORD_LENGTH <= end; i++) {
	          var r = {
	            platform: font.getUint16(),
	            encoding: font.getUint16(),
	            language: font.getUint16(),
	            name: font.getUint16(),
	            length: font.getUint16(),
	            offset: font.getUint16()
	          };
	          if (r.platform === 1 && r.encoding === 0 && r.language === 0 || r.platform === 3 && r.encoding === 1 && r.language === 0x409) {
	            records.push(r);
	          }
	        }
	        for (i = 0, ii = records.length; i < ii; i++) {
	          var record = records[i];
	          if (record.length <= 0) {
	            continue;
	          }
	          var pos = start + stringsStart + record.offset;
	          if (pos + record.length > end) {
	            continue;
	          }
	          font.pos = pos;
	          var nameIndex = record.name;
	          if (record.encoding) {
	            var str = '';
	            for (var j = 0, jj = record.length; j < jj; j += 2) {
	              str += String.fromCharCode(font.getUint16());
	            }
	            names[1][nameIndex] = str;
	          } else {
	            names[0][nameIndex] = (0, _util.bytesToString)(font.getBytes(record.length));
	          }
	        }
	        return names;
	      }
	      var TTOpsStackDeltas = [0, 0, 0, 0, 0, 0, 0, 0, -2, -2, -2, -2, 0, 0, -2, -5, -1, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, -1, -1, 1, -1, -999, 0, 1, 0, -1, -2, 0, -1, -2, -1, -1, 0, -1, -1, 0, 0, -999, -999, -1, -1, -1, -1, -2, -999, -2, -2, -999, 0, -2, -2, 0, 0, -2, 0, -2, 0, 0, 0, -2, -1, -1, 1, 1, 0, 0, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, 0, -999, -1, -1, -1, -1, -1, -1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -2, -999, -999, -999, -999, -999, -1, -1, -2, -2, 0, 0, 0, 0, -1, -1, -999, -2, -2, 0, 0, -1, -2, -2, 0, 0, 0, -1, -1, -1, -2];
	      function sanitizeTTProgram(table, ttContext) {
	        var data = table.data;
	        var i = 0,
	            j,
	            n,
	            b,
	            funcId,
	            pc,
	            lastEndf = 0,
	            lastDeff = 0;
	        var stack = [];
	        var callstack = [];
	        var functionsCalled = [];
	        var tooComplexToFollowFunctions = ttContext.tooComplexToFollowFunctions;
	        var inFDEF = false,
	            ifLevel = 0,
	            inELSE = 0;
	        for (var ii = data.length; i < ii;) {
	          var op = data[i++];
	          if (op === 0x40) {
	            n = data[i++];
	            if (inFDEF || inELSE) {
	              i += n;
	            } else {
	              for (j = 0; j < n; j++) {
	                stack.push(data[i++]);
	              }
	            }
	          } else if (op === 0x41) {
	            n = data[i++];
	            if (inFDEF || inELSE) {
	              i += n * 2;
	            } else {
	              for (j = 0; j < n; j++) {
	                b = data[i++];
	                stack.push(b << 8 | data[i++]);
	              }
	            }
	          } else if ((op & 0xF8) === 0xB0) {
	            n = op - 0xB0 + 1;
	            if (inFDEF || inELSE) {
	              i += n;
	            } else {
	              for (j = 0; j < n; j++) {
	                stack.push(data[i++]);
	              }
	            }
	          } else if ((op & 0xF8) === 0xB8) {
	            n = op - 0xB8 + 1;
	            if (inFDEF || inELSE) {
	              i += n * 2;
	            } else {
	              for (j = 0; j < n; j++) {
	                b = data[i++];
	                stack.push(b << 8 | data[i++]);
	              }
	            }
	          } else if (op === 0x2B && !tooComplexToFollowFunctions) {
	            if (!inFDEF && !inELSE) {
	              funcId = stack[stack.length - 1];
	              ttContext.functionsUsed[funcId] = true;
	              if (funcId in ttContext.functionsStackDeltas) {
	                stack.length += ttContext.functionsStackDeltas[funcId];
	              } else if (funcId in ttContext.functionsDefined && functionsCalled.indexOf(funcId) < 0) {
	                callstack.push({
	                  data: data,
	                  i: i,
	                  stackTop: stack.length - 1
	                });
	                functionsCalled.push(funcId);
	                pc = ttContext.functionsDefined[funcId];
	                if (!pc) {
	                  (0, _util.warn)('TT: CALL non-existent function');
	                  ttContext.hintsValid = false;
	                  return;
	                }
	                data = pc.data;
	                i = pc.i;
	              }
	            }
	          } else if (op === 0x2C && !tooComplexToFollowFunctions) {
	            if (inFDEF || inELSE) {
	              (0, _util.warn)('TT: nested FDEFs not allowed');
	              tooComplexToFollowFunctions = true;
	            }
	            inFDEF = true;
	            lastDeff = i;
	            funcId = stack.pop();
	            ttContext.functionsDefined[funcId] = {
	              data: data,
	              i: i
	            };
	          } else if (op === 0x2D) {
	            if (inFDEF) {
	              inFDEF = false;
	              lastEndf = i;
	            } else {
	              pc = callstack.pop();
	              if (!pc) {
	                (0, _util.warn)('TT: ENDF bad stack');
	                ttContext.hintsValid = false;
	                return;
	              }
	              funcId = functionsCalled.pop();
	              data = pc.data;
	              i = pc.i;
	              ttContext.functionsStackDeltas[funcId] = stack.length - pc.stackTop;
	            }
	          } else if (op === 0x89) {
	            if (inFDEF || inELSE) {
	              (0, _util.warn)('TT: nested IDEFs not allowed');
	              tooComplexToFollowFunctions = true;
	            }
	            inFDEF = true;
	            lastDeff = i;
	          } else if (op === 0x58) {
	            ++ifLevel;
	          } else if (op === 0x1B) {
	            inELSE = ifLevel;
	          } else if (op === 0x59) {
	            if (inELSE === ifLevel) {
	              inELSE = 0;
	            }
	            --ifLevel;
	          } else if (op === 0x1C) {
	            if (!inFDEF && !inELSE) {
	              var offset = stack[stack.length - 1];
	              if (offset > 0) {
	                i += offset - 1;
	              }
	            }
	          }
	          if (!inFDEF && !inELSE) {
	            var stackDelta = op <= 0x8E ? TTOpsStackDeltas[op] : op >= 0xC0 && op <= 0xDF ? -1 : op >= 0xE0 ? -2 : 0;
	            if (op >= 0x71 && op <= 0x75) {
	              n = stack.pop();
	              if (!isNaN(n)) {
	                stackDelta = -n * 2;
	              }
	            }
	            while (stackDelta < 0 && stack.length > 0) {
	              stack.pop();
	              stackDelta++;
	            }
	            while (stackDelta > 0) {
	              stack.push(NaN);
	              stackDelta--;
	            }
	          }
	        }
	        ttContext.tooComplexToFollowFunctions = tooComplexToFollowFunctions;
	        var content = [data];
	        if (i > data.length) {
	          content.push(new Uint8Array(i - data.length));
	        }
	        if (lastDeff > lastEndf) {
	          (0, _util.warn)('TT: complementing a missing function tail');
	          content.push(new Uint8Array([0x22, 0x2D]));
	        }
	        foldTTTable(table, content);
	      }
	      function checkInvalidFunctions(ttContext, maxFunctionDefs) {
	        if (ttContext.tooComplexToFollowFunctions) {
	          return;
	        }
	        if (ttContext.functionsDefined.length > maxFunctionDefs) {
	          (0, _util.warn)('TT: more functions defined than expected');
	          ttContext.hintsValid = false;
	          return;
	        }
	        for (var j = 0, jj = ttContext.functionsUsed.length; j < jj; j++) {
	          if (j > maxFunctionDefs) {
	            (0, _util.warn)('TT: invalid function id: ' + j);
	            ttContext.hintsValid = false;
	            return;
	          }
	          if (ttContext.functionsUsed[j] && !ttContext.functionsDefined[j]) {
	            (0, _util.warn)('TT: undefined function: ' + j);
	            ttContext.hintsValid = false;
	            return;
	          }
	        }
	      }
	      function foldTTTable(table, content) {
	        if (content.length > 1) {
	          var newLength = 0;
	          var j, jj;
	          for (j = 0, jj = content.length; j < jj; j++) {
	            newLength += content[j].length;
	          }
	          newLength = newLength + 3 & ~3;
	          var result = new Uint8Array(newLength);
	          var pos = 0;
	          for (j = 0, jj = content.length; j < jj; j++) {
	            result.set(content[j], pos);
	            pos += content[j].length;
	          }
	          table.data = result;
	          table.length = newLength;
	        }
	      }
	      function sanitizeTTPrograms(fpgm, prep, cvt, maxFunctionDefs) {
	        var ttContext = {
	          functionsDefined: [],
	          functionsUsed: [],
	          functionsStackDeltas: [],
	          tooComplexToFollowFunctions: false,
	          hintsValid: true
	        };
	        if (fpgm) {
	          sanitizeTTProgram(fpgm, ttContext);
	        }
	        if (prep) {
	          sanitizeTTProgram(prep, ttContext);
	        }
	        if (fpgm) {
	          checkInvalidFunctions(ttContext, maxFunctionDefs);
	        }
	        if (cvt && cvt.length & 1) {
	          var cvtData = new Uint8Array(cvt.length + 1);
	          cvtData.set(cvt.data);
	          cvt.data = cvtData;
	        }
	        return ttContext.hintsValid;
	      }
	      font = new _stream.Stream(new Uint8Array(font.getBytes()));
	      var VALID_TABLES = ['OS/2', 'cmap', 'head', 'hhea', 'hmtx', 'maxp', 'name', 'post', 'loca', 'glyf', 'fpgm', 'prep', 'cvt ', 'CFF '];
	      var header = readOpenTypeHeader(font);
	      var numTables = header.numTables;
	      var cff, cffFile;
	      var tables = Object.create(null);
	      tables['OS/2'] = null;
	      tables['cmap'] = null;
	      tables['head'] = null;
	      tables['hhea'] = null;
	      tables['hmtx'] = null;
	      tables['maxp'] = null;
	      tables['name'] = null;
	      tables['post'] = null;
	      var table;
	      for (var i = 0; i < numTables; i++) {
	        table = readTableEntry(font);
	        if (VALID_TABLES.indexOf(table.tag) < 0) {
	          continue;
	        }
	        if (table.length === 0) {
	          continue;
	        }
	        tables[table.tag] = table;
	      }
	      var isTrueType = !tables['CFF '];
	      if (!isTrueType) {
	        if (header.version === 'OTTO' && !(properties.composite && properties.cidToGidMap) || !tables['head'] || !tables['hhea'] || !tables['maxp'] || !tables['post']) {
	          cffFile = new _stream.Stream(tables['CFF '].data);
	          cff = new CFFFont(cffFile, properties);
	          adjustWidths(properties);
	          return this.convert(name, cff, properties);
	        }
	        delete tables['glyf'];
	        delete tables['loca'];
	        delete tables['fpgm'];
	        delete tables['prep'];
	        delete tables['cvt '];
	        this.isOpenType = true;
	      } else {
	        if (!tables['loca']) {
	          throw new _util.FormatError('Required "loca" table is not found');
	        }
	        if (!tables['glyf']) {
	          (0, _util.warn)('Required "glyf" table is not found -- trying to recover.');
	          tables['glyf'] = {
	            tag: 'glyf',
	            data: new Uint8Array(0)
	          };
	        }
	        this.isOpenType = false;
	      }
	      if (!tables['maxp']) {
	        throw new _util.FormatError('Required "maxp" table is not found');
	      }
	      font.pos = (font.start || 0) + tables['maxp'].offset;
	      var version = font.getInt32();
	      var numGlyphs = font.getUint16();
	      var maxFunctionDefs = 0;
	      var maxSizeOfInstructions = 0;
	      if (version >= 0x00010000 && tables['maxp'].length >= 22) {
	        font.pos += 8;
	        var maxZones = font.getUint16();
	        if (maxZones > 2) {
	          tables['maxp'].data[14] = 0;
	          tables['maxp'].data[15] = 2;
	        }
	        font.pos += 4;
	        maxFunctionDefs = font.getUint16();
	        font.pos += 6;
	        maxSizeOfInstructions = font.getUint16();
	      }
	      var dupFirstEntry = false;
	      if (properties.type === 'CIDFontType2' && properties.toUnicode && properties.toUnicode.get(0) > '\0') {
	        dupFirstEntry = true;
	        numGlyphs++;
	        tables['maxp'].data[4] = numGlyphs >> 8;
	        tables['maxp'].data[5] = numGlyphs & 255;
	      }
	      var hintsValid = sanitizeTTPrograms(tables['fpgm'], tables['prep'], tables['cvt '], maxFunctionDefs);
	      if (!hintsValid) {
	        delete tables['fpgm'];
	        delete tables['prep'];
	        delete tables['cvt '];
	      }
	      sanitizeMetrics(font, tables['hhea'], tables['hmtx'], numGlyphs);
	      if (!tables['head']) {
	        throw new _util.FormatError('Required "head" table is not found');
	      }
	      sanitizeHead(tables['head'], numGlyphs, isTrueType ? tables['loca'].length : 0);
	      var missingGlyphs = Object.create(null);
	      if (isTrueType) {
	        var isGlyphLocationsLong = int16(tables['head'].data[50], tables['head'].data[51]);
	        var glyphsInfo = sanitizeGlyphLocations(tables['loca'], tables['glyf'], numGlyphs, isGlyphLocationsLong, hintsValid, dupFirstEntry, maxSizeOfInstructions);
	        missingGlyphs = glyphsInfo.missingGlyphs;
	        if (version >= 0x00010000 && tables['maxp'].length >= 22) {
	          tables['maxp'].data[26] = glyphsInfo.maxSizeOfInstructions >> 8;
	          tables['maxp'].data[27] = glyphsInfo.maxSizeOfInstructions & 255;
	        }
	      }
	      if (!tables['hhea']) {
	        throw new _util.FormatError('Required "hhea" table is not found');
	      }
	      if (tables['hhea'].data[10] === 0 && tables['hhea'].data[11] === 0) {
	        tables['hhea'].data[10] = 0xFF;
	        tables['hhea'].data[11] = 0xFF;
	      }
	      var metricsOverride = {
	        unitsPerEm: int16(tables['head'].data[18], tables['head'].data[19]),
	        yMax: int16(tables['head'].data[42], tables['head'].data[43]),
	        yMin: signedInt16(tables['head'].data[38], tables['head'].data[39]),
	        ascent: int16(tables['hhea'].data[4], tables['hhea'].data[5]),
	        descent: signedInt16(tables['hhea'].data[6], tables['hhea'].data[7])
	      };
	      this.ascent = metricsOverride.ascent / metricsOverride.unitsPerEm;
	      this.descent = metricsOverride.descent / metricsOverride.unitsPerEm;
	      if (tables['post']) {
	        var valid = readPostScriptTable(tables['post'], properties, numGlyphs);
	        if (!valid) {
	          tables['post'] = null;
	        }
	      }
	      var charCodeToGlyphId = [],
	          charCode;
	      function hasGlyph(glyphId) {
	        return !missingGlyphs[glyphId];
	      }
	      if (properties.composite) {
	        var cidToGidMap = properties.cidToGidMap || [];
	        var isCidToGidMapEmpty = cidToGidMap.length === 0;
	        properties.cMap.forEach(function (charCode, cid) {
	          if (cid > 0xffff) {
	            throw new _util.FormatError('Max size of CID is 65,535');
	          }
	          var glyphId = -1;
	          if (isCidToGidMapEmpty) {
	            glyphId = cid;
	          } else if (cidToGidMap[cid] !== undefined) {
	            glyphId = cidToGidMap[cid];
	          }
	          if (glyphId >= 0 && glyphId < numGlyphs && hasGlyph(glyphId)) {
	            charCodeToGlyphId[charCode] = glyphId;
	          }
	        });
	        if (dupFirstEntry && (isCidToGidMapEmpty || !charCodeToGlyphId[0])) {
	          charCodeToGlyphId[0] = numGlyphs - 1;
	        }
	      } else {
	        var cmapTable = readCmapTable(tables['cmap'], font, this.isSymbolicFont, properties.hasEncoding);
	        var cmapPlatformId = cmapTable.platformId;
	        var cmapEncodingId = cmapTable.encodingId;
	        var cmapMappings = cmapTable.mappings;
	        var cmapMappingsLength = cmapMappings.length;
	        if (properties.hasEncoding && (cmapPlatformId === 3 && cmapEncodingId === 1 || cmapPlatformId === 1 && cmapEncodingId === 0) || cmapPlatformId === -1 && cmapEncodingId === -1 && !!(0, _encodings.getEncoding)(properties.baseEncodingName)) {
	          var baseEncoding = [];
	          if (properties.baseEncodingName === 'MacRomanEncoding' || properties.baseEncodingName === 'WinAnsiEncoding') {
	            baseEncoding = (0, _encodings.getEncoding)(properties.baseEncodingName);
	          }
	          var glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
	          for (charCode = 0; charCode < 256; charCode++) {
	            var glyphName, standardGlyphName;
	            if (this.differences && charCode in this.differences) {
	              glyphName = this.differences[charCode];
	            } else if (charCode in baseEncoding && baseEncoding[charCode] !== '') {
	              glyphName = baseEncoding[charCode];
	            } else {
	              glyphName = _encodings.StandardEncoding[charCode];
	            }
	            if (!glyphName) {
	              continue;
	            }
	            standardGlyphName = recoverGlyphName(glyphName, glyphsUnicodeMap);
	            var unicodeOrCharCode;
	            if (cmapPlatformId === 3 && cmapEncodingId === 1) {
	              unicodeOrCharCode = glyphsUnicodeMap[standardGlyphName];
	            } else if (cmapPlatformId === 1 && cmapEncodingId === 0) {
	              unicodeOrCharCode = _encodings.MacRomanEncoding.indexOf(standardGlyphName);
	            }
	            var found = false;
	            for (i = 0; i < cmapMappingsLength; ++i) {
	              if (cmapMappings[i].charCode !== unicodeOrCharCode) {
	                continue;
	              }
	              charCodeToGlyphId[charCode] = cmapMappings[i].glyphId;
	              found = true;
	              break;
	            }
	            if (!found && properties.glyphNames) {
	              var glyphId = properties.glyphNames.indexOf(glyphName);
	              if (glyphId === -1 && standardGlyphName !== glyphName) {
	                glyphId = properties.glyphNames.indexOf(standardGlyphName);
	              }
	              if (glyphId > 0 && hasGlyph(glyphId)) {
	                charCodeToGlyphId[charCode] = glyphId;
	                found = true;
	              }
	            }
	          }
	        } else if (cmapPlatformId === 0 && cmapEncodingId === 0) {
	          for (i = 0; i < cmapMappingsLength; ++i) {
	            charCodeToGlyphId[cmapMappings[i].charCode] = cmapMappings[i].glyphId;
	          }
	        } else {
	          for (i = 0; i < cmapMappingsLength; ++i) {
	            charCode = cmapMappings[i].charCode;
	            if (cmapPlatformId === 3 && charCode >= 0xF000 && charCode <= 0xF0FF) {
	              charCode &= 0xFF;
	            }
	            charCodeToGlyphId[charCode] = cmapMappings[i].glyphId;
	          }
	        }
	      }
	      if (charCodeToGlyphId.length === 0) {
	        charCodeToGlyphId[0] = 0;
	      }
	      var newMapping = adjustMapping(charCodeToGlyphId, properties, missingGlyphs);
	      this.toFontChar = newMapping.toFontChar;
	      tables['cmap'] = {
	        tag: 'cmap',
	        data: createCmapTable(newMapping.charCodeToGlyphId, numGlyphs)
	      };
	      if (!tables['OS/2'] || !validateOS2Table(tables['OS/2'])) {
	        tables['OS/2'] = {
	          tag: 'OS/2',
	          data: createOS2Table(properties, newMapping.charCodeToGlyphId, metricsOverride)
	        };
	      }
	      if (!tables['post']) {
	        tables['post'] = {
	          tag: 'post',
	          data: createPostTable(properties)
	        };
	      }
	      if (!isTrueType) {
	        try {
	          cffFile = new _stream.Stream(tables['CFF '].data);
	          var parser = new _cff_parser.CFFParser(cffFile, properties, SEAC_ANALYSIS_ENABLED);
	          cff = parser.parse();
	          var compiler = new _cff_parser.CFFCompiler(cff);
	          tables['CFF '].data = compiler.compile();
	        } catch (e) {
	          (0, _util.warn)('Failed to compile font ' + properties.loadedName);
	        }
	      }
	      if (!tables['name']) {
	        tables['name'] = {
	          tag: 'name',
	          data: createNameTable(this.name)
	        };
	      } else {
	        var namePrototype = readNameTable(tables['name']);
	        tables['name'].data = createNameTable(name, namePrototype);
	      }
	      var builder = new OpenTypeFileBuilder(header.version);
	      for (var tableTag in tables) {
	        builder.addTable(tableTag, tables[tableTag].data);
	      }
	      return builder.toArray();
	    },
	    convert: function Font_convert(fontName, font, properties) {
	      properties.fixedPitch = false;
	      if (properties.builtInEncoding) {
	        adjustToUnicode(properties, properties.builtInEncoding);
	      }
	      var mapping = font.getGlyphMapping(properties);
	      var newMapping = adjustMapping(mapping, properties, Object.create(null));
	      this.toFontChar = newMapping.toFontChar;
	      var numGlyphs = font.numGlyphs;
	      function getCharCodes(charCodeToGlyphId, glyphId) {
	        var charCodes = null;
	        for (var charCode in charCodeToGlyphId) {
	          if (glyphId === charCodeToGlyphId[charCode]) {
	            if (!charCodes) {
	              charCodes = [];
	            }
	            charCodes.push(charCode | 0);
	          }
	        }
	        return charCodes;
	      }
	      function createCharCode(charCodeToGlyphId, glyphId) {
	        for (var charCode in charCodeToGlyphId) {
	          if (glyphId === charCodeToGlyphId[charCode]) {
	            return charCode | 0;
	          }
	        }
	        newMapping.charCodeToGlyphId[newMapping.nextAvailableFontCharCode] = glyphId;
	        return newMapping.nextAvailableFontCharCode++;
	      }
	      var seacs = font.seacs;
	      if (SEAC_ANALYSIS_ENABLED && seacs && seacs.length) {
	        var matrix = properties.fontMatrix || _util.FONT_IDENTITY_MATRIX;
	        var charset = font.getCharset();
	        var seacMap = Object.create(null);
	        for (var glyphId in seacs) {
	          glyphId |= 0;
	          var seac = seacs[glyphId];
	          var baseGlyphName = _encodings.StandardEncoding[seac[2]];
	          var accentGlyphName = _encodings.StandardEncoding[seac[3]];
	          var baseGlyphId = charset.indexOf(baseGlyphName);
	          var accentGlyphId = charset.indexOf(accentGlyphName);
	          if (baseGlyphId < 0 || accentGlyphId < 0) {
	            continue;
	          }
	          var accentOffset = {
	            x: seac[0] * matrix[0] + seac[1] * matrix[2] + matrix[4],
	            y: seac[0] * matrix[1] + seac[1] * matrix[3] + matrix[5]
	          };
	          var charCodes = getCharCodes(mapping, glyphId);
	          if (!charCodes) {
	            continue;
	          }
	          for (var i = 0, ii = charCodes.length; i < ii; i++) {
	            var charCode = charCodes[i];
	            var charCodeToGlyphId = newMapping.charCodeToGlyphId;
	            var baseFontCharCode = createCharCode(charCodeToGlyphId, baseGlyphId);
	            var accentFontCharCode = createCharCode(charCodeToGlyphId, accentGlyphId);
	            seacMap[charCode] = {
	              baseFontCharCode: baseFontCharCode,
	              accentFontCharCode: accentFontCharCode,
	              accentOffset: accentOffset
	            };
	          }
	        }
	        properties.seacMap = seacMap;
	      }
	      var unitsPerEm = 1 / (properties.fontMatrix || _util.FONT_IDENTITY_MATRIX)[0];
	      var builder = new OpenTypeFileBuilder('\x4F\x54\x54\x4F');
	      builder.addTable('CFF ', font.data);
	      builder.addTable('OS/2', createOS2Table(properties, newMapping.charCodeToGlyphId));
	      builder.addTable('cmap', createCmapTable(newMapping.charCodeToGlyphId, numGlyphs));
	      builder.addTable('head', '\x00\x01\x00\x00' + '\x00\x00\x10\x00' + '\x00\x00\x00\x00' + '\x5F\x0F\x3C\xF5' + '\x00\x00' + safeString16(unitsPerEm) + '\x00\x00\x00\x00\x9e\x0b\x7e\x27' + '\x00\x00\x00\x00\x9e\x0b\x7e\x27' + '\x00\x00' + safeString16(properties.descent) + '\x0F\xFF' + safeString16(properties.ascent) + string16(properties.italicAngle ? 2 : 0) + '\x00\x11' + '\x00\x00' + '\x00\x00' + '\x00\x00');
	      builder.addTable('hhea', '\x00\x01\x00\x00' + safeString16(properties.ascent) + safeString16(properties.descent) + '\x00\x00' + '\xFF\xFF' + '\x00\x00' + '\x00\x00' + '\x00\x00' + safeString16(properties.capHeight) + safeString16(Math.tan(properties.italicAngle) * properties.xHeight) + '\x00\x00' + '\x00\x00' + '\x00\x00' + '\x00\x00' + '\x00\x00' + '\x00\x00' + string16(numGlyphs));
	      builder.addTable('hmtx', function fontFieldsHmtx() {
	        var charstrings = font.charstrings;
	        var cffWidths = font.cff ? font.cff.widths : null;
	        var hmtx = '\x00\x00\x00\x00';
	        for (var i = 1, ii = numGlyphs; i < ii; i++) {
	          var width = 0;
	          if (charstrings) {
	            var charstring = charstrings[i - 1];
	            width = 'width' in charstring ? charstring.width : 0;
	          } else if (cffWidths) {
	            width = Math.ceil(cffWidths[i] || 0);
	          }
	          hmtx += string16(width) + string16(0);
	        }
	        return hmtx;
	      }());
	      builder.addTable('maxp', '\x00\x00\x50\x00' + string16(numGlyphs));
	      builder.addTable('name', createNameTable(fontName));
	      builder.addTable('post', createPostTable(properties));
	      return builder.toArray();
	    },
	    get spaceWidth() {
	      if ('_shadowWidth' in this) {
	        return this._shadowWidth;
	      }
	      var possibleSpaceReplacements = ['space', 'minus', 'one', 'i', 'I'];
	      var width;
	      for (var i = 0, ii = possibleSpaceReplacements.length; i < ii; i++) {
	        var glyphName = possibleSpaceReplacements[i];
	        if (glyphName in this.widths) {
	          width = this.widths[glyphName];
	          break;
	        }
	        var glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
	        var glyphUnicode = glyphsUnicodeMap[glyphName];
	        var charcode = 0;
	        if (this.composite) {
	          if (this.cMap.contains(glyphUnicode)) {
	            charcode = this.cMap.lookup(glyphUnicode);
	          }
	        }
	        if (!charcode && this.toUnicode) {
	          charcode = this.toUnicode.charCodeOf(glyphUnicode);
	        }
	        if (charcode <= 0) {
	          charcode = glyphUnicode;
	        }
	        width = this.widths[charcode];
	        if (width) {
	          break;
	        }
	      }
	      width = width || this.defaultWidth;
	      this._shadowWidth = width;
	      return width;
	    },
	    charToGlyph: function Font_charToGlyph(charcode, isSpace) {
	      var fontCharCode, width, operatorListId;
	      var widthCode = charcode;
	      if (this.cMap && this.cMap.contains(charcode)) {
	        widthCode = this.cMap.lookup(charcode);
	      }
	      width = this.widths[widthCode];
	      width = (0, _util.isNum)(width) ? width : this.defaultWidth;
	      var vmetric = this.vmetrics && this.vmetrics[widthCode];
	      var unicode = this.toUnicode.get(charcode) || charcode;
	      if (typeof unicode === 'number') {
	        unicode = String.fromCharCode(unicode);
	      }
	      var isInFont = charcode in this.toFontChar;
	      fontCharCode = this.toFontChar[charcode] || charcode;
	      if (this.missingFile) {
	        fontCharCode = (0, _unicode.mapSpecialUnicodeValues)(fontCharCode);
	      }
	      if (this.isType3Font) {
	        operatorListId = fontCharCode;
	      }
	      var accent = null;
	      if (this.seacMap && this.seacMap[charcode]) {
	        isInFont = true;
	        var seac = this.seacMap[charcode];
	        fontCharCode = seac.baseFontCharCode;
	        accent = {
	          fontChar: String.fromCharCode(seac.accentFontCharCode),
	          offset: seac.accentOffset
	        };
	      }
	      var fontChar = String.fromCharCode(fontCharCode);
	      var glyph = this.glyphCache[charcode];
	      if (!glyph || !glyph.matchesForCache(fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont)) {
	        glyph = new Glyph(fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont);
	        this.glyphCache[charcode] = glyph;
	      }
	      return glyph;
	    },
	    charsToGlyphs: function Font_charsToGlyphs(chars) {
	      var charsCache = this.charsCache;
	      var glyphs, glyph, charcode;
	      if (charsCache) {
	        glyphs = charsCache[chars];
	        if (glyphs) {
	          return glyphs;
	        }
	      }
	      if (!charsCache) {
	        charsCache = this.charsCache = Object.create(null);
	      }
	      glyphs = [];
	      var charsCacheKey = chars;
	      var i = 0,
	          ii;
	      if (this.cMap) {
	        var c = Object.create(null);
	        while (i < chars.length) {
	          this.cMap.readCharCode(chars, i, c);
	          charcode = c.charcode;
	          var length = c.length;
	          i += length;
	          var isSpace = length === 1 && chars.charCodeAt(i - 1) === 0x20;
	          glyph = this.charToGlyph(charcode, isSpace);
	          glyphs.push(glyph);
	        }
	      } else {
	        for (i = 0, ii = chars.length; i < ii; ++i) {
	          charcode = chars.charCodeAt(i);
	          glyph = this.charToGlyph(charcode, charcode === 0x20);
	          glyphs.push(glyph);
	        }
	      }
	      return charsCache[charsCacheKey] = glyphs;
	    }
	  };
	  return Font;
	}();
	var ErrorFont = function ErrorFontClosure() {
	  function ErrorFont(error) {
	    this.error = error;
	    this.loadedName = 'g_font_error';
	    this.loading = false;
	  }
	  ErrorFont.prototype = {
	    charsToGlyphs: function ErrorFont_charsToGlyphs() {
	      return [];
	    },
	    exportData: function ErrorFont_exportData() {
	      return { error: this.error };
	    }
	  };
	  return ErrorFont;
	}();
	function type1FontGlyphMapping(properties, builtInEncoding, glyphNames) {
	  var charCodeToGlyphId = Object.create(null);
	  var glyphId, charCode, baseEncoding;
	  var isSymbolicFont = !!(properties.flags & FontFlags.Symbolic);
	  if (properties.baseEncodingName) {
	    baseEncoding = (0, _encodings.getEncoding)(properties.baseEncodingName);
	    for (charCode = 0; charCode < baseEncoding.length; charCode++) {
	      glyphId = glyphNames.indexOf(baseEncoding[charCode]);
	      if (glyphId >= 0) {
	        charCodeToGlyphId[charCode] = glyphId;
	      } else {
	        charCodeToGlyphId[charCode] = 0;
	      }
	    }
	  } else if (isSymbolicFont) {
	    for (charCode in builtInEncoding) {
	      charCodeToGlyphId[charCode] = builtInEncoding[charCode];
	    }
	  } else {
	    baseEncoding = _encodings.StandardEncoding;
	    for (charCode = 0; charCode < baseEncoding.length; charCode++) {
	      glyphId = glyphNames.indexOf(baseEncoding[charCode]);
	      if (glyphId >= 0) {
	        charCodeToGlyphId[charCode] = glyphId;
	      } else {
	        charCodeToGlyphId[charCode] = 0;
	      }
	    }
	  }
	  var differences = properties.differences,
	      glyphsUnicodeMap;
	  if (differences) {
	    for (charCode in differences) {
	      var glyphName = differences[charCode];
	      glyphId = glyphNames.indexOf(glyphName);
	      if (glyphId === -1) {
	        if (!glyphsUnicodeMap) {
	          glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
	        }
	        var standardGlyphName = recoverGlyphName(glyphName, glyphsUnicodeMap);
	        if (standardGlyphName !== glyphName) {
	          glyphId = glyphNames.indexOf(standardGlyphName);
	        }
	      }
	      if (glyphId >= 0) {
	        charCodeToGlyphId[charCode] = glyphId;
	      } else {
	        charCodeToGlyphId[charCode] = 0;
	      }
	    }
	  }
	  return charCodeToGlyphId;
	}
	var Type1Font = function Type1FontClosure() {
	  function findBlock(streamBytes, signature, startIndex) {
	    var streamBytesLength = streamBytes.length;
	    var signatureLength = signature.length;
	    var scanLength = streamBytesLength - signatureLength;
	    var i = startIndex,
	        j,
	        found = false;
	    while (i < scanLength) {
	      j = 0;
	      while (j < signatureLength && streamBytes[i + j] === signature[j]) {
	        j++;
	      }
	      if (j >= signatureLength) {
	        i += j;
	        while (i < streamBytesLength && (0, _util.isSpace)(streamBytes[i])) {
	          i++;
	        }
	        found = true;
	        break;
	      }
	      i++;
	    }
	    return {
	      found: found,
	      length: i
	    };
	  }
	  function getHeaderBlock(stream, suggestedLength) {
	    var EEXEC_SIGNATURE = [0x65, 0x65, 0x78, 0x65, 0x63];
	    var streamStartPos = stream.pos;
	    var headerBytes, headerBytesLength, block;
	    try {
	      headerBytes = stream.getBytes(suggestedLength);
	      headerBytesLength = headerBytes.length;
	    } catch (ex) {
	      if (ex instanceof _util.MissingDataException) {
	        throw ex;
	      }
	    }
	    if (headerBytesLength === suggestedLength) {
	      block = findBlock(headerBytes, EEXEC_SIGNATURE, suggestedLength - 2 * EEXEC_SIGNATURE.length);
	      if (block.found && block.length === suggestedLength) {
	        return {
	          stream: new _stream.Stream(headerBytes),
	          length: suggestedLength
	        };
	      }
	    }
	    (0, _util.warn)('Invalid "Length1" property in Type1 font -- trying to recover.');
	    stream.pos = streamStartPos;
	    var SCAN_BLOCK_LENGTH = 2048;
	    var actualLength;
	    while (true) {
	      var scanBytes = stream.peekBytes(SCAN_BLOCK_LENGTH);
	      block = findBlock(scanBytes, EEXEC_SIGNATURE, 0);
	      if (block.length === 0) {
	        break;
	      }
	      stream.pos += block.length;
	      if (block.found) {
	        actualLength = stream.pos - streamStartPos;
	        break;
	      }
	    }
	    stream.pos = streamStartPos;
	    if (actualLength) {
	      return {
	        stream: new _stream.Stream(stream.getBytes(actualLength)),
	        length: actualLength
	      };
	    }
	    (0, _util.warn)('Unable to recover "Length1" property in Type1 font -- using as is.');
	    return {
	      stream: new _stream.Stream(stream.getBytes(suggestedLength)),
	      length: suggestedLength
	    };
	  }
	  function getEexecBlock(stream, suggestedLength) {
	    var eexecBytes = stream.getBytes();
	    return {
	      stream: new _stream.Stream(eexecBytes),
	      length: eexecBytes.length
	    };
	  }
	  function Type1Font(name, file, properties) {
	    var PFB_HEADER_SIZE = 6;
	    var headerBlockLength = properties.length1;
	    var eexecBlockLength = properties.length2;
	    var pfbHeader = file.peekBytes(PFB_HEADER_SIZE);
	    var pfbHeaderPresent = pfbHeader[0] === 0x80 && pfbHeader[1] === 0x01;
	    if (pfbHeaderPresent) {
	      file.skip(PFB_HEADER_SIZE);
	      headerBlockLength = pfbHeader[5] << 24 | pfbHeader[4] << 16 | pfbHeader[3] << 8 | pfbHeader[2];
	    }
	    var headerBlock = getHeaderBlock(file, headerBlockLength);
	    headerBlockLength = headerBlock.length;
	    var headerBlockParser = new _type1_parser.Type1Parser(headerBlock.stream, false, SEAC_ANALYSIS_ENABLED);
	    headerBlockParser.extractFontHeader(properties);
	    if (pfbHeaderPresent) {
	      pfbHeader = file.getBytes(PFB_HEADER_SIZE);
	      eexecBlockLength = pfbHeader[5] << 24 | pfbHeader[4] << 16 | pfbHeader[3] << 8 | pfbHeader[2];
	    }
	    var eexecBlock = getEexecBlock(file, eexecBlockLength);
	    eexecBlockLength = eexecBlock.length;
	    var eexecBlockParser = new _type1_parser.Type1Parser(eexecBlock.stream, true, SEAC_ANALYSIS_ENABLED);
	    var data = eexecBlockParser.extractFontProgram();
	    for (var info in data.properties) {
	      properties[info] = data.properties[info];
	    }
	    var charstrings = data.charstrings;
	    var type2Charstrings = this.getType2Charstrings(charstrings);
	    var subrs = this.getType2Subrs(data.subrs);
	    this.charstrings = charstrings;
	    this.data = this.wrap(name, type2Charstrings, this.charstrings, subrs, properties);
	    this.seacs = this.getSeacs(data.charstrings);
	  }
	  Type1Font.prototype = {
	    get numGlyphs() {
	      return this.charstrings.length + 1;
	    },
	    getCharset: function Type1Font_getCharset() {
	      var charset = ['.notdef'];
	      var charstrings = this.charstrings;
	      for (var glyphId = 0; glyphId < charstrings.length; glyphId++) {
	        charset.push(charstrings[glyphId].glyphName);
	      }
	      return charset;
	    },
	    getGlyphMapping: function Type1Font_getGlyphMapping(properties) {
	      var charstrings = this.charstrings;
	      var glyphNames = ['.notdef'],
	          glyphId;
	      for (glyphId = 0; glyphId < charstrings.length; glyphId++) {
	        glyphNames.push(charstrings[glyphId].glyphName);
	      }
	      var encoding = properties.builtInEncoding;
	      if (encoding) {
	        var builtInEncoding = Object.create(null);
	        for (var charCode in encoding) {
	          glyphId = glyphNames.indexOf(encoding[charCode]);
	          if (glyphId >= 0) {
	            builtInEncoding[charCode] = glyphId;
	          }
	        }
	      }
	      return type1FontGlyphMapping(properties, builtInEncoding, glyphNames);
	    },
	    getSeacs: function Type1Font_getSeacs(charstrings) {
	      var i, ii;
	      var seacMap = [];
	      for (i = 0, ii = charstrings.length; i < ii; i++) {
	        var charstring = charstrings[i];
	        if (charstring.seac) {
	          seacMap[i + 1] = charstring.seac;
	        }
	      }
	      return seacMap;
	    },
	    getType2Charstrings: function Type1Font_getType2Charstrings(type1Charstrings) {
	      var type2Charstrings = [];
	      for (var i = 0, ii = type1Charstrings.length; i < ii; i++) {
	        type2Charstrings.push(type1Charstrings[i].charstring);
	      }
	      return type2Charstrings;
	    },
	    getType2Subrs: function Type1Font_getType2Subrs(type1Subrs) {
	      var bias = 0;
	      var count = type1Subrs.length;
	      if (count < 1133) {
	        bias = 107;
	      } else if (count < 33769) {
	        bias = 1131;
	      } else {
	        bias = 32768;
	      }
	      var type2Subrs = [];
	      var i;
	      for (i = 0; i < bias; i++) {
	        type2Subrs.push([0x0B]);
	      }
	      for (i = 0; i < count; i++) {
	        type2Subrs.push(type1Subrs[i]);
	      }
	      return type2Subrs;
	    },
	    wrap: function Type1Font_wrap(name, glyphs, charstrings, subrs, properties) {
	      var cff = new _cff_parser.CFF();
	      cff.header = new _cff_parser.CFFHeader(1, 0, 4, 4);
	      cff.names = [name];
	      var topDict = new _cff_parser.CFFTopDict();
	      topDict.setByName('version', 391);
	      topDict.setByName('Notice', 392);
	      topDict.setByName('FullName', 393);
	      topDict.setByName('FamilyName', 394);
	      topDict.setByName('Weight', 395);
	      topDict.setByName('Encoding', null);
	      topDict.setByName('FontMatrix', properties.fontMatrix);
	      topDict.setByName('FontBBox', properties.bbox);
	      topDict.setByName('charset', null);
	      topDict.setByName('CharStrings', null);
	      topDict.setByName('Private', null);
	      cff.topDict = topDict;
	      var strings = new _cff_parser.CFFStrings();
	      strings.add('Version 0.11');
	      strings.add('See original notice');
	      strings.add(name);
	      strings.add(name);
	      strings.add('Medium');
	      cff.strings = strings;
	      cff.globalSubrIndex = new _cff_parser.CFFIndex();
	      var count = glyphs.length;
	      var charsetArray = [0];
	      var i, ii;
	      for (i = 0; i < count; i++) {
	        var index = _cff_parser.CFFStandardStrings.indexOf(charstrings[i].glyphName);
	        if (index === -1) {
	          index = 0;
	        }
	        charsetArray.push(index >> 8 & 0xff, index & 0xff);
	      }
	      cff.charset = new _cff_parser.CFFCharset(false, 0, [], charsetArray);
	      var charStringsIndex = new _cff_parser.CFFIndex();
	      charStringsIndex.add([0x8B, 0x0E]);
	      for (i = 0; i < count; i++) {
	        var glyph = glyphs[i];
	        if (glyph.length === 0) {
	          charStringsIndex.add([0x8B, 0x0E]);
	          continue;
	        }
	        charStringsIndex.add(glyph);
	      }
	      cff.charStrings = charStringsIndex;
	      var privateDict = new _cff_parser.CFFPrivateDict();
	      privateDict.setByName('Subrs', null);
	      var fields = ['BlueValues', 'OtherBlues', 'FamilyBlues', 'FamilyOtherBlues', 'StemSnapH', 'StemSnapV', 'BlueShift', 'BlueFuzz', 'BlueScale', 'LanguageGroup', 'ExpansionFactor', 'ForceBold', 'StdHW', 'StdVW'];
	      for (i = 0, ii = fields.length; i < ii; i++) {
	        var field = fields[i];
	        if (!(field in properties.privateData)) {
	          continue;
	        }
	        var value = properties.privateData[field];
	        if (Array.isArray(value)) {
	          for (var j = value.length - 1; j > 0; j--) {
	            value[j] -= value[j - 1];
	          }
	        }
	        privateDict.setByName(field, value);
	      }
	      cff.topDict.privateDict = privateDict;
	      var subrIndex = new _cff_parser.CFFIndex();
	      for (i = 0, ii = subrs.length; i < ii; i++) {
	        subrIndex.add(subrs[i]);
	      }
	      privateDict.subrsIndex = subrIndex;
	      var compiler = new _cff_parser.CFFCompiler(cff);
	      return compiler.compile();
	    }
	  };
	  return Type1Font;
	}();
	var CFFFont = function CFFFontClosure() {
	  function CFFFont(file, properties) {
	    this.properties = properties;
	    var parser = new _cff_parser.CFFParser(file, properties, SEAC_ANALYSIS_ENABLED);
	    this.cff = parser.parse();
	    var compiler = new _cff_parser.CFFCompiler(this.cff);
	    this.seacs = this.cff.seacs;
	    try {
	      this.data = compiler.compile();
	    } catch (e) {
	      (0, _util.warn)('Failed to compile font ' + properties.loadedName);
	      this.data = file;
	    }
	  }
	  CFFFont.prototype = {
	    get numGlyphs() {
	      return this.cff.charStrings.count;
	    },
	    getCharset: function CFFFont_getCharset() {
	      return this.cff.charset.charset;
	    },
	    getGlyphMapping: function CFFFont_getGlyphMapping() {
	      var cff = this.cff;
	      var properties = this.properties;
	      var charsets = cff.charset.charset;
	      var charCodeToGlyphId;
	      var glyphId;
	      if (properties.composite) {
	        charCodeToGlyphId = Object.create(null);
	        if (cff.isCIDFont) {
	          for (glyphId = 0; glyphId < charsets.length; glyphId++) {
	            var cid = charsets[glyphId];
	            var charCode = properties.cMap.charCodeOf(cid);
	            charCodeToGlyphId[charCode] = glyphId;
	          }
	        } else {
	          for (glyphId = 0; glyphId < cff.charStrings.count; glyphId++) {
	            charCodeToGlyphId[glyphId] = glyphId;
	          }
	        }
	        return charCodeToGlyphId;
	      }
	      var encoding = cff.encoding ? cff.encoding.encoding : null;
	      charCodeToGlyphId = type1FontGlyphMapping(properties, encoding, charsets);
	      return charCodeToGlyphId;
	    }
	  };
	  return CFFFont;
	}();
	(function checkSeacSupport() {
	  if (typeof navigator !== 'undefined' && /Windows/.test(navigator.userAgent)) {
	    exports.SEAC_ANALYSIS_ENABLED = SEAC_ANALYSIS_ENABLED = true;
	  }
	})();
	(function checkChromeWindows() {
	  if (typeof navigator !== 'undefined' && /Windows.*Chrome/.test(navigator.userAgent)) {
	    SKIP_PRIVATE_USE_RANGE_F000_TO_F01F = true;
	  }
	})();
	exports.SEAC_ANALYSIS_ENABLED = SEAC_ANALYSIS_ENABLED;
	exports.PRIVATE_USE_OFFSET_START = PRIVATE_USE_OFFSET_START;
	exports.PRIVATE_USE_OFFSET_END = PRIVATE_USE_OFFSET_END;
	exports.ErrorFont = ErrorFont;
	exports.Font = Font;
	exports.FontFlags = FontFlags;
	exports.ToUnicodeMap = ToUnicodeMap;
	exports.IdentityToUnicodeMap = IdentityToUnicodeMap;
	exports.ProblematicCharRanges = ProblematicCharRanges;
	exports.getFontType = getFontType;
	
	/***/ }),
	/* 150 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ISOAdobeCharset = ['.notdef', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'endash', 'dagger', 'daggerdbl', 'periodcentered', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand', 'questiondown', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'emdash', 'AE', 'ordfeminine', 'Lslash', 'Oslash', 'OE', 'ordmasculine', 'ae', 'dotlessi', 'lslash', 'oslash', 'oe', 'germandbls', 'onesuperior', 'logicalnot', 'mu', 'trademark', 'Eth', 'onehalf', 'plusminus', 'Thorn', 'onequarter', 'divide', 'brokenbar', 'degree', 'thorn', 'threequarters', 'twosuperior', 'registered', 'minus', 'eth', 'multiply', 'threesuperior', 'copyright', 'Aacute', 'Acircumflex', 'Adieresis', 'Agrave', 'Aring', 'Atilde', 'Ccedilla', 'Eacute', 'Ecircumflex', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Ntilde', 'Oacute', 'Ocircumflex', 'Odieresis', 'Ograve', 'Otilde', 'Scaron', 'Uacute', 'Ucircumflex', 'Udieresis', 'Ugrave', 'Yacute', 'Ydieresis', 'Zcaron', 'aacute', 'acircumflex', 'adieresis', 'agrave', 'aring', 'atilde', 'ccedilla', 'eacute', 'ecircumflex', 'edieresis', 'egrave', 'iacute', 'icircumflex', 'idieresis', 'igrave', 'ntilde', 'oacute', 'ocircumflex', 'odieresis', 'ograve', 'otilde', 'scaron', 'uacute', 'ucircumflex', 'udieresis', 'ugrave', 'yacute', 'ydieresis', 'zcaron'];
	var ExpertCharset = ['.notdef', 'space', 'exclamsmall', 'Hungarumlautsmall', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', 'exclamdownsmall', 'centoldstyle', 'Lslashsmall', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall', 'Dotaccentsmall', 'Macronsmall', 'figuredash', 'hypheninferior', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', 'onequarter', 'onehalf', 'threequarters', 'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];
	var ExpertSubsetCharset = ['.notdef', 'space', 'dollaroldstyle', 'dollarsuperior', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', 'parenrightinferior', 'hyphensuperior', 'colonmonetary', 'onefitted', 'rupiah', 'centoldstyle', 'figuredash', 'hypheninferior', 'onequarter', 'onehalf', 'threequarters', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior'];
	exports.ISOAdobeCharset = ISOAdobeCharset;
	exports.ExpertCharset = ExpertCharset;
	exports.ExpertSubsetCharset = ExpertSubsetCharset;
	
	/***/ }),
	/* 151 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontRendererFactory = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _cff_parser = __w_pdfjs_require__(84);
	
	var _glyphlist = __w_pdfjs_require__(49);
	
	var _encodings = __w_pdfjs_require__(30);
	
	var _stream = __w_pdfjs_require__(5);
	
	var FontRendererFactory = function FontRendererFactoryClosure() {
	  function getLong(data, offset) {
	    return data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3];
	  }
	  function getUshort(data, offset) {
	    return data[offset] << 8 | data[offset + 1];
	  }
	  function parseCmap(data, start, end) {
	    var offset = getUshort(data, start + 2) === 1 ? getLong(data, start + 8) : getLong(data, start + 16);
	    var format = getUshort(data, start + offset);
	    var ranges, p, i;
	    if (format === 4) {
	      getUshort(data, start + offset + 2);
	      var segCount = getUshort(data, start + offset + 6) >> 1;
	      p = start + offset + 14;
	      ranges = [];
	      for (i = 0; i < segCount; i++, p += 2) {
	        ranges[i] = { end: getUshort(data, p) };
	      }
	      p += 2;
	      for (i = 0; i < segCount; i++, p += 2) {
	        ranges[i].start = getUshort(data, p);
	      }
	      for (i = 0; i < segCount; i++, p += 2) {
	        ranges[i].idDelta = getUshort(data, p);
	      }
	      for (i = 0; i < segCount; i++, p += 2) {
	        var idOffset = getUshort(data, p);
	        if (idOffset === 0) {
	          continue;
	        }
	        ranges[i].ids = [];
	        for (var j = 0, jj = ranges[i].end - ranges[i].start + 1; j < jj; j++) {
	          ranges[i].ids[j] = getUshort(data, p + idOffset);
	          idOffset += 2;
	        }
	      }
	      return ranges;
	    } else if (format === 12) {
	      getLong(data, start + offset + 4);
	      var groups = getLong(data, start + offset + 12);
	      p = start + offset + 16;
	      ranges = [];
	      for (i = 0; i < groups; i++) {
	        ranges.push({
	          start: getLong(data, p),
	          end: getLong(data, p + 4),
	          idDelta: getLong(data, p + 8) - getLong(data, p)
	        });
	        p += 12;
	      }
	      return ranges;
	    }
	    throw new _util.FormatError('unsupported cmap: ' + format);
	  }
	  function parseCff(data, start, end, seacAnalysisEnabled) {
	    var properties = {};
	    var parser = new _cff_parser.CFFParser(new _stream.Stream(data, start, end - start), properties, seacAnalysisEnabled);
	    var cff = parser.parse();
	    return {
	      glyphs: cff.charStrings.objects,
	      subrs: cff.topDict.privateDict && cff.topDict.privateDict.subrsIndex && cff.topDict.privateDict.subrsIndex.objects,
	      gsubrs: cff.globalSubrIndex && cff.globalSubrIndex.objects
	    };
	  }
	  function parseGlyfTable(glyf, loca, isGlyphLocationsLong) {
	    var itemSize, itemDecode;
	    if (isGlyphLocationsLong) {
	      itemSize = 4;
	      itemDecode = function fontItemDecodeLong(data, offset) {
	        return data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3];
	      };
	    } else {
	      itemSize = 2;
	      itemDecode = function fontItemDecode(data, offset) {
	        return data[offset] << 9 | data[offset + 1] << 1;
	      };
	    }
	    var glyphs = [];
	    var startOffset = itemDecode(loca, 0);
	    for (var j = itemSize; j < loca.length; j += itemSize) {
	      var endOffset = itemDecode(loca, j);
	      glyphs.push(glyf.subarray(startOffset, endOffset));
	      startOffset = endOffset;
	    }
	    return glyphs;
	  }
	  function lookupCmap(ranges, unicode) {
	    var code = unicode.charCodeAt(0),
	        gid = 0;
	    var l = 0,
	        r = ranges.length - 1;
	    while (l < r) {
	      var c = l + r + 1 >> 1;
	      if (code < ranges[c].start) {
	        r = c - 1;
	      } else {
	        l = c;
	      }
	    }
	    if (ranges[l].start <= code && code <= ranges[l].end) {
	      gid = ranges[l].idDelta + (ranges[l].ids ? ranges[l].ids[code - ranges[l].start] : code) & 0xFFFF;
	    }
	    return {
	      charCode: code,
	      glyphId: gid
	    };
	  }
	  function compileGlyf(code, cmds, font) {
	    function moveTo(x, y) {
	      cmds.push({
	        cmd: 'moveTo',
	        args: [x, y]
	      });
	    }
	    function lineTo(x, y) {
	      cmds.push({
	        cmd: 'lineTo',
	        args: [x, y]
	      });
	    }
	    function quadraticCurveTo(xa, ya, x, y) {
	      cmds.push({
	        cmd: 'quadraticCurveTo',
	        args: [xa, ya, x, y]
	      });
	    }
	    var i = 0;
	    var numberOfContours = (code[i] << 24 | code[i + 1] << 16) >> 16;
	    var flags;
	    var x = 0,
	        y = 0;
	    i += 10;
	    if (numberOfContours < 0) {
	      do {
	        flags = code[i] << 8 | code[i + 1];
	        var glyphIndex = code[i + 2] << 8 | code[i + 3];
	        i += 4;
	        var arg1, arg2;
	        if (flags & 0x01) {
	          arg1 = (code[i] << 24 | code[i + 1] << 16) >> 16;
	          arg2 = (code[i + 2] << 24 | code[i + 3] << 16) >> 16;
	          i += 4;
	        } else {
	          arg1 = code[i++];
	          arg2 = code[i++];
	        }
	        if (flags & 0x02) {
	          x = arg1;
	          y = arg2;
	        } else {
	          x = 0;
	          y = 0;
	        }
	        var scaleX = 1,
	            scaleY = 1,
	            scale01 = 0,
	            scale10 = 0;
	        if (flags & 0x08) {
	          scaleX = scaleY = (code[i] << 24 | code[i + 1] << 16) / 1073741824;
	          i += 2;
	        } else if (flags & 0x40) {
	          scaleX = (code[i] << 24 | code[i + 1] << 16) / 1073741824;
	          scaleY = (code[i + 2] << 24 | code[i + 3] << 16) / 1073741824;
	          i += 4;
	        } else if (flags & 0x80) {
	          scaleX = (code[i] << 24 | code[i + 1] << 16) / 1073741824;
	          scale01 = (code[i + 2] << 24 | code[i + 3] << 16) / 1073741824;
	          scale10 = (code[i + 4] << 24 | code[i + 5] << 16) / 1073741824;
	          scaleY = (code[i + 6] << 24 | code[i + 7] << 16) / 1073741824;
	          i += 8;
	        }
	        var subglyph = font.glyphs[glyphIndex];
	        if (subglyph) {
	          cmds.push({ cmd: 'save' });
	          cmds.push({
	            cmd: 'transform',
	            args: [scaleX, scale01, scale10, scaleY, x, y]
	          });
	          compileGlyf(subglyph, cmds, font);
	          cmds.push({ cmd: 'restore' });
	        }
	      } while (flags & 0x20);
	    } else {
	      var endPtsOfContours = [];
	      var j, jj;
	      for (j = 0; j < numberOfContours; j++) {
	        endPtsOfContours.push(code[i] << 8 | code[i + 1]);
	        i += 2;
	      }
	      var instructionLength = code[i] << 8 | code[i + 1];
	      i += 2 + instructionLength;
	      var numberOfPoints = endPtsOfContours[endPtsOfContours.length - 1] + 1;
	      var points = [];
	      while (points.length < numberOfPoints) {
	        flags = code[i++];
	        var repeat = 1;
	        if (flags & 0x08) {
	          repeat += code[i++];
	        }
	        while (repeat-- > 0) {
	          points.push({ flags: flags });
	        }
	      }
	      for (j = 0; j < numberOfPoints; j++) {
	        switch (points[j].flags & 0x12) {
	          case 0x00:
	            x += (code[i] << 24 | code[i + 1] << 16) >> 16;
	            i += 2;
	            break;
	          case 0x02:
	            x -= code[i++];
	            break;
	          case 0x12:
	            x += code[i++];
	            break;
	        }
	        points[j].x = x;
	      }
	      for (j = 0; j < numberOfPoints; j++) {
	        switch (points[j].flags & 0x24) {
	          case 0x00:
	            y += (code[i] << 24 | code[i + 1] << 16) >> 16;
	            i += 2;
	            break;
	          case 0x04:
	            y -= code[i++];
	            break;
	          case 0x24:
	            y += code[i++];
	            break;
	        }
	        points[j].y = y;
	      }
	      var startPoint = 0;
	      for (i = 0; i < numberOfContours; i++) {
	        var endPoint = endPtsOfContours[i];
	        var contour = points.slice(startPoint, endPoint + 1);
	        if (contour[0].flags & 1) {
	          contour.push(contour[0]);
	        } else if (contour[contour.length - 1].flags & 1) {
	          contour.unshift(contour[contour.length - 1]);
	        } else {
	          var p = {
	            flags: 1,
	            x: (contour[0].x + contour[contour.length - 1].x) / 2,
	            y: (contour[0].y + contour[contour.length - 1].y) / 2
	          };
	          contour.unshift(p);
	          contour.push(p);
	        }
	        moveTo(contour[0].x, contour[0].y);
	        for (j = 1, jj = contour.length; j < jj; j++) {
	          if (contour[j].flags & 1) {
	            lineTo(contour[j].x, contour[j].y);
	          } else if (contour[j + 1].flags & 1) {
	            quadraticCurveTo(contour[j].x, contour[j].y, contour[j + 1].x, contour[j + 1].y);
	            j++;
	          } else {
	            quadraticCurveTo(contour[j].x, contour[j].y, (contour[j].x + contour[j + 1].x) / 2, (contour[j].y + contour[j + 1].y) / 2);
	          }
	        }
	        startPoint = endPoint + 1;
	      }
	    }
	  }
	  function compileCharString(code, cmds, font) {
	    var stack = [];
	    var x = 0,
	        y = 0;
	    var stems = 0;
	    function moveTo(x, y) {
	      cmds.push({
	        cmd: 'moveTo',
	        args: [x, y]
	      });
	    }
	    function lineTo(x, y) {
	      cmds.push({
	        cmd: 'lineTo',
	        args: [x, y]
	      });
	    }
	    function bezierCurveTo(x1, y1, x2, y2, x, y) {
	      cmds.push({
	        cmd: 'bezierCurveTo',
	        args: [x1, y1, x2, y2, x, y]
	      });
	    }
	    function parse(code) {
	      var i = 0;
	      while (i < code.length) {
	        var stackClean = false;
	        var v = code[i++];
	        var xa, xb, ya, yb, y1, y2, y3, n, subrCode;
	        switch (v) {
	          case 1:
	            stems += stack.length >> 1;
	            stackClean = true;
	            break;
	          case 3:
	            stems += stack.length >> 1;
	            stackClean = true;
	            break;
	          case 4:
	            y += stack.pop();
	            moveTo(x, y);
	            stackClean = true;
	            break;
	          case 5:
	            while (stack.length > 0) {
	              x += stack.shift();
	              y += stack.shift();
	              lineTo(x, y);
	            }
	            break;
	          case 6:
	            while (stack.length > 0) {
	              x += stack.shift();
	              lineTo(x, y);
	              if (stack.length === 0) {
	                break;
	              }
	              y += stack.shift();
	              lineTo(x, y);
	            }
	            break;
	          case 7:
	            while (stack.length > 0) {
	              y += stack.shift();
	              lineTo(x, y);
	              if (stack.length === 0) {
	                break;
	              }
	              x += stack.shift();
	              lineTo(x, y);
	            }
	            break;
	          case 8:
	            while (stack.length > 0) {
	              xa = x + stack.shift();
	              ya = y + stack.shift();
	              xb = xa + stack.shift();
	              yb = ya + stack.shift();
	              x = xb + stack.shift();
	              y = yb + stack.shift();
	              bezierCurveTo(xa, ya, xb, yb, x, y);
	            }
	            break;
	          case 10:
	            n = stack.pop() + font.subrsBias;
	            subrCode = font.subrs[n];
	            if (subrCode) {
	              parse(subrCode);
	            }
	            break;
	          case 11:
	            return;
	          case 12:
	            v = code[i++];
	            switch (v) {
	              case 34:
	                xa = x + stack.shift();
	                xb = xa + stack.shift();
	                y1 = y + stack.shift();
	                x = xb + stack.shift();
	                bezierCurveTo(xa, y, xb, y1, x, y1);
	                xa = x + stack.shift();
	                xb = xa + stack.shift();
	                x = xb + stack.shift();
	                bezierCurveTo(xa, y1, xb, y, x, y);
	                break;
	              case 35:
	                xa = x + stack.shift();
	                ya = y + stack.shift();
	                xb = xa + stack.shift();
	                yb = ya + stack.shift();
	                x = xb + stack.shift();
	                y = yb + stack.shift();
	                bezierCurveTo(xa, ya, xb, yb, x, y);
	                xa = x + stack.shift();
	                ya = y + stack.shift();
	                xb = xa + stack.shift();
	                yb = ya + stack.shift();
	                x = xb + stack.shift();
	                y = yb + stack.shift();
	                bezierCurveTo(xa, ya, xb, yb, x, y);
	                stack.pop();
	                break;
	              case 36:
	                xa = x + stack.shift();
	                y1 = y + stack.shift();
	                xb = xa + stack.shift();
	                y2 = y1 + stack.shift();
	                x = xb + stack.shift();
	                bezierCurveTo(xa, y1, xb, y2, x, y2);
	                xa = x + stack.shift();
	                xb = xa + stack.shift();
	                y3 = y2 + stack.shift();
	                x = xb + stack.shift();
	                bezierCurveTo(xa, y2, xb, y3, x, y);
	                break;
	              case 37:
	                var x0 = x,
	                    y0 = y;
	                xa = x + stack.shift();
	                ya = y + stack.shift();
	                xb = xa + stack.shift();
	                yb = ya + stack.shift();
	                x = xb + stack.shift();
	                y = yb + stack.shift();
	                bezierCurveTo(xa, ya, xb, yb, x, y);
	                xa = x + stack.shift();
	                ya = y + stack.shift();
	                xb = xa + stack.shift();
	                yb = ya + stack.shift();
	                x = xb;
	                y = yb;
	                if (Math.abs(x - x0) > Math.abs(y - y0)) {
	                  x += stack.shift();
	                } else {
	                  y += stack.shift();
	                }
	                bezierCurveTo(xa, ya, xb, yb, x, y);
	                break;
	              default:
	                throw new _util.FormatError('unknown operator: 12 ' + v);
	            }
	            break;
	          case 14:
	            if (stack.length >= 4) {
	              var achar = stack.pop();
	              var bchar = stack.pop();
	              y = stack.pop();
	              x = stack.pop();
	              cmds.push({ cmd: 'save' });
	              cmds.push({
	                cmd: 'translate',
	                args: [x, y]
	              });
	              var cmap = lookupCmap(font.cmap, String.fromCharCode(font.glyphNameMap[_encodings.StandardEncoding[achar]]));
	              compileCharString(font.glyphs[cmap.glyphId], cmds, font);
	              cmds.push({ cmd: 'restore' });
	              cmap = lookupCmap(font.cmap, String.fromCharCode(font.glyphNameMap[_encodings.StandardEncoding[bchar]]));
	              compileCharString(font.glyphs[cmap.glyphId], cmds, font);
	            }
	            return;
	          case 18:
	            stems += stack.length >> 1;
	            stackClean = true;
	            break;
	          case 19:
	            stems += stack.length >> 1;
	            i += stems + 7 >> 3;
	            stackClean = true;
	            break;
	          case 20:
	            stems += stack.length >> 1;
	            i += stems + 7 >> 3;
	            stackClean = true;
	            break;
	          case 21:
	            y += stack.pop();
	            x += stack.pop();
	            moveTo(x, y);
	            stackClean = true;
	            break;
	          case 22:
	            x += stack.pop();
	            moveTo(x, y);
	            stackClean = true;
	            break;
	          case 23:
	            stems += stack.length >> 1;
	            stackClean = true;
	            break;
	          case 24:
	            while (stack.length > 2) {
	              xa = x + stack.shift();
	              ya = y + stack.shift();
	              xb = xa + stack.shift();
	              yb = ya + stack.shift();
	              x = xb + stack.shift();
	              y = yb + stack.shift();
	              bezierCurveTo(xa, ya, xb, yb, x, y);
	            }
	            x += stack.shift();
	            y += stack.shift();
	            lineTo(x, y);
	            break;
	          case 25:
	            while (stack.length > 6) {
	              x += stack.shift();
	              y += stack.shift();
	              lineTo(x, y);
	            }
	            xa = x + stack.shift();
	            ya = y + stack.shift();
	            xb = xa + stack.shift();
	            yb = ya + stack.shift();
	            x = xb + stack.shift();
	            y = yb + stack.shift();
	            bezierCurveTo(xa, ya, xb, yb, x, y);
	            break;
	          case 26:
	            if (stack.length % 2) {
	              x += stack.shift();
	            }
	            while (stack.length > 0) {
	              xa = x;
	              ya = y + stack.shift();
	              xb = xa + stack.shift();
	              yb = ya + stack.shift();
	              x = xb;
	              y = yb + stack.shift();
	              bezierCurveTo(xa, ya, xb, yb, x, y);
	            }
	            break;
	          case 27:
	            if (stack.length % 2) {
	              y += stack.shift();
	            }
	            while (stack.length > 0) {
	              xa = x + stack.shift();
	              ya = y;
	              xb = xa + stack.shift();
	              yb = ya + stack.shift();
	              x = xb + stack.shift();
	              y = yb;
	              bezierCurveTo(xa, ya, xb, yb, x, y);
	            }
	            break;
	          case 28:
	            stack.push((code[i] << 24 | code[i + 1] << 16) >> 16);
	            i += 2;
	            break;
	          case 29:
	            n = stack.pop() + font.gsubrsBias;
	            subrCode = font.gsubrs[n];
	            if (subrCode) {
	              parse(subrCode);
	            }
	            break;
	          case 30:
	            while (stack.length > 0) {
	              xa = x;
	              ya = y + stack.shift();
	              xb = xa + stack.shift();
	              yb = ya + stack.shift();
	              x = xb + stack.shift();
	              y = yb + (stack.length === 1 ? stack.shift() : 0);
	              bezierCurveTo(xa, ya, xb, yb, x, y);
	              if (stack.length === 0) {
	                break;
	              }
	              xa = x + stack.shift();
	              ya = y;
	              xb = xa + stack.shift();
	              yb = ya + stack.shift();
	              y = yb + stack.shift();
	              x = xb + (stack.length === 1 ? stack.shift() : 0);
	              bezierCurveTo(xa, ya, xb, yb, x, y);
	            }
	            break;
	          case 31:
	            while (stack.length > 0) {
	              xa = x + stack.shift();
	              ya = y;
	              xb = xa + stack.shift();
	              yb = ya + stack.shift();
	              y = yb + stack.shift();
	              x = xb + (stack.length === 1 ? stack.shift() : 0);
	              bezierCurveTo(xa, ya, xb, yb, x, y);
	              if (stack.length === 0) {
	                break;
	              }
	              xa = x;
	              ya = y + stack.shift();
	              xb = xa + stack.shift();
	              yb = ya + stack.shift();
	              x = xb + stack.shift();
	              y = yb + (stack.length === 1 ? stack.shift() : 0);
	              bezierCurveTo(xa, ya, xb, yb, x, y);
	            }
	            break;
	          default:
	            if (v < 32) {
	              throw new _util.FormatError('unknown operator: ' + v);
	            }
	            if (v < 247) {
	              stack.push(v - 139);
	            } else if (v < 251) {
	              stack.push((v - 247) * 256 + code[i++] + 108);
	            } else if (v < 255) {
	              stack.push(-(v - 251) * 256 - code[i++] - 108);
	            } else {
	              stack.push((code[i] << 24 | code[i + 1] << 16 | code[i + 2] << 8 | code[i + 3]) / 65536);
	              i += 4;
	            }
	            break;
	        }
	        if (stackClean) {
	          stack.length = 0;
	        }
	      }
	    }
	    parse(code);
	  }
	  var noop = '';
	  function CompiledFont(fontMatrix) {
	    this.compiledGlyphs = Object.create(null);
	    this.compiledCharCodeToGlyphId = Object.create(null);
	    this.fontMatrix = fontMatrix;
	  }
	  CompiledFont.prototype = {
	    getPathJs: function getPathJs(unicode) {
	      var cmap = lookupCmap(this.cmap, unicode);
	      var fn = this.compiledGlyphs[cmap.glyphId];
	      if (!fn) {
	        fn = this.compileGlyph(this.glyphs[cmap.glyphId]);
	        this.compiledGlyphs[cmap.glyphId] = fn;
	      }
	      if (this.compiledCharCodeToGlyphId[cmap.charCode] === undefined) {
	        this.compiledCharCodeToGlyphId[cmap.charCode] = cmap.glyphId;
	      }
	      return fn;
	    },
	    compileGlyph: function compileGlyph(code) {
	      if (!code || code.length === 0 || code[0] === 14) {
	        return noop;
	      }
	      var cmds = [];
	      cmds.push({ cmd: 'save' });
	      cmds.push({
	        cmd: 'transform',
	        args: this.fontMatrix.slice()
	      });
	      cmds.push({
	        cmd: 'scale',
	        args: ['size', '-size']
	      });
	      this.compileGlyphImpl(code, cmds);
	      cmds.push({ cmd: 'restore' });
	      return cmds;
	    },
	    compileGlyphImpl: function compileGlyphImpl() {
	      throw new Error('Children classes should implement this.');
	    },
	    hasBuiltPath: function hasBuiltPath(unicode) {
	      var cmap = lookupCmap(this.cmap, unicode);
	      return this.compiledGlyphs[cmap.glyphId] !== undefined && this.compiledCharCodeToGlyphId[cmap.charCode] !== undefined;
	    }
	  };
	  function TrueTypeCompiled(glyphs, cmap, fontMatrix) {
	    fontMatrix = fontMatrix || [0.000488, 0, 0, 0.000488, 0, 0];
	    CompiledFont.call(this, fontMatrix);
	    this.glyphs = glyphs;
	    this.cmap = cmap;
	  }
	  _util.Util.inherit(TrueTypeCompiled, CompiledFont, {
	    compileGlyphImpl: function compileGlyphImpl(code, cmds) {
	      compileGlyf(code, cmds, this);
	    }
	  });
	  function Type2Compiled(cffInfo, cmap, fontMatrix, glyphNameMap) {
	    fontMatrix = fontMatrix || [0.001, 0, 0, 0.001, 0, 0];
	    CompiledFont.call(this, fontMatrix);
	    this.glyphs = cffInfo.glyphs;
	    this.gsubrs = cffInfo.gsubrs || [];
	    this.subrs = cffInfo.subrs || [];
	    this.cmap = cmap;
	    this.glyphNameMap = glyphNameMap || (0, _glyphlist.getGlyphsUnicode)();
	    this.gsubrsBias = this.gsubrs.length < 1240 ? 107 : this.gsubrs.length < 33900 ? 1131 : 32768;
	    this.subrsBias = this.subrs.length < 1240 ? 107 : this.subrs.length < 33900 ? 1131 : 32768;
	  }
	  _util.Util.inherit(Type2Compiled, CompiledFont, {
	    compileGlyphImpl: function compileGlyphImpl(code, cmds) {
	      compileCharString(code, cmds, this);
	    }
	  });
	  return {
	    create: function FontRendererFactory_create(font, seacAnalysisEnabled) {
	      var data = new Uint8Array(font.data);
	      var cmap, glyf, loca, cff, indexToLocFormat, unitsPerEm;
	      var numTables = getUshort(data, 4);
	      for (var i = 0, p = 12; i < numTables; i++, p += 16) {
	        var tag = (0, _util.bytesToString)(data.subarray(p, p + 4));
	        var offset = getLong(data, p + 8);
	        var length = getLong(data, p + 12);
	        switch (tag) {
	          case 'cmap':
	            cmap = parseCmap(data, offset, offset + length);
	            break;
	          case 'glyf':
	            glyf = data.subarray(offset, offset + length);
	            break;
	          case 'loca':
	            loca = data.subarray(offset, offset + length);
	            break;
	          case 'head':
	            unitsPerEm = getUshort(data, offset + 18);
	            indexToLocFormat = getUshort(data, offset + 50);
	            break;
	          case 'CFF ':
	            cff = parseCff(data, offset, offset + length, seacAnalysisEnabled);
	            break;
	        }
	      }
	      if (glyf) {
	        var fontMatrix = !unitsPerEm ? font.fontMatrix : [1 / unitsPerEm, 0, 0, 1 / unitsPerEm, 0, 0];
	        return new TrueTypeCompiled(parseGlyfTable(glyf, loca, indexToLocFormat), cmap, fontMatrix);
	      }
	      return new Type2Compiled(cff, cmap, font.fontMatrix, font.glyphNameMap);
	    }
	  };
	}();
	exports.FontRendererFactory = FontRendererFactory;
	
	/***/ }),
	/* 152 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Type1Parser = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _encodings = __w_pdfjs_require__(30);
	
	var _stream = __w_pdfjs_require__(5);
	
	var HINTING_ENABLED = false;
	var Type1CharString = function Type1CharStringClosure() {
	  var COMMAND_MAP = {
	    'hstem': [1],
	    'vstem': [3],
	    'vmoveto': [4],
	    'rlineto': [5],
	    'hlineto': [6],
	    'vlineto': [7],
	    'rrcurveto': [8],
	    'callsubr': [10],
	    'flex': [12, 35],
	    'drop': [12, 18],
	    'endchar': [14],
	    'rmoveto': [21],
	    'hmoveto': [22],
	    'vhcurveto': [30],
	    'hvcurveto': [31]
	  };
	  function Type1CharString() {
	    this.width = 0;
	    this.lsb = 0;
	    this.flexing = false;
	    this.output = [];
	    this.stack = [];
	  }
	  Type1CharString.prototype = {
	    convert: function Type1CharString_convert(encoded, subrs, seacAnalysisEnabled) {
	      var count = encoded.length;
	      var error = false;
	      var wx, sbx, subrNumber;
	      for (var i = 0; i < count; i++) {
	        var value = encoded[i];
	        if (value < 32) {
	          if (value === 12) {
	            value = (value << 8) + encoded[++i];
	          }
	          switch (value) {
	            case 1:
	              if (!HINTING_ENABLED) {
	                this.stack = [];
	                break;
	              }
	              error = this.executeCommand(2, COMMAND_MAP.hstem);
	              break;
	            case 3:
	              if (!HINTING_ENABLED) {
	                this.stack = [];
	                break;
	              }
	              error = this.executeCommand(2, COMMAND_MAP.vstem);
	              break;
	            case 4:
	              if (this.flexing) {
	                if (this.stack.length < 1) {
	                  error = true;
	                  break;
	                }
	                var dy = this.stack.pop();
	                this.stack.push(0, dy);
	                break;
	              }
	              error = this.executeCommand(1, COMMAND_MAP.vmoveto);
	              break;
	            case 5:
	              error = this.executeCommand(2, COMMAND_MAP.rlineto);
	              break;
	            case 6:
	              error = this.executeCommand(1, COMMAND_MAP.hlineto);
	              break;
	            case 7:
	              error = this.executeCommand(1, COMMAND_MAP.vlineto);
	              break;
	            case 8:
	              error = this.executeCommand(6, COMMAND_MAP.rrcurveto);
	              break;
	            case 9:
	              this.stack = [];
	              break;
	            case 10:
	              if (this.stack.length < 1) {
	                error = true;
	                break;
	              }
	              subrNumber = this.stack.pop();
	              if (!subrs[subrNumber]) {
	                error = true;
	                break;
	              }
	              error = this.convert(subrs[subrNumber], subrs, seacAnalysisEnabled);
	              break;
	            case 11:
	              return error;
	            case 13:
	              if (this.stack.length < 2) {
	                error = true;
	                break;
	              }
	              wx = this.stack.pop();
	              sbx = this.stack.pop();
	              this.lsb = sbx;
	              this.width = wx;
	              this.stack.push(wx, sbx);
	              error = this.executeCommand(2, COMMAND_MAP.hmoveto);
	              break;
	            case 14:
	              this.output.push(COMMAND_MAP.endchar[0]);
	              break;
	            case 21:
	              if (this.flexing) {
	                break;
	              }
	              error = this.executeCommand(2, COMMAND_MAP.rmoveto);
	              break;
	            case 22:
	              if (this.flexing) {
	                this.stack.push(0);
	                break;
	              }
	              error = this.executeCommand(1, COMMAND_MAP.hmoveto);
	              break;
	            case 30:
	              error = this.executeCommand(4, COMMAND_MAP.vhcurveto);
	              break;
	            case 31:
	              error = this.executeCommand(4, COMMAND_MAP.hvcurveto);
	              break;
	            case (12 << 8) + 0:
	              this.stack = [];
	              break;
	            case (12 << 8) + 1:
	              if (!HINTING_ENABLED) {
	                this.stack = [];
	                break;
	              }
	              error = this.executeCommand(2, COMMAND_MAP.vstem);
	              break;
	            case (12 << 8) + 2:
	              if (!HINTING_ENABLED) {
	                this.stack = [];
	                break;
	              }
	              error = this.executeCommand(2, COMMAND_MAP.hstem);
	              break;
	            case (12 << 8) + 6:
	              if (seacAnalysisEnabled) {
	                this.seac = this.stack.splice(-4, 4);
	                error = this.executeCommand(0, COMMAND_MAP.endchar);
	              } else {
	                error = this.executeCommand(4, COMMAND_MAP.endchar);
	              }
	              break;
	            case (12 << 8) + 7:
	              if (this.stack.length < 4) {
	                error = true;
	                break;
	              }
	              this.stack.pop();
	              wx = this.stack.pop();
	              var sby = this.stack.pop();
	              sbx = this.stack.pop();
	              this.lsb = sbx;
	              this.width = wx;
	              this.stack.push(wx, sbx, sby);
	              error = this.executeCommand(3, COMMAND_MAP.rmoveto);
	              break;
	            case (12 << 8) + 12:
	              if (this.stack.length < 2) {
	                error = true;
	                break;
	              }
	              var num2 = this.stack.pop();
	              var num1 = this.stack.pop();
	              this.stack.push(num1 / num2);
	              break;
	            case (12 << 8) + 16:
	              if (this.stack.length < 2) {
	                error = true;
	                break;
	              }
	              subrNumber = this.stack.pop();
	              var numArgs = this.stack.pop();
	              if (subrNumber === 0 && numArgs === 3) {
	                var flexArgs = this.stack.splice(this.stack.length - 17, 17);
	                this.stack.push(flexArgs[2] + flexArgs[0], flexArgs[3] + flexArgs[1], flexArgs[4], flexArgs[5], flexArgs[6], flexArgs[7], flexArgs[8], flexArgs[9], flexArgs[10], flexArgs[11], flexArgs[12], flexArgs[13], flexArgs[14]);
	                error = this.executeCommand(13, COMMAND_MAP.flex, true);
	                this.flexing = false;
	                this.stack.push(flexArgs[15], flexArgs[16]);
	              } else if (subrNumber === 1 && numArgs === 0) {
	                this.flexing = true;
	              }
	              break;
	            case (12 << 8) + 17:
	              break;
	            case (12 << 8) + 33:
	              this.stack = [];
	              break;
	            default:
	              (0, _util.warn)('Unknown type 1 charstring command of "' + value + '"');
	              break;
	          }
	          if (error) {
	            break;
	          }
	          continue;
	        } else if (value <= 246) {
	          value = value - 139;
	        } else if (value <= 250) {
	          value = (value - 247) * 256 + encoded[++i] + 108;
	        } else if (value <= 254) {
	          value = -((value - 251) * 256) - encoded[++i] - 108;
	        } else {
	          value = (encoded[++i] & 0xff) << 24 | (encoded[++i] & 0xff) << 16 | (encoded[++i] & 0xff) << 8 | (encoded[++i] & 0xff) << 0;
	        }
	        this.stack.push(value);
	      }
	      return error;
	    },
	    executeCommand: function executeCommand(howManyArgs, command, keepStack) {
	      var stackLength = this.stack.length;
	      if (howManyArgs > stackLength) {
	        return true;
	      }
	      var start = stackLength - howManyArgs;
	      for (var i = start; i < stackLength; i++) {
	        var value = this.stack[i];
	        if (Number.isInteger(value)) {
	          this.output.push(28, value >> 8 & 0xff, value & 0xff);
	        } else {
	          value = 65536 * value | 0;
	          this.output.push(255, value >> 24 & 0xFF, value >> 16 & 0xFF, value >> 8 & 0xFF, value & 0xFF);
	        }
	      }
	      this.output.push.apply(this.output, command);
	      if (keepStack) {
	        this.stack.splice(start, howManyArgs);
	      } else {
	        this.stack.length = 0;
	      }
	      return false;
	    }
	  };
	  return Type1CharString;
	}();
	var Type1Parser = function Type1ParserClosure() {
	  var EEXEC_ENCRYPT_KEY = 55665;
	  var CHAR_STRS_ENCRYPT_KEY = 4330;
	  function isHexDigit(code) {
	    return code >= 48 && code <= 57 || code >= 65 && code <= 70 || code >= 97 && code <= 102;
	  }
	  function decrypt(data, key, discardNumber) {
	    if (discardNumber >= data.length) {
	      return new Uint8Array(0);
	    }
	    var r = key | 0,
	        c1 = 52845,
	        c2 = 22719,
	        i,
	        j;
	    for (i = 0; i < discardNumber; i++) {
	      r = (data[i] + r) * c1 + c2 & (1 << 16) - 1;
	    }
	    var count = data.length - discardNumber;
	    var decrypted = new Uint8Array(count);
	    for (i = discardNumber, j = 0; j < count; i++, j++) {
	      var value = data[i];
	      decrypted[j] = value ^ r >> 8;
	      r = (value + r) * c1 + c2 & (1 << 16) - 1;
	    }
	    return decrypted;
	  }
	  function decryptAscii(data, key, discardNumber) {
	    var r = key | 0,
	        c1 = 52845,
	        c2 = 22719;
	    var count = data.length,
	        maybeLength = count >>> 1;
	    var decrypted = new Uint8Array(maybeLength);
	    var i, j;
	    for (i = 0, j = 0; i < count; i++) {
	      var digit1 = data[i];
	      if (!isHexDigit(digit1)) {
	        continue;
	      }
	      i++;
	      var digit2;
	      while (i < count && !isHexDigit(digit2 = data[i])) {
	        i++;
	      }
	      if (i < count) {
	        var value = parseInt(String.fromCharCode(digit1, digit2), 16);
	        decrypted[j++] = value ^ r >> 8;
	        r = (value + r) * c1 + c2 & (1 << 16) - 1;
	      }
	    }
	    return Array.prototype.slice.call(decrypted, discardNumber, j);
	  }
	  function isSpecial(c) {
	    return c === 0x2F || c === 0x5B || c === 0x5D || c === 0x7B || c === 0x7D || c === 0x28 || c === 0x29;
	  }
	  function Type1Parser(stream, encrypted, seacAnalysisEnabled) {
	    if (encrypted) {
	      var data = stream.getBytes();
	      var isBinary = !(isHexDigit(data[0]) && isHexDigit(data[1]) && isHexDigit(data[2]) && isHexDigit(data[3]));
	      stream = new _stream.Stream(isBinary ? decrypt(data, EEXEC_ENCRYPT_KEY, 4) : decryptAscii(data, EEXEC_ENCRYPT_KEY, 4));
	    }
	    this.seacAnalysisEnabled = !!seacAnalysisEnabled;
	    this.stream = stream;
	    this.nextChar();
	  }
	  Type1Parser.prototype = {
	    readNumberArray: function Type1Parser_readNumberArray() {
	      this.getToken();
	      var array = [];
	      while (true) {
	        var token = this.getToken();
	        if (token === null || token === ']' || token === '}') {
	          break;
	        }
	        array.push(parseFloat(token || 0));
	      }
	      return array;
	    },
	    readNumber: function Type1Parser_readNumber() {
	      var token = this.getToken();
	      return parseFloat(token || 0);
	    },
	    readInt: function Type1Parser_readInt() {
	      var token = this.getToken();
	      return parseInt(token || 0, 10) | 0;
	    },
	    readBoolean: function Type1Parser_readBoolean() {
	      var token = this.getToken();
	      return token === 'true' ? 1 : 0;
	    },
	    nextChar: function Type1_nextChar() {
	      return this.currentChar = this.stream.getByte();
	    },
	    getToken: function Type1Parser_getToken() {
	      var comment = false;
	      var ch = this.currentChar;
	      while (true) {
	        if (ch === -1) {
	          return null;
	        }
	        if (comment) {
	          if (ch === 0x0A || ch === 0x0D) {
	            comment = false;
	          }
	        } else if (ch === 0x25) {
	          comment = true;
	        } else if (!(0, _util.isSpace)(ch)) {
	          break;
	        }
	        ch = this.nextChar();
	      }
	      if (isSpecial(ch)) {
	        this.nextChar();
	        return String.fromCharCode(ch);
	      }
	      var token = '';
	      do {
	        token += String.fromCharCode(ch);
	        ch = this.nextChar();
	      } while (ch >= 0 && !(0, _util.isSpace)(ch) && !isSpecial(ch));
	      return token;
	    },
	    readCharStrings: function Type1Parser_readCharStrings(bytes, lenIV) {
	      if (lenIV === -1) {
	        return bytes;
	      }
	      return decrypt(bytes, CHAR_STRS_ENCRYPT_KEY, lenIV);
	    },
	    extractFontProgram: function Type1Parser_extractFontProgram() {
	      var stream = this.stream;
	      var subrs = [],
	          charstrings = [];
	      var privateData = Object.create(null);
	      privateData['lenIV'] = 4;
	      var program = {
	        subrs: [],
	        charstrings: [],
	        properties: { 'privateData': privateData }
	      };
	      var token, length, data, lenIV, encoded;
	      while ((token = this.getToken()) !== null) {
	        if (token !== '/') {
	          continue;
	        }
	        token = this.getToken();
	        switch (token) {
	          case 'CharStrings':
	            this.getToken();
	            this.getToken();
	            this.getToken();
	            this.getToken();
	            while (true) {
	              token = this.getToken();
	              if (token === null || token === 'end') {
	                break;
	              }
	              if (token !== '/') {
	                continue;
	              }
	              var glyph = this.getToken();
	              length = this.readInt();
	              this.getToken();
	              data = stream.makeSubStream(stream.pos, length);
	              lenIV = program.properties.privateData['lenIV'];
	              encoded = this.readCharStrings(data.getBytes(), lenIV);
	              stream.skip(length);
	              this.nextChar();
	              token = this.getToken();
	              if (token === 'noaccess') {
	                this.getToken();
	              }
	              charstrings.push({
	                glyph: glyph,
	                encoded: encoded
	              });
	            }
	            break;
	          case 'Subrs':
	            this.readInt();
	            this.getToken();
	            while ((token = this.getToken()) === 'dup') {
	              var index = this.readInt();
	              length = this.readInt();
	              this.getToken();
	              data = stream.makeSubStream(stream.pos, length);
	              lenIV = program.properties.privateData['lenIV'];
	              encoded = this.readCharStrings(data.getBytes(), lenIV);
	              stream.skip(length);
	              this.nextChar();
	              token = this.getToken();
	              if (token === 'noaccess') {
	                this.getToken();
	              }
	              subrs[index] = encoded;
	            }
	            break;
	          case 'BlueValues':
	          case 'OtherBlues':
	          case 'FamilyBlues':
	          case 'FamilyOtherBlues':
	            var blueArray = this.readNumberArray();
	            if (blueArray.length > 0 && blueArray.length % 2 === 0 && HINTING_ENABLED) {
	              program.properties.privateData[token] = blueArray;
	            }
	            break;
	          case 'StemSnapH':
	          case 'StemSnapV':
	            program.properties.privateData[token] = this.readNumberArray();
	            break;
	          case 'StdHW':
	          case 'StdVW':
	            program.properties.privateData[token] = this.readNumberArray()[0];
	            break;
	          case 'BlueShift':
	          case 'lenIV':
	          case 'BlueFuzz':
	          case 'BlueScale':
	          case 'LanguageGroup':
	          case 'ExpansionFactor':
	            program.properties.privateData[token] = this.readNumber();
	            break;
	          case 'ForceBold':
	            program.properties.privateData[token] = this.readBoolean();
	            break;
	        }
	      }
	      for (var i = 0; i < charstrings.length; i++) {
	        glyph = charstrings[i].glyph;
	        encoded = charstrings[i].encoded;
	        var charString = new Type1CharString();
	        var error = charString.convert(encoded, subrs, this.seacAnalysisEnabled);
	        var output = charString.output;
	        if (error) {
	          output = [14];
	        }
	        program.charstrings.push({
	          glyphName: glyph,
	          charstring: output,
	          width: charString.width,
	          lsb: charString.lsb,
	          seac: charString.seac
	        });
	      }
	      return program;
	    },
	    extractFontHeader: function Type1Parser_extractFontHeader(properties) {
	      var token;
	      while ((token = this.getToken()) !== null) {
	        if (token !== '/') {
	          continue;
	        }
	        token = this.getToken();
	        switch (token) {
	          case 'FontMatrix':
	            var matrix = this.readNumberArray();
	            properties.fontMatrix = matrix;
	            break;
	          case 'Encoding':
	            var encodingArg = this.getToken();
	            var encoding;
	            if (!/^\d+$/.test(encodingArg)) {
	              encoding = (0, _encodings.getEncoding)(encodingArg);
	            } else {
	              encoding = [];
	              var size = parseInt(encodingArg, 10) | 0;
	              this.getToken();
	              for (var j = 0; j < size; j++) {
	                token = this.getToken();
	                while (token !== 'dup' && token !== 'def') {
	                  token = this.getToken();
	                  if (token === null) {
	                    return;
	                  }
	                }
	                if (token === 'def') {
	                  break;
	                }
	                var index = this.readInt();
	                this.getToken();
	                var glyph = this.getToken();
	                encoding[index] = glyph;
	                this.getToken();
	              }
	            }
	            properties.builtInEncoding = encoding;
	            break;
	          case 'FontBBox':
	            var fontBBox = this.readNumberArray();
	            properties.ascent = Math.max(fontBBox[3], fontBBox[1]);
	            properties.descent = Math.min(fontBBox[1], fontBBox[3]);
	            properties.ascentScaled = true;
	            break;
	        }
	      }
	    }
	  };
	  return Type1Parser;
	}();
	exports.Type1Parser = Type1Parser;
	
	/***/ }),
	/* 153 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTilingPatternIR = exports.Pattern = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _colorspace = __w_pdfjs_require__(29);
	
	var _primitives = __w_pdfjs_require__(2);
	
	var ShadingType = {
	  FUNCTION_BASED: 1,
	  AXIAL: 2,
	  RADIAL: 3,
	  FREE_FORM_MESH: 4,
	  LATTICE_FORM_MESH: 5,
	  COONS_PATCH_MESH: 6,
	  TENSOR_PATCH_MESH: 7
	};
	var Pattern = function PatternClosure() {
	  function Pattern() {
	    throw new Error('should not call Pattern constructor');
	  }
	  Pattern.prototype = {
	    getPattern: function Pattern_getPattern(ctx) {
	      throw new Error('Should not call Pattern.getStyle: ' + ctx);
	    }
	  };
	  Pattern.parseShading = function (shading, matrix, xref, res, handler, pdfFunctionFactory) {
	    var dict = (0, _primitives.isStream)(shading) ? shading.dict : shading;
	    var type = dict.get('ShadingType');
	    try {
	      switch (type) {
	        case ShadingType.AXIAL:
	        case ShadingType.RADIAL:
	          return new Shadings.RadialAxial(dict, matrix, xref, res, pdfFunctionFactory);
	        case ShadingType.FREE_FORM_MESH:
	        case ShadingType.LATTICE_FORM_MESH:
	        case ShadingType.COONS_PATCH_MESH:
	        case ShadingType.TENSOR_PATCH_MESH:
	          return new Shadings.Mesh(shading, matrix, xref, res, pdfFunctionFactory);
	        default:
	          throw new _util.FormatError('Unsupported ShadingType: ' + type);
	      }
	    } catch (ex) {
	      if (ex instanceof _util.MissingDataException) {
	        throw ex;
	      }
	      handler.send('UnsupportedFeature', { featureId: _util.UNSUPPORTED_FEATURES.shadingPattern });
	      (0, _util.warn)(ex);
	      return new Shadings.Dummy();
	    }
	  };
	  return Pattern;
	}();
	var Shadings = {};
	Shadings.SMALL_NUMBER = 1e-6;
	Shadings.RadialAxial = function RadialAxialClosure() {
	  function RadialAxial(dict, matrix, xref, res, pdfFunctionFactory) {
	    this.matrix = matrix;
	    this.coordsArr = dict.getArray('Coords');
	    this.shadingType = dict.get('ShadingType');
	    this.type = 'Pattern';
	    var cs = dict.get('ColorSpace', 'CS');
	    cs = _colorspace.ColorSpace.parse(cs, xref, res, pdfFunctionFactory);
	    this.cs = cs;
	    var t0 = 0.0,
	        t1 = 1.0;
	    if (dict.has('Domain')) {
	      var domainArr = dict.getArray('Domain');
	      t0 = domainArr[0];
	      t1 = domainArr[1];
	    }
	    var extendStart = false,
	        extendEnd = false;
	    if (dict.has('Extend')) {
	      var extendArr = dict.getArray('Extend');
	      extendStart = extendArr[0];
	      extendEnd = extendArr[1];
	    }
	    if (this.shadingType === ShadingType.RADIAL && (!extendStart || !extendEnd)) {
	      var x1 = this.coordsArr[0];
	      var y1 = this.coordsArr[1];
	      var r1 = this.coordsArr[2];
	      var x2 = this.coordsArr[3];
	      var y2 = this.coordsArr[4];
	      var r2 = this.coordsArr[5];
	      var distance = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
	      if (r1 <= r2 + distance && r2 <= r1 + distance) {
	        (0, _util.warn)('Unsupported radial gradient.');
	      }
	    }
	    this.extendStart = extendStart;
	    this.extendEnd = extendEnd;
	    var fnObj = dict.get('Function');
	    var fn = pdfFunctionFactory.createFromArray(fnObj);
	    var diff = t1 - t0;
	    var step = diff / 10;
	    var colorStops = this.colorStops = [];
	    if (t0 >= t1 || step <= 0) {
	      (0, _util.info)('Bad shading domain.');
	      return;
	    }
	    var color = new Float32Array(cs.numComps),
	        ratio = new Float32Array(1);
	    var rgbColor;
	    for (var i = t0; i <= t1; i += step) {
	      ratio[0] = i;
	      fn(ratio, 0, color, 0);
	      rgbColor = cs.getRgb(color, 0);
	      var cssColor = _util.Util.makeCssRgb(rgbColor[0], rgbColor[1], rgbColor[2]);
	      colorStops.push([(i - t0) / diff, cssColor]);
	    }
	    var background = 'transparent';
	    if (dict.has('Background')) {
	      rgbColor = cs.getRgb(dict.get('Background'), 0);
	      background = _util.Util.makeCssRgb(rgbColor[0], rgbColor[1], rgbColor[2]);
	    }
	    if (!extendStart) {
	      colorStops.unshift([0, background]);
	      colorStops[1][0] += Shadings.SMALL_NUMBER;
	    }
	    if (!extendEnd) {
	      colorStops[colorStops.length - 1][0] -= Shadings.SMALL_NUMBER;
	      colorStops.push([1, background]);
	    }
	    this.colorStops = colorStops;
	  }
	  RadialAxial.prototype = {
	    getIR: function RadialAxial_getIR() {
	      var coordsArr = this.coordsArr;
	      var shadingType = this.shadingType;
	      var type, p0, p1, r0, r1;
	      if (shadingType === ShadingType.AXIAL) {
	        p0 = [coordsArr[0], coordsArr[1]];
	        p1 = [coordsArr[2], coordsArr[3]];
	        r0 = null;
	        r1 = null;
	        type = 'axial';
	      } else if (shadingType === ShadingType.RADIAL) {
	        p0 = [coordsArr[0], coordsArr[1]];
	        p1 = [coordsArr[3], coordsArr[4]];
	        r0 = coordsArr[2];
	        r1 = coordsArr[5];
	        type = 'radial';
	      } else {
	        (0, _util.unreachable)('getPattern type unknown: ' + shadingType);
	      }
	      var matrix = this.matrix;
	      if (matrix) {
	        p0 = _util.Util.applyTransform(p0, matrix);
	        p1 = _util.Util.applyTransform(p1, matrix);
	        if (shadingType === ShadingType.RADIAL) {
	          var scale = _util.Util.singularValueDecompose2dScale(matrix);
	          r0 *= scale[0];
	          r1 *= scale[1];
	        }
	      }
	      return ['RadialAxial', type, this.colorStops, p0, p1, r0, r1];
	    }
	  };
	  return RadialAxial;
	}();
	Shadings.Mesh = function MeshClosure() {
	  function MeshStreamReader(stream, context) {
	    this.stream = stream;
	    this.context = context;
	    this.buffer = 0;
	    this.bufferLength = 0;
	    var numComps = context.numComps;
	    this.tmpCompsBuf = new Float32Array(numComps);
	    var csNumComps = context.colorSpace.numComps;
	    this.tmpCsCompsBuf = context.colorFn ? new Float32Array(csNumComps) : this.tmpCompsBuf;
	  }
	  MeshStreamReader.prototype = {
	    get hasData() {
	      if (this.stream.end) {
	        return this.stream.pos < this.stream.end;
	      }
	      if (this.bufferLength > 0) {
	        return true;
	      }
	      var nextByte = this.stream.getByte();
	      if (nextByte < 0) {
	        return false;
	      }
	      this.buffer = nextByte;
	      this.bufferLength = 8;
	      return true;
	    },
	    readBits: function MeshStreamReader_readBits(n) {
	      var buffer = this.buffer;
	      var bufferLength = this.bufferLength;
	      if (n === 32) {
	        if (bufferLength === 0) {
	          return (this.stream.getByte() << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte()) >>> 0;
	        }
	        buffer = buffer << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte();
	        var nextByte = this.stream.getByte();
	        this.buffer = nextByte & (1 << bufferLength) - 1;
	        return (buffer << 8 - bufferLength | (nextByte & 0xFF) >> bufferLength) >>> 0;
	      }
	      if (n === 8 && bufferLength === 0) {
	        return this.stream.getByte();
	      }
	      while (bufferLength < n) {
	        buffer = buffer << 8 | this.stream.getByte();
	        bufferLength += 8;
	      }
	      bufferLength -= n;
	      this.bufferLength = bufferLength;
	      this.buffer = buffer & (1 << bufferLength) - 1;
	      return buffer >> bufferLength;
	    },
	    align: function MeshStreamReader_align() {
	      this.buffer = 0;
	      this.bufferLength = 0;
	    },
	    readFlag: function MeshStreamReader_readFlag() {
	      return this.readBits(this.context.bitsPerFlag);
	    },
	    readCoordinate: function MeshStreamReader_readCoordinate() {
	      var bitsPerCoordinate = this.context.bitsPerCoordinate;
	      var xi = this.readBits(bitsPerCoordinate);
	      var yi = this.readBits(bitsPerCoordinate);
	      var decode = this.context.decode;
	      var scale = bitsPerCoordinate < 32 ? 1 / ((1 << bitsPerCoordinate) - 1) : 2.3283064365386963e-10;
	      return [xi * scale * (decode[1] - decode[0]) + decode[0], yi * scale * (decode[3] - decode[2]) + decode[2]];
	    },
	    readComponents: function MeshStreamReader_readComponents() {
	      var numComps = this.context.numComps;
	      var bitsPerComponent = this.context.bitsPerComponent;
	      var scale = bitsPerComponent < 32 ? 1 / ((1 << bitsPerComponent) - 1) : 2.3283064365386963e-10;
	      var decode = this.context.decode;
	      var components = this.tmpCompsBuf;
	      for (var i = 0, j = 4; i < numComps; i++, j += 2) {
	        var ci = this.readBits(bitsPerComponent);
	        components[i] = ci * scale * (decode[j + 1] - decode[j]) + decode[j];
	      }
	      var color = this.tmpCsCompsBuf;
	      if (this.context.colorFn) {
	        this.context.colorFn(components, 0, color, 0);
	      }
	      return this.context.colorSpace.getRgb(color, 0);
	    }
	  };
	  function decodeType4Shading(mesh, reader) {
	    var coords = mesh.coords;
	    var colors = mesh.colors;
	    var operators = [];
	    var ps = [];
	    var verticesLeft = 0;
	    while (reader.hasData) {
	      var f = reader.readFlag();
	      var coord = reader.readCoordinate();
	      var color = reader.readComponents();
	      if (verticesLeft === 0) {
	        if (!(0 <= f && f <= 2)) {
	          throw new _util.FormatError('Unknown type4 flag');
	        }
	        switch (f) {
	          case 0:
	            verticesLeft = 3;
	            break;
	          case 1:
	            ps.push(ps[ps.length - 2], ps[ps.length - 1]);
	            verticesLeft = 1;
	            break;
	          case 2:
	            ps.push(ps[ps.length - 3], ps[ps.length - 1]);
	            verticesLeft = 1;
	            break;
	        }
	        operators.push(f);
	      }
	      ps.push(coords.length);
	      coords.push(coord);
	      colors.push(color);
	      verticesLeft--;
	      reader.align();
	    }
	    mesh.figures.push({
	      type: 'triangles',
	      coords: new Int32Array(ps),
	      colors: new Int32Array(ps)
	    });
	  }
	  function decodeType5Shading(mesh, reader, verticesPerRow) {
	    var coords = mesh.coords;
	    var colors = mesh.colors;
	    var ps = [];
	    while (reader.hasData) {
	      var coord = reader.readCoordinate();
	      var color = reader.readComponents();
	      ps.push(coords.length);
	      coords.push(coord);
	      colors.push(color);
	    }
	    mesh.figures.push({
	      type: 'lattice',
	      coords: new Int32Array(ps),
	      colors: new Int32Array(ps),
	      verticesPerRow: verticesPerRow
	    });
	  }
	  var MIN_SPLIT_PATCH_CHUNKS_AMOUNT = 3;
	  var MAX_SPLIT_PATCH_CHUNKS_AMOUNT = 20;
	  var TRIANGLE_DENSITY = 20;
	  var getB = function getBClosure() {
	    function buildB(count) {
	      var lut = [];
	      for (var i = 0; i <= count; i++) {
	        var t = i / count,
	            t_ = 1 - t;
	        lut.push(new Float32Array([t_ * t_ * t_, 3 * t * t_ * t_, 3 * t * t * t_, t * t * t]));
	      }
	      return lut;
	    }
	    var cache = [];
	    return function getB(count) {
	      if (!cache[count]) {
	        cache[count] = buildB(count);
	      }
	      return cache[count];
	    };
	  }();
	  function buildFigureFromPatch(mesh, index) {
	    var figure = mesh.figures[index];
	    (0, _util.assert)(figure.type === 'patch', 'Unexpected patch mesh figure');
	    var coords = mesh.coords,
	        colors = mesh.colors;
	    var pi = figure.coords;
	    var ci = figure.colors;
	    var figureMinX = Math.min(coords[pi[0]][0], coords[pi[3]][0], coords[pi[12]][0], coords[pi[15]][0]);
	    var figureMinY = Math.min(coords[pi[0]][1], coords[pi[3]][1], coords[pi[12]][1], coords[pi[15]][1]);
	    var figureMaxX = Math.max(coords[pi[0]][0], coords[pi[3]][0], coords[pi[12]][0], coords[pi[15]][0]);
	    var figureMaxY = Math.max(coords[pi[0]][1], coords[pi[3]][1], coords[pi[12]][1], coords[pi[15]][1]);
	    var splitXBy = Math.ceil((figureMaxX - figureMinX) * TRIANGLE_DENSITY / (mesh.bounds[2] - mesh.bounds[0]));
	    splitXBy = Math.max(MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MAX_SPLIT_PATCH_CHUNKS_AMOUNT, splitXBy));
	    var splitYBy = Math.ceil((figureMaxY - figureMinY) * TRIANGLE_DENSITY / (mesh.bounds[3] - mesh.bounds[1]));
	    splitYBy = Math.max(MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MAX_SPLIT_PATCH_CHUNKS_AMOUNT, splitYBy));
	    var verticesPerRow = splitXBy + 1;
	    var figureCoords = new Int32Array((splitYBy + 1) * verticesPerRow);
	    var figureColors = new Int32Array((splitYBy + 1) * verticesPerRow);
	    var k = 0;
	    var cl = new Uint8Array(3),
	        cr = new Uint8Array(3);
	    var c0 = colors[ci[0]],
	        c1 = colors[ci[1]],
	        c2 = colors[ci[2]],
	        c3 = colors[ci[3]];
	    var bRow = getB(splitYBy),
	        bCol = getB(splitXBy);
	    for (var row = 0; row <= splitYBy; row++) {
	      cl[0] = (c0[0] * (splitYBy - row) + c2[0] * row) / splitYBy | 0;
	      cl[1] = (c0[1] * (splitYBy - row) + c2[1] * row) / splitYBy | 0;
	      cl[2] = (c0[2] * (splitYBy - row) + c2[2] * row) / splitYBy | 0;
	      cr[0] = (c1[0] * (splitYBy - row) + c3[0] * row) / splitYBy | 0;
	      cr[1] = (c1[1] * (splitYBy - row) + c3[1] * row) / splitYBy | 0;
	      cr[2] = (c1[2] * (splitYBy - row) + c3[2] * row) / splitYBy | 0;
	      for (var col = 0; col <= splitXBy; col++, k++) {
	        if ((row === 0 || row === splitYBy) && (col === 0 || col === splitXBy)) {
	          continue;
	        }
	        var x = 0,
	            y = 0;
	        var q = 0;
	        for (var i = 0; i <= 3; i++) {
	          for (var j = 0; j <= 3; j++, q++) {
	            var m = bRow[row][i] * bCol[col][j];
	            x += coords[pi[q]][0] * m;
	            y += coords[pi[q]][1] * m;
	          }
	        }
	        figureCoords[k] = coords.length;
	        coords.push([x, y]);
	        figureColors[k] = colors.length;
	        var newColor = new Uint8Array(3);
	        newColor[0] = (cl[0] * (splitXBy - col) + cr[0] * col) / splitXBy | 0;
	        newColor[1] = (cl[1] * (splitXBy - col) + cr[1] * col) / splitXBy | 0;
	        newColor[2] = (cl[2] * (splitXBy - col) + cr[2] * col) / splitXBy | 0;
	        colors.push(newColor);
	      }
	    }
	    figureCoords[0] = pi[0];
	    figureColors[0] = ci[0];
	    figureCoords[splitXBy] = pi[3];
	    figureColors[splitXBy] = ci[1];
	    figureCoords[verticesPerRow * splitYBy] = pi[12];
	    figureColors[verticesPerRow * splitYBy] = ci[2];
	    figureCoords[verticesPerRow * splitYBy + splitXBy] = pi[15];
	    figureColors[verticesPerRow * splitYBy + splitXBy] = ci[3];
	    mesh.figures[index] = {
	      type: 'lattice',
	      coords: figureCoords,
	      colors: figureColors,
	      verticesPerRow: verticesPerRow
	    };
	  }
	  function decodeType6Shading(mesh, reader) {
	    var coords = mesh.coords;
	    var colors = mesh.colors;
	    var ps = new Int32Array(16);
	    var cs = new Int32Array(4);
	    while (reader.hasData) {
	      var f = reader.readFlag();
	      if (!(0 <= f && f <= 3)) {
	        throw new _util.FormatError('Unknown type6 flag');
	      }
	      var i, ii;
	      var pi = coords.length;
	      for (i = 0, ii = f !== 0 ? 8 : 12; i < ii; i++) {
	        coords.push(reader.readCoordinate());
	      }
	      var ci = colors.length;
	      for (i = 0, ii = f !== 0 ? 2 : 4; i < ii; i++) {
	        colors.push(reader.readComponents());
	      }
	      var tmp1, tmp2, tmp3, tmp4;
	      switch (f) {
	        case 0:
	          ps[12] = pi + 3;
	          ps[13] = pi + 4;
	          ps[14] = pi + 5;
	          ps[15] = pi + 6;
	          ps[8] = pi + 2;
	          ps[11] = pi + 7;
	          ps[4] = pi + 1;
	          ps[7] = pi + 8;
	          ps[0] = pi;
	          ps[1] = pi + 11;
	          ps[2] = pi + 10;
	          ps[3] = pi + 9;
	          cs[2] = ci + 1;
	          cs[3] = ci + 2;
	          cs[0] = ci;
	          cs[1] = ci + 3;
	          break;
	        case 1:
	          tmp1 = ps[12];
	          tmp2 = ps[13];
	          tmp3 = ps[14];
	          tmp4 = ps[15];
	          ps[12] = tmp4;
	          ps[13] = pi + 0;
	          ps[14] = pi + 1;
	          ps[15] = pi + 2;
	          ps[8] = tmp3;
	          ps[11] = pi + 3;
	          ps[4] = tmp2;
	          ps[7] = pi + 4;
	          ps[0] = tmp1;
	          ps[1] = pi + 7;
	          ps[2] = pi + 6;
	          ps[3] = pi + 5;
	          tmp1 = cs[2];
	          tmp2 = cs[3];
	          cs[2] = tmp2;
	          cs[3] = ci;
	          cs[0] = tmp1;
	          cs[1] = ci + 1;
	          break;
	        case 2:
	          tmp1 = ps[15];
	          tmp2 = ps[11];
	          ps[12] = ps[3];
	          ps[13] = pi + 0;
	          ps[14] = pi + 1;
	          ps[15] = pi + 2;
	          ps[8] = ps[7];
	          ps[11] = pi + 3;
	          ps[4] = tmp2;
	          ps[7] = pi + 4;
	          ps[0] = tmp1;
	          ps[1] = pi + 7;
	          ps[2] = pi + 6;
	          ps[3] = pi + 5;
	          tmp1 = cs[3];
	          cs[2] = cs[1];
	          cs[3] = ci;
	          cs[0] = tmp1;
	          cs[1] = ci + 1;
	          break;
	        case 3:
	          ps[12] = ps[0];
	          ps[13] = pi + 0;
	          ps[14] = pi + 1;
	          ps[15] = pi + 2;
	          ps[8] = ps[1];
	          ps[11] = pi + 3;
	          ps[4] = ps[2];
	          ps[7] = pi + 4;
	          ps[0] = ps[3];
	          ps[1] = pi + 7;
	          ps[2] = pi + 6;
	          ps[3] = pi + 5;
	          cs[2] = cs[0];
	          cs[3] = ci;
	          cs[0] = cs[1];
	          cs[1] = ci + 1;
	          break;
	      }
	      ps[5] = coords.length;
	      coords.push([(-4 * coords[ps[0]][0] - coords[ps[15]][0] + 6 * (coords[ps[4]][0] + coords[ps[1]][0]) - 2 * (coords[ps[12]][0] + coords[ps[3]][0]) + 3 * (coords[ps[13]][0] + coords[ps[7]][0])) / 9, (-4 * coords[ps[0]][1] - coords[ps[15]][1] + 6 * (coords[ps[4]][1] + coords[ps[1]][1]) - 2 * (coords[ps[12]][1] + coords[ps[3]][1]) + 3 * (coords[ps[13]][1] + coords[ps[7]][1])) / 9]);
	      ps[6] = coords.length;
	      coords.push([(-4 * coords[ps[3]][0] - coords[ps[12]][0] + 6 * (coords[ps[2]][0] + coords[ps[7]][0]) - 2 * (coords[ps[0]][0] + coords[ps[15]][0]) + 3 * (coords[ps[4]][0] + coords[ps[14]][0])) / 9, (-4 * coords[ps[3]][1] - coords[ps[12]][1] + 6 * (coords[ps[2]][1] + coords[ps[7]][1]) - 2 * (coords[ps[0]][1] + coords[ps[15]][1]) + 3 * (coords[ps[4]][1] + coords[ps[14]][1])) / 9]);
	      ps[9] = coords.length;
	      coords.push([(-4 * coords[ps[12]][0] - coords[ps[3]][0] + 6 * (coords[ps[8]][0] + coords[ps[13]][0]) - 2 * (coords[ps[0]][0] + coords[ps[15]][0]) + 3 * (coords[ps[11]][0] + coords[ps[1]][0])) / 9, (-4 * coords[ps[12]][1] - coords[ps[3]][1] + 6 * (coords[ps[8]][1] + coords[ps[13]][1]) - 2 * (coords[ps[0]][1] + coords[ps[15]][1]) + 3 * (coords[ps[11]][1] + coords[ps[1]][1])) / 9]);
	      ps[10] = coords.length;
	      coords.push([(-4 * coords[ps[15]][0] - coords[ps[0]][0] + 6 * (coords[ps[11]][0] + coords[ps[14]][0]) - 2 * (coords[ps[12]][0] + coords[ps[3]][0]) + 3 * (coords[ps[2]][0] + coords[ps[8]][0])) / 9, (-4 * coords[ps[15]][1] - coords[ps[0]][1] + 6 * (coords[ps[11]][1] + coords[ps[14]][1]) - 2 * (coords[ps[12]][1] + coords[ps[3]][1]) + 3 * (coords[ps[2]][1] + coords[ps[8]][1])) / 9]);
	      mesh.figures.push({
	        type: 'patch',
	        coords: new Int32Array(ps),
	        colors: new Int32Array(cs)
	      });
	    }
	  }
	  function decodeType7Shading(mesh, reader) {
	    var coords = mesh.coords;
	    var colors = mesh.colors;
	    var ps = new Int32Array(16);
	    var cs = new Int32Array(4);
	    while (reader.hasData) {
	      var f = reader.readFlag();
	      if (!(0 <= f && f <= 3)) {
	        throw new _util.FormatError('Unknown type7 flag');
	      }
	      var i, ii;
	      var pi = coords.length;
	      for (i = 0, ii = f !== 0 ? 12 : 16; i < ii; i++) {
	        coords.push(reader.readCoordinate());
	      }
	      var ci = colors.length;
	      for (i = 0, ii = f !== 0 ? 2 : 4; i < ii; i++) {
	        colors.push(reader.readComponents());
	      }
	      var tmp1, tmp2, tmp3, tmp4;
	      switch (f) {
	        case 0:
	          ps[12] = pi + 3;
	          ps[13] = pi + 4;
	          ps[14] = pi + 5;
	          ps[15] = pi + 6;
	          ps[8] = pi + 2;
	          ps[9] = pi + 13;
	          ps[10] = pi + 14;
	          ps[11] = pi + 7;
	          ps[4] = pi + 1;
	          ps[5] = pi + 12;
	          ps[6] = pi + 15;
	          ps[7] = pi + 8;
	          ps[0] = pi;
	          ps[1] = pi + 11;
	          ps[2] = pi + 10;
	          ps[3] = pi + 9;
	          cs[2] = ci + 1;
	          cs[3] = ci + 2;
	          cs[0] = ci;
	          cs[1] = ci + 3;
	          break;
	        case 1:
	          tmp1 = ps[12];
	          tmp2 = ps[13];
	          tmp3 = ps[14];
	          tmp4 = ps[15];
	          ps[12] = tmp4;
	          ps[13] = pi + 0;
	          ps[14] = pi + 1;
	          ps[15] = pi + 2;
	          ps[8] = tmp3;
	          ps[9] = pi + 9;
	          ps[10] = pi + 10;
	          ps[11] = pi + 3;
	          ps[4] = tmp2;
	          ps[5] = pi + 8;
	          ps[6] = pi + 11;
	          ps[7] = pi + 4;
	          ps[0] = tmp1;
	          ps[1] = pi + 7;
	          ps[2] = pi + 6;
	          ps[3] = pi + 5;
	          tmp1 = cs[2];
	          tmp2 = cs[3];
	          cs[2] = tmp2;
	          cs[3] = ci;
	          cs[0] = tmp1;
	          cs[1] = ci + 1;
	          break;
	        case 2:
	          tmp1 = ps[15];
	          tmp2 = ps[11];
	          ps[12] = ps[3];
	          ps[13] = pi + 0;
	          ps[14] = pi + 1;
	          ps[15] = pi + 2;
	          ps[8] = ps[7];
	          ps[9] = pi + 9;
	          ps[10] = pi + 10;
	          ps[11] = pi + 3;
	          ps[4] = tmp2;
	          ps[5] = pi + 8;
	          ps[6] = pi + 11;
	          ps[7] = pi + 4;
	          ps[0] = tmp1;
	          ps[1] = pi + 7;
	          ps[2] = pi + 6;
	          ps[3] = pi + 5;
	          tmp1 = cs[3];
	          cs[2] = cs[1];
	          cs[3] = ci;
	          cs[0] = tmp1;
	          cs[1] = ci + 1;
	          break;
	        case 3:
	          ps[12] = ps[0];
	          ps[13] = pi + 0;
	          ps[14] = pi + 1;
	          ps[15] = pi + 2;
	          ps[8] = ps[1];
	          ps[9] = pi + 9;
	          ps[10] = pi + 10;
	          ps[11] = pi + 3;
	          ps[4] = ps[2];
	          ps[5] = pi + 8;
	          ps[6] = pi + 11;
	          ps[7] = pi + 4;
	          ps[0] = ps[3];
	          ps[1] = pi + 7;
	          ps[2] = pi + 6;
	          ps[3] = pi + 5;
	          cs[2] = cs[0];
	          cs[3] = ci;
	          cs[0] = cs[1];
	          cs[1] = ci + 1;
	          break;
	      }
	      mesh.figures.push({
	        type: 'patch',
	        coords: new Int32Array(ps),
	        colors: new Int32Array(cs)
	      });
	    }
	  }
	  function updateBounds(mesh) {
	    var minX = mesh.coords[0][0],
	        minY = mesh.coords[0][1],
	        maxX = minX,
	        maxY = minY;
	    for (var i = 1, ii = mesh.coords.length; i < ii; i++) {
	      var x = mesh.coords[i][0],
	          y = mesh.coords[i][1];
	      minX = minX > x ? x : minX;
	      minY = minY > y ? y : minY;
	      maxX = maxX < x ? x : maxX;
	      maxY = maxY < y ? y : maxY;
	    }
	    mesh.bounds = [minX, minY, maxX, maxY];
	  }
	  function packData(mesh) {
	    var i, ii, j, jj;
	    var coords = mesh.coords;
	    var coordsPacked = new Float32Array(coords.length * 2);
	    for (i = 0, j = 0, ii = coords.length; i < ii; i++) {
	      var xy = coords[i];
	      coordsPacked[j++] = xy[0];
	      coordsPacked[j++] = xy[1];
	    }
	    mesh.coords = coordsPacked;
	    var colors = mesh.colors;
	    var colorsPacked = new Uint8Array(colors.length * 3);
	    for (i = 0, j = 0, ii = colors.length; i < ii; i++) {
	      var c = colors[i];
	      colorsPacked[j++] = c[0];
	      colorsPacked[j++] = c[1];
	      colorsPacked[j++] = c[2];
	    }
	    mesh.colors = colorsPacked;
	    var figures = mesh.figures;
	    for (i = 0, ii = figures.length; i < ii; i++) {
	      var figure = figures[i],
	          ps = figure.coords,
	          cs = figure.colors;
	      for (j = 0, jj = ps.length; j < jj; j++) {
	        ps[j] *= 2;
	        cs[j] *= 3;
	      }
	    }
	  }
	  function Mesh(stream, matrix, xref, res, pdfFunctionFactory) {
	    if (!(0, _primitives.isStream)(stream)) {
	      throw new _util.FormatError('Mesh data is not a stream');
	    }
	    var dict = stream.dict;
	    this.matrix = matrix;
	    this.shadingType = dict.get('ShadingType');
	    this.type = 'Pattern';
	    this.bbox = dict.getArray('BBox');
	    var cs = dict.get('ColorSpace', 'CS');
	    cs = _colorspace.ColorSpace.parse(cs, xref, res, pdfFunctionFactory);
	    this.cs = cs;
	    this.background = dict.has('Background') ? cs.getRgb(dict.get('Background'), 0) : null;
	    var fnObj = dict.get('Function');
	    var fn = fnObj ? pdfFunctionFactory.createFromArray(fnObj) : null;
	    this.coords = [];
	    this.colors = [];
	    this.figures = [];
	    var decodeContext = {
	      bitsPerCoordinate: dict.get('BitsPerCoordinate'),
	      bitsPerComponent: dict.get('BitsPerComponent'),
	      bitsPerFlag: dict.get('BitsPerFlag'),
	      decode: dict.getArray('Decode'),
	      colorFn: fn,
	      colorSpace: cs,
	      numComps: fn ? 1 : cs.numComps
	    };
	    var reader = new MeshStreamReader(stream, decodeContext);
	    var patchMesh = false;
	    switch (this.shadingType) {
	      case ShadingType.FREE_FORM_MESH:
	        decodeType4Shading(this, reader);
	        break;
	      case ShadingType.LATTICE_FORM_MESH:
	        var verticesPerRow = dict.get('VerticesPerRow') | 0;
	        if (verticesPerRow < 2) {
	          throw new _util.FormatError('Invalid VerticesPerRow');
	        }
	        decodeType5Shading(this, reader, verticesPerRow);
	        break;
	      case ShadingType.COONS_PATCH_MESH:
	        decodeType6Shading(this, reader);
	        patchMesh = true;
	        break;
	      case ShadingType.TENSOR_PATCH_MESH:
	        decodeType7Shading(this, reader);
	        patchMesh = true;
	        break;
	      default:
	        (0, _util.unreachable)('Unsupported mesh type.');
	        break;
	    }
	    if (patchMesh) {
	      updateBounds(this);
	      for (var i = 0, ii = this.figures.length; i < ii; i++) {
	        buildFigureFromPatch(this, i);
	      }
	    }
	    updateBounds(this);
	    packData(this);
	  }
	  Mesh.prototype = {
	    getIR: function Mesh_getIR() {
	      return ['Mesh', this.shadingType, this.coords, this.colors, this.figures, this.bounds, this.matrix, this.bbox, this.background];
	    }
	  };
	  return Mesh;
	}();
	Shadings.Dummy = function DummyClosure() {
	  function Dummy() {
	    this.type = 'Pattern';
	  }
	  Dummy.prototype = {
	    getIR: function Dummy_getIR() {
	      return ['Dummy'];
	    }
	  };
	  return Dummy;
	}();
	function getTilingPatternIR(operatorList, dict, args) {
	  var matrix = dict.getArray('Matrix');
	  var bbox = _util.Util.normalizeRect(dict.getArray('BBox'));
	  var xstep = dict.get('XStep');
	  var ystep = dict.get('YStep');
	  var paintType = dict.get('PaintType');
	  var tilingType = dict.get('TilingType');
	  if (bbox[2] - bbox[0] === 0 || bbox[3] - bbox[1] === 0) {
	    throw new _util.FormatError('Invalid getTilingPatternIR /BBox array: [' + bbox + '].');
	  }
	  return ['TilingPattern', args, operatorList, matrix, bbox, xstep, ystep, paintType, tilingType];
	}
	exports.Pattern = Pattern;
	exports.getTilingPatternIR = getTilingPatternIR;
	
	/***/ }),
	/* 154 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bidi = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var baseTypes = ['BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'S', 'B', 'S', 'WS', 'B', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'B', 'B', 'B', 'S', 'WS', 'ON', 'ON', 'ET', 'ET', 'ET', 'ON', 'ON', 'ON', 'ON', 'ON', 'ES', 'CS', 'ES', 'CS', 'CS', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'CS', 'ON', 'ON', 'ON', 'ON', 'ON', 'ON', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'ON', 'ON', 'ON', 'ON', 'ON', 'ON', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'ON', 'ON', 'ON', 'ON', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'B', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'CS', 'ON', 'ET', 'ET', 'ET', 'ET', 'ON', 'ON', 'ON', 'ON', 'L', 'ON', 'ON', 'BN', 'ON', 'ON', 'ET', 'ET', 'EN', 'EN', 'ON', 'L', 'ON', 'ON', 'ON', 'EN', 'L', 'ON', 'ON', 'ON', 'ON', 'ON', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'ON', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'ON', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L'];
	var arabicTypes = ['AN', 'AN', 'AN', 'AN', 'AN', 'AN', 'ON', 'ON', 'AL', 'ET', 'ET', 'AL', 'CS', 'AL', 'ON', 'ON', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'AL', 'AL', '', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'AN', 'AN', 'AN', 'AN', 'AN', 'AN', 'AN', 'AN', 'AN', 'AN', 'ET', 'AN', 'AN', 'AL', 'AL', 'AL', 'NSM', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'AN', 'ON', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'AL', 'AL', 'NSM', 'NSM', 'ON', 'NSM', 'NSM', 'NSM', 'NSM', 'AL', 'AL', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL'];
	function isOdd(i) {
	  return (i & 1) !== 0;
	}
	function isEven(i) {
	  return (i & 1) === 0;
	}
	function findUnequal(arr, start, value) {
	  for (var j = start, jj = arr.length; j < jj; ++j) {
	    if (arr[j] !== value) {
	      return j;
	    }
	  }
	  return j;
	}
	function setValues(arr, start, end, value) {
	  for (var j = start; j < end; ++j) {
	    arr[j] = value;
	  }
	}
	function reverseValues(arr, start, end) {
	  for (var i = start, j = end - 1; i < j; ++i, --j) {
	    var temp = arr[i];
	    arr[i] = arr[j];
	    arr[j] = temp;
	  }
	}
	function createBidiText(str, isLTR, vertical) {
	  return {
	    str: str,
	    dir: vertical ? 'ttb' : isLTR ? 'ltr' : 'rtl'
	  };
	}
	var chars = [];
	var types = [];
	function bidi(str, startLevel, vertical) {
	  var isLTR = true;
	  var strLength = str.length;
	  if (strLength === 0 || vertical) {
	    return createBidiText(str, isLTR, vertical);
	  }
	  chars.length = strLength;
	  types.length = strLength;
	  var numBidi = 0;
	  var i, ii;
	  for (i = 0; i < strLength; ++i) {
	    chars[i] = str.charAt(i);
	    var charCode = str.charCodeAt(i);
	    var charType = 'L';
	    if (charCode <= 0x00ff) {
	      charType = baseTypes[charCode];
	    } else if (0x0590 <= charCode && charCode <= 0x05f4) {
	      charType = 'R';
	    } else if (0x0600 <= charCode && charCode <= 0x06ff) {
	      charType = arabicTypes[charCode & 0xff];
	      if (!charType) {
	        (0, _util.warn)('Bidi: invalid Unicode character ' + charCode.toString(16));
	      }
	    } else if (0x0700 <= charCode && charCode <= 0x08AC) {
	      charType = 'AL';
	    }
	    if (charType === 'R' || charType === 'AL' || charType === 'AN') {
	      numBidi++;
	    }
	    types[i] = charType;
	  }
	  if (numBidi === 0) {
	    isLTR = true;
	    return createBidiText(str, isLTR);
	  }
	  if (startLevel === -1) {
	    if (numBidi / strLength < 0.3) {
	      isLTR = true;
	      startLevel = 0;
	    } else {
	      isLTR = false;
	      startLevel = 1;
	    }
	  }
	  var levels = [];
	  for (i = 0; i < strLength; ++i) {
	    levels[i] = startLevel;
	  }
	  var e = isOdd(startLevel) ? 'R' : 'L';
	  var sor = e;
	  var eor = sor;
	  var lastType = sor;
	  for (i = 0; i < strLength; ++i) {
	    if (types[i] === 'NSM') {
	      types[i] = lastType;
	    } else {
	      lastType = types[i];
	    }
	  }
	  lastType = sor;
	  var t;
	  for (i = 0; i < strLength; ++i) {
	    t = types[i];
	    if (t === 'EN') {
	      types[i] = lastType === 'AL' ? 'AN' : 'EN';
	    } else if (t === 'R' || t === 'L' || t === 'AL') {
	      lastType = t;
	    }
	  }
	  for (i = 0; i < strLength; ++i) {
	    t = types[i];
	    if (t === 'AL') {
	      types[i] = 'R';
	    }
	  }
	  for (i = 1; i < strLength - 1; ++i) {
	    if (types[i] === 'ES' && types[i - 1] === 'EN' && types[i + 1] === 'EN') {
	      types[i] = 'EN';
	    }
	    if (types[i] === 'CS' && (types[i - 1] === 'EN' || types[i - 1] === 'AN') && types[i + 1] === types[i - 1]) {
	      types[i] = types[i - 1];
	    }
	  }
	  for (i = 0; i < strLength; ++i) {
	    if (types[i] === 'EN') {
	      var j;
	      for (j = i - 1; j >= 0; --j) {
	        if (types[j] !== 'ET') {
	          break;
	        }
	        types[j] = 'EN';
	      }
	      for (j = i + 1; j < strLength; ++j) {
	        if (types[j] !== 'ET') {
	          break;
	        }
	        types[j] = 'EN';
	      }
	    }
	  }
	  for (i = 0; i < strLength; ++i) {
	    t = types[i];
	    if (t === 'WS' || t === 'ES' || t === 'ET' || t === 'CS') {
	      types[i] = 'ON';
	    }
	  }
	  lastType = sor;
	  for (i = 0; i < strLength; ++i) {
	    t = types[i];
	    if (t === 'EN') {
	      types[i] = lastType === 'L' ? 'L' : 'EN';
	    } else if (t === 'R' || t === 'L') {
	      lastType = t;
	    }
	  }
	  for (i = 0; i < strLength; ++i) {
	    if (types[i] === 'ON') {
	      var end = findUnequal(types, i + 1, 'ON');
	      var before = sor;
	      if (i > 0) {
	        before = types[i - 1];
	      }
	      var after = eor;
	      if (end + 1 < strLength) {
	        after = types[end + 1];
	      }
	      if (before !== 'L') {
	        before = 'R';
	      }
	      if (after !== 'L') {
	        after = 'R';
	      }
	      if (before === after) {
	        setValues(types, i, end, before);
	      }
	      i = end - 1;
	    }
	  }
	  for (i = 0; i < strLength; ++i) {
	    if (types[i] === 'ON') {
	      types[i] = e;
	    }
	  }
	  for (i = 0; i < strLength; ++i) {
	    t = types[i];
	    if (isEven(levels[i])) {
	      if (t === 'R') {
	        levels[i] += 1;
	      } else if (t === 'AN' || t === 'EN') {
	        levels[i] += 2;
	      }
	    } else {
	      if (t === 'L' || t === 'AN' || t === 'EN') {
	        levels[i] += 1;
	      }
	    }
	  }
	  var highestLevel = -1;
	  var lowestOddLevel = 99;
	  var level;
	  for (i = 0, ii = levels.length; i < ii; ++i) {
	    level = levels[i];
	    if (highestLevel < level) {
	      highestLevel = level;
	    }
	    if (lowestOddLevel > level && isOdd(level)) {
	      lowestOddLevel = level;
	    }
	  }
	  for (level = highestLevel; level >= lowestOddLevel; --level) {
	    var start = -1;
	    for (i = 0, ii = levels.length; i < ii; ++i) {
	      if (levels[i] < level) {
	        if (start >= 0) {
	          reverseValues(chars, start, i);
	          start = -1;
	        }
	      } else if (start < 0) {
	        start = i;
	      }
	    }
	    if (start >= 0) {
	      reverseValues(chars, start, levels.length);
	    }
	  }
	  for (i = 0, ii = chars.length; i < ii; ++i) {
	    var ch = chars[i];
	    if (ch === '<' || ch === '>') {
	      chars[i] = '';
	    }
	  }
	  return createBidiText(chars.join(''), isLTR);
	}
	exports.bidi = bidi;
	
	/***/ }),
	/* 155 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMetrics = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var getMetrics = (0, _util.getLookupTableFactory)(function (t) {
	  t['Courier'] = 600;
	  t['Courier-Bold'] = 600;
	  t['Courier-BoldOblique'] = 600;
	  t['Courier-Oblique'] = 600;
	  t['Helvetica'] = (0, _util.getLookupTableFactory)(function (t) {
	    t['space'] = 278;
	    t['exclam'] = 278;
	    t['quotedbl'] = 355;
	    t['numbersign'] = 556;
	    t['dollar'] = 556;
	    t['percent'] = 889;
	    t['ampersand'] = 667;
	    t['quoteright'] = 222;
	    t['parenleft'] = 333;
	    t['parenright'] = 333;
	    t['asterisk'] = 389;
	    t['plus'] = 584;
	    t['comma'] = 278;
	    t['hyphen'] = 333;
	    t['period'] = 278;
	    t['slash'] = 278;
	    t['zero'] = 556;
	    t['one'] = 556;
	    t['two'] = 556;
	    t['three'] = 556;
	    t['four'] = 556;
	    t['five'] = 556;
	    t['six'] = 556;
	    t['seven'] = 556;
	    t['eight'] = 556;
	    t['nine'] = 556;
	    t['colon'] = 278;
	    t['semicolon'] = 278;
	    t['less'] = 584;
	    t['equal'] = 584;
	    t['greater'] = 584;
	    t['question'] = 556;
	    t['at'] = 1015;
	    t['A'] = 667;
	    t['B'] = 667;
	    t['C'] = 722;
	    t['D'] = 722;
	    t['E'] = 667;
	    t['F'] = 611;
	    t['G'] = 778;
	    t['H'] = 722;
	    t['I'] = 278;
	    t['J'] = 500;
	    t['K'] = 667;
	    t['L'] = 556;
	    t['M'] = 833;
	    t['N'] = 722;
	    t['O'] = 778;
	    t['P'] = 667;
	    t['Q'] = 778;
	    t['R'] = 722;
	    t['S'] = 667;
	    t['T'] = 611;
	    t['U'] = 722;
	    t['V'] = 667;
	    t['W'] = 944;
	    t['X'] = 667;
	    t['Y'] = 667;
	    t['Z'] = 611;
	    t['bracketleft'] = 278;
	    t['backslash'] = 278;
	    t['bracketright'] = 278;
	    t['asciicircum'] = 469;
	    t['underscore'] = 556;
	    t['quoteleft'] = 222;
	    t['a'] = 556;
	    t['b'] = 556;
	    t['c'] = 500;
	    t['d'] = 556;
	    t['e'] = 556;
	    t['f'] = 278;
	    t['g'] = 556;
	    t['h'] = 556;
	    t['i'] = 222;
	    t['j'] = 222;
	    t['k'] = 500;
	    t['l'] = 222;
	    t['m'] = 833;
	    t['n'] = 556;
	    t['o'] = 556;
	    t['p'] = 556;
	    t['q'] = 556;
	    t['r'] = 333;
	    t['s'] = 500;
	    t['t'] = 278;
	    t['u'] = 556;
	    t['v'] = 500;
	    t['w'] = 722;
	    t['x'] = 500;
	    t['y'] = 500;
	    t['z'] = 500;
	    t['braceleft'] = 334;
	    t['bar'] = 260;
	    t['braceright'] = 334;
	    t['asciitilde'] = 584;
	    t['exclamdown'] = 333;
	    t['cent'] = 556;
	    t['sterling'] = 556;
	    t['fraction'] = 167;
	    t['yen'] = 556;
	    t['florin'] = 556;
	    t['section'] = 556;
	    t['currency'] = 556;
	    t['quotesingle'] = 191;
	    t['quotedblleft'] = 333;
	    t['guillemotleft'] = 556;
	    t['guilsinglleft'] = 333;
	    t['guilsinglright'] = 333;
	    t['fi'] = 500;
	    t['fl'] = 500;
	    t['endash'] = 556;
	    t['dagger'] = 556;
	    t['daggerdbl'] = 556;
	    t['periodcentered'] = 278;
	    t['paragraph'] = 537;
	    t['bullet'] = 350;
	    t['quotesinglbase'] = 222;
	    t['quotedblbase'] = 333;
	    t['quotedblright'] = 333;
	    t['guillemotright'] = 556;
	    t['ellipsis'] = 1000;
	    t['perthousand'] = 1000;
	    t['questiondown'] = 611;
	    t['grave'] = 333;
	    t['acute'] = 333;
	    t['circumflex'] = 333;
	    t['tilde'] = 333;
	    t['macron'] = 333;
	    t['breve'] = 333;
	    t['dotaccent'] = 333;
	    t['dieresis'] = 333;
	    t['ring'] = 333;
	    t['cedilla'] = 333;
	    t['hungarumlaut'] = 333;
	    t['ogonek'] = 333;
	    t['caron'] = 333;
	    t['emdash'] = 1000;
	    t['AE'] = 1000;
	    t['ordfeminine'] = 370;
	    t['Lslash'] = 556;
	    t['Oslash'] = 778;
	    t['OE'] = 1000;
	    t['ordmasculine'] = 365;
	    t['ae'] = 889;
	    t['dotlessi'] = 278;
	    t['lslash'] = 222;
	    t['oslash'] = 611;
	    t['oe'] = 944;
	    t['germandbls'] = 611;
	    t['Idieresis'] = 278;
	    t['eacute'] = 556;
	    t['abreve'] = 556;
	    t['uhungarumlaut'] = 556;
	    t['ecaron'] = 556;
	    t['Ydieresis'] = 667;
	    t['divide'] = 584;
	    t['Yacute'] = 667;
	    t['Acircumflex'] = 667;
	    t['aacute'] = 556;
	    t['Ucircumflex'] = 722;
	    t['yacute'] = 500;
	    t['scommaaccent'] = 500;
	    t['ecircumflex'] = 556;
	    t['Uring'] = 722;
	    t['Udieresis'] = 722;
	    t['aogonek'] = 556;
	    t['Uacute'] = 722;
	    t['uogonek'] = 556;
	    t['Edieresis'] = 667;
	    t['Dcroat'] = 722;
	    t['commaaccent'] = 250;
	    t['copyright'] = 737;
	    t['Emacron'] = 667;
	    t['ccaron'] = 500;
	    t['aring'] = 556;
	    t['Ncommaaccent'] = 722;
	    t['lacute'] = 222;
	    t['agrave'] = 556;
	    t['Tcommaaccent'] = 611;
	    t['Cacute'] = 722;
	    t['atilde'] = 556;
	    t['Edotaccent'] = 667;
	    t['scaron'] = 500;
	    t['scedilla'] = 500;
	    t['iacute'] = 278;
	    t['lozenge'] = 471;
	    t['Rcaron'] = 722;
	    t['Gcommaaccent'] = 778;
	    t['ucircumflex'] = 556;
	    t['acircumflex'] = 556;
	    t['Amacron'] = 667;
	    t['rcaron'] = 333;
	    t['ccedilla'] = 500;
	    t['Zdotaccent'] = 611;
	    t['Thorn'] = 667;
	    t['Omacron'] = 778;
	    t['Racute'] = 722;
	    t['Sacute'] = 667;
	    t['dcaron'] = 643;
	    t['Umacron'] = 722;
	    t['uring'] = 556;
	    t['threesuperior'] = 333;
	    t['Ograve'] = 778;
	    t['Agrave'] = 667;
	    t['Abreve'] = 667;
	    t['multiply'] = 584;
	    t['uacute'] = 556;
	    t['Tcaron'] = 611;
	    t['partialdiff'] = 476;
	    t['ydieresis'] = 500;
	    t['Nacute'] = 722;
	    t['icircumflex'] = 278;
	    t['Ecircumflex'] = 667;
	    t['adieresis'] = 556;
	    t['edieresis'] = 556;
	    t['cacute'] = 500;
	    t['nacute'] = 556;
	    t['umacron'] = 556;
	    t['Ncaron'] = 722;
	    t['Iacute'] = 278;
	    t['plusminus'] = 584;
	    t['brokenbar'] = 260;
	    t['registered'] = 737;
	    t['Gbreve'] = 778;
	    t['Idotaccent'] = 278;
	    t['summation'] = 600;
	    t['Egrave'] = 667;
	    t['racute'] = 333;
	    t['omacron'] = 556;
	    t['Zacute'] = 611;
	    t['Zcaron'] = 611;
	    t['greaterequal'] = 549;
	    t['Eth'] = 722;
	    t['Ccedilla'] = 722;
	    t['lcommaaccent'] = 222;
	    t['tcaron'] = 317;
	    t['eogonek'] = 556;
	    t['Uogonek'] = 722;
	    t['Aacute'] = 667;
	    t['Adieresis'] = 667;
	    t['egrave'] = 556;
	    t['zacute'] = 500;
	    t['iogonek'] = 222;
	    t['Oacute'] = 778;
	    t['oacute'] = 556;
	    t['amacron'] = 556;
	    t['sacute'] = 500;
	    t['idieresis'] = 278;
	    t['Ocircumflex'] = 778;
	    t['Ugrave'] = 722;
	    t['Delta'] = 612;
	    t['thorn'] = 556;
	    t['twosuperior'] = 333;
	    t['Odieresis'] = 778;
	    t['mu'] = 556;
	    t['igrave'] = 278;
	    t['ohungarumlaut'] = 556;
	    t['Eogonek'] = 667;
	    t['dcroat'] = 556;
	    t['threequarters'] = 834;
	    t['Scedilla'] = 667;
	    t['lcaron'] = 299;
	    t['Kcommaaccent'] = 667;
	    t['Lacute'] = 556;
	    t['trademark'] = 1000;
	    t['edotaccent'] = 556;
	    t['Igrave'] = 278;
	    t['Imacron'] = 278;
	    t['Lcaron'] = 556;
	    t['onehalf'] = 834;
	    t['lessequal'] = 549;
	    t['ocircumflex'] = 556;
	    t['ntilde'] = 556;
	    t['Uhungarumlaut'] = 722;
	    t['Eacute'] = 667;
	    t['emacron'] = 556;
	    t['gbreve'] = 556;
	    t['onequarter'] = 834;
	    t['Scaron'] = 667;
	    t['Scommaaccent'] = 667;
	    t['Ohungarumlaut'] = 778;
	    t['degree'] = 400;
	    t['ograve'] = 556;
	    t['Ccaron'] = 722;
	    t['ugrave'] = 556;
	    t['radical'] = 453;
	    t['Dcaron'] = 722;
	    t['rcommaaccent'] = 333;
	    t['Ntilde'] = 722;
	    t['otilde'] = 556;
	    t['Rcommaaccent'] = 722;
	    t['Lcommaaccent'] = 556;
	    t['Atilde'] = 667;
	    t['Aogonek'] = 667;
	    t['Aring'] = 667;
	    t['Otilde'] = 778;
	    t['zdotaccent'] = 500;
	    t['Ecaron'] = 667;
	    t['Iogonek'] = 278;
	    t['kcommaaccent'] = 500;
	    t['minus'] = 584;
	    t['Icircumflex'] = 278;
	    t['ncaron'] = 556;
	    t['tcommaaccent'] = 278;
	    t['logicalnot'] = 584;
	    t['odieresis'] = 556;
	    t['udieresis'] = 556;
	    t['notequal'] = 549;
	    t['gcommaaccent'] = 556;
	    t['eth'] = 556;
	    t['zcaron'] = 500;
	    t['ncommaaccent'] = 556;
	    t['onesuperior'] = 333;
	    t['imacron'] = 278;
	    t['Euro'] = 556;
	  });
	  t['Helvetica-Bold'] = (0, _util.getLookupTableFactory)(function (t) {
	    t['space'] = 278;
	    t['exclam'] = 333;
	    t['quotedbl'] = 474;
	    t['numbersign'] = 556;
	    t['dollar'] = 556;
	    t['percent'] = 889;
	    t['ampersand'] = 722;
	    t['quoteright'] = 278;
	    t['parenleft'] = 333;
	    t['parenright'] = 333;
	    t['asterisk'] = 389;
	    t['plus'] = 584;
	    t['comma'] = 278;
	    t['hyphen'] = 333;
	    t['period'] = 278;
	    t['slash'] = 278;
	    t['zero'] = 556;
	    t['one'] = 556;
	    t['two'] = 556;
	    t['three'] = 556;
	    t['four'] = 556;
	    t['five'] = 556;
	    t['six'] = 556;
	    t['seven'] = 556;
	    t['eight'] = 556;
	    t['nine'] = 556;
	    t['colon'] = 333;
	    t['semicolon'] = 333;
	    t['less'] = 584;
	    t['equal'] = 584;
	    t['greater'] = 584;
	    t['question'] = 611;
	    t['at'] = 975;
	    t['A'] = 722;
	    t['B'] = 722;
	    t['C'] = 722;
	    t['D'] = 722;
	    t['E'] = 667;
	    t['F'] = 611;
	    t['G'] = 778;
	    t['H'] = 722;
	    t['I'] = 278;
	    t['J'] = 556;
	    t['K'] = 722;
	    t['L'] = 611;
	    t['M'] = 833;
	    t['N'] = 722;
	    t['O'] = 778;
	    t['P'] = 667;
	    t['Q'] = 778;
	    t['R'] = 722;
	    t['S'] = 667;
	    t['T'] = 611;
	    t['U'] = 722;
	    t['V'] = 667;
	    t['W'] = 944;
	    t['X'] = 667;
	    t['Y'] = 667;
	    t['Z'] = 611;
	    t['bracketleft'] = 333;
	    t['backslash'] = 278;
	    t['bracketright'] = 333;
	    t['asciicircum'] = 584;
	    t['underscore'] = 556;
	    t['quoteleft'] = 278;
	    t['a'] = 556;
	    t['b'] = 611;
	    t['c'] = 556;
	    t['d'] = 611;
	    t['e'] = 556;
	    t['f'] = 333;
	    t['g'] = 611;
	    t['h'] = 611;
	    t['i'] = 278;
	    t['j'] = 278;
	    t['k'] = 556;
	    t['l'] = 278;
	    t['m'] = 889;
	    t['n'] = 611;
	    t['o'] = 611;
	    t['p'] = 611;
	    t['q'] = 611;
	    t['r'] = 389;
	    t['s'] = 556;
	    t['t'] = 333;
	    t['u'] = 611;
	    t['v'] = 556;
	    t['w'] = 778;
	    t['x'] = 556;
	    t['y'] = 556;
	    t['z'] = 500;
	    t['braceleft'] = 389;
	    t['bar'] = 280;
	    t['braceright'] = 389;
	    t['asciitilde'] = 584;
	    t['exclamdown'] = 333;
	    t['cent'] = 556;
	    t['sterling'] = 556;
	    t['fraction'] = 167;
	    t['yen'] = 556;
	    t['florin'] = 556;
	    t['section'] = 556;
	    t['currency'] = 556;
	    t['quotesingle'] = 238;
	    t['quotedblleft'] = 500;
	    t['guillemotleft'] = 556;
	    t['guilsinglleft'] = 333;
	    t['guilsinglright'] = 333;
	    t['fi'] = 611;
	    t['fl'] = 611;
	    t['endash'] = 556;
	    t['dagger'] = 556;
	    t['daggerdbl'] = 556;
	    t['periodcentered'] = 278;
	    t['paragraph'] = 556;
	    t['bullet'] = 350;
	    t['quotesinglbase'] = 278;
	    t['quotedblbase'] = 500;
	    t['quotedblright'] = 500;
	    t['guillemotright'] = 556;
	    t['ellipsis'] = 1000;
	    t['perthousand'] = 1000;
	    t['questiondown'] = 611;
	    t['grave'] = 333;
	    t['acute'] = 333;
	    t['circumflex'] = 333;
	    t['tilde'] = 333;
	    t['macron'] = 333;
	    t['breve'] = 333;
	    t['dotaccent'] = 333;
	    t['dieresis'] = 333;
	    t['ring'] = 333;
	    t['cedilla'] = 333;
	    t['hungarumlaut'] = 333;
	    t['ogonek'] = 333;
	    t['caron'] = 333;
	    t['emdash'] = 1000;
	    t['AE'] = 1000;
	    t['ordfeminine'] = 370;
	    t['Lslash'] = 611;
	    t['Oslash'] = 778;
	    t['OE'] = 1000;
	    t['ordmasculine'] = 365;
	    t['ae'] = 889;
	    t['dotlessi'] = 278;
	    t['lslash'] = 278;
	    t['oslash'] = 611;
	    t['oe'] = 944;
	    t['germandbls'] = 611;
	    t['Idieresis'] = 278;
	    t['eacute'] = 556;
	    t['abreve'] = 556;
	    t['uhungarumlaut'] = 611;
	    t['ecaron'] = 556;
	    t['Ydieresis'] = 667;
	    t['divide'] = 584;
	    t['Yacute'] = 667;
	    t['Acircumflex'] = 722;
	    t['aacute'] = 556;
	    t['Ucircumflex'] = 722;
	    t['yacute'] = 556;
	    t['scommaaccent'] = 556;
	    t['ecircumflex'] = 556;
	    t['Uring'] = 722;
	    t['Udieresis'] = 722;
	    t['aogonek'] = 556;
	    t['Uacute'] = 722;
	    t['uogonek'] = 611;
	    t['Edieresis'] = 667;
	    t['Dcroat'] = 722;
	    t['commaaccent'] = 250;
	    t['copyright'] = 737;
	    t['Emacron'] = 667;
	    t['ccaron'] = 556;
	    t['aring'] = 556;
	    t['Ncommaaccent'] = 722;
	    t['lacute'] = 278;
	    t['agrave'] = 556;
	    t['Tcommaaccent'] = 611;
	    t['Cacute'] = 722;
	    t['atilde'] = 556;
	    t['Edotaccent'] = 667;
	    t['scaron'] = 556;
	    t['scedilla'] = 556;
	    t['iacute'] = 278;
	    t['lozenge'] = 494;
	    t['Rcaron'] = 722;
	    t['Gcommaaccent'] = 778;
	    t['ucircumflex'] = 611;
	    t['acircumflex'] = 556;
	    t['Amacron'] = 722;
	    t['rcaron'] = 389;
	    t['ccedilla'] = 556;
	    t['Zdotaccent'] = 611;
	    t['Thorn'] = 667;
	    t['Omacron'] = 778;
	    t['Racute'] = 722;
	    t['Sacute'] = 667;
	    t['dcaron'] = 743;
	    t['Umacron'] = 722;
	    t['uring'] = 611;
	    t['threesuperior'] = 333;
	    t['Ograve'] = 778;
	    t['Agrave'] = 722;
	    t['Abreve'] = 722;
	    t['multiply'] = 584;
	    t['uacute'] = 611;
	    t['Tcaron'] = 611;
	    t['partialdiff'] = 494;
	    t['ydieresis'] = 556;
	    t['Nacute'] = 722;
	    t['icircumflex'] = 278;
	    t['Ecircumflex'] = 667;
	    t['adieresis'] = 556;
	    t['edieresis'] = 556;
	    t['cacute'] = 556;
	    t['nacute'] = 611;
	    t['umacron'] = 611;
	    t['Ncaron'] = 722;
	    t['Iacute'] = 278;
	    t['plusminus'] = 584;
	    t['brokenbar'] = 280;
	    t['registered'] = 737;
	    t['Gbreve'] = 778;
	    t['Idotaccent'] = 278;
	    t['summation'] = 600;
	    t['Egrave'] = 667;
	    t['racute'] = 389;
	    t['omacron'] = 611;
	    t['Zacute'] = 611;
	    t['Zcaron'] = 611;
	    t['greaterequal'] = 549;
	    t['Eth'] = 722;
	    t['Ccedilla'] = 722;
	    t['lcommaaccent'] = 278;
	    t['tcaron'] = 389;
	    t['eogonek'] = 556;
	    t['Uogonek'] = 722;
	    t['Aacute'] = 722;
	    t['Adieresis'] = 722;
	    t['egrave'] = 556;
	    t['zacute'] = 500;
	    t['iogonek'] = 278;
	    t['Oacute'] = 778;
	    t['oacute'] = 611;
	    t['amacron'] = 556;
	    t['sacute'] = 556;
	    t['idieresis'] = 278;
	    t['Ocircumflex'] = 778;
	    t['Ugrave'] = 722;
	    t['Delta'] = 612;
	    t['thorn'] = 611;
	    t['twosuperior'] = 333;
	    t['Odieresis'] = 778;
	    t['mu'] = 611;
	    t['igrave'] = 278;
	    t['ohungarumlaut'] = 611;
	    t['Eogonek'] = 667;
	    t['dcroat'] = 611;
	    t['threequarters'] = 834;
	    t['Scedilla'] = 667;
	    t['lcaron'] = 400;
	    t['Kcommaaccent'] = 722;
	    t['Lacute'] = 611;
	    t['trademark'] = 1000;
	    t['edotaccent'] = 556;
	    t['Igrave'] = 278;
	    t['Imacron'] = 278;
	    t['Lcaron'] = 611;
	    t['onehalf'] = 834;
	    t['lessequal'] = 549;
	    t['ocircumflex'] = 611;
	    t['ntilde'] = 611;
	    t['Uhungarumlaut'] = 722;
	    t['Eacute'] = 667;
	    t['emacron'] = 556;
	    t['gbreve'] = 611;
	    t['onequarter'] = 834;
	    t['Scaron'] = 667;
	    t['Scommaaccent'] = 667;
	    t['Ohungarumlaut'] = 778;
	    t['degree'] = 400;
	    t['ograve'] = 611;
	    t['Ccaron'] = 722;
	    t['ugrave'] = 611;
	    t['radical'] = 549;
	    t['Dcaron'] = 722;
	    t['rcommaaccent'] = 389;
	    t['Ntilde'] = 722;
	    t['otilde'] = 611;
	    t['Rcommaaccent'] = 722;
	    t['Lcommaaccent'] = 611;
	    t['Atilde'] = 722;
	    t['Aogonek'] = 722;
	    t['Aring'] = 722;
	    t['Otilde'] = 778;
	    t['zdotaccent'] = 500;
	    t['Ecaron'] = 667;
	    t['Iogonek'] = 278;
	    t['kcommaaccent'] = 556;
	    t['minus'] = 584;
	    t['Icircumflex'] = 278;
	    t['ncaron'] = 611;
	    t['tcommaaccent'] = 333;
	    t['logicalnot'] = 584;
	    t['odieresis'] = 611;
	    t['udieresis'] = 611;
	    t['notequal'] = 549;
	    t['gcommaaccent'] = 611;
	    t['eth'] = 611;
	    t['zcaron'] = 500;
	    t['ncommaaccent'] = 611;
	    t['onesuperior'] = 333;
	    t['imacron'] = 278;
	    t['Euro'] = 556;
	  });
	  t['Helvetica-BoldOblique'] = (0, _util.getLookupTableFactory)(function (t) {
	    t['space'] = 278;
	    t['exclam'] = 333;
	    t['quotedbl'] = 474;
	    t['numbersign'] = 556;
	    t['dollar'] = 556;
	    t['percent'] = 889;
	    t['ampersand'] = 722;
	    t['quoteright'] = 278;
	    t['parenleft'] = 333;
	    t['parenright'] = 333;
	    t['asterisk'] = 389;
	    t['plus'] = 584;
	    t['comma'] = 278;
	    t['hyphen'] = 333;
	    t['period'] = 278;
	    t['slash'] = 278;
	    t['zero'] = 556;
	    t['one'] = 556;
	    t['two'] = 556;
	    t['three'] = 556;
	    t['four'] = 556;
	    t['five'] = 556;
	    t['six'] = 556;
	    t['seven'] = 556;
	    t['eight'] = 556;
	    t['nine'] = 556;
	    t['colon'] = 333;
	    t['semicolon'] = 333;
	    t['less'] = 584;
	    t['equal'] = 584;
	    t['greater'] = 584;
	    t['question'] = 611;
	    t['at'] = 975;
	    t['A'] = 722;
	    t['B'] = 722;
	    t['C'] = 722;
	    t['D'] = 722;
	    t['E'] = 667;
	    t['F'] = 611;
	    t['G'] = 778;
	    t['H'] = 722;
	    t['I'] = 278;
	    t['J'] = 556;
	    t['K'] = 722;
	    t['L'] = 611;
	    t['M'] = 833;
	    t['N'] = 722;
	    t['O'] = 778;
	    t['P'] = 667;
	    t['Q'] = 778;
	    t['R'] = 722;
	    t['S'] = 667;
	    t['T'] = 611;
	    t['U'] = 722;
	    t['V'] = 667;
	    t['W'] = 944;
	    t['X'] = 667;
	    t['Y'] = 667;
	    t['Z'] = 611;
	    t['bracketleft'] = 333;
	    t['backslash'] = 278;
	    t['bracketright'] = 333;
	    t['asciicircum'] = 584;
	    t['underscore'] = 556;
	    t['quoteleft'] = 278;
	    t['a'] = 556;
	    t['b'] = 611;
	    t['c'] = 556;
	    t['d'] = 611;
	    t['e'] = 556;
	    t['f'] = 333;
	    t['g'] = 611;
	    t['h'] = 611;
	    t['i'] = 278;
	    t['j'] = 278;
	    t['k'] = 556;
	    t['l'] = 278;
	    t['m'] = 889;
	    t['n'] = 611;
	    t['o'] = 611;
	    t['p'] = 611;
	    t['q'] = 611;
	    t['r'] = 389;
	    t['s'] = 556;
	    t['t'] = 333;
	    t['u'] = 611;
	    t['v'] = 556;
	    t['w'] = 778;
	    t['x'] = 556;
	    t['y'] = 556;
	    t['z'] = 500;
	    t['braceleft'] = 389;
	    t['bar'] = 280;
	    t['braceright'] = 389;
	    t['asciitilde'] = 584;
	    t['exclamdown'] = 333;
	    t['cent'] = 556;
	    t['sterling'] = 556;
	    t['fraction'] = 167;
	    t['yen'] = 556;
	    t['florin'] = 556;
	    t['section'] = 556;
	    t['currency'] = 556;
	    t['quotesingle'] = 238;
	    t['quotedblleft'] = 500;
	    t['guillemotleft'] = 556;
	    t['guilsinglleft'] = 333;
	    t['guilsinglright'] = 333;
	    t['fi'] = 611;
	    t['fl'] = 611;
	    t['endash'] = 556;
	    t['dagger'] = 556;
	    t['daggerdbl'] = 556;
	    t['periodcentered'] = 278;
	    t['paragraph'] = 556;
	    t['bullet'] = 350;
	    t['quotesinglbase'] = 278;
	    t['quotedblbase'] = 500;
	    t['quotedblright'] = 500;
	    t['guillemotright'] = 556;
	    t['ellipsis'] = 1000;
	    t['perthousand'] = 1000;
	    t['questiondown'] = 611;
	    t['grave'] = 333;
	    t['acute'] = 333;
	    t['circumflex'] = 333;
	    t['tilde'] = 333;
	    t['macron'] = 333;
	    t['breve'] = 333;
	    t['dotaccent'] = 333;
	    t['dieresis'] = 333;
	    t['ring'] = 333;
	    t['cedilla'] = 333;
	    t['hungarumlaut'] = 333;
	    t['ogonek'] = 333;
	    t['caron'] = 333;
	    t['emdash'] = 1000;
	    t['AE'] = 1000;
	    t['ordfeminine'] = 370;
	    t['Lslash'] = 611;
	    t['Oslash'] = 778;
	    t['OE'] = 1000;
	    t['ordmasculine'] = 365;
	    t['ae'] = 889;
	    t['dotlessi'] = 278;
	    t['lslash'] = 278;
	    t['oslash'] = 611;
	    t['oe'] = 944;
	    t['germandbls'] = 611;
	    t['Idieresis'] = 278;
	    t['eacute'] = 556;
	    t['abreve'] = 556;
	    t['uhungarumlaut'] = 611;
	    t['ecaron'] = 556;
	    t['Ydieresis'] = 667;
	    t['divide'] = 584;
	    t['Yacute'] = 667;
	    t['Acircumflex'] = 722;
	    t['aacute'] = 556;
	    t['Ucircumflex'] = 722;
	    t['yacute'] = 556;
	    t['scommaaccent'] = 556;
	    t['ecircumflex'] = 556;
	    t['Uring'] = 722;
	    t['Udieresis'] = 722;
	    t['aogonek'] = 556;
	    t['Uacute'] = 722;
	    t['uogonek'] = 611;
	    t['Edieresis'] = 667;
	    t['Dcroat'] = 722;
	    t['commaaccent'] = 250;
	    t['copyright'] = 737;
	    t['Emacron'] = 667;
	    t['ccaron'] = 556;
	    t['aring'] = 556;
	    t['Ncommaaccent'] = 722;
	    t['lacute'] = 278;
	    t['agrave'] = 556;
	    t['Tcommaaccent'] = 611;
	    t['Cacute'] = 722;
	    t['atilde'] = 556;
	    t['Edotaccent'] = 667;
	    t['scaron'] = 556;
	    t['scedilla'] = 556;
	    t['iacute'] = 278;
	    t['lozenge'] = 494;
	    t['Rcaron'] = 722;
	    t['Gcommaaccent'] = 778;
	    t['ucircumflex'] = 611;
	    t['acircumflex'] = 556;
	    t['Amacron'] = 722;
	    t['rcaron'] = 389;
	    t['ccedilla'] = 556;
	    t['Zdotaccent'] = 611;
	    t['Thorn'] = 667;
	    t['Omacron'] = 778;
	    t['Racute'] = 722;
	    t['Sacute'] = 667;
	    t['dcaron'] = 743;
	    t['Umacron'] = 722;
	    t['uring'] = 611;
	    t['threesuperior'] = 333;
	    t['Ograve'] = 778;
	    t['Agrave'] = 722;
	    t['Abreve'] = 722;
	    t['multiply'] = 584;
	    t['uacute'] = 611;
	    t['Tcaron'] = 611;
	    t['partialdiff'] = 494;
	    t['ydieresis'] = 556;
	    t['Nacute'] = 722;
	    t['icircumflex'] = 278;
	    t['Ecircumflex'] = 667;
	    t['adieresis'] = 556;
	    t['edieresis'] = 556;
	    t['cacute'] = 556;
	    t['nacute'] = 611;
	    t['umacron'] = 611;
	    t['Ncaron'] = 722;
	    t['Iacute'] = 278;
	    t['plusminus'] = 584;
	    t['brokenbar'] = 280;
	    t['registered'] = 737;
	    t['Gbreve'] = 778;
	    t['Idotaccent'] = 278;
	    t['summation'] = 600;
	    t['Egrave'] = 667;
	    t['racute'] = 389;
	    t['omacron'] = 611;
	    t['Zacute'] = 611;
	    t['Zcaron'] = 611;
	    t['greaterequal'] = 549;
	    t['Eth'] = 722;
	    t['Ccedilla'] = 722;
	    t['lcommaaccent'] = 278;
	    t['tcaron'] = 389;
	    t['eogonek'] = 556;
	    t['Uogonek'] = 722;
	    t['Aacute'] = 722;
	    t['Adieresis'] = 722;
	    t['egrave'] = 556;
	    t['zacute'] = 500;
	    t['iogonek'] = 278;
	    t['Oacute'] = 778;
	    t['oacute'] = 611;
	    t['amacron'] = 556;
	    t['sacute'] = 556;
	    t['idieresis'] = 278;
	    t['Ocircumflex'] = 778;
	    t['Ugrave'] = 722;
	    t['Delta'] = 612;
	    t['thorn'] = 611;
	    t['twosuperior'] = 333;
	    t['Odieresis'] = 778;
	    t['mu'] = 611;
	    t['igrave'] = 278;
	    t['ohungarumlaut'] = 611;
	    t['Eogonek'] = 667;
	    t['dcroat'] = 611;
	    t['threequarters'] = 834;
	    t['Scedilla'] = 667;
	    t['lcaron'] = 400;
	    t['Kcommaaccent'] = 722;
	    t['Lacute'] = 611;
	    t['trademark'] = 1000;
	    t['edotaccent'] = 556;
	    t['Igrave'] = 278;
	    t['Imacron'] = 278;
	    t['Lcaron'] = 611;
	    t['onehalf'] = 834;
	    t['lessequal'] = 549;
	    t['ocircumflex'] = 611;
	    t['ntilde'] = 611;
	    t['Uhungarumlaut'] = 722;
	    t['Eacute'] = 667;
	    t['emacron'] = 556;
	    t['gbreve'] = 611;
	    t['onequarter'] = 834;
	    t['Scaron'] = 667;
	    t['Scommaaccent'] = 667;
	    t['Ohungarumlaut'] = 778;
	    t['degree'] = 400;
	    t['ograve'] = 611;
	    t['Ccaron'] = 722;
	    t['ugrave'] = 611;
	    t['radical'] = 549;
	    t['Dcaron'] = 722;
	    t['rcommaaccent'] = 389;
	    t['Ntilde'] = 722;
	    t['otilde'] = 611;
	    t['Rcommaaccent'] = 722;
	    t['Lcommaaccent'] = 611;
	    t['Atilde'] = 722;
	    t['Aogonek'] = 722;
	    t['Aring'] = 722;
	    t['Otilde'] = 778;
	    t['zdotaccent'] = 500;
	    t['Ecaron'] = 667;
	    t['Iogonek'] = 278;
	    t['kcommaaccent'] = 556;
	    t['minus'] = 584;
	    t['Icircumflex'] = 278;
	    t['ncaron'] = 611;
	    t['tcommaaccent'] = 333;
	    t['logicalnot'] = 584;
	    t['odieresis'] = 611;
	    t['udieresis'] = 611;
	    t['notequal'] = 549;
	    t['gcommaaccent'] = 611;
	    t['eth'] = 611;
	    t['zcaron'] = 500;
	    t['ncommaaccent'] = 611;
	    t['onesuperior'] = 333;
	    t['imacron'] = 278;
	    t['Euro'] = 556;
	  });
	  t['Helvetica-Oblique'] = (0, _util.getLookupTableFactory)(function (t) {
	    t['space'] = 278;
	    t['exclam'] = 278;
	    t['quotedbl'] = 355;
	    t['numbersign'] = 556;
	    t['dollar'] = 556;
	    t['percent'] = 889;
	    t['ampersand'] = 667;
	    t['quoteright'] = 222;
	    t['parenleft'] = 333;
	    t['parenright'] = 333;
	    t['asterisk'] = 389;
	    t['plus'] = 584;
	    t['comma'] = 278;
	    t['hyphen'] = 333;
	    t['period'] = 278;
	    t['slash'] = 278;
	    t['zero'] = 556;
	    t['one'] = 556;
	    t['two'] = 556;
	    t['three'] = 556;
	    t['four'] = 556;
	    t['five'] = 556;
	    t['six'] = 556;
	    t['seven'] = 556;
	    t['eight'] = 556;
	    t['nine'] = 556;
	    t['colon'] = 278;
	    t['semicolon'] = 278;
	    t['less'] = 584;
	    t['equal'] = 584;
	    t['greater'] = 584;
	    t['question'] = 556;
	    t['at'] = 1015;
	    t['A'] = 667;
	    t['B'] = 667;
	    t['C'] = 722;
	    t['D'] = 722;
	    t['E'] = 667;
	    t['F'] = 611;
	    t['G'] = 778;
	    t['H'] = 722;
	    t['I'] = 278;
	    t['J'] = 500;
	    t['K'] = 667;
	    t['L'] = 556;
	    t['M'] = 833;
	    t['N'] = 722;
	    t['O'] = 778;
	    t['P'] = 667;
	    t['Q'] = 778;
	    t['R'] = 722;
	    t['S'] = 667;
	    t['T'] = 611;
	    t['U'] = 722;
	    t['V'] = 667;
	    t['W'] = 944;
	    t['X'] = 667;
	    t['Y'] = 667;
	    t['Z'] = 611;
	    t['bracketleft'] = 278;
	    t['backslash'] = 278;
	    t['bracketright'] = 278;
	    t['asciicircum'] = 469;
	    t['underscore'] = 556;
	    t['quoteleft'] = 222;
	    t['a'] = 556;
	    t['b'] = 556;
	    t['c'] = 500;
	    t['d'] = 556;
	    t['e'] = 556;
	    t['f'] = 278;
	    t['g'] = 556;
	    t['h'] = 556;
	    t['i'] = 222;
	    t['j'] = 222;
	    t['k'] = 500;
	    t['l'] = 222;
	    t['m'] = 833;
	    t['n'] = 556;
	    t['o'] = 556;
	    t['p'] = 556;
	    t['q'] = 556;
	    t['r'] = 333;
	    t['s'] = 500;
	    t['t'] = 278;
	    t['u'] = 556;
	    t['v'] = 500;
	    t['w'] = 722;
	    t['x'] = 500;
	    t['y'] = 500;
	    t['z'] = 500;
	    t['braceleft'] = 334;
	    t['bar'] = 260;
	    t['braceright'] = 334;
	    t['asciitilde'] = 584;
	    t['exclamdown'] = 333;
	    t['cent'] = 556;
	    t['sterling'] = 556;
	    t['fraction'] = 167;
	    t['yen'] = 556;
	    t['florin'] = 556;
	    t['section'] = 556;
	    t['currency'] = 556;
	    t['quotesingle'] = 191;
	    t['quotedblleft'] = 333;
	    t['guillemotleft'] = 556;
	    t['guilsinglleft'] = 333;
	    t['guilsinglright'] = 333;
	    t['fi'] = 500;
	    t['fl'] = 500;
	    t['endash'] = 556;
	    t['dagger'] = 556;
	    t['daggerdbl'] = 556;
	    t['periodcentered'] = 278;
	    t['paragraph'] = 537;
	    t['bullet'] = 350;
	    t['quotesinglbase'] = 222;
	    t['quotedblbase'] = 333;
	    t['quotedblright'] = 333;
	    t['guillemotright'] = 556;
	    t['ellipsis'] = 1000;
	    t['perthousand'] = 1000;
	    t['questiondown'] = 611;
	    t['grave'] = 333;
	    t['acute'] = 333;
	    t['circumflex'] = 333;
	    t['tilde'] = 333;
	    t['macron'] = 333;
	    t['breve'] = 333;
	    t['dotaccent'] = 333;
	    t['dieresis'] = 333;
	    t['ring'] = 333;
	    t['cedilla'] = 333;
	    t['hungarumlaut'] = 333;
	    t['ogonek'] = 333;
	    t['caron'] = 333;
	    t['emdash'] = 1000;
	    t['AE'] = 1000;
	    t['ordfeminine'] = 370;
	    t['Lslash'] = 556;
	    t['Oslash'] = 778;
	    t['OE'] = 1000;
	    t['ordmasculine'] = 365;
	    t['ae'] = 889;
	    t['dotlessi'] = 278;
	    t['lslash'] = 222;
	    t['oslash'] = 611;
	    t['oe'] = 944;
	    t['germandbls'] = 611;
	    t['Idieresis'] = 278;
	    t['eacute'] = 556;
	    t['abreve'] = 556;
	    t['uhungarumlaut'] = 556;
	    t['ecaron'] = 556;
	    t['Ydieresis'] = 667;
	    t['divide'] = 584;
	    t['Yacute'] = 667;
	    t['Acircumflex'] = 667;
	    t['aacute'] = 556;
	    t['Ucircumflex'] = 722;
	    t['yacute'] = 500;
	    t['scommaaccent'] = 500;
	    t['ecircumflex'] = 556;
	    t['Uring'] = 722;
	    t['Udieresis'] = 722;
	    t['aogonek'] = 556;
	    t['Uacute'] = 722;
	    t['uogonek'] = 556;
	    t['Edieresis'] = 667;
	    t['Dcroat'] = 722;
	    t['commaaccent'] = 250;
	    t['copyright'] = 737;
	    t['Emacron'] = 667;
	    t['ccaron'] = 500;
	    t['aring'] = 556;
	    t['Ncommaaccent'] = 722;
	    t['lacute'] = 222;
	    t['agrave'] = 556;
	    t['Tcommaaccent'] = 611;
	    t['Cacute'] = 722;
	    t['atilde'] = 556;
	    t['Edotaccent'] = 667;
	    t['scaron'] = 500;
	    t['scedilla'] = 500;
	    t['iacute'] = 278;
	    t['lozenge'] = 471;
	    t['Rcaron'] = 722;
	    t['Gcommaaccent'] = 778;
	    t['ucircumflex'] = 556;
	    t['acircumflex'] = 556;
	    t['Amacron'] = 667;
	    t['rcaron'] = 333;
	    t['ccedilla'] = 500;
	    t['Zdotaccent'] = 611;
	    t['Thorn'] = 667;
	    t['Omacron'] = 778;
	    t['Racute'] = 722;
	    t['Sacute'] = 667;
	    t['dcaron'] = 643;
	    t['Umacron'] = 722;
	    t['uring'] = 556;
	    t['threesuperior'] = 333;
	    t['Ograve'] = 778;
	    t['Agrave'] = 667;
	    t['Abreve'] = 667;
	    t['multiply'] = 584;
	    t['uacute'] = 556;
	    t['Tcaron'] = 611;
	    t['partialdiff'] = 476;
	    t['ydieresis'] = 500;
	    t['Nacute'] = 722;
	    t['icircumflex'] = 278;
	    t['Ecircumflex'] = 667;
	    t['adieresis'] = 556;
	    t['edieresis'] = 556;
	    t['cacute'] = 500;
	    t['nacute'] = 556;
	    t['umacron'] = 556;
	    t['Ncaron'] = 722;
	    t['Iacute'] = 278;
	    t['plusminus'] = 584;
	    t['brokenbar'] = 260;
	    t['registered'] = 737;
	    t['Gbreve'] = 778;
	    t['Idotaccent'] = 278;
	    t['summation'] = 600;
	    t['Egrave'] = 667;
	    t['racute'] = 333;
	    t['omacron'] = 556;
	    t['Zacute'] = 611;
	    t['Zcaron'] = 611;
	    t['greaterequal'] = 549;
	    t['Eth'] = 722;
	    t['Ccedilla'] = 722;
	    t['lcommaaccent'] = 222;
	    t['tcaron'] = 317;
	    t['eogonek'] = 556;
	    t['Uogonek'] = 722;
	    t['Aacute'] = 667;
	    t['Adieresis'] = 667;
	    t['egrave'] = 556;
	    t['zacute'] = 500;
	    t['iogonek'] = 222;
	    t['Oacute'] = 778;
	    t['oacute'] = 556;
	    t['amacron'] = 556;
	    t['sacute'] = 500;
	    t['idieresis'] = 278;
	    t['Ocircumflex'] = 778;
	    t['Ugrave'] = 722;
	    t['Delta'] = 612;
	    t['thorn'] = 556;
	    t['twosuperior'] = 333;
	    t['Odieresis'] = 778;
	    t['mu'] = 556;
	    t['igrave'] = 278;
	    t['ohungarumlaut'] = 556;
	    t['Eogonek'] = 667;
	    t['dcroat'] = 556;
	    t['threequarters'] = 834;
	    t['Scedilla'] = 667;
	    t['lcaron'] = 299;
	    t['Kcommaaccent'] = 667;
	    t['Lacute'] = 556;
	    t['trademark'] = 1000;
	    t['edotaccent'] = 556;
	    t['Igrave'] = 278;
	    t['Imacron'] = 278;
	    t['Lcaron'] = 556;
	    t['onehalf'] = 834;
	    t['lessequal'] = 549;
	    t['ocircumflex'] = 556;
	    t['ntilde'] = 556;
	    t['Uhungarumlaut'] = 722;
	    t['Eacute'] = 667;
	    t['emacron'] = 556;
	    t['gbreve'] = 556;
	    t['onequarter'] = 834;
	    t['Scaron'] = 667;
	    t['Scommaaccent'] = 667;
	    t['Ohungarumlaut'] = 778;
	    t['degree'] = 400;
	    t['ograve'] = 556;
	    t['Ccaron'] = 722;
	    t['ugrave'] = 556;
	    t['radical'] = 453;
	    t['Dcaron'] = 722;
	    t['rcommaaccent'] = 333;
	    t['Ntilde'] = 722;
	    t['otilde'] = 556;
	    t['Rcommaaccent'] = 722;
	    t['Lcommaaccent'] = 556;
	    t['Atilde'] = 667;
	    t['Aogonek'] = 667;
	    t['Aring'] = 667;
	    t['Otilde'] = 778;
	    t['zdotaccent'] = 500;
	    t['Ecaron'] = 667;
	    t['Iogonek'] = 278;
	    t['kcommaaccent'] = 500;
	    t['minus'] = 584;
	    t['Icircumflex'] = 278;
	    t['ncaron'] = 556;
	    t['tcommaaccent'] = 278;
	    t['logicalnot'] = 584;
	    t['odieresis'] = 556;
	    t['udieresis'] = 556;
	    t['notequal'] = 549;
	    t['gcommaaccent'] = 556;
	    t['eth'] = 556;
	    t['zcaron'] = 500;
	    t['ncommaaccent'] = 556;
	    t['onesuperior'] = 333;
	    t['imacron'] = 278;
	    t['Euro'] = 556;
	  });
	  t['Symbol'] = (0, _util.getLookupTableFactory)(function (t) {
	    t['space'] = 250;
	    t['exclam'] = 333;
	    t['universal'] = 713;
	    t['numbersign'] = 500;
	    t['existential'] = 549;
	    t['percent'] = 833;
	    t['ampersand'] = 778;
	    t['suchthat'] = 439;
	    t['parenleft'] = 333;
	    t['parenright'] = 333;
	    t['asteriskmath'] = 500;
	    t['plus'] = 549;
	    t['comma'] = 250;
	    t['minus'] = 549;
	    t['period'] = 250;
	    t['slash'] = 278;
	    t['zero'] = 500;
	    t['one'] = 500;
	    t['two'] = 500;
	    t['three'] = 500;
	    t['four'] = 500;
	    t['five'] = 500;
	    t['six'] = 500;
	    t['seven'] = 500;
	    t['eight'] = 500;
	    t['nine'] = 500;
	    t['colon'] = 278;
	    t['semicolon'] = 278;
	    t['less'] = 549;
	    t['equal'] = 549;
	    t['greater'] = 549;
	    t['question'] = 444;
	    t['congruent'] = 549;
	    t['Alpha'] = 722;
	    t['Beta'] = 667;
	    t['Chi'] = 722;
	    t['Delta'] = 612;
	    t['Epsilon'] = 611;
	    t['Phi'] = 763;
	    t['Gamma'] = 603;
	    t['Eta'] = 722;
	    t['Iota'] = 333;
	    t['theta1'] = 631;
	    t['Kappa'] = 722;
	    t['Lambda'] = 686;
	    t['Mu'] = 889;
	    t['Nu'] = 722;
	    t['Omicron'] = 722;
	    t['Pi'] = 768;
	    t['Theta'] = 741;
	    t['Rho'] = 556;
	    t['Sigma'] = 592;
	    t['Tau'] = 611;
	    t['Upsilon'] = 690;
	    t['sigma1'] = 439;
	    t['Omega'] = 768;
	    t['Xi'] = 645;
	    t['Psi'] = 795;
	    t['Zeta'] = 611;
	    t['bracketleft'] = 333;
	    t['therefore'] = 863;
	    t['bracketright'] = 333;
	    t['perpendicular'] = 658;
	    t['underscore'] = 500;
	    t['radicalex'] = 500;
	    t['alpha'] = 631;
	    t['beta'] = 549;
	    t['chi'] = 549;
	    t['delta'] = 494;
	    t['epsilon'] = 439;
	    t['phi'] = 521;
	    t['gamma'] = 411;
	    t['eta'] = 603;
	    t['iota'] = 329;
	    t['phi1'] = 603;
	    t['kappa'] = 549;
	    t['lambda'] = 549;
	    t['mu'] = 576;
	    t['nu'] = 521;
	    t['omicron'] = 549;
	    t['pi'] = 549;
	    t['theta'] = 521;
	    t['rho'] = 549;
	    t['sigma'] = 603;
	    t['tau'] = 439;
	    t['upsilon'] = 576;
	    t['omega1'] = 713;
	    t['omega'] = 686;
	    t['xi'] = 493;
	    t['psi'] = 686;
	    t['zeta'] = 494;
	    t['braceleft'] = 480;
	    t['bar'] = 200;
	    t['braceright'] = 480;
	    t['similar'] = 549;
	    t['Euro'] = 750;
	    t['Upsilon1'] = 620;
	    t['minute'] = 247;
	    t['lessequal'] = 549;
	    t['fraction'] = 167;
	    t['infinity'] = 713;
	    t['florin'] = 500;
	    t['club'] = 753;
	    t['diamond'] = 753;
	    t['heart'] = 753;
	    t['spade'] = 753;
	    t['arrowboth'] = 1042;
	    t['arrowleft'] = 987;
	    t['arrowup'] = 603;
	    t['arrowright'] = 987;
	    t['arrowdown'] = 603;
	    t['degree'] = 400;
	    t['plusminus'] = 549;
	    t['second'] = 411;
	    t['greaterequal'] = 549;
	    t['multiply'] = 549;
	    t['proportional'] = 713;
	    t['partialdiff'] = 494;
	    t['bullet'] = 460;
	    t['divide'] = 549;
	    t['notequal'] = 549;
	    t['equivalence'] = 549;
	    t['approxequal'] = 549;
	    t['ellipsis'] = 1000;
	    t['arrowvertex'] = 603;
	    t['arrowhorizex'] = 1000;
	    t['carriagereturn'] = 658;
	    t['aleph'] = 823;
	    t['Ifraktur'] = 686;
	    t['Rfraktur'] = 795;
	    t['weierstrass'] = 987;
	    t['circlemultiply'] = 768;
	    t['circleplus'] = 768;
	    t['emptyset'] = 823;
	    t['intersection'] = 768;
	    t['union'] = 768;
	    t['propersuperset'] = 713;
	    t['reflexsuperset'] = 713;
	    t['notsubset'] = 713;
	    t['propersubset'] = 713;
	    t['reflexsubset'] = 713;
	    t['element'] = 713;
	    t['notelement'] = 713;
	    t['angle'] = 768;
	    t['gradient'] = 713;
	    t['registerserif'] = 790;
	    t['copyrightserif'] = 790;
	    t['trademarkserif'] = 890;
	    t['product'] = 823;
	    t['radical'] = 549;
	    t['dotmath'] = 250;
	    t['logicalnot'] = 713;
	    t['logicaland'] = 603;
	    t['logicalor'] = 603;
	    t['arrowdblboth'] = 1042;
	    t['arrowdblleft'] = 987;
	    t['arrowdblup'] = 603;
	    t['arrowdblright'] = 987;
	    t['arrowdbldown'] = 603;
	    t['lozenge'] = 494;
	    t['angleleft'] = 329;
	    t['registersans'] = 790;
	    t['copyrightsans'] = 790;
	    t['trademarksans'] = 786;
	    t['summation'] = 713;
	    t['parenlefttp'] = 384;
	    t['parenleftex'] = 384;
	    t['parenleftbt'] = 384;
	    t['bracketlefttp'] = 384;
	    t['bracketleftex'] = 384;
	    t['bracketleftbt'] = 384;
	    t['bracelefttp'] = 494;
	    t['braceleftmid'] = 494;
	    t['braceleftbt'] = 494;
	    t['braceex'] = 494;
	    t['angleright'] = 329;
	    t['integral'] = 274;
	    t['integraltp'] = 686;
	    t['integralex'] = 686;
	    t['integralbt'] = 686;
	    t['parenrighttp'] = 384;
	    t['parenrightex'] = 384;
	    t['parenrightbt'] = 384;
	    t['bracketrighttp'] = 384;
	    t['bracketrightex'] = 384;
	    t['bracketrightbt'] = 384;
	    t['bracerighttp'] = 494;
	    t['bracerightmid'] = 494;
	    t['bracerightbt'] = 494;
	    t['apple'] = 790;
	  });
	  t['Times-Roman'] = (0, _util.getLookupTableFactory)(function (t) {
	    t['space'] = 250;
	    t['exclam'] = 333;
	    t['quotedbl'] = 408;
	    t['numbersign'] = 500;
	    t['dollar'] = 500;
	    t['percent'] = 833;
	    t['ampersand'] = 778;
	    t['quoteright'] = 333;
	    t['parenleft'] = 333;
	    t['parenright'] = 333;
	    t['asterisk'] = 500;
	    t['plus'] = 564;
	    t['comma'] = 250;
	    t['hyphen'] = 333;
	    t['period'] = 250;
	    t['slash'] = 278;
	    t['zero'] = 500;
	    t['one'] = 500;
	    t['two'] = 500;
	    t['three'] = 500;
	    t['four'] = 500;
	    t['five'] = 500;
	    t['six'] = 500;
	    t['seven'] = 500;
	    t['eight'] = 500;
	    t['nine'] = 500;
	    t['colon'] = 278;
	    t['semicolon'] = 278;
	    t['less'] = 564;
	    t['equal'] = 564;
	    t['greater'] = 564;
	    t['question'] = 444;
	    t['at'] = 921;
	    t['A'] = 722;
	    t['B'] = 667;
	    t['C'] = 667;
	    t['D'] = 722;
	    t['E'] = 611;
	    t['F'] = 556;
	    t['G'] = 722;
	    t['H'] = 722;
	    t['I'] = 333;
	    t['J'] = 389;
	    t['K'] = 722;
	    t['L'] = 611;
	    t['M'] = 889;
	    t['N'] = 722;
	    t['O'] = 722;
	    t['P'] = 556;
	    t['Q'] = 722;
	    t['R'] = 667;
	    t['S'] = 556;
	    t['T'] = 611;
	    t['U'] = 722;
	    t['V'] = 722;
	    t['W'] = 944;
	    t['X'] = 722;
	    t['Y'] = 722;
	    t['Z'] = 611;
	    t['bracketleft'] = 333;
	    t['backslash'] = 278;
	    t['bracketright'] = 333;
	    t['asciicircum'] = 469;
	    t['underscore'] = 500;
	    t['quoteleft'] = 333;
	    t['a'] = 444;
	    t['b'] = 500;
	    t['c'] = 444;
	    t['d'] = 500;
	    t['e'] = 444;
	    t['f'] = 333;
	    t['g'] = 500;
	    t['h'] = 500;
	    t['i'] = 278;
	    t['j'] = 278;
	    t['k'] = 500;
	    t['l'] = 278;
	    t['m'] = 778;
	    t['n'] = 500;
	    t['o'] = 500;
	    t['p'] = 500;
	    t['q'] = 500;
	    t['r'] = 333;
	    t['s'] = 389;
	    t['t'] = 278;
	    t['u'] = 500;
	    t['v'] = 500;
	    t['w'] = 722;
	    t['x'] = 500;
	    t['y'] = 500;
	    t['z'] = 444;
	    t['braceleft'] = 480;
	    t['bar'] = 200;
	    t['braceright'] = 480;
	    t['asciitilde'] = 541;
	    t['exclamdown'] = 333;
	    t['cent'] = 500;
	    t['sterling'] = 500;
	    t['fraction'] = 167;
	    t['yen'] = 500;
	    t['florin'] = 500;
	    t['section'] = 500;
	    t['currency'] = 500;
	    t['quotesingle'] = 180;
	    t['quotedblleft'] = 444;
	    t['guillemotleft'] = 500;
	    t['guilsinglleft'] = 333;
	    t['guilsinglright'] = 333;
	    t['fi'] = 556;
	    t['fl'] = 556;
	    t['endash'] = 500;
	    t['dagger'] = 500;
	    t['daggerdbl'] = 500;
	    t['periodcentered'] = 250;
	    t['paragraph'] = 453;
	    t['bullet'] = 350;
	    t['quotesinglbase'] = 333;
	    t['quotedblbase'] = 444;
	    t['quotedblright'] = 444;
	    t['guillemotright'] = 500;
	    t['ellipsis'] = 1000;
	    t['perthousand'] = 1000;
	    t['questiondown'] = 444;
	    t['grave'] = 333;
	    t['acute'] = 333;
	    t['circumflex'] = 333;
	    t['tilde'] = 333;
	    t['macron'] = 333;
	    t['breve'] = 333;
	    t['dotaccent'] = 333;
	    t['dieresis'] = 333;
	    t['ring'] = 333;
	    t['cedilla'] = 333;
	    t['hungarumlaut'] = 333;
	    t['ogonek'] = 333;
	    t['caron'] = 333;
	    t['emdash'] = 1000;
	    t['AE'] = 889;
	    t['ordfeminine'] = 276;
	    t['Lslash'] = 611;
	    t['Oslash'] = 722;
	    t['OE'] = 889;
	    t['ordmasculine'] = 310;
	    t['ae'] = 667;
	    t['dotlessi'] = 278;
	    t['lslash'] = 278;
	    t['oslash'] = 500;
	    t['oe'] = 722;
	    t['germandbls'] = 500;
	    t['Idieresis'] = 333;
	    t['eacute'] = 444;
	    t['abreve'] = 444;
	    t['uhungarumlaut'] = 500;
	    t['ecaron'] = 444;
	    t['Ydieresis'] = 722;
	    t['divide'] = 564;
	    t['Yacute'] = 722;
	    t['Acircumflex'] = 722;
	    t['aacute'] = 444;
	    t['Ucircumflex'] = 722;
	    t['yacute'] = 500;
	    t['scommaaccent'] = 389;
	    t['ecircumflex'] = 444;
	    t['Uring'] = 722;
	    t['Udieresis'] = 722;
	    t['aogonek'] = 444;
	    t['Uacute'] = 722;
	    t['uogonek'] = 500;
	    t['Edieresis'] = 611;
	    t['Dcroat'] = 722;
	    t['commaaccent'] = 250;
	    t['copyright'] = 760;
	    t['Emacron'] = 611;
	    t['ccaron'] = 444;
	    t['aring'] = 444;
	    t['Ncommaaccent'] = 722;
	    t['lacute'] = 278;
	    t['agrave'] = 444;
	    t['Tcommaaccent'] = 611;
	    t['Cacute'] = 667;
	    t['atilde'] = 444;
	    t['Edotaccent'] = 611;
	    t['scaron'] = 389;
	    t['scedilla'] = 389;
	    t['iacute'] = 278;
	    t['lozenge'] = 471;
	    t['Rcaron'] = 667;
	    t['Gcommaaccent'] = 722;
	    t['ucircumflex'] = 500;
	    t['acircumflex'] = 444;
	    t['Amacron'] = 722;
	    t['rcaron'] = 333;
	    t['ccedilla'] = 444;
	    t['Zdotaccent'] = 611;
	    t['Thorn'] = 556;
	    t['Omacron'] = 722;
	    t['Racute'] = 667;
	    t['Sacute'] = 556;
	    t['dcaron'] = 588;
	    t['Umacron'] = 722;
	    t['uring'] = 500;
	    t['threesuperior'] = 300;
	    t['Ograve'] = 722;
	    t['Agrave'] = 722;
	    t['Abreve'] = 722;
	    t['multiply'] = 564;
	    t['uacute'] = 500;
	    t['Tcaron'] = 611;
	    t['partialdiff'] = 476;
	    t['ydieresis'] = 500;
	    t['Nacute'] = 722;
	    t['icircumflex'] = 278;
	    t['Ecircumflex'] = 611;
	    t['adieresis'] = 444;
	    t['edieresis'] = 444;
	    t['cacute'] = 444;
	    t['nacute'] = 500;
	    t['umacron'] = 500;
	    t['Ncaron'] = 722;
	    t['Iacute'] = 333;
	    t['plusminus'] = 564;
	    t['brokenbar'] = 200;
	    t['registered'] = 760;
	    t['Gbreve'] = 722;
	    t['Idotaccent'] = 333;
	    t['summation'] = 600;
	    t['Egrave'] = 611;
	    t['racute'] = 333;
	    t['omacron'] = 500;
	    t['Zacute'] = 611;
	    t['Zcaron'] = 611;
	    t['greaterequal'] = 549;
	    t['Eth'] = 722;
	    t['Ccedilla'] = 667;
	    t['lcommaaccent'] = 278;
	    t['tcaron'] = 326;
	    t['eogonek'] = 444;
	    t['Uogonek'] = 722;
	    t['Aacute'] = 722;
	    t['Adieresis'] = 722;
	    t['egrave'] = 444;
	    t['zacute'] = 444;
	    t['iogonek'] = 278;
	    t['Oacute'] = 722;
	    t['oacute'] = 500;
	    t['amacron'] = 444;
	    t['sacute'] = 389;
	    t['idieresis'] = 278;
	    t['Ocircumflex'] = 722;
	    t['Ugrave'] = 722;
	    t['Delta'] = 612;
	    t['thorn'] = 500;
	    t['twosuperior'] = 300;
	    t['Odieresis'] = 722;
	    t['mu'] = 500;
	    t['igrave'] = 278;
	    t['ohungarumlaut'] = 500;
	    t['Eogonek'] = 611;
	    t['dcroat'] = 500;
	    t['threequarters'] = 750;
	    t['Scedilla'] = 556;
	    t['lcaron'] = 344;
	    t['Kcommaaccent'] = 722;
	    t['Lacute'] = 611;
	    t['trademark'] = 980;
	    t['edotaccent'] = 444;
	    t['Igrave'] = 333;
	    t['Imacron'] = 333;
	    t['Lcaron'] = 611;
	    t['onehalf'] = 750;
	    t['lessequal'] = 549;
	    t['ocircumflex'] = 500;
	    t['ntilde'] = 500;
	    t['Uhungarumlaut'] = 722;
	    t['Eacute'] = 611;
	    t['emacron'] = 444;
	    t['gbreve'] = 500;
	    t['onequarter'] = 750;
	    t['Scaron'] = 556;
	    t['Scommaaccent'] = 556;
	    t['Ohungarumlaut'] = 722;
	    t['degree'] = 400;
	    t['ograve'] = 500;
	    t['Ccaron'] = 667;
	    t['ugrave'] = 500;
	    t['radical'] = 453;
	    t['Dcaron'] = 722;
	    t['rcommaaccent'] = 333;
	    t['Ntilde'] = 722;
	    t['otilde'] = 500;
	    t['Rcommaaccent'] = 667;
	    t['Lcommaaccent'] = 611;
	    t['Atilde'] = 722;
	    t['Aogonek'] = 722;
	    t['Aring'] = 722;
	    t['Otilde'] = 722;
	    t['zdotaccent'] = 444;
	    t['Ecaron'] = 611;
	    t['Iogonek'] = 333;
	    t['kcommaaccent'] = 500;
	    t['minus'] = 564;
	    t['Icircumflex'] = 333;
	    t['ncaron'] = 500;
	    t['tcommaaccent'] = 278;
	    t['logicalnot'] = 564;
	    t['odieresis'] = 500;
	    t['udieresis'] = 500;
	    t['notequal'] = 549;
	    t['gcommaaccent'] = 500;
	    t['eth'] = 500;
	    t['zcaron'] = 444;
	    t['ncommaaccent'] = 500;
	    t['onesuperior'] = 300;
	    t['imacron'] = 278;
	    t['Euro'] = 500;
	  });
	  t['Times-Bold'] = (0, _util.getLookupTableFactory)(function (t) {
	    t['space'] = 250;
	    t['exclam'] = 333;
	    t['quotedbl'] = 555;
	    t['numbersign'] = 500;
	    t['dollar'] = 500;
	    t['percent'] = 1000;
	    t['ampersand'] = 833;
	    t['quoteright'] = 333;
	    t['parenleft'] = 333;
	    t['parenright'] = 333;
	    t['asterisk'] = 500;
	    t['plus'] = 570;
	    t['comma'] = 250;
	    t['hyphen'] = 333;
	    t['period'] = 250;
	    t['slash'] = 278;
	    t['zero'] = 500;
	    t['one'] = 500;
	    t['two'] = 500;
	    t['three'] = 500;
	    t['four'] = 500;
	    t['five'] = 500;
	    t['six'] = 500;
	    t['seven'] = 500;
	    t['eight'] = 500;
	    t['nine'] = 500;
	    t['colon'] = 333;
	    t['semicolon'] = 333;
	    t['less'] = 570;
	    t['equal'] = 570;
	    t['greater'] = 570;
	    t['question'] = 500;
	    t['at'] = 930;
	    t['A'] = 722;
	    t['B'] = 667;
	    t['C'] = 722;
	    t['D'] = 722;
	    t['E'] = 667;
	    t['F'] = 611;
	    t['G'] = 778;
	    t['H'] = 778;
	    t['I'] = 389;
	    t['J'] = 500;
	    t['K'] = 778;
	    t['L'] = 667;
	    t['M'] = 944;
	    t['N'] = 722;
	    t['O'] = 778;
	    t['P'] = 611;
	    t['Q'] = 778;
	    t['R'] = 722;
	    t['S'] = 556;
	    t['T'] = 667;
	    t['U'] = 722;
	    t['V'] = 722;
	    t['W'] = 1000;
	    t['X'] = 722;
	    t['Y'] = 722;
	    t['Z'] = 667;
	    t['bracketleft'] = 333;
	    t['backslash'] = 278;
	    t['bracketright'] = 333;
	    t['asciicircum'] = 581;
	    t['underscore'] = 500;
	    t['quoteleft'] = 333;
	    t['a'] = 500;
	    t['b'] = 556;
	    t['c'] = 444;
	    t['d'] = 556;
	    t['e'] = 444;
	    t['f'] = 333;
	    t['g'] = 500;
	    t['h'] = 556;
	    t['i'] = 278;
	    t['j'] = 333;
	    t['k'] = 556;
	    t['l'] = 278;
	    t['m'] = 833;
	    t['n'] = 556;
	    t['o'] = 500;
	    t['p'] = 556;
	    t['q'] = 556;
	    t['r'] = 444;
	    t['s'] = 389;
	    t['t'] = 333;
	    t['u'] = 556;
	    t['v'] = 500;
	    t['w'] = 722;
	    t['x'] = 500;
	    t['y'] = 500;
	    t['z'] = 444;
	    t['braceleft'] = 394;
	    t['bar'] = 220;
	    t['braceright'] = 394;
	    t['asciitilde'] = 520;
	    t['exclamdown'] = 333;
	    t['cent'] = 500;
	    t['sterling'] = 500;
	    t['fraction'] = 167;
	    t['yen'] = 500;
	    t['florin'] = 500;
	    t['section'] = 500;
	    t['currency'] = 500;
	    t['quotesingle'] = 278;
	    t['quotedblleft'] = 500;
	    t['guillemotleft'] = 500;
	    t['guilsinglleft'] = 333;
	    t['guilsinglright'] = 333;
	    t['fi'] = 556;
	    t['fl'] = 556;
	    t['endash'] = 500;
	    t['dagger'] = 500;
	    t['daggerdbl'] = 500;
	    t['periodcentered'] = 250;
	    t['paragraph'] = 540;
	    t['bullet'] = 350;
	    t['quotesinglbase'] = 333;
	    t['quotedblbase'] = 500;
	    t['quotedblright'] = 500;
	    t['guillemotright'] = 500;
	    t['ellipsis'] = 1000;
	    t['perthousand'] = 1000;
	    t['questiondown'] = 500;
	    t['grave'] = 333;
	    t['acute'] = 333;
	    t['circumflex'] = 333;
	    t['tilde'] = 333;
	    t['macron'] = 333;
	    t['breve'] = 333;
	    t['dotaccent'] = 333;
	    t['dieresis'] = 333;
	    t['ring'] = 333;
	    t['cedilla'] = 333;
	    t['hungarumlaut'] = 333;
	    t['ogonek'] = 333;
	    t['caron'] = 333;
	    t['emdash'] = 1000;
	    t['AE'] = 1000;
	    t['ordfeminine'] = 300;
	    t['Lslash'] = 667;
	    t['Oslash'] = 778;
	    t['OE'] = 1000;
	    t['ordmasculine'] = 330;
	    t['ae'] = 722;
	    t['dotlessi'] = 278;
	    t['lslash'] = 278;
	    t['oslash'] = 500;
	    t['oe'] = 722;
	    t['germandbls'] = 556;
	    t['Idieresis'] = 389;
	    t['eacute'] = 444;
	    t['abreve'] = 500;
	    t['uhungarumlaut'] = 556;
	    t['ecaron'] = 444;
	    t['Ydieresis'] = 722;
	    t['divide'] = 570;
	    t['Yacute'] = 722;
	    t['Acircumflex'] = 722;
	    t['aacute'] = 500;
	    t['Ucircumflex'] = 722;
	    t['yacute'] = 500;
	    t['scommaaccent'] = 389;
	    t['ecircumflex'] = 444;
	    t['Uring'] = 722;
	    t['Udieresis'] = 722;
	    t['aogonek'] = 500;
	    t['Uacute'] = 722;
	    t['uogonek'] = 556;
	    t['Edieresis'] = 667;
	    t['Dcroat'] = 722;
	    t['commaaccent'] = 250;
	    t['copyright'] = 747;
	    t['Emacron'] = 667;
	    t['ccaron'] = 444;
	    t['aring'] = 500;
	    t['Ncommaaccent'] = 722;
	    t['lacute'] = 278;
	    t['agrave'] = 500;
	    t['Tcommaaccent'] = 667;
	    t['Cacute'] = 722;
	    t['atilde'] = 500;
	    t['Edotaccent'] = 667;
	    t['scaron'] = 389;
	    t['scedilla'] = 389;
	    t['iacute'] = 278;
	    t['lozenge'] = 494;
	    t['Rcaron'] = 722;
	    t['Gcommaaccent'] = 778;
	    t['ucircumflex'] = 556;
	    t['acircumflex'] = 500;
	    t['Amacron'] = 722;
	    t['rcaron'] = 444;
	    t['ccedilla'] = 444;
	    t['Zdotaccent'] = 667;
	    t['Thorn'] = 611;
	    t['Omacron'] = 778;
	    t['Racute'] = 722;
	    t['Sacute'] = 556;
	    t['dcaron'] = 672;
	    t['Umacron'] = 722;
	    t['uring'] = 556;
	    t['threesuperior'] = 300;
	    t['Ograve'] = 778;
	    t['Agrave'] = 722;
	    t['Abreve'] = 722;
	    t['multiply'] = 570;
	    t['uacute'] = 556;
	    t['Tcaron'] = 667;
	    t['partialdiff'] = 494;
	    t['ydieresis'] = 500;
	    t['Nacute'] = 722;
	    t['icircumflex'] = 278;
	    t['Ecircumflex'] = 667;
	    t['adieresis'] = 500;
	    t['edieresis'] = 444;
	    t['cacute'] = 444;
	    t['nacute'] = 556;
	    t['umacron'] = 556;
	    t['Ncaron'] = 722;
	    t['Iacute'] = 389;
	    t['plusminus'] = 570;
	    t['brokenbar'] = 220;
	    t['registered'] = 747;
	    t['Gbreve'] = 778;
	    t['Idotaccent'] = 389;
	    t['summation'] = 600;
	    t['Egrave'] = 667;
	    t['racute'] = 444;
	    t['omacron'] = 500;
	    t['Zacute'] = 667;
	    t['Zcaron'] = 667;
	    t['greaterequal'] = 549;
	    t['Eth'] = 722;
	    t['Ccedilla'] = 722;
	    t['lcommaaccent'] = 278;
	    t['tcaron'] = 416;
	    t['eogonek'] = 444;
	    t['Uogonek'] = 722;
	    t['Aacute'] = 722;
	    t['Adieresis'] = 722;
	    t['egrave'] = 444;
	    t['zacute'] = 444;
	    t['iogonek'] = 278;
	    t['Oacute'] = 778;
	    t['oacute'] = 500;
	    t['amacron'] = 500;
	    t['sacute'] = 389;
	    t['idieresis'] = 278;
	    t['Ocircumflex'] = 778;
	    t['Ugrave'] = 722;
	    t['Delta'] = 612;
	    t['thorn'] = 556;
	    t['twosuperior'] = 300;
	    t['Odieresis'] = 778;
	    t['mu'] = 556;
	    t['igrave'] = 278;
	    t['ohungarumlaut'] = 500;
	    t['Eogonek'] = 667;
	    t['dcroat'] = 556;
	    t['threequarters'] = 750;
	    t['Scedilla'] = 556;
	    t['lcaron'] = 394;
	    t['Kcommaaccent'] = 778;
	    t['Lacute'] = 667;
	    t['trademark'] = 1000;
	    t['edotaccent'] = 444;
	    t['Igrave'] = 389;
	    t['Imacron'] = 389;
	    t['Lcaron'] = 667;
	    t['onehalf'] = 750;
	    t['lessequal'] = 549;
	    t['ocircumflex'] = 500;
	    t['ntilde'] = 556;
	    t['Uhungarumlaut'] = 722;
	    t['Eacute'] = 667;
	    t['emacron'] = 444;
	    t['gbreve'] = 500;
	    t['onequarter'] = 750;
	    t['Scaron'] = 556;
	    t['Scommaaccent'] = 556;
	    t['Ohungarumlaut'] = 778;
	    t['degree'] = 400;
	    t['ograve'] = 500;
	    t['Ccaron'] = 722;
	    t['ugrave'] = 556;
	    t['radical'] = 549;
	    t['Dcaron'] = 722;
	    t['rcommaaccent'] = 444;
	    t['Ntilde'] = 722;
	    t['otilde'] = 500;
	    t['Rcommaaccent'] = 722;
	    t['Lcommaaccent'] = 667;
	    t['Atilde'] = 722;
	    t['Aogonek'] = 722;
	    t['Aring'] = 722;
	    t['Otilde'] = 778;
	    t['zdotaccent'] = 444;
	    t['Ecaron'] = 667;
	    t['Iogonek'] = 389;
	    t['kcommaaccent'] = 556;
	    t['minus'] = 570;
	    t['Icircumflex'] = 389;
	    t['ncaron'] = 556;
	    t['tcommaaccent'] = 333;
	    t['logicalnot'] = 570;
	    t['odieresis'] = 500;
	    t['udieresis'] = 556;
	    t['notequal'] = 549;
	    t['gcommaaccent'] = 500;
	    t['eth'] = 500;
	    t['zcaron'] = 444;
	    t['ncommaaccent'] = 556;
	    t['onesuperior'] = 300;
	    t['imacron'] = 278;
	    t['Euro'] = 500;
	  });
	  t['Times-BoldItalic'] = (0, _util.getLookupTableFactory)(function (t) {
	    t['space'] = 250;
	    t['exclam'] = 389;
	    t['quotedbl'] = 555;
	    t['numbersign'] = 500;
	    t['dollar'] = 500;
	    t['percent'] = 833;
	    t['ampersand'] = 778;
	    t['quoteright'] = 333;
	    t['parenleft'] = 333;
	    t['parenright'] = 333;
	    t['asterisk'] = 500;
	    t['plus'] = 570;
	    t['comma'] = 250;
	    t['hyphen'] = 333;
	    t['period'] = 250;
	    t['slash'] = 278;
	    t['zero'] = 500;
	    t['one'] = 500;
	    t['two'] = 500;
	    t['three'] = 500;
	    t['four'] = 500;
	    t['five'] = 500;
	    t['six'] = 500;
	    t['seven'] = 500;
	    t['eight'] = 500;
	    t['nine'] = 500;
	    t['colon'] = 333;
	    t['semicolon'] = 333;
	    t['less'] = 570;
	    t['equal'] = 570;
	    t['greater'] = 570;
	    t['question'] = 500;
	    t['at'] = 832;
	    t['A'] = 667;
	    t['B'] = 667;
	    t['C'] = 667;
	    t['D'] = 722;
	    t['E'] = 667;
	    t['F'] = 667;
	    t['G'] = 722;
	    t['H'] = 778;
	    t['I'] = 389;
	    t['J'] = 500;
	    t['K'] = 667;
	    t['L'] = 611;
	    t['M'] = 889;
	    t['N'] = 722;
	    t['O'] = 722;
	    t['P'] = 611;
	    t['Q'] = 722;
	    t['R'] = 667;
	    t['S'] = 556;
	    t['T'] = 611;
	    t['U'] = 722;
	    t['V'] = 667;
	    t['W'] = 889;
	    t['X'] = 667;
	    t['Y'] = 611;
	    t['Z'] = 611;
	    t['bracketleft'] = 333;
	    t['backslash'] = 278;
	    t['bracketright'] = 333;
	    t['asciicircum'] = 570;
	    t['underscore'] = 500;
	    t['quoteleft'] = 333;
	    t['a'] = 500;
	    t['b'] = 500;
	    t['c'] = 444;
	    t['d'] = 500;
	    t['e'] = 444;
	    t['f'] = 333;
	    t['g'] = 500;
	    t['h'] = 556;
	    t['i'] = 278;
	    t['j'] = 278;
	    t['k'] = 500;
	    t['l'] = 278;
	    t['m'] = 778;
	    t['n'] = 556;
	    t['o'] = 500;
	    t['p'] = 500;
	    t['q'] = 500;
	    t['r'] = 389;
	    t['s'] = 389;
	    t['t'] = 278;
	    t['u'] = 556;
	    t['v'] = 444;
	    t['w'] = 667;
	    t['x'] = 500;
	    t['y'] = 444;
	    t['z'] = 389;
	    t['braceleft'] = 348;
	    t['bar'] = 220;
	    t['braceright'] = 348;
	    t['asciitilde'] = 570;
	    t['exclamdown'] = 389;
	    t['cent'] = 500;
	    t['sterling'] = 500;
	    t['fraction'] = 167;
	    t['yen'] = 500;
	    t['florin'] = 500;
	    t['section'] = 500;
	    t['currency'] = 500;
	    t['quotesingle'] = 278;
	    t['quotedblleft'] = 500;
	    t['guillemotleft'] = 500;
	    t['guilsinglleft'] = 333;
	    t['guilsinglright'] = 333;
	    t['fi'] = 556;
	    t['fl'] = 556;
	    t['endash'] = 500;
	    t['dagger'] = 500;
	    t['daggerdbl'] = 500;
	    t['periodcentered'] = 250;
	    t['paragraph'] = 500;
	    t['bullet'] = 350;
	    t['quotesinglbase'] = 333;
	    t['quotedblbase'] = 500;
	    t['quotedblright'] = 500;
	    t['guillemotright'] = 500;
	    t['ellipsis'] = 1000;
	    t['perthousand'] = 1000;
	    t['questiondown'] = 500;
	    t['grave'] = 333;
	    t['acute'] = 333;
	    t['circumflex'] = 333;
	    t['tilde'] = 333;
	    t['macron'] = 333;
	    t['breve'] = 333;
	    t['dotaccent'] = 333;
	    t['dieresis'] = 333;
	    t['ring'] = 333;
	    t['cedilla'] = 333;
	    t['hungarumlaut'] = 333;
	    t['ogonek'] = 333;
	    t['caron'] = 333;
	    t['emdash'] = 1000;
	    t['AE'] = 944;
	    t['ordfeminine'] = 266;
	    t['Lslash'] = 611;
	    t['Oslash'] = 722;
	    t['OE'] = 944;
	    t['ordmasculine'] = 300;
	    t['ae'] = 722;
	    t['dotlessi'] = 278;
	    t['lslash'] = 278;
	    t['oslash'] = 500;
	    t['oe'] = 722;
	    t['germandbls'] = 500;
	    t['Idieresis'] = 389;
	    t['eacute'] = 444;
	    t['abreve'] = 500;
	    t['uhungarumlaut'] = 556;
	    t['ecaron'] = 444;
	    t['Ydieresis'] = 611;
	    t['divide'] = 570;
	    t['Yacute'] = 611;
	    t['Acircumflex'] = 667;
	    t['aacute'] = 500;
	    t['Ucircumflex'] = 722;
	    t['yacute'] = 444;
	    t['scommaaccent'] = 389;
	    t['ecircumflex'] = 444;
	    t['Uring'] = 722;
	    t['Udieresis'] = 722;
	    t['aogonek'] = 500;
	    t['Uacute'] = 722;
	    t['uogonek'] = 556;
	    t['Edieresis'] = 667;
	    t['Dcroat'] = 722;
	    t['commaaccent'] = 250;
	    t['copyright'] = 747;
	    t['Emacron'] = 667;
	    t['ccaron'] = 444;
	    t['aring'] = 500;
	    t['Ncommaaccent'] = 722;
	    t['lacute'] = 278;
	    t['agrave'] = 500;
	    t['Tcommaaccent'] = 611;
	    t['Cacute'] = 667;
	    t['atilde'] = 500;
	    t['Edotaccent'] = 667;
	    t['scaron'] = 389;
	    t['scedilla'] = 389;
	    t['iacute'] = 278;
	    t['lozenge'] = 494;
	    t['Rcaron'] = 667;
	    t['Gcommaaccent'] = 722;
	    t['ucircumflex'] = 556;
	    t['acircumflex'] = 500;
	    t['Amacron'] = 667;
	    t['rcaron'] = 389;
	    t['ccedilla'] = 444;
	    t['Zdotaccent'] = 611;
	    t['Thorn'] = 611;
	    t['Omacron'] = 722;
	    t['Racute'] = 667;
	    t['Sacute'] = 556;
	    t['dcaron'] = 608;
	    t['Umacron'] = 722;
	    t['uring'] = 556;
	    t['threesuperior'] = 300;
	    t['Ograve'] = 722;
	    t['Agrave'] = 667;
	    t['Abreve'] = 667;
	    t['multiply'] = 570;
	    t['uacute'] = 556;
	    t['Tcaron'] = 611;
	    t['partialdiff'] = 494;
	    t['ydieresis'] = 444;
	    t['Nacute'] = 722;
	    t['icircumflex'] = 278;
	    t['Ecircumflex'] = 667;
	    t['adieresis'] = 500;
	    t['edieresis'] = 444;
	    t['cacute'] = 444;
	    t['nacute'] = 556;
	    t['umacron'] = 556;
	    t['Ncaron'] = 722;
	    t['Iacute'] = 389;
	    t['plusminus'] = 570;
	    t['brokenbar'] = 220;
	    t['registered'] = 747;
	    t['Gbreve'] = 722;
	    t['Idotaccent'] = 389;
	    t['summation'] = 600;
	    t['Egrave'] = 667;
	    t['racute'] = 389;
	    t['omacron'] = 500;
	    t['Zacute'] = 611;
	    t['Zcaron'] = 611;
	    t['greaterequal'] = 549;
	    t['Eth'] = 722;
	    t['Ccedilla'] = 667;
	    t['lcommaaccent'] = 278;
	    t['tcaron'] = 366;
	    t['eogonek'] = 444;
	    t['Uogonek'] = 722;
	    t['Aacute'] = 667;
	    t['Adieresis'] = 667;
	    t['egrave'] = 444;
	    t['zacute'] = 389;
	    t['iogonek'] = 278;
	    t['Oacute'] = 722;
	    t['oacute'] = 500;
	    t['amacron'] = 500;
	    t['sacute'] = 389;
	    t['idieresis'] = 278;
	    t['Ocircumflex'] = 722;
	    t['Ugrave'] = 722;
	    t['Delta'] = 612;
	    t['thorn'] = 500;
	    t['twosuperior'] = 300;
	    t['Odieresis'] = 722;
	    t['mu'] = 576;
	    t['igrave'] = 278;
	    t['ohungarumlaut'] = 500;
	    t['Eogonek'] = 667;
	    t['dcroat'] = 500;
	    t['threequarters'] = 750;
	    t['Scedilla'] = 556;
	    t['lcaron'] = 382;
	    t['Kcommaaccent'] = 667;
	    t['Lacute'] = 611;
	    t['trademark'] = 1000;
	    t['edotaccent'] = 444;
	    t['Igrave'] = 389;
	    t['Imacron'] = 389;
	    t['Lcaron'] = 611;
	    t['onehalf'] = 750;
	    t['lessequal'] = 549;
	    t['ocircumflex'] = 500;
	    t['ntilde'] = 556;
	    t['Uhungarumlaut'] = 722;
	    t['Eacute'] = 667;
	    t['emacron'] = 444;
	    t['gbreve'] = 500;
	    t['onequarter'] = 750;
	    t['Scaron'] = 556;
	    t['Scommaaccent'] = 556;
	    t['Ohungarumlaut'] = 722;
	    t['degree'] = 400;
	    t['ograve'] = 500;
	    t['Ccaron'] = 667;
	    t['ugrave'] = 556;
	    t['radical'] = 549;
	    t['Dcaron'] = 722;
	    t['rcommaaccent'] = 389;
	    t['Ntilde'] = 722;
	    t['otilde'] = 500;
	    t['Rcommaaccent'] = 667;
	    t['Lcommaaccent'] = 611;
	    t['Atilde'] = 667;
	    t['Aogonek'] = 667;
	    t['Aring'] = 667;
	    t['Otilde'] = 722;
	    t['zdotaccent'] = 389;
	    t['Ecaron'] = 667;
	    t['Iogonek'] = 389;
	    t['kcommaaccent'] = 500;
	    t['minus'] = 606;
	    t['Icircumflex'] = 389;
	    t['ncaron'] = 556;
	    t['tcommaaccent'] = 278;
	    t['logicalnot'] = 606;
	    t['odieresis'] = 500;
	    t['udieresis'] = 556;
	    t['notequal'] = 549;
	    t['gcommaaccent'] = 500;
	    t['eth'] = 500;
	    t['zcaron'] = 389;
	    t['ncommaaccent'] = 556;
	    t['onesuperior'] = 300;
	    t['imacron'] = 278;
	    t['Euro'] = 500;
	  });
	  t['Times-Italic'] = (0, _util.getLookupTableFactory)(function (t) {
	    t['space'] = 250;
	    t['exclam'] = 333;
	    t['quotedbl'] = 420;
	    t['numbersign'] = 500;
	    t['dollar'] = 500;
	    t['percent'] = 833;
	    t['ampersand'] = 778;
	    t['quoteright'] = 333;
	    t['parenleft'] = 333;
	    t['parenright'] = 333;
	    t['asterisk'] = 500;
	    t['plus'] = 675;
	    t['comma'] = 250;
	    t['hyphen'] = 333;
	    t['period'] = 250;
	    t['slash'] = 278;
	    t['zero'] = 500;
	    t['one'] = 500;
	    t['two'] = 500;
	    t['three'] = 500;
	    t['four'] = 500;
	    t['five'] = 500;
	    t['six'] = 500;
	    t['seven'] = 500;
	    t['eight'] = 500;
	    t['nine'] = 500;
	    t['colon'] = 333;
	    t['semicolon'] = 333;
	    t['less'] = 675;
	    t['equal'] = 675;
	    t['greater'] = 675;
	    t['question'] = 500;
	    t['at'] = 920;
	    t['A'] = 611;
	    t['B'] = 611;
	    t['C'] = 667;
	    t['D'] = 722;
	    t['E'] = 611;
	    t['F'] = 611;
	    t['G'] = 722;
	    t['H'] = 722;
	    t['I'] = 333;
	    t['J'] = 444;
	    t['K'] = 667;
	    t['L'] = 556;
	    t['M'] = 833;
	    t['N'] = 667;
	    t['O'] = 722;
	    t['P'] = 611;
	    t['Q'] = 722;
	    t['R'] = 611;
	    t['S'] = 500;
	    t['T'] = 556;
	    t['U'] = 722;
	    t['V'] = 611;
	    t['W'] = 833;
	    t['X'] = 611;
	    t['Y'] = 556;
	    t['Z'] = 556;
	    t['bracketleft'] = 389;
	    t['backslash'] = 278;
	    t['bracketright'] = 389;
	    t['asciicircum'] = 422;
	    t['underscore'] = 500;
	    t['quoteleft'] = 333;
	    t['a'] = 500;
	    t['b'] = 500;
	    t['c'] = 444;
	    t['d'] = 500;
	    t['e'] = 444;
	    t['f'] = 278;
	    t['g'] = 500;
	    t['h'] = 500;
	    t['i'] = 278;
	    t['j'] = 278;
	    t['k'] = 444;
	    t['l'] = 278;
	    t['m'] = 722;
	    t['n'] = 500;
	    t['o'] = 500;
	    t['p'] = 500;
	    t['q'] = 500;
	    t['r'] = 389;
	    t['s'] = 389;
	    t['t'] = 278;
	    t['u'] = 500;
	    t['v'] = 444;
	    t['w'] = 667;
	    t['x'] = 444;
	    t['y'] = 444;
	    t['z'] = 389;
	    t['braceleft'] = 400;
	    t['bar'] = 275;
	    t['braceright'] = 400;
	    t['asciitilde'] = 541;
	    t['exclamdown'] = 389;
	    t['cent'] = 500;
	    t['sterling'] = 500;
	    t['fraction'] = 167;
	    t['yen'] = 500;
	    t['florin'] = 500;
	    t['section'] = 500;
	    t['currency'] = 500;
	    t['quotesingle'] = 214;
	    t['quotedblleft'] = 556;
	    t['guillemotleft'] = 500;
	    t['guilsinglleft'] = 333;
	    t['guilsinglright'] = 333;
	    t['fi'] = 500;
	    t['fl'] = 500;
	    t['endash'] = 500;
	    t['dagger'] = 500;
	    t['daggerdbl'] = 500;
	    t['periodcentered'] = 250;
	    t['paragraph'] = 523;
	    t['bullet'] = 350;
	    t['quotesinglbase'] = 333;
	    t['quotedblbase'] = 556;
	    t['quotedblright'] = 556;
	    t['guillemotright'] = 500;
	    t['ellipsis'] = 889;
	    t['perthousand'] = 1000;
	    t['questiondown'] = 500;
	    t['grave'] = 333;
	    t['acute'] = 333;
	    t['circumflex'] = 333;
	    t['tilde'] = 333;
	    t['macron'] = 333;
	    t['breve'] = 333;
	    t['dotaccent'] = 333;
	    t['dieresis'] = 333;
	    t['ring'] = 333;
	    t['cedilla'] = 333;
	    t['hungarumlaut'] = 333;
	    t['ogonek'] = 333;
	    t['caron'] = 333;
	    t['emdash'] = 889;
	    t['AE'] = 889;
	    t['ordfeminine'] = 276;
	    t['Lslash'] = 556;
	    t['Oslash'] = 722;
	    t['OE'] = 944;
	    t['ordmasculine'] = 310;
	    t['ae'] = 667;
	    t['dotlessi'] = 278;
	    t['lslash'] = 278;
	    t['oslash'] = 500;
	    t['oe'] = 667;
	    t['germandbls'] = 500;
	    t['Idieresis'] = 333;
	    t['eacute'] = 444;
	    t['abreve'] = 500;
	    t['uhungarumlaut'] = 500;
	    t['ecaron'] = 444;
	    t['Ydieresis'] = 556;
	    t['divide'] = 675;
	    t['Yacute'] = 556;
	    t['Acircumflex'] = 611;
	    t['aacute'] = 500;
	    t['Ucircumflex'] = 722;
	    t['yacute'] = 444;
	    t['scommaaccent'] = 389;
	    t['ecircumflex'] = 444;
	    t['Uring'] = 722;
	    t['Udieresis'] = 722;
	    t['aogonek'] = 500;
	    t['Uacute'] = 722;
	    t['uogonek'] = 500;
	    t['Edieresis'] = 611;
	    t['Dcroat'] = 722;
	    t['commaaccent'] = 250;
	    t['copyright'] = 760;
	    t['Emacron'] = 611;
	    t['ccaron'] = 444;
	    t['aring'] = 500;
	    t['Ncommaaccent'] = 667;
	    t['lacute'] = 278;
	    t['agrave'] = 500;
	    t['Tcommaaccent'] = 556;
	    t['Cacute'] = 667;
	    t['atilde'] = 500;
	    t['Edotaccent'] = 611;
	    t['scaron'] = 389;
	    t['scedilla'] = 389;
	    t['iacute'] = 278;
	    t['lozenge'] = 471;
	    t['Rcaron'] = 611;
	    t['Gcommaaccent'] = 722;
	    t['ucircumflex'] = 500;
	    t['acircumflex'] = 500;
	    t['Amacron'] = 611;
	    t['rcaron'] = 389;
	    t['ccedilla'] = 444;
	    t['Zdotaccent'] = 556;
	    t['Thorn'] = 611;
	    t['Omacron'] = 722;
	    t['Racute'] = 611;
	    t['Sacute'] = 500;
	    t['dcaron'] = 544;
	    t['Umacron'] = 722;
	    t['uring'] = 500;
	    t['threesuperior'] = 300;
	    t['Ograve'] = 722;
	    t['Agrave'] = 611;
	    t['Abreve'] = 611;
	    t['multiply'] = 675;
	    t['uacute'] = 500;
	    t['Tcaron'] = 556;
	    t['partialdiff'] = 476;
	    t['ydieresis'] = 444;
	    t['Nacute'] = 667;
	    t['icircumflex'] = 278;
	    t['Ecircumflex'] = 611;
	    t['adieresis'] = 500;
	    t['edieresis'] = 444;
	    t['cacute'] = 444;
	    t['nacute'] = 500;
	    t['umacron'] = 500;
	    t['Ncaron'] = 667;
	    t['Iacute'] = 333;
	    t['plusminus'] = 675;
	    t['brokenbar'] = 275;
	    t['registered'] = 760;
	    t['Gbreve'] = 722;
	    t['Idotaccent'] = 333;
	    t['summation'] = 600;
	    t['Egrave'] = 611;
	    t['racute'] = 389;
	    t['omacron'] = 500;
	    t['Zacute'] = 556;
	    t['Zcaron'] = 556;
	    t['greaterequal'] = 549;
	    t['Eth'] = 722;
	    t['Ccedilla'] = 667;
	    t['lcommaaccent'] = 278;
	    t['tcaron'] = 300;
	    t['eogonek'] = 444;
	    t['Uogonek'] = 722;
	    t['Aacute'] = 611;
	    t['Adieresis'] = 611;
	    t['egrave'] = 444;
	    t['zacute'] = 389;
	    t['iogonek'] = 278;
	    t['Oacute'] = 722;
	    t['oacute'] = 500;
	    t['amacron'] = 500;
	    t['sacute'] = 389;
	    t['idieresis'] = 278;
	    t['Ocircumflex'] = 722;
	    t['Ugrave'] = 722;
	    t['Delta'] = 612;
	    t['thorn'] = 500;
	    t['twosuperior'] = 300;
	    t['Odieresis'] = 722;
	    t['mu'] = 500;
	    t['igrave'] = 278;
	    t['ohungarumlaut'] = 500;
	    t['Eogonek'] = 611;
	    t['dcroat'] = 500;
	    t['threequarters'] = 750;
	    t['Scedilla'] = 500;
	    t['lcaron'] = 300;
	    t['Kcommaaccent'] = 667;
	    t['Lacute'] = 556;
	    t['trademark'] = 980;
	    t['edotaccent'] = 444;
	    t['Igrave'] = 333;
	    t['Imacron'] = 333;
	    t['Lcaron'] = 611;
	    t['onehalf'] = 750;
	    t['lessequal'] = 549;
	    t['ocircumflex'] = 500;
	    t['ntilde'] = 500;
	    t['Uhungarumlaut'] = 722;
	    t['Eacute'] = 611;
	    t['emacron'] = 444;
	    t['gbreve'] = 500;
	    t['onequarter'] = 750;
	    t['Scaron'] = 500;
	    t['Scommaaccent'] = 500;
	    t['Ohungarumlaut'] = 722;
	    t['degree'] = 400;
	    t['ograve'] = 500;
	    t['Ccaron'] = 667;
	    t['ugrave'] = 500;
	    t['radical'] = 453;
	    t['Dcaron'] = 722;
	    t['rcommaaccent'] = 389;
	    t['Ntilde'] = 667;
	    t['otilde'] = 500;
	    t['Rcommaaccent'] = 611;
	    t['Lcommaaccent'] = 556;
	    t['Atilde'] = 611;
	    t['Aogonek'] = 611;
	    t['Aring'] = 611;
	    t['Otilde'] = 722;
	    t['zdotaccent'] = 389;
	    t['Ecaron'] = 611;
	    t['Iogonek'] = 333;
	    t['kcommaaccent'] = 444;
	    t['minus'] = 675;
	    t['Icircumflex'] = 333;
	    t['ncaron'] = 500;
	    t['tcommaaccent'] = 278;
	    t['logicalnot'] = 675;
	    t['odieresis'] = 500;
	    t['udieresis'] = 500;
	    t['notequal'] = 549;
	    t['gcommaaccent'] = 500;
	    t['eth'] = 500;
	    t['zcaron'] = 389;
	    t['ncommaaccent'] = 500;
	    t['onesuperior'] = 300;
	    t['imacron'] = 278;
	    t['Euro'] = 500;
	  });
	  t['ZapfDingbats'] = (0, _util.getLookupTableFactory)(function (t) {
	    t['space'] = 278;
	    t['a1'] = 974;
	    t['a2'] = 961;
	    t['a202'] = 974;
	    t['a3'] = 980;
	    t['a4'] = 719;
	    t['a5'] = 789;
	    t['a119'] = 790;
	    t['a118'] = 791;
	    t['a117'] = 690;
	    t['a11'] = 960;
	    t['a12'] = 939;
	    t['a13'] = 549;
	    t['a14'] = 855;
	    t['a15'] = 911;
	    t['a16'] = 933;
	    t['a105'] = 911;
	    t['a17'] = 945;
	    t['a18'] = 974;
	    t['a19'] = 755;
	    t['a20'] = 846;
	    t['a21'] = 762;
	    t['a22'] = 761;
	    t['a23'] = 571;
	    t['a24'] = 677;
	    t['a25'] = 763;
	    t['a26'] = 760;
	    t['a27'] = 759;
	    t['a28'] = 754;
	    t['a6'] = 494;
	    t['a7'] = 552;
	    t['a8'] = 537;
	    t['a9'] = 577;
	    t['a10'] = 692;
	    t['a29'] = 786;
	    t['a30'] = 788;
	    t['a31'] = 788;
	    t['a32'] = 790;
	    t['a33'] = 793;
	    t['a34'] = 794;
	    t['a35'] = 816;
	    t['a36'] = 823;
	    t['a37'] = 789;
	    t['a38'] = 841;
	    t['a39'] = 823;
	    t['a40'] = 833;
	    t['a41'] = 816;
	    t['a42'] = 831;
	    t['a43'] = 923;
	    t['a44'] = 744;
	    t['a45'] = 723;
	    t['a46'] = 749;
	    t['a47'] = 790;
	    t['a48'] = 792;
	    t['a49'] = 695;
	    t['a50'] = 776;
	    t['a51'] = 768;
	    t['a52'] = 792;
	    t['a53'] = 759;
	    t['a54'] = 707;
	    t['a55'] = 708;
	    t['a56'] = 682;
	    t['a57'] = 701;
	    t['a58'] = 826;
	    t['a59'] = 815;
	    t['a60'] = 789;
	    t['a61'] = 789;
	    t['a62'] = 707;
	    t['a63'] = 687;
	    t['a64'] = 696;
	    t['a65'] = 689;
	    t['a66'] = 786;
	    t['a67'] = 787;
	    t['a68'] = 713;
	    t['a69'] = 791;
	    t['a70'] = 785;
	    t['a71'] = 791;
	    t['a72'] = 873;
	    t['a73'] = 761;
	    t['a74'] = 762;
	    t['a203'] = 762;
	    t['a75'] = 759;
	    t['a204'] = 759;
	    t['a76'] = 892;
	    t['a77'] = 892;
	    t['a78'] = 788;
	    t['a79'] = 784;
	    t['a81'] = 438;
	    t['a82'] = 138;
	    t['a83'] = 277;
	    t['a84'] = 415;
	    t['a97'] = 392;
	    t['a98'] = 392;
	    t['a99'] = 668;
	    t['a100'] = 668;
	    t['a89'] = 390;
	    t['a90'] = 390;
	    t['a93'] = 317;
	    t['a94'] = 317;
	    t['a91'] = 276;
	    t['a92'] = 276;
	    t['a205'] = 509;
	    t['a85'] = 509;
	    t['a206'] = 410;
	    t['a86'] = 410;
	    t['a87'] = 234;
	    t['a88'] = 234;
	    t['a95'] = 334;
	    t['a96'] = 334;
	    t['a101'] = 732;
	    t['a102'] = 544;
	    t['a103'] = 544;
	    t['a104'] = 910;
	    t['a106'] = 667;
	    t['a107'] = 760;
	    t['a108'] = 760;
	    t['a112'] = 776;
	    t['a111'] = 595;
	    t['a110'] = 694;
	    t['a109'] = 626;
	    t['a120'] = 788;
	    t['a121'] = 788;
	    t['a122'] = 788;
	    t['a123'] = 788;
	    t['a124'] = 788;
	    t['a125'] = 788;
	    t['a126'] = 788;
	    t['a127'] = 788;
	    t['a128'] = 788;
	    t['a129'] = 788;
	    t['a130'] = 788;
	    t['a131'] = 788;
	    t['a132'] = 788;
	    t['a133'] = 788;
	    t['a134'] = 788;
	    t['a135'] = 788;
	    t['a136'] = 788;
	    t['a137'] = 788;
	    t['a138'] = 788;
	    t['a139'] = 788;
	    t['a140'] = 788;
	    t['a141'] = 788;
	    t['a142'] = 788;
	    t['a143'] = 788;
	    t['a144'] = 788;
	    t['a145'] = 788;
	    t['a146'] = 788;
	    t['a147'] = 788;
	    t['a148'] = 788;
	    t['a149'] = 788;
	    t['a150'] = 788;
	    t['a151'] = 788;
	    t['a152'] = 788;
	    t['a153'] = 788;
	    t['a154'] = 788;
	    t['a155'] = 788;
	    t['a156'] = 788;
	    t['a157'] = 788;
	    t['a158'] = 788;
	    t['a159'] = 788;
	    t['a160'] = 894;
	    t['a161'] = 838;
	    t['a163'] = 1016;
	    t['a164'] = 458;
	    t['a196'] = 748;
	    t['a165'] = 924;
	    t['a192'] = 748;
	    t['a166'] = 918;
	    t['a167'] = 927;
	    t['a168'] = 928;
	    t['a169'] = 928;
	    t['a170'] = 834;
	    t['a171'] = 873;
	    t['a172'] = 828;
	    t['a173'] = 924;
	    t['a162'] = 924;
	    t['a174'] = 917;
	    t['a175'] = 930;
	    t['a176'] = 931;
	    t['a177'] = 463;
	    t['a178'] = 883;
	    t['a179'] = 836;
	    t['a193'] = 836;
	    t['a180'] = 867;
	    t['a199'] = 867;
	    t['a181'] = 696;
	    t['a200'] = 696;
	    t['a182'] = 874;
	    t['a201'] = 874;
	    t['a183'] = 760;
	    t['a184'] = 946;
	    t['a197'] = 771;
	    t['a185'] = 865;
	    t['a194'] = 771;
	    t['a198'] = 888;
	    t['a186'] = 967;
	    t['a195'] = 888;
	    t['a187'] = 831;
	    t['a188'] = 873;
	    t['a189'] = 927;
	    t['a190'] = 970;
	    t['a191'] = 918;
	  });
	});
	exports.getMetrics = getMetrics;
	
	/***/ }),
	/* 156 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PostScriptParser = exports.PostScriptLexer = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _primitives = __w_pdfjs_require__(2);
	
	var PostScriptParser = function PostScriptParserClosure() {
	  function PostScriptParser(lexer) {
	    this.lexer = lexer;
	    this.operators = [];
	    this.token = null;
	    this.prev = null;
	  }
	  PostScriptParser.prototype = {
	    nextToken: function PostScriptParser_nextToken() {
	      this.prev = this.token;
	      this.token = this.lexer.getToken();
	    },
	    accept: function PostScriptParser_accept(type) {
	      if (this.token.type === type) {
	        this.nextToken();
	        return true;
	      }
	      return false;
	    },
	    expect: function PostScriptParser_expect(type) {
	      if (this.accept(type)) {
	        return true;
	      }
	      throw new _util.FormatError('Unexpected symbol: found ' + this.token.type + ' expected ' + type + '.');
	    },
	    parse: function PostScriptParser_parse() {
	      this.nextToken();
	      this.expect(PostScriptTokenTypes.LBRACE);
	      this.parseBlock();
	      this.expect(PostScriptTokenTypes.RBRACE);
	      return this.operators;
	    },
	    parseBlock: function PostScriptParser_parseBlock() {
	      while (true) {
	        if (this.accept(PostScriptTokenTypes.NUMBER)) {
	          this.operators.push(this.prev.value);
	        } else if (this.accept(PostScriptTokenTypes.OPERATOR)) {
	          this.operators.push(this.prev.value);
	        } else if (this.accept(PostScriptTokenTypes.LBRACE)) {
	          this.parseCondition();
	        } else {
	          return;
	        }
	      }
	    },
	    parseCondition: function PostScriptParser_parseCondition() {
	      var conditionLocation = this.operators.length;
	      this.operators.push(null, null);
	      this.parseBlock();
	      this.expect(PostScriptTokenTypes.RBRACE);
	      if (this.accept(PostScriptTokenTypes.IF)) {
	        this.operators[conditionLocation] = this.operators.length;
	        this.operators[conditionLocation + 1] = 'jz';
	      } else if (this.accept(PostScriptTokenTypes.LBRACE)) {
	        var jumpLocation = this.operators.length;
	        this.operators.push(null, null);
	        var endOfTrue = this.operators.length;
	        this.parseBlock();
	        this.expect(PostScriptTokenTypes.RBRACE);
	        this.expect(PostScriptTokenTypes.IFELSE);
	        this.operators[jumpLocation] = this.operators.length;
	        this.operators[jumpLocation + 1] = 'j';
	        this.operators[conditionLocation] = endOfTrue;
	        this.operators[conditionLocation + 1] = 'jz';
	      } else {
	        throw new _util.FormatError('PS Function: error parsing conditional.');
	      }
	    }
	  };
	  return PostScriptParser;
	}();
	var PostScriptTokenTypes = {
	  LBRACE: 0,
	  RBRACE: 1,
	  NUMBER: 2,
	  OPERATOR: 3,
	  IF: 4,
	  IFELSE: 5
	};
	var PostScriptToken = function PostScriptTokenClosure() {
	  function PostScriptToken(type, value) {
	    this.type = type;
	    this.value = value;
	  }
	  var opCache = Object.create(null);
	  PostScriptToken.getOperator = function PostScriptToken_getOperator(op) {
	    var opValue = opCache[op];
	    if (opValue) {
	      return opValue;
	    }
	    return opCache[op] = new PostScriptToken(PostScriptTokenTypes.OPERATOR, op);
	  };
	  PostScriptToken.LBRACE = new PostScriptToken(PostScriptTokenTypes.LBRACE, '{');
	  PostScriptToken.RBRACE = new PostScriptToken(PostScriptTokenTypes.RBRACE, '}');
	  PostScriptToken.IF = new PostScriptToken(PostScriptTokenTypes.IF, 'IF');
	  PostScriptToken.IFELSE = new PostScriptToken(PostScriptTokenTypes.IFELSE, 'IFELSE');
	  return PostScriptToken;
	}();
	var PostScriptLexer = function PostScriptLexerClosure() {
	  function PostScriptLexer(stream) {
	    this.stream = stream;
	    this.nextChar();
	    this.strBuf = [];
	  }
	  PostScriptLexer.prototype = {
	    nextChar: function PostScriptLexer_nextChar() {
	      return this.currentChar = this.stream.getByte();
	    },
	    getToken: function PostScriptLexer_getToken() {
	      var comment = false;
	      var ch = this.currentChar;
	      while (true) {
	        if (ch < 0) {
	          return _primitives.EOF;
	        }
	        if (comment) {
	          if (ch === 0x0A || ch === 0x0D) {
	            comment = false;
	          }
	        } else if (ch === 0x25) {
	          comment = true;
	        } else if (!(0, _util.isSpace)(ch)) {
	          break;
	        }
	        ch = this.nextChar();
	      }
	      switch (ch | 0) {
	        case 0x30:
	        case 0x31:
	        case 0x32:
	        case 0x33:
	        case 0x34:
	        case 0x35:
	        case 0x36:
	        case 0x37:
	        case 0x38:
	        case 0x39:
	        case 0x2B:
	        case 0x2D:
	        case 0x2E:
	          return new PostScriptToken(PostScriptTokenTypes.NUMBER, this.getNumber());
	        case 0x7B:
	          this.nextChar();
	          return PostScriptToken.LBRACE;
	        case 0x7D:
	          this.nextChar();
	          return PostScriptToken.RBRACE;
	      }
	      var strBuf = this.strBuf;
	      strBuf.length = 0;
	      strBuf[0] = String.fromCharCode(ch);
	      while ((ch = this.nextChar()) >= 0 && (ch >= 0x41 && ch <= 0x5A || ch >= 0x61 && ch <= 0x7A)) {
	        strBuf.push(String.fromCharCode(ch));
	      }
	      var str = strBuf.join('');
	      switch (str.toLowerCase()) {
	        case 'if':
	          return PostScriptToken.IF;
	        case 'ifelse':
	          return PostScriptToken.IFELSE;
	        default:
	          return PostScriptToken.getOperator(str);
	      }
	    },
	    getNumber: function PostScriptLexer_getNumber() {
	      var ch = this.currentChar;
	      var strBuf = this.strBuf;
	      strBuf.length = 0;
	      strBuf[0] = String.fromCharCode(ch);
	      while ((ch = this.nextChar()) >= 0) {
	        if (ch >= 0x30 && ch <= 0x39 || ch === 0x2D || ch === 0x2E) {
	          strBuf.push(String.fromCharCode(ch));
	        } else {
	          break;
	        }
	      }
	      var value = parseFloat(strBuf.join(''));
	      if (isNaN(value)) {
	        throw new _util.FormatError('Invalid floating point number: ' + value);
	      }
	      return value;
	    }
	  };
	  return PostScriptLexer;
	}();
	exports.PostScriptLexer = PostScriptLexer;
	exports.PostScriptParser = PostScriptParser;
	
	/***/ }),
	/* 157 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var MurmurHash3_64 = function MurmurHash3_64Closure(seed) {
	  var MASK_HIGH = 0xffff0000;
	  var MASK_LOW = 0xffff;
	  function MurmurHash3_64(seed) {
	    var SEED = 0xc3d2e1f0;
	    this.h1 = seed ? seed & 0xffffffff : SEED;
	    this.h2 = seed ? seed & 0xffffffff : SEED;
	  }
	  MurmurHash3_64.prototype = {
	    update: function MurmurHash3_64_update(input) {
	      var i;
	      if (typeof input === 'string') {
	        var data = new Uint8Array(input.length * 2);
	        var length = 0;
	        for (i = 0; i < input.length; i++) {
	          var code = input.charCodeAt(i);
	          if (code <= 0xff) {
	            data[length++] = code;
	          } else {
	            data[length++] = code >>> 8;
	            data[length++] = code & 0xff;
	          }
	        }
	      } else if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object' && 'byteLength' in input) {
	        data = input;
	        length = data.byteLength;
	      } else {
	        throw new Error('Wrong data format in MurmurHash3_64_update. ' + 'Input must be a string or array.');
	      }
	      var blockCounts = length >> 2;
	      var tailLength = length - blockCounts * 4;
	      var dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
	      var k1 = 0;
	      var k2 = 0;
	      var h1 = this.h1;
	      var h2 = this.h2;
	      var C1 = 0xcc9e2d51;
	      var C2 = 0x1b873593;
	      var C1_LOW = C1 & MASK_LOW;
	      var C2_LOW = C2 & MASK_LOW;
	      for (i = 0; i < blockCounts; i++) {
	        if (i & 1) {
	          k1 = dataUint32[i];
	          k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
	          k1 = k1 << 15 | k1 >>> 17;
	          k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
	          h1 ^= k1;
	          h1 = h1 << 13 | h1 >>> 19;
	          h1 = h1 * 5 + 0xe6546b64;
	        } else {
	          k2 = dataUint32[i];
	          k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
	          k2 = k2 << 15 | k2 >>> 17;
	          k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
	          h2 ^= k2;
	          h2 = h2 << 13 | h2 >>> 19;
	          h2 = h2 * 5 + 0xe6546b64;
	        }
	      }
	      k1 = 0;
	      switch (tailLength) {
	        case 3:
	          k1 ^= data[blockCounts * 4 + 2] << 16;
	        case 2:
	          k1 ^= data[blockCounts * 4 + 1] << 8;
	        case 1:
	          k1 ^= data[blockCounts * 4];
	          k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
	          k1 = k1 << 15 | k1 >>> 17;
	          k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
	          if (blockCounts & 1) {
	            h1 ^= k1;
	          } else {
	            h2 ^= k1;
	          }
	      }
	      this.h1 = h1;
	      this.h2 = h2;
	      return this;
	    },
	    hexdigest: function MurmurHash3_64_hexdigest() {
	      var h1 = this.h1;
	      var h2 = this.h2;
	      h1 ^= h2 >>> 1;
	      h1 = h1 * 0xed558ccd & MASK_HIGH | h1 * 0x8ccd & MASK_LOW;
	      h2 = h2 * 0xff51afd7 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & MASK_HIGH) >>> 16;
	      h1 ^= h2 >>> 1;
	      h1 = h1 * 0x1a85ec53 & MASK_HIGH | h1 * 0xec53 & MASK_LOW;
	      h2 = h2 * 0xc4ceb9fe & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & MASK_HIGH) >>> 16;
	      h1 ^= h2 >>> 1;
	      for (var i = 0, arr = [h1, h2], str = ''; i < arr.length; i++) {
	        var hex = (arr[i] >>> 0).toString(16);
	        while (hex.length < 8) {
	          hex = '0' + hex;
	        }
	        str += hex;
	      }
	      return str;
	    }
	  };
	  return MurmurHash3_64;
	}();
	exports.MurmurHash3_64 = MurmurHash3_64;
	
	/***/ }),
	/* 158 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFImage = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _util = __w_pdfjs_require__(0);
	
	var _stream = __w_pdfjs_require__(5);
	
	var _primitives = __w_pdfjs_require__(2);
	
	var _colorspace = __w_pdfjs_require__(29);
	
	var _jpx = __w_pdfjs_require__(80);
	
	var PDFImage = function PDFImageClosure() {
	  function handleImageData(image, nativeDecoder) {
	    if (nativeDecoder && nativeDecoder.canDecode(image)) {
	      return nativeDecoder.decode(image);
	    }
	    return Promise.resolve(image);
	  }
	  function decodeAndClamp(value, addend, coefficient, max) {
	    value = addend + value * coefficient;
	    return value < 0 ? 0 : value > max ? max : value;
	  }
	  function resizeImageMask(src, bpc, w1, h1, w2, h2) {
	    var length = w2 * h2;
	    var dest = bpc <= 8 ? new Uint8Array(length) : bpc <= 16 ? new Uint16Array(length) : new Uint32Array(length);
	    var xRatio = w1 / w2;
	    var yRatio = h1 / h2;
	    var i,
	        j,
	        py,
	        newIndex = 0,
	        oldIndex;
	    var xScaled = new Uint16Array(w2);
	    var w1Scanline = w1;
	    for (i = 0; i < w2; i++) {
	      xScaled[i] = Math.floor(i * xRatio);
	    }
	    for (i = 0; i < h2; i++) {
	      py = Math.floor(i * yRatio) * w1Scanline;
	      for (j = 0; j < w2; j++) {
	        oldIndex = py + xScaled[j];
	        dest[newIndex++] = src[oldIndex];
	      }
	    }
	    return dest;
	  }
	  function PDFImage(_ref) {
	    var xref = _ref.xref,
	        res = _ref.res,
	        image = _ref.image,
	        _ref$smask = _ref.smask,
	        smask = _ref$smask === undefined ? null : _ref$smask,
	        _ref$mask = _ref.mask,
	        mask = _ref$mask === undefined ? null : _ref$mask,
	        _ref$isMask = _ref.isMask,
	        isMask = _ref$isMask === undefined ? false : _ref$isMask,
	        pdfFunctionFactory = _ref.pdfFunctionFactory;
	
	    this.image = image;
	    var dict = image.dict;
	    if (dict.has('Filter')) {
	      var filter = dict.get('Filter').name;
	      if (filter === 'JPXDecode') {
	        var jpxImage = new _jpx.JpxImage();
	        jpxImage.parseImageProperties(image.stream);
	        image.stream.reset();
	        image.bitsPerComponent = jpxImage.bitsPerComponent;
	        image.numComps = jpxImage.componentsCount;
	      } else if (filter === 'JBIG2Decode') {
	        image.bitsPerComponent = 1;
	        image.numComps = 1;
	      }
	    }
	    this.width = dict.get('Width', 'W');
	    this.height = dict.get('Height', 'H');
	    if (this.width < 1 || this.height < 1) {
	      throw new _util.FormatError('Invalid image width: ' + this.width + ' or ' + ('height: ' + this.height));
	    }
	    this.interpolate = dict.get('Interpolate', 'I') || false;
	    this.imageMask = dict.get('ImageMask', 'IM') || false;
	    this.matte = dict.get('Matte') || false;
	    var bitsPerComponent = image.bitsPerComponent;
	    if (!bitsPerComponent) {
	      bitsPerComponent = dict.get('BitsPerComponent', 'BPC');
	      if (!bitsPerComponent) {
	        if (this.imageMask) {
	          bitsPerComponent = 1;
	        } else {
	          throw new _util.FormatError('Bits per component missing in image: ' + this.imageMask);
	        }
	      }
	    }
	    this.bpc = bitsPerComponent;
	    if (!this.imageMask) {
	      var colorSpace = dict.get('ColorSpace', 'CS');
	      if (!colorSpace) {
	        (0, _util.info)('JPX images (which do not require color spaces)');
	        switch (image.numComps) {
	          case 1:
	            colorSpace = _primitives.Name.get('DeviceGray');
	            break;
	          case 3:
	            colorSpace = _primitives.Name.get('DeviceRGB');
	            break;
	          case 4:
	            colorSpace = _primitives.Name.get('DeviceCMYK');
	            break;
	          default:
	            throw new Error('JPX images with ' + this.numComps + ' ' + 'color components not supported.');
	        }
	      }
	      this.colorSpace = _colorspace.ColorSpace.parse(colorSpace, xref, res, pdfFunctionFactory);
	      this.numComps = this.colorSpace.numComps;
	    }
	    this.decode = dict.getArray('Decode', 'D');
	    this.needsDecode = false;
	    if (this.decode && (this.colorSpace && !this.colorSpace.isDefaultDecode(this.decode) || isMask && !_colorspace.ColorSpace.isDefaultDecode(this.decode, 1))) {
	      this.needsDecode = true;
	      var max = (1 << bitsPerComponent) - 1;
	      this.decodeCoefficients = [];
	      this.decodeAddends = [];
	      for (var i = 0, j = 0; i < this.decode.length; i += 2, ++j) {
	        var dmin = this.decode[i];
	        var dmax = this.decode[i + 1];
	        this.decodeCoefficients[j] = dmax - dmin;
	        this.decodeAddends[j] = max * dmin;
	      }
	    }
	    if (smask) {
	      this.smask = new PDFImage({
	        xref: xref,
	        res: res,
	        image: smask,
	        pdfFunctionFactory: pdfFunctionFactory
	      });
	    } else if (mask) {
	      if ((0, _primitives.isStream)(mask)) {
	        var maskDict = mask.dict,
	            imageMask = maskDict.get('ImageMask', 'IM');
	        if (!imageMask) {
	          (0, _util.warn)('Ignoring /Mask in image without /ImageMask.');
	        } else {
	          this.mask = new PDFImage({
	            xref: xref,
	            res: res,
	            image: mask,
	            isMask: true,
	            pdfFunctionFactory: pdfFunctionFactory
	          });
	        }
	      } else {
	        this.mask = mask;
	      }
	    }
	  }
	  PDFImage.buildImage = function (_ref2) {
	    var handler = _ref2.handler,
	        xref = _ref2.xref,
	        res = _ref2.res,
	        image = _ref2.image,
	        _ref2$nativeDecoder = _ref2.nativeDecoder,
	        nativeDecoder = _ref2$nativeDecoder === undefined ? null : _ref2$nativeDecoder,
	        pdfFunctionFactory = _ref2.pdfFunctionFactory;
	
	    var imagePromise = handleImageData(image, nativeDecoder);
	    var smaskPromise;
	    var maskPromise;
	    var smask = image.dict.get('SMask');
	    var mask = image.dict.get('Mask');
	    if (smask) {
	      smaskPromise = handleImageData(smask, nativeDecoder);
	      maskPromise = Promise.resolve(null);
	    } else {
	      smaskPromise = Promise.resolve(null);
	      if (mask) {
	        if ((0, _primitives.isStream)(mask)) {
	          maskPromise = handleImageData(mask, nativeDecoder);
	        } else if (Array.isArray(mask)) {
	          maskPromise = Promise.resolve(mask);
	        } else {
	          (0, _util.warn)('Unsupported mask format.');
	          maskPromise = Promise.resolve(null);
	        }
	      } else {
	        maskPromise = Promise.resolve(null);
	      }
	    }
	    return Promise.all([imagePromise, smaskPromise, maskPromise]).then(function (_ref3) {
	      var _ref4 = _slicedToArray(_ref3, 3),
	          imageData = _ref4[0],
	          smaskData = _ref4[1],
	          maskData = _ref4[2];
	
	      return new PDFImage({
	        xref: xref,
	        res: res,
	        image: imageData,
	        smask: smaskData,
	        mask: maskData,
	        pdfFunctionFactory: pdfFunctionFactory
	      });
	    });
	  };
	  PDFImage.createMask = function (_ref5) {
	    var imgArray = _ref5.imgArray,
	        width = _ref5.width,
	        height = _ref5.height,
	        imageIsFromDecodeStream = _ref5.imageIsFromDecodeStream,
	        inverseDecode = _ref5.inverseDecode;
	
	    var computedLength = (width + 7 >> 3) * height;
	    var actualLength = imgArray.byteLength;
	    var haveFullData = computedLength === actualLength;
	    var data, i;
	    if (imageIsFromDecodeStream && (!inverseDecode || haveFullData)) {
	      data = imgArray;
	    } else if (!inverseDecode) {
	      data = new Uint8Array(actualLength);
	      data.set(imgArray);
	    } else {
	      data = new Uint8Array(computedLength);
	      data.set(imgArray);
	      for (i = actualLength; i < computedLength; i++) {
	        data[i] = 0xff;
	      }
	    }
	    if (inverseDecode) {
	      for (i = 0; i < actualLength; i++) {
	        data[i] ^= 0xFF;
	      }
	    }
	    return {
	      data: data,
	      width: width,
	      height: height
	    };
	  };
	  PDFImage.prototype = {
	    get drawWidth() {
	      return Math.max(this.width, this.smask && this.smask.width || 0, this.mask && this.mask.width || 0);
	    },
	    get drawHeight() {
	      return Math.max(this.height, this.smask && this.smask.height || 0, this.mask && this.mask.height || 0);
	    },
	    decodeBuffer: function decodeBuffer(buffer) {
	      var bpc = this.bpc;
	      var numComps = this.numComps;
	      var decodeAddends = this.decodeAddends;
	      var decodeCoefficients = this.decodeCoefficients;
	      var max = (1 << bpc) - 1;
	      var i, ii;
	      if (bpc === 1) {
	        for (i = 0, ii = buffer.length; i < ii; i++) {
	          buffer[i] = +!buffer[i];
	        }
	        return;
	      }
	      var index = 0;
	      for (i = 0, ii = this.width * this.height; i < ii; i++) {
	        for (var j = 0; j < numComps; j++) {
	          buffer[index] = decodeAndClamp(buffer[index], decodeAddends[j], decodeCoefficients[j], max);
	          index++;
	        }
	      }
	    },
	    getComponents: function getComponents(buffer) {
	      var bpc = this.bpc;
	      if (bpc === 8) {
	        return buffer;
	      }
	      var width = this.width;
	      var height = this.height;
	      var numComps = this.numComps;
	      var length = width * height * numComps;
	      var bufferPos = 0;
	      var output = bpc <= 8 ? new Uint8Array(length) : bpc <= 16 ? new Uint16Array(length) : new Uint32Array(length);
	      var rowComps = width * numComps;
	      var max = (1 << bpc) - 1;
	      var i = 0,
	          ii,
	          buf;
	      if (bpc === 1) {
	        var mask, loop1End, loop2End;
	        for (var j = 0; j < height; j++) {
	          loop1End = i + (rowComps & ~7);
	          loop2End = i + rowComps;
	          while (i < loop1End) {
	            buf = buffer[bufferPos++];
	            output[i] = buf >> 7 & 1;
	            output[i + 1] = buf >> 6 & 1;
	            output[i + 2] = buf >> 5 & 1;
	            output[i + 3] = buf >> 4 & 1;
	            output[i + 4] = buf >> 3 & 1;
	            output[i + 5] = buf >> 2 & 1;
	            output[i + 6] = buf >> 1 & 1;
	            output[i + 7] = buf & 1;
	            i += 8;
	          }
	          if (i < loop2End) {
	            buf = buffer[bufferPos++];
	            mask = 128;
	            while (i < loop2End) {
	              output[i++] = +!!(buf & mask);
	              mask >>= 1;
	            }
	          }
	        }
	      } else {
	        var bits = 0;
	        buf = 0;
	        for (i = 0, ii = length; i < ii; ++i) {
	          if (i % rowComps === 0) {
	            buf = 0;
	            bits = 0;
	          }
	          while (bits < bpc) {
	            buf = buf << 8 | buffer[bufferPos++];
	            bits += 8;
	          }
	          var remainingBits = bits - bpc;
	          var value = buf >> remainingBits;
	          output[i] = value < 0 ? 0 : value > max ? max : value;
	          buf = buf & (1 << remainingBits) - 1;
	          bits = remainingBits;
	        }
	      }
	      return output;
	    },
	    fillOpacity: function fillOpacity(rgbaBuf, width, height, actualHeight, image) {
	      var smask = this.smask;
	      var mask = this.mask;
	      var alphaBuf, sw, sh, i, ii, j;
	      if (smask) {
	        sw = smask.width;
	        sh = smask.height;
	        alphaBuf = new Uint8Array(sw * sh);
	        smask.fillGrayBuffer(alphaBuf);
	        if (sw !== width || sh !== height) {
	          alphaBuf = resizeImageMask(alphaBuf, smask.bpc, sw, sh, width, height);
	        }
	      } else if (mask) {
	        if (mask instanceof PDFImage) {
	          sw = mask.width;
	          sh = mask.height;
	          alphaBuf = new Uint8Array(sw * sh);
	          mask.numComps = 1;
	          mask.fillGrayBuffer(alphaBuf);
	          for (i = 0, ii = sw * sh; i < ii; ++i) {
	            alphaBuf[i] = 255 - alphaBuf[i];
	          }
	          if (sw !== width || sh !== height) {
	            alphaBuf = resizeImageMask(alphaBuf, mask.bpc, sw, sh, width, height);
	          }
	        } else if (Array.isArray(mask)) {
	          alphaBuf = new Uint8Array(width * height);
	          var numComps = this.numComps;
	          for (i = 0, ii = width * height; i < ii; ++i) {
	            var opacity = 0;
	            var imageOffset = i * numComps;
	            for (j = 0; j < numComps; ++j) {
	              var color = image[imageOffset + j];
	              var maskOffset = j * 2;
	              if (color < mask[maskOffset] || color > mask[maskOffset + 1]) {
	                opacity = 255;
	                break;
	              }
	            }
	            alphaBuf[i] = opacity;
	          }
	        } else {
	          throw new _util.FormatError('Unknown mask format.');
	        }
	      }
	      if (alphaBuf) {
	        for (i = 0, j = 3, ii = width * actualHeight; i < ii; ++i, j += 4) {
	          rgbaBuf[j] = alphaBuf[i];
	        }
	      } else {
	        for (i = 0, j = 3, ii = width * actualHeight; i < ii; ++i, j += 4) {
	          rgbaBuf[j] = 255;
	        }
	      }
	    },
	    undoPreblend: function undoPreblend(buffer, width, height) {
	      var matte = this.smask && this.smask.matte;
	      if (!matte) {
	        return;
	      }
	      var matteRgb = this.colorSpace.getRgb(matte, 0);
	      var matteR = matteRgb[0];
	      var matteG = matteRgb[1];
	      var matteB = matteRgb[2];
	      var length = width * height * 4;
	      var r, g, b;
	      for (var i = 0; i < length; i += 4) {
	        var alpha = buffer[i + 3];
	        if (alpha === 0) {
	          buffer[i] = 255;
	          buffer[i + 1] = 255;
	          buffer[i + 2] = 255;
	          continue;
	        }
	        var k = 255 / alpha;
	        r = (buffer[i] - matteR) * k + matteR;
	        g = (buffer[i + 1] - matteG) * k + matteG;
	        b = (buffer[i + 2] - matteB) * k + matteB;
	        buffer[i] = r <= 0 ? 0 : r >= 255 ? 255 : r | 0;
	        buffer[i + 1] = g <= 0 ? 0 : g >= 255 ? 255 : g | 0;
	        buffer[i + 2] = b <= 0 ? 0 : b >= 255 ? 255 : b | 0;
	      }
	    },
	    createImageData: function createImageData() {
	      var forceRGBA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var drawWidth = this.drawWidth;
	      var drawHeight = this.drawHeight;
	      var imgData = {
	        width: drawWidth,
	        height: drawHeight
	      };
	      var numComps = this.numComps;
	      var originalWidth = this.width;
	      var originalHeight = this.height;
	      var bpc = this.bpc;
	      var rowBytes = originalWidth * numComps * bpc + 7 >> 3;
	      var imgArray;
	      if (!forceRGBA) {
	        var kind;
	        if (this.colorSpace.name === 'DeviceGray' && bpc === 1) {
	          kind = _util.ImageKind.GRAYSCALE_1BPP;
	        } else if (this.colorSpace.name === 'DeviceRGB' && bpc === 8 && !this.needsDecode) {
	          kind = _util.ImageKind.RGB_24BPP;
	        }
	        if (kind && !this.smask && !this.mask && drawWidth === originalWidth && drawHeight === originalHeight) {
	          imgData.kind = kind;
	          imgArray = this.getImageBytes(originalHeight * rowBytes);
	          if (this.image instanceof _stream.DecodeStream) {
	            imgData.data = imgArray;
	          } else {
	            var newArray = new Uint8Array(imgArray.length);
	            newArray.set(imgArray);
	            imgData.data = newArray;
	          }
	          if (this.needsDecode) {
	            (0, _util.assert)(kind === _util.ImageKind.GRAYSCALE_1BPP);
	            var buffer = imgData.data;
	            for (var i = 0, ii = buffer.length; i < ii; i++) {
	              buffer[i] ^= 0xff;
	            }
	          }
	          return imgData;
	        }
	        if (this.image instanceof _stream.JpegStream && !this.smask && !this.mask && (this.colorSpace.name === 'DeviceGray' || this.colorSpace.name === 'DeviceRGB' || this.colorSpace.name === 'DeviceCMYK')) {
	          imgData.kind = _util.ImageKind.RGB_24BPP;
	          imgData.data = this.getImageBytes(originalHeight * rowBytes, drawWidth, drawHeight, true);
	          return imgData;
	        }
	      }
	      imgArray = this.getImageBytes(originalHeight * rowBytes);
	      var actualHeight = 0 | imgArray.length / rowBytes * drawHeight / originalHeight;
	      var comps = this.getComponents(imgArray);
	      var alpha01, maybeUndoPreblend;
	      if (!forceRGBA && !this.smask && !this.mask) {
	        imgData.kind = _util.ImageKind.RGB_24BPP;
	        imgData.data = new Uint8Array(drawWidth * drawHeight * 3);
	        alpha01 = 0;
	        maybeUndoPreblend = false;
	      } else {
	        imgData.kind = _util.ImageKind.RGBA_32BPP;
	        imgData.data = new Uint8Array(drawWidth * drawHeight * 4);
	        alpha01 = 1;
	        maybeUndoPreblend = true;
	        this.fillOpacity(imgData.data, drawWidth, drawHeight, actualHeight, comps);
	      }
	      if (this.needsDecode) {
	        this.decodeBuffer(comps);
	      }
	      this.colorSpace.fillRgb(imgData.data, originalWidth, originalHeight, drawWidth, drawHeight, actualHeight, bpc, comps, alpha01);
	      if (maybeUndoPreblend) {
	        this.undoPreblend(imgData.data, drawWidth, actualHeight);
	      }
	      return imgData;
	    },
	    fillGrayBuffer: function fillGrayBuffer(buffer) {
	      var numComps = this.numComps;
	      if (numComps !== 1) {
	        throw new _util.FormatError('Reading gray scale from a color image: ' + numComps);
	      }
	      var width = this.width;
	      var height = this.height;
	      var bpc = this.bpc;
	      var rowBytes = width * numComps * bpc + 7 >> 3;
	      var imgArray = this.getImageBytes(height * rowBytes);
	      var comps = this.getComponents(imgArray);
	      var i, length;
	      if (bpc === 1) {
	        length = width * height;
	        if (this.needsDecode) {
	          for (i = 0; i < length; ++i) {
	            buffer[i] = comps[i] - 1 & 255;
	          }
	        } else {
	          for (i = 0; i < length; ++i) {
	            buffer[i] = -comps[i] & 255;
	          }
	        }
	        return;
	      }
	      if (this.needsDecode) {
	        this.decodeBuffer(comps);
	      }
	      length = width * height;
	      var scale = 255 / ((1 << bpc) - 1);
	      for (i = 0; i < length; ++i) {
	        buffer[i] = scale * comps[i] | 0;
	      }
	    },
	    getImageBytes: function getImageBytes(length, drawWidth, drawHeight) {
	      var forceRGB = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	      this.image.reset();
	      this.image.drawWidth = drawWidth || this.width;
	      this.image.drawHeight = drawHeight || this.height;
	      this.image.forceRGB = !!forceRGB;
	      return this.image.getBytes(length);
	    }
	  };
	  return PDFImage;
	}();
	exports.PDFImage = PDFImage;
	
	/***/ }),
	/* 159 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AnnotationFactory = exports.AnnotationBorderStyle = exports.Annotation = undefined;
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __w_pdfjs_require__(0);
	
	var _obj = __w_pdfjs_require__(79);
	
	var _primitives = __w_pdfjs_require__(2);
	
	var _colorspace = __w_pdfjs_require__(29);
	
	var _evaluator = __w_pdfjs_require__(83);
	
	var _stream = __w_pdfjs_require__(5);
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AnnotationFactory = function () {
	  function AnnotationFactory() {
	    _classCallCheck(this, AnnotationFactory);
	  }
	
	  _createClass(AnnotationFactory, null, [{
	    key: 'create',
	    value: function create(xref, ref, pdfManager, idFactory) {
	      var dict = xref.fetchIfRef(ref);
	      if (!(0, _primitives.isDict)(dict)) {
	        return;
	      }
	      var id = (0, _primitives.isRef)(ref) ? ref.toString() : 'annot_' + idFactory.createObjId();
	      var subtype = dict.get('Subtype');
	      subtype = (0, _primitives.isName)(subtype) ? subtype.name : null;
	      var parameters = {
	        xref: xref,
	        dict: dict,
	        ref: (0, _primitives.isRef)(ref) ? ref : null,
	        subtype: subtype,
	        id: id,
	        pdfManager: pdfManager
	      };
	      switch (subtype) {
	        case 'Link':
	          return new LinkAnnotation(parameters);
	        case 'Text':
	          return new TextAnnotation(parameters);
	        case 'Widget':
	          var fieldType = _util.Util.getInheritableProperty(dict, 'FT');
	          fieldType = (0, _primitives.isName)(fieldType) ? fieldType.name : null;
	          switch (fieldType) {
	            case 'Tx':
	              return new TextWidgetAnnotation(parameters);
	            case 'Btn':
	              return new ButtonWidgetAnnotation(parameters);
	            case 'Ch':
	              return new ChoiceWidgetAnnotation(parameters);
	          }
	          (0, _util.warn)('Unimplemented widget field type "' + fieldType + '", ' + 'falling back to base field type.');
	          return new WidgetAnnotation(parameters);
	        case 'Popup':
	          return new PopupAnnotation(parameters);
	        case 'Line':
	          return new LineAnnotation(parameters);
	        case 'Square':
	          return new SquareAnnotation(parameters);
	        case 'Circle':
	          return new CircleAnnotation(parameters);
	        case 'PolyLine':
	          return new PolylineAnnotation(parameters);
	        case 'Polygon':
	          return new PolygonAnnotation(parameters);
	        case 'Highlight':
	          return new HighlightAnnotation(parameters);
	        case 'Underline':
	          return new UnderlineAnnotation(parameters);
	        case 'Squiggly':
	          return new SquigglyAnnotation(parameters);
	        case 'StrikeOut':
	          return new StrikeOutAnnotation(parameters);
	        case 'Stamp':
	          return new StampAnnotation(parameters);
	        case 'FileAttachment':
	          return new FileAttachmentAnnotation(parameters);
	        default:
	          if (!subtype) {
	            (0, _util.warn)('Annotation is missing the required /Subtype.');
	          } else {
	            (0, _util.warn)('Unimplemented annotation type "' + subtype + '", ' + 'falling back to base annotation.');
	          }
	          return new Annotation(parameters);
	      }
	    }
	  }]);
	
	  return AnnotationFactory;
	}();
	
	function getTransformMatrix(rect, bbox, matrix) {
	  var bounds = _util.Util.getAxialAlignedBoundingBox(bbox, matrix);
	  var minX = bounds[0];
	  var minY = bounds[1];
	  var maxX = bounds[2];
	  var maxY = bounds[3];
	  if (minX === maxX || minY === maxY) {
	    return [1, 0, 0, 1, rect[0], rect[1]];
	  }
	  var xRatio = (rect[2] - rect[0]) / (maxX - minX);
	  var yRatio = (rect[3] - rect[1]) / (maxY - minY);
	  return [xRatio, 0, 0, yRatio, rect[0] - minX * xRatio, rect[1] - minY * yRatio];
	}
	
	var Annotation = function () {
	  function Annotation(params) {
	    _classCallCheck(this, Annotation);
	
	    var dict = params.dict;
	    this.setFlags(dict.get('F'));
	    this.setRectangle(dict.getArray('Rect'));
	    this.setColor(dict.getArray('C'));
	    this.setBorderStyle(dict);
	    this.setAppearance(dict);
	    this.data = {
	      annotationFlags: this.flags,
	      borderStyle: this.borderStyle,
	      color: this.color,
	      hasAppearance: !!this.appearance,
	      id: params.id,
	      rect: this.rectangle,
	      subtype: params.subtype
	    };
	  }
	
	  _createClass(Annotation, [{
	    key: '_hasFlag',
	    value: function _hasFlag(flags, flag) {
	      return !!(flags & flag);
	    }
	  }, {
	    key: '_isViewable',
	    value: function _isViewable(flags) {
	      return !this._hasFlag(flags, _util.AnnotationFlag.INVISIBLE) && !this._hasFlag(flags, _util.AnnotationFlag.HIDDEN) && !this._hasFlag(flags, _util.AnnotationFlag.NOVIEW);
	    }
	  }, {
	    key: '_isPrintable',
	    value: function _isPrintable(flags) {
	      return this._hasFlag(flags, _util.AnnotationFlag.PRINT) && !this._hasFlag(flags, _util.AnnotationFlag.INVISIBLE) && !this._hasFlag(flags, _util.AnnotationFlag.HIDDEN);
	    }
	  }, {
	    key: 'setFlags',
	    value: function setFlags(flags) {
	      this.flags = Number.isInteger(flags) && flags > 0 ? flags : 0;
	    }
	  }, {
	    key: 'hasFlag',
	    value: function hasFlag(flag) {
	      return this._hasFlag(this.flags, flag);
	    }
	  }, {
	    key: 'setRectangle',
	    value: function setRectangle(rectangle) {
	      if (Array.isArray(rectangle) && rectangle.length === 4) {
	        this.rectangle = _util.Util.normalizeRect(rectangle);
	      } else {
	        this.rectangle = [0, 0, 0, 0];
	      }
	    }
	  }, {
	    key: 'setColor',
	    value: function setColor(color) {
	      var rgbColor = new Uint8Array(3);
	      if (!Array.isArray(color)) {
	        this.color = rgbColor;
	        return;
	      }
	      switch (color.length) {
	        case 0:
	          this.color = null;
	          break;
	        case 1:
	          _colorspace.ColorSpace.singletons.gray.getRgbItem(color, 0, rgbColor, 0);
	          this.color = rgbColor;
	          break;
	        case 3:
	          _colorspace.ColorSpace.singletons.rgb.getRgbItem(color, 0, rgbColor, 0);
	          this.color = rgbColor;
	          break;
	        case 4:
	          _colorspace.ColorSpace.singletons.cmyk.getRgbItem(color, 0, rgbColor, 0);
	          this.color = rgbColor;
	          break;
	        default:
	          this.color = rgbColor;
	          break;
	      }
	    }
	  }, {
	    key: 'setBorderStyle',
	    value: function setBorderStyle(borderStyle) {
	      this.borderStyle = new AnnotationBorderStyle();
	      if (!(0, _primitives.isDict)(borderStyle)) {
	        return;
	      }
	      if (borderStyle.has('BS')) {
	        var dict = borderStyle.get('BS');
	        var dictType = dict.get('Type');
	        if (!dictType || (0, _primitives.isName)(dictType, 'Border')) {
	          this.borderStyle.setWidth(dict.get('W'));
	          this.borderStyle.setStyle(dict.get('S'));
	          this.borderStyle.setDashArray(dict.getArray('D'));
	        }
	      } else if (borderStyle.has('Border')) {
	        var array = borderStyle.getArray('Border');
	        if (Array.isArray(array) && array.length >= 3) {
	          this.borderStyle.setHorizontalCornerRadius(array[0]);
	          this.borderStyle.setVerticalCornerRadius(array[1]);
	          this.borderStyle.setWidth(array[2]);
	          if (array.length === 4) {
	            this.borderStyle.setDashArray(array[3]);
	          }
	        }
	      } else {
	        this.borderStyle.setWidth(0);
	      }
	    }
	  }, {
	    key: 'setAppearance',
	    value: function setAppearance(dict) {
	      this.appearance = null;
	      var appearanceStates = dict.get('AP');
	      if (!(0, _primitives.isDict)(appearanceStates)) {
	        return;
	      }
	      var normalAppearanceState = appearanceStates.get('N');
	      if ((0, _primitives.isStream)(normalAppearanceState)) {
	        this.appearance = normalAppearanceState;
	        return;
	      }
	      if (!(0, _primitives.isDict)(normalAppearanceState)) {
	        return;
	      }
	      var as = dict.get('AS');
	      if (!(0, _primitives.isName)(as) || !normalAppearanceState.has(as.name)) {
	        return;
	      }
	      this.appearance = normalAppearanceState.get(as.name);
	    }
	  }, {
	    key: '_preparePopup',
	    value: function _preparePopup(dict) {
	      if (!dict.has('C')) {
	        this.data.color = null;
	      }
	      this.data.hasPopup = dict.has('Popup');
	      this.data.title = (0, _util.stringToPDFString)(dict.get('T') || '');
	      this.data.contents = (0, _util.stringToPDFString)(dict.get('Contents') || '');
	    }
	  }, {
	    key: 'loadResources',
	    value: function loadResources(keys) {
	      return this.appearance.dict.getAsync('Resources').then(function (resources) {
	        if (!resources) {
	          return;
	        }
	        var objectLoader = new _obj.ObjectLoader(resources, keys, resources.xref);
	        return objectLoader.load().then(function () {
	          return resources;
	        });
	      });
	    }
	  }, {
	    key: 'getOperatorList',
	    value: function getOperatorList(evaluator, task, renderForms) {
	      var _this = this;
	
	      if (!this.appearance) {
	        return Promise.resolve(new _evaluator.OperatorList());
	      }
	      var data = this.data;
	      var appearanceDict = this.appearance.dict;
	      var resourcesPromise = this.loadResources(['ExtGState', 'ColorSpace', 'Pattern', 'Shading', 'XObject', 'Font']);
	      var bbox = appearanceDict.getArray('BBox') || [0, 0, 1, 1];
	      var matrix = appearanceDict.getArray('Matrix') || [1, 0, 0, 1, 0, 0];
	      var transform = getTransformMatrix(data.rect, bbox, matrix);
	      return resourcesPromise.then(function (resources) {
	        var opList = new _evaluator.OperatorList();
	        opList.addOp(_util.OPS.beginAnnotation, [data.rect, transform, matrix]);
	        return evaluator.getOperatorList({
	          stream: _this.appearance,
	          task: task,
	          resources: resources,
	          operatorList: opList
	        }).then(function () {
	          opList.addOp(_util.OPS.endAnnotation, []);
	          _this.appearance.reset();
	          return opList;
	        });
	      });
	    }
	  }, {
	    key: 'viewable',
	    get: function get() {
	      if (this.flags === 0) {
	        return true;
	      }
	      return this._isViewable(this.flags);
	    }
	  }, {
	    key: 'printable',
	    get: function get() {
	      if (this.flags === 0) {
	        return false;
	      }
	      return this._isPrintable(this.flags);
	    }
	  }]);
	
	  return Annotation;
	}();
	
	var AnnotationBorderStyle = function () {
	  function AnnotationBorderStyle() {
	    _classCallCheck(this, AnnotationBorderStyle);
	
	    this.width = 1;
	    this.style = _util.AnnotationBorderStyleType.SOLID;
	    this.dashArray = [3];
	    this.horizontalCornerRadius = 0;
	    this.verticalCornerRadius = 0;
	  }
	
	  _createClass(AnnotationBorderStyle, [{
	    key: 'setWidth',
	    value: function setWidth(width) {
	      if (Number.isInteger(width)) {
	        this.width = width;
	      }
	    }
	  }, {
	    key: 'setStyle',
	    value: function setStyle(style) {
	      if (!style) {
	        return;
	      }
	      switch (style.name) {
	        case 'S':
	          this.style = _util.AnnotationBorderStyleType.SOLID;
	          break;
	        case 'D':
	          this.style = _util.AnnotationBorderStyleType.DASHED;
	          break;
	        case 'B':
	          this.style = _util.AnnotationBorderStyleType.BEVELED;
	          break;
	        case 'I':
	          this.style = _util.AnnotationBorderStyleType.INSET;
	          break;
	        case 'U':
	          this.style = _util.AnnotationBorderStyleType.UNDERLINE;
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'setDashArray',
	    value: function setDashArray(dashArray) {
	      if (Array.isArray(dashArray) && dashArray.length > 0) {
	        var isValid = true;
	        var allZeros = true;
	        for (var i = 0, len = dashArray.length; i < len; i++) {
	          var element = dashArray[i];
	          var validNumber = +element >= 0;
	          if (!validNumber) {
	            isValid = false;
	            break;
	          } else if (element > 0) {
	            allZeros = false;
	          }
	        }
	        if (isValid && !allZeros) {
	          this.dashArray = dashArray;
	        } else {
	          this.width = 0;
	        }
	      } else if (dashArray) {
	        this.width = 0;
	      }
	    }
	  }, {
	    key: 'setHorizontalCornerRadius',
	    value: function setHorizontalCornerRadius(radius) {
	      if (Number.isInteger(radius)) {
	        this.horizontalCornerRadius = radius;
	      }
	    }
	  }, {
	    key: 'setVerticalCornerRadius',
	    value: function setVerticalCornerRadius(radius) {
	      if (Number.isInteger(radius)) {
	        this.verticalCornerRadius = radius;
	      }
	    }
	  }]);
	
	  return AnnotationBorderStyle;
	}();
	
	var WidgetAnnotation = function (_Annotation) {
	  _inherits(WidgetAnnotation, _Annotation);
	
	  function WidgetAnnotation(params) {
	    _classCallCheck(this, WidgetAnnotation);
	
	    var _this2 = _possibleConstructorReturn(this, (WidgetAnnotation.__proto__ || Object.getPrototypeOf(WidgetAnnotation)).call(this, params));
	
	    var dict = params.dict;
	    var data = _this2.data;
	    data.annotationType = _util.AnnotationType.WIDGET;
	    data.fieldName = _this2._constructFieldName(dict);
	    data.fieldValue = _util.Util.getInheritableProperty(dict, 'V', true);
	    data.alternativeText = (0, _util.stringToPDFString)(dict.get('TU') || '');
	    data.defaultAppearance = _util.Util.getInheritableProperty(dict, 'DA') || '';
	    var fieldType = _util.Util.getInheritableProperty(dict, 'FT');
	    data.fieldType = (0, _primitives.isName)(fieldType) ? fieldType.name : null;
	    _this2.fieldResources = _util.Util.getInheritableProperty(dict, 'DR') || _primitives.Dict.empty;
	    data.fieldFlags = _util.Util.getInheritableProperty(dict, 'Ff');
	    if (!Number.isInteger(data.fieldFlags) || data.fieldFlags < 0) {
	      data.fieldFlags = 0;
	    }
	    data.readOnly = _this2.hasFieldFlag(_util.AnnotationFieldFlag.READONLY);
	    if (data.fieldType === 'Sig') {
	      _this2.setFlags(_util.AnnotationFlag.HIDDEN);
	    }
	    return _this2;
	  }
	
	  _createClass(WidgetAnnotation, [{
	    key: '_constructFieldName',
	    value: function _constructFieldName(dict) {
	      if (!dict.has('T') && !dict.has('Parent')) {
	        (0, _util.warn)('Unknown field name, falling back to empty field name.');
	        return '';
	      }
	      if (!dict.has('Parent')) {
	        return (0, _util.stringToPDFString)(dict.get('T'));
	      }
	      var fieldName = [];
	      if (dict.has('T')) {
	        fieldName.unshift((0, _util.stringToPDFString)(dict.get('T')));
	      }
	      var loopDict = dict;
	      while (loopDict.has('Parent')) {
	        loopDict = loopDict.get('Parent');
	        if (!(0, _primitives.isDict)(loopDict)) {
	          break;
	        }
	        if (loopDict.has('T')) {
	          fieldName.unshift((0, _util.stringToPDFString)(loopDict.get('T')));
	        }
	      }
	      return fieldName.join('.');
	    }
	  }, {
	    key: 'hasFieldFlag',
	    value: function hasFieldFlag(flag) {
	      return !!(this.data.fieldFlags & flag);
	    }
	  }, {
	    key: 'getOperatorList',
	    value: function getOperatorList(evaluator, task, renderForms) {
	      if (renderForms) {
	        return Promise.resolve(new _evaluator.OperatorList());
	      }
	      return _get(WidgetAnnotation.prototype.__proto__ || Object.getPrototypeOf(WidgetAnnotation.prototype), 'getOperatorList', this).call(this, evaluator, task, renderForms);
	    }
	  }]);
	
	  return WidgetAnnotation;
	}(Annotation);
	
	var TextWidgetAnnotation = function (_WidgetAnnotation) {
	  _inherits(TextWidgetAnnotation, _WidgetAnnotation);
	
	  function TextWidgetAnnotation(params) {
	    _classCallCheck(this, TextWidgetAnnotation);
	
	    var _this3 = _possibleConstructorReturn(this, (TextWidgetAnnotation.__proto__ || Object.getPrototypeOf(TextWidgetAnnotation)).call(this, params));
	
	    _this3.data.fieldValue = (0, _util.stringToPDFString)(_this3.data.fieldValue || '');
	    var alignment = _util.Util.getInheritableProperty(params.dict, 'Q');
	    if (!Number.isInteger(alignment) || alignment < 0 || alignment > 2) {
	      alignment = null;
	    }
	    _this3.data.textAlignment = alignment;
	    var maximumLength = _util.Util.getInheritableProperty(params.dict, 'MaxLen');
	    if (!Number.isInteger(maximumLength) || maximumLength < 0) {
	      maximumLength = null;
	    }
	    _this3.data.maxLen = maximumLength;
	    _this3.data.multiLine = _this3.hasFieldFlag(_util.AnnotationFieldFlag.MULTILINE);
	    _this3.data.comb = _this3.hasFieldFlag(_util.AnnotationFieldFlag.COMB) && !_this3.hasFieldFlag(_util.AnnotationFieldFlag.MULTILINE) && !_this3.hasFieldFlag(_util.AnnotationFieldFlag.PASSWORD) && !_this3.hasFieldFlag(_util.AnnotationFieldFlag.FILESELECT) && _this3.data.maxLen !== null;
	    return _this3;
	  }
	
	  _createClass(TextWidgetAnnotation, [{
	    key: 'getOperatorList',
	    value: function getOperatorList(evaluator, task, renderForms) {
	      if (renderForms || this.appearance) {
	        return _get(TextWidgetAnnotation.prototype.__proto__ || Object.getPrototypeOf(TextWidgetAnnotation.prototype), 'getOperatorList', this).call(this, evaluator, task, renderForms);
	      }
	      var operatorList = new _evaluator.OperatorList();
	      if (!this.data.defaultAppearance) {
	        return Promise.resolve(operatorList);
	      }
	      var stream = new _stream.Stream((0, _util.stringToBytes)(this.data.defaultAppearance));
	      return evaluator.getOperatorList({
	        stream: stream,
	        task: task,
	        resources: this.fieldResources,
	        operatorList: operatorList
	      }).then(function () {
	        return operatorList;
	      });
	    }
	  }]);
	
	  return TextWidgetAnnotation;
	}(WidgetAnnotation);
	
	var ButtonWidgetAnnotation = function (_WidgetAnnotation2) {
	  _inherits(ButtonWidgetAnnotation, _WidgetAnnotation2);
	
	  function ButtonWidgetAnnotation(params) {
	    _classCallCheck(this, ButtonWidgetAnnotation);
	
	    var _this4 = _possibleConstructorReturn(this, (ButtonWidgetAnnotation.__proto__ || Object.getPrototypeOf(ButtonWidgetAnnotation)).call(this, params));
	
	    _this4.data.checkBox = !_this4.hasFieldFlag(_util.AnnotationFieldFlag.RADIO) && !_this4.hasFieldFlag(_util.AnnotationFieldFlag.PUSHBUTTON);
	    if (_this4.data.checkBox) {
	      if (!(0, _primitives.isName)(_this4.data.fieldValue)) {
	        return _possibleConstructorReturn(_this4);
	      }
	      _this4.data.fieldValue = _this4.data.fieldValue.name;
	    }
	    _this4.data.radioButton = _this4.hasFieldFlag(_util.AnnotationFieldFlag.RADIO) && !_this4.hasFieldFlag(_util.AnnotationFieldFlag.PUSHBUTTON);
	    if (_this4.data.radioButton) {
	      _this4.data.fieldValue = _this4.data.buttonValue = null;
	      var fieldParent = params.dict.get('Parent');
	      if ((0, _primitives.isDict)(fieldParent) && fieldParent.has('V')) {
	        var fieldParentValue = fieldParent.get('V');
	        if ((0, _primitives.isName)(fieldParentValue)) {
	          _this4.data.fieldValue = fieldParentValue.name;
	        }
	      }
	      var appearanceStates = params.dict.get('AP');
	      if (!(0, _primitives.isDict)(appearanceStates)) {
	        return _possibleConstructorReturn(_this4);
	      }
	      var normalAppearanceState = appearanceStates.get('N');
	      if (!(0, _primitives.isDict)(normalAppearanceState)) {
	        return _possibleConstructorReturn(_this4);
	      }
	      var keys = normalAppearanceState.getKeys();
	      for (var i = 0, ii = keys.length; i < ii; i++) {
	        if (keys[i] !== 'Off') {
	          _this4.data.buttonValue = keys[i];
	          break;
	        }
	      }
	    }
	    return _this4;
	  }
	
	  return ButtonWidgetAnnotation;
	}(WidgetAnnotation);
	
	var ChoiceWidgetAnnotation = function (_WidgetAnnotation3) {
	  _inherits(ChoiceWidgetAnnotation, _WidgetAnnotation3);
	
	  function ChoiceWidgetAnnotation(params) {
	    _classCallCheck(this, ChoiceWidgetAnnotation);
	
	    var _this5 = _possibleConstructorReturn(this, (ChoiceWidgetAnnotation.__proto__ || Object.getPrototypeOf(ChoiceWidgetAnnotation)).call(this, params));
	
	    _this5.data.options = [];
	    var options = _util.Util.getInheritableProperty(params.dict, 'Opt');
	    if (Array.isArray(options)) {
	      var xref = params.xref;
	      for (var i = 0, ii = options.length; i < ii; i++) {
	        var option = xref.fetchIfRef(options[i]);
	        var isOptionArray = Array.isArray(option);
	        _this5.data.options[i] = {
	          exportValue: isOptionArray ? xref.fetchIfRef(option[0]) : option,
	          displayValue: isOptionArray ? xref.fetchIfRef(option[1]) : option
	        };
	      }
	    }
	    if (!Array.isArray(_this5.data.fieldValue)) {
	      _this5.data.fieldValue = [_this5.data.fieldValue];
	    }
	    _this5.data.combo = _this5.hasFieldFlag(_util.AnnotationFieldFlag.COMBO);
	    _this5.data.multiSelect = _this5.hasFieldFlag(_util.AnnotationFieldFlag.MULTISELECT);
	    return _this5;
	  }
	
	  return ChoiceWidgetAnnotation;
	}(WidgetAnnotation);
	
	var TextAnnotation = function (_Annotation2) {
	  _inherits(TextAnnotation, _Annotation2);
	
	  function TextAnnotation(parameters) {
	    _classCallCheck(this, TextAnnotation);
	
	    var DEFAULT_ICON_SIZE = 22;
	
	    var _this6 = _possibleConstructorReturn(this, (TextAnnotation.__proto__ || Object.getPrototypeOf(TextAnnotation)).call(this, parameters));
	
	    _this6.data.annotationType = _util.AnnotationType.TEXT;
	    if (_this6.data.hasAppearance) {
	      _this6.data.name = 'NoIcon';
	    } else {
	      _this6.data.rect[1] = _this6.data.rect[3] - DEFAULT_ICON_SIZE;
	      _this6.data.rect[2] = _this6.data.rect[0] + DEFAULT_ICON_SIZE;
	      _this6.data.name = parameters.dict.has('Name') ? parameters.dict.get('Name').name : 'Note';
	    }
	    _this6._preparePopup(parameters.dict);
	    return _this6;
	  }
	
	  return TextAnnotation;
	}(Annotation);
	
	var LinkAnnotation = function (_Annotation3) {
	  _inherits(LinkAnnotation, _Annotation3);
	
	  function LinkAnnotation(params) {
	    _classCallCheck(this, LinkAnnotation);
	
	    var _this7 = _possibleConstructorReturn(this, (LinkAnnotation.__proto__ || Object.getPrototypeOf(LinkAnnotation)).call(this, params));
	
	    _this7.data.annotationType = _util.AnnotationType.LINK;
	    _obj.Catalog.parseDestDictionary({
	      destDict: params.dict,
	      resultObj: _this7.data,
	      docBaseUrl: params.pdfManager.docBaseUrl
	    });
	    return _this7;
	  }
	
	  return LinkAnnotation;
	}(Annotation);
	
	var PopupAnnotation = function (_Annotation4) {
	  _inherits(PopupAnnotation, _Annotation4);
	
	  function PopupAnnotation(parameters) {
	    _classCallCheck(this, PopupAnnotation);
	
	    var _this8 = _possibleConstructorReturn(this, (PopupAnnotation.__proto__ || Object.getPrototypeOf(PopupAnnotation)).call(this, parameters));
	
	    _this8.data.annotationType = _util.AnnotationType.POPUP;
	    var dict = parameters.dict;
	    var parentItem = dict.get('Parent');
	    if (!parentItem) {
	      (0, _util.warn)('Popup annotation has a missing or invalid parent annotation.');
	      return _possibleConstructorReturn(_this8);
	    }
	    var parentSubtype = parentItem.get('Subtype');
	    _this8.data.parentType = (0, _primitives.isName)(parentSubtype) ? parentSubtype.name : null;
	    _this8.data.parentId = dict.getRaw('Parent').toString();
	    _this8.data.title = (0, _util.stringToPDFString)(parentItem.get('T') || '');
	    _this8.data.contents = (0, _util.stringToPDFString)(parentItem.get('Contents') || '');
	    if (!parentItem.has('C')) {
	      _this8.data.color = null;
	    } else {
	      _this8.setColor(parentItem.getArray('C'));
	      _this8.data.color = _this8.color;
	    }
	    if (!_this8.viewable) {
	      var parentFlags = parentItem.get('F');
	      if (_this8._isViewable(parentFlags)) {
	        _this8.setFlags(parentFlags);
	      }
	    }
	    return _this8;
	  }
	
	  return PopupAnnotation;
	}(Annotation);
	
	var LineAnnotation = function (_Annotation5) {
	  _inherits(LineAnnotation, _Annotation5);
	
	  function LineAnnotation(parameters) {
	    _classCallCheck(this, LineAnnotation);
	
	    var _this9 = _possibleConstructorReturn(this, (LineAnnotation.__proto__ || Object.getPrototypeOf(LineAnnotation)).call(this, parameters));
	
	    _this9.data.annotationType = _util.AnnotationType.LINE;
	    var dict = parameters.dict;
	    _this9.data.lineCoordinates = _util.Util.normalizeRect(dict.getArray('L'));
	    _this9._preparePopup(dict);
	    return _this9;
	  }
	
	  return LineAnnotation;
	}(Annotation);
	
	var SquareAnnotation = function (_Annotation6) {
	  _inherits(SquareAnnotation, _Annotation6);
	
	  function SquareAnnotation(parameters) {
	    _classCallCheck(this, SquareAnnotation);
	
	    var _this10 = _possibleConstructorReturn(this, (SquareAnnotation.__proto__ || Object.getPrototypeOf(SquareAnnotation)).call(this, parameters));
	
	    _this10.data.annotationType = _util.AnnotationType.SQUARE;
	    _this10._preparePopup(parameters.dict);
	    return _this10;
	  }
	
	  return SquareAnnotation;
	}(Annotation);
	
	var CircleAnnotation = function (_Annotation7) {
	  _inherits(CircleAnnotation, _Annotation7);
	
	  function CircleAnnotation(parameters) {
	    _classCallCheck(this, CircleAnnotation);
	
	    var _this11 = _possibleConstructorReturn(this, (CircleAnnotation.__proto__ || Object.getPrototypeOf(CircleAnnotation)).call(this, parameters));
	
	    _this11.data.annotationType = _util.AnnotationType.CIRCLE;
	    _this11._preparePopup(parameters.dict);
	    return _this11;
	  }
	
	  return CircleAnnotation;
	}(Annotation);
	
	var PolylineAnnotation = function (_Annotation8) {
	  _inherits(PolylineAnnotation, _Annotation8);
	
	  function PolylineAnnotation(parameters) {
	    _classCallCheck(this, PolylineAnnotation);
	
	    var _this12 = _possibleConstructorReturn(this, (PolylineAnnotation.__proto__ || Object.getPrototypeOf(PolylineAnnotation)).call(this, parameters));
	
	    _this12.data.annotationType = _util.AnnotationType.POLYLINE;
	    var dict = parameters.dict;
	    var rawVertices = dict.getArray('Vertices');
	    _this12.data.vertices = [];
	    for (var i = 0, ii = rawVertices.length; i < ii; i += 2) {
	      _this12.data.vertices.push({
	        x: rawVertices[i],
	        y: rawVertices[i + 1]
	      });
	    }
	    _this12._preparePopup(dict);
	    return _this12;
	  }
	
	  return PolylineAnnotation;
	}(Annotation);
	
	var PolygonAnnotation = function (_PolylineAnnotation) {
	  _inherits(PolygonAnnotation, _PolylineAnnotation);
	
	  function PolygonAnnotation(parameters) {
	    _classCallCheck(this, PolygonAnnotation);
	
	    var _this13 = _possibleConstructorReturn(this, (PolygonAnnotation.__proto__ || Object.getPrototypeOf(PolygonAnnotation)).call(this, parameters));
	
	    _this13.data.annotationType = _util.AnnotationType.POLYGON;
	    return _this13;
	  }
	
	  return PolygonAnnotation;
	}(PolylineAnnotation);
	
	var HighlightAnnotation = function (_Annotation9) {
	  _inherits(HighlightAnnotation, _Annotation9);
	
	  function HighlightAnnotation(parameters) {
	    _classCallCheck(this, HighlightAnnotation);
	
	    var _this14 = _possibleConstructorReturn(this, (HighlightAnnotation.__proto__ || Object.getPrototypeOf(HighlightAnnotation)).call(this, parameters));
	
	    _this14.data.annotationType = _util.AnnotationType.HIGHLIGHT;
	    _this14._preparePopup(parameters.dict);
	    return _this14;
	  }
	
	  return HighlightAnnotation;
	}(Annotation);
	
	var UnderlineAnnotation = function (_Annotation10) {
	  _inherits(UnderlineAnnotation, _Annotation10);
	
	  function UnderlineAnnotation(parameters) {
	    _classCallCheck(this, UnderlineAnnotation);
	
	    var _this15 = _possibleConstructorReturn(this, (UnderlineAnnotation.__proto__ || Object.getPrototypeOf(UnderlineAnnotation)).call(this, parameters));
	
	    _this15.data.annotationType = _util.AnnotationType.UNDERLINE;
	    _this15._preparePopup(parameters.dict);
	    return _this15;
	  }
	
	  return UnderlineAnnotation;
	}(Annotation);
	
	var SquigglyAnnotation = function (_Annotation11) {
	  _inherits(SquigglyAnnotation, _Annotation11);
	
	  function SquigglyAnnotation(parameters) {
	    _classCallCheck(this, SquigglyAnnotation);
	
	    var _this16 = _possibleConstructorReturn(this, (SquigglyAnnotation.__proto__ || Object.getPrototypeOf(SquigglyAnnotation)).call(this, parameters));
	
	    _this16.data.annotationType = _util.AnnotationType.SQUIGGLY;
	    _this16._preparePopup(parameters.dict);
	    return _this16;
	  }
	
	  return SquigglyAnnotation;
	}(Annotation);
	
	var StrikeOutAnnotation = function (_Annotation12) {
	  _inherits(StrikeOutAnnotation, _Annotation12);
	
	  function StrikeOutAnnotation(parameters) {
	    _classCallCheck(this, StrikeOutAnnotation);
	
	    var _this17 = _possibleConstructorReturn(this, (StrikeOutAnnotation.__proto__ || Object.getPrototypeOf(StrikeOutAnnotation)).call(this, parameters));
	
	    _this17.data.annotationType = _util.AnnotationType.STRIKEOUT;
	    _this17._preparePopup(parameters.dict);
	    return _this17;
	  }
	
	  return StrikeOutAnnotation;
	}(Annotation);
	
	var StampAnnotation = function (_Annotation13) {
	  _inherits(StampAnnotation, _Annotation13);
	
	  function StampAnnotation(parameters) {
	    _classCallCheck(this, StampAnnotation);
	
	    var _this18 = _possibleConstructorReturn(this, (StampAnnotation.__proto__ || Object.getPrototypeOf(StampAnnotation)).call(this, parameters));
	
	    _this18.data.annotationType = _util.AnnotationType.STAMP;
	    _this18._preparePopup(parameters.dict);
	    return _this18;
	  }
	
	  return StampAnnotation;
	}(Annotation);
	
	var FileAttachmentAnnotation = function (_Annotation14) {
	  _inherits(FileAttachmentAnnotation, _Annotation14);
	
	  function FileAttachmentAnnotation(parameters) {
	    _classCallCheck(this, FileAttachmentAnnotation);
	
	    var _this19 = _possibleConstructorReturn(this, (FileAttachmentAnnotation.__proto__ || Object.getPrototypeOf(FileAttachmentAnnotation)).call(this, parameters));
	
	    var file = new _obj.FileSpec(parameters.dict.get('FS'), parameters.xref);
	    _this19.data.annotationType = _util.AnnotationType.FILEATTACHMENT;
	    _this19.data.file = file.serializable;
	    _this19._preparePopup(parameters.dict);
	    return _this19;
	  }
	
	  return FileAttachmentAnnotation;
	}(Annotation);
	
	exports.Annotation = Annotation;
	exports.AnnotationBorderStyle = AnnotationBorderStyle;
	exports.AnnotationFactory = AnnotationFactory;
	
	/***/ }),
	/* 160 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFNodeStream = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __w_pdfjs_require__(0);
	
	var _network_utils = __w_pdfjs_require__(50);
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var fs = __webpack_require__(686);
	var http = __webpack_require__(687);
	var https = __webpack_require__(688);
	var url = __webpack_require__(680);
	
	var PDFNodeStream = function () {
	  function PDFNodeStream(options) {
	    _classCallCheck(this, PDFNodeStream);
	
	    this.options = options;
	    this.source = options.source;
	    this.url = url.parse(this.source.url);
	    this.isHttp = this.url.protocol === 'http:' || this.url.protocol === 'https:';
	    this.isFsUrl = this.url.protocol === 'file:' || !this.url.host;
	    this.httpHeaders = this.isHttp && this.source.httpHeaders || {};
	    this._fullRequest = null;
	    this._rangeRequestReaders = [];
	  }
	
	  _createClass(PDFNodeStream, [{
	    key: 'getFullReader',
	    value: function getFullReader() {
	      (0, _util.assert)(!this._fullRequest);
	      this._fullRequest = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
	      return this._fullRequest;
	    }
	  }, {
	    key: 'getRangeReader',
	    value: function getRangeReader(start, end) {
	      var rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
	      this._rangeRequestReaders.push(rangeReader);
	      return rangeReader;
	    }
	  }, {
	    key: 'cancelAllRequests',
	    value: function cancelAllRequests(reason) {
	      if (this._fullRequest) {
	        this._fullRequest.cancel(reason);
	      }
	      var readers = this._rangeRequestReaders.slice(0);
	      readers.forEach(function (reader) {
	        reader.cancel(reason);
	      });
	    }
	  }]);
	
	  return PDFNodeStream;
	}();
	
	var BaseFullReader = function () {
	  function BaseFullReader(stream) {
	    _classCallCheck(this, BaseFullReader);
	
	    this._url = stream.url;
	    this._done = false;
	    this._errored = false;
	    this._reason = null;
	    this.onProgress = null;
	    this._contentLength = stream.source.length;
	    this._loaded = 0;
	    this._disableRange = stream.options.disableRange || false;
	    this._rangeChunkSize = stream.source.rangeChunkSize;
	    if (!this._rangeChunkSize && !this._disableRange) {
	      this._disableRange = true;
	    }
	    this._isStreamingSupported = !stream.source.disableStream;
	    this._isRangeSupported = !stream.options.disableRange;
	    this._readableStream = null;
	    this._readCapability = (0, _util.createPromiseCapability)();
	    this._headersCapability = (0, _util.createPromiseCapability)();
	  }
	
	  _createClass(BaseFullReader, [{
	    key: 'read',
	    value: function read() {
	      var _this = this;
	
	      return this._readCapability.promise.then(function () {
	        if (_this._done) {
	          return Promise.resolve({
	            value: undefined,
	            done: true
	          });
	        }
	        if (_this._errored) {
	          return Promise.reject(_this._reason);
	        }
	        var chunk = _this._readableStream.read();
	        if (chunk === null) {
	          _this._readCapability = (0, _util.createPromiseCapability)();
	          return _this.read();
	        }
	        _this._loaded += chunk.length;
	        if (_this.onProgress) {
	          _this.onProgress({
	            loaded: _this._loaded,
	            total: _this._contentLength
	          });
	        }
	        var buffer = new Uint8Array(chunk).buffer;
	        return Promise.resolve({
	          value: buffer,
	          done: false
	        });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (!this._readableStream) {
	        this._error(reason);
	        return;
	      }
	      this._readableStream.destroy(reason);
	    }
	  }, {
	    key: '_error',
	    value: function _error(reason) {
	      this._errored = true;
	      this._reason = reason;
	      this._readCapability.resolve();
	    }
	  }, {
	    key: '_setReadableStream',
	    value: function _setReadableStream(readableStream) {
	      var _this2 = this;
	
	      this._readableStream = readableStream;
	      readableStream.on('readable', function () {
	        _this2._readCapability.resolve();
	      });
	      readableStream.on('end', function () {
	        readableStream.destroy();
	        _this2._done = true;
	        _this2._readCapability.resolve();
	      });
	      readableStream.on('error', function (reason) {
	        _this2._error(reason);
	      });
	      if (!this._isStreamingSupported && this._isRangeSupported) {
	        this._error(new _util.AbortException('streaming is disabled'));
	      }
	      if (this._errored) {
	        this._readableStream.destroy(this._reason);
	      }
	    }
	  }, {
	    key: 'headersReady',
	    get: function get() {
	      return this._headersCapability.promise;
	    }
	  }, {
	    key: 'contentLength',
	    get: function get() {
	      return this._contentLength;
	    }
	  }, {
	    key: 'isRangeSupported',
	    get: function get() {
	      return this._isRangeSupported;
	    }
	  }, {
	    key: 'isStreamingSupported',
	    get: function get() {
	      return this._isStreamingSupported;
	    }
	  }]);
	
	  return BaseFullReader;
	}();
	
	var BaseRangeReader = function () {
	  function BaseRangeReader(stream) {
	    _classCallCheck(this, BaseRangeReader);
	
	    this._url = stream.url;
	    this._done = false;
	    this._errored = false;
	    this._reason = null;
	    this.onProgress = null;
	    this._loaded = 0;
	    this._readableStream = null;
	    this._readCapability = (0, _util.createPromiseCapability)();
	    this._isStreamingSupported = !stream.source.disableStream;
	  }
	
	  _createClass(BaseRangeReader, [{
	    key: 'read',
	    value: function read() {
	      var _this3 = this;
	
	      return this._readCapability.promise.then(function () {
	        if (_this3._done) {
	          return Promise.resolve({
	            value: undefined,
	            done: true
	          });
	        }
	        if (_this3._errored) {
	          return Promise.reject(_this3._reason);
	        }
	        var chunk = _this3._readableStream.read();
	        if (chunk === null) {
	          _this3._readCapability = (0, _util.createPromiseCapability)();
	          return _this3.read();
	        }
	        _this3._loaded += chunk.length;
	        if (_this3.onProgress) {
	          _this3.onProgress({ loaded: _this3._loaded });
	        }
	        var buffer = new Uint8Array(chunk).buffer;
	        return Promise.resolve({
	          value: buffer,
	          done: false
	        });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (!this._readableStream) {
	        this._error(reason);
	        return;
	      }
	      this._readableStream.destroy(reason);
	    }
	  }, {
	    key: '_error',
	    value: function _error(reason) {
	      this._errored = true;
	      this._reason = reason;
	      this._readCapability.resolve();
	    }
	  }, {
	    key: '_setReadableStream',
	    value: function _setReadableStream(readableStream) {
	      var _this4 = this;
	
	      this._readableStream = readableStream;
	      readableStream.on('readable', function () {
	        _this4._readCapability.resolve();
	      });
	      readableStream.on('end', function () {
	        readableStream.destroy();
	        _this4._done = true;
	        _this4._readCapability.resolve();
	      });
	      readableStream.on('error', function (reason) {
	        _this4._error(reason);
	      });
	      if (this._errored) {
	        this._readableStream.destroy(this._reason);
	      }
	    }
	  }, {
	    key: 'isStreamingSupported',
	    get: function get() {
	      return this._isStreamingSupported;
	    }
	  }]);
	
	  return BaseRangeReader;
	}();
	
	function createRequestOptions(url, headers) {
	  return {
	    protocol: url.protocol,
	    auth: url.auth,
	    host: url.hostname,
	    port: url.port,
	    path: url.path,
	    method: 'GET',
	    headers: headers
	  };
	}
	
	var PDFNodeStreamFullReader = function (_BaseFullReader) {
	  _inherits(PDFNodeStreamFullReader, _BaseFullReader);
	
	  function PDFNodeStreamFullReader(stream) {
	    _classCallCheck(this, PDFNodeStreamFullReader);
	
	    var _this5 = _possibleConstructorReturn(this, (PDFNodeStreamFullReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFullReader)).call(this, stream));
	
	    var handleResponse = function handleResponse(response) {
	      _this5._headersCapability.resolve();
	      _this5._setReadableStream(response);
	
	      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
	        getResponseHeader: function getResponseHeader(name) {
	          return _this5._readableStream.headers[name.toLowerCase()];
	        },
	        isHttp: stream.isHttp,
	        rangeChunkSize: _this5._rangeChunkSize,
	        disableRange: _this5._disableRange
	      }),
	          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
	          suggestedLength = _validateRangeRequest.suggestedLength;
	
	      if (allowRangeRequests) {
	        _this5._isRangeSupported = true;
	      }
	      _this5._contentLength = suggestedLength;
	    };
	    _this5._request = null;
	    if (_this5._url.protocol === 'http:') {
	      _this5._request = http.request(createRequestOptions(_this5._url, stream.httpHeaders), handleResponse);
	    } else {
	      _this5._request = https.request(createRequestOptions(_this5._url, stream.httpHeaders), handleResponse);
	    }
	    _this5._request.on('error', function (reason) {
	      _this5._errored = true;
	      _this5._reason = reason;
	      _this5._headersCapability.reject(reason);
	    });
	    _this5._request.end();
	    return _this5;
	  }
	
	  return PDFNodeStreamFullReader;
	}(BaseFullReader);
	
	var PDFNodeStreamRangeReader = function (_BaseRangeReader) {
	  _inherits(PDFNodeStreamRangeReader, _BaseRangeReader);
	
	  function PDFNodeStreamRangeReader(stream, start, end) {
	    _classCallCheck(this, PDFNodeStreamRangeReader);
	
	    var _this6 = _possibleConstructorReturn(this, (PDFNodeStreamRangeReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamRangeReader)).call(this, stream));
	
	    _this6._httpHeaders = {};
	    for (var property in stream.httpHeaders) {
	      var value = stream.httpHeaders[property];
	      if (typeof value === 'undefined') {
	        continue;
	      }
	      _this6._httpHeaders[property] = value;
	    }
	    _this6._httpHeaders['Range'] = 'bytes=' + start + '-' + (end - 1);
	    _this6._request = null;
	    if (_this6._url.protocol === 'http:') {
	      _this6._request = http.request(createRequestOptions(_this6._url, _this6._httpHeaders), function (response) {
	        _this6._setReadableStream(response);
	      });
	    } else {
	      _this6._request = https.request(createRequestOptions(_this6._url, _this6._httpHeaders), function (response) {
	        _this6._setReadableStream(response);
	      });
	    }
	    _this6._request.on('error', function (reason) {
	      _this6._errored = true;
	      _this6._reason = reason;
	    });
	    _this6._request.end();
	    return _this6;
	  }
	
	  return PDFNodeStreamRangeReader;
	}(BaseRangeReader);
	
	var PDFNodeStreamFsFullReader = function (_BaseFullReader2) {
	  _inherits(PDFNodeStreamFsFullReader, _BaseFullReader2);
	
	  function PDFNodeStreamFsFullReader(stream) {
	    _classCallCheck(this, PDFNodeStreamFsFullReader);
	
	    var _this7 = _possibleConstructorReturn(this, (PDFNodeStreamFsFullReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFsFullReader)).call(this, stream));
	
	    var path = decodeURI(_this7._url.path);
	    fs.lstat(path, function (error, stat) {
	      if (error) {
	        _this7._errored = true;
	        _this7._reason = error;
	        _this7._headersCapability.reject(error);
	        return;
	      }
	      _this7._contentLength = stat.size;
	      _this7._setReadableStream(fs.createReadStream(path));
	      _this7._headersCapability.resolve();
	    });
	    return _this7;
	  }
	
	  return PDFNodeStreamFsFullReader;
	}(BaseFullReader);
	
	var PDFNodeStreamFsRangeReader = function (_BaseRangeReader2) {
	  _inherits(PDFNodeStreamFsRangeReader, _BaseRangeReader2);
	
	  function PDFNodeStreamFsRangeReader(stream, start, end) {
	    _classCallCheck(this, PDFNodeStreamFsRangeReader);
	
	    var _this8 = _possibleConstructorReturn(this, (PDFNodeStreamFsRangeReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFsRangeReader)).call(this, stream));
	
	    _this8._setReadableStream(fs.createReadStream(decodeURI(_this8._url.path), {
	      start: start,
	      end: end - 1
	    }));
	    return _this8;
	  }
	
	  return PDFNodeStreamFsRangeReader;
	}(BaseRangeReader);
	
	exports.PDFNodeStream = PDFNodeStream;
	
	/***/ }),
	/* 161 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFFetchStream = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __w_pdfjs_require__(0);
	
	var _network_utils = __w_pdfjs_require__(50);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function createFetchOptions(headers, withCredentials) {
	  return {
	    method: 'GET',
	    headers: headers,
	    mode: 'cors',
	    credentials: withCredentials ? 'include' : 'same-origin',
	    redirect: 'follow'
	  };
	}
	
	var PDFFetchStream = function () {
	  function PDFFetchStream(options) {
	    _classCallCheck(this, PDFFetchStream);
	
	    this.options = options;
	    this.source = options.source;
	    this.isHttp = /^https?:/i.test(this.source.url);
	    this.httpHeaders = this.isHttp && this.source.httpHeaders || {};
	    this._fullRequestReader = null;
	    this._rangeRequestReaders = [];
	  }
	
	  _createClass(PDFFetchStream, [{
	    key: 'getFullReader',
	    value: function getFullReader() {
	      (0, _util.assert)(!this._fullRequestReader);
	      this._fullRequestReader = new PDFFetchStreamReader(this);
	      return this._fullRequestReader;
	    }
	  }, {
	    key: 'getRangeReader',
	    value: function getRangeReader(begin, end) {
	      var reader = new PDFFetchStreamRangeReader(this, begin, end);
	      this._rangeRequestReaders.push(reader);
	      return reader;
	    }
	  }, {
	    key: 'cancelAllRequests',
	    value: function cancelAllRequests(reason) {
	      if (this._fullRequestReader) {
	        this._fullRequestReader.cancel(reason);
	      }
	      var readers = this._rangeRequestReaders.slice(0);
	      readers.forEach(function (reader) {
	        reader.cancel(reason);
	      });
	    }
	  }]);
	
	  return PDFFetchStream;
	}();
	
	var PDFFetchStreamReader = function () {
	  function PDFFetchStreamReader(stream) {
	    var _this = this;
	
	    _classCallCheck(this, PDFFetchStreamReader);
	
	    this._stream = stream;
	    this._reader = null;
	    this._loaded = 0;
	    this._withCredentials = stream.source.withCredentials;
	    this._contentLength = this._stream.source.length;
	    this._headersCapability = (0, _util.createPromiseCapability)();
	    this._disableRange = this._stream.options.disableRange;
	    this._rangeChunkSize = this._stream.source.rangeChunkSize;
	    if (!this._rangeChunkSize && !this._disableRange) {
	      this._disableRange = true;
	    }
	    this._isRangeSupported = !this._stream.options.disableRange;
	    this._isStreamingSupported = !this._stream.source.disableStream;
	    this._headers = new Headers();
	    for (var property in this._stream.httpHeaders) {
	      var value = this._stream.httpHeaders[property];
	      if (typeof value === 'undefined') {
	        continue;
	      }
	      this._headers.append(property, value);
	    }
	    var url = this._stream.source.url;
	    fetch(url, createFetchOptions(this._headers, this._withCredentials)).then(function (response) {
	      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
	        throw (0, _network_utils.createResponseStatusError)(response.status, url);
	      }
	      _this._reader = response.body.getReader();
	      _this._headersCapability.resolve();
	
	      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
	        getResponseHeader: function getResponseHeader(name) {
	          return response.headers.get(name);
	        },
	        isHttp: _this._stream.isHttp,
	        rangeChunkSize: _this._rangeChunkSize,
	        disableRange: _this._disableRange
	      }),
	          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
	          suggestedLength = _validateRangeRequest.suggestedLength;
	
	      _this._contentLength = suggestedLength;
	      _this._isRangeSupported = allowRangeRequests;
	      if (!_this._isStreamingSupported && _this._isRangeSupported) {
	        _this.cancel(new _util.AbortException('streaming is disabled'));
	      }
	    }).catch(this._headersCapability.reject);
	    this.onProgress = null;
	  }
	
	  _createClass(PDFFetchStreamReader, [{
	    key: 'read',
	    value: function read() {
	      var _this2 = this;
	
	      return this._headersCapability.promise.then(function () {
	        return _this2._reader.read().then(function (_ref) {
	          var value = _ref.value,
	              done = _ref.done;
	
	          if (done) {
	            return Promise.resolve({
	              value: value,
	              done: done
	            });
	          }
	          _this2._loaded += value.byteLength;
	          if (_this2.onProgress) {
	            _this2.onProgress({
	              loaded: _this2._loaded,
	              total: _this2._contentLength
	            });
	          }
	          var buffer = new Uint8Array(value).buffer;
	          return Promise.resolve({
	            value: buffer,
	            done: false
	          });
	        });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (this._reader) {
	        this._reader.cancel(reason);
	      }
	    }
	  }, {
	    key: 'headersReady',
	    get: function get() {
	      return this._headersCapability.promise;
	    }
	  }, {
	    key: 'contentLength',
	    get: function get() {
	      return this._contentLength;
	    }
	  }, {
	    key: 'isRangeSupported',
	    get: function get() {
	      return this._isRangeSupported;
	    }
	  }, {
	    key: 'isStreamingSupported',
	    get: function get() {
	      return this._isStreamingSupported;
	    }
	  }]);
	
	  return PDFFetchStreamReader;
	}();
	
	var PDFFetchStreamRangeReader = function () {
	  function PDFFetchStreamRangeReader(stream, begin, end) {
	    var _this3 = this;
	
	    _classCallCheck(this, PDFFetchStreamRangeReader);
	
	    this._stream = stream;
	    this._reader = null;
	    this._loaded = 0;
	    this._withCredentials = stream.source.withCredentials;
	    this._readCapability = (0, _util.createPromiseCapability)();
	    this._isStreamingSupported = !stream.source.disableStream;
	    this._headers = new Headers();
	    for (var property in this._stream.httpHeaders) {
	      var value = this._stream.httpHeaders[property];
	      if (typeof value === 'undefined') {
	        continue;
	      }
	      this._headers.append(property, value);
	    }
	    var rangeStr = begin + '-' + (end - 1);
	    this._headers.append('Range', 'bytes=' + rangeStr);
	    var url = this._stream.source.url;
	    fetch(url, createFetchOptions(this._headers, this._withCredentials)).then(function (response) {
	      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
	        throw (0, _network_utils.createResponseStatusError)(response.status, url);
	      }
	      _this3._readCapability.resolve();
	      _this3._reader = response.body.getReader();
	    });
	    this.onProgress = null;
	  }
	
	  _createClass(PDFFetchStreamRangeReader, [{
	    key: 'read',
	    value: function read() {
	      var _this4 = this;
	
	      return this._readCapability.promise.then(function () {
	        return _this4._reader.read().then(function (_ref2) {
	          var value = _ref2.value,
	              done = _ref2.done;
	
	          if (done) {
	            return Promise.resolve({
	              value: value,
	              done: done
	            });
	          }
	          _this4._loaded += value.byteLength;
	          if (_this4.onProgress) {
	            _this4.onProgress({ loaded: _this4._loaded });
	          }
	          var buffer = new Uint8Array(value).buffer;
	          return Promise.resolve({
	            value: buffer,
	            done: false
	          });
	        });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (this._reader) {
	        this._reader.cancel(reason);
	      }
	    }
	  }, {
	    key: 'isStreamingSupported',
	    get: function get() {
	      return this._isStreamingSupported;
	    }
	  }]);
	
	  return PDFFetchStreamRangeReader;
	}();
	
	exports.PDFFetchStream = PDFFetchStream;
	
	/***/ }),
	/* 162 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NetworkManager = exports.PDFNetworkStream = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _network_utils = __w_pdfjs_require__(50);
	
	var _global_scope = __w_pdfjs_require__(22);
	
	var _global_scope2 = _interopRequireDefault(_global_scope);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	var OK_RESPONSE = 200;
	var PARTIAL_CONTENT_RESPONSE = 206;
	function NetworkManager(url, args) {
	  this.url = url;
	  args = args || {};
	  this.isHttp = /^https?:/i.test(url);
	  this.httpHeaders = this.isHttp && args.httpHeaders || {};
	  this.withCredentials = args.withCredentials || false;
	  this.getXhr = args.getXhr || function NetworkManager_getXhr() {
	    return new XMLHttpRequest();
	  };
	  this.currXhrId = 0;
	  this.pendingRequests = Object.create(null);
	  this.loadedRequests = Object.create(null);
	}
	function getArrayBuffer(xhr) {
	  var data = xhr.response;
	  if (typeof data !== 'string') {
	    return data;
	  }
	  var array = (0, _util.stringToBytes)(data);
	  return array.buffer;
	}
	var supportsMozChunked = function supportsMozChunkedClosure() {
	  try {
	    var x = new XMLHttpRequest();
	    x.open('GET', _global_scope2.default.location.href);
	    x.responseType = 'moz-chunked-arraybuffer';
	    return x.responseType === 'moz-chunked-arraybuffer';
	  } catch (e) {
	    return false;
	  }
	}();
	NetworkManager.prototype = {
	  requestRange: function NetworkManager_requestRange(begin, end, listeners) {
	    var args = {
	      begin: begin,
	      end: end
	    };
	    for (var prop in listeners) {
	      args[prop] = listeners[prop];
	    }
	    return this.request(args);
	  },
	  requestFull: function NetworkManager_requestFull(listeners) {
	    return this.request(listeners);
	  },
	  request: function NetworkManager_request(args) {
	    var xhr = this.getXhr();
	    var xhrId = this.currXhrId++;
	    var pendingRequest = this.pendingRequests[xhrId] = { xhr: xhr };
	    xhr.open('GET', this.url);
	    xhr.withCredentials = this.withCredentials;
	    for (var property in this.httpHeaders) {
	      var value = this.httpHeaders[property];
	      if (typeof value === 'undefined') {
	        continue;
	      }
	      xhr.setRequestHeader(property, value);
	    }
	    if (this.isHttp && 'begin' in args && 'end' in args) {
	      var rangeStr = args.begin + '-' + (args.end - 1);
	      xhr.setRequestHeader('Range', 'bytes=' + rangeStr);
	      pendingRequest.expectedStatus = 206;
	    } else {
	      pendingRequest.expectedStatus = 200;
	    }
	    var useMozChunkedLoading = supportsMozChunked && !!args.onProgressiveData;
	    if (useMozChunkedLoading) {
	      xhr.responseType = 'moz-chunked-arraybuffer';
	      pendingRequest.onProgressiveData = args.onProgressiveData;
	      pendingRequest.mozChunked = true;
	    } else {
	      xhr.responseType = 'arraybuffer';
	    }
	    if (args.onError) {
	      xhr.onerror = function (evt) {
	        args.onError(xhr.status);
	      };
	    }
	    xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
	    xhr.onprogress = this.onProgress.bind(this, xhrId);
	    pendingRequest.onHeadersReceived = args.onHeadersReceived;
	    pendingRequest.onDone = args.onDone;
	    pendingRequest.onError = args.onError;
	    pendingRequest.onProgress = args.onProgress;
	    xhr.send(null);
	    return xhrId;
	  },
	  onProgress: function NetworkManager_onProgress(xhrId, evt) {
	    var pendingRequest = this.pendingRequests[xhrId];
	    if (!pendingRequest) {
	      return;
	    }
	    if (pendingRequest.mozChunked) {
	      var chunk = getArrayBuffer(pendingRequest.xhr);
	      pendingRequest.onProgressiveData(chunk);
	    }
	    var onProgress = pendingRequest.onProgress;
	    if (onProgress) {
	      onProgress(evt);
	    }
	  },
	  onStateChange: function NetworkManager_onStateChange(xhrId, evt) {
	    var pendingRequest = this.pendingRequests[xhrId];
	    if (!pendingRequest) {
	      return;
	    }
	    var xhr = pendingRequest.xhr;
	    if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
	      pendingRequest.onHeadersReceived();
	      delete pendingRequest.onHeadersReceived;
	    }
	    if (xhr.readyState !== 4) {
	      return;
	    }
	    if (!(xhrId in this.pendingRequests)) {
	      return;
	    }
	    delete this.pendingRequests[xhrId];
	    if (xhr.status === 0 && this.isHttp) {
	      if (pendingRequest.onError) {
	        pendingRequest.onError(xhr.status);
	      }
	      return;
	    }
	    var xhrStatus = xhr.status || OK_RESPONSE;
	    var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
	    if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
	      if (pendingRequest.onError) {
	        pendingRequest.onError(xhr.status);
	      }
	      return;
	    }
	    this.loadedRequests[xhrId] = true;
	    var chunk = getArrayBuffer(xhr);
	    if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
	      var rangeHeader = xhr.getResponseHeader('Content-Range');
	      var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
	      var begin = parseInt(matches[1], 10);
	      pendingRequest.onDone({
	        begin: begin,
	        chunk: chunk
	      });
	    } else if (pendingRequest.onProgressiveData) {
	      pendingRequest.onDone(null);
	    } else if (chunk) {
	      pendingRequest.onDone({
	        begin: 0,
	        chunk: chunk
	      });
	    } else if (pendingRequest.onError) {
	      pendingRequest.onError(xhr.status);
	    }
	  },
	  hasPendingRequests: function NetworkManager_hasPendingRequests() {
	    for (var xhrId in this.pendingRequests) {
	      return true;
	    }
	    return false;
	  },
	  getRequestXhr: function NetworkManager_getXhr(xhrId) {
	    return this.pendingRequests[xhrId].xhr;
	  },
	  isStreamingRequest: function NetworkManager_isStreamingRequest(xhrId) {
	    return !!this.pendingRequests[xhrId].onProgressiveData;
	  },
	  isPendingRequest: function NetworkManager_isPendingRequest(xhrId) {
	    return xhrId in this.pendingRequests;
	  },
	  isLoadedRequest: function NetworkManager_isLoadedRequest(xhrId) {
	    return xhrId in this.loadedRequests;
	  },
	  abortAllRequests: function NetworkManager_abortAllRequests() {
	    for (var xhrId in this.pendingRequests) {
	      this.abortRequest(xhrId | 0);
	    }
	  },
	  abortRequest: function NetworkManager_abortRequest(xhrId) {
	    var xhr = this.pendingRequests[xhrId].xhr;
	    delete this.pendingRequests[xhrId];
	    xhr.abort();
	  }
	};
	function PDFNetworkStream(options) {
	  this._options = options;
	  var source = options.source;
	  this._manager = new NetworkManager(source.url, {
	    httpHeaders: source.httpHeaders,
	    withCredentials: source.withCredentials
	  });
	  this._rangeChunkSize = source.rangeChunkSize;
	  this._fullRequestReader = null;
	  this._rangeRequestReaders = [];
	}
	PDFNetworkStream.prototype = {
	  _onRangeRequestReaderClosed: function PDFNetworkStream_onRangeRequestReaderClosed(reader) {
	    var i = this._rangeRequestReaders.indexOf(reader);
	    if (i >= 0) {
	      this._rangeRequestReaders.splice(i, 1);
	    }
	  },
	  getFullReader: function PDFNetworkStream_getFullReader() {
	    (0, _util.assert)(!this._fullRequestReader);
	    this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._options);
	    return this._fullRequestReader;
	  },
	  getRangeReader: function PDFNetworkStream_getRangeReader(begin, end) {
	    var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
	    reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
	    this._rangeRequestReaders.push(reader);
	    return reader;
	  },
	  cancelAllRequests: function PDFNetworkStream_cancelAllRequests(reason) {
	    if (this._fullRequestReader) {
	      this._fullRequestReader.cancel(reason);
	    }
	    var readers = this._rangeRequestReaders.slice(0);
	    readers.forEach(function (reader) {
	      reader.cancel(reason);
	    });
	  }
	};
	function PDFNetworkStreamFullRequestReader(manager, options) {
	  this._manager = manager;
	  var source = options.source;
	  var args = {
	    onHeadersReceived: this._onHeadersReceived.bind(this),
	    onProgressiveData: source.disableStream ? null : this._onProgressiveData.bind(this),
	    onDone: this._onDone.bind(this),
	    onError: this._onError.bind(this),
	    onProgress: this._onProgress.bind(this)
	  };
	  this._url = source.url;
	  this._fullRequestId = manager.requestFull(args);
	  this._headersReceivedCapability = (0, _util.createPromiseCapability)();
	  this._disableRange = options.disableRange || false;
	  this._contentLength = source.length;
	  this._rangeChunkSize = source.rangeChunkSize;
	  if (!this._rangeChunkSize && !this._disableRange) {
	    this._disableRange = true;
	  }
	  this._isStreamingSupported = false;
	  this._isRangeSupported = false;
	  this._cachedChunks = [];
	  this._requests = [];
	  this._done = false;
	  this._storedError = undefined;
	  this.onProgress = null;
	}
	PDFNetworkStreamFullRequestReader.prototype = {
	  _onHeadersReceived: function PDFNetworkStreamFullRequestReader_onHeadersReceived() {
	    var fullRequestXhrId = this._fullRequestId;
	    var fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
	
	    var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
	      getResponseHeader: function getResponseHeader(name) {
	        return fullRequestXhr.getResponseHeader(name);
	      },
	      isHttp: this._manager.isHttp,
	      rangeChunkSize: this._rangeChunkSize,
	      disableRange: this._disableRange
	    }),
	        allowRangeRequests = _validateRangeRequest.allowRangeRequests,
	        suggestedLength = _validateRangeRequest.suggestedLength;
	
	    this._contentLength = suggestedLength || this._contentLength;
	    if (allowRangeRequests) {
	      this._isRangeSupported = true;
	    }
	    var networkManager = this._manager;
	    if (networkManager.isStreamingRequest(fullRequestXhrId)) {
	      this._isStreamingSupported = true;
	    } else if (this._isRangeSupported) {
	      networkManager.abortRequest(fullRequestXhrId);
	    }
	    this._headersReceivedCapability.resolve();
	  },
	  _onProgressiveData: function PDFNetworkStreamFullRequestReader_onProgressiveData(chunk) {
	    if (this._requests.length > 0) {
	      var requestCapability = this._requests.shift();
	      requestCapability.resolve({
	        value: chunk,
	        done: false
	      });
	    } else {
	      this._cachedChunks.push(chunk);
	    }
	  },
	  _onDone: function PDFNetworkStreamFullRequestReader_onDone(args) {
	    if (args) {
	      this._onProgressiveData(args.chunk);
	    }
	    this._done = true;
	    if (this._cachedChunks.length > 0) {
	      return;
	    }
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	  },
	  _onError: function PDFNetworkStreamFullRequestReader_onError(status) {
	    var url = this._url;
	    var exception = (0, _network_utils.createResponseStatusError)(status, url);
	    this._storedError = exception;
	    this._headersReceivedCapability.reject(exception);
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.reject(exception);
	    });
	    this._requests = [];
	    this._cachedChunks = [];
	  },
	  _onProgress: function PDFNetworkStreamFullRequestReader_onProgress(data) {
	    if (this.onProgress) {
	      this.onProgress({
	        loaded: data.loaded,
	        total: data.lengthComputable ? data.total : this._contentLength
	      });
	    }
	  },
	  get isRangeSupported() {
	    return this._isRangeSupported;
	  },
	  get isStreamingSupported() {
	    return this._isStreamingSupported;
	  },
	  get contentLength() {
	    return this._contentLength;
	  },
	  get headersReady() {
	    return this._headersReceivedCapability.promise;
	  },
	  read: function PDFNetworkStreamFullRequestReader_read() {
	    if (this._storedError) {
	      return Promise.reject(this._storedError);
	    }
	    if (this._cachedChunks.length > 0) {
	      var chunk = this._cachedChunks.shift();
	      return Promise.resolve({
	        value: chunk,
	        done: false
	      });
	    }
	    if (this._done) {
	      return Promise.resolve({
	        value: undefined,
	        done: true
	      });
	    }
	    var requestCapability = (0, _util.createPromiseCapability)();
	    this._requests.push(requestCapability);
	    return requestCapability.promise;
	  },
	  cancel: function PDFNetworkStreamFullRequestReader_cancel(reason) {
	    this._done = true;
	    this._headersReceivedCapability.reject(reason);
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	    if (this._manager.isPendingRequest(this._fullRequestId)) {
	      this._manager.abortRequest(this._fullRequestId);
	    }
	    this._fullRequestReader = null;
	  }
	};
	function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
	  this._manager = manager;
	  var args = {
	    onDone: this._onDone.bind(this),
	    onProgress: this._onProgress.bind(this)
	  };
	  this._requestId = manager.requestRange(begin, end, args);
	  this._requests = [];
	  this._queuedChunk = null;
	  this._done = false;
	  this.onProgress = null;
	  this.onClosed = null;
	}
	PDFNetworkStreamRangeRequestReader.prototype = {
	  _close: function PDFNetworkStreamRangeRequestReader_close() {
	    if (this.onClosed) {
	      this.onClosed(this);
	    }
	  },
	  _onDone: function PDFNetworkStreamRangeRequestReader_onDone(data) {
	    var chunk = data.chunk;
	    if (this._requests.length > 0) {
	      var requestCapability = this._requests.shift();
	      requestCapability.resolve({
	        value: chunk,
	        done: false
	      });
	    } else {
	      this._queuedChunk = chunk;
	    }
	    this._done = true;
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	    this._close();
	  },
	  _onProgress: function PDFNetworkStreamRangeRequestReader_onProgress(evt) {
	    if (!this.isStreamingSupported && this.onProgress) {
	      this.onProgress({ loaded: evt.loaded });
	    }
	  },
	  get isStreamingSupported() {
	    return false;
	  },
	  read: function PDFNetworkStreamRangeRequestReader_read() {
	    if (this._queuedChunk !== null) {
	      var chunk = this._queuedChunk;
	      this._queuedChunk = null;
	      return Promise.resolve({
	        value: chunk,
	        done: false
	      });
	    }
	    if (this._done) {
	      return Promise.resolve({
	        value: undefined,
	        done: true
	      });
	    }
	    var requestCapability = (0, _util.createPromiseCapability)();
	    this._requests.push(requestCapability);
	    return requestCapability.promise;
	  },
	  cancel: function PDFNetworkStreamRangeRequestReader_cancel(reason) {
	    this._done = true;
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	    if (this._manager.isPendingRequest(this._requestId)) {
	      this._manager.abortRequest(this._requestId);
	    }
	    this._close();
	  }
	};
	exports.PDFNetworkStream = PDFNetworkStream;
	exports.NetworkManager = NetworkManager;
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=pdf.combined.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), (function() { return this; }()), __webpack_require__(10).Buffer))

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),

/***/ 571:
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(570);
	exports.encode = exports.stringify = __webpack_require__(571);


/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(90);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(17));
	util.inherits = __webpack_require__(18);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(30).Buffer;
	var util = __webpack_require__(690);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(89);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(91);
	exports.Duplex = __webpack_require__(13);
	exports.Transform = __webpack_require__(90);
	exports.PassThrough = __webpack_require__(670);


/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(672).Transform


/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(7)))

/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(675);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)(module), (function() { return this; }())))

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var punycode = __webpack_require__(679);
	var util = __webpack_require__(681);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // Special case for a simple path URL
	    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(572);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && util.isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!util.isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  // Copy chrome, IE, opera backslash-handling behavior.
	  // Back slashes before the query string get converted to forward slashes
	  // See: https://code.google.com/p/chromium/issues/detail?id=25916
	  var queryIndex = url.indexOf('?'),
	      splitter =
	          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
	      uSplit = url.split(splitter),
	      slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a punycoded representation of "domain".
	      // It only converts parts of the domain name that
	      // have non-ASCII characters, i.e. it doesn't matter if
	      // you call it with a domain that already is ASCII-only.
	      this.hostname = punycode.toASCII(this.hostname);
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1)
	        continue;
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (util.isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      util.isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (util.isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol')
	        result[rkey] = relative[rkey];
	    }
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!util.isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especially happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host || srcPath.length > 1) &&
	      (last === '.' || last === '..') || last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especially happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};


/***/ }),

/***/ 681:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  isString: function(arg) {
	    return typeof(arg) === 'string';
	  },
	  isObject: function(arg) {
	    return typeof(arg) === 'object' && arg !== null;
	  },
	  isNull: function(arg) {
	    return arg === null;
	  },
	  isNullOrUndefined: function(arg) {
	    return arg == null;
	  }
	};


/***/ }),

/***/ 682:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 683:
140,

/***/ 684:
141,

/***/ 685:
[691, 684, 683],

/***/ 686:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 687:
686,

/***/ 688:
686,

/***/ 689:
686,

/***/ 690:
686,

/***/ 691:
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(__webpack_module_template_argument_0__);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(__webpack_module_template_argument_1__);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(7)))

/***/ })

/******/ })));


// WEBPACK FOOTER //
// vendor.28ccf1948b58a056fc2f.js